(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://cdn.printos.com/apps/start/2.12.8/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	configApp.$inject = ["$logProvider", "rnDebugEnabled", "rnClientProvider"];
	configRoutes.$inject = ["$stateProvider", "$urlRouterProvider"];
	configLocCatalogs.$inject = ["$translateProvider"];
	loadTranslations.$inject = ["$translate"];
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _gazelle = __webpack_require__(278);
	
	var _gazelle2 = _interopRequireDefault(_gazelle);
	
	var _rhino = __webpack_require__(413);
	
	var _rhino2 = _interopRequireDefault(_rhino);
	
	// import HP common style classes
	
	__webpack_require__(545);
	
	var _cacheImagesRun = __webpack_require__(472);
	
	var _cacheImagesRun2 = _interopRequireDefault(_cacheImagesRun);
	
	__webpack_require__(560);
	
	// Import view controller names
	
	var _componentsAcceptHpidSignInHpidSignInController = __webpack_require__(76);
	
	var HpIdSignInController = _interopRequireWildcard(_componentsAcceptHpidSignInHpidSignInController);
	
	// Pull in all component modules here.
	// In the future, look to introduce webpack split points for performance
	// in the router configuration.
	// See https://github.com/ay13/webpack-angular-oclazyload/blob/master/app/config.js#L43
	var appModuleNames = requireAllModules();
	
	// Common state resolve functions
	var resolve = {
	  // Ensures translates are loaded
	  loadTranslations: loadTranslations
	};
	
	angular.module('start', [_angularMaterial2['default'], _angularUiRouter2['default'], _rhino2['default'], _gazelle2['default'], _angularTranslate2['default']].concat(appModuleNames)).config(configApp).config(configRoutes).config(configLocCatalogs).run(_cacheImagesRun2['default']).run(appRun);
	
	function configApp($logProvider, rnDebugEnabled, rnClientProvider) {
	  'ngInject';
	  $logProvider.debugEnabled(rnDebugEnabled);
	
	  // Don't use Blue for registry because this app doesn't load blue
	  rnClientProvider.useBlueApi(false);
	}
	
	function configRoutes($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  // For any unmatched url, redirect to /state1
	  $urlRouterProvider.otherwise('/signin');
	
	  // Now set up the states
	  $stateProvider.state('signin', {
	    url: '/signin?forward&messageKey&messageParams&statusCode&subCode&username&altUsername&userId&orgId&chooseAccount&bu',
	    params: {
	      signout: undefined,
	      forward: undefined,
	      messageKey: undefined,
	      messageParams: undefined,
	      statusCode: undefined,
	      subCode: undefined,
	      username: undefined,
	      chooseAccount: undefined,
	      data: undefined,
	      userId: undefined,
	      orgId: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(270),
	    controller: 'SignInController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('redirect', {
	    url: '/redirect?bu',
	    params: {
	      data: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(268),
	    controller: 'RedirectController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('signup', {
	    url: '/signup?bu',
	    params: {
	      data: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(271),
	    controller: 'SignUpController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('support', {
	    url: '/support?bu&fromState',
	    params: {
	      data: undefined,
	      bu: undefined,
	      fromState: 'signin'
	    },
	    template: __webpack_require__(272),
	    controller: 'SupportRequestController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('account', {
	    url: '/account?bu',
	    params: {
	      data: undefined,
	      bu: undefined
	    },
	    controller: 'SelfProvisionController',
	    resolve: resolve
	  }).state('migration', {
	    url: '/migration?bu',
	    params: {
	      data: undefined,
	      bu: undefined
	    },
	    controller: 'MigrateUserController',
	    resolve: resolve
	  }).state('acceptHpIdSignIn', {
	    url: '/accept/sign-in?state&invitationId&statusCode&subCode&hpidId&bu',
	    params: {
	      signout: undefined,
	      invitationId: undefined,
	      state: undefined,
	      statusCode: undefined,
	      subCode: undefined,
	      hpidId: undefined,
	      data: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(261),
	    controller: HpIdSignInController.name,
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('acceptUser', {
	    url: '/accept/user/{invitationId}?hpidId&bu',
	    params: {
	      data: undefined,
	      hpidId: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(263),
	    controller: 'AcceptUserController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('acceptExistingUser', {
	    url: '/accept/existing-user/{invitationId}?bu',
	    params: {
	      data: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(262),
	    controller: 'AcceptExistingUserController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('acceptAccount', {
	    url: '/accept/account/{invitationId}?hpidId&bu',
	    params: {
	      data: undefined,
	      hpidId: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(260),
	    controller: 'AcceptAccountController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('lf-code', {
	    //activate/lf/activationCode=
	    url: '/activate/lf?bu',
	    params: {
	      data: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(267),
	    controller: 'addLFCodeController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('lf-add', {
	    //activate/lf/activationCode=
	    url: '/activate/lf/{lfCode}?bu',
	    params: {
	      data: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(266),
	    controller: 'addLFDeviceController',
	    controllerAs: 'vm',
	    resolve: resolve
	  }).state('unsubscribe', {
	    url: '/unsubscribe?email&category&userId&bu',
	    params: {
	      data: undefined,
	      bu: undefined
	    },
	    template: __webpack_require__(273),
	    controller: 'UnsubscribeController',
	    controllerAs: 'vm',
	    resolve: resolve
	  });
	}
	
	function appRun() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  console.log('Start App Running');
	}
	
	function configLocCatalogs($translateProvider) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  $translateProvider.useLoader('gzL10nLoader', {
	    'catalogServices': {
	      'register.register': 'portal_service',
	      'devices.devices': 'portal_service'
	    }
	  });
	}
	
	function loadTranslations($translate) {
	  'ngInject';
	  return $translate.onReady();
	}
	
	/**
	 * Require all component modules and return the module names.
	 * (This uses webpack's require.context() function to find and
	 * then require all module files.)
	 *
	 * @returns {string[]} module names
	 */
	function requireAllModules() {
	  var requiresModule = __webpack_require__(573);
	  var scriptFiles = requiresModule.keys();
	  return scriptFiles.map(function (script) {
	    return requiresModule(script);
	  });
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(42)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _authAuthModule = __webpack_require__(73);
	
	var _authAuthModule2 = _interopRequireDefault(_authAuthModule);
	
	var _blueBlueModule = __webpack_require__(33);
	
	var _blueBlueModule2 = _interopRequireDefault(_blueBlueModule);
	
	var _clientClientModule = __webpack_require__(26);
	
	var _clientClientModule2 = _interopRequireDefault(_clientClientModule);
	
	var _debugDebugModule = __webpack_require__(74);
	
	var _debugDebugModule2 = _interopRequireDefault(_debugDebugModule);
	
	var _httpHttpModule = __webpack_require__(11);
	
	var _httpHttpModule2 = _interopRequireDefault(_httpHttpModule);
	
	var _recordRecordModule = __webpack_require__(75);
	
	var _recordRecordModule2 = _interopRequireDefault(_recordRecordModule);
	
	var _registryRegistryModule = __webpack_require__(34);
	
	var _registryRegistryModule2 = _interopRequireDefault(_registryRegistryModule);
	
	var _coreConfig = __webpack_require__(463);
	
	var _coreConfig2 = _interopRequireDefault(_coreConfig);
	
	var _coreRun = __webpack_require__(464);
	
	var _coreRun2 = _interopRequireDefault(_coreRun);
	
	/**
	 * @ngdoc overview
	 * @name rhino.core
	 * @description The core Rhino module, which includes all of the central features of Rhino including authentication, the Rhino Registry,
	 * the Rhino HTTP service, and Rhino Records.
	 */
	exports['default'] = angular.module('rhino.core', ['angulartics.google.analytics', // depend on angulartics google analytics so that all apps get this plugged in automatically
	'ngCookies', _authAuthModule2['default'], _blueBlueModule2['default'], _clientClientModule2['default'], _debugDebugModule2['default'], _httpHttpModule2['default'], _recordRecordModule2['default'], _registryRegistryModule2['default']]).config(_coreConfig2['default']).run(_coreRun2['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.8.1 - 2015-10-01
	 * 
	 * Copyright (c) 2015 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	runTranslate.$inject = ['$translate'];
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (arguments.length < 3) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee) {
	    if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      angular.forEach(value, function (propertyValue, propertyKey) {
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee);
	      });
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else {
	      return iteratee(value);
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	.constant('pascalprechtTranslateOverrider', {})
	.provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	      $preferredLanguage,
	      $availableLanguageKeys = [],
	      $languageKeyAliases,
	      $fallbackLanguage,
	      $fallbackWasString,
	      $uses,
	      $nextLang,
	      $storageFactory,
	      $storageKey = $STORAGE_KEY,
	      $storagePrefix,
	      $missingTranslationHandlerFactory,
	      $interpolationFactory,
	      $interpolatorFactories = [],
	      $loaderFactory,
	      $cloakClassName = 'translate-cloak',
	      $loaderOptions,
	      $notFoundIndicatorLeft,
	      $notFoundIndicatorRight,
	      $postCompilingEnabled = false,
	      $forceAsyncReloadEnabled = false,
	      $nestedObjectDelimeter = '.',
	      $isReady = false,
	      loaderCache,
	      directivePriority = 0,
	      statefulFilter = true,
	      uniformLanguageTagResolver = 'default',
	      languageTagResolver = {
	        'default': function (tag) {
	          return (tag || '').split('-').join('_');
	        },
	        java: function (tag) {
	          var temp = (tag || '').split('-').join('_');
	          var parts = temp.split('_');
	          return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	        },
	        bcp47: function (tag) {
	          var temp = (tag || '').split('_').join('-');
	          var parts = temp.split('-');
	          return parts.length > 1 ? (parts[0].toLowerCase() + '-' + parts[1].toUpperCase()) : temp;
	        }
	      };
	
	  var version = '2.8.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	        browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	        i,
	        language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function(array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  var negotiateLocale = function (preferred) {
	
	    var avail = [],
	        locale = angular.lowercase(preferred),
	        i = 0,
	        n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(angular.lowercase($availableLanguageKeys[i]));
	    }
	
	    if (indexOf(avail, locale) > -1) {
	      return preferred;
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        var hasWildcardKey = false;
	        var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	          angular.lowercase(langKeyAlias) === angular.lowercase(preferred);
	
	        if (langKeyAlias.slice(-1) === '*') {
	          hasWildcardKey = langKeyAlias.slice(0, -1) === preferred.slice(0, langKeyAlias.length-1);
	        }
	        if (hasExactKey || hasWildcardKey) {
	          alias = $languageKeyAliases[langKeyAlias];
	          if (indexOf(avail, angular.lowercase(alias)) > -1) {
	            return alias;
	          }
	        }
	      }
	    }
	
	    if (preferred) {
	      var parts = preferred.split('_');
	
	      if (parts.length > 1 && indexOf(avail, angular.lowercase(parts[0])) > -1) {
	        return parts[0];
	      }
	    }
	
	    // If everything fails, just return the preferred, unchanged.
	    return preferred;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} key A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if(path.length && key === prevKey){
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	 /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function(langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [ langKey ];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage)  && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	 /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function(key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({ url: url }, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard: options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale);
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} interpolateParams An object hash for dynamic values
	   * @param {string} interpolationId The id of the interpolation to use
	   * @returns {object} promise
	   */
	  this.$get = [
	    '$log',
	    '$injector',
	    '$rootScope',
	    '$q',
	    function ($log, $injector, $rootScope, $q) {
	
	      var Storage,
	          defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	          pendingLoader = false,
	          interpolatorHashMap = {},
	          langPromises = {},
	          fallbackIndex,
	          startFallbackIteration;
	
	      var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText) {
	
	        // Duck detection: If the first argument is an array, a bunch of translations was requested.
	        // The result is an object.
	        if (angular.isArray(translationId)) {
	          // Inspired by Q.allSettled by Kris Kowal
	          // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	          // This transforms all promises regardless resolved or rejected
	          var translateAll = function (translationIds) {
	            var results = {}; // storing the actual results
	            var promises = []; // promises to wait for
	            // Wraps the promise a) being always resolved and b) storing the link id->value
	            var translate = function (translationId) {
	              var deferred = $q.defer();
	              var regardless = function (value) {
	                results[translationId] = value;
	                deferred.resolve([translationId, value]);
	              };
	              // we don't care whether the promise was resolved or rejected; just store the values
	              $translate(translationId, interpolateParams, interpolationId, defaultTranslationText).then(regardless, regardless);
	              return deferred.promise;
	            };
	            for (var i = 0, c = translationIds.length; i < c; i++) {
	              promises.push(translate(translationIds[i]));
	            }
	            // wait for all (including storing to results)
	            return $q.all(promises).then(function () {
	              // return the results
	              return results;
	            });
	          };
	          return translateAll(translationId);
	        }
	
	        var deferred = $q.defer();
	
	        // trim off any whitespace
	        if (translationId) {
	          translationId = trim.apply(translationId);
	        }
	
	        var promiseToWaitFor = (function () {
	          var promise = $preferredLanguage ?
	            langPromises[$preferredLanguage] :
	            langPromises[$uses];
	
	          fallbackIndex = 0;
	
	          if ($storageFactory && !promise) {
	            // looks like there's no pending promise for $preferredLanguage or
	            // $uses. Maybe there's one pending for a language that comes from
	            // storage.
	            var langKey = Storage.get($storageKey);
	            promise = langPromises[langKey];
	
	            if ($fallbackLanguage && $fallbackLanguage.length) {
	                var index = indexOf($fallbackLanguage, langKey);
	                // maybe the language from storage is also defined as fallback language
	                // we increase the fallback language index to not search in that language
	                // as fallback, since it's probably the first used language
	                // in that case the index starts after the first element
	                fallbackIndex = (index === 0) ? 1 : 0;
	
	                // but we can make sure to ALWAYS fallback to preferred language at least
	                if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	                  $fallbackLanguage.push($preferredLanguage);
	                }
	            }
	          }
	          return promise;
	        }());
	
	        if (!promiseToWaitFor) {
	          // no promise to wait for? okay. Then there's no loader registered
	          // nor is a one pending for language that comes from storage.
	          // We can just translate.
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText).then(deferred.resolve, deferred.reject);
	        } else {
	          var promiseResolved = function () {
	            determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText).then(deferred.resolve, deferred.reject);
	          };
	          promiseResolved.displayName = 'promiseResolved';
	
	          promiseToWaitFor['finally'](promiseResolved, deferred.reject);
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name applyNotFoundIndicators
	       * @private
	       *
	       * @description
	       * Applies not fount indicators to given translation id, if needed.
	       * This function gets only executed, if a translation id doesn't exist,
	       * which is why a translation id is expected as argument.
	       *
	       * @param {string} translationId Translation id.
	       * @returns {string} Same as given translation id but applied with not found
	       * indicators.
	       */
	      var applyNotFoundIndicators = function (translationId) {
	        // applying notFoundIndicators
	        if ($notFoundIndicatorLeft) {
	          translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	        }
	        if ($notFoundIndicatorRight) {
	          translationId = [translationId, $notFoundIndicatorRight].join(' ');
	        }
	        return translationId;
	      };
	
	      /**
	       * @name useLanguage
	       * @private
	       *
	       * @description
	       * Makes actual use of a language by setting a given language key as used
	       * language and informs registered interpolators to also use the given
	       * key as locale.
	       *
	       * @param {key} Locale key.
	       */
	      var useLanguage = function (key) {
	        $uses = key;
	
	        // make sure to store new language key before triggering success event
	        if ($storageFactory) {
	          Storage.put($translate.storageKey(), $uses);
	        }
	
	        $rootScope.$emit('$translateChangeSuccess', {language: key});
	
	        // inform default interpolator
	        defaultInterpolator.setLocale($uses);
	
	        var eachInterpolator = function (interpolator, id) {
	          interpolatorHashMap[id].setLocale($uses);
	        };
	        eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	        // inform all others too!
	        angular.forEach(interpolatorHashMap, eachInterpolator);
	        $rootScope.$emit('$translateChangeEnd', {language: key});
	      };
	
	      /**
	       * @name loadAsync
	       * @private
	       *
	       * @description
	       * Kicks of registered async loader using `$injector` and applies existing
	       * loader options. When resolved, it updates translation tables accordingly
	       * or rejects with given language key.
	       *
	       * @param {string} key Language key.
	       * @return {Promise} A promise.
	       */
	      var loadAsync = function (key) {
	        if (!key) {
	          throw 'No language key specified for loading.';
	        }
	
	        var deferred = $q.defer();
	
	        $rootScope.$emit('$translateLoadingStart', {language: key});
	        pendingLoader = true;
	
	        var cache = loaderCache;
	        if (typeof(cache) === 'string') {
	          // getting on-demand instance of loader
	          cache = $injector.get(cache);
	        }
	
	        var loaderOptions = angular.extend({}, $loaderOptions, {
	          key: key,
	          $http: angular.extend({}, {
	            cache: cache
	          }, $loaderOptions.$http)
	        });
	
	        var onLoaderSuccess = function (data) {
	          var translationTable = {};
	          $rootScope.$emit('$translateLoadingSuccess', {language: key});
	
	          if (angular.isArray(data)) {
	            angular.forEach(data, function (table) {
	              angular.extend(translationTable, flatObject(table));
	            });
	          } else {
	            angular.extend(translationTable, flatObject(data));
	          }
	          pendingLoader = false;
	          deferred.resolve({
	            key: key,
	            table: translationTable
	          });
	          $rootScope.$emit('$translateLoadingEnd', {language: key});
	        };
	        onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	        var onLoaderError = function (key) {
	          $rootScope.$emit('$translateLoadingError', {language: key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateLoadingEnd', {language: key});
	        };
	        onLoaderError.displayName = 'onLoaderError';
	
	        $injector.get($loaderFactory)(loaderOptions)
	          .then(onLoaderSuccess, onLoaderError);
	
	        return deferred.promise;
	      };
	
	      if ($storageFactory) {
	        Storage = $injector.get($storageFactory);
	
	        if (!Storage.get || !Storage.put) {
	          throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	        }
	      }
	
	      // if we have additional interpolations that were added via
	      // $translateProvider.addInterpolation(), we have to map'em
	      if ($interpolatorFactories.length) {
	        var eachInterpolationFactory = function (interpolatorFactory) {
	          var interpolator = $injector.get(interpolatorFactory);
	          // setting initial locale for each interpolation service
	          interpolator.setLocale($preferredLanguage || $uses);
	          // make'em recognizable through id
	          interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	        };
	        eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	        angular.forEach($interpolatorFactories, eachInterpolationFactory);
	      }
	
	      /**
	       * @name getTranslationTable
	       * @private
	       *
	       * @description
	       * Returns a promise that resolves to the translation table
	       * or is rejected if an error occurred.
	       *
	       * @param langKey
	       * @returns {Q.promise}
	       */
	      var getTranslationTable = function (langKey) {
	        var deferred = $q.defer();
	        if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	          deferred.resolve($translationTable[langKey]);
	        } else if (langPromises[langKey]) {
	          var onResolve = function (data) {
	            translations(data.key, data.table);
	            deferred.resolve(data.table);
	          };
	          onResolve.displayName = 'translationTableResolver';
	          langPromises[langKey].then(onResolve, deferred.reject);
	        } else {
	          deferred.reject();
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name getFallbackTranslation
	       * @private
	       *
	       * @description
	       * Returns a promise that will resolve to the translation
	       * or be rejected if no translation was found for the language.
	       * This function is currently only used for fallback language translation.
	       *
	       * @param langKey The language to translate to.
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise}
	       */
	      var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator) {
	        var deferred = $q.defer();
	
	        var onResolve = function (translationTable) {
	          if (Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
	            Interpolator.setLocale(langKey);
	            var translation = translationTable[translationId];
	            if (translation.substr(0, 2) === '@:') {
	              getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator)
	                .then(deferred.resolve, deferred.reject);
	            } else {
	              deferred.resolve(Interpolator.interpolate(translationTable[translationId], interpolateParams));
	            }
	            Interpolator.setLocale($uses);
	          } else {
	            deferred.reject();
	          }
	        };
	        onResolve.displayName = 'fallbackTranslationResolver';
	
	        getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	        return deferred.promise;
	      };
	
	      /**
	       * @name getFallbackTranslationInstant
	       * @private
	       *
	       * @description
	       * Returns a translation
	       * This function is currently only used for fallback language translation.
	       *
	       * @param langKey The language to translate to.
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {string} translation
	       */
	      var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator) {
	        var result, translationTable = $translationTable[langKey];
	
	        if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId)) {
	          Interpolator.setLocale(langKey);
	          result = Interpolator.interpolate(translationTable[translationId], interpolateParams);
	          if (result.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator);
	          }
	          Interpolator.setLocale($uses);
	        }
	
	        return result;
	      };
	
	
	      /**
	       * @name translateByHandler
	       * @private
	       *
	       * Translate by missing translation handler.
	       *
	       * @param translationId
	       * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	       * absent
	       */
	      var translateByHandler = function (translationId, interpolateParams) {
	        // If we have a handler factory - we might also call it here to determine if it provides
	        // a default text for a translationid that can't be found anywhere in our tables
	        if ($missingTranslationHandlerFactory) {
	          var resultString = $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams);
	          if (resultString !== undefined) {
	            return resultString;
	          } else {
	            return translationId;
	          }
	        } else {
	          return translationId;
	        }
	      };
	
	      /**
	       * @name resolveForFallbackLanguage
	       * @private
	       *
	       * Recursive helper function for fallbackTranslation that will sequentially look
	       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	       *
	       * @param fallbackLanguageIndex
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise} Promise that will resolve to the translation.
	       */
	      var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText) {
	        var deferred = $q.defer();
	
	        if (fallbackLanguageIndex < $fallbackLanguage.length) {
	          var langKey = $fallbackLanguage[fallbackLanguageIndex];
	          getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator).then(
	            deferred.resolve,
	            function () {
	              // Look in the next fallback language for a translation.
	              // It delays the resolving by passing another promise to resolve.
	              resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText).then(deferred.resolve);
	            }
	          );
	        } else {
	          // No translation found in any fallback language
	          // if a default translation text is set in the directive, then return this as a result
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            // if no default translation is set and an error handler is defined, send it to the handler
	            // and then return the result
	            deferred.resolve(translateByHandler(translationId, interpolateParams));
	          }
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @name resolveForFallbackLanguageInstant
	       * @private
	       *
	       * Recursive helper function for fallbackTranslation that will sequentially look
	       * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	       *
	       * @param fallbackLanguageIndex
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {string} translation
	       */
	      var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator) {
	        var result;
	
	        if (fallbackLanguageIndex < $fallbackLanguage.length) {
	          var langKey = $fallbackLanguage[fallbackLanguageIndex];
	          result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator);
	          if (!result) {
	            result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	          }
	        }
	        return result;
	      };
	
	      /**
	       * Translates with the usage of the fallback languages.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {Q.promise} Promise, that resolves to the translation.
	       */
	      var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText) {
	        // Start with the fallbackLanguage with index 0
	        return resolveForFallbackLanguage((startFallbackIteration>0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText);
	      };
	
	      /**
	       * Translates with the usage of the fallback languages.
	       *
	       * @param translationId
	       * @param interpolateParams
	       * @param Interpolator
	       * @returns {String} translation
	       */
	      var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator) {
	        // Start with the fallbackLanguage with index 0
	        return resolveForFallbackLanguageInstant((startFallbackIteration>0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator);
	      };
	
	      var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText) {
	
	        var deferred = $q.defer();
	
	        var table = $uses ? $translationTable[$uses] : $translationTable,
	            Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	        // if the translation id exists, we can just interpolate it
	        if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
	          var translation = table[translationId];
	
	          // If using link, rerun $translate with linked translationId and return it
	          if (translation.substr(0, 2) === '@:') {
	
	            $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            deferred.resolve(Interpolator.interpolate(translation, interpolateParams));
	          }
	        } else {
	          var missingTranslationHandlerTranslation;
	          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams);
	          }
	
	          // since we couldn't translate the inital requested translation id,
	          // we try it now with one or more fallback languages, if fallback language(s) is
	          // configured.
	          if ($uses && $fallbackLanguage && $fallbackLanguage.length) {
	            fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText)
	                .then(function (translation) {
	                  deferred.resolve(translation);
	                }, function (_translationId) {
	                  deferred.reject(applyNotFoundIndicators(_translationId));
	                });
	          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            if (defaultTranslationText) {
	              deferred.resolve(defaultTranslationText);
	              } else {
	                deferred.resolve(missingTranslationHandlerTranslation);
	              }
	          } else {
	            if (defaultTranslationText) {
	              deferred.resolve(defaultTranslationText);
	            } else {
	              deferred.reject(applyNotFoundIndicators(translationId));
	            }
	          }
	        }
	        return deferred.promise;
	      };
	
	      var determineTranslationInstant = function (translationId, interpolateParams, interpolationId) {
	
	        var result, table = $uses ? $translationTable[$uses] : $translationTable,
	            Interpolator = defaultInterpolator;
	
	        // if the interpolation id exists use custom interpolator
	        if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	          Interpolator = interpolatorHashMap[interpolationId];
	        }
	
	        // if the translation id exists, we can just interpolate it
	        if (table && Object.prototype.hasOwnProperty.call(table, translationId)) {
	          var translation = table[translationId];
	
	          // If using link, rerun $translate with linked translationId and return it
	          if (translation.substr(0, 2) === '@:') {
	            result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId);
	          } else {
	            result = Interpolator.interpolate(translation, interpolateParams);
	          }
	        } else {
	          var missingTranslationHandlerTranslation;
	          // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams);
	          }
	
	          // since we couldn't translate the inital requested translation id,
	          // we try it now with one or more fallback languages, if fallback language(s) is
	          // configured.
	          if ($uses && $fallbackLanguage && $fallbackLanguage.length) {
	            fallbackIndex = 0;
	            result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator);
	          } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            // looks like the requested translation id doesn't exists.
	            // Now, if there is a registered handler for missing translations and no
	            // asyncLoader is pending, we execute the handler
	            result = missingTranslationHandlerTranslation;
	          } else {
	            result = applyNotFoundIndicators(translationId);
	          }
	        }
	
	        return result;
	      };
	
	      var clearNextLangAndPromise = function(key) {
	        if ($nextLang === key) {
	          $nextLang = undefined;
	        }
	        langPromises[key] = undefined;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#preferredLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key for the preferred language.
	       *
	       * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	       *
	       * @return {string} preferred language key
	       */
	      $translate.preferredLanguage = function (langKey) {
	        if(langKey) {
	          setupPreferredLanguage(langKey);
	        }
	        return $preferredLanguage;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#cloakClassName
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the configured class name for `translate-cloak` directive.
	       *
	       * @return {string} cloakClassName
	       */
	      $translate.cloakClassName = function () {
	        return $cloakClassName;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the configured delimiter for nested namespaces.
	       *
	       * @return {string} nestedObjectDelimeter
	       */
	      $translate.nestedObjectDelimeter = function () {
	        return $nestedObjectDelimeter;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#fallbackLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key for the fallback languages or sets a new fallback stack.
	       *
	       * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	       *
	       * @return {string||array} fallback language key
	       */
	      $translate.fallbackLanguage = function (langKey) {
	        if (langKey !== undefined && langKey !== null) {
	          fallbackStack(langKey);
	
	          // as we might have an async loader initiated and a new translation language might have been defined
	          // we need to add the promise to the stack also. So - iterate.
	          if ($loaderFactory) {
	            if ($fallbackLanguage && $fallbackLanguage.length) {
	              for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	                if (!langPromises[$fallbackLanguage[i]]) {
	                  langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	                }
	              }
	            }
	          }
	          $translate.use($translate.use());
	        }
	        if ($fallbackWasString) {
	          return $fallbackLanguage[0];
	        } else {
	          return $fallbackLanguage;
	        }
	
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#useFallbackLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Sets the first key of the fallback language stack to be used for translation.
	       * Therefore all languages in the fallback array BEFORE this key will be skipped!
	       *
	       * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	       * get back to the whole stack
	       */
	      $translate.useFallbackLanguage = function (langKey) {
	        if (langKey !== undefined && langKey !== null) {
	          if (!langKey) {
	            startFallbackIteration = 0;
	          } else {
	            var langKeyPosition = indexOf($fallbackLanguage, langKey);
	            if (langKeyPosition > -1) {
	              startFallbackIteration = langKeyPosition;
	            }
	          }
	
	        }
	
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#proposedLanguage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the language key of language that is currently loaded asynchronously.
	       *
	       * @return {string} language key
	       */
	      $translate.proposedLanguage = function () {
	        return $nextLang;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#storage
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns registered storage.
	       *
	       * @return {object} Storage
	       */
	      $translate.storage = function () {
	        return Storage;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#use
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Tells angular-translate which language to use by given language key. This method is
	       * used to change language at runtime. It also takes care of storing the language
	       * key in a configured store to let your app remember the choosed language.
	       *
	       * When trying to 'use' a language which isn't available it tries to load it
	       * asynchronously with registered loaders.
	       *
	       * Returns promise object with loaded language file data or string of the currently used language.
	       *
	       * If no or a falsy key is given it returns the currently used language key.
	       * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	       * @example
	       * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	       *
	       * @param {string} [key] Language key
	       * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	       */
	      $translate.use = function (key) {
	        if (!key) {
	          return $uses;
	        }
	
	        var deferred = $q.defer();
	
	        $rootScope.$emit('$translateChangeStart', {language: key});
	
	        // Try to get the aliased language key
	        var aliasedKey = negotiateLocale(key);
	        if (aliasedKey) {
	          key = aliasedKey;
	        }
	
	        // if there isn't a translation table for the language we've requested,
	        // we load it asynchronously
	        if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	          $nextLang = key;
	          langPromises[key] = loadAsync(key).then(function (translation) {
	            translations(translation.key, translation.table);
	            deferred.resolve(translation.key);
	            if ($nextLang === key) {
	              useLanguage(translation.key);
	            }
	            return translation;
	          }, function (key) {
	            $rootScope.$emit('$translateChangeError', {language: key});
	            deferred.reject(key);
	            $rootScope.$emit('$translateChangeEnd', {language: key});
	            return $q.reject(key);
	          });
	          langPromises[key]['finally'](function () {
	            clearNextLangAndPromise(key);
	          });
	        } else if ($nextLang === key && langPromises[key]) {
	          // we are already loading this asynchronously
	          // resolve our new deferred when the old langPromise is resolved
	          langPromises[key].then(function (translation) {
	            deferred.resolve(translation.key);
	            return translation;
	          }, function (key) {
	            deferred.reject(key);
	            return $q.reject(key);
	          });
	        } else {
	          deferred.resolve(key);
	          useLanguage(key);
	        }
	
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#storageKey
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the key for the storage.
	       *
	       * @return {string} storage key
	       */
	      $translate.storageKey = function () {
	        return storageKey();
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether post compiling is enabled or not
	       *
	       * @return {bool} storage key
	       */
	      $translate.isPostCompilingEnabled = function () {
	        return $postCompilingEnabled;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether force async reload is enabled or not
	       *
	       * @return {boolean} forceAsyncReload value
	       */
	      $translate.isForceAsyncReloadEnabled = function () {
	        return $forceAsyncReloadEnabled;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#refresh
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	       * the module will drop all existent translation tables and load new version of those which
	       * are currently in use.
	       *
	       * Refresh means that the module will drop target translation table and try to load it again.
	       *
	       * In case there are no loaders registered the refresh() method will throw an Error.
	       *
	       * If the module is able to refresh translation tables refresh() method will broadcast
	       * $translateRefreshStart and $translateRefreshEnd events.
	       *
	       * @example
	       * // this will drop all currently existent translation tables and reload those which are
	       * // currently in use
	       * $translate.refresh();
	       * // this will refresh a translation table for the en_US language
	       * $translate.refresh('en_US');
	       *
	       * @param {string} langKey A language key of the table, which has to be refreshed
	       *
	       * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	       * process is finished successfully, and reject if not.
	       */
	      $translate.refresh = function (langKey) {
	        if (!$loaderFactory) {
	          throw new Error('Couldn\'t refresh translation table, no loader registered!');
	        }
	
	        var deferred = $q.defer();
	
	        function resolve() {
	          deferred.resolve();
	          $rootScope.$emit('$translateRefreshEnd', {language: langKey});
	        }
	
	        function reject() {
	          deferred.reject();
	          $rootScope.$emit('$translateRefreshEnd', {language: langKey});
	        }
	
	        $rootScope.$emit('$translateRefreshStart', {language: langKey});
	
	        if (!langKey) {
	          // if there's no language key specified we refresh ALL THE THINGS!
	          var tables = [], loadingKeys = {};
	
	          // reload registered fallback languages
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              tables.push(loadAsync($fallbackLanguage[i]));
	              loadingKeys[$fallbackLanguage[i]] = true;
	            }
	          }
	
	          // reload currently used language
	          if ($uses && !loadingKeys[$uses]) {
	            tables.push(loadAsync($uses));
	          }
	
	          var allTranslationsLoaded = function (tableData) {
	            $translationTable = {};
	            angular.forEach(tableData, function (data) {
	              translations(data.key, data.table);
	            });
	            if ($uses) {
	              useLanguage($uses);
	            }
	            resolve();
	          };
	          allTranslationsLoaded.displayName = 'refreshPostProcessor';
	
	          $q.all(tables).then(allTranslationsLoaded, reject);
	
	        } else if ($translationTable[langKey]) {
	
	          var oneTranslationsLoaded = function (data) {
	            translations(data.key, data.table);
	            if (langKey === $uses) {
	              useLanguage($uses);
	            }
	            resolve();
	          };
	          oneTranslationsLoaded.displayName = 'refreshPostProcessor';
	
	          loadAsync(langKey).then(oneTranslationsLoaded, reject);
	
	        } else {
	          reject();
	        }
	        return deferred.promise;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#instant
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns a translation instantly from the internal state of loaded translation. All rules
	       * regarding the current language, the preferred language of even fallback languages will be
	       * used except any promise handling. If a language was not found, an asynchronous loading
	       * will be invoked in the background.
	       *
	       * @param {string|array} translationId A token which represents a translation id
	       *                                     This can be optionally an array of translation ids which
	       *                                     results that the function's promise returns an object where
	       *                                     each key is the translation id and the value the translation.
	       * @param {object} interpolateParams Params
	       * @param {string} interpolationId The id of the interpolation to use
	       *
	       * @return {string|object} translation
	       */
	      $translate.instant = function (translationId, interpolateParams, interpolationId) {
	
	        // Detect undefined and null values to shorten the execution and prevent exceptions
	        if (translationId === null || angular.isUndefined(translationId)) {
	          return translationId;
	        }
	
	        // Duck detection: If the first argument is an array, a bunch of translations was requested.
	        // The result is an object.
	        if (angular.isArray(translationId)) {
	          var results = {};
	          for (var i = 0, c = translationId.length; i < c; i++) {
	            results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId);
	          }
	          return results;
	        }
	
	        // We discarded unacceptable values. So we just need to verify if translationId is empty String
	        if (angular.isString(translationId) && translationId.length < 1) {
	          return translationId;
	        }
	
	        // trim off any whitespace
	        if (translationId) {
	          translationId = trim.apply(translationId);
	        }
	
	        var result, possibleLangKeys = [];
	        if ($preferredLanguage) {
	          possibleLangKeys.push($preferredLanguage);
	        }
	        if ($uses) {
	          possibleLangKeys.push($uses);
	        }
	        if ($fallbackLanguage && $fallbackLanguage.length) {
	          possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	        }
	        for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	          var possibleLangKey = possibleLangKeys[j];
	          if ($translationTable[possibleLangKey]) {
	            if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	              result = determineTranslationInstant(translationId, interpolateParams, interpolationId);
	            } else if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	              result = applyNotFoundIndicators(translationId);
	            }
	          }
	          if (typeof result !== 'undefined') {
	            break;
	          }
	        }
	
	        if (!result && result !== '') {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams);
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            result = translateByHandler(translationId, interpolateParams);
	          }
	        }
	
	        return result;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#versionInfo
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the current version information for the angular-translate library
	       *
	       * @return {string} angular-translate version
	       */
	      $translate.versionInfo = function () {
	        return version;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#loaderCache
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns the defined loaderCache.
	       *
	       * @return {boolean|string|object} current value of loaderCache
	       */
	      $translate.loaderCache = function () {
	        return loaderCache;
	      };
	
	      // internal purpose only
	      $translate.directivePriority = function () {
	        return directivePriority;
	      };
	
	      // internal purpose only
	      $translate.statefulFilter = function () {
	        return statefulFilter;
	      };
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#isReady
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	       *
	       * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	       *
	       * @return {boolean} current value of ready
	       */
	      $translate.isReady = function () {
	        return $isReady;
	      };
	
	      var $onReadyDeferred = $q.defer();
	      $onReadyDeferred.promise.then(function () {
	        $isReady = true;
	      });
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translate#onReady
	       * @methodOf pascalprecht.translate.$translate
	       *
	       * @description
	       * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	       *
	       * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	       *
	       * @param {Function=} fn Function to invoke when service is ready
	       * @return {object} Promise resolved when service is ready
	       */
	      $translate.onReady = function (fn) {
	        var deferred = $q.defer();
	        if (angular.isFunction(fn)) {
	          deferred.promise.then(fn);
	        }
	        if ($isReady) {
	          deferred.resolve();
	        } else {
	          $onReadyDeferred.promise.then(deferred.resolve);
	        }
	        return deferred.promise;
	      };
	
	      // Whenever $translateReady is being fired, this will ensure the state of $isReady
	      var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	        $onReadyDeferred.resolve();
	        globalOnReadyListener(); // one time only
	        globalOnReadyListener = null;
	      });
	      var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	        $onReadyDeferred.resolve();
	        globalOnChangeListener(); // one time only
	        globalOnChangeListener = null;
	      });
	
	      if ($loaderFactory) {
	
	        // If at least one async loader is defined and there are no
	        // (default) translations available we should try to load them.
	        if (angular.equals($translationTable, {})) {
	          if ($translate.use()) {
	            $translate.use($translate.use());
	          }
	        }
	
	        // Also, if there are any fallback language registered, we start
	        // loading them asynchronously as soon as we can.
	        if ($fallbackLanguage && $fallbackLanguage.length) {
	          var processAsyncResult = function (translation) {
	            translations(translation.key, translation.table);
	            $rootScope.$emit('$translateChangeEnd', { language: translation.key });
	            return translation;
	          };
	          for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	            var fallbackLanguageId = $fallbackLanguage[i];
	            if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	              langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	            }
	          }
	        }
	      } else {
	        $rootScope.$emit('$translateReady', { language: $translate.use() });
	      }
	
	      return $translate;
	    }
	  ];
	}
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given string agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * @returns {string} interpolated string.
	   */
	  $translateInterpolator.interpolate = function (string, interpolationParams) {
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params');
	
	    var interpolatedText = $interpolate(string)(interpolationParams);
	    interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text');
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $compile
	 * @requires $filter
	 * @requires $interpolate
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $q, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = angular.lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text());
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              translationIds.translate = iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr') {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	        });
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = angular.lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (!successful && typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	            iElement.empty().append(scope.preText + value + scope.postText);
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            if (!successful && typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	translateDirective.$inject = ['$translate', '$q', '$interpolate', '$compile', '$parse', '$rootScope'];
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $rootScope
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate) {
	
	  'use strict';
	
	  return {
	    compile: function (tElement) {
	      var applyCloak = function () {
	        tElement.addClass($translate.cloakClassName());
	      },
	      removeCloak = function () {
	        tElement.removeClass($translate.cloakClassName());
	      };
	      $translate.onReady(function () {
	        removeCloak();
	      });
	      applyCloak();
	
	      return function linkFn(scope, iElement, iAttr) {
	        // Register a watcher for the defined translation allowing a fine tuned cloak
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(removeCloak, applyCloak);
	          });
	        }
	      };
	    }
	  };
	}
	translateCloakDirective.$inject = ['$translate'];
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation) {
	
	    if (!angular.isObject(interpolateParams)) {
	      interpolateParams = $parse(interpolateParams)(this);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	translateFilterFactory.$inject = ['$parse', '$translate'];
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	$translationCache.$inject = ['$cacheFactory'];
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module for capturing page transitions and reporting back to Google Analytics
	 */
	'use strict';
	
	disableAngularticsPageTracking.$inject = ["$analyticsProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(393);
	
	var _pageAnalyticsRun = __webpack_require__(394);
	
	var _pageAnalyticsRun2 = _interopRequireDefault(_pageAnalyticsRun);
	
	var _analyticsService = __webpack_require__(392);
	
	var gzAnalytics = _interopRequireWildcard(_analyticsService);
	
	var _analyticsEventDirective = __webpack_require__(391);
	
	var gzAnalyitcsEvent = _interopRequireWildcard(_analyticsEventDirective);
	
	exports['default'] = angular.module('gazelle.core.analytics', ['angulartics', 'rhino.components.application', 'ui.router']).config(disableAngularticsPageTracking).run(_pageAnalyticsRun2['default']).service(gzAnalytics.name, gzAnalytics['default']).directive(gzAnalyitcsEvent.name, gzAnalyitcsEvent['default']).name;
	
	function disableAngularticsPageTracking($analyticsProvider) {
	  'nginject';
	
	  $analyticsProvider.firstPageview(false);
	  $analyticsProvider.virtualPageviews(false);
	}
	module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.4.2
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	// issue #2676 #2889
	function silenceUncaughtInPromise (promise) {
	  return promise.then(undefined, function() {}) && promise;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = silenceUncaughtInPromise(resolution.promise),
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	
	      silenceUncaughtInPromise(result);
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = silenceUncaughtInPromise(invocation.promise);
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactoryProvider
	 *
	 * @description
	 * Provider for $templateFactory. Manages which template-loading mechanism to
	 * use, and will default to the most recent one ($templateRequest on Angular
	 * versions starting from 1.3, $http otherwise).
	 */
	function TemplateFactoryProvider() {
	  var shouldUnsafelyUseHttp = angular.version.minor < 3;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
	   * @methodOf ui.router.util.$templateFactoryProvider
	   *
	   * @description
	   * Forces $templateFactory to use $http instead of $templateRequest. This
	   * might cause XSS, as $http doesn't enforce the regular security checks for
	   * templates that have been introduced in Angular 1.3. Note that setting this
	   * to false on Angular older than 1.3.x will crash, as the $templateRequest
	   * service (and the security checks) are not implemented on these versions.
	   *
	   * See the $sce documentation, section
	   * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
	   * Impact on loading templates</a> for more details about this mechanism.
	   *
	   * @param {boolean} value
	   */
	  this.shouldUnsafelyUseHttp = function(value) {
	    shouldUnsafelyUseHttp = !!value;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$templateFactory
	   *
	   * @requires $http
	   * @requires $templateCache
	   * @requires $injector
	   *
	   * @description
	   * Service. Manages loading of templates.
	   */
	  this.$get = ['$http', '$templateCache', '$injector', function($http, $templateCache, $injector){
	    return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);}];
	}
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else {
	      if(!shouldUnsafelyUseHttp) {
	        return $injector.get('$templateRequest')(url);
	      } else {
	        return $http
	          .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	          .then(function(response) { return response.data; });
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').provider('$templateFactory', TemplateFactoryProvider);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return {'~':'~~', '/':'~2F'}[m]; }) : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return {'~~':'~', '~2F':'/'}[m]; }) : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return val !== undefined && val !== null && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSupersededError = new Error('transition superseded');
	
	    var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
	    var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
	    var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
	    var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) {
	          $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
	          return TransitionSuperseded;
	        }
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }).then(null, function (error) {
	        // propagate TransitionSuperseded error without emitting $stateChangeCancel
	        // as it was already emitted in the success handler above
	        if (error === TransitionSupersededError) return TransitionSuperseded;
	
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	          $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      silenceUncaughtInPromise(transition);
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	
	      return !params || objectKeys(params).reduce(function(acc, key) {
	        var paramDef = state.params[key];
	        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
	      }, true);
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      if (!params) { return true; }
	
	      var keys = objectKeys(params);
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i], paramDef = state.params[key];
	        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
	          return false;
	        }
	      }
	
	      return objectKeys(params).reduce(function(acc, key) {
	        var paramDef = state.params[key];
	        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
	      }, true);
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            result.$$resolveAs = view.resolveAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .constant("$state.runtime", { autoinject: true })
	  .provider('$state', $StateProvider)
	  // Inject $state to initialize when entering runtime. #2574
	  .run(['$injector', function ($injector) {
	    // Allow tests (stateSpec.js) to turn this off by defining this constant
	    if ($injector.get("$state.runtime").autoinject) {
	      $injector.get('$state');
	    }
	  }]);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @example
	 * A view can be unnamed or named.
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div>
	 *
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div>
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 *
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * But typically you'll only use the views property if you name your view or have more than one view
	 * in the same template. There's not really a compelling reason to name a view if its the only one,
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre>
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div>
	 * <div ui-view="data"></div>
	 * </pre>
	 *
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 *
	 * Resolve data:
	 *
	 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	 *
	 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	 * depends on `$resolve` data.
	 *
	 * Example usage of $resolve in a view template
	 * <pre>
	 * $stateProvider.state('home', {
	 *   template: '<my-component user="$resolve.user"></my-component>',
	 *   resolve: {
	 *     user: function(UserService) { return UserService.fetchUser(); }
	 *   }
	 * });
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = function() {
	      return {
	        enter: function (element, target, cb) { target.after(element); cb(); },
	        leave: function (element, cb) { element.remove(); cb(); }
	      };
	    };
	
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics();
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope),
	            inherited     = $element.inheritedData('$uiView');
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          if (previousEl) {
	            previousEl.remove();
	            previousEl = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	
	          if (currentEl) {
	            var $uiViewData = currentEl.data('$uiViewAnim');
	            renderer.leave(currentEl, function() {
	              $uiViewData.$$animLeave.resolve();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	            currentEl = null;
	          }
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            var animEnter = $q.defer(), animLeave = $q.defer();
	            var viewAnimData = {
	              $animEnter: animEnter.promise,
	              $animLeave: animLeave.promise,
	              $$animLeave: animLeave
	            };
	
	            clone.data('$uiViewAnim', viewAnimData);
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              animEnter.resolve();
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      if (tElement.empty) {
	        tElement.empty();
	      } else {
	        // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
	        tElement[0].innerHTML = null;
	      }
	
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          $element.html(initial);
	          $compile($element.contents())(scope);
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var resolveData = angular.extend({}, locals);
	        scope[locals.$$resolveAs] = resolveData;
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
	          }
	          if (isFunction(controller.$onInit)) controller.$onInit();
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var uiViewCreatedBy = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element[element.on ? 'on' : 'bind']("click", hookFn);
	      scope.$on('$destroy', function() {
	        element[element.off ? 'off' : 'unbind']("click", hookFn);
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element[element.on ? 'on' : 'bind']("click", hookFn);
	      scope.$on('$destroy', function() {
	        element[element.off ? 'off' : 'unbind']("click", hookFn);
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        var deregister = addState(newState, newParams, uiSrefActive);
	        update();
	        return deregister;
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        var stateInfo = {
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        };
	
	        states.push(stateInfo);
	        activeClasses[stateHash] = activeClass;
	
	        return function removeState() {
	          var idx = states.indexOf(stateInfo);
	          if (idx !== -1) states.splice(idx, 1);
	        };
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// Should already be required, here for clarity
	__webpack_require__(12);
	
	// Load Angular and dependent libs
	__webpack_require__(28);
	__webpack_require__(29);
	
	// Now load Angular Material
	__webpack_require__(37);
	
	// Export namespace
	module.exports = 'ngMaterial';


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(538);
	
	var _eulaService = __webpack_require__(377);
	
	var gzEulaService = _interopRequireWildcard(_eulaService);
	
	var _eulaController = __webpack_require__(61);
	
	var gzEulaCtrl = _interopRequireWildcard(_eulaController);
	
	exports['default'] = angular.module('gazelle.components.eula', ['ngMaterial', 'rhino.components.locale', 'rhino.core']).service(gzEulaService.name, gzEulaService['default']).controller(gzEulaCtrl.name, gzEulaCtrl['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _rhinoSrcComponentsApplicationApplicationModule = __webpack_require__(65);
	
	var _rhinoSrcComponentsApplicationApplicationModule2 = _interopRequireDefault(_rhinoSrcComponentsApplicationApplicationModule);
	
	var _sessionService = __webpack_require__(449);
	
	var rnSession = _interopRequireWildcard(_sessionService);
	
	exports['default'] = angular.module('rhino.components.session', ['ngCookies', _rhinoSrcComponentsApplicationApplicationModule2['default'], _rhinoSrcCoreCoreModule2['default']]).service(rnSession.name, rnSession['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _httpService = __webpack_require__(467);
	
	var rnHttp = _interopRequireWildcard(_httpService);
	
	var _rhinoSrcCoreRegistryRegistryModule = __webpack_require__(34);
	
	var _rhinoSrcCoreRegistryRegistryModule2 = _interopRequireDefault(_rhinoSrcCoreRegistryRegistryModule);
	
	var _httpConfig = __webpack_require__(465);
	
	var _httpConfig2 = _interopRequireDefault(_httpConfig);
	
	var _withCredentialsInterceptor = __webpack_require__(468);
	
	var withCredentialsInterceptor = _interopRequireWildcard(_withCredentialsInterceptor);
	
	exports['default'] = angular.module('rhino.core.http', [_rhinoSrcCoreRegistryRegistryModule2['default']]).config(_httpConfig2['default']).config(withCredentialsInterceptor.installInterceptorConfig).factory(withCredentialsInterceptor.name, withCredentialsInterceptor['default']).factory(rnHttp.name, rnHttp['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	module.exports = angular;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _hpidService = __webpack_require__(335);
	
	var $gzHpId = _interopRequireWildcard(_hpidService);
	
	exports['default'] = angular.module('gazelle.components.hpid', ['ui.router', 'rhino.core', 'rhino.components.locale']).factory($gzHpId.name, $gzHpId['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var metrics = {
	  responseEndTime: 'metric1',
	  domLoadTime: 'metric2',
	  windowLoadTime: 'metric3',
	  ttfb: 'metric4',
	  stalled: 'metric5',
	  download: 'metric6',
	  startDuration: 'metric7',
	  endDuration: 'metric8',
	  cachedResources: 'metric9'
	};
	
	exports.metrics = metrics;
	var dimensions = {
	  uid: 'dimension1',
	  orgId: 'dimension2',
	  hpInternal: 'dimension3',
	  roles: 'dimension4',
	  orgType: 'dimension5',
	  selfProvisioned: 'dimension6',
	  entityType: 'dimension7',
	  windowId: 'dimension8',
	  hitId: 'dimension9',
	  hitTime: 'dimension10',
	  mobileDeviceId: 'dimension11',
	  appBuContext: 'dimension12',
	  visitingOrgId: 'dimension13'
	};
	
	exports.dimensions = dimensions;
	/**
	 * For use in the APP BU Context custom dimension
	 */
	var APP_BU_CONTEXT = {
	  Indigo: 'Indigo',
	  Latex: 'Latex',
	  DesignJet: 'DesignJet',
	  Scitex: 'Scitex',
	  PWP: 'PWP',
	  ThreeD: '3D'
	};
	exports.APP_BU_CONTEXT = APP_BU_CONTEXT;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreBlueBlueModule = __webpack_require__(33);
	
	var _rhinoSrcCoreBlueBlueModule2 = _interopRequireDefault(_rhinoSrcCoreBlueBlueModule);
	
	var _clientProvider = __webpack_require__(462);
	
	var rnClient = _interopRequireWildcard(_clientProvider);
	
	exports['default'] = angular.module('rhino.core.client', [_rhinoSrcCoreBlueBlueModule2['default']]).provider(rnClient.name, rnClient['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(35);
	module.exports = 'ngAnimate';


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(36);
	module.exports = 'ngAria';


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _blueBlueModule = __webpack_require__(64);
	
	var _blueBlueModule2 = _interopRequireDefault(_blueBlueModule);
	
	var _analyticsAnalyticsModule = __webpack_require__(6);
	
	var _analyticsAnalyticsModule2 = _interopRequireDefault(_analyticsAnalyticsModule);
	
	var _coreConfig = __webpack_require__(396);
	
	var _coreConfig2 = _interopRequireDefault(_coreConfig);
	
	var _coreRun = __webpack_require__(397);
	
	var _coreRun2 = _interopRequireDefault(_coreRun);
	
	var _trustImagesConfig = __webpack_require__(401);
	
	var _trustImagesConfig2 = _interopRequireDefault(_trustImagesConfig);
	
	var _tooltipsConfig = __webpack_require__(400);
	
	var _tooltipsConfig2 = _interopRequireDefault(_tooltipsConfig);
	
	__webpack_require__(540);
	
	exports['default'] = angular.module('gazelle.core', [_blueBlueModule2['default'], _analyticsAnalyticsModule2['default'], 'ngMaterial', 'rhino.core']).config(_tooltipsConfig2['default']).config(_trustImagesConfig2['default']).config(_coreConfig2['default']).run(_coreRun2['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcComponentsSessionSessionModule = __webpack_require__(10);
	
	var _rhinoSrcComponentsSessionSessionModule2 = _interopRequireDefault(_rhinoSrcComponentsSessionSessionModule);
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _deviceService = __webpack_require__(421);
	
	var rnDevice = _interopRequireWildcard(_deviceService);
	
	var _dcsService = __webpack_require__(420);
	
	var rnDcs = _interopRequireWildcard(_dcsService);
	
	var _systemStatisticsService = __webpack_require__(423);
	
	var systemStatisticsService = _interopRequireWildcard(_systemStatisticsService);
	
	var _instructionsService = __webpack_require__(422);
	
	var rnInstructionsService = _interopRequireWildcard(_instructionsService);
	
	var _detectorService = __webpack_require__(66);
	
	var rnDeviceDetector = _interopRequireWildcard(_detectorService);
	
	var _rhinoSrcComponentsSessionSessionModule3 = _interopRequireDefault(_rhinoSrcComponentsSessionSessionModule);
	
	var _rhinoSrcComponentsPusherPusherModule = __webpack_require__(71);
	
	var _rhinoSrcComponentsPusherPusherModule2 = _interopRequireDefault(_rhinoSrcComponentsPusherPusherModule);
	
	exports['default'] = angular.module('rhino.components.device', [_rhinoSrcCoreCoreModule2['default'], _rhinoSrcComponentsSessionSessionModule2['default'], _rhinoSrcComponentsSessionSessionModule3['default'], _rhinoSrcComponentsPusherPusherModule2['default']]).factory(rnDevice.name, rnDevice['default']).factory(rnDcs.name, rnDcs['default']).factory(systemStatisticsService.name, systemStatisticsService['default']).factory(rnInstructionsService.name, rnInstructionsService['default']).factory(rnDeviceDetector.name, rnDeviceDetector['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _rhinoSrcComponentsPreferencesPreferencesModule = __webpack_require__(45);
	
	var _rhinoSrcComponentsPreferencesPreferencesModule2 = _interopRequireDefault(_rhinoSrcComponentsPreferencesPreferencesModule);
	
	var _formatFormatModule = __webpack_require__(70);
	
	var _formatFormatModule2 = _interopRequireDefault(_formatFormatModule);
	
	var _localeCookieProvider = __webpack_require__(433);
	
	var rnLocaleCookie = _interopRequireWildcard(_localeCookieProvider);
	
	var _localeService = __webpack_require__(434);
	
	var rnLocale = _interopRequireWildcard(_localeService);
	
	exports['default'] = angular.module('rhino.components.locale', ['ngCookies', _rhinoSrcCoreCoreModule2['default'], _rhinoSrcComponentsPreferencesPreferencesModule2['default'], _formatFormatModule2['default']]).provider(rnLocaleCookie.name, rnLocaleCookie['default']).service(rnLocale.name, rnLocale['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _blueService = __webpack_require__(461);
	
	var rnBlue = _interopRequireWildcard(_blueService);
	
	exports['default'] = angular.module('rhino.core.blue', []).factory(rnBlue.name, rnBlue['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreBlueBlueModule = __webpack_require__(33);
	
	var _rhinoSrcCoreBlueBlueModule2 = _interopRequireDefault(_rhinoSrcCoreBlueBlueModule);
	
	var _rhinoSrcCoreClientClientModule = __webpack_require__(26);
	
	var _rhinoSrcCoreClientClientModule2 = _interopRequireDefault(_rhinoSrcCoreClientClientModule);
	
	var _registryProvider = __webpack_require__(471);
	
	var registryService = _interopRequireWildcard(_registryProvider);
	
	exports['default'] = angular.module('rhino.core.registry', [_rhinoSrcCoreBlueBlueModule2['default'], _rhinoSrcCoreClientClientModule2['default']]).provider(registryService.name, registryService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  };
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof jqLite) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses(element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockTransitions(node, duration) {
	  // we use a negative delay value since it performs blocking
	  // yet it doesn't kill any existing transitions running on the
	  // same element which makes this safe for class-based animations
	  var value = duration ? '-' + duration + 's' : '';
	  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	  return [TRANSITION_DELAY_PROP, value];
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="MainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('MainController', function MainController() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	/* exported $AnimateCssProvider */
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## Usage
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) === 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	function createLocalCacheLookup() {
	  var cache = Object.create(null);
	  return {
	    flush: function() {
	      cache = Object.create(null);
	    },
	
	    count: function(key) {
	      var entry = cache[key];
	      return entry ? entry.total : 0;
	    },
	
	    get: function(key) {
	      var entry = cache[key];
	      return entry && entry.value;
	    },
	
	    put: function(key, value) {
	      if (!cache[key]) {
	        cache[key] = { total: 1, value: value };
	      } else {
	        cache[key].total++;
	      }
	    }
	  };
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var gcsLookup = createLocalCacheLookup();
	  var gcsStaggerLookup = createLocalCacheLookup();
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    var parentCounter = 0;
	    function gcsHashFn(node, extraClasses) {
	      var KEY = '$$ngAnimateParentKey';
	      var parentNode = node.parentNode;
	      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
	    }
	
	    function computeCachedCssStyles(node, className, cacheKey, properties) {
	      var timings = gcsLookup.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      gcsLookup.put(cacheKey, timings);
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if (gcsLookup.count(cacheKey) > 0) {
	        stagger = gcsStaggerLookup.get(cacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          gcsStaggerLookup.put(cacheKey, stagger);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        gcsLookup.flush();
	        gcsStaggerLookup.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var cacheKey, stagger;
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        cacheKey = gcsHashFn(node, fullClassName);
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : gcsLookup.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== 'boolean') {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) {
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (!options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	        $$jqLite.removeClass(element, activeClasses);
	
	        blockKeyframeAnimations(node, false);
	        blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            if (value) {
	              node.style.setProperty(prop, value);
	            } else {
	              node.style.removeProperty(prop);
	            }
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              if (animationPaused) {
	                temporaryStyles.push(value);
	              } else {
	                removeFromArray(temporaryStyles, value);
	              }
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
	            cacheKey = gcsHashFn(node, fullClassName);
	
	            timings = computeTimings(node, fullClassName, cacheKey);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event === 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a, b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          if (runners.length) {
	            $$AnimateRunner.all(runners, callback);
	          }  else {
	            callback();
	          }
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              if (reject) {
	                runner.cancel();
	              } else {
	                runner.end();
	              }
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i = 0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event === 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	               '$$isDocumentHidden',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
	                $$isDocumentHidden) {
	
	    var activeAnimationsLookup = new $$Map();
	    var disabledElementsLookup = new $$Map();
	    var animationsEnabled = null;
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = Object.create(null);
	
	    // remember that the classNameFilter is set during the provider/config
	    // stage therefore we can optimize here and setup a helper function
	    var classNameFilter = $animateProvider.classNameFilter();
	    var isAnimatableClassName = !classNameFilter
	              ? function() { return true; }
	              : function(className) {
	                return classNameFilter.test(className);
	              };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
	      // eslint-disable-next-line no-bitwise
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	    };
	
	    function findCallbacks(targetParentNode, targetNode, event) {
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, node) {
	      if (phase === 'close' && !node.parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(node);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !disabledElementsLookup.get(node);
	            } else {
	              // (element, bool) - Element setter
	              disabledElementsLookup.set(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(originalElement, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var element = stripCommentsFromElement(originalElement);
	      var node = getDomNode(element);
	      var parentNode = node && node.parentNode;
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // there are situations where a directive issues an animation for
	      // a jqLite wrapper that contains only comment nodes... If this
	      // happens then there is no way we can perform an animation
	      if (!node) {
	        close();
	        return runner;
	      }
	
	      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
	      if (!isAnimatableClassName(className)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $$isDocumentHidden();
	
	      // this is a hard disable of all animations for the application or on
	      // the element itself, therefore  there is no need to continue further
	      // past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start');
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close');
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(node);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(node);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
	        // happen if the animated element is a transcluded clone and also has a `templateUrl`
	        // directive on it. Therefore, we must recreate `element` in order to interact with the
	        // actual DOM nodes.
	        // Note: We still need to use the old `node` for certain things, such as looking up in
	        //       HashMaps where it was used as the key.
	
	        element = stripCommentsFromElement(originalElement);
	
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(node);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(node, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', {});
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(node);
	          }
	          notifyProgress(runner, event, 'close', {});
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parentNode, node, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, node);
	            });
	          } else {
	            cleanupEventListeners(phase, node);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) {
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(node) {
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.delete(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(node) {
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.delete(node);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(node, parentNode, event) {
	      var bodyNode = $document[0].body;
	      var rootNode = getDomNode($rootElement);
	
	      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
	      var rootNodeDetected = (node === rootNode);
	      var parentAnimationDetected = false;
	      var elementDisabled = disabledElementsLookup.get(node);
	      var animateChildren;
	
	      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentNode = getDomNode(parentHost);
	      }
	
	      while (parentNode) {
	        if (!rootNodeDetected) {
	          // angular doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootNodeDetected = (parentNode === rootNode);
	        }
	
	        if (parentNode.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentNode) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentNodeDisabled = disabledElementsLookup.get(parentNode);
	
	          if (parentNodeDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentNodeDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyNodeDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyNodeDetected = (parentNode === bodyNode);
	        }
	
	        if (bodyNodeDetected && rootNodeDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootNodeDetected) {
	          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
	          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentNode = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentNode = parentNode.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootNodeDetected && bodyNodeDetected;
	    }
	
	    function markElementAnimationState(node, state, details) {
	      details = details || {};
	      details.state = state;
	
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.set(node, newValue);
	    }
	  }];
	}];
	
	/* exported $$AnimationProvider */
	
	var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$Map();
	
	      // this is done first beforehand so that the map
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.set(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.set(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry.fn);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      setRunner(element, runner);
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      var prepareClassName;
	      if (isStructural) {
	        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
	        $$jqLite.addClass(element, prepareClassName);
	      }
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          toBeSortedAnimations.push({
	            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
	            fn: function triggerAnimationStart() {
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        element.addClass(NG_ANIMATE_CLASSNAME);
	        if (tempClasses) {
	          $$jqLite.addClass(element, tempClasses);
	        }
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) {
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        element.removeClass(NG_ANIMATE_CLASSNAME);
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 600, // we use 600 here to ensure that the directive is caught before others
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          previousScope = scope.$new();
	          $transclude(previousScope, function(element) {
	            previousElement = element;
	            $animate.enter(element, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                                                | Supported Animations                                                     |
	 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	 *
	 * (More information can be found by visiting each the documentation associated with each directive.)
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 *
	 *   /&#42; if you are using animations instead of transitions you should configure as follows:
	 *     animation-delay: 0.1s;
	 *     animation-duration: 0s; &#42;/
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 *
	 * ```
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that angular
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#!/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id: 1, title: 'Miss Beulah Roob' },
	            { id: 2, title: 'Trent Morissette' },
	            { id: 3, title: 'Miss Ava Pouros' },
	            { id: 4, title: 'Rod Pouros' },
	            { id: 5, title: 'Abdul Rice' },
	            { id: 6, title: 'Laurie Rutherford Sr.' },
	            { id: 7, title: 'Nakia McLaughlin' },
	            { id: 8, title: 'Jordon Blanda DVM' },
	            { id: 9, title: 'Rhoda Hand' },
	            { id: 10, title: 'Alexandrea Sauer' }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams',
	            function ProfileController($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#!/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
	 */
	
	var copy;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var isElement;
	var isFunction;
	var isObject;
	var isString;
	var isUndefined;
	var jqLite;
	var noop;
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [], function initAngularHelpers() {
	  // Access helpers from angular core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  noop        = angular.noop;
	  copy        = angular.copy;
	  extend      = angular.extend;
	  jqLite      = angular.element;
	  forEach     = angular.forEach;
	  isArray     = angular.isArray;
	  isString    = angular.isString;
	  isObject    = angular.isObject;
	  isUndefined = angular.isUndefined;
	  isDefined   = angular.isDefined;
	  isFunction  = angular.isFunction;
	  isElement   = angular.isElement;
	})
	  .info({ angularVersion: '1.6.4' })
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngAria
	 * @description
	 *
	 * The `ngAria` module provides support for common
	 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
	 * attributes that convey state or semantic information about the application for users
	 * of assistive technologies, such as screen readers.
	 *
	 * <div doc-module-components="ngAria"></div>
	 *
	 * ## Usage
	 *
	 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
	 * directives are supported:
	 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
	 * `ngDblClick`, and `ngMessages`.
	 *
	 * Below is a more detailed breakdown of the attributes handled by ngAria:
	 *
	 * | Directive                                   | Supported Attributes                                                                                |
	 * |---------------------------------------------|-----------------------------------------------------------------------------------------------------|
	 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
	 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                                       |
	 * | {@link ng.directive:ngRequired ngRequired}  | aria-required                                                                                       |
	 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked                                                                                        |
	 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                                       |
	 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                                        |
	 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                                         |
	 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                                         |
	 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                                            |
	 * | {@link module:ngMessages ngMessages}        | aria-live                                                                                           |
	 * | {@link ng.directive:ngClick ngClick}        | tabindex, keydown event, button role                                                                |
	 *
	 * Find out more information about each directive by reading the
	 * {@link guide/accessibility ngAria Developer Guide}.
	 *
	 * ## Example
	 * Using ngDisabled with ngAria:
	 * ```html
	 * <md-checkbox ng-disabled="disabled">
	 * ```
	 * Becomes:
	 * ```html
	 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
	 * ```
	 *
	 * ## Disabling Attributes
	 * It's possible to disable individual attributes added by ngAria with the
	 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
	 * {@link guide/accessibility Developer Guide}.
	 */
	var ngAriaModule = angular.module('ngAria', ['ng']).
	                        info({ angularVersion: '1.6.4' }).
	                        provider('$aria', $AriaProvider);
	
	/**
	* Internal Utilities
	*/
	var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];
	
	var isNodeOneOf = function(elem, nodeTypeArray) {
	  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
	    return true;
	  }
	};
	/**
	 * @ngdoc provider
	 * @name $ariaProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the ARIA attributes injected and managed by ngAria.
	 *
	 * ```js
	 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
	 *   $ariaProvider.config({
	 *     ariaValue: true,
	 *     tabindex: false
	 *   });
	 * });
	 *```
	 *
	 * ## Dependencies
	 * Requires the {@link ngAria} module to be installed.
	 *
	 */
	function $AriaProvider() {
	  var config = {
	    ariaHidden: true,
	    ariaChecked: true,
	    ariaReadonly: true,
	    ariaDisabled: true,
	    ariaRequired: true,
	    ariaInvalid: true,
	    ariaValue: true,
	    tabindex: true,
	    bindKeydown: true,
	    bindRoleForClick: true
	  };
	
	  /**
	   * @ngdoc method
	   * @name $ariaProvider#config
	   *
	   * @param {object} config object to enable/disable specific ARIA attributes
	   *
	   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
	   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
	   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
	   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
	   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
	   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
	   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and
	   *    aria-valuenow tags
	   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
	   *  - **bindKeydown** – `{boolean}` – Enables/disables keyboard event binding on non-interactive
	   *    elements (such as `div` or `li`) using ng-click, making them more accessible to users of
	   *    assistive technologies
	   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements (such as
	   *    `div` or `li`) using ng-click, making them more accessible to users of assistive
	   *    technologies
	   *
	   * @description
	   * Enables/disables various ARIA attributes
	   */
	  this.config = function(newConfig) {
	    config = angular.extend(config, newConfig);
	  };
	
	  function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
	    return function(scope, elem, attr) {
	      var ariaCamelName = attr.$normalize(ariaAttr);
	      if (config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
	        scope.$watch(attr[attrName], function(boolVal) {
	          // ensure boolean value
	          boolVal = negate ? !boolVal : !!boolVal;
	          elem.attr(ariaAttr, boolVal);
	        });
	      }
	    };
	  }
	  /**
	   * @ngdoc service
	   * @name $aria
	   *
	   * @description
	   * @priority 200
	   *
	   * The $aria service contains helper methods for applying common
	   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
	   *
	   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
	   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
	   * let's review a code snippet from ngAria itself:
	   *
	   *```js
	   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
	   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	   * }])
	   *```
	   * Shown above, the ngAria module creates a directive with the same signature as the
	   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
	   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
	   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
	   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
	   * value in `ngDisabled`.
	   *
	   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
	   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
	   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
	   *
	   * The full list of directives that interface with ngAria:
	   * * **ngModel**
	   * * **ngChecked**
	   * * **ngReadonly**
	   * * **ngRequired**
	   * * **ngDisabled**
	   * * **ngValue**
	   * * **ngShow**
	   * * **ngHide**
	   * * **ngClick**
	   * * **ngDblclick**
	   * * **ngMessages**
	   *
	   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
	   * directive.
	   *
	   *
	   * ## Dependencies
	   * Requires the {@link ngAria} module to be installed.
	   */
	  this.$get = function() {
	    return {
	      config: function(key) {
	        return config[key];
	      },
	      $$watchExpr: watchExpr
	    };
	  };
	}
	
	
	ngAriaModule.directive('ngShow', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
	}])
	.directive('ngHide', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
	}])
	.directive('ngValue', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngChecked', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
	}])
	.directive('ngReadonly', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
	}])
	.directive('ngRequired', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
	}])
	.directive('ngModel', ['$aria', function($aria) {
	
	  function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
	    return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
	  }
	
	  function shouldAttachRole(role, elem) {
	    // if element does not have role attribute
	    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
	    // AND element is not in nodeBlackList
	    return !elem.attr('role') && (elem.attr('type') === role) && !isNodeOneOf(elem, nodeBlackList);
	  }
	
	  function getShape(attr, elem) {
	    var type = attr.type,
	        role = attr.role;
	
	    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
	           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
	           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
	  }
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
	    compile: function(elem, attr) {
	      var shape = getShape(attr, elem);
	
	      return {
	        post: function(scope, elem, attr, ngModel) {
	          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);
	
	          function ngAriaWatchModelValue() {
	            return ngModel.$modelValue;
	          }
	
	          function getRadioReaction(newVal) {
	            // Strict comparison would cause a BC
	            // eslint-disable-next-line eqeqeq
	            var boolVal = (attr.value == ngModel.$viewValue);
	            elem.attr('aria-checked', boolVal);
	          }
	
	          function getCheckboxReaction() {
	            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
	          }
	
	          switch (shape) {
	            case 'radio':
	            case 'checkbox':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', shape);
	              }
	              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
	                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
	                    getRadioReaction : getCheckboxReaction);
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	            case 'range':
	              if (shouldAttachRole(shape, elem)) {
	                elem.attr('role', 'slider');
	              }
	              if ($aria.config('ariaValue')) {
	                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
	                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
	                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
	                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
	                var needsAriaValuenow = !elem.attr('aria-valuenow');
	
	                if (needsAriaValuemin) {
	                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemin', newVal);
	                  });
	                }
	                if (needsAriaValuemax) {
	                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
	                    elem.attr('aria-valuemax', newVal);
	                  });
	                }
	                if (needsAriaValuenow) {
	                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
	                    elem.attr('aria-valuenow', newVal);
	                  });
	                }
	              }
	              if (needsTabIndex) {
	                elem.attr('tabindex', 0);
	              }
	              break;
	          }
	
	          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
	            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
	            // ngModel.$error.required is undefined on custom controls
	            attr.$observe('required', function() {
	              elem.attr('aria-required', !!attr['required']);
	            });
	          }
	
	          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
	            scope.$watch(function ngAriaInvalidWatch() {
	              return ngModel.$invalid;
	            }, function ngAriaInvalidReaction(newVal) {
	              elem.attr('aria-invalid', !!newVal);
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDisabled', ['$aria', function($aria) {
	  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
	}])
	.directive('ngMessages', function() {
	  return {
	    restrict: 'A',
	    require: '?ngMessages',
	    link: function(scope, elem, attr, ngMessages) {
	      if (!elem.attr('aria-live')) {
	        elem.attr('aria-live', 'assertive');
	      }
	    }
	  };
	})
	.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
	  return {
	    restrict: 'A',
	    compile: function(elem, attr) {
	      var fn = $parse(attr.ngClick);
	      return function(scope, elem, attr) {
	
	        if (!isNodeOneOf(elem, nodeBlackList)) {
	
	          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
	            elem.attr('role', 'button');
	          }
	
	          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
	            elem.attr('tabindex', 0);
	          }
	
	          if ($aria.config('bindKeydown') && !attr.ngKeydown && !attr.ngKeypress && !attr.ngKeyup) {
	            elem.on('keydown', function(event) {
	              var keyCode = event.which || event.keyCode;
	              if (keyCode === 32 || keyCode === 13) {
	                scope.$apply(callback);
	              }
	
	              function callback() {
	                fn(scope, { $event: event });
	              }
	            });
	          }
	        }
	      };
	    }
	  };
	}])
	.directive('ngDblclick', ['$aria', function($aria) {
	  return function(scope, elem, attr) {
	    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
	      elem.attr('tabindex', 0);
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	/*!
	 * AngularJS Material Design
	 * https://github.com/angular/material
	 * @license MIT
	 * v1.1.4
	 */
	(function( window, angular, undefined ){
	"use strict";
	
	(function(){
	"use strict";
	
	angular.module('ngMaterial', ["ng","ngAnimate","ngAria","material.core","material.core.interaction","material.core.gestures","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.core.animate","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.checkbox","material.components.chips","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.gridList","material.components.icon","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.progressCircular","material.components.panel","material.components.progressLinear","material.components.radioButton","material.components.showHide","material.components.sidenav","material.components.select","material.components.slider","material.components.sticky","material.components.subheader","material.components.switch","material.components.swipe","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.truncate","material.components.virtualRepeat","material.components.whiteframe"]);
	})();
	(function(){
	"use strict";
	
	/**
	 * Initialization function that validates environment
	 * requirements.
	 */
	DetectNgTouch.$inject = ["$log", "$injector"];
	MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];
	rAFDecorator.$inject = ["$delegate"];
	qDecorator.$inject = ["$delegate"];
	angular
	  .module('material.core', [
	    'ngAnimate',
	    'material.core.animate',
	    'material.core.layout',
	    'material.core.interaction',
	    'material.core.gestures',
	    'material.core.theming'
	  ])
	  .config(MdCoreConfigure)
	  .run(DetectNgTouch);
	
	
	/**
	 * Detect if the ng-Touch module is also being used.
	 * Warn if detected.
	 * @ngInject
	 */
	function DetectNgTouch($log, $injector) {
	  if ( $injector.has('$swipe') ) {
	    var msg = "" +
	      "You are using the ngTouch module. \n" +
	      "AngularJS Material already has mobile click, tap, and swipe support... \n" +
	      "ngTouch is not supported with AngularJS Material!";
	    $log.warn(msg);
	  }
	}
	
	/**
	 * @ngInject
	 */
	function MdCoreConfigure($provide, $mdThemingProvider) {
	
	  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
	  $provide.decorator('$q', ['$delegate', qDecorator]);
	
	  $mdThemingProvider.theme('default')
	    .primaryPalette('indigo')
	    .accentPalette('pink')
	    .warnPalette('deep-orange')
	    .backgroundPalette('grey');
	}
	
	/**
	 * @ngInject
	 */
	function rAFDecorator($delegate) {
	  /**
	   * Use this to throttle events that come in often.
	   * The throttled function will always use the *last* invocation before the
	   * coming frame.
	   *
	   * For example, window resize events that fire many times a second:
	   * If we set to use an raf-throttled callback on window resize, then
	   * our callback will only be fired once per frame, with the last resize
	   * event that happened before that frame.
	   *
	   * @param {function} callback function to debounce
	   */
	  $delegate.throttle = function(cb) {
	    var queuedArgs, alreadyQueued, queueCb, context;
	    return function debounced() {
	      queuedArgs = arguments;
	      context = this;
	      queueCb = cb;
	      if (!alreadyQueued) {
	        alreadyQueued = true;
	        $delegate(function() {
	          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
	          alreadyQueued = false;
	        });
	      }
	    };
	  };
	  return $delegate;
	}
	
	/**
	 * @ngInject
	 */
	function qDecorator($delegate) {
	  /**
	   * Adds a shim for $q.resolve for AngularJS version that don't have it,
	   * so we don't have to think about it.
	   *
	   * via https://github.com/angular/angular.js/pull/11987
	   */
	
	  // TODO(crisbeto): this won't be necessary once we drop AngularJS 1.3
	  if (!$delegate.resolve) {
	    $delegate.resolve = $delegate.when;
	  }
	  return $delegate;
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutofocusDirective.$inject = ["$parse"];angular.module('material.core')
	  .directive('mdAutofocus', MdAutofocusDirective)
	
	  // Support the deprecated md-auto-focus and md-sidenav-focus as well
	  .directive('mdAutoFocus', MdAutofocusDirective)
	  .directive('mdSidenavFocus', MdAutofocusDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdAutofocus
	 * @module material.core.util
	 *
	 * @description
	 *
	 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
	 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
	 *
	 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
	 * attribute directive and optional expression. An expression may be specified as the directive
	 * value to enable conditional activation of the autofocus.
	 *
	 * @usage
	 *
	 * ### Dialog
	 * <hljs lang="html">
	 * <md-dialog>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-autofocus>
	 *     </md-input-container>
	 *   </form>
	 * </md-dialog>
	 * </hljs>
	 *
	 * ### Bottomsheet
	 * <hljs lang="html">
	 * <md-bottom-sheet class="md-list md-has-header">
	 *  <md-subheader>Comment Actions</md-subheader>
	 *  <md-list>
	 *    <md-list-item ng-repeat="item in items">
	 *
	 *      <md-button md-autofocus="$index == 2">
	 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
	 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
	 *      </md-button>
	 *
	 *    </md-list-item>
	 *  </md-list>
	 * </md-bottom-sheet>
	 * </hljs>
	 *
	 * ### Autocomplete
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-autofocus
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Sidenav
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 **/
	function MdAutofocusDirective($parse) {
	  return {
	    restrict: 'A',
	    link: {
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr) {
	    var attrExp = attr.mdAutoFocus || attr.mdAutofocus || attr.mdSidenavFocus;
	
	    // Initially update the expression by manually parsing the expression as per $watch source.
	    updateExpression($parse(attrExp)(scope));
	
	    // Only watch the expression if it is not empty.
	    if (attrExp) {
	      scope.$watch(attrExp, updateExpression);
	    }
	
	    /**
	     * Updates the autofocus class which is used to determine whether the attribute
	     * expression evaluates to true or false.
	     * @param {string|boolean} value Attribute Value
	     */
	    function updateExpression(value) {
	
	      // Rather than passing undefined to the jqLite toggle class function we explicitly set the
	      // value to true. Otherwise the class will be just toggled instead of being forced.
	      if (angular.isUndefined(value)) {
	        value = true;
	      }
	
	      element.toggleClass('md-autofocus', !!value);
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.colorUtil
	 * @description
	 * Color Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdColorUtil', ColorUtilFactory);
	
	function ColorUtilFactory() {
	  /**
	   * Converts hex value to RGBA string
	   * @param color {string}
	   * @returns {string}
	   */
	  function hexToRgba (color) {
	    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
	      dig   = hex.length / 3,
	      red   = hex.substr(0, dig),
	      green = hex.substr(dig, dig),
	      blue  = hex.substr(dig * 2);
	    if (dig === 1) {
	      red += red;
	      green += green;
	      blue += blue;
	    }
	    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
	  }
	
	  /**
	   * Converts rgba value to hex string
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbaToHex(color) {
	    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	
	    var hex = (color && color.length === 4) ? "#" +
	    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
	    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';
	
	    return hex.toUpperCase();
	  }
	
	  /**
	   * Converts an RGB color to RGBA
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbToRgba (color) {
	    return color.replace(')', ', 0.1)').replace('(', 'a(');
	  }
	
	  /**
	   * Converts an RGBA color to RGB
	   * @param color {string}
	   * @returns {string}
	   */
	  function rgbaToRgb (color) {
	    return color
	      ? color.replace('rgba', 'rgb').replace(/,[^\),]+\)/, ')')
	      : 'rgb(0,0,0)';
	  }
	
	  return {
	    rgbaToHex: rgbaToHex,
	    hexToRgba: hexToRgba,
	    rgbToRgba: rgbToRgba,
	    rgbaToRgb: rgbaToRgb
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	.factory('$mdConstant', MdConstantFactory);
	
	/**
	 * Factory function that creates the grab-bag $mdConstant service.
	 * @ngInject
	 */
	function MdConstantFactory() {
	
	  var prefixTestEl = document.createElement('div');
	  var vendorPrefix = getVendorPrefix(prefixTestEl);
	  var isWebkit = /webkit/i.test(vendorPrefix);
	  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
	
	  function vendorProperty(name) {
	    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
	    var prefixedName = vendorPrefix + '-' + name;
	    var ucPrefix = camelCase(prefixedName);
	    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);
	
	    return hasStyleProperty(prefixTestEl, name)     ? name     :       // The current browser supports the un-prefixed property
	           hasStyleProperty(prefixTestEl, ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
	           hasStyleProperty(prefixTestEl, lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
	  }
	
	  function hasStyleProperty(testElement, property) {
	    return angular.isDefined(testElement.style[property]);
	  }
	
	  function camelCase(input) {
	    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	  }
	
	  function getVendorPrefix(testElement) {
	    var prop, match;
	    var vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/;
	
	    for (prop in testElement.style) {
	      if (match = vendorRegex.exec(prop)) {
	        return match[0];
	      }
	    }
	  }
	
	  var self = {
	    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
	    isNumPadKey : function(e) { return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
	    isMetaKey: function(e) { return (e.keyCode >= 91 && e.keyCode <= 93); },
	    isFnLockKey: function(e) { return (e.keyCode >= 112 && e.keyCode <= 145); },
	    isNavigationKey : function(e) {
	      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
	      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);
	    },
	    hasModifierKey: function(e) {
	      return e.ctrlKey || e.metaKey || e.altKey;
	    },
	
	    /**
	     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
	     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
	     * compute this value, but Firefox always reports an element to have a size of zero if it
	     * goes over the max, meaning that we'd have to binary search for the value.
	     */
	    ELEMENT_MAX_PIXELS: 1533917,
	
	    /**
	     * Priority for a directive that should run before the directives from ngAria.
	     */
	    BEFORE_NG_ARIA: 210,
	
	    /**
	     * Common Keyboard actions and their associated keycode.
	     */
	    KEY_CODE: {
	      COMMA: 188,
	      SEMICOLON : 186,
	      ENTER: 13,
	      ESCAPE: 27,
	      SPACE: 32,
	      PAGE_UP: 33,
	      PAGE_DOWN: 34,
	      END: 35,
	      HOME: 36,
	      LEFT_ARROW : 37,
	      UP_ARROW : 38,
	      RIGHT_ARROW : 39,
	      DOWN_ARROW : 40,
	      TAB : 9,
	      BACKSPACE: 8,
	      DELETE: 46
	    },
	
	    /**
	     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
	     * as well.
	     */
	    CSS: {
	      /* Constants */
	      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
	      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),
	
	      TRANSFORM: vendorProperty('transform'),
	      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
	      TRANSITION: vendorProperty('transition'),
	      TRANSITION_DURATION: vendorProperty('transitionDuration'),
	      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
	      ANIMATION_DURATION: vendorProperty('animationDuration'),
	      ANIMATION_NAME: vendorProperty('animationName'),
	      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
	      ANIMATION_DIRECTION: vendorProperty('animationDirection')
	    },
	
	    /**
	     * As defined in core/style/variables.scss
	     *
	     * $layout-breakpoint-xs:     600px !default;
	     * $layout-breakpoint-sm:     960px !default;
	     * $layout-breakpoint-md:     1280px !default;
	     * $layout-breakpoint-lg:     1920px !default;
	     *
	     */
	    MEDIA: {
	      'xs'        : '(max-width: 599px)'                         ,
	      'gt-xs'     : '(min-width: 600px)'                         ,
	      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
	      'gt-sm'     : '(min-width: 960px)'                         ,
	      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
	      'gt-md'     : '(min-width: 1280px)'                        ,
	      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
	      'gt-lg'     : '(min-width: 1920px)'                        ,
	      'xl'        : '(min-width: 1920px)'                        ,
	      'landscape' : '(orientation: landscape)'                   ,
	      'portrait'  : '(orientation: portrait)'                    ,
	      'print' : 'print'
	    },
	
	    MEDIA_PRIORITY: [
	      'xl',
	      'gt-lg',
	      'lg',
	      'gt-md',
	      'md',
	      'gt-sm',
	      'sm',
	      'gt-xs',
	      'xs',
	      'landscape',
	      'portrait',
	      'print'
	    ]
	  };
	
	  return self;
	}
	
	})();
	(function(){
	"use strict";
	
	  angular
	    .module('material.core')
	    .config( ["$provide", function($provide){
	       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
	           /**
	            * Inject the iterator facade to easily support iteration and accessors
	            * @see iterator below
	            */
	           $delegate.iterator = MdIterator;
	
	           return $delegate;
	         }
	       ]);
	     }]);
	
	  /**
	   * iterator is a list facade to easily support iteration and accessors
	   *
	   * @param items Array list which this iterator will enumerate
	   * @param reloop Boolean enables iterator to consider the list as an endless reloop
	   */
	  function MdIterator(items, reloop) {
	    var trueFn = function() { return true; };
	
	    if (items && !angular.isArray(items)) {
	      items = Array.prototype.slice.call(items);
	    }
	
	    reloop = !!reloop;
	    var _items = items || [ ];
	
	    // Published API
	    return {
	      items: getItems,
	      count: count,
	
	      inRange: inRange,
	      contains: contains,
	      indexOf: indexOf,
	      itemAt: itemAt,
	
	      findBy: findBy,
	
	      add: add,
	      remove: remove,
	
	      first: first,
	      last: last,
	      next: angular.bind(null, findSubsequentItem, false),
	      previous: angular.bind(null, findSubsequentItem, true),
	
	      hasPrevious: hasPrevious,
	      hasNext: hasNext
	
	    };
	
	    /**
	     * Publish copy of the enumerable set
	     * @returns {Array|*}
	     */
	    function getItems() {
	      return [].concat(_items);
	    }
	
	    /**
	     * Determine length of the list
	     * @returns {Array.length|*|number}
	     */
	    function count() {
	      return _items.length;
	    }
	
	    /**
	     * Is the index specified valid
	     * @param index
	     * @returns {Array.length|*|number|boolean}
	     */
	    function inRange(index) {
	      return _items.length && ( index > -1 ) && (index < _items.length );
	    }
	
	    /**
	     * Can the iterator proceed to the next item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasNext(item) {
	      return item ? inRange(indexOf(item) + 1) : false;
	    }
	
	    /**
	     * Can the iterator proceed to the previous item in the list; relative to
	     * the specified item.
	     *
	     * @param item
	     * @returns {Array.length|*|number|boolean}
	     */
	    function hasPrevious(item) {
	      return item ? inRange(indexOf(item) - 1) : false;
	    }
	
	    /**
	     * Get item at specified index/position
	     * @param index
	     * @returns {*}
	     */
	    function itemAt(index) {
	      return inRange(index) ? _items[index] : null;
	    }
	
	    /**
	     * Find all elements matching the key/value pair
	     * otherwise return null
	     *
	     * @param val
	     * @param key
	     *
	     * @return array
	     */
	    function findBy(key, val) {
	      return _items.filter(function(item) {
	        return item[key] === val;
	      });
	    }
	
	    /**
	     * Add item to list
	     * @param item
	     * @param index
	     * @returns {*}
	     */
	    function add(item, index) {
	      if ( !item ) return -1;
	
	      if (!angular.isNumber(index)) {
	        index = _items.length;
	      }
	
	      _items.splice(index, 0, item);
	
	      return indexOf(item);
	    }
	
	    /**
	     * Remove item from list...
	     * @param item
	     */
	    function remove(item) {
	      if ( contains(item) ){
	        _items.splice(indexOf(item), 1);
	      }
	    }
	
	    /**
	     * Get the zero-based index of the target item
	     * @param item
	     * @returns {*}
	     */
	    function indexOf(item) {
	      return _items.indexOf(item);
	    }
	
	    /**
	     * Boolean existence check
	     * @param item
	     * @returns {boolean}
	     */
	    function contains(item) {
	      return item && (indexOf(item) > -1);
	    }
	
	    /**
	     * Return first item in the list
	     * @returns {*}
	     */
	    function first() {
	      return _items.length ? _items[0] : null;
	    }
	
	    /**
	     * Return last item in the list...
	     * @returns {*}
	     */
	    function last() {
	      return _items.length ? _items[_items.length - 1] : null;
	    }
	
	    /**
	     * Find the next item. If reloop is true and at the end of the list, it will go back to the
	     * first item. If given, the `validate` callback will be used to determine whether the next item
	     * is valid. If not valid, it will try to find the next item again.
	     *
	     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
	     * @param {*} item The item whose subsequent item we are looking for
	     * @param {Function=} validate The `validate` function
	     * @param {integer=} limit The recursion limit
	     *
	     * @returns {*} The subsequent item or null
	     */
	    function findSubsequentItem(backwards, item, validate, limit) {
	      validate = validate || trueFn;
	
	      var curIndex = indexOf(item);
	      while (true) {
	        if (!inRange(curIndex)) return null;
	
	        var nextIndex = curIndex + (backwards ? -1 : 1);
	        var foundItem = null;
	        if (inRange(nextIndex)) {
	          foundItem = _items[nextIndex];
	        } else if (reloop) {
	          foundItem = backwards ? last() : first();
	          nextIndex = indexOf(foundItem);
	        }
	
	        if ((foundItem === null) || (nextIndex === limit)) return null;
	        if (validate(foundItem)) return foundItem;
	
	        if (angular.isUndefined(limit)) limit = nextIndex;
	
	        curIndex = nextIndex;
	      }
	    }
	  }
	
	
	})();
	(function(){
	"use strict";
	
	
	mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
	.factory('$mdMedia', mdMediaFactory);
	
	/**
	 * @ngdoc service
	 * @name $mdMedia
	 * @module material.core
	 *
	 * @description
	 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
	 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
	 * you to register a watch.
	 *
	 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
	 *
	 *  <table class="md-api-table">
	 *    <thead>
	 *    <tr>
	 *      <th>Breakpoint</th>
	 *      <th>mediaQuery</th>
	 *    </tr>
	 *    </thead>
	 *    <tbody>
	 *    <tr>
	 *      <td>xs</td>
	 *      <td>(max-width: 599px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-xs</td>
	 *      <td>(min-width: 600px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>sm</td>
	 *      <td>(min-width: 600px) and (max-width: 959px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-sm</td>
	 *      <td>(min-width: 960px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>md</td>
	 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-md</td>
	 *      <td>(min-width: 1280px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>lg</td>
	 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>gt-lg</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>xl</td>
	 *      <td>(min-width: 1920px)</td>
	 *    </tr>
	 *    <tr>
	 *      <td>landscape</td>
	 *      <td>landscape</td>
	 *    </tr>
	 *    <tr>
	 *      <td>portrait</td>
	 *      <td>portrait</td>
	 *    </tr>
	 *    <tr>
	 *      <td>print</td>
	 *      <td>print</td>
	 *    </tr>
	 *    </tbody>
	 *  </table>
	 *
	 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
	 *
	 *  <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">
	 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
	 *  </a>
	 *
	 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.controller('MyController', function($mdMedia, $scope) {
	 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
	 *     $scope.bigScreen = big;
	 *   });
	 *
	 *   $scope.screenIsSmall = $mdMedia('sm');
	 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
	 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
	 * });
	 * </hljs>
	 */
	
	/* @ngInject */
	function mdMediaFactory($mdConstant, $rootScope, $window) {
	  var queries = {};
	  var mqls = {};
	  var results = {};
	  var normalizeCache = {};
	
	  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
	  $mdMedia.getQuery = getQuery;
	  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;
	
	  return $mdMedia;
	
	  function $mdMedia(query) {
	    var validated = queries[query];
	    if (angular.isUndefined(validated)) {
	      validated = queries[query] = validate(query);
	    }
	
	    var result = results[validated];
	    if (angular.isUndefined(result)) {
	      result = add(validated);
	    }
	
	    return result;
	  }
	
	  function validate(query) {
	    return $mdConstant.MEDIA[query] ||
	           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
	  }
	
	  function add(query) {
	    var result = mqls[query];
	    if ( !result ) {
	      result = mqls[query] = $window.matchMedia(query);
	    }
	
	    result.addListener(onQueryChange);
	    return (results[result.media] = !!result.matches);
	  }
	
	  function onQueryChange(query) {
	    $rootScope.$evalAsync(function() {
	      results[query.media] = !!query.matches;
	    });
	  }
	
	  function getQuery(name) {
	    return mqls[name];
	  }
	
	  function getResponsiveAttribute(attrs, attrName) {
	    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
	      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
	      if (!mqls[queries[mediaName]].matches) {
	        continue;
	      }
	
	      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	      if (attrs[normalizedName]) {
	        return attrs[normalizedName];
	      }
	    }
	
	    // fallback on unprefixed
	    return attrs[getNormalizedName(attrs, attrName)];
	  }
	
	  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
	    var unwatchFns = [];
	    attrNames.forEach(function(attrName) {
	      var normalizedName = getNormalizedName(attrs, attrName);
	      if (angular.isDefined(attrs[normalizedName])) {
	        unwatchFns.push(
	            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
	      }
	
	      for (var mediaName in $mdConstant.MEDIA) {
	        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
	        if (angular.isDefined(attrs[normalizedName])) {
	          unwatchFns.push(
	              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
	        }
	      }
	    });
	
	    return function unwatch() {
	      unwatchFns.forEach(function(fn) { fn(); });
	    };
	  }
	
	  // Improves performance dramatically
	  function getNormalizedName(attrs, attrName) {
	    return normalizeCache[attrName] ||
	        (normalizeCache[attrName] = attrs.$normalize(attrName));
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.core')
	  .config( ["$provide", function($provide) {
	    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {
	
	      // Inject the prefixer into our original $mdUtil service.
	      $delegate.prefixer = MdPrefixer;
	
	      return $delegate;
	    }]);
	  }]);
	
	function MdPrefixer(initialAttributes, buildSelector) {
	  var PREFIXES = ['data', 'x'];
	
	  if (initialAttributes) {
	    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
	    // the specified attributes.
	    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
	  }
	
	  return {
	    buildList: _buildList,
	    buildSelector: _buildSelector,
	    hasAttribute: _hasAttribute,
	    removeAttribute: _removeAttribute
	  };
	
	  function _buildList(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    attributes.forEach(function(item) {
	      PREFIXES.forEach(function(prefix) {
	        attributes.push(prefix + '-' + item);
	      });
	    });
	
	    return attributes;
	  }
	
	  function _buildSelector(attributes) {
	    attributes = angular.isArray(attributes) ? attributes : [attributes];
	
	    return _buildList(attributes)
	      .map(function(item) {
	        return '[' + item + ']';
	      })
	      .join(',');
	  }
	
	  function _hasAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return false;
	    }
	
	    var prefixedAttrs = _buildList(attribute);
	
	    for (var i = 0; i < prefixedAttrs.length; i++) {
	      if (element.hasAttribute(prefixedAttrs[i])) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function _removeAttribute(element, attribute) {
	    element = _getNativeElement(element);
	
	    if (!element) {
	      return;
	    }
	
	    _buildList(attribute).forEach(function(prefixedAttribute) {
	      element.removeAttribute(prefixedAttribute);
	    });
	  }
	
	  /**
	   * Transforms a jqLite or DOM element into a HTML element.
	   * This is useful when supporting jqLite elements and DOM elements at
	   * same time.
	   * @param element {JQLite|Element} Element to be parsed
	   * @returns {HTMLElement} Parsed HTMLElement
	   */
	  function _getNativeElement(element) {
	    element =  element[0] || element;
	
	    if (element.nodeType) {
	      return element;
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/*
	 * This var has to be outside the angular factory, otherwise when
	 * there are multiple material apps on the same page, each app
	 * will create its own instance of this array and the app's IDs
	 * will not be unique.
	 */
	UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
	var nextUniqueId = 0;
	
	/**
	 * @ngdoc module
	 * @name material.core.util
	 * @description
	 * Util
	 */
	angular
	  .module('material.core')
	  .factory('$mdUtil', UtilFactory);
	
	/**
	 * @ngInject
	 */
	function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log, $rootElement, $window, $$rAF) {
	  // Setup some core variables for the processTemplate method
	  var startSymbol = $interpolate.startSymbol(),
	    endSymbol = $interpolate.endSymbol(),
	    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));
	
	  /**
	   * Checks if the target element has the requested style by key
	   * @param {DOMElement|JQLite} target Target element
	   * @param {string} key Style key
	   * @param {string=} expectedVal Optional expected value
	   * @returns {boolean} Whether the target element has the style or not
	   */
	  var hasComputedStyle = function (target, key, expectedVal) {
	    var hasValue = false;
	
	    if ( target && target.length  ) {
	      var computedStyles = $window.getComputedStyle(target[0]);
	      hasValue = angular.isDefined(computedStyles[key]) && (expectedVal ? computedStyles[key] == expectedVal : true);
	    }
	
	    return hasValue;
	  };
	
	  function validateCssValue(value) {
	    return !value       ? '0'   :
	      hasPx(value) || hasPercent(value) ? value : value + 'px';
	  }
	
	  function hasPx(value) {
	    return String(value).indexOf('px') > -1;
	  }
	
	  function hasPercent(value) {
	    return String(value).indexOf('%') > -1;
	
	  }
	
	  var $mdUtil = {
	    dom: {},
	    now: window.performance && window.performance.now ?
	      angular.bind(window.performance, window.performance.now) : Date.now || function() {
	      return new Date().getTime();
	    },
	
	    /**
	     * Cross-version compatibility method to retrieve an option of a ngModel controller,
	     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
	     * @param {!angular.ngModelCtrl} ngModelCtrl
	     * @param {!string} optionName
	     * @returns {Object|undefined}
	     */
	    getModelOption: function (ngModelCtrl, optionName) {
	      if (!ngModelCtrl.$options) {
	        return;
	      }
	
	      var $options = ngModelCtrl.$options;
	
	      // The newer versions of AngularJS introduced a `getOption function and made the option values no longer
	      // visible on the $options object.
	      return $options.getOption ? $options.getOption(optionName) : $options[optionName]
	    },
	
	    /**
	     * Bi-directional accessor/mutator used to easily update an element's
	     * property based on the current 'dir'ectional value.
	     */
	    bidi : function(element, property, lValue, rValue) {
	      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');
	
	      // If accessor
	      if ( arguments.length == 0 ) return ltr ? 'ltr' : 'rtl';
	
	      // If mutator
	      var elem = angular.element(element);
	
	      if ( ltr && angular.isDefined(lValue)) {
	        elem.css(property, validateCssValue(lValue));
	      }
	      else if ( !ltr && angular.isDefined(rValue)) {
	        elem.css(property, validateCssValue(rValue) );
	      }
	    },
	
	    bidiProperty: function (element, lProperty, rProperty, value) {
	      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');
	
	      var elem = angular.element(element);
	
	      if ( ltr && angular.isDefined(lProperty)) {
	        elem.css(lProperty, validateCssValue(value));
	        elem.css(rProperty, '');
	      }
	      else if ( !ltr && angular.isDefined(rProperty)) {
	        elem.css(rProperty, validateCssValue(value) );
	        elem.css(lProperty, '');
	      }
	    },
	
	    clientRect: function(element, offsetParent, isOffsetRect) {
	      var node = getNode(element);
	      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
	      var nodeRect = node.getBoundingClientRect();
	
	      // The user can ask for an offsetRect: a rect relative to the offsetParent,
	      // or a clientRect: a rect relative to the page
	      var offsetRect = isOffsetRect ?
	        offsetParent.getBoundingClientRect() :
	      {left: 0, top: 0, width: 0, height: 0};
	      return {
	        left: nodeRect.left - offsetRect.left,
	        top: nodeRect.top - offsetRect.top,
	        width: nodeRect.width,
	        height: nodeRect.height
	      };
	    },
	    offsetRect: function(element, offsetParent) {
	      return $mdUtil.clientRect(element, offsetParent, true);
	    },
	
	    // Annoying method to copy nodes to an array, thanks to IE
	    nodesToArray: function(nodes) {
	      nodes = nodes || [];
	
	      var results = [];
	      for (var i = 0; i < nodes.length; ++i) {
	        results.push(nodes.item(i));
	      }
	      return results;
	    },
	
	    /**
	     * Determines the absolute position of the viewport.
	     * Useful when making client rectangles absolute.
	     * @returns {number}
	     */
	    getViewportTop: function() {
	      return window.scrollY || window.pageYOffset || 0;
	    },
	
	    /**
	     * Finds the proper focus target by searching the DOM.
	     *
	     * @param containerEl
	     * @param attributeVal
	     * @returns {*}
	     */
	    findFocusTarget: function(containerEl, attributeVal) {
	      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
	      var elToFocus;
	
	      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);
	
	      if ( !elToFocus && attributeVal != AUTO_FOCUS) {
	        // Scan for deprecated attribute
	        elToFocus = scanForFocusable(containerEl, this.prefixer('md-auto-focus', true));
	
	        if ( !elToFocus ) {
	          // Scan for fallback to 'universal' API
	          elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
	        }
	      }
	
	      return elToFocus;
	
	      /**
	       * Can target and nested children for specified Selector (attribute)
	       * whose value may be an expression that evaluates to True/False.
	       */
	      function scanForFocusable(target, selector) {
	        var elFound, items = target[0].querySelectorAll(selector);
	
	        // Find the last child element with the focus attribute
	        if ( items && items.length ){
	          items.length && angular.forEach(items, function(it) {
	            it = angular.element(it);
	
	            // Check the element for the md-autofocus class to ensure any associated expression
	            // evaluated to true.
	            var isFocusable = it.hasClass('md-autofocus');
	            if (isFocusable) elFound = it;
	          });
	        }
	        return elFound;
	      }
	    },
	
	    /**
	     * Disables scroll around the passed parent element.
	     * @param element Unused
	     * @param {!Element|!angular.JQLite} parent Element to disable scrolling within.
	     *   Defaults to body if none supplied.
	     * @param options Object of options to modify functionality
	     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
	     *     use the passed parent element.
	     */
	    disableScrollAround: function(element, parent, options) {
	      options = options || {};
	
	      $mdUtil.disableScrollAround._count = Math.max(0, $mdUtil.disableScrollAround._count || 0);
	      $mdUtil.disableScrollAround._count++;
	
	      if ($mdUtil.disableScrollAround._restoreScroll) {
	        return $mdUtil.disableScrollAround._restoreScroll;
	      }
	
	      var body = $document[0].body;
	      var restoreBody = disableBodyScroll();
	      var restoreElement = disableElementScroll(parent);
	
	      return $mdUtil.disableScrollAround._restoreScroll = function() {
	        if (--$mdUtil.disableScrollAround._count <= 0) {
	          restoreBody();
	          restoreElement();
	          delete $mdUtil.disableScrollAround._restoreScroll;
	        }
	      };
	
	      /**
	       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
	       * and wheel events
	       */
	      function disableElementScroll(element) {
	        element = angular.element(element || body);
	
	        var scrollMask;
	
	        if (options.disableScrollMask) {
	          scrollMask = element;
	        } else {
	          scrollMask = angular.element(
	            '<div class="md-scroll-mask">' +
	            '  <div class="md-scroll-mask-bar"></div>' +
	            '</div>');
	          element.append(scrollMask);
	        }
	
	        scrollMask.on('wheel', preventDefault);
	        scrollMask.on('touchmove', preventDefault);
	
	        return function restoreElementScroll() {
	          scrollMask.off('wheel');
	          scrollMask.off('touchmove');
	
	          if (!options.disableScrollMask) {
	            scrollMask[0].parentNode.removeChild(scrollMask[0]);
	          }
	        };
	
	        function preventDefault(e) {
	          e.preventDefault();
	        }
	      }
	
	      // Converts the body to a position fixed block and translate it to the proper scroll position
	      function disableBodyScroll() {
	        var documentElement = $document[0].documentElement;
	
	        var prevDocumentStyle = documentElement.style.cssText || '';
	        var prevBodyStyle = body.style.cssText || '';
	
	        var viewportTop = $mdUtil.getViewportTop();
	        var clientWidth = body.clientWidth;
	        var hasVerticalScrollbar = body.scrollHeight > body.clientHeight + 1;
	
	        if (hasVerticalScrollbar) {
	          angular.element(body).css({
	            position: 'fixed',
	            width: '100%',
	            top: -viewportTop + 'px'
	          });
	        }
	
	        if (body.clientWidth < clientWidth) {
	          body.style.overflow = 'hidden';
	        }
	
	        // This should be applied after the manipulation to the body, because
	        // adding a scrollbar can potentially resize it, causing the measurement
	        // to change.
	        if (hasVerticalScrollbar) {
	          documentElement.style.overflowY = 'scroll';
	        }
	
	        return function restoreScroll() {
	          // Reset the inline style CSS to the previous.
	          body.style.cssText = prevBodyStyle;
	          documentElement.style.cssText = prevDocumentStyle;
	
	          // The body loses its scroll position while being fixed.
	          body.scrollTop = viewportTop;
	        };
	      }
	
	    },
	
	    enableScrolling: function() {
	      var restoreFn = this.disableScrollAround._restoreScroll;
	      restoreFn && restoreFn();
	    },
	
	    floatingScrollbars: function() {
	      if (this.floatingScrollbars.cached === undefined) {
	        var tempNode = angular.element('<div><div></div></div>').css({
	          width: '100%',
	          'z-index': -1,
	          position: 'absolute',
	          height: '35px',
	          'overflow-y': 'scroll'
	        });
	        tempNode.children().css('height', '60px');
	
	        $document[0].body.appendChild(tempNode[0]);
	        this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
	        tempNode.remove();
	      }
	      return this.floatingScrollbars.cached;
	    },
	
	    // Mobile safari only allows you to set focus in click event listeners...
	    forceFocus: function(element) {
	      var node = element[0] || element;
	
	      document.addEventListener('click', function focusOnClick(ev) {
	        if (ev.target === node && ev.$focus) {
	          node.focus();
	          ev.stopImmediatePropagation();
	          ev.preventDefault();
	          node.removeEventListener('click', focusOnClick);
	        }
	      }, true);
	
	      var newEvent = document.createEvent('MouseEvents');
	      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
	        false, false, false, false, 0, null);
	      newEvent.$material = true;
	      newEvent.$focus = true;
	      node.dispatchEvent(newEvent);
	    },
	
	    /**
	     * facade to build md-backdrop element with desired styles
	     * NOTE: Use $compile to trigger backdrop postLink function
	     */
	    createBackdrop: function(scope, addClass) {
	      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
	    },
	
	    /**
	     * supplant() method from Crockford's `Remedial Javascript`
	     * Equivalent to use of $interpolate; without dependency on
	     * interpolation symbols and scope. Note: the '{<token>}' can
	     * be property names, property chains, or array indices.
	     */
	    supplant: function(template, values, pattern) {
	      pattern = pattern || /\{([^\{\}]*)\}/g;
	      return template.replace(pattern, function(a, b) {
	        var p = b.split('.'),
	          r = values;
	        try {
	          for (var s in p) {
	            if (p.hasOwnProperty(s) ) {
	              r = r[p[s]];
	            }
	          }
	        } catch (e) {
	          r = a;
	        }
	        return (typeof r === 'string' || typeof r === 'number') ? r : a;
	      });
	    },
	
	    fakeNgModel: function() {
	      return {
	        $fake: true,
	        $setTouched: angular.noop,
	        $setViewValue: function(value) {
	          this.$viewValue = value;
	          this.$render(value);
	          this.$viewChangeListeners.forEach(function(cb) {
	            cb();
	          });
	        },
	        $isEmpty: function(value) {
	          return ('' + value).length === 0;
	        },
	        $parsers: [],
	        $formatters: [],
	        $viewChangeListeners: [],
	        $render: angular.noop
	      };
	    },
	
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds.
	    // @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
	    // @param invokeApply should the $timeout trigger $digest() dirty checking
	    debounce: function(func, wait, scope, invokeApply) {
	      var timer;
	
	      return function debounced() {
	        var context = scope,
	          args = Array.prototype.slice.call(arguments);
	
	        $timeout.cancel(timer);
	        timer = $timeout(function() {
	
	          timer = undefined;
	          func.apply(context, args);
	
	        }, wait || 10, invokeApply);
	      };
	    },
	
	    // Returns a function that can only be triggered every `delay` milliseconds.
	    // In other words, the function will not be called unless it has been more
	    // than `delay` milliseconds since the last call.
	    throttle: function throttle(func, delay) {
	      var recent;
	      return function throttled() {
	        var context = this;
	        var args = arguments;
	        var now = $mdUtil.now();
	
	        if (!recent || (now - recent > delay)) {
	          func.apply(context, args);
	          recent = now;
	        }
	      };
	    },
	
	    /**
	     * Measures the number of milliseconds taken to run the provided callback
	     * function. Uses a high-precision timer if available.
	     */
	    time: function time(cb) {
	      var start = $mdUtil.now();
	      cb();
	      return $mdUtil.now() - start;
	    },
	
	    /**
	     * Create an implicit getter that caches its `getter()`
	     * lookup value
	     */
	    valueOnUse : function (scope, key, getter) {
	      var value = null, args = Array.prototype.slice.call(arguments);
	      var params = (args.length > 3) ? args.slice(3) : [ ];
	
	      Object.defineProperty(scope, key, {
	        get: function () {
	          if (value === null) value = getter.apply(scope, params);
	          return value;
	        }
	      });
	    },
	
	    /**
	     * Get a unique ID.
	     *
	     * @returns {string} an unique numeric string
	     */
	    nextUid: function() {
	      return '' + nextUniqueId++;
	    },
	
	    // Stop watchers and events from firing on a scope without destroying it,
	    // by disconnecting it from its parent and its siblings' linked lists.
	    disconnectScope: function disconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't destroy the root scope or a scope that has been already destroyed
	      if (scope.$root === scope) return;
	      if (scope.$$destroyed) return;
	
	      var parent = scope.$parent;
	      scope.$$disconnected = true;
	
	      // See Scope.$destroy
	      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
	      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
	      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
	      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;
	
	      scope.$$nextSibling = scope.$$prevSibling = null;
	
	    },
	
	    // Undo the effects of disconnectScope above.
	    reconnectScope: function reconnectScope(scope) {
	      if (!scope) return;
	
	      // we can't disconnect the root node or scope already disconnected
	      if (scope.$root === scope) return;
	      if (!scope.$$disconnected) return;
	
	      var child = scope;
	
	      var parent = child.$parent;
	      child.$$disconnected = false;
	      // See Scope.$new for this logic...
	      child.$$prevSibling = parent.$$childTail;
	      if (parent.$$childHead) {
	        parent.$$childTail.$$nextSibling = child;
	        parent.$$childTail = child;
	      } else {
	        parent.$$childHead = parent.$$childTail = child;
	      }
	    },
	
	    /*
	     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
	     *
	     * @param el Element to start walking the DOM from
	     * @param check Either a string or a function. If a string is passed, it will be evaluated against
	     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each of
	     * the parents and will use the return value to determine whether the node is a match.
	     * @param onlyParent Only start checking from the parent element, not `el`.
	     */
	    getClosest: function getClosest(el, validateWith, onlyParent) {
	      if ( angular.isString(validateWith) ) {
	        var tagName = validateWith.toUpperCase();
	        validateWith = function(el) {
	          return el.nodeName.toUpperCase() === tagName;
	        };
	      }
	
	      if (el instanceof angular.element) el = el[0];
	      if (onlyParent) el = el.parentNode;
	      if (!el) return null;
	
	      do {
	        if (validateWith(el)) {
	          return el;
	        }
	      } while (el = el.parentNode);
	
	      return null;
	    },
	
	    /**
	     * Build polyfill for the Node.contains feature (if needed)
	     */
	    elementContains: function(node, child) {
	      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
	      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
	        // compares the positions of two nodes and returns a bitmask
	        return (node === child) || !!(this.compareDocumentPosition(arg) & 16)
	      });
	
	      return findFn(child);
	    },
	
	    /**
	     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
	     * useful with interimElements where the element and its container are important...
	     *
	     * @param {[]} elements to scan
	     * @param {string} name of node to find (e.g. 'md-dialog')
	     * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
	     * @param {boolean=} optional flag to enable log warnings; defaults to false
	     */
	    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
	      var found = scanTree(element);
	      if (!found && !!warnNotFound) {
	        $log.warn( $mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]) );
	      }
	
	      return angular.element(found || element);
	
	      /**
	       * Breadth-First tree scan for element with matching `nodeName`
	       */
	      function scanTree(element) {
	        return scanLevel(element) || (!!scanDeep ? scanChildren(element) : null);
	      }
	
	      /**
	       * Case-insensitive scan of current elements only (do not descend).
	       */
	      function scanLevel(element) {
	        if ( element ) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            if (element[i].nodeName.toLowerCase() === nodeName) {
	              return element[i];
	            }
	          }
	        }
	        return null;
	      }
	
	      /**
	       * Scan children of specified node
	       */
	      function scanChildren(element) {
	        var found;
	        if ( element ) {
	          for (var i = 0, len = element.length; i < len; i++) {
	            var target = element[i];
	            if ( !found ) {
	              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
	                found = found || scanTree([target.childNodes[j]]);
	              }
	            }
	          }
	        }
	        return found;
	      }
	
	    },
	
	    /**
	     * Give optional properties with no value a boolean true if attr provided or false otherwise
	     */
	    initOptionalProperties: function(scope, attr, defaults) {
	      defaults = defaults || {};
	      angular.forEach(scope.$$isolateBindings, function(binding, key) {
	        if (binding.optional && angular.isUndefined(scope[key])) {
	          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
	          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
	        }
	      });
	    },
	
	    /**
	     * Alternative to $timeout calls with 0 delay.
	     * nextTick() coalesces all calls within a single frame
	     * to minimize $digest thrashing
	     *
	     * @param callback
	     * @param digest
	     * @returns {*}
	     */
	    nextTick: function(callback, digest, scope) {
	      //-- grab function reference for storing state details
	      var nextTick = $mdUtil.nextTick;
	      var timeout = nextTick.timeout;
	      var queue = nextTick.queue || [];
	
	      //-- add callback to the queue
	      queue.push({scope: scope, callback: callback});
	
	      //-- set default value for digest
	      if (digest == null) digest = true;
	
	      //-- store updated digest/queue values
	      nextTick.digest = nextTick.digest || digest;
	      nextTick.queue = queue;
	
	      //-- either return existing timeout or create a new one
	      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));
	
	      /**
	       * Grab a copy of the current queue
	       * Clear the queue for future use
	       * Process the existing queue
	       * Trigger digest if necessary
	       */
	      function processQueue() {
	        var queue = nextTick.queue;
	        var digest = nextTick.digest;
	
	        nextTick.queue = [];
	        nextTick.timeout = null;
	        nextTick.digest = false;
	
	        queue.forEach(function(queueItem) {
	          var skip = queueItem.scope && queueItem.scope.$$destroyed;
	          if (!skip) {
	            queueItem.callback();
	          }
	        });
	
	        if (digest) $rootScope.$digest();
	      }
	    },
	
	    /**
	     * Processes a template and replaces the start/end symbols if the application has
	     * overriden them.
	     *
	     * @param template The template to process whose start/end tags may be replaced.
	     * @returns {*}
	     */
	    processTemplate: function(template) {
	      if (usesStandardSymbols) {
	        return template;
	      } else {
	        if (!template || !angular.isString(template)) return template;
	        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	      }
	    },
	
	    /**
	     * Scan up dom hierarchy for enabled parent;
	     */
	    getParentWithPointerEvents: function (element) {
	      var parent = element.parent();
	
	      // jqLite might return a non-null, but still empty, parent; so check for parent and length
	      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
	        parent = parent.parent();
	      }
	
	      return parent;
	    },
	
	    getNearestContentElement: function (element) {
	      var current = element.parent()[0];
	      // Look for the nearest parent md-content, stopping at the rootElement.
	      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
	        current = current.parentNode;
	      }
	      return current;
	    },
	
	    /**
	     * Checks if the current browser is natively supporting the `sticky` position.
	     * @returns {string} supported sticky property name
	     */
	    checkStickySupport: function() {
	      var stickyProp;
	      var testEl = angular.element('<div>');
	      $document[0].body.appendChild(testEl[0]);
	
	      var stickyProps = ['sticky', '-webkit-sticky'];
	      for (var i = 0; i < stickyProps.length; ++i) {
	        testEl.css({
	          position: stickyProps[i],
	          top: 0,
	          'z-index': 2
	        });
	
	        if (testEl.css('position') == stickyProps[i]) {
	          stickyProp = stickyProps[i];
	          break;
	        }
	      }
	
	      testEl.remove();
	
	      return stickyProp;
	    },
	
	    /**
	     * Parses an attribute value, mostly a string.
	     * By default checks for negated values and returns `false´ if present.
	     * Negated values are: (native falsy) and negative strings like:
	     * `false` or `0`.
	     * @param value Attribute value which should be parsed.
	     * @param negatedCheck When set to false, won't check for negated values.
	     * @returns {boolean}
	     */
	    parseAttributeBoolean: function(value, negatedCheck) {
	      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
	    },
	
	    hasComputedStyle: hasComputedStyle,
	
	    /**
	     * Returns true if the parent form of the element has been submitted.
	     *
	     * @param element An AngularJS or HTML5 element.
	     *
	     * @returns {boolean}
	     */
	    isParentFormSubmitted: function(element) {
	      var parent = $mdUtil.getClosest(element, 'form');
	      var form = parent ? angular.element(parent).controller('form') : null;
	
	      return form ? form.$submitted : false;
	    },
	
	    /**
	     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
	     *
	     * @param {!HTMLElement} element The element to scroll.
	     * @param {number} scrollEnd The new/final scroll position.
	     * @param {number=} duration Duration of the scroll. Default is 1000ms.
	     */
	    animateScrollTo: function(element, scrollEnd, duration) {
	      var scrollStart = element.scrollTop;
	      var scrollChange = scrollEnd - scrollStart;
	      var scrollingDown = scrollStart < scrollEnd;
	      var startTime = $mdUtil.now();
	
	      $$rAF(scrollChunk);
	
	      function scrollChunk() {
	        var newPosition = calculateNewPosition();
	
	        element.scrollTop = newPosition;
	
	        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
	          $$rAF(scrollChunk);
	        }
	      }
	
	      function calculateNewPosition() {
	        var easeDuration = duration || 1000;
	        var currentTime = $mdUtil.now() - startTime;
	
	        return ease(currentTime, scrollStart, scrollChange, easeDuration);
	      }
	
	      function ease(currentTime, start, change, duration) {
	        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
	        // straight to the proper position
	        if (currentTime > duration) {
	          return start + change;
	        }
	
	        var ts = (currentTime /= duration) * currentTime;
	        var tc = ts * currentTime;
	
	        return start + change * (-2 * tc + 3 * ts);
	      }
	    },
	
	    /**
	     * Provides an easy mechanism for removing duplicates from an array.
	     *
	     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
	     *
	     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
	     *
	     * @param {array} array The array whose unique values should be returned.
	     *
	     * @returns {array} A copy of the array containing only unique values.
	     */
	    uniq: function(array) {
	      if (!array) { return; }
	
	      return array.filter(function(value, index, self) {
	        return self.indexOf(value) === index;
	      });
	    }
	  };
	
	
	// Instantiate other namespace utility methods
	
	  $mdUtil.dom.animator = $$mdAnimate($mdUtil);
	
	  return $mdUtil;
	
	  function getNode(el) {
	    return el[0] || el;
	  }
	
	}
	
	/*
	 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
	 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
	 */
	
	angular.element.prototype.focus = angular.element.prototype.focus || function() {
	    if (this.length) {
	      this[0].focus();
	    }
	    return this;
	  };
	angular.element.prototype.blur = angular.element.prototype.blur || function() {
	    if (this.length) {
	      this[0].blur();
	    }
	    return this;
	  };
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.compiler
	 * @description
	 * AngularJS Material template and element compiler.
	 */
	MdCompilerService.$inject = ["$q", "$templateRequest", "$injector", "$compile", "$controller"];
	angular
	  .module('material.core')
	  .service('$mdCompiler', MdCompilerService);
	
	/**
	 * @ngdoc service
	 * @name $mdCompiler
	 * @module material.core.compiler
	 * @description
	 * The $mdCompiler service is an abstraction of AngularJS's compiler, that allows developers
	 * to easily compile an element with options like in a Directive Definition Object.
	 *
	 * > The compiler powers a lot of components inside of AngularJS Material.
	 * > Like the `$mdPanel` or `$mdDialog`.
	 *
	 * @usage
	 *
	 * Basic Usage with a template
	 *
	 * <hljs lang="js">
	 *   $mdCompiler.compile({
	 *     templateUrl: 'modal.html',
	 *     controller: 'ModalCtrl',
	 *     locals: {
	 *       modal: myModalInstance;
	 *     }
	 *   }).then(function (compileData) {
	 *     compileData.element; // Compiled DOM element
	 *     compileData.link(myScope); // Instantiate controller and link element to scope.
	 *   });
	 * </hljs>
	 *
	 * Example with a content element
	 *
	 * <hljs lang="js">
	 *
	 *   // Create a virtual element and link it manually.
	 *   // The compiler doesn't need to recompile the element each time.
	 *   var myElement = $compile('<span>Test</span>')(myScope);
	 *
	 *   $mdCompiler.compile({
	 *     contentElement: myElement
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 * > Content Element is a significant performance improvement when the developer already knows that the
	 * > compiled element will be always the same and the scope will not change either.
	 *
	 * The `contentElement` option also supports DOM elements which will be temporary removed and restored
	 * at its old position.
	 *
	 * <hljs lang="js">
	 *   var domElement = document.querySelector('#myElement');
	 *
	 *   $mdCompiler.compile({
	 *     contentElement: myElement
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 * The `$mdCompiler` can also query for the element in the DOM itself.
	 *
	 * <hljs lang="js">
	 *   $mdCompiler.compile({
	 *     contentElement: '#myElement'
	 *   }).then(function (compileData) {
	 *     compileData.element // Content Element (same as above)
	 *     compileData.link // This does nothing when using a contentElement.
	 *   });
	 * </hljs>
	 *
	 */
	function MdCompilerService($q, $templateRequest, $injector, $compile, $controller) {
	  /** @private @const {!angular.$q} */
	  this.$q = $q;
	
	  /** @private @const {!angular.$templateRequest} */
	  this.$templateRequest = $templateRequest;
	
	  /** @private @const {!angular.$injector} */
	  this.$injector = $injector;
	
	  /** @private @const {!angular.$compile} */
	  this.$compile = $compile;
	
	  /** @private @const {!angular.$controller} */
	  this.$controller = $controller;
	}
	
	/**
	 * @ngdoc method
	 * @name $mdCompiler#compile
	 * @description
	 *
	 * A method to compile a HTML template with the AngularJS compiler.
	 * The `$mdCompiler` is wrapper around the AngularJS compiler and provides extra functionality
	 * like controller instantiation or async resolves.
	 *
	 * @param {!Object} options An options object, with the following properties:
	 *
	 *    - `controller` - `{string|Function}` Controller fn that should be associated with
	 *         newly created scope or the name of a registered controller if passed as a string.
	 *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
	 *         published to scope under the `controllerAs` name.
	 *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
	 *         compiled each time, you can also use a DOM element.<br/>
	 *    - `template` - `{string=}` An html template as a string.
	 *    - `templateUrl` - `{string=}` A path to an html template.
	 *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
	 *        it is loaded. It will be given the template string as a parameter, and should
	 *        return a a new string representing the transformed template.
	 *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
	 *        be injected into the controller. If any of these dependencies are promises, the compiler
	 *        will wait for them all to be resolved, or if one is rejected before the controller is
	 *        instantiated `compile()` will fail..
	 *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
	 *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
	 *        Otherwise if function, then it is injected and the return value is treated as the
	 *        dependency. If the result is a promise, it is resolved before its value is
	 *        injected into the controller.
	 *
	 * @returns {Object} promise A promise, which will be resolved with a `compileData` object.
	 * `compileData` has the following properties:
	 *
	 *   - `element` - `{element}`: an uncompiled element matching the provided template.
	 *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
	 *     the element and instantiate the provided controller (if given).
	 *   - `locals` - `{object}`: The locals which will be passed into the controller once `link` is
	 *     called. If `bindToController` is true, they will be coppied to the ctrl instead
	 *
	 */
	MdCompilerService.prototype.compile = function(options) {
	
	  if (options.contentElement) {
	    return this._prepareContentElement(options);
	  } else {
	    return this._compileTemplate(options);
	  }
	
	};
	
	/**
	 * Instead of compiling any template, the compiler just fetches an existing HTML element from the DOM and
	 * provides a restore function to put the element back it old DOM position.
	 * @param {!Object} options Options to be used for the compiler.
	 * @private
	 */
	MdCompilerService.prototype._prepareContentElement = function(options) {
	
	  var contentElement = this._fetchContentElement(options);
	
	  return this.$q.resolve({
	    element: contentElement.element,
	    cleanup: contentElement.restore,
	    locals: {},
	    link: function() {
	      return contentElement.element;
	    }
	  });
	
	};
	
	/**
	 * Compiles a template by considering all options and waiting for all resolves to be ready.
	 * @param {!Object} options Compile options
	 * @returns {!Object} Compile data with link function.
	 * @private
	 */
	MdCompilerService.prototype._compileTemplate = function(options) {
	
	  var self = this;
	  var templateUrl = options.templateUrl;
	  var template = options.template || '';
	  var resolve = angular.extend({}, options.resolve);
	  var locals = angular.extend({}, options.locals);
	  var transformTemplate = options.transformTemplate || angular.identity;
	
	  // Take resolve values and invoke them.
	  // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
	  // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
	  angular.forEach(resolve, function(value, key) {
	    if (angular.isString(value)) {
	      resolve[key] = self.$injector.get(value);
	    } else {
	      resolve[key] = self.$injector.invoke(value);
	    }
	  });
	
	  // Add the locals, which are just straight values to inject
	  // eg locals: { three: 3 }, will inject three into the controller
	  angular.extend(resolve, locals);
	
	  if (templateUrl) {
	    resolve.$$ngTemplate = this.$templateRequest(templateUrl);
	  } else {
	    resolve.$$ngTemplate = this.$q.when(template);
	  }
	
	
	  // Wait for all the resolves to finish if they are promises
	  return this.$q.all(resolve).then(function(locals) {
	
	    var template = transformTemplate(locals.$$ngTemplate, options);
	    var element = options.element || angular.element('<div>').html(template.trim()).contents();
	
	    return self._compileElement(locals, element, options);
	  });
	
	};
	
	/**
	 * Method to compile an element with the given options.
	 * @param {!Object} locals Locals to be injected to the controller if present
	 * @param {!JQLite} element Element to be compiled and linked
	 * @param {!Object} options Options to be used for linking.
	 * @returns {!Object} Compile data with link function.
	 * @private
	 */
	MdCompilerService.prototype._compileElement = function(locals, element, options) {
	  var self = this;
	  var ngLinkFn = this.$compile(element);
	
	  var compileData = {
	    element: element,
	    cleanup: element.remove.bind(element),
	    locals: locals,
	    link: linkFn
	  };
	
	  function linkFn(scope) {
	    locals.$scope = scope;
	
	    // Instantiate controller if the developer provided one.
	    if (options.controller) {
	
	      var injectLocals = angular.extend(locals, {
	        $element: element
	      });
	
	      var invokeCtrl = self.$controller(options.controller, injectLocals, true, options.controllerAs);
	
	      if (options.bindToController) {
	        angular.extend(invokeCtrl.instance, locals);
	      }
	
	      var ctrl = invokeCtrl();
	
	      // Unique identifier for AngularJS Route ngView controllers.
	      element.data('$ngControllerController', ctrl);
	      element.children().data('$ngControllerController', ctrl);
	
	      // Expose the instantiated controller to the compile data
	      compileData.controller = ctrl;
	    }
	
	    // Invoke the AngularJS $compile link function.
	    return ngLinkFn(scope);
	  }
	
	  return compileData;
	
	};
	
	/**
	 * Fetches an element removing it from the DOM and using it temporary for the compiler.
	 * Elements which were fetched will be restored after use.
	 * @param {!Object} options Options to be used for the compilation.
	 * @returns {{element: !JQLite, restore: !Function}}
	 * @private
	 */
	MdCompilerService.prototype._fetchContentElement = function(options) {
	
	  var contentEl = options.contentElement;
	  var restoreFn = null;
	
	  if (angular.isString(contentEl)) {
	    contentEl = document.querySelector(contentEl);
	    restoreFn = createRestoreFn(contentEl);
	  } else {
	    contentEl = contentEl[0] || contentEl;
	
	    // When the element is visible in the DOM, then we restore it at close of the dialog.
	    // Otherwise it will be removed from the DOM after close.
	    if (document.contains(contentEl)) {
	      restoreFn = createRestoreFn(contentEl);
	    } else {
	      restoreFn = function() {
	        if (contentEl.parentNode) {
	          contentEl.parentNode.removeChild(contentEl);
	        }
	      }
	    }
	  }
	
	  return {
	    element: angular.element(contentEl),
	    restore: restoreFn
	  };
	
	  function createRestoreFn(element) {
	    var parent = element.parentNode;
	    var nextSibling = element.nextElementSibling;
	
	    return function() {
	      if (!nextSibling) {
	        // When the element didn't had any sibling, then it can be simply appended to the
	        // parent, because it plays no role, which index it had before.
	        parent.appendChild(element);
	      } else {
	        // When the element had a sibling, which marks the previous position of the element
	        // in the DOM, we insert it correctly before the sibling, to have the same index as
	        // before.
	        parent.insertBefore(element, nextSibling);
	      }
	    }
	  }
	};
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.aria
	 * @description
	 * Aria Expectations for AngularJS Material components.
	 */
	MdAriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];
	angular
	  .module('material.core')
	  .provider('$mdAria', MdAriaProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdAriaProvider
	 * @module material.core.aria
	 *
	 * @description
	 *
	 * Modify options of the `$mdAria` service, which will be used by most of the AngularJS Material
	 * components.
	 *
	 * You are able to disable `$mdAria` warnings, by using the following markup.
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdAriaProvider) {
	 *     // Globally disables all ARIA warnings.
	 *     $mdAriaProvider.disableWarnings();
	 *   });
	 * </hljs>
	 *
	 */
	function MdAriaProvider() {
	
	  var config = {
	    /** Whether we should show ARIA warnings in the console if labels are missing on the element */
	    showWarnings: true
	  };
	
	  return {
	    disableWarnings: disableWarnings,
	    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
	      return MdAriaService.apply(config, arguments);
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdAriaProvider#disableWarnings
	   * @description Disables all ARIA warnings generated by AngularJS Material.
	   */
	  function disableWarnings() {
	    config.showWarnings = false;
	  }
	}
	
	/*
	 * @ngInject
	 */
	function MdAriaService($$rAF, $log, $window, $interpolate) {
	
	  // Load the showWarnings option from the current context and store it inside of a scope variable,
	  // because the context will be probably lost in some function calls.
	  var showWarnings = this.showWarnings;
	
	  return {
	    expect: expect,
	    expectAsync: expectAsync,
	    expectWithText: expectWithText,
	    expectWithoutText: expectWithoutText,
	    getText: getText,
	    hasAriaLabel: hasAriaLabel,
	    parentHasAriaLabel: parentHasAriaLabel
	  };
	
	  /**
	   * Check if expected attribute has been specified on the target element or child
	   * @param element
	   * @param attrName
	   * @param {optional} defaultValue What to set the attr to if no value is found
	   */
	  function expect(element, attrName, defaultValue) {
	
	    var node = angular.element(element)[0] || element;
	
	    // if node exists and neither it nor its children have the attribute
	    if (node &&
	       ((!node.hasAttribute(attrName) ||
	        node.getAttribute(attrName).length === 0) &&
	        !childHasAttribute(node, attrName))) {
	
	      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
	      if (defaultValue.length) {
	        element.attr(attrName, defaultValue);
	      } else if (showWarnings) {
	        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
	      }
	
	    }
	  }
	
	  function expectAsync(element, attrName, defaultValueGetter) {
	    // Problem: when retrieving the element's contents synchronously to find the label,
	    // the text may not be defined yet in the case of a binding.
	    // There is a higher chance that a binding will be defined if we wait one frame.
	    $$rAF(function() {
	        expect(element, attrName, defaultValueGetter());
	    });
	  }
	
	  function expectWithText(element, attrName) {
	    var content = getText(element) || "";
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if (hasBinding) {
	      expectAsync(element, attrName, function() {
	        return getText(element);
	      });
	    } else {
	      expect(element, attrName, content);
	    }
	  }
	
	  function expectWithoutText(element, attrName) {
	    var content = getText(element);
	    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;
	
	    if ( !hasBinding && !content) {
	      expect(element, attrName, content);
	    }
	  }
	
	  function getText(element) {
	    element = element[0] || element;
	    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
	    var text = '';
	
	    var node;
	    while (node = walker.nextNode()) {
	      if (!isAriaHiddenNode(node)) {
	        text += node.textContent;
	      }
	    }
	
	    return text.trim() || '';
	
	    function isAriaHiddenNode(node) {
	      while (node.parentNode && (node = node.parentNode) !== element) {
	        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	          return true;
	        }
	      }
	    }
	  }
	
	  function childHasAttribute(node, attrName) {
	    var hasChildren = node.hasChildNodes(),
	        hasAttr = false;
	
	    function isHidden(el) {
	      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
	      return (style.display === 'none');
	    }
	
	    if (hasChildren) {
	      var children = node.childNodes;
	      for (var i=0; i < children.length; i++) {
	        var child = children[i];
	        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
	          if (!isHidden(child)) {
	            hasAttr = true;
	          }
	        }
	      }
	    }
	    return hasAttr;
	  }
	
	  /**
	   * Check if expected element has aria label attribute
	   * @param element
	   */
	  function hasAriaLabel(element) {
	    var node = angular.element(element)[0] || element;
	
	    /* Check if compatible node type (ie: not HTML Document node) */
	    if (!node.hasAttribute) {
	      return false;
	    }
	
	    /* Check label or description attributes */
	    return node.hasAttribute('aria-label') || node.hasAttribute('aria-labelledby') || node.hasAttribute('aria-describedby');
	  }
	
	  /**
	   * Check if expected element's parent has aria label attribute and has valid role and tagName
	   * @param element
	   * @param {optional} level Number of levels deep search should be performed
	   */
	  function parentHasAriaLabel(element, level) {
	    level = level || 1;
	    var node = angular.element(element)[0] || element;
	    if (!node.parentNode) {
	      return false;
	    }
	    if (performCheck(node.parentNode)) {
	      return true;
	    }
	    level--;
	    if (level) {
	      return parentHasAriaLabel(node.parentNode, level);
	    }
	    return false;
	
	    function performCheck(parentNode) {
	      if (!hasAriaLabel(parentNode)) {
	        return false;
	      }
	      /* Perform role blacklist check */
	      if (parentNode.hasAttribute('role')) {
	        switch(parentNode.getAttribute('role').toLowerCase()) {
	          case 'command':
	          case 'definition':
	          case 'directory':
	          case 'grid':
	          case 'list':
	          case 'listitem':
	          case 'log':
	          case 'marquee':
	          case 'menu':
	          case 'menubar':
	          case 'note':
	          case 'presentation':
	          case 'separator':
	          case 'scrollbar':
	          case 'status':
	          case 'tablist':
	            return false;
	        }
	      }
	      /* Perform tagName blacklist check */
	      switch(parentNode.tagName.toLowerCase()) {
	        case 'abbr':
	        case 'acronym':
	        case 'address':
	        case 'applet':
	        case 'audio':
	        case 'b':
	        case 'bdi':
	        case 'bdo':
	        case 'big':
	        case 'blockquote':
	        case 'br':
	        case 'canvas':
	        case 'caption':
	        case 'center':
	        case 'cite':
	        case 'code':
	        case 'col':
	        case 'data':
	        case 'dd':
	        case 'del':
	        case 'dfn':
	        case 'dir':
	        case 'div':
	        case 'dl':
	        case 'em':
	        case 'embed':
	        case 'fieldset':
	        case 'figcaption':
	        case 'font':
	        case 'h1':
	        case 'h2':
	        case 'h3':
	        case 'h4':
	        case 'h5':
	        case 'h6':
	        case 'hgroup':
	        case 'html':
	        case 'i':
	        case 'ins':
	        case 'isindex':
	        case 'kbd':
	        case 'keygen':
	        case 'label':
	        case 'legend':
	        case 'li':
	        case 'map':
	        case 'mark':
	        case 'menu':
	        case 'object':
	        case 'ol':
	        case 'output':
	        case 'pre':
	        case 'presentation':
	        case 'q':
	        case 'rt':
	        case 'ruby':
	        case 'samp':
	        case 'small':
	        case 'source':
	        case 'span':
	        case 'status':
	        case 'strike':
	        case 'strong':
	        case 'sub':
	        case 'sup':
	        case 'svg':
	        case 'tbody':
	        case 'td':
	        case 'th':
	        case 'thead':
	        case 'time':
	        case 'tr':
	        case 'track':
	        case 'tt':
	        case 'ul':
	        case 'var':
	          return false;
	      }
	      return true;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.interaction
	 * @description
	 * User interaction detection to provide proper accessibility.
	 */
	MdInteractionService.$inject = ["$timeout", "$mdUtil"];
	angular
	  .module('material.core.interaction', [])
	  .service('$mdInteraction', MdInteractionService);
	
	
	/**
	 * @ngdoc service
	 * @name $mdInteraction
	 * @module material.core.interaction
	 *
	 * @description
	 *
	 * Service which keeps track of the last interaction type and validates them for several browsers.
	 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
	 *
	 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
	 *
	 * Here is an example markup for using the interaction service.
	 *
	 * <hljs lang="js">
	 *   var lastType = $mdInteraction.getLastInteractionType();
	 *
	 *   if (lastType === 'keyboard') {
	 *     // We only restore the focus for keyboard users.
	 *     restoreFocus();
	 *   }
	 * </hljs>
	 *
	 */
	function MdInteractionService($timeout, $mdUtil) {
	  this.$timeout = $timeout;
	  this.$mdUtil = $mdUtil;
	
	  this.bodyElement = angular.element(document.body);
	  this.isBuffering = false;
	  this.bufferTimeout = null;
	  this.lastInteractionType = null;
	  this.lastInteractionTime = null;
	
	  // Type Mappings for the different events
	  // There will be three three interaction types
	  // `keyboard`, `mouse` and `touch`
	  // type `pointer` will be evaluated in `pointerMap` for IE Browser events
	  this.inputEventMap = {
	    'keydown': 'keyboard',
	    'mousedown': 'mouse',
	    'mouseenter': 'mouse',
	    'touchstart': 'touch',
	    'pointerdown': 'pointer',
	    'MSPointerDown': 'pointer'
	  };
	
	  // IE PointerDown events will be validated in `touch` or `mouse`
	  // Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
	  this.iePointerMap = {
	    2: 'touch',
	    3: 'touch',
	    4: 'mouse'
	  };
	
	  this.initializeEvents();
	}
	
	/**
	 * Initializes the interaction service, by registering all interaction events to the
	 * body element.
	 */
	MdInteractionService.prototype.initializeEvents = function() {
	  // IE browsers can also trigger pointer events, which also leads to an interaction.
	  var pointerEvent = 'MSPointerEvent' in window ? 'MSPointerDown' : 'PointerEvent' in window ? 'pointerdown' : null;
	
	  this.bodyElement.on('keydown mousedown', this.onInputEvent.bind(this));
	
	  if ('ontouchstart' in document.documentElement) {
	    this.bodyElement.on('touchstart', this.onBufferInputEvent.bind(this));
	  }
	
	  if (pointerEvent) {
	    this.bodyElement.on(pointerEvent, this.onInputEvent.bind(this));
	  }
	
	};
	
	/**
	 * Event listener for normal interaction events, which should be tracked.
	 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
	 */
	MdInteractionService.prototype.onInputEvent = function(event) {
	  if (this.isBuffering) {
	    return;
	  }
	
	  var type = this.inputEventMap[event.type];
	
	  if (type === 'pointer') {
	    type = this.iePointerMap[event.pointerType] || event.pointerType;
	  }
	
	  this.lastInteractionType = type;
	  this.lastInteractionTime = this.$mdUtil.now();
	};
	
	/**
	 * Event listener for interaction events which should be buffered (touch events).
	 * @param event {TouchEvent}
	 */
	MdInteractionService.prototype.onBufferInputEvent = function(event) {
	  this.$timeout.cancel(this.bufferTimeout);
	
	  this.onInputEvent(event);
	  this.isBuffering = true;
	
	  // The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
	  // the `onInput` function multiple times.
	  this.bufferTimeout = this.$timeout(function() {
	    this.isBuffering = false;
	  }.bind(this), 650, false);
	
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#getLastInteractionType
	 * @description Retrieves the last interaction type triggered in body.
	 * @returns {string|null} Last interaction type.
	 */
	MdInteractionService.prototype.getLastInteractionType = function() {
	  return this.lastInteractionType;
	};
	
	/**
	 * @ngdoc method
	 * @name $mdInteraction#isUserInvoked
	 * @description Method to detect whether any interaction happened recently or not.
	 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
	 * @returns {boolean} Whether there was any interaction or not.
	 */
	MdInteractionService.prototype.isUserInvoked = function(checkDelay) {
	  var delay = angular.isNumber(checkDelay) ? checkDelay : 15;
	
	  // Check for any interaction to be within the specified check time.
	  return this.lastInteractionTime >= this.$mdUtil.now() - delay;
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout"];
	attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler"];var HANDLERS = {};
	
	/* The state of the current 'pointer'
	 * The pointer represents the state of the current touch.
	 * It contains normalized x and y coordinates from DOM events,
	 * as well as other information abstracted from the DOM.
	 */
	
	var pointer, lastPointer, forceSkipClickHijack = false;
	
	/**
	 * The position of the most recent click if that click was on a label element.
	 * @type {{x: number, y: number}?}
	 */
	var lastLabelClickPos = null;
	
	// Used to attach event listeners once when multiple ng-apps are running.
	var isInitialized = false;
	
	angular
	  .module('material.core.gestures', [ ])
	  .provider('$mdGesture', MdGestureProvider)
	  .factory('$$MdGestureHandler', MdGestureHandler)
	  .run( attachToDocument );
	
	/**
	   * @ngdoc service
	   * @name $mdGestureProvider
	   * @module material.core.gestures
	   *
	   * @description
	   * In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked.
	   * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking on mobile
	   * devices.
	   *
	   * <hljs lang="js">
	   *   app.config(function($mdGestureProvider) {
	   *
	   *     // For mobile devices without jQuery loaded, do not
	   *     // intercept click events during the capture phase.
	   *     $mdGestureProvider.skipClickHijack();
	   *
	   *   });
	   * </hljs>
	   *
	   */
	function MdGestureProvider() { }
	
	MdGestureProvider.prototype = {
	
	  // Publish access to setter to configure a variable  BEFORE the
	  // $mdGesture service is instantiated...
	  skipClickHijack: function() {
	    return forceSkipClickHijack = true;
	  },
	
	  /**
	   * $get is used to build an instance of $mdGesture
	   * @ngInject
	   */
	  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", function($$MdGestureHandler, $$rAF, $timeout) {
	       return new MdGesture($$MdGestureHandler, $$rAF, $timeout);
	  }]
	};
	
	
	
	/**
	 * MdGesture factory construction function
	 * @ngInject
	 */
	function MdGesture($$MdGestureHandler, $$rAF, $timeout) {
	  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	  var isIos = userAgent.match(/ipad|iphone|ipod/i);
	  var isAndroid = userAgent.match(/android/i);
	  var touchActionProperty = getTouchAction();
	  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);
	
	  var self = {
	    handler: addHandler,
	    register: register,
	    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
	    isHijackingClicks: (isIos || isAndroid) && !hasJQuery && !forceSkipClickHijack
	  };
	
	  if (self.isHijackingClicks) {
	    var maxClickDistance = 6;
	    self.handler('click', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('click')
	    });
	
	    self.handler('focus', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: function(ev, pointer) {
	        if (pointer.distance < this.state.options.maxDistance) {
	          if (canFocus(ev.target)) {
	            this.dispatchEvent(ev, 'focus', pointer);
	            ev.target.focus();
	          }
	        }
	
	        function canFocus(element) {
	          var focusableElements = ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'];
	
	          return (element.getAttribute('tabindex') != '-1') &&
	              !element.hasAttribute('DISABLED') &&
	              (element.hasAttribute('tabindex') || element.hasAttribute('href') || element.isContentEditable ||
	              (focusableElements.indexOf(element.nodeName) != -1));
	        }
	      }
	    });
	
	    self.handler('mouseup', {
	      options: {
	        maxDistance: maxClickDistance
	      },
	      onEnd: checkDistanceAndEmit('mouseup')
	    });
	
	    self.handler('mousedown', {
	      onStart: function(ev) {
	        this.dispatchEvent(ev, 'mousedown');
	      }
	    });
	  }
	
	  function checkDistanceAndEmit(eventName) {
	    return function(ev, pointer) {
	      if (pointer.distance < this.state.options.maxDistance) {
	        this.dispatchEvent(ev, eventName, pointer);
	      }
	    };
	  }
	
	  /*
	   * Register an element to listen for a handler.
	   * This allows an element to override the default options for a handler.
	   * Additionally, some handlers like drag and hold only dispatch events if
	   * the domEvent happens inside an element that's registered to listen for these events.
	   *
	   * @see GestureHandler for how overriding of default options works.
	   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horziontal: false })
	   */
	  function register(element, handlerName, options) {
	    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
	    if (!handler) {
	      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
	      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
	    }
	    return handler.registerElement(element, options);
	  }
	
	  /*
	   * add a handler to $mdGesture. see below.
	   */
	  function addHandler(name, definition) {
	    var handler = new $$MdGestureHandler(name);
	    angular.extend(handler, definition);
	    HANDLERS[name] = handler;
	
	    return self;
	  }
	
	  /*
	   * Register handlers. These listen to touch/start/move events, interpret them,
	   * and dispatch gesture events depending on options & conditions. These are all
	   * instances of GestureHandler.
	   * @see GestureHandler
	   */
	  return self
	    /*
	     * The press handler dispatches an event on touchdown/touchend.
	     * It's a simple abstraction of touch/mouse/pointer start and end.
	     */
	    .handler('press', {
	      onStart: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressdown');
	      },
	      onEnd: function (ev, pointer) {
	        this.dispatchEvent(ev, '$md.pressup');
	      }
	    })
	
	    /*
	     * The hold handler dispatches an event if the user keeps their finger within
	     * the same <maxDistance> area for <delay> ms.
	     * The hold handler will only run if a parent of the touch target is registered
	     * to listen for hold events through $mdGesture.register()
	     */
	    .handler('hold', {
	      options: {
	        maxDistance: 6,
	        delay: 500
	      },
	      onCancel: function () {
	        $timeout.cancel(this.state.timeout);
	      },
	      onStart: function (ev, pointer) {
	        // For hold, require a parent to be registered with $mdGesture.register()
	        // Because we prevent scroll events, this is necessary.
	        if (!this.state.registeredParent) return this.cancel();
	
	        this.state.pos = {x: pointer.x, y: pointer.y};
	        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
	          this.dispatchEvent(ev, '$md.hold');
	          this.cancel(); //we're done!
	        }), this.state.options.delay, false);
	      },
	      onMove: function (ev, pointer) {
	        // Don't scroll while waiting for hold.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        // If the user moves greater than <maxDistance> pixels, stop the hold timer
	        // set in onStart
	        var dx = this.state.pos.x - pointer.x;
	        var dy = this.state.pos.y - pointer.y;
	        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
	          this.cancel();
	        }
	      },
	      onEnd: function () {
	        this.onCancel();
	      }
	    })
	
	    /*
	     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
	     * <minDistance> px in the x or y direction, depending on options.horizontal.
	     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
	     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
	     * pixels vertically, this handler won't consider the move part of a drag.
	     */
	    .handler('drag', {
	      options: {
	        minDistance: 6,
	        horizontal: true,
	        cancelMultiplier: 1.5
	      },
	      onSetup: function(element, options) {
	        if (touchActionProperty) {
	          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
	          this.oldTouchAction = element[0].style[touchActionProperty];
	          element[0].style[touchActionProperty] = options.horizontal ? 'pan-y' : 'pan-x';
	        }
	      },
	      onCleanup: function(element) {
	        if (this.oldTouchAction) {
	          element[0].style[touchActionProperty] = this.oldTouchAction;
	        }
	      },
	      onStart: function (ev) {
	        // For drag, require a parent to be registered with $mdGesture.register()
	        if (!this.state.registeredParent) this.cancel();
	      },
	      onMove: function (ev, pointer) {
	        var shouldStartDrag, shouldCancel;
	        // Don't scroll while deciding if this touchmove qualifies as a drag event.
	        // If we don't preventDefault touchmove events here, Android will assume we don't
	        // want to listen to anymore touch events. It will start scrolling and stop sending
	        // touchmove events.
	        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();
	
	        if (!this.state.dragPointer) {
	          if (this.state.options.horizontal) {
	            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          } else {
	            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
	            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
	          }
	
	          if (shouldStartDrag) {
	            // Create a new pointer representing this drag, starting at this point where the drag started.
	            this.state.dragPointer = makeStartPointer(ev);
	            updatePointerState(ev, this.state.dragPointer);
	            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);
	
	          } else if (shouldCancel) {
	            this.cancel();
	          }
	        } else {
	          this.dispatchDragMove(ev);
	        }
	      },
	      // Only dispatch dragmove events every frame; any more is unnecessary
	      dispatchDragMove: $$rAF.throttle(function (ev) {
	        // Make sure the drag didn't stop while waiting for the next frame
	        if (this.state.isRunning) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
	        }
	      }),
	      onEnd: function (ev, pointer) {
	        if (this.state.dragPointer) {
	          updatePointerState(ev, this.state.dragPointer);
	          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
	        }
	      }
	    })
	
	    /*
	     * The swipe handler will dispatch a swipe event if, on the end of a touch,
	     * the velocity and distance were high enough.
	     */
	    .handler('swipe', {
	      options: {
	        minVelocity: 0.65,
	        minDistance: 10
	      },
	      onEnd: function (ev, pointer) {
	        var eventType;
	
	        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
	          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
	          this.dispatchEvent(ev, eventType);
	        }
	        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
	          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
	          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
	          this.dispatchEvent(ev, eventType);
	        }
	      }
	    });
	
	  function getTouchAction() {
	    var testEl = document.createElement('div');
	    var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	
	    for (var i = 0; i < vendorPrefixes.length; i++) {
	      var prefix = vendorPrefixes[i];
	      var property = prefix ? prefix + 'TouchAction' : 'touchAction';
	      if (angular.isDefined(testEl.style[property])) {
	        return property;
	      }
	    }
	  }
	
	}
	
	/**
	 * MdGestureHandler
	 * A GestureHandler is an object which is able to dispatch custom dom events
	 * based on native dom {touch,pointer,mouse}{start,move,end} events.
	 *
	 * A gesture will manage its lifecycle through the start,move,end, and cancel
	 * functions, which are called by native dom events.
	 *
	 * A gesture has the concept of 'options' (eg a swipe's required velocity), which can be
	 * overridden by elements registering through $mdGesture.register()
	 */
	function GestureHandler (name) {
	  this.name = name;
	  this.state = {};
	}
	
	function MdGestureHandler() {
	  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);
	
	  GestureHandler.prototype = {
	    options: {},
	    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
	    // differently when jQuery is loaded
	    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,
	
	    // These are overridden by the registered handler
	    onSetup: angular.noop,
	    onCleanup: angular.noop,
	    onStart: angular.noop,
	    onMove: angular.noop,
	    onEnd: angular.noop,
	    onCancel: angular.noop,
	
	    // onStart sets up a new state for the handler, which includes options from the
	    // nearest registered parent element of ev.target.
	    start: function (ev, pointer) {
	      if (this.state.isRunning) return;
	      var parentTarget = this.getNearestParent(ev.target);
	      // Get the options from the nearest registered parent
	      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};
	
	      this.state = {
	        isRunning: true,
	        // Override the default options with the nearest registered parent's options
	        options: angular.extend({}, this.options, parentTargetOptions),
	        // Pass in the registered parent node to the state so the onStart listener can use
	        registeredParent: parentTarget
	      };
	      this.onStart(ev, pointer);
	    },
	    move: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onMove(ev, pointer);
	    },
	    end: function (ev, pointer) {
	      if (!this.state.isRunning) return;
	      this.onEnd(ev, pointer);
	      this.state.isRunning = false;
	    },
	    cancel: function (ev, pointer) {
	      this.onCancel(ev, pointer);
	      this.state = {};
	    },
	
	    // Find and return the nearest parent element that has been registered to
	    // listen for this handler via $mdGesture.register(element, 'handlerName').
	    getNearestParent: function (node) {
	      var current = node;
	      while (current) {
	        if ((current.$mdGesture || {})[this.name]) {
	          return current;
	        }
	        current = current.parentNode;
	      }
	      return null;
	    },
	
	    // Called from $mdGesture.register when an element registers itself with a handler.
	    // Store the options the user gave on the DOMElement itself. These options will
	    // be retrieved with getNearestParent when the handler starts.
	    registerElement: function (element, options) {
	      var self = this;
	      element[0].$mdGesture = element[0].$mdGesture || {};
	      element[0].$mdGesture[this.name] = options || {};
	      element.on('$destroy', onDestroy);
	
	      self.onSetup(element, options || {});
	
	      return onDestroy;
	
	      function onDestroy() {
	        delete element[0].$mdGesture[self.name];
	        element.off('$destroy', onDestroy);
	
	        self.onCleanup(element, options || {});
	      }
	    }
	  };
	
	  return GestureHandler;
	
	  /*
	   * Dispatch an event with jQuery
	   * TODO: Make sure this sends bubbling events
	   *
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj = new angular.element.Event(eventType);
	
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	
	    angular.extend(eventObj, {
	      clientX: eventPointer.x,
	      clientY: eventPointer.y,
	      screenX: eventPointer.x,
	      screenY: eventPointer.y,
	      pageX: eventPointer.x,
	      pageY: eventPointer.y,
	      ctrlKey: srcEvent.ctrlKey,
	      altKey: srcEvent.altKey,
	      shiftKey: srcEvent.shiftKey,
	      metaKey: srcEvent.metaKey
	    });
	    angular.element(eventPointer.target).trigger(eventObj);
	  }
	
	  /*
	   * NOTE: nativeDispatchEvent is very performance sensitive.
	   * @param srcEvent the original DOM touch event that started this.
	   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
	   * @param eventPointer the pointer object that matches this event.
	   */
	  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
	    eventPointer = eventPointer || pointer;
	    var eventObj;
	
	    if (eventType === 'click' || eventType == 'mouseup' || eventType == 'mousedown' ) {
	      eventObj = document.createEvent('MouseEvents');
	      eventObj.initMouseEvent(
	        eventType, true, true, window, srcEvent.detail,
	        eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
	        srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
	        srcEvent.button, srcEvent.relatedTarget || null
	      );
	
	    } else {
	      eventObj = document.createEvent('CustomEvent');
	      eventObj.initCustomEvent(eventType, true, true, {});
	    }
	    eventObj.$material = true;
	    eventObj.pointer = eventPointer;
	    eventObj.srcEvent = srcEvent;
	    eventPointer.target.dispatchEvent(eventObj);
	  }
	
	}
	
	/**
	 * Attach Gestures: hook document and check shouldHijack clicks
	 * @ngInject
	 */
	function attachToDocument( $mdGesture, $$MdGestureHandler ) {
	
	  // Polyfill document.contains for IE11.
	  // TODO: move to util
	  document.contains || (document.contains = function (node) {
	    return document.body.contains(node);
	  });
	
	  if (!isInitialized && $mdGesture.isHijackingClicks ) {
	    /*
	     * If hijack clicks is true, we preventDefault any click that wasn't
	     * sent by AngularJS Material. This is because on older Android & iOS, a false, or 'ghost',
	     * click event will be sent ~400ms after a touchend event happens.
	     * The only way to know if this click is real is to prevent any normal
	     * click events, and add a flag to events sent by material so we know not to prevent those.
	     *
	     * Two exceptions to click events that should be prevented are:
	     *  - click events sent by the keyboard (eg form submit)
	     *  - events that originate from an Ionic app
	     */
	    document.addEventListener('click'    , clickHijacker     , true);
	    document.addEventListener('mouseup'  , mouseInputHijacker, true);
	    document.addEventListener('mousedown', mouseInputHijacker, true);
	    document.addEventListener('focus'    , mouseInputHijacker, true);
	
	    isInitialized = true;
	  }
	
	  function mouseInputHijacker(ev) {
	    var isKeyClick = !ev.clientX && !ev.clientY;
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap
	      && !isInputEventFromLabelClick(ev)) {
	      ev.preventDefault();
	      ev.stopPropagation();
	    }
	  }
	
	  function clickHijacker(ev) {
	    var isKeyClick = ev.clientX === 0 && ev.clientY === 0;
	    var isSubmitEvent = ev.target && ev.target.type === 'submit';
	    if (!isKeyClick && !ev.$material && !ev.isIonicTap
	      && !isInputEventFromLabelClick(ev)
	      && !isSubmitEvent) {
	      ev.preventDefault();
	      ev.stopPropagation();
	      lastLabelClickPos = null;
	    } else {
	      lastLabelClickPos = null;
	      if (ev.target.tagName.toLowerCase() == 'label') {
	        lastLabelClickPos = {x: ev.x, y: ev.y};
	      }
	    }
	  }
	
	
	  // Listen to all events to cover all platforms.
	  var START_EVENTS = 'mousedown touchstart pointerdown';
	  var MOVE_EVENTS = 'mousemove touchmove pointermove';
	  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';
	
	  angular.element(document)
	    .on(START_EVENTS, gestureStart)
	    .on(MOVE_EVENTS, gestureMove)
	    .on(END_EVENTS, gestureEnd)
	    // For testing
	    .on('$$mdGestureReset', function gestureClearCache () {
	      lastPointer = pointer = null;
	    });
	
	  /*
	   * When a DOM event happens, run all registered gesture handlers' lifecycle
	   * methods which match the DOM event.
	   * Eg when a 'touchstart' event happens, runHandlers('start') will call and
	   * run `handler.cancel()` and `handler.start()` on all registered handlers.
	   */
	  function runHandlers(handlerEvent, event) {
	    var handler;
	    for (var name in HANDLERS) {
	      handler = HANDLERS[name];
	      if( handler instanceof $$MdGestureHandler ) {
	
	        if (handlerEvent === 'start') {
	          // Run cancel to reset any handlers' state
	          handler.cancel();
	        }
	        handler[handlerEvent](event, pointer);
	
	      }
	    }
	  }
	
	  /*
	   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
	   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
	   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
	   * won't effect it.
	   */
	  function gestureStart(ev) {
	    // If we're already touched down, abort
	    if (pointer) return;
	
	    var now = +Date.now();
	
	    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
	    // If <400ms have passed, don't allow an event of a different type than the previous event
	    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
	      return;
	    }
	
	    pointer = makeStartPointer(ev);
	
	    runHandlers('start', ev);
	  }
	  /*
	   * If a move event happens of the right type, update the pointer and run all the move handlers.
	   * "of the right type": if a mousemove happens but our pointer started with a touch event, do nothing.
	   */
	  function gestureMove(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    runHandlers('move', ev);
	  }
	  /*
	   * If an end event happens of the right type, update the pointer, run endHandlers, and save the pointer as 'lastPointer'
	   */
	  function gestureEnd(ev) {
	    if (!pointer || !typesMatch(ev, pointer)) return;
	
	    updatePointerState(ev, pointer);
	    pointer.endTime = +Date.now();
	
	    runHandlers('end', ev);
	
	    lastPointer = pointer;
	    pointer = null;
	  }
	
	}
	
	// ********************
	// Module Functions
	// ********************
	
	/*
	 * Initiate the pointer. x, y, and the pointer's type.
	 */
	function makeStartPointer(ev) {
	  var point = getEventPoint(ev);
	  var startPointer = {
	    startTime: +Date.now(),
	    target: ev.target,
	    // 'p' for pointer events, 'm' for mouse, 't' for touch
	    type: ev.type.charAt(0)
	  };
	  startPointer.startX = startPointer.x = point.pageX;
	  startPointer.startY = startPointer.y = point.pageY;
	  return startPointer;
	}
	
	/*
	 * return whether the pointer's type matches the event's type.
	 * Eg if a touch event happens but the pointer has a mouse type, return false.
	 */
	function typesMatch(ev, pointer) {
	  return ev && pointer && ev.type.charAt(0) === pointer.type;
	}
	
	/**
	 * Gets whether the given event is an input event that was caused by clicking on an
	 * associated label element.
	 *
	 * This is necessary because the browser will, upon clicking on a label element, fire an
	 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
	 * click as with `$material` correctly, but not the second input click.
	 *
	 * In order to determine whether an input event is from a label click, we compare the (x, y) for
	 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
	 * click occurs). Unfortunately, there are no event properties that tie the input and the label
	 * together (such as relatedTarget).
	 *
	 * @param {MouseEvent} event
	 * @returns {boolean}
	 */
	function isInputEventFromLabelClick(event) {
	  return lastLabelClickPos
	      && lastLabelClickPos.x == event.x
	      && lastLabelClickPos.y == event.y;
	}
	
	/*
	 * Update the given pointer based upon the given DOMEvent.
	 * Distance, velocity, direction, duration, etc
	 */
	function updatePointerState(ev, pointer) {
	  var point = getEventPoint(ev);
	  var x = pointer.x = point.pageX;
	  var y = pointer.y = point.pageY;
	
	  pointer.distanceX = x - pointer.startX;
	  pointer.distanceY = y - pointer.startY;
	  pointer.distance = Math.sqrt(
	    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
	  );
	
	  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
	  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';
	
	  pointer.duration = +Date.now() - pointer.startTime;
	  pointer.velocityX = pointer.distanceX / pointer.duration;
	  pointer.velocityY = pointer.distanceY / pointer.duration;
	}
	
	/*
	 * Normalize the point where the DOM event happened whether it's touch or mouse.
	 * @returns point event obj with pageX and pageY on it.
	 */
	function getEventPoint(ev) {
	  ev = ev.originalEvent || ev; // support jQuery events
	  return (ev.touches && ev.touches[0]) ||
	    (ev.changedTouches && ev.changedTouches[0]) ||
	    ev;
	}
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core')
	  .provider('$$interimElement', InterimElementProvider);
	
	/*
	 * @ngdoc service
	 * @name $$interimElement
	 * @module material.core
	 *
	 * @description
	 *
	 * Factory that contructs `$$interimElement.$service` services.
	 * Used internally in material design for elements that appear on screen temporarily.
	 * The service provides a promise-like API for interacting with the temporary
	 * elements.
	 *
	 * ```js
	 * app.service('$mdToast', function($$interimElement) {
	 *   var $mdToast = $$interimElement(toastDefaultOptions);
	 *   return $mdToast;
	 * });
	 * ```
	 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
	 *
	 * @returns {$$interimElement.$service}
	 *
	 */
	
	function InterimElementProvider() {
	  InterimElementFactory.$inject = ["$document", "$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector", "$exceptionHandler"];
	  createInterimElementProvider.$get = InterimElementFactory;
	  return createInterimElementProvider;
	
	  /**
	   * Returns a new provider which allows configuration of a new interimElement
	   * service. Allows configuration of default options & methods for options,
	   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
	   */
	  function createInterimElementProvider(interimFactoryName) {
	    factory.$inject = ["$$interimElement", "$injector"];
	    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];
	
	    var customMethods = {};
	    var providerConfig = {
	      presets: {}
	    };
	
	    var provider = {
	      setDefaults: setDefaults,
	      addPreset: addPreset,
	      addMethod: addMethod,
	      $get: factory
	    };
	
	    /**
	     * all interim elements will come with the 'build' preset
	     */
	    provider.addPreset('build', {
	      methods: ['controller', 'controllerAs', 'resolve', 'multiple',
	        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent', 'contentElement']
	    });
	
	    return provider;
	
	    /**
	     * Save the configured defaults to be used when the factory is instantiated
	     */
	    function setDefaults(definition) {
	      providerConfig.optionsFactory = definition.options;
	      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
	      return provider;
	    }
	
	    /**
	     * Add a method to the factory that isn't specific to any interim element operations
	     */
	
	    function addMethod(name, fn) {
	      customMethods[name] = fn;
	      return provider;
	    }
	
	    /**
	     * Save the configured preset to be used when the factory is instantiated
	     */
	    function addPreset(name, definition) {
	      definition = definition || {};
	      definition.methods = definition.methods || [];
	      definition.options = definition.options || function() { return {}; };
	
	      if (/^cancel|hide|show$/.test(name)) {
	        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
	      }
	      if (definition.methods.indexOf('_options') > -1) {
	        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
	      }
	      providerConfig.presets[name] = {
	        methods: definition.methods.concat(EXPOSED_METHODS),
	        optionsFactory: definition.options,
	        argOption: definition.argOption
	      };
	      return provider;
	    }
	
	    function addPresetMethod(presetName, methodName, method) {
	      providerConfig.presets[presetName][methodName] = method;
	    }
	
	    /**
	     * Create a factory that has the given methods & defaults implementing interimElement
	     */
	    /* @ngInject */
	    function factory($$interimElement, $injector) {
	      var defaultMethods;
	      var defaultOptions;
	      var interimElementService = $$interimElement();
	
	      /*
	       * publicService is what the developer will be using.
	       * It has methods hide(), cancel(), show(), build(), and any other
	       * presets which were set during the config phase.
	       */
	      var publicService = {
	        hide: interimElementService.hide,
	        cancel: interimElementService.cancel,
	        show: showInterimElement,
	
	        // Special internal method to destroy an interim element without animations
	        // used when navigation changes causes a $scope.$destroy() action
	        destroy : destroyInterimElement
	      };
	
	
	      defaultMethods = providerConfig.methods || [];
	      // This must be invoked after the publicService is initialized
	      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});
	
	      // Copy over the simple custom methods
	      angular.forEach(customMethods, function(fn, name) {
	        publicService[name] = fn;
	      });
	
	      angular.forEach(providerConfig.presets, function(definition, name) {
	        var presetDefaults = invokeFactory(definition.optionsFactory, {});
	        var presetMethods = (definition.methods || []).concat(defaultMethods);
	
	        // Every interimElement built with a preset has a field called `$type`,
	        // which matches the name of the preset.
	        // Eg in preset 'confirm', options.$type === 'confirm'
	        angular.extend(presetDefaults, { $type: name });
	
	        // This creates a preset class which has setter methods for every
	        // method given in the `.addPreset()` function, as well as every
	        // method given in the `.setDefaults()` function.
	        //
	        // @example
	        // .setDefaults({
	        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
	        //   options: dialogDefaultOptions
	        // })
	        // .addPreset('alert', {
	        //   methods: ['title', 'ok'],
	        //   options: alertDialogOptions
	        // })
	        //
	        // Set values will be passed to the options when interimElement.show() is called.
	        function Preset(opts) {
	          this._options = angular.extend({}, presetDefaults, opts);
	        }
	        angular.forEach(presetMethods, function(name) {
	          Preset.prototype[name] = function(value) {
	            this._options[name] = value;
	            return this;
	          };
	        });
	
	        // Create shortcut method for one-linear methods
	        if (definition.argOption) {
	          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
	          publicService[methodName] = function(arg) {
	            var config = publicService[name](arg);
	            return publicService.show(config);
	          };
	        }
	
	        // eg $mdDialog.alert() will return a new alert preset
	        publicService[name] = function(arg) {
	          // If argOption is supplied, eg `argOption: 'content'`, then we assume
	          // if the argument is not an options object then it is the `argOption` option.
	          //
	          // @example `$mdToast.simple('hello')` // sets options.content to hello
	          //                                     // because argOption === 'content'
	          if (arguments.length && definition.argOption &&
	              !angular.isObject(arg) && !angular.isArray(arg))  {
	
	            return (new Preset())[definition.argOption](arg);
	
	          } else {
	            return new Preset(arg);
	          }
	
	        };
	      });
	
	      return publicService;
	
	      /**
	       *
	       */
	      function showInterimElement(opts) {
	        // opts is either a preset which stores its options on an _options field,
	        // or just an object made up of options
	        opts = opts || { };
	        if (opts._options) opts = opts._options;
	
	        return interimElementService.show(
	          angular.extend({}, defaultOptions, opts)
	        );
	      }
	
	      /**
	       *  Special method to hide and destroy an interimElement WITHOUT
	       *  any 'leave` or hide animations ( an immediate force hide/remove )
	       *
	       *  NOTE: This calls the onRemove() subclass method for each component...
	       *  which must have code to respond to `options.$destroy == true`
	       */
	      function destroyInterimElement(opts) {
	          return interimElementService.destroy(opts);
	      }
	
	      /**
	       * Helper to call $injector.invoke with a local of the factory name for
	       * this provider.
	       * If an $mdDialog is providing options for a dialog and tries to inject
	       * $mdDialog, a circular dependency error will happen.
	       * We get around that by manually injecting $mdDialog as a local.
	       */
	      function invokeFactory(factory, defaultVal) {
	        var locals = {};
	        locals[interimFactoryName] = publicService;
	        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
	      }
	
	    }
	
	  }
	
	  /* @ngInject */
	  function InterimElementFactory($document, $q, $rootScope, $timeout, $rootElement, $animate,
	                                 $mdUtil, $mdCompiler, $mdTheming, $injector, $exceptionHandler) {
	    return function createInterimElementService() {
	      var SHOW_CANCELLED = false;
	
	      /*
	       * @ngdoc service
	       * @name $$interimElement.$service
	       *
	       * @description
	       * A service used to control inserting and removing an element into the DOM.
	       *
	       */
	
	      var service;
	
	      var showPromises = []; // Promises for the interim's which are currently opening.
	      var hidePromises = []; // Promises for the interim's which are currently hiding.
	      var showingInterims = []; // Interim elements which are currently showing up.
	
	      // Publish instance $$interimElement service;
	      // ... used as $mdDialog, $mdToast, $mdMenu, and $mdSelect
	
	      return service = {
	        show: show,
	        hide: waitForInterim(hide),
	        cancel: waitForInterim(cancel),
	        destroy : destroy,
	        $injector_: $injector
	      };
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#show
	       * @kind function
	       *
	       * @description
	       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved or rejected
	       * with hide or cancel, respectively. To external cancel/hide, developers should use the
	       *
	       * @param {*} options is hashMap of settings
	       * @returns a Promise
	       *
	       */
	      function show(options) {
	        options = options || {};
	        var interimElement = new InterimElement(options || {});
	
	        // When an interim element is currently showing, we have to cancel it.
	        // Just hiding it, will resolve the InterimElement's promise, the promise should be
	        // rejected instead.
	        var hideAction = options.multiple ? $q.resolve() : $q.all(showPromises);
	
	        if (!options.multiple) {
	          // Wait for all opening interim's to finish their transition.
	          hideAction = hideAction.then(function() {
	            // Wait for all closing and showing interim's to be completely closed.
	            var promiseArray = hidePromises.concat(showingInterims.map(service.cancel));
	            return $q.all(promiseArray);
	          });
	        }
	
	        var showAction = hideAction.then(function() {
	
	          return interimElement
	            .show()
	            .catch(function(reason) { return reason; })
	            .finally(function() {
	              showPromises.splice(showPromises.indexOf(showAction), 1);
	              showingInterims.push(interimElement);
	            });
	
	        });
	
	        showPromises.push(showAction);
	
	        // In AngularJS 1.6+, exceptions inside promises will cause a rejection. We need to handle
	        // the rejection and only log it if it's an error.
	        interimElement.deferred.promise.catch(function(fault) {
	          if (fault instanceof Error) {
	            $exceptionHandler(fault);
	          }
	
	          return fault;
	        });
	
	        // Return a promise that will be resolved when the interim
	        // element is hidden or cancelled...
	        return interimElement.deferred.promise;
	      }
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#hide
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and resolves the promise returned from `show`
	       *
	       * @param {*} resolveParam Data to resolve the promise with
	       * @returns a Promise that will be resolved after the element has been removed.
	       *
	       */
	      function hide(reason, options) {
	        options = options || {};
	
	        if (options.closeAll) {
	          // We have to make a shallow copy of the array, because otherwise the map will break.
	          return $q.all(showingInterims.slice().reverse().map(closeElement));
	        } else if (options.closeTo !== undefined) {
	          return $q.all(showingInterims.slice(options.closeTo).map(closeElement));
	        }
	
	        // Hide the latest showing interim element.
	        return closeElement(showingInterims[showingInterims.length - 1]);
	
	        function closeElement(interim) {
	
	          var hideAction = interim
	            .remove(reason, false, options || { })
	            .catch(function(reason) { return reason; })
	            .finally(function() {
	              hidePromises.splice(hidePromises.indexOf(hideAction), 1);
	            });
	
	          showingInterims.splice(showingInterims.indexOf(interim), 1);
	          hidePromises.push(hideAction);
	
	          return interim.deferred.promise;
	        }
	      }
	
	      /*
	       * @ngdoc method
	       * @name $$interimElement.$service#cancel
	       * @kind function
	       *
	       * @description
	       * Removes the `$interimElement` from the DOM and rejects the promise returned from `show`
	       *
	       * @param {*} reason Data to reject the promise with
	       * @returns Promise that will be resolved after the element has been removed.
	       *
	       */
	      function cancel(reason, options) {
	        var interim = showingInterims.pop();
	        if (!interim) {
	          return $q.when(reason);
	        }
	
	        var cancelAction = interim
	          .remove(reason, true, options || {})
	          .catch(function(reason) { return reason; })
	          .finally(function() {
	            hidePromises.splice(hidePromises.indexOf(cancelAction), 1);
	          });
	
	        hidePromises.push(cancelAction);
	
	        // Since AngularJS 1.6.7, promises will be logged to $exceptionHandler when the promise
	        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
	        // promise from being logged to the $exceptionHandler.
	        return interim.deferred.promise.catch(angular.noop);
	      }
	
	      /**
	       * Creates a function to wait for at least one interim element to be available.
	       * @param callbackFn Function to be used as callback
	       * @returns {Function}
	       */
	      function waitForInterim(callbackFn) {
	        return function() {
	          var fnArguments = arguments;
	
	          if (!showingInterims.length) {
	            // When there are still interim's opening, then wait for the first interim element to
	            // finish its open animation.
	            if (showPromises.length) {
	              return showPromises[0].finally(function () {
	                return callbackFn.apply(service, fnArguments);
	              });
	            }
	
	            return $q.when("No interim elements currently showing up.");
	          }
	
	          return callbackFn.apply(service, fnArguments);
	        };
	      }
	
	      /*
	       * Special method to quick-remove the interim element without animations
	       * Note: interim elements are in "interim containers"
	       */
	      function destroy(targetEl) {
	        var interim = !targetEl ? showingInterims.shift() : null;
	
	        var parentEl = angular.element(targetEl).length && angular.element(targetEl)[0].parentNode;
	
	        if (parentEl) {
	          // Try to find the interim in the stack which corresponds to the supplied DOM element.
	          var filtered = showingInterims.filter(function(entry) {
	            return entry.options.element[0] === parentEl;
	          });
	
	          // Note: This function might be called when the element already has been removed,
	          // in which case we won't find any matches.
	          if (filtered.length) {
	            interim = filtered[0];
	            showingInterims.splice(showingInterims.indexOf(interim), 1);
	          }
	        }
	
	        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) :
	                         $q.when(SHOW_CANCELLED);
	      }
	
	      /*
	       * Internal Interim Element Object
	       * Used internally to manage the DOM element and related data
	       */
	      function InterimElement(options) {
	        var self, element, showAction = $q.when(true);
	
	        options = configureScopeAndTransitions(options);
	
	        return self = {
	          options : options,
	          deferred: $q.defer(),
	          show    : createAndTransitionIn,
	          remove  : transitionOutAndRemove
	        };
	
	        /**
	         * Compile, link, and show this interim element
	         * Use optional autoHided and transition-in effects
	         */
	        function createAndTransitionIn() {
	          return $q(function(resolve, reject) {
	
	            // Trigger onCompiling callback before the compilation starts.
	            // This is useful, when modifying options, which can be influenced by developers.
	            options.onCompiling && options.onCompiling(options);
	
	            compileElement(options)
	              .then(function( compiledData ) {
	                element = linkElement( compiledData, options );
	
	                // Expose the cleanup function from the compiler.
	                options.cleanupElement = compiledData.cleanup;
	
	                showAction = showElement(element, options, compiledData.controller)
	                  .then(resolve, rejectAll);
	              }).catch(rejectAll);
	
	            function rejectAll(fault) {
	              // Force the '$md<xxx>.show()' promise to reject
	              self.deferred.reject(fault);
	
	              // Continue rejection propagation
	              reject(fault);
	            }
	          });
	        }
	
	        /**
	         * After the show process has finished/rejected:
	         * - announce 'removing',
	         * - perform the transition-out, and
	         * - perform optional clean up scope.
	         */
	        function transitionOutAndRemove(response, isCancelled, opts) {
	
	          // abort if the show() and compile failed
	          if ( !element ) return $q.when(false);
	
	          options = angular.extend(options || {}, opts || {});
	          options.cancelAutoHide && options.cancelAutoHide();
	          options.element.triggerHandler('$mdInterimElementRemove');
	
	          if ( options.$destroy === true ) {
	
	            return hideElement(options.element, options).then(function(){
	              (isCancelled && rejectAll(response)) || resolveAll(response);
	            });
	
	          } else {
	            $q.when(showAction).finally(function() {
	              hideElement(options.element, options).then(function() {
	                isCancelled ? rejectAll(response) : resolveAll(response);
	              }, rejectAll);
	            });
	
	            return self.deferred.promise;
	          }
	
	
	          /**
	           * The `show()` returns a promise that will be resolved when the interim
	           * element is hidden or cancelled...
	           */
	          function resolveAll(response) {
	            self.deferred.resolve(response);
	          }
	
	          /**
	           * Force the '$md<xxx>.show()' promise to reject
	           */
	          function rejectAll(fault) {
	            self.deferred.reject(fault);
	          }
	        }
	
	        /**
	         * Prepare optional isolated scope and prepare $animate with default enter and leave
	         * transitions for the new element instance.
	         */
	        function configureScopeAndTransitions(options) {
	          options = options || { };
	          if ( options.template ) {
	            options.template = $mdUtil.processTemplate(options.template);
	          }
	
	          return angular.extend({
	            preserveScope: false,
	            cancelAutoHide : angular.noop,
	            scope: options.scope || $rootScope.$new(options.isolateScope),
	
	            /**
	             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
	             */
	            onShow: function transitionIn(scope, element, options) {
	              return $animate.enter(element, options.parent);
	            },
	
	            /**
	             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
	             */
	            onRemove: function transitionOut(scope, element) {
	              // Element could be undefined if a new element is shown before
	              // the old one finishes compiling.
	              return element && $animate.leave(element) || $q.when();
	            }
	          }, options );
	
	        }
	
	        /**
	         * Compile an element with a templateUrl, controller, and locals
	         */
	        function compileElement(options) {
	
	          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;
	
	          return compiled || $q(function (resolve) {
	              resolve({
	                locals: {},
	                link: function () {
	                  return options.element;
	                }
	              });
	            });
	        }
	
	        /**
	         *  Link an element with compiled configuration
	         */
	        function linkElement(compileData, options){
	          angular.extend(compileData.locals, options);
	
	          var element = compileData.link(options.scope);
	
	          // Search for parent at insertion time, if not specified
	          options.element = element;
	          options.parent = findParent(element, options);
	          if (options.themable) $mdTheming(element);
	
	          return element;
	        }
	
	        /**
	         * Search for parent at insertion time, if not specified
	         */
	        function findParent(element, options) {
	          var parent = options.parent;
	
	          // Search for parent at insertion time, if not specified
	          if (angular.isFunction(parent)) {
	            parent = parent(options.scope, element, options);
	          } else if (angular.isString(parent)) {
	            parent = angular.element($document[0].querySelector(parent));
	          } else {
	            parent = angular.element(parent);
	          }
	
	          // If parent querySelector/getter function fails, or it's just null,
	          // find a default.
	          if (!(parent || {}).length) {
	            var el;
	            if ($rootElement[0] && $rootElement[0].querySelector) {
	              el = $rootElement[0].querySelector(':not(svg) > body');
	            }
	            if (!el) el = $rootElement[0];
	            if (el.nodeName == '#comment') {
	              el = $document[0].body;
	            }
	            return angular.element(el);
	          }
	
	          return parent;
	        }
	
	        /**
	         * If auto-hide is enabled, start timer and prepare cancel function
	         */
	        function startAutoHide() {
	          var autoHideTimer, cancelAutoHide = angular.noop;
	
	          if (options.hideDelay) {
	            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
	            cancelAutoHide = function() {
	              $timeout.cancel(autoHideTimer);
	            };
	          }
	
	          // Cache for subsequent use
	          options.cancelAutoHide = function() {
	            cancelAutoHide();
	            options.cancelAutoHide = undefined;
	          };
	        }
	
	        /**
	         * Show the element ( with transitions), notify complete and start
	         * optional auto-Hide
	         */
	        function showElement(element, options, controller) {
	          // Trigger onShowing callback before the `show()` starts
	          var notifyShowing = options.onShowing || angular.noop;
	          // Trigger onComplete callback when the `show()` finishes
	          var notifyComplete = options.onComplete || angular.noop;
	
	          // Necessary for consistency between AngularJS 1.5 and 1.6.
	          try {
	            notifyShowing(options.scope, element, options, controller);
	          } catch (e) {
	            return $q.reject(e);
	          }
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              $q.when(options.onShow(options.scope, element, options, controller))
	                .then(function () {
	                  notifyComplete(options.scope, element, options);
	                  startAutoHide();
	
	                  resolve(element);
	                }, reject);
	
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	        function hideElement(element, options) {
	          var announceRemoving = options.onRemoving || angular.noop;
	
	          return $q(function (resolve, reject) {
	            try {
	              // Start transitionIn
	              var action = $q.when( options.onRemove(options.scope, element, options) || true );
	
	              // Trigger callback *before* the remove operation starts
	              announceRemoving(element, action);
	
	              if (options.$destroy) {
	                // For $destroy, onRemove should be synchronous
	                resolve(element);
	
	                if (!options.preserveScope && options.scope ) {
	                  // scope destroy should still be be done after the current digest is done
	                  action.then( function() { options.scope.$destroy(); });
	                }
	              } else {
	                // Wait until transition-out is done
	                action.then(function () {
	                  if (!options.preserveScope && options.scope ) {
	                    options.scope.$destroy();
	                  }
	
	                  resolve(element);
	                }, reject);
	              }
	            } catch (e) {
	              reject(e.message);
	            }
	          });
	        }
	
	      }
	    };
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  var $mdUtil, $interpolate, $log;
	
	  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
	  var WHITESPACE = /\s+/g;
	
	  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow' ];
	  var LAYOUT_OPTIONS = ['row', 'column'];
	  var ALIGNMENT_MAIN_AXIS= [ "", "start", "center", "end", "stretch", "space-around", "space-between" ];
	  var ALIGNMENT_CROSS_AXIS= [ "", "start", "center", "end", "stretch" ];
	
	  var config = {
	    /**
	     * Enable directive attribute-to-class conversions
	     * Developers can use `<body md-layout-css />` to quickly
	     * disable the Layout directives and prohibit the injection of Layout classNames
	     */
	    enabled: true,
	
	    /**
	     * List of mediaQuery breakpoints and associated suffixes
	     *
	     *   [
	     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
	     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
	     *   ]
	     */
	    breakpoints: []
	  };
	
	  registerLayoutAPI( angular.module('material.core.layout', ['ng']) );
	
	  /**
	   *   registerLayoutAPI()
	   *
	   *   The original AngularJS Material Layout solution used attribute selectors and CSS.
	   *
	   *  ```html
	   *  <div layout="column"> My Content </div>
	   *  ```
	   *
	   *  ```css
	   *  [layout] {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  [layout=column] {
	   *    flex-direction : column
	   *  }
	   *  ```
	   *
	   *  Use of attribute selectors creates significant performance impacts in some
	   *  browsers... mainly IE.
	   *
	   *  This module registers directives that allow the same layout attributes to be
	   *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
	   *  contains a Layout directive.
	   *
	   * ```html
	   *   <div layout="column" class="layout layout-column"> My Content </div>
	   *```
	   *
	   *  ```css
	   *  .layout {
	   *    box-sizing: border-box;
	   *    display:flex;
	   *  }
	   *  .layout-column {
	   *    flex-direction : column
	   *  }
	   *  ```
	   */
	  function registerLayoutAPI(module){
	    var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	    var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	
	    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
	    var BREAKPOINTS     = [ "", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print" ];
	    var API_WITH_VALUES = [ "layout", "flex", "flex-order", "flex-offset", "layout-align" ];
	    var API_NO_VALUES   = [ "show", "hide", "layout-padding", "layout-margin" ];
	
	
	    // Build directive registration functions for the standard Layout API... for all breakpoints.
	    angular.forEach(BREAKPOINTS, function(mqb) {
	
	      // Attribute directives with expected, observable value(s)
	      angular.forEach( API_WITH_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive( directiveNormalize(fullName), attributeWithObserve(fullName));
	      });
	
	      // Attribute directives with no expected value(s)
	      angular.forEach( API_NO_VALUES, function(name){
	        var fullName = mqb ? name + "-" + mqb : name;
	        module.directive( directiveNormalize(fullName), attributeWithoutValue(fullName));
	      });
	
	    });
	
	    // Register other, special directive functions for the Layout features:
	    module
	
	      .provider('$$mdLayout'     , function() {
	        // Publish internal service for Layouts
	        return {
	          $get : angular.noop,
	          validateAttributeValue : validateAttributeValue,
	          validateAttributeUsage : validateAttributeUsage,
	          /**
	           * Easy way to disable/enable the Layout API.
	           * When disabled, this stops all attribute-to-classname generations
	           */
	          disableLayouts  : function(isDisabled) {
	            config.enabled =  (isDisabled !== true);
	          }
	        };
	      })
	
	      .directive('mdLayoutCss'        , disableLayoutDirective )
	      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))
	
	      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
	      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
	      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
	      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))
	
	      // !! Deprecated attributes: use the `-lt` (aka less-than) notations
	
	      .directive('layoutLtMd'     , warnAttrNotSupported('layout-lt-md', true))
	      .directive('layoutLtLg'     , warnAttrNotSupported('layout-lt-lg', true))
	      .directive('flexLtMd'       , warnAttrNotSupported('flex-lt-md', true))
	      .directive('flexLtLg'       , warnAttrNotSupported('flex-lt-lg', true))
	
	      .directive('layoutAlignLtMd', warnAttrNotSupported('layout-align-lt-md'))
	      .directive('layoutAlignLtLg', warnAttrNotSupported('layout-align-lt-lg'))
	      .directive('flexOrderLtMd'  , warnAttrNotSupported('flex-order-lt-md'))
	      .directive('flexOrderLtLg'  , warnAttrNotSupported('flex-order-lt-lg'))
	      .directive('offsetLtMd'     , warnAttrNotSupported('flex-offset-lt-md'))
	      .directive('offsetLtLg'     , warnAttrNotSupported('flex-offset-lt-lg'))
	
	      .directive('hideLtMd'       , warnAttrNotSupported('hide-lt-md'))
	      .directive('hideLtLg'       , warnAttrNotSupported('hide-lt-lg'))
	      .directive('showLtMd'       , warnAttrNotSupported('show-lt-md'))
	      .directive('showLtLg'       , warnAttrNotSupported('show-lt-lg'))
	
	      // Determine if
	      .config( detectDisabledLayouts );
	
	    /**
	     * Converts snake_case to camelCase.
	     * Also there is special case for Moz prefix starting with upper case letter.
	     * @param name Name to normalize
	     */
	    function directiveNormalize(name) {
	      return name
	        .replace(PREFIX_REGEXP, '')
	        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	          return offset ? letter.toUpperCase() : letter;
	        });
	    }
	
	  }
	
	
	  /**
	    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
	    * If yes, then immediately disable all layout API features
	    *
	    * Note: this attribute should be specified on either the HTML or BODY tags
	    */
	   /**
	    * @ngInject
	    */
	   function detectDisabledLayouts() {
	     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
	     config.enabled = !isDisabled;
	   }
	
	  /**
	   * Special directive that will disable ALL Layout conversions of layout
	   * attribute(s) to classname(s).
	   *
	   * <link rel="stylesheet" href="angular-material.min.css">
	   * <link rel="stylesheet" href="angular-material.layout.css">
	   *
	   * <body md-layout-css>
	   *  ...
	   * </body>
	   *
	   * Note: Using md-layout-css directive requires the developer to load the Material
	   * Layout Attribute stylesheet (which only uses attribute selectors):
	   *
	   *       `angular-material.layout.css`
	   *
	   * Another option is to use the LayoutProvider to configure and disable the attribute
	   * conversions; this would obviate the use of the `md-layout-css` directive
	   *
	   */
	  function disableLayoutDirective() {
	    // Return a 1x-only, first-match attribute directive
	    config.enabled = false;
	
	    return {
	      restrict : 'A',
	      priority : '900'
	    };
	  }
	
	  /**
	   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
	   * finish processing. Eliminates flicker with Material.Layouts
	   */
	  function buildCloakInterceptor(className) {
	    return [ '$timeout', function($timeout){
	      return {
	        restrict : 'A',
	        priority : -10,   // run after normal ng-cloak
	        compile  : function( element ) {
	          if (!config.enabled) return angular.noop;
	
	          // Re-add the cloak
	          element.addClass(className);
	
	          return function( scope, element ) {
	            // Wait while layout injectors configure, then uncloak
	            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
	            //       $timeout is acceptable.
	            $timeout( function(){
	              element.removeClass(className);
	            }, 10, false);
	          };
	        }
	      };
	    }];
	  }
	
	
	  // *********************************************************************************
	  //
	  // These functions create registration functions for AngularJS Material Layout attribute directives
	  // This provides easy translation to switch AngularJS Material attribute selectors to
	  // CLASS selectors and directives; which has huge performance implications
	  // for IE Browsers
	  //
	  // *********************************************************************************
	
	  /**
	   * Creates a directive registration function where a possible dynamic attribute
	   * value will be observed/watched.
	   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
	   */
	  function attributeWithObserve(className) {
	
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeUsage(className, attr, element, $log);
	
	            validateAttributeValue( className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            linkFn = translateWithValueToCssClass;
	          }
	
	          // Use for postLink to account for transforms after ng-transclude.
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector(s), then
	     * remove the deprecated attribute selector
	     */
	    function translateWithValueToCssClass(scope, element, attrs) {
	      var updateFn = updateClassWithValue(element, className, attrs);
	      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);
	
	      updateFn(getNormalizedAttrValue(className, attrs, ""));
	      scope.$on("$destroy", function() { unwatch(); });
	    }
	  }
	
	  /**
	   * Creates a registration function for AngularJS Material Layout attribute directive.
	   * This is a `simple` transpose of attribute usage to class usage; where we ignore
	   * any attribute value
	   */
	  function attributeWithoutValue(className) {
	    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
	      $mdUtil = _$mdUtil_;
	      $interpolate = _$interpolate_;
	      $log = _$log_;
	
	      return {
	        restrict: 'A',
	        compile: function(element, attr) {
	          var linkFn;
	          if (config.enabled) {
	            // immediately replace static (non-interpolated) invalid values...
	
	            validateAttributeValue( className,
	              getNormalizedAttrValue(className, attr, ""),
	              buildUpdateFn(element, className, attr)
	            );
	
	            translateToCssClass(null, element);
	
	            // Use for postLink to account for transforms after ng-transclude.
	            linkFn = translateToCssClass;
	          }
	
	          return linkFn || angular.noop;
	        }
	      };
	    }];
	
	    /**
	     * Add as transformed class selector, then
	     * remove the deprecated attribute selector
	     */
	    function translateToCssClass(scope, element) {
	      element.addClass(className);
	    }
	  }
	
	
	
	  /**
	   * After link-phase, do NOT remove deprecated layout attribute selector.
	   * Instead watch the attribute so interpolated data-bindings to layout
	   * selectors will continue to be supported.
	   *
	   * $observe() the className and update with new class (after removing the last one)
	   *
	   * e.g. `layout="{{layoutDemo.direction}}"` will update...
	   *
	   * NOTE: The value must match one of the specified styles in the CSS.
	   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
	   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
	   *
	   */
	  function updateClassWithValue(element, className) {
	    var lastClass;
	
	    return function updateClassFn(newValue) {
	      var value = validateAttributeValue(className, newValue || "");
	      if ( angular.isDefined(value) ) {
	        if (lastClass) element.removeClass(lastClass);
	        lastClass = !value ? className : className + "-" + value.trim().replace(WHITESPACE, "-");
	        element.addClass(lastClass);
	      }
	    };
	  }
	
	  /**
	   * Provide console warning that this layout attribute has been deprecated
	   *
	   */
	  function warnAttrNotSupported(className) {
	    var parts = className.split("-");
	    return ["$log", function($log) {
	      $log.warn(className + "has been deprecated. Please use a `" + parts[0] + "-gt-<xxx>` variant.");
	      return angular.noop;
	    }];
	  }
	
	  /**
	   * Centralize warnings for known flexbox issues (especially IE-related issues)
	   */
	  function validateAttributeUsage(className, attr, element, $log){
	    var message, usage, url;
	    var nodeName = element[0].nodeName.toLowerCase();
	
	    switch(className.replace(SUFFIXES,"")) {
	      case "flex":
	        if ((nodeName == "md-button") || (nodeName == "fieldset")){
	          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
	          // Use <div flex> wrapper inside (preferred) or outside
	
	          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
	          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
	          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";
	
	          $log.warn( $mdUtil.supplant(message, [usage, url]) );
	        }
	    }
	
	  }
	
	
	  /**
	   * For the Layout attribute value, validate or replace with default
	   * fallback value
	   */
	  function validateAttributeValue(className, value, updateFn) {
	    var origValue;
	
	    if (!needsInterpolation(value)) {
	      switch (className.replace(SUFFIXES,"")) {
	        case 'layout'        :
	          if ( !findIn(value, LAYOUT_OPTIONS) ) {
	            value = LAYOUT_OPTIONS[0];    // 'row';
	          }
	          break;
	
	        case 'flex'          :
	          if (!findIn(value, FLEX_OPTIONS)) {
	            if (isNaN(value)) {
	              value = '';
	            }
	          }
	          break;
	
	        case 'flex-offset' :
	        case 'flex-order'    :
	          if (!value || isNaN(+value)) {
	            value = '0';
	          }
	          break;
	
	        case 'layout-align'  :
	          var axis = extractAlignAxis(value);
	          value = $mdUtil.supplant("{main}-{cross}",axis);
	          break;
	
	        case 'layout-padding' :
	        case 'layout-margin'  :
	        case 'layout-fill'    :
	        case 'layout-wrap'    :
	        case 'layout-nowrap'  :
	        case 'layout-nowrap' :
	          value = '';
	          break;
	      }
	
	      if (value != origValue) {
	        (updateFn || angular.noop)(value);
	      }
	    }
	
	    return value ? value.trim() : "";
	  }
	
	  /**
	   * Replace current attribute value with fallback value
	   */
	  function buildUpdateFn(element, className, attrs) {
	    return function updateAttrValue(fallback) {
	      if (!needsInterpolation(fallback)) {
	        // Do not modify the element's attribute value; so
	        // uses '<ui-layout layout="/api/sidebar.html" />' will not
	        // be affected. Just update the attrs value.
	        attrs[attrs.$normalize(className)] = fallback;
	      }
	    };
	  }
	
	  /**
	   * See if the original value has interpolation symbols:
	   * e.g.  flex-gt-md="{{triggerPoint}}"
	   */
	  function needsInterpolation(value) {
	    return (value || "").indexOf($interpolate.startSymbol()) > -1;
	  }
	
	  function getNormalizedAttrValue(className, attrs, defaultVal) {
	    var normalizedAttr = attrs.$normalize(className);
	    return attrs[normalizedAttr] ? attrs[normalizedAttr].trim().replace(WHITESPACE, "-") : defaultVal || null;
	  }
	
	  function findIn(item, list, replaceWith) {
	    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;
	
	    var found = false;
	    if (item) {
	      list.forEach(function(it) {
	        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
	        found = found || (it === item);
	      });
	    }
	    return found;
	  }
	
	  function extractAlignAxis(attrValue) {
	    var axis = {
	      main : "start",
	      cross: "stretch"
	    }, values;
	
	    attrValue = (attrValue || "");
	
	    if ( attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
	      // For missing main-axis values
	      attrValue = "none" + attrValue;
	    }
	
	    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
	    if ( values.length && (values[0] === "space") ) {
	      // for main-axis values of "space-around" or "space-between"
	      values = [ values[0]+"-"+values[1],values[2] ];
	    }
	
	    if ( values.length > 0 ) axis.main  = values[0] || axis.main;
	    if ( values.length > 1 ) axis.cross = values[1] || axis.cross;
	
	    if ( ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0 )   axis.main = "start";
	    if ( ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0 ) axis.cross = "stretch";
	
	    return axis;
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.liveannouncer
	 * @description
	 * AngularJS Material Live Announcer to provide accessibility for Voice Readers.
	 */
	MdLiveAnnouncer.$inject = ["$timeout"];
	angular
	  .module('material.core')
	  .service('$mdLiveAnnouncer', MdLiveAnnouncer);
	
	/**
	 * @ngdoc service
	 * @name $mdLiveAnnouncer
	 * @module material.core.liveannouncer
	 *
	 * @description
	 *
	 * Service to announce messages to supported screenreaders.
	 *
	 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
	 *
	 * <hljs lang="js">
	 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
	 *     // Basic announcement (Polite Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google');
	 *
	 *     // Custom announcement (Assertive Mode)
	 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
	 *   });
	 * </hljs>
	 *
	 */
	function MdLiveAnnouncer($timeout) {
	  /** @private @const @type {!angular.$timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const @type {!HTMLElement} */
	  this._liveElement = this._createLiveElement();
	
	  /** @private @const @type {!number} */
	  this._announceTimeout = 100;
	}
	
	/**
	 * @ngdoc method
	 * @name $mdLiveAnnouncer#announce
	 * @description Announces messages to supported screenreaders.
	 * @param {string} message Message to be announced to the screenreader
	 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
	 */
	MdLiveAnnouncer.prototype.announce = function(message, politeness) {
	  if (!politeness) {
	    politeness = 'polite';
	  }
	
	  var self = this;
	
	  self._liveElement.textContent = '';
	  self._liveElement.setAttribute('aria-live', politeness);
	
	  // This 100ms timeout is necessary for some browser + screen-reader combinations:
	  // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
	  // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
	  //   second time without clearing and then using a non-zero delay.
	  // (using JAWS 17 at time of this writing).
	  self._$timeout(function() {
	    self._liveElement.textContent = message;
	  }, self._announceTimeout, false);
	};
	
	/**
	 * Creates a live announcer element, which listens for DOM changes and announces them
	 * to the screenreaders.
	 * @returns {!HTMLElement}
	 * @private
	 */
	MdLiveAnnouncer.prototype._createLiveElement = function() {
	  var liveEl = document.createElement('div');
	
	  liveEl.classList.add('md-visually-hidden');
	  liveEl.setAttribute('role', 'status');
	  liveEl.setAttribute('aria-atomic', 'true');
	  liveEl.setAttribute('aria-live', 'polite');
	
	  document.body.appendChild(liveEl);
	
	  return liveEl;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $$mdMeta
	 * @module material.core.meta
	 *
	 * @description
	 *
	 * A provider and a service that simplifies meta tags access
	 *
	 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
	 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
	 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
	 *
	 * ```js
	 * app.config(function($$mdMetaProvider) {
	 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 *
	 * app.controller('myController', function($$mdMeta) {
	 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
	 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
	 *
	 *   removeMeta();
	 * });
	 * ```
	 *
	 * @returns {$$mdMeta.$service}
	 *
	 */
	angular.module('material.core.meta', [])
	  .provider('$$mdMeta', function () {
	    var head = angular.element(document.head);
	    var metaElements = {};
	
	    /**
	     * Checks if the requested element was written manually and maps it
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {boolean} returns true if there is an element with the requested name
	     */
	    function mapExistingElement(name) {
	      if (metaElements[name]) {
	        return true;
	      }
	
	      var element = document.getElementsByName(name)[0];
	
	      if (!element) {
	        return false;
	      }
	
	      metaElements[name] = angular.element(element);
	
	      return true;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#setMeta
	     *
	     * @description
	     * Creates meta element with the 'name' and 'content' attributes,
	     * if the meta tag is already created than we replace the 'content' value
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @param {string} content meta tag 'content' attribute value
	     * @returns {function} remove function
	     *
	     */
	    function setMeta(name, content) {
	      mapExistingElement(name);
	
	      if (!metaElements[name]) {
	        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
	        head.append(newMeta);
	        metaElements[name] = newMeta;
	      }
	      else {
	        metaElements[name].attr('content', content);
	      }
	
	      return function () {
	        metaElements[name].attr('content', '');
	        metaElements[name].remove();
	        delete metaElements[name];
	      };
	    }
	
	    /**
	     * @ngdoc method
	     * @name $$mdMeta#getMeta
	     *
	     * @description
	     * Gets the 'content' attribute value of the wanted meta element
	     *
	     * @param {string} name meta tag 'name' attribute value
	     * @returns {string} content attribute value
	     */
	    function getMeta(name) {
	      if (!mapExistingElement(name)) {
	        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
	      }
	
	      return metaElements[name].attr('content');
	    }
	
	    var module = {
	      setMeta: setMeta,
	      getMeta: getMeta
	    };
	
	    return angular.extend({}, module, {
	      $get: function () {
	        return module;
	      }
	    });
	  });
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.core.componentRegistry
	   *
	   * @description
	   * A component instance registration service.
	   * Note: currently this as a private service in the SideNav component.
	   */
	  ComponentRegistry.$inject = ["$log", "$q"];
	  angular.module('material.core')
	    .factory('$mdComponentRegistry', ComponentRegistry);
	
	  /*
	   * @private
	   * @ngdoc factory
	   * @name ComponentRegistry
	   * @module material.core.componentRegistry
	   *
	   */
	  function ComponentRegistry($log, $q) {
	
	    var self;
	    var instances = [ ];
	    var pendings = { };
	
	    return self = {
	      /**
	       * Used to print an error when an instance for a handle isn't found.
	       */
	      notFoundError: function(handle, msgContext) {
	        $log.error( (msgContext || "") + 'No instance found for handle', handle);
	      },
	      /**
	       * Return all registered instances as an array.
	       */
	      getInstances: function() {
	        return instances;
	      },
	
	      /**
	       * Get a registered instance.
	       * @param handle the String handle to look up for a registered instance.
	       */
	      get: function(handle) {
	        if ( !isValidID(handle) ) return null;
	
	        var i, j, instance;
	        for(i = 0, j = instances.length; i < j; i++) {
	          instance = instances[i];
	          if(instance.$$mdHandle === handle) {
	            return instance;
	          }
	        }
	        return null;
	      },
	
	      /**
	       * Register an instance.
	       * @param instance the instance to register
	       * @param handle the handle to identify the instance under.
	       */
	      register: function(instance, handle) {
	        if ( !handle ) return angular.noop;
	
	        instance.$$mdHandle = handle;
	        instances.push(instance);
	        resolveWhen();
	
	        return deregister;
	
	        /**
	         * Remove registration for an instance
	         */
	        function deregister() {
	          var index = instances.indexOf(instance);
	          if (index !== -1) {
	            instances.splice(index, 1);
	          }
	        }
	
	        /**
	         * Resolve any pending promises for this instance
	         */
	        function resolveWhen() {
	          var dfd = pendings[handle];
	          if ( dfd ) {
	            dfd.forEach(function (promise) {
	              promise.resolve(instance);
	            });
	            delete pendings[handle];
	          }
	        }
	      },
	
	      /**
	       * Async accessor to registered component instance
	       * If not available then a promise is created to notify
	       * all listeners when the instance is registered.
	       */
	      when : function(handle) {
	        if ( isValidID(handle) ) {
	          var deferred = $q.defer();
	          var instance = self.get(handle);
	
	          if ( instance )  {
	            deferred.resolve( instance );
	          } else {
	            if (pendings[handle] === undefined) {
	              pendings[handle] = [];
	            }
	            pendings[handle].push(deferred);
	          }
	
	          return deferred.promise;
	        }
	        return $q.reject("Invalid `md-component-id` value.");
	      }
	
	    };
	
	    function isValidID(handle){
	      return handle && (handle !== "");
	    }
	
	  }
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdButtonInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
	   */
	
	  MdButtonInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdButtonInkRipple', MdButtonInkRipple);
	
	  function MdButtonInkRipple($mdInkRipple) {
	    return {
	      attach: function attachRipple(scope, element, options) {
	        options = angular.extend(optionsForElement(element), options);
	
	        return $mdInkRipple.attach(scope, element, options);
	      }
	    };
	
	    function optionsForElement(element) {
	      if (element.hasClass('md-icon-button')) {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          fitRipple: true,
	          center: true
	        };
	      } else {
	        return {
	          isMenuItem: element.hasClass('md-menu-item'),
	          dimBackground: true
	        };
	      }
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdCheckboxInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdCheckboxInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);
	
	  function MdCheckboxInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: true,
	        dimBackground: false,
	        fitRipple: true
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdListInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdListInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdListInkRipple', MdListInkRipple);
	
	  function MdListInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.core.ripple
	 * @description
	 * Ripple
	 */
	InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
	InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
	angular.module('material.core')
	    .provider('$mdInkRipple', InkRippleProvider)
	    .directive('mdInkRipple', InkRippleDirective)
	    .directive('mdNoInk', attrNoDirective)
	    .directive('mdNoBar', attrNoDirective)
	    .directive('mdNoStretch', attrNoDirective);
	
	var DURATION = 450;
	
	/**
	 * @ngdoc directive
	 * @name mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * The `md-ink-ripple` directive allows you to specify the ripple color or id a ripple is allowed.
	 *
	 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
	 *
	 * @usage
	 * ### String values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="#FF0000">
	 *     Ripples in red
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="false">
	 *     Not rippling
	 *   </ANY>
	 * </hljs>
	 *
	 * ### Interpolated values
	 * <hljs lang="html">
	 *   <ANY md-ink-ripple="{{ randomColor() }}">
	 *     Ripples with the return value of 'randomColor' function
	 *   </ANY>
	 *
	 *   <ANY md-ink-ripple="{{ canRipple() }}">
	 *     Ripples if 'canRipple' function return value is not 'false' or '0'
	 *   </ANY>
	 * </hljs>
	 */
	function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
	  return {
	    controller: angular.noop,
	    link:       function (scope, element, attr) {
	      attr.hasOwnProperty('mdInkRippleCheckbox')
	          ? $mdCheckboxInkRipple.attach(scope, element)
	          : $mdButtonInkRipple.attach(scope, element);
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdInkRipple
	 * @module material.core.ripple
	 *
	 * @description
	 * `$mdInkRipple` is a service for adding ripples to any element
	 *
	 * @usage
	 * <hljs lang="js">
	 * app.factory('$myElementInkRipple', function($mdInkRipple) {
	 *   return {
	 *     attach: function (scope, element, options) {
	 *       return $mdInkRipple.attach(scope, element, angular.extend({
	 *         center: false,
	 *         dimBackground: true
	 *       }, options));
	 *     }
	 *   };
	 * });
	 *
	 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
	 *   $scope.onClick = function (ev) {
	 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
	 *   }
	 * });
	 * </hljs>
	 *
	 * ### Disabling ripples globally
	 * If you want to disable ink ripples globally, for all components, you can call the
	 * `disableInkRipple` method in your app's config.
	 *
	 * <hljs lang="js">
	 * app.config(function ($mdInkRippleProvider) {
	 *   $mdInkRippleProvider.disableInkRipple();
	 * });
	 */
	
	function InkRippleProvider () {
	  var isDisabledGlobally = false;
	
	  return {
	    disableInkRipple: disableInkRipple,
	    $get: ["$injector", function($injector) {
	      return { attach: attach };
	
	      /**
	       * @ngdoc method
	       * @name $mdInkRipple#attach
	       *
	       * @description
	       * Attaching given scope, element and options to inkRipple controller
	       *
	       * @param {object=} scope Scope within the current context
	       * @param {object=} element The element the ripple effect should be applied to
	       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
	       * * `center` -  Whether the ripple should start from the center of the container element
	       * * `dimBackground` - Whether the background should be dimmed with the ripple color
	       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
	       * * `fitRipple` - Whether the ripple should fill the element
	       */
	      function attach (scope, element, options) {
	        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
	        return $injector.instantiate(InkRippleCtrl, {
	          $scope:        scope,
	          $element:      element,
	          rippleOptions: options
	        });
	      }
	    }]
	  };
	
	  /**
	   * @ngdoc method
	   * @name $mdInkRipple#disableInkRipple
	   *
	   * @description
	   * A config-time method that, when called, disables ripples globally.
	   */
	  function disableInkRipple () {
	    isDisabledGlobally = true;
	  }
	}
	
	/**
	 * Controller used by the ripple service in order to apply ripples
	 * @ngInject
	 */
	function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
	  this.$window    = $window;
	  this.$timeout   = $timeout;
	  this.$mdUtil    = $mdUtil;
	  this.$mdColorUtil    = $mdColorUtil;
	  this.$scope     = $scope;
	  this.$element   = $element;
	  this.options    = rippleOptions;
	  this.mousedown  = false;
	  this.ripples    = [];
	  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
	  this.lastRipple = null;
	
	  $mdUtil.valueOnUse(this, 'container', this.createContainer);
	
	  this.$element.addClass('md-ink-ripple');
	
	  // attach method for unit tests
	  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
	  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);
	
	  this.bindEvents();
	}
	
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup or mouseleave event)
	 */
	function autoCleanup (self, cleanupFn) {
	
	  if ( self.mousedown || self.lastRipple ) {
	    self.mousedown = false;
	    self.$mdUtil.nextTick( angular.bind(self, cleanupFn), false);
	  }
	
	}
	
	
	/**
	 * Returns the color that the ripple should be (either based on CSS or hard-coded)
	 * @returns {string}
	 */
	InkRippleCtrl.prototype.color = function (value) {
	  var self = this;
	
	  // If assigning a color value, apply it to background and the ripple color
	  if (angular.isDefined(value)) {
	    self._color = self._parseColor(value);
	  }
	
	  // If color lookup, use assigned, defined, or inherited
	  return self._color || self._parseColor( self.inkRipple() ) || self._parseColor( getElementColor() );
	
	  /**
	   * Finds the color element and returns its text color for use as default ripple color
	   * @returns {string}
	   */
	  function getElementColor () {
	    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
	    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];
	
	    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
	  }
	};
	
	/**
	 * Updating the ripple colors based on the current inkRipple value
	 * or the element's computed style color
	 */
	InkRippleCtrl.prototype.calculateColor = function () {
	  return this.color();
	};
	
	
	/**
	 * Takes a string color and converts it to RGBA format
	 * @param color {string}
	 * @param [multiplier] {int}
	 * @returns {string}
	 */
	
	InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
	  multiplier = multiplier || 1;
	  var colorUtil = this.$mdColorUtil;
	
	  if (!color) return;
	  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
	  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
	  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);
	
	};
	
	/**
	 * Binds events to the root element for
	 */
	InkRippleCtrl.prototype.bindEvents = function () {
	  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
	  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
	  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
	  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
	};
	
	/**
	 * Create a new ripple on every mousedown event from the root element
	 * @param event {MouseEvent}
	 */
	InkRippleCtrl.prototype.handleMousedown = function (event) {
	  if ( this.mousedown ) return;
	
	  // When jQuery is loaded, we have to get the original event
	  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
	  this.mousedown = true;
	  if (this.options.center) {
	    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
	  } else {
	
	    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
	    if (event.srcElement !== this.$element[0]) {
	      var layerRect = this.$element[0].getBoundingClientRect();
	      var layerX = event.clientX - layerRect.left;
	      var layerY = event.clientY - layerRect.top;
	
	      this.createRipple(layerX, layerY);
	    } else {
	      this.createRipple(event.offsetX, event.offsetY);
	    }
	  }
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
	 * mouseup, touchend or mouseleave event)
	 */
	InkRippleCtrl.prototype.handleMouseup = function () {
	  autoCleanup(this, this.clearRipples);
	};
	
	/**
	 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
	 * touchmove)
	 */
	InkRippleCtrl.prototype.handleTouchmove = function () {
	  autoCleanup(this, this.deleteRipples);
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them.
	 */
	InkRippleCtrl.prototype.deleteRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.ripples[ i ].remove();
	  }
	};
	
	/**
	 * Cycles through all ripples and attempts to remove them with fade.
	 * Depending on logic within `fadeInComplete`, some removals will be postponed.
	 */
	InkRippleCtrl.prototype.clearRipples = function () {
	  for (var i = 0; i < this.ripples.length; i++) {
	    this.fadeInComplete(this.ripples[ i ]);
	  }
	};
	
	/**
	 * Creates the ripple container element
	 * @returns {*}
	 */
	InkRippleCtrl.prototype.createContainer = function () {
	  var container = angular.element('<div class="md-ripple-container"></div>');
	  this.$element.append(container);
	  return container;
	};
	
	InkRippleCtrl.prototype.clearTimeout = function () {
	  if (this.timeout) {
	    this.$timeout.cancel(this.timeout);
	    this.timeout = null;
	  }
	};
	
	InkRippleCtrl.prototype.isRippleAllowed = function () {
	  var element = this.$element[0];
	  do {
	    if (!element.tagName || element.tagName === 'BODY') break;
	
	    if (element && angular.isFunction(element.hasAttribute)) {
	      if (element.hasAttribute('disabled')) return false;
	      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
	    }
	
	  } while (element = element.parentNode);
	  return true;
	};
	
	/**
	 * The attribute `md-ink-ripple` may be a static or interpolated
	 * color value OR a boolean indicator (used to disable ripples)
	 */
	InkRippleCtrl.prototype.inkRipple = function () {
	  return this.$element.attr('md-ink-ripple');
	};
	
	/**
	 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
	 * @param left
	 * @param top
	 */
	InkRippleCtrl.prototype.createRipple = function (left, top) {
	  if (!this.isRippleAllowed()) return;
	
	  var ctrl        = this;
	  var colorUtil   = ctrl.$mdColorUtil;
	  var ripple      = angular.element('<div class="md-ripple"></div>');
	  var width       = this.$element.prop('clientWidth');
	  var height      = this.$element.prop('clientHeight');
	  var x           = Math.max(Math.abs(width - left), left) * 2;
	  var y           = Math.max(Math.abs(height - top), top) * 2;
	  var size        = getSize(this.options.fitRipple, x, y);
	  var color       = this.calculateColor();
	
	  ripple.css({
	    left:            left + 'px',
	    top:             top + 'px',
	    background:      'black',
	    width:           size + 'px',
	    height:          size + 'px',
	    backgroundColor: colorUtil.rgbaToRgb(color),
	    borderColor:     colorUtil.rgbaToRgb(color)
	  });
	  this.lastRipple = ripple;
	
	  // we only want one timeout to be running at a time
	  this.clearTimeout();
	  this.timeout    = this.$timeout(function () {
	    ctrl.clearTimeout();
	    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
	  }, DURATION * 0.35, false);
	
	  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
	  this.container.append(ripple);
	  this.ripples.push(ripple);
	  ripple.addClass('md-ripple-placed');
	
	  this.$mdUtil.nextTick(function () {
	
	    ripple.addClass('md-ripple-scaled md-ripple-active');
	    ctrl.$timeout(function () {
	      ctrl.clearRipples();
	    }, DURATION, false);
	
	  }, false);
	
	  function getSize (fit, x, y) {
	    return fit
	        ? Math.max(x, y)
	        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	  }
	};
	
	
	
	/**
	 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
	  if (this.lastRipple === ripple) {
	    if (!this.timeout && !this.mousedown) {
	      this.removeRipple(ripple);
	    }
	  } else {
	    this.removeRipple(ripple);
	  }
	};
	
	/**
	 * Kicks off the animation for removing a ripple
	 * @param ripple {Element}
	 */
	InkRippleCtrl.prototype.removeRipple = function (ripple) {
	  var ctrl  = this;
	  var index = this.ripples.indexOf(ripple);
	  if (index < 0) return;
	  this.ripples.splice(this.ripples.indexOf(ripple), 1);
	  ripple.removeClass('md-ripple-active');
	  ripple.addClass('md-ripple-remove');
	  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
	  // use a 2-second timeout in order to allow for the animation to finish
	  // we don't actually care how long the animation takes
	  this.$timeout(function () {
	    ctrl.fadeOutComplete(ripple);
	  }, DURATION, false);
	};
	
	/**
	 * Removes the provided ripple from the DOM
	 * @param ripple
	 */
	InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
	  ripple.remove();
	  this.lastRipple = null;
	};
	
	/**
	 * Used to create an empty directive.  This is used to track flag-directives whose children may have
	 * functionality based on them.
	 *
	 * Example: `md-no-ink` will potentially be used by all child directives.
	 */
	function attrNoDirective () {
	  return { controller: angular.noop };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	    /**
	   * @ngdoc service
	   * @name $mdTabInkRipple
	   * @module material.core
	   *
	   * @description
	   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
	   *
	   * @param {object=} scope Scope within the current context
	   * @param {object=} element The element the ripple effect should be applied to
	   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
	   */
	
	  MdTabInkRipple.$inject = ["$mdInkRipple"];
	  angular.module('material.core')
	    .factory('$mdTabInkRipple', MdTabInkRipple);
	
	  function MdTabInkRipple($mdInkRipple) {
	    return {
	      attach: attach
	    };
	
	    function attach(scope, element, options) {
	      return $mdInkRipple.attach(scope, element, angular.extend({
	        center: false,
	        dimBackground: true,
	        outline: false,
	        rippleSize: 'full'
	      }, options));
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	angular.module('material.core.theming.palette', [])
	.constant('$mdColorPalette', {
	  'red': {
	    '50': '#ffebee',
	    '100': '#ffcdd2',
	    '200': '#ef9a9a',
	    '300': '#e57373',
	    '400': '#ef5350',
	    '500': '#f44336',
	    '600': '#e53935',
	    '700': '#d32f2f',
	    '800': '#c62828',
	    '900': '#b71c1c',
	    'A100': '#ff8a80',
	    'A200': '#ff5252',
	    'A400': '#ff1744',
	    'A700': '#d50000',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100',
	    'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
	  },
	  'pink': {
	    '50': '#fce4ec',
	    '100': '#f8bbd0',
	    '200': '#f48fb1',
	    '300': '#f06292',
	    '400': '#ec407a',
	    '500': '#e91e63',
	    '600': '#d81b60',
	    '700': '#c2185b',
	    '800': '#ad1457',
	    '900': '#880e4f',
	    'A100': '#ff80ab',
	    'A200': '#ff4081',
	    'A400': '#f50057',
	    'A700': '#c51162',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '500 600 A200 A400 A700'
	  },
	  'purple': {
	    '50': '#f3e5f5',
	    '100': '#e1bee7',
	    '200': '#ce93d8',
	    '300': '#ba68c8',
	    '400': '#ab47bc',
	    '500': '#9c27b0',
	    '600': '#8e24aa',
	    '700': '#7b1fa2',
	    '800': '#6a1b9a',
	    '900': '#4a148c',
	    'A100': '#ea80fc',
	    'A200': '#e040fb',
	    'A400': '#d500f9',
	    'A700': '#aa00ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400 A700'
	  },
	  'deep-purple': {
	    '50': '#ede7f6',
	    '100': '#d1c4e9',
	    '200': '#b39ddb',
	    '300': '#9575cd',
	    '400': '#7e57c2',
	    '500': '#673ab7',
	    '600': '#5e35b1',
	    '700': '#512da8',
	    '800': '#4527a0',
	    '900': '#311b92',
	    'A100': '#b388ff',
	    'A200': '#7c4dff',
	    'A400': '#651fff',
	    'A700': '#6200ea',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200'
	  },
	  'indigo': {
	    '50': '#e8eaf6',
	    '100': '#c5cae9',
	    '200': '#9fa8da',
	    '300': '#7986cb',
	    '400': '#5c6bc0',
	    '500': '#3f51b5',
	    '600': '#3949ab',
	    '700': '#303f9f',
	    '800': '#283593',
	    '900': '#1a237e',
	    'A100': '#8c9eff',
	    'A200': '#536dfe',
	    'A400': '#3d5afe',
	    'A700': '#304ffe',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100',
	    'contrastStrongLightColors': '300 400 A200 A400'
	  },
	  'blue': {
	    '50': '#e3f2fd',
	    '100': '#bbdefb',
	    '200': '#90caf9',
	    '300': '#64b5f6',
	    '400': '#42a5f5',
	    '500': '#2196f3',
	    '600': '#1e88e5',
	    '700': '#1976d2',
	    '800': '#1565c0',
	    '900': '#0d47a1',
	    'A100': '#82b1ff',
	    'A200': '#448aff',
	    'A400': '#2979ff',
	    'A700': '#2962ff',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100',
	    'contrastStrongLightColors': '500 600 700 A200 A400 A700'
	  },
	  'light-blue': {
	    '50': '#e1f5fe',
	    '100': '#b3e5fc',
	    '200': '#81d4fa',
	    '300': '#4fc3f7',
	    '400': '#29b6f6',
	    '500': '#03a9f4',
	    '600': '#039be5',
	    '700': '#0288d1',
	    '800': '#0277bd',
	    '900': '#01579b',
	    'A100': '#80d8ff',
	    'A200': '#40c4ff',
	    'A400': '#00b0ff',
	    'A700': '#0091ea',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A700',
	    'contrastStrongLightColors': '600 700 800 A700'
	  },
	  'cyan': {
	    '50': '#e0f7fa',
	    '100': '#b2ebf2',
	    '200': '#80deea',
	    '300': '#4dd0e1',
	    '400': '#26c6da',
	    '500': '#00bcd4',
	    '600': '#00acc1',
	    '700': '#0097a7',
	    '800': '#00838f',
	    '900': '#006064',
	    'A100': '#84ffff',
	    'A200': '#18ffff',
	    'A400': '#00e5ff',
	    'A700': '#00b8d4',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'teal': {
	    '50': '#e0f2f1',
	    '100': '#b2dfdb',
	    '200': '#80cbc4',
	    '300': '#4db6ac',
	    '400': '#26a69a',
	    '500': '#009688',
	    '600': '#00897b',
	    '700': '#00796b',
	    '800': '#00695c',
	    '900': '#004d40',
	    'A100': '#a7ffeb',
	    'A200': '#64ffda',
	    'A400': '#1de9b6',
	    'A700': '#00bfa5',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'green': {
	    '50': '#e8f5e9',
	    '100': '#c8e6c9',
	    '200': '#a5d6a7',
	    '300': '#81c784',
	    '400': '#66bb6a',
	    '500': '#4caf50',
	    '600': '#43a047',
	    '700': '#388e3c',
	    '800': '#2e7d32',
	    '900': '#1b5e20',
	    'A100': '#b9f6ca',
	    'A200': '#69f0ae',
	    'A400': '#00e676',
	    'A700': '#00c853',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '500 600 700 800 900',
	    'contrastStrongLightColors': '500 600 700'
	  },
	  'light-green': {
	    '50': '#f1f8e9',
	    '100': '#dcedc8',
	    '200': '#c5e1a5',
	    '300': '#aed581',
	    '400': '#9ccc65',
	    '500': '#8bc34a',
	    '600': '#7cb342',
	    '700': '#689f38',
	    '800': '#558b2f',
	    '900': '#33691e',
	    'A100': '#ccff90',
	    'A200': '#b2ff59',
	    'A400': '#76ff03',
	    'A700': '#64dd17',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '700 800 900',
	    'contrastStrongLightColors': '700 800 900'
	  },
	  'lime': {
	    '50': '#f9fbe7',
	    '100': '#f0f4c3',
	    '200': '#e6ee9c',
	    '300': '#dce775',
	    '400': '#d4e157',
	    '500': '#cddc39',
	    '600': '#c0ca33',
	    '700': '#afb42b',
	    '800': '#9e9d24',
	    '900': '#827717',
	    'A100': '#f4ff81',
	    'A200': '#eeff41',
	    'A400': '#c6ff00',
	    'A700': '#aeea00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '900',
	    'contrastStrongLightColors': '900'
	  },
	  'yellow': {
	    '50': '#fffde7',
	    '100': '#fff9c4',
	    '200': '#fff59d',
	    '300': '#fff176',
	    '400': '#ffee58',
	    '500': '#ffeb3b',
	    '600': '#fdd835',
	    '700': '#fbc02d',
	    '800': '#f9a825',
	    '900': '#f57f17',
	    'A100': '#ffff8d',
	    'A200': '#ffff00',
	    'A400': '#ffea00',
	    'A700': '#ffd600',
	    'contrastDefaultColor': 'dark'
	  },
	  'amber': {
	    '50': '#fff8e1',
	    '100': '#ffecb3',
	    '200': '#ffe082',
	    '300': '#ffd54f',
	    '400': '#ffca28',
	    '500': '#ffc107',
	    '600': '#ffb300',
	    '700': '#ffa000',
	    '800': '#ff8f00',
	    '900': '#ff6f00',
	    'A100': '#ffe57f',
	    'A200': '#ffd740',
	    'A400': '#ffc400',
	    'A700': '#ffab00',
	    'contrastDefaultColor': 'dark'
	  },
	  'orange': {
	    '50': '#fff3e0',
	    '100': '#ffe0b2',
	    '200': '#ffcc80',
	    '300': '#ffb74d',
	    '400': '#ffa726',
	    '500': '#ff9800',
	    '600': '#fb8c00',
	    '700': '#f57c00',
	    '800': '#ef6c00',
	    '900': '#e65100',
	    'A100': '#ffd180',
	    'A200': '#ffab40',
	    'A400': '#ff9100',
	    'A700': '#ff6d00',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '800 900',
	    'contrastStrongLightColors': '800 900'
	  },
	  'deep-orange': {
	    '50': '#fbe9e7',
	    '100': '#ffccbc',
	    '200': '#ffab91',
	    '300': '#ff8a65',
	    '400': '#ff7043',
	    '500': '#ff5722',
	    '600': '#f4511e',
	    '700': '#e64a19',
	    '800': '#d84315',
	    '900': '#bf360c',
	    'A100': '#ff9e80',
	    'A200': '#ff6e40',
	    'A400': '#ff3d00',
	    'A700': '#dd2c00',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 400 A100 A200',
	    'contrastStrongLightColors': '500 600 700 800 900 A400 A700'
	  },
	  'brown': {
	    '50': '#efebe9',
	    '100': '#d7ccc8',
	    '200': '#bcaaa4',
	    '300': '#a1887f',
	    '400': '#8d6e63',
	    '500': '#795548',
	    '600': '#6d4c41',
	    '700': '#5d4037',
	    '800': '#4e342e',
	    '900': '#3e2723',
	    'A100': '#d7ccc8',
	    'A200': '#bcaaa4',
	    'A400': '#8d6e63',
	    'A700': '#5d4037',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 A100 A200',
	    'contrastStrongLightColors': '300 400'
	  },
	  'grey': {
	    '50': '#fafafa',
	    '100': '#f5f5f5',
	    '200': '#eeeeee',
	    '300': '#e0e0e0',
	    '400': '#bdbdbd',
	    '500': '#9e9e9e',
	    '600': '#757575',
	    '700': '#616161',
	    '800': '#424242',
	    '900': '#212121',
	    'A100': '#ffffff',
	    'A200': '#000000',
	    'A400': '#303030',
	    'A700': '#616161',
	    'contrastDefaultColor': 'dark',
	    'contrastLightColors': '600 700 800 900 A200 A400 A700'
	  },
	  'blue-grey': {
	    '50': '#eceff1',
	    '100': '#cfd8dc',
	    '200': '#b0bec5',
	    '300': '#90a4ae',
	    '400': '#78909c',
	    '500': '#607d8b',
	    '600': '#546e7a',
	    '700': '#455a64',
	    '800': '#37474f',
	    '900': '#263238',
	    'A100': '#cfd8dc',
	    'A200': '#b0bec5',
	    'A400': '#78909c',
	    'A700': '#455a64',
	    'contrastDefaultColor': 'light',
	    'contrastDarkColors': '50 100 200 300 A100 A200',
	    'contrastStrongLightColors': '400 500 700'
	  }
	});
	
	})();
	(function(){
	"use strict";
	
	(function(angular) {
	  'use strict';
	/**
	 * @ngdoc module
	 * @name material.core.theming
	 * @description
	 * Theming
	 */
	detectDisabledThemes.$inject = ["$mdThemingProvider"];
	ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$parse", "$mdUtil", "$q", "$log"];
	ThemableDirective.$inject = ["$mdTheming"];
	ThemingProvider.$inject = ["$mdColorPalette", "$$mdMetaProvider"];
	generateAllThemes.$inject = ["$injector", "$mdTheming"];
	angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
	  .directive('mdTheme', ThemingDirective)
	  .directive('mdThemable', ThemableDirective)
	  .directive('mdThemesDisabled', disableThemesDirective )
	  .provider('$mdTheming', ThemingProvider)
	  .config( detectDisabledThemes )
	  .run(generateAllThemes);
	
	/**
	 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
	 * If yes, then immediately disable all theme stylesheet generation and DOM injection
	 */
	/**
	 * @ngInject
	 */
	function detectDisabledThemes($mdThemingProvider) {
	  var isDisabled = !!document.querySelector('[md-themes-disabled]');
	  $mdThemingProvider.disableTheming(isDisabled);
	}
	
	/**
	 * @ngdoc service
	 * @name $mdThemingProvider
	 * @module material.core.theming
	 *
	 * @description Provider to configure the `$mdTheming` service.
	 *
	 * ### Default Theme
	 * The `$mdThemingProvider` uses by default the following theme configuration:
	 *
	 * - Primary Palette: `Blue`
	 * - Accent Palette: `Pink`
	 * - Warn Palette: `Deep-Orange`
	 * - Background Palette: `Grey`
	 *
	 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
	 * the default theme.<br/>
	 * This can be done by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     $mdThemingProvider
	 *       .theme('default')
	 *       .primaryPalette('blue')
	 *       .accentPalette('teal')
	 *       .warnPalette('red')
	 *       .backgroundPalette('grey');
	 *   });
	 * </hljs>
	 *
	
	 * ### Dynamic Themes
	 *
	 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
	 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable theme watching.
	 *     $mdThemingProvider.alwaysWatchTheme(true);
	 *   });
	 * </hljs>
	 *
	 * ### Custom Theme Styles
	 *
	 * Sometimes you may want to use your own theme styles for some custom components.<br/>
	 * You are able to register your own styles by using the following markup.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register our custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(STYLESHEET);
	 *   });
	 * </hljs>
	 *
	 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
	 * stylesheet file into the `$mdThemingProvider`.
	 *
	 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
	 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Register your custom stylesheet into the theming provider.
	 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
	 *   });
	 * </hljs>
	 *
	 * ### Browser color
	 *
	 * Enables browser header coloring
	 * for more info please visit:
	 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	 *
	 * Options parameter: <br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 *
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdThemingProvider) {
	 *     // Enable browser color
	 *     $mdThemingProvider.enableBrowserColor({
	 *       theme: 'myTheme', // Default is 'default'
	 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
	 *       hue: '200' // Default is '800'
	 *     });
	 *   });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#registerStyles
	 * @param {string} styles The styles to be appended to AngularJS Material's built in theme css.
	 */
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#setNonce
	 * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
	 * Setting a value allows the use of CSP policy without using the unsafe-inline directive.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#setDefaultTheme
	 * @param {string} themeName Default theme name to be applied to elements. Default value is `default`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#alwaysWatchTheme
	 * @param {boolean} watch Whether or not to always watch themes for changes and re-apply
	 * classes when they change. Default is `false`. Enabling can reduce performance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdThemingProvider#enableBrowserColor
	 * @param {Object=} options Options object for the browser color<br/>
	 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
	 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
	 * `hue`     - The hue from the selected palette. Default is `800`<br/>
	 * @returns {Function} remove function of the browser color
	 */
	
	/* Some Example Valid Theming Expressions
	 * =======================================
	 *
	 * Intention group expansion: (valid for primary, accent, warn, background)
	 *
	 * {{primary-100}} - grab shade 100 from the primary palette
	 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
	 * {{primary-100-contrast}} - grab shade 100's contrast color
	 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
	 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
	 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
	 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
	 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
	 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
	 *
	 * Foreground expansion: Applies rgba to black/white foreground text
	 *
	 * {{foreground-1}} - used for primary text
	 * {{foreground-2}} - used for secondary text/divider
	 * {{foreground-3}} - used for disabled text
	 * {{foreground-4}} - used for dividers
	 *
	 */
	
	// In memory generated CSS rules; registered by theme.name
	var GENERATED = { };
	
	// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
	var PALETTES;
	
	// Text Colors on light and dark backgrounds
	// @see https://www.google.com/design/spec/style/color.html#color-text-background-colors
	var DARK_FOREGROUND = {
	  name: 'dark',
	  '1': 'rgba(0,0,0,0.87)',
	  '2': 'rgba(0,0,0,0.54)',
	  '3': 'rgba(0,0,0,0.38)',
	  '4': 'rgba(0,0,0,0.12)'
	};
	var LIGHT_FOREGROUND = {
	  name: 'light',
	  '1': 'rgba(255,255,255,1.0)',
	  '2': 'rgba(255,255,255,0.7)',
	  '3': 'rgba(255,255,255,0.5)',
	  '4': 'rgba(255,255,255,0.12)'
	};
	
	var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
	var LIGHT_SHADOW = '';
	
	var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
	var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
	var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');
	
	var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
	var DEFAULT_COLOR_TYPE = 'primary';
	
	// A color in a theme will use these hues by default, if not specified by user.
	var LIGHT_DEFAULT_HUES = {
	  'accent': {
	    'default': 'A200',
	    'hue-1': 'A100',
	    'hue-2': 'A400',
	    'hue-3': 'A700'
	  },
	  'background': {
	    'default': '50',
	    'hue-1': 'A100',
	    'hue-2': '100',
	    'hue-3': '300'
	  }
	};
	
	var DARK_DEFAULT_HUES = {
	  'background': {
	    'default': 'A400',
	    'hue-1': '800',
	    'hue-2': '900',
	    'hue-3': 'A200'
	  }
	};
	THEME_COLOR_TYPES.forEach(function(colorType) {
	  // Color types with unspecified default hues will use these default hue values
	  var defaultDefaultHues = {
	    'default': '500',
	    'hue-1': '300',
	    'hue-2': '800',
	    'hue-3': 'A100'
	  };
	  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
	  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
	});
	
	var VALID_HUE_VALUES = [
	  '50', '100', '200', '300', '400', '500', '600',
	  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
	];
	
	var themeConfig = {
	  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
	  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
	  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
	  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
	};
	
	/**
	 *
	 */
	function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
	  ThemingService.$inject = ["$rootScope", "$mdUtil", "$q", "$log"];
	  PALETTES = { };
	  var THEMES = { };
	
	  var themingProvider;
	
	  var alwaysWatchTheme = false;
	  var defaultTheme = 'default';
	
	  // Load JS Defined Palettes
	  angular.extend(PALETTES, $mdColorPalette);
	
	  // Default theme defined in core.js
	
	  /**
	   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
	   * @param {string} color Hex value of the wanted browser color
	   * @returns {Function} Remove function of the meta tags
	   */
	  var setBrowserColor = function (color) {
	    // Chrome, Firefox OS and Opera
	    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
	    // Windows Phone
	    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);
	
	    return function () {
	      removeChrome();
	      removeWindows();
	    };
	  };
	
	  /**
	   * Enables browser header coloring
	   * for more info please visit:
	   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	   *
	   * The default color is `800` from `primary` palette of the `default` theme
	   *
	   * options are:
	   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme
	   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	   *             'accent', 'background' and 'warn'. Default is `primary`
	   * `hue`     - The hue from the selected palette. Default is `800`
	   *
	   * @param {Object=} options Options object for the browser color
	   * @returns {Function} remove function of the browser color
	   */
	  var enableBrowserColor = function (options) {
	    options = angular.isObject(options) ? options : {};
	
	    var theme = options.theme || 'default';
	    var hue = options.hue || '800';
	
	    var palette = PALETTES[options.palette] ||
	      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];
	
	    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];
	
	    return setBrowserColor(color);
	  };
	
	  return themingProvider = {
	    definePalette: definePalette,
	    extendPalette: extendPalette,
	    theme: registerTheme,
	
	    /**
	     * return a read-only clone of the current theme configuration
	     */
	    configuration : function() {
	      return angular.extend( { }, themeConfig, {
	        defaultTheme : defaultTheme,
	        alwaysWatchTheme : alwaysWatchTheme,
	        registeredStyles : [].concat(themeConfig.registeredStyles)
	      });
	    },
	
	    /**
	     * Easy way to disable theming without having to use
	     * `.constant("$MD_THEME_CSS","");` This disables
	     * all dynamic theme style sheet generations and injections...
	     */
	    disableTheming: function(isDisabled) {
	      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
	    },
	
	    registerStyles: function(styles) {
	      themeConfig.registeredStyles.push(styles);
	    },
	
	    setNonce: function(nonceValue) {
	      themeConfig.nonce = nonceValue;
	    },
	
	    generateThemesOnDemand: function(onDemand) {
	      themeConfig.generateOnDemand = onDemand;
	    },
	
	    setDefaultTheme: function(theme) {
	      defaultTheme = theme;
	    },
	
	    alwaysWatchTheme: function(alwaysWatch) {
	      alwaysWatchTheme = alwaysWatch;
	    },
	
	    enableBrowserColor: enableBrowserColor,
	
	    $get: ThemingService,
	    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
	    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
	    _PALETTES: PALETTES,
	    _THEMES: THEMES,
	    _parseRules: parseRules,
	    _rgba: rgba
	  };
	
	  // Example: $mdThemingProvider.definePalette('neonRed', { 50: '#f5fafa', ... });
	  function definePalette(name, map) {
	    map = map || {};
	    PALETTES[name] = checkPaletteValid(name, map);
	    return themingProvider;
	  }
	
	  // Returns an new object which is a copy of a given palette `name` with variables from
	  // `map` overwritten
	  // Example: var neonRedMap = $mdThemingProvider.extendPalette('red', { 50: '#f5fafafa' });
	  function extendPalette(name, map) {
	    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map) );
	  }
	
	  // Make sure that palette has all required hues
	  function checkPaletteValid(name, map) {
	    var missingColors = VALID_HUE_VALUES.filter(function(field) {
	      return !map[field];
	    });
	    if (missingColors.length) {
	      throw new Error("Missing colors %1 in palette %2!"
	                      .replace('%1', missingColors.join(', '))
	                      .replace('%2', name));
	    }
	
	    return map;
	  }
	
	  // Register a theme (which is a collection of color palettes to use with various states
	  // ie. warn, accent, primary )
	  // Optionally inherit from an existing theme
	  // $mdThemingProvider.theme('custom-theme').primaryPalette('red');
	  function registerTheme(name, inheritFrom) {
	    if (THEMES[name]) return THEMES[name];
	
	    inheritFrom = inheritFrom || 'default';
	
	    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
	    var theme = new Theme(name);
	
	    if (parentTheme) {
	      angular.forEach(parentTheme.colors, function(color, colorType) {
	        theme.colors[colorType] = {
	          name: color.name,
	          // Make sure a COPY of the hues is given to the child color,
	          // not the same reference.
	          hues: angular.extend({}, color.hues)
	        };
	      });
	    }
	    THEMES[name] = theme;
	
	    return theme;
	  }
	
	  function Theme(name) {
	    var self = this;
	    self.name = name;
	    self.colors = {};
	
	    self.dark = setDark;
	    setDark(false);
	
	    function setDark(isDark) {
	      isDark = arguments.length === 0 ? true : !!isDark;
	
	      // If no change, abort
	      if (isDark === self.isDark) return;
	
	      self.isDark = isDark;
	
	      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
	      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;
	
	      // Light and dark themes have different default hues.
	      // Go through each existing color type for this theme, and for every
	      // hue value that is still the default hue value from the previous light/dark setting,
	      // set it to the default hue value from the new light/dark setting.
	      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
	      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
	      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
	        var color = self.colors[colorType];
	        var oldDefaults = oldDefaultHues[colorType];
	        if (color) {
	          for (var hueName in color.hues) {
	            if (color.hues[hueName] === oldDefaults[hueName]) {
	              color.hues[hueName] = newDefaults[hueName];
	            }
	          }
	        }
	      });
	
	      return self;
	    }
	
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
	      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
	        var color = self.colors[colorType] = {
	          name: paletteName,
	          hues: angular.extend({}, defaultHues, hues)
	        };
	
	        Object.keys(color.hues).forEach(function(name) {
	          if (!defaultHues[name]) {
	            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
	              .replace('%1', name)
	              .replace('%2', self.name)
	              .replace('%3', paletteName)
	              .replace('%4', Object.keys(defaultHues).join(', '))
	            );
	          }
	        });
	        Object.keys(color.hues).map(function(key) {
	          return color.hues[key];
	        }).forEach(function(hueValue) {
	          if (VALID_HUE_VALUES.indexOf(hueValue) == -1) {
	            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
	              .replace('%1', hueValue)
	              .replace('%2', self.name)
	              .replace('%3', colorType)
	              .replace('%4', paletteName)
	              .replace('%5', VALID_HUE_VALUES.join(', '))
	            );
	          }
	        });
	        return self;
	      };
	
	      self[colorType + 'Color'] = function() {
	        var args = Array.prototype.slice.call(arguments);
	        console.warn('$mdThemingProviderTheme.' + colorType + 'Color() has been deprecated. ' +
	                     'Use $mdThemingProviderTheme.' + colorType + 'Palette() instead.');
	        return self[colorType + 'Palette'].apply(self, args);
	      };
	    });
	  }
	
	  /**
	   * @ngdoc service
	   * @name $mdTheming
	   * @module material.core.theming
	   *
	   * @description
	   *
	   * Service that makes an element apply theming related <b>classes</b> to itself.
	   *
	   * <hljs lang="js">
	   * app.directive('myFancyDirective', function($mdTheming) {
	   *   return {
	   *     restrict: 'e',
	   *     link: function(scope, el, attrs) {
	   *       $mdTheming(el);
	   *
	   *       $mdTheming.defineTheme('myTheme', {
	   *         primary: 'blue',
	   *         accent: 'pink',
	   *         dark: true
	   *       })
	   *     }
	   *   };
	   * });
	   * </hljs>
	   * @param {element=} element to apply theming to
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#THEMES
	   * @description
	   * Property to get all the themes defined
	   * @returns {Object} All the themes defined with their properties
	   */
	
	  /**
	   * @ngdoc property
	   * @name $mdTheming#PALETTES
	   * @description
	   * Property to get all the palettes defined
	   * @returns {Object} All the palettes defined with their colors
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#registered
	   * @description
	   * Determine is specified theme name is a valid, registered theme
	   * @param {string} themeName the theme to check if registered
	   * @returns {boolean} whether the theme is registered or not
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defaultTheme
	   * @description
	   * Returns the default theme
	   * @returns {string} The default theme
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#generateTheme
	   * @description
	   * Lazy generate themes - by default, every theme is generated when defined.
	   * You can disable this in the configuration section using the
	   * `$mdThemingProvider.generateThemesOnDemand(true);`
	   *
	   * The theme name that is passed in must match the name of the theme that was defined as part of the configuration block.
	   *
	   * @param name {string} theme name to generate
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#setBrowserColor
	   * @description
	   * Sets browser header coloring
	   * for more info please visit:
	   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
	   *
	   * The default color is `800` from `primary` palette of the `default` theme
	   *
	   * options are:<br/>
	   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme.<br/>
	   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
	   *             'accent', 'background' and 'warn'. Default is `primary`<br/>
	   * `hue`     - The hue from the selected palette. Default is `800`
	   *
	   * @param {Object} options Options object for the browser color
	   * @returns {Function} remove function of the browser color
	   */
	
	  /**
	   * @ngdoc method
	   * @name $mdTheming#defineTheme
	   * @description
	   * Dynamically define a theme by an options object
	   *
	   * options are:<br/>
	   * `primary`    - The primary palette of the theme.<br/>
	   * `accent`     - The accent palette of the theme.<br/>
	   * `warn`       - The warn palette of the theme.<br/>
	   * `background` - The background palette of the theme.<br/>
	   * `dark`       - Indicates if it's a dark theme.<br/>
	   *
	   * @param {String} name Theme name to define
	   * @param {Object} options Theme definition options
	   * @returns {Promise<string>} A resolved promise with the theme name
	   */
	
	  /* @ngInject */
	  function ThemingService($rootScope, $mdUtil, $q, $log) {
	        // Allow us to be invoked via a linking function signature.
	    var applyTheme = function (scope, el) {
	          if (el === undefined) { el = scope; scope = undefined; }
	          if (scope === undefined) { scope = $rootScope; }
	          applyTheme.inherit(el, el);
	        };
	
	    Object.defineProperty(applyTheme, 'THEMES', {
	      get: function () {
	        return angular.extend({}, THEMES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'PALETTES', {
	      get: function () {
	        return angular.extend({}, PALETTES);
	      }
	    });
	    Object.defineProperty(applyTheme, 'ALWAYS_WATCH', {
	      get: function () {
	        return alwaysWatchTheme;
	      }
	    });
	    applyTheme.inherit = inheritTheme;
	    applyTheme.registered = registered;
	    applyTheme.defaultTheme = function() { return defaultTheme; };
	    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
	    applyTheme.defineTheme = function(name, options) {
	      options = options || {};
	
	      var theme = registerTheme(name);
	
	      if (options.primary) {
	        theme.primaryPalette(options.primary);
	      }
	      if (options.accent) {
	        theme.accentPalette(options.accent);
	      }
	      if (options.warn) {
	        theme.warnPalette(options.warn);
	      }
	      if (options.background) {
	        theme.backgroundPalette(options.background);
	      }
	      if (options.dark){
	        theme.dark();
	      }
	
	      this.generateTheme(name);
	
	      return $q.resolve(name);
	    };
	    applyTheme.setBrowserColor = enableBrowserColor;
	
	    return applyTheme;
	
	    /**
	     * Determine is specified theme name is a valid, registered theme
	     */
	    function registered(themeName) {
	      if (themeName === undefined || themeName === '') return true;
	      return applyTheme.THEMES[themeName] !== undefined;
	    }
	
	    /**
	     * Get theme name for the element, then update with Theme CSS class
	     */
	    function inheritTheme (el, parent) {
	      var ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');
	
	      updateThemeClass(lookupThemeName());
	
	      if (ctrl) {
	        var watchTheme = alwaysWatchTheme ||
	                         ctrl.$shouldWatch ||
	                         $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));
	
	        var unwatch = ctrl.registerChanges(function (name) {
	          updateThemeClass(name);
	
	          if (!watchTheme) {
	            unwatch();
	          }
	          else {
	            el.on('$destroy', unwatch);
	          }
	        });
	      }
	
	      /**
	       * Find the theme name from the parent controller or element data
	       */
	      function lookupThemeName() {
	        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
	        return ctrl && ctrl.$mdTheme || (defaultTheme == 'default' ? '' : defaultTheme);
	      }
	
	      /**
	       * Remove old theme class and apply a new one
	       * NOTE: if not a valid theme name, then the current name is not changed
	       */
	      function updateThemeClass(theme) {
	        if (!theme) return;
	        if (!registered(theme)) {
	          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
	                    'Register it with $mdThemingProvider.theme().');
	        }
	
	        var oldTheme = el.data('$mdThemeName');
	        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
	        el.addClass('md-' + theme + '-theme');
	        el.data('$mdThemeName', theme);
	        if (ctrl) {
	          el.data('$mdThemeController', ctrl);
	        }
	      }
	    }
	
	  }
	}
	
	function ThemingDirective($mdTheming, $interpolate, $parse, $mdUtil, $q, $log) {
	  return {
	    priority: 101, // has to be more than 100 to be before interpolation (issue on IE)
	    link: {
	      pre: function(scope, el, attrs) {
	        var registeredCallbacks = [];
	
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	
	        var theme = attrs.mdTheme.trim();
	
	        var hasInterpolation =
	          theme.substr(0, startSymbol.length) === startSymbol &&
	          theme.lastIndexOf(endSymbol) === theme.length - endSymbol.length;
	
	        var oneTimeOperator = '::';
	        var oneTimeBind = attrs.mdTheme
	            .split(startSymbol).join('')
	            .split(endSymbol).join('')
	            .trim()
	            .substr(0, oneTimeOperator.length) === oneTimeOperator;
	
	        var ctrl = {
	          registerChanges: function (cb, context) {
	            if (context) {
	              cb = angular.bind(context, cb);
	            }
	
	            registeredCallbacks.push(cb);
	
	            return function () {
	              var index = registeredCallbacks.indexOf(cb);
	
	              if (index > -1) {
	                registeredCallbacks.splice(index, 1);
	              }
	            };
	          },
	          $setTheme: function (theme) {
	            if (!$mdTheming.registered(theme)) {
	              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
	            }
	
	            ctrl.$mdTheme = theme;
	
	            // Iterating backwards to support unregistering during iteration
	            // http://stackoverflow.com/a/9882349/890293
	            // we don't use `reverse()` of array because it mutates the array and we don't want it to get re-indexed
	            for (var i = registeredCallbacks.length; i--;) {
	              registeredCallbacks[i](theme);
	            }
	          },
	          $shouldWatch: $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch')) ||
	                        $mdTheming.ALWAYS_WATCH ||
	                        (hasInterpolation && !oneTimeBind)
	        };
	
	        el.data('$mdThemeController', ctrl);
	
	        var getTheme = function () {
	          var interpolation = $interpolate(attrs.mdTheme)(scope);
	          return $parse(interpolation)(scope) || interpolation;
	        };
	
	        var setParsedTheme = function (theme) {
	          if (typeof theme === 'string') {
	            return ctrl.$setTheme(theme);
	          }
	
	          $q.when( angular.isFunction(theme) ?  theme() : theme )
	            .then(function(name){
	              ctrl.$setTheme(name);
	            });
	        };
	
	        setParsedTheme(getTheme());
	
	        var unwatch = scope.$watch(getTheme, function(theme) {
	          if (theme) {
	            setParsedTheme(theme);
	
	            if (!ctrl.$shouldWatch) {
	              unwatch();
	            }
	          }
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Special directive that will disable ALL runtime Theme style generation and DOM injection
	 *
	 * <link rel="stylesheet" href="angular-material.min.css">
	 * <link rel="stylesheet" href="angular-material.themes.css">
	 *
	 * <body md-themes-disabled>
	 *  ...
	 * </body>
	 *
	 * Note: Using md-themes-css directive requires the developer to load external
	 * theme stylesheets; e.g. custom themes from Material-Tools:
	 *
	 *       `angular-material.themes.css`
	 *
	 * Another option is to use the ThemingProvider to configure and disable the attribute
	 * conversions; this would obviate the use of the `md-themes-css` directive
	 *
	 */
	function disableThemesDirective() {
	  themeConfig.disableTheming = true;
	
	  // Return a 1x-only, first-match attribute directive
	  return {
	    restrict : 'A',
	    priority : '900'
	  };
	}
	
	function ThemableDirective($mdTheming) {
	  return $mdTheming;
	}
	
	function parseRules(theme, colorType, rules) {
	  checkValidPalette(theme, colorType);
	
	  rules = rules.replace(/THEME_NAME/g, theme.name);
	  var generatedRules = [];
	  var color = theme.colors[colorType];
	
	  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
	  // Matches '{{ primary-color }}', etc
	  var hueRegex = new RegExp('(\'|")?{{\\s*(' + colorType + ')-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}(\"|\')?','g');
	  var simpleVariableRegex = /'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue\-[0-3]|shadow|default)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;
	  var palette = PALETTES[color.name];
	
	  // find and replace simple variables where we use a specific hue, not an entire palette
	  // eg. "{{primary-100}}"
	  //\(' + THEME_COLOR_TYPES.join('\|') + '\)'
	  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, opacity, contrast) {
	    if (colorType === 'foreground') {
	      if (hue == 'shadow') {
	        return theme.foregroundShadow;
	      } else {
	        return theme.foregroundPalette[hue] || theme.foregroundPalette['1'];
	      }
	    }
	
	    // `default` is also accepted as a hue-value, because the background palettes are
	    // using it as a name for the default hue.
	    if (hue.indexOf('hue') === 0 || hue === 'default') {
	      hue = theme.colors[colorType].hues[hue];
	    }
	
	    return rgba( (PALETTES[ theme.colors[colorType].name ][hue] || '')[contrast ? 'contrast' : 'value'], opacity );
	  });
	
	  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
	  angular.forEach(color.hues, function(hueValue, hueName) {
	    var newRule = rules
	      .replace(hueRegex, function(match, _, colorType, hueType, opacity) {
	        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
	      });
	    if (hueName !== 'default') {
	      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
	    }
	
	    // Don't apply a selector rule to the default theme, making it easier to override
	    // styles of the base-component
	    if (theme.name == 'default') {
	      var themeRuleRegex = /((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;
	
	      newRule = newRule.replace(themeRuleRegex, function(match, start, end) {
	        return match + ', ' + start + end;
	      });
	    }
	    generatedRules.push(newRule);
	  });
	
	  return generatedRules;
	}
	
	var rulesByType = {};
	
	// Generate our themes at run time given the state of THEMES and PALETTES
	function generateAllThemes($injector, $mdTheming) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';
	
	  // Append our custom registered styles to the theme stylesheet.
	  themeCss += themeConfig.registeredStyles.join('');
	
	  if ( !firstChild ) return;
	  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task
	
	  // Expose contrast colors for palettes to ensure that text is always readable
	  angular.forEach(PALETTES, sanitizePalette);
	
	  // MD_THEME_CSS is a string generated by the build process that includes all the themable
	  // components as templates
	
	  // Break the CSS into individual rules
	  var rules = themeCss
	                  .split(/\}(?!(\}|'|"|;))/)
	                  .filter(function(rule) { return rule && rule.trim().length; })
	                  .map(function(rule) { return rule.trim() + '}'; });
	
	
	  var ruleMatchRegex = new RegExp('md-(' + THEME_COLOR_TYPES.join('|') + ')', 'g');
	
	  THEME_COLOR_TYPES.forEach(function(type) {
	    rulesByType[type] = '';
	  });
	
	
	  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
	  rules.forEach(function(rule) {
	    var match = rule.match(ruleMatchRegex);
	    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
	    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf('.md-' + type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
	    // there
	    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
	      if (rule.indexOf(type) > -1) {
	        return rulesByType[type] += rule;
	      }
	    }
	
	    // Default to the primary array
	    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
	  });
	
	  // If themes are being generated on-demand, quit here. The user will later manually
	  // call generateTheme to do this on a theme-by-theme basis.
	  if (themeConfig.generateOnDemand) return;
	
	  angular.forEach($mdTheming.THEMES, function(theme) {
	    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
	      generateTheme(theme, theme.name, themeConfig.nonce);
	    }
	  });
	
	
	  // *************************
	  // Internal functions
	  // *************************
	
	  // The user specifies a 'default' contrast color as either light or dark,
	  // then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
	  function sanitizePalette(palette, name) {
	    var defaultContrast = palette.contrastDefaultColor;
	    var lightColors = palette.contrastLightColors || [];
	    var strongLightColors = palette.contrastStrongLightColors || [];
	    var darkColors = palette.contrastDarkColors || [];
	
	    // These colors are provided as space-separated lists
	    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
	    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
	    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');
	
	    // Cleanup after ourselves
	    delete palette.contrastDefaultColor;
	    delete palette.contrastLightColors;
	    delete palette.contrastStrongLightColors;
	    delete palette.contrastDarkColors;
	
	    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
	    angular.forEach(palette, function(hueValue, hueName) {
	      if (angular.isObject(hueValue)) return; // Already converted
	      // Map everything to rgb colors
	      var rgbValue = colorToRgbaArray(hueValue);
	      if (!rgbValue) {
	        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
	                        .replace('%1', hueValue)
	                        .replace('%2', palette.name)
	                        .replace('%3', hueName));
	      }
	
	      palette[hueName] = {
	        hex: palette[hueName],
	        value: rgbValue,
	        contrast: getContrastColor()
	      };
	      function getContrastColor() {
	        if (defaultContrast === 'light') {
	          if (darkColors.indexOf(hueName) > -1) {
	            return DARK_CONTRAST_COLOR;
	          } else {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          }
	        } else {
	          if (lightColors.indexOf(hueName) > -1) {
	            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
	              : LIGHT_CONTRAST_COLOR;
	          } else {
	            return DARK_CONTRAST_COLOR;
	          }
	        }
	      }
	    });
	  }
	}
	
	function generateTheme(theme, name, nonce) {
	  var head = document.head;
	  var firstChild = head ? head.firstElementChild : null;
	
	  if (!GENERATED[name]) {
	    // For each theme, use the color palettes specified for
	    // `primary`, `warn` and `accent` to generate CSS rules.
	    THEME_COLOR_TYPES.forEach(function(colorType) {
	      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
	      while (styleStrings.length) {
	        var styleContent = styleStrings.shift();
	        if (styleContent) {
	          var style = document.createElement('style');
	          style.setAttribute('md-theme-style', '');
	          if (nonce) {
	            style.setAttribute('nonce', nonce);
	          }
	          style.appendChild(document.createTextNode(styleContent));
	          head.insertBefore(style, firstChild);
	        }
	      }
	    });
	
	    GENERATED[theme.name] = true;
	  }
	
	}
	
	
	function checkValidPalette(theme, colorType) {
	  // If theme attempts to use a palette that doesnt exist, throw error
	  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
	    throw new Error(
	      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
	                    .replace('%1', theme.name)
	                    .replace('%2', colorType)
	                    .replace('%3', Object.keys(PALETTES).join(', '))
	    );
	  }
	}
	
	function colorToRgbaArray(clr) {
	  if (angular.isArray(clr) && clr.length == 3) return clr;
	  if (/^rgb/.test(clr)) {
	    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
	      return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
	    });
	  }
	  if (clr.charAt(0) == '#') clr = clr.substring(1);
	  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;
	
	  var dig = clr.length / 3;
	  var red = clr.substr(0, dig);
	  var grn = clr.substr(dig, dig);
	  var blu = clr.substr(dig * 2);
	  if (dig === 1) {
	    red += red;
	    grn += grn;
	    blu += blu;
	  }
	  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
	}
	
	function rgba(rgbArray, opacity) {
	  if ( !rgbArray ) return "rgb('0,0,0')";
	
	  if (rgbArray.length == 4) {
	    rgbArray = angular.copy(rgbArray);
	    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
	  }
	  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
	    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
	    'rgb(' + rgbArray.join(',') + ')';
	}
	
	
	})(window.angular);
	
	})();
	(function(){
	"use strict";
	
	// Polyfill angular < 1.4 (provide $animateCss)
	angular
	  .module('material.core')
	  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss){
	
	     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
	     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils
	
	     return function($mdUtil) {
	       return AnimateDomUtils( $mdUtil, $q, $timeout, $mdConstant, $animateCss);
	     };
	   }]);
	
	/**
	 * Factory function that requires special injections
	 */
	function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
	  var self;
	  return self = {
	    /**
	     *
	     */
	    translate3d : function( target, from, to, options ) {
	      return $animateCss(target, {
	        from: from,
	        to: to,
	        addClass: options.transitionInClass,
	        removeClass: options.transitionOutClass,
	        duration: options.duration
	      })
	      .start()
	      .then(function(){
	          // Resolve with reverser function...
	          return reverseTranslate;
	      });
	
	      /**
	       * Specific reversal of the request translate animation above...
	       */
	      function reverseTranslate (newFrom) {
	        return $animateCss(target, {
	           to: newFrom || from,
	           addClass: options.transitionOutClass,
	           removeClass: options.transitionInClass,
	           duration: options.duration
	        }).start();
	
	      }
	    },
	
	    /**
	     * Listen for transitionEnd event (with optional timeout)
	     * Announce completion or failure via promise handlers
	     */
	    waitTransitionEnd: function (element, opts) {
	      var TIMEOUT = 3000; // fallback is 3 secs
	
	      return $q(function(resolve, reject){
	        opts = opts || { };
	
	        // If there is no transition is found, resolve immediately
	        //
	        // NOTE: using $mdUtil.nextTick() causes delays/issues
	        if (noTransitionFound(opts.cachedTransitionStyles)) {
	          TIMEOUT = 0;
	        }
	
	        var timer = $timeout(finished, opts.timeout || TIMEOUT);
	        element.on($mdConstant.CSS.TRANSITIONEND, finished);
	
	        /**
	         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
	         * NOTE: Make sure this transitionEnd didn't bubble up from a child
	         */
	        function finished(ev) {
	          if ( ev && ev.target !== element[0]) return;
	
	          if ( ev  ) $timeout.cancel(timer);
	          element.off($mdConstant.CSS.TRANSITIONEND, finished);
	
	          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
	          resolve();
	
	        }
	
	        /**
	         * Checks whether or not there is a transition.
	         *
	         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
	         * will be used.
	         *
	         * @returns {boolean} True if there is no transition/duration; false otherwise.
	         */
	        function noTransitionFound(styles) {
	          styles = styles || window.getComputedStyle(element[0]);
	
	          return styles.transitionDuration == '0s' || (!styles.transition && !styles.transitionProperty);
	        }
	
	      });
	    },
	
	    calculateTransformValues: function (element, originator) {
	      var origin = originator.element;
	      var bounds = originator.bounds;
	
	      if (origin || bounds) {
	        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
	        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
	        var dialogCenterPt = self.centerPointFor(dialogRect);
	        var originCenterPt = self.centerPointFor(originBnds);
	
	        return {
	          centerX: originCenterPt.x - dialogCenterPt.x,
	          centerY: originCenterPt.y - dialogCenterPt.y,
	          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
	          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
	        };
	      }
	      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};
	
	      /**
	       * This is a fallback if the origin information is no longer valid, then the
	       * origin bounds simply becomes the current bounds for the dialogContainer's parent
	       */
	      function currentBounds() {
	        var cntr = element ? element.parent() : null;
	        var parent = cntr ? cntr.parent() : null;
	
	        return parent ? self.clientRect(parent) : null;
	      }
	    },
	
	    /**
	     * Calculate the zoom transform from dialog to origin.
	     *
	     * We use this to set the dialog position immediately;
	     * then the md-transition-in actually translates back to
	     * `translate3d(0,0,0) scale(1.0)`...
	     *
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateZoomToOrigin: function (element, originator) {
	      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
	      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);
	
	      return buildZoom(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Calculate the slide transform from panel to origin.
	     * NOTE: all values are rounded to the nearest integer
	     */
	    calculateSlideToOrigin: function (element, originator) {
	      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
	      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);
	
	      return buildSlide(self.calculateTransformValues(element, originator));
	    },
	
	    /**
	     * Enhance raw values to represent valid css stylings...
	     */
	    toCss : function( raw ) {
	      var css = { };
	      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';
	
	      angular.forEach(raw, function(value,key) {
	        if ( angular.isUndefined(value) ) return;
	
	        if ( lookups.indexOf(key) >= 0 ) {
	          css[key] = value + 'px';
	        } else {
	          switch (key) {
	            case 'transition':
	              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
	              break;
	            case 'transform':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
	              break;
	            case 'transformOrigin':
	              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
	              break;
	            case 'font-size':
	              css['font-size'] = value; // font sizes aren't always in px
	              break;
	          }
	        }
	      });
	
	      return css;
	
	      function convertToVendor(key, vendor, value) {
	        angular.forEach(vendor.split(' '), function (key) {
	          css[key] = value;
	        });
	      }
	    },
	
	    /**
	     * Convert the translate CSS value to key/value pair(s).
	     */
	    toTransformCss: function (transform, addTransition, transition) {
	      var css = {};
	      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
	        css[key] = transform;
	      });
	
	      if (addTransition) {
	        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
	        css.transition = transition;
	      }
	
	      return css;
	    },
	
	    /**
	     *  Clone the Rect and calculate the height/width if needed
	     */
	    copyRect: function (source, destination) {
	      if (!source) return null;
	
	      destination = destination || {};
	
	      angular.forEach('left top right bottom width height'.split(' '), function (key) {
	        destination[key] = Math.round(source[key]);
	      });
	
	      destination.width = destination.width || (destination.right - destination.left);
	      destination.height = destination.height || (destination.bottom - destination.top);
	
	      return destination;
	    },
	
	    /**
	     * Calculate ClientRect of element; return null if hidden or zero size
	     */
	    clientRect: function (element) {
	      var bounds = angular.element(element)[0].getBoundingClientRect();
	      var isPositiveSizeClientRect = function (rect) {
	        return rect && (rect.width > 0) && (rect.height > 0);
	      };
	
	      // If the event origin element has zero size, it has probably been hidden.
	      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
	    },
	
	    /**
	     *  Calculate 'rounded' center point of Rect
	     */
	    centerPointFor: function (targetRect) {
	      return targetRect ? {
	        x: Math.round(targetRect.left + (targetRect.width / 2)),
	        y: Math.round(targetRect.top + (targetRect.height / 2))
	      } : { x : 0, y : 0 };
	    }
	
	  };
	}
	
	
	})();
	(function(){
	"use strict";
	
	if (angular.version.minor >= 4) {
	  angular.module('material.core.animate', []);
	} else {
	(function() {
	  "use strict";
	
	  var forEach = angular.forEach;
	
	  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
	  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
	  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
	  var PREFIX = WEBKIT ? '-webkit-' : '';
	
	  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
	  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';
	
	  var $$ForceReflowFactory = ['$document', function($document) {
	    return function() {
	      return $document[0].body.clientWidth + 1;
	    };
	  }];
	
	  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
	    return function() {
	      var passed = false;
	      $$rAF(function() {
	        passed = true;
	      });
	      return function(fn) {
	        passed ? fn() : $$rAF(fn);
	      };
	    };
	  }];
	
	  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      this._doneCallbacks = [];
	      this._runInAnimationFrame = $$rAFMutex();
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: angular.noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._runInAnimationFrame(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    // Polyfill AnimateRunner.all which is used by input animations
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	
	  angular
	    .module('material.core.animate', [])
	    .factory('$$forceReflow', $$ForceReflowFactory)
	    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
	    .factory('$$rAFMutex', $$rAFMutexFactory)
	    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
	                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {
	
	      function init(element, options) {
	
	        var temporaryStyles = [];
	        var node = getDomNode(element);
	        var areAnimationsAllowed = node && $animate.enabled();
	
	        var hasCompleteStyles = false;
	        var hasCompleteClasses = false;
	
	        if (areAnimationsAllowed) {
	          if (options.transitionStyle) {
	            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
	          }
	
	          if (options.keyframeStyle) {
	            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
	          }
	
	          if (options.delay) {
	            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
	          }
	
	          if (options.duration) {
	            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
	          }
	
	          hasCompleteStyles = options.keyframeStyle ||
	              (options.to && (options.duration > 0 || options.transitionStyle));
	          hasCompleteClasses = !!options.addClass || !!options.removeClass;
	
	          blockTransition(element, true);
	        }
	
	        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);
	
	        applyAnimationFromStyles(element, options);
	
	        var animationClosed = false;
	        var events, eventFn;
	
	        return {
	          close: $window.close,
	          start: function() {
	            var runner = new $$AnimateRunner();
	            waitUntilQuiet(function() {
	              blockTransition(element, false);
	              if (!hasCompleteAnimation) {
	                return close();
	              }
	
	              forEach(temporaryStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	              });
	
	              applyClasses(element, options);
	
	              var timings = computeTimings(element);
	              if (timings.duration === 0) {
	                return close();
	              }
	
	              var moreStyles = [];
	
	              if (options.easing) {
	                if (timings.transitionDuration) {
	                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
	                }
	                if (timings.animationDuration) {
	                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
	                }
	              }
	
	              if (options.delay && timings.animationDelay) {
	                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
	              }
	
	              if (options.duration && timings.animationDuration) {
	                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
	              }
	
	              forEach(moreStyles, function(entry) {
	                var key = entry[0];
	                var value = entry[1];
	                node.style[camelCase(key)] = value;
	                temporaryStyles.push(entry);
	              });
	
	              var maxDelay = timings.delay;
	              var maxDelayTime = maxDelay * 1000;
	              var maxDuration = timings.duration;
	              var maxDurationTime = maxDuration * 1000;
	              var startTime = Date.now();
	
	              events = [];
	              if (timings.transitionDuration) {
	                events.push(TRANSITION_EVENTS);
	              }
	              if (timings.animationDuration) {
	                events.push(ANIMATION_EVENTS);
	              }
	              events = events.join(' ');
	              eventFn = function(event) {
	                event.stopPropagation();
	                var ev = event.originalEvent || event;
	                var timeStamp = ev.timeStamp || Date.now();
	                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
	                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	                  close();
	                }
	              };
	              element.on(events, eventFn);
	
	              applyAnimationToStyles(element, options);
	
	              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
	            });
	
	            return runner;
	
	            function close() {
	              if (animationClosed) return;
	              animationClosed = true;
	
	              if (events && eventFn) {
	                element.off(events, eventFn);
	              }
	              applyClasses(element, options);
	              applyAnimationStyles(element, options);
	              forEach(temporaryStyles, function(entry) {
	                node.style[camelCase(entry[0])] = '';
	              });
	              runner.complete(true);
	              return runner;
	            }
	          }
	        };
	      }
	
	      function applyClasses(element, options) {
	        if (options.addClass) {
	          $$jqLite.addClass(element, options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          $$jqLite.removeClass(element, options.removeClass);
	          options.removeClass = null;
	        }
	      }
	
	      function computeTimings(element) {
	        var node = getDomNode(element);
	        var cs = $window.getComputedStyle(node);
	        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
	        var adr = parseMaxTime(cs[prop('animationDuration')]);
	        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
	        var ady = parseMaxTime(cs[prop('animationDelay')]);
	
	        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
	        var duration = Math.max(adr, tdr);
	        var delay = Math.max(ady, tdy);
	
	        return {
	          duration: duration,
	          delay: delay,
	          animationDuration: adr,
	          transitionDuration: tdr,
	          animationDelay: ady,
	          transitionDelay: tdy
	        };
	
	        function prop(key) {
	          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
	                        : key;
	        }
	      }
	
	      function parseMaxTime(str) {
	        var maxValue = 0;
	        var values = (str || "").split(/\s*,\s*/);
	        forEach(values, function(value) {
	          // it's always safe to consider only second values and omit `ms` values since
	          // getComputedStyle will always handle the conversion for us
	          if (value.charAt(value.length - 1) == 's') {
	            value = value.substring(0, value.length - 1);
	          }
	          value = parseFloat(value) || 0;
	          maxValue = maxValue ? Math.max(value, maxValue) : value;
	        });
	        return maxValue;
	      }
	
	      var cancelLastRAFRequest;
	      var rafWaitQueue = [];
	      function waitUntilQuiet(callback) {
	        if (cancelLastRAFRequest) {
	          cancelLastRAFRequest(); //cancels the request
	        }
	        rafWaitQueue.push(callback);
	        cancelLastRAFRequest = $$rAF(function() {
	          cancelLastRAFRequest = null;
	
	          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	          var pageWidth = $$forceReflow();
	
	          // we use a for loop to ensure that if the queue is changed
	          // during this looping then it will consider new requests
	          for (var i = 0; i < rafWaitQueue.length; i++) {
	            rafWaitQueue[i](pageWidth);
	          }
	          rafWaitQueue.length = 0;
	        });
	      }
	
	      function applyAnimationStyles(element, options) {
	        applyAnimationFromStyles(element, options);
	        applyAnimationToStyles(element, options);
	      }
	
	      function applyAnimationFromStyles(element, options) {
	        if (options.from) {
	          element.css(options.from);
	          options.from = null;
	        }
	      }
	
	      function applyAnimationToStyles(element, options) {
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	
	      function getDomNode(element) {
	        for (var i = 0; i < element.length; i++) {
	          if (element[i].nodeType === 1) return element[i];
	        }
	      }
	
	      function blockTransition(element, bool) {
	        var node = getDomNode(element);
	        var key = camelCase(PREFIX + 'transition-delay');
	        node.style[key] = bool ? '-9999s' : '';
	      }
	
	      return init;
	    }]);
	
	  /**
	   * Older browsers [FF31] expect camelCase
	   * property keys.
	   * e.g.
	   *  animation-duration --> animationDuration
	   */
	  function camelCase(str) {
	    return str.replace(/-[a-z]/g, function(str) {
	      return str.charAt(1).toUpperCase();
	    });
	  }
	
	})();
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.autocomplete
	 */
	/*
	 * @see js folder for autocomplete implementation
	 */
	angular.module('material.components.autocomplete', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	/*
	 * @ngdoc module
	 * @name material.components.backdrop
	 * @description Backdrop
	 */
	
	/**
	 * @ngdoc directive
	 * @name mdBackdrop
	 * @module material.components.backdrop
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
	 * Apply class `opaque` to make the backdrop use the theme backdrop color.
	 *
	 */
	
	angular
	  .module('material.components.backdrop', ['material.core'])
	  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
	    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';
	
	    return {
	      restrict: 'E',
	      link: postLink
	    };
	
	    function postLink(scope, element, attrs) {
	      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
	      if ($animate.pin) $animate.pin(element, $rootElement);
	
	      var bodyStyles;
	
	      $$rAF(function() {
	        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
	        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
	        // Note that this can be pretty expensive and is better done inside the $$rAF.
	        bodyStyles = $window.getComputedStyle($document[0].body);
	
	        if (bodyStyles.position === 'fixed') {
	          var resizeHandler = $mdUtil.debounce(function(){
	            bodyStyles = $window.getComputedStyle($document[0].body);
	            resize();
	          }, 60, null, false);
	
	          resize();
	          angular.element($window).on('resize', resizeHandler);
	
	          scope.$on('$destroy', function() {
	            angular.element($window).off('resize', resizeHandler);
	          });
	        }
	
	        // Often $animate.enter() is used to append the backDrop element
	        // so let's wait until $animate is done...
	        var parent = element.parent();
	
	        if (parent.length) {
	          if (parent[0].nodeName === 'BODY') {
	            element.css('position', 'fixed');
	          }
	
	          var styles = $window.getComputedStyle(parent[0]);
	
	          if (styles.position === 'static') {
	            // backdrop uses position:absolute and will not work properly with parent position:static (default)
	            $log.warn(ERROR_CSS_POSITION);
	          }
	
	          // Only inherit the parent if the backdrop has a parent.
	          $mdTheming.inherit(element, parent);
	        }
	      });
	
	      function resize() {
	        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
	        element.css('height', viewportHeight + 'px');
	      }
	    }
	
	  }]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.bottomSheet
	 * @description
	 * BottomSheet
	 */
	MdBottomSheetDirective.$inject = ["$mdBottomSheet"];
	MdBottomSheetProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.bottomSheet', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdBottomSheet', MdBottomSheetDirective)
	  .provider('$mdBottomSheet', MdBottomSheetProvider);
	
	/* @ngInject */
	function MdBottomSheetDirective($mdBottomSheet) {
	  return {
	    restrict: 'E',
	    link : function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdBottomSheet.destroy();
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $mdBottomSheet
	 * @module material.components.bottomSheet
	 *
	 * @description
	 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
	 *
	 * ## Restrictions
	 *
	 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
	 * - Add the `md-grid` class to the bottom sheet for a grid layout.
	 * - Add the `md-list` class to the bottom sheet for a list layout.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div ng-controller="MyController">
	 *   <md-button ng-click="openBottomSheet()">
	 *     Open a Bottom Sheet!
	 *   </md-button>
	 * </div>
	 * </hljs>
	 * <hljs lang="js">
	 * var app = angular.module('app', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdBottomSheet) {
	 *   $scope.openBottomSheet = function() {
	 *     $mdBottomSheet.show({
	 *       template: '<md-bottom-sheet>' +
	 *       'Hello! <md-button ng-click="closeBottomSheet()">Close</md-button>' +
	 *       '</md-bottom-sheet>'
	 *     })
	 *
	 *     // Fires when the hide() method is used
	 *     .then(function() {
	 *       console.log('You clicked the button to close the bottom sheet!');
	 *     })
	 *
	 *     // Fires when the cancel() method is used
	 *     .catch(function() {
	 *       console.log('You hit escape or clicked the backdrop to close.');
	 *     });
	 *   };
	 *
	 *   $scope.closeBottomSheet = function($scope, $mdBottomSheet) {
	 *     $mdBottomSheet.hide();
	 *   }
	 *
	 * });
	 * </hljs>
	 */
	
	 /**
	 * @ngdoc method
	 * @name $mdBottomSheet#show
	 *
	 * @description
	 * Show a bottom sheet with the specified options.
	 *
	 * <em><b>Note:</b> You should <b>always</b> provide a `.catch()` method in case the user hits the
	 * `esc` key or clicks the background to close. In this case, the `cancel()` method will
	 * automatically be called on the bottom sheet which will `reject()` the promise. See the @usage
	 * section above for an example.
	 *
	 * Newer versions of Angular will throw a `Possibly unhandled rejection` exception if you forget
	 * this.</em>
	 *
	 * @param {object} options An options object, with the following properties:
	 *
	 *   - `templateUrl` - `{string=}`: The url of an html template file that will
	 *   be used as the content of the bottom sheet. Restrictions: the template must
	 *   have an outer `md-bottom-sheet` element.
	 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	 *   template string.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	 *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
	 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	 *   be used as names of values to inject into the controller. For example,
	 *   `locals: {three: 3}` would inject `three` into the controller with the value
	 *   of 3.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
	 *     close it. Default true.
	 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the controller instance.
	 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
	 *     Default true.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	 *   and the bottom sheet will not open until the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
	 *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
	 *   e.g. angular.element(document.getElementById('content')) or "#content"
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
	 *     Default true.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
	 * rejected with `$mdBottomSheet.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#hide
	 *
	 * @description
	 * Hide the existing bottom sheet and resolve the promise returned from
	 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottomsheet (if
	 * any).
	 *
	 * <em><b>Note:</b> Use a `.then()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdBottomSheet#cancel
	 *
	 * @description
	 * Hide the existing bottom sheet and reject the promise returned from
	 * `$mdBottomSheet.show()`.
	 *
	 * <em><b>Note:</b> Use a `.catch()` on your `.show()` to handle this callback.</em>
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 */
	
	function MdBottomSheetProvider($$interimElementProvider) {
	  // how fast we need to flick down to close the sheet, pixels/ms
	  bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
	  var CLOSING_VELOCITY = 0.5;
	  var PADDING = 80; // same as css
	
	  return $$interimElementProvider('$mdBottomSheet')
	    .setDefaults({
	      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
	      options: bottomSheetDefaults
	    });
	
	  /* @ngInject */
	  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
	                               $mdGesture, $log) {
	    var backdrop;
	
	    return {
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      disableBackdrop: false,
	      escapeToClose: true,
	      clickOutsideToClose: true,
	      disableParentScroll: true
	    };
	
	
	    function onShow(scope, element, options, controller) {
	
	      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');
	
	      // prevent tab focus or click focus on the bottom-sheet container
	      element.attr('tabindex',"-1");
	
	      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (element.hasClass('ng-cloak')) {
	        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak >` will affect the bottom-sheet opening animations.';
	        $log.warn( message, element[0] );
	      }
	
	      if (!options.disableBackdrop) {
	        // Add a backdrop that will close on click
	        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");
	
	        // Prevent mouse focus on backdrop; ONLY programatic focus allowed.
	        // This allows clicks on backdrop to propogate to the $rootElement and
	        // ESC key events to be detected properly.
	        
	        backdrop[0].tabIndex = -1;
	
	        if (options.clickOutsideToClose) {
	          backdrop.on('click', function() {
	            $mdUtil.nextTick($mdBottomSheet.cancel,true);
	          });
	        }
	
	        $mdTheming.inherit(backdrop, options.parent);
	
	        $animate.enter(backdrop, options.parent, null);
	      }
	
	      var bottomSheet = new BottomSheet(element, options.parent);
	      options.bottomSheet = bottomSheet;
	
	      $mdTheming.inherit(bottomSheet.element, options.parent);
	
	      if (options.disableParentScroll) {
	        options.restoreScroll = $mdUtil.disableScrollAround(bottomSheet.element, options.parent);
	      }
	
	      return $animate.enter(bottomSheet.element, options.parent, backdrop)
	        .then(function() {
	          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
	            element[0].querySelector('button') ||
	            element[0].querySelector('a') ||
	            element[0].querySelector($mdUtil.prefixer('ng-click', true))
	          ) || backdrop;
	
	          if (options.escapeToClose) {
	            options.rootElementKeyupCallback = function(e) {
	              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	                $mdUtil.nextTick($mdBottomSheet.cancel,true);
	              }
	            };
	
	            $rootElement.on('keyup', options.rootElementKeyupCallback);
	            focusable && focusable.focus();
	          }
	        });
	
	    }
	
	    function onRemove(scope, element, options) {
	
	      var bottomSheet = options.bottomSheet;
	
	      if (!options.disableBackdrop) $animate.leave(backdrop);
	      return $animate.leave(bottomSheet.element).then(function() {
	        if (options.disableParentScroll) {
	          options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        bottomSheet.cleanup();
	      });
	    }
	
	    /**
	     * BottomSheet class to apply bottom-sheet behavior to an element
	     */
	    function BottomSheet(element, parent) {
	      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
	      parent.on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      return {
	        element: element,
	        cleanup: function cleanup() {
	          deregister();
	          parent.off('$md.dragstart', onDragStart);
	          parent.off('$md.drag', onDrag);
	          parent.off('$md.dragend', onDragEnd);
	        }
	      };
	
	      function onDragStart(ev) {
	        // Disable transitions on transform so that it feels fast
	        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
	      }
	
	      function onDrag(ev) {
	        var transform = ev.pointer.distanceY;
	        if (transform < 5) {
	          // Slow down drag when trying to drag up, and stop after PADDING
	          transform = Math.max(-PADDING, transform / 2);
	        }
	        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
	      }
	
	      function onDragEnd(ev) {
	        if (ev.pointer.distanceY > 0 &&
	            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
	          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
	          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
	          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
	          $mdUtil.nextTick($mdBottomSheet.cancel,true);
	        } else {
	          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
	          element.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      }
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.button
	 * @description
	 *
	 * Button
	 */
	MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$mdInteraction"];
	MdAnchorDirective.$inject = ["$mdTheming"];
	angular
	    .module('material.components.button', [ 'material.core' ])
	    .directive('mdButton', MdButtonDirective)
	    .directive('a', MdAnchorDirective);
	
	
	/**
	 * @private
	 * @restrict E
	 *
	 * @description
	 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 *  <md-content md-theme="myTheme">
	 *    <a href="#chapter1" class="md-accent"></a>
	 *  </md-content>
	 * </hljs>
	 */
	function MdAnchorDirective($mdTheming) {
	  return {
	    restrict : 'E',
	    link : function postLink(scope, element) {
	      // Make sure to inherit theme so stand-alone anchors
	      // support theme colors for md-primary, md-accent, etc.
	      $mdTheming(element);
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name mdButton
	 * @module material.components.button
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-button>` is a button directive with optional ink ripples (default enabled).
	 *
	 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
	 * will become a `<button>` element. As per the
	 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
	 * the FAB button background is filled with the accent color [by default]. The primary color palette
	 * may be used with the `md-primary` class.
	 *
	 * Developers can also change the color palette of the button, by using the following classes
	 * - `md-primary`
	 * - `md-accent`
	 * - `md-warn`
	 *
	 * See for example
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-primary">Primary Button</md-button>
	 * </hljs>
	 *
	 * Button can be also raised, which means that they will use the current color palette to fill the button.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
	 * </hljs>
	 *
	 * It is also possible to disable the focus effect on the button, by using the following markup.
	 *
	 * <hljs lang="html">
	 *   <md-button class="md-no-focus">No Focus Style</md-button>
	 * </hljs>
	 *
	 * @param {boolean=} md-no-ink If present, disable ripple ink effects.
	 * @param {expression=} ng-disabled En/Disable based on the expression
	 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`
	 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
	 * If no default text is found, a warning will be logged.
	 *
	 * @usage
	 *
	 * Regular buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button> Flat Button </md-button>
	 *  <md-button href="http://google.com"> Flat link </md-button>
	 *  <md-button class="md-raised"> Raised Button </md-button>
	 *  <md-button ng-disabled="true"> Disabled Button </md-button>
	 *  <md-button>
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *    Register Now
	 *  </md-button>
	 * </hljs>
	 *
	 * FAB buttons:
	 *
	 * <hljs lang="html">
	 *  <md-button class="md-fab" aria-label="FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- mini-FAB -->
	 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
	 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
	 *  </md-button>
	 *  <!-- Button with SVG Icon -->
	 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
	 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
	 *  </md-button>
	 * </hljs>
	 */
	function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $mdInteraction) {
	
	  return {
	    restrict: 'EA',
	    replace: true,
	    transclude: true,
	    template: getTemplate,
	    link: postLink
	  };
	
	  function isAnchor(attr) {
	    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
	  }
	
	  function getTemplate(element, attr) {
	    if (isAnchor(attr)) {
	      return '<a class="md-button" ng-transclude></a>';
	    } else {
	      //If buttons don't have type="button", they will submit forms automatically.
	      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
	      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
	    }
	  }
	
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    $mdButtonInkRipple.attach(scope, element);
	
	    // Use async expect to support possible bindings in the button label
	    $mdAria.expectWithoutText(element, 'aria-label');
	
	    // For anchor elements, we have to set tabindex manually when the
	    // element is disabled
	    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) ) {
	      scope.$watch(attr.ngDisabled, function(isDisabled) {
	        element.attr('tabindex', isDisabled ? -1 : 0);
	      });
	    }
	
	    // disabling click event when disabled is true
	    element.on('click', function(e){
	      if (attr.disabled === true) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    });
	
	    if (!element.hasClass('md-no-focus')) {
	
	      element.on('focus', function() {
	
	        // Only show the focus effect when being focused through keyboard interaction or programmatically
	        if (!$mdInteraction.isUserInvoked() || $mdInteraction.getLastInteractionType() === 'keyboard') {
	          element.addClass('md-focused');
	        }
	
	      });
	
	      element.on('blur', function() {
	        element.removeClass('md-focused');
	      });
	    }
	
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.card
	 *
	 * @description
	 * Card components.
	 */
	mdCardDirective.$inject = ["$mdTheming"];
	angular.module('material.components.card', [
	    'material.core'
	  ])
	  .directive('mdCard', mdCardDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdCard
	 * @module material.components.card
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-card>` directive is a container element used within `<md-content>` containers.
	 *
	 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
	 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
	 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
	 * optionally included to put content flush against the bottom edge of the card.
	 *
	 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
	 * You can then position buttons using layout attributes.
	 *
	 * Card is built with:
	 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
	 *  - `<md-card-avatar>` - Card avatar
	 *    - `md-user-avatar` - Class for user image
	 *    - `<md-icon>`
	 *  - `<md-card-header-text>` - Contains elements for the card description
	 *    - `md-title` - Class for the card title
	 *    - `md-subhead` - Class for the card sub header
	 * * `<img>` - Image for the card
	 * * `<md-card-title>` - Card content title
	 *  - `<md-card-title-text>`
	 *    - `md-headline` - Class for the card content title
	 *    - `md-subhead` - Class for the card content sub header
	 *  - `<md-card-title-media>` - Squared image within the title
	 *    - `md-media-sm` - Class for small image
	 *    - `md-media-md` - Class for medium image
	 *    - `md-media-lg` - Class for large image
	 *    - `md-media-xl` - Class for extra large image
	 * * `<md-card-content>` - Card content
	 * * `<md-card-actions>` - Card actions
	 *  - `<md-card-icon-actions>` - Icon actions
	 *
	 * Cards have constant width and variable heights; where the maximum height is limited to what can
	 * fit within a single view on a platform, but it can temporarily expand as needed.
	 *
	 * @usage
	 * ### Card with optional footer
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-footer>
	 *    Card footer
	 *  </md-card-footer>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with actions
	 * <hljs lang="html">
	 * <md-card>
	 *  <img src="card-image.png" class="md-card-image" alt="image caption">
	 *  <md-card-content>
	 *    <h2>Card headline</h2>
	 *    <p>Card content</p>
	 *  </md-card-content>
	 *  <md-card-actions layout="row" layout-align="end center">
	 *    <md-button>Action 1</md-button>
	 *    <md-button>Action 2</md-button>
	 *  </md-card-actions>
	 * </md-card>
	 * </hljs>
	 *
	 * ### Card with header, image, title actions and content
	 * <hljs lang="html">
	 * <md-card>
	 *   <md-card-header>
	 *     <md-card-avatar>
	 *       <img class="md-user-avatar" src="avatar.png"/>
	 *     </md-card-avatar>
	 *     <md-card-header-text>
	 *       <span class="md-title">Title</span>
	 *       <span class="md-subhead">Sub header</span>
	 *     </md-card-header-text>
	 *   </md-card-header>
	 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
	 *   <md-card-title>
	 *     <md-card-title-text>
	 *       <span class="md-headline">Card headline</span>
	 *       <span class="md-subhead">Card subheader</span>
	 *     </md-card-title-text>
	 *   </md-card-title>
	 *   <md-card-actions layout="row" layout-align="start center">
	 *     <md-button>Action 1</md-button>
	 *     <md-button>Action 2</md-button>
	 *     <md-card-icon-actions>
	 *       <md-button class="md-icon-button" aria-label="icon">
	 *         <md-icon md-svg-icon="icon"></md-icon>
	 *       </md-button>
	 *     </md-card-icon-actions>
	 *   </md-card-actions>
	 *   <md-card-content>
	 *     <p>
	 *      Card content
	 *     </p>
	 *   </md-card-content>
	 * </md-card>
	 * </hljs>
	 */
	function mdCardDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: function ($scope, $element, attr) {
	      $element.addClass('_md');     // private md component indicator for styling
	      $mdTheming($element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.checkbox
	 * @description Checkbox module!
	 */
	MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$mdInteraction"];
	angular
	  .module('material.components.checkbox', ['material.core'])
	  .directive('mdCheckbox', MdCheckboxDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdCheckbox
	 * @module material.components.checkbox
	 * @restrict E
	 *
	 * @description
	 * The checkbox directive is used like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-color-schemes)
	 * the checkbox is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user interaction with the input element.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects
	 * @param {string=} aria-label Adds label to checkbox for accessibility.
	 *     Defaults to checkbox's text. If no default text is found, a warning will be logged.
	 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as 'indeterminate'.
	 *     If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state.
	 *     If falsy expression is passed in it just looks like a normal unchecked checkbox.
	 *     The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time.
	 *     Adding the 'md-indeterminate' attribute overrides any checked/unchecked rendering logic.
	 *     When using the 'md-indeterminate' attribute use 'ng-checked' to define rendering logic instead of using 'ng-model'.
	 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css class is added to the checkbox and it
	 *     will appear checked.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
	 *   Finished ?
	 * </md-checkbox>
	 *
	 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-checkbox>
	 *
	 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-checkbox>
	 *
	 * </hljs>
	 *
	 */
	function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $mdInteraction) {
	  inputDirective = inputDirective[0];
	
	  return {
	    restrict: 'E',
	    transclude: true,
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    template:
	      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	        '<div class="md-icon"></div>' +
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
	    tAttrs.$set('type', 'checkbox');
	    tAttrs.$set('role', tAttrs.type);
	
	    return  {
	      pre: function(scope, element) {
	        // Attach a click handler during preLink, in order to immediately stop propagation
	        // (especially for ng-click) when the checkbox is disabled.
	        element.on('click', function(e) {
	          if (this.hasAttribute('disabled')) {
	            e.stopImmediatePropagation();
	          }
	        });
	      },
	      post: postLink
	    };
	
	    function postLink(scope, element, attr, ctrls) {
	      var isIndeterminate;
	      var containerCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        containerCtrl.input = element;
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      $mdTheming(element);
	
	      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
	      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
	      element.children().on('focus', function() {
	        element.focus();
	      });
	
	      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
	        setIndeterminateState();
	        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
	      }
	
	      if (attr.ngChecked) {
	        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
	          ngModelCtrl.$setViewValue(value);
	          ngModelCtrl.$render();
	        });
	      }
	
	      $$watchExpr('ngDisabled', 'tabindex', {
	        true: '-1',
	        false: attr.tabindex
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	
	      // Reuse the original input[type=checkbox] directive from AngularJS core.
	      // This is a bit hacky as we need our own event listener and own render
	      // function.
	      inputDirective.link.pre(scope, {
	        on: angular.noop,
	        0: {}
	      }, attr, [ngModelCtrl]);
	
	      element.on('click', listener)
	        .on('keypress', keypressHandler)
	        .on('focus', function() {
	          if ($mdInteraction.getLastInteractionType() === 'keyboard') {
	            element.addClass('md-focused');
	          }
	        })
	        .on('blur', function() {
	          element.removeClass('md-focused');
	        });
	
	      ngModelCtrl.$render = render;
	
	      function $$watchExpr(expr, htmlAttr, valueOpts) {
	        if (attr[expr]) {
	          scope.$watch(attr[expr], function(val) {
	            if (valueOpts[val]) {
	              element.attr(htmlAttr, valueOpts[val]);
	            }
	          });
	        }
	      }
	
	      function keypressHandler(ev) {
	        var keyCode = ev.which || ev.keyCode;
	        if (keyCode === $mdConstant.KEY_CODE.SPACE || keyCode === $mdConstant.KEY_CODE.ENTER) {
	          ev.preventDefault();
	          element.addClass('md-focused');
	          listener(ev);
	        }
	      }
	
	      function listener(ev) {
	        // skipToggle boolean is used by the switch directive to prevent the click event
	        // when releasing the drag. There will be always a click if releasing the drag over the checkbox
	        if (element[0].hasAttribute('disabled') || scope.skipToggle) {
	          return;
	        }
	
	        scope.$apply(function() {
	          // Toggle the checkbox value...
	          var viewValue = attr.ngChecked && attr.ngClick ? attr.checked : !ngModelCtrl.$viewValue;
	
	          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
	          ngModelCtrl.$render();
	        });
	      }
	
	      function render() {
	        // Cast the $viewValue to a boolean since it could be undefined
	        element.toggleClass('md-checked', !!ngModelCtrl.$viewValue && !isIndeterminate);
	      }
	
	      function setIndeterminateState(newValue) {
	        isIndeterminate = newValue !== false;
	        if (isIndeterminate) {
	          element.attr('aria-checked', 'mixed');
	        }
	        element.toggleClass('md-indeterminate', isIndeterminate);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.chips
	 */
	/*
	 * @see js folder for chips implementation
	 */
	angular.module('material.components.chips', [
	  'material.core',
	  'material.components.autocomplete'
	]);
	
	})();
	(function(){
	"use strict";
	
	(function () {
	  "use strict";
	
	  /**
	   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
	   *  or one that should be observed and dynamically interpolated.
	   */
	  MdColorsDirective.$inject = ["$mdColors", "$mdUtil", "$log", "$parse"];
	  MdColorsService.$inject = ["$mdTheming", "$mdUtil", "$log"];
	  var STATIC_COLOR_EXPRESSION = /^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?('|")[a-zA-Z0-9-.]*('|"))+\s*}$/;
	  var colorPalettes = null;
	
	  /**
	   * @ngdoc module
	   * @name material.components.colors
	   *
	   * @description
	   * Define $mdColors service and a `md-colors=""` attribute directive
	   */
	  angular
	    .module('material.components.colors', ['material.core'])
	    .directive('mdColors', MdColorsDirective)
	    .service('$mdColors', MdColorsService);
	
	  /**
	   * @ngdoc service
	   * @name $mdColors
	   * @module material.components.colors
	   *
	   * @description
	   * With only defining themes, one couldn't get non AngularJS Material elements colored with Material colors,
	   * `$mdColors` service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply
	   * those values to element as CSS property values.
	   *
	   *  @usage
	   *  <hljs lang="js">
	   *    angular.controller('myCtrl', function ($mdColors) {
	   *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	   *      ...
	   *    });
	   *  </hljs>
	   *
	   */
	  function MdColorsService($mdTheming, $mdUtil, $log) {
	    colorPalettes = colorPalettes || Object.keys($mdTheming.PALETTES);
	
	    // Publish service instance
	    return {
	      applyThemeColors: applyThemeColors,
	      getThemeColor: getThemeColor,
	      hasTheme: hasTheme
	    };
	
	    // ********************************************
	    // Internal Methods
	    // ********************************************
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#applyThemeColors
	     *
	     * @description
	     * Gets a color json object, keys are css properties and values are string of the wanted color
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @param {DOMElement} element the element to apply the styles on.
	     * @param {object} colorExpression json object, keys are css properties and values are string of the wanted color,
	     * for example: `{color: 'red-A200-0.3'}`.
	     *
	     * @usage
	     * <hljs lang="js">
	     *   app.directive('myDirective', function($mdColors) {
	     *     return {
	     *       ...
	     *       link: function (scope, elem) {
	     *         $mdColors.applyThemeColors(elem, {color: 'red'});
	     *       }
	     *    }
	     *   });
	     * </hljs>
	     */
	    function applyThemeColors(element, colorExpression) {
	      try {
	        if (colorExpression) {
	          // Assign the calculate RGBA color values directly as inline CSS
	          element.css(interpolateColors(colorExpression));
	        }
	      } catch (e) {
	        $log.error(e.message);
	      }
	
	    }
	
	    /**
	     * @ngdoc method
	     * @name $mdColors#getThemeColor
	     *
	     * @description
	     * Get parsed color from expression
	     *
	     * @param {string} expression string of a color expression (for instance `'red-700-0.8'`)
	     *
	     * @returns {string} a css color expression (for instance `rgba(211, 47, 47, 0.8)`)
	     *
	     * @usage
	     *  <hljs lang="js">
	     *    angular.controller('myCtrl', function ($mdColors) {
	     *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
	     *      ...
	     *    });
	     *  </hljs>
	     */
	    function getThemeColor(expression) {
	      var color = extractColorOptions(expression);
	
	      return parseColor(color);
	    }
	
	    /**
	     * Return the parsed color
	     * @param color hashmap of color definitions
	     * @param contrast whether use contrast color for foreground
	     * @returns rgba color string
	     */
	    function parseColor(color, contrast) {
	      contrast = contrast || false;
	      var rgbValues = $mdTheming.PALETTES[color.palette][color.hue];
	
	      rgbValues = contrast ? rgbValues.contrast : rgbValues.value;
	
	      return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',
	        [rgbValues[0], rgbValues[1], rgbValues[2], rgbValues[3] || color.opacity]
	      );
	    }
	
	    /**
	     * Convert the color expression into an object with scope-interpolated values
	     * Then calculate the rgba() values based on the theme color parts
	     *
	     * @results Hashmap of CSS properties with associated `rgba( )` string vales
	     *
	     *
	     */
	    function interpolateColors(themeColors) {
	      var rgbColors = {};
	
	      var hasColorProperty = themeColors.hasOwnProperty('color');
	
	      angular.forEach(themeColors, function (value, key) {
	        var color = extractColorOptions(value);
	        var hasBackground = key.indexOf('background') > -1;
	
	        rgbColors[key] = parseColor(color);
	        if (hasBackground && !hasColorProperty) {
	          rgbColors.color = parseColor(color, true);
	        }
	      });
	
	      return rgbColors;
	    }
	
	    /**
	     * Check if expression has defined theme
	     * e.g.
	     * 'myTheme-primary' => true
	     * 'red-800' => false
	     */
	    function hasTheme(expression) {
	      return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);
	    }
	
	    /**
	     * For the evaluated expression, extract the color parts into a hash map
	     */
	    function extractColorOptions(expression) {
	      var parts = expression.split('-');
	      var hasTheme = angular.isDefined($mdTheming.THEMES[parts[0]]);
	      var theme = hasTheme ? parts.splice(0, 1)[0] : $mdTheming.defaultTheme();
	
	      return {
	        theme: theme,
	        palette: extractPalette(parts, theme),
	        hue: extractHue(parts, theme),
	        opacity: parts[2] || 1
	      };
	    }
	
	    /**
	     * Calculate the theme palette name
	     */
	    function extractPalette(parts, theme) {
	      // If the next section is one of the palettes we assume it's a two word palette
	      // Two word palette can be also written in camelCase, forming camelCase to dash-case
	
	      var isTwoWord = parts.length > 1 && colorPalettes.indexOf(parts[1]) !== -1;
	      var palette = parts[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	
	      if (isTwoWord)  palette = parts[0] + '-' + parts.splice(1, 1);
	
	      if (colorPalettes.indexOf(palette) === -1) {
	        // If the palette is not in the palette list it's one of primary/accent/warn/background
	        var scheme = $mdTheming.THEMES[theme].colors[palette];
	        if (!scheme) {
	          throw new Error($mdUtil.supplant('mdColors: couldn\'t find \'{palette}\' in the palettes.', {palette: palette}));
	        }
	        palette = scheme.name;
	      }
	
	      return palette;
	    }
	
	    function extractHue(parts, theme) {
	      var themeColors = $mdTheming.THEMES[theme].colors;
	
	      if (parts[1] === 'hue') {
	        var hueNumber = parseInt(parts.splice(2, 1)[0], 10);
	
	        if (hueNumber < 1 || hueNumber > 3) {
	          throw new Error($mdUtil.supplant('mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'', {hueNumber: hueNumber}));
	        }
	        parts[1] = 'hue-' + hueNumber;
	
	        if (!(parts[0] in themeColors)) {
	          throw new Error($mdUtil.supplant('mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'', {
	            availableThemes: Object.keys(themeColors).join(', '),
	            usedTheme: parts[0]
	          }));
	        }
	
	        return themeColors[parts[0]].hues[parts[1]];
	      }
	
	      return parts[1] || themeColors[parts[0] in themeColors ? parts[0] : 'primary'].hues['default'];
	    }
	  }
	
	  /**
	   * @ngdoc directive
	   * @name mdColors
	   * @module material.components.colors
	   *
	   * @restrict A
	   *
	   * @description
	   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
	   *
	   *   The format will be similar to our color defining in the scss files:
	   *
	   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
	   *   - [theme]    - default value is the default theme
	   *   - [palette]  - can be either palette name or primary/accent/warn/background
	   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
	   *   - [opacity]  - default is 1
	   *
	   *   > `?` indicates optional parameter
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
	   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
	   *       <span>Color demo</span>
	   *     </div>
	   *   </div>
	   * </hljs>
	   *
	   * `mdColors` directive will automatically watch for changes in the expression if it recognizes an interpolation
	   * expression or a function. For performance options, you can use `::` prefix to the `md-colors` expression
	   * to indicate a one-time data binding.
	   * <hljs lang="html">
	   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
	   *   </md-card>
	   * </hljs>
	   *
	   */
	  function MdColorsDirective($mdColors, $mdUtil, $log, $parse) {
	    return {
	      restrict: 'A',
	      require: ['^?mdTheme'],
	      compile: function (tElem, tAttrs) {
	        var shouldWatch = shouldColorsWatch();
	
	        return function (scope, element, attrs, ctrl) {
	          var mdThemeController = ctrl[0];
	
	          var lastColors = {};
	
	          var parseColors = function (theme) {
	            if (typeof theme !== 'string') {
	              theme = '';
	            }
	
	            if (!attrs.mdColors) {
	              attrs.mdColors = '{}';
	            }
	
	            /**
	             * Json.parse() does not work because the keys are not quoted;
	             * use $parse to convert to a hash map
	             */
	            var colors = $parse(attrs.mdColors)(scope);
	
	            /**
	             * If mdTheme is defined up the DOM tree
	             * we add mdTheme theme to colors who doesn't specified a theme
	             *
	             * # example
	             * <hljs lang="html">
	             *   <div md-theme="myTheme">
	             *     <div md-colors="{background: 'primary-600'}">
	             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
	             *     </div>
	             *   </div>
	             * </hljs>
	             *
	             * 'primary-600' will be 'myTheme-primary-600',
	             * but 'mySecondTheme-accent-200' will stay the same cause it has a theme prefix
	             */
	            if (mdThemeController) {
	              Object.keys(colors).forEach(function (prop) {
	                var color = colors[prop];
	                if (!$mdColors.hasTheme(color)) {
	                  colors[prop] = (theme || mdThemeController.$mdTheme) + '-' + color;
	                }
	              });
	            }
	
	            cleanElement(colors);
	
	            return colors;
	          };
	
	          var cleanElement = function (colors) {
	            if (!angular.equals(colors, lastColors)) {
	              var keys = Object.keys(lastColors);
	
	              if (lastColors.background && !keys.color) {
	                keys.push('color');
	              }
	
	              keys.forEach(function (key) {
	                element.css(key, '');
	              });
	            }
	
	            lastColors = colors;
	          };
	
	          /**
	           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever a theme changes
	           */
	          var unregisterChanges = angular.noop;
	
	          if (mdThemeController) {
	            unregisterChanges = mdThemeController.registerChanges(function (theme) {
	              $mdColors.applyThemeColors(element, parseColors(theme));
	            });
	          }
	
	          scope.$on('$destroy', function () {
	            unregisterChanges();
	          });
	
	          try {
	            if (shouldWatch) {
	              scope.$watch(parseColors, angular.bind(this,
	                $mdColors.applyThemeColors, element
	              ), true);
	            }
	            else {
	              $mdColors.applyThemeColors(element, parseColors());
	            }
	
	          }
	          catch (e) {
	            $log.error(e.message);
	          }
	
	        };
	
	        function shouldColorsWatch() {
	          // Simulate 1x binding and mark mdColorsWatch == false
	          var rawColorExpression = tAttrs.mdColors;
	          var bindOnce = rawColorExpression.indexOf('::') > -1;
	          var isStatic = bindOnce ? true : STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);
	
	          // Remove it for the postLink...
	          tAttrs.mdColors = rawColorExpression.replace('::', '');
	
	          var hasWatchAttr = angular.isDefined(tAttrs.mdColorsWatch);
	
	          return (bindOnce || isStatic) ? false :
	            hasWatchAttr ? $mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch) : true;
	        }
	      }
	    };
	
	  }
	
	
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.content
	 *
	 * @description
	 * Scrollable content
	 */
	mdContentDirective.$inject = ["$mdTheming"];
	angular.module('material.components.content', [
	  'material.core'
	])
	  .directive('mdContent', mdContentDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdContent
	 * @module material.components.content
	 *
	 * @restrict E
	 *
	 * @description
	 *
	 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
	 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
	 *
	 * In general, `<md-content>` components are not designed to be nested inside one another. If
	 * possible, it is better to make them siblings. This often results in a better user experience as
	 * having nested scrollbars may confuse the user.
	 *
	 * ## Troubleshooting
	 *
	 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
	 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
	 * SVG icons and some other components.
	 *
	 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
	 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
	 * inside (which eliminates the flicker on iOS devices).
	 *
	 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
	 * related to the z-index of elements. Please use with caution and only on the elements needed._
	 *
	 * @usage
	 *
	 * Add the `[layout-padding]` attribute to make the content padded.
	 *
	 * <hljs lang="html">
	 *  <md-content layout-padding>
	 *      Lorem ipsum dolor sit amet, ne quod novum mei.
	 *  </md-content>
	 * </hljs>
	 */
	
	function mdContentDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    controller: ['$scope', '$element', ContentController],
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      scope.$broadcast('$mdContentLoaded', element);
	
	      iosScrollFix(element[0]);
	    }
	  };
	
	  function ContentController($scope, $element) {
	    this.$scope = $scope;
	    this.$element = $element;
	  }
	}
	
	function iosScrollFix(node) {
	  // IOS FIX:
	  // If we scroll where there is no more room for the webview to scroll,
	  // by default the webview itself will scroll up and down, this looks really
	  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
	  angular.element(node).on('$md.pressdown', function(ev) {
	    // Only touch events
	    if (ev.pointer.type !== 't') return;
	    // Don't let a child content's touchstart ruin it for us.
	    if (ev.$materialScrollFixed) return;
	    ev.$materialScrollFixed = true;
	
	    if (node.scrollTop === 0) {
	      node.scrollTop = 1;
	    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
	      node.scrollTop -= 1;
	    }
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.datepicker
	 * @description Module for the datepicker component.
	 */
	
	angular.module('material.components.datepicker', [
	  'material.core',
	  'material.components.icon',
	  'material.components.virtualRepeat'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.dialog
	 */
	MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];
	MdDialogProvider.$inject = ["$$interimElementProvider"];
	angular
	  .module('material.components.dialog', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdDialog', MdDialogDirective)
	  .provider('$mdDialog', MdDialogProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdDialog
	 * @module material.components.dialog
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-dialog>` - The dialog's template must be inside this element.
	 *
	 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 * an `<md-dialog-actions>` element for the dialog's actions.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * ## Notes
	 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
	 * prefixed with `dialogContent_`.
	 *
	 * @usage
	 * ### Dialog template
	 * <hljs lang="html">
	 * <md-dialog aria-label="List dialog">
	 *   <md-dialog-content>
	 *     <md-list>
	 *       <md-list-item ng-repeat="item in items">
	 *         <p>Number {{item}}</p>
	 *       </md-list-item>
	 *     </md-list>
	 *   </md-dialog-content>
	 *   <md-dialog-actions>
	 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
	 *   </md-dialog-actions>
	 * </md-dialog>
	 * </hljs>
	 */
	function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
	  return {
	    restrict: 'E',
	    link: function(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	
	      $mdTheming(element);
	      $$rAF(function() {
	        var images;
	        var content = element[0].querySelector('md-dialog-content');
	
	        if (content) {
	          images = content.getElementsByTagName('img');
	          addOverflowClass();
	          //-- delayed image loading may impact scroll height, check after images are loaded
	          angular.element(images).on('load', addOverflowClass);
	        }
	
	        scope.$on('$destroy', function() {
	          $mdDialog.destroy(element);
	        });
	
	        /**
	         *
	         */
	        function addOverflowClass() {
	          element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
	        }
	
	
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $mdDialog
	 * @module material.components.dialog
	 *
	 * @description
	 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
	 *  them to make decisions. There are two approaches for setup: a simple promise API
	 *  and regular object syntax.
	 *
	 * ## Restrictions
	 *
	 * - The dialog is always given an isolate scope.
	 * - The dialog's template must have an outer `<md-dialog>` element.
	 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
	 *   an `<md-dialog-actions>` element for the dialog's actions.
	 * - Dialogs must cover the entire application to keep interactions inside of them.
	 * Use the `parent` option to change where dialogs are appended.
	 *
	 * ## Sizing
	 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
	 * - Default max-width is 80% of the `rootElement` or `parent`.
	 *
	 * ## CSS
	 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div  ng-app="demoApp" ng-controller="EmployeeController">
	 *   <div>
	 *     <md-button ng-click="showAlert()" class="md-raised md-warn">
	 *       Employee Alert!
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showDialog($event)" class="md-raised">
	 *       Custom Dialog
	 *       </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">
	 *       Close Alert
	 *     </md-button>
	 *   </div>
	 *   <div>
	 *     <md-button ng-click="showGreeting($event)" class="md-raised md-primary" >
	 *       Greet Employee
	 *       </md-button>
	 *   </div>
	 * </div>
	 * </hljs>
	 *
	 * ### JavaScript: object syntax
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *    .module('demoApp', ['ngMaterial'])
	 *    .controller('AppCtrl', AppController);
	 *
	 *   function AppController($scope, $mdDialog) {
	 *     var alert;
	 *     $scope.showAlert = showAlert;
	 *     $scope.showDialog = showDialog;
	 *     $scope.items = [1, 2, 3];
	 *
	 *     // Internal method
	 *     function showAlert() {
	 *       alert = $mdDialog.alert({
	 *         title: 'Attention',
	 *         textContent: 'This is an example of how easy dialogs can be!',
	 *         ok: 'Close'
	 *       });
	 *
	 *       $mdDialog
	 *         .show( alert )
	 *         .finally(function() {
	 *           alert = undefined;
	 *         });
	 *     }
	 *
	 *     function showDialog($event) {
	 *        var parentEl = angular.element(document.body);
	 *        $mdDialog.show({
	 *          parent: parentEl,
	 *          targetEvent: $event,
	 *          template:
	 *            '<md-dialog aria-label="List dialog">' +
	 *            '  <md-dialog-content>'+
	 *            '    <md-list>'+
	 *            '      <md-list-item ng-repeat="item in items">'+
	 *            '       <p>Number {{item}}</p>' +
	 *            '      </md-item>'+
	 *            '    </md-list>'+
	 *            '  </md-dialog-content>' +
	 *            '  <md-dialog-actions>' +
	 *            '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *            '      Close Dialog' +
	 *            '    </md-button>' +
	 *            '  </md-dialog-actions>' +
	 *            '</md-dialog>',
	 *          locals: {
	 *            items: $scope.items
	 *          },
	 *          controller: DialogController
	 *       });
	 *       function DialogController($scope, $mdDialog, items) {
	 *         $scope.items = items;
	 *         $scope.closeDialog = function() {
	 *           $mdDialog.hide();
	 *         }
	 *       }
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 *
	 * ### Multiple Dialogs
	 * Using the `multiple` option for the `$mdDialog` service allows developers to show multiple dialogs
	 * at the same time.
	 *
	 * <hljs lang="js">
	 *   // From plain options
	 *   $mdDialog.show({
	 *     multiple: true
	 *   });
	 *
	 *   // From a dialog preset
	 *   $mdDialog.show(
	 *     $mdDialog
	 *       .alert()
	 *       .multiple(true)
	 *   );
	 *
	 * </hljs>
	 *
	 * ### Pre-Rendered Dialogs
	 * By using the `contentElement` option, it is possible to use an already existing element in the DOM.
	 *
	 * > Pre-rendered dialogs will be not linked to any scope and will not instantiate any new controller.<br/>
	 * > You can manually link the elements to a scope or instantiate a controller from the template (`ng-controller`)
	 *
	 * <hljs lang="js">
	 *   $scope.showPrerenderedDialog = function() {
	 *     $mdDialog.show({
	 *       contentElement: '#myStaticDialog',
	 *       parent: angular.element(document.body)
	 *     });
	 *   };
	 * </hljs>
	 *
	 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS selector.
	 *
	 * <hljs lang="html">
	 *   <div style="visibility: hidden">
	 *     <div class="md-dialog-container" id="myStaticDialog">
	 *       <md-dialog>
	 *         This is a pre-rendered dialog.
	 *       </md-dialog>
	 *     </div>
	 *   </div>
	 * </hljs>
	 *
	 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise the dialog
	 * will not show up.
	 *
	 * It also possible to use a DOM element for the `contentElement` option.
	 * - `contentElement: document.querySelector('#myStaticDialog')`
	 * - `contentElement: angular.element(TEMPLATE)`
	 *
	 * When using a `template` as content element, it will be not compiled upon open.
	 * This allows you to compile the element yourself and use it each time the dialog opens.
	 *
	 * ### Custom Presets
	 * Developers are also able to create their own preset, which can be easily used without repeating
	 * their options each time.
	 *
	 * <hljs lang="js">
	 *   $mdDialogProvider.addPreset('testPreset', {
	 *     options: function() {
	 *       return {
	 *         template:
	 *           '<md-dialog>' +
	 *             'This is a custom preset' +
	 *           '</md-dialog>',
	 *         controllerAs: 'dialog',
	 *         bindToController: true,
	 *         clickOutsideToClose: true,
	 *         escapeToClose: true
	 *       };
	 *     }
	 *   });
	 * </hljs>
	 *
	 * After you created your preset at config phase, you can easily access it.
	 *
	 * <hljs lang="js">
	 *   $mdDialog.show(
	 *     $mdDialog.testPreset()
	 *   );
	 * </hljs>
	 *
	 * ### JavaScript: promise API syntax, custom dialog template
	 * <hljs lang="js">
	 * (function(angular, undefined){
	 *   "use strict";
	 *
	 *   angular
	 *     .module('demoApp', ['ngMaterial'])
	 *     .controller('EmployeeController', EmployeeEditor)
	 *     .controller('GreetingController', GreetingController);
	 *
	 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
	 *
	 *   function EmployeeEditor($scope, $mdDialog) {
	 *     var alert;
	 *
	 *     $scope.showAlert = showAlert;
	 *     $scope.closeAlert = closeAlert;
	 *     $scope.showGreeting = showCustomGreeting;
	 *
	 *     $scope.hasAlert = function() { return !!alert };
	 *     $scope.userName = $scope.userName || 'Bobby';
	 *
	 *     // Dialog #1 - Show simple alert dialog and cache
	 *     // reference to dialog instance
	 *
	 *     function showAlert() {
	 *       alert = $mdDialog.alert()
	 *         .title('Attention, ' + $scope.userName)
	 *         .textContent('This is an example of how easy dialogs can be!')
	 *         .ok('Close');
	 *
	 *       $mdDialog
	 *           .show( alert )
	 *           .finally(function() {
	 *             alert = undefined;
	 *           });
	 *     }
	 *
	 *     // Close the specified dialog instance and resolve with 'finished' flag
	 *     // Normally this is not needed, just use '$mdDialog.hide()' to close
	 *     // the most recent dialog popup.
	 *
	 *     function closeAlert() {
	 *       $mdDialog.hide( alert, "finished" );
	 *       alert = undefined;
	 *     }
	 *
	 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
	 *
	 *     function showCustomGreeting($event) {
	 *         $mdDialog.show({
	 *           targetEvent: $event,
	 *           template:
	 *             '<md-dialog>' +
	 *
	 *             '  <md-dialog-content>Hello {{ employee }}!</md-dialog-content>' +
	 *
	 *             '  <md-dialog-actions>' +
	 *             '    <md-button ng-click="closeDialog()" class="md-primary">' +
	 *             '      Close Greeting' +
	 *             '    </md-button>' +
	 *             '  </md-dialog-actions>' +
	 *             '</md-dialog>',
	 *           controller: 'GreetingController',
	 *           onComplete: afterShowAnimation,
	 *           locals: { employee: $scope.userName }
	 *         });
	 *
	 *         // When the 'enter' animation finishes...
	 *
	 *         function afterShowAnimation(scope, element, options) {
	 *            // post-show code here: DOM element focus, etc.
	 *         }
	 *     }
	 *
	 *     // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog
	 *     //             Here we used ng-controller="GreetingController as vm" and
	 *     //             $scope.vm === <controller instance>
	 *
	 *     function showCustomGreeting() {
	 *
	 *        $mdDialog.show({
	 *           clickOutsideToClose: true,
	 *
	 *           scope: $scope,        // use parent scope in template
	 *           preserveScope: true,  // do not forget this if use parent scope
	
	 *           // Since GreetingController is instantiated with ControllerAs syntax
	 *           // AND we are passing the parent '$scope' to the dialog, we MUST
	 *           // use 'vm.<xxx>' in the template markup
	 *
	 *           template: '<md-dialog>' +
	 *                     '  <md-dialog-content>' +
	 *                     '     Hi There {{vm.employee}}' +
	 *                     '  </md-dialog-content>' +
	 *                     '</md-dialog>',
	 *
	 *           controller: function DialogController($scope, $mdDialog) {
	 *             $scope.closeDialog = function() {
	 *               $mdDialog.hide();
	 *             }
	 *           }
	 *        });
	 *     }
	 *
	 *   }
	 *
	 *   // Greeting controller used with the more complex 'showCustomGreeting()' custom dialog
	 *
	 *   function GreetingController($scope, $mdDialog, employee) {
	 *     // Assigned from construction <code>locals</code> options...
	 *     $scope.employee = employee;
	 *
	 *     $scope.closeDialog = function() {
	 *       // Easily hides most recent dialog shown...
	 *       // no specific instance reference is needed.
	 *       $mdDialog.hide();
	 *     };
	 *   }
	 *
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#alert
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the alert title.
	 * - $mdDialogPreset#textContent(string) - Sets the alert message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the alert "Okay" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the alert dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#confirm
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message. You can call show and the promise returned
	 * will be resolved only if the user clicks the confirm action on the dialog.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the confirm title.
	 * - $mdDialogPreset#textContent(string) - Sets the confirm message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#ok(string) - Sets the confirm "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the confirm "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#prompt
	 *
	 * @description
	 * Builds a preconfigured dialog with the specified message and input box. You can call show and the promise returned
	 * will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.
	 *
	 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
	 *
	 * Additionally, it supports the following methods:
	 *
	 * - $mdDialogPreset#title(string) - Sets the prompt title.
	 * - $mdDialogPreset#textContent(string) - Sets the prompt message.
	 * - $mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize
	 *     module to be loaded. HTML is not run through Angular's compiler.
	 * - $mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.
	 * - $mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.
	 * - $mdDialogPreset#ok(string) - Sets the prompt "Okay" button text.
	 * - $mdDialogPreset#cancel(string) - Sets the prompt "Cancel" button text.
	 * - $mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.
	 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#show
	 *
	 * @description
	 * Show a dialog with the specified options.
	 *
	 * @param {object} optionsOrPreset Either provide an `$mdDialogPreset` returned from `alert()`, and
	 * `confirm()`, or an options object with the following properties:
	 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
	 *   of the dialog.
	 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
	 *      with respect to Angular's [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *      This template should **never** be constructed with any kind of user input or user data.
	 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled each time a
	 *     dialog opens, you can also use a DOM element.<br/>
	 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch the element into
	 *       the dialog and restores it at the old DOM position upon close.
	 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.
	 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
	 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
	 *     custom dialog directive.
	 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
	 *     the location of the click will be used as the starting point for the opening animation
	 *     of the the dialog.
	 *   - `openFrom` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
	 *     originate.
	 *   - `closeTo` - `{string|Element|object}`: The query selector, DOM element or the Rect object
	 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
	 *     target.
	 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
	 *     it will create a new isolate scope.
	 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to true.
	 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
	 *     Default true.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
	 *     Default true.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
	 *     close it. Default false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
	 *     Default true.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
	 *     focusing some other way, as focus management is required for dialogs to be accessible.
	 *     Defaults to true.
	 *   - `controller` - `{function|string=}`: The controller to associate with the dialog. The controller
	 *     will be injected with the local `$mdDialog`, which passes along a scope for the dialog.
	 *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will be used as names
	 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
	 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
	 *     copied to the controller instead.
	 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values, and the
	 *     dialog will not open until all of the promises resolve.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
	 *     to the root element of the application.
	 *   - `onShowing` - `function(scope, element)`: Callback function used to announce the show() action is
	 *     starting.
	 *   - `onComplete` - `function(scope, element)`: Callback function used to announce when the show() action is
	 *     finished.
	 *   - `onRemoving` - `function(element, removePromise)`: Callback function used to announce the
	 *      close/hide() action is starting. This allows developers to run custom animations
	 *      in parallel the close animations.
	 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
	 *      or not. Defaults to `false`.
	 *   - `multiple` `{boolean=}`: An option to allow this dialog to display over one that's currently open.
	 * @returns {promise} A promise that can be resolved with `$mdDialog.hide()` or
	 * rejected with `$mdDialog.cancel()`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#hide
	 *
	 * @description
	 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the resolved promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdDialog#cancel
	 *
	 * @description
	 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
	 *
	 * @param {*=} response An argument for the rejected promise.
	 *
	 * @returns {promise} A promise that is resolved when the dialog has been closed.
	 */
	
	function MdDialogProvider($$interimElementProvider) {
	  // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
	  advancedDialogOptions.$inject = ["$mdDialog", "$mdConstant"];
	  dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector", "$mdTheming", "$interpolate", "$mdInteraction"];
	  var topFocusTrap, bottomFocusTrap;
	
	  return $$interimElementProvider('$mdDialog')
	    .setDefaults({
	      methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
	          'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen', 'multiple'],
	      options: dialogDefaultOptions
	    })
	    .addPreset('alert', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'theme',
	          'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('confirm', {
	      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'cancel',
	          'theme', 'css'],
	      options: advancedDialogOptions
	    })
	    .addPreset('prompt', {
	      methods: ['title', 'htmlContent', 'textContent', 'initialValue', 'content', 'placeholder', 'ariaLabel',
	          'ok', 'cancel', 'theme', 'css'],
	      options: advancedDialogOptions
	    });
	
	  /* @ngInject */
	  function advancedDialogOptions($mdDialog, $mdConstant) {
	    return {
	      template: [
	        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
	        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
	        '    <h2 class="md-title">{{ dialog.title }}</h2>',
	        '    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ',
	        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
	        '    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">',
	        '      <p>{{::dialog.mdTextContent}}</p>',
	        '    </div>',
	        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
	        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
	        '             placeholder="{{::dialog.placeholder}}">',
	        '    </md-input-container>',
	        '  </md-dialog-content>',
	        '  <md-dialog-actions>',
	        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
	        '               ng-click="dialog.abort()" class="md-primary md-cancel-button">',
	        '      {{ dialog.cancel }}',
	        '    </md-button>',
	        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'">',
	        '      {{ dialog.ok }}',
	        '    </md-button>',
	        '  </md-dialog-actions>',
	        '</md-dialog>'
	      ].join('').replace(/\s\s+/g, ''),
	      controller: function mdDialogCtrl() {
	        var isPrompt = this.$type == 'prompt';
	
	        if (isPrompt && this.initialValue) {
	          this.result = this.initialValue;
	        }
	
	        this.hide = function() {
	          $mdDialog.hide(isPrompt ? this.result : true);
	        };
	        this.abort = function() {
	          $mdDialog.cancel();
	        };
	        this.keypress = function($event) {
	          if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
	            $mdDialog.hide(this.result);
	          }
	        };
	      },
	      controllerAs: 'dialog',
	      bindToController: true,
	    };
	  }
	
	  /* @ngInject */
	  function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document, $window, $rootElement,
	                                $log, $injector, $mdTheming, $interpolate, $mdInteraction) {
	
	    return {
	      hasBackdrop: true,
	      isolateScope: true,
	      onCompiling: beforeCompile,
	      onShow: onShow,
	      onShowing: beforeShow,
	      onRemove: onRemove,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      targetEvent: null,
	      closeTo: null,
	      openFrom: null,
	      focusOnOpen: true,
	      disableParentScroll: true,
	      autoWrap: true,
	      fullscreen: false,
	      transformTemplate: function(template, options) {
	        // Make the dialog container focusable, because otherwise the focus will be always redirected to
	        // an element outside of the container, and the focus trap won't work probably..
	        // Also the tabindex is needed for the `escapeToClose` functionality, because
	        // the keyDown event can't be triggered when the focus is outside of the container.
	        var startSymbol = $interpolate.startSymbol();
	        var endSymbol = $interpolate.endSymbol();
	        var theme = startSymbol + (options.themeWatch ? '' : '::') + 'theme' + endSymbol;
	        return '<div class="md-dialog-container" tabindex="-1" md-theme="' + theme + '">' + validatedTemplate(template) + '</div>';
	
	        /**
	         * The specified template should contain a <md-dialog> wrapper element....
	         */
	        function validatedTemplate(template) {
	          if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
	            return '<md-dialog>' + (template || '') + '</md-dialog>';
	          } else {
	            return template || '';
	          }
	        }
	      }
	    };
	
	    function beforeCompile(options) {
	      // Automatically apply the theme, if the user didn't specify a theme explicitly.
	      // Those option changes need to be done, before the compilation has started, because otherwise
	      // the option changes will be not available in the $mdCompilers locales.
	      options.defaultTheme = $mdTheming.defaultTheme();
	
	      detectTheming(options);
	    }
	
	    function beforeShow(scope, element, options, controller) {
	
	      if (controller) {
	        var mdHtmlContent = controller.htmlContent || options.htmlContent || '';
	        var mdTextContent = controller.textContent || options.textContent ||
	            controller.content || options.content || '';
	
	        if (mdHtmlContent && !$injector.has('$sanitize')) {
	          throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
	        }
	
	        if (mdHtmlContent && mdTextContent) {
	          throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
	        }
	
	        // Only assign the content if nothing throws, otherwise it'll still be compiled.
	        controller.mdHtmlContent = mdHtmlContent;
	        controller.mdTextContent = mdTextContent;
	      }
	    }
	
	    /** Show method for dialogs */
	    function onShow(scope, element, options, controller) {
	      angular.element($document[0].body).addClass('md-dialog-is-showing');
	
	      var dialogElement = element.find('md-dialog');
	
	      // Once a dialog has `ng-cloak` applied on his template the dialog animation will not work properly.
	      // This is a very common problem, so we have to notify the developer about this.
	      if (dialogElement.hasClass('ng-cloak')) {
	        var message = '$mdDialog: using `<md-dialog ng-cloak>` will affect the dialog opening animations.';
	        $log.warn( message, element[0] );
	      }
	
	      captureParentAndFromToElements(options);
	      configureAria(dialogElement, options);
	      showBackdrop(scope, element, options);
	      activateListeners(element, options);
	
	      return dialogPopIn(element, options)
	        .then(function() {
	          lockScreenReader(element, options);
	          warnDeprecatedActions();
	          focusOnOpen();
	        });
	
	      /**
	       * Check to see if they used the deprecated .md-actions class and log a warning
	       */
	      function warnDeprecatedActions() {
	        if (element[0].querySelector('.md-actions')) {
	          $log.warn('Using a class of md-actions is deprecated, please use <md-dialog-actions>.');
	        }
	      }
	
	      /**
	       * For alerts, focus on content... otherwise focus on
	       * the close button (or equivalent)
	       */
	      function focusOnOpen() {
	        if (options.focusOnOpen) {
	          var target = $mdUtil.findFocusTarget(element) || findCloseButton() || dialogElement;
	          target.focus();
	        }
	
	        /**
	         * If no element with class dialog-close, try to find the last
	         * button child in md-actions and assume it is a close button.
	         *
	         * If we find no actions at all, log a warning to the console.
	         */
	        function findCloseButton() {
	          return element[0].querySelector('.dialog-close, md-dialog-actions button:last-child');
	        }
	      }
	    }
	
	    /**
	     * Remove function for all dialogs
	     */
	    function onRemove(scope, element, options) {
	      options.deactivateListeners();
	      options.unlockScreenReader();
	      options.hideBackdrop(options.$destroy);
	
	      // Remove the focus traps that we added earlier for keeping focus within the dialog.
	      if (topFocusTrap && topFocusTrap.parentNode) {
	        topFocusTrap.parentNode.removeChild(topFocusTrap);
	      }
	
	      if (bottomFocusTrap && bottomFocusTrap.parentNode) {
	        bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
	      }
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	      return !!options.$destroy ? detachAndClean() : animateRemoval().then( detachAndClean );
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return dialogPopOut(element, options);
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        angular.element($document[0].body).removeClass('md-dialog-is-showing');
	
	        // Reverse the container stretch if using a content element.
	        if (options.contentElement) {
	          options.reverseContainerStretch();
	        }
	
	        // Exposed cleanup function from the $mdCompiler.
	        options.cleanupElement();
	
	        // Restores the focus to the origin element if the last interaction upon opening was a keyboard.
	        if (!options.$destroy && options.originInteraction === 'keyboard') {
	          options.origin.focus();
	        }
	      }
	    }
	
	    function detectTheming(options) {
	      // Once the user specifies a targetEvent, we will automatically try to find the correct
	      // nested theme.
	      var targetEl;
	      if (options.targetEvent && options.targetEvent.target) {
	        targetEl = angular.element(options.targetEvent.target);
	      }
	
	      var themeCtrl = targetEl && targetEl.controller('mdTheme');
	
	      if (!themeCtrl) {
	        return;
	      }
	
	      options.themeWatch = themeCtrl.$shouldWatch;
	
	      var theme = options.theme || themeCtrl.$mdTheme;
	
	      if (theme) {
	        options.scope.theme = theme;
	      }
	
	      var unwatch = themeCtrl.registerChanges(function (newTheme) {
	        options.scope.theme = newTheme;
	
	        if (!options.themeWatch) {
	          unwatch();
	        }
	      });
	    }
	
	    /**
	     * Capture originator/trigger/from/to element information (if available)
	     * and the parent container for the dialog; defaults to the $rootElement
	     * unless overridden in the options.parent
	     */
	    function captureParentAndFromToElements(options) {
	          options.origin = angular.extend({
	            element: null,
	            bounds: null,
	            focus: angular.noop
	          }, options.origin || {});
	
	          options.parent   = getDomElement(options.parent, $rootElement);
	          options.closeTo  = getBoundingClientRect(getDomElement(options.closeTo));
	          options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));
	
	          if ( options.targetEvent ) {
	            options.origin = getBoundingClientRect(options.targetEvent.target, options.origin);
	            options.originInteraction = $mdInteraction.getLastInteractionType();
	          }
	
	
	          /**
	           * Identify the bounding RECT for the target element
	           *
	           */
	          function getBoundingClientRect (element, orig) {
	            var source = angular.element((element || {}));
	            if (source && source.length) {
	              // Compute and save the target element's bounding rect, so that if the
	              // element is hidden when the dialog closes, we can shrink the dialog
	              // back to the same position it expanded from.
	              //
	              // Checking if the source is a rect object or a DOM element
	              var bounds = {top:0,left:0,height:0,width:0};
	              var hasFn = angular.isFunction(source[0].getBoundingClientRect);
	
	              return angular.extend(orig || {}, {
	                  element : hasFn ? source : undefined,
	                  bounds  : hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
	                  focus   : angular.bind(source, source.focus),
	              });
	            }
	          }
	
	          /**
	           * If the specifier is a simple string selector, then query for
	           * the DOM element.
	           */
	          function getDomElement(element, defaultElement) {
	            if (angular.isString(element)) {
	              element = $document[0].querySelector(element);
	            }
	
	            // If we have a reference to a raw dom element, always wrap it in jqLite
	            return angular.element(element || defaultElement);
	          }
	
	        }
	
	    /**
	     * Listen for escape keys and outside clicks to auto close
	     */
	    function activateListeners(element, options) {
	      var window = angular.element($window);
	      var onWindowResize = $mdUtil.debounce(function() {
	        stretchDialogContainerToViewport(element, options);
	      }, 60);
	
	      var removeListeners = [];
	      var smartClose = function() {
	        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
	        // cancel or fallback to hide.
	        var closeFn = ( options.$type == 'alert' ) ? $mdDialog.hide : $mdDialog.cancel;
	        $mdUtil.nextTick(closeFn, true);
	      };
	
	      if (options.escapeToClose) {
	        var parentTarget = options.parent;
	        var keyHandlerFn = function(ev) {
	          if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add keydown listeners
	        element.on('keydown', keyHandlerFn);
	        parentTarget.on('keydown', keyHandlerFn);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	
	          element.off('keydown', keyHandlerFn);
	          parentTarget.off('keydown', keyHandlerFn);
	
	        });
	      }
	
	      // Register listener to update dialog on window resize
	      window.on('resize', onWindowResize);
	
	      removeListeners.push(function() {
	        window.off('resize', onWindowResize);
	      });
	
	      if (options.clickOutsideToClose) {
	        var target = element;
	        var sourceElem;
	
	        // Keep track of the element on which the mouse originally went down
	        // so that we can only close the backdrop when the 'click' started on it.
	        // A simple 'click' handler does not work,
	        // it sets the target object as the element the mouse went down on.
	        var mousedownHandler = function(ev) {
	          sourceElem = ev.target;
	        };
	
	        // We check if our original element and the target is the backdrop
	        // because if the original was the backdrop and the target was inside the dialog
	        // we don't want to dialog to close.
	        var mouseupHandler = function(ev) {
	          if (sourceElem === target[0] && ev.target === target[0]) {
	            ev.stopPropagation();
	            ev.preventDefault();
	
	            smartClose();
	          }
	        };
	
	        // Add listeners
	        target.on('mousedown', mousedownHandler);
	        target.on('mouseup', mouseupHandler);
	
	        // Queue remove listeners function
	        removeListeners.push(function() {
	          target.off('mousedown', mousedownHandler);
	          target.off('mouseup', mouseupHandler);
	        });
	      }
	
	      // Attach specific `remove` listener handler
	      options.deactivateListeners = function() {
	        removeListeners.forEach(function(removeFn) {
	          removeFn();
	        });
	        options.deactivateListeners = null;
	      };
	    }
	
	    /**
	     * Show modal backdrop element...
	     */
	    function showBackdrop(scope, element, options) {
	
	      if (options.disableParentScroll) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-dialog-backdrop md-opaque");
	        $animate.enter(options.backdrop, options.parent);
	      }
	
	      /**
	       * Hide modal backdrop element...
	       */
	      options.hideBackdrop = function hideBackdrop($destroy) {
	        if (options.backdrop) {
	          if ( !!$destroy ) options.backdrop.remove();
	          else              $animate.leave(options.backdrop);
	        }
	
	
	        if (options.disableParentScroll) {
	          options.restoreScroll && options.restoreScroll();
	          delete options.restoreScroll;
	        }
	
	        options.hideBackdrop = null;
	      };
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for Dialogs
	     */
	    function configureAria(element, options) {
	
	      var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
	      var dialogContent = element.find('md-dialog-content');
	      var existingDialogId = element.attr('id');
	      var dialogContentId = 'dialogContent_' + (existingDialogId || $mdUtil.nextUid());
	
	      element.attr({
	        'role': role,
	        'tabIndex': '-1'
	      });
	
	      if (dialogContent.length === 0) {
	        dialogContent = element;
	        // If the dialog element already had an ID, don't clobber it.
	        if (existingDialogId) {
	          dialogContentId = existingDialogId;
	        }
	      }
	
	      dialogContent.attr('id', dialogContentId);
	      element.attr('aria-describedby', dialogContentId);
	
	      if (options.ariaLabel) {
	        $mdAria.expect(element, 'aria-label', options.ariaLabel);
	      }
	      else {
	        $mdAria.expectAsync(element, 'aria-label', function() {
	          var words = dialogContent.text().split(/\s+/);
	          if (words.length > 3) words = words.slice(0, 3).concat('...');
	          return words.join(' ');
	        });
	      }
	
	      // Set up elements before and after the dialog content to capture focus and
	      // redirect back into the dialog.
	      topFocusTrap = document.createElement('div');
	      topFocusTrap.classList.add('md-dialog-focus-trap');
	      topFocusTrap.tabIndex = 0;
	
	      bottomFocusTrap = topFocusTrap.cloneNode(false);
	
	      // When focus is about to move out of the dialog, we want to intercept it and redirect it
	      // back to the dialog element.
	      var focusHandler = function() {
	        element.focus();
	      };
	      topFocusTrap.addEventListener('focus', focusHandler);
	      bottomFocusTrap.addEventListener('focus', focusHandler);
	
	      // The top focus trap inserted immeidately before the md-dialog element (as a sibling).
	      // The bottom focus trap is inserted at the very end of the md-dialog element (as a child).
	      element[0].parentNode.insertBefore(topFocusTrap, element[0]);
	      element.after(bottomFocusTrap);
	    }
	
	    /**
	     * Prevents screen reader interaction behind modal window
	     * on swipe interfaces
	     */
	    function lockScreenReader(element, options) {
	      var isHidden = true;
	
	      // get raw DOM node
	      walkDOM(element[0]);
	
	      options.unlockScreenReader = function() {
	        isHidden = false;
	        walkDOM(element[0]);
	
	        options.unlockScreenReader = null;
	      };
	
	      /**
	       * Walk DOM to apply or remove aria-hidden on sibling nodes
	       * and parent sibling nodes
	       *
	       */
	      function walkDOM(element) {
	        while (element.parentNode) {
	          if (element === document.body) {
	            return;
	          }
	          var children = element.parentNode.children;
	          for (var i = 0; i < children.length; i++) {
	            // skip over child if it is an ascendant of the dialog
	            // or a script or style tag
	            if (element !== children[i] && !isNodeOneOf(children[i], ['SCRIPT', 'STYLE'])) {
	              children[i].setAttribute('aria-hidden', isHidden);
	            }
	          }
	
	          walkDOM(element = element.parentNode);
	        }
	      }
	    }
	
	    /**
	     * Ensure the dialog container fill-stretches to the viewport
	     */
	    function stretchDialogContainerToViewport(container, options) {
	      var isFixed = $window.getComputedStyle($document[0].body).position == 'fixed';
	      var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
	      var height = backdrop ? Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10)))) : 0;
	
	      var previousStyles = {
	        top: container.css('top'),
	        height: container.css('height')
	      };
	
	      // If the body is fixed, determine the distance to the viewport in relative from the parent.
	      var parentTop = Math.abs(options.parent[0].getBoundingClientRect().top);
	
	      container.css({
	        top: (isFixed ? parentTop : 0) + 'px',
	        height: height ? height + 'px' : '100%'
	      });
	
	      return function() {
	        // Reverts the modified styles back to the previous values.
	        // This is needed for contentElements, which should have the same styles after close
	        // as before.
	        container.css(previousStyles);
	      };
	    }
	
	    /**
	     *  Dialog open and pop-in animation
	     */
	    function dialogPopIn(container, options) {
	      // Add the `md-dialog-container` to the DOM
	      options.parent.append(container);
	      options.reverseContainerStretch = stretchDialogContainerToViewport(container, options);
	
	      var dialogEl = container.find('md-dialog');
	      var animator = $mdUtil.dom.animator;
	      var buildTranslateToOrigin = animator.calculateZoomToOrigin;
	      var translateOptions = {transitionInClass: 'md-transition-in', transitionOutClass: 'md-transition-out'};
	      var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
	      var to = animator.toTransformCss("");  // defaults to center display (or parent or $rootElement)
	
	      dialogEl.toggleClass('md-dialog-fullscreen', !!options.fullscreen);
	
	      return animator
	        .translate3d(dialogEl, from, to, translateOptions)
	        .then(function(animateReversal) {
	
	          // Build a reversal translate function synced to this translation...
	          options.reverseAnimate = function() {
	            delete options.reverseAnimate;
	
	            if (options.closeTo) {
	              // Using the opposite classes to create a close animation to the closeTo element
	              translateOptions = {transitionInClass: 'md-transition-out', transitionOutClass: 'md-transition-in'};
	              from = to;
	              to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));
	
	              return animator
	                .translate3d(dialogEl, from, to,translateOptions);
	            }
	
	            return animateReversal(
	              to = animator.toTransformCss(
	                // in case the origin element has moved or is hidden,
	                // let's recalculate the translateCSS
	                buildTranslateToOrigin(dialogEl, options.origin)
	              )
	            );
	
	          };
	
	          // Function to revert the generated animation styles on the dialog element.
	          // Useful when using a contentElement instead of a template.
	          options.clearAnimate = function() {
	            delete options.clearAnimate;
	
	            // Remove the transition classes, added from $animateCSS, since those can't be removed
	            // by reversely running the animator.
	            dialogEl.removeClass([
	              translateOptions.transitionOutClass,
	              translateOptions.transitionInClass
	            ].join(' '));
	
	            // Run the animation reversely to remove the previous added animation styles.
	            return animator.translate3d(dialogEl, to, animator.toTransformCss(''), {});
	          };
	
	          return true;
	        });
	    }
	
	    /**
	     * Dialog close and pop-out animation
	     */
	    function dialogPopOut(container, options) {
	      return options.reverseAnimate().then(function() {
	        if (options.contentElement) {
	          // When we use a contentElement, we want the element to be the same as before.
	          // That means, that we have to clear all the animation properties, like transform.
	          options.clearAnimate();
	        }
	      });
	    }
	
	    /**
	     * Utility function to filter out raw DOM nodes
	     */
	    function isNodeOneOf(elem, nodeTypeArray) {
	      if (nodeTypeArray.indexOf(elem.nodeName) !== -1) {
	        return true;
	      }
	    }
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.divider
	 * @description Divider module!
	 */
	MdDividerDirective.$inject = ["$mdTheming"];
	angular.module('material.components.divider', [
	  'material.core'
	])
	  .directive('mdDivider', MdDividerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdDivider
	 * @module material.components.divider
	 * @restrict E
	 *
	 * @description
	 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
	 *
	 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
	 * @usage
	 * <hljs lang="html">
	 * <md-divider></md-divider>
	 *
	 * <md-divider md-inset></md-divider>
	 * </hljs>
	 *
	 */
	function MdDividerDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    link: $mdTheming
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabActions
	   */
	  MdFabActionsDirective.$inject = ["$mdUtil"];
	  angular
	    .module('material.components.fabActions', ['material.core'])
	    .directive('mdFabActions', MdFabActionsDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabActions
	   * @module material.components.fabActions
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
	   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
	   * proper event listeners.
	   *
	   * @usage
	   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
	   */
	  function MdFabActionsDirective($mdUtil) {
	    return {
	      restrict: 'E',
	
	      require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],
	
	      compile: function(element, attributes) {
	        var children = element.children();
	
	        var hasNgRepeat = $mdUtil.prefixer().hasAttribute(children, 'ng-repeat');
	
	        // Support both ng-repeat and static content
	        if (hasNgRepeat) {
	          children.addClass('md-fab-action-item');
	        } else {
	          // Wrap every child in a new div and add a class that we can scale/fling independently
	          children.wrap('<div class="md-fab-action-item">');
	        }
	      }
	    };
	  }
	
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
	  angular.module('material.components.fabShared', ['material.core'])
	    .controller('MdFabController', MdFabController);
	
	  function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
	    var vm = this;
	    var initialAnimationAttempts = 0;
	
	    // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops
	
	    vm.open = function() {
	      $scope.$evalAsync("vm.isOpen = true");
	    };
	
	    vm.close = function() {
	      // Async eval to avoid conflicts with existing digest loops
	      $scope.$evalAsync("vm.isOpen = false");
	
	      // Focus the trigger when the element closes so users can still tab to the next item
	      $element.find('md-fab-trigger')[0].focus();
	    };
	
	    // Toggle the open/close state when the trigger is clicked
	    vm.toggle = function() {
	      $scope.$evalAsync("vm.isOpen = !vm.isOpen");
	    };
	
	    /*
	     * AngularJS Lifecycle hook for newer AngularJS versions.
	     * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	     */
	    vm.$onInit = function() {
	      setupDefaults();
	      setupListeners();
	      setupWatchers();
	
	      fireInitialAnimations();
	    };
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	    function setupDefaults() {
	      // Set the default direction to 'down' if none is specified
	      vm.direction = vm.direction || 'down';
	
	      // Set the default to be closed
	      vm.isOpen = vm.isOpen || false;
	
	      // Start the keyboard interaction at the first action
	      resetActionIndex();
	
	      // Add an animations waiting class so we know not to run
	      $element.addClass('md-animations-waiting');
	    }
	
	    function setupListeners() {
	      var eventTypes = [
	        'click', 'focusin', 'focusout'
	      ];
	
	      // Add our listeners
	      angular.forEach(eventTypes, function(eventType) {
	        $element.on(eventType, parseEvents);
	      });
	
	      // Remove our listeners when destroyed
	      $scope.$on('$destroy', function() {
	        angular.forEach(eventTypes, function(eventType) {
	          $element.off(eventType, parseEvents);
	        });
	
	        // remove any attached keyboard handlers in case element is removed while
	        // speed dial is open
	        disableKeyboard();
	      });
	    }
	
	    var closeTimeout;
	    function parseEvents(event) {
	      // If the event is a click, just handle it
	      if (event.type == 'click') {
	        handleItemClick(event);
	      }
	
	      // If we focusout, set a timeout to close the element
	      if (event.type == 'focusout' && !closeTimeout) {
	        closeTimeout = $timeout(function() {
	          vm.close();
	        }, 100, false);
	      }
	
	      // If we see a focusin and there is a timeout about to run, cancel it so we stay open
	      if (event.type == 'focusin' && closeTimeout) {
	        $timeout.cancel(closeTimeout);
	        closeTimeout = null;
	      }
	    }
	
	    function resetActionIndex() {
	      vm.currentActionIndex = -1;
	    }
	
	    function setupWatchers() {
	      // Watch for changes to the direction and update classes/attributes
	      $scope.$watch('vm.direction', function(newDir, oldDir) {
	        // Add the appropriate classes so we can target the direction in the CSS
	        $animate.removeClass($element, 'md-' + oldDir);
	        $animate.addClass($element, 'md-' + newDir);
	
	        // Reset the action index since it may have changed
	        resetActionIndex();
	      });
	
	      var trigger, actions;
	
	      // Watch for changes to md-open
	      $scope.$watch('vm.isOpen', function(isOpen) {
	        // Reset the action index since it may have changed
	        resetActionIndex();
	
	        // We can't get the trigger/actions outside of the watch because the component hasn't been
	        // linked yet, so we wait until the first watch fires to cache them.
	        if (!trigger || !actions) {
	          trigger = getTriggerElement();
	          actions = getActionsElement();
	        }
	
	        if (isOpen) {
	          enableKeyboard();
	        } else {
	          disableKeyboard();
	        }
	
	        var toAdd = isOpen ? 'md-is-open' : '';
	        var toRemove = isOpen ? '' : 'md-is-open';
	
	        // Set the proper ARIA attributes
	        trigger.attr('aria-haspopup', true);
	        trigger.attr('aria-expanded', isOpen);
	        actions.attr('aria-hidden', !isOpen);
	
	        // Animate the CSS classes
	        $animate.setClass($element, toAdd, toRemove);
	      });
	    }
	
	    function fireInitialAnimations() {
	      // If the element is actually visible on the screen
	      if ($element[0].scrollHeight > 0) {
	        // Fire our animation
	        $animate.addClass($element, '_md-animations-ready').then(function() {
	          // Remove the waiting class
	          $element.removeClass('md-animations-waiting');
	        });
	      }
	
	      // Otherwise, try for up to 1 second before giving up
	      else if (initialAnimationAttempts < 10) {
	        $timeout(fireInitialAnimations, 100);
	
	        // Increment our counter
	        initialAnimationAttempts = initialAnimationAttempts + 1;
	      }
	    }
	
	    function enableKeyboard() {
	      $element.on('keydown', keyPressed);
	
	      // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
	      // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
	      $mdUtil.nextTick(function() {
	        angular.element(document).on('click touchend', checkForOutsideClick);
	      });
	
	      // TODO: On desktop, we should be able to reset the indexes so you cannot tab through, but
	      // this breaks accessibility, especially on mobile, since you have no arrow keys to press
	      //resetActionTabIndexes();
	    }
	
	    function disableKeyboard() {
	      $element.off('keydown', keyPressed);
	      angular.element(document).off('click touchend', checkForOutsideClick);
	    }
	
	    function checkForOutsideClick(event) {
	      if (event.target) {
	        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
	        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');
	
	        if (!closestTrigger && !closestActions) {
	          vm.close();
	        }
	      }
	    }
	
	    function keyPressed(event) {
	      switch (event.which) {
	        case $mdConstant.KEY_CODE.ESCAPE: vm.close(); event.preventDefault(); return false;
	        case $mdConstant.KEY_CODE.LEFT_ARROW: doKeyLeft(event); return false;
	        case $mdConstant.KEY_CODE.UP_ARROW: doKeyUp(event); return false;
	        case $mdConstant.KEY_CODE.RIGHT_ARROW: doKeyRight(event); return false;
	        case $mdConstant.KEY_CODE.DOWN_ARROW: doKeyDown(event); return false;
	      }
	    }
	
	    function doActionPrev(event) {
	      focusAction(event, -1);
	    }
	
	    function doActionNext(event) {
	      focusAction(event, 1);
	    }
	
	    function focusAction(event, direction) {
	      var actions = resetActionTabIndexes();
	
	      // Increment/decrement the counter with restrictions
	      vm.currentActionIndex = vm.currentActionIndex + direction;
	      vm.currentActionIndex = Math.min(actions.length - 1, vm.currentActionIndex);
	      vm.currentActionIndex = Math.max(0, vm.currentActionIndex);
	
	      // Focus the element
	      var focusElement =  angular.element(actions[vm.currentActionIndex]).children()[0];
	      angular.element(focusElement).attr('tabindex', 0);
	      focusElement.focus();
	
	      // Make sure the event doesn't bubble and cause something else
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    }
	
	    function resetActionTabIndexes() {
	      // Grab all of the actions
	      var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');
	
	      // Disable all other actions for tabbing
	      angular.forEach(actions, function(action) {
	        angular.element(angular.element(action).children()[0]).attr('tabindex', -1);
	      });
	
	      return actions;
	    }
	
	    function doKeyLeft(event) {
	      if (vm.direction === 'left') {
	        doActionNext(event);
	      } else {
	        doActionPrev(event);
	      }
	    }
	
	    function doKeyUp(event) {
	      if (vm.direction === 'down') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyRight(event) {
	      if (vm.direction === 'left') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function doKeyDown(event) {
	      if (vm.direction === 'up') {
	        doActionPrev(event);
	      } else {
	        doActionNext(event);
	      }
	    }
	
	    function isTrigger(element) {
	      return $mdUtil.getClosest(element, 'md-fab-trigger');
	    }
	
	    function isAction(element) {
	      return $mdUtil.getClosest(element, 'md-fab-actions');
	    }
	
	    function handleItemClick(event) {
	      if (isTrigger(event.target)) {
	        vm.toggle();
	      }
	
	      if (isAction(event.target)) {
	        vm.close();
	      }
	    }
	
	    function getTriggerElement() {
	      return $element.find('md-fab-trigger');
	    }
	
	    function getActionsElement() {
	      return $element.find('md-fab-actions');
	    }
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * The duration of the CSS animation in milliseconds.
	   *
	   * @type {number}
	   */
	  MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];
	  MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
	  var cssAnimationDuration = 300;
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabSpeedDial
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabSpeedDial', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabSpeedDial', MdFabSpeedDialDirective)
	
	    // Register our custom animations
	    .animation('.md-fling', MdFabSpeedDialFlingAnimation)
	    .animation('.md-scale', MdFabSpeedDialScaleAnimation)
	
	    // Register a service for each animation so that we can easily inject them into unit tests
	    .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
	    .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabSpeedDial
	   * @module material.components.fabSpeedDial
	   *
	   * @restrict E
	   *
	   * @description
	   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
	   * `<md-button>`s) for quick access to common actions.
	   *
	   * There are currently two animations available by applying one of the following classes to
	   * the component:
	   *
	   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
	   *    appropriate positions.
	   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-speed-dial>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
	   * open or close the speed dial. However, if you wish to allow users to hover over the empty
	   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
	   * dial element. Without this, the hover effect will only occur on top of the trigger.
	   *
	   * See the demos for more information.
	   *
	   * ## Troubleshooting
	   *
	   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
	   * the parent container to ensure that it is only visible once ready. We have plans to remove this
	   * necessity in the future.
	   *
	   * @usage
	   * <hljs lang="html">
	   * <md-fab-speed-dial md-direction="up" class="md-fling">
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-fab-actions>
	   *     <md-button aria-label="Add User">
	   *       <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *     </md-button>
	   *
	   *     <md-button aria-label="Add Group">
	   *       <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *     </md-button>
	   *   </md-fab-actions>
	   * </md-fab-speed-dial>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the speed dial to appear
	   * relative to the trigger element.
	   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
	   */
	  function MdFabSpeedDialDirective() {
	    return {
	      restrict: 'E',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: FabSpeedDialLink
	    };
	
	    function FabSpeedDialLink(scope, element) {
	      // Prepend an element to hold our CSS variables so we can use them in the animations below
	      element.prepend('<div class="_md-css-variables"></div>');
	    }
	  }
	
	  function MdFabSpeedDialFlingAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    function runAnimation(element) {
	      // Don't run if we are still waiting and we are not ready
	      if (element.hasClass('md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our trigger element
	      var triggerElement = el.querySelector('md-fab-trigger');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style;
	
	        styles.transform = styles.webkitTransform = '';
	        styles.transitionDelay = '';
	        styles.opacity = 1;
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	
	      // Set the trigger to be above all of the actions so they disappear behind it.
	      triggerElement.style.zIndex = startZIndex + items.length + 1;
	
	      // If the control is closed, hide the items behind the trigger
	      if (!ctrl.isOpen) {
	        angular.forEach(items, function(item, index) {
	          var newPosition, axis;
	          var styles = item.style;
	
	          // Make sure to account for differences in the dimensions of the trigger verses the items
	          // so that we can properly center everything; this helps hide the item's shadows behind
	          // the trigger.
	          var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
	          var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;
	
	          switch (ctrl.direction) {
	            case 'up':
	              newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'down':
	              newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
	              axis = 'Y';
	              break;
	            case 'left':
	              newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	            case 'right':
	              newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
	              axis = 'X';
	              break;
	          }
	
	          var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';
	
	          styles.transform = styles.webkitTransform = newTranslate;
	        });
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        if (element.hasClass('md-fling')) {
	          runAnimation(element);
	          delayDone(done);
	        } else {
	          done();
	        }
	      },
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	
	  function MdFabSpeedDialScaleAnimation($timeout) {
	    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }
	
	    var delay = 65;
	
	    function runAnimation(element) {
	      var el = element[0];
	      var ctrl = element.controller('mdFabSpeedDial');
	      var items = el.querySelectorAll('.md-fab-action-item');
	
	      // Grab our element which stores CSS variables
	      var variablesElement = el.querySelector('._md-css-variables');
	
	      // Setup JS variables based on our CSS variables
	      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);
	
	      // Always reset the items to their natural position/state
	      angular.forEach(items, function(item, index) {
	        var styles = item.style,
	          offsetDelay = index * delay;
	
	        styles.opacity = ctrl.isOpen ? 1 : 0;
	        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
	        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';
	
	        // Make the items closest to the trigger have the highest z-index
	        styles.zIndex = (items.length - index) + startZIndex;
	      });
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element);
	        delayDone(done);
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc module
	   * @name material.components.fabToolbar
	   */
	  angular
	    // Declare our module
	    .module('material.components.fabToolbar', [
	      'material.core',
	      'material.components.fabShared',
	      'material.components.fabActions'
	    ])
	
	    // Register our directive
	    .directive('mdFabToolbar', MdFabToolbarDirective)
	
	    // Register our custom animations
	    .animation('.md-fab-toolbar', MdFabToolbarAnimation)
	
	    // Register a service for the animation so that we can easily inject it into unit tests
	    .service('mdFabToolbarAnimation', MdFabToolbarAnimation);
	
	  /**
	   * @ngdoc directive
	   * @name mdFabToolbar
	   * @module material.components.fabToolbar
	   *
	   * @restrict E
	   *
	   * @description
	   *
	   * The `<md-fab-toolbar>` directive is used to present a toolbar of elements (usually `<md-button>`s)
	   * for quick access to common actions when a floating action button is activated (via click or
	   * keyboard navigation).
	   *
	   * You may also easily position the trigger by applying one one of the following classes to the
	   * `<md-fab-toolbar>` element:
	   *  - `md-fab-top-left`
	   *  - `md-fab-top-right`
	   *  - `md-fab-bottom-left`
	   *  - `md-fab-bottom-right`
	   *
	   * These CSS classes use `position: absolute`, so you need to ensure that the container element
	   * also uses `position: absolute` or `position: relative` in order for them to work.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   * <md-fab-toolbar md-direction='left'>
	   *   <md-fab-trigger>
	   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
	   *   </md-fab-trigger>
	   *
	   *   <md-toolbar>
	   *    <md-fab-actions>
	   *      <md-button aria-label="Add User">
	   *        <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
	   *      </md-button>
	   *
	   *      <md-button aria-label="Add Group">
	   *        <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
	   *      </md-button>
	   *    </md-fab-actions>
	   *   </md-toolbar>
	   * </md-fab-toolbar>
	   * </hljs>
	   *
	   * @param {string} md-direction From which direction you would like the toolbar items to appear
	   * relative to the trigger element. Supports `left` and `right` directions.
	   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
	   */
	  function MdFabToolbarDirective() {
	    return {
	      restrict: 'E',
	      transclude: true,
	      template: '<div class="md-fab-toolbar-wrapper">' +
	      '  <div class="md-fab-toolbar-content" ng-transclude></div>' +
	      '</div>',
	
	      scope: {
	        direction: '@?mdDirection',
	        isOpen: '=?mdOpen'
	      },
	
	      bindToController: true,
	      controller: 'MdFabController',
	      controllerAs: 'vm',
	
	      link: link
	    };
	
	    function link(scope, element, attributes) {
	      // Add the base class for animations
	      element.addClass('md-fab-toolbar');
	
	      // Prepend the background element to the trigger's button
	      element.find('md-fab-trigger').find('button')
	        .prepend('<div class="md-fab-toolbar-background"></div>');
	    }
	  }
	
	  function MdFabToolbarAnimation() {
	
	    function runAnimation(element, className, done) {
	      // If no className was specified, don't do anything
	      if (!className) {
	        return;
	      }
	
	      var el = element[0];
	      var ctrl = element.controller('mdFabToolbar');
	
	      // Grab the relevant child elements
	      var backgroundElement = el.querySelector('.md-fab-toolbar-background');
	      var triggerElement = el.querySelector('md-fab-trigger button');
	      var toolbarElement = el.querySelector('md-toolbar');
	      var iconElement = el.querySelector('md-fab-trigger button md-icon');
	      var actions = element.find('md-fab-actions').children();
	
	      // If we have both elements, use them to position the new background
	      if (triggerElement && backgroundElement) {
	        // Get our variables
	        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
	        var width = el.offsetWidth;
	        var height = el.offsetHeight;
	
	        // Make it twice as big as it should be since we scale from the center
	        var scale = 2 * (width / triggerElement.offsetWidth);
	
	        // Set some basic styles no matter what animation we're doing
	        backgroundElement.style.backgroundColor = color;
	        backgroundElement.style.borderRadius = width + 'px';
	
	        // If we're open
	        if (ctrl.isOpen) {
	          // Turn on toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'inherit';
	
	          backgroundElement.style.width = triggerElement.offsetWidth + 'px';
	          backgroundElement.style.height = triggerElement.offsetHeight + 'px';
	          backgroundElement.style.transform = 'scale(' + scale + ')';
	
	          // Set the next close animation to have the proper delays
	          backgroundElement.style.transitionDelay = '0ms';
	          iconElement && (iconElement.style.transitionDelay = '.3s');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
	          });
	        } else {
	          // Turn off toolbar pointer events when closed
	          toolbarElement.style.pointerEvents = 'none';
	
	          // Scale it back down to the trigger's size
	          backgroundElement.style.transform = 'scale(1)';
	
	          // Reset the position
	          backgroundElement.style.top = '0';
	
	          if (element.hasClass('md-right')) {
	            backgroundElement.style.left = '0';
	            backgroundElement.style.right = null;
	          }
	
	          if (element.hasClass('md-left')) {
	            backgroundElement.style.right = '0';
	            backgroundElement.style.left = null;
	          }
	
	          // Set the next open animation to have the proper delays
	          backgroundElement.style.transitionDelay = '200ms';
	          iconElement && (iconElement.style.transitionDelay = '0ms');
	
	          // Apply a transition delay to actions
	          angular.forEach(actions, function(action, index) {
	            action.style.transitionDelay = 200 + (index * 25) + 'ms';
	          });
	        }
	      }
	    }
	
	    return {
	      addClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      },
	
	      removeClass: function(element, className, done) {
	        runAnimation(element, className, done);
	        done();
	      }
	    };
	  }
	})();
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.gridList
	 */
	GridListController.$inject = ["$mdUtil"];
	GridLayoutFactory.$inject = ["$mdUtil"];
	GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia"];
	GridTileDirective.$inject = ["$mdMedia"];
	angular.module('material.components.gridList', ['material.core'])
	       .directive('mdGridList', GridListDirective)
	       .directive('mdGridTile', GridTileDirective)
	       .directive('mdGridTileFooter', GridTileCaptionDirective)
	       .directive('mdGridTileHeader', GridTileCaptionDirective)
	       .factory('$mdGridLayout', GridLayoutFactory);
	
	/**
	 * @ngdoc directive
	 * @name mdGridList
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Grid lists are an alternative to standard list views. Grid lists are distinct
	 * from grids used for layouts and other visual presentations.
	 *
	 * A grid list is best suited to presenting a homogenous data type, typically
	 * images, and is optimized for visual comprehension and differentiating between
	 * like data types.
	 *
	 * A grid list is a continuous element consisting of tessellated, regular
	 * subdivisions called cells that contain tiles (`md-grid-tile`).
	 *
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
	 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
	 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
	 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
	 *
	 * Cells are arrayed vertically and horizontally within the grid.
	 *
	 * Tiles hold content and can span one or more cells vertically or horizontally.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-list` directive supports "responsive" attributes, which allow
	 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
	 * currently matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-cols-lg="8"`)
	 *
	 * @param {number} md-cols Number of columns in the grid.
	 * @param {string} md-row-height One of
	 * <ul>
	 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
	 *   <li>`{width}:{height}` - Ratio of width to height (eg.
	 *   `md-row-height="16:9"`)</li>
	 *   <li>`"fit"` - Height will be determined by subdividing the available
	 *   height by the number of rows</li>
	 * </ul>
	 * @param {string=} md-gutter The amount of space between tiles in CSS units
	 *     (default 1px)
	 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
	 *     object is available as `$event`, and contains performance information.
	 *
	 * @usage
	 * Basic:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fixed-height rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="200px" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Fit rows:
	 * <hljs lang="html">
	 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 *
	 * Using responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-list
	 *     md-cols-sm="2"
	 *     md-cols-md="4"
	 *     md-cols-lg="8"
	 *     md-cols-gt-lg="12"
	 *     ...>
	 *   <md-grid-tile></md-grid-tile>
	 * </md-grid-list>
	 * </hljs>
	 */
	function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia) {
	  return {
	    restrict: 'E',
	    controller: GridListController,
	    scope: {
	      mdOnLayout: '&'
	    },
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, ctrl) {
	    element.addClass('_md');     // private md component indicator for styling
	    
	    // Apply semantics
	    element.attr('role', 'list');
	
	    // Provide the controller with a way to trigger layouts.
	    ctrl.layoutDelegate = layoutDelegate;
	
	    var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
	        unwatchAttrs = watchMedia();
	      scope.$on('$destroy', unwatchMedia);
	
	    /**
	     * Watches for changes in media, invalidating layout as necessary.
	     */
	    function watchMedia() {
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia(mediaName); // initialize
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .addListener(invalidateLayout);
	      }
	      return $mdMedia.watchResponsiveAttributes(
	          ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
	    }
	
	    function unwatchMedia() {
	      ctrl.layoutDelegate = angular.noop;
	
	      unwatchAttrs();
	      for (var mediaName in $mdConstant.MEDIA) {
	        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
	            .removeListener(invalidateLayout);
	      }
	    }
	
	    /**
	     * Performs grid layout if the provided mediaName matches the currently
	     * active media type.
	     */
	    function layoutIfMediaMatch(mediaName) {
	      if (mediaName == null) {
	        // TODO(shyndman): It would be nice to only layout if we have
	        // instances of attributes using this media type
	        ctrl.invalidateLayout();
	      } else if ($mdMedia(mediaName)) {
	        ctrl.invalidateLayout();
	      }
	    }
	
	    var lastLayoutProps;
	
	    /**
	     * Invokes the layout engine, and uses its results to lay out our
	     * tile elements.
	     *
	     * @param {boolean} tilesInvalidated Whether tiles have been
	     *    added/removed/moved since the last layout. This is to avoid situations
	     *    where tiles are replaced with properties identical to their removed
	     *    counterparts.
	     */
	    function layoutDelegate(tilesInvalidated) {
	      var tiles = getTileElements();
	      var props = {
	        tileSpans: getTileSpans(tiles),
	        colCount: getColumnCount(),
	        rowMode: getRowMode(),
	        rowHeight: getRowHeight(),
	        gutter: getGutter()
	      };
	
	      if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
	        return;
	      }
	
	      var performance =
	        $mdGridLayout(props.colCount, props.tileSpans, tiles)
	          .map(function(tilePositions, rowCount) {
	            return {
	              grid: {
	                element: element,
	                style: getGridStyle(props.colCount, rowCount,
	                    props.gutter, props.rowMode, props.rowHeight)
	              },
	              tiles: tilePositions.map(function(ps, i) {
	                return {
	                  element: angular.element(tiles[i]),
	                  style: getTileStyle(ps.position, ps.spans,
	                      props.colCount, rowCount,
	                      props.gutter, props.rowMode, props.rowHeight)
	                }
	              })
	            }
	          })
	          .reflow()
	          .performance();
	
	      // Report layout
	      scope.mdOnLayout({
	        $event: {
	          performance: performance
	        }
	      });
	
	      lastLayoutProps = props;
	    }
	
	    // Use $interpolate to do some simple string interpolation as a convenience.
	
	    var startSymbol = $interpolate.startSymbol();
	    var endSymbol = $interpolate.endSymbol();
	
	    // Returns an expression wrapped in the interpolator's start and end symbols.
	    function expr(exprStr) {
	      return startSymbol + exprStr + endSymbol;
	    }
	
	    // The amount of space a single 1x1 tile would take up (either width or height), used as
	    // a basis for other calculations. This consists of taking the base size percent (as would be
	    // if evenly dividing the size between cells), and then subtracting the size of one gutter.
	    // However, since there are no gutters on the edges, each tile only uses a fration
	    // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
	    // tile, and then breaking up the extra gutter on the edge evenly among the cells).
	    var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');
	
	    // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
	    // row/column (offset).
	    var POSITION  = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');
	
	    // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
	    // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
	    // in the space that the gutter would normally have used (which was already accounted for in
	    // the base unit calculation).
	    var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');
	
	    /**
	     * Gets the styles applied to a tile element described by the given parameters.
	     * @param {{row: number, col: number}} position The row and column indices of the tile.
	     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
	     * @param {number} colCount The number of columns.
	     * @param {number} rowCount The number of rows.
	     * @param {string} gutter The amount of space between tiles. This will be something like
	     *     '5px' or '2em'.
	     * @param {string} rowMode The row height mode. Can be one of:
	     *     'fixed': all rows have a fixed size, given by rowHeight,
	     *     'ratio': row height defined as a ratio to width, or
	     *     'fit': fit to the grid-list element height, divinding evenly among rows.
	     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
	     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
	     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
	     *     values for top, left, width, height, marginTop, and paddingTop.
	     */
	    function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
	      // TODO(shyndman): There are style caching opportunities here.
	
	      // Percent of the available horizontal space that one column takes up.
	      var hShare = (1 / colCount) * 100;
	
	      // Fraction of the gutter size that each column takes up.
	      var hGutterShare = (colCount - 1) / colCount;
	
	      // Base horizontal size of a column.
	      var hUnit = UNIT({share: hShare, gutterShare: hGutterShare, gutter: gutter});
	
	      // The width and horizontal position of each tile is always calculated the same way, but the
	      // height and vertical position depends on the rowMode.
	      var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
	      var style = ltr ? {
	          left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	          width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	          // resets
	          paddingTop: '',
	          marginTop: '',
	          top: '',
	          height: ''
	        } : {
	        right: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
	        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
	        // resets
	        paddingTop: '',
	        marginTop: '',
	        top: '',
	        height: ''
	      };
	
	      switch (rowMode) {
	        case 'fixed':
	          // In fixed mode, simply use the given rowHeight.
	          style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
	          style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
	          break;
	
	        case 'ratio':
	          // Percent of the available vertical space that one row takes up. Here, rowHeight holds
	          // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
	          var vShare = hShare / rowHeight;
	
	          // Base veritcal size of a row.
	          var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          // padidngTop and marginTop are used to maintain the given aspect ratio, as
	          // a percentage-based value for these properties is applied to the *width* of the
	          // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
	          style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter});
	          style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
	          break;
	
	        case 'fit':
	          // Fraction of the gutter size that each column takes up.
	          var vGutterShare = (rowCount - 1) / rowCount;
	
	          // Percent of the available vertical space that one row takes up.
	          var vShare = (1 / rowCount) * 100;
	
	          // Base vertical size of a row.
	          var vUnit = UNIT({share: vShare, gutterShare: vGutterShare, gutter: gutter});
	
	          style.top = POSITION({unit: vUnit, offset: position.row, gutter: gutter});
	          style.height = DIMENSION({unit: vUnit, span: spans.row, gutter: gutter});
	          break;
	      }
	
	      return style;
	    }
	
	    function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
	      var style = {};
	
	      switch(rowMode) {
	        case 'fixed':
	          style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
	          style.paddingBottom = '';
	          break;
	
	        case 'ratio':
	          // rowHeight is width / height
	          var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
	              hShare = (1 / colCount) * 100,
	              vShare = hShare * (1 / rowHeight),
	              vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });
	
	          style.height = '';
	          style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter});
	          break;
	
	        case 'fit':
	          // noop, as the height is user set
	          break;
	      }
	
	      return style;
	    }
	
	    function getTileElements() {
	      return [].filter.call(element.children(), function(ele) {
	        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
	      });
	    }
	
	    /**
	     * Gets an array of objects containing the rowspan and colspan for each tile.
	     * @returns {Array<{row: number, col: number}>}
	     */
	    function getTileSpans(tileElements) {
	      return [].map.call(tileElements, function(ele) {
	        var ctrl = angular.element(ele).controller('mdGridTile');
	        return {
	          row: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
	          col: parseInt(
	              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
	        };
	      });
	    }
	
	    function getColumnCount() {
	      var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
	      if (isNaN(colCount)) {
	        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
	      }
	      return colCount;
	    }
	
	    function getGutter() {
	      return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
	    }
	
	    function getRowHeight() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      switch (getRowMode()) {
	        case 'fixed':
	          return applyDefaultUnit(rowHeight);
	        case 'ratio':
	          var whRatio = rowHeight.split(':');
	          return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
	        case 'fit':
	          return 0; // N/A
	      }
	    }
	
	    function getRowMode() {
	      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
	      if (!rowHeight) {
	        throw 'md-grid-list: md-row-height attribute was not found';
	      }
	
	      if (rowHeight == 'fit') {
	        return 'fit';
	      } else if (rowHeight.indexOf(':') !== -1) {
	        return 'ratio';
	      } else {
	        return 'fixed';
	      }
	    }
	
	    function applyDefaultUnit(val) {
	      return /\D$/.test(val) ? val : val + 'px';
	    }
	  }
	}
	
	/* @ngInject */
	function GridListController($mdUtil) {
	  this.layoutInvalidated = false;
	  this.tilesInvalidated = false;
	  this.$timeout_ = $mdUtil.nextTick;
	  this.layoutDelegate = angular.noop;
	}
	
	GridListController.prototype = {
	  invalidateTiles: function() {
	    this.tilesInvalidated = true;
	    this.invalidateLayout();
	  },
	
	  invalidateLayout: function() {
	    if (this.layoutInvalidated) {
	      return;
	    }
	    this.layoutInvalidated = true;
	    this.$timeout_(angular.bind(this, this.layout));
	  },
	
	  layout: function() {
	    try {
	      this.layoutDelegate(this.tilesInvalidated);
	    } finally {
	      this.layoutInvalidated = false;
	      this.tilesInvalidated = false;
	    }
	  }
	};
	
	
	/* @ngInject */
	function GridLayoutFactory($mdUtil) {
	  var defaultAnimator = GridTileAnimator;
	
	  /**
	   * Set the reflow animator callback
	   */
	  GridLayout.animateWith = function(customAnimator) {
	    defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
	  };
	
	  return GridLayout;
	
	  /**
	   * Publish layout function
	   */
	  function GridLayout(colCount, tileSpans) {
	      var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;
	
	      layoutTime = $mdUtil.time(function() {
	        layoutInfo = calculateGridFor(colCount, tileSpans);
	      });
	
	      return self = {
	
	        /**
	         * An array of objects describing each tile's position in the grid.
	         */
	        layoutInfo: function() {
	          return layoutInfo;
	        },
	
	        /**
	         * Maps grid positioning to an element and a set of styles using the
	         * provided updateFn.
	         */
	        map: function(updateFn) {
	          mapTime = $mdUtil.time(function() {
	            var info = self.layoutInfo();
	            gridStyles = updateFn(info.positioning, info.rowCount);
	          });
	          return self;
	        },
	
	        /**
	         * Default animator simply sets the element.css( <styles> ). An alternate
	         * animator can be provided as an argument. The function has the following
	         * signature:
	         *
	         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
	         */
	        reflow: function(animatorFn) {
	          reflowTime = $mdUtil.time(function() {
	            var animator = animatorFn || defaultAnimator;
	            animator(gridStyles.grid, gridStyles.tiles);
	          });
	          return self;
	        },
	
	        /**
	         * Timing for the most recent layout run.
	         */
	        performance: function() {
	          return {
	            tileCount: tileSpans.length,
	            layoutTime: layoutTime,
	            mapTime: mapTime,
	            reflowTime: reflowTime,
	            totalTime: layoutTime + mapTime + reflowTime
	          };
	        }
	      };
	    }
	
	  /**
	   * Default Gridlist animator simple sets the css for each element;
	   * NOTE: any transitions effects must be manually set in the CSS.
	   * e.g.
	   *
	   *  md-grid-tile {
	   *    transition: all 700ms ease-out 50ms;
	   *  }
	   *
	   */
	  function GridTileAnimator(grid, tiles) {
	    grid.element.css(grid.style);
	    tiles.forEach(function(t) {
	      t.element.css(t.style);
	    })
	  }
	
	  /**
	   * Calculates the positions of tiles.
	   *
	   * The algorithm works as follows:
	   *    An Array<Number> with length colCount (spaceTracker) keeps track of
	   *    available tiling positions, where elements of value 0 represents an
	   *    empty position. Space for a tile is reserved by finding a sequence of
	   *    0s with length <= than the tile's colspan. When such a space has been
	   *    found, the occupied tile positions are incremented by the tile's
	   *    rowspan value, as these positions have become unavailable for that
	   *    many rows.
	   *
	   *    If the end of a row has been reached without finding space for the
	   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
	   *    of 0. Rows are searched in this fashion until space is found.
	   */
	  function calculateGridFor(colCount, tileSpans) {
	    var curCol = 0,
	        curRow = 0,
	        spaceTracker = newSpaceTracker();
	
	    return {
	      positioning: tileSpans.map(function(spans, i) {
	        return {
	          spans: spans,
	          position: reserveSpace(spans, i)
	        };
	      }),
	      rowCount: curRow + Math.max.apply(Math, spaceTracker)
	    };
	
	    function reserveSpace(spans, i) {
	      if (spans.col > colCount) {
	        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
	            '(' + spans.col + ') that exceeds the column count ' +
	            '(' + colCount + ')';
	      }
	
	      var start = 0,
	          end = 0;
	
	      // TODO(shyndman): This loop isn't strictly necessary if you can
	      // determine the minimum number of rows before a space opens up. To do
	      // this, recognize that you've iterated across an entire row looking for
	      // space, and if so fast-forward by the minimum rowSpan count. Repeat
	      // until the required space opens up.
	      while (end - start < spans.col) {
	        if (curCol >= colCount) {
	          nextRow();
	          continue;
	        }
	
	        start = spaceTracker.indexOf(0, curCol);
	        if (start === -1 || (end = findEnd(start + 1)) === -1) {
	          start = end = 0;
	          nextRow();
	          continue;
	        }
	
	        curCol = end + 1;
	      }
	
	      adjustRow(start, spans.col, spans.row);
	      curCol = start + spans.col;
	
	      return {
	        col: start,
	        row: curRow
	      };
	    }
	
	    function nextRow() {
	      curCol = 0;
	      curRow++;
	      adjustRow(0, colCount, -1); // Decrement row spans by one
	    }
	
	    function adjustRow(from, cols, by) {
	      for (var i = from; i < from + cols; i++) {
	        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
	      }
	    }
	
	    function findEnd(start) {
	      var i;
	      for (i = start; i < spaceTracker.length; i++) {
	        if (spaceTracker[i] !== 0) {
	          return i;
	        }
	      }
	
	      if (i === spaceTracker.length) {
	        return i;
	      }
	    }
	
	    function newSpaceTracker() {
	      var tracker = [];
	      for (var i = 0; i < colCount; i++) {
	        tracker.push(0);
	      }
	      return tracker;
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdGridTile
	 * @module material.components.gridList
	 * @restrict E
	 * @description
	 * Tiles contain the content of an `md-grid-list`. They span one or more grid
	 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
	 * display secondary content.
	 *
	 * ### Responsive Attributes
	 *
	 * The `md-grid-tile` directive supports "responsive" attributes, which allow
	 * different `md-rowspan` and `md-colspan` values depending on the currently
	 * matching media query.
	 *
	 * In order to set a responsive attribute, first define the fallback value with
	 * the standard attribute name, then add additional attributes with the
	 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
	 * (ie. `md-colspan-sm="4"`)
	 *
	 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
	 *    exceed the number of columns in the grid. Supports interpolation.
	 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
	 *     interpolation.
	 *
	 * @usage
	 * With header:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-header>
	 *     <h3>This is a header</h3>
	 *   </md-grid-tile-header>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * With footer:
	 * <hljs lang="html">
	 * <md-grid-tile>
	 *   <md-grid-tile-footer>
	 *     <h3>This is a footer</h3>
	 *   </md-grid-tile-footer>
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Spanning multiple rows/columns:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="2" md-rowspan="3">
	 * </md-grid-tile>
	 * </hljs>
	 *
	 * Responsive attributes:
	 * <hljs lang="html">
	 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
	 * </md-grid-tile>
	 * </hljs>
	 */
	function GridTileDirective($mdMedia) {
	  return {
	    restrict: 'E',
	    require: '^mdGridList',
	    template: '<figure ng-transclude></figure>',
	    transclude: true,
	    scope: {},
	    // Simple controller that exposes attributes to the grid directive
	    controller: ["$attrs", function($attrs) {
	      this.$attrs = $attrs;
	    }],
	    link: postLink
	  };
	
	  function postLink(scope, element, attrs, gridCtrl) {
	    // Apply semantics
	    element.attr('role', 'listitem');
	
	    // If our colspan or rowspan changes, trigger a layout
	    var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
	        attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));
	
	    // Tile registration/deregistration
	    gridCtrl.invalidateTiles();
	    scope.$on('$destroy', function() {
	      // Mark the tile as destroyed so it is no longer considered in layout,
	      // even if the DOM element sticks around (like during a leave animation)
	      element[0].$$mdDestroyed = true;
	      unwatchAttrs();
	      gridCtrl.invalidateLayout();
	    });
	
	    if (angular.isDefined(scope.$parent.$index)) {
	      scope.$watch(function() { return scope.$parent.$index; },
	        function indexChanged(newIdx, oldIdx) {
	          if (newIdx === oldIdx) {
	            return;
	          }
	          gridCtrl.invalidateTiles();
	        });
	    }
	  }
	}
	
	
	function GridTileCaptionDirective() {
	  return {
	    template: '<figcaption ng-transclude></figcaption>',
	    transclude: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.icon
	 * @description
	 * Icon
	 */
	angular.module('material.components.icon', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.input
	 */
	mdInputContainerDirective.$inject = ["$mdTheming", "$parse"];
	inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
	mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
	placeholderDirective.$inject = ["$compile"];
	ngMessageDirective.$inject = ["$mdUtil"];
	mdSelectOnFocusDirective.$inject = ["$timeout"];
	mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
	var inputModule = angular.module('material.components.input', [
	    'material.core'
	  ])
	  .directive('mdInputContainer', mdInputContainerDirective)
	  .directive('label', labelDirective)
	  .directive('input', inputTextareaDirective)
	  .directive('textarea', inputTextareaDirective)
	  .directive('mdMaxlength', mdMaxlengthDirective)
	  .directive('placeholder', placeholderDirective)
	  .directive('ngMessages', ngMessagesDirective)
	  .directive('ngMessage', ngMessageDirective)
	  .directive('ngMessageExp', ngMessageDirective)
	  .directive('mdSelectOnFocus', mdSelectOnFocusDirective)
	
	  .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
	  .animation('.md-input-messages-animation', ngMessagesAnimation)
	  .animation('.md-input-message-animation', ngMessageAnimation);
	
	// If we are running inside of tests; expose some extra services so that we can test them
	if (window._mdMocksIncluded) {
	  inputModule.service('$$mdInput', function() {
	    return {
	      // special accessor to internals... useful for testing
	      messages: {
	        show        : showInputMessages,
	        hide        : hideInputMessages,
	        getElement  : getMessagesElement
	      }
	    }
	  })
	
	  // Register a service for each animation so that we can easily inject them into unit tests
	  .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
	  .service('mdInputMessagesAnimation', ngMessagesAnimation)
	  .service('mdInputMessageAnimation', ngMessageAnimation);
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInputContainer
	 * @module material.components.input
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-input-container>` is the parent of any input or textarea element.
	 *
	 * Input and textarea elements will not behave properly unless the md-input-container
	 * parent is provided.
	 *
	 * A single `<md-input-container>` should contain only one `<input>` element, otherwise it will throw an error.
	 *
	 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an error, so
	 * you may combine these with other inputs.
	 *
	 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container elements
	 * are *block* elements, otherwise animations applied to the messages will not look as intended. Either use a `div` and
	 * apply the `ng-message` and `ng-messages` classes respectively, or use the `md-block` class on your element.
	 *
	 * @param md-is-error {expression=} When the given expression evaluates to true, the input container
	 *   will go into error state. Defaults to erroring if the input has been touched and is invalid.
	 * @param md-no-float {boolean=} When present, `placeholder` attributes on the input will not be converted to floating
	 *   labels.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Username</label>
	 *   <input type="text" ng-model="user.name">
	 * </md-input-container>
	 *
	 * <md-input-container>
	 *   <label>Description</label>
	 *   <textarea ng-model="user.description"></textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 *
	 * <h3>When disabling floating labels</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container md-no-float>
	 *   <input type="text" placeholder="Non-Floating Label">
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdInputContainerDirective($mdTheming, $parse) {
	
	  ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
	  var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];
	
	  var LEFT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
	  }, []).join(",");
	
	  var RIGHT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
	    return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
	  }, []).join(",");
	
	  return {
	    restrict: 'E',
	    compile: compile,
	    controller: ContainerCtrl
	  };
	
	  function compile(tElement) {
	    // Check for both a left & right icon
	    var leftIcon = tElement[0].querySelector(LEFT_SELECTORS);
	    var rightIcon = tElement[0].querySelector(RIGHT_SELECTORS);
	
	    if (leftIcon) { tElement.addClass('md-icon-left'); }
	    if (rightIcon) { tElement.addClass('md-icon-right'); }
	
	    return function postLink(scope, element) {
	      $mdTheming(element);
	    };
	  }
	
	  function ContainerCtrl($scope, $element, $attrs, $animate) {
	    var self = this;
	
	    self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);
	
	    self.delegateClick = function() {
	      self.input.focus();
	    };
	    self.element = $element;
	    self.setFocused = function(isFocused) {
	      $element.toggleClass('md-input-focused', !!isFocused);
	    };
	    self.setHasValue = function(hasValue) {
	      $element.toggleClass('md-input-has-value', !!hasValue);
	    };
	    self.setHasPlaceholder = function(hasPlaceholder) {
	      $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
	    };
	    self.setInvalid = function(isInvalid) {
	      if (isInvalid) {
	        $animate.addClass($element, 'md-input-invalid');
	      } else {
	        $animate.removeClass($element, 'md-input-invalid');
	      }
	    };
	    $scope.$watch(function() {
	      return self.label && self.input;
	    }, function(hasLabelAndInput) {
	      if (hasLabelAndInput && !self.label.attr('for')) {
	        self.label.attr('for', self.input.attr('id'));
	      }
	    });
	  }
	}
	
	function labelDirective() {
	  return {
	    restrict: 'E',
	    require: '^?mdInputContainer',
	    link: function(scope, element, attr, containerCtrl) {
	      if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;
	
	      containerCtrl.label = element;
	      scope.$on('$destroy', function() {
	        containerCtrl.label = null;
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdInput
	 * @restrict E
	 * @module material.components.input
	 *
	 * @description
	 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
	 * allows you to build complex forms for data entry.
	 *
	 * When the input is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`).<br/>
	 * This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
	 *   specified, a character counter will be shown underneath the input.<br/><br/>
	 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
	 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
	 *   or maxlength attributes.<br/><br/>
	 *   **Note:** Only valid for text/string inputs (not numeric).
	 *
	 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
	 *   will be logged in the console if not present.
	 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
	 *   PRESENT. The placeholder text is copied to the aria-label attribute.
	 * @param md-no-autogrow {boolean=} When present, textareas will not grow automatically.
	 * @param md-no-asterisk {boolean=} When present, an asterisk will not be appended to the inputs floating label
	 * @param md-no-resize {boolean=} Disables the textarea resize handle.
	 * @param {number=} max-rows The maximum amount of rows for a textarea.
	 * @param md-detect-hidden {boolean=} When present, textareas will be sized properly when they are
	 *   revealed after being hidden. This is off by default for performance reasons because it
	 *   guarantees a reflow every digest cycle.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-input-container>
	 *   <label>Color</label>
	 *   <input type="text" ng-model="color" required md-maxlength="10">
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>With Errors</h3>
	 *
	 * `md-input-container` also supports errors using the standard `ng-messages` directives and
	 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
	 * the `ngShow`/`ngHide` events.
	 *
	 * By default, the messages will be hidden until the input is in an error state. This is based off
	 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
	 * fill out the form before the errors become visible.
	 *
	 * <hljs lang="html">
	 * <form name="colorForm">
	 *   <md-input-container>
	 *     <label>Favorite Color</label>
	 *     <input name="favoriteColor" ng-model="favoriteColor" required>
	 *     <div ng-messages="colorForm.favoriteColor.$error">
	 *       <div ng-message="required">This is required!</div>
	 *     </div>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * We automatically disable this auto-hiding functionality if you provide any of the following
	 * visibility directives on the `ng-messages` container:
	 *
	 *  - `ng-if`
	 *  - `ng-show`/`ng-hide`
	 *  - `ng-switch-when`/`ng-switch-default`
	 *
	 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
	 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
	 * or if you are building your own visibilty directive.
	 *
	 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
	 * initialization of the `ng-messages` directive to see if it equals the string `false`._
	 *
	 * <hljs lang="html">
	 * <form name="userForm">
	 *   <md-input-container>
	 *     <label>Last Name</label>
	 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
	 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *       <div ng-message="minlength">That's too short!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <label>Biography</label>
	 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
	 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
	 *       <div ng-message="required">This is required!</div>
	 *       <div ng-message="md-maxlength">That's too long!</div>
	 *     </div>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input aria-label='title' ng-model='title'>
	 *   </md-input-container>
	 *   <md-input-container>
	 *     <input placeholder='title' ng-model='title'>
	 *   </md-input-container>
	 * </form>
	 * </hljs>
	 *
	 * <h3>Notes</h3>
	 *
	 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
	 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
	 *
	 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
	 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
	 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
	 *
	 *
	 * <h3>Textarea directive</h3>
	 * The `textarea` element within a `md-input-container` has the following specific behavior:
	 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
	 * attribute.
	 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
	 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
	 * high initially. If no rows are specified, the directive defaults to 1.
	 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
	 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
	 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
	 * - If you want a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
	 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
	 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
	 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
	 */
	
	function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	
	    var containerCtrl = ctrls[0];
	    var hasNgModel = !!ctrls[1];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	    var parentForm = ctrls[2];
	    var isReadonly = angular.isDefined(attr.readonly);
	    var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	    var tagName = element[0].tagName.toLowerCase();
	
	
	    if (!containerCtrl) return;
	    if (attr.type === 'hidden') {
	      element.attr('aria-hidden', 'true');
	      return;
	    } else if (containerCtrl.input) {
	      if (containerCtrl.input[0].contains(element[0])) {
	        return;
	      } else {
	        throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
	      }
	    }
	    containerCtrl.input = element;
	
	    setupAttributeWatchers();
	
	    // Add an error spacer div after our input to provide space for the char counter and any ng-messages
	    var errorsSpacer = angular.element('<div class="md-errors-spacer">');
	    element.after(errorsSpacer);
	
	    if (!containerCtrl.label) {
	      $mdAria.expect(element, 'aria-label', attr.placeholder);
	    }
	
	    element.addClass('md-input');
	    if (!element.attr('id')) {
	      element.attr('id', 'input_' + $mdUtil.nextUid());
	    }
	
	    // This works around a Webkit issue where number inputs, placed in a flexbox, that have
	    // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
	    // for more info. Also note that we don't override the `step` if the user has specified it,
	    // in order to prevent some unexpected behaviour.
	    if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
	      element.attr('step', 'any');
	    } else if (tagName === 'textarea') {
	      setupTextarea();
	    }
	
	    // If the input doesn't have an ngModel, it may have a static value. For that case,
	    // we have to do one initial check to determine if the container should be in the
	    // "has a value" state.
	    if (!hasNgModel) {
	      inputCheckValue();
	    }
	
	    var isErrorGetter = containerCtrl.isErrorGetter || function() {
	      return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	    };
	
	    scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	
	    // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
	    // AngularJS's ngValue directive is just setting the `value` attribute.
	    if (attr.ngValue) {
	      attr.$observe('value', inputCheckValue);
	    }
	
	    ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
	    ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
	
	    element.on('input', inputCheckValue);
	
	    if (!isReadonly) {
	      element
	        .on('focus', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(true);
	          });
	        })
	        .on('blur', function(ev) {
	          $mdUtil.nextTick(function() {
	            containerCtrl.setFocused(false);
	            inputCheckValue();
	          });
	        });
	    }
	
	    scope.$on('$destroy', function() {
	      containerCtrl.setFocused(false);
	      containerCtrl.setHasValue(false);
	      containerCtrl.input = null;
	    });
	
	    /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
	    function ngModelPipelineCheckValue(arg) {
	      containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
	      return arg;
	    }
	
	    function setupAttributeWatchers() {
	      if (containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // We don't need to parse the required value, it's always a boolean because of angular's
	          // required directive.
	          containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
	        });
	      }
	    }
	
	    function inputCheckValue() {
	      // An input's value counts if its length > 0,
	      // or if the input's validity state says it has bad input (eg string in a number input)
	      containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
	    }
	
	    function setupTextarea() {
	      var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');
	
	      attachResizeHandle();
	
	      if (!isAutogrowing) return;
	
	      // Can't check if height was or not explicity set,
	      // so rows attribute will take precedence if present
	      var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
	      var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
	      var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
	      var lineHeight = null;
	      var node = element[0];
	
	      // This timeout is necessary, because the browser needs a little bit
	      // of time to calculate the `clientHeight` and `scrollHeight`.
	      $timeout(function() {
	        $mdUtil.nextTick(growTextarea);
	      }, 10, false);
	
	      // We could leverage ngModel's $parsers here, however it
	      // isn't reliable, because AngularJS trims the input by default,
	      // which means that growTextarea won't fire when newlines and
	      // spaces are added.
	      element.on('input', growTextarea);
	
	      // We should still use the $formatters, because they fire when
	      // the value was changed from outside the textarea.
	      if (hasNgModel) {
	        ngModelCtrl.$formatters.push(formattersListener);
	      }
	
	      if (!minRows) {
	        element.attr('rows', 1);
	      }
	
	      angular.element($window).on('resize', growTextarea);
	      scope.$on('$destroy', disableAutogrow);
	
	      function growTextarea() {
	        // temporarily disables element's flex so its height 'runs free'
	        element
	          .attr('rows', 1)
	          .css('height', 'auto')
	          .addClass('md-no-flex');
	
	        var height = getHeight();
	
	        if (!lineHeight) {
	          // offsetHeight includes padding which can throw off our value
	          var originalPadding = element[0].style.padding || '';
	          lineHeight = element.css('padding', 0).prop('offsetHeight');
	          element[0].style.padding = originalPadding;
	        }
	
	        if (minRows && lineHeight) {
	          height = Math.max(height, lineHeight * minRows);
	        }
	
	        if (maxRows && lineHeight) {
	          var maxHeight = lineHeight * maxRows;
	
	          if (maxHeight < height) {
	            element.attr('md-no-autogrow', '');
	            height = maxHeight;
	          } else {
	            element.removeAttr('md-no-autogrow');
	          }
	        }
	
	        if (lineHeight) {
	          element.attr('rows', Math.round(height / lineHeight));
	        }
	
	        element
	          .css('height', height + 'px')
	          .removeClass('md-no-flex');
	      }
	
	      function getHeight() {
	        var offsetHeight = node.offsetHeight;
	        var line = node.scrollHeight - offsetHeight;
	        return offsetHeight + Math.max(line, 0);
	      }
	
	      function formattersListener(value) {
	        $mdUtil.nextTick(growTextarea);
	        return value;
	      }
	
	      function disableAutogrow() {
	        if (!isAutogrowing) return;
	
	        isAutogrowing = false;
	        angular.element($window).off('resize', growTextarea);
	        scopeResizeListener && scopeResizeListener();
	        element
	          .attr('md-no-autogrow', '')
	          .off('input', growTextarea);
	
	        if (hasNgModel) {
	          var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);
	
	          if (listenerIndex > -1) {
	            ngModelCtrl.$formatters.splice(listenerIndex, 1);
	          }
	        }
	      }
	
	      function attachResizeHandle() {
	        if (attr.hasOwnProperty('mdNoResize')) return;
	
	        var handle = angular.element('<div class="md-resize-handle"></div>');
	        var isDragging = false;
	        var dragStart = null;
	        var startHeight = 0;
	        var container = containerCtrl.element;
	        var dragGestureHandler = $mdGesture.register(handle, 'drag', { horizontal: false });
	
	
	        element.wrap('<div class="md-resize-wrapper">').after(handle);
	        handle.on('mousedown', onMouseDown);
	
	        container
	          .on('$md.dragstart', onDragStart)
	          .on('$md.drag', onDrag)
	          .on('$md.dragend', onDragEnd);
	
	        scope.$on('$destroy', function() {
	          handle
	            .off('mousedown', onMouseDown)
	            .remove();
	
	          container
	            .off('$md.dragstart', onDragStart)
	            .off('$md.drag', onDrag)
	            .off('$md.dragend', onDragEnd);
	
	          dragGestureHandler();
	          handle = null;
	          container = null;
	          dragGestureHandler = null;
	        });
	
	        function onMouseDown(ev) {
	          ev.preventDefault();
	          isDragging = true;
	          dragStart = ev.clientY;
	          startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
	        }
	
	        function onDragStart(ev) {
	          if (!isDragging) return;
	          ev.preventDefault();
	          disableAutogrow();
	          container.addClass('md-input-resized');
	        }
	
	        function onDrag(ev) {
	          if (!isDragging) return;
	
	          element.css('height', (startHeight + ev.pointer.distanceY) + 'px');
	        }
	
	        function onDragEnd(ev) {
	          if (!isDragging) return;
	          isDragging = false;
	          container.removeClass('md-input-resized');
	        }
	      }
	
	      // Attach a watcher to detect when the textarea gets shown.
	      if (attr.hasOwnProperty('mdDetectHidden')) {
	
	        var handleHiddenChange = function() {
	          var wasHidden = false;
	
	          return function() {
	            var isHidden = node.offsetHeight === 0;
	
	            if (isHidden === false && wasHidden === true) {
	              growTextarea();
	            }
	
	            wasHidden = isHidden;
	          };
	        }();
	
	        // Check every digest cycle whether the visibility of the textarea has changed.
	        // Queue up to run after the digest cycle is complete.
	        scope.$watch(function() {
	          $mdUtil.nextTick(handleHiddenChange, false);
	          return true;
	        });
	      }
	    }
	  }
	}
	
	function mdMaxlengthDirective($animate, $mdUtil) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^mdInputContainer'],
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var maxlength;
	    var ngModelCtrl = ctrls[0];
	    var containerCtrl = ctrls[1];
	    var charCountEl, errorsSpacer;
	
	    // Wait until the next tick to ensure that the input has setup the errors spacer where we will
	    // append our counter
	    $mdUtil.nextTick(function() {
	      errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
	      charCountEl = angular.element('<div class="md-char-counter">');
	
	      // Append our character counter inside the errors spacer
	      errorsSpacer.append(charCountEl);
	
	      // Stop model from trimming. This makes it so whitespace
	      // over the maxlength still counts as invalid.
	      attr.$set('ngTrim', 'false');
	
	      scope.$watch(attr.mdMaxlength, function(value) {
	        maxlength = value;
	        if (angular.isNumber(value) && value > 0) {
	          if (!charCountEl.parent().length) {
	            $animate.enter(charCountEl, errorsSpacer);
	          }
	          renderCharCount();
	        } else {
	          $animate.leave(charCountEl);
	        }
	      });
	
	      ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
	        if (!angular.isNumber(maxlength) || maxlength < 0) {
	          return true;
	        }
	
	        // We always update the char count, when the modelValue has changed.
	        // Using the $validators for triggering the update works very well.
	        renderCharCount();
	
	        return ( modelValue || element.val() || viewValue || '' ).length <= maxlength;
	      };
	    });
	
	    function renderCharCount(value) {
	      // If we have not been appended to the body yet; do not render
	      if (!charCountEl.parent) {
	        return value;
	      }
	
	      // Force the value into a string since it may be a number,
	      // which does not have a length property.
	      charCountEl.text(String(element.val() || value || '').length + ' / ' + maxlength);
	      return value;
	    }
	  }
	}
	
	function placeholderDirective($compile) {
	  return {
	    restrict: 'A',
	    require: '^^?mdInputContainer',
	    priority: 200,
	    link: {
	      // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
	      // support data bindings in the placeholder. This is necessary, because we have a case where
	      // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
	      // If we did this in the post-link, AngularJS would have set up the observers already and would be
	      // re-adding the attribute, even though we removed it from the element.
	      pre: preLink
	    }
	  };
	
	  function preLink(scope, element, attr, inputContainer) {
	    // If there is no input container, just return
	    if (!inputContainer) return;
	
	    var label = inputContainer.element.find('label');
	    var noFloat = inputContainer.element.attr('md-no-float');
	
	    // If we have a label, or they specify the md-no-float attribute, just return
	    if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
	      // Add a placeholder class so we can target it in the CSS
	      inputContainer.setHasPlaceholder(true);
	      return;
	    }
	
	    // md-select handles placeholders on it's own
	    if (element[0].nodeName != 'MD-SELECT') {
	      // Move the placeholder expression to the label
	      var newLabel = angular.element('<label ng-click="delegateClick()" tabindex="-1">' + attr.placeholder + '</label>');
	
	      // Note that we unset it via `attr`, in order to get AngularJS
	      // to remove any observers that it might have set up. Otherwise
	      // the attribute will be added on the next digest.
	      attr.$set('placeholder', null);
	
	      // We need to compile the label manually in case it has any bindings.
	      // A gotcha here is that we first add the element to the DOM and we compile
	      // it later. This is necessary, because if we compile the element beforehand,
	      // it won't be able to find the `mdInputContainer` controller.
	      inputContainer.element
	        .addClass('md-icon-float')
	        .prepend(newLabel);
	
	      $compile(newLabel)(scope);
	    }
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSelectOnFocus
	 * @module material.components.input
	 *
	 * @restrict A
	 *
	 * @description
	 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
	 *
	 * <h3>Notes</h3>
	 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
	 *
	 * @usage
	 * <h3>Using with an Input</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <input type="text" md-select-on-focus>
	 * </md-input-container>
	 * </hljs>
	 *
	 * <h3>Using with a Textarea</h3>
	 * <hljs lang="html">
	 *
	 * <md-input-container>
	 *   <label>Auto Select</label>
	 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
	 * </md-input-container>
	 *
	 * </hljs>
	 */
	function mdSelectOnFocusDirective($timeout) {
	
	  return {
	    restrict: 'A',
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;
	
	    var preventMouseUp = false;
	
	    element
	      .on('focus', onFocus)
	      .on('mouseup', onMouseUp);
	
	    scope.$on('$destroy', function() {
	      element
	        .off('focus', onFocus)
	        .off('mouseup', onMouseUp);
	    });
	
	    function onFocus() {
	      preventMouseUp = true;
	
	      $timeout(function() {
	        // Use HTMLInputElement#select to fix firefox select issues.
	        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
	        element[0].select();
	
	        // This should be reset from inside the `focus`, because the event might
	        // have originated from something different than a click, e.g. a keyboard event.
	        preventMouseUp = false;
	      }, 1, false);
	    }
	
	    // Prevents the default action of the first `mouseup` after a focus.
	    // This is necessary, because browsers fire a `mouseup` right after the element
	    // has been focused. In some browsers (Firefox in particular) this can clear the
	    // selection. There are examples of the problem in issue #7487.
	    function onMouseUp(event) {
	      if (preventMouseUp) {
	        event.preventDefault();
	      }
	    }
	  }
	}
	
	var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];
	function ngMessagesDirective() {
	  return {
	    restrict: 'EA',
	    link: postLink,
	
	    // This is optional because we don't want target *all* ngMessage instances, just those inside of
	    // mdInputContainer.
	    require: '^^?mdInputContainer'
	  };
	
	  function postLink(scope, element, attrs, inputContainer) {
	    // If we are not a child of an input container, don't do anything
	    if (!inputContainer) return;
	
	    // Add our animation class
	    element.toggleClass('md-input-messages-animation', true);
	
	    // Add our md-auto-hide class to automatically hide/show messages when container is invalid
	    element.toggleClass('md-auto-hide', true);
	
	    // If we see some known visibility directives, remove the md-auto-hide class
	    if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
	      element.toggleClass('md-auto-hide', false);
	    }
	  }
	
	  function hasVisibiltyDirective(attrs) {
	    return visibilityDirectives.some(function(attr) {
	      return attrs[attr];
	    });
	  }
	}
	
	function ngMessageDirective($mdUtil) {
	  return {
	    restrict: 'EA',
	    compile: compile,
	    priority: 100
	  };
	
	  function compile(tElement) {
	    if (!isInsideInputContainer(tElement)) {
	
	      // When the current element is inside of a document fragment, then we need to check for an input-container
	      // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
	      // fragment, which causes the input-container check to fail.
	      if (isInsideFragment()) {
	        return function (scope, element) {
	          if (isInsideInputContainer(element)) {
	            // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
	            // currently hidden. To access the shown element, we need to use the element from the compile function.
	            initMessageElement(tElement);
	          }
	        };
	      }
	    } else {
	      initMessageElement(tElement);
	    }
	
	    function isInsideFragment() {
	      var nextNode = tElement[0];
	      while (nextNode = nextNode.parentNode) {
	        if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function isInsideInputContainer(element) {
	      return !!$mdUtil.getClosest(element, "md-input-container");
	    }
	
	    function initMessageElement(element) {
	      // Add our animation class
	      element.toggleClass('md-input-message-animation', true);
	    }
	  }
	}
	
	var $$AnimateRunner, $animateCss, $mdUtil, $log;
	
	function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    addClass: function(element, className, done) {
	      showInputMessages(element, done);
	    }
	
	    // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
	  };
	}
	
	function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    enter: function(element, done) {
	      showInputMessages(element, done);
	    },
	
	    leave: function(element, done) {
	      hideInputMessages(element, done);
	    },
	
	    addClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        hideInputMessages(element, done);
	      } else {
	        done();
	      }
	    },
	
	    removeClass: function(element, className, done) {
	      if (className == "ng-hide") {
	        showInputMessages(element, done);
	      } else {
	        done();
	      }
	    }
	  };
	}
	
	function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
	  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);
	
	  return {
	    enter: function(element, done) {
	      var animator = showMessage(element);
	
	      animator.start().done(done);
	    },
	
	    leave: function(element, done) {
	      var animator = hideMessage(element);
	
	      animator.start().done(done);
	    }
	  };
	}
	
	function showInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    $log.warn('mdInput messages show animation called on invalid messages element: ', element);
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = showMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function hideInputMessages(element, done) {
	  var animators = [], animator;
	  var messages = getMessagesElement(element);
	  var children = messages.children();
	
	  if (messages.length == 0 || children.length == 0) {
	    $log.warn('mdInput messages hide animation called on invalid messages element: ', element);
	    done();
	    return;
	  }
	
	  angular.forEach(children, function(child) {
	    animator = hideMessage(angular.element(child));
	
	    animators.push(animator.start());
	  });
	
	  $$AnimateRunner.all(animators, done);
	}
	
	function showMessage(element) {
	  var height = parseInt(window.getComputedStyle(element[0]).height);
	  var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);
	
	  var messages = getMessagesElement(element);
	  var container = getInputElement(element);
	
	  // Check to see if the message is already visible so we can skip
	  var alreadyVisible = (topMargin > -height);
	
	  // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
	  if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
	    return $animateCss(element, {});
	  }
	
	  return $animateCss(element, {
	    event: 'enter',
	    structural: true,
	    from: {"opacity": 0, "margin-top": -height + "px"},
	    to: {"opacity": 1, "margin-top": "0"},
	    duration: 0.3
	  });
	}
	
	function hideMessage(element) {
	  var height = element[0].offsetHeight;
	  var styles = window.getComputedStyle(element[0]);
	
	  // If we are already hidden, just return an empty animation
	  if (parseInt(styles.opacity) === 0) {
	    return $animateCss(element, {});
	  }
	
	  // Otherwise, animate
	  return $animateCss(element, {
	    event: 'leave',
	    structural: true,
	    from: {"opacity": 1, "margin-top": 0},
	    to: {"opacity": 0, "margin-top": -height + "px"},
	    duration: 0.3
	  });
	}
	
	function getInputElement(element) {
	  var inputContainer = element.controller('mdInputContainer');
	
	  return inputContainer.element;
	}
	
	function getMessagesElement(element) {
	  // If we ARE the messages element, just return ourself
	  if (element.hasClass('md-input-messages-animation')) {
	    return element;
	  }
	
	  // If we are a ng-message element, we need to traverse up the DOM tree
	  if (element.hasClass('md-input-message-animation')) {
	    return angular.element($mdUtil.getClosest(element, function(node) {
	      return node.classList.contains('md-input-messages-animation');
	    }));
	  }
	
	  // Otherwise, we can traverse down
	  return angular.element(element[0].querySelector('.md-input-messages-animation'));
	}
	
	function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_, _$log_) {
	  $$AnimateRunner = _$$AnimateRunner_;
	  $animateCss = _$animateCss_;
	  $mdUtil = _$mdUtil_;
	  $log = _$log_;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.list
	 * @description
	 * List module
	 */
	MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];
	mdListDirective.$inject = ["$mdTheming"];
	mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
	angular.module('material.components.list', [
	  'material.core'
	])
	  .controller('MdListController', MdListController)
	  .directive('mdList', mdListDirective)
	  .directive('mdListItem', mdListItemDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdList
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-list>
	 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
	 *     <md-checkbox ng-model="item.done"></md-checkbox>
	 *     <div class="md-list-item-text">
	 *       <h3>{{item.title}}</h3>
	 *       <p>{{item.description}}</p>
	 *     </div>
	 *   </md-list-item>
	 * </md-list>
	 * </hljs>
	 */
	
	function mdListDirective($mdTheming) {
	  return {
	    restrict: 'E',
	    compile: function(tEl) {
	      tEl[0].setAttribute('role', 'list');
	      return $mdTheming;
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdListItem
	 * @module material.components.list
	 *
	 * @restrict E
	 *
	 * @description
	 * A `md-list-item` element can be used to represent some information in a row.<br/>
	 *
	 * @usage
	 * ### Single Row Item
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Multiple Lines
	 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-2-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It is also possible to have three lines inside of one list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-3-line">
	 *     <div class="md-list-item-text" layout="column">
	 *       <p>First Line</p>
	 *       <p>Second Line</p>
	 *       <p>Third Line</p>
	 *     </div>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Secondary Items
	 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">
	 *       Secondary Button
	 *     </md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * It also possible to have multiple secondary items inside of one `md-list-item`.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>Single Row Item</span>
	 *     <md-button class="md-secondary">First Button</md-button>
	 *     <md-button class="md-secondary">Second Button</md-button>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### Proxy Item
	 * Proxies are elements, which will execute their specific action on click<br/>
	 * Currently supported proxy items are
	 * - `md-checkbox` (Toggle)
	 * - `md-switch` (Toggle)
	 * - `md-menu` (Open)
	 *
	 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
	 * automatically become clickable and executes the associated action of the proxy element on click.
	 *
	 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-no-proxy">
	 *     <span>No Proxy List</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * Here are a few examples of proxy elements inside of a list item.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-checkbox class="md-secondary"></md-checkbox>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on click.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <span>First Line</span>
	 *     <md-switch class="md-secondary"></md-switch>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
	 *
	 * It is also possible to have a `md-menu` inside of a `md-list-item`.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <p>Click anywhere to fire the secondary action</p>
	 *     <md-menu class="md-secondary">
	 *       <md-button class="md-icon-button">
	 *         <md-icon md-svg-icon="communication:message"></md-icon>
	 *       </md-button>
	 *       <md-menu-content width="4">
	 *         <md-menu-item>
	 *           <md-button>
	 *             Redial
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Check voicemail
	 *           </md-button>
	 *         </md-menu-item>
	 *         <md-menu-divider></md-menu-divider>
	 *         <md-menu-item>
	 *           <md-button>
	 *             Notifications
	 *           </md-button>
	 *         </md-menu-item>
	 *       </md-menu-content>
	 *     </md-menu>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
	 *
	 * If the developer didn't specify any position mode on the menu, the `md-list-item` will automatically detect the
	 * position mode and applies it to the `md-menu`.
	 *
	 * ### Avatars
	 * Sometimes you may want to have some avatars inside of the `md-list-item `.<br/>
	 * You are able to create a optimized icon for the list item, by applying the `.md-avatar` class on the `<img>` element.
	 *
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <img src="my-avatar.png" class="md-avatar">
	 *     <span>Alan Turing</span>
	 * </hljs>
	 *
	 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
	 * <hljs lang="html">
	 *   <md-list-item>
	 *     <md-icon class="md-avatar-icon" md-svg-icon="avatars:timothy"></md-icon>
	 *     <span>Timothy Kopra</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * In cases, you have a `md-list-item`, which doesn't have any avatar,
	 * but you want to align it with the other avatar items, you have to use the `.md-offset` class.
	 *
	 * <hljs lang="html">
	 *   <md-list-item class="md-offset">
	 *     <span>Jon Doe</span>
	 *   </md-list-item>
	 * </hljs>
	 *
	 * ### DOM modification
	 * The `md-list-item` component automatically detects if the list item should be clickable.
	 *
	 * ---
	 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
	 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`)
	 *
	 * We create an overlaying button, instead of wrapping all content inside of the button,
	 * because otherwise some elements may not be clickable inside of the button.
	 *
	 * ---
	 * When using a secondary item inside of your list item, the `md-list-item` component will automatically create
	 * a secondary container at the end of the `md-list-item`, which contains all secondary items.
	 *
	 * The secondary item container is not static, because otherwise the overflow will not work properly on the
	 * list item.
	 *
	 */
	function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
	  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
	  return {
	    restrict: 'E',
	    controller: 'MdListController',
	    compile: function(tEl, tAttrs) {
	
	      // Check for proxy controls (no ng-click on parent, and a control inside)
	      var secondaryItems = tEl[0].querySelectorAll('.md-secondary');
	      var hasProxiedElement;
	      var proxyElement;
	      var itemContainer = tEl;
	
	      tEl[0].setAttribute('role', 'listitem');
	
	      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
	        wrapIn('button');
	      } else if (!tEl.hasClass('md-no-proxy')) {
	
	        for (var i = 0, type; type = proxiedTypes[i]; ++i) {
	          if (proxyElement = tEl[0].querySelector(type)) {
	            hasProxiedElement = true;
	            break;
	          }
	        }
	
	        if (hasProxiedElement) {
	          wrapIn('div');
	        } else {
	          tEl.addClass('md-no-proxy');
	        }
	
	      }
	
	      wrapSecondaryItems();
	      setupToggleAria();
	
	      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
	        setupProxiedMenu();
	      }
	
	      function setupToggleAria() {
	        var toggleTypes = ['md-switch', 'md-checkbox'];
	        var toggle;
	
	        for (var i = 0, toggleType; toggleType = toggleTypes[i]; ++i) {
	          if (toggle = tEl.find(toggleType)[0]) {
	            if (!toggle.hasAttribute('aria-label')) {
	              var p = tEl.find('p')[0];
	              if (!p) return;
	              toggle.setAttribute('aria-label', 'Toggle ' + p.textContent);
	            }
	          }
	        }
	      }
	
	      function setupProxiedMenu() {
	        var menuEl = angular.element(proxyElement);
	
	        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
	                           proxyElement.parentNode.firstElementChild !== proxyElement;
	
	        var xAxisPosition = 'left';
	
	        if (isEndAligned) {
	          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
	          xAxisPosition = 'right';
	        }
	
	        // Set the position mode / origin of the proxied menu.
	        if (!menuEl.attr('md-position-mode')) {
	          menuEl.attr('md-position-mode', xAxisPosition + ' target');
	        }
	
	        // Apply menu open binding to menu button
	        var menuOpenButton = menuEl.children().eq(0);
	        if (!hasClickEvent(menuOpenButton[0])) {
	          menuOpenButton.attr('ng-click', '$mdMenu.open($event)');
	        }
	
	        if (!menuOpenButton.attr('aria-label')) {
	          menuOpenButton.attr('aria-label', 'Open List Menu');
	        }
	      }
	
	      function wrapIn(type) {
	        if (type == 'div') {
	          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
	          itemContainer.append(tEl.contents());
	          tEl.addClass('md-proxy-focus');
	        } else {
	          // Element which holds the default list-item content.
	          itemContainer = angular.element(
	            '<div class="md-button md-no-style">'+
	            '   <div class="md-list-item-inner"></div>'+
	            '</div>'
	          );
	
	          // Button which shows ripple and executes primary action.
	          var buttonWrap = angular.element(
	            '<md-button class="md-no-style"></md-button>'
	          );
	
	          copyAttributes(tEl[0], buttonWrap[0]);
	
	          // If there is no aria-label set on the button (previously copied over if present)
	          // we determine the label from the content and copy it to the button.
	          if (!buttonWrap.attr('aria-label')) {
	            buttonWrap.attr('aria-label', $mdAria.getText(tEl));
	          }
	
	          // We allow developers to specify the `md-no-focus` class, to disable the focus style
	          // on the button executor. Once more classes should be forwarded, we should probably make the
	          // class forward more generic.
	          if (tEl.hasClass('md-no-focus')) {
	            buttonWrap.addClass('md-no-focus');
	          }
	
	          // Append the button wrap before our list-item content, because it will overlay in relative.
	          itemContainer.prepend(buttonWrap);
	          itemContainer.children().eq(1).append(tEl.contents());
	
	          tEl.addClass('_md-button-wrap');
	        }
	
	        tEl[0].setAttribute('tabindex', '-1');
	        tEl.append(itemContainer);
	      }
	
	      function wrapSecondaryItems() {
	        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');
	
	        angular.forEach(secondaryItems, function(secondaryItem) {
	          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
	        });
	
	        itemContainer.append(secondaryItemsWrapper);
	      }
	
	      function wrapSecondaryItem(secondaryItem, container) {
	        // If the current secondary item is not a button, but contains a ng-click attribute,
	        // the secondary item will be automatically wrapped inside of a button.
	        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {
	
	          $mdAria.expect(secondaryItem, 'aria-label');
	          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');
	
	          // Copy the attributes from the secondary item to the generated button.
	          // We also support some additional attributes from the secondary item,
	          // because some developers may use a ngIf, ngHide, ngShow on their item.
	          copyAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);
	
	          secondaryItem.setAttribute('tabindex', '-1');
	          buttonWrapper.append(secondaryItem);
	
	          secondaryItem = buttonWrapper[0];
	        }
	
	        if (secondaryItem && (!hasClickEvent(secondaryItem) || (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
	          // In this case we remove the secondary class, so we can identify it later, when we searching for the
	          // proxy items.
	          angular.element(secondaryItem).removeClass('md-secondary');
	        }
	
	        tEl.addClass('md-with-secondary');
	        container.append(secondaryItem);
	      }
	
	      /**
	       * Copies attributes from a source element to the destination element
	       * By default the function will copy the most necessary attributes, supported
	       * by the button executor for clickable list items.
	       * @param source Element with the specified attributes
	       * @param destination Element which will retrieve the attributes
	       * @param extraAttrs Additional attributes, which will be copied over.
	       */
	      function copyAttributes(source, destination, extraAttrs) {
	        var copiedAttrs = $mdUtil.prefixer([
	          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
	          'href', 'ng-href', 'target', 'ng-attr-ui-sref', 'ui-sref-opts'
	        ]);
	
	        if (extraAttrs) {
	          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
	        }
	
	        angular.forEach(copiedAttrs, function(attr) {
	          if (source.hasAttribute(attr)) {
	            destination.setAttribute(attr, source.getAttribute(attr));
	            source.removeAttribute(attr);
	          }
	        });
	      }
	
	      function isProxiedElement(el) {
	        return proxiedTypes.indexOf(el.nodeName.toLowerCase()) != -1;
	      }
	
	      function isButton(el) {
	        var nodeName = el.nodeName.toUpperCase();
	
	        return nodeName == "MD-BUTTON" || nodeName == "BUTTON";
	      }
	
	      function hasClickEvent (element) {
	        var attr = element.attributes;
	        for (var i = 0; i < attr.length; i++) {
	          if (tAttrs.$normalize(attr[i].name) === 'ngClick') return true;
	        }
	        return false;
	      }
	
	      return postLink;
	
	      function postLink($scope, $element, $attr, ctrl) {
	        $element.addClass('_md');     // private md component indicator for styling
	
	        var proxies       = [],
	            firstElement  = $element[0].firstElementChild,
	            isButtonWrap  = $element.hasClass('_md-button-wrap'),
	            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
	            hasClick      = clickChild && hasClickEvent(clickChild),
	            noProxies     = $element.hasClass('md-no-proxy');
	
	        computeProxies();
	        computeClickable();
	
	        if (proxies.length) {
	          angular.forEach(proxies, function(proxy) {
	            proxy = angular.element(proxy);
	
	            $scope.mouseActive = false;
	            proxy.on('mousedown', function() {
	              $scope.mouseActive = true;
	              $timeout(function(){
	                $scope.mouseActive = false;
	              }, 100);
	            })
	            .on('focus', function() {
	              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
	              proxy.on('blur', function proxyOnBlur() {
	                $element.removeClass('md-focused');
	                proxy.off('blur', proxyOnBlur);
	              });
	            });
	          });
	        }
	
	
	        function computeProxies() {
	
	          if (firstElement && firstElement.children && !hasClick && !noProxies) {
	
	            angular.forEach(proxiedTypes, function(type) {
	
	              // All elements which are not capable for being used a proxy have the .md-secondary class
	              // applied. These items had been sorted out in the secondary wrap function.
	              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
	                proxies.push(child);
	              });
	            });
	
	          }
	        }
	
	        function computeClickable() {
	          if (proxies.length == 1 || hasClick) {
	            $element.addClass('md-clickable');
	
	            if (!hasClick) {
	              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
	            }
	          }
	        }
	
	        function isEventFromControl(event) {
	          var forbiddenControls = ['md-slider'];
	
	          // If there is no path property in the event, then we can assume that the event was not bubbled.
	          if (!event.path) {
	            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
	          }
	
	          // We iterate the event path up and check for a possible component.
	          // Our maximum index to search, is the list item root.
	          var maxPath = event.path.indexOf($element.children()[0]);
	
	          for (var i = 0; i < maxPath; i++) {
	            if (forbiddenControls.indexOf(event.path[i].tagName.toLowerCase()) !== -1) {
	              return true;
	            }
	          }
	        }
	
	        var clickChildKeypressListener = function(e) {
	          if (e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA' && !e.target.isContentEditable) {
	            var keyCode = e.which || e.keyCode;
	            if (keyCode == $mdConstant.KEY_CODE.SPACE) {
	              if (clickChild) {
	                clickChild.click();
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            }
	          }
	        };
	
	        if (!hasClick && !proxies.length) {
	          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
	        }
	
	        $element.off('click');
	        $element.off('keypress');
	
	        if (proxies.length == 1 && clickChild) {
	          $element.children().eq(0).on('click', function(e) {
	            // When the event is coming from an control and it should not trigger the proxied element
	            // then we are skipping.
	            if (isEventFromControl(e)) return;
	
	            var parentButton = $mdUtil.getClosest(e.target, 'BUTTON');
	            if (!parentButton && clickChild.contains(e.target)) {
	              angular.forEach(proxies, function(proxy) {
	                if (e.target !== proxy && !proxy.contains(e.target)) {
	                  if (proxy.nodeName === 'MD-MENU') {
	                    proxy = proxy.children[0];
	                  }
	                  angular.element(proxy).triggerHandler('click');
	                }
	              });
	            }
	          });
	        }
	
	        $scope.$on('$destroy', function () {
	          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
	        });
	      }
	    }
	  };
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name MdListController
	 * @module material.components.list
	 *
	 */
	function MdListController($scope, $element, $mdListInkRipple) {
	  var ctrl = this;
	  ctrl.attachRipple = attachRipple;
	
	  function attachRipple (scope, element) {
	    var options = {};
	    $mdListInkRipple.attach(scope, element, options);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menu
	 */
	
	angular.module('material.components.menu', [
	  'material.core',
	  'material.components.backdrop'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.menuBar
	 */
	
	angular.module('material.components.menuBar', [
	  'material.core',
	  'material.components.icon',
	  'material.components.menu'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.navBar
	 */
	
	
	MdNavBarController.$inject = ["$element", "$scope", "$timeout", "$mdConstant"];
	MdNavItem.$inject = ["$mdAria", "$$rAF"];
	MdNavItemController.$inject = ["$element"];
	MdNavBar.$inject = ["$mdAria", "$mdTheming"];
	angular.module('material.components.navBar', ['material.core'])
	    .controller('MdNavBarController', MdNavBarController)
	    .directive('mdNavBar', MdNavBar)
	    .controller('MdNavItemController', MdNavItemController)
	    .directive('mdNavItem', MdNavItem);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	/**
	 * @ngdoc directive
	 * @name mdNavBar
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
	 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
	 * body and no bar pagination.
	 *
	 * Because it deals with page navigation, certain routing concepts are built-in.
	 * Route changes via via ng-href, ui-sref, or ng-click events are supported.
	 * Alternatively, the user could simply watch currentNavItem for changes.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 *
	 * @param {string=} mdSelectedNavItem The name of the current tab; this must
	 *     match the name attribute of `<md-nav-item>`
	 * @param {boolean=} mdNoInkBar If set to true, the ink bar will be hidden.
	 * @param {string=} navBarAriaLabel An aria-label for the nav-bar
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-nav-bar md-selected-nav-item="currentNavItem">
	 *    <md-nav-item md-nav-click="goto('page1')" name="page1">
	 *      Page One
	 *    </md-nav-item>
	 *    <md-nav-item md-nav-href="#page2" name="page3">Page Two</md-nav-item>
	 *    <md-nav-item md-nav-sref="page3" name="page2">Page Three</md-nav-item>
	 *    <md-nav-item
	 *      md-nav-sref="app.page4"
	 *      sref-opts="{reload: true, notify: true}"
	 *      name="page4">
	 *      Page Four
	 *    </md-nav-item>
	 *  </md-nav-bar>
	 *</hljs>
	 * <hljs lang="js">
	 * (function() {
	 *   'use strict';
	 *
	 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
	 *      $scope.currentLink = getCurrentLinkFromRoute(current);
	 *    });
	 * });
	 * </hljs>
	 */
	
	/*****************************************************************************
	 *                            mdNavItem
	 *****************************************************************************/
	/**
	 * @ngdoc directive
	 * @name mdNavItem
	 * @module material.components.navBar
	 *
	 * @restrict E
	 *
	 * @description
	 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>`
	 * component. It renders an md-button as the actual link.
	 *
	 * Exactly one of the mdNavClick, mdNavHref, mdNavSref attributes are required
	 * to be specified.
	 *
	 * @param {Function=} mdNavClick Function which will be called when the
	 *     link is clicked to change the page. Renders as an `ng-click`.
	 * @param {string=} mdNavHref url to transition to when this link is clicked.
	 *     Renders as an `ng-href`.
	 * @param {string=} mdNavSref Ui-router state to transition to when this link is
	 *     clicked. Renders as a `ui-sref`.
	 * @param {!Object=} srefOpts Ui-router options that are passed to the
	 *     `$state.go()` function. See the [Ui-router documentation for details]
	 *     (https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html).
	 * @param {string=} name The name of this link. Used by the nav bar to know
	 *     which link is currently selected.
	 * @param {string=} aria-label Adds alternative text for accessibility
	 *
	 * @usage
	 * See `<md-nav-bar>` for usage.
	 */
	
	
	/*****************************************************************************
	 *                                IMPLEMENTATION                             *
	 *****************************************************************************/
	
	function MdNavBar($mdAria, $mdTheming) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    controller: MdNavBarController,
	    controllerAs: 'ctrl',
	    bindToController: true,
	    scope: {
	      'mdSelectedNavItem': '=?',
	      'mdNoInkBar': '=?',
	      'navBarAriaLabel': '@?',
	    },
	    template:
	      '<div class="md-nav-bar">' +
	        '<nav role="navigation">' +
	          '<ul class="_md-nav-bar-list" ng-transclude role="listbox"' +
	            'tabindex="0"' +
	            'ng-focus="ctrl.onFocus()"' +
	            'ng-keydown="ctrl.onKeydown($event)"' +
	            'aria-label="{{ctrl.navBarAriaLabel}}">' +
	          '</ul>' +
	        '</nav>' +
	        '<md-nav-ink-bar ng-hide="ctrl.mdNoInkBar"></md-nav-ink-bar>' +
	      '</div>',
	    link: function(scope, element, attrs, ctrl) {
	      $mdTheming(element);
	      if (!ctrl.navBarAriaLabel) {
	        $mdAria.expectAsync(element, 'aria-label', angular.noop);
	      }
	    },
	  };
	}
	
	/**
	 * Controller for the nav-bar component.
	 *
	 * Accessibility functionality is implemented as a site navigator with a
	 * listbox, according to
	 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
	 * @param {!angular.JQLite} $element
	 * @param {!angular.Scope} $scope
	 * @param {!angular.Timeout} $timeout
	 * @param {!Object} $mdConstant
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavBarController($element, $scope, $timeout, $mdConstant) {
	  // Injected variables
	  /** @private @const {!angular.Timeout} */
	  this._$timeout = $timeout;
	
	  /** @private @const {!angular.Scope} */
	  this._$scope = $scope;
	
	  /** @private @const {!Object} */
	  this._$mdConstant = $mdConstant;
	
	  // Data-bound variables.
	  /** @type {string} */
	  this.mdSelectedNavItem;
	
	  /** @type {string} */
	  this.navBarAriaLabel;
	
	  // State variables.
	
	  /** @type {?angular.JQLite} */
	  this._navBarEl = $element[0];
	
	  /** @type {?angular.JQLite} */
	  this._inkbar;
	
	  var self = this;
	  // need to wait for transcluded content to be available
	  var deregisterTabWatch = this._$scope.$watch(function() {
	    return self._navBarEl.querySelectorAll('._md-nav-button').length;
	  },
	  function(newLength) {
	    if (newLength > 0) {
	      self._initTabs();
	      deregisterTabWatch();
	    }
	  });
	}
	
	
	
	/**
	 * Initializes the tab components once they exist.
	 * @private
	 */
	MdNavBarController.prototype._initTabs = function() {
	  this._inkbar = angular.element(this._navBarEl.querySelector('md-nav-ink-bar'));
	
	  var self = this;
	  this._$timeout(function() {
	    self._updateTabs(self.mdSelectedNavItem, undefined);
	  });
	
	  this._$scope.$watch('ctrl.mdSelectedNavItem', function(newValue, oldValue) {
	    // Wait a digest before update tabs for products doing
	    // anything dynamic in the template.
	    self._$timeout(function() {
	      self._updateTabs(newValue, oldValue);
	    });
	  });
	};
	
	/**
	 * Set the current tab to be selected.
	 * @param {string|undefined} newValue New current tab name.
	 * @param {string|undefined} oldValue Previous tab name.
	 * @private
	 */
	MdNavBarController.prototype._updateTabs = function(newValue, oldValue) {
	  var self = this;
	  var tabs = this._getTabs();
	
	  // this._getTabs can return null if nav-bar has not yet been initialized
	  if(!tabs)
	    return;
	
	  var oldIndex = -1;
	  var newIndex = -1;
	  var newTab = this._getTabByName(newValue);
	  var oldTab = this._getTabByName(oldValue);
	
	  if (oldTab) {
	    oldTab.setSelected(false);
	    oldIndex = tabs.indexOf(oldTab);
	  }
	
	  if (newTab) {
	    newTab.setSelected(true);
	    newIndex = tabs.indexOf(newTab);
	  }
	
	  this._$timeout(function() {
	    self._updateInkBarStyles(newTab, newIndex, oldIndex);
	  });
	};
	
	/**
	 * Repositions the ink bar to the selected tab.
	 * @private
	 */
	MdNavBarController.prototype._updateInkBarStyles = function(tab, newIndex, oldIndex) {
	  this._inkbar.toggleClass('_md-left', newIndex < oldIndex)
	      .toggleClass('_md-right', newIndex > oldIndex);
	
	  this._inkbar.css({display: newIndex < 0 ? 'none' : ''});
	
	  if (tab) {
	    var tabEl = tab.getButtonEl();
	    var left = tabEl.offsetLeft;
	
	    this._inkbar.css({left: left + 'px', width: tabEl.offsetWidth + 'px'});
	  }
	};
	
	/**
	 * Returns an array of the current tabs.
	 * @return {!Array<!NavItemController>}
	 * @private
	 */
	MdNavBarController.prototype._getTabs = function() {
	  var controllers = Array.prototype.slice.call(
	    this._navBarEl.querySelectorAll('.md-nav-item'))
	    .map(function(el) {
	      return angular.element(el).controller('mdNavItem')
	    });
	  return controllers.indexOf(undefined) ? controllers : null;
	};
	
	/**
	 * Returns the tab with the specified name.
	 * @param {string} name The name of the tab, found in its name attribute.
	 * @return {!NavItemController|undefined}
	 * @private
	 */
	MdNavBarController.prototype._getTabByName = function(name) {
	  return this._findTab(function(tab) {
	    return tab.getName() == name;
	  });
	};
	
	/**
	 * Returns the selected tab.
	 * @return {!NavItemController|undefined}
	 * @private
	 */
	MdNavBarController.prototype._getSelectedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.isSelected();
	  });
	};
	
	/**
	 * Returns the focused tab.
	 * @return {!NavItemController|undefined}
	 */
	MdNavBarController.prototype.getFocusedTab = function() {
	  return this._findTab(function(tab) {
	    return tab.hasFocus();
	  });
	};
	
	/**
	 * Find a tab that matches the specified function.
	 * @private
	 */
	MdNavBarController.prototype._findTab = function(fn) {
	  var tabs = this._getTabs();
	  for (var i = 0; i < tabs.length; i++) {
	    if (fn(tabs[i])) {
	      return tabs[i];
	    }
	  }
	
	  return null;
	};
	
	/**
	 * Direct focus to the selected tab when focus enters the nav bar.
	 */
	MdNavBarController.prototype.onFocus = function() {
	  var tab = this._getSelectedTab();
	  if (tab) {
	    tab.setFocused(true);
	  }
	};
	
	/**
	 * Move focus from oldTab to newTab.
	 * @param {!NavItemController} oldTab
	 * @param {!NavItemController} newTab
	 * @private
	 */
	MdNavBarController.prototype._moveFocus = function(oldTab, newTab) {
	  oldTab.setFocused(false);
	  newTab.setFocused(true);
	};
	
	/**
	 * Responds to keypress events.
	 * @param {!Event} e
	 */
	MdNavBarController.prototype.onKeydown = function(e) {
	  var keyCodes = this._$mdConstant.KEY_CODE;
	  var tabs = this._getTabs();
	  var focusedTab = this.getFocusedTab();
	  if (!focusedTab) return;
	
	  var focusedTabIndex = tabs.indexOf(focusedTab);
	
	  // use arrow keys to navigate between tabs
	  switch (e.keyCode) {
	    case keyCodes.UP_ARROW:
	    case keyCodes.LEFT_ARROW:
	      if (focusedTabIndex > 0) {
	        this._moveFocus(focusedTab, tabs[focusedTabIndex - 1]);
	      }
	      break;
	    case keyCodes.DOWN_ARROW:
	    case keyCodes.RIGHT_ARROW:
	      if (focusedTabIndex < tabs.length - 1) {
	        this._moveFocus(focusedTab, tabs[focusedTabIndex + 1]);
	      }
	      break;
	    case keyCodes.SPACE:
	    case keyCodes.ENTER:
	      // timeout to avoid a "digest already in progress" console error
	      this._$timeout(function() {
	        focusedTab.getButtonEl().click();
	      });
	      break;
	  }
	};
	
	/**
	 * @ngInject
	 */
	function MdNavItem($mdAria, $$rAF) {
	  return {
	    restrict: 'E',
	    require: ['mdNavItem', '^mdNavBar'],
	    controller: MdNavItemController,
	    bindToController: true,
	    controllerAs: 'ctrl',
	    replace: true,
	    transclude: true,
	    template: function(tElement, tAttrs) {
	      var hasNavClick = tAttrs.mdNavClick;
	      var hasNavHref = tAttrs.mdNavHref;
	      var hasNavSref = tAttrs.mdNavSref;
	      var hasSrefOpts = tAttrs.srefOpts;
	      var navigationAttribute;
	      var navigationOptions;
	      var buttonTemplate;
	
	      // Cannot specify more than one nav attribute
	      if ((hasNavClick ? 1:0) + (hasNavHref ? 1:0) + (hasNavSref ? 1:0) > 1) {
	        throw Error(
	          'Must not specify more than one of the md-nav-click, md-nav-href, ' +
	          'or md-nav-sref attributes per nav-item directive.'
	        );
	      }
	
	      if (hasNavClick) {
	        navigationAttribute = 'ng-click="ctrl.mdNavClick()"';
	      } else if (hasNavHref) {
	        navigationAttribute = 'ng-href="{{ctrl.mdNavHref}}"';
	      } else if (hasNavSref) {
	        navigationAttribute = 'ui-sref="{{ctrl.mdNavSref}}"';
	      }
	
	      navigationOptions = hasSrefOpts ? 'ui-sref-opts="{{ctrl.srefOpts}}" ' : '';
	
	      if (navigationAttribute) {
	        buttonTemplate = '' +
	          '<md-button class="_md-nav-button md-accent" ' +
	            'ng-class="ctrl.getNgClassMap()" ' +
	            'ng-blur="ctrl.setFocused(false)" ' +
	            'tabindex="-1" ' +
	            navigationOptions +
	            navigationAttribute + '>' +
	            '<span ng-transclude class="_md-nav-button-text"></span>' +
	          '</md-button>';
	      }
	
	      return '' +
	        '<li class="md-nav-item" ' +
	          'role="option" ' +
	          'aria-selected="{{ctrl.isSelected()}}">' +
	          (buttonTemplate || '') +
	        '</li>';
	    },
	    scope: {
	      'mdNavClick': '&?',
	      'mdNavHref': '@?',
	      'mdNavSref': '@?',
	      'srefOpts': '=?',
	      'name': '@',
	    },
	    link: function(scope, element, attrs, controllers) {
	      // When accessing the element's contents synchronously, they
	      // may not be defined yet because of transclusion. There is a higher
	      // chance that it will be accessible if we wait one frame.
	      $$rAF(function() {
	        var mdNavItem = controllers[0];
	        var mdNavBar = controllers[1];
	        var navButton = angular.element(element[0].querySelector('._md-nav-button'));
	
	        if (!mdNavItem.name) {
	          mdNavItem.name = angular.element(element[0]
	              .querySelector('._md-nav-button-text')).text().trim();
	        }
	
	        navButton.on('click', function() {
	          mdNavBar.mdSelectedNavItem = mdNavItem.name;
	          scope.$apply();
	        });
	
	        $mdAria.expectWithText(element, 'aria-label');
	      });
	    }
	  };
	}
	
	/**
	 * Controller for the nav-item component.
	 * @param {!angular.JQLite} $element
	 * @constructor
	 * @final
	 * @ngInject
	 */
	function MdNavItemController($element) {
	
	  /** @private @const {!angular.JQLite} */
	  this._$element = $element;
	
	  // Data-bound variables
	
	  /** @const {?Function} */
	  this.mdNavClick;
	
	  /** @const {?string} */
	  this.mdNavHref;
	
	  /** @const {?string} */
	  this.mdNavSref;
	  /** @const {?Object} */
	  this.srefOpts;
	  /** @const {?string} */
	  this.name;
	
	  // State variables
	  /** @private {boolean} */
	  this._selected = false;
	
	  /** @private {boolean} */
	  this._focused = false;
	}
	
	/**
	 * Returns a map of class names and values for use by ng-class.
	 * @return {!Object<string,boolean>}
	 */
	MdNavItemController.prototype.getNgClassMap = function() {
	  return {
	    'md-active': this._selected,
	    'md-primary': this._selected,
	    'md-unselected': !this._selected,
	    'md-focused': this._focused,
	  };
	};
	
	/**
	 * Get the name attribute of the tab.
	 * @return {string}
	 */
	MdNavItemController.prototype.getName = function() {
	  return this.name;
	};
	
	/**
	 * Get the button element associated with the tab.
	 * @return {!Element}
	 */
	MdNavItemController.prototype.getButtonEl = function() {
	  return this._$element[0].querySelector('._md-nav-button');
	};
	
	/**
	 * Set the selected state of the tab.
	 * @param {boolean} isSelected
	 */
	MdNavItemController.prototype.setSelected = function(isSelected) {
	  this._selected = isSelected;
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.isSelected = function() {
	  return this._selected;
	};
	
	/**
	 * Set the focused state of the tab.
	 * @param {boolean} isFocused
	 */
	MdNavItemController.prototype.setFocused = function(isFocused) {
	  this._focused = isFocused;
	
	  if (isFocused) {
	    this.getButtonEl().focus();
	  }
	};
	
	/**
	 * @return {boolean}
	 */
	MdNavItemController.prototype.hasFocus = function() {
	  return this._focused;
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressCircular
	 * @description Module for a circular progressbar
	 */
	
	angular.module('material.components.progressCircular', ['material.core']);
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.panel
	 */
	MdPanelService.$inject = ["presets", "$rootElement", "$rootScope", "$injector", "$window"];
	angular
	  .module('material.components.panel', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .provider('$mdPanel', MdPanelProvider);
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanelProvider
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanelProvider` allows users to create configuration presets that will be
	 * stored within a cached presets object. When the configuration is needed, the
	 * user can request the preset by passing it as the first parameter in the
	 * `$mdPanel.create` or `$mdPanel.open` methods.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .config(DemoConfig)
	 *       .controller('DemoCtrl', DemoCtrl)
	 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
	 *
	 *   function DemoConfig($mdPanelProvider) {
	 *     $mdPanelProvider.definePreset('demoPreset', {
	 *       attachTo: angular.element(document.body),
	 *       controller: DemoMenuCtrl,
	 *       controllerAs: 'ctrl',
	 *       template: '' +
	 *           '<div class="menu-panel" md-whiteframe="4">' +
	 *           '  <div class="menu-content">' +
	 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
	 *           '      <button class="md-button">' +
	 *           '        <span>{{item}}</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '    <md-divider></md-divider>' +
	 *           '    <div class="menu-item">' +
	 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
	 *           '        <span>Close Menu</span>' +
	 *           '      </button>' +
	 *           '    </div>' +
	 *           '  </div>' +
	 *           '</div>',
	 *       panelClass: 'menu-panel-container',
	 *       focusOnOpen: false,
	 *       zIndex: 100,
	 *       propagateContainerEvents: true,
	 *       groupName: 'menus'
	 *     });
	 *   }
	 *
	 *   function PanelProviderCtrl($mdPanel) {
	 *     this.navigation = {
	 *       name: 'navigation',
	 *       items: [
	 *         'Home',
	 *         'About',
	 *         'Contact'
	 *       ]
	 *     };
	 *     this.favorites = {
	 *       name: 'favorites',
	 *       items: [
	 *         'Add to Favorites'
	 *       ]
	 *     };
	 *     this.more = {
	 *       name: 'more',
	 *       items: [
	 *         'Account',
	 *         'Sign Out'
	 *       ]
	 *     };
	 *
	 *     $mdPanel.newPanelGroup('menus', {
	 *       maxOpen: 2
	 *     });
	 *
	 *     this.showMenu = function($event, menu) {
	 *       $mdPanel.open('demoPreset', {
	 *         id: 'menu_' + menu.name,
	 *         position: $mdPanel.newPanelPosition()
	 *             .relativeTo($event.srcElement)
	 *             .addPanelPosition(
	 *               $mdPanel.xPosition.ALIGN_START,
	 *               $mdPanel.yPosition.BELOW
	 *             ),
	 *         locals: {
	 *           items: menu.items
	 *         },
	 *         openFrom: $event
	 *       });
	 *     };
	 *   }
	 *
	 *   function PanelMenuCtrl(mdPanelRef) {
	 *     this.closeMenu = function() {
	 *       mdPanelRef && mdPanelRef.close();
	 *     };
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanelProvider#definePreset
	 * @description
	 * Takes the passed in preset name and preset configuration object and adds it
	 * to the `_presets` object of the provider. This `_presets` object is then
	 * passed along to the `$mdPanel` service.
	 *
	 * @param {string} name Preset name.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters avaialble within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc service
	 * @name $mdPanel
	 * @module material.components.panel
	 *
	 * @description
	 * `$mdPanel` is a robust, low-level service for creating floating panels on
	 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
	 *
	 * @usage
	 * <hljs lang="js">
	 * (function(angular, undefined) {
	 *   'use strict';
	 *
	 *   angular
	 *       .module('demoApp', ['ngMaterial'])
	 *       .controller('DemoDialogController', DialogController);
	 *
	 *   var panelRef;
	 *
	 *   function showPanel($event) {
	 *     var panelPosition = $mdPanel.newPanelPosition()
	 *         .absolute()
	 *         .top('50%')
	 *         .left('50%');
	 *
	 *     var panelAnimation = $mdPanel.newPanelAnimation()
	 *         .targetEvent($event)
	 *         .defaultAnimation('md-panel-animate-fly')
	 *         .closeTo('.show-button');
	 *
	 *     var config = {
	 *       attachTo: angular.element(document.body),
	 *       controller: DialogController,
	 *       controllerAs: 'ctrl',
	 *       position: panelPosition,
	 *       animation: panelAnimation,
	 *       targetEvent: $event,
	 *       templateUrl: 'dialog-template.html',
	 *       clickOutsideToClose: true,
	 *       escapeToClose: true,
	 *       focusOnOpen: true
	 *     }
	 *
	 *     $mdPanel.open(config)
	 *         .then(function(result) {
	 *           panelRef = result;
	 *         });
	 *   }
	 *
	 *   function DialogController(MdPanelRef) {
	 *     function closeDialog() {
	 *       if (MdPanelRef) MdPanelRef.close();
	 *     }
	 *   }
	 * })(angular);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#create
	 * @description
	 * Creates a panel with the specified options.
	 *
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
	 *     the created panel is added to a tracked panels object. Any subsequent
	 *     requests made to create a panel with that ID are ignored. This is useful
	 *     in having the panel service not open multiple panels from the same user
	 *     interaction when there is no backdrop and events are propagated. Defaults
	 *     to an arbitrary string that is not tracked.
	 *   - `template` - `{string=}`: HTML template to show in the panel. This
	 *     **must** be trusted HTML with respect to AngularJS’s
	 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
	 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
	 *     the panel.
	 *   - `contentElement` - `{(string|!angular.JQLite|!Element)=}`: Pre-compiled
	 *     element to be used as the panel's content.
	 *   - `controller` - `{(function|string)=}`: The controller to associate with
	 *     the panel. The controller can inject a reference to the returned
	 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
	 *     fields passed in through locals or resolve will be bound to the
	 *     controller.
	 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
	 *     the scope.
	 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
	 *     instead of passing them in. Defaults to true, as this is a best
	 *     practice.
	 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
	 *     will be used as names of values to inject into the controller. For
	 *     example, `locals: {three: 3}` would inject `three` into the controller,
	 *     with the value 3.
	 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
	 *     values. The panel will not open until all of the promises resolve.
	 *   - `attachTo` - `{(string|!angular.JQLite|!Element)=}`: The element to
	 *     attach the panel to. Defaults to appending to the root element of the
	 *     application.
	 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
	 *     events should be allowed to propagate 'go through' the container, aka the
	 *     wrapper, of the panel. Defaults to false.
	 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
	 *     This class should define any borders, box-shadow, etc. for the panel.
	 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
	 *     Defaults to 80.
	 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
	 *     specifies the alignment of the panel. For more information, see
	 *     `MdPanelPosition`.
	 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
	 *     outside the panel to close it. Defaults to false.
	 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
	 *     close the panel. Defaults to false.
	 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
	 *     called after the close successfully finishes. The first parameter passed
	 *     into this function is the current panelRef and the 2nd is an optional
	 *     string explaining the close reason. The currently supported closeReasons
	 *     can be found in the MdPanelRef.closeReasons enum. These are by default
	 *     passed along by the panel.
	 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
	 *     panel. If `trapFocus` is true, the user will not be able to interact
	 *     with the rest of the page until the panel is dismissed. Defaults to
	 *     false.
	 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
	 *     open. Only disable if focusing some other way, as focus management is
	 *     required for panels to be accessible. Defaults to true.
	 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
	 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
	 *     to false.
	 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
	 *     specifies the animation of the panel. For more information, see
	 *     `MdPanelAnimation`.
	 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
	 *     behind the panel. Defaults to false.
	 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
	 *     page behind the panel. Defaults to false.
	 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
	 *     the panel is added to the DOM.
	 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
	 *     when the open() action is finished.
	 *   - `onRemoving` - `{function=}`: Callback function used to announce the
	 *     close/hide() action is starting.
	 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
	 *     the panel is removed from the DOM.
	 *   - `origin` - `{(string|!angular.JQLite|!Element)=}`: The element to focus
	 *     on when the panel closes. This is commonly the element which triggered
	 *     the opening of the panel. If you do not use `origin`, you need to control
	 *     the focus manually.
	 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
	 *     group names. The group name is used for creating a group of panels. The
	 *     group is used for configuring the number of open panels and identifying
	 *     specific behaviors for groups. For instance, all tooltips could be
	 *     identified using the same groupName.
	 *
	 * @returns {!MdPanelRef} panelRef
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#open
	 * @description
	 * Calls the create method above, then opens the panel. This is a shortcut for
	 * creating and then calling open manually. If custom methods need to be
	 * called when the panel is added to the DOM or opened, do not use this method.
	 * Instead create the panel, chain promises on the domAdded and openComplete
	 * methods, and call open from the returned panelRef.
	 *
	 * @param {!Object=} config Specific configuration object that may contain
	 *     the properties defined in `$mdPanel.create`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} panelRef A promise that resolves
	 *     to an instance of the panel.
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelPosition
	 * @description
	 * Returns a new instance of the MdPanelPosition object. Use this to create
	 * the position config object.
	 *
	 * @returns {!MdPanelPosition} panelPosition
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelAnimation
	 * @description
	 * Returns a new instance of the MdPanelAnimation object. Use this to create
	 * the animation config object.
	 *
	 * @returns {!MdPanelAnimation} panelAnimation
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#newPanelGroup
	 * @description
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 *
	 * @param {string} groupName Name of the group to create.
	 * @param {!Object=} config Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed to
	 *     be open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdPanel#setGroupMaxOpen
	 * @description
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 *
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelRef
	 * @module material.components.panel
	 * @description
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with the following properties:
	 *
	 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
	 *     when a panel was interacted with.
	 *   - `config` - `{!Object=}`: The entire config object that was used in
	 *     create.
	 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
	 *     Visibility to the user does not factor into isAttached.
	 *   - `panelContainer` - `{angular.JQLite}`: The wrapper element containing the
	 *     panel. This property is added in order to have access to the `addClass`,
	 *     `removeClass`, `toggleClass`, etc methods.
	 *   - `panelEl` - `{angular.JQLite}`: The panel element. This property is added
	 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
	 *     etc methods.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#open
	 * @description
	 * Attaches and shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     opened.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#close
	 * @description
	 * Hides and detaches the panel. Note that this will **not** destroy the panel.
	 * If you don't intend on using the panel again, call the {@link #destroy
	 * destroy} method afterwards.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     closed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#attach
	 * @description
	 * Create the panel elements and attach them to the DOM. The panel will be
	 * hidden by default.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     attached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#detach
	 * @description
	 * Removes the panel from the DOM. This will NOT hide the panel before removing
	 * it.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     detached.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#show
	 * @description
	 * Shows the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     shown and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#hide
	 * @description
	 * Hides the panel.
	 *
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     hidden and animations are completed.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#destroy
	 * @description
	 * Destroys the panel. The panel cannot be opened again after this is called.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Adds a class to the panel. DO NOT use this hide/show the panel.
	 *
	 * @param {string} newClass class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Removes a class from the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#toggleClass
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 * @description
	 * Toggles a class on the panel. DO NOT use this to hide/show the panel.
	 *
	 * @param {string} toggleClass Class to be toggled.
	 * @param {boolean} onElement Whether or not to remove the class from the panel
	 *     element instead of the container.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updatePosition
	 * @description
	 * Updates the position configuration of a panel. Use this to update the
	 * position of a panel that is open, without having to close and re-open the
	 * panel.
	 *
	 * @param {!MdPanelPosition} position
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#addToGroup
	 * @description
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 *
	 * @param {string} groupName The name of the group to add the panel to.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeFromGroup
	 * @description
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 *
	 * @param {string} groupName The name of the group.
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#registerInterceptor
	 * @description
	 * Registers an interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected. The interceptors are called sequentially
	 * and it reverse order. `type` must be one of the following
	 * values available on `$mdPanel.interceptorTypes`:
	 * * `CLOSE` - Gets called before the panel begins closing.
	 *
	 * @param {string} type Type of interceptor.
	 * @param {!angular.$q.Promise<any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeInterceptor
	 * @description
	 * Removes a registered interceptor.
	 *
	 * @param {string} type Type of interceptor to be removed.
	 * @param {function(): !angular.$q.Promise<any>} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#removeAllInterceptors
	 * @description
	 * Removes all interceptors. If a type is supplied, only the
	 * interceptors of that type will be cleared.
	 *
	 * @param {string=} type Type of interceptors to be removed.
	 * @returns {!MdPanelRef}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelRef#updateAnimation
	 * @description
	 * Updates the animation configuration for a panel. You can use this to change
	 * the panel's animation without having to re-create it.
	 *
	 * @param {!MdPanelAnimation} animation
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelPosition
	 * @module material.components.panel
	 * @description
	 *
	 * Object for configuring the position of the panel.
	 *
	 * @usage
	 *
	 * #### Centering the panel
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition().absolute().center();
	 * </hljs>
	 *
	 * #### Overlapping the panel with an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.ALIGN_START,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 * </hljs>
	 *
	 * #### Aligning the panel with the bottom of an element
	 *
	 * <hljs lang="js">
	 * new MdPanelPosition()
	 *     .relativeTo(someElement)
	 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#absolute
	 * @description
	 * Positions the panel absolutely relative to the parent element. If the parent
	 * is document.body, this is equivalent to positioning the panel absolutely
	 * within the viewport.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#relativeTo
	 * @description
	 * Positions the panel relative to a specific element.
	 *
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to position the panel with respect to.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#top
	 * @description
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#bottom
	 * @description
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 *
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#start
	 * @description
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 *
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#end
	 * @description
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 *
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#left
	 * @description
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#right
	 * @description
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 *
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerHorizontally
	 * @description
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#centerVertically
	 * @description
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#center
	 * @description
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 *
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#addPanelPosition
	 * @description
	 * Sets the x and y position for the panel relative to another element. Can be
	 * called multiple times to specify an ordered list of panel positions. The
	 * first position which allows the panel to be completely on-screen will be
	 * chosen; the last position will be chose whether it is on-screen or not.
	 *
	 * xPosition must be one of the following values available on
	 * $mdPanel.xPosition:
	 *
	 *
	 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
	 *
	 * <pre>
	 *    *************
	 *    *           *
	 *    *   PANEL   *
	 *    *           *
	 *    *************
	 *   A B    C    D E
	 *
	 * A: OFFSET_START (for LTR displays)
	 * B: ALIGN_START (for LTR displays)
	 * C: CENTER
	 * D: ALIGN_END (for LTR displays)
	 * E: OFFSET_END (for LTR displays)
	 * </pre>
	 *
	 * yPosition must be one of the following values available on
	 * $mdPanel.yPosition:
	 *
	 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
	 *
	 * <pre>
	 *   F
	 *   G *************
	 *     *           *
	 *   H *   PANEL   *
	 *     *           *
	 *   I *************
	 *   J
	 *
	 * F: BELOW
	 * G: ALIGN_TOPS
	 * H: CENTER
	 * I: ALIGN_BOTTOMS
	 * J: ABOVE
	 * </pre>
	 *
	 * @param {string} xPosition
	 * @param {string} yPosition
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetX
	 * @description
	 * Sets the value of the offset in the x-direction.
	 *
	 * @param {string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelPosition#withOffsetY
	 * @description
	 * Sets the value of the offset in the y-direction.
	 *
	 * @param {string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * @ngdoc type
	 * @name MdPanelAnimation
	 * @module material.components.panel
	 * @description
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * @usage
	 *
	 * <hljs lang="js">
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .duration(1337)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 * </hljs>
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#openFrom
	 * @description
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 *
	 * @param {string|!Element|!Event|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#closeTo
	 * @description
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 *
	 * @param {string|!Element|{top: number, left: number}}
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#withAnimation
	 * @description
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * ($mdPanel.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *       elements. It will not fade in or out.
	 *   SCALE: The panel scales in and out. Slide and fade are
	 *       included in this animation.
	 *   FADE: The panel fades in and out.
	 *
	 * Custom classes will by default fade in and out unless
	 * "transition: opacity 1ms" is added to the to custom class.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	
	/**
	 * @ngdoc method
	 * @name MdPanelAnimation#duration
	 * @description
	 * Specifies the duration of the animation in milliseconds. The `duration`
	 * method accepts either a number or an object with separate open and close
	 * durations.
	 *
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	
	
	/*****************************************************************************
	 *                            PUBLIC DOCUMENTATION                           *
	 *****************************************************************************/
	
	
	var MD_PANEL_Z_INDEX = 80;
	var MD_PANEL_HIDDEN = '_md-panel-hidden';
	var FOCUS_TRAP_TEMPLATE = angular.element(
	    '<div class="_md-panel-focus-trap" tabindex="0"></div>');
	
	var _presets = {};
	
	
	/**
	 * A provider that is used for creating presets for the panel API.
	 * @final @constructor @ngInject
	 */
	function MdPanelProvider() {
	  return {
	    'definePreset': definePreset,
	    'getAllPresets': getAllPresets,
	    'clearPresets': clearPresets,
	    '$get': $getProvider()
	  };
	}
	
	
	/**
	 * Takes the passed in panel configuration object and adds it to the `_presets`
	 * object at the specified name.
	 * @param {string} name Name of the preset to set.
	 * @param {!Object} preset Specific configuration object that can contain any
	 *     and all of the parameters avaialble within the `$mdPanel.create` method.
	 *     However, parameters that pertain to id, position, animation, and user
	 *     interaction are not allowed and will be removed from the preset
	 *     configuration.
	 */
	function definePreset(name, preset) {
	  if (!name || !preset) {
	    throw new Error('mdPanelProvider: The panel preset definition is ' +
	        'malformed. The name and preset object are required.');
	  } else if (_presets.hasOwnProperty(name)) {
	    throw new Error('mdPanelProvider: The panel preset you have requested ' +
	        'has already been defined.');
	  }
	
	  // Delete any property on the preset that is not allowed.
	  delete preset.id;
	  delete preset.position;
	  delete preset.animation;
	
	  _presets[name] = preset;
	}
	
	
	/**
	 * Gets a clone of the `_presets`.
	 * @return {!Object}
	 */
	function getAllPresets() {
	  return angular.copy(_presets);
	}
	
	
	/**
	 * Clears all of the stored presets.
	 */
	function clearPresets() {
	  _presets = {};
	}
	
	
	/**
	 * Represents the `$get` method of the AngularJS provider. From here, a new
	 * reference to the MdPanelService is returned where the needed arguments are
	 * passed in including the MdPanelProvider `_presets`.
	 * @param {!Object} _presets
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 */
	function $getProvider() {
	  return [
	    '$rootElement', '$rootScope', '$injector', '$window',
	    function($rootElement, $rootScope, $injector, $window) {
	      return new MdPanelService(_presets, $rootElement, $rootScope,
	          $injector, $window);
	    }
	  ];
	}
	
	
	/*****************************************************************************
	 *                               MdPanel Service                             *
	 *****************************************************************************/
	
	
	/**
	 * A service that is used for controlling/displaying panels on the screen.
	 * @param {!Object} presets
	 * @param {!angular.JQLite} $rootElement
	 * @param {!angular.Scope} $rootScope
	 * @param {!angular.$injector} $injector
	 * @param {!angular.$window} $window
	 * @final @constructor @ngInject
	 */
	function MdPanelService(presets, $rootElement, $rootScope, $injector, $window) {
	  /**
	   * Default config options for the panel.
	   * Anything angular related needs to be done later. Therefore
	   *     scope: $rootScope.$new(true),
	   *     attachTo: $rootElement,
	   * are added later.
	   * @private {!Object}
	   */
	  this._defaultConfigOptions = {
	    bindToController: true,
	    clickOutsideToClose: false,
	    disableParentScroll: false,
	    escapeToClose: false,
	    focusOnOpen: true,
	    fullscreen: false,
	    hasBackdrop: false,
	    propagateContainerEvents: false,
	    transformTemplate: angular.bind(this, this._wrapTemplate),
	    trapFocus: false,
	    zIndex: MD_PANEL_Z_INDEX
	  };
	
	  /** @private {!Object} */
	  this._config = {};
	
	  /** @private {!Object} */
	  this._presets = presets;
	
	  /** @private @const */
	  this._$rootElement = $rootElement;
	
	  /** @private @const */
	  this._$rootScope = $rootScope;
	
	  /** @private @const */
	  this._$injector = $injector;
	
	  /** @private @const */
	  this._$window = $window;
	
	  /** @private @const */
	  this._$mdUtil = this._$injector.get('$mdUtil');
	
	  /** @private {!Object<string, !MdPanelRef>} */
	  this._trackedPanels = {};
	
	  /**
	   * @private {!Object<string,
	   *     {panels: !Array<!MdPanelRef>,
	   *     openPanels: !Array<!MdPanelRef>,
	   *     maxOpen: number}>}
	   */
	  this._groups = Object.create(null);
	
	  /**
	   * Default animations that can be used within the panel.
	   * @type {enum}
	   */
	  this.animation = MdPanelAnimation.animation;
	
	  /**
	   * Possible values of xPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.xPosition = MdPanelPosition.xPosition;
	
	  /**
	   * Possible values of yPosition for positioning the panel relative to
	   * another element.
	   * @type {enum}
	   */
	  this.yPosition = MdPanelPosition.yPosition;
	
	  /**
	   * Possible values for the interceptors that can be registered on a panel.
	   * @type {enum}
	   */
	  this.interceptorTypes = MdPanelRef.interceptorTypes;
	
	  /**
	   * Possible values for closing of a panel.
	   * @type {enum}
	   */
	  this.closeReasons = MdPanelRef.closeReasons;
	
	  /**
	   * Possible values of absolute position.
	   * @type {enum}
	   */
	  this.absPosition = MdPanelPosition.absPosition;
	}
	
	
	/**
	 * Creates a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!MdPanelRef}
	 */
	MdPanelService.prototype.create = function(preset, config) {
	  if (typeof preset === 'string') {
	    preset = this._getPresetByName(preset);
	  } else if (typeof preset === 'object' &&
	      (angular.isUndefined(config) || !config)) {
	    config = preset;
	    preset = {};
	  }
	
	  preset = preset || {};
	  config = config || {};
	
	  // If the passed-in config contains an ID and the ID is within _trackedPanels,
	  // return the tracked panel after updating its config with the passed-in
	  // config.
	  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
	    var trackedPanel = this._trackedPanels[config.id];
	    angular.extend(trackedPanel.config, config);
	    return trackedPanel;
	  }
	
	  // Combine the passed-in config, the _defaultConfigOptions, and the preset
	  // configuration into the `_config`.
	  this._config = angular.extend({
	    // If no ID is set within the passed-in config, then create an arbitrary ID.
	    id: config.id || 'panel_' + this._$mdUtil.nextUid(),
	    scope: this._$rootScope.$new(true),
	    attachTo: this._$rootElement
	  }, this._defaultConfigOptions, config, preset);
	
	  // Create the panelRef and add it to the `_trackedPanels` object.
	  var panelRef = new MdPanelRef(this._config, this._$injector);
	  this._trackedPanels[config.id] = panelRef;
	
	  // Add the panel to each of its requested groups.
	  if (this._config.groupName) {
	    if (angular.isString(this._config.groupName)) {
	      this._config.groupName = [this._config.groupName];
	    }
	    angular.forEach(this._config.groupName, function(group) {
	      panelRef.addToGroup(group);
	    });
	  }
	
	  this._config.scope.$on('$destroy', angular.bind(panelRef, panelRef.detach));
	
	  return panelRef;
	};
	
	
	/**
	 * Creates and opens a panel with the specified options.
	 * @param {string=} preset Name of a preset configuration that can be used to
	 *     extend the panel configuration.
	 * @param {!Object=} config Configuration object for the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} The panel created from create.
	 */
	MdPanelService.prototype.open = function(preset, config) {
	  var panelRef = this.create(preset, config);
	  return panelRef.open().then(function() {
	    return panelRef;
	  });
	};
	
	
	/**
	 * Gets a specific preset configuration object saved within `_presets`.
	 * @param {string} preset Name of the preset to search for.
	 * @returns {!Object} The preset configuration object.
	 */
	MdPanelService.prototype._getPresetByName = function(preset) {
	  if (!this._presets[preset]) {
	    throw new Error('mdPanel: The panel preset configuration that you ' +
	        'requested does not exist. Use the $mdPanelProvider to create a ' +
	        'preset before requesting one.');
	  }
	  return this._presets[preset];
	};
	
	
	/**
	 * Returns a new instance of the MdPanelPosition. Use this to create the
	 * positioning object.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelService.prototype.newPanelPosition = function() {
	  return new MdPanelPosition(this._$injector);
	};
	
	
	/**
	 * Returns a new instance of the MdPanelAnimation. Use this to create the
	 * animation object.
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelService.prototype.newPanelAnimation = function() {
	  return new MdPanelAnimation(this._$injector);
	};
	
	
	/**
	 * Creates a panel group and adds it to a tracked list of panel groups.
	 * @param groupName {string} Name of the group to create.
	 * @param config {!Object=} Specific configuration object that may contain the
	 *     following properties:
	 *
	 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed
	 *     open within a defined panel group.
	 *
	 * @returns {!Object<string,
	 *     {panels: !Array<!MdPanelRef>,
	 *     openPanels: !Array<!MdPanelRef>,
	 *     maxOpen: number}>} panelGroup
	 */
	MdPanelService.prototype.newPanelGroup = function(groupName, config) {
	  if (!this._groups[groupName]) {
	    config = config || {};
	    var group = {
	      panels: [],
	      openPanels: [],
	      maxOpen: config.maxOpen > 0 ? config.maxOpen : Infinity
	    };
	    this._groups[groupName] = group;
	  }
	  return this._groups[groupName];
	};
	
	
	/**
	 * Sets the maximum number of panels in a group that can be opened at a given
	 * time.
	 * @param {string} groupName The name of the group to configure.
	 * @param {number} maxOpen The maximum number of panels that can be
	 *     opened. Infinity can be passed in to remove the maxOpen limit.
	 */
	MdPanelService.prototype.setGroupMaxOpen = function(groupName, maxOpen) {
	  if (this._groups[groupName]) {
	    this._groups[groupName].maxOpen = maxOpen;
	  } else {
	    throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');
	  }
	};
	
	
	/**
	 * Determines if the current number of open panels within a group exceeds the
	 * limit of allowed open panels.
	 * @param {string} groupName The name of the group to check.
	 * @returns {boolean} true if open count does exceed maxOpen and false if not.
	 * @private
	 */
	MdPanelService.prototype._openCountExceedsMaxOpen = function(groupName) {
	  if (this._groups[groupName]) {
	    var group = this._groups[groupName];
	    return group.maxOpen > 0 && group.openPanels.length > group.maxOpen;
	  }
	  return false;
	};
	
	
	/**
	 * Closes the first open panel within a specific group.
	 * @param {string} groupName The name of the group.
	 * @private
	 */
	MdPanelService.prototype._closeFirstOpenedPanel = function(groupName) {
	  this._groups[groupName].openPanels[0].close();
	};
	
	
	/**
	 * Wraps the users template in two elements, md-panel-outer-wrapper, which
	 * covers the entire attachTo element, and md-panel, which contains only the
	 * template. This allows the panel control over positioning, animations,
	 * and similar properties.
	 * @param {string} origTemplate The original template.
	 * @returns {string} The wrapped template.
	 * @private
	 */
	MdPanelService.prototype._wrapTemplate = function(origTemplate) {
	  var template = origTemplate || '';
	
	  // The panel should be initially rendered offscreen so we can calculate
	  // height and width for positioning.
	  return '' +
	      '<div class="md-panel-outer-wrapper">' +
	      '  <div class="md-panel _md-panel-offscreen">' + template + '</div>' +
	      '</div>';
	};
	
	
	/**
	 * Wraps a content element in a md-panel-outer wrapper and
	 * positions it off-screen. Allows for proper control over positoning
	 * and animations.
	 * @param {!angular.JQLite} contentElement Element to be wrapped.
	 * @return {!angular.JQLite} Wrapper element.
	 * @private
	 */
	MdPanelService.prototype._wrapContentElement = function(contentElement) {
	  var wrapper = angular.element('<div class="md-panel-outer-wrapper">');
	
	  contentElement.addClass('md-panel _md-panel-offscreen');
	  wrapper.append(contentElement);
	
	  return wrapper;
	};
	
	
	/*****************************************************************************
	 *                                 MdPanelRef                                *
	 *****************************************************************************/
	
	
	/**
	 * A reference to a created panel. This reference contains a unique id for the
	 * panel, along with properties/functions used to control the panel.
	 * @param {!Object} config
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelRef(config, $injector) {
	  // Injected variables.
	  /** @private @const {!angular.$q} */
	  this._$q = $injector.get('$q');
	
	  /** @private @const {!angular.$mdCompiler} */
	  this._$mdCompiler = $injector.get('$mdCompiler');
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /** @private @const {!angular.$mdTheming} */
	  this._$mdTheming = $injector.get('$mdTheming');
	
	  /** @private @const {!angular.Scope} */
	  this._$rootScope = $injector.get('$rootScope');
	
	  /** @private @const {!angular.$animate} */
	  this._$animate = $injector.get('$animate');
	
	  /** @private @const {!MdPanelRef} */
	  this._$mdPanel = $injector.get('$mdPanel');
	
	  /** @private @const {!angular.$log} */
	  this._$log = $injector.get('$log');
	
	  /** @private @const {!angular.$window} */
	  this._$window = $injector.get('$window');
	
	  /** @private @const {!Function} */
	  this._$$rAF = $injector.get('$$rAF');
	
	  // Public variables.
	  /**
	   * Unique id for the panelRef.
	   * @type {string}
	   */
	  this.id = config.id;
	
	  /** @type {!Object} */
	  this.config = config;
	
	  /** @type {!angular.JQLite|undefined} */
	  this.panelContainer;
	
	  /** @type {!angular.JQLite|undefined} */
	  this.panelEl;
	
	  /**
	   * Whether the panel is attached. This is synchronous. When attach is called,
	   * isAttached is set to true. When detach is called, isAttached is set to
	   * false.
	   * @type {boolean}
	   */
	  this.isAttached = false;
	
	  // Private variables.
	  /** @private {Array<function()>} */
	  this._removeListeners = [];
	
	  /** @private {!angular.JQLite|undefined} */
	  this._topFocusTrap;
	
	  /** @private {!angular.JQLite|undefined} */
	  this._bottomFocusTrap;
	
	  /** @private {!$mdPanel|undefined} */
	  this._backdropRef;
	
	  /** @private {Function?} */
	  this._restoreScroll = null;
	
	  /**
	   * Keeps track of all the panel interceptors.
	   * @private {!Object}
	   */
	  this._interceptors = Object.create(null);
	
	  /**
	   * Cleanup function, provided by `$mdCompiler` and assigned after the element
	   * has been compiled. When `contentElement` is used, the function is used to
	   * restore the element to it's proper place in the DOM.
	   * @private {!Function}
	   */
	  this._compilerCleanup = null;
	
	  /**
	   * Cache for saving and restoring element inline styles, CSS classes etc.
	   * @type {{styles: string, classes: string}}
	   */
	  this._restoreCache = {
	    styles: '',
	    classes: ''
	  };
	}
	
	
	MdPanelRef.interceptorTypes = {
	  CLOSE: 'onClose'
	};
	
	
	/**
	 * Opens an already created and configured panel. If the panel is already
	 * visible, does nothing.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is opened and animations finish.
	 */
	MdPanelRef.prototype.open = function() {
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var show = self._simpleBind(self.show, self);
	    var checkGroupMaxOpen = function() {
	      if (self.config.groupName) {
	        angular.forEach(self.config.groupName, function(group) {
	          if (self._$mdPanel._openCountExceedsMaxOpen(group)) {
	            self._$mdPanel._closeFirstOpenedPanel(group);
	          }
	        });
	      }
	    };
	
	    self.attach()
	        .then(show)
	        .then(checkGroupMaxOpen)
	        .then(done)
	        .catch(reject);
	  });
	};
	
	
	/**
	 * Closes the panel.
	 * @param {string} closeReason The event type that triggered the close.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is closed and animations finish.
	 */
	MdPanelRef.prototype.close = function(closeReason) {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function() {
	      var done = self._done(resolve, self);
	      var detach = self._simpleBind(self.detach, self);
	      var onCloseSuccess = self.config['onCloseSuccess'] || angular.noop;
	      onCloseSuccess = angular.bind(self, onCloseSuccess, self, closeReason);
	
	      self.hide()
	          .then(detach)
	          .then(done)
	          .then(onCloseSuccess)
	          .catch(reject);
	    }, reject);
	  });
	};
	
	
	/**
	 * Attaches the panel. The panel will be hidden afterwards.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is attached.
	 */
	MdPanelRef.prototype.attach = function() {
	  if (this.isAttached && this.panelEl) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onDomAdded = self.config['onDomAdded'] || angular.noop;
	    var addListeners = function(response) {
	      self.isAttached = true;
	      self._addEventListeners();
	      return response;
	    };
	
	    self._$q.all([
	        self._createBackdrop(),
	        self._createPanel()
	            .then(addListeners)
	            .catch(reject)
	    ]).then(onDomAdded)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Only detaches the panel. Will NOT hide the panel first.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel is detached.
	 */
	MdPanelRef.prototype.detach = function() {
	  if (!this.isAttached) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;
	
	  var detachFn = function() {
	    self._removeEventListeners();
	
	    // Remove the focus traps that we added earlier for keeping focus within
	    // the panel.
	    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
	      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
	    }
	
	    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
	      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
	    }
	
	    if (self._restoreCache.classes) {
	      self.panelEl[0].className = self._restoreCache.classes;
	    }
	
	    // Either restore the saved styles or clear the ones set by mdPanel.
	    self.panelEl[0].style.cssText = self._restoreCache.styles || '';
	
	    self._compilerCleanup();
	    self.panelContainer.remove();
	    self.isAttached = false;
	    return self._$q.when(self);
	  };
	
	  if (this._restoreScroll) {
	    this._restoreScroll();
	    this._restoreScroll = null;
	  }
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	
	    self._$q.all([
	      detachFn(),
	      self._backdropRef ? self._backdropRef.detach() : true
	    ]).then(onDomRemoved)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Destroys the panel. The Panel cannot be opened again after this.
	 */
	MdPanelRef.prototype.destroy = function() {
	  var self = this;
	  if (this.config.groupName) {
	    angular.forEach(this.config.groupName, function(group) {
	      self.removeFromGroup(group);
	    });
	  }
	  this.config.scope.$destroy();
	  this.config.locals = null;
	  this._interceptors = null;
	};
	
	
	/**
	 * Shows the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has shown and animations finish.
	 */
	MdPanelRef.prototype.show = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  var animatePromise = function() {
	    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
	    return self._animateOpen();
	  };
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
	    var addToGroupOpen = function() {
	      if (self.config.groupName) {
	        angular.forEach(self.config.groupName, function(group) {
	          self._$mdPanel._groups[group].openPanels.push(self);
	        });
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.show() : self,
	      animatePromise().then(function() { self._focusOnOpen(); }, reject)
	    ]).then(onOpenComplete)
	      .then(addToGroupOpen)
	      .then(done)
	      .catch(reject);
	  });
	};
	
	
	/**
	 * Hides the panel.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
	 *     the panel has hidden and animations finish.
	 */
	MdPanelRef.prototype.hide = function() {
	  if (!this.panelContainer) {
	    return this._$q(function(resolve, reject) {
	      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
	    });
	  }
	
	  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
	    return this._$q.when(this);
	  }
	
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    var done = self._done(resolve, self);
	    var onRemoving = self.config['onRemoving'] || angular.noop;
	    var hidePanel = function() {
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	    };
	    var removeFromGroupOpen = function() {
	      if (self.config.groupName) {
	        var group, index;
	        angular.forEach(self.config.groupName, function(group) {
	          group = self._$mdPanel._groups[group];
	          index = group.openPanels.indexOf(self);
	          if (index > -1) {
	            group.openPanels.splice(index, 1);
	          }
	        });
	      }
	    };
	    var focusOnOrigin = function() {
	      var origin = self.config['origin'];
	      if (origin) {
	        getElement(origin).focus();
	      }
	    };
	
	    self._$q.all([
	      self._backdropRef ? self._backdropRef.hide() : self,
	      self._animateClose()
	          .then(onRemoving)
	          .then(hidePanel)
	          .then(removeFromGroupOpen)
	          .then(focusOnOrigin)
	          .catch(reject)
	    ]).then(done, reject);
	  });
	};
	
	
	/**
	 * Add a class to the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} newClass Class to be added.
	 * @param {boolean} toElement Whether or not to add the class to the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.addClass = function(newClass, toElement) {
	  this._$log.warn(
	      'mdPanel: The addClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!toElement && !this.panelContainer.hasClass(newClass)) {
	    this.panelContainer.addClass(newClass);
	  } else if (toElement && !this.panelEl.hasClass(newClass)) {
	    this.panelEl.addClass(newClass);
	  }
	};
	
	
	/**
	 * Remove a class from the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} oldClass Class to be removed.
	 * @param {boolean} fromElement Whether or not to remove the class from the
	 *     panel element instead of the container.
	 */
	MdPanelRef.prototype.removeClass = function(oldClass, fromElement) {
	  this._$log.warn(
	      'mdPanel: The removeClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!fromElement && this.panelContainer.hasClass(oldClass)) {
	    this.panelContainer.removeClass(oldClass);
	  } else if (fromElement && this.panelEl.hasClass(oldClass)) {
	    this.panelEl.removeClass(oldClass);
	  }
	};
	
	
	/**
	 * Toggle a class on the panel. DO NOT use this to hide/show the panel.
	 * @deprecated
	 * This method is in the process of being deprecated in favor of using the panel
	 * and container JQLite elements that are referenced in the MdPanelRef object.
	 * Full deprecation is scheduled for material 1.2.
	 *
	 * @param {string} toggleClass The class to toggle.
	 * @param {boolean} onElement Whether or not to toggle the class on the panel
	 *     element instead of the container.
	 */
	MdPanelRef.prototype.toggleClass = function(toggleClass, onElement) {
	  this._$log.warn(
	      'mdPanel: The toggleClass method is in the process of being deprecated. ' +
	      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
	      'To achieve the same results, use the panelContainer or panelEl ' +
	      'JQLite elements that are referenced in MdPanelRef.');
	
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  if (!onElement) {
	    this.panelContainer.toggleClass(toggleClass);
	  } else {
	    this.panelEl.toggleClass(toggleClass);
	  }
	};
	
	
	/**
	 * Compiles the panel, according to the passed in config and appends it to
	 * the DOM. Helps normalize differences in the compilation process between
	 * using a string template and a content element.
	 * @returns {!angular.$q.Promise<!MdPanelRef>} Promise that is resolved when
	 *     the element has been compiled and added to the DOM.
	 * @private
	 */
	MdPanelRef.prototype._compile = function() {
	  var self = this;
	
	  // Compile the element via $mdCompiler. Note that when using a
	  // contentElement, the element isn't actually being compiled, rather the
	  // compiler saves it's place in the DOM and provides a way of restoring it.
	  return self._$mdCompiler.compile(self.config).then(function(compileData) {
	    var config = self.config;
	
	    if (config.contentElement) {
	      var panelEl = compileData.element;
	
	      // Since mdPanel modifies the inline styles and CSS classes, we need
	      // to save them in order to be able to restore on close.
	      self._restoreCache.styles = panelEl[0].style.cssText;
	      self._restoreCache.classes = panelEl[0].className;
	
	      self.panelContainer = self._$mdPanel._wrapContentElement(panelEl);
	      self.panelEl = panelEl;
	    } else {
	      self.panelContainer = compileData.link(config['scope']);
	      self.panelEl = angular.element(
	        self.panelContainer[0].querySelector('.md-panel')
	      );
	    }
	
	    // Save a reference to the cleanup function from the compiler.
	    self._compilerCleanup = compileData.cleanup;
	
	    // Attach the panel to the proper place in the DOM.
	    getElement(self.config['attachTo']).append(self.panelContainer);
	
	    return self;
	  });
	};
	
	
	/**
	 * Creates a panel and adds it to the dom.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
	 *     created.
	 * @private
	 */
	MdPanelRef.prototype._createPanel = function() {
	  var self = this;
	
	  return this._$q(function(resolve, reject) {
	    if (!self.config.locals) {
	      self.config.locals = {};
	    }
	
	    self.config.locals.mdPanelRef = self;
	
	    self._compile().then(function() {
	      if (self.config['disableParentScroll']) {
	        self._restoreScroll = self._$mdUtil.disableScrollAround(
	          null,
	          self.panelContainer,
	          { disableScrollMask: true }
	        );
	      }
	
	      // Add a custom CSS class to the panel element.
	      if (self.config['panelClass']) {
	        self.panelEl.addClass(self.config['panelClass']);
	      }
	
	      // Handle click and touch events for the panel container.
	      if (self.config['propagateContainerEvents']) {
	        self.panelContainer.css('pointer-events', 'none');
	      }
	
	      // Panel may be outside the $rootElement, tell ngAnimate to animate
	      // regardless.
	      if (self._$animate.pin) {
	        self._$animate.pin(
	          self.panelContainer,
	          getElement(self.config['attachTo'])
	        );
	      }
	
	      self._configureTrapFocus();
	      self._addStyles().then(function() {
	        resolve(self);
	      }, reject);
	    }, reject);
	
	  });
	};
	
	
	/**
	 * Adds the styles for the panel, such as positioning and z-index. Also,
	 * themes the panel element and panel container using `$mdTheming`.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._addStyles = function() {
	  var self = this;
	  return this._$q(function(resolve) {
	    self.panelContainer.css('z-index', self.config['zIndex']);
	    self.panelEl.css('z-index', self.config['zIndex'] + 1);
	
	    var hideAndResolve = function() {
	      // Theme the element and container.
	      self._setTheming();
	
	      // Remove offscreen class and add hidden class.
	      self.panelEl.removeClass('_md-panel-offscreen');
	      self.panelContainer.addClass(MD_PANEL_HIDDEN);
	
	      resolve(self);
	    };
	
	    if (self.config['fullscreen']) {
	      self.panelEl.addClass('_md-panel-fullscreen');
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    var positionConfig = self.config['position'];
	    if (!positionConfig) {
	      hideAndResolve();
	      return; // Don't setup positioning.
	    }
	
	    // Wait for angular to finish processing the template
	    self._$rootScope['$$postDigest'](function() {
	      // Position it correctly. This is necessary so that the panel will have a
	      // defined height and width.
	      self._updatePosition(true);
	
	      // Theme the element and container.
	      self._setTheming();
	
	      resolve(self);
	    });
	  });
	};
	
	
	/**
	 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
	 * @private
	 */
	MdPanelRef.prototype._setTheming = function() {
	  this._$mdTheming(this.panelEl);
	  this._$mdTheming(this.panelContainer);
	};
	
	
	/**
	 * Updates the position configuration of a panel
	 * @param {!MdPanelPosition} position
	 */
	MdPanelRef.prototype.updatePosition = function(position) {
	  if (!this.panelContainer) {
	    throw new Error(
	        'mdPanel: Panel does not exist yet. Call open() or attach().');
	  }
	
	  this.config['position'] = position;
	  this._updatePosition();
	};
	
	
	/**
	 * Calculates and updates the position of the panel.
	 * @param {boolean=} init
	 * @private
	 */
	MdPanelRef.prototype._updatePosition = function(init) {
	  var positionConfig = this.config['position'];
	
	  if (positionConfig) {
	    positionConfig._setPanelPosition(this.panelEl);
	
	    // Hide the panel now that position is known.
	    if (init) {
	      this.panelEl.removeClass('_md-panel-offscreen');
	      this.panelContainer.addClass(MD_PANEL_HIDDEN);
	    }
	
	    this.panelEl.css(
	      MdPanelPosition.absPosition.TOP,
	      positionConfig.getTop()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.BOTTOM,
	      positionConfig.getBottom()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.LEFT,
	      positionConfig.getLeft()
	    );
	    this.panelEl.css(
	      MdPanelPosition.absPosition.RIGHT,
	      positionConfig.getRight()
	    );
	  }
	};
	
	
	/**
	 * Focuses on the panel or the first focus target.
	 * @private
	 */
	MdPanelRef.prototype._focusOnOpen = function() {
	  if (this.config['focusOnOpen']) {
	    // Wait for the template to finish rendering to guarantee md-autofocus has
	    // finished adding the class md-autofocus, otherwise the focusable element
	    // isn't available to focus.
	    var self = this;
	    this._$rootScope['$$postDigest'](function() {
	      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
	          self.panelEl;
	      target.focus();
	    });
	  }
	};
	
	
	/**
	 * Shows the backdrop.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the backdrop
	 *     is created and attached.
	 * @private
	 */
	MdPanelRef.prototype._createBackdrop = function() {
	  if (this.config.hasBackdrop) {
	    if (!this._backdropRef) {
	      var backdropAnimation = this._$mdPanel.newPanelAnimation()
	          .openFrom(this.config.attachTo)
	          .withAnimation({
	            open: '_md-opaque-enter',
	            close: '_md-opaque-leave'
	          });
	
	      if (this.config.animation) {
	        backdropAnimation.duration(this.config.animation._rawDuration);
	      }
	
	      var backdropConfig = {
	        animation: backdropAnimation,
	        attachTo: this.config.attachTo,
	        focusOnOpen: false,
	        panelClass: '_md-panel-backdrop',
	        zIndex: this.config.zIndex - 1
	      };
	
	      this._backdropRef = this._$mdPanel.create(backdropConfig);
	    }
	    if (!this._backdropRef.isAttached) {
	      return this._backdropRef.attach();
	    }
	  }
	};
	
	
	/**
	 * Listen for escape keys and outside clicks to auto close.
	 * @private
	 */
	MdPanelRef.prototype._addEventListeners = function() {
	  this._configureEscapeToClose();
	  this._configureClickOutsideToClose();
	  this._configureScrollListener();
	};
	
	
	/**
	 * Remove event listeners added in _addEventListeners.
	 * @private
	 */
	MdPanelRef.prototype._removeEventListeners = function() {
	  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
	    removeFn();
	  });
	  this._removeListeners = [];
	};
	
	
	/**
	 * Setup the escapeToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureEscapeToClose = function() {
	  if (this.config['escapeToClose']) {
	    var parentTarget = getElement(this.config['attachTo']);
	    var self = this;
	
	    var keyHandlerFn = function(ev) {
	      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.ESCAPE);
	      }
	    };
	
	    // Add keydown listeners
	    this.panelContainer.on('keydown', keyHandlerFn);
	    parentTarget.on('keydown', keyHandlerFn);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      self.panelContainer.off('keydown', keyHandlerFn);
	      parentTarget.off('keydown', keyHandlerFn);
	    });
	  }
	};
	
	
	/**
	 * Setup the clickOutsideToClose event listeners.
	 * @private
	 */
	MdPanelRef.prototype._configureClickOutsideToClose = function() {
	  if (this.config['clickOutsideToClose']) {
	    var target = this.config['propagateContainerEvents'] ?
	        angular.element(document.body) :
	        this.panelContainer;
	    var sourceEl;
	
	    // Keep track of the element on which the mouse originally went down
	    // so that we can only close the backdrop when the 'click' started on it.
	    // A simple 'click' handler does not work, it sets the target object as the
	    // element the mouse went down on.
	    var mousedownHandler = function(ev) {
	      sourceEl = ev.target;
	    };
	
	    // We check if our original element and the target is the backdrop
	    // because if the original was the backdrop and the target was inside the
	    // panel we don't want to panel to close.
	    var self = this;
	    var mouseupHandler = function(ev) {
	      if (self.config['propagateContainerEvents']) {
	
	        // We check if the sourceEl of the event is the panel element or one
	        // of it's children. If it is not, then close the panel.
	        if (sourceEl !== self.panelEl[0] && !self.panelEl[0].contains(sourceEl)) {
	          self.close();
	        }
	
	      } else if (sourceEl === target[0] && ev.target === target[0]) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);
	      }
	    };
	
	    // Add listeners
	    target.on('mousedown', mousedownHandler);
	    target.on('mouseup', mouseupHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(function() {
	      target.off('mousedown', mousedownHandler);
	      target.off('mouseup', mouseupHandler);
	    });
	  }
	};
	
	
	/**
	 * Configures the listeners for updating the panel position on scroll.
	 * @private
	*/
	MdPanelRef.prototype._configureScrollListener = function() {
	  // No need to bind the event if scrolling is disabled.
	  if (!this.config['disableParentScroll']) {
	    var updatePosition = angular.bind(this, this._updatePosition);
	    var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
	    var self = this;
	
	    var onScroll = function() {
	      debouncedUpdatePosition();
	    };
	
	    // Add listeners.
	    this._$window.addEventListener('scroll', onScroll, true);
	
	    // Queue remove listeners function.
	    this._removeListeners.push(function() {
	      self._$window.removeEventListener('scroll', onScroll, true);
	    });
	  }
	};
	
	
	/**
	 * Setup the focus traps. These traps will wrap focus when tabbing past the
	 * panel. When shift-tabbing, the focus will stick in place.
	 * @private
	 */
	MdPanelRef.prototype._configureTrapFocus = function() {
	  // Focus doesn't remain inside of the panel without this.
	  this.panelEl.attr('tabIndex', '-1');
	  if (this.config['trapFocus']) {
	    var element = this.panelEl;
	    // Set up elements before and after the panel to capture focus and
	    // redirect back into the panel.
	    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
	
	    // When focus is about to move out of the panel, we want to intercept it
	    // and redirect it back to the panel element.
	    var focusHandler = function() {
	      element.focus();
	    };
	    this._topFocusTrap.addEventListener('focus', focusHandler);
	    this._bottomFocusTrap.addEventListener('focus', focusHandler);
	
	    // Queue remove listeners function
	    this._removeListeners.push(this._simpleBind(function() {
	      this._topFocusTrap.removeEventListener('focus', focusHandler);
	      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
	    }, this));
	
	    // The top focus trap inserted immediately before the md-panel element (as
	    // a sibling). The bottom focus trap inserted immediately after the
	    // md-panel element (as a sibling).
	    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
	    element.after(this._bottomFocusTrap);
	  }
	};
	
	
	/**
	 * Updates the animation of a panel.
	 * @param {!MdPanelAnimation} animation
	 */
	MdPanelRef.prototype.updateAnimation = function(animation) {
	  this.config['animation'] = animation;
	
	  if (this._backdropRef) {
	    this._backdropRef.config.animation.duration(animation._rawDuration);
	  }
	};
	
	
	/**
	 * Animate the panel opening.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated open.
	 * @private
	 */
	MdPanelRef.prototype._animateOpen = function() {
	  this.panelContainer.addClass('md-panel-is-showing');
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    // Promise is in progress, return it.
	    this.panelContainer.addClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = self._done(resolve, self);
	    var warnAndOpen = function() {
	      self._$log.warn(
	          'mdPanel: MdPanel Animations failed. ' +
	          'Showing panel without animating.');
	      done();
	    };
	
	    animationConfig.animateOpen(self.panelEl)
	        .then(done, warnAndOpen);
	  });
	};
	
	
	/**
	 * Animate the panel closing.
	 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
	 *     animated closed.
	 * @private
	 */
	MdPanelRef.prototype._animateClose = function() {
	  var animationConfig = this.config['animation'];
	  if (!animationConfig) {
	    this.panelContainer.removeClass('md-panel-is-showing');
	    this.panelContainer.removeClass('_md-panel-shown');
	    return this._$q.when(this);
	  }
	
	  var self = this;
	  return this._$q(function(resolve) {
	    var done = function() {
	      self.panelContainer.removeClass('md-panel-is-showing');
	      resolve(self);
	    };
	    var warnAndClose = function() {
	      self._$log.warn(
	          'mdPanel: MdPanel Animations failed. ' +
	          'Hiding panel without animating.');
	      done();
	    };
	
	    animationConfig.animateClose(self.panelEl)
	        .then(done, warnAndClose);
	  });
	};
	
	
	/**
	 * Registers a interceptor with the panel. The callback should return a promise,
	 * which will allow the action to continue when it gets resolved, or will
	 * prevent an action if it is rejected.
	 * @param {string} type Type of interceptor.
	 * @param {!angular.$q.Promise<!any>} callback Callback to be registered.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.registerInterceptor = function(type, callback) {
	  var error = null;
	
	  if (!angular.isString(type)) {
	    error = 'Interceptor type must be a string, instead got ' + typeof type;
	  } else if (!angular.isFunction(callback)) {
	    error = 'Interceptor callback must be a function, instead got ' + typeof callback;
	  }
	
	  if (error) {
	    throw new Error('MdPanel: ' + error);
	  }
	
	  var interceptors = this._interceptors[type] = this._interceptors[type] || [];
	
	  if (interceptors.indexOf(callback) === -1) {
	    interceptors.push(callback);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes a registered interceptor.
	 * @param {string} type Type of interceptor to be removed.
	 * @param {Function} callback Interceptor to be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeInterceptor = function(type, callback) {
	  var index = this._interceptors[type] ?
	    this._interceptors[type].indexOf(callback) : -1;
	
	  if (index > -1) {
	    this._interceptors[type].splice(index, 1);
	  }
	
	  return this;
	};
	
	
	/**
	 * Removes all interceptors.
	 * @param {string=} type Type of interceptors to be removed.
	 *     If ommited, all interceptors types will be removed.
	 * @returns {!MdPanelRef}
	 */
	MdPanelRef.prototype.removeAllInterceptors = function(type) {
	  if (type) {
	    this._interceptors[type] = [];
	  } else {
	    this._interceptors = Object.create(null);
	  }
	
	  return this;
	};
	
	
	/**
	 * Invokes all the interceptors of a certain type sequantially in
	 *     reverse order. Works in a similar way to `$q.all`, except it
	 *     respects the order of the functions.
	 * @param {string} type Type of interceptors to be invoked.
	 * @returns {!angular.$q.Promise<!MdPanelRef>}
	 * @private
	 */
	MdPanelRef.prototype._callInterceptors = function(type) {
	  var self = this;
	  var $q = self._$q;
	  var interceptors = self._interceptors && self._interceptors[type] || [];
	
	  return interceptors.reduceRight(function(promise, interceptor) {
	    var isPromiseLike = interceptor && angular.isFunction(interceptor.then);
	    var response = isPromiseLike ? interceptor : null;
	
	    /**
	    * For interceptors to reject/cancel subsequent portions of the chain, simply
	    * return a `$q.reject(<value>)`
	    */
	    return promise.then(function() {
	      if (!response) {
	        try {
	          response = interceptor(self);
	        } catch(e) {
	          response = $q.reject(e);
	        }
	      }
	
	     return response;
	    });
	  }, $q.resolve(self));
	};
	
	
	/**
	 * Faster, more basic than angular.bind
	 * http://jsperf.com/angular-bind-vs-custom-vs-native
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a bound self.
	 */
	MdPanelRef.prototype._simpleBind = function(callback, self) {
	  return function(value) {
	    return callback.apply(self, value);
	  };
	};
	
	
	/**
	 * @param {function} callback
	 * @param {!Object} self
	 * @return {function} Callback function with a self param.
	 */
	MdPanelRef.prototype._done = function(callback, self) {
	  return function() {
	    callback(self);
	  };
	};
	
	
	/**
	 * Adds a panel to a group if the panel does not exist within the group already.
	 * A panel can only exist within a single group.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.addToGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    this._$mdPanel.newPanelGroup(groupName);
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index < 0) {
	    group.panels.push(this);
	  }
	};
	
	
	/**
	 * Removes a panel from a group if the panel exists within that group. The group
	 * must be created ahead of time.
	 * @param {string} groupName The name of the group.
	 */
	MdPanelRef.prototype.removeFromGroup = function(groupName) {
	  if (!this._$mdPanel._groups[groupName]) {
	    throw new Error('mdPanel: The group ' + groupName + ' does not exist.');
	  }
	
	  var group = this._$mdPanel._groups[groupName];
	  var index = group.panels.indexOf(this);
	
	  if (index > -1) {
	    group.panels.splice(index, 1);
	  }
	};
	
	
	/**
	 * Possible default closeReasons for the close function.
	 * @enum {string}
	 */
	MdPanelRef.closeReasons = {
	  CLICK_OUTSIDE: 'clickOutsideToClose',
	  ESCAPE: 'escapeToClose',
	};
	
	
	/*****************************************************************************
	 *                               MdPanelPosition                             *
	 *****************************************************************************/
	
	
	/**
	 * Position configuration object. To use, create an MdPanelPosition with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelPosition = new MdPanelPosition()
	 *     .relativeTo(myButtonEl)
	 *     .addPanelPosition(
	 *       $mdPanel.xPosition.CENTER,
	 *       $mdPanel.yPosition.ALIGN_TOPS
	 *     );
	 *
	 * $mdPanel.create({
	 *   position: panelPosition
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelPosition($injector) {
	  /** @private @const {!angular.$window} */
	  this._$window = $injector.get('$window');
	
	  /** @private {boolean} */
	  this._isRTL = $injector.get('$mdUtil').bidi() === 'rtl';
	
	  /** @private @const {!angular.$mdConstant} */
	  this._$mdConstant = $injector.get('$mdConstant');
	
	  /** @private {boolean} */
	  this._absolute = false;
	
	  /** @private {!angular.JQLite} */
	  this._relativeToEl;
	
	  /** @private {string} */
	  this._top = '';
	
	  /** @private {string} */
	  this._bottom = '';
	
	  /** @private {string} */
	  this._left = '';
	
	  /** @private {string} */
	  this._right = '';
	
	  /** @private {!Array<string>} */
	  this._translateX = [];
	
	  /** @private {!Array<string>} */
	  this._translateY = [];
	
	  /** @private {!Array<{x:string, y:string}>} */
	  this._positions = [];
	
	  /** @private {?{x:string, y:string}} */
	  this._actualPosition;
	}
	
	
	/**
	 * Possible values of xPosition.
	 * @enum {string}
	 */
	MdPanelPosition.xPosition = {
	  CENTER: 'center',
	  ALIGN_START: 'align-start',
	  ALIGN_END: 'align-end',
	  OFFSET_START: 'offset-start',
	  OFFSET_END: 'offset-end'
	};
	
	
	/**
	 * Possible values of yPosition.
	 * @enum {string}
	 */
	MdPanelPosition.yPosition = {
	  CENTER: 'center',
	  ALIGN_TOPS: 'align-tops',
	  ALIGN_BOTTOMS: 'align-bottoms',
	  ABOVE: 'above',
	  BELOW: 'below'
	};
	
	
	/**
	 * Possible values of absolute position.
	 * @enum {string}
	 */
	MdPanelPosition.absPosition = {
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	/**
	 * Margin between the edges of a panel and the viewport.
	 * @const {number}
	 */
	MdPanelPosition.viewportMargin = 8;
	
	
	/**
	 * Sets absolute positioning for the panel.
	 * @return {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.absolute = function() {
	  this._absolute = true;
	  return this;
	};
	
	
	/**
	 * Sets the value of a position for the panel. Clears any previously set
	 * position.
	 * @param {string} position Position to set
	 * @param {string=} value Value of the position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 * @private
	 */
	MdPanelPosition.prototype._setPosition = function(position, value) {
	  if (position === MdPanelPosition.absPosition.RIGHT ||
	      position === MdPanelPosition.absPosition.LEFT) {
	    this._left = this._right = '';
	  } else if (
	      position === MdPanelPosition.absPosition.BOTTOM ||
	      position === MdPanelPosition.absPosition.TOP) {
	    this._top = this._bottom = '';
	  } else {
	    var positions = Object.keys(MdPanelPosition.absPosition).join()
	        .toLowerCase();
	
	    throw new Error('mdPanel: Position must be one of ' + positions + '.');
	  }
	
	  this['_' +  position] = angular.isString(value) ? value : '0';
	
	  return this;
	};
	
	
	/**
	 * Sets the value of `top` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} top Value of `top`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.top = function(top) {
	  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
	};
	
	
	/**
	 * Sets the value of `bottom` for the panel. Clears any previously set vertical
	 * position.
	 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.bottom = function(bottom) {
	  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
	};
	
	
	/**
	 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
	 * `rtl`. Clears any previously set horizontal position.
	 * @param {string=} start Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.start = function(start) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
	  return this._setPosition(position, start);
	};
	
	
	/**
	 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
	 * Clears any previously set horizontal position.
	 * @param {string=} end Value of position. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.end = function(end) {
	  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
	  return this._setPosition(position, end);
	};
	
	
	/**
	 * Sets the value of `left` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} left Value of `left`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.left = function(left) {
	  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
	};
	
	
	/**
	 * Sets the value of `right` for the panel. Clears any previously set
	 * horizontal position.
	 * @param {string=} right Value of `right`. Defaults to '0'.
	 * @returns {!MdPanelPosition}
	*/
	MdPanelPosition.prototype.right = function(right) {
	  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
	};
	
	
	/**
	 * Centers the panel horizontally in the viewport. Clears any previously set
	 * horizontal position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerHorizontally = function() {
	  this._left = '50%';
	  this._right = '';
	  this._translateX = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel vertically in the viewport. Clears any previously set
	 * vertical position.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.centerVertically = function() {
	  this._top = '50%';
	  this._bottom = '';
	  this._translateY = ['-50%'];
	  return this;
	};
	
	
	/**
	 * Centers the panel horizontally and vertically in the viewport. This is
	 * equivalent to calling both `centerHorizontally` and `centerVertically`.
	 * Clears any previously set horizontal and vertical positions.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.center = function() {
	  return this.centerHorizontally().centerVertically();
	};
	
	
	/**
	 * Sets element for relative positioning.
	 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
	 *     or angular element to set the panel relative to.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.relativeTo = function(element) {
	  this._absolute = false;
	  this._relativeToEl = getElement(element);
	  return this;
	};
	
	
	/**
	 * Sets the x and y positions for the panel relative to another element.
	 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
	 *     values.
	 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
	 *     values.
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
	  if (!this._relativeToEl) {
	    throw new Error('mdPanel: addPanelPosition can only be used with ' +
	        'relative positioning. Set relativeTo first.');
	  }
	
	  this._validateXPosition(xPosition);
	  this._validateYPosition(yPosition);
	
	  this._positions.push({
	      x: xPosition,
	      y: yPosition,
	  });
	  return this;
	};
	
	
	/**
	 * Ensures that yPosition is a valid position name. Throw an exception if not.
	 * @param {string} yPosition
	 */
	MdPanelPosition.prototype._validateYPosition = function(yPosition) {
	  // empty is ok
	  if (yPosition == null) {
	      return;
	  }
	
	  var positionKeys = Object.keys(MdPanelPosition.yPosition);
	  var positionValues = [];
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = MdPanelPosition.yPosition[key];
	    positionValues.push(position);
	
	    if (position === yPosition) {
	      return;
	    }
	  }
	
	  throw new Error('mdPanel: Panel y position only accepts the following ' +
	      'values:\n' + positionValues.join(' | '));
	};
	
	
	/**
	 * Ensures that xPosition is a valid position name. Throw an exception if not.
	 * @param {string} xPosition
	 */
	MdPanelPosition.prototype._validateXPosition = function(xPosition) {
	  // empty is ok
	  if (xPosition == null) {
	      return;
	  }
	
	  var positionKeys = Object.keys(MdPanelPosition.xPosition);
	  var positionValues = [];
	  for (var key, i = 0; key = positionKeys[i]; i++) {
	    var position = MdPanelPosition.xPosition[key];
	    positionValues.push(position);
	    if (position === xPosition) {
	      return;
	    }
	  }
	
	  throw new Error('mdPanel: Panel x Position only accepts the following ' +
	      'values:\n' + positionValues.join(' | '));
	};
	
	
	/**
	 * Sets the value of the offset in the x-direction. This will add to any
	 * previously set offsets.
	 * @param {string|function(MdPanelPosition): string} offsetX
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetX = function(offsetX) {
	  this._translateX.push(offsetX);
	  return this;
	};
	
	
	/**
	 * Sets the value of the offset in the y-direction. This will add to any
	 * previously set offsets.
	 * @param {string|function(MdPanelPosition): string} offsetY
	 * @returns {!MdPanelPosition}
	 */
	MdPanelPosition.prototype.withOffsetY = function(offsetY) {
	  this._translateY.push(offsetY);
	  return this;
	};
	
	
	/**
	 * Gets the value of `top` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTop = function() {
	  return this._top;
	};
	
	
	/**
	 * Gets the value of `bottom` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getBottom = function() {
	  return this._bottom;
	};
	
	
	/**
	 * Gets the value of `left` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getLeft = function() {
	  return this._left;
	};
	
	
	/**
	 * Gets the value of `right` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getRight = function() {
	  return this._right;
	};
	
	
	/**
	 * Gets the value of `transform` for the panel.
	 * @returns {string}
	 */
	MdPanelPosition.prototype.getTransform = function() {
	  var translateX = this._reduceTranslateValues('translateX', this._translateX);
	  var translateY = this._reduceTranslateValues('translateY', this._translateY);
	
	  // It's important to trim the result, because the browser will ignore the set
	  // operation if the string contains only whitespace.
	  return (translateX + ' ' + translateY).trim();
	};
	
	
	/**
	 * Sets the `transform` value for a panel element.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.JQLite}
	 * @private
	 */
	MdPanelPosition.prototype._setTransform = function(panelEl) {
	  return panelEl.css(this._$mdConstant.CSS.TRANSFORM, this.getTransform());
	};
	
	
	/**
	 * True if the panel is completely on-screen with this positioning; false
	 * otherwise.
	 * @param {!angular.JQLite} panelEl
	 * @return {boolean}
	 * @private
	 */
	MdPanelPosition.prototype._isOnscreen = function(panelEl) {
	  // this works because we always use fixed positioning for the panel,
	  // which is relative to the viewport.
	  var left = parseInt(this.getLeft());
	  var top = parseInt(this.getTop());
	
	  if (this._translateX.length || this._translateY.length) {
	    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
	    var offsets = getComputedTranslations(panelEl, prefixedTransform);
	    left += offsets.x;
	    top += offsets.y;
	  }
	
	  var right = left + panelEl[0].offsetWidth;
	  var bottom = top + panelEl[0].offsetHeight;
	
	  return (left >= 0) &&
	    (top >= 0) &&
	    (bottom <= this._$window.innerHeight) &&
	    (right <= this._$window.innerWidth);
	};
	
	
	/**
	 * Gets the first x/y position that can fit on-screen.
	 * @returns {{x: string, y: string}}
	 */
	MdPanelPosition.prototype.getActualPosition = function() {
	  return this._actualPosition;
	};
	
	
	/**
	 * Reduces a list of translate values to a string that can be used within
	 * transform.
	 * @param {string} translateFn
	 * @param {!Array<string>} values
	 * @returns {string}
	 * @private
	 */
	MdPanelPosition.prototype._reduceTranslateValues =
	    function(translateFn, values) {
	      return values.map(function(translation) {
	        // TODO(crisbeto): this should add the units after #9609 is merged.
	        var translationValue = angular.isFunction(translation) ?
	            translation(this) : translation;
	        return translateFn + '(' + translationValue + ')';
	      }, this).join(' ');
	    };
	
	
	/**
	 * Sets the panel position based on the created panel element and best x/y
	 * positioning.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelPosition.prototype._setPanelPosition = function(panelEl) {
	  // Remove the "position adjusted" class in case it has been added before.
	  panelEl.removeClass('_md-panel-position-adjusted');
	
	  // Only calculate the position if necessary.
	  if (this._absolute) {
	    this._setTransform(panelEl);
	    return;
	  }
	
	  if (this._actualPosition) {
	    this._calculatePanelPosition(panelEl, this._actualPosition);
	    this._setTransform(panelEl);
	    this._constrainToViewport(panelEl);
	    return;
	  }
	
	  for (var i = 0; i < this._positions.length; i++) {
	    this._actualPosition = this._positions[i];
	    this._calculatePanelPosition(panelEl, this._actualPosition);
	    this._setTransform(panelEl);
	
	    if (this._isOnscreen(panelEl)) {
	      return;
	    }
	  }
	
	  this._constrainToViewport(panelEl);
	};
	
	
	/**
	 * Constrains a panel's position to the viewport.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelPosition.prototype._constrainToViewport = function(panelEl) {
	  var margin = MdPanelPosition.viewportMargin;
	  var initialTop = this._top;
	  var initialLeft = this._left;
	
	  if (this.getTop()) {
	    var top = parseInt(this.getTop());
	    var bottom = panelEl[0].offsetHeight + top;
	    var viewportHeight = this._$window.innerHeight;
	
	    if (top < margin) {
	      this._top = margin + 'px';
	    } else if (bottom > viewportHeight) {
	      this._top = top - (bottom - viewportHeight + margin) + 'px';
	    }
	  }
	
	  if (this.getLeft()) {
	    var left = parseInt(this.getLeft());
	    var right = panelEl[0].offsetWidth + left;
	    var viewportWidth = this._$window.innerWidth;
	
	    if (left < margin) {
	      this._left = margin + 'px';
	    } else if (right > viewportWidth) {
	      this._left = left - (right - viewportWidth + margin) + 'px';
	    }
	  }
	
	  // Class that can be used to re-style the panel if it was repositioned.
	  panelEl.toggleClass(
	    '_md-panel-position-adjusted',
	    this._top !== initialTop || this._left !== initialLeft
	  );
	};
	
	
	/**
	 * Switches between 'start' and 'end'.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} Reversed position
	 * @private
	 */
	MdPanelPosition.prototype._reverseXPosition = function(position) {
	  if (position === MdPanelPosition.xPosition.CENTER) {
	    return;
	  }
	
	  var start = 'start';
	  var end = 'end';
	
	  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
	};
	
	
	/**
	 * Handles horizontal positioning in rtl or ltr environments.
	 * @param {string} position Horizontal position of the panel
	 * @returns {string} The correct position according the page direction
	 * @private
	 */
	MdPanelPosition.prototype._bidi = function(position) {
	  return this._isRTL ? this._reverseXPosition(position) : position;
	};
	
	
	/**
	 * Calculates the panel position based on the created panel element and the
	 * provided positioning.
	 * @param {!angular.JQLite} panelEl
	 * @param {!{x:string, y:string}} position
	 * @private
	 */
	MdPanelPosition.prototype._calculatePanelPosition = function(panelEl, position) {
	
	  var panelBounds = panelEl[0].getBoundingClientRect();
	  var panelWidth = panelBounds.width;
	  var panelHeight = panelBounds.height;
	
	  var targetBounds = this._relativeToEl[0].getBoundingClientRect();
	
	  var targetLeft = targetBounds.left;
	  var targetRight = targetBounds.right;
	  var targetWidth = targetBounds.width;
	
	  switch (this._bidi(position.x)) {
	    case MdPanelPosition.xPosition.OFFSET_START:
	      this._left = targetLeft - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_END:
	      this._left = targetRight - panelWidth + 'px';
	      break;
	    case MdPanelPosition.xPosition.CENTER:
	      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
	      this._left = left + 'px';
	      break;
	    case MdPanelPosition.xPosition.ALIGN_START:
	      this._left = targetLeft + 'px';
	      break;
	    case MdPanelPosition.xPosition.OFFSET_END:
	      this._left = targetRight + 'px';
	      break;
	  }
	
	  var targetTop = targetBounds.top;
	  var targetBottom = targetBounds.bottom;
	  var targetHeight = targetBounds.height;
	
	  switch (position.y) {
	    case MdPanelPosition.yPosition.ABOVE:
	      this._top = targetTop - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
	      this._top = targetBottom - panelHeight + 'px';
	      break;
	    case MdPanelPosition.yPosition.CENTER:
	      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
	      this._top = top + 'px';
	      break;
	    case MdPanelPosition.yPosition.ALIGN_TOPS:
	      this._top = targetTop + 'px';
	      break;
	    case MdPanelPosition.yPosition.BELOW:
	      this._top = targetBottom + 'px';
	      break;
	  }
	};
	
	
	/*****************************************************************************
	 *                               MdPanelAnimation                            *
	 *****************************************************************************/
	
	
	/**
	 * Animation configuration object. To use, create an MdPanelAnimation with the
	 * desired properties, then pass the object as part of $mdPanel creation.
	 *
	 * Example:
	 *
	 * var panelAnimation = new MdPanelAnimation()
	 *     .openFrom(myButtonEl)
	 *     .closeTo('.my-button')
	 *     .withAnimation($mdPanel.animation.SCALE);
	 *
	 * $mdPanel.create({
	 *   animation: panelAnimation
	 * });
	 *
	 * @param {!angular.$injector} $injector
	 * @final @constructor
	 */
	function MdPanelAnimation($injector) {
	  /** @private @const {!angular.$mdUtil} */
	  this._$mdUtil = $injector.get('$mdUtil');
	
	  /**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._openFrom;
	
	  /**
	   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
	   *     undefined}
	   */
	  this._closeTo;
	
	  /** @private {string|{open: string, close: string}} */
	  this._animationClass = '';
	
	  /** @private {number} */
	  this._openDuration;
	
	  /** @private {number} */
	  this._closeDuration;
	
	  /** @private {number|{open: number, close: number}} */
	  this._rawDuration;
	}
	
	
	/**
	 * Possible default animations.
	 * @enum {string}
	 */
	MdPanelAnimation.animation = {
	  SLIDE: 'md-panel-animate-slide',
	  SCALE: 'md-panel-animate-scale',
	  FADE: 'md-panel-animate-fade'
	};
	
	
	/**
	 * Specifies where to start the open animation. `openFrom` accepts a
	 * click event object, query selector, DOM element, or a Rect object that
	 * is used to determine the bounds. When passed a click event, the location
	 * of the click will be used as the position to start the animation.
	 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.openFrom = function(openFrom) {
	  // Check if 'openFrom' is an Event.
	  openFrom = openFrom.target ? openFrom.target : openFrom;
	
	  this._openFrom = this._getPanelAnimationTarget(openFrom);
	
	  if (!this._closeTo) {
	    this._closeTo = this._openFrom;
	  }
	  return this;
	};
	
	
	/**
	 * Specifies where to animate the panel close. `closeTo` accepts a
	 * query selector, DOM element, or a Rect object that is used to determine
	 * the bounds.
	 * @param {string|!Element|{top: number, left: number}} closeTo
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.closeTo = function(closeTo) {
	  this._closeTo = this._getPanelAnimationTarget(closeTo);
	  return this;
	};
	
	
	/**
	 * Specifies the duration of the animation in milliseconds.
	 * @param {number|{open: number, close: number}} duration
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.duration = function(duration) {
	  if (duration) {
	    if (angular.isNumber(duration)) {
	      this._openDuration = this._closeDuration = toSeconds(duration);
	    } else if (angular.isObject(duration)) {
	      this._openDuration = toSeconds(duration.open);
	      this._closeDuration = toSeconds(duration.close);
	    }
	  }
	
	  // Save the original value so it can be passed to the backdrop.
	  this._rawDuration = duration;
	
	  return this;
	
	  function toSeconds(value) {
	    if (angular.isNumber(value)) return value / 1000;
	  }
	};
	
	
	/**
	 * Returns the element and bounds for the animation target.
	 * @param {string|!Element|{top: number, left: number}} location
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
	  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
	    return {
	      element: undefined,
	      bounds: {
	        top: location.top || 0,
	        left: location.left || 0
	      }
	    };
	  } else {
	    return this._getBoundingClientRect(getElement(location));
	  }
	};
	
	
	/**
	 * Specifies the animation class.
	 *
	 * There are several default animations that can be used:
	 * (MdPanelAnimation.animation)
	 *   SLIDE: The panel slides in and out from the specified
	 *        elements.
	 *   SCALE: The panel scales in and out.
	 *   FADE: The panel fades in and out.
	 *
	 * @param {string|{open: string, close: string}} cssClass
	 * @returns {!MdPanelAnimation}
	 */
	MdPanelAnimation.prototype.withAnimation = function(cssClass) {
	  this._animationClass = cssClass;
	  return this;
	};
	
	
	/**
	 * Animate the panel open.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that is resolved when the open
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateOpen = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	
	  this._fixBounds(panelEl);
	  var animationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var openFrom = animator.toTransformCss(panelTransform);
	  var openTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openSlide = animator.calculateSlideToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	
	      var openScale = animator.calculateZoomToOrigin(
	              panelEl, this._openFrom) || '';
	      openFrom = animator.toTransformCss(openScale + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      animationOptions = {
	        transitionInClass: '_md-panel-animate-enter'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        animationOptions = {
	          transitionInClass: this._animationClass
	        };
	      } else {
	        animationOptions = {
	          transitionInClass: this._animationClass['open'],
	          transitionOutClass: this._animationClass['close'],
	        };
	      }
	  }
	
	  animationOptions.duration = this._openDuration;
	
	  return animator
	      .translate3d(panelEl, openFrom, openTo, animationOptions);
	};
	
	
	/**
	 * Animate the panel close.
	 * @param {!angular.JQLite} panelEl
	 * @returns {!angular.$q.Promise} A promise that resolves when the close
	 *     animation is complete.
	 */
	MdPanelAnimation.prototype.animateClose = function(panelEl) {
	  var animator = this._$mdUtil.dom.animator;
	  var reverseAnimationOptions = {};
	
	  // Include the panel transformations when calculating the animations.
	  var panelTransform = panelEl[0].style.transform || '';
	
	  var closeFrom = animator.toTransformCss(panelTransform);
	  var closeTo = animator.toTransformCss(panelTransform);
	
	  switch (this._animationClass) {
	    case MdPanelAnimation.animation.SLIDE:
	      // Slide should start with opacity: 1.
	      panelEl.css('opacity', '1');
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-leave'
	      };
	
	      var closeSlide = animator.calculateSlideToOrigin(
	              panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.SCALE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave'
	      };
	
	      var closeScale = animator.calculateZoomToOrigin(
	              panelEl, this._closeTo) || '';
	      closeTo = animator.toTransformCss(closeScale + ' ' + panelTransform);
	      break;
	
	    case MdPanelAnimation.animation.FADE:
	      reverseAnimationOptions = {
	        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave'
	      };
	      break;
	
	    default:
	      if (angular.isString(this._animationClass)) {
	        reverseAnimationOptions = {
	          transitionOutClass: this._animationClass
	        };
	      } else {
	        reverseAnimationOptions = {
	          transitionInClass: this._animationClass['close'],
	          transitionOutClass: this._animationClass['open']
	        };
	      }
	  }
	
	  reverseAnimationOptions.duration = this._closeDuration;
	
	  return animator
	      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
	};
	
	
	/**
	 * Set the height and width to match the panel if not provided.
	 * @param {!angular.JQLite} panelEl
	 * @private
	 */
	MdPanelAnimation.prototype._fixBounds = function(panelEl) {
	  var panelWidth = panelEl[0].offsetWidth;
	  var panelHeight = panelEl[0].offsetHeight;
	
	  if (this._openFrom && this._openFrom.bounds.height == null) {
	    this._openFrom.bounds.height = panelHeight;
	  }
	  if (this._openFrom && this._openFrom.bounds.width == null) {
	    this._openFrom.bounds.width = panelWidth;
	  }
	  if (this._closeTo && this._closeTo.bounds.height == null) {
	    this._closeTo.bounds.height = panelHeight;
	  }
	  if (this._closeTo && this._closeTo.bounds.width == null) {
	    this._closeTo.bounds.width = panelWidth;
	  }
	};
	
	
	/**
	 * Identify the bounding RECT for the target element.
	 * @param {!angular.JQLite} element
	 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
	 * @private
	 */
	MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
	  if (element instanceof angular.element) {
	    return {
	      element: element,
	      bounds: element[0].getBoundingClientRect()
	    };
	  }
	};
	
	
	/*****************************************************************************
	 *                                Util Methods                               *
	 *****************************************************************************/
	
	
	/**
	 * Returns the angular element associated with a css selector or element.
	 * @param el {string|!angular.JQLite|!Element}
	 * @returns {!angular.JQLite}
	 */
	function getElement(el) {
	  var queryResult = angular.isString(el) ?
	      document.querySelector(el) : el;
	  return angular.element(queryResult);
	}
	
	
	/**
	 * Gets the computed values for an element's translateX and translateY in px.
	 * @param {!angular.JQLite|!Element} el
	 * @param {string} property
	 * @return {{x: number, y: number}}
	 */
	function getComputedTranslations(el, property) {
	  // The transform being returned by `getComputedStyle` is in the format:
	  // `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
	  // if the element doesn't have a transform.
	  var transform = getComputedStyle(el[0] || el)[property];
	  var openIndex = transform.indexOf('(');
	  var closeIndex = transform.lastIndexOf(')');
	  var output = { x: 0, y: 0 };
	
	  if (openIndex > -1 && closeIndex > -1) {
	    var parsedValues = transform
	      .substring(openIndex + 1, closeIndex)
	      .split(', ')
	      .slice(-2);
	
	    output.x = parseInt(parsedValues[0]);
	    output.y = parseInt(parsedValues[1]);
	  }
	
	  return output;
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.progressLinear
	 * @description Linear Progress module!
	 */
	MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];
	angular.module('material.components.progressLinear', [
	  'material.core'
	])
	  .directive('mdProgressLinear', MdProgressLinearDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdProgressLinear
	 * @module material.components.progressLinear
	 * @restrict E
	 *
	 * @description
	 * The linear progress directive is used to make loading content
	 * in your app as delightful and painless as possible by minimizing
	 * the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * Each operation should only be represented by one activity indicator
	 * For example: one refresh operation should not display both a
	 * refresh bar and an activity circle.
	 *
	 * For operations where the percentage of the operation completed
	 * can be determined, use a determinate indicator. They give users
	 * a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while
	 * something finishes up, and it’s not necessary to expose what's
	 * happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
	 * then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
	 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
	 *
	 * <md-progress-linear md-mode="query"></md-progress-linear>
	 * </hljs>
	 */
	function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
	  var MODE_DETERMINATE = "determinate";
	  var MODE_INDETERMINATE = "indeterminate";
	  var MODE_BUFFER = "buffer";
	  var MODE_QUERY = "query";
	  var DISABLED_CLASS = "_md-progress-linear-disabled";
	
	  return {
	    restrict: 'E',
	    template: '<div class="md-container">' +
	      '<div class="md-dashed"></div>' +
	      '<div class="md-bar md-bar1"></div>' +
	      '<div class="md-bar md-bar2"></div>' +
	      '</div>',
	    compile: compile
	  };
	
	  function compile(tElement, tAttrs, transclude) {
	    tElement.attr('aria-valuemin', 0);
	    tElement.attr('aria-valuemax', 100);
	    tElement.attr('role', 'progressbar');
	
	    return postLink;
	  }
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	
	    var lastMode;
	    var isDisabled = attr.hasOwnProperty('disabled');
	    var toVendorCSS = $mdUtil.dom.animator.toCss;
	    var bar1 = angular.element(element[0].querySelector('.md-bar1'));
	    var bar2 = angular.element(element[0].querySelector('.md-bar2'));
	    var container = angular.element(element[0].querySelector('.md-container'));
	
	    element
	      .attr('md-mode', mode())
	      .toggleClass(DISABLED_CLASS, isDisabled);
	
	    validateMode();
	    watchAttributes();
	
	    /**
	     * Watch the value, md-buffer-value, and md-mode attributes
	     */
	    function watchAttributes() {
	      attr.$observe('value', function(value) {
	        var percentValue = clamp(value);
	        element.attr('aria-valuenow', percentValue);
	
	        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
	      });
	
	      attr.$observe('mdBufferValue', function(value) {
	        animateIndicator(bar1, clamp(value));
	      });
	
	      attr.$observe('disabled', function(value) {
	        if (value === true || value === false) {
	          isDisabled = !!value;
	        } else {
	          isDisabled = angular.isDefined(value);
	        }
	
	        element.toggleClass(DISABLED_CLASS, isDisabled);
	        container.toggleClass(lastMode, !isDisabled);
	      });
	
	      attr.$observe('mdMode', function(mode) {
	        if (lastMode) container.removeClass( lastMode );
	
	        switch( mode ) {
	          case MODE_QUERY:
	          case MODE_BUFFER:
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	            container.addClass( lastMode = "md-mode-" + mode );
	            break;
	          default:
	            container.addClass( lastMode = "md-mode-" + MODE_INDETERMINATE );
	            break;
	        }
	      });
	    }
	
	    /**
	     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
	     */
	    function validateMode() {
	      if ( angular.isUndefined(attr.mdMode) ) {
	        var hasValue = angular.isDefined(attr.value);
	        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";
	
	        //$log.debug( $mdUtil.supplant(info, [mode]) );
	
	        element.attr("md-mode", mode);
	        attr.mdMode = mode;
	      }
	    }
	
	    /**
	     * Is the md-mode a valid option?
	     */
	    function mode() {
	      var value = (attr.mdMode || "").trim();
	      if ( value ) {
	        switch(value) {
	          case MODE_DETERMINATE:
	          case MODE_INDETERMINATE:
	          case MODE_BUFFER:
	          case MODE_QUERY:
	            break;
	          default:
	            value = MODE_INDETERMINATE;
	            break;
	        }
	      }
	      return value;
	    }
	
	    /**
	     * Manually set CSS to animate the Determinate indicator based on the specified
	     * percentage value (0-100).
	     */
	    function animateIndicator(target, value) {
	      if ( isDisabled || !mode() ) return;
	
	      var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [ (value-100)/2, value/100 ]);
	      var styles = toVendorCSS({ transform : to });
	      angular.element(target).css( styles );
	    }
	  }
	
	  /**
	   * Clamps the value to be between 0 and 100.
	   * @param {number} value The value to clamp.
	   * @returns {number}
	   */
	  function clamp(value) {
	    return Math.max(0, Math.min(value || 0, 100));
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.radioButton
	 * @description radioButton module!
	 */
	mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
	mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];
	angular.module('material.components.radioButton', [
	  'material.core'
	])
	  .directive('mdRadioGroup', mdRadioGroupDirective)
	  .directive('mdRadioButton', mdRadioButtonDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioGroup
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-group>` directive identifies a grouping
	 * container for the 1..n grouped radio buttons; specified using nested
	 * `<md-radio-button>` tags.
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the radio button is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * Note: `<md-radio-group>` and `<md-radio-button>` handle tabindex differently
	 * than the native `<input type='radio'>` controls. Whereas the native controls
	 * force the user to tab through all the radio buttons, `<md-radio-group>`
	 * is focusable, and by default the `<md-radio-button>`s are not.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {boolean=} md-no-ink Use of attribute indicates flag to disable ink ripple effects.
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-radio-group ng-model="selected">
	 *
	 *   <md-radio-button
	 *        ng-repeat="d in colorOptions"
	 *        ng-value="d.value" aria-label="{{ d.label }}">
	 *
	 *          {{ d.label }}
	 *
	 *   </md-radio-button>
	 *
	 * </md-radio-group>
	 * </hljs>
	 *
	 */
	function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
	  RadioGroupController.prototype = createRadioGroupControllerProto();
	
	  return {
	    restrict: 'E',
	    controller: ['$element', RadioGroupController],
	    require: ['mdRadioGroup', '?ngModel'],
	    link: { pre: linkRadioGroup }
	  };
	
	  function linkRadioGroup(scope, element, attr, ctrls) {
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    var rgCtrl = ctrls[0];
	    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
	
	    rgCtrl.init(ngModelCtrl);
	
	    scope.mouseActive = false;
	
	    element
	      .attr({
	        'role': 'radiogroup',
	        'tabIndex': element.attr('tabindex') || '0'
	      })
	      .on('keydown', keydownListener)
	      .on('mousedown', function(event) {
	        scope.mouseActive = true;
	        $timeout(function() {
	          scope.mouseActive = false;
	        }, 100);
	      })
	      .on('focus', function() {
	        if(scope.mouseActive === false) {
	          rgCtrl.$element.addClass('md-focused');
	        }
	      })
	      .on('blur', function() {
	        rgCtrl.$element.removeClass('md-focused');
	      });
	
	    /**
	     *
	     */
	    function setFocus() {
	      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
	    }
	
	    /**
	     *
	     */
	    function keydownListener(ev) {
	      var keyCode = ev.which || ev.keyCode;
	
	      // Only listen to events that we originated ourselves
	      // so that we don't trigger on things like arrow keys in
	      // inputs.
	
	      if (keyCode != $mdConstant.KEY_CODE.ENTER &&
	          ev.currentTarget != ev.target) {
	        return;
	      }
	
	      switch (keyCode) {
	        case $mdConstant.KEY_CODE.LEFT_ARROW:
	        case $mdConstant.KEY_CODE.UP_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectPrevious();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        case $mdConstant.KEY_CODE.DOWN_ARROW:
	          ev.preventDefault();
	          rgCtrl.selectNext();
	          setFocus();
	          break;
	
	        case $mdConstant.KEY_CODE.ENTER:
	          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
	          if (form.length > 0) {
	            form.triggerHandler('submit');
	          }
	          break;
	      }
	
	    }
	  }
	
	  function RadioGroupController($element) {
	    this._radioButtonRenderFns = [];
	    this.$element = $element;
	  }
	
	  function createRadioGroupControllerProto() {
	    return {
	      init: function(ngModelCtrl) {
	        this._ngModelCtrl = ngModelCtrl;
	        this._ngModelCtrl.$render = angular.bind(this, this.render);
	      },
	      add: function(rbRender) {
	        this._radioButtonRenderFns.push(rbRender);
	      },
	      remove: function(rbRender) {
	        var index = this._radioButtonRenderFns.indexOf(rbRender);
	        if (index !== -1) {
	          this._radioButtonRenderFns.splice(index, 1);
	        }
	      },
	      render: function() {
	        this._radioButtonRenderFns.forEach(function(rbRender) {
	          rbRender();
	        });
	      },
	      setViewValue: function(value, eventType) {
	        this._ngModelCtrl.$setViewValue(value, eventType);
	        // update the other radio buttons as well
	        this.render();
	      },
	      getViewValue: function() {
	        return this._ngModelCtrl.$viewValue;
	      },
	      selectNext: function() {
	        return changeSelectedButton(this.$element, 1);
	      },
	      selectPrevious: function() {
	        return changeSelectedButton(this.$element, -1);
	      },
	      setActiveDescendant: function (radioId) {
	        this.$element.attr('aria-activedescendant', radioId);
	      },
	      isDisabled: function() {
	        return this.$element[0].hasAttribute('disabled');
	      }
	    };
	  }
	  /**
	   * Change the radio group's selected button by a given increment.
	   * If no button is selected, select the first button.
	   */
	  function changeSelectedButton(parent, increment) {
	    // Coerce all child radio buttons into an array, then wrap then in an iterator
	    var buttons = $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);
	
	    if (buttons.count()) {
	      var validate = function (button) {
	        // If disabled, then NOT valid
	        return !angular.element(button).attr("disabled");
	      };
	
	      var selected = parent[0].querySelector('md-radio-button.md-checked');
	      var target = buttons[increment < 0 ? 'previous' : 'next'](selected, validate) || buttons.first();
	
	      // Activate radioButton's click listener (triggerHandler won't create a real click event)
	      angular.element(target).triggerHandler('click');
	    }
	  }
	
	}
	
	/**
	 * @ngdoc directive
	 * @module material.components.radioButton
	 * @name mdRadioButton
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
	 *
	 * While similar to the `<input type="radio" ng-model="" value="">` directive,
	 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
	 * supports use within named radio groups.
	 *
	 * @param {string} ngValue AngularJS expression which sets the value to which the expression should
	 *    be set when selected.
	 * @param {string} value The value to which the expression should be set when selected.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} aria-label Adds label to radio button for accessibility.
	 * Defaults to radio button's text. If no text content is available, a warning will be logged.
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-radio-button value="1" aria-label="Label 1">
	 *   Label 1
	 * </md-radio-button>
	 *
	 * <md-radio-button ng-value="specialValue" aria-label="Green">
	 *   Green
	 * </md-radio-button>
	 *
	 * </hljs>
	 *
	 */
	function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {
	
	  var CHECKED_CSS = 'md-checked';
	
	  return {
	    restrict: 'E',
	    require: '^mdRadioGroup',
	    transclude: true,
	    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
	                '<div class="md-off"></div>' +
	                '<div class="md-on"></div>' +
	              '</div>' +
	              '<div ng-transclude class="md-label"></div>',
	    link: link
	  };
	
	  function link(scope, element, attr, rgCtrl) {
	    var lastChecked;
	
	    $mdTheming(element);
	    configureAria(element, scope);
	
	    // ngAria overwrites the aria-checked inside a $watch for ngValue.
	    // We should defer the initialization until all the watches have fired.
	    // This can also be fixed by removing the `lastChecked` check, but that'll
	    // cause more DOM manipulation on each digest.
	    if (attr.ngValue) {
	      $mdUtil.nextTick(initialize, false);
	    } else {
	      initialize();
	    }
	
	    /**
	     * Initializes the component.
	     */
	    function initialize() {
	      if (!rgCtrl) {
	        throw 'RadioButton: No RadioGroupController could be found.';
	      }
	
	      rgCtrl.add(render);
	      attr.$observe('value', render);
	
	      element
	        .on('click', listener)
	        .on('$destroy', function() {
	          rgCtrl.remove(render);
	        });
	    }
	
	    /**
	     * On click functionality.
	     */
	    function listener(ev) {
	      if (element[0].hasAttribute('disabled') || rgCtrl.isDisabled()) return;
	
	      scope.$apply(function() {
	        rgCtrl.setViewValue(attr.value, ev && ev.type);
	      });
	    }
	
	    /**
	     *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
	     *  Update the `aria-activedescendant` attribute.
	     */
	    function render() {
	      var checked = rgCtrl.getViewValue() == attr.value;
	
	      if (checked === lastChecked) return;
	
	      if (element[0].parentNode.nodeName.toLowerCase() !== 'md-radio-group') {
	        // If the radioButton is inside a div, then add class so highlighting will work
	        element.parent().toggleClass(CHECKED_CSS, checked);
	      }
	
	      if (checked) {
	        rgCtrl.setActiveDescendant(element.attr('id'));
	      }
	
	      lastChecked = checked;
	
	      element
	        .attr('aria-checked', checked)
	        .toggleClass(CHECKED_CSS, checked);
	    }
	
	    /**
	     * Inject ARIA-specific attributes appropriate for each radio button
	     */
	    function configureAria(element, scope){
	      element.attr({
	        id: attr.id || 'radio_' + $mdUtil.nextUid(),
	        role: 'radio',
	        'aria-checked': 'false'
	      });
	
	      $mdAria.expectWithText(element, 'aria-label');
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.showHide
	 */
	
	// Add additional handlers to ng-show and ng-hide that notify directives
	// contained within that they should recompute their size.
	// These run in addition to AngularJS's built-in ng-hide and ng-show directives.
	angular.module('material.components.showHide', [
	  'material.core'
	])
	  .directive('ngShow', createDirective('ngShow', true))
	  .directive('ngHide', createDirective('ngHide', false));
	
	
	function createDirective(name, targetValue) {
	  return ['$mdUtil', '$window', function($mdUtil, $window) {
	    return {
	      restrict: 'A',
	      multiElement: true,
	      link: function($scope, $element, $attr) {
	        var unregister = $scope.$on('$md-resize-enable', function() {
	          unregister();
	
	          var node = $element[0];
	          var cachedTransitionStyles = node.nodeType === $window.Node.ELEMENT_NODE ?
	            $window.getComputedStyle(node) : {};
	
	          $scope.$watch($attr[name], function(value) {
	            if (!!value === targetValue) {
	              $mdUtil.nextTick(function() {
	                $scope.$broadcast('$md-resize');
	              });
	
	              var opts = {
	                cachedTransitionStyles: cachedTransitionStyles
	              };
	
	              $mdUtil.dom.animator.waitTransitionEnd($element, opts).then(function() {
	                $scope.$broadcast('$md-resize');
	              });
	            }
	          });
	        });
	      }
	    };
	  }];
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sidenav
	 *
	 * @description
	 * A Sidenav QP component.
	 */
	SidenavService.$inject = ["$mdComponentRegistry", "$mdUtil", "$q", "$log"];
	SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$mdInteraction", "$animate", "$compile", "$parse", "$log", "$q", "$document", "$window", "$$rAF"];
	SidenavController.$inject = ["$scope", "$attrs", "$mdComponentRegistry", "$q", "$interpolate"];
	angular
	  .module('material.components.sidenav', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .factory('$mdSidenav', SidenavService )
	  .directive('mdSidenav', SidenavDirective)
	  .directive('mdSidenavFocus', SidenavFocusDirective)
	  .controller('$mdSidenavController', SidenavController);
	
	
	/**
	 * @ngdoc service
	 * @name $mdSidenav
	 * @module material.components.sidenav
	 *
	 * @description
	 * `$mdSidenav` makes it easy to interact with multiple sidenavs
	 * in an app. When looking up a sidenav instance, you can either look
	 * it up synchronously or wait for it to be initializied asynchronously.
	 * This is done by passing the second argument to `$mdSidenav`.
	 *
	 * @usage
	 * <hljs lang="js">
	 * // Async lookup for sidenav instance; will resolve when the instance is available
	 * $mdSidenav(componentId, true).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Sync lookup for sidenav instance; this will resolve immediately.
	 * $mdSidenav(componentId).then(function(instance) {
	 *   $log.debug( componentId + "is now ready" );
	 * });
	 * // Async toggle the given sidenav;
	 * // when instance is known ready and lazy lookup is not needed.
	 * $mdSidenav(componentId)
	 *    .toggle()
	 *    .then(function(){
	 *      $log.debug('toggled');
	 *    });
	 * // Async open the given sidenav
	 * $mdSidenav(componentId)
	 *    .open()
	 *    .then(function(){
	 *      $log.debug('opened');
	 *    });
	 * // Async close the given sidenav
	 * $mdSidenav(componentId)
	 *    .close()
	 *    .then(function(){
	 *      $log.debug('closed');
	 *    });
	 * // Sync check to see if the specified sidenav is set to be open
	 * $mdSidenav(componentId).isOpen();
	 * // Sync check to whether given sidenav is locked open
	 * // If this is true, the sidenav will be open regardless of close()
	 * $mdSidenav(componentId).isLockedOpen();
	 * // On close callback to handle close, backdrop click or escape key pressed
	 * // Callback happens BEFORE the close action occurs.
	 * $mdSidenav(componentId).onClose(function () {
	 *   $log.debug('closing');
	 * });
	 * </hljs>
	 */
	function SidenavService($mdComponentRegistry, $mdUtil, $q, $log) {
	  var errorMsg = "SideNav '{0}' is not available! Did you use md-component-id='{0}'?";
	  var service = {
	        find    : findInstance,     //  sync  - returns proxy API
	        waitFor : waitForInstance   //  async - returns promise
	      };
	
	  /**
	   * Service API that supports three (3) usages:
	   *   $mdSidenav().find("left")                       // sync (must already exist) or returns undefined
	   *   $mdSidenav("left").toggle();                    // sync (must already exist) or returns reject promise;
	   *   $mdSidenav("left",true).then( function(left){   // async returns instance when available
	   *    left.toggle();
	   *   });
	   */
	  return function(handle, enableWait) {
	    if ( angular.isUndefined(handle) ) return service;
	
	    var shouldWait = enableWait === true;
	    var instance = service.find(handle, shouldWait);
	    return  !instance && shouldWait ? service.waitFor(handle) :
	            !instance && angular.isUndefined(enableWait) ? addLegacyAPI(service, handle) : instance;
	  };
	
	  /**
	   * For failed instance/handle lookups, older-clients expect an response object with noops
	   * that include `rejected promise APIs`
	   */
	  function addLegacyAPI(service, handle) {
	      var falseFn  = function() { return false; };
	      var rejectFn = function() {
	            return $q.when($mdUtil.supplant(errorMsg, [handle || ""]));
	          };
	
	      return angular.extend({
	        isLockedOpen : falseFn,
	        isOpen       : falseFn,
	        toggle       : rejectFn,
	        open         : rejectFn,
	        close        : rejectFn,
	        onClose      : angular.noop,
	        then : function(callback) {
	          return waitForInstance(handle)
	            .then(callback || angular.noop);
	        }
	       }, service);
	    }
	    /**
	     * Synchronously lookup the controller instance for the specified sidNav instance which has been
	     * registered with the markup `md-component-id`
	     */
	    function findInstance(handle, shouldWait) {
	      var instance = $mdComponentRegistry.get(handle);
	
	      if (!instance && !shouldWait) {
	
	        // Report missing instance
	        $log.error( $mdUtil.supplant(errorMsg, [handle || ""]) );
	
	        // The component has not registered itself... most like NOT yet created
	        // return null to indicate that the Sidenav is not in the DOM
	        return undefined;
	      }
	      return instance;
	    }
	
	    /**
	     * Asynchronously wait for the component instantiation,
	     * Deferred lookup of component instance using $component registry
	     */
	    function waitForInstance(handle) {
	      return $mdComponentRegistry.when(handle).catch($log.error);
	    }
	}
	/**
	 * @ngdoc directive
	 * @name mdSidenavFocus
	 * @module material.components.sidenav
	 *
	 * @restrict A
	 *
	 * @description
	 * `mdSidenavFocus` provides a way to specify the focused element when a sidenav opens.
	 * This is completely optional, as the sidenav itself is focused by default.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-sidenav>
	 *   <form>
	 *     <md-input-container>
	 *       <label for="testInput">Label</label>
	 *       <input id="testInput" type="text" md-sidenav-focus>
	 *     </md-input-container>
	 *   </form>
	 * </md-sidenav>
	 * </hljs>
	 **/
	function SidenavFocusDirective() {
	  return {
	    restrict: 'A',
	    require: '^mdSidenav',
	    link: function(scope, element, attr, sidenavCtrl) {
	      // @see $mdUtil.findFocusTarget(...)
	    }
	  };
	}
	/**
	 * @ngdoc directive
	 * @name mdSidenav
	 * @module material.components.sidenav
	 * @restrict E
	 *
	 * @description
	 *
	 * A Sidenav component that can be opened and closed programatically.
	 *
	 * By default, upon opening it will slide out on top of the main content area.
	 *
	 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
	 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="row" ng-controller="MyController">
	 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
	 *     Left Nav!
	 *   </md-sidenav>
	 *
	 *   <md-content>
	 *     Center Content
	 *     <md-button ng-click="openLeftMenu()">
	 *       Open Left Menu
	 *     </md-button>
	 *   </md-content>
	 *
	 *   <md-sidenav md-component-id="right"
	 *     md-is-locked-open="$mdMedia('min-width: 333px')"
	 *     class="md-sidenav-right">
	 *     <form>
	 *       <md-input-container>
	 *         <label for="testInput">Test input</label>
	 *         <input id="testInput" type="text"
	 *                ng-model="data" md-autofocus>
	 *       </md-input-container>
	 *     </form>
	 *   </md-sidenav>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="js">
	 * var app = angular.module('myApp', ['ngMaterial']);
	 * app.controller('MyController', function($scope, $mdSidenav) {
	 *   $scope.openLeftMenu = function() {
	 *     $mdSidenav('left').toggle();
	 *   };
	 * });
	 * </hljs>
	 *
	 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
	 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a backdrop.
	 * @param {string=} md-component-id componentId to use with $mdSidenav service.
	 * @param {expression=} md-is-locked-open When this expression evaluates to true,
	 * the sidenav 'locks open': it falls into the content's flow instead
	 * of appearing over it. This overrides the `md-is-open` attribute.
	 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
	 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
	 *
	* The $mdMedia() service is exposed to the is-locked-open attribute, which
	 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
	 * Examples:
	 *
	 *   - `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
	 *   - `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>` (locks open on small screens)
	 */
	function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $mdInteraction, $animate,
	                          $compile, $parse, $log, $q, $document, $window, $$rAF) {
	  return {
	    restrict: 'E',
	    scope: {
	      isOpen: '=?mdIsOpen'
	    },
	    controller: '$mdSidenavController',
	    compile: function(element) {
	      element.addClass('md-closed').attr('tabIndex', '-1');
	      return postLink;
	    }
	  };
	
	  /**
	   * Directive Post Link function...
	   */
	  function postLink(scope, element, attr, sidenavCtrl) {
	    var lastParentOverFlow;
	    var backdrop;
	    var disableScrollTarget = null;
	    var triggeringInteractionType;
	    var triggeringElement = null;
	    var previousContainerStyles;
	    var promise = $q.when(true);
	    var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
	    var ngWindow = angular.element($window);
	    var isLocked = function() {
	      return isLockedOpenParsed(scope.$parent, {
	        $media: function(arg) {
	          $log.warn("$media is deprecated for is-locked-open. Use $mdMedia instead.");
	          return $mdMedia(arg);
	        },
	        $mdMedia: $mdMedia
	      });
	    };
	
	    if (attr.mdDisableScrollTarget) {
	      disableScrollTarget = $document[0].querySelector(attr.mdDisableScrollTarget);
	
	      if (disableScrollTarget) {
	        disableScrollTarget = angular.element(disableScrollTarget);
	      } else {
	        $log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching ' +
	          'selector "{selector}". Falling back to parent.', { selector: attr.mdDisableScrollTarget }));
	      }
	    }
	
	    if (!disableScrollTarget) {
	      disableScrollTarget = element.parent();
	    }
	
	    // Only create the backdrop if the backdrop isn't disabled.
	    if (!attr.hasOwnProperty('mdDisableBackdrop')) {
	      backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
	    }
	
	    element.addClass('_md');     // private md component indicator for styling
	    $mdTheming(element);
	
	    // The backdrop should inherit the sidenavs theme,
	    // because the backdrop will take its parent theme by default.
	    if ( backdrop ) $mdTheming.inherit(backdrop, element);
	
	    element.on('$destroy', function() {
	      backdrop && backdrop.remove();
	      sidenavCtrl.destroy();
	    });
	
	    scope.$on('$destroy', function(){
	      backdrop && backdrop.remove();
	    });
	
	    scope.$watch(isLocked, updateIsLocked);
	    scope.$watch('isOpen', updateIsOpen);
	
	
	    // Publish special accessor for the Controller instance
	    sidenavCtrl.$toggleOpen = toggleOpen;
	
	    /**
	     * Toggle the DOM classes to indicate `locked`
	     * @param isLocked
	     */
	    function updateIsLocked(isLocked, oldValue) {
	      scope.isLockedOpen = isLocked;
	      if (isLocked === oldValue) {
	        element.toggleClass('md-locked-open', !!isLocked);
	      } else {
	        $animate[isLocked ? 'addClass' : 'removeClass'](element, 'md-locked-open');
	      }
	      if (backdrop) {
	        backdrop.toggleClass('md-locked-open', !!isLocked);
	      }
	    }
	
	    /**
	     * Toggle the SideNav view and attach/detach listeners
	     * @param isOpen
	     */
	    function updateIsOpen(isOpen) {
	      // Support deprecated md-sidenav-focus attribute as fallback
	      var focusEl = $mdUtil.findFocusTarget(element) || $mdUtil.findFocusTarget(element,'[md-sidenav-focus]') || element;
	      var parent = element.parent();
	
	      parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
	      if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);
	
	      var restorePositioning = updateContainerPositions(parent, isOpen);
	
	      if ( isOpen ) {
	        // Capture upon opening..
	        triggeringElement = $document[0].activeElement;
	        triggeringInteractionType = $mdInteraction.getLastInteractionType();
	      }
	
	      disableParentScroll(isOpen);
	
	      return promise = $q.all([
	        isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ?
	                             $animate.leave(backdrop) : $q.when(true),
	        $animate[isOpen ? 'removeClass' : 'addClass'](element, 'md-closed')
	      ]).then(function() {
	        // Perform focus when animations are ALL done...
	        if (scope.isOpen) {
	          $$rAF(function() {
	            // Notifies child components that the sidenav was opened. Should wait
	            // a frame in order to allow for the element height to be computed.
	            ngWindow.triggerHandler('resize');
	          });
	
	          focusEl && focusEl.focus();
	        }
	
	        // Restores the positioning on the sidenav and backdrop.
	        restorePositioning && restorePositioning();
	      });
	    }
	
	    function updateContainerPositions(parent, willOpen) {
	      var drawerEl = element[0];
	      var scrollTop = parent[0].scrollTop;
	
	      if (willOpen && scrollTop) {
	        previousContainerStyles = {
	          top: drawerEl.style.top,
	          bottom: drawerEl.style.bottom,
	          height: drawerEl.style.height
	        };
	
	        // When the parent is scrolled down, then we want to be able to show the sidenav at the current scroll
	        // position. We're moving the sidenav down to the correct scroll position and apply the height of the
	        // parent, to increase the performance. Using 100% as height, will impact the performance heavily.
	        var positionStyle = {
	          top: scrollTop + 'px',
	          bottom: 'auto',
	          height: parent[0].clientHeight + 'px'
	        };
	
	        // Apply the new position styles to the sidenav and backdrop.
	        element.css(positionStyle);
	        backdrop.css(positionStyle);
	      }
	
	      // When the sidenav is closing and we have previous defined container styles,
	      // then we return a restore function, which resets the sidenav and backdrop.
	      if (!willOpen && previousContainerStyles) {
	        return function() {
	          drawerEl.style.top = previousContainerStyles.top;
	          drawerEl.style.bottom = previousContainerStyles.bottom;
	          drawerEl.style.height = previousContainerStyles.height;
	
	          backdrop[0].style.top = null;
	          backdrop[0].style.bottom = null;
	          backdrop[0].style.height = null;
	
	          previousContainerStyles = null;
	        };
	      }
	    }
	
	    /**
	     * Prevent parent scrolling (when the SideNav is open)
	     */
	    function disableParentScroll(disabled) {
	      if ( disabled && !lastParentOverFlow ) {
	        lastParentOverFlow = disableScrollTarget.css('overflow');
	        disableScrollTarget.css('overflow', 'hidden');
	      } else if (angular.isDefined(lastParentOverFlow)) {
	        disableScrollTarget.css('overflow', lastParentOverFlow);
	        lastParentOverFlow = undefined;
	      }
	    }
	
	    /**
	     * Toggle the sideNav view and publish a promise to be resolved when
	     * the view animation finishes.
	     *
	     * @param isOpen
	     * @returns {*}
	     */
	    function toggleOpen( isOpen ) {
	      if (scope.isOpen == isOpen ) {
	
	        return $q.when(true);
	
	      } else {
	        if (scope.isOpen && sidenavCtrl.onCloseCb) sidenavCtrl.onCloseCb();
	
	        return $q(function(resolve){
	          // Toggle value to force an async `updateIsOpen()` to run
	          scope.isOpen = isOpen;
	
	          $mdUtil.nextTick(function() {
	            // When the current `updateIsOpen()` animation finishes
	            promise.then(function(result) {
	
	              if ( !scope.isOpen && triggeringElement && triggeringInteractionType === 'keyboard') {
	                // reset focus to originating element (if available) upon close
	                triggeringElement.focus();
	                triggeringElement = null;
	              }
	
	              resolve(result);
	            });
	          });
	
	        });
	
	      }
	    }
	
	    /**
	     * Auto-close sideNav when the `escape` key is pressed.
	     * @param evt
	     */
	    function onKeyDown(ev) {
	      var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
	      return isEscape ? close(ev) : $q.when(true);
	    }
	
	    /**
	     * With backdrop `clicks` or `escape` key-press, immediately
	     * apply the CSS close transition... Then notify the controller
	     * to close() and perform its own actions.
	     */
	    function close(ev) {
	      ev.preventDefault();
	
	      return sidenavCtrl.close();
	    }
	
	  }
	}
	
	/*
	 * @private
	 * @ngdoc controller
	 * @name SidenavController
	 * @module material.components.sidenav
	 */
	function SidenavController($scope, $attrs, $mdComponentRegistry, $q, $interpolate) {
	
	  var self = this;
	
	  // Use Default internal method until overridden by directive postLink
	
	  // Synchronous getters
	  self.isOpen = function() { return !!$scope.isOpen; };
	  self.isLockedOpen = function() { return !!$scope.isLockedOpen; };
	
	  // Synchronous setters
	  self.onClose = function (callback) {
	    self.onCloseCb = callback;
	    return self;
	  };
	
	  // Async actions
	  self.open   = function() { return self.$toggleOpen( true );  };
	  self.close  = function() { return self.$toggleOpen( false ); };
	  self.toggle = function() { return self.$toggleOpen( !$scope.isOpen );  };
	  self.$toggleOpen = function(value) { return $q.when($scope.isOpen = value); };
	
	  // Evaluate the component id.
	  var rawId = $attrs.mdComponentId;
	  var hasDataBinding = rawId && rawId.indexOf($interpolate.startSymbol()) > -1;
	  var componentId = hasDataBinding ? $interpolate(rawId)($scope.$parent) : rawId;
	
	  // Register the component.
	  self.destroy = $mdComponentRegistry.register(self, componentId);
	
	  // Watch and update the component, if the id has changed.
	  if (hasDataBinding) {
	    $attrs.$observe('mdComponentId', function(id) {
	      if (id && id !== self.$$mdHandle) {
	        self.destroy(); // `destroy` only deregisters the old component id so we can add the new one.
	        self.destroy = $mdComponentRegistry.register(self, id);
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.select
	 */
	
	/***************************************************
	
	 ### TODO - POST RC1 ###
	 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service
	
	 ***************************************************/
	
	SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$parse", "$sce", "$injector"];
	SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
	OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil", "$mdTheming"];
	SelectProvider.$inject = ["$$interimElementProvider"];
	var SELECT_EDGE_MARGIN = 8;
	var selectNextId = 0;
	var CHECKBOX_SELECTION_INDICATOR =
	  angular.element('<div class="md-container"><div class="md-icon"></div></div>');
	
	angular.module('material.components.select', [
	    'material.core',
	    'material.components.backdrop'
	  ])
	  .directive('mdSelect', SelectDirective)
	  .directive('mdSelectMenu', SelectMenuDirective)
	  .directive('mdOption', OptionDirective)
	  .directive('mdOptgroup', OptgroupDirective)
	  .directive('mdSelectHeader', SelectHeaderDirective)
	  .provider('$mdSelect', SelectProvider);
	
	/**
	 * @ngdoc directive
	 * @name mdSelect
	 * @restrict E
	 * @module material.components.select
	 *
	 * @description Displays a select box, bound to an ng-model.
	 *
	 * When the select is required and uses a floating label, then the label will automatically contain
	 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
	 *
	 * By default, the select will display with an underline to match other form elements. This can be
	 * disabled by applying the `md-no-underline` CSS class.
	 *
	 * ### Option Params
	 *
	 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to  clear the
	 * select and put it back in it's default state. You may supply this attribute on any option you
	 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
	 * defined.
	 *
	 * **Automatically Applied**
	 *
	 *  - `<md-option>`
	 *  - `<md-option value>`
	 *  - `<md-option value="">`
	 *  - `<md-option ng-value>`
	 *  - `<md-option ng-value="">`
	 *
	 * **NOT Automatically Applied**
	 *
	 *  - `<md-option ng-value="1">`
	 *  - `<md-option ng-value="''">`
	 *  - `<md-option ng-value="undefined">`
	 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
	 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
	 *
	 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
	 * attribute) since you may wish this to be your "Not Available" or "None" option.
	 *
	 * **Note:** Using the `value` attribute (as opposed to `ng-value`) always evaluates to a string, so
	 * `value="null"` will require the test `ng-if="myValue != 'null'"` rather than `ng-if="!myValue"`.
	 *
	 * @param {expression} ng-model The model!
	 * @param {boolean=} multiple When set to true, allows for more than one option to be selected. The model is an array with the selected choices.
	 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
	 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
	 * Will hide the select options and show a spinner until the evaluated promise resolves.
	 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed. The value
	 * will be treated as *text* (not html).
	 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
	 * to be displayed as a placeholder in the select input box when it is closed. The value
	 * will be treated as *html*. The value must either be explicitly marked as trustedHtml or
	 * the ngSanitize module must be loaded.
	 * @param {string=} placeholder Placeholder hint text.
	 * @param md-no-asterisk {boolean=} When set to true, an asterisk will not be appended to the
	 * floating label. **Note:** This attribute is only evaluated once; it is not watched.
	 * @param {string=} aria-label Optional label for accessibility. Only necessary if no placeholder or
	 * explicit label is present.
	 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
	 * element (for custom styling).
	 *
	 * @usage
	 * With a placeholder (label and aria-label are added dynamically)
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select
	 *       ng-model="someModel"
	 *       placeholder="Select a state">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With an explicit label
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <label>State</label>
	 *     <md-select
	 *       ng-model="someModel">
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * With a select-header
	 *
	 * When a developer needs to put more than just a text label in the
	 * md-select-menu, they should use the md-select-header.
	 * The user can put custom HTML inside of the header and style it to their liking.
	 * One common use case of this would be a sticky search bar.
	 *
	 * When using the md-select-header the labels that would previously be added to the
	 * OptGroupDirective are ignored.
	 *
	 * <hljs lang="html">
	 *   <md-input-container>
	 *     <md-select ng-model="someModel">
	 *       <md-select-header>
	 *         <span> Neighborhoods - </span>
	 *       </md-select-header>
	 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
	 *     </md-select>
	 *   </md-input-container>
	 * </hljs>
	 *
	 * ## Selects and object equality
	 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
	 * equality. Consider the following example:
	 * <hljs lang="js">
	 * angular.controller('MyCtrl', function($scope) {
	 *   $scope.users = [
	 *     { id: 1, name: 'Bob' },
	 *     { id: 2, name: 'Alice' },
	 *     { id: 3, name: 'Steve' }
	 *   ];
	 *   $scope.selectedUser = { id: 1, name: 'Bob' };
	 * });
	 * </hljs>
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 *
	 * At first one might expect that the select should be populated with "Bob" as the selected user. However,
	 * this is not true. To determine whether something is selected,
	 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
	 *
	 * Javascript's `==` operator does not check for deep equality (ie. that all properties
	 * on the object are the same), but instead whether the objects are *the same object in memory*.
	 * In this case, we have two instances of identical objects, but they exist in memory as unique
	 * entities. Because of this, the select will have no value populated for a selected user.
	 *
	 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a different
	 * expression which will be used for the equality operator. As such, we can update our `html` to
	 * make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the `md-select`
	 * element. This converts our equality expression to be
	 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
	 * which results in Bob being selected as desired.
	 *
	 * Working HTML:
	 * <hljs lang="html">
	 * <div ng-controller="MyCtrl">
	 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
	 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
	 *   </md-select>
	 * </div>
	 * </hljs>
	 */
	function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $parse, $sce,
	    $injector) {
	  var keyCodes = $mdConstant.KEY_CODE;
	  var NAVIGATION_KEYS = [keyCodes.SPACE, keyCodes.ENTER, keyCodes.UP_ARROW, keyCodes.DOWN_ARROW];
	
	  return {
	    restrict: 'E',
	    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
	    compile: compile,
	    controller: function() {
	    } // empty placeholder controller to be initialized in link
	  };
	
	  function compile(element, attr) {
	    // add the select value that will hold our placeholder or selected option value
	    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
	    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
	    valueEl.addClass('md-select-value');
	    if (!valueEl[0].hasAttribute('id')) {
	      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
	    }
	
	    // There's got to be an md-content inside. If there's not one, let's add it.
	    if (!element.find('md-content').length) {
	      element.append(angular.element('<md-content>').append(element.contents()));
	    }
	
	
	    // Add progress spinner for md-options-loading
	    if (attr.mdOnOpen) {
	
	      // Show progress indicator while loading async
	      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
	      element
	        .find('md-content')
	        .prepend(angular.element(
	          '<div>' +
	          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false" md-diameter="25px"></md-progress-circular>' +
	          '</div>'
	        ));
	
	      // Hide list [of item options] while loading async
	      element
	        .find('md-option')
	        .attr('ng-show', '$$loadingAsyncDone');
	    }
	
	    if (attr.name) {
	      var autofillClone = angular.element('<select class="md-visually-hidden">');
	      autofillClone.attr({
	        'name': attr.name,
	        'aria-hidden': 'true',
	        'tabindex': '-1'
	      });
	      var opts = element.find('md-option');
	      angular.forEach(opts, function(el) {
	        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
	        if (el.hasAttribute('ng-value')) newEl.attr('ng-value', el.getAttribute('ng-value'));
	        else if (el.hasAttribute('value')) newEl.attr('value', el.getAttribute('value'));
	        autofillClone.append(newEl);
	      });
	
	      // Adds an extra option that will hold the selected value for the
	      // cases where the select is a part of a non-angular form. This can be done with a ng-model,
	      // however if the `md-option` is being `ng-repeat`-ed, AngularJS seems to insert a similar
	      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
	      // This also goes around having to prepend a dot to the name attribute.
	      autofillClone.append(
	        '<option ng-value="' + attr.ngModel + '" selected></option>'
	      );
	
	      element.parent().append(autofillClone);
	    }
	
	    var isMultiple = $mdUtil.parseAttributeBoolean(attr.multiple);
	
	    // Use everything that's left inside element.contents() as the contents of the menu
	    var multipleContent = isMultiple ? 'multiple' : '';
	    var selectTemplate = '' +
	      '<div class="md-select-menu-container" aria-hidden="true">' +
	      '<md-select-menu {0}>{1}</md-select-menu>' +
	      '</div>';
	
	    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, element.html()]);
	    element.empty().append(valueEl);
	    element.append(selectTemplate);
	
	    if(!attr.tabindex){
	      attr.$set('tabindex', 0);
	    }
	
	    return function postLink(scope, element, attr, ctrls) {
	      var untouched = true;
	      var isDisabled, ariaLabelBase;
	
	      var containerCtrl = ctrls[0];
	      var mdSelectCtrl = ctrls[1];
	      var ngModelCtrl = ctrls[2];
	      var formCtrl = ctrls[3];
	      // grab a reference to the select menu value label
	      var valueEl = element.find('md-select-value');
	      var isReadonly = angular.isDefined(attr.readonly);
	      var disableAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	      if (disableAsterisk) {
	        element.addClass('md-no-asterisk');
	      }
	
	      if (containerCtrl) {
	        var isErrorGetter = containerCtrl.isErrorGetter || function() {
	          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
	        };
	
	        if (containerCtrl.input) {
	          // We ignore inputs that are in the md-select-header (one
	          // case where this might be useful would be adding as searchbox)
	          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
	            throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");
	          }
	        }
	
	        containerCtrl.input = element;
	        if (!containerCtrl.label) {
	          $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
	        }
	
	        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
	      }
	
	      var selectContainer, selectScope, selectMenuCtrl;
	
	      findSelectContainer();
	      $mdTheming(element);
	
	      if (formCtrl && angular.isDefined(attr.multiple)) {
	        $mdUtil.nextTick(function() {
	          var hasModelValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue;
	          if (hasModelValue) {
	            formCtrl.$setPristine();
	          }
	        });
	      }
	
	      var originalRender = ngModelCtrl.$render;
	      ngModelCtrl.$render = function() {
	        originalRender();
	        syncLabelText();
	        syncAriaLabel();
	        inputCheckValue();
	      };
	
	      attr.$observe('placeholder', ngModelCtrl.$render);
	
	      if (containerCtrl && containerCtrl.label) {
	        attr.$observe('required', function (value) {
	          // Toggle the md-required class on the input containers label, because the input container is automatically
	          // applying the asterisk indicator on the label.
	          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
	        });
	      }
	
	      mdSelectCtrl.setLabelText = function(text) {
	        mdSelectCtrl.setIsPlaceholder(!text);
	
	        // Whether the select label has been given via user content rather than the internal
	        // template of <md-option>
	        var isSelectLabelFromUser = false;
	
	        if (attr.mdSelectedText && attr.mdSelectedHtml) {
	          throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');
	        }
	
	        if (attr.mdSelectedText || attr.mdSelectedHtml) {
	          text = $parse(attr.mdSelectedText || attr.mdSelectedHtml)(scope);
	          isSelectLabelFromUser = true;
	        } else if (!text) {
	          // Use placeholder attribute, otherwise fallback to the md-input-container label
	          var tmpPlaceholder = attr.placeholder ||
	              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');
	
	          text = tmpPlaceholder || '';
	          isSelectLabelFromUser = true;
	        }
	
	        var target = valueEl.children().eq(0);
	
	        if (attr.mdSelectedHtml) {
	            // Using getTrustedHtml will run the content through $sanitize if it is not already
	            // explicitly trusted. If the ngSanitize module is not loaded, this will
	            // *correctly* throw an sce error.
	            target.html($sce.getTrustedHtml(text));
	        } else if (isSelectLabelFromUser) {
	          target.text(text);
	        } else {
	          // If we've reached this point, the text is not user-provided.
	          target.html(text);
	        }
	      };
	
	      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
	        if (isPlaceholder) {
	          valueEl.addClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.addClass('md-placeholder');
	          }
	        } else {
	          valueEl.removeClass('md-select-placeholder');
	          if (containerCtrl && containerCtrl.label) {
	            containerCtrl.label.removeClass('md-placeholder');
	          }
	        }
	      };
	
	      if (!isReadonly) {
	        element
	          .on('focus', function(ev) {
	            // Always focus the container (if we have one) so floating labels and other styles are
	            // applied properly
	            containerCtrl && containerCtrl.setFocused(true);
	          });
	
	        // Attach before ngModel's blur listener to stop propagation of blur event
	        // to prevent from setting $touched.
	        element.on('blur', function(event) {
	          if (untouched) {
	            untouched = false;
	            if (selectScope._mdSelectIsOpen) {
	              event.stopImmediatePropagation();
	            }
	          }
	
	          if (selectScope._mdSelectIsOpen) return;
	          containerCtrl && containerCtrl.setFocused(false);
	          inputCheckValue();
	        });
	      }
	
	      mdSelectCtrl.triggerClose = function() {
	        $parse(attr.mdOnClose)(scope);
	      };
	
	      scope.$$postDigest(function() {
	        initAriaLabel();
	        syncLabelText();
	        syncAriaLabel();
	      });
	
	      function initAriaLabel() {
	        var labelText = element.attr('aria-label') || element.attr('placeholder');
	        if (!labelText && containerCtrl && containerCtrl.label) {
	          labelText = containerCtrl.label.text();
	        }
	        ariaLabelBase = labelText;
	        $mdAria.expect(element, 'aria-label', labelText);
	      }
	
	      scope.$watch(function() {
	        return selectMenuCtrl.selectedLabels();
	      }, syncLabelText);
	
	      function syncLabelText() {
	        if (selectContainer) {
	          selectMenuCtrl = selectMenuCtrl || selectContainer.find('md-select-menu').controller('mdSelectMenu');
	          mdSelectCtrl.setLabelText(selectMenuCtrl.selectedLabels());
	        }
	      }
	
	      function syncAriaLabel() {
	        if (!ariaLabelBase) return;
	        var ariaLabels = selectMenuCtrl.selectedLabels({mode: 'aria'});
	        element.attr('aria-label', ariaLabels.length ? ariaLabelBase + ': ' + ariaLabels : ariaLabelBase);
	      }
	
	      var deregisterWatcher;
	      attr.$observe('ngMultiple', function(val) {
	        if (deregisterWatcher) deregisterWatcher();
	        var parser = $parse(val);
	        deregisterWatcher = scope.$watch(function() {
	          return parser(scope);
	        }, function(multiple, prevVal) {
	          if (multiple === undefined && prevVal === undefined) return; // assume compiler did a good job
	          if (multiple) {
	            element.attr('multiple', 'multiple');
	          } else {
	            element.removeAttr('multiple');
	          }
	          element.attr('aria-multiselectable', multiple ? 'true' : 'false');
	          if (selectContainer) {
	            selectMenuCtrl.setMultiple(multiple);
	            originalRender = ngModelCtrl.$render;
	            ngModelCtrl.$render = function() {
	              originalRender();
	              syncLabelText();
	              syncAriaLabel();
	              inputCheckValue();
	            };
	            ngModelCtrl.$render();
	          }
	        });
	      });
	
	      attr.$observe('disabled', function(disabled) {
	        if (angular.isString(disabled)) {
	          disabled = true;
	        }
	        // Prevent click event being registered twice
	        if (isDisabled !== undefined && isDisabled === disabled) {
	          return;
	        }
	        isDisabled = disabled;
	        if (disabled) {
	          element
	            .attr({'aria-disabled': 'true'})
	            .removeAttr('tabindex')
	            .off('click', openSelect)
	            .off('keydown', handleKeypress);
	        } else {
	          element
	            .attr({'tabindex': attr.tabindex, 'aria-disabled': 'false'})
	            .on('click', openSelect)
	            .on('keydown', handleKeypress);
	        }
	      });
	
	      if (!attr.hasOwnProperty('disabled') && !attr.hasOwnProperty('ngDisabled')) {
	        element.attr({'aria-disabled': 'false'});
	        element.on('click', openSelect);
	        element.on('keydown', handleKeypress);
	      }
	
	      var ariaAttrs = {
	        role: 'listbox',
	        'aria-expanded': 'false',
	        'aria-multiselectable': isMultiple && !attr.ngMultiple ? 'true' : 'false'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
	      }
	
	      var containerId = 'select_container_' + $mdUtil.nextUid();
	      selectContainer.attr('id', containerId);
	      ariaAttrs['aria-owns'] = containerId;
	      element.attr(ariaAttrs);
	
	      scope.$on('$destroy', function() {
	        $mdSelect
	          .destroy()
	          .finally(function() {
	            if (containerCtrl) {
	              containerCtrl.setFocused(false);
	              containerCtrl.setHasValue(false);
	              containerCtrl.input = null;
	            }
	            ngModelCtrl.$setTouched();
	          });
	      });
	
	
	
	      function inputCheckValue() {
	        // The select counts as having a value if one or more options are selected,
	        // or if the input's validity state says it has bad input (eg string in a number input)
	        containerCtrl && containerCtrl.setHasValue(selectMenuCtrl.selectedLabels().length > 0 || (element[0].validity || {}).badInput);
	      }
	
	      function findSelectContainer() {
	        selectContainer = angular.element(
	          element[0].querySelector('.md-select-menu-container')
	        );
	        selectScope = scope;
	        if (attr.mdContainerClass) {
	          var value = selectContainer[0].getAttribute('class') + ' ' + attr.mdContainerClass;
	          selectContainer[0].setAttribute('class', value);
	        }
	        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
	        selectMenuCtrl.init(ngModelCtrl, attr.ngModel);
	        element.on('$destroy', function() {
	          selectContainer.remove();
	        });
	      }
	
	      function handleKeypress(e) {
	        if ($mdConstant.isNavigationKey(e)) {
	          // prevent page scrolling on interaction
	          e.preventDefault();
	          openSelect(e);
	        } else {
	          if (shouldHandleKey(e, $mdConstant)) {
	            e.preventDefault();
	
	            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
	            if (!node || node.hasAttribute('disabled')) return;
	            var optionCtrl = angular.element(node).controller('mdOption');
	            if (!selectMenuCtrl.isMultiple) {
	              selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
	            }
	            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	            selectMenuCtrl.refreshViewValue();
	          }
	        }
	      }
	
	      function openSelect() {
	        selectScope._mdSelectIsOpen = true;
	        element.attr('aria-expanded', 'true');
	
	        $mdSelect.show({
	          scope: selectScope,
	          preserveScope: true,
	          skipCompile: true,
	          element: selectContainer,
	          target: element[0],
	          selectCtrl: mdSelectCtrl,
	          preserveElement: true,
	          hasBackdrop: true,
	          loadingAsync: attr.mdOnOpen ? scope.$eval(attr.mdOnOpen) || true : false
	        }).finally(function() {
	          selectScope._mdSelectIsOpen = false;
	          element.focus();
	          element.attr('aria-expanded', 'false');
	          ngModelCtrl.$setTouched();
	        });
	      }
	
	    };
	  }
	}
	
	function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
	  // We want the scope to be set to 'false' so an isolated scope is not created
	  // which would interfere with the md-select-header's access to the
	  // parent scope.
	  SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
	  return {
	    restrict: 'E',
	    require: ['mdSelectMenu'],
	    scope: false,
	    controller: SelectMenuController,
	    link: {pre: preLink}
	  };
	
	  // We use preLink instead of postLink to ensure that the select is initialized before
	  // its child options run postLink.
	  function preLink(scope, element, attr, ctrls) {
	    var selectCtrl = ctrls[0];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    $mdTheming(element);
	    element.on('click', clickListener);
	    element.on('keypress', keyListener);
	
	    function keyListener(e) {
	      if (e.keyCode == 13 || e.keyCode == 32) {
	        clickListener(e);
	      }
	    }
	
	    function clickListener(ev) {
	      var option = $mdUtil.getClosest(ev.target, 'md-option');
	      var optionCtrl = option && angular.element(option).data('$mdOptionController');
	      if (!option || !optionCtrl) return;
	      if (option.hasAttribute('disabled')) {
	        ev.stopImmediatePropagation();
	        return false;
	      }
	
	      var optionHashKey = selectCtrl.hashGetter(optionCtrl.value);
	      var isSelected = angular.isDefined(selectCtrl.selected[optionHashKey]);
	
	      scope.$apply(function() {
	        if (selectCtrl.isMultiple) {
	          if (isSelected) {
	            selectCtrl.deselect(optionHashKey);
	          } else {
	            selectCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        } else {
	          if (!isSelected) {
	            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
	            selectCtrl.select(optionHashKey, optionCtrl.value);
	          }
	        }
	        selectCtrl.refreshViewValue();
	      });
	    }
	  }
	
	  function SelectMenuController($scope, $attrs, $element) {
	    var self = this;
	    self.isMultiple = angular.isDefined($attrs.multiple);
	    // selected is an object with keys matching all of the selected options' hashed values
	    self.selected = {};
	    // options is an object with keys matching every option's hash value,
	    // and values matching every option's controller.
	    self.options = {};
	
	    $scope.$watchCollection(function() {
	      return self.options;
	    }, function() {
	      self.ngModel.$render();
	    });
	
	    var deregisterCollectionWatch;
	    var defaultIsEmpty;
	    self.setMultiple = function(isMultiple) {
	      var ngModel = self.ngModel;
	      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;
	
	      self.isMultiple = isMultiple;
	      if (deregisterCollectionWatch) deregisterCollectionWatch();
	
	      if (self.isMultiple) {
	        ngModel.$validators['md-multiple'] = validateArray;
	        ngModel.$render = renderMultiple;
	
	        // watchCollection on the model because by default ngModel only watches the model's
	        // reference. This allowed the developer to also push and pop from their array.
	        $scope.$watchCollection(self.modelBinding, function(value) {
	          if (validateArray(value)) renderMultiple(value);
	          self.ngModel.$setPristine();
	        });
	
	        ngModel.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	      } else {
	        delete ngModel.$validators['md-multiple'];
	        ngModel.$render = renderSingular;
	      }
	
	      function validateArray(modelValue, viewValue) {
	        // If a value is truthy but not an array, reject it.
	        // If value is undefined/falsy, accept that it's an empty array.
	        return angular.isArray(modelValue || viewValue || []);
	      }
	    };
	
	    var searchStr = '';
	    var clearSearchTimeout, optNodes, optText;
	    var CLEAR_SEARCH_AFTER = 300;
	
	    self.optNodeForKeyboardSearch = function(e) {
	      clearSearchTimeout && clearTimeout(clearSearchTimeout);
	      clearSearchTimeout = setTimeout(function() {
	        clearSearchTimeout = undefined;
	        searchStr = '';
	        optText = undefined;
	        optNodes = undefined;
	      }, CLEAR_SEARCH_AFTER);
	
	      // Support 1-9 on numpad
	      var keyCode = e.keyCode - ($mdConstant.isNumPadKey(e) ? 48 : 0);
	
	      searchStr += String.fromCharCode(keyCode);
	      var search = new RegExp('^' + searchStr, 'i');
	      if (!optNodes) {
	        optNodes = $element.find('md-option');
	        optText = new Array(optNodes.length);
	        angular.forEach(optNodes, function(el, i) {
	          optText[i] = el.textContent.trim();
	        });
	      }
	      for (var i = 0; i < optText.length; ++i) {
	        if (search.test(optText[i])) {
	          return optNodes[i];
	        }
	      }
	    };
	
	    self.init = function(ngModel, binding) {
	      self.ngModel = ngModel;
	      self.modelBinding = binding;
	
	      // Setup a more robust version of isEmpty to ensure value is a valid option
	      self.ngModel.$isEmpty = function($viewValue) {
	        // We have to transform the viewValue into the hashKey, because otherwise the
	        // OptionCtrl may not exist. Developers may have specified a trackBy function.
	        return !self.options[self.hashGetter($viewValue)];
	      };
	
	      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: 'foo.id'}"` so
	      // that we can properly compare objects set on the model to the available options
	      var trackByOption = $mdUtil.getModelOption(ngModel, 'trackBy');
	
	      if (trackByOption) {
	        var trackByLocals = {};
	        var trackByParsed = $parse(trackByOption);
	        self.hashGetter = function(value, valueScope) {
	          trackByLocals.$value = value;
	          return trackByParsed(valueScope || $scope, trackByLocals);
	        };
	        // If the user doesn't provide a trackBy, we automatically generate an id for every
	        // value passed in
	      } else {
	        self.hashGetter = function getHashValue(value) {
	          if (angular.isObject(value)) {
	            return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
	          }
	          return value;
	        };
	      }
	      self.setMultiple(self.isMultiple);
	    };
	
	    self.selectedLabels = function(opts) {
	      opts = opts || {};
	      var mode = opts.mode || 'html';
	      var selectedOptionEls = $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
	      if (selectedOptionEls.length) {
	        var mapFn;
	
	        if (mode == 'html') {
	          // Map the given element to its innerHTML string. If the element has a child ripple
	          // container remove it from the HTML string, before returning the string.
	          mapFn = function(el) {
	            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears the select
	            if (el.hasAttribute('md-option-empty')) {
	              return '';
	            }
	
	            var html = el.innerHTML;
	
	            // Remove the ripple container from the selected option, copying it would cause a CSP violation.
	            var rippleContainer = el.querySelector('.md-ripple-container');
	            if (rippleContainer) {
	              html = html.replace(rippleContainer.outerHTML, '');
	            }
	
	            // Remove the checkbox container, because it will cause the label to wrap inside of the placeholder.
	            // It should be not displayed inside of the label element.
	            var checkboxContainer = el.querySelector('.md-container');
	            if (checkboxContainer) {
	              html = html.replace(checkboxContainer.outerHTML, '');
	            }
	
	            return html;
	          };
	        } else if (mode == 'aria') {
	          mapFn = function(el) { return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent; };
	        }
	
	        // Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
	        return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');
	      } else {
	        return '';
	      }
	    };
	
	    self.select = function(hashKey, hashedValue) {
	      var option = self.options[hashKey];
	      option && option.setSelected(true);
	      self.selected[hashKey] = hashedValue;
	    };
	    self.deselect = function(hashKey) {
	      var option = self.options[hashKey];
	      option && option.setSelected(false);
	      delete self.selected[hashKey];
	    };
	
	    self.addOption = function(hashKey, optionCtrl) {
	      if (angular.isDefined(self.options[hashKey])) {
	        throw new Error('Duplicate md-option values are not allowed in a select. ' +
	          'Duplicate value "' + optionCtrl.value + '" found.');
	      }
	
	      self.options[hashKey] = optionCtrl;
	
	      // If this option's value was already in our ngModel, go ahead and select it.
	      if (angular.isDefined(self.selected[hashKey])) {
	        self.select(hashKey, optionCtrl.value);
	
	        // When the current $modelValue of the ngModel Controller is using the same hash as
	        // the current option, which will be added, then we can be sure, that the validation
	        // of the option has occurred before the option was added properly.
	        // This means, that we have to manually trigger a new validation of the current option.
	        if (angular.isDefined(self.ngModel.$modelValue) && self.hashGetter(self.ngModel.$modelValue) === hashKey) {
	          self.ngModel.$validate();
	        }
	
	        self.refreshViewValue();
	      }
	    };
	    self.removeOption = function(hashKey) {
	      delete self.options[hashKey];
	      // Don't deselect an option when it's removed - the user's ngModel should be allowed
	      // to have values that do not match a currently available option.
	    };
	
	    self.refreshViewValue = function() {
	      var values = [];
	      var option;
	      for (var hashKey in self.selected) {
	        // If this hashKey has an associated option, push that option's value to the model.
	        if ((option = self.options[hashKey])) {
	          values.push(option.value);
	        } else {
	          // Otherwise, the given hashKey has no associated option, and we got it
	          // from an ngModel value at an earlier time. Push the unhashed value of
	          // this hashKey to the model.
	          // This allows the developer to put a value in the model that doesn't yet have
	          // an associated option.
	          values.push(self.selected[hashKey]);
	        }
	      }
	      var usingTrackBy = $mdUtil.getModelOption(self.ngModel, 'trackBy');
	
	      var newVal = self.isMultiple ? values : values[0];
	      var prevVal = self.ngModel.$modelValue;
	
	      if (usingTrackBy ? !angular.equals(prevVal, newVal) : (prevVal + '') !== newVal) {
	        self.ngModel.$setViewValue(newVal);
	        self.ngModel.$render();
	      }
	    };
	
	    function renderMultiple() {
	      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
	      if (!angular.isArray(newSelectedValues)) return;
	
	      var oldSelected = Object.keys(self.selected);
	
	      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
	      var deselected = oldSelected.filter(function(hash) {
	        return newSelectedHashes.indexOf(hash) === -1;
	      });
	
	      deselected.forEach(self.deselect);
	      newSelectedHashes.forEach(function(hashKey, i) {
	        self.select(hashKey, newSelectedValues[i]);
	      });
	    }
	
	    function renderSingular() {
	      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
	      Object.keys(self.selected).forEach(self.deselect);
	      self.select(self.hashGetter(value), value);
	    }
	  }
	
	}
	
	function OptionDirective($mdButtonInkRipple, $mdUtil, $mdTheming) {
	
	  OptionController.$inject = ["$element"];
	  return {
	    restrict: 'E',
	    require: ['mdOption', '^^mdSelectMenu'],
	    controller: OptionController,
	    compile: compile
	  };
	
	  function compile(element, attr) {
	    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
	    element.append(angular.element('<div class="md-text">').append(element.contents()));
	
	    element.attr('tabindex', attr.tabindex || '0');
	
	    if (!hasDefinedValue(attr)) {
	      element.attr('md-option-empty', '');
	    }
	
	    return postLink;
	  }
	
	  function hasDefinedValue(attr) {
	    var value = attr.value;
	    var ngValue = attr.ngValue;
	
	    return value || ngValue;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    var optionCtrl = ctrls[0];
	    var selectCtrl = ctrls[1];
	
	    $mdTheming(element);
	
	    if (selectCtrl.isMultiple) {
	      element.addClass('md-checkbox-enabled');
	      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
	    }
	
	    if (angular.isDefined(attr.ngValue)) {
	      scope.$watch(attr.ngValue, setOptionValue);
	    } else if (angular.isDefined(attr.value)) {
	      setOptionValue(attr.value);
	    } else {
	      scope.$watch(function() {
	        return element.text().trim();
	      }, setOptionValue);
	    }
	
	    attr.$observe('disabled', function(disabled) {
	      if (disabled) {
	        element.attr('tabindex', '-1');
	      } else {
	        element.attr('tabindex', '0');
	      }
	    });
	
	    scope.$$postDigest(function() {
	      attr.$observe('selected', function(selected) {
	        if (!angular.isDefined(selected)) return;
	        if (typeof selected == 'string') selected = true;
	        if (selected) {
	          if (!selectCtrl.isMultiple) {
	            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
	          }
	          selectCtrl.select(optionCtrl.hashKey, optionCtrl.value);
	        } else {
	          selectCtrl.deselect(optionCtrl.hashKey);
	        }
	        selectCtrl.refreshViewValue();
	      });
	    });
	
	    $mdButtonInkRipple.attach(scope, element);
	    configureAria();
	
	    function setOptionValue(newValue, oldValue, prevAttempt) {
	      if (!selectCtrl.hashGetter) {
	        if (!prevAttempt) {
	          scope.$$postDigest(function() {
	            setOptionValue(newValue, oldValue, true);
	          });
	        }
	        return;
	      }
	      var oldHashKey = selectCtrl.hashGetter(oldValue, scope);
	      var newHashKey = selectCtrl.hashGetter(newValue, scope);
	
	      optionCtrl.hashKey = newHashKey;
	      optionCtrl.value = newValue;
	
	      selectCtrl.removeOption(oldHashKey, optionCtrl);
	      selectCtrl.addOption(newHashKey, optionCtrl);
	    }
	
	    scope.$on('$destroy', function() {
	      selectCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
	    });
	
	    function configureAria() {
	      var ariaAttrs = {
	        'role': 'option',
	        'aria-selected': 'false'
	      };
	
	      if (!element[0].hasAttribute('id')) {
	        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
	      }
	      element.attr(ariaAttrs);
	    }
	  }
	
	  function OptionController($element) {
	    this.selected = false;
	    this.setSelected = function(isSelected) {
	      if (isSelected && !this.selected) {
	        $element.attr({
	          'selected': 'selected',
	          'aria-selected': 'true'
	        });
	      } else if (!isSelected && this.selected) {
	        $element.removeAttr('selected');
	        $element.attr('aria-selected', 'false');
	      }
	      this.selected = isSelected;
	    };
	  }
	
	}
	
	function OptgroupDirective() {
	  return {
	    restrict: 'E',
	    compile: compile
	  };
	  function compile(el, attrs) {
	    // If we have a select header element, we don't want to add the normal label
	    // header.
	    if (!hasSelectHeader()) {
	      setupLabelElement();
	    }
	
	    function hasSelectHeader() {
	      return el.parent().find('md-select-header').length;
	    }
	
	    function setupLabelElement() {
	      var labelElement = el.find('label');
	      if (!labelElement.length) {
	        labelElement = angular.element('<label>');
	        el.prepend(labelElement);
	      }
	      labelElement.addClass('md-container-ignore');
	      if (attrs.label) labelElement.text(attrs.label);
	    }
	  }
	}
	
	function SelectHeaderDirective() {
	  return {
	    restrict: 'E',
	  };
	}
	
	function SelectProvider($$interimElementProvider) {
	  selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
	  return $$interimElementProvider('$mdSelect')
	    .setDefaults({
	      methods: ['target'],
	      options: selectDefaultOptions
	    });
	
	  /* @ngInject */
	  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
	    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
	    var animator = $mdUtil.dom.animator;
	    var keyCodes = $mdConstant.KEY_CODE;
	
	    return {
	      parent: 'body',
	      themable: true,
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true
	    };
	
	    /**
	     * Interim-element onRemove logic....
	     */
	    function onRemove(scope, element, opts) {
	      opts = opts || { };
	      opts.cleanupInteraction();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return  (opts.$destroy === true) ? cleanElement() : animateRemoval().then( cleanElement );
	
	      /**
	       * For normal closes (eg clicks), animate the removal.
	       * For forced closes (like $destroy events from navigation),
	       * skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Restore the element to a closed state
	       */
	      function cleanElement() {
	
	        element.removeClass('md-active');
	        element.attr('aria-hidden', 'true');
	        element[0].style.display = 'none';
	
	        announceClosed(opts);
	
	        if (!opts.$destroy && opts.restoreFocus) {
	          opts.target.focus();
	        }
	      }
	
	    }
	
	    /**
	     * Interim-element onShow logic....
	     */
	    function onShow(scope, element, opts) {
	
	      watchAsyncLoad();
	      sanitizeAndConfigure(scope, opts);
	
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      return showDropDown(scope, element, opts)
	        .then(function(response) {
	          element.attr('aria-hidden', 'false');
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupResizing = activateResizing();
	
	          return response;
	        }, opts.hideBackdrop);
	
	      // ************************************
	      // Closure Functions
	      // ************************************
	
	      /**
	       *  Attach the select DOM element(s) and animate to the correct positions
	       *  and scalings...
	       */
	      function showDropDown(scope, element, opts) {
	        opts.parent.append(element);
	
	        return $q(function(resolve, reject) {
	
	          try {
	
	            $animateCss(element, {removeClass: 'md-leave', duration: 0})
	              .start()
	              .then(positionAndFocusMenu)
	              .then(resolve);
	
	          } catch (e) {
	            reject(e);
	          }
	
	        });
	      }
	
	      /**
	       * Initialize container and dropDown menu positions/scale, then animate
	       * to show... and autoFocus.
	       */
	      function positionAndFocusMenu() {
	        return $q(function(resolve) {
	          if (opts.isRemoved) return $q.reject(false);
	
	          var info = calculateMenuPositions(scope, element, opts);
	
	          info.container.element.css(animator.toCss(info.container.styles));
	          info.dropDown.element.css(animator.toCss(info.dropDown.styles));
	
	          $$rAF(function() {
	            element.addClass('md-active');
	            info.dropDown.element.css(animator.toCss({transform: ''}));
	
	            autoFocus(opts.focusedNode);
	            resolve();
	          });
	
	        });
	      }
	
	      /**
	       * Show modal backdrop element...
	       */
	      function showBackdrop(scope, element, options) {
	
	        // If we are not within a dialog...
	        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	          // !! DO this before creating the backdrop; since disableScrollAround()
	          //    configures the scroll offset; which is used by mdBackDrop postLink()
	          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	        } else {
	          options.disableParentScroll = false;
	        }
	
	        if (options.hasBackdrop) {
	          // Override duration to immediately show invisible backdrop
	          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
	          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
	        }
	
	        /**
	         * Hide modal backdrop element...
	         */
	        return function hideBackdrop() {
	          if (options.backdrop) options.backdrop.remove();
	          if (options.disableParentScroll) options.restoreScroll();
	
	          delete options.restoreScroll;
	        };
	      }
	
	      /**
	       *
	       */
	      function autoFocus(focusedNode) {
	        if (focusedNode && !focusedNode.hasAttribute('disabled')) {
	          focusedNode.focus();
	        }
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure(scope, options) {
	        var selectEl = element.find('md-select-menu');
	
	        if (!options.target) {
	          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
	        }
	
	        angular.extend(options, {
	          isRemoved: false,
	          target: angular.element(options.target), //make sure it's not a naked dom node
	          parent: angular.element(options.parent),
	          selectEl: selectEl,
	          contentEl: element.find('md-content'),
	          optionNodes: selectEl[0].getElementsByTagName('md-option')
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function activateResizing() {
	        var debouncedOnResize = (function(scope, target, options) {
	
	          return function() {
	            if (options.isRemoved) return;
	
	            var updates = calculateMenuPositions(scope, target, options);
	            var container = updates.container;
	            var dropDown = updates.dropDown;
	
	            container.element.css(animator.toCss(container.styles));
	            dropDown.element.css(animator.toCss(dropDown.styles));
	          };
	
	        })(scope, element, opts);
	
	        var window = angular.element($window);
	        window.on('resize', debouncedOnResize);
	        window.on('orientationchange', debouncedOnResize);
	
	        // Publish deactivation closure...
	        return function deactivateResizing() {
	
	          // Disable resizing handlers
	          window.off('resize', debouncedOnResize);
	          window.off('orientationchange', debouncedOnResize);
	        };
	      }
	
	      /**
	       *  If asynchronously loading, watch and update internal
	       *  '$$loadingAsyncDone' flag
	       */
	      function watchAsyncLoad() {
	        if (opts.loadingAsync && !opts.isRemoved) {
	          scope.$$loadingAsyncDone = false;
	
	          $q.when(opts.loadingAsync)
	            .then(function() {
	              scope.$$loadingAsyncDone = true;
	              delete opts.loadingAsync;
	            }).then(function() {
	              $$rAF(positionAndFocusMenu);
	            });
	        }
	      }
	
	      /**
	       *
	       */
	      function activateInteraction() {
	        if (opts.isRemoved) return;
	
	        var dropDown = opts.selectEl;
	        var selectCtrl = dropDown.controller('mdSelectMenu') || {};
	
	        element.addClass('md-clickable');
	
	        // Close on backdrop click
	        opts.backdrop && opts.backdrop.on('click', onBackdropClick);
	
	        // Escape to close
	        // Cycling of options, and closing on enter
	        dropDown.on('keydown', onMenuKeyDown);
	        dropDown.on('click', checkCloseMenu);
	
	        return function cleanupInteraction() {
	          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
	          dropDown.off('keydown', onMenuKeyDown);
	          dropDown.off('click', checkCloseMenu);
	
	          element.removeClass('md-clickable');
	          opts.isRemoved = true;
	        };
	
	        // ************************************
	        // Closure Functions
	        // ************************************
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          opts.restoreFocus = false;
	          $mdUtil.nextTick($mdSelect.hide, true);
	        }
	
	        function onMenuKeyDown(ev) {
	          ev.preventDefault();
	          ev.stopPropagation();
	
	          switch (ev.keyCode) {
	            case keyCodes.UP_ARROW:
	              return focusPrevOption();
	            case keyCodes.DOWN_ARROW:
	              return focusNextOption();
	            case keyCodes.SPACE:
	            case keyCodes.ENTER:
	              var option = $mdUtil.getClosest(ev.target, 'md-option');
	              if (option) {
	                dropDown.triggerHandler({
	                  type: 'click',
	                  target: option
	                });
	                ev.preventDefault();
	              }
	              checkCloseMenu(ev);
	              break;
	            case keyCodes.TAB:
	            case keyCodes.ESCAPE:
	              ev.stopPropagation();
	              ev.preventDefault();
	              opts.restoreFocus = true;
	              $mdUtil.nextTick($mdSelect.hide, true);
	              break;
	            default:
	              if (shouldHandleKey(ev, $mdConstant)) {
	                var optNode = dropDown.controller('mdSelectMenu').optNodeForKeyboardSearch(ev);
	                opts.focusedNode = optNode || opts.focusedNode;
	                optNode && optNode.focus();
	              }
	          }
	        }
	
	        function focusOption(direction) {
	          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
	          var index = optionsArray.indexOf(opts.focusedNode);
	
	          var newOption;
	
	          do {
	            if (index === -1) {
	              // We lost the previously focused element, reset to first option
	              index = 0;
	            } else if (direction === 'next' && index < optionsArray.length - 1) {
	              index++;
	            } else if (direction === 'prev' && index > 0) {
	              index--;
	            }
	            newOption = optionsArray[index];
	            if (newOption.hasAttribute('disabled')) newOption = undefined;
	          } while (!newOption && index < optionsArray.length - 1 && index > 0);
	
	          newOption && newOption.focus();
	          opts.focusedNode = newOption;
	        }
	
	        function focusNextOption() {
	          focusOption('next');
	        }
	
	        function focusPrevOption() {
	          focusOption('prev');
	        }
	
	        function checkCloseMenu(ev) {
	          if (ev && ( ev.type == 'click') && (ev.currentTarget != dropDown[0])) return;
	          if ( mouseOnScrollbar() ) return;
	
	          var option = $mdUtil.getClosest(ev.target, 'md-option');
	          if (option && option.hasAttribute && !option.hasAttribute('disabled')) {
	            ev.preventDefault();
	            ev.stopPropagation();
	            if (!selectCtrl.isMultiple) {
	              opts.restoreFocus = true;
	
	              $mdUtil.nextTick(function () {
	                $mdSelect.hide(selectCtrl.ngModel.$viewValue);
	              }, true);
	            }
	          }
	          /**
	           * check if the mouseup event was on a scrollbar
	           */
	          function mouseOnScrollbar() {
	            var clickOnScrollbar = false;
	            if (ev && (ev.currentTarget.children.length > 0)) {
	              var child = ev.currentTarget.children[0];
	              var hasScrollbar = child.scrollHeight > child.clientHeight;
	              if (hasScrollbar && child.children.length > 0) {
	                var relPosX = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
	                if (relPosX > child.querySelector('md-option').offsetWidth)
	                  clickOnScrollbar = true;
	              }
	            }
	            return clickOnScrollbar;
	          }
	        }
	      }
	
	    }
	
	    /**
	     * To notify listeners that the Select menu has closed,
	     * trigger the [optional] user-defined expression
	     */
	    function announceClosed(opts) {
	      var mdSelect = opts.selectCtrl;
	      if (mdSelect) {
	        var menuController = opts.selectEl.controller('mdSelectMenu');
	        mdSelect.setLabelText(menuController ? menuController.selectedLabels() : '');
	        mdSelect.triggerClose();
	      }
	    }
	
	
	    /**
	     * Calculate the
	     */
	    function calculateMenuPositions(scope, element, opts) {
	      var
	        containerNode = element[0],
	        targetNode = opts.target[0].children[0], // target the label
	        parentNode = $document[0].body,
	        selectNode = opts.selectEl[0],
	        contentNode = opts.contentEl[0],
	        parentRect = parentNode.getBoundingClientRect(),
	        targetRect = targetNode.getBoundingClientRect(),
	        shouldOpenAroundTarget = false,
	        bounds = {
	          left: parentRect.left + SELECT_EDGE_MARGIN,
	          top: SELECT_EDGE_MARGIN,
	          bottom: parentRect.height - SELECT_EDGE_MARGIN,
	          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
	        },
	        spaceAvailable = {
	          top: targetRect.top - bounds.top,
	          left: targetRect.left - bounds.left,
	          right: bounds.right - (targetRect.left + targetRect.width),
	          bottom: bounds.bottom - (targetRect.top + targetRect.height)
	        },
	        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
	        selectedNode = selectNode.querySelector('md-option[selected]'),
	        optionNodes = selectNode.getElementsByTagName('md-option'),
	        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
	        isScrollable = calculateScrollable(element, contentNode),
	        centeredNode;
	
	      var loading = isPromiseLike(opts.loadingAsync);
	      if (!loading) {
	        // If a selected node, center around that
	        if (selectedNode) {
	          centeredNode = selectedNode;
	          // If there are option groups, center around the first option group
	        } else if (optgroupNodes.length) {
	          centeredNode = optgroupNodes[0];
	          // Otherwise - if we are not loading async - center around the first optionNode
	        } else if (optionNodes.length) {
	          centeredNode = optionNodes[0];
	          // In case there are no options, center on whatever's in there... (eg progress indicator)
	        } else {
	          centeredNode = contentNode.firstElementChild || contentNode;
	        }
	      } else {
	        // If loading, center on progress indicator
	        centeredNode = contentNode.firstElementChild || contentNode;
	      }
	
	      if (contentNode.offsetWidth > maxWidth) {
	        contentNode.style['max-width'] = maxWidth + 'px';
	      } else {
	        contentNode.style.maxWidth = null;
	      }
	      if (shouldOpenAroundTarget) {
	        contentNode.style['min-width'] = targetRect.width + 'px';
	      }
	
	      // Remove padding before we compute the position of the menu
	      if (isScrollable) {
	        selectNode.classList.add('md-overflow');
	      }
	
	      var focusedNode = centeredNode;
	      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
	        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
	        centeredNode = focusedNode;
	      }
	      // Cache for autoFocus()
	      opts.focusedNode = focusedNode;
	
	      // Get the selectMenuRect *after* max-width is possibly set above
	      containerNode.style.display = 'block';
	      var selectMenuRect = selectNode.getBoundingClientRect();
	      var centeredRect = getOffsetRect(centeredNode);
	
	      if (centeredNode) {
	        var centeredStyle = $window.getComputedStyle(centeredNode);
	        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
	        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
	      }
	
	      if (isScrollable) {
	        var scrollBuffer = contentNode.offsetHeight / 2;
	        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;
	
	        if (spaceAvailable.top < scrollBuffer) {
	          contentNode.scrollTop = Math.min(
	            centeredRect.top,
	            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
	          );
	        } else if (spaceAvailable.bottom < scrollBuffer) {
	          contentNode.scrollTop = Math.max(
	            centeredRect.top + centeredRect.height - selectMenuRect.height,
	            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
	          );
	        }
	      }
	
	      var left, top, transformOrigin, minWidth, fontSize;
	      if (shouldOpenAroundTarget) {
	        left = targetRect.left;
	        top = targetRect.top + targetRect.height;
	        transformOrigin = '50% 0';
	        if (top + selectMenuRect.height > bounds.bottom) {
	          top = targetRect.top - selectMenuRect.height;
	          transformOrigin = '50% 100%';
	        }
	      } else {
	        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft) + 2;
	        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
	            centeredRect.top + contentNode.scrollTop) + 2;
	
	        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
	          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';
	
	        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);
	
	        fontSize = window.getComputedStyle(targetNode)['font-size'];
	      }
	
	      // Keep left and top within the window
	      var containerRect = containerNode.getBoundingClientRect();
	      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;
	
	      return {
	        container: {
	          element: angular.element(containerNode),
	          styles: {
	            left: Math.floor(clamp(bounds.left, left, bounds.right - containerRect.width)),
	            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
	            'min-width': minWidth,
	            'font-size': fontSize
	          }
	        },
	        dropDown: {
	          element: angular.element(selectNode),
	          styles: {
	            transformOrigin: transformOrigin,
	            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
	          }
	        }
	      };
	
	    }
	
	  }
	
	  function isPromiseLike(obj) {
	    return obj && angular.isFunction(obj.then);
	  }
	
	  function clamp(min, n, max) {
	    return Math.max(min, Math.min(n, max));
	  }
	
	  function getOffsetRect(node) {
	    return node ? {
	      left: node.offsetLeft,
	      top: node.offsetTop,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    } : {left: 0, top: 0, width: 0, height: 0};
	  }
	
	  function calculateScrollable(element, contentNode) {
	    var isScrollable = false;
	
	    try {
	      var oldDisplay = element[0].style.display;
	
	      // Set the element's display to block so that this calculation is correct
	      element[0].style.display = 'block';
	
	      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;
	
	      // Reset it back afterwards
	      element[0].style.display = oldDisplay;
	    } finally {
	      // Nothing to do
	    }
	    return isScrollable;
	  }
	
	}
	
	function shouldHandleKey(ev, $mdConstant) {
	  var char = String.fromCharCode(ev.keyCode);
	  var isNonUsefulKey = (ev.keyCode <= 31);
	
	  return (char && char.length && !isNonUsefulKey &&
	    !$mdConstant.isMetaKey(ev) && !$mdConstant.isFnLockKey(ev) && !$mdConstant.hasModifierKey(ev));
	}
	
	})();
	(function(){
	"use strict";
	
	  /**
	   * @ngdoc module
	   * @name material.components.slider
	   */
	SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
	  angular.module('material.components.slider', [
	    'material.core'
	  ])
	  .directive('mdSlider', SliderDirective)
	  .directive('mdSliderContainer', SliderContainerDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSliderContainer
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider-container>` contains slider with two other elements.
	 *
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * </hljs>
	 */
	function SliderContainerDirective() {
	  return {
	    controller: function () {},
	    compile: function (elem) {
	      var slider = elem.find('md-slider');
	
	      if (!slider) {
	        return;
	      }
	
	      var vertical = slider.attr('md-vertical');
	
	      if (vertical !== undefined) {
	        elem.attr('md-vertical', '');
	      }
	
	      if(!slider.attr('flex')) {
	        slider.attr('flex', '');
	      }
	
	      return function postLink(scope, element, attr, ctrl) {
	        element.addClass('_md');     // private md component indicator for styling
	
	        // We have to manually stop the $watch on ngDisabled because it exists
	        // on the parent scope, and won't be automatically destroyed when
	        // the component is destroyed.
	        function setDisable(value) {
	          element.children().attr('disabled', value);
	          element.find('input').attr('disabled', value);
	        }
	
	        var stopDisabledWatch = angular.noop;
	
	        if (attr.disabled) {
	          setDisable(true);
	        }
	        else if (attr.ngDisabled) {
	          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
	            setDisable(value);
	          });
	        }
	
	        scope.$on('$destroy', function () {
	          stopDisabledWatch();
	        });
	
	        var initialMaxWidth;
	
	        ctrl.fitInputWidthToTextLength = function (length) {
	          var input = element[0].querySelector('md-input-container');
	
	          if (input) {
	            var computedStyle = getComputedStyle(input);
	            var minWidth = parseInt(computedStyle.minWidth);
	            var padding = parseInt(computedStyle.padding) * 2;
	
	            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
	            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));
	
	            input.style.maxWidth = newMaxWidth + 'px';
	          }
	        };
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name mdSlider
	 * @module material.components.slider
	 * @restrict E
	 * @description
	 * The `<md-slider>` component allows the user to choose from a range of
	 * values.
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the slider is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * It has two modes: 'normal' mode, where the user slides between a wide range
	 * of values, and 'discrete' mode, where the user slides between only a few
	 * select values.
	 *
	 * To enable discrete mode, add the `md-discrete` attribute to a slider,
	 * and use the `step` attribute to change the distance between
	 * values the user is allowed to pick.
	 *
	 * @usage
	 * <h4>Normal Mode</h4>
	 * <hljs lang="html">
	 * <md-slider ng-model="myValue" min="5" max="500">
	 * </md-slider>
	 * </hljs>
	 * <h4>Discrete Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 * <h4>Invert Mode</h4>
	 * <hljs lang="html">
	 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
	 * </md-slider>
	 * </hljs>
	 *
	 * @param {boolean=} md-discrete Whether to enable discrete mode.
	 * @param {boolean=} md-invert Whether to enable invert mode.
	 * @param {number=} step The distance between values the user is allowed to pick. Default 1.
	 * @param {number=} min The minimum value the user is allowed to pick. Default 0.
	 * @param {number=} max The maximum value the user is allowed to pick. Default 100.
	 * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
	 */
	function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture, $parse, $log, $timeout) {
	  return {
	    scope: {},
	    require: ['?ngModel', '?^mdSliderContainer'],
	    template:
	      '<div class="md-slider-wrapper">' +
	        '<div class="md-slider-content">' +
	          '<div class="md-track-container">' +
	            '<div class="md-track"></div>' +
	            '<div class="md-track md-track-fill"></div>' +
	            '<div class="md-track-ticks"></div>' +
	          '</div>' +
	          '<div class="md-thumb-container">' +
	            '<div class="md-thumb"></div>' +
	            '<div class="md-focus-thumb"></div>' +
	            '<div class="md-focus-ring"></div>' +
	            '<div class="md-sign">' +
	              '<span class="md-thumb-text"></span>' +
	            '</div>' +
	            '<div class="md-disabled-thumb"></div>' +
	          '</div>' +
	        '</div>' +
	      '</div>',
	    compile: compile
	  };
	
	  // **********************************************************
	  // Private Methods
	  // **********************************************************
	
	  function compile (tElement, tAttrs) {
	    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));
	
	    var tabIndex = tAttrs.tabindex || 0;
	    wrapper.attr('tabindex', tabIndex);
	
	    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);
	
	    wrapper.attr('role', 'slider');
	
	    $mdAria.expect(tElement, 'aria-label');
	
	    return postLink;
	  }
	
	  function postLink(scope, element, attr, ctrls) {
	    $mdTheming(element);
	    var ngModelCtrl = ctrls[0] || {
	      // Mock ngModelController if it doesn't exist to give us
	      // the minimum functionality needed
	      $setViewValue: function(val) {
	        this.$viewValue = val;
	        this.$viewChangeListeners.forEach(function(cb) { cb(); });
	      },
	      $parsers: [],
	      $formatters: [],
	      $viewChangeListeners: []
	    };
	
	    var containerCtrl = ctrls[1];
	    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
	    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
	          return element[0].hasAttribute('disabled');
	        };
	
	    var thumb = angular.element(element[0].querySelector('.md-thumb'));
	    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
	    var thumbContainer = thumb.parent();
	    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
	    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
	    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
	    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
	    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
	    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);
	
	    // Default values, overridable by attrs
	    var DEFAULT_ROUND = 3;
	    var vertical = angular.isDefined(attr.mdVertical);
	    var discrete = angular.isDefined(attr.mdDiscrete);
	    var invert = angular.isDefined(attr.mdInvert);
	    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
	    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
	    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
	    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);
	
	    // We have to manually stop the $watch on ngDisabled because it exists
	    // on the parent scope, and won't be automatically destroyed when
	    // the component is destroyed.
	    var stopDisabledWatch = angular.noop;
	    if (attr.ngDisabled) {
	      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
	    }
	
	    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });
	
	    scope.mouseActive = false;
	
	    wrapper
	      .on('keydown', keydownListener)
	      .on('mousedown', mouseDownListener)
	      .on('focus', focusListener)
	      .on('blur', blurListener)
	      .on('$md.pressdown', onPressDown)
	      .on('$md.pressup', onPressUp)
	      .on('$md.dragstart', onDragStart)
	      .on('$md.drag', onDrag)
	      .on('$md.dragend', onDragEnd);
	
	    // On resize, recalculate the slider's dimensions and re-render
	    function updateAll() {
	      refreshSliderDimensions();
	      ngModelRender();
	    }
	    setTimeout(updateAll, 0);
	
	    var debouncedUpdateAll = $$rAF.throttle(updateAll);
	    angular.element($window).on('resize', debouncedUpdateAll);
	
	    scope.$on('$destroy', function() {
	      angular.element($window).off('resize', debouncedUpdateAll);
	    });
	
	    ngModelCtrl.$render = ngModelRender;
	    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
	    ngModelCtrl.$formatters.push(minMaxValidator);
	    ngModelCtrl.$formatters.push(stepValidator);
	
	    /**
	     * Attributes
	     */
	    var min;
	    var max;
	    var step;
	    var round;
	    function updateMin(value) {
	      min = parseFloat(value);
	      element.attr('aria-valuemin', value);
	      updateAll();
	    }
	    function updateMax(value) {
	      max = parseFloat(value);
	      element.attr('aria-valuemax', value);
	      updateAll();
	    }
	    function updateStep(value) {
	      step = parseFloat(value);
	    }
	    function updateRound(value) {
	      // Set max round digits to 6, after 6 the input uses scientific notation
	      round = minMaxValidator(parseInt(value), 0, 6);
	    }
	    function updateAriaDisabled() {
	      element.attr('aria-disabled', !!isDisabled());
	    }
	
	    // Draw the ticks with canvas.
	    // The alternative to drawing ticks with canvas is to draw one element for each tick,
	    // which could quickly become a performance bottleneck.
	    var tickCanvas, tickCtx;
	    function redrawTicks() {
	      if (!discrete || isDisabled()) return;
	      if ( angular.isUndefined(step) )         return;
	
	      if ( step <= 0 ) {
	        var msg = 'Slider step value must be greater than zero when in discrete mode';
	        $log.error(msg);
	        throw new Error(msg);
	      }
	
	      var numSteps = Math.floor( (max - min) / step );
	      if (!tickCanvas) {
	        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
	        tickContainer.append(tickCanvas);
	
	        tickCtx = tickCanvas[0].getContext('2d');
	      }
	
	      var dimensions = getSliderDimensions();
	
	      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
	      if (dimensions && !dimensions.height && !dimensions.width) {
	        refreshSliderDimensions();
	        dimensions = sliderDimensions;
	      }
	
	      tickCanvas[0].width = dimensions.width;
	      tickCanvas[0].height = dimensions.height;
	
	      var distance;
	      for (var i = 0; i <= numSteps; i++) {
	        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
	        tickCtx.fillStyle = trackTicksStyle.color || 'black';
	
	        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));
	
	        tickCtx.fillRect(vertical ? 0 : distance - 1,
	          vertical ? distance - 1 : 0,
	          vertical ? dimensions.width : 2,
	          vertical ? 2 : dimensions.height);
	      }
	    }
	
	    function clearTicks() {
	      if(tickCanvas && tickCtx) {
	        var dimensions = getSliderDimensions();
	        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
	      }
	    }
	
	    /**
	     * Refreshing Dimensions
	     */
	    var sliderDimensions = {};
	    refreshSliderDimensions();
	    function refreshSliderDimensions() {
	      sliderDimensions = trackContainer[0].getBoundingClientRect();
	    }
	    function getSliderDimensions() {
	      throttledRefreshDimensions();
	      return sliderDimensions;
	    }
	
	    /**
	     * left/right/up/down arrow listener
	     */
	    function keydownListener(ev) {
	      if (isDisabled()) return;
	
	      var changeAmount;
	      if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
	        changeAmount = -step;
	      } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
	        changeAmount = step;
	      }
	      changeAmount = invert ? -changeAmount : changeAmount;
	      if (changeAmount) {
	        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
	          changeAmount *= 4;
	        }
	        ev.preventDefault();
	        ev.stopPropagation();
	        scope.$evalAsync(function() {
	          setModelValue(ngModelCtrl.$viewValue + changeAmount);
	        });
	      }
	    }
	
	    function mouseDownListener() {
	      redrawTicks();
	
	      scope.mouseActive = true;
	      wrapper.removeClass('md-focused');
	
	      $timeout(function() {
	        scope.mouseActive = false;
	      }, 100);
	    }
	
	    function focusListener() {
	      if (scope.mouseActive === false) {
	        wrapper.addClass('md-focused');
	      }
	    }
	
	    function blurListener() {
	      wrapper.removeClass('md-focused');
	      element.removeClass('md-active');
	      clearTicks();
	    }
	
	    /**
	     * ngModel setters and validators
	     */
	    function setModelValue(value) {
	      ngModelCtrl.$setViewValue( minMaxValidator(stepValidator(value)) );
	    }
	    function ngModelRender() {
	      if (isNaN(ngModelCtrl.$viewValue)) {
	        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
	      }
	
	      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);
	
	      var percent = valueToPercent(ngModelCtrl.$viewValue);
	      scope.modelValue = ngModelCtrl.$viewValue;
	      element.attr('aria-valuenow', ngModelCtrl.$viewValue);
	      setSliderPercent(percent);
	      thumbText.text( ngModelCtrl.$viewValue );
	    }
	
	    function minMaxValidator(value, minValue, maxValue) {
	      if (angular.isNumber(value)) {
	        minValue = angular.isNumber(minValue) ? minValue : min;
	        maxValue = angular.isNumber(maxValue) ? maxValue : max;
	
	        return Math.max(minValue, Math.min(maxValue, value));
	      }
	    }
	
	    function stepValidator(value) {
	      if (angular.isNumber(value)) {
	        var formattedValue = (Math.round((value - min) / step) * step + min);
	        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));
	
	        if (containerCtrl && containerCtrl.fitInputWidthToTextLength){
	          $mdUtil.debounce(function () {
	            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
	          }, 100)();
	        }
	
	        return formattedValue;
	      }
	    }
	
	    /**
	     * @param percent 0-1
	     */
	    function setSliderPercent(percent) {
	
	      percent = clamp(percent);
	
	      var thumbPosition = (percent * 100) + '%';
	      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;
	
	      if (vertical) {
	        thumbContainer.css('bottom', thumbPosition);
	      }
	      else {
	        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
	      }
	
	      
	      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);
	
	      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
	      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
	    }
	
	    /**
	     * Slide listeners
	     */
	    var isDragging = false;
	
	    function onPressDown(ev) {
	      if (isDisabled()) return;
	
	      element.addClass('md-active');
	      element[0].focus();
	      refreshSliderDimensions();
	
	      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      scope.$apply(function() {
	        setModelValue( closestVal );
	        setSliderPercent( valueToPercent(closestVal));
	      });
	    }
	    function onPressUp(ev) {
	      if (isDisabled()) return;
	
	      element.removeClass('md-dragging');
	
	      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      scope.$apply(function() {
	        setModelValue(closestVal);
	        ngModelRender();
	      });
	    }
	    function onDragStart(ev) {
	      if (isDisabled()) return;
	      isDragging = true;
	
	      ev.stopPropagation();
	
	      element.addClass('md-dragging');
	      setSliderFromEvent(ev);
	    }
	    function onDrag(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      setSliderFromEvent(ev);
	    }
	    function onDragEnd(ev) {
	      if (!isDragging) return;
	      ev.stopPropagation();
	      isDragging = false;
	    }
	
	    function setSliderFromEvent(ev) {
	      // While panning discrete, update only the
	      // visual positioning but not the model value.
	      if ( discrete ) adjustThumbPosition( vertical ? ev.pointer.y : ev.pointer.x );
	      else            doSlide( vertical ? ev.pointer.y : ev.pointer.x );
	    }
	
	    /**
	     * Slide the UI by changing the model value
	     * @param x
	     */
	    function doSlide( x ) {
	      scope.$evalAsync( function() {
	        setModelValue( percentToValue( positionToPercent(x) ));
	      });
	    }
	
	    /**
	     * Slide the UI without changing the model (while dragging/panning)
	     * @param x
	     */
	    function adjustThumbPosition( x ) {
	      var exactVal = percentToValue( positionToPercent( x ));
	      var closestVal = minMaxValidator( stepValidator(exactVal) );
	      setSliderPercent( positionToPercent(x) );
	      thumbText.text( closestVal );
	    }
	
	    /**
	    * Clamps the value to be between 0 and 1.
	    * @param {number} value The value to clamp.
	    * @returns {number}
	    */
	    function clamp(value) {
	      return Math.max(0, Math.min(value || 0, 1));
	    }
	
	    /**
	     * Convert position on slider to percentage value of offset from beginning...
	     * @param position
	     * @returns {number}
	     */
	    function positionToPercent( position ) {
	      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
	      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
	      var calc = (position - offset) / size;
	
	      if (!vertical && $mdUtil.bidi() === 'rtl') {
	        calc = 1 - calc;
	      }
	
	      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
	    }
	
	    /**
	     * Convert percentage offset on slide to equivalent model value
	     * @param percent
	     * @returns {*}
	     */
	    function percentToValue( percent ) {
	      var adjustedPercent = invert ? (1 - percent) : percent;
	      return (min + adjustedPercent * (max - min));
	    }
	
	    function valueToPercent( val ) {
	      var percent = (val - min) / (max - min);
	      return invert ? (1 - percent) : percent;
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.sticky
	 * @description
	 * Sticky effects for md
	 *
	 */
	MdSticky.$inject = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
	angular
	  .module('material.components.sticky', [
	    'material.core',
	    'material.components.content'
	  ])
	  .factory('$mdSticky', MdSticky);
	
	/**
	 * @ngdoc service
	 * @name $mdSticky
	 * @module material.components.sticky
	 *
	 * @description
	 * The `$mdSticky`service provides a mixin to make elements sticky.
	 *
	 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will just
	 * use the native browser stickiness.
	 *
	 * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
	 * parameter, in the same scope as the actual element lives.
	 *
	 *
	 * <h3>Notes</h3>
	 * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
	 * you should compile the clone yourself using the plain template.<br/><br/>
	 * See the right usage below:
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickySelect', function($mdSticky, $compile) {
	 *       var SELECT_TEMPLATE =
	 *         '<md-select ng-model="selected">' +
	 *           '<md-option>Option 1</md-option>' +
	 *         '</md-select>';
	 *
	 *       return {
	 *         restrict: 'E',
	 *         replace: true,
	 *         template: SELECT_TEMPLATE,
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="js">
	 *   angular.module('myModule')
	 *     .directive('stickyText', function($mdSticky, $compile) {
	 *       return {
	 *         restrict: 'E',
	 *         template: '<span>Sticky Text</span>',
	 *         link: function(scope,element) {
	 *           $mdSticky(scope, element);
	 *         }
	 *       };
	 *     });
	 * </hljs>
	 *
	 * @returns A `$mdSticky` function that takes three arguments:
	 *   - `scope`
	 *   - `element`: The element that will be 'sticky'
	 *   - `elementClone`: A clone of the element, that will be shown
	 *     when the user starts scrolling past the original element.
	 *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
	 */
	function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {
	
	  var browserStickySupport = $mdUtil.checkStickySupport();
	
	  /**
	   * Registers an element as sticky, used internally by directives to register themselves
	   */
	  return function registerStickyElement(scope, element, stickyClone) {
	    var contentCtrl = element.controller('mdContent');
	    if (!contentCtrl) return;
	
	    if (browserStickySupport) {
	      element.css({
	        position: browserStickySupport,
	        top: 0,
	        'z-index': 2
	      });
	    } else {
	      var $$sticky = contentCtrl.$element.data('$$sticky');
	      if (!$$sticky) {
	        $$sticky = setupSticky(contentCtrl);
	        contentCtrl.$element.data('$$sticky', $$sticky);
	      }
	
	      // Compile our cloned element, when cloned in this service, into the given scope.
	      var cloneElement = stickyClone || $compile(element.clone())(scope);
	
	      var deregister = $$sticky.add(element, cloneElement);
	      scope.$on('$destroy', deregister);
	    }
	  };
	
	  function setupSticky(contentCtrl) {
	    var contentEl = contentCtrl.$element;
	
	    // Refresh elements is very expensive, so we use the debounced
	    // version when possible.
	    var debouncedRefreshElements = $$rAF.throttle(refreshElements);
	
	    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
	    // more reliable than `scroll` on android.
	    setupAugmentedScrollEvents(contentEl);
	    contentEl.on('$scrollstart', debouncedRefreshElements);
	    contentEl.on('$scroll', onScroll);
	
	    var self;
	    return self = {
	      prev: null,
	      current: null, //the currently stickied item
	      next: null,
	      items: [],
	      add: add,
	      refreshElements: refreshElements
	    };
	
	    /***************
	     * Public
	     ***************/
	    // Add an element and its sticky clone to this content's sticky collection
	    function add(element, stickyClone) {
	      stickyClone.addClass('md-sticky-clone');
	
	      var item = {
	        element: element,
	        clone: stickyClone
	      };
	      self.items.push(item);
	
	      $mdUtil.nextTick(function() {
	        contentEl.prepend(item.clone);
	      });
	
	      debouncedRefreshElements();
	
	      return function remove() {
	        self.items.forEach(function(item, index) {
	          if (item.element[0] === element[0]) {
	            self.items.splice(index, 1);
	            item.clone.remove();
	          }
	        });
	        debouncedRefreshElements();
	      };
	    }
	
	    function refreshElements() {
	      // Sort our collection of elements by their current position in the DOM.
	      // We need to do this because our elements' order of being added may not
	      // be the same as their order of display.
	      self.items.forEach(refreshPosition);
	      self.items = self.items.sort(function(a, b) {
	        return a.top < b.top ? -1 : 1;
	      });
	
	      // Find which item in the list should be active, 
	      // based upon the content's current scroll position
	      var item;
	      var currentScrollTop = contentEl.prop('scrollTop');
	      for (var i = self.items.length - 1; i >= 0; i--) {
	        if (currentScrollTop > self.items[i].top) {
	          item = self.items[i];
	          break;
	        }
	      }
	      setCurrentItem(item);
	    }
	
	    /***************
	     * Private
	     ***************/
	
	    // Find the `top` of an item relative to the content element,
	    // and also the height.
	    function refreshPosition(item) {
	      // Find the top of an item by adding to the offsetHeight until we reach the 
	      // content element.
	      var current = item.element[0];
	      item.top = 0;
	      item.left = 0;
	      item.right = 0;
	      while (current && current !== contentEl[0]) {
	        item.top += current.offsetTop;
	        item.left += current.offsetLeft;
	        if ( current.offsetParent ){
	          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft; //Compute offsetRight
	        }
	        current = current.offsetParent;
	      }
	      item.height = item.element.prop('offsetHeight');
	
	      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
	      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
	      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
	    }
	
	    // As we scroll, push in and select the correct sticky element.
	    function onScroll() {
	      var scrollTop = contentEl.prop('scrollTop');
	      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);
	
	      // Store the previous scroll so we know which direction we are scrolling
	      onScroll.prevScrollTop = scrollTop;
	
	      //
	      // AT TOP (not scrolling)
	      //
	      if (scrollTop === 0) {
	        // If we're at the top, just clear the current item and return
	        setCurrentItem(null);
	        return;
	      }
	
	      //
	      // SCROLLING DOWN (going towards the next item)
	      //
	      if (isScrollingDown) {
	
	        // If we've scrolled down past the next item's position, sticky it and return
	        if (self.next && self.next.top <= scrollTop) {
	          setCurrentItem(self.next);
	          return;
	        }
	
	        // If the next item is close to the current one, push the current one up out of the way
	        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
	          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
	          return;
	        }
	      }
	
	      //
	      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
	      //
	      if (!isScrollingDown) {
	
	        // If we've scrolled up past the previous item's position, sticky it and return
	        if (self.current && self.prev && scrollTop < self.current.top) {
	          setCurrentItem(self.prev);
	          return;
	        }
	
	        // If the next item is close to the current one, pull the current one down into view
	        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
	          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
	          return;
	        }
	      }
	
	      //
	      // Otherwise, just move the current item to the proper place (scrolling up or down)
	      //
	      if (self.current) {
	        translate(self.current, scrollTop);
	      }
	    }
	
	    function setCurrentItem(item) {
	      if (self.current === item) return;
	      // Deactivate currently active item
	      if (self.current) {
	        translate(self.current, null);
	        setStickyState(self.current, null);
	      }
	
	      // Activate new item if given
	      if (item) {
	        setStickyState(item, 'active');
	      }
	
	      self.current = item;
	      var index = self.items.indexOf(item);
	      // If index === -1, index + 1 = 0. It works out.
	      self.next = self.items[index + 1];
	      self.prev = self.items[index - 1];
	      setStickyState(self.next, 'next');
	      setStickyState(self.prev, 'prev');
	    }
	
	    function setStickyState(item, state) {
	      if (!item || item.state === state) return;
	      if (item.state) {
	        item.clone.attr('sticky-prev-state', item.state);
	        item.element.attr('sticky-prev-state', item.state);
	      }
	      item.clone.attr('sticky-state', state);
	      item.element.attr('sticky-state', state);
	      item.state = state;
	    }
	
	    function translate(item, amount) {
	      if (!item) return;
	      if (amount === null || amount === undefined) {
	        if (item.translateY) {
	          item.translateY = null;
	          item.clone.css($mdConstant.CSS.TRANSFORM, '');
	        }
	      } else {
	        item.translateY = amount;
	
	        $mdUtil.bidi( item.clone, $mdConstant.CSS.TRANSFORM,
	          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
	          'translateY(' + amount + 'px)'
	        );
	      }
	    }
	  }
	
	
	  // Android 4.4 don't accurately give scroll events.
	  // To fix this problem, we setup a fake scroll event. We say:
	  // > If a scroll or touchmove event has happened in the last DELAY milliseconds, 
	  //   then send a `$scroll` event every animationFrame.
	  // Additionally, we add $scrollstart and $scrollend events.
	  function setupAugmentedScrollEvents(element) {
	    var SCROLL_END_DELAY = 200;
	    var isScrolling;
	    var lastScrollTime;
	    element.on('scroll touchmove', function() {
	      if (!isScrolling) {
	        isScrolling = true;
	        $$rAF.throttle(loopScrollEvent);
	        element.triggerHandler('$scrollstart');
	      }
	      element.triggerHandler('$scroll');
	      lastScrollTime = +$mdUtil.now();
	    });
	
	    function loopScrollEvent() {
	      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
	        isScrolling = false;
	        element.triggerHandler('$scrollend');
	      } else {
	        element.triggerHandler('$scroll');
	        $$rAF.throttle(loopScrollEvent);
	      }
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.subheader
	 * @description
	 * SubHeader module
	 *
	 *  Subheaders are special list tiles that delineate distinct sections of a
	 *  list or grid list and are typically related to the current filtering or
	 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
	 *  can be associated with content, for example, in an adjacent column.
	 *
	 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
	 *  pinned until pushed on or off screen by the next subheader. @see [Material
	 *  Design Specifications](https://www.google.com/design/spec/components/subheaders.html)
	 *
	 *  > To improve the visual grouping of content, use the system color for your subheaders.
	 *
	 */
	MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil", "$mdAria"];
	angular
	  .module('material.components.subheader', [
	    'material.core',
	    'material.components.sticky'
	  ])
	  .directive('mdSubheader', MdSubheaderDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdSubheader
	 * @module material.components.subheader
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-subheader` directive creates a sticky subheader for a section.
	 *
	 * Developers are able to disable the stickiness of the subheader by using the following markup
	 *
	 * <hljs lang="html">
	 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
	 * </hljs>
	 *
	 * ### Notes
	 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
	 * to make the subheader sticky.
	 *
	 * > Whenever the current browser doesn't support stickiness natively, the subheader
	 * will be compiled twice to create a sticky clone of the subheader.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-subheader>Online Friends</md-subheader>
	 * </hljs>
	 */
	
	function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil, $mdAria) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    template: (
	    '<div class="md-subheader _md">' +
	    '  <div class="md-subheader-inner">' +
	    '    <div class="md-subheader-content"></div>' +
	    '  </div>' +
	    '</div>'
	    ),
	    link: function postLink(scope, element, attr, controllers, transclude) {
	      $mdTheming(element);
	      element.addClass('_md');
	
	      // Remove the ngRepeat attribute from the root element, because we don't want to compile
	      // the ngRepeat for the sticky clone again.
	      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');
	
	      var outerHTML = element[0].outerHTML;
	
	      function getContent(el) {
	        return angular.element(el[0].querySelector('.md-subheader-content'));
	      }
	
	      // Set the ARIA attributes on the original element since it keeps it's original place in
	      // the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
	      // in order to avoid having multiple element be marked as headers.
	      attr.$set('role', 'heading');
	      $mdAria.expect(element, 'aria-level', '2');
	
	      // Transclude the user-given contents of the subheader
	      // the conventional way.
	      transclude(scope, function(clone) {
	        getContent(element).append(clone);
	      });
	
	      // Create another clone, that uses the outer and inner contents
	      // of the element, that will be 'stickied' as the user scrolls.
	      if (!element.hasClass('md-no-sticky')) {
	        transclude(scope, function(clone) {
	          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
	          // compiled clone below will only be a comment tag (since they replace their elements with
	          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
	          // DIV to ensure we have something $mdSticky can use
	          var wrapper = $compile('<div class="md-subheader-wrapper" aria-hidden="true">' + outerHTML + '</div>')(scope);
	
	          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
	          // attempting to create the clone
	          $mdUtil.nextTick(function() {
	            // Append our transcluded clone into the wrapper.
	            // We don't have to recompile the element again, because the clone is already
	            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
	            // our ngIf's and other previous registered bindings / properties.
	            getContent(wrapper).append(clone);
	          });
	
	          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
	          // element.
	          $mdSticky(scope, element, wrapper);
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.switch
	 */
	
	MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
	angular.module('material.components.switch', [
	  'material.core',
	  'material.components.checkbox'
	])
	  .directive('mdSwitch', MdSwitch);
	
	/**
	 * @ngdoc directive
	 * @module material.components.switch
	 * @name mdSwitch
	 * @restrict E
	 *
	 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
	 *
	 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
	 * the switch is in the accent color by default. The primary color palette may be used with
	 * the `md-primary` class.
	 *
	 * @param {string} ng-model Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
	 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
	 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user interaction with the input element.
	 * @param {expression=} ng-disabled En/Disable based on the expression.
	 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
	 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
	 * @param {boolean=} md-invert When set to true, the switch will be inverted.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-switch ng-model="isActive" aria-label="Finished?">
	 *   Finished ?
	 * </md-switch>
	 *
	 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
	 *   No Ink Effects
	 * </md-switch>
	 *
	 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
	 *   Disabled
	 * </md-switch>
	 *
	 * </hljs>
	 */
	function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
	  var checkboxDirective = mdCheckboxDirective[0];
	
	  return {
	    restrict: 'E',
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    transclude: true,
	    template:
	      '<div class="md-container">' +
	        '<div class="md-bar"></div>' +
	        '<div class="md-thumb-container">' +
	          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
	        '</div>'+
	      '</div>' +
	      '<div ng-transclude class="md-label"></div>',
	    require: ['^?mdInputContainer', '?ngModel', '?^form'],
	    compile: mdSwitchCompile
	  };
	
	  function mdSwitchCompile(element, attr) {
	    var checkboxLink = checkboxDirective.compile(element, attr).post;
	    // No transition on initial load.
	    element.addClass('md-dragging');
	
	    return function (scope, element, attr, ctrls) {
	      var containerCtrl = ctrls[0];
	      var ngModel = ctrls[1] || $mdUtil.fakeNgModel();
	      var formCtrl = ctrls[2];
	
	      var disabledGetter = null;
	      if (attr.disabled != null) {
	        disabledGetter = function() { return true; };
	      } else if (attr.ngDisabled) {
	        disabledGetter = $parse(attr.ngDisabled);
	      }
	
	      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
	      var switchContainer = angular.element(element[0].querySelector('.md-container'));
	      var labelContainer = angular.element(element[0].querySelector('.md-label'));
	
	      // no transition on initial load
	      $$rAF(function() {
	        element.removeClass('md-dragging');
	      });
	
	      checkboxLink(scope, element, attr, ctrls);
	
	      if (disabledGetter) {
	        scope.$watch(disabledGetter, function(isDisabled) {
	          element.attr('tabindex', isDisabled ? -1 : 0);
	        });
	      }
	
	      attr.$observe('mdInvert', function(newValue) {
	        var isInverted = $mdUtil.parseAttributeBoolean(newValue);
	
	        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);
	
	        // Toggle a CSS class to update the margin.
	        element.toggleClass('md-inverted', isInverted);
	      });
	
	      // These events are triggered by setup drag
	      $mdGesture.register(switchContainer, 'drag');
	      switchContainer
	        .on('$md.dragstart', onDragStart)
	        .on('$md.drag', onDrag)
	        .on('$md.dragend', onDragEnd);
	
	      var drag;
	      function onDragStart(ev) {
	        // Don't go if the switch is disabled.
	        if (disabledGetter && disabledGetter(scope)) return;
	        ev.stopPropagation();
	
	        element.addClass('md-dragging');
	        drag = {width: thumbContainer.prop('offsetWidth')};
	      }
	
	      function onDrag(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	        ev.srcEvent && ev.srcEvent.preventDefault();
	
	        var percent = ev.pointer.distanceX / drag.width;
	
	        //if checked, start from right. else, start from left
	        var translate = ngModel.$viewValue ?  1 + percent : percent;
	        // Make sure the switch stays inside its bounds, 0-1%
	        translate = Math.max(0, Math.min(1, translate));
	
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
	        drag.translate = translate;
	      }
	
	      function onDragEnd(ev) {
	        if (!drag) return;
	        ev.stopPropagation();
	
	        element.removeClass('md-dragging');
	        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');
	
	        // We changed if there is no distance (this is a click a click),
	        // or if the drag distance is >50% of the total.
	        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
	        if (isChanged) {
	          applyModelValue(!ngModel.$viewValue);
	        }
	        drag = null;
	
	        // Wait for incoming mouse click
	        scope.skipToggle = true;
	        $timeout(function() {
	          scope.skipToggle = false;
	        }, 1);
	      }
	
	      function applyModelValue(newValue) {
	        scope.$apply(function() {
	          ngModel.$setViewValue(newValue);
	          ngModel.$render();
	        });
	      }
	
	    };
	  }
	
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.swipe
	 * @description Swipe module!
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeLeft
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
	 * left.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-left="onSwipeLeft()">Swipe me left!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeRight
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
	 * right.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-right="onSwipeRight()">Swipe me right!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeUp
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
	 * up.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-up="onSwipeUp()">Swipe me up!</div>
	 * </hljs>
	 */
	/**
	 * @ngdoc directive
	 * @module material.components.swipe
	 * @name mdSwipeDown
	 *
	 * @restrict A
	 *
	 * @description
	 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
	 * down.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div md-swipe-down="onSwipDown()">Swipe me down!</div>
	 * </hljs>
	 */
	
	angular.module('material.components.swipe', ['material.core'])
	    .directive('mdSwipeLeft', getDirective('SwipeLeft'))
	    .directive('mdSwipeRight', getDirective('SwipeRight'))
	    .directive('mdSwipeUp', getDirective('SwipeUp'))
	    .directive('mdSwipeDown', getDirective('SwipeDown'));
	
	function getDirective(name) {
	    DirectiveFactory.$inject = ["$parse"];
	  var directiveName = 'md' + name;
	  var eventName = '$md.' + name.toLowerCase();
	
	  return DirectiveFactory;
	
	  /* @ngInject */
	  function DirectiveFactory($parse) {
	      return {restrict: 'A', link: postLink};
	
	    function postLink(scope, element, attr) {
	        element.css('touch-action', attr['mdSwipeTouchAction'] || 'none');
	
	        var fn = $parse(attr[directiveName]);
	        element.on(eventName, function(ev) {
	          scope.$applyAsync(function() { fn(scope, { $event: ev }); });
	        });
	      }
	    }
	}
	
	
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tabs
	 * @description
	 *
	 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
	 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
	 *
	 *  Features include support for:
	 *
	 *  - static or dynamic tabs,
	 *  - responsive designs,
	 *  - accessibility support (ARIA),
	 *  - tab pagination,
	 *  - external or internal tab content,
	 *  - focus indicators and arrow-key navigations,
	 *  - programmatic lookup and access to tab controllers, and
	 *  - dynamic transitions through different tab contents.
	 *
	 */
	/*
	 * @see js folder for tabs implementation
	 */
	angular.module('material.components.tabs', [
	  'material.core',
	  'material.components.icon'
	]);
	
	})();
	(function(){
	"use strict";
	
	/**
	  * @ngdoc module
	  * @name material.components.toast
	  * @description
	  * Toast
	  */
	MdToastDirective.$inject = ["$mdToast"];
	MdToastProvider.$inject = ["$$interimElementProvider"];
	angular.module('material.components.toast', [
	  'material.core',
	  'material.components.button'
	])
	  .directive('mdToast', MdToastDirective)
	  .provider('$mdToast', MdToastProvider);
	
	/* @ngInject */
	function MdToastDirective($mdToast) {
	  return {
	    restrict: 'E',
	    link: function postLink(scope, element) {
	      element.addClass('_md');     // private md component indicator for styling
	      
	      // When navigation force destroys an interimElement, then
	      // listen and $destroy() that interim instance...
	      scope.$on('$destroy', function() {
	        $mdToast.destroy();
	      });
	    }
	  };
	}
	
	/**
	  * @ngdoc service
	  * @name $mdToast
	  * @module material.components.toast
	  *
	  * @description
	  * `$mdToast` is a service to build a toast notification on any position
	  * on the screen with an optional duration, and provides a simple promise API.
	  *
	  * The toast will be always positioned at the `bottom`, when the screen size is
	  * between `600px` and `959px` (`sm` breakpoint)
	  *
	  * ## Restrictions on custom toasts
	  * - The toast's template must have an outer `<md-toast>` element.
	  * - For a toast action, use element with class `md-action`.
	  * - Add the class `md-capsule` for curved corners.
	  *
	  * ### Custom Presets
	  * Developers are also able to create their own preset, which can be easily used without repeating
	  * their options each time.
	  *
	  * <hljs lang="js">
	  *   $mdToastProvider.addPreset('testPreset', {
	  *     options: function() {
	  *       return {
	  *         template:
	  *           '<md-toast>' +
	  *             '<div class="md-toast-content">' +
	  *               'This is a custom preset' +
	  *             '</div>' +
	  *           '</md-toast>',
	  *         controllerAs: 'toast',
	  *         bindToController: true
	  *       };
	  *     }
	  *   });
	  * </hljs>
	  *
	  * After you created your preset at config phase, you can easily access it.
	  *
	  * <hljs lang="js">
	  *   $mdToast.show(
	  *     $mdToast.testPreset()
	  *   );
	  * </hljs>
	  *
	  * ## Parent container notes
	  *
	  * The toast is positioned using absolute positioning relative to its first non-static parent
	  * container. Thus, if the requested parent container uses static positioning, we will temporarily
	  * set its positioning to `relative` while the toast is visible and reset it when the toast is
	  * hidden.
	  *
	  * Because of this, it is usually best to ensure that the parent container has a fixed height and
	  * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
	  * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
	  *
	  * You can, however, have a scrollable element inside of the container; just make sure the
	  * container itself does not scroll.
	  *
	  * <hljs lang="html">
	  * <div layout-fill id="toast-container">
	  *   <md-content>
	  *     I can have lots of content and scroll!
	  *   </md-content>
	  * </div>
	  * </hljs>
	  *
	  * @usage
	  * <hljs lang="html">
	  * <div ng-controller="MyController">
	  *   <md-button ng-click="openToast()">
	  *     Open a Toast!
	  *   </md-button>
	  * </div>
	  * </hljs>
	  *
	  * <hljs lang="js">
	  * var app = angular.module('app', ['ngMaterial']);
	  * app.controller('MyController', function($scope, $mdToast) {
	  *   $scope.openToast = function($event) {
	  *     $mdToast.show($mdToast.simple().textContent('Hello!'));
	  *     // Could also do $mdToast.showSimple('Hello');
	  *   };
	  * });
	  * </hljs>
	  */
	
	/**
	 * @ngdoc method
	 * @name $mdToast#showSimple
	 * 
	 * @param {string} message The message to display inside the toast
	 * @description
	 * Convenience method which builds and shows a simple toast.
	 *
	 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	 * rejected with `$mdToast.cancel()`.
	 *
	 */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#simple
	  *
	  * @description
	  * Builds a preconfigured toast.
	  *
	  * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
	  *
	  * _**Note:** These configuration methods are provided in addition to the methods provided by
	  * the `build()` and `show()` methods below._
	  *
	  * <table class="md-api-table methods">
	  *    <thead>
	  *      <tr>
	  *        <th>Method</th>
	  *        <th>Description</th>
	  *      </tr>
	  *    </thead>
	  *    <tbody>
	  *      <tr>
	  *        <td>`.textContent(string)`</td>
	  *        <td>Sets the toast content to the specified string</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.action(string)`</td>
	  *        <td>
	  *          Adds an action button. <br/>
	  *          If clicked, the promise (returned from `show()`)
	  *          will resolve with the value `'ok'`; otherwise, it is resolved with `true` after a `hideDelay`
	  *          timeout
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightAction(boolean)`</td>
	  *        <td>
	  *          Whether or not the action button will have an additional highlight class.<br/>
	  *          By default the `accent` color will be applied to the action button.
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.highlightClass(string)`</td>
	  *        <td>
	  *          If set, the given class will be applied to the highlighted action button.<br/>
	  *          This allows you to specify the highlight color easily. Highlight classes are `md-primary`, `md-warn`
	  *          and `md-accent`
	  *        </td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.capsule(boolean)`</td>
	  *        <td>Whether or not to add the `md-capsule` class to the toast to provide rounded corners</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.theme(string)`</td>
	  *        <td>Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s default.</td>
	  *      </tr>
	  *      <tr>
	  *        <td>`.toastClass(string)`</td>
	  *        <td>Sets a class on the toast element</td>
	  *      </tr>
	  *    </tbody>
	  * </table>
	  *
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#updateTextContent
	  *
	  * @description
	  * Updates the content of an existing toast. Useful for updating things like counts, etc.
	  *
	  */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#build
	  *
	  * @description
	  * Creates a custom `$mdToastPreset` that you can configure.
	  *
	  * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options (see below).
	  */
	
	 /**
	  * @ngdoc method
	  * @name $mdToast#show
	  *
	  * @description Shows the toast.
	  *
	  * @param {object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
	  * and `build()`, or an options object with the following properties:
	  *
	  *   - `templateUrl` - `{string=}`: The url of an html template file that will
	  *     be used as the content of the toast. Restrictions: the template must
	  *     have an outer `md-toast` element.
	  *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
	  *     template string.
	  *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
	  *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled if you provide a
	  *     custom toast directive.
	  *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
	  *     This scope will be destroyed when the toast is removed unless `preserveScope` is set to true.
	  *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
	  *   - `hideDelay` - `{number=}`: How many milliseconds the toast should stay
	  *     active before automatically closing.  Set to 0 or false to have the toast stay open until
	  *     closed manually. Default: 3000.
	  *   - `position` - `{string=}`: Sets the position of the toast. <br/>
	  *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'` and `'start'`.
	  *     The properties `'end'` and `'start'` are dynamic and can be used for RTL support.<br/>
	  *     Default combination: `'bottom left'`.
	  *   - `toastClass` - `{string=}`: A class to set on the toast element.
	  *   - `controller` - `{string=}`: The controller to associate with this toast.
	  *     The controller will be injected the local `$mdToast.hide( )`, which is a function
	  *     used to hide the toast.
	  *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
	  *     be used as names of values to inject into the controller. For example,
	  *     `locals: {three: 3}` would inject `three` into the controller with the value
	  *     of 3.
	  *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
	  *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
	  *     and the toast will not open until the promises resolve.
	  *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
	  *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
	  *     to the root element of the application.
	  *
	  * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
	  * rejected with `$mdToast.cancel()`. `$mdToast.hide()` will resolve either with a Boolean
	  * value == 'true' or the value passed as an argument to `$mdToast.hide()`.
	  * And `$mdToast.cancel()` will resolve the promise with a Boolean value == 'false'
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#hide
	  *
	  * @description
	  * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the resolved promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM.
	  * The promise is resolved with either a Boolean value == 'true' or the value passed as the
	  * argument to `.hide()`.
	  *
	  */
	
	/**
	  * @ngdoc method
	  * @name $mdToast#cancel
	  *
	  * @description
	  * `DEPRECATED` - The promise returned from opening a toast is used only to notify about the closing of the toast.
	  * As such, there isn't any reason to also allow that promise to be rejected,
	  * since it's not clear what the difference between resolve and reject would be.
	  *
	  * Hide the existing toast and reject the promise returned from
	  * `$mdToast.show()`.
	  *
	  * @param {*=} response An argument for the rejected promise.
	  *
	  * @returns {promise} a promise that is called when the existing element is removed from the DOM
	  * The promise is resolved with a Boolean value == 'false'.
	  *
	  */
	
	function MdToastProvider($$interimElementProvider) {
	  // Differentiate promise resolves: hide timeout (value == true) and hide action clicks (value == ok).
	  toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia"];
	  var ACTION_RESOLVE = 'ok';
	
	  var activeToastContent;
	  var $mdToast = $$interimElementProvider('$mdToast')
	    .setDefaults({
	      methods: ['position', 'hideDelay', 'capsule', 'parent', 'position', 'toastClass'],
	      options: toastDefaultOptions
	    })
	    .addPreset('simple', {
	      argOption: 'textContent',
	      methods: ['textContent', 'content', 'action', 'highlightAction', 'highlightClass', 'theme', 'parent' ],
	      options: /* @ngInject */ ["$mdToast", "$mdTheming", function($mdToast, $mdTheming) {
	        return {
	          template:
	            '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
	            '  <div class="md-toast-content">' +
	            '    <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">' +
	            '      {{ toast.content }}' +
	            '    </span>' +
	            '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
	            '        ng-class="highlightClasses">' +
	            '      {{ toast.action }}' +
	            '    </md-button>' +
	            '  </div>' +
	            '</md-toast>',
	          controller: /* @ngInject */ ["$scope", function mdToastCtrl($scope) {
	            var self = this;
	
	            if (self.highlightAction) {
	              $scope.highlightClasses = [
	                'md-highlight',
	                self.highlightClass
	              ]
	            }
	
	            $scope.$watch(function() { return activeToastContent; }, function() {
	              self.content = activeToastContent;
	            });
	
	            this.resolve = function() {
	              $mdToast.hide( ACTION_RESOLVE );
	            };
	          }],
	          theme: $mdTheming.defaultTheme(),
	          controllerAs: 'toast',
	          bindToController: true
	        };
	      }]
	    })
	    .addMethod('updateTextContent', updateTextContent)
	    .addMethod('updateContent', updateTextContent);
	
	    function updateTextContent(newContent) {
	      activeToastContent = newContent;
	    }
	
	    return $mdToast;
	
	  /* @ngInject */
	  function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia) {
	    var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
	    return {
	      onShow: onShow,
	      onRemove: onRemove,
	      toastClass: '',
	      position: 'bottom left',
	      themable: true,
	      hideDelay: 3000,
	      autoWrap: true,
	      transformTemplate: function(template, options) {
	        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);
	
	        if (shouldAddWrapper) {
	          // Root element of template will be <md-toast>. We need to wrap all of its content inside of
	          // of <div class="md-toast-content">. All templates provided here should be static, developer-controlled
	          // content (meaning we're not attempting to guard against XSS).
	          var templateRoot = document.createElement('md-template');
	          templateRoot.innerHTML = template;
	
	          // Iterate through all root children, to detect possible md-toast directives.
	          for (var i = 0; i < templateRoot.children.length; i++) {
	            if (templateRoot.children[i].nodeName === 'MD-TOAST') {
	              var wrapper = angular.element('<div class="md-toast-content">');
	
	              // Wrap the children of the `md-toast` directive in jqLite, to be able to append multiple
	              // nodes with the same execution.
	              wrapper.append(angular.element(templateRoot.children[i].childNodes));
	
	              // Append the new wrapped element to the `md-toast` directive.
	              templateRoot.children[i].appendChild(wrapper[0]);
	            }
	          }
	
	          // We have to return the innerHTMl, because we do not want to have the `md-template` element to be
	          // the root element of our interimElement.
	          return templateRoot.innerHTML;
	        }
	
	        return template || '';
	      }
	    };
	
	    function onShow(scope, element, options) {
	      activeToastContent = options.textContent || options.content; // support deprecated #content method
	
	      var isSmScreen = !$mdMedia('gt-sm');
	
	      element = $mdUtil.extractElementByName(element, 'md-toast', true);
	      options.element = element;
	
	      options.onSwipe = function(ev, gesture) {
	        //Add the relevant swipe class to the element so it can animate correctly
	        var swipe = ev.type.replace('$md.','');
	        var direction = swipe.replace('swipe', '');
	
	        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
	        // Unless the screen is small, then the toast always on bottom
	        if ((direction === 'down' && options.position.indexOf('top') != -1 && !isSmScreen) ||
	            (direction === 'up' && (options.position.indexOf('bottom') != -1 || isSmScreen))) {
	          return;
	        }
	
	        if ((direction === 'left' || direction === 'right') && isSmScreen) {
	          return;
	        }
	
	        element.addClass('md-' + swipe);
	        $mdUtil.nextTick($mdToast.cancel);
	      };
	      options.openClass = toastOpenClass(options.position);
	
	      element.addClass(options.toastClass);
	
	      // 'top left' -> 'md-top md-left'
	      options.parent.addClass(options.openClass);
	
	      // static is the default position
	      if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	        options.parent.css('position', 'relative');
	      }
	
	      element.on(SWIPE_EVENTS, options.onSwipe);
	      element.addClass(isSmScreen ? 'md-bottom' : options.position.split(' ').map(function(pos) {
	        return 'md-' + pos;
	      }).join(' '));
	
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      return $animate.enter(element, options.parent).then(function() {
	        if (options.parent) options.parent.removeClass('md-toast-animating');
	      });
	    }
	
	    function onRemove(scope, element, options) {
	      element.off(SWIPE_EVENTS, options.onSwipe);
	      if (options.parent) options.parent.addClass('md-toast-animating');
	      if (options.openClass) options.parent.removeClass(options.openClass);
	
	      return ((options.$destroy == true) ? element.remove() : $animate.leave(element))
	        .then(function () {
	          if (options.parent) options.parent.removeClass('md-toast-animating');
	          if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
	            options.parent.css('position', '');
	          }
	        });
	    }
	
	    function toastOpenClass(position) {
	      // For mobile, always open full-width on bottom
	      if (!$mdMedia('gt-xs')) {
	        return 'md-toast-open-bottom';
	      }
	
	      return 'md-toast-open-' +
	        (position.indexOf('top') > -1 ? 'top' : 'bottom');
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.toolbar
	 */
	mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate"];
	angular.module('material.components.toolbar', [
	  'material.core',
	  'material.components.content'
	])
	  .directive('mdToolbar', mdToolbarDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdToolbar
	 * @module material.components.toolbar
	 * @restrict E
	 * @description
	 * `md-toolbar` is used to place a toolbar in your app.
	 *
	 * Toolbars are usually used above a content area to display the title of the
	 * current page, and show relevant action buttons for that page.
	 *
	 * You can change the height of the toolbar by adding either the
	 * `md-medium-tall` or `md-tall` class to the toolbar.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <div layout="column" layout-fill>
	 *   <md-toolbar>
	 *
	 *     <div class="md-toolbar-tools">
	 *       <h2 md-truncate flex>My App's Title</h2>
	 *
	 *       <md-button>
	 *         Right Bar Button
	 *       </md-button>
	 *     </div>
	 *
	 *   </md-toolbar>
	 *   <md-content>
	 *     Hello!
	 *   </md-content>
	 * </div>
	 * </hljs>
	 *
	 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
	 * ellipsis if the title is longer than the width of the Toolbar.</i>
	 *
	 * ## CSS & Styles
	 *
	 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
	 * functionality of your toolbar.
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
	 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
	 *     buttons and text. When applied, it will center the buttons and text vertically for you.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 *
	 * ### Private Classes
	 *
	 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
	 * considered public.
	 *
	 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
	 * the user scrolls down, and reveal itself as the user scrolls up.
	 *
	 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
	 * `md-content` element, placed before it. See the scroll shrink demo._
	 *
	 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
	 * initialization, it does not watch for scope changes._
	 *
	 *
	 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
	 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
	 * at one fourth the rate at which the user scrolls down. Default 0.5.
	 *
	 */
	
	function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate) {
	  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');
	
	  return {
	    template: '',
	    restrict: 'E',
	
	    link: function(scope, element, attr) {
	
	      element.addClass('_md');     // private md component indicator for styling
	      $mdTheming(element);
	
	      $mdUtil.nextTick(function () {
	        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
	      }, false);
	
	      if (angular.isDefined(attr.mdScrollShrink)) {
	        setupScrollShrink();
	      }
	
	      function setupScrollShrink() {
	
	        var toolbarHeight;
	        var contentElement;
	        var disableScrollShrink = angular.noop;
	
	        // Current "y" position of scroll
	        // Store the last scroll top position
	        var y = 0;
	        var prevScrollTop = 0;
	        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;
	
	        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
	        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);
	
	        // Wait for $mdContentLoaded event from mdContent directive.
	        // If the mdContent element is a sibling of our toolbar, hook it up
	        // to scroll events.
	
	        scope.$on('$mdContentLoaded', onMdContentLoad);
	
	        // If the toolbar is used inside an ng-if statement, we may miss the
	        // $mdContentLoaded event, so we attempt to fake it if we have a
	        // md-content close enough.
	
	        attr.$observe('mdScrollShrink', onChangeScrollShrink);
	
	        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
	        // and not wait for $mdUtil.debounce to happen
	
	        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
	        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }
	
	        // If the scope is destroyed (which could happen with ng-if), make sure
	        // to disable scroll shrinking again
	
	        scope.$on('$destroy', disableScrollShrink);
	
	        /**
	         *
	         */
	        function onChangeScrollShrink(shrinkWithScroll) {
	          var closestContent = element.parent().find('md-content');
	
	          // If we have a content element, fake the call; this might still fail
	          // if the content element isn't a sibling of the toolbar
	
	          if (!contentElement && closestContent.length) {
	            onMdContentLoad(null, closestContent);
	          }
	
	          // Evaluate the expression
	          shrinkWithScroll = scope.$eval(shrinkWithScroll);
	
	          // Disable only if the attribute's expression evaluates to false
	          if (shrinkWithScroll === false) {
	            disableScrollShrink();
	          } else {
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onMdContentLoad($event, newContentEl) {
	          // Toolbar and content must be siblings
	          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
	            // unhook old content event listener if exists
	            if (contentElement) {
	              contentElement.off('scroll', debouncedContentScroll);
	            }
	
	            contentElement = newContentEl;
	            disableScrollShrink = enableScrollShrink();
	          }
	        }
	
	        /**
	         *
	         */
	        function onContentScroll(e) {
	          var scrollTop = e ? e.target.scrollTop : prevScrollTop;
	
	          debouncedUpdateHeight();
	
	          y = Math.min(
	            toolbarHeight / shrinkSpeedFactor,
	            Math.max(0, y + scrollTop - prevScrollTop)
	          );
	
	          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
	          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));
	
	          prevScrollTop = scrollTop;
	
	          $mdUtil.nextTick(function() {
	            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');
	
	            if (hasWhiteFrame && !y) {
	              $animate.removeClass(element, 'md-whiteframe-z1');
	            } else if (!hasWhiteFrame && y) {
	              $animate.addClass(element, 'md-whiteframe-z1');
	            }
	          });
	
	        }
	
	        /**
	         *
	         */
	        function enableScrollShrink() {
	          if (!contentElement)     return angular.noop;           // no md-content
	
	          contentElement.on('scroll', debouncedContentScroll);
	          contentElement.attr('scroll-shrink', 'true');
	
	          $mdUtil.nextTick(updateToolbarHeight, false);
	
	          return function disableScrollShrink() {
	            contentElement.off('scroll', debouncedContentScroll);
	            contentElement.attr('scroll-shrink', 'false');
	
	            updateToolbarHeight();
	          };
	        }
	
	        /**
	         *
	         */
	        function updateToolbarHeight() {
	          toolbarHeight = element.prop('offsetHeight');
	          // Add a negative margin-top the size of the toolbar to the content el.
	          // The content will start transformed down the toolbarHeight amount,
	          // so everything looks normal.
	          //
	          // As the user scrolls down, the content will be transformed up slowly
	          // to put the content underneath where the toolbar was.
	          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';
	
	          contentElement.css({
	            "margin-top": margin,
	            "margin-bottom": margin
	          });
	
	          onContentScroll();
	        }
	
	      }
	
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.tooltip
	 */
	MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$interpolate", "$mdUtil", "$mdPanel", "$$mdTooltipRegistry"];
	angular
	    .module('material.components.tooltip', [
	      'material.core',
	      'material.components.panel'
	    ])
	    .directive('mdTooltip', MdTooltipDirective)
	    .service('$$mdTooltipRegistry', MdTooltipRegistry);
	
	
	/**
	 * @ngdoc directive
	 * @name mdTooltip
	 * @module material.components.tooltip
	 * @description
	 * Tooltips are used to describe elements that are interactive and primarily
	 * graphical (not textual).
	 *
	 * Place a `<md-tooltip>` as a child of the element it describes.
	 *
	 * A tooltip will activate when the user hovers over, focuses, or touches the
	 * parent element.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-button class="md-fab md-accent" aria-label="Play">
	 *     <md-tooltip>Play Music</md-tooltip>
	 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
	 *   </md-button>
	 * </hljs>
	 *
	 * @param {number=} md-z-index The visual level that the tooltip will appear
	 *     in comparison with the rest of the elements of the application.
	 * @param {expression=} md-visible Boolean bound to whether the tooltip is
	 *     currently visible.
	 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
	 *     after the user hovers over, focuses, or touches the parent element.
	 *     Defaults to 0ms on non-touch devices and 75ms on touch.
	 * @param {boolean=} md-autohide If present or provided with a boolean value,
	 *     the tooltip will hide on mouse leave, regardless of focus.
	 * @param {string=} md-direction The direction that the tooltip is shown,
	 *     relative to the parent element. Supports top, right, bottom, and left.
	 *     Defaults to bottom.
	 */
	function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
	    $mdUtil, $mdPanel, $$mdTooltipRegistry) {
	
	  var ENTER_EVENTS = 'focus touchstart mouseenter';
	  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
	  var TOOLTIP_DEFAULT_Z_INDEX = 100;
	  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
	  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
	  var TOOLTIP_DIRECTIONS = {
	    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
	    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
	    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
	    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 210, // Before ngAria
	    scope: {
	      mdZIndex: '=?mdZIndex',
	      mdDelay: '=?mdDelay',
	      mdVisible: '=?mdVisible',
	      mdAutohide: '=?mdAutohide',
	      mdDirection: '@?mdDirection' // Do not expect expressions.
	    },
	    link: linkFunc
	  };
	
	  function linkFunc(scope, element, attr) {
	    // Set constants.
	    var tooltipId = 'md-tooltip-' + $mdUtil.nextUid();
	    var parent = $mdUtil.getParentWithPointerEvents(element);
	    var debouncedOnResize = $$rAF.throttle(updatePosition);
	    var mouseActive = false;
	    var origin, position, panelPosition, panelRef, autohide, showTimeout,
	        elementFocusedOnWindowBlur = null;
	
	    // Set defaults
	    setDefaults();
	
	    // Set parent aria-label.
	    addAriaLabel();
	
	    // Remove the element from its current DOM position.
	    element.detach();
	
	    updatePosition();
	    bindEvents();
	    configureWatchers();
	
	    function setDefaults() {
	      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
	      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
	      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
	        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
	      }
	    }
	
	    function addAriaLabel(labelText) {
	      // Only interpolate the text from the HTML element because otherwise the custom text could
	      // be interpolated twice and cause XSS violations.
	      var interpolatedText = labelText || $interpolate(element.text().trim())(scope.$parent);
	
	      // Only add the `aria-label` to the parent if there isn't already one, if there isn't an
	      // already present `aria-labelledby`, or if the previous `aria-label` was added by the
	      // tooltip directive.
	      if (
	        (!parent.attr('aria-label') && !parent.attr('aria-labelledby')) ||
	        parent.attr('md-labeled-by-tooltip')
	      ) {
	        parent.attr('aria-label', interpolatedText);
	
	        // Set the `md-labeled-by-tooltip` attribute if it has not already been set.
	        if (!parent.attr('md-labeled-by-tooltip')) {
	          parent.attr('md-labeled-by-tooltip', tooltipId);
	        }
	      }
	    }
	
	    function updatePosition() {
	      setDefaults();
	
	      // If the panel has already been created, remove the current origin
	      // class from the panel element.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.removeClass(origin);
	      }
	
	      // Set the panel element origin class based off of the current
	      // mdDirection.
	      origin = 'md-origin-' + scope.mdDirection;
	
	      // Create the position of the panel based off of the mdDirection.
	      position = TOOLTIP_DIRECTIONS[scope.mdDirection];
	
	      // Using the newly created position object, use the MdPanel
	      // panelPosition API to build the panel's position.
	      panelPosition = $mdPanel.newPanelPosition()
	          .relativeTo(parent)
	          .addPanelPosition(position.x, position.y);
	
	      // If the panel has already been created, add the new origin class to
	      // the panel element and update it's position with the panelPosition.
	      if (panelRef && panelRef.panelEl) {
	        panelRef.panelEl.addClass(origin);
	        panelRef.updatePosition(panelPosition);
	      }
	    }
	
	    function bindEvents() {
	      // Add a mutationObserver where there is support for it and the need
	      // for it in the form of viable host(parent[0]).
	      if (parent[0] && 'MutationObserver' in $window) {
	        // Use a mutationObserver to tackle #2602.
	        var attributeObserver = new MutationObserver(function(mutations) {
	          if (isDisabledMutation(mutations)) {
	            $mdUtil.nextTick(function() {
	              setVisible(false);
	            });
	          }
	        });
	
	        attributeObserver.observe(parent[0], {
	          attributes: true
	        });
	      }
	
	      elementFocusedOnWindowBlur = false;
	
	      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
	      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
	      $$mdTooltipRegistry.register('resize', debouncedOnResize);
	
	      scope.$on('$destroy', onDestroy);
	
	      // To avoid 'synthetic clicks', we listen to mousedown instead of
	      // 'click'.
	      parent.on('mousedown', mousedownEventHandler);
	      parent.on(ENTER_EVENTS, enterEventHandler);
	
	      function isDisabledMutation(mutations) {
	        mutations.some(function(mutation) {
	          return mutation.attributeName === 'disabled' && parent[0].disabled;
	        });
	        return false;
	      }
	
	      function windowScrollEventHandler() {
	        setVisible(false);
	      }
	
	      function windowBlurEventHandler() {
	        elementFocusedOnWindowBlur = document.activeElement === parent[0];
	      }
	
	      function enterEventHandler($event) {
	        // Prevent the tooltip from showing when the window is receiving
	        // focus.
	        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
	          elementFocusedOnWindowBlur = false;
	        } else if (!scope.mdVisible) {
	          parent.on(LEAVE_EVENTS, leaveEventHandler);
	          setVisible(true);
	
	          // If the user is on a touch device, we should bind the tap away
	          // after the 'touched' in order to prevent the tooltip being
	          // removed immediately.
	          if ($event.type === 'touchstart') {
	            parent.one('touchend', function() {
	              $mdUtil.nextTick(function() {
	                $document.one('touchend', leaveEventHandler);
	              }, false);
	            });
	          }
	        }
	      }
	
	      function leaveEventHandler() {
	        autohide = scope.hasOwnProperty('mdAutohide') ?
	            scope.mdAutohide :
	            attr.hasOwnProperty('mdAutohide');
	
	        if (autohide || mouseActive ||
	            $document[0].activeElement !== parent[0]) {
	          // When a show timeout is currently in progress, then we have
	          // to cancel it, otherwise the tooltip will remain showing
	          // without focus or hover.
	          if (showTimeout) {
	            $timeout.cancel(showTimeout);
	            setVisible.queued = false;
	            showTimeout = null;
	          }
	
	          parent.off(LEAVE_EVENTS, leaveEventHandler);
	          parent.triggerHandler('blur');
	          setVisible(false);
	        }
	        mouseActive = false;
	      }
	
	      function mousedownEventHandler() {
	        mouseActive = true;
	      }
	
	      function onDestroy() {
	        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
	        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
	        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);
	
	        parent
	            .off(ENTER_EVENTS, enterEventHandler)
	            .off(LEAVE_EVENTS, leaveEventHandler)
	            .off('mousedown', mousedownEventHandler);
	
	        // Trigger the handler in case any of the tooltips are
	        // still visible.
	        leaveEventHandler();
	        attributeObserver && attributeObserver.disconnect();
	      }
	    }
	
	    function configureWatchers() {
	      if (element[0] && 'MutationObserver' in $window) {
	        var attributeObserver = new MutationObserver(function(mutations) {
	          mutations.forEach(function(mutation) {
	            if (mutation.attributeName === 'md-visible' &&
	                !scope.visibleWatcher ) {
	              scope.visibleWatcher = scope.$watch('mdVisible',
	                  onVisibleChanged);
	            }
	          });
	        });
	
	        attributeObserver.observe(element[0], {
	          attributes: true
	        });
	
	        // Build watcher only if mdVisible is being used.
	        if (attr.hasOwnProperty('mdVisible')) {
	          scope.visibleWatcher = scope.$watch('mdVisible',
	              onVisibleChanged);
	        }
	      } else {
	        // MutationObserver not supported
	        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
	      }
	
	      // Direction watcher
	      scope.$watch('mdDirection', updatePosition);
	
	      // Clean up if the element or parent was removed via jqLite's .remove.
	      // A couple of notes:
	      //   - In these cases the scope might not have been destroyed, which
	      //     is why we destroy it manually. An example of this can be having
	      //     `md-visible="false"` and adding tooltips while they're
	      //     invisible. If `md-visible` becomes true, at some point, you'd
	      //     usually get a lot of tooltips.
	      //   - We use `.one`, not `.on`, because this only needs to fire once.
	      //     If we were using `.on`, it would get thrown into an infinite
	      //     loop.
	      //   - This kicks off the scope's `$destroy` event which finishes the
	      //     cleanup.
	      element.one('$destroy', onElementDestroy);
	      parent.one('$destroy', onElementDestroy);
	      scope.$on('$destroy', function() {
	        setVisible(false);
	        panelRef && panelRef.destroy();
	        attributeObserver && attributeObserver.disconnect();
	        element.remove();
	      });
	
	      // Updates the aria-label when the element text changes. This watch
	      // doesn't need to be set up if the element doesn't have any data
	      // bindings.
	      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
	        scope.$watch(function() {
	          return element.text().trim();
	        }, addAriaLabel);
	      }
	
	      function onElementDestroy() {
	        scope.$destroy();
	      }
	    }
	
	    function setVisible(value) {
	      // Break if passed value is already in queue or there is no queue and
	      // passed value is current in the controller.
	      if (setVisible.queued && setVisible.value === !!value ||
	          !setVisible.queued && scope.mdVisible === !!value) {
	        return;
	      }
	      setVisible.value = !!value;
	
	      if (!setVisible.queued) {
	        if (value) {
	          setVisible.queued = true;
	          showTimeout = $timeout(function() {
	            scope.mdVisible = setVisible.value;
	            setVisible.queued = false;
	            showTimeout = null;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(scope.mdVisible);
	            }
	          }, scope.mdDelay);
	        } else {
	          $mdUtil.nextTick(function() {
	            scope.mdVisible = false;
	            if (!scope.visibleWatcher) {
	              onVisibleChanged(false);
	            }
	          });
	        }
	      }
	    }
	
	    function onVisibleChanged(isVisible) {
	      isVisible ? showTooltip() : hideTooltip();
	    }
	
	    function showTooltip() {
	      // Do not show the tooltip if the text is empty.
	      if (!element[0].textContent.trim()) {
	        throw new Error('Text for the tooltip has not been provided. ' +
	            'Please include text within the mdTooltip element.');
	      }
	
	      if (!panelRef) {
	        var attachTo = angular.element(document.body);
	        var panelAnimation = $mdPanel.newPanelAnimation()
	            .openFrom(parent)
	            .closeTo(parent)
	            .withAnimation({
	              open: 'md-show',
	              close: 'md-hide'
	            });
	
	        var panelConfig = {
	          id: tooltipId,
	          attachTo: attachTo,
	          contentElement: element,
	          propagateContainerEvents: true,
	          panelClass: 'md-tooltip ' + origin,
	          animation: panelAnimation,
	          position: panelPosition,
	          zIndex: scope.mdZIndex,
	          focusOnOpen: false
	        };
	
	        panelRef = $mdPanel.create(panelConfig);
	      }
	
	      panelRef.open().then(function() {
	        panelRef.panelEl.attr('role', 'tooltip');
	      });
	    }
	
	    function hideTooltip() {
	      panelRef && panelRef.close();
	    }
	  }
	
	}
	
	
	/**
	 * Service that is used to reduce the amount of listeners that are being
	 * registered on the `window` by the tooltip component. Works by collecting
	 * the individual event handlers and dispatching them from a global handler.
	 *
	 * @ngInject
	 */
	function MdTooltipRegistry() {
	  var listeners = {};
	  var ngWindow = angular.element(window);
	
	  return {
	    register: register,
	    deregister: deregister
	  };
	
	  /**
	   * Global event handler that dispatches the registered handlers in the
	   * service.
	   * @param {!Event} event Event object passed in by the browser
	   */
	  function globalEventHandler(event) {
	    if (listeners[event.type]) {
	      listeners[event.type].forEach(function(currentHandler) {
	        currentHandler.call(this, event);
	      }, this);
	    }
	  }
	
	  /**
	   * Registers a new handler with the service.
	   * @param {string} type Type of event to be registered.
	   * @param {!Function} handler Event handler.
	   * @param {boolean} useCapture Whether to use event capturing.
	   */
	  function register(type, handler, useCapture) {
	    var handlers = listeners[type] = listeners[type] || [];
	
	    if (!handlers.length) {
	      useCapture ? window.addEventListener(type, globalEventHandler, true) :
	          ngWindow.on(type, globalEventHandler);
	    }
	
	    if (handlers.indexOf(handler) === -1) {
	      handlers.push(handler);
	    }
	  }
	
	  /**
	   * Removes an event handler from the service.
	   * @param {string} type Type of event handler.
	   * @param {!Function} handler The event handler itself.
	   * @param {boolean} useCapture Whether the event handler used event capturing.
	   */
	  function deregister(type, handler, useCapture) {
	    var handlers = listeners[type];
	    var index = handlers ? handlers.indexOf(handler) : -1;
	
	    if (index > -1) {
	      handlers.splice(index, 1);
	
	      if (handlers.length === 0) {
	        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
	            ngWindow.off(type, globalEventHandler);
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.truncate
	 */
	MdTruncateController.$inject = ["$element"];
	angular.module('material.components.truncate', ['material.core'])
	  .directive('mdTruncate', MdTruncateDirective);
	
	/**
	 * @ngdoc directive
	 * @name mdTruncate
	 * @module material.components.truncate
	 * @restrict AE
	 * @description
	 *
	 * The `md-truncate` component displays a label that will automatically clip text which is wider
	 * than the component. By default, it displays an ellipsis, but you may apply the `md-clip` CSS
	 * class to override this default and use a standard "clipping" approach.
	 *
	 * <i><b>Note:</b> The `md-truncate` component does not automatically adjust it's width. You must
	 * provide the `flex` attribute, or some other CSS-based width management. See the
	 * <a ng-href="./demo/truncate">demos</a> for examples.</i>
	 *
	 * @usage
	 *
	 * ### As an Element
	 *
	 * <hljs lang="html">
	 *   <div layout="row">
	 *     <md-button>Back</md-button>
	 *
	 *     <md-truncate flex>Chapter 1 - The Way of the Old West</md-truncate>
	 *
	 *     <md-button>Forward</md-button>
	 *   </div>
	 * </hljs>
	 *
	 * ### As an Attribute
	 *
	 * <hljs lang="html">
	 *   <h2 md-truncate style="max-width: 100px;">Some Title With a Lot of Text</h2>
	 * </hljs>
	 *
	 * ## CSS & Styles
	 *
	 * `<md-truncate>` provides two CSS classes that you may use to control the type of clipping.
	 *
	 * <i><b>Note:</b> The `md-truncate` also applies a setting of `width: 0;` when used with the `flex`
	 * attribute to fix an issue with the flex element not shrinking properly.</i>
	 *
	 * <div>
	 * <docs-css-api-table>
	 *
	 *   <docs-css-selector code=".md-ellipsis">
	 *     Assigns the "ellipsis" behavior (default) which will cut off mid-word and append an ellipsis
	 *     (&hellip;) to the end of the text.
	 *   </docs-css-selector>
	 *
	 *   <docs-css-selector code=".md-clip">
	 *     Assigns the "clipping" behavior which will simply chop off the text. This may happen
	 *     mid-word or even mid-character.
	 *   </docs-css-selector>
	 *
	 * </docs-css-api-table>
	 * </div>
	 */
	function MdTruncateDirective() {
	  return {
	    restrict: 'AE',
	
	    controller: MdTruncateController,
	    controllerAs: '$ctrl',
	    bindToController: true
	  }
	}
	
	/**
	 * Controller for the <md-truncate> component.
	 *
	 * @param $element The md-truncate element.
	 *
	 * @constructor
	 * @ngInject
	 */
	function MdTruncateController($element) {
	  $element.addClass('md-truncate');
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.virtualRepeat
	 */
	VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$mdConstant", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];
	VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
	VirtualRepeatDirective.$inject = ["$parse"];
	angular.module('material.components.virtualRepeat', [
	  'material.core',
	  'material.components.showHide'
	])
	.directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
	.directive('mdVirtualRepeat', VirtualRepeatDirective);
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeatContainer
	 * @module material.components.virtualRepeat
	 * @restrict E
	 * @description
	 * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
	 *
	 * VirtualRepeat is a limited substitute for ng-repeat that renders only
	 * enough DOM nodes to fill the container and recycling them as the user scrolls.
	 *
	 * Once an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for
	 * another visible item by replacing the previous dataset with the new one.
	 *
	 * ### Common Issues
	 *
	 * - When having one-time bindings inside of the view template, the VirtualRepeat will not properly
	 *   update the bindings for new items, since the view will be recycled.
	 *
	 * - Directives inside of a VirtualRepeat will be only compiled (linked) once, because those
	 *   are will be recycled items and used for other items.
	 *   The VirtualRepeat just updates the scope bindings.
	 *
	 *
	 * ### Notes
	 *
	 * > The VirtualRepeat is a similar implementation to the Android
	 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html)
	 *
	 * <!-- This comment forces a break between blockquotes //-->
	 *
	 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">VirtualRepeat</a>
	 * documentation for more information.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *
	 * <md-virtual-repeat-container md-top-index="topIndex">
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
	 *     container to $scope. It can both read and set the scroll position.
	 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
	 *     (defaults to orientation and scrolling vertically).
	 * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
	 *     the number of items when that number is less than its original size.
	 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
	 *     will shrink to (default: 0).
	 */
	function VirtualRepeatContainerDirective() {
	  return {
	    controller: VirtualRepeatContainerController,
	    template: virtualRepeatContainerTemplate,
	    compile: function virtualRepeatContainerCompile($element, $attrs) {
	      $element
	          .addClass('md-virtual-repeat-container')
	          .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
	              ? 'md-orient-horizontal'
	              : 'md-orient-vertical');
	    }
	  };
	}
	
	
	function virtualRepeatContainerTemplate($element) {
	  return '<div class="md-virtual-repeat-scroller">' +
	    '<div class="md-virtual-repeat-sizer"></div>' +
	    '<div class="md-virtual-repeat-offsetter">' +
	      $element[0].innerHTML +
	    '</div></div>';
	}
	
	/**
	 * Number of additional elements to render above and below the visible area inside
	 * of the virtual repeat container. A higher number results in less flicker when scrolling
	 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
	 * @const {number}
	 */
	var NUM_EXTRA = 3;
	
	/** @ngInject */
	function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window, $scope,
	                                          $element, $attrs) {
	  this.$rootScope = $rootScope;
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  /** @type {number} The width or height of the container */
	  this.size = 0;
	  /** @type {number} The scroll width or height of the scroller */
	  this.scrollSize = 0;
	  /** @type {number} The scrollLeft or scrollTop of the scroller */
	  this.scrollOffset = 0;
	  /** @type {boolean} Whether the scroller is oriented horizontally */
	  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
	  /** @type {!VirtualRepeatController} The repeater inside of this container */
	  this.repeater = null;
	  /** @type {boolean} Whether auto-shrink is enabled */
	  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
	  /** @type {number} Minimum number of items to auto-shrink to */
	  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
	  /** @type {?number} Original container size when shrank */
	  this.originalSize = null;
	  /** @type {number} Amount to offset the total scroll size by. */
	  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
	  /** @type {?string} height or width element style on the container prior to auto-shrinking. */
	  this.oldElementSize = null;
	  /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
	  this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;
	
	  if (this.$attrs.mdTopIndex) {
	    /** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */
	    this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
	    /** @type {number} The index of the item that is at the top of the scroll container */
	    this.topIndex = this.bindTopIndex(this.$scope);
	
	    if (!angular.isDefined(this.topIndex)) {
	      this.topIndex = 0;
	      this.bindTopIndex.assign(this.$scope, 0);
	    }
	
	    this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
	      if (newIndex !== this.topIndex) {
	        this.scrollToIndex(newIndex);
	      }
	    }));
	  } else {
	    this.topIndex = 0;
	  }
	
	  this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	  this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
	  this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');
	
	  // After the dom stablizes, measure the initial size of the container and
	  // make a best effort at re-measuring as it changes.
	  var boundUpdateSize = angular.bind(this, this.updateSize);
	
	  $$rAF(angular.bind(this, function() {
	    boundUpdateSize();
	
	    var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
	    var jWindow = angular.element($window);
	
	    // Make one more attempt to get the size if it is 0.
	    // This is not by any means a perfect approach, but there's really no
	    // silver bullet here.
	    if (!this.size) {
	      debouncedUpdateSize();
	    }
	
	    jWindow.on('resize', debouncedUpdateSize);
	    $scope.$on('$destroy', function() {
	      jWindow.off('resize', debouncedUpdateSize);
	    });
	
	    $scope.$emit('$md-resize-enable');
	    $scope.$on('$md-resize', boundUpdateSize);
	  }));
	}
	
	
	/** Called by the md-virtual-repeat inside of the container at startup. */
	VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
	  this.repeater = repeaterCtrl;
	
	  angular.element(this.scroller)
	      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
	};
	
	
	/** @return {boolean} Whether the container is configured for horizontal scrolling. */
	VirtualRepeatContainerController.prototype.isHorizontal = function() {
	  return this.horizontal;
	};
	
	
	/** @return {number} The size (width or height) of the container. */
	VirtualRepeatContainerController.prototype.getSize = function() {
	  return this.size;
	};
	
	
	/**
	 * Resizes the container.
	 * @private
	 * @param {number} size The new size to set.
	 */
	VirtualRepeatContainerController.prototype.setSize_ = function(size) {
	  var dimension = this.getDimensionName_();
	
	  this.size = size;
	  this.$element[0].style[dimension] = size + 'px';
	};
	
	
	VirtualRepeatContainerController.prototype.unsetSize_ = function() {
	  this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
	  this.oldElementSize = null;
	};
	
	
	/** Instructs the container to re-measure its size. */
	VirtualRepeatContainerController.prototype.updateSize = function() {
	  // If the original size is already determined, we can skip the update.
	  if (this.originalSize) return;
	
	  this.size = this.isHorizontal()
	      ? this.$element[0].clientWidth
	      : this.$element[0].clientHeight;
	
	  // Recheck the scroll position after updating the size. This resolves
	  // problems that can result if the scroll position was measured while the
	  // element was display: none or detached from the document.
	  this.handleScroll_();
	
	  this.repeater && this.repeater.containerUpdated();
	};
	
	
	/** @return {number} The container's scrollHeight or scrollWidth. */
	VirtualRepeatContainerController.prototype.getScrollSize = function() {
	  return this.scrollSize;
	};
	
	
	VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
	  return this.isHorizontal() ? 'width' : 'height';
	};
	
	
	/**
	 * Sets the scroller element to the specified size.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
	  var dimension =  this.getDimensionName_();
	  var crossDimension = this.isHorizontal() ? 'height' : 'width';
	
	  // Clear any existing dimensions.
	  this.sizer.innerHTML = '';
	
	  // If the size falls within the browser's maximum explicit size for a single element, we can
	  // set the size and be done. Otherwise, we have to create children that add up the the desired
	  // size.
	  if (size < this.maxElementPixels) {
	    this.sizer.style[dimension] = size + 'px';
	  } else {
	    this.sizer.style[dimension] = 'auto';
	    this.sizer.style[crossDimension] = 'auto';
	
	    // Divide the total size we have to render into N max-size pieces.
	    var numChildren = Math.floor(size / this.maxElementPixels);
	
	    // Element template to clone for each max-size piece.
	    var sizerChild = document.createElement('div');
	    sizerChild.style[dimension] = this.maxElementPixels + 'px';
	    sizerChild.style[crossDimension] = '1px';
	
	    for (var i = 0; i < numChildren; i++) {
	      this.sizer.appendChild(sizerChild.cloneNode(false));
	    }
	
	    // Re-use the element template for the remainder.
	    sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
	    this.sizer.appendChild(sizerChild);
	  }
	};
	
	
	/**
	 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
	 * @private
	 * @param {number} size The new size.
	 */
	VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
	  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
	
	  if (this.autoShrink && shrinkSize !== this.size) {
	    if (this.oldElementSize === null) {
	      this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
	    }
	
	    var currentSize = this.originalSize || this.size;
	
	    if (!currentSize || shrinkSize < currentSize) {
	      if (!this.originalSize) {
	        this.originalSize = this.size;
	      }
	
	      // Now we update the containers size, because shrinking is enabled.
	      this.setSize_(shrinkSize);
	    } else if (this.originalSize !== null) {
	      // Set the size back to our initial size.
	      this.unsetSize_();
	
	      var _originalSize = this.originalSize;
	      this.originalSize = null;
	
	      // We determine the repeaters size again, if the original size was zero.
	      // The originalSize needs to be null, to be able to determine the size.
	      if (!_originalSize) this.updateSize();
	
	      // Apply the original size or the determined size back to the container, because
	      // it has been overwritten before, in the shrink block.
	      this.setSize_(_originalSize || this.size);
	    }
	
	    this.repeater.containerUpdated();
	  }
	};
	
	
	/**
	 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
	 * its item count and item size.
	 * @param {number} itemsSize The total size of the items.
	 */
	VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
	  var size = itemsSize + this.offsetSize;
	  if (this.scrollSize === size) return;
	
	  this.sizeScroller_(size);
	  this.autoShrink_(size);
	  this.scrollSize = size;
	};
	
	
	/** @return {number} The container's current scroll offset. */
	VirtualRepeatContainerController.prototype.getScrollOffset = function() {
	  return this.scrollOffset;
	};
	
	/**
	 * Scrolls to a given scrollTop position.
	 * @param {number} position
	 */
	VirtualRepeatContainerController.prototype.scrollTo = function(position) {
	  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
	  this.handleScroll_();
	};
	
	/**
	 * Scrolls the item with the given index to the top of the scroll container.
	 * @param {number} index
	 */
	VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
	  var itemSize = this.repeater.getItemSize();
	  var itemsLength = this.repeater.itemsLength;
	  if(index > itemsLength) {
	    index = itemsLength - 1;
	  }
	  this.scrollTo(itemSize * index);
	};
	
	VirtualRepeatContainerController.prototype.resetScroll = function() {
	  this.scrollTo(0);
	};
	
	
	VirtualRepeatContainerController.prototype.handleScroll_ = function() {
	  var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
	  if(!ltr && !this.maxSize) {
	    this.scroller.scrollLeft = this.scrollSize;
	    this.maxSize = this.scroller.scrollLeft;
	  }
	  var offset = this.isHorizontal() ?
	      (ltr?this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
	      : this.scroller.scrollTop;
	  if (offset === this.scrollOffset || offset > this.scrollSize - this.size) return;
	
	  var itemSize = this.repeater.getItemSize();
	  if (!itemSize) return;
	
	  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
	
	  var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
	      (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
	
	  this.scrollOffset = offset;
	  this.offsetter.style.webkitTransform = transform;
	  this.offsetter.style.transform = transform;
	
	  if (this.bindTopIndex) {
	    var topIndex = Math.floor(offset / itemSize);
	    if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
	      this.topIndex = topIndex;
	      this.bindTopIndex.assign(this.$scope, topIndex);
	      if (!this.$rootScope.$$phase) this.$scope.$digest();
	    }
	  }
	
	  this.repeater.containerUpdated();
	};
	
	
	/**
	 * @ngdoc directive
	 * @name mdVirtualRepeat
	 * @module material.components.virtualRepeat
	 * @restrict A
	 * @priority 1000
	 * @description
	 * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
	 *
	 * Virtual repeat is a limited substitute for ng-repeat that renders only
	 * enough DOM nodes to fill the container and recycling them as the user scrolls.
	 *
	 * Arrays, but not objects are supported for iteration.
	 * Track by, as alias, and (key, value) syntax are not supported.
	 *
	 * ### On-Demand Async Item Loading
	 *
	 * When using the `md-on-demand` attribute and loading some asynchronous data, the `getItemAtIndex` function will
	 * mostly return nothing.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.getItemAtIndex = function(index) {
	 *     if (this.pages[index]) {
	 *       return this.pages[index];
	 *     } else {
	 *       // This is an asynchronous action and does not return any value.
	 *       this.loadPage(index);
	 *     }
	 *   };
	 * </hljs>
	 *
	 * This means that the VirtualRepeat will not have any value for the given index.<br/>
	 * After the data loading completed, the user expects the VirtualRepeat to recognize the change.
	 *
	 * To make sure that the VirtualRepeat properly detects any change, you need to run the operation
	 * in another digest.
	 *
	 * <hljs lang="js">
	 *   DynamicItems.prototype.loadPage = function(index) {
	 *     var self = this;
	 *
	 *     // Trigger a new digest by using $timeout
	 *     $timeout(function() {
	 *       self.pages[index] = Data;
	 *     });
	 *   };
	 * </hljs>
	 *
	 * > <b>Note:</b> Please also review the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
	 *   for more information.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-virtual-repeat-container>
	 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 *
	 * <md-virtual-repeat-container md-orient-horizontal>
	 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
	 * </md-virtual-repeat-container>
	 * </hljs>
	 *
	 * @param {number=} md-item-size The height or width of the repeated elements (which must be
	 *   identical for each element). Optional. Will attempt to read the size from the dom if missing,
	 *   but still assumes that all repeated nodes have same height or width.
	 * @param {string=} md-extra-name Evaluates to an additional name to which the current iterated item
	 *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
	 * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument as an object
	 *   that can fetch rows rather than an array.
	 *
	 *   **NOTE:** This object must implement the following interface with two (2) methods:
	 *
	 *   - `getItemAtIndex: function(index) [object]` The item at that index or null if it is not yet
	 *     loaded (it should start downloading the item in that case).
	 *   - `getLength: function() [number]` The data length to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 */
	function VirtualRepeatDirective($parse) {
	  return {
	    controller: VirtualRepeatController,
	    priority: 1000,
	    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
	    restrict: 'A',
	    terminal: true,
	    transclude: 'element',
	    compile: function VirtualRepeatCompile($element, $attrs) {
	      var expression = $attrs.mdVirtualRepeat;
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
	      var repeatName = match[1];
	      var repeatListExpression = $parse(match[2]);
	      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);
	
	      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
	        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
	      };
	    }
	  };
	}
	
	
	/** @ngInject */
	function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
	    $$rAF, $mdUtil) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$browser = $browser;
	  this.$document = $document;
	  this.$rootScope = $rootScope;
	  this.$$rAF = $$rAF;
	
	  /** @type {boolean} Whether we are in on-demand mode. */
	  this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
	  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
	  this.browserCheckUrlChange = $browser.$$checkUrlChange;
	  /** @type {number} Most recent starting repeat index (based on scroll offset) */
	  this.newStartIndex = 0;
	  /** @type {number} Most recent ending repeat index (based on scroll offset) */
	  this.newEndIndex = 0;
	  /** @type {number} Most recent end visible index (based on scroll offset) */
	  this.newVisibleEnd = 0;
	  /** @type {number} Previous starting repeat index (based on scroll offset) */
	  this.startIndex = 0;
	  /** @type {number} Previous ending repeat index (based on scroll offset) */
	  this.endIndex = 0;
	  // TODO: measure width/height of first element from dom if not provided.
	  // getComputedStyle?
	  /** @type {?number} Height/width of repeated elements. */
	  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;
	
	  /** @type {boolean} Whether this is the first time that items are rendered. */
	  this.isFirstRender = true;
	
	  /**
	   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
	   *     nested calls to virtualRepeatUpdate_.
	   */
	  this.isVirtualRepeatUpdating_ = false;
	
	  /** @type {number} Most recently seen length of items. */
	  this.itemsLength = 0;
	
	  /**
	   * @type {!Function} Unwatch callback for item size (when md-items-size is
	   *     not specified), or angular.noop otherwise.
	   */
	  this.unwatchItemSize_ = angular.noop;
	
	  /**
	   * Presently rendered blocks by repeat index.
	   * @type {Object<number, !VirtualRepeatController.Block}
	   */
	  this.blocks = {};
	  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
	  this.pooledBlocks = [];
	
	  $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
	}
	
	
	/**
	 * An object representing a repeated item.
	 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
	 */
	VirtualRepeatController.Block;
	
	
	/**
	 * Called at startup by the md-virtual-repeat postLink function.
	 * @param {!VirtualRepeatContainerController} container The container's controller.
	 * @param {!Function} transclude The repeated element's bound transclude function.
	 * @param {string} repeatName The left hand side of the repeat expression, indicating
	 *     the name for each item in the array.
	 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
	 *     of the repeat expression. Points to the array to repeat over.
	 * @param {string|undefined} extraName The optional extra repeatName.
	 */
	VirtualRepeatController.prototype.link_ =
	    function(container, transclude, repeatName, repeatListExpression, extraName) {
	  this.container = container;
	  this.transclude = transclude;
	  this.repeatName = repeatName;
	  this.rawRepeatListExpression = repeatListExpression;
	  this.extraName = extraName;
	  this.sized = false;
	
	  this.repeatListExpression = angular.bind(this, this.repeatListExpression_);
	
	  this.container.register(this);
	};
	
	
	/** @private Cleans up unused blocks. */
	VirtualRepeatController.prototype.cleanupBlocks_ = function() {
	  angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
	    block.element.remove();
	  });
	};
	
	
	/** @private Attempts to set itemSize by measuring a repeated element in the dom */
	VirtualRepeatController.prototype.readItemSize_ = function() {
	  if (this.itemSize) {
	    // itemSize was successfully read in a different asynchronous call.
	    return;
	  }
	
	  this.items = this.repeatListExpression(this.$scope);
	  this.parentNode = this.$element[0].parentNode;
	  var block = this.getBlock_(0);
	  if (!block.element[0].parentNode) {
	    this.parentNode.appendChild(block.element[0]);
	  }
	
	  this.itemSize = block.element[0][
	      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;
	
	  this.blocks[0] = block;
	  this.poolBlock_(0);
	
	  if (this.itemSize) {
	    this.containerUpdated();
	  }
	};
	
	
	/**
	 * Returns the user-specified repeat list, transforming it into an array-like
	 * object in the case of infinite scroll/dynamic load mode.
	 * @param {!angular.Scope} The scope.
	 * @return {!Array|!Object} An array or array-like object for iteration.
	 */
	VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
	  var repeatList = this.rawRepeatListExpression(scope);
	
	  if (this.onDemand && repeatList) {
	    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
	    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
	    return virtualList;
	  } else {
	    return repeatList;
	  }
	};
	
	
	/**
	 * Called by the container. Informs us that the containers scroll or size has
	 * changed.
	 */
	VirtualRepeatController.prototype.containerUpdated = function() {
	  // If itemSize is unknown, attempt to measure it.
	  if (!this.itemSize) {
	    // Make sure to clean up watchers if we can (see #8178)
	    if(this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
	      this.unwatchItemSize_();
	    }
	    this.unwatchItemSize_ = this.$scope.$watchCollection(
	        this.repeatListExpression,
	        angular.bind(this, function(items) {
	          if (items && items.length) {
	            this.readItemSize_();
	          }
	        }));
	    if (!this.$rootScope.$$phase) this.$scope.$digest();
	
	    return;
	  } else if (!this.sized) {
	    this.items = this.repeatListExpression(this.$scope);
	  }
	
	  if (!this.sized) {
	    this.unwatchItemSize_();
	    this.sized = true;
	    this.$scope.$watchCollection(this.repeatListExpression,
	        angular.bind(this, function(items, oldItems) {
	          if (!this.isVirtualRepeatUpdating_) {
	            this.virtualRepeatUpdate_(items, oldItems);
	          }
	        }));
	  }
	
	  this.updateIndexes_();
	
	  if (this.newStartIndex !== this.startIndex ||
	      this.newEndIndex !== this.endIndex ||
	      this.container.getScrollOffset() > this.container.getScrollSize()) {
	    if (this.items instanceof VirtualRepeatModelArrayLike) {
	      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
	    }
	    this.virtualRepeatUpdate_(this.items, this.items);
	  }
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} Size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemSize = function() {
	  return this.itemSize;
	};
	
	
	/**
	 * Called by the container. Returns the size of a single repeated item.
	 * @return {?number} Size of a repeated item.
	 */
	VirtualRepeatController.prototype.getItemCount = function() {
	  return this.itemsLength;
	};
	
	
	/**
	 * Updates the order and visible offset of repeated blocks in response to scrolling
	 * or items updates.
	 * @private
	 */
	VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
	  this.isVirtualRepeatUpdating_ = true;
	
	  var itemsLength = items && items.length || 0;
	  var lengthChanged = false;
	
	  // If the number of items shrank, keep the scroll position.
	  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
	    this.items = items;
	    var previousScrollOffset = this.container.getScrollOffset();
	    this.container.resetScroll();
	    this.container.scrollTo(previousScrollOffset);
	  }
	
	  if (itemsLength !== this.itemsLength) {
	    lengthChanged = true;
	    this.itemsLength = itemsLength;
	  }
	
	  this.items = items;
	  if (items !== oldItems || lengthChanged) {
	    this.updateIndexes_();
	  }
	
	  this.parentNode = this.$element[0].parentNode;
	
	  if (lengthChanged) {
	    this.container.setScrollSize(itemsLength * this.itemSize);
	  }
	
	  var cleanupFirstRender = false, firstRenderStartIndex;
	  if (this.isFirstRender) {
	    cleanupFirstRender = true;
	    this.isFirstRender = false;
	    firstRenderStartIndex = this.$attrs.mdStartIndex ?
	      this.$scope.$eval(this.$attrs.mdStartIndex) :
	      this.container.topIndex;
	    this.container.scrollToIndex(firstRenderStartIndex);
	  }
	
	  // Detach and pool any blocks that are no longer in the viewport.
	  Object.keys(this.blocks).forEach(function(blockIndex) {
	    var index = parseInt(blockIndex, 10);
	    if (index < this.newStartIndex || index >= this.newEndIndex) {
	      this.poolBlock_(index);
	    }
	  }, this);
	
	  // Add needed blocks.
	  // For performance reasons, temporarily block browser url checks as we digest
	  // the restored block scopes ($$checkUrlChange reads window.location to
	  // check for changes and trigger route change, etc, which we don't need when
	  // trying to scroll at 60fps).
	  this.$browser.$$checkUrlChange = angular.noop;
	
	  var i, block,
	      newStartBlocks = [],
	      newEndBlocks = [];
	
	  // Collect blocks at the top.
	  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newStartBlocks.push(block);
	  }
	
	  // Update blocks that are already rendered.
	  for (; this.blocks[i] != null; i++) {
	    this.updateBlock_(this.blocks[i], i);
	  }
	  var maxIndex = i - 1;
	
	  // Collect blocks at the end.
	  for (; i < this.newEndIndex; i++) {
	    block = this.getBlock_(i);
	    this.updateBlock_(block, i);
	    newEndBlocks.push(block);
	  }
	
	  // Attach collected blocks to the document.
	  if (newStartBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newStartBlocks),
	        this.$element[0].nextSibling);
	  }
	  if (newEndBlocks.length) {
	    this.parentNode.insertBefore(
	        this.domFragmentFromBlocks_(newEndBlocks),
	        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
	  }
	
	  // DOM manipulation may have altered scroll, so scroll again
	  if (cleanupFirstRender) {
	    this.container.scrollToIndex(firstRenderStartIndex);
	  }
	  // Restore $$checkUrlChange.
	  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;
	
	  this.startIndex = this.newStartIndex;
	  this.endIndex = this.newEndIndex;
	
	  this.isVirtualRepeatUpdating_ = false;
	};
	
	
	/**
	 * @param {number} index Where the block is to be in the repeated list.
	 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
	 * @private
	 */
	VirtualRepeatController.prototype.getBlock_ = function(index) {
	  if (this.pooledBlocks.length) {
	    return this.pooledBlocks.pop();
	  }
	
	  var block;
	  this.transclude(angular.bind(this, function(clone, scope) {
	    block = {
	      element: clone,
	      new: true,
	      scope: scope
	    };
	
	    this.updateScope_(scope, index);
	    this.parentNode.appendChild(clone[0]);
	  }));
	
	  return block;
	};
	
	
	/**
	 * Updates and if not in a digest cycle, digests the specified block's scope to the data
	 * at the specified index.
	 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
	  this.blocks[index] = block;
	
	  if (!block.new &&
	      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
	    return;
	  }
	  block.new = false;
	
	  // Update and digest the block's scope.
	  this.updateScope_(block.scope, index);
	
	  // Perform digest before reattaching the block.
	  // Any resulting synchronous dom mutations should be much faster as a result.
	  // This might break some directives, but I'm going to try it for now.
	  if (!this.$rootScope.$$phase) {
	    block.scope.$digest();
	  }
	};
	
	
	/**
	 * Updates scope to the data at the specified index.
	 * @param {!angular.Scope} scope The scope which should be updated.
	 * @param {number} index The index to set.
	 * @private
	 */
	VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
	  scope.$index = index;
	  scope[this.repeatName] = this.items && this.items[index];
	  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
	};
	
	
	/**
	 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
	 * @param {number} index The index at which the block to pool is stored.
	 * @private
	 */
	VirtualRepeatController.prototype.poolBlock_ = function(index) {
	  this.pooledBlocks.push(this.blocks[index]);
	  this.parentNode.removeChild(this.blocks[index].element[0]);
	  delete this.blocks[index];
	};
	
	
	/**
	 * Produces a dom fragment containing the elements from the list of blocks.
	 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
	 *     should be added to the document fragment.
	 * @return {DocumentFragment}
	 * @private
	 */
	VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
	  var fragment = this.$document[0].createDocumentFragment();
	  blocks.forEach(function(block) {
	    fragment.appendChild(block.element[0]);
	  });
	  return fragment;
	};
	
	
	/**
	 * Updates start and end indexes based on length of repeated items and container size.
	 * @private
	 */
	VirtualRepeatController.prototype.updateIndexes_ = function() {
	  var itemsLength = this.items ? this.items.length : 0;
	  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);
	
	  this.newStartIndex = Math.max(0, Math.min(
	      itemsLength - containerLength,
	      Math.floor(this.container.getScrollOffset() / this.itemSize)));
	  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
	  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
	  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
	};
	
	/**
	 * This VirtualRepeatModelArrayLike class enforces the interface requirements
	 * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
	 * interface must implement the following interface with two (2) methods:
	 *
	 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
	 *     loaded (It should start downloading the item in that case).
	 *
	 * getLength: function() -> number The data legnth to which the repeater container
	 *     should be sized. Ideally, when the count is known, this method should return it.
	 *     Otherwise, return a higher number than the currently loaded items to produce an
	 *     infinite-scroll behavior.
	 *
	 * @usage
	 * <hljs lang="html">
	 *  <md-virtual-repeat-container md-orient-horizontal>
	 *    <div md-virtual-repeat="i in items" md-on-demand>
	 *      Hello {{i}}!
	 *    </div>
	 *  </md-virtual-repeat-container>
	 * </hljs>
	 *
	 */
	function VirtualRepeatModelArrayLike(model) {
	  if (!angular.isFunction(model.getItemAtIndex) ||
	      !angular.isFunction(model.getLength)) {
	    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
	        'functions getItemAtIndex() and getLength() ');
	  }
	
	  this.model = model;
	}
	
	
	VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
	  for (var i = start; i < end; i++) {
	    if (!this.hasOwnProperty(i)) {
	      this[i] = this.model.getItemAtIndex(i);
	    }
	  }
	  this.length = this.model.getLength();
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc module
	 * @name material.components.whiteframe
	 */
	MdWhiteframeDirective.$inject = ["$log"];
	angular
	  .module('material.components.whiteframe', ['material.core'])
	  .directive('mdWhiteframe', MdWhiteframeDirective);
	
	/**
	 * @ngdoc directive
	 * @module material.components.whiteframe
	 * @name mdWhiteframe
	 *
	 * @description
	 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
	 *
	 * The attribute values needs to be a number between 1 and 24 or -1.
	 * When set to -1 no style is applied.
	 *
	 * ### Notes
	 * - If there is no value specified it defaults to 4dp.
	 * - If the value is not valid it defaults to 4dp.
	
	 * @usage
	 * <hljs lang="html">
	 * <div md-whiteframe="3">
	 *   <span>Elevation of 3dp</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div md-whiteframe="-1">
	 *   <span>No elevation shadow applied</span>
	 * </div>
	 * </hljs>
	 *
	 * <hljs lang="html">
	 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
	 *   <span>Elevation of 5dp with an interpolated value</span>
	 * </div>
	 * </hljs>
	 */
	function MdWhiteframeDirective($log) {
	  var DISABLE_DP = -1;
	  var MIN_DP = 1;
	  var MAX_DP = 24;
	  var DEFAULT_DP = 4;
	
	  return {
	    link: postLink
	  };
	
	  function postLink(scope, element, attr) {
	    var oldClass = '';
	
	    attr.$observe('mdWhiteframe', function(elevation) {
	      elevation = parseInt(elevation, 10) || DEFAULT_DP;
	
	      if (elevation != DISABLE_DP && (elevation > MAX_DP || elevation < MIN_DP)) {
	        $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
	        elevation = DEFAULT_DP;
	      }
	
	      var newClass = elevation == DISABLE_DP ? '' : 'md-whiteframe-' + elevation + 'dp';
	      attr.$updateClass(newClass, oldClass);
	      oldClass = newClass;
	    });
	  }
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log", "$mdLiveAnnouncer"];angular
	    .module('material.components.autocomplete')
	    .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);
	
	var ITEM_HEIGHT   = 48,
	    MAX_ITEMS     = 5,
	    MENU_PADDING  = 8,
	    INPUT_PADDING = 2; // Padding provided by `md-input-container`
	
	function MdAutocompleteCtrl ($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
	                             $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) {
	
	  // Internal Variables.
	  var ctrl                 = this,
	      itemParts            = $scope.itemsExpr.split(/ in /i),
	      itemExpr             = itemParts[ 1 ],
	      elements             = null,
	      cache                = {},
	      noBlur               = false,
	      selectedItemWatchers = [],
	      hasFocus             = false,
	      fetchesInProgress    = 0,
	      enableWrapScroll     = null,
	      inputModelCtrl       = null,
	      debouncedOnResize    = $mdUtil.debounce(onWindowResize);
	
	  // Public Exported Variables with handlers
	  defineProperty('hidden', handleHiddenChange, true);
	
	  // Public Exported Variables
	  ctrl.scope      = $scope;
	  ctrl.parent     = $scope.$parent;
	  ctrl.itemName   = itemParts[ 0 ];
	  ctrl.matches    = [];
	  ctrl.loading    = false;
	  ctrl.hidden     = true;
	  ctrl.index      = null;
	  ctrl.id         = $mdUtil.nextUid();
	  ctrl.isDisabled = null;
	  ctrl.isRequired = null;
	  ctrl.isReadonly = null;
	  ctrl.hasNotFound = false;
	
	  // Public Exported Methods
	  ctrl.keydown                       = keydown;
	  ctrl.blur                          = blur;
	  ctrl.focus                         = focus;
	  ctrl.clear                         = clearValue;
	  ctrl.select                        = select;
	  ctrl.listEnter                     = onListEnter;
	  ctrl.listLeave                     = onListLeave;
	  ctrl.mouseUp                       = onMouseup;
	  ctrl.getCurrentDisplayValue        = getCurrentDisplayValue;
	  ctrl.registerSelectedItemWatcher   = registerSelectedItemWatcher;
	  ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
	  ctrl.notFoundVisible               = notFoundVisible;
	  ctrl.loadingIsVisible              = loadingIsVisible;
	  ctrl.positionDropdown              = positionDropdown;
	
	  /**
	   * Report types to be used for the $mdLiveAnnouncer
	   * @enum {number} Unique flag id.
	   */
	  var ReportType = {
	    Count: 1,
	    Selected: 2
	  };
	
	  return init();
	
	  //-- initialization methods
	
	  /**
	   * Initialize the controller, setup watchers, gather elements
	   */
	  function init () {
	
	    $mdUtil.initOptionalProperties($scope, $attrs, {
	      searchText: '',
	      selectedItem: null,
	      clearButton: false
	    });
	
	    $mdTheming($element);
	    configureWatchers();
	    $mdUtil.nextTick(function () {
	
	      gatherElements();
	      moveDropdown();
	
	      // Forward all focus events to the input element when autofocus is enabled
	      if ($scope.autofocus) {
	        $element.on('focus', focusInputElement);
	      }
	    });
	  }
	
	  function updateModelValidators() {
	    if (!$scope.requireMatch || !inputModelCtrl) return;
	
	    inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem || !$scope.searchText);
	  }
	
	  /**
	   * Calculates the dropdown's position and applies the new styles to the menu element
	   * @returns {*}
	   */
	  function positionDropdown () {
	    if (!elements) {
	      return $mdUtil.nextTick(positionDropdown, false, $scope);
	    }
	
	    var dropdownHeight = ($scope.dropdownItems || MAX_ITEMS) * ITEM_HEIGHT;
	
	    var hrect  = elements.wrap.getBoundingClientRect(),
	        vrect  = elements.snap.getBoundingClientRect(),
	        root   = elements.root.getBoundingClientRect(),
	        top    = vrect.bottom - root.top,
	        bot    = root.bottom - vrect.top,
	        left   = hrect.left - root.left,
	        width  = hrect.width,
	        offset = getVerticalOffset(),
	        position = $scope.dropdownPosition,
	        styles;
	
	    // Automatically determine dropdown placement based on available space in viewport.
	    if (!position) {
	      position = (top > bot && root.height - top - MENU_PADDING < dropdownHeight) ? 'top' : 'bottom';
	    }
	    // Adjust the width to account for the padding provided by `md-input-container`
	    if ($attrs.mdFloatingLabel) {
	      left += INPUT_PADDING;
	      width -= INPUT_PADDING * 2;
	    }
	    styles = {
	      left:     left + 'px',
	      minWidth: width + 'px',
	      maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
	    };
	
	    if (position === 'top') {
	      styles.top       = 'auto';
	      styles.bottom    = bot + 'px';
	      styles.maxHeight = Math.min(dropdownHeight, hrect.top - root.top - MENU_PADDING) + 'px';
	    } else {
	      var bottomSpace = root.bottom - hrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();
	
	      styles.top       = (top - offset) + 'px';
	      styles.bottom    = 'auto';
	      styles.maxHeight = Math.min(dropdownHeight, bottomSpace) + 'px';
	    }
	
	    elements.$.scrollContainer.css(styles);
	    $mdUtil.nextTick(correctHorizontalAlignment, false);
	
	    /**
	     * Calculates the vertical offset for floating label examples to account for ngMessages
	     * @returns {number}
	     */
	    function getVerticalOffset () {
	      var offset = 0;
	      var inputContainer = $element.find('md-input-container');
	      if (inputContainer.length) {
	        var input = inputContainer.find('input');
	        offset = inputContainer.prop('offsetHeight');
	        offset -= input.prop('offsetTop');
	        offset -= input.prop('offsetHeight');
	        // add in the height left up top for the floating label text
	        offset += inputContainer.prop('offsetTop');
	      }
	      return offset;
	    }
	
	    /**
	     * Makes sure that the menu doesn't go off of the screen on either side.
	     */
	    function correctHorizontalAlignment () {
	      var dropdown = elements.scrollContainer.getBoundingClientRect(),
	          styles   = {};
	      if (dropdown.right > root.right - MENU_PADDING) {
	        styles.left = (hrect.right - dropdown.width) + 'px';
	      }
	      elements.$.scrollContainer.css(styles);
	    }
	  }
	
	  /**
	   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
	   */
	  function moveDropdown () {
	    if (!elements.$.root.length) return;
	    $mdTheming(elements.$.scrollContainer);
	    elements.$.scrollContainer.detach();
	    elements.$.root.append(elements.$.scrollContainer);
	    if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
	  }
	
	  /**
	   * Sends focus to the input element.
	   */
	  function focusInputElement () {
	    elements.input.focus();
	  }
	
	  /**
	   * Sets up any watchers used by autocomplete
	   */
	  function configureWatchers () {
	    var wait = parseInt($scope.delay, 10) || 0;
	
	    $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
	    $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });
	
	    $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
	    $scope.$watch('selectedItem', selectedItemChange);
	
	    angular.element($window).on('resize', debouncedOnResize);
	
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Removes any events or leftover elements created by this controller
	   */
	  function cleanup () {
	    if (!ctrl.hidden) {
	      $mdUtil.enableScrolling();
	    }
	
	    angular.element($window).off('resize', debouncedOnResize);
	
	    if ( elements ){
	      var items = ['ul', 'scroller', 'scrollContainer', 'input'];
	      angular.forEach(items, function(key){
	        elements.$[key].remove();
	      });
	    }
	  }
	
	  /**
	   * Event handler to be called whenever the window resizes.
	   */
	  function onWindowResize() {
	    if (!ctrl.hidden) {
	      positionDropdown();
	    }
	  }
	
	  /**
	   * Gathers all of the elements needed for this controller
	   */
	  function gatherElements () {
	
	    var snapWrap = gatherSnapWrap();
	
	    elements = {
	      main:  $element[0],
	      scrollContainer: $element[0].querySelector('.md-virtual-repeat-container'),
	      scroller: $element[0].querySelector('.md-virtual-repeat-scroller'),
	      ul:    $element.find('ul')[0],
	      input: $element.find('input')[0],
	      wrap:  snapWrap.wrap,
	      snap:  snapWrap.snap,
	      root:  document.body
	    };
	
	    elements.li   = elements.ul.getElementsByTagName('li');
	    elements.$    = getAngularElements(elements);
	
	    inputModelCtrl = elements.$.input.controller('ngModel');
	  }
	
	  /**
	   * Gathers the snap and wrap elements
	   *
	   */
	  function gatherSnapWrap() {
	    var element;
	    var value;
	    for (element = $element; element.length; element = element.parent()) {
	      value = element.attr('md-autocomplete-snap');
	      if (angular.isDefined(value)) break;
	    }
	
	    if (element.length) {
	      return {
	        snap: element[0],
	        wrap: (value.toLowerCase() === 'width') ? element[0] : $element.find('md-autocomplete-wrap')[0]
	      };
	    }
	
	    var wrap = $element.find('md-autocomplete-wrap')[0];
	    return {
	      snap: wrap,
	      wrap: wrap
	    };
	  }
	
	  /**
	   * Gathers angular-wrapped versions of each element
	   * @param elements
	   * @returns {{}}
	   */
	  function getAngularElements (elements) {
	    var obj = {};
	    for (var key in elements) {
	      if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
	    }
	    return obj;
	  }
	
	  //-- event/change handlers
	
	  /**
	   * Handles changes to the `hidden` property.
	   * @param hidden
	   * @param oldHidden
	   */
	  function handleHiddenChange (hidden, oldHidden) {
	    if (!hidden && oldHidden) {
	      positionDropdown();
	
	      // Report in polite mode, because the screenreader should finish the default description of
	      // the input. element.
	      reportMessages(true, ReportType.Count | ReportType.Selected);
	
	      if (elements) {
	        $mdUtil.disableScrollAround(elements.ul);
	        enableWrapScroll = disableElementScrollEvents(angular.element(elements.wrap));
	      }
	    } else if (hidden && !oldHidden) {
	      $mdUtil.enableScrolling();
	
	      if (enableWrapScroll) {
	        enableWrapScroll();
	        enableWrapScroll = null;
	      }
	    }
	  }
	
	  /**
	   * Disables scrolling for a specific element
	   */
	  function disableElementScrollEvents(element) {
	
	    function preventDefault(e) {
	      e.preventDefault();
	    }
	
	    element.on('wheel', preventDefault);
	    element.on('touchmove', preventDefault);
	
	    return function() {
	      element.off('wheel', preventDefault);
	      element.off('touchmove', preventDefault);
	    };
	  }
	
	  /**
	   * When the user mouses over the dropdown menu, ignore blur events.
	   */
	  function onListEnter () {
	    noBlur = true;
	  }
	
	  /**
	   * When the user's mouse leaves the menu, blur events may hide the menu again.
	   */
	  function onListLeave () {
	    if (!hasFocus && !ctrl.hidden) elements.input.focus();
	    noBlur = false;
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * When the mouse button is released, send focus back to the input field.
	   */
	  function onMouseup () {
	    elements.input.focus();
	  }
	
	  /**
	   * Handles changes to the selected item.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function selectedItemChange (selectedItem, previousSelectedItem) {
	
	    updateModelValidators();
	
	    if (selectedItem) {
	      getDisplayValue(selectedItem).then(function (val) {
	        $scope.searchText = val;
	        handleSelectedItemChange(selectedItem, previousSelectedItem);
	      });
	    } else if (previousSelectedItem && $scope.searchText) {
	      getDisplayValue(previousSelectedItem).then(function(displayValue) {
	        // Clear the searchText, when the selectedItem is set to null.
	        // Do not clear the searchText, when the searchText isn't matching with the previous
	        // selected item.
	        if (angular.isString($scope.searchText)
	          && displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
	          $scope.searchText = '';
	        }
	      });
	    }
	
	    if (selectedItem !== previousSelectedItem) announceItemChange();
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time a new item is selected
	   */
	  function announceItemChange () {
	    angular.isFunction($scope.itemChange) && $scope.itemChange(getItemAsNameVal($scope.selectedItem));
	  }
	
	  /**
	   * Use the user-defined expression to announce changes each time the search text is changed
	   */
	  function announceTextChange () {
	    angular.isFunction($scope.textChange) && $scope.textChange();
	  }
	
	  /**
	   * Calls any external watchers listening for the selected item.  Used in conjunction with
	   * `registerSelectedItemWatcher`.
	   * @param selectedItem
	   * @param previousSelectedItem
	   */
	  function handleSelectedItemChange (selectedItem, previousSelectedItem) {
	    selectedItemWatchers.forEach(function (watcher) { watcher(selectedItem, previousSelectedItem); });
	  }
	
	  /**
	   * Register a function to be called when the selected item changes.
	   * @param cb
	   */
	  function registerSelectedItemWatcher (cb) {
	    if (selectedItemWatchers.indexOf(cb) == -1) {
	      selectedItemWatchers.push(cb);
	    }
	  }
	
	  /**
	   * Unregister a function previously registered for selected item changes.
	   * @param cb
	   */
	  function unregisterSelectedItemWatcher (cb) {
	    var i = selectedItemWatchers.indexOf(cb);
	    if (i != -1) {
	      selectedItemWatchers.splice(i, 1);
	    }
	  }
	
	  /**
	   * Handles changes to the searchText property.
	   * @param searchText
	   * @param previousSearchText
	   */
	  function handleSearchText (searchText, previousSearchText) {
	    ctrl.index = getDefaultIndex();
	
	    // do nothing on init
	    if (searchText === previousSearchText) return;
	
	    updateModelValidators();
	
	    getDisplayValue($scope.selectedItem).then(function (val) {
	      // clear selected item if search text no longer matches it
	      if (searchText !== val) {
	        $scope.selectedItem = null;
	
	
	        // trigger change event if available
	        if (searchText !== previousSearchText) announceTextChange();
	
	        // cancel results if search text is not long enough
	        if (!isMinLengthMet()) {
	          ctrl.matches = [];
	
	          setLoading(false);
	          reportMessages(false, ReportType.Count);
	
	        } else {
	          handleQuery();
	        }
	      }
	    });
	
	  }
	
	  /**
	   * Handles input blur event, determines if the dropdown should hide.
	   */
	  function blur($event) {
	    hasFocus = false;
	
	    if (!noBlur) {
	      ctrl.hidden = shouldHide();
	      evalAttr('ngBlur', { $event: $event });
	    }
	  }
	
	  /**
	   * Force blur on input element
	   * @param forceBlur
	   */
	  function doBlur(forceBlur) {
	    if (forceBlur) {
	      noBlur = false;
	      hasFocus = false;
	    }
	    elements.input.blur();
	  }
	
	  /**
	   * Handles input focus event, determines if the dropdown should show.
	   */
	  function focus($event) {
	    hasFocus = true;
	
	    if (isSearchable() && isMinLengthMet()) {
	      handleQuery();
	    }
	
	    ctrl.hidden = shouldHide();
	
	    evalAttr('ngFocus', { $event: $event });
	  }
	
	  /**
	   * Handles keyboard input.
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.DOWN_ARROW:
	        if (ctrl.loading) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index   = Math.min(ctrl.index + 1, ctrl.matches.length - 1);
	        updateScroll();
	        reportMessages(false, ReportType.Selected);
	        break;
	      case $mdConstant.KEY_CODE.UP_ARROW:
	        if (ctrl.loading) return;
	        event.stopPropagation();
	        event.preventDefault();
	        ctrl.index   = ctrl.index < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
	        updateScroll();
	        reportMessages(false, ReportType.Selected);
	        break;
	      case $mdConstant.KEY_CODE.TAB:
	        // If we hit tab, assume that we've left the list so it will close
	        onListLeave();
	
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ENTER:
	        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
	        if (hasSelection()) return;
	        event.stopPropagation();
	        event.preventDefault();
	        select(ctrl.index);
	        break;
	      case $mdConstant.KEY_CODE.ESCAPE:
	        event.preventDefault(); // Prevent browser from always clearing input
	        if (!shouldProcessEscape()) return;
	        event.stopPropagation();
	
	        clearSelectedItem();
	        if ($scope.searchText && hasEscapeOption('clear')) {
	          clearSearchText();
	        }
	
	        // Manually hide (needed for mdNotFound support)
	        ctrl.hidden = true;
	
	        if (hasEscapeOption('blur')) {
	          // Force the component to blur if they hit escape
	          doBlur(true);
	        }
	
	        break;
	      default:
	    }
	  }
	
	  //-- getters
	
	  /**
	   * Returns the minimum length needed to display the dropdown.
	   * @returns {*}
	   */
	  function getMinLength () {
	    return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
	  }
	
	  /**
	   * Returns the display value for an item.
	   * @param item
	   * @returns {*}
	   */
	  function getDisplayValue (item) {
	    return $q.when(getItemText(item) || item).then(function(itemText) {
	      if (itemText && !angular.isString(itemText)) {
	        $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
	          'Please check the `md-item-text` attribute.');
	      }
	
	      return itemText;
	    });
	
	    /**
	     * Getter function to invoke user-defined expression (in the directive)
	     * to convert your object to a single string.
	     */
	    function getItemText (item) {
	      return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
	    }
	  }
	
	  /**
	   * Returns the locals object for compiling item templates.
	   * @param item
	   * @returns {{}}
	   */
	  function getItemAsNameVal (item) {
	    if (!item) return undefined;
	
	    var locals = {};
	    if (ctrl.itemName) locals[ ctrl.itemName ] = item;
	
	    return locals;
	  }
	
	  /**
	   * Returns the default index based on whether or not autoselect is enabled.
	   * @returns {number}
	   */
	  function getDefaultIndex () {
	    return $scope.autoselect ? 0 : -1;
	  }
	
	  /**
	   * Sets the loading parameter and updates the hidden state.
	   * @param value {boolean} Whether or not the component is currently loading.
	   */
	  function setLoading(value) {
	    if (ctrl.loading != value) {
	      ctrl.loading = value;
	    }
	
	    // Always refresh the hidden variable as something else might have changed
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Determines if the menu should be hidden.
	   * @returns {boolean}
	   */
	  function shouldHide () {
	    if (!isSearchable()) return true;    // Hide when not able to query
	    else return !shouldShow();            // Hide when the dropdown is not able to show.
	  }
	
	  /**
	   * Determines whether the autocomplete is able to query within the current state.
	   * @returns {boolean}
	   */
	  function isSearchable() {
	    if (ctrl.loading && !hasMatches()) return false; // No query when query is in progress.
	    else if (hasSelection()) return false;           // No query if there is already a selection
	    else if (!hasFocus) return false;                // No query if the input does not have focus
	    return true;
	  }
	
	  /**
	   * Determines if the escape keydown should be processed
	   * @returns {boolean}
	   */
	  function shouldProcessEscape() {
	    return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
	  }
	
	  /**
	   * Determines if an escape option is set
	   * @returns {boolean}
	   */
	  function hasEscapeOption(option) {
	    return !$scope.escapeOptions || $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
	  }
	
	  /**
	   * Determines if the menu should be shown.
	   * @returns {boolean}
	   */
	  function shouldShow() {
	    return (isMinLengthMet() && hasMatches()) || notFoundVisible();
	  }
	
	  /**
	   * Returns true if the search text has matches.
	   * @returns {boolean}
	   */
	  function hasMatches() {
	    return ctrl.matches.length ? true : false;
	  }
	
	  /**
	   * Returns true if the autocomplete has a valid selection.
	   * @returns {boolean}
	   */
	  function hasSelection() {
	    return ctrl.scope.selectedItem ? true : false;
	  }
	
	  /**
	   * Returns true if the loading indicator is, or should be, visible.
	   * @returns {boolean}
	   */
	  function loadingIsVisible() {
	    return ctrl.loading && !hasSelection();
	  }
	
	  /**
	   * Returns the display value of the current item.
	   * @returns {*}
	   */
	  function getCurrentDisplayValue () {
	    return getDisplayValue(ctrl.matches[ ctrl.index ]);
	  }
	
	  /**
	   * Determines if the minimum length is met by the search text.
	   * @returns {*}
	   */
	  function isMinLengthMet () {
	    return ($scope.searchText || '').length >= getMinLength();
	  }
	
	  //-- actions
	
	  /**
	   * Defines a public property with a handler and a default value.
	   * @param key
	   * @param handler
	   * @param value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Selects the item at the given index.
	   * @param index
	   */
	  function select (index) {
	    //-- force form to update state for validation
	    $mdUtil.nextTick(function () {
	      getDisplayValue(ctrl.matches[ index ]).then(function (val) {
	        var ngModel = elements.$.input.controller('ngModel');
	        ngModel.$setViewValue(val);
	        ngModel.$render();
	      }).finally(function () {
	        $scope.selectedItem = ctrl.matches[ index ];
	        setLoading(false);
	      });
	    }, false);
	  }
	
	  /**
	   * Clears the searchText value and selected item.
	   */
	  function clearValue () {
	    clearSelectedItem();
	    clearSearchText();
	  }
	
	  /**
	   * Clears the selected item
	   */
	  function clearSelectedItem () {
	    // Reset our variables
	    ctrl.index = 0;
	    ctrl.matches = [];
	  }
	
	  /**
	   * Clears the searchText value
	   */
	  function clearSearchText () {
	    // Set the loading to true so we don't see flashes of content.
	    // The flashing will only occur when an async request is running.
	    // So the loading process will stop when the results had been retrieved.
	    setLoading(true);
	
	    $scope.searchText = '';
	
	    // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
	    // But some browsers are not detecting it properly, which means that we have to trigger the event.
	    // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
	    // The `change` event is a good alternative and is supported by all supported browsers.
	    var eventObj = document.createEvent('CustomEvent');
	    eventObj.initCustomEvent('change', true, true, { value: '' });
	    elements.input.dispatchEvent(eventObj);
	
	    // For some reason, firing the above event resets the value of $scope.searchText if
	    // $scope.searchText has a space character at the end, so we blank it one more time and then
	    // focus.
	    elements.input.blur();
	    $scope.searchText = '';
	    elements.input.focus();
	  }
	
	  /**
	   * Fetches the results for the provided search text.
	   * @param searchText
	   */
	  function fetchResults (searchText) {
	    var items = $scope.$parent.$eval(itemExpr),
	        term  = searchText.toLowerCase(),
	        isList = angular.isArray(items),
	        isPromise = !!items.then; // Every promise should contain a `then` property
	
	    if (isList) onResultsRetrieved(items);
	    else if (isPromise) handleAsyncResults(items);
	
	    function handleAsyncResults(items) {
	      if ( !items ) return;
	
	      items = $q.when(items);
	      fetchesInProgress++;
	      setLoading(true);
	
	      $mdUtil.nextTick(function () {
	          items
	            .then(onResultsRetrieved)
	            .finally(function(){
	              if (--fetchesInProgress === 0) {
	                setLoading(false);
	              }
	            });
	      },true, $scope);
	    }
	
	    function onResultsRetrieved(matches) {
	      cache[term] = matches;
	
	      // Just cache the results if the request is now outdated.
	      // The request becomes outdated, when the new searchText has changed during the result fetching.
	      if ((searchText || '') !== ($scope.searchText || '')) {
	        return;
	      }
	
	      handleResults(matches);
	    }
	  }
	
	
	  /**
	   * Reports given message types to supported screenreaders.
	   * @param {boolean} isPolite Whether the announcement should be polite.
	   * @param {!number} types Message flags to be reported to the screenreader.
	   */
	  function reportMessages(isPolite, types) {
	
	    var politeness = isPolite ? 'polite' : 'assertive';
	    var messages = [];
	
	    if (types & ReportType.Selected && ctrl.index !== -1) {
	      messages.push(getCurrentDisplayValue());
	    }
	
	    if (types & ReportType.Count) {
	      messages.push($q.resolve(getCountMessage()));
	    }
	
	    $q.all(messages).then(function(data) {
	      $mdLiveAnnouncer.announce(data.join(' '), politeness);
	    });
	
	  }
	
	  /**
	   * Returns the ARIA message for how many results match the current query.
	   * @returns {*}
	   */
	  function getCountMessage () {
	    switch (ctrl.matches.length) {
	      case 0:
	        return 'There are no matches available.';
	      case 1:
	        return 'There is 1 match available.';
	      default:
	        return 'There are ' + ctrl.matches.length + ' matches available.';
	    }
	  }
	
	  /**
	   * Makes sure that the focused element is within view.
	   */
	  function updateScroll () {
	    if (!elements.li[0]) return;
	    var height = elements.li[0].offsetHeight,
	        top = height * ctrl.index,
	        bot = top + height,
	        hgt = elements.scroller.clientHeight,
	        scrollTop = elements.scroller.scrollTop;
	    if (top < scrollTop) {
	      scrollTo(top);
	    } else if (bot > scrollTop + hgt) {
	      scrollTo(bot - hgt);
	    }
	  }
	
	  function isPromiseFetching() {
	    return fetchesInProgress !== 0;
	  }
	
	  function scrollTo (offset) {
	    elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
	  }
	
	  function notFoundVisible () {
	    var textLength = (ctrl.scope.searchText || '').length;
	
	    return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
	  }
	
	  /**
	   * Starts the query to gather the results for the current searchText.  Attempts to return cached
	   * results first, then forwards the process to `fetchResults` if necessary.
	   */
	  function handleQuery () {
	    var searchText = $scope.searchText || '';
	    var term = searchText.toLowerCase();
	
	    // If caching is enabled and the current searchText is stored in the cache
	    if (!$scope.noCache && cache[term]) {
	      // The results should be handled as same as a normal un-cached request does.
	      handleResults(cache[term]);
	    } else {
	      fetchResults(searchText);
	    }
	
	    ctrl.hidden = shouldHide();
	  }
	
	  /**
	   * Handles the retrieved results by showing them in the autocompletes dropdown.
	   * @param results Retrieved results
	   */
	  function handleResults(results) {
	    ctrl.matches = results;
	    ctrl.hidden  = shouldHide();
	
	    // If loading is in progress, then we'll end the progress. This is needed for example,
	    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
	    if (ctrl.loading) setLoading(false);
	
	    if ($scope.selectOnMatch) selectItemOnMatch();
	
	    positionDropdown();
	    reportMessages(true, ReportType.Count);
	  }
	
	  /**
	   * If there is only one matching item and the search text matches its display value exactly,
	   * automatically select that item.  Note: This function is only called if the user uses the
	   * `md-select-on-match` flag.
	   */
	  function selectItemOnMatch () {
	    var searchText = $scope.searchText,
	        matches    = ctrl.matches,
	        item       = matches[ 0 ];
	    if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
	      var isMatching = searchText == displayValue;
	      if ($scope.matchInsensitive && !isMatching) {
	        isMatching = searchText.toLowerCase() == displayValue.toLowerCase();
	      }
	
	      if (isMatching) select(0);
	    });
	  }
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   * @param {Object?} locals Properties to be injected into the evaluation context.
	   */
	 function evalAttr(attr, locals) {
	    if ($attrs[attr]) {
	      $scope.$parent.$eval($attrs[attr], locals || {});
	    }
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocomplete.$inject = ["$$mdSvgRegistry"];angular
	    .module('material.components.autocomplete')
	    .directive('mdAutocomplete', MdAutocomplete);
	
	/**
	 * @ngdoc directive
	 * @name mdAutocomplete
	 * @module material.components.autocomplete
	 *
	 * @description
	 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
	 *     custom query. This component allows you to provide real-time suggestions as the user types
	 *     in the input area.
	 *
	 * To start, you will need to specify the required parameters and provide a template for your
	 *     results. The content inside `md-autocomplete` will be treated as a template.
	 *
	 * In more complex cases, you may want to include other content such as a message to display when
	 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
	 *     adding a tag for `md-not-found`.  An example of this is shown below.
	 *
	 * To reset the displayed value you must clear both values for `md-search-text` and `md-selected-item`.
	 *
	 * ### Validation
	 *
	 * You can use `ng-messages` to include validation the same way that you would normally validate;
	 *     however, if you want to replicate a standard input with a floating label, you will have to
	 *     do the following:
	 *
	 * - Make sure that your template is wrapped in `md-item-template`
	 * - Add your `ng-messages` code inside of `md-autocomplete`
	 * - Add your validation properties to `md-autocomplete` (ie. `required`)
	 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
	 *
	 * There is an example below of how this should look.
	 *
	 * ### Snapping Drop-Down
	 *
	 * You can cause the autocomplete drop-down to snap to an ancestor element by applying the
	 *     `md-autocomplete-snap` attribute to that element. You can also snap to the width of
	 *     the `md-autocomplete-snap` element by setting the attribute's value to `width`
	 *     (ie. `md-autocomplete-snap="width"`).
	 *
	 * ### Notes
	 *
	 * **Autocomplete Dropdown Items Rendering**
	 *
	 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeat</a>
	 * directive for displaying the results inside of the dropdown.<br/>
	 *
	 * > When encountering issues regarding the item template please take a look at the
	 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
	 *
	 * **Autocomplete inside of a Virtual Repeat**
	 *
	 * When using the `md-autocomplete` directive inside of a
	 * <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> the dropdown items might
	 * not update properly, because caching of the results is enabled by default.
	 *
	 * The autocomplete will then show invalid dropdown items, because the VirtualRepeat only updates the
	 * scope bindings, rather than re-creating the `md-autocomplete` and the previous cached results will be used.
	 *
	 * > To avoid such problems ensure that the autocomplete does not cache any results.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-no-cache="true"
	 *       md-selected-item="selectedItem"
	 *       md-items="item in items"
	 *       md-search-text="searchText"
	 *       md-item-text="item.display">
	 *     <span>{{ item.display }}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 *
	 *
	 * @param {expression} md-items An expression in the format of `item in results` to iterate over
	 *     matches for your search.<br/><br/>
	 *     The `results` expression can be also a function, which returns the results synchronously
	 *     or asynchronously (per Promise)
	 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
	 *     selected
	 * @param {expression=} md-search-text-change An expression to be run each time the search text
	 *     updates
	 * @param {expression=} md-search-text A model to bind the search query text to
	 * @param {object=} md-selected-item A model to bind the selected item to
	 * @param {expression=} md-item-text An expression that will convert your object to a single string.
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete
	 * @param {boolean=} ng-disabled Determines whether or not to disable the input field
	 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
	 *     which will evaluate to false, when no item is currently selected.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *     make suggestions
	 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
	 *     for results
	 * @param {boolean=} md-clear-button Whether the clear button for the autocomplete input should show up or not.
	 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a `$mdDialog`,
	 *     `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening. <br/><br/>
	 *     Also the autocomplete will immediately focus the input element.
	 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating label
	 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
	 *     in the dropdown upon open.
	 * @param {string=} md-menu-class This will be applied to the dropdown menu for styling
	 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
	 *     `md-input-container`
	 * @param {string=} md-input-name The name attribute given to the input element to be used with
	 *     FormController
	 * @param {string=} md-select-on-focus When present the inputs text will be automatically selected
	 *     on focus.
	 * @param {string=} md-input-id An ID to be added to the input element
	 * @param {number=} md-input-minlength The minimum length for the input's value for validation
	 * @param {number=} md-input-maxlength The maximum length for the input's value for validation
	 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select exact
	 *     the item if the search text is an exact match. <br/><br/>
	 *     Exact match means that there is only one match showing up.
	 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
	 *     will select on case-insensitive match
	 * @param {string=} md-escape-options Override escape key logic. Default is `blur clear`.<br/>
	 *     Options: `blur | clear`, `none`
	 * @param {string=} md-dropdown-items Specifies the maximum amount of items to be shown in
	 *     the dropdown.<br/><br/>
	 *     When the dropdown doesn't fit into the viewport, the dropdown will shrink
	 *     as less as possible.
	 * @param {string=} md-dropdown-position Overrides the default dropdown position. Options: `top`, `bottom`.
	 * @param {string=} ng-trim If set to false, the search text will be not trimmed automatically.
	 *     Defaults to true.
	 * @param {string=} ng-pattern Adds the pattern validator to the ngModel of the search text.
	 *     [ngPattern Directive](https://docs.angularjs.org/api/ng/directive/ngPattern)
	 *
	 * @usage
	 * ### Basic Example
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with "not found" message
	 * <hljs lang="html">
	 * <md-autocomplete
	 *     md-selected-item="selectedItem"
	 *     md-search-text="searchText"
	 *     md-items="item in getMatches(searchText)"
	 *     md-item-text="item.display">
	 *   <md-item-template>
	 *     <span md-highlight-text="searchText">{{item.display}}</span>
	 *   </md-item-template>
	 *   <md-not-found>
	 *     No matches found.
	 *   </md-not-found>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
	 *     different parts that make up our component.
	 *
	 * ### Clear button for the input
	 * By default, for floating label autocomplete's the clear button is not showing up
	 * ([See specs](https://material.google.com/components/text-fields.html#text-fields-auto-complete-text-field))
	 *
	 * Nevertheless, developers are able to explicitly toggle the clear button for all types of autocomplete's.
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete ... md-clear-button="true"></md-autocomplete>
	 *   <md-autocomplete ... md-clear-button="false"></md-autocomplete>
	 * </hljs>
	 *
	 * ### Example with validation
	 * <hljs lang="html">
	 * <form name="autocompleteForm">
	 *   <md-autocomplete
	 *       required
	 *       md-input-name="autocomplete"
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in getMatches(searchText)"
	 *       md-item-text="item.display">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item.display}}</span>
	 *     </md-item-template>
	 *     <div ng-messages="autocompleteForm.autocomplete.$error">
	 *       <div ng-message="required">This field is required</div>
	 *     </div>
	 *   </md-autocomplete>
	 * </form>
	 * </hljs>
	 *
	 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
	 *     input validation for the field.
	 *
	 * ### Asynchronous Results
	 * The autocomplete items expression also supports promises, which will resolve with the query results.
	 *
	 * <hljs lang="js">
	 *   function AppController($scope, $http) {
	 *     $scope.query = function(searchText) {
	 *       return $http
	 *         .get(BACKEND_URL + '/items/' + searchText)
	 *         .then(function(data) {
	 *           // Map the response object to the data object.
	 *           return data;
	 *         });
	 *     };
	 *   }
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *   <md-autocomplete
	 *       md-selected-item="selectedItem"
	 *       md-search-text="searchText"
	 *       md-items="item in query(searchText)">
	 *     <md-item-template>
	 *       <span md-highlight-text="searchText">{{item}}</span>
	 *     </md-item-template>
	 * </md-autocomplete>
	 * </hljs>
	 *
	 */
	
	function MdAutocomplete ($$mdSvgRegistry) {
	
	  return {
	    controller:   'MdAutocompleteCtrl',
	    controllerAs: '$mdAutocompleteCtrl',
	    scope:        {
	      inputName:        '@mdInputName',
	      inputMinlength:   '@mdInputMinlength',
	      inputMaxlength:   '@mdInputMaxlength',
	      searchText:       '=?mdSearchText',
	      selectedItem:     '=?mdSelectedItem',
	      itemsExpr:        '@mdItems',
	      itemText:         '&mdItemText',
	      placeholder:      '@placeholder',
	      noCache:          '=?mdNoCache',
	      requireMatch:     '=?mdRequireMatch',
	      selectOnMatch:    '=?mdSelectOnMatch',
	      matchInsensitive: '=?mdMatchCaseInsensitive',
	      itemChange:       '&?mdSelectedItemChange',
	      textChange:       '&?mdSearchTextChange',
	      minLength:        '=?mdMinLength',
	      delay:            '=?mdDelay',
	      autofocus:        '=?mdAutofocus',
	      floatingLabel:    '@?mdFloatingLabel',
	      autoselect:       '=?mdAutoselect',
	      menuClass:        '@?mdMenuClass',
	      inputId:          '@?mdInputId',
	      escapeOptions:    '@?mdEscapeOptions',
	      dropdownItems:    '=?mdDropdownItems',
	      dropdownPosition: '@?mdDropdownPosition',
	      clearButton:      '=?mdClearButton'
	    },
	    compile: function(tElement, tAttrs) {
	      var attributes = ['md-select-on-focus', 'md-no-asterisk', 'ng-trim', 'ng-pattern'];
	      var input = tElement.find('input');
	
	      attributes.forEach(function(attribute) {
	        var attrValue = tAttrs[tAttrs.$normalize(attribute)];
	
	        if (attrValue !== null) {
	          input.attr(attribute, attrValue);
	        }
	      });
	
	      return function(scope, element, attrs, ctrl) {
	        // Retrieve the state of using a md-not-found template by using our attribute, which will
	        // be added to the element in the template function.
	        ctrl.hasNotFound = !!element.attr('md-has-not-found');
	
	        // By default the inset autocomplete should show the clear button when not explicitly overwritten.
	        if (!angular.isDefined(attrs.mdClearButton) && !scope.floatingLabel) {
	          scope.clearButton = true;
	        }
	      }
	    },
	    template:     function (element, attr) {
	      var noItemsTemplate = getNoItemsTemplate(),
	          itemTemplate    = getItemTemplate(),
	          leftover        = element.html(),
	          tabindex        = attr.tabindex;
	
	      // Set our attribute for the link function above which runs later.
	      // We will set an attribute, because otherwise the stored variables will be trashed when
	      // removing the element is hidden while retrieving the template. For example when using ngIf.
	      if (noItemsTemplate) element.attr('md-has-not-found', true);
	
	      // Always set our tabindex of the autocomplete directive to -1, because our input
	      // will hold the actual tabindex.
	      element.attr('tabindex', '-1');
	
	      return '\
	        <md-autocomplete-wrap\
	            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
	                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
	                        \'md-show-clear-button\': !!clearButton }">\
	          ' + getInputElement() + '\
	          ' + getClearButton() + '\
	          <md-progress-linear\
	              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
	              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
	              md-mode="indeterminate"></md-progress-linear>\
	          <md-virtual-repeat-container\
	              md-auto-shrink\
	              md-auto-shrink-min="1"\
	              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
	              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
	              ng-mouseup="$mdAutocompleteCtrl.mouseUp()"\
	              ng-hide="$mdAutocompleteCtrl.hidden"\
	              class="md-autocomplete-suggestions-container md-whiteframe-z1"\
	              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
	              role="presentation">\
	            <ul class="md-autocomplete-suggestions"\
	                ng-class="::menuClass"\
	                id="ul-{{$mdAutocompleteCtrl.id}}">\
	              <li md-virtual-repeat="item in $mdAutocompleteCtrl.matches"\
	                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
	                  ng-click="$mdAutocompleteCtrl.select($index)"\
	                  md-extra-name="$mdAutocompleteCtrl.itemName">\
	                  ' + itemTemplate + '\
	                  </li>' + noItemsTemplate + '\
	            </ul>\
	          </md-virtual-repeat-container>\
	        </md-autocomplete-wrap>';
	
	      function getItemTemplate() {
	        var templateTag = element.find('md-item-template').detach(),
	            html = templateTag.length ? templateTag.html() : element.html();
	        if (!templateTag.length) element.empty();
	        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html + '</md-autocomplete-parent-scope>';
	      }
	
	      function getNoItemsTemplate() {
	        var templateTag = element.find('md-not-found').detach(),
	            template = templateTag.length ? templateTag.html() : '';
	        return template
	            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
	                         md-autocomplete-parent-scope>' + template + '</li>'
	            : '';
	
	      }
	
	      function getInputElement () {
	        if (attr.mdFloatingLabel) {
	          return '\
	            <md-input-container ng-if="floatingLabel">\
	              <label>{{floatingLabel}}</label>\
	              <input type="search"\
	                  ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                  id="{{ inputId || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
	                  name="{{inputName}}"\
	                  autocomplete="off"\
	                  ng-required="$mdAutocompleteCtrl.isRequired"\
	                  ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                  ng-minlength="inputMinlength"\
	                  ng-maxlength="inputMaxlength"\
	                  ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                  ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                  ng-model-options="{ allowInvalid: true }"\
	                  ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                  ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                  ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                  aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                  aria-label="{{floatingLabel}}"\
	                  aria-autocomplete="list"\
	                  role="combobox"\
	                  aria-haspopup="true"\
	                  aria-activedescendant=""\
	                  aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
	              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
	            </md-input-container>';
	        } else {
	          return '\
	            <input type="search"\
	                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
	                id="{{ inputId || \'input-\' + $mdAutocompleteCtrl.id }}"\
	                name="{{inputName}}"\
	                ng-if="!floatingLabel"\
	                autocomplete="off"\
	                ng-required="$mdAutocompleteCtrl.isRequired"\
	                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
	                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
	                ng-minlength="inputMinlength"\
	                ng-maxlength="inputMaxlength"\
	                ng-model="$mdAutocompleteCtrl.scope.searchText"\
	                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
	                ng-blur="$mdAutocompleteCtrl.blur($event)"\
	                ng-focus="$mdAutocompleteCtrl.focus($event)"\
	                placeholder="{{placeholder}}"\
	                aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
	                aria-label="{{placeholder}}"\
	                aria-autocomplete="list"\
	                role="combobox"\
	                aria-haspopup="true"\
	                aria-activedescendant=""\
	                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>';
	        }
	      }
	
	      function getClearButton() {
	        return '' +
	          '<button ' +
	              'type="button" ' +
	              'aria-label="Clear Input" ' +
	              'tabindex="-1" ' +
	              'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText && !$mdAutocompleteCtrl.isDisabled" ' +
	              'ng-click="$mdAutocompleteCtrl.clear($event)">' +
	            '<md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>' +
	          '</button>';
	        }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];angular
	  .module('material.components.autocomplete')
	  .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);
	
	function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
	  return {
	    restrict: 'AE',
	    compile: compile,
	    terminal: true,
	    transclude: 'element'
	  };
	
	  function compile(tElement, tAttr, transclude) {
	    return function postLink(scope, element, attr) {
	      var ctrl = scope.$mdAutocompleteCtrl;
	      var newScope = ctrl.parent.$new();
	      var itemName = ctrl.itemName;
	
	      // Watch for changes to our scope's variables and copy them to the new scope
	      watchVariable('$index', '$index');
	      watchVariable('item', itemName);
	
	      // Ensure that $digest calls on our scope trigger $digest on newScope.
	      connectScopes();
	
	      // Link the element against newScope.
	      transclude(newScope, function(clone) {
	        element.after(clone);
	      });
	
	      /**
	       * Creates a watcher for variables that are copied from the parent scope
	       * @param variable
	       * @param alias
	       */
	      function watchVariable(variable, alias) {
	        newScope[alias] = scope[variable];
	
	        scope.$watch(variable, function(value) {
	          $mdUtil.nextTick(function() {
	            newScope[alias] = value;
	          });
	        });
	      }
	
	      /**
	       * Creates watchers on scope and newScope that ensure that for any
	       * $digest of scope, newScope is also $digested.
	       */
	      function connectScopes() {
	        var scopeDigesting = false;
	        var newScopeDigesting = false;
	
	        scope.$watch(function() {
	          if (newScopeDigesting || scopeDigesting) {
	            return;
	          }
	
	          scopeDigesting = true;
	          scope.$$postDigest(function() {
	            if (!newScopeDigesting) {
	              newScope.$digest();
	            }
	
	            scopeDigesting = newScopeDigesting = false;
	          });
	        });
	
	        newScope.$watch(function() {
	          newScopeDigesting = true;
	        });
	      }
	    };
	  }
	}
	})();
	(function(){
	"use strict";
	
	
	MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs"];angular
	    .module('material.components.autocomplete')
	    .controller('MdHighlightCtrl', MdHighlightCtrl);
	
	function MdHighlightCtrl ($scope, $element, $attrs) {
	  this.$scope = $scope;
	  this.$element = $element;
	  this.$attrs = $attrs;
	
	  // Cache the Regex to avoid rebuilding each time.
	  this.regex = null;
	}
	
	MdHighlightCtrl.prototype.init = function(unsafeTermFn, unsafeContentFn) {
	
	  this.flags = this.$attrs.mdHighlightFlags || '';
	
	  this.unregisterFn = this.$scope.$watch(function($scope) {
	    return {
	      term: unsafeTermFn($scope),
	      contentText: unsafeContentFn($scope)
	    };
	  }.bind(this), this.onRender.bind(this), true);
	
	  this.$element.on('$destroy', this.unregisterFn);
	};
	
	/**
	 * Triggered once a new change has been recognized and the highlighted
	 * text needs to be updated.
	 */
	MdHighlightCtrl.prototype.onRender = function(state, prevState) {
	
	  var contentText = state.contentText;
	
	  /* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */
	  if (this.regex === null || state.term !== prevState.term) {
	    this.regex = this.createRegex(state.term, this.flags);
	  }
	
	  /* If a term is available apply the regex to the content */
	  if (state.term) {
	    this.applyRegex(contentText);
	  } else {
	    this.$element.text(contentText);
	  }
	
	};
	
	/**
	 * Decomposes the specified text into different tokens (whether match or not).
	 * Breaking down the string guarantees proper XSS protection due to the native browser
	 * escaping of unsafe text.
	 */
	MdHighlightCtrl.prototype.applyRegex = function(text) {
	  var tokens = this.resolveTokens(text);
	
	  this.$element.empty();
	
	  tokens.forEach(function (token) {
	
	    if (token.isMatch) {
	      var tokenEl = angular.element('<span class="highlight">').text(token.text);
	
	      this.$element.append(tokenEl);
	    } else {
	      this.$element.append(document.createTextNode(token));
	    }
	
	  }.bind(this));
	
	};
	
	  /**
	 * Decomposes the specified text into different tokens by running the regex against the text.
	 */
	MdHighlightCtrl.prototype.resolveTokens = function(string) {
	  var tokens = [];
	  var lastIndex = 0;
	
	  // Use replace here, because it supports global and single regular expressions at same time.
	  string.replace(this.regex, function(match, index) {
	    appendToken(lastIndex, index);
	
	    tokens.push({
	      text: match,
	      isMatch: true
	    });
	
	    lastIndex = index + match.length;
	  });
	
	  // Append the missing text as a token.
	  appendToken(lastIndex);
	
	  return tokens;
	
	  function appendToken(from, to) {
	    var targetText = string.slice(from, to);
	    targetText && tokens.push(targetText);
	  }
	};
	
	/** Creates a regex for the specified text with the given flags. */
	MdHighlightCtrl.prototype.createRegex = function(term, flags) {
	  var startFlag = '', endFlag = '';
	  var regexTerm = this.sanitizeRegex(term);
	
	  if (flags.indexOf('^') >= 0) startFlag = '^';
	  if (flags.indexOf('$') >= 0) endFlag = '$';
	
	  return new RegExp(startFlag + regexTerm + endFlag, flags.replace(/[$\^]/g, ''));
	};
	
	/** Sanitizes a regex by removing all common RegExp identifiers */
	MdHighlightCtrl.prototype.sanitizeRegex = function(term) {
	  return term && term.toString().replace(/[\\\^\$\*\+\?\.\(\)\|\{}\[\]]/g, '\\$&');
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdHighlight.$inject = ["$interpolate", "$parse"];angular
	    .module('material.components.autocomplete')
	    .directive('mdHighlightText', MdHighlight);
	
	/**
	 * @ngdoc directive
	 * @name mdHighlightText
	 * @module material.components.autocomplete
	 *
	 * @description
	 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
	 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
	 *     be styled through CSS.  Please note that child elements may not be used with this directive.
	 *
	 * @param {string} md-highlight-text A model to be searched for
	 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
	 * #### **Supported flags**:
	 * - `g`: Find all matches within the provided text
	 * - `i`: Ignore case when searching for matches
	 * - `$`: Only match if the text ends with the search term
	 * - `^`: Only match if the text begins with the search term
	 *
	 * @usage
	 * <hljs lang="html">
	 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
	 * <ul>
	 *   <li ng-repeat="result in results" md-highlight-text="searchTerm">
	 *     {{result.text}}
	 *   </li>
	 * </ul>
	 * </hljs>
	 */
	
	function MdHighlight ($interpolate, $parse) {
	  return {
	    terminal: true,
	    controller: 'MdHighlightCtrl',
	    compile: function mdHighlightCompile(tElement, tAttr) {
	      var termExpr = $parse(tAttr.mdHighlightText);
	      var unsafeContentExpr = $interpolate(tElement.html());
	
	      return function mdHighlightLink(scope, element, attr, ctrl) {
	        ctrl.init(termExpr, unsafeContentExpr);
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];angular
	  .module('material.components.chips')
	  .controller('MdChipCtrl', MdChipCtrl);
	
	/**
	 * Controller for the MdChip component. Responsible for handling keyboard
	 * events and editting the chip if needed.
	 *
	 * @param $scope
	 * @param $element
	 * @param $mdConstant
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipCtrl ($scope, $element, $mdConstant, $timeout, $mdUtil) {
	  /**
	   * @type {$scope}
	   */
	  this.$scope = $scope;
	
	  /**
	   * @type {$element}
	   */
	  this.$element = $element;
	
	  /**
	   * @type {$mdConstant}
	   */
	  this.$mdConstant = $mdConstant;
	
	  /**
	   * @type {$timeout}
	   */
	  this.$timeout = $timeout;
	
	  /**
	   * @type {$mdUtil}
	   */
	  this.$mdUtil = $mdUtil;
	
	  /**
	   * @type {boolean}
	   */
	  this.isEditting = false;
	
	  /**
	   * @type {MdChipsCtrl}
	   */
	  this.parentController = undefined;
	
	  /**
	   * @type {boolean}
	   */
	  this.enableChipEdit = false;
	}
	
	
	/**
	 * @param {MdChipsCtrl} controller
	 */
	MdChipCtrl.prototype.init = function(controller) {
	  this.parentController = controller;
	  this.enableChipEdit = this.parentController.enableChipEdit;
	
	  if (this.enableChipEdit) {
	    this.$element.on('keydown', this.chipKeyDown.bind(this));
	    this.$element.on('mousedown', this.chipMouseDown.bind(this));
	    this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
	  }
	};
	
	
	/**
	 * @return {Object}
	 */
	MdChipCtrl.prototype.getChipContent = function() {
	  var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
	  return angular.element(chipContents[0]);
	};
	
	
	/**
	 * @return {Object}
	 */
	MdChipCtrl.prototype.getContentElement = function() {
	  return angular.element(this.getChipContent().children()[0]);
	};
	
	
	/**
	 * @return {number}
	 */
	MdChipCtrl.prototype.getChipIndex = function() {
	  return parseInt(this.$element.attr('index'));
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goOutOfEditMode = function() {
	  if (!this.isEditting) return;
	
	  this.isEditting = false;
	  this.$element.removeClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'false';
	  var chipIndex = this.getChipIndex();
	
	  var content = this.getContentElement().text();
	  if (content) {
	    this.parentController.updateChipContents(
	        chipIndex,
	        this.getContentElement().text()
	    );
	
	    this.$mdUtil.nextTick(function() {
	      if (this.parentController.selectedChip === chipIndex) {
	        this.parentController.focusChip(chipIndex);
	      }
	    }.bind(this));
	  } else {
	    this.parentController.removeChipAndFocusInput(chipIndex);
	  }
	};
	
	
	/**
	 * Given an HTML element. Selects contents of it.
	 * @param node
	 */
	MdChipCtrl.prototype.selectNodeContents = function(node) {
	  var range, selection;
	  if (document.body.createTextRange) {
	    range = document.body.createTextRange();
	    range.moveToElementText(node);
	    range.select();
	  } else if (window.getSelection) {
	    selection = window.getSelection();
	    range = document.createRange();
	    range.selectNodeContents(node);
	    selection.removeAllRanges();
	    selection.addRange(range);
	  }
	};
	
	
	/**
	 * Presents an input element to edit the contents of the chip.
	 */
	MdChipCtrl.prototype.goInEditMode = function() {
	  this.isEditting = true;
	  this.$element.addClass('_md-chip-editing');
	  this.getChipContent()[0].contentEditable = 'true';
	  this.getChipContent().on('blur', function() {
	    this.goOutOfEditMode();
	  }.bind(this));
	
	  this.selectNodeContents(this.getChipContent()[0]);
	};
	
	
	/**
	 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
	 * set to true, space or enter keys can trigger going into edit mode. Enter can also
	 * trigger submitting if the chip is already being edited.
	 * @param event
	 */
	MdChipCtrl.prototype.chipKeyDown = function(event) {
	  if (!this.isEditting &&
	    (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
	    event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
	    event.preventDefault();
	    this.goInEditMode();
	  } else if (this.isEditting &&
	    event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
	    event.preventDefault();
	    this.goOutOfEditMode();
	  }
	};
	
	
	/**
	 * Handles the double click event
	 */
	MdChipCtrl.prototype.chipMouseDown = function() {
	  if(this.getChipIndex() == this.parentController.selectedChip &&
	    this.enableChipEdit &&
	    !this.isEditting) {
	    this.goInEditMode();
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdChip.$inject = ["$mdTheming", "$mdUtil", "$compile", "$timeout"];angular
	  .module('material.components.chips')
	  .directive('mdChip', MdChip);
	
	/**
	 * @ngdoc directive
	 * @name mdChip
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-chip>` is a component used within `<md-chips>` and is responsible for rendering individual
	 * chips.
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chip>{{$chip}}</md-chip>
	 * </hljs>
	 *
	 */
	
	// This hint text is hidden within a chip but used by screen readers to
	// inform the user how they can interact with a chip.
	var DELETE_HINT_TEMPLATE = '\
	    <span ng-if="!$mdChipsCtrl.readonly" class="md-visually-hidden">\
	      {{$mdChipsCtrl.deleteHint}}\
	    </span>';
	
	/**
	 * MDChip Directive Definition
	 *
	 * @param $mdTheming
	 * @param $mdUtil
	 * @ngInject
	 */
	function MdChip($mdTheming, $mdUtil, $compile, $timeout) {
	  var deleteHintTemplate = $mdUtil.processTemplate(DELETE_HINT_TEMPLATE);
	
	  return {
	    restrict: 'E',
	    require: ['^?mdChips', 'mdChip'],
	    link: postLink,
	    controller: 'MdChipCtrl'
	  };
	
	  function postLink(scope, element, attr, ctrls) {
	    var chipsController = ctrls.shift();
	    var chipController = ctrls.shift();
	    var chipContentElement = angular.element(element[0].querySelector('.md-chip-content'));
	
	    $mdTheming(element);
	
	    if (chipsController) {
	      chipController.init(chipsController);
	
	      // Append our delete hint to the div.md-chip-content (which does not exist at compile time)
	      chipContentElement.append($compile(deleteHintTemplate)(scope));
	
	      // When a chip is blurred, make sure to unset (or reset) the selected chip so that tabbing
	      // through elements works properly
	      chipContentElement.on('blur', function() {
	        chipsController.resetSelectedChip();
	        chipsController.$scope.$applyAsync();
	      });
	    }
	
	    // Use $timeout to ensure we run AFTER the element has been added to the DOM so we can focus it.
	    $timeout(function() {
	      if (!chipsController) {
	        return;
	      }
	
	      if (chipsController.shouldFocusLastChip) {
	        chipsController.focusLastChipThenInput();
	      }
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipRemove.$inject = ["$timeout"];angular
	    .module('material.components.chips')
	    .directive('mdChipRemove', MdChipRemove);
	
	/**
	 * @ngdoc directive
	 * @name mdChipRemove
	 * @restrict A
	 * @module material.components.chips
	 *
	 * @description
	 * Designates an element to be used as the delete button for a chip. <br/>
	 * This element is passed as a child of the `md-chips` element.
	 *
	 * The designated button will be just appended to the chip and removes the given chip on click.<br/>
	 * By default the button is not being styled by the `md-chips` component.
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-chips>
	 *     <button md-chip-remove="">
	 *       <md-icon md-svg-icon="md-close"></md-icon>
	 *     </button>
	 *   </md-chips>
	 * </hljs>
	 */
	
	
	/**
	 * MdChipRemove Directive Definition.
	 * 
	 * @param $timeout
	 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
	 * @constructor
	 */
	function MdChipRemove ($timeout) {
	  return {
	    restrict: 'A',
	    require: '^mdChips',
	    scope: false,
	    link: postLink
	  };
	
	  function postLink(scope, element, attr, ctrl) {
	    element.on('click', function(event) {
	      scope.$apply(function() {
	        ctrl.removeChip(scope.$$replacedScope.$index);
	      });
	    });
	
	    // Child elements aren't available until after a $timeout tick as they are hidden by an
	    // `ng-if`. see http://goo.gl/zIWfuw
	    $timeout(function() {
	      element.attr({ tabindex: -1, 'aria-hidden': true });
	      element.find('button').attr('tabindex', '-1');
	    });
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdChipTransclude.$inject = ["$compile"];angular
	    .module('material.components.chips')
	    .directive('mdChipTransclude', MdChipTransclude);
	
	function MdChipTransclude ($compile) {
	  return {
	    restrict: 'EA',
	    terminal: true,
	    link: link,
	    scope: false
	  };
	  function link (scope, element, attr) {
	    var ctrl = scope.$parent.$mdChipsCtrl,
	        newScope = ctrl.parent.$new(false, ctrl.parent);
	    newScope.$$replacedScope = scope;
	    newScope.$chip = scope.$chip;
	    newScope.$index = scope.$index;
	    newScope.$mdChipsCtrl = ctrl;
	
	    var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);
	
	    element.html(newHtml);
	    $compile(element.contents())(newScope);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * The default chip append delay.
	 *
	 * @type {number}
	 */
	MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil"];
	var DEFAULT_CHIP_APPEND_DELAY = 300;
	
	angular
	    .module('material.components.chips')
	    .controller('MdChipsCtrl', MdChipsCtrl);
	
	/**
	 * Controller for the MdChips component. Responsible for adding to and
	 * removing from the list of chips, marking chips as selected, and binding to
	 * the models of various input components.
	 *
	 * @param $scope
	 * @param $attrs
	 * @param $mdConstant
	 * @param $log
	 * @param $element
	 * @param $timeout
	 * @param $mdUtil
	 * @constructor
	 */
	function MdChipsCtrl ($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil) {
	  /** @type {$timeout} **/
	  this.$timeout = $timeout;
	
	  /** @type {Object} */
	  this.$mdConstant = $mdConstant;
	
	  /** @type {angular.$scope} */
	  this.$scope = $scope;
	
	  /** @type {angular.$scope} */
	  this.parent = $scope.$parent;
	
	  /** @type {$mdUtil} */
	  this.$mdUtil = $mdUtil;
	
	  /** @type {$log} */
	  this.$log = $log;
	
	  /** @type {$element} */
	  this.$element = $element;
	
	  /** @type {$attrs} */
	  this.$attrs = $attrs;
	
	  /** @type {angular.NgModelController} */
	  this.ngModelCtrl = null;
	
	  /** @type {angular.NgModelController} */
	  this.userInputNgModelCtrl = null;
	
	  /** @type {MdAutocompleteCtrl} */
	  this.autocompleteCtrl = null;
	
	  /** @type {Element} */
	  this.userInputElement = null;
	
	  /** @type {Array.<Object>} */
	  this.items = [];
	
	  /** @type {number} */
	  this.selectedChip = -1;
	
	  /** @type {string} */
	  this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);
	
	  /** @type {string} */
	  this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);
	
	  /**
	   * The text to be used as the aria-label for the input.
	   * @type {string}
	   */
	  this.inputAriaLabel = 'Chips input.';
	
	  /**
	   * Hidden hint text to describe the chips container. Used to give context to screen readers when
	   * the chips are readonly and the input cannot be selected.
	   *
	   * @type {string}
	   */
	  this.containerHint = 'Chips container. Use arrow keys to select chips.';
	
	  /**
	   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteHint = 'Press delete to remove this chip.';
	
	  /**
	   * Hidden label for the delete button. Used to give context to screen readers.
	   * @type {string}
	   */
	  this.deleteButtonLabel = 'Remove';
	
	  /**
	   * Model used by the input element.
	   * @type {string}
	   */
	  this.chipBuffer = '';
	
	  /**
	   * Whether to use the transformChip expression to transform the chip buffer
	   * before appending it to the list.
	   * @type {boolean}
	   */
	  this.useTransformChip = false;
	
	  /**
	   * Whether to use the onAdd expression to notify of chip additions.
	   * @type {boolean}
	   */
	  this.useOnAdd = false;
	
	  /**
	   * Whether to use the onRemove expression to notify of chip removals.
	   * @type {boolean}
	   */
	  this.useOnRemove = false;
	
	  /**
	   * The ID of the chips wrapper which is used to build unique IDs for the chips and the aria-owns
	   * attribute.
	   *
	   * Defaults to '_md-chips-wrapper-' plus a unique number.
	   *
	   * @type {string}
	   */
	  this.wrapperId = '';
	
	  /**
	   * Array of unique numbers which will be auto-generated any time the items change, and is used to
	   * create unique IDs for the aria-owns attribute.
	   *
	   * @type {Array}
	   */
	  this.contentIds = [];
	
	  /**
	   * The index of the chip that should have it's tabindex property set to 0 so it is selectable
	   * via the keyboard.
	   *
	   * @type {int}
	   */
	  this.ariaTabIndex = null;
	
	  /**
	   * After appending a chip, the chip will be focused for this number of milliseconds before the
	   * input is refocused.
	   *
	   * **Note:** This is **required** for compatibility with certain screen readers in order for
	   * them to properly allow keyboard access.
	   *
	   * @type {number}
	   */
	  this.chipAppendDelay = DEFAULT_CHIP_APPEND_DELAY;
	
	  this.init();
	}
	
	/**
	 * Initializes variables and sets up watchers
	 */
	MdChipsCtrl.prototype.init = function() {
	  var ctrl = this;
	
	  // Set the wrapper ID
	  ctrl.wrapperId = '_md-chips-wrapper-' + ctrl.$mdUtil.nextUid();
	
	  // Setup a watcher which manages the role and aria-owns attributes
	  ctrl.$scope.$watchCollection('$mdChipsCtrl.items', function() {
	    // Make sure our input and wrapper have the correct ARIA attributes
	    ctrl.setupInputAria();
	    ctrl.setupWrapperAria();
	  });
	
	  ctrl.$attrs.$observe('mdChipAppendDelay', function(newValue) {
	    ctrl.chipAppendDelay = parseInt(newValue) || DEFAULT_CHIP_APPEND_DELAY;
	  });
	};
	
	/**
	 * If we have an input, ensure it has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupInputAria = function() {
	  var input = this.$element.find('input');
	
	  // If we have no input, just return
	  if (!input) {
	    return;
	  }
	
	  input.attr('role', 'textbox');
	  input.attr('aria-multiline', true);
	};
	
	/**
	 * Ensure our wrapper has the appropriate ARIA attributes.
	 */
	MdChipsCtrl.prototype.setupWrapperAria = function() {
	  var ctrl = this,
	      wrapper = this.$element.find('md-chips-wrap');
	
	  if (this.items && this.items.length) {
	    // Dynamically add the listbox role on every change because it must be removed when there are
	    // no items.
	    wrapper.attr('role', 'listbox');
	
	    // Generate some random (but unique) IDs for each chip
	    this.contentIds = this.items.map(function() {
	      return ctrl.wrapperId + '-chip-' + ctrl.$mdUtil.nextUid();
	    });
	
	    // Use the contentIDs above to generate the aria-owns attribute
	    wrapper.attr('aria-owns', this.contentIds.join(' '));
	  } else {
	    // If we have no items, then the role and aria-owns attributes MUST be removed
	    wrapper.removeAttr('role');
	    wrapper.removeAttr('aria-owns');
	  }
	};
	
	/**
	 * Handles the keydown event on the input element: by default <enter> appends
	 * the buffer to the chip list, while backspace removes the last chip in the
	 * list if the current buffer is empty.
	 * @param event
	 */
	MdChipsCtrl.prototype.inputKeydown = function(event) {
	  var chipBuffer = this.getChipBuffer();
	
	  // If we have an autocomplete, and it handled the event, we have nothing to do
	  if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
	    return;
	  }
	
	  if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
	    // Only select and focus the previous chip, if the current caret position of the
	    // input element is at the beginning.
	    if (this.getCursorPosition(event.target) !== 0) {
	      return;
	    }
	
	    event.preventDefault();
	    event.stopPropagation();
	
	    if (this.items.length) {
	      this.selectAndFocusChipSafe(this.items.length - 1);
	    }
	
	    return;
	  }
	
	  // By default <enter> appends the buffer to the chip list.
	  if (!this.separatorKeys || this.separatorKeys.length < 1) {
	    this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
	  }
	
	  // Support additional separator key codes in an array of `md-separator-keys`.
	  if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
	    if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
	    event.preventDefault();
	
	    // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	    if (this.hasMaxChipsReached()) return;
	
	    this.appendChip(chipBuffer.trim());
	    this.resetChipBuffer();
	
	    return false;
	  }
	};
	
	/**
	 * Returns the cursor position of the specified input element.
	 * @param element HTMLInputElement
	 * @returns {Number} Cursor Position of the input.
	 */
	MdChipsCtrl.prototype.getCursorPosition = function(element) {
	  /*
	   * Figure out whether the current input for the chips buffer is valid for using
	   * the selectionStart / end property to retrieve the cursor position.
	   * Some browsers do not allow the use of those attributes, on different input types.
	   */
	  try {
	    if (element.selectionStart === element.selectionEnd) {
	      return element.selectionStart;
	    }
	  } catch (e) {
	    if (!element.value) {
	      return 0;
	    }
	  }
	};
	
	
	/**
	 * Updates the content of the chip at given index
	 * @param chipIndex
	 * @param chipContents
	 */
	MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents){
	  if(chipIndex >= 0 && chipIndex < this.items.length) {
	    this.items[chipIndex] = chipContents;
	    this.ngModelCtrl.$setDirty();
	  }
	};
	
	
	/**
	 * Returns true if a chip is currently being edited. False otherwise.
	 * @return {boolean}
	 */
	MdChipsCtrl.prototype.isEditingChip = function() {
	  return !!this.$element[0].querySelector('._md-chip-editing');
	};
	
	
	MdChipsCtrl.prototype.isRemovable = function() {
	  // Return false if we have static chips
	  if (!this.ngModelCtrl) {
	    return false;
	  }
	
	  return this.readonly ? this.removable :
	         angular.isDefined(this.removable) ? this.removable : true;
	};
	
	/**
	 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
	 * keys switch which chips is active
	 * @param event
	 */
	MdChipsCtrl.prototype.chipKeydown = function (event) {
	  if (this.getChipBuffer()) return;
	  if (this.isEditingChip()) return;
	
	  switch (event.keyCode) {
	    case this.$mdConstant.KEY_CODE.BACKSPACE:
	    case this.$mdConstant.KEY_CODE.DELETE:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      // Cancel the delete action only after the event cancel. Otherwise the page will go back.
	      if (!this.isRemovable()) return;
	      this.removeAndSelectAdjacentChip(this.selectedChip);
	      break;
	    case this.$mdConstant.KEY_CODE.LEFT_ARROW:
	      event.preventDefault();
	      // By default, allow selection of -1 which will focus the input; if we're readonly, don't go
	      // below 0
	      if (this.selectedChip < 0 || (this.readonly && this.selectedChip == 0)) {
	        this.selectedChip = this.items.length;
	      }
	      if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
	      break;
	    case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
	      event.preventDefault();
	      this.selectAndFocusChipSafe(this.selectedChip + 1);
	      break;
	    case this.$mdConstant.KEY_CODE.ESCAPE:
	    case this.$mdConstant.KEY_CODE.TAB:
	      if (this.selectedChip < 0) return;
	      event.preventDefault();
	      this.onFocus();
	      break;
	  }
	};
	
	/**
	 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
	 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
	 * always.
	 */
	MdChipsCtrl.prototype.getPlaceholder = function() {
	  // Allow `secondary-placeholder` to be blank.
	  var useSecondary = (this.items && this.items.length &&
	      (this.secondaryPlaceholder == '' || this.secondaryPlaceholder));
	  return useSecondary ? this.secondaryPlaceholder : this.placeholder;
	};
	
	/**
	 * Removes chip at {@code index} and selects the adjacent chip.
	 * @param index
	 */
	MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index) {
	  var self = this;
	  var selIndex = self.getAdjacentChipIndex(index);
	  var wrap = this.$element[0].querySelector('md-chips-wrap');
	  var chip = this.$element[0].querySelector('md-chip[index="' + index + '"]');
	
	  self.removeChip(index);
	
	  // The dobule-timeout is currently necessary to ensure that the DOM has finalized and the select()
	  // will find the proper chip since the selection is index-based.
	  //
	  // TODO: Investigate calling from within chip $scope.$on('$destroy') to reduce/remove timeouts
	  self.$timeout(function() {
	    self.$timeout(function() {
	      self.selectAndFocusChipSafe(selIndex);
	    });
	  });
	};
	
	/**
	 * Sets the selected chip index to -1.
	 */
	MdChipsCtrl.prototype.resetSelectedChip = function() {
	  this.selectedChip = -1;
	  this.ariaTabIndex = null;
	};
	
	/**
	 * Gets the index of an adjacent chip to select after deletion. Adjacency is
	 * determined as the next chip in the list, unless the target chip is the
	 * last in the list, then it is the chip immediately preceding the target. If
	 * there is only one item in the list, -1 is returned (select none).
	 * The number returned is the index to select AFTER the target has been
	 * removed.
	 * If the current chip is not selected, then -1 is returned to select none.
	 */
	MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
	  var len = this.items.length - 1;
	  return (len == 0) ? -1 :
	      (index == len) ? index -1 : index;
	};
	
	/**
	 * Append the contents of the buffer to the chip list. This method will first
	 * call out to the md-transform-chip method, if provided.
	 *
	 * @param newChip
	 */
	MdChipsCtrl.prototype.appendChip = function(newChip) {
	  this.shouldFocusLastChip = true;
	  if (this.useTransformChip && this.transformChip) {
	    var transformedChip = this.transformChip({'$chip': newChip});
	
	    // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
	    // they want the string version.
	    if (angular.isDefined(transformedChip)) {
	      newChip = transformedChip;
	    }
	  }
	
	  // If items contains an identical object to newChip, do not append
	  if (angular.isObject(newChip)){
	    var identical = this.items.some(function(item){
	      return angular.equals(newChip, item);
	    });
	    if (identical) return;
	  }
	
	  // Check for a null (but not undefined), or existing chip and cancel appending
	  if (newChip == null || this.items.indexOf(newChip) + 1) return;
	
	  // Append the new chip onto our list
	  var length = this.items.push(newChip);
	  var index = length - 1;
	
	  // Update model validation
	  this.ngModelCtrl.$setDirty();
	  this.validateModel();
	
	  // If they provide the md-on-add attribute, notify them of the chip addition
	  if (this.useOnAdd && this.onAdd) {
	    this.onAdd({ '$chip': newChip, '$index': index });
	  }
	};
	
	/**
	 * Sets whether to use the md-transform-chip expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code transformChip}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useTransformChipExpression = function() {
	  this.useTransformChip = true;
	};
	
	/**
	 * Sets whether to use the md-on-add expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onAdd}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnAddExpression = function() {
	  this.useOnAdd = true;
	};
	
	/**
	 * Sets whether to use the md-on-remove expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onRemove}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnRemoveExpression = function() {
	  this.useOnRemove = true;
	};
	
	/*
	 * Sets whether to use the md-on-select expression. This expression is
	 * bound to scope and controller in {@code MdChipsDirective} as
	 * {@code onSelect}. Due to the nature of directive scope bindings, the
	 * controller cannot know on its own/from the scope whether an expression was
	 * actually provided.
	 */
	MdChipsCtrl.prototype.useOnSelectExpression = function() {
	  this.useOnSelect = true;
	};
	
	/**
	 * Gets the input buffer. The input buffer can be the model bound to the
	 * default input item {@code this.chipBuffer}, the {@code selectedItem}
	 * model of an {@code md-autocomplete}, or, through some magic, the model
	 * bound to any inpput or text area element found within a
	 * {@code md-input-container} element.
	 * @return {string}
	 */
	MdChipsCtrl.prototype.getChipBuffer = function() {
	  var chipBuffer =  !this.userInputElement ? this.chipBuffer :
	                     this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
	                     this.userInputElement[0].value;
	
	  // Ensure that the chip buffer is always a string. For example, the input element buffer might be falsy.
	  return angular.isString(chipBuffer) ? chipBuffer : '';
	};
	
	/**
	 * Resets the input buffer for either the internal input or user provided input element.
	 */
	MdChipsCtrl.prototype.resetChipBuffer = function() {
	  if (this.userInputElement) {
	    if (this.userInputNgModelCtrl) {
	      this.userInputNgModelCtrl.$setViewValue('');
	      this.userInputNgModelCtrl.$render();
	    } else {
	      this.userInputElement[0].value = '';
	    }
	  } else {
	    this.chipBuffer = '';
	  }
	};
	
	MdChipsCtrl.prototype.hasMaxChipsReached = function() {
	  if (angular.isString(this.maxChips)) this.maxChips = parseInt(this.maxChips, 10) || 0;
	
	  return this.maxChips > 0 && this.items.length >= this.maxChips;
	};
	
	/**
	 * Updates the validity properties for the ngModel.
	 */
	MdChipsCtrl.prototype.validateModel = function() {
	  this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
	};
	
	/**
	 * Removes the chip at the given index.
	 * @param index
	 */
	MdChipsCtrl.prototype.removeChip = function(index) {
	  var removed = this.items.splice(index, 1);
	
	  // Update model validation
	  this.ngModelCtrl.$setDirty();
	  this.validateModel();
	
	  if (removed && removed.length && this.useOnRemove && this.onRemove) {
	    this.onRemove({ '$chip': removed[0], '$index': index });
	  }
	};
	
	MdChipsCtrl.prototype.removeChipAndFocusInput = function (index) {
	  this.removeChip(index);
	
	  if (this.autocompleteCtrl) {
	    // Always hide the autocomplete dropdown before focusing the autocomplete input.
	    // Wait for the input to move horizontally, because the chip was removed.
	    // This can lead to an incorrect dropdown position.
	    this.autocompleteCtrl.hidden = true;
	    this.$mdUtil.nextTick(this.onFocus.bind(this));
	  } else {
	    this.onFocus();
	  }
	
	};
	/**
	 * Selects the chip at `index`,
	 * @param index
	 */
	MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
	  // If we have no chips, or are asked to select a chip before the first, just focus the input
	  if (!this.items.length || index === -1) {
	    return this.focusInput();
	  }
	
	  // If we are asked to select a chip greater than the number of chips...
	  if (index >= this.items.length) {
	    if (this.readonly) {
	      // If we are readonly, jump back to the start (because we have no input)
	      index = 0;
	    } else {
	      // If we are not readonly, we should attempt to focus the input
	      return this.onFocus();
	    }
	  }
	
	  index = Math.max(index, 0);
	  index = Math.min(index, this.items.length - 1);
	
	  this.selectChip(index);
	  this.focusChip(index);
	};
	
	MdChipsCtrl.prototype.focusLastChipThenInput = function() {
	  var ctrl = this;
	
	  ctrl.shouldFocusLastChip = false;
	
	  ctrl.focusChip(this.items.length - 1);
	
	  ctrl.$timeout(function() {
	    ctrl.focusInput();
	  }, ctrl.chipAppendDelay);
	};
	
	MdChipsCtrl.prototype.focusInput = function() {
	  this.selectChip(-1);
	  this.onFocus();
	};
	
	/**
	 * Marks the chip at the given index as selected.
	 * @param index
	 */
	MdChipsCtrl.prototype.selectChip = function(index) {
	  if (index >= -1 && index <= this.items.length) {
	    this.selectedChip = index;
	
	    // Fire the onSelect if provided
	    if (this.useOnSelect && this.onSelect) {
	      this.onSelect({'$chip': this.items[index] });
	    }
	  } else {
	    this.$log.warn('Selected Chip index out of bounds; ignoring.');
	  }
	};
	
	/**
	 * Selects the chip at `index` and gives it focus.
	 * @param index
	 */
	MdChipsCtrl.prototype.selectAndFocusChip = function(index) {
	  this.selectChip(index);
	  if (index != -1) {
	    this.focusChip(index);
	  }
	};
	
	/**
	 * Call `focus()` on the chip at `index`
	 */
	MdChipsCtrl.prototype.focusChip = function(index) {
	  var chipContent = this.$element[0].querySelector('md-chip[index="' + index + '"] .md-chip-content');
	
	  this.ariaTabIndex = index;
	
	  chipContent.focus();
	};
	
	/**
	 * Configures the required interactions with the ngModel Controller.
	 * Specifically, set {@code this.items} to the {@code NgModelCtrl#$viewVale}.
	 * @param ngModelCtrl
	 */
	MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	  this.ngModelCtrl = ngModelCtrl;
	
	  var self = this;
	  ngModelCtrl.$render = function() {
	    // model is updated. do something.
	    self.items = self.ngModelCtrl.$viewValue;
	  };
	};
	
	MdChipsCtrl.prototype.onFocus = function () {
	  var input = this.$element[0].querySelector('input');
	  input && input.focus();
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputFocus = function () {
	  this.inputHasFocus = true;
	
	  // Make sure we have the appropriate ARIA attributes
	  this.setupInputAria();
	
	  // Make sure we don't have any chips selected
	  this.resetSelectedChip();
	};
	
	MdChipsCtrl.prototype.onInputBlur = function () {
	  this.inputHasFocus = false;
	
	  if (this.shouldAddOnBlur()) {
	    this.appendChip(this.getChipBuffer().trim());
	    this.resetChipBuffer();
	  }
	};
	
	/**
	 * Configure event bindings on a user-provided input element.
	 * @param inputElement
	 */
	MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
	  this.userInputElement = inputElement;
	
	  // Find the NgModelCtrl for the input element
	  var ngModelCtrl = inputElement.controller('ngModel');
	  // `.controller` will look in the parent as well.
	  if (ngModelCtrl != this.ngModelCtrl) {
	    this.userInputNgModelCtrl = ngModelCtrl;
	  }
	
	  var scope = this.$scope;
	  var ctrl = this;
	
	  // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
	  var scopeApplyFn = function(event, fn) {
	    scope.$evalAsync(angular.bind(ctrl, fn, event));
	  };
	
	  // Bind to keydown and focus events of input
	  inputElement
	      .attr({ tabindex: 0 })
	      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown) })
	      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus) })
	      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur) })
	};
	
	MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
	  if (ctrl) {
	    this.autocompleteCtrl = ctrl;
	
	    ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
	      if (item) {
	        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
	        if (this.hasMaxChipsReached()) return;
	
	        this.appendChip(item);
	        this.resetChipBuffer();
	      }
	    }));
	
	    this.$element.find('input')
	        .on('focus',angular.bind(this, this.onInputFocus) )
	        .on('blur', angular.bind(this, this.onInputBlur) );
	  }
	};
	
	/**
	 * Whether the current chip buffer should be added on input blur or not.
	 * @returns {boolean}
	 */
	MdChipsCtrl.prototype.shouldAddOnBlur = function() {
	
	  // Update the custom ngModel validators from the chips component.
	  this.validateModel();
	
	  var chipBuffer = this.getChipBuffer().trim();
	  var isModelValid = this.ngModelCtrl.$valid;
	  var isAutocompleteShowing = this.autocompleteCtrl && !this.autocompleteCtrl.hidden;
	
	  if (this.userInputNgModelCtrl) {
	    isModelValid = isModelValid && this.userInputNgModelCtrl.$valid;
	  }
	
	  return this.addOnBlur && !this.requireMatch && chipBuffer && isModelValid && !isAutocompleteShowing;
	};
	
	MdChipsCtrl.prototype.hasFocus = function () {
	  return this.inputHasFocus || this.selectedChip >= 0;
	};
	
	MdChipsCtrl.prototype.contentIdFor = function(index) {
	  return this.contentIds[index];
	};
	
	})();
	(function(){
	"use strict";
	
	  
	  MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];angular
	      .module('material.components.chips')
	      .directive('mdChips', MdChips);
	
	  /**
	   * @ngdoc directive
	   * @name mdChips
	   * @module material.components.chips
	   *
	   * @description
	   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
	   * displayed as 'chips'. This component can make use of an `<input>` element or an 
	   * `<md-autocomplete>` element.
	   *
	   * ### Custom templates
	   * A custom template may be provided to render the content of each chip. This is achieved by
	   * specifying an `<md-chip-template>` element containing the custom content as a child of
	   * `<md-chips>`.
	   *
	   * Note: Any attributes on
	   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
	   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
	   * the chip object and its index in the list of chips, respectively.
	   * To override the chip delete control, include an element (ideally a button) with the attribute
	   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
	   * is also placed as a sibling to the chip content (on which there are also click listeners) to
	   * avoid a nested ng-click situation.
	   *
	   * <!-- Note: We no longer want to include this in the site docs; but it should remain here for
	   * future developers and those looking at the documentation.
	   *
	   * <h3> Pending Features </h3>
	   * <ul style="padding-left:20px;">
	   *
	   *   <ul>Style
	   *     <li>Colours for hover, press states (ripple?).</li>
	   *   </ul>
	   *
	   *   <ul>Validation
	   *     <li>allow a validation callback</li>
	   *     <li>hilighting style for invalid chips</li>
	   *   </ul>
	   *
	   *   <ul>Item mutation
	   *     <li>Support `
	   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
	   *       click?
	   *     </li>
	   *   </ul>
	   *
	   *   <ul>Truncation and Disambiguation (?)
	   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
	   *     indistinguishable.</li>
	   *   </ul>
	   *
	   *   <ul>Drag and Drop
	   *     <li>Drag and drop chips between related `<md-chips>` elements.
	   *     </li>
	   *   </ul>
	   * </ul>
	   *
	   * //-->
	   *
	   * Sometimes developers want to limit the amount of possible chips.<br/>
	   * You can specify the maximum amount of chips by using the following markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *   </md-chips>
	   * </hljs>
	   *
	   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
	   * When the maximum amount of chips has been reached, you can also disable the autocomplete selection.<br/>
	   * Here is an example markup.
	   *
	   * <hljs lang="html">
	   *   <md-chips ng-model="myItems" md-max-chips="5">
	   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
	   *   </md-chips>
	   * </hljs>
	   *
	   * ### Accessibility
	   *
	   * The `md-chips` component supports keyboard and screen reader users since Version 1.1.2. In
	   * order to achieve this, we modified the chips behavior to select newly appended chips for
	   * `300ms` before re-focusing the input and allowing the user to type.
	   *
	   * For most users, this delay is small enough that it will not be noticeable but allows certain
	   * screen readers to function properly (JAWS and NVDA in particular).
	   *
	   * We introduced a new `md-chip-append-delay` option to allow developers to better control this
	   * behavior.
	   *
	   * Please refer to the documentation of this option (below) for more information.
	   *
	   * @param {string=|object=} ng-model A model to which the list of items will be bound.
	   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	   *    displayed when there is at least one item in the list
	   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
	   *    removal icon or the Delete/Backspace key. Defaults to true.
	   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
	   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
	   *    marked as readonly.<br/><br/>
	   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and disabled.
	   * @param {string=} md-enable-chip-edit Set this to "true" to enable editing of chip contents. The user can 
	   *    go into edit mode with pressing "space", "enter", or double clicking on the chip. Chip edit is only
	   *    supported for chips with basic template.
	   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
	   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
	   *    amount is reached.
	   * @param {boolean=} md-add-on-blur When set to true, remaining text inside of the input will
	   *    be converted into a new chip on blur.
	   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when called
	   *    expects one of the following return values:
	   *    - an object representing the `$chip` input string
	   *    - `undefined` to simply add the `$chip` input string, or
	   *    - `null` to prevent the chip from being appended
	   * @param {expression=} md-on-add An expression which will be called when a chip has been
	   *    added.
	   * @param {expression=} md-on-remove An expression which will be called when a chip has been
	   *    removed.
	   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
	   * @param {boolean} md-require-match If true, and the chips template contains an autocomplete,
	   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
	   * @param {string=} input-aria-label A string read by screen readers to identify the input.
	   * @param {string=} container-hint A string read by screen readers informing users of how to
	   *    navigate the chips. Used in readonly mode.
	   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
	   *    the delete key will remove the chip.
	   * @param {string=} delete-button-label A label for the delete button. Also hidden and read by
	   *    screen readers.
	   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
	   * @param {string=} md-chip-append-delay The number of milliseconds that the component will select
	   *    a newly appended chip before allowing a user to type into the input. This is **necessary**
	   *    for keyboard accessibility for screen readers. It defaults to 300ms and any number less than
	   *    300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).
	   *
	   *    _Available since Version 1.1.2._
	   *
	   *    **Note:** You can safely set this to `0` in one of the following two instances:
	   *
	   *    1. You are targeting an iOS or Safari-only application (where users would use VoiceOver) or
	   *    only ChromeVox users.
	   *
	   *    2. If you have utilized the `md-separator-keys` to disable the `enter` keystroke in
	   *    favor of another one (such as `,` or `;`).
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-chips
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       readonly="isReadOnly">
	   *   </md-chips>
	   * </hljs>
	   *
	   * <h3>Validation</h3>
	   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
	   * on our custom validators.
	   * <hljs lang="html">
	   *   <form name="userForm">
	   *     <md-chips
	   *       name="fruits"
	   *       ng-model="myItems"
	   *       placeholder="Add an item"
	   *       md-max-chips="5">
	   *     </md-chips>
	   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
	   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
	   *    </div>
	   *   </form>
	   * </hljs>
	   *
	   */
	
	  var MD_CHIPS_TEMPLATE = '\
	      <md-chips-wrap\
	          id="{{$mdChipsCtrl.wrapperId}}"\
	          tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"\
	          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
	          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
	                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
	                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
	          aria-setsize="{{$mdChipsCtrl.items.length}}"\
	          class="md-chips">\
	        <span ng-if="$mdChipsCtrl.readonly" class="md-visually-hidden">\
	          {{$mdChipsCtrl.containerHint}}\
	        </span>\
	        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
	            index="{{$index}}"\
	            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
	          <div class="md-chip-content"\
	              tabindex="{{$mdChipsCtrl.ariaTabIndex == $index ? 0 : -1}}"\
	              id="{{$mdChipsCtrl.contentIdFor($index)}}"\
	              role="option"\
	              aria-selected="{{$mdChipsCtrl.selectedChip == $index}}" \
	              aria-posinset="{{$index}}"\
	              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
	              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
	              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
	          <div ng-if="$mdChipsCtrl.isRemovable()"\
	               class="md-chip-remove-container"\
	               tabindex="-1"\
	               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
	        </md-chip>\
	        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
	          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
	        </div>\
	      </md-chips-wrap>';
	
	  var CHIP_INPUT_TEMPLATE = '\
	        <input\
	            class="md-input"\
	            tabindex="0"\
	            aria-label="{{$mdChipsCtrl.inputAriaLabel}}" \
	            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
	            ng-model="$mdChipsCtrl.chipBuffer"\
	            ng-focus="$mdChipsCtrl.onInputFocus()"\
	            ng-blur="$mdChipsCtrl.onInputBlur()"\
	            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';
	
	  var CHIP_DEFAULT_TEMPLATE = '\
	      <span>{{$chip}}</span>';
	
	  var CHIP_REMOVE_TEMPLATE = '\
	      <button\
	          class="md-chip-remove"\
	          ng-if="$mdChipsCtrl.isRemovable()"\
	          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)"\
	          type="button"\
	          tabindex="-1">\
	        <md-icon md-svg-src="{{ $mdChipsCtrl.mdCloseIcon }}"></md-icon>\
	        <span class="md-visually-hidden">\
	          {{$mdChipsCtrl.deleteButtonLabel}}\
	        </span>\
	      </button>';
	
	  /**
	   * MDChips Directive Definition
	   */
	  function MdChips ($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
	    // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
	    var templates = getTemplates();
	
	    return {
	      template: function(element, attrs) {
	        // Clone the element into an attribute. By prepending the attribute
	        // name with '$', AngularJS won't write it into the DOM. The cloned
	        // element propagates to the link function via the attrs argument,
	        // where various contained-elements can be consumed.
	        attrs['$mdUserTemplate'] = element.clone();
	        return templates.chips;
	      },
	      require: ['mdChips'],
	      restrict: 'E',
	      controller: 'MdChipsCtrl',
	      controllerAs: '$mdChipsCtrl',
	      bindToController: true,
	      compile: compile,
	      scope: {
	        readonly: '=readonly',
	        removable: '=mdRemovable',
	        placeholder: '@',
	        secondaryPlaceholder: '@',
	        maxChips: '@mdMaxChips',
	        transformChip: '&mdTransformChip',
	        onAppend: '&mdOnAppend',
	        onAdd: '&mdOnAdd',
	        onRemove: '&mdOnRemove',
	        onSelect: '&mdOnSelect',
	        inputAriaLabel: '@',
	        containerHint: '@',
	        deleteHint: '@',
	        deleteButtonLabel: '@',
	        separatorKeys: '=?mdSeparatorKeys',
	        requireMatch: '=?mdRequireMatch',
	        chipAppendDelayString: '@?mdChipAppendDelay'
	      }
	    };
	
	    /**
	     * Builds the final template for `md-chips` and returns the postLink function.
	     *
	     * Building the template involves 3 key components:
	     * static chips
	     * chip template
	     * input control
	     *
	     * If no `ng-model` is provided, only the static chip work needs to be done.
	     *
	     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
	     * template is appended to the chip content element.
	     *
	     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
	     *
	     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
	     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
	     * If no user input is provided, a default one is appended to the input container node in the
	     * template.
	     *
	     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
	     * transclusion in the `postLink` function.
	     *
	     *
	     * @param element
	     * @param attr
	     * @returns {Function}
	     */
	    function compile(element, attr) {
	      // Grab the user template from attr and reset the attribute to null.
	      var userTemplate = attr['$mdUserTemplate'];
	      attr['$mdUserTemplate'] = null;
	
	      var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');
	
	      var chipRemoveSelector = $mdUtil
	        .prefixer()
	        .buildList('md-chip-remove')
	        .map(function(attr) {
	          return 'md-chips>*[' + attr + ']';
	        })
	        .join(',');
	
	      // Set the chip remove, chip contents and chip input templates. The link function will put
	      // them on the scope for transclusion later.
	      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
	          chipContentsTemplate = chipTemplate || templates.default,
	          chipInputTemplate    = getTemplateByQuery('md-chips>md-autocomplete')
	              || getTemplateByQuery('md-chips>input')
	              || templates.input,
	          staticChips = userTemplate.find('md-chip');
	
	      // Warn of malformed template. See #2545
	      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
	        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
	      }
	
	      function getTemplateByQuery (query) {
	        if (!attr.ngModel) return;
	        var element = userTemplate[0].querySelector(query);
	        return element && element.outerHTML;
	      }
	
	      /**
	       * Configures controller and transcludes.
	       */
	      return function postLink(scope, element, attrs, controllers) {
	        $mdUtil.initOptionalProperties(scope, attr);
	
	        $mdTheming(element);
	        var mdChipsCtrl = controllers[0];
	        if(chipTemplate) {
	          // Chip editing functionality assumes we are using the default chip template.
	          mdChipsCtrl.enableChipEdit = false;
	        }
	
	        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
	        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
	        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;
	
	        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdClose;
	
	        element
	            .attr({ tabindex: -1 })
	            .on('focus', function () { mdChipsCtrl.onFocus(); });
	
	        if (attr.ngModel) {
	          mdChipsCtrl.configureNgModel(element.controller('ngModel'));
	
	          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
	          // before appending chips.
	          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();
	
	          // If an `md-on-append` attribute was set, tell the controller to use the expression
	          // when appending chips.
	          //
	          // DEPRECATED: Will remove in official 1.0 release
	          if (attrs.mdOnAppend) mdChipsCtrl.useOnAppendExpression();
	
	          // If an `md-on-add` attribute was set, tell the controller to use the expression
	          // when adding chips.
	          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();
	
	          // If an `md-on-remove` attribute was set, tell the controller to use the expression
	          // when removing chips.
	          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();
	
	          // If an `md-on-select` attribute was set, tell the controller to use the expression
	          // when selecting chips.
	          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();
	
	          // The md-autocomplete and input elements won't be compiled until after this directive
	          // is complete (due to their nested nature). Wait a tick before looking for them to
	          // configure the controller.
	          if (chipInputTemplate != templates.input) {
	            // The autocomplete will not appear until the readonly attribute is not true (i.e.
	            // false or undefined), so we have to watch the readonly and then on the next tick
	            // after the chip transclusion has run, we can configure the autocomplete and user
	            // input.
	            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
	              if (!readonly) {
	
	                $mdUtil.nextTick(function(){
	
	                  if (chipInputTemplate.indexOf('<md-autocomplete') === 0) {
	                    var autocompleteEl = element.find('md-autocomplete');
	                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));
	                  }
	
	                  mdChipsCtrl.configureUserInput(element.find('input'));
	                });
	              }
	            });
	          }
	
	          // At the next tick, if we find an input, make sure it has the md-input class
	          $mdUtil.nextTick(function() {
	            var input = element.find('input');
	
	            input && input.toggleClass('md-input', true);
	          });
	        }
	
	        // Compile with the parent's scope and prepend any static chips to the wrapper.
	        if (staticChips.length > 0) {
	          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
	          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
	        }
	      };
	    }
	
	    function getTemplates() {
	      return {
	        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
	        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
	        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
	        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
	      };
	    }
	  }
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.chips')
	    .controller('MdContactChipsCtrl', MdContactChipsCtrl);
	
	
	
	/**
	 * Controller for the MdContactChips component
	 * @constructor
	 */
	function MdContactChipsCtrl () {
	  /** @type {Object} */
	  this.selectedItem = null;
	
	  /** @type {string} */
	  this.searchText = '';
	}
	
	
	MdContactChipsCtrl.prototype.queryContact = function(searchText) {
	  return this.contactQuery({'$query': searchText});
	};
	
	
	MdContactChipsCtrl.prototype.itemName = function(item) {
	  return item[this.contactName];
	};
	
	})();
	(function(){
	"use strict";
	
	
	MdContactChips.$inject = ["$mdTheming", "$mdUtil"];angular
	  .module('material.components.chips')
	  .directive('mdContactChips', MdContactChips);
	
	/**
	 * @ngdoc directive
	 * @name mdContactChips
	 * @module material.components.chips
	 *
	 * @description
	 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
	 * `md-autocomplete` element. The component allows the caller to supply a query expression which
	 * returns  a list of possible contacts. The user can select one of these and add it to the list of
	 * chips.
	 *
	 * You may also use the `md-highlight-text` directive along with its parameters to control the
	 * appearance of the matched text inside of the contacts' autocomplete popup.
	 *
	 * @param {string=|object=} ng-model A model to bind the list of items to
	 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
	 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
	 *    displayed when there is at least on item in the list
	 * @param {expression} md-contacts An expression expected to return contacts matching the search
	 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
	 *    waiting for it to resolve.
	 * @param {string} md-contact-name The field name of the contact object representing the
	 *    contact's name.
	 * @param {string} md-contact-email The field name of the contact object representing the
	 *    contact's email address.
	 * @param {string} md-contact-image The field name of the contact object representing the
	 *    contact's image.
	 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
	 *    make suggestions
	 *
	 * @param {expression=} filter-selected Whether to filter selected contacts from the list of
	 *    suggestions shown in the autocomplete.
	 *
	 *    ***Note:** This attribute has been removed but may come back.*
	 *
	 *
	 *
	 * @usage
	 * <hljs lang="html">
	 *   <md-contact-chips
	 *       ng-model="ctrl.contacts"
	 *       md-contacts="ctrl.querySearch($query)"
	 *       md-contact-name="name"
	 *       md-contact-image="image"
	 *       md-contact-email="email"
	 *       placeholder="To">
	 *   </md-contact-chips>
	 * </hljs>
	 *
	 */
	
	
	var MD_CONTACT_CHIPS_TEMPLATE = '\
	      <md-chips class="md-contact-chips"\
	          ng-model="$mdContactChipsCtrl.contacts"\
	          md-require-match="$mdContactChipsCtrl.requireMatch"\
	          md-chip-append-delay="{{$mdContactChipsCtrl.chipAppendDelay}}" \
	          md-autocomplete-snap>\
	          <md-autocomplete\
	              md-menu-class="md-contact-chips-suggestions"\
	              md-selected-item="$mdContactChipsCtrl.selectedItem"\
	              md-search-text="$mdContactChipsCtrl.searchText"\
	              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
	              md-item-text="$mdContactChipsCtrl.itemName(item)"\
	              md-no-cache="true"\
	              md-min-length="$mdContactChipsCtrl.minLength"\
	              md-autoselect\
	              placeholder="{{$mdContactChipsCtrl.contacts.length == 0 ?\
	                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
	            <div class="md-contact-suggestion">\
	              <img \
	                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
	              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
	                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
	                {{item[$mdContactChipsCtrl.contactName]}}\
	              </span>\
	              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
	            </div>\
	          </md-autocomplete>\
	          <md-chip-template>\
	            <div class="md-contact-avatar">\
	              <img \
	                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
	                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
	                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
	            </div>\
	            <div class="md-contact-name">\
	              {{$chip[$mdContactChipsCtrl.contactName]}}\
	            </div>\
	          </md-chip-template>\
	      </md-chips>';
	
	
	/**
	 * MDContactChips Directive Definition
	 *
	 * @param $mdTheming
	 * @returns {*}
	 * @ngInject
	 */
	function MdContactChips($mdTheming, $mdUtil) {
	  return {
	    template: function(element, attrs) {
	      return MD_CONTACT_CHIPS_TEMPLATE;
	    },
	    restrict: 'E',
	    controller: 'MdContactChipsCtrl',
	    controllerAs: '$mdContactChipsCtrl',
	    bindToController: true,
	    compile: compile,
	    scope: {
	      contactQuery: '&mdContacts',
	      placeholder: '@',
	      secondaryPlaceholder: '@',
	      contactName: '@mdContactName',
	      contactImage: '@mdContactImage',
	      contactEmail: '@mdContactEmail',
	      contacts: '=ngModel',
	      requireMatch: '=?mdRequireMatch',
	      minLength: '=?mdMinLength',
	      highlightFlags: '@?mdHighlightFlags',
	      chipAppendDelay: '@?mdChipAppendDelay'
	    }
	  };
	
	  function compile(element, attr) {
	    return function postLink(scope, element, attrs, controllers) {
	      var contactChipsController = controllers;
	
	      $mdUtil.initOptionalProperties(scope, attr);
	      $mdTheming(element);
	
	      element.attr('tabindex', '-1');
	
	      attrs.$observe('mdChipAppendDelay', function(newValue) {
	        contactChipsController.chipAppendDelay = newValue;
	      });
	    };
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name mdCalendar
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Should be a Date object.
	   * @param {Date=} md-min-date Expression representing the minimum date.
	   * @param {Date=} md-max-date Expression representing the maximum date.
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   *
	   * @description
	   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
	   * It is a part of the `<md-datepicker>` pane, however it can also be used on it's own.
	   *
	   * @usage
	   *
	   * <hljs lang="html">
	   *   <md-calendar ng-model="birthday"></md-calendar>
	   * </hljs>
	   */
	  CalendarCtrl.$inject = ["$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendar', calendarDirective);
	
	  // POST RELEASE
	  // TODO(jelbourn): Mac Cmd + left / right == Home / End
	  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
	  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
	  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
	  // TODO(jelbourn): Scroll snapping (virtual repeat)
	  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
	  // TODO(jelbourn): Month headers stick to top when scrolling.
	  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
	  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
	  //     announcement and key handling).
	  // Read-only calendar (not just date-picker).
	
	  function calendarDirective() {
	    return {
	      template: function(tElement, tAttr) {
	        // TODO(crisbeto): This is a workaround that allows the calendar to work, without
	        // a datepicker, until issue #8585 gets resolved. It can safely be removed
	        // afterwards. This ensures that the virtual repeater scrolls to the proper place on load by
	        // deferring the execution until the next digest. It's necessary only if the calendar is used
	        // without a datepicker, otherwise it's already wrapped in an ngIf.
	        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
	        var template = '' +
	          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
	            '<md-calendar-year ng-switch-when="year"></md-calendar-year>' +
	            '<md-calendar-month ng-switch-default></md-calendar-month>' +
	          '</div>';
	
	        return template;
	      },
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        dateFilter: '=mdDateFilter',
	        _currentView: '@mdCurrentView'
	      },
	      require: ['ngModel', 'mdCalendar'],
	      controller: CalendarCtrl,
	      controllerAs: 'calendarCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdCalendarCtrl = controllers[1];
	        mdCalendarCtrl.configureNgModel(ngModelCtrl);
	      }
	    };
	  }
	
	  /**
	   * Occasionally the hideVerticalScrollbar method might read an element's
	   * width as 0, because it hasn't been laid out yet. This value will be used
	   * as a fallback, in order to prevent scenarios where the element's width
	   * would otherwise have been set to 0. This value is the "usual" width of a
	   * calendar within a floating calendar pane.
	   */
	  var FALLBACK_WIDTH = 340;
	
	  /** Next identifier for calendar instance. */
	  var nextUniqueId = 0;
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarCtrl($element, $scope, $$mdDateUtil, $mdUtil,
	    $mdConstant, $mdTheming, $$rAF, $attrs, $mdDateLocale) {
	
	    $mdTheming($element);
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.keyCode = $mdConstant.KEY_CODE;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /** @final {Date} */
	    this.today = this.dateUtil.createDateAtMidnight();
	
	    /** @type {!angular.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {String} Class applied to the selected date cell. */
	    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';
	
	    /** @type {String} Class applied to the cell for today. */
	    this.TODAY_CLASS = 'md-calendar-date-today';
	
	    /** @type {String} Class applied to the focused cell. */
	    this.FOCUSED_DATE_CLASS = 'md-focus';
	
	    /** @final {number} Unique ID for this calendar instance. */
	    this.id = nextUniqueId++;
	
	    /**
	     * The date that is currently focused or showing in the calendar. This will initially be set
	     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
	     * to other months. The cell corresponding to the displayDate does not necesarily always have
	     * focus in the document (such as for cases when the user is scrolling the calendar).
	     * @type {Date}
	     */
	    this.displayDate = null;
	
	    /**
	     * The selected date. Keep track of this separately from the ng-model value so that we
	     * can know, when the ng-model value changes, what the previous value was before it's updated
	     * in the component's UI.
	     *
	     * @type {Date}
	     */
	    this.selectedDate = null;
	
	    /**
	     * The first date that can be rendered by the calendar. The default is taken
	     * from the mdDateLocale provider and is limited by the mdMinDate.
	     * @type {Date}
	     */
	    this.firstRenderableDate = null;
	
	    /**
	     * The last date that can be rendered by the calendar. The default comes
	     * from the mdDateLocale provider and is limited by the maxDate.
	     * @type {Date}
	     */
	    this.lastRenderableDate = null;
	
	    /**
	     * Used to toggle initialize the root element in the next digest.
	     * @type {Boolean}
	     */
	    this.isInitialized = false;
	
	    /**
	     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
	     * and to avoid extra reflows when switching between views.
	     * @type {Number}
	     */
	    this.width = 0;
	
	    /**
	     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
	     * @type {Number}
	     */
	    this.scrollbarWidth = 0;
	
	    // Unless the user specifies so, the calendar should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if (!$attrs.tabindex) {
	      $element.attr('tabindex', '-1');
	    }
	
	    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);
	
	
	
	    // If use the md-calendar directly in the body without datepicker,
	    // handleKeyEvent will disable other inputs on the page.
	    // So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
	    // otherwise apply on the calendar element only.
	
	    var handleKeyElement;
	    if ($element.parent().hasClass('md-datepicker-calendar')) {
	      handleKeyElement = angular.element(document.body);
	    } else {
	      handleKeyElement = $element;
	    }
	
	    // Bind the keydown handler to the body, in order to handle cases where the focused
	    // element gets removed from the DOM and stops propagating click events.
	    handleKeyElement.on('keydown', boundKeyHandler);
	
	    $scope.$on('$destroy', function() {
	      handleKeyElement.off('keydown', boundKeyHandler);
	    });
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  CalendarCtrl.prototype.$onInit = function() {
	
	    /**
	     * The currently visible calendar view. Note the prefix on the scope value,
	     * which is necessary, because the datepicker seems to reset the real one value if the
	     * calendar is open, but the value on the datepicker's scope is empty.
	     * @type {String}
	     */
	    this.currentView = this._currentView || 'month';
	
	    var dateLocale = this.$mdDateLocale;
	
	    if (this.minDate && this.minDate > dateLocale.firstRenderableDate) {
	      this.firstRenderableDate = this.minDate;
	    } else {
	      this.firstRenderableDate = dateLocale.firstRenderableDate;
	    }
	
	    if (this.maxDate && this.maxDate < dateLocale.lastRenderableDate) {
	      this.lastRenderableDate = this.maxDate;
	    } else {
	      this.lastRenderableDate = dateLocale.lastRenderableDate;
	    }
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController.
	   * @param {!angular.NgModelController} ngModelCtrl
	   */
	  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl) {
	    var self = this;
	
	    self.ngModelCtrl = ngModelCtrl;
	
	    self.$mdUtil.nextTick(function() {
	      self.isInitialized = true;
	    });
	
	    ngModelCtrl.$render = function() {
	      var value = this.$viewValue;
	
	      // Notify the child scopes of any changes.
	      self.$scope.$broadcast('md-calendar-parent-changed', value);
	
	      // Set up the selectedDate if it hasn't been already.
	      if (!self.selectedDate) {
	        self.selectedDate = value;
	      }
	
	      // Also set up the displayDate.
	      if (!self.displayDate) {
	        self.displayDate = self.selectedDate || self.today;
	      }
	    };
	  };
	
	  /**
	   * Sets the ng-model value for the calendar and emits a change event.
	   * @param {Date} date
	   */
	  CalendarCtrl.prototype.setNgModelValue = function(date) {
	    var value = this.dateUtil.createDateAtMidnight(date);
	    this.focus(value);
	    this.$scope.$emit('md-calendar-change', value);
	    this.ngModelCtrl.$setViewValue(value);
	    this.ngModelCtrl.$render();
	    return value;
	  };
	
	  /**
	   * Sets the current view that should be visible in the calendar
	   * @param {string} newView View name to be set.
	   * @param {number|Date} time Date object or a timestamp for the new display date.
	   */
	  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
	    var self = this;
	
	    self.$mdUtil.nextTick(function() {
	      self.currentView = newView;
	
	      if (time) {
	        self.displayDate = angular.isDate(time) ? time : new Date(time);
	      }
	    });
	  };
	
	  /**
	   * Focus the cell corresponding to the given date.
	   * @param {Date} date The date to be focused.
	   */
	  CalendarCtrl.prototype.focus = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var previousFocus = this.$element[0].querySelector('.md-focus');
	      if (previousFocus) {
	        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
	      }
	
	      var cellId = this.getDateId(date, this.currentView);
	      var cell = document.getElementById(cellId);
	      if (cell) {
	        cell.classList.add(this.FOCUSED_DATE_CLASS);
	        cell.focus();
	        this.displayDate = date;
	      }
	    } else {
	      var rootElement = this.$element[0].querySelector('[ng-switch]');
	
	      if (rootElement) {
	        rootElement.focus();
	      }
	    }
	  };
	
	  /**
	   * Normalizes the key event into an action name. The action will be broadcast
	   * to the child controllers.
	   * @param {KeyboardEvent} event
	   * @returns {String} The action that should be taken, or null if the key
	   * does not match a calendar shortcut.
	   */
	  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
	    var keyCode = this.keyCode;
	
	    switch (event.which) {
	      case keyCode.ENTER: return 'select';
	
	      case keyCode.RIGHT_ARROW: return 'move-right';
	      case keyCode.LEFT_ARROW: return 'move-left';
	
	      // TODO(crisbeto): Might want to reconsider using metaKey, because it maps
	      // to the "Windows" key on PC, which opens the start menu or resizes the browser.
	      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
	      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';
	
	      case keyCode.PAGE_DOWN: return 'move-page-down';
	      case keyCode.PAGE_UP: return 'move-page-up';
	
	      case keyCode.HOME: return 'start';
	      case keyCode.END: return 'end';
	
	      default: return null;
	    }
	  };
	
	  /**
	   * Handles a key event in the calendar with the appropriate action. The action will either
	   * be to select the focused date or to navigate to focus a new date.
	   * @param {KeyboardEvent} event
	   */
	  CalendarCtrl.prototype.handleKeyEvent = function(event) {
	    var self = this;
	
	    this.$scope.$apply(function() {
	      // Capture escape and emit back up so that a wrapping component
	      // (such as a date-picker) can decide to close.
	      if (event.which == self.keyCode.ESCAPE || event.which == self.keyCode.TAB) {
	        self.$scope.$emit('md-calendar-close');
	
	        if (event.which == self.keyCode.TAB) {
	          event.preventDefault();
	        }
	
	        return;
	      }
	
	      // Broadcast the action that any child controllers should take.
	      var action = self.getActionFromKeyEvent(event);
	      if (action) {
	        event.preventDefault();
	        event.stopPropagation();
	        self.$scope.$broadcast('md-calendar-parent-action', action);
	      }
	    });
	  };
	
	  /**
	   * Hides the vertical scrollbar on the calendar scroller of a child controller by
	   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
	   * around the scroller, and then setting a padding-right on the scroller equal
	   * to the width of the browser's scrollbar.
	   *
	   * This will cause a reflow.
	   *
	   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
	   */
	  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
	    var self = this;
	    var element = childCtrl.$element[0];
	    var scrollMask = element.querySelector('.md-calendar-scroll-mask');
	
	    if (self.width > 0) {
	      setWidth();
	    } else {
	      self.$$rAF(function() {
	        var scroller = childCtrl.calendarScroller;
	
	        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
	        self.width = element.querySelector('table').offsetWidth;
	        setWidth();
	      });
	    }
	
	    function setWidth() {
	      var width = self.width || FALLBACK_WIDTH;
	      var scrollbarWidth = self.scrollbarWidth;
	      var scroller = childCtrl.calendarScroller;
	
	      scrollMask.style.width = width + 'px';
	      scroller.style.width = (width + scrollbarWidth) + 'px';
	      scroller.style.paddingRight = scrollbarWidth + 'px';
	    }
	  };
	
	  /**
	   * Gets an identifier for a date unique to the calendar instance for internal
	   * purposes. Not to be displayed.
	   * @param {Date} date The date for which the id is being generated
	   * @param {string} namespace Namespace for the id. (month, year etc.)
	   * @returns {string}
	   */
	  CalendarCtrl.prototype.getDateId = function(date, namespace) {
	    if (!namespace) {
	      throw new Error('A namespace for the date id has to be specified.');
	    }
	
	    return [
	      'md',
	      this.id,
	      namespace,
	      date.getFullYear(),
	      date.getMonth(),
	      date.getDate()
	    ].join('-');
	  };
	
	  /**
	   * Util to trigger an extra digest on a parent scope, in order to to ensure that
	   * any child virtual repeaters have updated. This is necessary, because the virtual
	   * repeater doesn't update the $index the first time around since the content isn't
	   * in place yet. The case, in which this is an issue, is when the repeater has less
	   * than a page of content (e.g. a month or year view has a min or max date).
	   */
	  CalendarCtrl.prototype.updateVirtualRepeat = function() {
	    var scope = this.$scope;
	    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
	      if (!scope.$$phase) {
	        scope.$apply();
	      }
	
	      virtualRepeatResizeListener();
	    });
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarMonthCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarMonth', calendarDirective);
	
	  /**
	   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific months.
	   */
	  var TBODY_HEIGHT = 265;
	
	  /**
	   * Height of a calendar month with a single row. This is needed to calculate the offset for
	   * rendering an extra month in virtual-repeat that only contains one row.
	   */
	  var TBODY_SINGLE_ROW_HEIGHT = 45;
	
	  /** Private directive that represents a list of months inside the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
	        '<div class="md-calendar-scroll-mask">' +
	        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
	              'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-month-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in monthCtrl.items" ' +
	                  'md-month-offset="$index" ' +
	                  'class="md-calendar-month" ' +
	                  'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	
	                // The <tr> ensures that the <tbody> will always have the
	                // proper height, even if it's empty. If it's content is
	                // compiled, the <tr> will be overwritten.
	                '<tr aria-hidden="true" style="height:' + TBODY_HEIGHT + 'px;"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarMonth'],
	      controller: CalendarMonthCtrl,
	      controllerAs: 'monthCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        monthCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the calendar month component.
	   * @ngInject @constructor
	   */
	  function CalendarMonthCtrl($element, $scope, $animate, $q,
	    $$mdDateUtil, $mdDateLocale) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
	      self.$scope.$apply(function() {
	        self.calendarCtrl.setNgModelValue(timestamp);
	      });
	    };
	
	    /**
	     * Handles click events on the month headers. Switches
	     * the calendar to the year view.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.headerClickHandler = function() {
	      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /*** Initialization ***/
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of months that can be viewed. We add 2 months: one to include the current month
	     * and one for the last dummy month.
	     *
	     * This is shorter than ideal because of a (potential) Firefox bug
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
	     */
	
	    this.items = {
	      length: this.dateUtil.getMonthDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 2
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getMonthDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the selected date in the calendar (ngModel value has already been changed).
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeSelectedDate = function(date) {
	    var self = this;
	    var calendarCtrl = self.calendarCtrl;
	    var previousSelectedDate = calendarCtrl.selectedDate;
	    calendarCtrl.selectedDate = date;
	
	    this.changeDisplayDate(date).then(function() {
	      var selectedDateClass = calendarCtrl.SELECTED_DATE_CLASS;
	      var namespace = 'month';
	
	      // Remove the selected class from the previously selected date, if any.
	      if (previousSelectedDate) {
	        var prevDateCell = document.getElementById(calendarCtrl.getDateId(previousSelectedDate, namespace));
	        if (prevDateCell) {
	          prevDateCell.classList.remove(selectedDateClass);
	          prevDateCell.setAttribute('aria-selected', 'false');
	        }
	      }
	
	      // Apply the select class to the new selected date if it is set.
	      if (date) {
	        var dateCell = document.getElementById(calendarCtrl.getDateId(date, namespace));
	        if (dateCell) {
	          dateCell.classList.add(selectedDateClass);
	          dateCell.setAttribute('aria-selected', 'true');
	        }
	      }
	    });
	  };
	
	  /**
	   * Change the date that is being shown in the calendar. If the given date is in a different
	   * month, the displayed month will be transitioned.
	   * @param {Date} date
	   */
	  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.buildWeekHeader();
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    }
	
	    // If trying to show an invalid date or a transition is in progress, do nothing.
	    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
	      return this.$q.when();
	    }
	
	    this.isMonthTransitionInProgress = true;
	    var animationPromise = this.animateDateChange(date);
	
	    this.calendarCtrl.displayDate = date;
	
	    var self = this;
	    animationPromise.then(function() {
	      self.isMonthTransitionInProgress = false;
	    });
	
	    return animationPromise;
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Builds and appends a day-of-the-week header to the calendar.
	   * This should only need to be called once during initialization.
	   */
	  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
	    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
	    var shortDays = this.dateLocale.shortDays;
	
	    var row = document.createElement('tr');
	    for (var i = 0; i < 7; i++) {
	      var th = document.createElement('th');
	      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
	      row.appendChild(th);
	    }
	
	    this.$element.find('thead').append(row);
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.changeSelectedDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
	  };
	
	  /**
	   * Handles the month-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      calendarCtrl.setNgModelValue(displayDate);
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;
	
	        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
	        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;
	
	        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
	        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
	      }
	
	      if (date) {
	        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);
	
	        this.changeDisplayDate(date).then(function() {
	          calendarCtrl.focus(date);
	        });
	      }
	    }
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
	  CalendarMonthBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarMonthBody', mdCalendarMonthBodyDirective);
	
	  /**
	   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
	   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
	   * the rest of the calendar controller logic.
	   * @ngInject
	   */
	  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
	    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
	      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];
	
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarMonth', 'mdCalendarMonthBody'],
	      scope: { offset: '=mdMonthOffset' },
	      controller: CalendarMonthBodyCtrl,
	      controllerAs: 'mdMonthBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var monthCtrl = controllers[1];
	        var monthBodyCtrl = controllers[2];
	
	        monthBodyCtrl.calendarCtrl = calendarCtrl;
	        monthBodyCtrl.monthCtrl = monthCtrl;
	        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);
	
	        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
	        // of repeated items that are linked, and then those elements have their bindings updated.
	        // Since the months are not generated by bindings, we simply regenerate the entire thing
	        // when the binding (offset) changes.
	        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            monthBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single calendar month.
	   * @ngInject @constructor
	   */
	  function CalendarMonthBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the month view. */
	    this.monthCtrl = null;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this month to the directive element. */
	  CalendarMonthBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForMonth(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend.focus();
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a date in the calendar with all appropriate
	   * attributes and classes added. If a date is given, the cell content will be set
	   * based on the date.
	   * @param {Date=} opt_date
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
	    var monthCtrl = this.monthCtrl;
	    var calendarCtrl = this.calendarCtrl;
	
	    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    if (opt_date) {
	      cell.setAttribute('tabindex', '-1');
	      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
	      cell.id = calendarCtrl.getDateId(opt_date, 'month');
	
	      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	      cell.setAttribute('data-timestamp', opt_date.getTime());
	
	      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
	      // It may be better to finish the construction and then query the node and add the class.
	      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
	        cell.classList.add(calendarCtrl.TODAY_CLASS);
	      }
	
	      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	          this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
	        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	        cell.setAttribute('aria-selected', 'true');
	      }
	
	      var cellText = this.dateLocale.dates[opt_date.getDate()];
	
	      if (this.isDateEnabled(opt_date)) {
	        // Add a indicator for select, hover, and focus states.
	        var selectionIndicator = document.createElement('span');
	        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	        selectionIndicator.textContent = cellText;
	        cell.appendChild(selectionIndicator);
	        cell.addEventListener('click', monthCtrl.cellClickHandler);
	
	        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
	          this.focusAfterAppend = cell;
	        }
	      } else {
	        cell.classList.add('md-calendar-date-disabled');
	        cell.textContent = cellText;
	      }
	    }
	
	    return cell;
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date,
	          this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
	          (!angular.isFunction(this.calendarCtrl.dateFilter)
	           || this.calendarCtrl.dateFilter(opt_date));
	  };
	
	  /**
	   * Builds a `tr` element for the calendar grid.
	   * @param rowNumber The week number within the month.
	   * @returns {HTMLElement}
	   */
	  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
	    var row = document.createElement('tr');
	    row.setAttribute('role', 'row');
	
	    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
	    // to prevent the entire row being read aloud when the user moves between rows.
	    // See http://community.nvda-project.org/ticket/4643.
	    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));
	
	    return row;
	  };
	
	  /**
	   * Builds the <tbody> content for the given date's month.
	   * @param {Date=} opt_dateInMonth
	   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
	   */
	  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
	    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();
	
	    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
	    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
	    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);
	
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var monthBody = document.createDocumentFragment();
	
	    var rowNumber = 1;
	    var row = this.buildDateRow(rowNumber);
	    monthBody.appendChild(row);
	
	    // If this is the final month in the list of items, only the first week should render,
	    // so we should return immediately after the first row is complete and has been
	    // attached to the body.
	    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;
	
	    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
	    // goes on a row above the first of the month. Otherwise, the month label takes up the first
	    // two cells of the first row.
	    var blankCellOffset = 0;
	    var monthLabelCell = document.createElement('td');
	    var monthLabelCellContent = document.createElement('span');
	
	    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
	    monthLabelCell.appendChild(monthLabelCellContent);
	    monthLabelCell.classList.add('md-calendar-month-label');
	    // If the entire month is after the max date, render the label as a disabled state.
	    if (this.calendarCtrl.maxDate && firstDayOfMonth > this.calendarCtrl.maxDate) {
	      monthLabelCell.classList.add('md-calendar-month-label-disabled');
	    } else {
	      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
	      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
	      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
	      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
	    }
	
	    if (firstDayOfTheWeek <= 2) {
	      monthLabelCell.setAttribute('colspan', '7');
	
	      var monthLabelRow = this.buildDateRow();
	      monthLabelRow.appendChild(monthLabelCell);
	      monthBody.insertBefore(monthLabelRow, row);
	
	      if (isFinalMonth) {
	        return monthBody;
	      }
	    } else {
	      blankCellOffset = 3;
	      monthLabelCell.setAttribute('colspan', '3');
	      row.appendChild(monthLabelCell);
	    }
	
	    // Add a blank cell for each day of the week that occurs before the first of the month.
	    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
	    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
	    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Add a cell for each day of the month, keeping track of the day of the week so that
	    // we know when to start a new row.
	    var dayOfWeek = firstDayOfTheWeek;
	    var iterationDate = firstDayOfMonth;
	    for (var d = 1; d <= numberOfDaysInMonth; d++) {
	      // If we've reached the end of the week, start a new row.
	      if (dayOfWeek === 7) {
	        // We've finished the first row, so we're done if this is the final month.
	        if (isFinalMonth) {
	          return monthBody;
	        }
	        dayOfWeek = 0;
	        rowNumber++;
	        row = this.buildDateRow(rowNumber);
	        monthBody.appendChild(row);
	      }
	
	      iterationDate.setDate(d);
	      var cell = this.buildDateCell(iterationDate);
	      row.appendChild(cell);
	
	      dayOfWeek++;
	    }
	
	    // Ensure that the last row of the month has 7 cells.
	    while (row.childNodes.length < 7) {
	      row.appendChild(this.buildDateCell());
	    }
	
	    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
	    // requires that all items have exactly the same height.
	    while (monthBody.childNodes.length < 6) {
	      var whitespaceRow = this.buildDateRow();
	      for (var j = 0; j < 7; j++) {
	        whitespaceRow.appendChild(this.buildDateCell());
	      }
	      monthBody.appendChild(whitespaceRow);
	    }
	
	    return monthBody;
	  };
	
	  /**
	   * Gets the day-of-the-week index for a date for the current locale.
	   * @private
	   * @param {Date} date
	   * @returns {number} The column index of the date in the calendar.
	   */
	  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
	    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil"];
	  angular.module('material.components.datepicker')
	    .directive('mdCalendarYear', calendarDirective);
	
	  /**
	   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
	   * subsequently used for scrolling to specific years.
	   */
	  var TBODY_HEIGHT = 88;
	
	  /** Private component, representing a list of years in the calendar. */
	  function calendarDirective() {
	    return {
	      template:
	        '<div class="md-calendar-scroll-mask">' +
	          '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
	            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
	              '<tbody ' +
	                  'md-calendar-year-body ' +
	                  'role="rowgroup" ' +
	                  'md-virtual-repeat="i in yearCtrl.items" ' +
	                  'md-year-offset="$index" class="md-calendar-year" ' +
	                  'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
	                  'md-item-size="' + TBODY_HEIGHT + '">' +
	                // The <tr> ensures that the <tbody> will have the proper
	                // height, even though it may be empty.
	                '<tr aria-hidden="true" style="height:' + TBODY_HEIGHT + 'px;"></tr>' +
	              '</tbody>' +
	            '</table>' +
	          '</md-virtual-repeat-container>' +
	        '</div>',
	      require: ['^^mdCalendar', 'mdCalendarYear'],
	      controller: CalendarYearCtrl,
	      controllerAs: 'yearCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        yearCtrl.initialize(calendarCtrl);
	      }
	    };
	  }
	
	  /**
	   * Controller for the mdCalendar component.
	   * @ngInject @constructor
	   */
	  function CalendarYearCtrl($element, $scope, $animate, $q, $$mdDateUtil) {
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @final {!angular.$animate} */
	    this.$animate = $animate;
	
	    /** @final {!angular.$q} */
	    this.$q = $q;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final {HTMLElement} */
	    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');
	
	    /** @type {boolean} */
	    this.isInitialized = false;
	
	    /** @type {boolean} */
	    this.isMonthTransitionInProgress = false;
	
	    var self = this;
	
	    /**
	     * Handles a click event on a date cell.
	     * Created here so that every cell can use the same function instance.
	     * @this {HTMLTableCellElement} The cell that was clicked.
	     */
	    this.cellClickHandler = function() {
	      self.calendarCtrl.setCurrentView('month', $$mdDateUtil.getTimestampFromNode(this));
	    };
	  }
	
	  /**
	   * Initialize the controller by saving a reference to the calendar and
	   * setting up the object that will be iterated by the virtual repeater.
	   */
	  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
	    /**
	     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
	     * number of years that can be viewed. We add 1 extra in order to include the current year.
	     */
	    this.items = {
	      length: this.dateUtil.getYearDistance(
	        calendarCtrl.firstRenderableDate,
	        calendarCtrl.lastRenderableDate
	      ) + 1
	    };
	
	    this.calendarCtrl = calendarCtrl;
	    this.attachScopeListeners();
	    calendarCtrl.updateVirtualRepeat();
	
	    // Fire the initial render, since we might have missed it the first time it fired.
	    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
	  };
	
	  /**
	   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
	   * @returns {number}
	   */
	  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
	    var calendarCtrl = this.calendarCtrl;
	
	    return this.dateUtil.getYearDistance(
	      calendarCtrl.firstRenderableDate,
	      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
	    );
	  };
	
	  /**
	   * Change the date that is highlighted in the calendar.
	   * @param {Date} date
	   */
	  CalendarYearCtrl.prototype.changeDate = function(date) {
	    // Initialization is deferred until this function is called because we want to reflect
	    // the starting value of ngModel.
	    if (!this.isInitialized) {
	      this.calendarCtrl.hideVerticalScrollbar(this);
	      this.isInitialized = true;
	      return this.$q.when();
	    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
	      var self = this;
	      var animationPromise = this.animateDateChange(date);
	
	      self.isMonthTransitionInProgress = true;
	      self.calendarCtrl.displayDate = date;
	
	      return animationPromise.then(function() {
	        self.isMonthTransitionInProgress = false;
	      });
	    }
	  };
	
	  /**
	   * Animates the transition from the calendar's current month to the given month.
	   * @param {Date} date
	   * @returns {angular.$q.Promise} The animation promise.
	   */
	  CalendarYearCtrl.prototype.animateDateChange = function(date) {
	    if (this.dateUtil.isValidDate(date)) {
	      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
	      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
	    }
	
	    return this.$q.when();
	  };
	
	  /**
	   * Handles the year-view-specific keyboard interactions.
	   * @param {Object} event Scope event object passed by the calendar.
	   * @param {String} action Action, corresponding to the key that was pressed.
	   */
	  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
	    var calendarCtrl = this.calendarCtrl;
	    var displayDate = calendarCtrl.displayDate;
	
	    if (action === 'select') {
	      this.changeDate(displayDate).then(function() {
	        calendarCtrl.setCurrentView('month', displayDate);
	        calendarCtrl.focus(displayDate);
	      });
	    } else {
	      var date = null;
	      var dateUtil = this.dateUtil;
	
	      switch (action) {
	        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
	        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;
	
	        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
	        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
	      }
	
	      if (date) {
	        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
	        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
	        date = dateUtil.getFirstDateOfMonth(this.dateUtil.clampDate(date, min, max));
	
	        this.changeDate(date).then(function() {
	          calendarCtrl.focus(date);
	        });
	      }
	    }
	  };
	
	  /**
	   * Attaches listeners for the scope events that are broadcast by the calendar.
	   */
	  CalendarYearCtrl.prototype.attachScopeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
	      self.changeDate(value);
	    });
	
	    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  CalendarYearBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
	  angular.module('material.components.datepicker')
	      .directive('mdCalendarYearBody', mdCalendarYearDirective);
	
	  /**
	   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
	   * and allows for the year view to use md-virtual-repeat.
	   */
	  function mdCalendarYearDirective() {
	    return {
	      require: ['^^mdCalendar', '^^mdCalendarYear', 'mdCalendarYearBody'],
	      scope: { offset: '=mdYearOffset' },
	      controller: CalendarYearBodyCtrl,
	      controllerAs: 'mdYearBodyCtrl',
	      bindToController: true,
	      link: function(scope, element, attrs, controllers) {
	        var calendarCtrl = controllers[0];
	        var yearCtrl = controllers[1];
	        var yearBodyCtrl = controllers[2];
	
	        yearBodyCtrl.calendarCtrl = calendarCtrl;
	        yearBodyCtrl.yearCtrl = yearCtrl;
	
	        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset) {
	          if (angular.isNumber(offset)) {
	            yearBodyCtrl.generateContent();
	          }
	        });
	      }
	    };
	  }
	
	  /**
	   * Controller for a single year.
	   * @ngInject @constructor
	   */
	  function CalendarYearBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.dateLocale = $mdDateLocale;
	
	    /** @type {Object} Reference to the calendar. */
	    this.calendarCtrl = null;
	
	    /** @type {Object} Reference to the year view. */
	    this.yearCtrl = null;
	
	    /**
	     * Number of months from the start of the month "items" that the currently rendered month
	     * occurs. Set via angular data binding.
	     * @type {number}
	     */
	    this.offset = null;
	
	    /**
	     * Date cell to focus after appending the month to the document.
	     * @type {HTMLElement}
	     */
	    this.focusAfterAppend = null;
	  }
	
	  /** Generate and append the content for this year to the directive element. */
	  CalendarYearBodyCtrl.prototype.generateContent = function() {
	    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);
	
	    this.$element
	      .empty()
	      .append(this.buildCalendarForYear(date));
	
	    if (this.focusAfterAppend) {
	      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
	      this.focusAfterAppend.focus();
	      this.focusAfterAppend = null;
	    }
	  };
	
	  /**
	   * Creates a single cell to contain a year in the calendar.
	   * @param {number} opt_year Four-digit year.
	   * @param {number} opt_month Zero-indexed month.
	   * @returns {HTMLElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
	    var calendarCtrl = this.calendarCtrl;
	    var yearCtrl = this.yearCtrl;
	    var cell = this.buildBlankCell();
	
	    // Represent this month/year as a date.
	    var firstOfMonth = new Date(year, month, 1);
	    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
	    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');
	
	    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
	    cell.setAttribute('data-timestamp', firstOfMonth.getTime());
	
	    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
	      cell.classList.add(calendarCtrl.TODAY_CLASS);
	    }
	
	    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
	        this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
	      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
	      cell.setAttribute('aria-selected', 'true');
	    }
	
	    var cellText = this.dateLocale.shortMonths[month];
	
	    if (this.dateUtil.isMonthWithinRange(firstOfMonth,
	        calendarCtrl.minDate, calendarCtrl.maxDate)) {
	      var selectionIndicator = document.createElement('span');
	      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
	      selectionIndicator.textContent = cellText;
	      cell.appendChild(selectionIndicator);
	      cell.addEventListener('click', yearCtrl.cellClickHandler);
	
	      if (calendarCtrl.displayDate && this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
	        this.focusAfterAppend = cell;
	      }
	    } else {
	      cell.classList.add('md-calendar-date-disabled');
	      cell.textContent = cellText;
	    }
	
	    return cell;
	  };
	
	  /**
	   * Builds a blank cell.
	   * @return {HTMLTableCellElement}
	   */
	  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
	    var cell = document.createElement('td');
	    cell.tabIndex = -1;
	    cell.classList.add('md-calendar-date');
	    cell.setAttribute('role', 'gridcell');
	
	    cell.setAttribute('tabindex', '-1');
	    return cell;
	  };
	
	  /**
	   * Builds the <tbody> content for the given year.
	   * @param {Date} date Date for which the content should be built.
	   * @returns {DocumentFragment} A document fragment containing the months within the year.
	   */
	  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
	    // Store rows for the month in a document fragment so that we can append them all at once.
	    var year = date.getFullYear();
	    var yearBody = document.createDocumentFragment();
	
	    var monthCell, i;
	    // First row contains label and Jan-Jun.
	    var firstRow = document.createElement('tr');
	    var labelCell = document.createElement('td');
	    labelCell.className = 'md-calendar-month-label';
	    labelCell.textContent = year;
	    firstRow.appendChild(labelCell);
	
	    for (i = 0; i < 6; i++) {
	      firstRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(firstRow);
	
	    // Second row contains a blank cell and Jul-Dec.
	    var secondRow = document.createElement('tr');
	    secondRow.appendChild(this.buildBlankCell());
	    for (i = 6; i < 12; i++) {
	      secondRow.appendChild(this.buildMonthCell(year, i));
	    }
	    yearBody.appendChild(secondRow);
	
	    return yearBody;
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @name $mdDateLocaleProvider
	   * @module material.components.datepicker
	   *
	   * @description
	   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
	   * This provider that allows the user to specify messages, formatters, and parsers for date
	   * internationalization. The `$mdDateLocale` service itself is consumed by AngularJS Material
	   * components that deal with dates.
	   *
	   * @property {(Array<string>)=} months Array of month names (in order).
	   * @property {(Array<string>)=} shortMonths Array of abbreviated month names.
	   * @property {(Array<string>)=} days Array of the days of the week (in order).
	   * @property {(Array<string>)=} shortDays Array of abbreviated days of the week.
	   * @property {(Array<string>)=} dates Array of dates of the month. Only necessary for locales
	   *     using a numeral system other than [1, 2, 3...].
	   * @property {(Array<string>)=} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
	   *    etc.
	   * @property {(function(string): Date)=} parseDate Function to parse a date object from a string.
	   * @property {(function(Date, string): string)=} formatDate Function to format a date object to a
	   *     string. The datepicker directive also provides the time zone, if it was specified.
	   * @property {(function(Date): string)=} monthHeaderFormatter Function that returns the label for
	   *     a month given a date.
	   * @property {(function(Date): string)=} monthFormatter Function that returns the full name of a month
	   *     for a given date.
	   * @property {(function(number): string)=} weekNumberFormatter Function that returns a label for
	   *     a week given the week number.
	   * @property {(string)=} msgCalendar Translation of the label "Calendar" for the current locale.
	   * @property {(string)=} msgOpenCalendar Translation of the button label "Open calendar" for the
	   *     current locale.
	   * @property {Date=} firstRenderableDate The date from which the datepicker calendar will begin
	   * rendering. Note that this will be ignored if a minimum date is set. Defaults to January 1st 1880.
	   * @property {Date=} lastRenderableDate The last date that will be rendered by the datepicker
	   * calendar. Note that this will be ignored if a maximum date is set. Defaults to January 1st 2130.
	   *
	   * @usage
	   * <hljs lang="js">
	   * myAppModule.config(function($mdDateLocaleProvider) {
	   *
	   *     // Example of a French localization.
	   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
	   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
	   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
	   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
	   *
	   *     // Can change week display to start on Monday.
	   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
	   *
	   *     // Optional.
	   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
	   *
	   *     // Example uses moment.js to parse and format dates.
	   *     $mdDateLocaleProvider.parseDate = function(dateString) {
	   *       var m = moment(dateString, 'L', true);
	   *       return m.isValid() ? m.toDate() : new Date(NaN);
	   *     };
	   *
	   *     $mdDateLocaleProvider.formatDate = function(date) {
	   *       var m = moment(date);
	   *       return m.isValid() ? m.format('L') : '';
	   *     };
	   *
	   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
	   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
	   *     };
	   *
	   *     // In addition to date display, date components also need localized messages
	   *     // for aria-labels for screen-reader users.
	   *
	   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
	   *       return 'Semaine ' + weekNumber;
	   *     };
	   *
	   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
	   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
	   *
	   *     // You can also set when your calendar begins and ends.
	   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
	   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
	   * });
	   * </hljs>
	   *
	   */
	  angular.module('material.components.datepicker').config(["$provide", function($provide) {
	    // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.
	
	    /** @constructor */
	    function DateLocaleProvider() {
	      /** Array of full month names. E.g., ['January', 'Febuary', ...] */
	      this.months = null;
	
	      /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
	      this.shortMonths = null;
	
	      /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
	      this.days = null;
	
	      /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
	      this.shortDays = null;
	
	      /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
	      this.dates = null;
	
	      /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
	      this.firstDayOfWeek = 0;
	
	      /**
	       * Function that converts the date portion of a Date to a string.
	       * @type {(function(Date): string)}
	       */
	      this.formatDate = null;
	
	      /**
	       * Function that converts a date string to a Date object (the date portion)
	       * @type {function(string): Date}
	       */
	      this.parseDate = null;
	
	      /**
	       * Function that formats a Date into a month header string.
	       * @type {function(Date): string}
	       */
	      this.monthHeaderFormatter = null;
	
	      /**
	       * Function that formats a week number into a label for the week.
	       * @type {function(number): string}
	       */
	      this.weekNumberFormatter = null;
	
	      /**
	       * Function that formats a date into a long aria-label that is read
	       * when the focused date changes.
	       * @type {function(Date): string}
	       */
	      this.longDateFormatter = null;
	
	      /**
	       * ARIA label for the calendar "dialog" used in the datepicker.
	       * @type {string}
	       */
	      this.msgCalendar = '';
	
	      /**
	       * ARIA label for the datepicker's "Open calendar" buttons.
	       * @type {string}
	       */
	      this.msgOpenCalendar = '';
	    }
	
	    /**
	     * Factory function that returns an instance of the dateLocale service.
	     * @ngInject
	     * @param $locale
	     * @returns {DateLocale}
	     */
	    DateLocaleProvider.prototype.$get = function($locale, $filter) {
	      /**
	       * Default date-to-string formatting function.
	       * @param {!Date} date
	       * @param {string=} timezone
	       * @returns {string}
	       */
	      function defaultFormatDate(date, timezone) {
	        if (!date) {
	          return '';
	        }
	
	        // All of the dates created through ng-material *should* be set to midnight.
	        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
	        // we have run into an issue with DST where we need to increment the hour by one:
	        // var d = new Date(1992, 9, 8, 0, 0, 0);
	        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
	        var localeTime = date.toLocaleTimeString();
	        var formatDate = date;
	        if (date.getHours() === 0 &&
	            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
	          formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
	        }
	
	        return $filter('date')(formatDate, 'M/d/yyyy', timezone);
	      }
	
	      /**
	       * Default string-to-date parsing function.
	       * @param {string} dateString
	       * @returns {!Date}
	       */
	      function defaultParseDate(dateString) {
	        return new Date(dateString);
	      }
	
	      /**
	       * Default function to determine whether a string makes sense to be
	       * parsed to a Date object.
	       *
	       * This is very permissive and is just a basic sanity check to ensure that
	       * things like single integers aren't able to be parsed into dates.
	       * @param {string} dateString
	       * @returns {boolean}
	       */
	      function defaultIsDateComplete(dateString) {
	        dateString = dateString.trim();
	
	        // Looks for three chunks of content (either numbers or text) separated
	        // by delimiters.
	        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ \.,]+|[\/\-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
	        return re.test(dateString);
	      }
	
	      /**
	       * Default date-to-string formatter to get a month header.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthHeaderFormatter(date) {
	        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default formatter for a month.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultMonthFormatter(date) {
	        return service.months[date.getMonth()] + ' ' + date.getFullYear();
	      }
	
	      /**
	       * Default week number formatter.
	       * @param number
	       * @returns {string}
	       */
	      function defaultWeekNumberFormatter(number) {
	        return 'Week ' + number;
	      }
	
	      /**
	       * Default formatter for date cell aria-labels.
	       * @param {!Date} date
	       * @returns {string}
	       */
	      function defaultLongDateFormatter(date) {
	        // Example: 'Thursday June 18 2015'
	        return [
	          service.days[date.getDay()],
	          service.months[date.getMonth()],
	          service.dates[date.getDate()],
	          date.getFullYear()
	        ].join(' ');
	      }
	
	      // The default "short" day strings are the first character of each day,
	      // e.g., "Monday" => "M".
	      var defaultShortDays = $locale.DATETIME_FORMATS.SHORTDAY.map(function(day) {
	        return day.substring(0, 1);
	      });
	
	      // The default dates are simply the numbers 1 through 31.
	      var defaultDates = Array(32);
	      for (var i = 1; i <= 31; i++) {
	        defaultDates[i] = i;
	      }
	
	      // Default ARIA messages are in English (US).
	      var defaultMsgCalendar = 'Calendar';
	      var defaultMsgOpenCalendar = 'Open calendar';
	
	      // Default start/end dates that are rendered in the calendar.
	      var defaultFirstRenderableDate = new Date(1880, 0, 1);
	      var defaultLastRendereableDate = new Date(defaultFirstRenderableDate.getFullYear() + 250, 0, 1);
	
	      var service = {
	        months: this.months || $locale.DATETIME_FORMATS.MONTH,
	        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
	        days: this.days || $locale.DATETIME_FORMATS.DAY,
	        shortDays: this.shortDays || defaultShortDays,
	        dates: this.dates || defaultDates,
	        firstDayOfWeek: this.firstDayOfWeek || 0,
	        formatDate: this.formatDate || defaultFormatDate,
	        parseDate: this.parseDate || defaultParseDate,
	        isDateComplete: this.isDateComplete || defaultIsDateComplete,
	        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
	        monthFormatter: this.monthFormatter || defaultMonthFormatter,
	        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
	        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
	        msgCalendar: this.msgCalendar || defaultMsgCalendar,
	        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar,
	        firstRenderableDate: this.firstRenderableDate || defaultFirstRenderableDate,
	        lastRenderableDate: this.lastRenderableDate || defaultLastRendereableDate
	      };
	
	      return service;
	    };
	    DateLocaleProvider.prototype.$get.$inject = ["$locale", "$filter"];
	
	    $provide.provider('$mdDateLocale', new DateLocaleProvider());
	  }]);
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  /**
	   * Utility for performing date calculations to facilitate operation of the calendar and
	   * datepicker.
	   */
	  angular.module('material.components.datepicker').factory('$$mdDateUtil', function() {
	    return {
	      getFirstDateOfMonth: getFirstDateOfMonth,
	      getNumberOfDaysInMonth: getNumberOfDaysInMonth,
	      getDateInNextMonth: getDateInNextMonth,
	      getDateInPreviousMonth: getDateInPreviousMonth,
	      isInNextMonth: isInNextMonth,
	      isInPreviousMonth: isInPreviousMonth,
	      getDateMidpoint: getDateMidpoint,
	      isSameMonthAndYear: isSameMonthAndYear,
	      getWeekOfMonth: getWeekOfMonth,
	      incrementDays: incrementDays,
	      incrementMonths: incrementMonths,
	      getLastDateOfMonth: getLastDateOfMonth,
	      isSameDay: isSameDay,
	      getMonthDistance: getMonthDistance,
	      isValidDate: isValidDate,
	      setDateTimeToMidnight: setDateTimeToMidnight,
	      createDateAtMidnight: createDateAtMidnight,
	      isDateWithinRange: isDateWithinRange,
	      incrementYears: incrementYears,
	      getYearDistance: getYearDistance,
	      clampDate: clampDate,
	      getTimestampFromNode: getTimestampFromNode,
	      isMonthWithinRange: isMonthWithinRange
	    };
	
	    /**
	     * Gets the first day of the month for the given date's month.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getFirstDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), 1);
	    }
	
	    /**
	     * Gets the number of days in the month for the given date's month.
	     * @param date
	     * @returns {number}
	     */
	    function getNumberOfDaysInMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
	    }
	
	    /**
	     * Get an arbitrary date in the month after the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInNextMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	    }
	
	    /**
	     * Get an arbitrary date in the month before the given date's month.
	     * @param date
	     * @returns {Date}
	     */
	    function getDateInPreviousMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
	    }
	
	    /**
	     * Gets whether two dates have the same month and year.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameMonthAndYear(d1, d2) {
	      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
	    }
	
	    /**
	     * Gets whether two dates are the same day (not not necesarily the same time).
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {boolean}
	     */
	    function isSameDay(d1, d2) {
	      return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately after some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInNextMonth(startDate, endDate) {
	      var nextMonth = getDateInNextMonth(startDate);
	      return isSameMonthAndYear(nextMonth, endDate);
	    }
	
	    /**
	     * Gets whether a date is in the month immediately before some date.
	     * @param {Date} startDate The date from which to compare.
	     * @param {Date} endDate The date to check.
	     * @returns {boolean}
	     */
	    function isInPreviousMonth(startDate, endDate) {
	      var previousMonth = getDateInPreviousMonth(startDate);
	      return isSameMonthAndYear(endDate, previousMonth);
	    }
	
	    /**
	     * Gets the midpoint between two dates.
	     * @param {Date} d1
	     * @param {Date} d2
	     * @returns {Date}
	     */
	    function getDateMidpoint(d1, d2) {
	      return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
	    }
	
	    /**
	     * Gets the week of the month that a given date occurs in.
	     * @param {Date} date
	     * @returns {number} Index of the week of the month (zero-based).
	     */
	    function getWeekOfMonth(date) {
	      var firstDayOfMonth = getFirstDateOfMonth(date);
	      return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of days. Number of days can be negative.
	     * @param {Date} date
	     * @param {number} numberOfDays
	     * @returns {Date}
	     */
	    function incrementDays(date, numberOfDays) {
	      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
	    }
	
	    /**
	     * Gets a new date incremented by the given number of months. Number of months can be negative.
	     * If the date of the given month does not match the target month, the date will be set to the
	     * last day of the month.
	     * @param {Date} date
	     * @param {number} numberOfMonths
	     * @returns {Date}
	     */
	    function incrementMonths(date, numberOfMonths) {
	      // If the same date in the target month does not actually exist, the Date object will
	      // automatically advance *another* month by the number of missing days.
	      // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
	      // So, we check if the month overflowed and go to the last day of the target month instead.
	      var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
	      var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
	      if (numberOfDaysInMonth < date.getDate()) {
	        dateInTargetMonth.setDate(numberOfDaysInMonth);
	      } else {
	        dateInTargetMonth.setDate(date.getDate());
	      }
	
	      return dateInTargetMonth;
	    }
	
	    /**
	     * Get the integer distance between two months. This *only* considers the month and year
	     * portion of the Date instances.
	     *
	     * @param {Date} start
	     * @param {Date} end
	     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	     *     chronologically, this number will be negative.
	     */
	    function getMonthDistance(start, end) {
	      return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
	    }
	
	    /**
	     * Gets the last day of the month for the given date.
	     * @param {Date} date
	     * @returns {Date}
	     */
	    function getLastDateOfMonth(date) {
	      return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
	    }
	
	    /**
	     * Checks whether a date is valid.
	     * @param {Date} date
	     * @return {boolean} Whether the date is a valid Date.
	     */
	    function isValidDate(date) {
	      return date && date.getTime && !isNaN(date.getTime());
	    }
	
	    /**
	     * Sets a date's time to midnight.
	     * @param {Date} date
	     */
	    function setDateTimeToMidnight(date) {
	      if (isValidDate(date)) {
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	
	    /**
	     * Creates a date with the time set to midnight.
	     * Drop-in replacement for two forms of the Date constructor:
	     * 1. No argument for Date representing now.
	     * 2. Single-argument value representing number of seconds since Unix Epoch
	     * or a Date object.
	     * @param {number|Date=} opt_value
	     * @return {Date} New date with time set to midnight.
	     */
	    function createDateAtMidnight(opt_value) {
	      var date;
	      if (angular.isUndefined(opt_value)) {
	        date = new Date();
	      } else {
	        date = new Date(opt_value);
	      }
	      setDateTimeToMidnight(date);
	      return date;
	    }
	
	     /**
	      * Checks if a date is within a min and max range, ignoring the time component.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isDateWithinRange(date, minDate, maxDate) {
	       var dateAtMidnight = createDateAtMidnight(date);
	       var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
	       var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
	       return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
	           (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
	     }
	
	    /**
	     * Gets a new date incremented by the given number of years. Number of years can be negative.
	     * See `incrementMonths` for notes on overflow for specific dates.
	     * @param {Date} date
	     * @param {number} numberOfYears
	     * @returns {Date}
	     */
	     function incrementYears(date, numberOfYears) {
	       return incrementMonths(date, numberOfYears * 12);
	     }
	
	     /**
	      * Get the integer distance between two years. This *only* considers the year portion of the
	      * Date instances.
	      *
	      * @param {Date} start
	      * @param {Date} end
	      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
	      *     chronologically, this number will be negative.
	      */
	     function getYearDistance(start, end) {
	       return end.getFullYear() - start.getFullYear();
	     }
	
	     /**
	      * Clamps a date between a minimum and a maximum date.
	      * @param {Date} date Date to be clamped
	      * @param {Date=} minDate Minimum date
	      * @param {Date=} maxDate Maximum date
	      * @return {Date}
	      */
	     function clampDate(date, minDate, maxDate) {
	       var boundDate = date;
	       if (minDate && date < minDate) {
	         boundDate = new Date(minDate.getTime());
	       }
	       if (maxDate && date > maxDate) {
	         boundDate = new Date(maxDate.getTime());
	       }
	       return boundDate;
	     }
	
	     /**
	      * Extracts and parses the timestamp from a DOM node.
	      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
	      * @return {number} Time since epoch.
	      */
	     function getTimestampFromNode(node) {
	       if (node && node.hasAttribute('data-timestamp')) {
	         return Number(node.getAttribute('data-timestamp'));
	       }
	     }
	
	     /**
	      * Checks if a month is within a min and max range, ignoring the date and time components.
	      * If minDate or maxDate are not dates, they are ignored.
	      * @param {Date} date
	      * @param {Date} minDate
	      * @param {Date} maxDate
	      */
	     function isMonthWithinRange(date, minDate, maxDate) {
	       var month = date.getMonth();
	       var year = date.getFullYear();
	
	       return (!minDate || minDate.getFullYear() < year || minDate.getMonth() <= month) &&
	        (!maxDate || maxDate.getFullYear() > year || maxDate.getMonth() >= month);
	     }
	  });
	})();
	
	})();
	(function(){
	"use strict";
	
	(function() {
	  'use strict';
	
	  // POST RELEASE
	  // TODO(jelbourn): Demo that uses moment.js
	  // TODO(jelbourn): make sure this plays well with validation and ngMessages.
	  // TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
	  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
	  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
	  // TODO(jelbourn): input behavior (masking? auto-complete?)
	
	
	  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$filter"];
	  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
	  angular.module('material.components.datepicker')
	      .directive('mdDatepicker', datePickerDirective);
	
	  /**
	   * @ngdoc directive
	   * @name mdDatepicker
	   * @module material.components.datepicker
	   *
	   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a value that can be parsed into one (e.g. a ISO 8601 string).
	   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being updated. Also allows
	   * for a timezone to be specified. <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the ngModelOptions docs.</a>
	   * @param {expression=} ng-change Expression evaluated when the model value changes.
	   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar is opened.
	   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the calendar is closed.
	   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
	   * @param {boolean=} ng-required Whether a value is required for the datepicker.
	   * @param {Date=} md-min-date Expression representing a min date (inclusive).
	   * @param {Date=} md-max-date Expression representing a max date (inclusive).
	   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
	   * @param {String=} md-placeholder The date input placeholder value.
	   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input is focused.
	   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar on-demand.
	   * @param {String=} md-current-view Default open view of the calendar pane. Can be either "month" or "year".
	   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that this may cause the
	   * datepicker to not align properly with other components. **Use at your own risk.** Possible values are:
	   * * `"all"` - Hides all icons.
	   * * `"calendar"` - Only hides the calendar icon.
	   * * `"triangle"` - Only hides the triangle icon.
	   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
	   * ovewritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
	   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
	   *
	   * @description
	   * `<md-datepicker>` is a component used to select a single date.
	   * For information on how to configure internationalization for the date picker,
	   * see `$mdDateLocaleProvider`.
	   *
	   * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
	   * Supported attributes are:
	   * * `required`: whether a required date is not set.
	   * * `mindate`: whether the selected date is before the minimum allowed date.
	   * * `maxdate`: whether the selected date is after the maximum allowed date.
	   * * `debounceInterval`: ms to delay input processing (since last debounce reset); default value 500ms
	   *
	   * @usage
	   * <hljs lang="html">
	   *   <md-datepicker ng-model="birthday"></md-datepicker>
	   * </hljs>
	   *
	   */
	
	  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
	    return {
	      template: function(tElement, tAttrs) {
	        // Buttons are not in the tab order because users can open the calendar via keyboard
	        // interaction on the text input, and multiple tab stops for one component (picker)
	        // may be confusing.
	        var hiddenIcons = tAttrs.mdHideIcons;
	        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;
	
	        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
	          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
	              'tabindex="-1" aria-hidden="true" ' +
	              'ng-click="ctrl.openCalendarPane($event)">' +
	            '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
	                     'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
	          '</md-button>';
	
	        var triangleButton = '';
	
	        if (hiddenIcons !== 'all' && hiddenIcons !== 'triangle') {
	          triangleButton = '' +
	            '<md-button type="button" md-no-ink ' +
	              'class="md-datepicker-triangle-button md-icon-button" ' +
	              'ng-click="ctrl.openCalendarPane($event)" ' +
	              'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
	            '<div class="md-datepicker-expand-triangle"></div>' +
	          '</md-button>';
	
	          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
	        }
	
	        return calendarButton +
	        '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
	          '<input ' +
	            (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
	            'class="md-datepicker-input" ' +
	            'aria-haspopup="true" ' +
	            'aria-expanded="{{ctrl.isCalendarOpen}}" ' +
	            'ng-focus="ctrl.setFocused(true)" ' +
	            'ng-blur="ctrl.setFocused(false)"> ' +
	            triangleButton +
	        '</div>' +
	
	        // This pane will be detached from here and re-attached to the document body.
	        '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
	          '<div class="md-datepicker-input-mask">' +
	            '<div class="md-datepicker-input-mask-opaque"></div>' +
	          '</div>' +
	          '<div class="md-datepicker-calendar">' +
	            '<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
	                'md-current-view="{{::ctrl.currentView}}"' +
	                'md-min-date="ctrl.minDate"' +
	                'md-max-date="ctrl.maxDate"' +
	                'md-date-filter="ctrl.dateFilter"' +
	                'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
	            '</md-calendar>' +
	          '</div>' +
	        '</div>';
	      },
	      require: ['ngModel', 'mdDatepicker', '?^mdInputContainer', '?^form'],
	      scope: {
	        minDate: '=mdMinDate',
	        maxDate: '=mdMaxDate',
	        placeholder: '@mdPlaceholder',
	        currentView: '@mdCurrentView',
	        dateFilter: '=mdDateFilter',
	        isOpen: '=?mdIsOpen',
	        debounceInterval: '=mdDebounceInterval',
	        dateLocale: '=mdDateLocale'
	      },
	      controller: DatePickerCtrl,
	      controllerAs: 'ctrl',
	      bindToController: true,
	      link: function(scope, element, attr, controllers) {
	        var ngModelCtrl = controllers[0];
	        var mdDatePickerCtrl = controllers[1];
	        var mdInputContainer = controllers[2];
	        var parentForm = controllers[3];
	        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
	
	        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);
	
	        if (mdInputContainer) {
	          // We need to move the spacer after the datepicker itself,
	          // because md-input-container adds it after the
	          // md-datepicker-input by default. The spacer gets wrapped in a
	          // div, because it floats and gets aligned next to the datepicker.
	          // There are easier ways of working around this with CSS (making the
	          // datepicker 100% wide, change the `display` etc.), however they
	          // break the alignment with any other form controls.
	          var spacer = element[0].querySelector('.md-errors-spacer');
	
	          if (spacer) {
	            element.after(angular.element('<div>').append(spacer));
	          }
	
	          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
	          mdInputContainer.input = element;
	          mdInputContainer.element
	            .addClass(INPUT_CONTAINER_CLASS)
	            .toggleClass(HAS_CALENDAR_ICON_CLASS, attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');
	
	          if (!mdInputContainer.label) {
	            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
	          } else if(!mdNoAsterisk) {
	            attr.$observe('required', function(value) {
	              mdInputContainer.label.toggleClass('md-required', !!value);
	            });
	          }
	
	          scope.$watch(mdInputContainer.isErrorGetter || function() {
	            return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
	          }, mdInputContainer.setInvalid);
	        } else if (parentForm) {
	          // If invalid, highlights the input when the parent form is submitted.
	          var parentSubmittedWatcher = scope.$watch(function() {
	            return parentForm.$submitted;
	          }, function(isSubmitted) {
	            if (isSubmitted) {
	              mdDatePickerCtrl.updateErrorState();
	              parentSubmittedWatcher();
	            }
	          });
	        }
	      }
	    };
	  }
	
	  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
	  var EXTRA_INPUT_SIZE = 3;
	
	  /** Class applied to the container if the date is invalid. */
	  var INVALID_CLASS = 'md-datepicker-invalid';
	
	  /** Class applied to the datepicker when it's open. */
	  var OPEN_CLASS = 'md-datepicker-open';
	
	  /** Class applied to the md-input-container, if a datepicker is placed inside it */
	  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';
	
	  /** Class to be applied when the calendar icon is enabled. */
	  var HAS_CALENDAR_ICON_CLASS = '_md-datepicker-has-calendar-icon';
	
	  /** Class to be applied when the triangle icon is enabled. */
	  var HAS_TRIANGLE_ICON_CLASS = '_md-datepicker-has-triangle-icon';
	
	  /** Default time in ms to debounce input event by. */
	  var DEFAULT_DEBOUNCE_INTERVAL = 500;
	
	  /**
	   * Height of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_HEIGHT = 368;
	
	  /**
	   * Width of the calendar pane used to check if the pane is going outside the boundary of
	   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
	   * also added to space the pane away from the exact edge of the screen.
	   *
	   *  This is computed statically now, but can be changed to be measured if the circumstances
	   *  of calendar sizing are changed.
	   */
	  var CALENDAR_PANE_WIDTH = 360;
	
	  /** Used for checking whether the current user agent is on iOS or Android. */
	  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;
	
	  /**
	   * Controller for md-datepicker.
	   *
	   * @ngInject @constructor
	   */
	  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant,
	    $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF, $filter) {
	
	    /** @final */
	    this.$window = $window;
	
	    /** @final */
	    this.dateUtil = $$mdDateUtil;
	
	    /** @final */
	    this.$mdConstant = $mdConstant;
	
	    /* @final */
	    this.$mdUtil = $mdUtil;
	
	    /** @final */
	    this.$$rAF = $$rAF;
	
	    /** @final */
	    this.$mdDateLocale = $mdDateLocale;
	
	    /**
	     * The root document element. This is used for attaching a top-level click handler to
	     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
	     * instead of body because, when scrolling is disabled, some browsers consider the body element
	     * to be completely off the screen and propagate events directly to the html element.
	     * @type {!angular.JQLite}
	     */
	    this.documentElement = angular.element(document.documentElement);
	
	    /** @type {!angular.NgModelController} */
	    this.ngModelCtrl = null;
	
	    /** @type {HTMLInputElement} */
	    this.inputElement = $element[0].querySelector('input');
	
	    /** @final {!angular.JQLite} */
	    this.ngInputElement = angular.element(this.inputElement);
	
	    /** @type {HTMLElement} */
	    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');
	
	    /** @type {HTMLElement} Floating calendar pane. */
	    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');
	
	    /** @type {HTMLElement} Calendar icon button. */
	    this.calendarButton = $element[0].querySelector('.md-datepicker-button');
	
	    /**
	     * Element covering everything but the input in the top of the floating calendar pane.
	     * @type {!angular.JQLite}
	     */
	    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));
	
	    /** @final {!angular.JQLite} */
	    this.$element = $element;
	
	    /** @final {!angular.Attributes} */
	    this.$attrs = $attrs;
	
	    /** @final {!angular.Scope} */
	    this.$scope = $scope;
	
	    /** @type {Date} */
	    this.date = null;
	
	    /** @type {boolean} */
	    this.isFocused = false;
	
	    /** @type {boolean} */
	    this.isDisabled;
	    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));
	
	    /** @type {boolean} Whether the date-picker's calendar pane is open. */
	    this.isCalendarOpen = false;
	
	    /** @type {boolean} Whether the calendar should open when the input is focused. */
	    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');
	
	    /** @final */
	    this.mdInputContainer = null;
	
	    /**
	     * Element from which the calendar pane was opened. Keep track of this so that we can return
	     * focus to it when the pane is closed.
	     * @type {HTMLElement}
	     */
	    this.calendarPaneOpenedFrom = null;
	
	    /** @type {String} Unique id for the calendar pane. */
	    this.calendarPaneId = 'md-date-pane-' + $mdUtil.nextUid();
	
	    /** Pre-bound click handler is saved so that the event listener can be removed. */
	    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);
	
	    /**
	     * Name of the event that will trigger a close. Necessary to sniff the browser, because
	     * the resize event doesn't make sense on mobile and can have a negative impact since it
	     * triggers whenever the browser zooms in on a focused input.
	     */
	    this.windowEventName = IS_MOBILE_REGEX.test(
	      navigator.userAgent || navigator.vendor || window.opera
	    ) ? 'orientationchange' : 'resize';
	
	    /** Pre-bound close handler so that the event listener can be removed. */
	    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);
	
	    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
	    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);
	
	    /** The built-in AngularJS date filter. */
	    this.ngDateFilter = $filter('date');
	
	    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
	    this.leftMargin = 20;
	
	    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
	    this.topMargin = null;
	
	    // Unless the user specifies so, the datepicker should not be a tab stop.
	    // This is necessary because ngAria might add a tabindex to anything with an ng-model
	    // (based on whether or not the user has turned that particular feature on/off).
	    if ($attrs.tabindex) {
	      this.ngInputElement.attr('tabindex', $attrs.tabindex);
	      $attrs.$set('tabindex', null);
	    } else {
	      $attrs.$set('tabindex', '-1');
	    }
	
	    $attrs.$set('aria-owns', this.calendarPaneId);
	
	    $mdTheming($element);
	    $mdTheming(angular.element(this.calendarPane));
	
	    var self = this;
	
	    $scope.$on('$destroy', function() {
	      self.detachCalendarPane();
	    });
	
	    if ($attrs.mdIsOpen) {
	      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
	        if (shouldBeOpen) {
	          self.openCalendarPane({
	            target: self.inputElement
	          });
	        } else {
	          self.closeCalendarPane();
	        }
	      });
	    }
	
	    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	    // manually call the $onInit hook.
	    if (angular.version.major === 1 && angular.version.minor <= 4) {
	      this.$onInit();
	    }
	
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  DatePickerCtrl.prototype.$onInit = function() {
	
	    /**
	     * Holds locale-specific formatters, parsers, labels etc. Allows
	     * the user to override specific ones from the $mdDateLocale provider.
	     * @type {!Object}
	     */
	    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale) : this.$mdDateLocale;
	
	    this.installPropertyInterceptors();
	    this.attachChangeListeners();
	    this.attachInteractionListeners();
	  };
	
	  /**
	   * Sets up the controller's reference to ngModelController and
	   * applies AngularJS's `input[type="date"]` directive.
	   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
	   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
	   * @param {Object} inputDirective Config for AngularJS's `input` directive.
	   */
	  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
	    this.ngModelCtrl = ngModelCtrl;
	    this.mdInputContainer = mdInputContainer;
	
	    // The input needs to be [type="date"] in order to be picked up by AngularJS.
	    this.$attrs.$set('type', 'date');
	
	    // Invoke the `input` directive link function, adding a stub for the element.
	    // This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
	    // It works by calling the link function directly which then adds the proper `$parsers` and
	    // `$formatters` to the ngModel controller.
	    inputDirective[0].link.pre(this.$scope, {
	      on: angular.noop,
	      val: angular.noop,
	      0: {}
	    }, this.$attrs, [ngModelCtrl]);
	
	    var self = this;
	
	    // Responds to external changes to the model value.
	    self.ngModelCtrl.$formatters.push(function(value) {
	      var parsedValue = angular.isDefined(value) ? Date.parse(value) : null;
	
	      // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
	      if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
	        value = new Date(parsedValue);
	      }
	
	      if (value && !(value instanceof Date)) {
	        throw Error(
	          'The ng-model for md-datepicker must be a Date instance or a value ' +
	          'that can be parsed into a date. Currently the model is of type: ' + typeof value
	        );
	      }
	
	      self.onExternalChange(value);
	
	      return value;
	    });
	
	    // Responds to external error state changes (e.g. ng-required based on another input).
	    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));
	
	    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
	    // working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
	    // the `<md-datepicker>`.
	    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, 'updateOn');
	
	    if (updateOn) {
	      this.ngInputElement.on(
	        updateOn,
	        angular.bind(this.$element, this.$element.triggerHandler, updateOn)
	      );
	    }
	  };
	
	  /**
	   * Attach event listeners for both the text input and the md-calendar.
	   * Events are used instead of ng-model so that updates don't infinitely update the other
	   * on a change. This should also be more performant than using a $watch.
	   */
	  DatePickerCtrl.prototype.attachChangeListeners = function() {
	    var self = this;
	
	    self.$scope.$on('md-calendar-change', function(event, date) {
	      self.setModelValue(date);
	      self.onExternalChange(date);
	      self.closeCalendarPane();
	    });
	
	    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
	
	    var debounceInterval = angular.isDefined(this.debounceInterval) ?
	        this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
	    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
	        debounceInterval, self));
	  };
	
	  /** Attach event listeners for user interaction. */
	  DatePickerCtrl.prototype.attachInteractionListeners = function() {
	    var self = this;
	    var $scope = this.$scope;
	    var keyCodes = this.$mdConstant.KEY_CODE;
	
	    // Add event listener through angular so that we can triggerHandler in unit tests.
	    self.ngInputElement.on('keydown', function(event) {
	      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
	        self.openCalendarPane(event);
	        $scope.$digest();
	      }
	    });
	
	    if (self.openOnFocus) {
	      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
	      angular.element(self.$window).on('blur', self.windowBlurHandler);
	
	      $scope.$on('$destroy', function() {
	        angular.element(self.$window).off('blur', self.windowBlurHandler);
	      });
	    }
	
	    $scope.$on('md-calendar-close', function() {
	      self.closeCalendarPane();
	    });
	  };
	
	  /**
	   * Capture properties set to the date-picker and imperitively handle internal changes.
	   * This is done to avoid setting up additional $watches.
	   */
	  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
	    var self = this;
	
	    if (this.$attrs.ngDisabled) {
	      // The expression is to be evaluated against the directive element's scope and not
	      // the directive's isolate scope.
	      var scope = this.$scope.$parent;
	
	      if (scope) {
	        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
	          self.setDisabled(isDisabled);
	        });
	      }
	    }
	
	    Object.defineProperty(this, 'placeholder', {
	      get: function() { return self.inputElement.placeholder; },
	      set: function(value) { self.inputElement.placeholder = value || ''; }
	    });
	  };
	
	  /**
	   * Sets whether the date-picker is disabled.
	   * @param {boolean} isDisabled
	   */
	  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
	    this.isDisabled = isDisabled;
	    this.inputElement.disabled = isDisabled;
	
	    if (this.calendarButton) {
	      this.calendarButton.disabled = isDisabled;
	    }
	  };
	
	  /**
	   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
	   *   - mindate: whether the selected date is before the minimum date.
	   *   - maxdate: whether the selected flag is after the maximum date.
	   *   - filtered: whether the selected date is allowed by the custom filtering function.
	   *   - valid: whether the entered text input is a valid date
	   *
	   * The 'required' flag is handled automatically by ngModel.
	   *
	   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
	   */
	  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
	    var date = opt_date || this.date;
	
	    // Clear any existing errors to get rid of anything that's no longer relevant.
	    this.clearErrorState();
	
	    if (this.dateUtil.isValidDate(date)) {
	      // Force all dates to midnight in order to ignore the time portion.
	      date = this.dateUtil.createDateAtMidnight(date);
	
	      if (this.dateUtil.isValidDate(this.minDate)) {
	        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
	        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
	      }
	
	      if (this.dateUtil.isValidDate(this.maxDate)) {
	        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
	        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
	      }
	
	      if (angular.isFunction(this.dateFilter)) {
	        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
	      }
	    } else {
	      // The date is seen as "not a valid date" if there is *something* set
	      // (i.e.., not null or undefined), but that something isn't a valid date.
	      this.ngModelCtrl.$setValidity('valid', date == null);
	    }
	
	    angular.element(this.inputContainer).toggleClass(INVALID_CLASS, !this.ngModelCtrl.$valid);
	  };
	
	  /** Clears any error flags set by `updateErrorState`. */
	  DatePickerCtrl.prototype.clearErrorState = function() {
	    this.inputContainer.classList.remove(INVALID_CLASS);
	    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
	      this.ngModelCtrl.$setValidity(field, true);
	    }, this);
	  };
	
	  /** Resizes the input element based on the size of its content. */
	  DatePickerCtrl.prototype.resizeInputElement = function() {
	    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
	  };
	
	  /**
	   * Sets the model value if the user input is a valid date.
	   * Adds an invalid class to the input element if not.
	   */
	  DatePickerCtrl.prototype.handleInputEvent = function() {
	    var inputString = this.inputElement.value;
	    var parsedDate = inputString ? this.locale.parseDate(inputString) : null;
	    this.dateUtil.setDateTimeToMidnight(parsedDate);
	
	    // An input string is valid if it is either empty (representing no date)
	    // or if it parses to a valid date that the user is allowed to select.
	    var isValidInput = inputString == '' || (
	      this.dateUtil.isValidDate(parsedDate) &&
	      this.locale.isDateComplete(inputString) &&
	      this.isDateEnabled(parsedDate)
	    );
	
	    // The datepicker's model is only updated when there is a valid input.
	    if (isValidInput) {
	      this.setModelValue(parsedDate);
	      this.date = parsedDate;
	    }
	
	    this.updateErrorState(parsedDate);
	  };
	
	  /**
	   * Check whether date is in range and enabled
	   * @param {Date=} opt_date
	   * @return {boolean} Whether the date is enabled.
	   */
	  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
	    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
	          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
	  };
	
	  /** Position and attach the floating calendar to the document. */
	  DatePickerCtrl.prototype.attachCalendarPane = function() {
	    var calendarPane = this.calendarPane;
	    var body = document.body;
	
	    calendarPane.style.transform = '';
	    this.$element.addClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
	    angular.element(body).addClass('md-datepicker-is-showing');
	
	    var elementRect = this.inputContainer.getBoundingClientRect();
	    var bodyRect = body.getBoundingClientRect();
	
	    if (!this.topMargin || this.topMargin < 0) {
	      this.topMargin = (this.inputMask.parent().prop('clientHeight') - this.ngInputElement.prop('clientHeight')) / 2;
	    }
	
	    // Check to see if the calendar pane would go off the screen. If so, adjust position
	    // accordingly to keep it within the viewport.
	    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
	    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;
	
	    // If ng-material has disabled body scrolling (for example, if a dialog is open),
	    // then it's possible that the already-scrolled body has a negative top/left. In this case,
	    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
	    // though, the top of the viewport should just be the body's scroll position.
	    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
	        -bodyRect.top :
	        document.body.scrollTop;
	
	    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
	        -bodyRect.left :
	        document.body.scrollLeft;
	
	    var viewportBottom = viewportTop + this.$window.innerHeight;
	    var viewportRight = viewportLeft + this.$window.innerWidth;
	
	    // Creates an overlay with a hole the same size as element. We remove a pixel or two
	    // on each end to make it overlap slightly. The overlay's background is added in
	    // the theme in the form of a box-shadow with a huge spread.
	    this.inputMask.css({
	      position: 'absolute',
	      left: this.leftMargin + 'px',
	      top: this.topMargin + 'px',
	      width: (elementRect.width - 1) + 'px',
	      height: (elementRect.height - 2) + 'px'
	    });
	
	    // If the right edge of the pane would be off the screen and shifting it left by the
	    // difference would not go past the left edge of the screen. If the calendar pane is too
	    // big to fit on the screen at all, move it to the left of the screen and scale the entire
	    // element down to fit.
	    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
	      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
	        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
	      } else {
	        paneLeft = viewportLeft;
	        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
	        calendarPane.style.transform = 'scale(' + scale + ')';
	      }
	
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    // If the bottom edge of the pane would be off the screen and shifting it up by the
	    // difference would not go past the top edge of the screen.
	    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
	        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
	      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
	      calendarPane.classList.add('md-datepicker-pos-adjusted');
	    }
	
	    calendarPane.style.left = paneLeft + 'px';
	    calendarPane.style.top = paneTop + 'px';
	    document.body.appendChild(calendarPane);
	
	    // Add CSS class after one frame to trigger open animation.
	    this.$$rAF(function() {
	      calendarPane.classList.add('md-pane-open');
	    });
	  };
	
	  /** Detach the floating calendar pane from the document. */
	  DatePickerCtrl.prototype.detachCalendarPane = function() {
	    this.$element.removeClass(OPEN_CLASS);
	    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
	    angular.element(document.body).removeClass('md-datepicker-is-showing');
	    this.calendarPane.classList.remove('md-pane-open');
	    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');
	
	    if (this.isCalendarOpen) {
	      this.$mdUtil.enableScrolling();
	    }
	
	    if (this.calendarPane.parentNode) {
	      // Use native DOM removal because we do not want any of the
	      // angular state of this element to be disposed.
	      this.calendarPane.parentNode.removeChild(this.calendarPane);
	    }
	  };
	
	  /**
	   * Open the floating calendar pane.
	   * @param {Event} event
	   */
	  DatePickerCtrl.prototype.openCalendarPane = function(event) {
	    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
	      this.isCalendarOpen = this.isOpen = true;
	      this.calendarPaneOpenedFrom = event.target;
	
	      // Because the calendar pane is attached directly to the body, it is possible that the
	      // rest of the component (input, etc) is in a different scrolling container, such as
	      // an md-content. This means that, if the container is scrolled, the pane would remain
	      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
	      // also matches the native behavior for things like `<select>` on Mac and Windows.
	      this.$mdUtil.disableScrollAround(this.calendarPane);
	
	      this.attachCalendarPane();
	      this.focusCalendar();
	      this.evalAttr('ngFocus');
	
	      // Attach click listener inside of a timeout because, if this open call was triggered by a
	      // click, we don't want it to be immediately propogated up to the body and handled.
	      var self = this;
	      this.$mdUtil.nextTick(function() {
	        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
	        // events aren't propogated under most circumstances.
	        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        self.documentElement.on('click touchstart', self.bodyClickHandler);
	      }, false);
	
	      window.addEventListener(this.windowEventName, this.windowEventHandler);
	    }
	  };
	
	  /** Close the floating calendar pane. */
	  DatePickerCtrl.prototype.closeCalendarPane = function() {
	    if (this.isCalendarOpen) {
	      var self = this;
	
	      self.detachCalendarPane();
	      self.ngModelCtrl.$setTouched();
	      self.evalAttr('ngBlur');
	
	      self.documentElement.off('click touchstart', self.bodyClickHandler);
	      window.removeEventListener(self.windowEventName, self.windowEventHandler);
	
	      self.calendarPaneOpenedFrom.focus();
	      self.calendarPaneOpenedFrom = null;
	
	      if (self.openOnFocus) {
	        // Ensures that all focus events have fired before resetting
	        // the calendar. Prevents the calendar from reopening immediately
	        // in IE when md-open-on-focus is set. Also it needs to trigger
	        // a digest, in order to prevent issues where the calendar wasn't
	        // showing up on the next open.
	        self.$mdUtil.nextTick(reset);
	      } else {
	        reset();
	      }
	    }
	
	    function reset(){
	      self.isCalendarOpen = self.isOpen = false;
	    }
	  };
	
	  /** Gets the controller instance for the calendar in the floating pane. */
	  DatePickerCtrl.prototype.getCalendarCtrl = function() {
	    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
	  };
	
	  /** Focus the calendar in the floating pane. */
	  DatePickerCtrl.prototype.focusCalendar = function() {
	    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
	    var self = this;
	    this.$mdUtil.nextTick(function() {
	      self.getCalendarCtrl().focus();
	    }, false);
	  };
	
	  /**
	   * Sets whether the input is currently focused.
	   * @param {boolean} isFocused
	   */
	  DatePickerCtrl.prototype.setFocused = function(isFocused) {
	    if (!isFocused) {
	      this.ngModelCtrl.$setTouched();
	    }
	
	    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
	    // because they also get called when the calendar is opened/closed.
	    if (!this.openOnFocus) {
	      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
	    }
	
	    this.isFocused = isFocused;
	  };
	
	  /**
	   * Handles a click on the document body when the floating calendar pane is open.
	   * Closes the floating calendar pane if the click is not inside of it.
	   * @param {MouseEvent} event
	   */
	  DatePickerCtrl.prototype.handleBodyClick = function(event) {
	    if (this.isCalendarOpen) {
	      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
	
	      if (!isInCalendar) {
	        this.closeCalendarPane();
	      }
	
	      this.$scope.$digest();
	    }
	  };
	
	  /**
	   * Handles the event when the user navigates away from the current tab. Keeps track of
	   * whether the input was focused when the event happened, in order to prevent the calendar
	   * from re-opening.
	   */
	  DatePickerCtrl.prototype.handleWindowBlur = function() {
	    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
	  };
	
	  /**
	   * Evaluates an attribute expression against the parent scope.
	   * @param {String} attr Name of the attribute to be evaluated.
	   */
	  DatePickerCtrl.prototype.evalAttr = function(attr) {
	    if (this.$attrs[attr]) {
	      this.$scope.$parent.$eval(this.$attrs[attr]);
	    }
	  };
	
	  /**
	   * Sets the ng-model value by first converting the date object into a strng. Converting it
	   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
	   * the value into a Date object afterwards, before setting it on the model.
	   * @param {Date=} value Date to be set as the model value.
	   */
	  DatePickerCtrl.prototype.setModelValue = function(value) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	    this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone));
	  };
	
	  /**
	   * Updates the datepicker when a model change occurred externally.
	   * @param {Date=} value Value that was set to the model.
	   */
	  DatePickerCtrl.prototype.onExternalChange = function(value) {
	    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
	
	    this.date = value;
	    this.inputElement.value = this.locale.formatDate(value, timezone);
	    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
	    this.resizeInputElement();
	    this.updateErrorState();
	  };
	})();
	
	})();
	(function(){
	"use strict";
	
	angular
	  .module('material.components.icon')
	  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);
	
	/**
	 * @ngdoc directive
	 * @name mdIcon
	 * @module material.components.icon
	 *
	 * @restrict E
	 *
	 * @description
	 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
	 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
	 *
	 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
	 * inside a `md-button` to add hover and click features.
	 *
	 * ### Icon fonts
	 * Icon fonts are a technique in which you use a font where the glyphs in the font are
	 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
	 * single HTTP request, simple scaling, easy color changing, and more.
	 *
	 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
	 * by name rather than character code.
	 *
	 * ### SVG
	 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
	 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
	 * animation.
	 *
	 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
	 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
	 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
	 * reference it by name instead of URL throughout your templates.
	 *
	 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
	 * your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can
	 * also be given a name, which acts as a namespace for individual icons, so you can reference them
	 * like `"social:cake"`.
	 *
	 * When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be
	 * easily loaded and used. When using font-icons, developers must follow three (3) simple steps:
	 *
	 * <ol>
	 * <li>Load the font library. e.g.<br/>
	 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
	 *    rel="stylesheet">`
	 * </li>
	 * <li>
	 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
	 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
	 *   none is specified.
	 * </li>
	 * <li> Use any of the following templates: <br/>
	 *   <ul>
	 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
	 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
	 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
	 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
	 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
	 *   </ul>
	 * </li>
	 * </ol>
	 *
	 * Full details for these steps can be found:
	 *
	 * <ul>
	 * <li>http://google.github.io/material-design-icons/</li>
	 * <li>http://google.github.io/material-design-icons/#icon-font-for-the-web</li>
	 * </ul>
	 *
	 * The Material Design icon style <code>.material-icons</code> and the icon font references are published in
	 * Material Design Icons:
	 *
	 * <ul>
	 * <li>https://design.google.com/icons/</li>
	 * <li>https://design.google.com/icons/#ic_accessibility</li>
	 * </ul>
	 *
	 * ### Localization
	 *
	 * Because an `md-icon` element's text content is not intended to translated, it is recommended to declare the text
	 * content for an `md-icon` element in its start tag. Instead of using the HTML text content, consider using `ng-bind`
	 * with a scope variable or literal string.
	 *
	 * Examples:
	 *
	 * <ul>
	 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
	 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
	 * </ul>
	 *
	 * <h2 id="material_design_icons">Material Design Icons</h2>
	 * Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and
	 * determine its textual name and character reference code. Click on any icon to see the slide-up information
	 * panel with details regarding a SVG download or information on the font-icon usage.
	 *
	 * <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">
	 * <img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png"
	 *      aria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%">
	 * </a>
	 *
	 * <span class="image_caption">
	 *  Click on the image above to link to the
	 *  <a href="https://design.google.com/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.
	 * </span>
	 *
	 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
	 * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
	 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
	 * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
	 * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
	 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
	 *     external SVG.
	 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
	 *     interpolated strings or expressions may also be used. Specific set names can be used with
	 *     the syntax `<set name>:<icon name>`.<br/><br/>
	 * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
	 * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
	 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
	 * nor a label on the parent element, a warning will be logged to the console.
	 *
	 * @usage
	 * When using SVGs:
	 * <hljs lang="html">
	 *
	 *  <!-- Icon ID; may contain optional icon set prefix; icons must registered using $mdIconProvider -->
	 *  <md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
	 *
	 *  <!-- Icon urls; may be preloaded in templateCache -->
	 *  <md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
	 *  <md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
	 *
	 * </hljs>
	 *
	 * Use the <code>$mdIconProvider</code> to configure your application with
	 * svg iconsets.
	 *
	 * <hljs lang="js">
	 *  angular.module('appSvgIconSets', ['ngMaterial'])
	 *    .controller('DemoCtrl', function($scope) {})
	 *    .config(function($mdIconProvider) {
	 *      $mdIconProvider
	 *         .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
	 *         .defaultIconSet('img/icons/sets/core-icons.svg', 24);
	 *     });
	 * </hljs>
	 *
	 *
	 * When using Font Icons with classnames:
	 * <hljs lang="html">
	 *
	 *  <md-icon md-font-icon="android" aria-label="android" ></md-icon>
	 *  <md-icon class="icon_home"      aria-label="Home"    ></md-icon>
	 *
	 * </hljs>
	 *
	 * When using Material Font Icons with ligatures:
	 * <hljs lang="html">
	 *  <!--
	 *  For Material Design Icons
	 *  The class '.material-icons' is auto-added if a style has NOT been specified
	 *  since `material-icons` is the default fontset. So your markup:
	 *  -->
	 *  <md-icon> face </md-icon>
	 *  <!-- becomes this at runtime: -->
	 *  <md-icon md-font-set="material-icons"> face </md-icon>
	 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
	 *  <md-icon> &#xE87C; </md-icon>
	 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
	 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
	 * </hljs>
	 *
	 * When using other Font-Icon libraries:
	 *
	 * <hljs lang="js">
	 *  // Specify a font-icon style alias
	 *  angular.config(function($mdIconProvider) {
	 *    $mdIconProvider.fontSet('md', 'material-icons');
	 *  });
	 * </hljs>
	 *
	 * <hljs lang="html">
	 *  <md-icon md-font-set="md">favorite</md-icon>
	 * </hljs>
	 *
	 */
	function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {
	
	  return {
	    restrict: 'E',
	    link : postLink
	  };
	
	
	  /**
	   * Directive postLink
	   * Supports embedded SVGs, font-icons, & external SVGs
	   */
	  function postLink(scope, element, attr) {
	    $mdTheming(element);
	    var lastFontIcon = attr.mdFontIcon;
	    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	    prepareForFontIcon();
	
	    attr.$observe('mdFontIcon', fontIconChanged);
	    attr.$observe('mdFontSet', fontIconChanged);
	
	    // Keep track of the content of the svg src so we can compare against it later to see if the
	    // attribute is static (and thus safe).
	    var originalSvgSrc = element[0].getAttribute(attr.$attr.mdSvgSrc);
	
	    // If using a font-icon, then the textual name of the icon itself
	    // provides the aria-label.
	
	    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');
	
	    /* Provide a default accessibility role of img */
	    if (!attr.role) {
	      $mdAria.expect(element, 'role', 'img');
	      /* manually update attr variable */
	      attr.role = 'img';
	    }
	
	    /* Don't process ARIA if already valid */
	    if ( attr.role === "img" && !attr.ariaHidden && !$mdAria.hasAriaLabel(element) ) {
	      var iconName;
	      if (attr.alt) {
	        /* Use alt text by default if available */
	        $mdAria.expect(element, 'aria-label', attr.alt);
	      } else if ($mdAria.parentHasAriaLabel(element, 2)) {
	        /* Parent has ARIA so we will assume it will describe the image */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      } else if (iconName = (attr.mdFontIcon || attr.mdSvgIcon || element.text())) {
	        /* Use icon name as aria-label */
	        $mdAria.expect(element, 'aria-label', iconName);
	      } else {
	        /* No label found */
	        $mdAria.expect(element, 'aria-hidden', 'true');
	      }
	    }
	
	    if (attrName) {
	      // Use either pre-configured SVG or URL source, respectively.
	      attr.$observe(attrName, function(attrVal) {
	        element.empty();
	        if (attrVal) {
	          $mdIcon(attrVal)
	            .then(function(svg) {
	            element.empty();
	            element.append(svg);
	          });
	        }
	      });
	    }
	
	    function prepareForFontIcon() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.addClass('md-font ' + attr.mdFontIcon);
	        }
	
	        element.addClass(lastFontSet);
	      }
	    }
	
	    function fontIconChanged() {
	      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
	        if (attr.mdFontIcon) {
	          element.removeClass(lastFontIcon);
	          element.addClass(attr.mdFontIcon);
	
	          lastFontIcon = attr.mdFontIcon;
	        }
	
	        var fontSet = $mdIcon.fontSet(attr.mdFontSet);
	
	        if (lastFontSet !== fontSet) {
	          element.removeClass(lastFontSet);
	          element.addClass(fontSet);
	
	          lastFontSet = fontSet;
	        }
	      }
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	  
	MdIconService.$inject = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
	    .module('material.components.icon')
	    .constant('$$mdSvgRegistry', {
	        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
	        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
	        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
	        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
	        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
	        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
	        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
	    })
	    .provider('$mdIcon', MdIconProvider);
	
	/**
	 * @ngdoc service
	 * @name $mdIconProvider
	 * @module material.components.icon
	 *
	 * @description
	 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
	 * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
	 * directives are compiled.
	 *
	 * If using font-icons, the developer is responsible for loading the fonts.
	 *
	 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
	 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
	 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
	 * that URL is used to on-demand load and parse the SVG dynamically.
	 *
	 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
	 * This means, when loading icons from an external URL, you have to trust the URL in the `$sceDelegateProvider`.
	 *
	 * <hljs lang="js">
	 *   app.config(function($sceDelegateProvider) {
	 *     $sceDelegateProvider.resourceUrlWhitelist([
	 *       // Adding 'self' to the whitelist, will allow requests from the current origin.
	 *       'self',
	 *       // Using double asterisks here, will allow all URLs to load.
	 *       // We recommend to only specify the given domain you want to allow.
	 *       '**'
	 *     ]);
	 *   });
	 * </hljs>
	 *
	 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
	 *
	 * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
	 *  In such cases you are not able to use the icon's ligature name - Like so:
	 *
	 *  <hljs lang="html">
	 *    <md-icon md-font-set="fa">fa-bell</md-icon>
	 *  </hljs>
	 *
	 * You should instead use the given unicode, instead of the ligature name.
	 *
	 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
	 *  ```html
	 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
	 *  ```
	 *
	 * All unicode ligatures are prefixed with the `&#x` string.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
	    *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
	 * **startup** process (shown below):
	 *
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Register a default set of SVG icon definitions
	    *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
	    *
	    *   })
	 *   .run(function($templateRequest){
	    *
	    *     // Pre-fetch icons sources by URL and cache in the $templateCache...
	    *     // subsequent $templateRequest calls will look there first.
	    *
	    *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
	    *
	    *     angular.forEach(urls, function(url) {
	    *       $templateRequest(url);
	    *     });
	    *
	    *   });
	 *
	 * </hljs>
	 *
	 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#icon
	 *
	 * @description
	 * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
	 * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
	 *
	 * @param {string} id Icon name/id used to register the icon
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
	 * It is ignored for icons with an existing viewBox. Default size is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
	    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#iconSet
	 *
	 * @description
	 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
	 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
	 * `$mdIcon(<icon set name>:<icon name>)`
	 *
	 * @param {string} id Icon name/id used to register the iconset
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultIconSet
	 *
	 * @description
	 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
	 * subsequent lookups of icons will failover to search this 'default' icon set.
	 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
	 *
	 * @param {string} url specifies the external location for the data file. Used internally by
	 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
	 * was configured.
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
	 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
	 * Default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
	    *   });
	 * </hljs>
	 *
	 */
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultFontSet
	 *
	 * @description
	 * When using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and automatically
	 * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
	 * class style that should be applied to the `<md-icon>`.
	 *
	 * Configuring the default means that the attributes
	 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
	 * `<md-icon>` markup. For example:
	 *
	 *  `<md-icon> face </md-icon>`
	 *  will render as
	 *  `<span class="material-icons"> face </span>`, and
	 *
	 *  `<md-icon md-font-set="fa"> face </md-icon>`
	 *  will render as
	 *  `<span class="fa"> face </span>`
	 *
	 * @param {string} name of the font-library style that should be applied to the md-icon DOM element
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     $mdIconProvider.defaultFontSet( 'fa' );
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#fontSet
	 *
	 * @description
	 * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
	 * attribute. If the fonset className is really long, your markup may become cluttered... an easy
	 * solution is to define an `alias` for your fontset:
	 *
	 * @param {string} alias of the specified fontset.
	 * @param {string} className of the fontset.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	   *     // In this case, we set an alias for the `material-icons` fontset.
	   *     $mdIconProvider.fontSet('md', 'material-icons');
	   *   });
	 * </hljs>
	 *
	 */
	
	/**
	 * @ngdoc method
	 * @name $mdIconProvider#defaultViewBoxSize
	 *
	 * @description
	 * While `<md-icon />` markup can also be style with sizing CSS, this method configures
	 * the default width **and** height used for all icons; unless overridden by specific CSS.
	 * The default sizing is (24px, 24px).
	 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
	 * All icons in a set should be the same size. The default value is 24.
	 *
	 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
	 *
	 * @usage
	 * <hljs lang="js">
	 *   app.config(function($mdIconProvider) {
	    *
	    *     // Configure URLs for icons specified by [set:]id.
	    *
	    *     $mdIconProvider
	    *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
	    *   });
	 * </hljs>
	 *
	 */
	
	var config = {
	  defaultViewBoxSize: 24,
	  defaultFontSet: 'material-icons',
	  fontSets: []
	};
	
	function MdIconProvider() {
	}
	
	MdIconProvider.prototype = {
	  icon: function(id, url, viewBoxSize) {
	    if (id.indexOf(':') == -1) id = '$default:' + id;
	
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  iconSet: function(id, url, viewBoxSize) {
	    config[id] = new ConfigurationItem(url, viewBoxSize);
	    return this;
	  },
	
	  defaultIconSet: function(url, viewBoxSize) {
	    var setName = '$default';
	
	    if (!config[setName]) {
	      config[setName] = new ConfigurationItem(url, viewBoxSize);
	    }
	
	    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	
	    return this;
	  },
	
	  defaultViewBoxSize: function(viewBoxSize) {
	    config.defaultViewBoxSize = viewBoxSize;
	    return this;
	  },
	
	  /**
	   * Register an alias name associated with a font-icon library style ;
	   */
	  fontSet: function fontSet(alias, className) {
	    config.fontSets.push({
	      alias: alias,
	      fontSet: className || alias
	    });
	    return this;
	  },
	
	  /**
	   * Specify a default style name associated with a font-icon library
	   * fallback to Material Icons.
	   *
	   */
	  defaultFontSet: function defaultFontSet(className) {
	    config.defaultFontSet = !className ? '' : className;
	    return this;
	  },
	
	  defaultIconSize: function defaultIconSize(iconSize) {
	    config.defaultIconSize = iconSize;
	    return this;
	  },
	
	  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
	    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
	  }]
	};
	
	/**
	 *  Configuration item stored in the Icon registry; used for lookups
	 *  to load if not already cached in the `loaded` cache
	 */
	function ConfigurationItem(url, viewBoxSize) {
	  this.url = url;
	  this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
	}
	
	/**
	 * @ngdoc service
	 * @name $mdIcon
	 * @module material.components.icon
	 *
	 * @description
	 * The `$mdIcon` service is a function used to lookup SVG icons.
	 *
	 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
	 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
	 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
	 *
	 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
	 * using the `$mdIconProvider`.
	 *
	 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
	 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
	 * will get rejected.
	 *
	 * @usage
	 * <hljs lang="js">
	 * function SomeDirective($mdIcon) {
	  *
	  *   // See if the icon has already been loaded, if not
	  *   // then lookup the icon from the registry cache, load and cache
	  *   // it for future requests.
	  *   // NOTE: ID queries require configuration with $mdIconProvider
	  *
	  *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
	  *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
	  *
	  *   // Load and cache the external SVG using a URL
	  *
	  *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
	  *     element.append(iconEl);
	  *   });
	  * };
	 * </hljs>
	 *
	 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, loaded,
	 *   and instantiate SVG DOM elements.
	 */
	
	/* @ngInject */
	function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
	  var iconCache = {};
	  var svgCache = {};
	  var urlRegex = /[-\w@:%\+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%\+.~#?&//=]*)?/i;
	  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-\=]*?(base64)?,(.*)$/i;
	
	  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
	  getIcon.fontSet = findRegisteredFontSet;
	
	  // Publish service...
	  return getIcon;
	
	  /**
	   * Actual $mdIcon service is essentially a lookup function
	   */
	  function getIcon(id) {
	    id = id || '';
	
	    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
	    // over a URL string. If the value is not trusted, this will intentionally throw an error
	    // because the user is attempted to use an unsafe URL, potentially opening themselves up
	    // to an XSS attack.
	    if (!angular.isString(id)) {
	      id = $sce.getTrustedUrl(id);
	    }
	
	    // If already loaded and cached, use a clone of the cached icon.
	    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.
	
	    if (iconCache[id]) {
	      return $q.when(transformClone(iconCache[id]));
	    }
	
	    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
	      return loadByURL(id).then(cacheIcon(id));
	    }
	
	    if (id.indexOf(':') == -1) {
	      id = '$default:' + id;
	    }
	
	    var load = config[id] ? loadByID : loadFromIconSet;
	    return load(id)
	      .then(cacheIcon(id));
	  }
	
	  /**
	   * Lookup registered fontSet style using its alias...
	   * If not found,
	   */
	  function findRegisteredFontSet(alias) {
	    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
	    if (useDefault) return config.defaultFontSet;
	
	    var result = alias;
	    angular.forEach(config.fontSets, function(it) {
	      if (it.alias == alias) result = it.fontSet || result;
	    });
	
	    return result;
	  }
	
	  function transformClone(cacheElement) {
	    var clone = cacheElement.clone();
	    var cacheSuffix = '_cache' + $mdUtil.nextUid();
	
	    // We need to modify for each cached icon the id attributes.
	    // This is needed because SVG id's are treated as normal DOM ids
	    // and should not have a duplicated id.
	    if (clone.id) clone.id += cacheSuffix;
	    angular.forEach(clone.querySelectorAll('[id]'), function(item) {
	      item.id += cacheSuffix;
	    });
	
	    return clone;
	  }
	
	  /**
	   * Prepare and cache the loaded icon for the specified `id`
	   */
	  function cacheIcon(id) {
	
	    return function updateCache(icon) {
	      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);
	
	      return iconCache[id].clone();
	    };
	  }
	
	  /**
	   * Lookup the configuration in the registry, if !registered throw an error
	   * otherwise load the icon [on-demand] using the registered URL.
	   *
	   */
	  function loadByID(id) {
	    var iconConfig = config[id];
	    return loadByURL(iconConfig.url).then(function(icon) {
	      return new Icon(icon, iconConfig);
	    });
	  }
	
	  /**
	   *    Loads the file as XML and uses querySelector( <id> ) to find
	   *    the desired node...
	   */
	  function loadFromIconSet(id) {
	    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
	    var iconSetConfig = config[setName];
	
	    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);
	
	    function extractFromSet(set) {
	      var iconName = id.slice(id.lastIndexOf(':') + 1);
	      var icon = set.querySelector('#' + iconName);
	      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
	    }
	
	    function announceIdNotFound(id) {
	      var msg = 'icon ' + id + ' not found';
	      $log.warn(msg);
	
	      return $q.reject(msg || id);
	    }
	  }
	
	  /**
	   * Load the icon by URL (may use the $templateCache).
	   * Extract the data for later conversion to Icon
	   */
	  function loadByURL(url) {
	    /* Load the icon from embedded data URL. */
	    function loadByDataUrl(url) {
	      var results = dataUrlRegex.exec(url);
	      var isBase64 = /base64/i.test(url);
	      var data = isBase64 ? window.atob(results[2]) : results[2];
	
	      return $q.when(angular.element(data)[0]);
	    }
	
	    /* Load the icon by URL using HTTP. */
	    function loadByHttpUrl(url) {
	      return $q(function(resolve, reject) {
	        // Catch HTTP or generic errors not related to incorrect icon IDs.
	        var announceAndReject = function(err) {
	            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
	            $log.warn(msg);
	            reject(err);
	          },
	          extractSvg = function(response) {
	            if (!svgCache[url]) {
	              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
	            }
	            resolve(svgCache[url]);
	          };
	
	        $templateRequest(url, true).then(extractSvg, announceAndReject);
	      });
	    }
	
	    return dataUrlRegex.test(url)
	      ? loadByDataUrl(url)
	      : loadByHttpUrl(url);
	  }
	
	  /**
	   * Check target signature to see if it is an Icon instance.
	   */
	  function isIcon(target) {
	    return angular.isDefined(target.element) && angular.isDefined(target.config);
	  }
	
	  /**
	   *  Define the Icon class
	   */
	  function Icon(el, config) {
	    if (el && el.tagName != 'svg') {
	      el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
	    }
	
	    // Inject the namespace if not available...
	    if (!el.getAttribute('xmlns')) {
	      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	    }
	
	    this.element = el;
	    this.config = config;
	    this.prepare();
	  }
	
	  /**
	   *  Prepare the DOM element that will be cached in the
	   *  loaded iconCache store.
	   */
	  function prepareAndStyle() {
	    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
	    angular.forEach({
	      'fit': '',
	      'height': '100%',
	      'width': '100%',
	      'preserveAspectRatio': 'xMidYMid meet',
	      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
	      'focusable': false // Disable IE11s default behavior to make SVGs focusable
	    }, function(val, attr) {
	      this.element.setAttribute(attr, val);
	    }, this);
	  }
	
	  /**
	   * Clone the Icon DOM element.
	   */
	  function cloneSVG() {
	    // If the element or any of its children have a style attribute, then a CSP policy without
	    // 'unsafe-inline' in the style-src directive, will result in a violation.
	    return this.element.cloneNode(true);
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	
	MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q", "$log"];
	angular
	    .module('material.components.menu')
	    .controller('mdMenuCtrl', MenuController);
	
	/**
	 * @ngInject
	 */
	function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q, $log) {
	
	  var prefixer = $mdUtil.prefixer();
	  var menuContainer;
	  var self = this;
	  var triggerElement;
	
	  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;
	
	  /**
	   * Called by our linking fn to provide access to the menu-content
	   * element removed during link
	   */
	  this.init = function init(setMenuContainer, opts) {
	    opts = opts || {};
	    menuContainer = setMenuContainer;
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
	    triggerElement.setAttribute('aria-expanded', 'false');
	
	    this.isInMenuBar = opts.isInMenuBar;
	    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));
	
	    menuContainer.on('$mdInterimElementRemove', function() {
	      self.isOpen = false;
	      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    });
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
	    menuContainer.attr('id', menuContainerId);
	    angular.element(triggerElement).attr({
	      'aria-owns': menuContainerId,
	      'aria-haspopup': 'true'
	    });
	
	    $scope.$on('$destroy', angular.bind(this, function() {
	      this.disableHoverListener();
	      $mdMenu.destroy();
	    }));
	
	    menuContainer.on('$destroy', function() {
	      $mdMenu.destroy();
	    });
	  };
	
	  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
	  this.enableHoverListener = function() {
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = el.controller('mdMenu');
	        self.isAlreadyOpening = false;
	        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
	      }
	    }));
	    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
	      if (menuContainer[0].contains(el[0])) {
	        self.currentlyOpenMenu = undefined;
	      }
	    }));
	    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
	    menuItems.on('mouseenter', self.handleMenuItemHover);
	    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.disableHoverListener = function() {
	    while (deregisterScopeListeners.length) {
	      deregisterScopeListeners.shift()();
	    }
	    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
	    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
	  };
	
	  this.handleMenuItemHover = function(event) {
	    if (self.isAlreadyOpening) return;
	    var nestedMenu = (
	      event.target.querySelector('md-menu')
	        || $mdUtil.getClosest(event.target, 'MD-MENU')
	    );
	    openMenuTimeout = $timeout(function() {
	      if (nestedMenu) {
	        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
	      }
	
	      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
	        var closeTo = self.nestLevel + 1;
	        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
	        self.isAlreadyOpening = !!nestedMenu;
	        nestedMenu && nestedMenu.open();
	      }
	    }, nestedMenu ? 100 : 250);
	    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
	    focusableTarget && focusableTarget.focus();
	  };
	
	  this.handleMenuItemMouseLeave = function() {
	    if (openMenuTimeout) {
	      $timeout.cancel(openMenuTimeout);
	      openMenuTimeout = undefined;
	    }
	  };
	
	
	  /**
	   * Uses the $mdMenu interim element service to open the menu contents
	   */
	  this.open = function openMenu(ev) {
	    ev && ev.stopPropagation();
	    ev && ev.preventDefault();
	    if (self.isOpen) return;
	    self.enableHoverListener();
	    self.isOpen = true;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
	    triggerElement.setAttribute('aria-expanded', 'true');
	    $scope.$emit('$mdMenuOpen', $element);
	    $mdMenu.show({
	      scope: $scope,
	      mdMenuCtrl: self,
	      nestLevel: self.nestLevel,
	      element: menuContainer,
	      target: triggerElement,
	      preserveElement: true,
	      parent: 'body'
	    }).finally(function() {
	      triggerElement.setAttribute('aria-expanded', 'false');
	      self.disableHoverListener();
	    });
	  };
	
	  this.onIsOpenChanged = function(isOpen) {
	    if (isOpen) {
	      menuContainer.attr('aria-hidden', 'false');
	      $element[0].classList.add('md-open');
	      angular.forEach(self.nestedMenus, function(el) {
	        el.classList.remove('md-open');
	      });
	    } else {
	      menuContainer.attr('aria-hidden', 'true');
	      $element[0].classList.remove('md-open');
	    }
	    $scope.$mdMenuIsOpen = self.isOpen;
	  };
	
	  this.focusMenuContainer = function focusMenuContainer() {
	    var focusTarget = menuContainer[0]
	      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button:not([disabled])');
	    focusTarget.focus();
	  };
	
	  this.registerContainerProxy = function registerContainerProxy(handler) {
	    this.containerProxy = handler;
	  };
	
	  this.triggerContainerProxy = function triggerContainerProxy(ev) {
	    this.containerProxy && this.containerProxy(ev);
	  };
	
	  this.destroy = function() {
	    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
	  };
	
	  // Use the $mdMenu interim element service to close the menu contents
	  this.close = function closeMenu(skipFocus, closeOpts) {
	    if ( !self.isOpen ) return;
	    self.isOpen = false;
	    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
	
	    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
	    $scope.$emit('$mdMenuClose', $element, eventDetails);
	    $mdMenu.hide(null, closeOpts);
	
	    if (!skipFocus) {
	      var el = self.restoreFocusTo || $element.find('button')[0];
	      if (el instanceof angular.element) el = el[0];
	      if (el) el.focus();
	    }
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies the
	   * target mode for left and top positioning
	   */
	  this.positionMode = function positionMode() {
	    var attachment = ($attrs.mdPositionMode || 'target').split(' ');
	
	    // If attachment is a single item, duplicate it for our second value.
	    // ie. 'target' -> 'target target'
	    if (attachment.length == 1) {
	      attachment.push(attachment[0]);
	    }
	
	    return {
	      left: attachment[0],
	      top: attachment[1]
	    };
	  };
	
	  /**
	   * Build a nice object out of our string attribute which specifies
	   * the offset of top and left in pixels.
	   */
	  this.offsets = function offsets() {
	    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
	    if (position.length == 2) {
	      return {
	        left: position[0],
	        top: position[1]
	      };
	    } else if (position.length == 1) {
	      return {
	        top: position[0],
	        left: position[0]
	      };
	    } else {
	      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
	    }
	  };
	
	  // Functionality that is exposed in the view.
	  $scope.$mdMenu = {
	    open: this.open,
	    close: this.close
	  };
	
	  // Deprecated APIs
	  $scope.$mdOpenMenu = angular.bind(this, function() {
	    $log.warn('mdMenu: The $mdOpenMenu method is deprecated. Please use `$mdMenu.open`.');
	    return this.open.apply(this, arguments);
	  });
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenu
	 * @module material.components.menu
	 * @restrict E
	 * @description
	 *
	 * Menus are elements that open when clicked. They are useful for displaying
	 * additional options within the context of an action.
	 *
	 * Every `md-menu` must specify exactly two child elements. The first element is what is
	 * left in the DOM and is used to open the menu. This element is called the trigger element.
	 * The trigger element's scope has access to `$mdMenu.open($event)`
	 * which it may call to open the menu. By passing $event as argument, the
	 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
	 * can be used to close the menu.
	 *
	 * The second element is the `md-menu-content` element which represents the
	 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
	 * but you can do custom content as well.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <!-- Trigger element is a md-button with an icon -->
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	
	 * ## Sizing Menus
	 *
	 * The width of the menu when it is open may be specified by specifying a `width`
	 * attribute on the `md-menu-content` element.
	 * See the [Material Design Spec](https://material.google.com/components/menus.html#menus-simple-menus)
	 * for more information.
	 *
	 *
	 * ## Aligning Menus
	 *
	 * When a menu opens, it is important that the content aligns with the trigger element.
	 * Failure to align menus can result in jarring experiences for users as content
	 * suddenly shifts. To help with this, `md-menu` provides serveral APIs to help
	 * with alignment.
	 *
	 * ### Target Mode
	 *
	 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
	 * designated child elements in both the trigger and the menu content.
	 *
	 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
	 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
	 * will be used as the origin element.
	 *
	 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
	 * `md-menu-item` to specify the node that it should try and align with.
	 *
	 * In this example code, we specify an icon to be our origin element, and an
	 * icon in our menu content to be our alignment target. This ensures that both
	 * icons are aligned when the menu opens.
	 *
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
	 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item>
	 *      <md-button ng-click="doSomething()" aria-label="Do something">
	 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *        Do Something
	 *      </md-button>
	 *    </md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * Sometimes we want to specify alignment on the right side of an element, for example
	 * if we have a menu on the right side a toolbar, we want to right align our menu content.
	 *
	 * We can specify the origin by using the `md-position-mode` attribute on both
	 * the `x` and `y` axis. Right now only the `x-axis` has more than one option.
	 * You may specify the default mode of `target target` or
	 * `target-right target` to specify a right-oriented alignment target. See the
	 * position section of the demos for more examples.
	 *
	 * ### Menu Offsets
	 *
	 * It is sometimes unavoidable to need to have a deeper level of control for
	 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
	 * the `md-offset` attribute to allow pixel level specificty of adjusting the
	 * exact positioning.
	 *
	 * This offset is provided in the format of `x y` or `n` where `n` will be used
	 * in both the `x` and `y` axis.
	 *
	 * For example, to move a menu by `2px` down from the top, we can use:
	 * <hljs lang="html">
	 * <md-menu md-offset="0 2">
	 *   <!-- menu-content -->
	 * </md-menu>
	 * </hljs>
	 *
	 * ### Auto Focus
	 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
	 *
	 * But sometimes you would like to focus another specific menu item instead of the first.<br/>
	 * This can be done by applying the `md-autofocus` directive on the given element.
	 *
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-button md-autofocus ng-click="doSomething()">
	 *     Auto Focus
	 *   </md-button>
	 * </md-menu-item>
	 * </hljs>
	 *
	 *
	 * ### Preventing close
	 *
	 * Sometimes you would like to be able to click on a menu item without having the menu
	 * close. To do this, AngularJS Material exposes the `md-prevent-menu-close` attribute which
	 * can be added to a button inside a menu to stop the menu from automatically closing.
	 * You can then close the menu either by using `$mdMenu.close()` in the template,
	 * or programatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
	 *
	 * <hljs lang="html">
	 * <md-menu-content ng-mouseleave="$mdMenu.close()">
	 *   <md-menu-item>
	 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
	 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
	 *       Do Something
	 *     </md-button>
	 *   </md-menu-item>
	 * </md-menu-content>
	 * </hljs>
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu>
	 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
	 *    <md-icon md-svg-icon="call:phone"></md-icon>
	 *  </md-button>
	 *  <md-menu-content>
	 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
	 *  </md-menu-content>
	 * </md-menu>
	 * </hljs>
	 *
	 * @param {string} md-position-mode The position mode in the form of
	 *           `x`, `y`. Default value is `target`,`target`. Right now the `x` axis
	 *           also supports `target-right`.
	 * @param {string} md-offset An offset to apply to the dropdown after positioning
	 *           `x`, `y`. Default value is `0`,`0`.
	 *
	 */
	
	MenuDirective.$inject = ["$mdUtil"];
	angular
	    .module('material.components.menu')
	    .directive('mdMenu', MenuDirective);
	
	/**
	 * @ngInject
	 */
	function MenuDirective($mdUtil) {
	  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
	  return {
	    restrict: 'E',
	    require: ['mdMenu', '?^mdMenuBar'],
	    controller: 'mdMenuCtrl', // empty function to be built by link
	    scope: true,
	    compile: compile
	  };
	
	  function compile(templateElement) {
	    templateElement.addClass('md-menu');
	
	    var triggerEl = templateElement.children()[0];
	    var contentEl = templateElement.children()[1];
	
	    var prefixer = $mdUtil.prefixer();
	
	    if (!prefixer.hasAttribute(triggerEl, 'ng-click')) {
	      triggerEl = triggerEl
	          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerEl;
	    }
	
	    var isButtonTrigger = triggerEl.nodeName === 'MD-BUTTON' || triggerEl.nodeName === 'BUTTON';
	
	    if (triggerEl && isButtonTrigger && !triggerEl.hasAttribute('type')) {
	      triggerEl.setAttribute('type', 'button');
	    }
	
	    if (!triggerEl) {
	      throw Error(INVALID_PREFIX + 'Expected the menu to have a trigger element.');
	    }
	
	    if (!contentEl || contentEl.nodeName !== 'MD-MENU-CONTENT') {
	      throw Error(INVALID_PREFIX + 'Expected the menu to contain a `md-menu-content` element.');
	    }
	
	    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
	    triggerEl && triggerEl.setAttribute('aria-haspopup', 'true');
	
	    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
	    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
	    if (nestedMenus) {
	      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
	        if (!menuEl.hasAttribute('md-position-mode')) {
	          menuEl.setAttribute('md-position-mode', 'cascade');
	        }
	        menuEl.classList.add('_md-nested-menu');
	        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
	      });
	    }
	    return link;
	  }
	
	  function link(scope, element, attr, ctrls) {
	    var mdMenuCtrl = ctrls[0];
	    var isInMenuBar = !!ctrls[1];
	    // Move everything into a md-menu-container and pass it to the controller
	    var menuContainer = angular.element( '<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
	    var menuContents = element.children()[1];
	
	    element.addClass('_md');     // private md component indicator for styling
	
	    if (!menuContents.hasAttribute('role')) {
	      menuContents.setAttribute('role', 'menu');
	    }
	    menuContainer.append(menuContents);
	
	    element.on('$destroy', function() {
	      menuContainer.remove();
	    });
	
	    element.append(menuContainer);
	    menuContainer[0].style.display = 'none';
	    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar });
	
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuProvider.$inject = ["$$interimElementProvider"];angular
	  .module('material.components.menu')
	  .provider('$mdMenu', MenuProvider);
	
	/*
	 * Interim element provider for the menu.
	 * Handles behavior for a menu while it is open, including:
	 *    - handling animating the menu opening/closing
	 *    - handling key/mouse events on the menu element
	 *    - handling enabling/disabling scroll while the menu is open
	 *    - handling redrawing during resizes and orientation changes
	 *
	 */
	
	function MenuProvider($$interimElementProvider) {
	  menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$log"];
	  var MENU_EDGE_MARGIN = 8;
	
	  return $$interimElementProvider('$mdMenu')
	    .setDefaults({
	      methods: ['target'],
	      options: menuDefaultOptions
	    });
	
	  /* @ngInject */
	  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF,
	                              $animateCss, $animate, $log) {
	
	    var prefixer = $mdUtil.prefixer();
	    var animator = $mdUtil.dom.animator;
	
	    return {
	      parent: 'body',
	      onShow: onShow,
	      onRemove: onRemove,
	      hasBackdrop: true,
	      disableParentScroll: true,
	      skipCompile: true,
	      preserveScope: true,
	      multiple: true,
	      themable: true
	    };
	
	    /**
	     * Show modal backdrop element...
	     * @returns {function(): void} A function that removes this backdrop
	     */
	    function showBackdrop(scope, element, options) {
	      if (options.nestLevel) return angular.noop;
	
	      // If we are not within a dialog...
	      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
	        // !! DO this before creating the backdrop; since disableScrollAround()
	        //    configures the scroll offset; which is used by mdBackDrop postLink()
	        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
	      } else {
	        options.disableParentScroll = false;
	      }
	
	      if (options.hasBackdrop) {
	        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");
	
	        $animate.enter(options.backdrop, $document[0].body);
	      }
	
	      /**
	       * Hide and destroys the backdrop created by showBackdrop()
	       */
	      return function hideBackdrop() {
	        if (options.backdrop) options.backdrop.remove();
	        if (options.disableParentScroll) options.restoreScroll();
	      };
	    }
	
	    /**
	     * Removing the menu element from the DOM and remove all associated event listeners
	     * and backdrop
	     */
	    function onRemove(scope, element, opts) {
	      opts.cleanupInteraction();
	      opts.cleanupBackdrop();
	      opts.cleanupResizing();
	      opts.hideBackdrop();
	
	      // Before the menu is closing remove the clickable class.
	      element.removeClass('md-clickable');
	
	      // For navigation $destroy events, do a quick, non-animated removal,
	      // but for normal closes (from clicks, etc) animate the removal
	
	      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then( detachAndClean );
	
	      /**
	       * For normal closes, animate the removal.
	       * For forced closes (like $destroy events), skip the animations
	       */
	      function animateRemoval() {
	        return $animateCss(element, {addClass: 'md-leave'}).start();
	      }
	
	      /**
	       * Detach the element
	       */
	      function detachAndClean() {
	        element.removeClass('md-active');
	        detachElement(element, opts);
	        opts.alreadyOpen = false;
	      }
	
	    }
	
	    /**
	     * Inserts and configures the staged Menu element into the DOM, positioning it,
	     * and wiring up various interaction events
	     */
	    function onShow(scope, element, opts) {
	      sanitizeAndConfigure(opts);
	
	      if (opts.menuContentEl[0]) {
	        // Inherit the theme from the target element.
	        $mdTheming.inherit(opts.menuContentEl, opts.target);
	      } else {
	        $log.warn(
	          '$mdMenu: Menu elements should always contain a `md-menu-content` element,' +
	          'otherwise interactivity features will not work properly.',
	          element
	        );
	      }
	      
	      // Register various listeners to move menu on resize/orientation change
	      opts.cleanupResizing = startRepositioningOnResize();
	      opts.hideBackdrop = showBackdrop(scope, element, opts);
	
	      // Return the promise for when our menu is done animating in
	      return showMenu()
	        .then(function(response) {
	          opts.alreadyOpen = true;
	          opts.cleanupInteraction = activateInteraction();
	          opts.cleanupBackdrop = setupBackdrop();
	
	          // Since the menu finished its animation, mark the menu as clickable.
	          element.addClass('md-clickable');
	
	          return response;
	        });
	
	      /**
	       * Place the menu into the DOM and call positioning related functions
	       */
	      function showMenu() {
	        opts.parent.append(element);
	        element[0].style.display = '';
	
	        return $q(function(resolve) {
	          var position = calculateMenuPosition(element, opts);
	
	          element.removeClass('md-leave');
	
	          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
	          // to normal scale.
	          $animateCss(element, {
	            addClass: 'md-active',
	            from: animator.toCss(position),
	            to: animator.toCss({transform: ''})
	          })
	          .start()
	          .then(resolve);
	
	        });
	      }
	
	      /**
	       * Check for valid opts and set some sane defaults
	       */
	      function sanitizeAndConfigure() {
	        if (!opts.target) {
	          throw Error(
	            '$mdMenu.show() expected a target to animate from in options.target'
	          );
	        }
	        angular.extend(opts, {
	          alreadyOpen: false,
	          isRemoved: false,
	          target: angular.element(opts.target), //make sure it's not a naked dom node
	          parent: angular.element(opts.parent),
	          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
	        });
	      }
	
	      /**
	       * Configure various resize listeners for screen changes
	       */
	      function startRepositioningOnResize() {
	
	        var repositionMenu = (function(target, options) {
	          return $$rAF.throttle(function() {
	            if (opts.isRemoved) return;
	            var position = calculateMenuPosition(target, options);
	
	            target.css(animator.toCss(position));
	          });
	        })(element, opts);
	
	        $window.addEventListener('resize', repositionMenu);
	        $window.addEventListener('orientationchange', repositionMenu);
	
	        return function stopRepositioningOnResize() {
	
	          // Disable resizing handlers
	          $window.removeEventListener('resize', repositionMenu);
	          $window.removeEventListener('orientationchange', repositionMenu);
	
	        };
	      }
	
	      /**
	       * Sets up the backdrop and listens for click elements.
	       * Once the backdrop will be clicked, the menu will automatically close.
	       * @returns {!Function} Function to remove the backdrop.
	       */
	      function setupBackdrop() {
	        if (!opts.backdrop) return angular.noop;
	
	        opts.backdrop.on('click', onBackdropClick);
	
	        return function() {
	          opts.backdrop.off('click', onBackdropClick);
	        }
	      }
	
	      /**
	       * Function to be called whenever the backdrop is clicked.
	       * @param {!MouseEvent} event
	       */
	      function onBackdropClick(event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        scope.$apply(function() {
	          opts.mdMenuCtrl.close(true, { closeAll: true });
	        });
	      }
	
	      /**
	       * Activate interaction on the menu. Resolves the focus target and closes the menu on
	       * escape or option click.
	       * @returns {!Function} Function to deactivate the interaction listeners.
	       */
	      function activateInteraction() {
	        if (!opts.menuContentEl[0]) return angular.noop;
	
	        // Wire up keyboard listeners.
	        // - Close on escape,
	        // - focus next item on down arrow,
	        // - focus prev item on up
	        opts.menuContentEl.on('keydown', onMenuKeyDown);
	        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);
	
	        // kick off initial focus in the menu on the first enabled element
	        var focusTarget = opts.menuContentEl[0]
	          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));
	
	        if ( !focusTarget ) {
	          var childrenLen = opts.menuContentEl[0].children.length;
	          for(var childIndex = 0; childIndex < childrenLen; childIndex++) {
	            var child = opts.menuContentEl[0].children[childIndex];
	            focusTarget = child.querySelector('.md-button:not([disabled])');
	            if (focusTarget) {
	              break;
	            }
	            if (child.firstElementChild && !child.firstElementChild.disabled) {
	              focusTarget = child.firstElementChild;
	              break;
	            }
	          }
	        }
	
	        focusTarget && focusTarget.focus();
	
	        return function cleanupInteraction() {
	          opts.menuContentEl.off('keydown', onMenuKeyDown);
	          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
	        };
	
	        // ************************************
	        // internal functions
	        // ************************************
	
	        function onMenuKeyDown(ev) {
	          var handled;
	          switch (ev.keyCode) {
	            case $mdConstant.KEY_CODE.ESCAPE:
	              opts.mdMenuCtrl.close(false, { closeAll: true });
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.UP_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.DOWN_ARROW:
	              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.LEFT_ARROW:
	              if (opts.nestLevel) {
	                opts.mdMenuCtrl.close();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	            case $mdConstant.KEY_CODE.RIGHT_ARROW:
	              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
	              if (parentMenu && parentMenu != opts.parent[0]) {
	                ev.target.click();
	              } else {
	                opts.mdMenuCtrl.triggerContainerProxy(ev);
	              }
	              handled = true;
	              break;
	          }
	          if (handled) {
	            ev.preventDefault();
	            ev.stopImmediatePropagation();
	          }
	        }
	
	        function onBackdropClick(e) {
	          e.preventDefault();
	          e.stopPropagation();
	          scope.$apply(function() {
	            opts.mdMenuCtrl.close(true, { closeAll: true });
	          });
	        }
	
	        // Close menu on menu item click, if said menu-item is not disabled
	        function captureClickListener(e) {
	          var target = e.target;
	          // Traverse up the event until we get to the menuContentEl to see if
	          // there is an ng-click and that the ng-click is not disabled
	          do {
	            if (target == opts.menuContentEl[0]) return;
	            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
	                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
	              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
	              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
	                close();
	              }
	              break;
	            }
	          } while (target = target.parentNode);
	
	          function close() {
	            scope.$apply(function() {
	              opts.mdMenuCtrl.close(true, { closeAll: true });
	            });
	          }
	
	          function hasAnyAttribute(target, attrs) {
	            if (!target) return false;
	
	            for (var i = 0, attr; attr = attrs[i]; ++i) {
	              if (prefixer.hasAttribute(target, attr)) {
	                return true;
	              }
	            }
	
	            return false;
	          }
	        }
	
	      }
	    }
	
	    /**
	     * Takes a keypress event and focuses the next/previous menu
	     * item from the emitting element
	     * @param {event} e - The origin keypress event
	     * @param {angular.element} menuEl - The menu element
	     * @param {object} opts - The interim element options for the mdMenu
	     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
	     */
	    function focusMenuItem(e, menuEl, opts, direction) {
	      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');
	
	      var items = $mdUtil.nodesToArray(menuEl[0].children);
	      var currentIndex = items.indexOf(currentItem);
	
	      // Traverse through our elements in the specified direction (+/-1) and try to
	      // focus them until we find one that accepts focus
	      var didFocus;
	      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
	        var focusTarget = items[i].querySelector('.md-button');
	        didFocus = attemptFocus(focusTarget);
	        if (didFocus) {
	          break;
	        }
	      }
	      return didFocus;
	    }
	
	    /**
	     * Attempts to focus an element. Checks whether that element is the currently
	     * focused element after attempting.
	     * @param {HTMLElement} el - the element to attempt focus on
	     * @returns {bool} - whether the element was successfully focused
	     */
	    function attemptFocus(el) {
	      if (el && el.getAttribute('tabindex') != -1) {
	        el.focus();
	        return ($document[0].activeElement == el);
	      }
	    }
	
	    /**
	     * Use browser to remove this element without triggering a $destroy event
	     */
	    function detachElement(element, opts) {
	      if (!opts.preserveElement) {
	        if (toNode(element).parentNode === toNode(opts.parent)) {
	          toNode(opts.parent).removeChild(toNode(element));
	        }
	      } else {
	        toNode(element).style.display = 'none';
	      }
	    }
	
	    /**
	     * Computes menu position and sets the style on the menu container
	     * @param {HTMLElement} el - the menu container element
	     * @param {object} opts - the interim element options object
	     */
	    function calculateMenuPosition(el, opts) {
	
	      var containerNode = el[0],
	        openMenuNode = el[0].firstElementChild,
	        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
	        boundryNode = $document[0].body,
	        boundryNodeRect = boundryNode.getBoundingClientRect();
	
	      var menuStyle = $window.getComputedStyle(openMenuNode);
	
	      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
	        originNodeRect = originNode.getBoundingClientRect();
	
	      var bounds = {
	        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
	        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
	        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
	        right: boundryNodeRect.right - MENU_EDGE_MARGIN
	      };
	
	      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
	      var positionMode = opts.mdMenuCtrl.positionMode();
	
	      if (positionMode.top == 'target' || positionMode.left == 'target' || positionMode.left == 'target-right') {
	        alignTarget = firstVisibleChild();
	        if ( alignTarget ) {
	          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
	          alignTarget = alignTarget.firstElementChild || alignTarget;
	          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
	          alignTargetRect = alignTarget.getBoundingClientRect();
	
	          existingOffsets = {
	            top: parseFloat(containerNode.style.top || 0),
	            left: parseFloat(containerNode.style.left || 0)
	          };
	        }
	      }
	
	      var position = {};
	      var transformOrigin = 'top ';
	
	      switch (positionMode.top) {
	        case 'target':
	          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
	          break;
	        case 'cascade':
	          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
	          break;
	        case 'bottom':
	          position.top = originNodeRect.top + originNodeRect.height;
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
	      }
	
	      var rtl = ($mdUtil.bidi() == 'rtl');
	
	      switch (positionMode.left) {
	        case 'target':
	          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
	          transformOrigin += rtl ? 'right'  : 'left';
	          break;
	        case 'target-left':
	          position.left = originNodeRect.left;
	          transformOrigin += 'left';
	          break;
	        case 'target-right':
	          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
	          transformOrigin += 'right';
	          break;
	        case 'cascade':
	          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
	          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
	          transformOrigin += willFitRight ? 'left' : 'right';
	          break;
	        case 'right':
	          if (rtl) {
	            position.left = originNodeRect.right - originNodeRect.width;
	            transformOrigin += 'left';
	          } else {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          }
	          break;
	        case 'left':
	          if (rtl) {
	            position.left = originNodeRect.right - openMenuNodeRect.width;
	            transformOrigin += 'right';
	          } else {
	            position.left = originNodeRect.left;
	            transformOrigin += 'left';
	          }
	          break;
	        default:
	          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
	      }
	
	      var offsets = opts.mdMenuCtrl.offsets();
	      position.top += offsets.top;
	      position.left += offsets.left;
	
	      clamp(position);
	
	      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
	      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;
	
	      return {
	        top: Math.round(position.top),
	        left: Math.round(position.left),
	        // Animate a scale out if we aren't just repositioning
	        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
	        transformOrigin: transformOrigin
	      };
	
	      /**
	       * Clamps the repositioning of the menu within the confines of
	       * bounding element (often the screen/body)
	       */
	      function clamp(pos) {
	        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
	        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
	      }
	
	      /**
	       * Gets the first visible child in the openMenuNode
	       * Necessary incase menu nodes are being dynamically hidden
	       */
	      function firstVisibleChild() {
	        for (var i = 0; i < openMenuNode.children.length; ++i) {
	          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
	            return openMenuNode.children[i];
	          }
	        }
	      }
	    }
	  }
	  function toNode(el) {
	    if (el instanceof angular.element) {
	      el = el[0];
	    }
	    return el;
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuBarController', MenuBarController);
	
	var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];
	
	/**
	 * @ngInject
	 */
	function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$mdConstant = $mdConstant;
	  this.$mdUtil = $mdUtil;
	  this.$document = $document;
	  this.$scope = $scope;
	  this.$rootScope = $rootScope;
	  this.$timeout = $timeout;
	
	  var self = this;
	  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
	    self[methodName] = angular.bind(self, self[methodName]);
	  });
	}
	
	MenuBarController.prototype.init = function() {
	  var $element = this.$element;
	  var $mdUtil = this.$mdUtil;
	  var $scope = this.$scope;
	
	  var self = this;
	  var deregisterFns = [];
	  $element.on('keydown', this.handleKeyDown);
	  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
	    if (self.getMenus().indexOf(el[0]) != -1) {
	      $element[0].classList.add('md-open');
	      el[0].classList.add('md-open');
	      self.currentlyOpenMenu = el.controller('mdMenu');
	      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
	      self.enableOpenOnHover();
	    }
	  }));
	
	  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
	    var rootMenus = self.getMenus();
	    if (rootMenus.indexOf(el[0]) != -1) {
	      $element[0].classList.remove('md-open');
	      el[0].classList.remove('md-open');
	    }
	
	    if ($element[0].contains(el[0])) {
	      var parentMenu = el[0];
	      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
	        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
	      }
	      if (parentMenu) {
	        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
	        self.currentlyOpenMenu = undefined;
	        self.disableOpenOnHover();
	        self.setKeyboardMode(true);
	      }
	    }
	  }));
	
	  $scope.$on('$destroy', function() {
	    self.disableOpenOnHover();
	    while (deregisterFns.length) {
	      deregisterFns.shift()();
	    }
	  });
	
	
	  this.setKeyboardMode(true);
	};
	
	MenuBarController.prototype.setKeyboardMode = function(enabled) {
	  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
	  else this.$element[0].classList.remove('md-keyboard-mode');
	};
	
	MenuBarController.prototype.enableOpenOnHover = function() {
	  if (this.openOnHoverEnabled) return;
	
	  var self = this;
	
	  self.openOnHoverEnabled = true;
	
	  if (self.parentToolbar) {
	    self.parentToolbar.classList.add('md-has-open-menu');
	
	    // Needs to be on the next tick so it doesn't close immediately.
	    self.$mdUtil.nextTick(function() {
	      angular.element(self.parentToolbar).on('click', self.handleParentClick);
	    }, false);
	  }
	
	  angular
	    .element(self.getMenus())
	    .on('mouseenter', self.handleMenuHover);
	};
	
	MenuBarController.prototype.handleMenuHover = function(e) {
	  this.setKeyboardMode(false);
	  if (this.openOnHoverEnabled) {
	    this.scheduleOpenHoveredMenu(e);
	  }
	};
	
	MenuBarController.prototype.disableOpenOnHover = function() {
	  if (!this.openOnHoverEnabled) return;
	
	  this.openOnHoverEnabled = false;
	
	  if (this.parentToolbar) {
	    this.parentToolbar.classList.remove('md-has-open-menu');
	    angular.element(this.parentToolbar).off('click', this.handleParentClick);
	  }
	
	  angular
	    .element(this.getMenus())
	    .off('mouseenter', this.handleMenuHover);
	};
	
	MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
	  var menuEl = angular.element(e.currentTarget);
	  var menuCtrl = menuEl.controller('mdMenu');
	  this.setKeyboardMode(false);
	  this.scheduleOpenMenu(menuCtrl);
	};
	
	MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
	  var self = this;
	  var $timeout = this.$timeout;
	  if (menuCtrl != self.currentlyOpenMenu) {
	    $timeout.cancel(self.pendingMenuOpen);
	    self.pendingMenuOpen = $timeout(function() {
	      self.pendingMenuOpen = undefined;
	      if (self.currentlyOpenMenu) {
	        self.currentlyOpenMenu.close(true, { closeAll: true });
	      }
	      menuCtrl.open();
	    }, 200, false);
	  }
	};
	
	MenuBarController.prototype.handleKeyDown = function(e) {
	  var keyCodes = this.$mdConstant.KEY_CODE;
	  var currentMenu = this.currentlyOpenMenu;
	  var wasOpen = currentMenu && currentMenu.isOpen;
	  this.setKeyboardMode(true);
	  var handled, newMenu, newMenuCtrl;
	  switch (e.keyCode) {
	    case keyCodes.DOWN_ARROW:
	      if (currentMenu) {
	        currentMenu.focusMenuContainer();
	      } else {
	        this.openFocusedMenu();
	      }
	      handled = true;
	      break;
	    case keyCodes.UP_ARROW:
	      currentMenu && currentMenu.close();
	      handled = true;
	      break;
	    case keyCodes.LEFT_ARROW:
	      newMenu = this.focusMenu(-1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	    case keyCodes.RIGHT_ARROW:
	      newMenu = this.focusMenu(+1);
	      if (wasOpen) {
	        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
	        this.scheduleOpenMenu(newMenuCtrl);
	      }
	      handled = true;
	      break;
	  }
	  if (handled) {
	    e && e.preventDefault && e.preventDefault();
	    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
	  }
	};
	
	MenuBarController.prototype.focusMenu = function(direction) {
	  var menus = this.getMenus();
	  var focusedIndex = this.getFocusedMenuIndex();
	
	  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }
	
	  var changed = false;
	
	  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
	  else if (
	    direction < 0 && focusedIndex > 0 ||
	    direction > 0 && focusedIndex < menus.length - direction
	  ) {
	    focusedIndex += direction;
	    changed = true;
	  }
	  if (changed) {
	    menus[focusedIndex].querySelector('button').focus();
	    return menus[focusedIndex];
	  }
	};
	
	MenuBarController.prototype.openFocusedMenu = function() {
	  var menu = this.getFocusedMenu();
	  menu && angular.element(menu).controller('mdMenu').open();
	};
	
	MenuBarController.prototype.getMenus = function() {
	  var $element = this.$element;
	  return this.$mdUtil.nodesToArray($element[0].children)
	    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
	};
	
	MenuBarController.prototype.getFocusedMenu = function() {
	  return this.getMenus()[this.getFocusedMenuIndex()];
	};
	
	MenuBarController.prototype.getFocusedMenuIndex = function() {
	  var $mdUtil = this.$mdUtil;
	  var focusedEl = $mdUtil.getClosest(
	    this.$document[0].activeElement,
	    'MD-MENU'
	  );
	  if (!focusedEl) return -1;
	
	  var focusedIndex = this.getMenus().indexOf(focusedEl);
	  return focusedIndex;
	};
	
	MenuBarController.prototype.getOpenMenuIndex = function() {
	  var menus = this.getMenus();
	  for (var i = 0; i < menus.length; ++i) {
	    if (menus[i].classList.contains('md-open')) return i;
	  }
	  return -1;
	};
	
	MenuBarController.prototype.handleParentClick = function(event) {
	  var openMenu = this.querySelector('md-menu.md-open');
	
	  if (openMenu && !openMenu.contains(event.target)) {
	    angular.element(openMenu).controller('mdMenu').close(true, {
	      closeAll: true
	    });
	  }
	};
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdMenuBar
	 * @module material.components.menuBar
	 * @restrict E
	 * @description
	 *
	 * Menu bars are containers that hold multiple menus. They change the behavior and appearence
	 * of the `md-menu` directive to behave similar to an operating system provided menu.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">
	 *       File
	 *     </button>
	 *     <md-menu-content>
	 *       <md-menu-item>
	 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
	 *           Share...
	 *         </md-button>
	 *       </md-menu-item>
	 *       <md-menu-divider></md-menu-divider>
	 *       <md-menu-item>
	 *       <md-menu-item>
	 *         <md-menu>
	 *           <md-button ng-click="$mdMenu.open()">New</md-button>
	 *           <md-menu-content>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *           </md-menu-content>
	 *         </md-menu>
	 *       </md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 * ## Menu Bar Controls
	 *
	 * You may place `md-menu-items` that function as controls within menu bars.
	 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
	 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
	 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
	 * to the `string` value of the `value` attribute. If you need non-string values, you can use
	 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]` works.
	 *
	 * <hljs lang="html">
	 * <md-menu-bar>
	 *  <md-menu>
	 *    <button ng-click="$mdMenu.open()">
	 *      Sample Menu
	 *    </button>
	 *    <md-menu-content>
	 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item>
	 *      <md-menu-divider></md-menu-divider>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 2</md-menu-item>
	 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 3</md-menu-item>
	 *    </md-menu-content>
	 *  </md-menu>
	 * </md-menu-bar>
	 * </hljs>
	 *
	 *
	 * ### Nesting Menus
	 *
	 * Menus may be nested within menu bars. This is commonly called cascading menus.
	 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
	 * <hljs lang="html">
	 * <md-menu-item>
	 *   <md-menu>
	 *     <button ng-click="$mdMenu.open()">New</md-button>
	 *     <md-menu-content>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
	 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
	 *     </md-menu-content>
	 *   </md-menu>
	 * </md-menu-item>
	 * </hljs>
	 *
	 */
	
	MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuBar', MenuBarDirective);
	
	/* @ngInject */
	function MenuBarDirective($mdUtil, $mdTheming) {
	  return {
	    restrict: 'E',
	    require: 'mdMenuBar',
	    controller: 'MenuBarController',
	
	    compile: function compile(templateEl, templateAttrs) {
	      if (!templateAttrs.ariaRole) {
	        templateEl[0].setAttribute('role', 'menubar');
	      }
	      angular.forEach(templateEl[0].children, function(menuEl) {
	        if (menuEl.nodeName == 'MD-MENU') {
	          if (!menuEl.hasAttribute('md-position-mode')) {
	            menuEl.setAttribute('md-position-mode', 'left bottom');
	
	            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
	            // we need to query for possible `md-buttons` as well.
	            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
	          }
	          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
	          angular.forEach(contentEls, function(contentEl) {
	            contentEl.classList.add('md-menu-bar-menu');
	            contentEl.classList.add('md-dense');
	            if (!contentEl.hasAttribute('width')) {
	              contentEl.setAttribute('width', 5);
	            }
	          });
	        }
	      });
	
	      // Mark the child menu items that they're inside a menu bar. This is necessary,
	      // because mnMenuItem has special behaviour during compilation, depending on
	      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
	      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
	      // the element won't have a parent and won't compile properly.
	      templateEl.find('md-menu-item').addClass('md-in-menu-bar');
	
	      return function postLink(scope, el, attr, ctrl) {
	        el.addClass('_md');     // private md component indicator for styling
	        $mdTheming(scope, el);
	        ctrl.init();
	      };
	    }
	  };
	
	}
	
	})();
	(function(){
	"use strict";
	
	
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuDivider', MenuDividerDirective);
	
	
	function MenuDividerDirective() {
	  return {
	    restrict: 'E',
	    compile: function(templateEl, templateAttrs) {
	      if (!templateAttrs.role) {
	        templateEl[0].setAttribute('role', 'separator');
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemController.$inject = ["$scope", "$element", "$attrs"];
	angular
	  .module('material.components.menuBar')
	  .controller('MenuItemController', MenuItemController);
	
	
	/**
	 * @ngInject
	 */
	function MenuItemController($scope, $element, $attrs) {
	  this.$element = $element;
	  this.$attrs = $attrs;
	  this.$scope = $scope;
	}
	
	MenuItemController.prototype.init = function(ngModel) {
	  var $element = this.$element;
	  var $attrs = this.$attrs;
	
	  this.ngModel = ngModel;
	  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
	    this.mode  = $attrs.type;
	    this.iconEl = $element[0].children[0];
	    this.buttonEl = $element[0].children[1];
	    if (ngModel) {
	      // Clear ngAria set attributes
	      this.initClickListeners();
	    }
	  }
	};
	
	// ngAria auto sets attributes on a menu-item with a ngModel.
	// We don't want this because our content (buttons) get the focus
	// and set their own aria attributes appropritately. Having both
	// breaks NVDA / JAWS. This undeoes ngAria's attrs.
	MenuItemController.prototype.clearNgAria = function() {
	  var el = this.$element[0];
	  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
	  angular.forEach(clearAttrs, function(attr) {
	    el.removeAttribute(attr);
	  });
	};
	
	MenuItemController.prototype.initClickListeners = function() {
	  var self = this;
	  var ngModel = this.ngModel;
	  var $scope = this.$scope;
	  var $attrs = this.$attrs;
	  var $element = this.$element;
	  var mode = this.mode;
	
	  this.handleClick = angular.bind(this, this.handleClick);
	
	  var icon = this.iconEl;
	  var button = angular.element(this.buttonEl);
	  var handleClick = this.handleClick;
	
	  $attrs.$observe('disabled', setDisabled);
	  setDisabled($attrs.disabled);
	
	  ngModel.$render = function render() {
	    self.clearNgAria();
	    if (isSelected()) {
	      icon.style.display = '';
	      button.attr('aria-checked', 'true');
	    } else {
	      icon.style.display = 'none';
	      button.attr('aria-checked', 'false');
	    }
	  };
	
	  $scope.$$postDigest(ngModel.$render);
	
	  function isSelected() {
	    if (mode == 'radio') {
	      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
	      return ngModel.$modelValue == val;
	    } else {
	      return ngModel.$modelValue;
	    }
	  }
	
	  function setDisabled(disabled) {
	    if (disabled) {
	      button.off('click', handleClick);
	    } else {
	      button.on('click', handleClick);
	    }
	  }
	};
	
	MenuItemController.prototype.handleClick = function(e) {
	  var mode = this.mode;
	  var ngModel = this.ngModel;
	  var $attrs = this.$attrs;
	  var newVal;
	  if (mode == 'checkbox') {
	    newVal = !ngModel.$modelValue;
	  } else if (mode == 'radio') {
	    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
	  }
	  ngModel.$setViewValue(newVal);
	  ngModel.$render();
	};
	
	})();
	(function(){
	"use strict";
	
	
	MenuItemDirective.$inject = ["$mdUtil", "$mdConstant", "$$mdSvgRegistry"];
	angular
	  .module('material.components.menuBar')
	  .directive('mdMenuItem', MenuItemDirective);
	
	 /* @ngInject */
	function MenuItemDirective($mdUtil, $mdConstant, $$mdSvgRegistry) {
	  return {
	    controller: 'MenuItemController',
	    require: ['mdMenuItem', '?ngModel'],
	    priority: $mdConstant.BEFORE_NG_ARIA,
	    compile: function(templateEl, templateAttrs) {
	      var type = templateAttrs.type;
	      var inMenuBarClass = 'md-in-menu-bar';
	
	      // Note: This allows us to show the `check` icon for the md-menu-bar items.
	      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
	      if ((type == 'checkbox' || type == 'radio') && templateEl.hasClass(inMenuBarClass)) {
	        var text = templateEl[0].textContent;
	        var buttonEl = angular.element('<md-button type="button"></md-button>');
	        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';
	
	        buttonEl.html(text);
	        buttonEl.attr('tabindex', '0');
	
	        templateEl.html('');
	        templateEl.append(angular.element(iconTemplate));
	        templateEl.append(buttonEl);
	        templateEl.addClass('md-indent').removeClass(inMenuBarClass);
	
	        setDefault('role', type == 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
	        moveAttrToButton('ng-disabled');
	
	      } else {
	        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
	      }
	
	
	      return function(scope, el, attrs, ctrls) {
	        var ctrl = ctrls[0];
	        var ngModel = ctrls[1];
	        ctrl.init(ngModel);
	      };
	
	      function setDefault(attr, val, el) {
	        el = el || templateEl;
	        if (el instanceof angular.element) {
	          el = el[0];
	        }
	        if (!el.hasAttribute(attr)) {
	          el.setAttribute(attr, val);
	        }
	      }
	
	      function moveAttrToButton(attribute) {
	        var attributes = $mdUtil.prefixer(attribute);
	
	        angular.forEach(attributes, function(attr) {
	          if (templateEl[0].hasAttribute(attr)) {
	            var val = templateEl[0].getAttribute(attr);
	            buttonEl[0].setAttribute(attr, val);
	            templateEl[0].removeAttribute(attr);
	          }
	        });
	      }
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdProgressCircular
	 * @module material.components.progressCircular
	 * @restrict E
	 *
	 * @description
	 * The circular progress directive is used to make loading content in your app as delightful and
	 * painless as possible by minimizing the amount of visual change a user sees before they can view
	 * and interact with content.
	 *
	 * For operations where the percentage of the operation completed can be determined, use a
	 * determinate indicator. They give users a quick sense of how long an operation will take.
	 *
	 * For operations where the user is asked to wait a moment while something finishes up, and it’s
	 * not necessary to expose what's happening behind the scenes and how long it will take, use an
	 * indeterminate indicator.
	 *
	 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
	 *
	 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
	 * will be auto-applied as the mode.
	 *
	 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
	 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
	 * @param {number=} value In determinate mode, this number represents the percentage of the
	 *     circular progress. Default: 0
	 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
	 * should be a pixel-size value (eg '100'). If this attribute is
	 * not present then a default value of '50px' is assumed.
	 *
	 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
	 *
	 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
	 * </hljs>
	 */
	
	MdProgressCircularDirective.$inject = ["$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];
	angular
	  .module('material.components.progressCircular')
	  .directive('mdProgressCircular', MdProgressCircularDirective);
	
	/* @ngInject */
	function MdProgressCircularDirective($window, $mdProgressCircular, $mdTheming,
	                                     $mdUtil, $interval, $log) {
	
	  // Note that this shouldn't use use $$rAF, because it can cause an infinite loop
	  // in any tests that call $animate.flush.
	  var rAF = $window.requestAnimationFrame ||
	            $window.webkitRequestAnimationFrame ||
	            angular.noop;
	
	  var cAF = $window.cancelAnimationFrame ||
	            $window.webkitCancelAnimationFrame ||
	            $window.webkitCancelRequestAnimationFrame ||
	            angular.noop;
	
	  var MODE_DETERMINATE = 'determinate';
	  var MODE_INDETERMINATE = 'indeterminate';
	  var DISABLED_CLASS = '_md-progress-circular-disabled';
	  var INDETERMINATE_CLASS = 'md-mode-indeterminate';
	
	  return {
	    restrict: 'E',
	    scope: {
	      value: '@',
	      mdDiameter: '@',
	      mdMode: '@'
	    },
	    template:
	      '<svg xmlns="http://www.w3.org/2000/svg">' +
	        '<path fill="none"/>' +
	      '</svg>',
	    compile: function(element, attrs) {
	      element.attr({
	        'aria-valuemin': 0,
	        'aria-valuemax': 100,
	        'role': 'progressbar'
	      });
	
	      if (angular.isUndefined(attrs.mdMode)) {
	        var mode = attrs.hasOwnProperty('value') ? MODE_DETERMINATE : MODE_INDETERMINATE;
	        attrs.$set('mdMode', mode);
	      } else {
	        attrs.$set('mdMode', attrs.mdMode.trim());
	      }
	
	      return MdProgressCircularLink;
	    }
	  };
	
	  function MdProgressCircularLink(scope, element, attrs) {
	    var node = element[0];
	    var svg = angular.element(node.querySelector('svg'));
	    var path = angular.element(node.querySelector('path'));
	    var startIndeterminate = $mdProgressCircular.startIndeterminate;
	    var endIndeterminate = $mdProgressCircular.endIndeterminate;
	    var iterationCount = 0;
	    var lastAnimationId = 0;
	    var lastDrawFrame;
	    var interval;
	
	    $mdTheming(element);
	    element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));
	
	    // If the mode is indeterminate, it doesn't need to
	    // wait for the next digest. It can start right away.
	    if(scope.mdMode === MODE_INDETERMINATE){
	      startIndeterminateAnimation();
	    }
	
	    scope.$on('$destroy', function(){
	      cleanupIndeterminateAnimation();
	
	      if (lastDrawFrame) {
	        cAF(lastDrawFrame);
	      }
	    });
	
	    scope.$watchGroup(['value', 'mdMode', function() {
	      var isDisabled = node.disabled;
	
	      // Sometimes the browser doesn't return a boolean, in
	      // which case we should check whether the attribute is
	      // present.
	      if (isDisabled === true || isDisabled === false){
	        return isDisabled;
	      }
	
	      return angular.isDefined(element.attr('disabled'));
	    }], function(newValues, oldValues) {
	      var mode = newValues[1];
	      var isDisabled = newValues[2];
	      var wasDisabled = oldValues[2];
	
	      if (isDisabled !== wasDisabled) {
	        element.toggleClass(DISABLED_CLASS, !!isDisabled);
	      }
	
	      if (isDisabled) {
	        cleanupIndeterminateAnimation();
	      } else {
	        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
	          mode = MODE_INDETERMINATE;
	          attrs.$set('mdMode', mode);
	        }
	
	        if (mode === MODE_INDETERMINATE) {
	          startIndeterminateAnimation();
	        } else {
	          var newValue = clamp(newValues[0]);
	
	          cleanupIndeterminateAnimation();
	
	          element.attr('aria-valuenow', newValue);
	          renderCircle(clamp(oldValues[0]), newValue);
	        }
	      }
	
	    });
	
	    // This is in a separate watch in order to avoid layout, unless
	    // the value has actually changed.
	    scope.$watch('mdDiameter', function(newValue) {
	      var diameter = getSize(newValue);
	      var strokeWidth = getStroke(diameter);
	      var value = clamp(scope.value);
	      var transformOrigin = (diameter / 2) + 'px';
	      var dimensions = {
	        width: diameter + 'px',
	        height: diameter + 'px'
	      };
	
	      // The viewBox has to be applied via setAttribute, because it is
	      // case-sensitive. If jQuery is included in the page, `.attr` lowercases
	      // all attribute names.
	      svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);
	
	      // Usually viewBox sets the dimensions for the SVG, however that doesn't
	      // seem to be the case on IE10.
	      // Important! The transform origin has to be set from here and it has to
	      // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
	      // IE and Edge, because they don't account for the stroke width when
	      // rotating. Also "center" doesn't help in this case, it has to be a
	      // precise value.
	      svg
	        .css(dimensions)
	        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);
	
	      element.css(dimensions);
	
	      path.attr('stroke-width', strokeWidth);
	      path.attr('stroke-linecap', 'square');
	      if (scope.mdMode == MODE_INDETERMINATE) {
	        path.attr('d', getSvgArc(diameter, strokeWidth, true));
	        path.attr('stroke-dasharray', (diameter - strokeWidth) * $window.Math.PI * 0.75);
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, 1, 75));
	      } else {
	        path.attr('d', getSvgArc(diameter, strokeWidth, false));
	        path.attr('stroke-dasharray', (diameter - strokeWidth) * $window.Math.PI);
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, 0, 100));
	        renderCircle(value, value);
	      }
	
	    });
	
	    function renderCircle(animateFrom, animateTo, easing, duration, iterationCount, maxValue) {
	      var id = ++lastAnimationId;
	      var startTime = $mdUtil.now();
	      var changeInValue = animateTo - animateFrom;
	      var diameter = getSize(scope.mdDiameter);
	      var strokeWidth = getStroke(diameter);
	      var ease = easing || $mdProgressCircular.easeFn;
	      var animationDuration = duration || $mdProgressCircular.duration;
	      var rotation = -90 * (iterationCount || 0);
	      var dashLimit = maxValue || 100;
	
	      // No need to animate it if the values are the same
	      if (animateTo === animateFrom) {
	        renderFrame(animateTo);
	      } else {
	        lastDrawFrame = rAF(function animation() {
	          var currentTime = $window.Math.max(0, $window.Math.min($mdUtil.now() - startTime, animationDuration));
	
	          renderFrame(ease(currentTime, animateFrom, changeInValue, animationDuration));
	
	          // Do not allow overlapping animations
	          if (id === lastAnimationId && currentTime < animationDuration) {
	            lastDrawFrame = rAF(animation);
	          }
	        });
	      }
	
	      function renderFrame(value) {
	        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, value, dashLimit));
	        path.attr('transform','rotate(' + (rotation) + ' ' + diameter/2 + ' ' + diameter/2 + ')');
	      }
	    }
	
	    function animateIndeterminate() {
	      renderCircle(
	        startIndeterminate,
	        endIndeterminate,
	        $mdProgressCircular.easeFnIndeterminate,
	        $mdProgressCircular.durationIndeterminate,
	        iterationCount,
	        75
	      );
	
	      // The %4 technically isn't necessary, but it keeps the rotation
	      // under 360, instead of becoming a crazy large number.
	      iterationCount = ++iterationCount % 4;
	
	    }
	
	    function startIndeterminateAnimation() {
	      if (!interval) {
	        // Note that this interval isn't supposed to trigger a digest.
	        interval = $interval(
	          animateIndeterminate,
	          $mdProgressCircular.durationIndeterminate,
	          0,
	          false
	        );
	
	        animateIndeterminate();
	
	        element
	          .addClass(INDETERMINATE_CLASS)
	          .removeAttr('aria-valuenow');
	      }
	    }
	
	    function cleanupIndeterminateAnimation() {
	      if (interval) {
	        $interval.cancel(interval);
	        interval = null;
	        element.removeClass(INDETERMINATE_CLASS);
	      }
	    }
	  }
	
	  /**
	   * Returns SVG path data for progress circle
	   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {boolean} indeterminate Use if progress circle will be used for indeterminate
	   *
	   * @returns {string} String representation of an SVG arc.
	   */
	  function getSvgArc(diameter, strokeWidth, indeterminate) {
	    var radius = diameter / 2;
	    var offset = strokeWidth / 2;
	    var start = radius + ',' + offset; // ie: (25, 2.5) or 12 o'clock
	    var end = offset + ',' + radius;   // ie: (2.5, 25) or  9 o'clock
	    var arcRadius = radius - offset;
	    return 'M' + start
	         + 'A' + arcRadius + ',' + arcRadius + ' 0 1 1 ' + end // 75% circle
	         + (indeterminate ? '' : 'A' + arcRadius + ',' + arcRadius + ' 0 0 1 ' + start); // loop to start
	  }
	
	  /**
	   * Return stroke length for progress circle
	   *
	   * @param {number} diameter Diameter of the container.
	   * @param {number} strokeWidth Stroke width to be used when drawing circle
	   * @param {number} value Percentage of circle (between 0 and 100)
	   * @param {number} limit Max percentage for circle
	   *
	   * @returns {number} Stroke length for progres circle
	   */
	  function getDashLength(diameter, strokeWidth, value, limit) {
	    return (diameter - strokeWidth) * $window.Math.PI * ( (3 * (limit || 100) / 100) - (value/100) );
	  }
	
	  /**
	   * Limits a value between 0 and 100.
	   */
	  function clamp(value) {
	    return $window.Math.max(0, $window.Math.min(value || 0, 100));
	  }
	
	  /**
	   * Determines the size of a progress circle, based on the provided
	   * value in the following formats: `X`, `Ypx`, `Z%`.
	   */
	  function getSize(value) {
	    var defaultValue = $mdProgressCircular.progressSize;
	
	    if (value) {
	      var parsed = parseFloat(value);
	
	      if (value.lastIndexOf('%') === value.length - 1) {
	        parsed = (parsed / 100) * defaultValue;
	      }
	
	      return parsed;
	    }
	
	    return defaultValue;
	  }
	
	  /**
	   * Determines the circle's stroke width, based on
	   * the provided diameter.
	   */
	  function getStroke(diameter) {
	    return $mdProgressCircular.strokeWidth / 100 * diameter;
	  }
	
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc service
	 * @name $mdProgressCircular
	 * @module material.components.progressCircular
	 *
	 * @description
	 * Allows the user to specify the default options for the `progressCircular` directive.
	 *
	 * @property {number} progressSize Diameter of the progress circle in pixels.
	 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
	 * @property {number} duration Length of the circle animation in milliseconds.
	 * @property {function} easeFn Default easing animation function.
	 * @property {object} easingPresets Collection of pre-defined easing functions.
	 *
	 * @property {number} durationIndeterminate Duration of the indeterminate animation.
	 * @property {number} startIndeterminate Indeterminate animation start point.
	 * @property {number} endIndeterminate Indeterminate animation end point.
	 * @property {function} easeFnIndeterminate Easing function to be used when animating
	 * between the indeterminate values.
	 *
	 * @property {(function(object): object)} configure Used to modify the default options.
	 *
	 * @usage
	 * <hljs lang="js">
	 *   myAppModule.config(function($mdProgressCircularProvider) {
	 *
	 *     // Example of changing the default progress options.
	 *     $mdProgressCircularProvider.configure({
	 *       progressSize: 100,
	 *       strokeWidth: 20,
	 *       duration: 800
	 *     });
	 * });
	 * </hljs>
	 *
	 */
	
	angular
	  .module('material.components.progressCircular')
	  .provider("$mdProgressCircular", MdProgressCircularProvider);
	
	function MdProgressCircularProvider() {
	  var progressConfig = {
	    progressSize: 50,
	    strokeWidth: 10,
	    duration: 100,
	    easeFn: linearEase,
	
	    durationIndeterminate: 1333,
	    startIndeterminate: 1,
	    endIndeterminate: 149,
	    easeFnIndeterminate: materialEase,
	
	    easingPresets: {
	      linearEase: linearEase,
	      materialEase: materialEase
	    }
	  };
	
	  return {
	    configure: function(options) {
	      progressConfig = angular.extend(progressConfig, options || {});
	      return progressConfig;
	    },
	    $get: function() { return progressConfig; }
	  };
	
	  function linearEase(t, b, c, d) {
	    return c * t / d + b;
	  }
	
	  function materialEase(t, b, c, d) {
	    // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
	    // with settings of [0, 0, 1, 1]
	    var ts = (t /= d) * t;
	    var tc = ts * t;
	    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTab
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tab>` is a nested directive used within `<md-tabs>` to specify a tab with a **label** and optional *view content*.
	 *
	 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to specify more
	 * complex tab header markup. If neither the **label** nor the **md-tab-label** are specified, then the nested
	 * markup of the `<md-tab>` is used as the tab header markup.
	 *
	 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the `<md-tab-body>` tag.  This
	 * is to define a clear separation between the tab content and the tab label.
	 *
	 * This container is used by the TabsController to show/hide the active tab's content view. This synchronization is
	 * automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can
	 * be initiated via data binding changes, programmatic invocation, or user gestures.
	 *
	 * @param {string=} label Optional attribute to specify a simple string as the tab label
	 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab selection.
	 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been de-selected.
	 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
	 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active tab at a time.
	 *
	 *
	 * @usage
	 *
	 * <hljs lang="html">
	 * <md-tab label="" ng-disabled md-on-select="" md-on-deselect="" >
	 *   <h3>My Tab content</h3>
	 * </md-tab>
	 *
	 * <md-tab >
	 *   <md-tab-label>
	 *     <h3>My Tab content</h3>
	 *   </md-tab-label>
	 *   <md-tab-body>
	 *     <p>
	 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
	 *       totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
	 *       dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
	 *       sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
	 *     </p>
	 *   </md-tab-body>
	 * </md-tab>
	 * </hljs>
	 *
	 */
	angular
	    .module('material.components.tabs')
	    .directive('mdTab', MdTab);
	
	function MdTab () {
	  return {
	    require:  '^?mdTabs',
	    terminal: true,
	    compile:  function (element, attr) {
	      var label = firstChild(element, 'md-tab-label'),
	          body  = firstChild(element, 'md-tab-body');
	
	      if (label.length === 0) {
	        label = angular.element('<md-tab-label></md-tab-label>');
	        if (attr.label) label.text(attr.label);
	        else label.append(element.contents());
	
	        if (body.length === 0) {
	          var contents = element.contents().detach();
	          body         = angular.element('<md-tab-body></md-tab-body>');
	          body.append(contents);
	        }
	      }
	
	      element.append(label);
	      if (body.html()) element.append(body);
	
	      return postLink;
	    },
	    scope:    {
	      active:   '=?mdActive',
	      disabled: '=?ngDisabled',
	      select:   '&?mdOnSelect',
	      deselect: '&?mdOnDeselect'
	    }
	  };
	
	  function postLink (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	    var index = ctrl.getTabElementIndex(element),
	        body  = firstChild(element, 'md-tab-body').remove(),
	        label = firstChild(element, 'md-tab-label').remove(),
	        data  = ctrl.insertTab({
	          scope:    scope,
	          parent:   scope.$parent,
	          index:    index,
	          element:  element,
	          template: body.html(),
	          label:    label.html()
	        }, index);
	
	    scope.select   = scope.select || angular.noop;
	    scope.deselect = scope.deselect || angular.noop;
	
	    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
	    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
	    scope.$watch(
	        function () {
	          return ctrl.getTabElementIndex(element);
	        },
	        function (newIndex) {
	          data.index = newIndex;
	          ctrl.updateTabOrder();
	        }
	    );
	    scope.$on('$destroy', function () { ctrl.removeTab(data); });
	  }
	
	  function firstChild (element, tagName) {
	    var children = element[0].children;
	    for (var i = 0, len = children.length; i < len; i++) {
	      var child = children[i];
	      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
	    }
	    return angular.element();
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabItem', MdTabItem);
	
	function MdTabItem () {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	      ctrl.attachRipple(scope, element);
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	angular
	    .module('material.components.tabs')
	    .directive('mdTabLabel', MdTabLabel);
	
	function MdTabLabel () {
	  return { terminal: true };
	}
	
	
	})();
	(function(){
	"use strict";
	
	
	MdTabScroll.$inject = ["$parse"];angular.module('material.components.tabs')
	    .directive('mdTabScroll', MdTabScroll);
	
	function MdTabScroll ($parse) {
	  return {
	    restrict: 'A',
	    compile: function ($element, attr) {
	      var fn = $parse(attr.mdTabScroll, null, true);
	      return function ngEventHandler (scope, element) {
	        element.on('mousewheel', function (event) {
	          scope.$apply(function () { fn(scope, { $event: event }); });
	        });
	      };
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming", "$mdInteraction"];angular
	    .module('material.components.tabs')
	    .controller('MdTabsController', MdTabsController);
	
	/**
	 * @ngInject
	 */
	function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple, $mdUtil,
	                           $animateCss, $attrs, $compile, $mdTheming, $mdInteraction) {
	  // define private properties
	  var ctrl      = this,
	      locked    = false,
	      elements  = getElements(),
	      queue     = [],
	      destroyed = false,
	      loaded    = false;
	
	
	  // Define public methods
	  ctrl.$onInit            = $onInit;
	  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
	  ctrl.redirectFocus      = redirectFocus;
	  ctrl.attachRipple       = attachRipple;
	  ctrl.insertTab          = insertTab;
	  ctrl.removeTab          = removeTab;
	  ctrl.select             = select;
	  ctrl.scroll             = scroll;
	  ctrl.nextPage           = nextPage;
	  ctrl.previousPage       = previousPage;
	  ctrl.keydown            = keydown;
	  ctrl.canPageForward     = canPageForward;
	  ctrl.canPageBack        = canPageBack;
	  ctrl.refreshIndex       = refreshIndex;
	  ctrl.incrementIndex     = incrementIndex;
	  ctrl.getTabElementIndex = getTabElementIndex;
	  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
	  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
	  ctrl.getFocusedTabId    = getFocusedTabId;
	
	  // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
	  // manually call the $onInit hook.
	  if (angular.version.major === 1 && angular.version.minor <= 4) {
	    this.$onInit();
	  }
	
	  /**
	   * AngularJS Lifecycle hook for newer AngularJS versions.
	   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
	   */
	  function $onInit() {
	    // Define one-way bindings
	    defineOneWayBinding('stretchTabs', handleStretchTabs);
	
	    // Define public properties with change handlers
	    defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
	    defineProperty('offsetLeft', handleOffsetChange, 0);
	    defineProperty('hasContent', handleHasContent, false);
	    defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
	    defineProperty('shouldPaginate', handleShouldPaginate, false);
	
	    // Define boolean attributes
	    defineBooleanAttribute('noInkBar', handleInkBar);
	    defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
	    defineBooleanAttribute('noPagination');
	    defineBooleanAttribute('swipeContent');
	    defineBooleanAttribute('noDisconnect');
	    defineBooleanAttribute('autoselect');
	    defineBooleanAttribute('noSelectClick');
	    defineBooleanAttribute('centerTabs', handleCenterTabs, false);
	    defineBooleanAttribute('enableDisconnect');
	
	    // Define public properties
	    ctrl.scope             = $scope;
	    ctrl.parent            = $scope.$parent;
	    ctrl.tabs              = [];
	    ctrl.lastSelectedIndex = null;
	    ctrl.hasFocus          = false;
	    ctrl.styleTabItemFocus = false;
	    ctrl.shouldCenterTabs  = shouldCenterTabs();
	    ctrl.tabContentPrefix  = 'tab-content-';
	
	    // Setup the tabs controller after all bindings are available.
	    setupTabsController();
	  }
	
	  /**
	   * Perform setup for the controller, setup events and watcher(s)
	   */
	  function setupTabsController () {
	    ctrl.selectedIndex = ctrl.selectedIndex || 0;
	    compileTemplate();
	    configureWatchers();
	    bindEvents();
	    $mdTheming($element);
	    $mdUtil.nextTick(function () {
	      // Note that the element references need to be updated, because certain "browsers"
	      // (IE/Edge) lose them and start throwing "Invalid calling object" errors, when we
	      // compile the element contents down in `compileElement`.
	      elements = getElements();
	      updateHeightFromContent();
	      adjustOffset();
	      updateInkBarStyles();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	      loaded = true;
	      updatePagination();
	    });
	  }
	
	  /**
	   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
	   * directive's template function.
	   */
	  function compileTemplate () {
	    var template = $attrs.$mdTabsTemplate,
	        element  = angular.element($element[0].querySelector('md-tab-data'));
	
	    element.html(template);
	    $compile(element.contents())(ctrl.parent);
	    delete $attrs.$mdTabsTemplate;
	  }
	
	  /**
	   * Binds events used by the tabs component.
	   */
	  function bindEvents () {
	    angular.element($window).on('resize', handleWindowResize);
	    $scope.$on('$destroy', cleanup);
	  }
	
	  /**
	   * Configure watcher(s) used by Tabs
	   */
	  function configureWatchers () {
	    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
	  }
	
	  /**
	   * Creates a one-way binding manually rather than relying on AngularJS's isolated scope
	   * @param key
	   * @param handler
	   */
	  function defineOneWayBinding (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
	  }
	
	  /**
	   * Defines boolean attributes with default value set to true.  (ie. md-stretch-tabs with no value
	   * will be treated as being truthy)
	   * @param key
	   * @param handler
	   */
	  function defineBooleanAttribute (key, handler) {
	    var attr = $attrs.$normalize('md-' + key);
	    if (handler) defineProperty(key, handler);
	    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
	    $attrs.$observe(attr, updateValue);
	    function updateValue (newValue) {
	      ctrl[ key ] = newValue !== 'false';
	    }
	  }
	
	  /**
	   * Remove any events defined by this controller
	   */
	  function cleanup () {
	    destroyed = true;
	    angular.element($window).off('resize', handleWindowResize);
	  }
	
	  // Change handlers
	
	  /**
	   * Toggles stretch tabs class and updates inkbar when tab stretching changes
	   * @param stretchTabs
	   */
	  function handleStretchTabs (stretchTabs) {
	    var elements = getElements();
	    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
	    updateInkBarStyles();
	  }
	
	  function handleCenterTabs (newValue) {
	    ctrl.shouldCenterTabs = shouldCenterTabs();
	  }
	
	  function handleMaxTabWidth (newWidth, oldWidth) {
	    if (newWidth !== oldWidth) {
	      var elements = getElements();
	
	      angular.forEach(elements.tabs, function(tab) {
	        tab.style.maxWidth = newWidth + 'px';
	      });
	      $mdUtil.nextTick(ctrl.updateInkBarStyles);
	    }
	  }
	
	  function handleShouldPaginate (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      ctrl.maxTabWidth      = getMaxTabWidth();
	      ctrl.shouldCenterTabs = shouldCenterTabs();
	      $mdUtil.nextTick(function () {
	        ctrl.maxTabWidth = getMaxTabWidth();
	        adjustOffset(ctrl.selectedIndex);
	      });
	    }
	  }
	
	  /**
	   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
	   * @param hasContent
	   */
	  function handleHasContent (hasContent) {
	    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
	  }
	
	  /**
	   * Apply ctrl.offsetLeft to the paging element when it changes
	   * @param left
	   */
	  function handleOffsetChange (left) {
	    var elements = getElements();
	    var newValue = ctrl.shouldCenterTabs ? '' : '-' + left + 'px';
	
	    angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
	    $scope.$broadcast('$mdTabsPaginationChanged');
	  }
	
	  /**
	   * Update the UI whenever `ctrl.focusIndex` is updated
	   * @param newIndex
	   * @param oldIndex
	   */
	  function handleFocusIndexChange (newIndex, oldIndex) {
	    if (newIndex === oldIndex) return;
	    if (!getElements().tabs[ newIndex ]) return;
	    adjustOffset();
	    redirectFocus();
	  }
	
	  /**
	   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
	   * @param newValue
	   * @param oldValue
	   */
	  function handleSelectedIndexChange (newValue, oldValue) {
	    if (newValue === oldValue) return;
	
	    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
	    ctrl.lastSelectedIndex = oldValue;
	    ctrl.updateInkBarStyles();
	    updateHeightFromContent();
	    adjustOffset(newValue);
	    $scope.$broadcast('$mdTabsChanged');
	    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
	    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
	  }
	
	  function getTabElementIndex(tabEl){
	    var tabs = $element[0].getElementsByTagName('md-tab');
	    return Array.prototype.indexOf.call(tabs, tabEl[0]);
	  }
	
	  /**
	   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
	   * hidden.
	   */
	  function handleResizeWhenVisible () {
	    // if there is already a watcher waiting for resize, do nothing
	    if (handleResizeWhenVisible.watcher) return;
	    // otherwise, we will abuse the $watch function to check for visible
	    handleResizeWhenVisible.watcher = $scope.$watch(function () {
	      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
	      $mdUtil.nextTick(function () {
	        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
	        if (!handleResizeWhenVisible.watcher) return;
	
	        if ($element.prop('offsetParent')) {
	          handleResizeWhenVisible.watcher();
	          handleResizeWhenVisible.watcher = null;
	
	          handleWindowResize();
	        }
	      }, false);
	    });
	  }
	
	  // Event handlers / actions
	
	  /**
	   * Handle user keyboard interactions
	   * @param event
	   */
	  function keydown (event) {
	    switch (event.keyCode) {
	      case $mdConstant.KEY_CODE.LEFT_ARROW:
	        event.preventDefault();
	        incrementIndex(-1, true);
	        break;
	      case $mdConstant.KEY_CODE.RIGHT_ARROW:
	        event.preventDefault();
	        incrementIndex(1, true);
	        break;
	      case $mdConstant.KEY_CODE.SPACE:
	      case $mdConstant.KEY_CODE.ENTER:
	        event.preventDefault();
	        if (!locked) select(ctrl.focusIndex);
	        break;
	    }
	  }
	
	  /**
	   * Update the selected index. Triggers a click event on the original `md-tab` element in order
	   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
	   * @param index
	   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
	   */
	  function select (index, canSkipClick) {
	    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
	    // skip the click event if noSelectClick is enabled
	    if (canSkipClick && ctrl.noSelectClick) return;
	    // nextTick is required to prevent errors in user-defined click events
	    $mdUtil.nextTick(function () {
	      ctrl.tabs[ index ].element.triggerHandler('click');
	    }, false);
	  }
	
	  /**
	   * When pagination is on, this makes sure the selected index is in view.
	   * @param event
	   */
	  function scroll (event) {
	    if (!ctrl.shouldPaginate) return;
	    event.preventDefault();
	    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft - event.wheelDelta);
	  }
	
	  /**
	   * Slides the tabs over approximately one page forward.
	   */
	  function nextPage () {
	    var elements = getElements();
	    var viewportWidth = elements.canvas.clientWidth,
	        totalWidth    = viewportWidth + ctrl.offsetLeft,
	        i, tab;
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[ i ];
	      if (tab.offsetLeft + tab.offsetWidth > totalWidth) break;
	    }
	
	    if (viewportWidth > tab.offsetWidth) {
	      //Canvas width *greater* than tab width: usual positioning
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft);
	    } else {
	      /**
	       * Canvas width *smaller* than tab width: positioning at the *end* of current tab to let
	       * pagination "for loop" to proceed correctly on next tab when nextPage() is called again
	       */
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft + (tab.offsetWidth - viewportWidth + 1));
	    }
	  }
	
	  /**
	   * Slides the tabs over approximately one page backward.
	   */
	  function previousPage () {
	    var i, tab, elements = getElements();
	
	    for (i = 0; i < elements.tabs.length; i++) {
	      tab = elements.tabs[ i ];
	      if (tab.offsetLeft + tab.offsetWidth >= ctrl.offsetLeft) break;
	    }
	
	    if (elements.canvas.clientWidth > tab.offsetWidth) {
	      //Canvas width *greater* than tab width: usual positioning
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft + tab.offsetWidth - elements.canvas.clientWidth);
	    } else {
	      /**
	       * Canvas width *smaller* than tab width: positioning at the *beginning* of current tab to let
	       * pagination "for loop" to break correctly on previous tab when previousPage() is called again
	       */
	      ctrl.offsetLeft = fixOffset(tab.offsetLeft);
	    }
	  }
	
	  /**
	   * Update size calculations when the window is resized.
	   */
	  function handleWindowResize () {
	    ctrl.lastSelectedIndex = ctrl.selectedIndex;
	    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);
	    $mdUtil.nextTick(function () {
	      ctrl.updateInkBarStyles();
	      updatePagination();
	    });
	  }
	
	  function handleInkBar (hide) {
	    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
	  }
	
	  /**
	   * Toggle dynamic height class when value changes
	   * @param value
	   */
	  function handleDynamicHeight (value) {
	    $element.toggleClass('md-dynamic-height', value);
	  }
	
	  /**
	   * Remove a tab from the data and select the nearest valid tab.
	   * @param tabData
	   */
	  function removeTab (tabData) {
	    if (destroyed) return;
	    var selectedIndex = ctrl.selectedIndex,
	        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
	    refreshIndex();
	    // when removing a tab, if the selected index did not change, we have to manually trigger the
	    //   tab select/deselect events
	    if (ctrl.selectedIndex === selectedIndex) {
	      tab.scope.deselect();
	      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
	    }
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
	    });
	  }
	
	  /**
	   * Create an entry in the tabs array for a new tab at the specified index.
	   * @param tabData
	   * @param index
	   * @returns {*}
	   */
	  function insertTab (tabData, index) {
	    var hasLoaded = loaded;
	    var proto     = {
	          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
	          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
	          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
	          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
	          shouldRender: function () { return !ctrl.noDisconnect || this.isActive(); },
	          hasFocus:     function () {
	            return ctrl.styleTabItemFocus
	                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
	          },
	          id:           $mdUtil.nextUid(),
	          hasContent: !!(tabData.template && tabData.template.trim())
	        },
	        tab       = angular.extend(proto, tabData);
	    if (angular.isDefined(index)) {
	      ctrl.tabs.splice(index, 0, tab);
	    } else {
	      ctrl.tabs.push(tab);
	    }
	
	    processQueue();
	    updateHasContent();
	    $mdUtil.nextTick(function () {
	      updatePagination();
	      setAriaControls(tab);
	
	      // if autoselect is enabled, select the newly added tab
	      if (hasLoaded && ctrl.autoselect) $mdUtil.nextTick(function () {
	        $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
	      });
	    });
	    return tab;
	  }
	
	  // Getter methods
	
	  /**
	   * Gathers references to all of the DOM elements used by this controller.
	   * @returns {{}}
	   */
	  function getElements () {
	    var elements = {};
	    var node = $element[0];
	
	    // gather tab bar elements
	    elements.wrapper = node.querySelector('md-tabs-wrapper');
	    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
	    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
	    elements.inkBar  = elements.paging.querySelector('md-ink-bar');
	
	    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
	    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
	    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');
	
	    return elements;
	  }
	
	  /**
	   * Determines whether or not the left pagination arrow should be enabled.
	   * @returns {boolean}
	   */
	  function canPageBack () {
	    return ctrl.offsetLeft > 0;
	  }
	
	  /**
	   * Determines whether or not the right pagination arrow should be enabled.
	   * @returns {*|boolean}
	   */
	  function canPageForward () {
	    var elements = getElements();
	    var lastTab = elements.tabs[ elements.tabs.length - 1 ];
	    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
	        ctrl.offsetLeft;
	  }
	
	  /**
	   * Returns currently focused tab item's element ID
	   */
	  function getFocusedTabId() {
	    var focusedTab = ctrl.tabs[ctrl.focusIndex];
	    if (!focusedTab || !focusedTab.id) {
	      return null;
	    }
	    return 'tab-item-' + focusedTab.id;
	  }
	
	  /**
	   * Determines if the UI should stretch the tabs to fill the available space.
	   * @returns {*}
	   */
	  function shouldStretchTabs () {
	    switch (ctrl.stretchTabs) {
	      case 'always':
	        return true;
	      case 'never':
	        return false;
	      default:
	        return !ctrl.shouldPaginate
	            && $window.matchMedia('(max-width: 600px)').matches;
	    }
	  }
	
	  /**
	   * Determines if the tabs should appear centered.
	   * @returns {string|boolean}
	   */
	  function shouldCenterTabs () {
	    return ctrl.centerTabs && !ctrl.shouldPaginate;
	  }
	
	  /**
	   * Determines if pagination is necessary to display the tabs within the available space.
	   * @returns {boolean}
	   */
	  function shouldPaginate () {
	    if (ctrl.noPagination || !loaded) return false;
	    var canvasWidth = $element.prop('clientWidth');
	
	    angular.forEach(getElements().dummies, function (tab) {
	      canvasWidth -= tab.offsetWidth;
	    });
	
	    return canvasWidth < 0;
	  }
	
	  /**
	   * Finds the nearest tab index that is available.  This is primarily used for when the active
	   * tab is removed.
	   * @param newIndex
	   * @returns {*}
	   */
	  function getNearestSafeIndex (newIndex) {
	    if (newIndex === -1) return -1;
	    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
	        i, tab;
	    for (i = 0; i <= maxOffset; i++) {
	      tab = ctrl.tabs[ newIndex + i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	      tab = ctrl.tabs[ newIndex - i ];
	      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
	    }
	    return newIndex;
	  }
	
	  // Utility methods
	
	  /**
	   * Defines a property using a getter and setter in order to trigger a change handler without
	   * using `$watch` to observe changes.
	   * @param key
	   * @param handler
	   * @param value
	   */
	  function defineProperty (key, handler, value) {
	    Object.defineProperty(ctrl, key, {
	      get: function () { return value; },
	      set: function (newValue) {
	        var oldValue = value;
	        value        = newValue;
	        handler && handler(newValue, oldValue);
	      }
	    });
	  }
	
	  /**
	   * Updates whether or not pagination should be displayed.
	   */
	  function updatePagination () {
	    ctrl.maxTabWidth = getMaxTabWidth();
	    ctrl.shouldPaginate = shouldPaginate();
	  }
	
	  /**
	   * Calculates the width of the pagination wrapper by summing the widths of the dummy tabs.
	   * @returns {number}
	   */
	  function calcPagingWidth () {
	    return calcTabsWidth(getElements().dummies);
	  }
	
	  function calcTabsWidth(tabs) {
	    var width = 0;
	
	    angular.forEach(tabs, function (tab) {
	      //-- Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
	      //   prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
	      //   also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
	      //   of a dialog)
	      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
	    });
	
	    return Math.ceil(width);
	  }
	
	  function getMaxTabWidth () {
	    return $element.prop('clientWidth');
	  }
	
	  /**
	   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
	   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
	   */
	  function updateTabOrder () {
	    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
	        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
	    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
	      return a.index - b.index;
	    });
	    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
	    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
	  }
	
	  /**
	   * This moves the selected or focus index left or right.  This is used by the keydown handler.
	   * @param inc
	   */
	  function incrementIndex (inc, focus) {
	    var newIndex,
	        key   = focus ? 'focusIndex' : 'selectedIndex',
	        index = ctrl[ key ];
	    for (newIndex = index + inc;
	         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
	         newIndex += inc) {}
	    if (ctrl.tabs[ newIndex ]) {
	      ctrl[ key ] = newIndex;
	    }
	  }
	
	  /**
	   * This is used to forward focus to dummy elements.  This method is necessary to avoid animation
	   * issues when attempting to focus an item that is out of view.
	   */
	  function redirectFocus () {
	    ctrl.styleTabItemFocus = ($mdInteraction.getLastInteractionType() === 'keyboard');
	    getElements().dummies[ ctrl.focusIndex ].focus();
	  }
	
	  /**
	   * Forces the pagination to move the focused tab into view.
	   */
	  function adjustOffset (index) {
	    var elements = getElements();
	
	    if (!angular.isNumber(index)) index = ctrl.focusIndex;
	    if (!elements.tabs[ index ]) return;
	    if (ctrl.shouldCenterTabs) return;
	    var tab         = elements.tabs[ index ],
	        left        = tab.offsetLeft,
	        right       = tab.offsetWidth + left;
	    ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + 32 * 2));
	    ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
	  }
	
	  /**
	   * Iterates through all queued functions and clears the queue.  This is used for functions that
	   * are called before the UI is ready, such as size calculations.
	   */
	  function processQueue () {
	    queue.forEach(function (func) { $mdUtil.nextTick(func); });
	    queue = [];
	  }
	
	  /**
	   * Determines if the tab content area is needed.
	   */
	  function updateHasContent () {
	    var hasContent  = false;
	
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].hasContent) {
	        hasContent = true;
	        break;
	      }
	    }
	
	    ctrl.hasContent = hasContent;
	  }
	
	  /**
	   * Moves the indexes to their nearest valid values.
	   */
	  function refreshIndex () {
	    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
	    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
	  }
	
	  /**
	   * Calculates the content height of the current tab.
	   * @returns {*}
	   */
	  function updateHeightFromContent () {
	    if (!ctrl.dynamicHeight) return $element.css('height', '');
	    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);
	
	    var elements = getElements();
	
	    var tabContent    = elements.contents[ ctrl.selectedIndex ],
	        contentHeight = tabContent ? tabContent.offsetHeight : 0,
	        tabsHeight    = elements.wrapper.offsetHeight,
	        newHeight     = contentHeight + tabsHeight,
	        currentHeight = $element.prop('clientHeight');
	
	    if (currentHeight === newHeight) return;
	
	    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
	    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
	    if ($element.attr('md-align-tabs') === 'bottom') {
	      currentHeight -= tabsHeight;
	      newHeight -= tabsHeight;
	      // Need to include bottom border in these calculations
	      if ($element.attr('md-border-bottom') !== undefined) ++currentHeight;
	    }
	
	    // Lock during animation so the user can't change tabs
	    locked = true;
	
	    var fromHeight = { height: currentHeight + 'px' },
	        toHeight = { height: newHeight + 'px' };
	
	    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
	    // first animates to 0, then back to the proper height causing a visual glitch
	    $element.css(fromHeight);
	
	    // Animate the height from the old to the new
	    $animateCss($element, {
	      from: fromHeight,
	      to: toHeight,
	      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
	      duration: 0.5
	    }).start().done(function () {
	      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
	      // pixel height so the height can size with browser width/content changes, etc.
	      $element.css({
	        transition: 'none',
	        height: ''
	      });
	
	      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
	      // enough to batch it for us instead of doing it immediately, which undoes the original
	      // transition: none)
	      $mdUtil.nextTick(function() {
	        $element.css('transition', '');
	      });
	
	      // And unlock so tab changes can occur
	      locked = false;
	    });
	  }
	
	  /**
	   * Repositions the ink bar to the selected tab.
	   * @returns {*}
	   */
	  function updateInkBarStyles () {
	    var elements = getElements();
	
	    if (!elements.tabs[ ctrl.selectedIndex ]) {
	      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
	      return;
	    }
	
	    if (!ctrl.tabs.length) return queue.push(ctrl.updateInkBarStyles);
	    // if the element is not visible, we will not be able to calculate sizes until it is
	    // we should treat that as a resize event rather than just updating the ink bar
	    if (!$element.prop('offsetParent')) return handleResizeWhenVisible();
	
	    var index      = ctrl.selectedIndex,
	        totalWidth = elements.paging.offsetWidth,
	        tab        = elements.tabs[ index ],
	        left       = tab.offsetLeft,
	        right      = totalWidth - left - tab.offsetWidth;
	
	    if (ctrl.shouldCenterTabs) {
	      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding deviations.
	      var tabWidth = calcTabsWidth(elements.tabs);
	
	      if (totalWidth > tabWidth) {
	        $mdUtil.nextTick(updateInkBarStyles, false);
	      }
	    }
	    updateInkBarClassName();
	    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
	  }
	
	  /**
	   * Adds left/right classes so that the ink bar will animate properly.
	   */
	  function updateInkBarClassName () {
	    var elements = getElements();
	    var newIndex = ctrl.selectedIndex,
	        oldIndex = ctrl.lastSelectedIndex,
	        ink      = angular.element(elements.inkBar);
	    if (!angular.isNumber(oldIndex)) return;
	    ink
	        .toggleClass('md-left', newIndex < oldIndex)
	        .toggleClass('md-right', newIndex > oldIndex);
	  }
	
	  /**
	   * Takes an offset value and makes sure that it is within the min/max allowed values.
	   * @param value
	   * @returns {*}
	   */
	  function fixOffset (value) {
	    var elements = getElements();
	
	    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;
	    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
	        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
	    value          = Math.max(0, value);
	    value          = Math.min(totalWidth - elements.canvas.clientWidth, value);
	    return value;
	  }
	
	  /**
	   * Attaches a ripple to the tab item element.
	   * @param scope
	   * @param element
	   */
	  function attachRipple (scope, element) {
	    var elements = getElements();
	    var options = { colorElement: angular.element(elements.inkBar) };
	    $mdTabInkRipple.attach(scope, element, options);
	  }
	
	  /**
	   * Sets the `aria-controls` attribute to the elements that
	   * correspond to the passed-in tab.
	   * @param tab
	   */
	  function setAriaControls (tab) {
	    if (tab.hasContent) {
	      var nodes = $element[0].querySelectorAll('[md-tab-id="' + tab.id + '"]');
	      angular.element(nodes).attr('aria-controls', ctrl.tabContentPrefix + tab.id);
	    }
	  }
	}
	
	})();
	(function(){
	"use strict";
	
	/**
	 * @ngdoc directive
	 * @name mdTabs
	 * @module material.components.tabs
	 *
	 * @restrict E
	 *
	 * @description
	 * The `<md-tabs>` directive serves as the container for 1..n `<md-tab>` child directives to
	 * produces a Tabs components. In turn, the nested `<md-tab>` directive is used to specify a tab
	 * label for the **header button** and a [optional] tab view content that will be associated with
	 * each tab button.
	 *
	 * Below is the markup for its simplest usage:
	 *
	 *  <hljs lang="html">
	 *  <md-tabs>
	 *    <md-tab label="Tab #1"></md-tab>
	 *    <md-tab label="Tab #2"></md-tab>
	 *    <md-tab label="Tab #3"></md-tab>
	 *  </md-tabs>
	 *  </hljs>
	 *
	 * Tabs supports three (3) usage scenarios:
	 *
	 *  1. Tabs (buttons only)
	 *  2. Tabs with internal view content
	 *  3. Tabs with external view content
	 *
	 * **Tab-only** support is useful when tab buttons are used for custom navigation regardless of any
	 * other components, content, or views.
	 *
	 * <i><b>Note:</b> If you are using the Tabs component for page-level navigation, please take a look
	 * at the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead as it can handle this
	 * case a bit more natively.</i>
	 *
	 * **Tabs with internal views** are the traditional usages where each tab has associated view
	 * content and the view switching is managed internally by the Tabs component.
	 *
	 * **Tabs with external view content** is often useful when content associated with each tab is
	 * independently managed and data-binding notifications announce tab selection changes.
	 *
	 * Additional features also include:
	 *
	 * *  Content can include any markup.
	 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
	 *
	 * ### Explanation of tab stretching
	 *
	 * Initially, tabs will have an inherent size.  This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS.  Calculations will be based on this size.
	 *
	 * On mobile devices, tabs will be expanded to fill the available horizontal space.  When this happens, all tabs will become the same size.
	 *
	 * On desktops, by default, stretching will never occur.
	 *
	 * This default behavior can be overridden through the `md-stretch-tabs` attribute.  Here is a table showing when stretching will occur:
	 *
	 * `md-stretch-tabs` | mobile    | desktop
	 * ------------------|-----------|--------
	 * `auto`            | stretched | ---
	 * `always`          | stretched | stretched
	 * `never`           | ---       | ---
	 *
	 * @param {integer=} md-selected Index of the active/selected tab
	 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
	 * @param {boolean=} md-no-ink-bar If present, disables the selection ink bar.
	 * @param {string=}  md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`; default is `top`
	 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`, `always`, or `never`; default is `auto`
	 * @param {boolean=} md-dynamic-height When enabled, the tab wrapper will resize based on the contents of the selected tab
	 * @param {boolean=} md-border-bottom If present, shows a solid `1px` border between the tabs and their content
	 * @param {boolean=} md-center-tabs When enabled, tabs will be centered provided there is no need for pagination
	 * @param {boolean=} md-no-pagination When enabled, pagination will remain off
	 * @param {boolean=} md-swipe-content When enabled, swipe gestures will be enabled for the content area to jump between tabs
	 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that are not being displayed.  This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.
	 * @param {boolean=} md-autoselect When present, any tabs added after the initial load will be automatically selected
	 * @param {boolean=} md-no-select-click When enabled, click events will not be fired when selecting tabs
	 *
	 * @usage
	 * <hljs lang="html">
	 * <md-tabs md-selected="selectedIndex" >
	 *   <img ng-src="img/angular.png" class="centered">
	 *   <md-tab
	 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
	 *       md-on-select="onTabSelected(tab)"
	 *       md-on-deselect="announceDeselected(tab)"
	 *       ng-disabled="tab.disabled">
	 *     <md-tab-label>
	 *       {{tab.title}}
	 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
	 *     </md-tab-label>
	 *     <md-tab-body>
	 *       {{tab.content}}
	 *     </md-tab-body>
	 *   </md-tab>
	 * </md-tabs>
	 * </hljs>
	 *
	 */
	MdTabs.$inject = ["$$mdSvgRegistry"];
	angular
	    .module('material.components.tabs')
	    .directive('mdTabs', MdTabs);
	
	function MdTabs ($$mdSvgRegistry) {
	  return {
	    scope:            {
	      selectedIndex: '=?mdSelected'
	    },
	    template:         function (element, attr) {
	      attr.$mdTabsTemplate = element.html();
	      return '' +
	        '<md-tabs-wrapper> ' +
	          '<md-tab-data></md-tab-data> ' +
	          '<md-prev-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Previous Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.previousPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-prev-button> ' +
	          '<md-next-button ' +
	              'tabindex="-1" ' +
	              'role="button" ' +
	              'aria-label="Next Page" ' +
	              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
	              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
	              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
	              'ng-click="$mdTabsCtrl.nextPage()"> ' +
	            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
	          '</md-next-button> ' +
	          '<md-tabs-canvas ' +
	              'tabindex="{{ $mdTabsCtrl.hasFocus ? -1 : 0 }}" ' +
	              'aria-activedescendant="{{$mdTabsCtrl.getFocusedTabId()}}" ' +
	              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
	              'ng-class="{ ' +
	                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
	                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
	              '}" ' +
	              'ng-keydown="$mdTabsCtrl.keydown($event)" ' +
	              'role="tablist"> ' +
	            '<md-pagination-wrapper ' +
	                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
	                'md-tab-scroll="$mdTabsCtrl.scroll($event)"> ' +
	              '<md-tab-item ' +
	                  'tabindex="-1" ' +
	                  'class="md-tab" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'role="tab" ' +
	                  'md-tab-id="{{::tab.id}}"' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
	                  'ng-class="{ ' +
	                      '\'md-active\':    tab.isActive(), ' +
	                      '\'md-focused\':   tab.hasFocus(), ' +
	                      '\'md-disabled\':  tab.scope.disabled ' +
	                  '}" ' +
	                  'ng-disabled="tab.scope.disabled" ' +
	                  'md-swipe-left="$mdTabsCtrl.nextPage()" md-swipe-touch-action="pan-y" ' +
	                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-tab-item> ' +
	              '<md-ink-bar></md-ink-bar> ' +
	            '</md-pagination-wrapper> ' +
	            '<md-tabs-dummy-wrapper class="md-visually-hidden md-dummy-wrapper"> ' +
	              '<md-dummy-tab ' +
	                  'class="md-tab" ' +
	                  'tabindex="-1" ' +
	                  'id="tab-item-{{::tab.id}}" ' +
	                  'md-tab-id="{{::tab.id}}"' +
	                  'aria-selected="{{tab.isActive()}}" ' +
	                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
	                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
	                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
	                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
	                  'md-tabs-template="::tab.label" ' +
	                  'md-scope="::tab.parent"></md-dummy-tab> ' +
	            '</md-tabs-dummy-wrapper> ' +
	          '</md-tabs-canvas> ' +
	        '</md-tabs-wrapper> ' +
	        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
	          '<md-tab-content ' +
	              'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" ' +
	              'class="_md" ' +
	              'role="tabpanel" ' +
	              'aria-labelledby="tab-item-{{::tab.id}}" ' +
	              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
	              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
	              'md-swipe-touch-action="pan-y" ' +
	              'ng-if="tab.hasContent" ' +
	              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
	              'ng-class="{ ' +
	                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
	                '\'md-active\':        tab.isActive(), ' +
	                '\'md-left\':          tab.isLeft(), ' +
	                '\'md-right\':         tab.isRight(), ' +
	                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
	              '}"> ' +
	            '<div ' +
	                'md-tabs-template="::tab.template" ' +
	                'md-connected-if="tab.isActive()" ' +
	                'md-scope="::tab.parent" ' +
	                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
	          '</md-tab-content> ' +
	        '</md-tabs-content-wrapper>';
	    },
	    controller:       'MdTabsController',
	    controllerAs:     '$mdTabsCtrl',
	    bindToController: true
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsDummyWrapper.$inject = ["$mdUtil", "$window"];angular
	  .module('material.components.tabs')
	  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);
	
	/**
	 * @private
	 *
	 * @param $mdUtil
	 * @param $window
	 * @returns {{require: string, link: link}}
	 * @constructor
	 *
	 * @ngInject
	 */
	function MdTabsDummyWrapper ($mdUtil, $window) {
	  return {
	    require: '^?mdTabs',
	    link:    function link (scope, element, attr, ctrl) {
	      if (!ctrl) return;
	
	      var observer;
	      var disconnect;
	
	      var mutationCallback = function() {
	        ctrl.updatePagination();
	        ctrl.updateInkBarStyles();
	      };
	
	      if('MutationObserver' in $window) {
	        var config = {
	          childList: true,
	          subtree: true,
	          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
	          // the childList mutation, once a <span> element's innerText changes.
	          // The characterData of the <span> element will change.
	          characterData: true
	        };
	
	        observer = new MutationObserver(mutationCallback);
	        observer.observe(element[0], config);
	        disconnect = observer.disconnect.bind(observer);
	      } else {
	        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);
	        
	        element.on('DOMSubtreeModified', debounced);
	        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
	      }
	
	      // Disconnect the observer
	      scope.$on('$destroy', function() {
	        disconnect();
	      });
	    }
	  };
	}
	
	})();
	(function(){
	"use strict";
	
	
	MdTabsTemplate.$inject = ["$compile", "$mdUtil"];angular
	    .module('material.components.tabs')
	    .directive('mdTabsTemplate', MdTabsTemplate);
	
	function MdTabsTemplate ($compile, $mdUtil) {
	  return {
	    restrict: 'A',
	    link:     link,
	    scope:    {
	      template:     '=mdTabsTemplate',
	      connected:    '=?mdConnectedIf',
	      compileScope: '=mdScope'
	    },
	    require:  '^?mdTabs'
	  };
	  function link (scope, element, attr, ctrl) {
	    if (!ctrl) return;
	
	    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;
	
	    element.html(scope.template);
	    $compile(element.contents())(compileScope);
	
	    return $mdUtil.nextTick(handleScope);
	
	    function handleScope () {
	      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
	      scope.$on('$destroy', reconnect);
	    }
	
	    function disconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
	    }
	
	    function reconnect () {
	      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
	    }
	  }
	}
	
	})();
	(function(){ 
	angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme{background:\"{{background-A100}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-100}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-A100}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li{color:\"{{background-900}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight{color:\"{{background-600}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover{background:\"{{background-200}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-50}}\";border-top-color:\"{{background-300}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-50}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{color:\"{{primary-contrast}}\";background-color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-raised{color:\"{{background-900}}\";background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{color:\"{{warn-contrast}}\";background-color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{color:\"{{accent-contrast}}\";background-color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-hue-1}}\";border-radius:2px}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{color:\"{{background-color}}\";background-color:\"{{foreground-3}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{accent-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:\"{{background-500}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-content.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-default}}\"}.md-calendar.md-THEME_NAME-theme{background:\"{{background-A100}}\";color:\"{{background-A200-0.87}}\"}.md-calendar.md-THEME_NAME-theme tr:last-child td{border-bottom-color:\"{{background-200}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-300}}\";color:\"{{background-A200-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-300}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";color:\"{{primary-500-contrast}}\";border-color:transparent}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{background-A200-0.435}}\"}.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-A100}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{border-radius:4px;background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions,md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions,md-divider.md-THEME_NAME-theme{border-top-color:\"{{foreground-4}}\"}.layout-gt-lg-row>md-divider.md-THEME_NAME-theme,.layout-gt-md-row>md-divider.md-THEME_NAME-theme,.layout-gt-sm-row>md-divider.md-THEME_NAME-theme,.layout-gt-xs-row>md-divider.md-THEME_NAME-theme,.layout-lg-row>md-divider.md-THEME_NAME-theme,.layout-md-row>md-divider.md-THEME_NAME-theme,.layout-row>md-divider.md-THEME_NAME-theme,.layout-sm-row>md-divider.md-THEME_NAME-theme,.layout-xl-row>md-divider.md-THEME_NAME-theme,.layout-xs-row>md-divider.md-THEME_NAME-theme{border-right-color:\"{{foreground-4}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{color:\"{{foreground-1}}\";border-color:\"{{foreground-4}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{border-bottom-color:transparent;color:\"{{foreground-3}}\";background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-A100}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{background-A200-0.87}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{background-A200-0.25}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{background-A200-0.11}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{color:\"{{foreground-2}}\";border-radius:2px}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{outline:none;background:\"{{background-200}}\"}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.2}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.2}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-A100}}\";color:\"{{background-A200}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{background-A100-0.87}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{background-A100-0.87}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar{background-color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar{background-color:\"{{warn-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar{background-color:\"{{primary-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{primary-color}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked.md-primary .md-ink-ripple{color:\"{{warn-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme[disabled] .md-select-value{border-bottom-color:transparent;background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background:\"{{background-A100}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{background-600-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{background-900-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{background-400-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background:\"{{background-200}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{background-900-0.87}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{border-color:\"{{background-color}}\";background-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{border-color:\"{{accent-color}}\";background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{border-color:\"{{warn-color}}\";background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{border-color:\"{{primary-color}}\";background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{border-color:transparent;background-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{color:\"{{ foreground-2-0.23 }}\";background-color:\"{{background-default}}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme .md-paginator md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{color:\"{{primary-contrast}}\";fill:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{color:\"{{primary-contrast-0.26}}\";fill:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{color:\"{{accent-contrast}}\";fill:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{color:\"{{accent-contrast-0.26}}\";fill:\"{{accent-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{color:\"{{background-700-contrast}}\";background-color:\"{{background-700}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-color}}\"}"); 
	})();
	
	
	})(window, window.angular);;window.ngMaterial={version:{full: "1.1.4"}};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v1.0.1 / (c) 2013, 2014, 2015, 2016 Uri Shaked / MIT Licence */
	
	'format amd';
	/* global define */
	
	(function () {
		'use strict';
	
		function isUndefinedOrNull(val) {
			return angular.isUndefined(val) || val === null;
		}
	
		function requireMoment() {
			try {
				return __webpack_require__(3); // Using nw.js or browserify?
			} catch (e) {
				throw new Error('Please install moment via npm. Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
			}
		}
	
		function angularMoment(angular, moment) {
	
			if(typeof moment === 'undefined') {
				if(true) {
					moment = requireMoment();
				}else{
					throw new Error('Moment cannot be found by angular-moment! Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
				}
			}
	
			/**
			 * @ngdoc overview
			 * @name angularMoment
			 *
			 * @description
			 * angularMoment module provides moment.js functionality for angular.js apps.
			 */
			angular.module('angularMoment', [])
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:angularMomentConfig
			 *
			 * @description
			 * Common configuration of the angularMoment module
			 */
				.constant('angularMomentConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#preprocess
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {function} A preprocessor function that will be applied on all incoming dates
					 *
					 * @description
					 * Defines a preprocessor function to apply on all input dates (e.g. the input of `am-time-ago`,
					 * `amCalendar`, etc.). The function must return a `moment` object.
					 *
					 * @example
					 *   // Causes angular-moment to always treat the input values as unix timestamps
					 *   angularMomentConfig.preprocess = function(value) {
					 * 	   return moment.unix(value);
					 *   }
					 */
					preprocess: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#timezone
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The default timezone
					 *
					 * @description
					 * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
					 * any timezone shift).
					 *
					 * NOTE: This option requires moment-timezone >= 0.3.0.
					 */
					timezone: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#format
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The pre-conversion format of the date
					 *
					 * @description
					 * Specify the format of the input date. Essentially it's a
					 * default and saves you from specifying a format in every
					 * element. Overridden by element attr. Null by default.
					 */
					format: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#statefulFilters
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {boolean} Whether angular-moment filters should be stateless (or not)
					 *
					 * @description
					 * Specifies whether the filters included with angular-moment are stateful.
					 * Stateful filters will automatically re-evaluate whenever you change the timezone
					 * or locale settings, but may negatively impact performance. true by default.
					 */
					statefulFilters: true
				})
	
			/**
			 * @ngdoc object
			 * @name angularMoment.object:moment
			 *
			 * @description
			 * moment global (as provided by the moment.js library)
			 */
				.constant('moment', moment)
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:amTimeAgoConfig
			 * @module angularMoment
			 *
			 * @description
			 * configuration specific to the amTimeAgo directive
			 */
				.constant('amTimeAgoConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {boolean} Whether to include a suffix in am-time-ago directive
					 *
					 * @description
					 * Defaults to false.
					 */
					withoutSuffix: false,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#serverTime
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} Server time in milliseconds since the epoch
					 *
					 * @description
					 * If set, time ago will be calculated relative to the given value.
					 * If null, local time will be used. Defaults to null.
					 */
					serverTime: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#titleFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format of the date to be displayed in the title of the element. If null,
					 *        the directive set the title of the element.
					 *
					 * @description
					 * The format of the date used for the title of the element. null by default.
					 */
					titleFormat: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} The minimum number of days for showing a full date instead of relative time
					 *
					 * @description
					 * The threshold for displaying a full date. The default is null, which means the date will always
					 * be relative, and full date will never be displayed.
					 */
					fullDateThreshold: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format to use when displaying a full date.
					 *
					 * @description
					 * Specify the format of the date when displayed as full date. null by default.
					 */
					fullDateFormat: null,
	
					fullDateThresholdUnit: 'day'
				})
	
			/**
			 * @ngdoc directive
			 * @name angularMoment.directive:amTimeAgo
			 * @module angularMoment
			 *
			 * @restrict A
			 */
				.directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', function ($window, moment, amMoment, amTimeAgoConfig) {
	
					return function (scope, element, attr) {
						var activeTimeout = null;
						var currentValue;
						var withoutSuffix = amTimeAgoConfig.withoutSuffix;
						var titleFormat = amTimeAgoConfig.titleFormat;
						var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
						var fullDateFormat = amTimeAgoConfig.fullDateFormat;
						var fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;
	
						var localDate = new Date().getTime();
						var modelName = attr.amTimeAgo;
						var currentFrom;
						var isTimeElement = ('TIME' === element[0].nodeName.toUpperCase());
						var setTitleTime = !element.attr('title');
	
						function getNow() {
							var now;
							if (currentFrom) {
								now = currentFrom;
							} else if (amTimeAgoConfig.serverTime) {
								var localNow = new Date().getTime();
								var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
								now = moment(nowMillis);
							}
							else {
								now = moment();
							}
							return now;
						}
	
						function cancelTimer() {
							if (activeTimeout) {
								$window.clearTimeout(activeTimeout);
								activeTimeout = null;
							}
						}
	
						function updateTime(momentInstance) {
							var timeAgo = getNow().diff(momentInstance, fullDateThresholdUnit);
							var showFullDate = fullDateThreshold && timeAgo >= fullDateThreshold;
	
							if (showFullDate) {
								element.text(momentInstance.format(fullDateFormat));
							} else {
								element.text(momentInstance.from(getNow(), withoutSuffix));
							}
	
							if (titleFormat && setTitleTime) {
								element.attr('title', momentInstance.format(titleFormat));
							}
	
							if (!showFullDate) {
								var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
								var secondsUntilUpdate = 3600;
								if (howOld < 1) {
									secondsUntilUpdate = 1;
								} else if (howOld < 60) {
									secondsUntilUpdate = 30;
								} else if (howOld < 180) {
									secondsUntilUpdate = 300;
								}
	
								activeTimeout = $window.setTimeout(function () {
									updateTime(momentInstance);
								}, secondsUntilUpdate * 1000);
							}
						}
	
						function updateDateTimeAttr(value) {
							if (isTimeElement) {
								element.attr('datetime', value);
							}
						}
	
						function updateMoment() {
							cancelTimer();
							if (currentValue) {
								var momentValue = amMoment.preprocessDate(currentValue);
								updateTime(momentValue);
								updateDateTimeAttr(momentValue.toISOString());
							}
						}
	
						scope.$watch(modelName, function (value) {
							if (isUndefinedOrNull(value) || (value === '')) {
								cancelTimer();
								if (currentValue) {
									element.text('');
									updateDateTimeAttr('');
									currentValue = null;
								}
								return;
							}
	
							currentValue = value;
							updateMoment();
						});
	
						if (angular.isDefined(attr.amFrom)) {
							scope.$watch(attr.amFrom, function (value) {
								if (isUndefinedOrNull(value) || (value === '')) {
									currentFrom = null;
								} else {
									currentFrom = moment(value);
								}
								updateMoment();
							});
						}
	
						if (angular.isDefined(attr.amWithoutSuffix)) {
							scope.$watch(attr.amWithoutSuffix, function (value) {
								if (typeof value === 'boolean') {
									withoutSuffix = value;
									updateMoment();
								} else {
									withoutSuffix = amTimeAgoConfig.withoutSuffix;
								}
							});
						}
	
						attr.$observe('amFullDateThreshold', function (newValue) {
							fullDateThreshold = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateFormat', function (newValue) {
							fullDateFormat = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateThresholdUnit', function (newValue) {
							fullDateThresholdUnit = newValue;
							updateMoment();
						});
	
						scope.$on('$destroy', function () {
							cancelTimer();
						});
	
						scope.$on('amMoment:localeChanged', function () {
							updateMoment();
						});
					};
				}])
	
			/**
			 * @ngdoc service
			 * @name angularMoment.service.amMoment
			 * @module angularMoment
			 */
				.service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
					var defaultTimezone = null;
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeLocale
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the locale for moment.js and updates all the am-time-ago directive instances
					 * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
					 *
					 * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
					 * @param {object} customization object of locale strings to override
					 */
					this.changeLocale = function (locale, customization) {
						var result = moment.locale(locale, customization);
						if (angular.isDefined(locale)) {
							$rootScope.$broadcast('amMoment:localeChanged');
	
						}
						return result;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeTimezone
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
					 * `amMoment:timezoneChanged` event on $rootScope.
					 *
					 * Note: this method works only if moment-timezone > 0.3.0 is loaded
					 *
					 * @param {string} timezone Timezone name (e.g. UTC)
					 */
					this.changeTimezone = function (timezone) {
						if (moment.tz && moment.tz.setDefault) {
							moment.tz.setDefault(timezone);
							$rootScope.$broadcast('amMoment:timezoneChanged');
						} else {
							$log.warn('angular-moment: changeTimezone() works only with moment-timezone.js v0.3.0 or greater.');
						}
						angularMomentConfig.timezone = timezone;
						defaultTimezone = timezone;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#preprocessDate
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Preprocess a given value and convert it into a Moment instance appropriate for use in the
					 * am-time-ago directive and the filters. The behavior of this function can be overriden by
					 * setting `angularMomentConfig.preprocess`.
					 *
					 * @param {*} value The value to be preprocessed
					 * @return {Moment} A `moment` object
					 */
					this.preprocessDate = function (value) {
						// Configure the default timezone if needed
						if (defaultTimezone !== angularMomentConfig.timezone) {
							this.changeTimezone(angularMomentConfig.timezone);
						}
	
						if (angularMomentConfig.preprocess) {
							return angularMomentConfig.preprocess(value);
						}
	
						if (!isNaN(parseFloat(value)) && isFinite(value)) {
							// Milliseconds since the epoch
							return moment(parseInt(value, 10));
						}
	
						// else just returns the value as-is.
						return moment(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amParse
			 * @module angularMoment
			 */
				.filter('amParse', ['moment', function (moment) {
					return function (value, format) {
						return moment(value, format);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amFromUnix
			 * @module angularMoment
			 */
				.filter('amFromUnix', ['moment', function (moment) {
					return function (value) {
						return moment.unix(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtc
			 * @module angularMoment
			 */
				.filter('amUtc', ['moment', function (moment) {
					return function (value) {
						return moment.utc(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtcOffset
			 * @module angularMoment
			 *
			 * @description
			 * Adds a UTC offset to the given timezone object. The offset can be a number of minutes, or a string such as
			 * '+0300', '-0300' or 'Z'.
			 */
				.filter('amUtcOffset', ['amMoment', function (amMoment) {
					function amUtcOffset(value, offset) {
						return amMoment.preprocessDate(value).utcOffset(offset);
					}
	
					return amUtcOffset;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amLocal
			 * @module angularMoment
			 */
				.filter('amLocal', ['moment', function (moment) {
					return function (value) {
						return moment.isMoment(value) ? value.local() : null;
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimezone
			 * @module angularMoment
			 *
			 * @description
			 * Apply a timezone onto a given moment object, e.g. 'America/Phoenix').
			 *
			 * You need to include moment-timezone.js for timezone support.
			 */
				.filter('amTimezone', ['amMoment', 'angularMomentConfig', '$log', function (amMoment, angularMomentConfig, $log) {
					function amTimezone(value, timezone) {
						var aMoment = amMoment.preprocessDate(value);
	
						if (!timezone) {
							return aMoment;
						}
	
						if (aMoment.tz) {
							return aMoment.tz(timezone);
						} else {
							$log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
							return aMoment;
						}
					}
	
					return amTimezone;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amCalendar
			 * @module angularMoment
			 */
				.filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amCalendarFilter(value, referenceTime, formats) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						return date.isValid() ? date.calendar(referenceTime, formats) : '';
					}
	
					// Since AngularJS 1.3, filters have to explicitly define being stateful
					// (this is no longer the default).
					amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amCalendarFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDifference
			 * @module angularMoment
			 */
				.filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDifferenceFilter(value, otherValue, unit, usePrecision) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						var date2 = !isUndefinedOrNull(otherValue) ? amMoment.preprocessDate(otherValue) : moment();
	
						if (!date.isValid() || !date2.isValid()) {
							return '';
						}
	
						return date.diff(date2, unit, usePrecision);
					}
	
					amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDifferenceFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDateFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDateFormatFilter(value, format) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						if (!date.isValid()) {
							return '';
						}
	
						return date.format(format);
					}
	
					amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDateFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDurationFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amDurationFormatFilter(value, format, suffix) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment.duration(value, format).humanize(suffix);
					}
	
					amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDurationFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimeAgo
			 * @module angularMoment
			 * @function
			 */
				.filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amTimeAgoFilter(value, suffix, from) {
						var date, dateFrom;
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						value = amMoment.preprocessDate(value);
						date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						dateFrom = moment(from);
						if (!isUndefinedOrNull(from) && dateFrom.isValid()) {
							return date.from(dateFrom, suffix);
						}
	
						return date.fromNow(suffix);
					}
	
					amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amTimeAgoFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amSubtract
			 * @module angularMoment
			 * @function
			 */
				.filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amSubtractFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).subtract(parseInt(amount, 10), type);
					}
	
					amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amSubtractFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amAdd
			 * @module angularMoment
			 * @function
			 */
				.filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amAddFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).add(parseInt(amount, 10), type);
					}
	
					amAddFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amAddFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amStartOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amStartOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amStartOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).startOf(type);
					}
	
					amStartOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amStartOfFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amEndOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amEndOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amEndOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).endOf(type);
					}
	
					amEndOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amEndOfFilter;
	 			}]);
	
			return 'angularMoment';
		}
	
		var isElectron = window && window.process && window.process.type;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module && module.exports && (typeof require === 'function') && !isElectron) {
			module.exports = angularMoment(require('angular'), require('moment'));
		} else {
			angularMoment(angular, (typeof global !== 'undefined' ? global : window).moment);
		}
	})();


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index];
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.6.4/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var minErrConfig = {
	  objectMaxDepth: 5
	};
	
	 /**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-14+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) { /* empty */ }
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global toDebugString: true */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    obj = copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.6.4',
	  major: 1,
	  minor: 6,
	  dot: 4,
	  codeName: 'phenomenal-footnote'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$stringify': stringify
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.6.4' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (' ' + (element.getAttribute('class') || '') + ' ')
	          .replace(/[\n\t]/g, ' ')
	          .replace(' ' + trim(cssClass) + ' ', ' '))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key === this._lastKey) {
	      return this._lastIndex;
	    }
	    this._lastKey = key;
	    this._lastIndex = this._keys.indexOf(key);
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        // Support: Edge 12-13 only
	        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
	 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
	 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is false.
	   *
	   * @deprecated
	   * sinceVersion="1.6.0"
	   * removeVersion="1.7.0"
	   *
	   * This method and the option to assign the bindings before calling the controller's constructor
	   * will be removed in v1.7.0.
	   */
	  var preAssignBindingsEnabled = false;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (error instanceof Error) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (tag === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents',
	            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                'ng- versions (such as ng-click instead of onclick) instead.');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = undefined;
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, fnCamelCaseReplace);
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount();
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, key) {
	      if (/[&?][^=]+=JSON_CALLBACK/.test(url)) {
	        // Throw if the url already contains a reference to JSON_CALLBACK
	        throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	      }
	
	      var callbackParamRegex = new RegExp('[&?]' + key + '=');
	      if (callbackParamRegex.test(url)) {
	        // Throw if the callback param was already provided
	        throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', key, url);
	      }
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + key + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text);
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	      xhr.ontimeout = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        // Interval cancels should not report as unhandled promise.
	        intervals[promise.$$intervalId].promise.catch(noop);
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = trimEmptyHash($browser.url());
	        var newUrl = trimEmptyHash($location.absUrl());
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = oldUrl !== newUrl ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) { /* empty */ }
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	      if (property.computed) {
	        findConstantAndWatchExpressions(property.key, $filter);
	        if (!property.key.constant) {
	          argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	        }
	      }
	
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.ast.ast(text);
	    var fn = this.astCompiler.compile(ast);
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, oneTime, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.oneTime = true;
	              parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, parsedExpression.literal)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], parsedExpression.literal))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	      if (parsedExpression.inputs) {
	        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
	      } else {
	        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
	      }
	      return unwatch;
	
	      function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }
	      function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isDone(value)) {
	          scope.$$postDigest(function() {
	            if (isDone(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	
	      function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      }
	
	      function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDone(value) ? result : value;
	      }
	
	      var fn = parsedExpression.oneTime ? oneTimeInterceptedExpression : regularInterceptedExpression;
	
	      // Propogate the literal/oneTime attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	
	      // Propagate or create inputs / $$watchDelegates
	      useInputs = !parsedExpression.inputs;
	      if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = watchDelegate;
	        fn.inputs = parsedExpression.inputs;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 @ param {=boolean} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        state.pur = true;
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!toCheck.pur) {
	        toCheck.pur = true;
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (toCheck.value instanceof Error) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !state.pur) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it does not refer to a resource that loads code. Currently
	  // unused in AngularJS.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes any input, and either returns a value that's safe to use in the specified context, or
	     * throws an exception.
	     *
	     * In practice, there are several cases. When given a string, this function runs checks
	     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
	     * value if that value's context is valid for this call's context. Finally, this function can
	     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
	     * is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
	      // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
	      // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
	      // has no corresponding sinks.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        // RESOURCE_URL uses a whitelist.
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ## Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ## In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
	 * also use the `$sanitize` service if it is available when binding untrusted values to
	 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
	 *
	 *
	 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
	 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
	 * might evolve.
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes Angular accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        // Timeout cancels should not report an unhandled promise.
	        deferreds[promise.$$timeoutId].promise.catch(noop);
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services.Angular comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  $setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    this.$$parentForm.$setSubmitted();
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Sets the validity of a form control.
	 *
	 * This method will also propagate to parent forms.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for Angular:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, Angular will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options.getOption('timezone');
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal;
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	             isValidForStep(viewValue, minVal || 0, stepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      stepVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          // When using a one-time binding the newClassString will return
	          // the pre-interceptor value until the one-time is complete
	          if (!isString(newClassString)) {
	            newClassString = toClassString(newClassString);
	          }
	
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * Angular has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell Angular not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect Angular:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function MainController() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  try {
	                    eval('1+2'); // eslint-disable-line no-eval
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // NOTE:
	          // We expose the powerful `$event` object on the scope that provides access to the Window,
	          // etc. This is OK, because expressions are not sandboxed any more (and the expression
	          // sandbox was never meant to be a security feature anyway).
	          var fn = $parse(attr[directiveName]);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event: event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	
	  this.$$currentValidationRunId = 0;
	
	  // https://github.com/angular/angular.js/issues/15833
	  // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
	  Object.defineProperty(this, '$$scope', {value: $scope});
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName || 'parse';
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default'])) {
	      debounceDelay = debounceDelay['default'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$scope.$root.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	        // eslint-disable-next-line no-self-compare
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      ctrl.$$parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        // It is possible that model and view value have been updated during render
	        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by Angular when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options.getOption('updateOn')) {
	            element.on(modelCtrl.$options.getOption('updateOn'), function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /* @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an Angular expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div "ng-model-options"="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example name="ng-non-bindable">
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var selectedOption = options.selectValueMap[selectElement.val()];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.element.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	              selectCtrl.unselectEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	
	            if (providedEmptyOption) {
	              selectCtrl.selectEmptyOption();
	            } else if (selectCtrl.unknownOption.parent().length) {
	              selectCtrl.updateUnknownOption(value);
	            } else {
	              selectCtrl.renderUnknownOption(value);
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        selectCtrl.emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(selectCtrl.emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have a unique identifier property, you should track
	 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 *
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * Avoid using `track by $index` when the repeated template contains
	 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
	 * element will always be matched with the `nth` item of the array, so the bindings on that element
	 * will not be updated even when the corresponding item changes, essentially causing the view to get
	 * out-of-sync with the underlying data.
	 * </div>
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value); // needed for IE
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that te application developer can
	  // provide inside the select. When the model changes to a value that doesn't match an option,
	  // it is selected - so if an empty option is provided, no unknown option is generated.
	  // However, the empty option is not removed when the model matches an option. It is always selectable
	  // and indicates that a "null" selection has been made.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      self.emptyOption.removeAttr('selected');
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        self.selectEmptyOption();
	      } else if (self.unknownOption.parent().length) {
	        self.updateUnknownOption(value);
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal = NaN;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // IE and Edge, adding options to the selection via shift+click/UP/DOWN,
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if neccessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	(function(angular, analytics) {
	'use strict';
	
	var angulartics = window.angulartics || (window.angulartics = {});
	angulartics.waitForVendorCount = 0;
	angulartics.waitForVendorApi = function (objectName, delay, containsField, registerFn, onTimeout) {
	  if (!onTimeout) { angulartics.waitForVendorCount++; }
	  if (!registerFn) { registerFn = containsField; containsField = undefined; }
	  if (!Object.prototype.hasOwnProperty.call(window, objectName) || (containsField !== undefined && window[objectName][containsField] === undefined)) {
	    setTimeout(function () { angulartics.waitForVendorApi(objectName, delay, containsField, registerFn, true); }, delay);
	  }
	  else {
	    angulartics.waitForVendorCount--;
	    registerFn(window[objectName]);
	  }
	};
	
	/**
	 * @ngdoc overview
	 * @name angulartics
	 */
	angular.module('angulartics', [])
	.provider('$analytics', $analytics)
	.run(['$rootScope', '$window', '$analytics', '$injector', $analyticsRun])
	.directive('analyticsOn', ['$analytics', analyticsOn]);
	
	function $analytics() {
	  var settings = {
	    pageTracking: {
	      autoTrackFirstPage: true,
	      autoTrackVirtualPages: true,
	      trackRelativePath: false,
	      autoBasePath: false,
	      basePath: '',
	      excludedRoutes: []
	    },
	    eventTracking: {},
	    bufferFlushDelay: 1000, // Support only one configuration for buffer flush delay to simplify buffering
	    developerMode: false // Prevent sending data in local/development environment
	  };
	
	  // List of known handlers that plugins can register themselves for
	  var knownHandlers = [
	    'pageTrack',
	    'eventTrack',
	    'exceptionTrack',
	    'setAlias',
	    'setUsername',
	    'setUserProperties',
	    'setUserPropertiesOnce',
	    'setSuperProperties',
	    'setSuperPropertiesOnce',
	    'userTimings'
	  ];
	  // Cache and handler properties will match values in 'knownHandlers' as the buffering functons are installed.
	  var cache = {};
	  var handlers = {};
	
	  // General buffering handler
	  function bufferedHandler(handlerName){
	    return function(){
	      if(angulartics.waitForVendorCount){
	        if(!cache[handlerName]){ cache[handlerName] = []; }
	        cache[handlerName].push(arguments);
	      }
	    };
	  }
	
	  // As handlers are installed by plugins, they get pushed into a list and invoked in order.
	  function updateHandlers(handlerName, fn){
	    if(!handlers[handlerName]){
	      handlers[handlerName] = [];
	    }
	    handlers[handlerName].push(fn);
	    return function(){
	      var handlerArgs = arguments;
	      angular.forEach(handlers[handlerName], function(handler){
	        handler.apply(this, handlerArgs);
	      }, this);
	    };
	  }
	
	  // The api (returned by this provider) gets populated with handlers below.
	  var api = {
	    settings: settings
	  };
	
	  // Will run setTimeout if delay is > 0
	  // Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
	  // Plugins should take care to register handlers by order of precedence.
	  function onTimeout(fn, delay){
	    if(delay){
	      setTimeout(fn, delay);
	    } else {
	      fn();
	    }
	  }
	
	  var provider = {
	    $get: function() { return api; },
	    api: api,
	    settings: settings,
	    virtualPageviews: function (value) { this.settings.pageTracking.autoTrackVirtualPages = value; },
	    excludeRoutes: function(routes) { this.settings.pageTracking.excludedRoutes = routes; },
	    firstPageview: function (value) { this.settings.pageTracking.autoTrackFirstPage = value; },
	    withBase: function (value) {
	      this.settings.pageTracking.basePath = (value) ? angular.element(document).find('base').attr('href') : '';
	    },
	    withAutoBase: function (value) { this.settings.pageTracking.autoBasePath = value; },
	    developerMode: function(value) { this.settings.developerMode = value; }
	  };
	
	  // General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
	  function register(handlerName, fn){
	    api[handlerName] = updateHandlers(handlerName, fn);
	    var handlerSettings = settings[handlerName];
	    var handlerDelay = (handlerSettings) ? handlerSettings.bufferFlushDelay : null;
	    var delay = (handlerDelay !== null) ? handlerDelay : settings.bufferFlushDelay;
	    angular.forEach(cache[handlerName], function (args, index) {
	      onTimeout(function () { fn.apply(this, args); }, index * delay);
	    });
	  }
	
	  function capitalize(input) {
	      return input.replace(/^./, function (match) {
	          return match.toUpperCase();
	      });
	  }
	
	  // Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
	  function installHandlerRegisterFunction(handlerName){
	    var registerName = 'register'+capitalize(handlerName);
	    provider[registerName] = function(fn){
	      register(handlerName, fn);
	    };
	    api[handlerName] = updateHandlers(handlerName, bufferedHandler(handlerName));
	  }
	
	  // Set up register functions for each known handler
	  angular.forEach(knownHandlers, installHandlerRegisterFunction);
	  return provider;
	}
	
	function $analyticsRun($rootScope, $window, $analytics, $injector) {
	  function matchesExcludedRoute(url) {
	    for (var i = 0; i < $analytics.settings.pageTracking.excludedRoutes.length; i++) {
	      var excludedRoute = $analytics.settings.pageTracking.excludedRoutes[i];
	      if ((excludedRoute instanceof RegExp && excludedRoute.test(url)) || url.indexOf(excludedRoute) > -1) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function pageTrack(url, $location) {
	    if (!matchesExcludedRoute(url)) {
	      $analytics.pageTrack(url, $location);
	    }
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackFirstPage) {
	    $injector.invoke(['$location', function ($location) {
	      /* Only track the 'first page' if there are no routes or states on the page */
	      var noRoutesOrStates = true;
	      if ($injector.has('$route')) {
	         var $route = $injector.get('$route');
	         for (var route in $route.routes) {
	           noRoutesOrStates = false;
	           break;
	         }
	      } else if ($injector.has('$state')) {
	        var $state = $injector.get('$state');
	        for (var state in $state.get()) {
	          noRoutesOrStates = false;
	          break;
	        }
	      }
	      if (noRoutesOrStates) {
	        if ($analytics.settings.pageTracking.autoBasePath) {
	          $analytics.settings.pageTracking.basePath = $window.location.pathname;
	        }
	        if ($analytics.settings.pageTracking.trackRelativePath) {
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          pageTrack(url, $location);
	        } else {
	          pageTrack($location.absUrl(), $location);
	        }
	      }
	    }]);
	  }
	
	  if ($analytics.settings.pageTracking.autoTrackVirtualPages) {
	    $injector.invoke(['$location', function ($location) {
	      if ($analytics.settings.pageTracking.autoBasePath) {
	        /* Add the full route to the base. */
	        $analytics.settings.pageTracking.basePath = $window.location.pathname + "#";
	      }
	      var noRoutesOrStates = true;
	      if ($injector.has('$route')) {
	        var $route = $injector.get('$route');
	        for (var route in $route.routes) {
	          noRoutesOrStates = false;
	          break;
	        }
	        $rootScope.$on('$routeChangeSuccess', function (event, current) {
	          if (current && (current.$$route||current).redirectTo) return;
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          pageTrack(url, $location);
	        });
	      }
	      if ($injector.has('$state')) {
	        noRoutesOrStates = false;
	        $rootScope.$on('$stateChangeSuccess', function (event, current) {
	          var url = $analytics.settings.pageTracking.basePath + $location.url();
	          pageTrack(url, $location);
	        });
	      }
	      if (noRoutesOrStates) {
	        $rootScope.$on('$locationChangeSuccess', function (event, current) {
	          if (current && (current.$$route || current).redirectTo) return;
	          if ($analytics.settings.pageTracking.trackRelativePath) {
	            var url = $analytics.settings.pageTracking.basePath + $location.url();
	            pageTrack(url, $location);
	          } else {
	            pageTrack($location.absUrl(), $location);
	          }
	        });
	      }
	    }]);
	  }
	  if ($analytics.settings.developerMode) {
	    angular.forEach($analytics, function(attr, name) {
	      if (typeof attr === 'function') {
	        $analytics[name] = function(){};
	      }
	    });
	  }
	}
	
	function analyticsOn($analytics) {
	  return {
	    restrict: 'A',
	    link: function ($scope, $element, $attrs) {
	      var eventType = $attrs.analyticsOn || 'click';
	      var trackingData = {};
	
	      angular.forEach($attrs.$attr, function(attr, name) {
	        if (isProperty(name)) {
	          trackingData[propertyName(name)] = $attrs[name];
	          $attrs.$observe(name, function(value){
	            trackingData[propertyName(name)] = value;
	          });
	        }
	      });
	
	      angular.element($element[0]).bind(eventType, function ($event) {
	        var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
	        trackingData.eventType = $event.type;
	
	        if($attrs.analyticsIf){
	          if(! $scope.$eval($attrs.analyticsIf)){
	            return; // Cancel this event if we don't pass the analytics-if condition
	          }
	        }
	        // Allow components to pass through an expression that gets merged on to the event properties
	        // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
	        if($attrs.analyticsProperties){
	          angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
	        }
	        $analytics.eventTrack(eventName, trackingData);
	      });
	    }
	  };
	}
	
	function isCommand(element) {
	  return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
	    element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
	}
	
	function inferEventType(element) {
	  if (isCommand(element)) return 'click';
	  return 'click';
	}
	
	function inferEventName(element) {
	  if (isCommand(element)) return element.innerText || element.value;
	  return element.id || element.name || element.tagName;
	}
	
	function isProperty(name) {
	  return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
	}
	
	function propertyName(name) {
	  var s = name.slice(9); // slice off the 'analytics' prefix
	  if (typeof s !== 'undefined' && s!==null && s.length > 0) {
	    return s.substring(0, 1).toLowerCase() + s.substring(1);
	  }
	  else {
	    return s;
	  }
	}
	})(angular);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(40);
	module.exports = 'angulartics';


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./de": 14,
		"./de.js": 14,
		"./en-gb": 15,
		"./en-gb.js": 15,
		"./es": 16,
		"./es.js": 16,
		"./fr": 17,
		"./fr.js": 17,
		"./it": 18,
		"./it.js": 18,
		"./ja": 19,
		"./ja.js": 19,
		"./ko": 20,
		"./ko.js": 20,
		"./pt": 21,
		"./pt.js": 21,
		"./ru": 22,
		"./ru.js": 22,
		"./tr": 23,
		"./tr.js": 23,
		"./zh-cn": 24,
		"./zh-cn.js": 24
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 42;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(532);
	
	var _localeSelectDirective = __webpack_require__(347);
	
	var gzLocaleSelectDirective = _interopRequireWildcard(_localeSelectDirective);
	
	exports['default'] = angular.module('gazelle.components.localeSelect', ['rhino.components.locale', 'pascalprecht.translate']).directive(gzLocaleSelectDirective.name, gzLocaleSelectDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _spinnerDirective = __webpack_require__(369);
	
	var gzSpinnerDirective = _interopRequireWildcard(_spinnerDirective);
	
	exports['default'] = angular.module('gazelle.components.spinner', []).directive(gzSpinnerDirective.name, gzSpinnerDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcComponentsLocalStorageLocalStorageModule = __webpack_require__(69);
	
	var _rhinoSrcComponentsLocalStorageLocalStorageModule2 = _interopRequireDefault(_rhinoSrcComponentsLocalStorageLocalStorageModule);
	
	var _rhinoSrcComponentsSessionSessionModule = __webpack_require__(10);
	
	var _rhinoSrcComponentsSessionSessionModule2 = _interopRequireDefault(_rhinoSrcComponentsSessionSessionModule);
	
	var _localPrefsConstant = __webpack_require__(439);
	
	var rnLocalPreferences = _interopRequireWildcard(_localPrefsConstant);
	
	var _preferencesService = __webpack_require__(46);
	
	var rnPreferences = _interopRequireWildcard(_preferencesService);
	
	exports['default'] = angular.module('rhino.components.preferences', [_rhinoSrcComponentsSessionSessionModule2['default'], _rhinoSrcComponentsLocalStorageLocalStorageModule2['default']]).constant(rnLocalPreferences.name, rnLocalPreferences['default']).factory(rnPreferences.name, rnPreferences['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// Exported for testing
	'use strict';
	
	rnPreferences.$inject = ["$q", "$log", "rnHttp", "rnClient", "rnSession", "$rootScope", "rnLocalStorage", "$cacheFactory", "rnAUTH_EVENTS", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnPreferences;
	var DEFAULT_PREFERENCES = {
	  general: {
	    unitSystem: 'Metric'
	  }
	};
	
	exports.DEFAULT_PREFERENCES = DEFAULT_PREFERENCES;
	var LOCAL_STORAGE_KEY = 'pos.rn.preferences';
	
	exports.LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY;
	/**
	 * @ngdoc service
	 * @name rhino.components.preferences.service:rnPreferences
	 * @description Provides for managing the user's preferences
	 */
	
	/**
	 * @ngdoc event
	 * @name rnPreferencesUpdated
	 * @eventOf rhino.components.preferences.service:rnPreferences
	 * @description emitted on `$rootScope` when preferences are updated
	 */
	var EVENT_PREFERENCES_UPDATED = 'rnPreferencesUpdated';
	
	exports.EVENT_PREFERENCES_UPDATED = EVENT_PREFERENCES_UPDATED;
	var name = 'rnPreferences';
	exports.name = name;
	
	function rnPreferences($q, $log, rnHttp, rnClient, rnSession, $rootScope, rnLocalStorage, $cacheFactory, rnAUTH_EVENTS, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var PORTAL_SERVICE_NAME = 'portal_service';
	  var PORTAL_PREFERENCES_PATH = 'preferences';
	
	  var preferencesCache = $cacheFactory('rnPreferences');
	  var queue = [];
	
	  var service = {
	    getAll: getAll,
	    setAll: setAll,
	    getSingle: getSingle,
	    setSingle: setSingle,
	    getSingleObject: getSingleObject,
	    setSingleObject: setSingleObject,
	    getPrefObjectHelper: getPrefObjectHelper,
	    getChoices: getChoices,
	    deleteSingle: deleteSingle,
	    deleteAll: deleteAll
	  };
	
	  activate();
	  return service;
	
	  ////////////////
	
	  function activate() {
	    $rootScope.$on(rnAUTH_EVENTS.authenticated, invalidateCache);
	    $rootScope.$on(rnAUTH_EVENTS.notAuthenticated, invalidateCache);
	  }
	
	  function invalidateCache() {
	    preferencesCache.removeAll();
	  }
	
	  function synchronize(myfunction, param1, param2, param3) {
	    var deferred = $q.defer();
	    queue.push({ myFunction: myfunction, param1: param1, param2: param2, param3: param3, promise: deferred });
	    if (queue.length === 1) {
	      runQueueItem();
	    }
	    return deferred.promise;
	  }
	
	  function runQueueItem() {
	    queue[0].myFunction.call(this, queue[0].param1, queue[0].param2, queue[0].param3).then(function (resp) {
	      queue[0].promise.resolve(resp);
	      queue.shift();
	      if (queue.length > 0) {
	        runQueueItem();
	      }
	    })['catch'](function () {
	      queue[0].promise.reject();
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name getAll
	   * @methodOf rhino.components.preferences.service:rnPreferences
	   * @description Gets all preferences, falling back to default preferences on error or
	   * missing defaults.
	   *
	   * @returns {IPromise<preferences>} a promise containing the preferences
	   */
	  function getAll() {
	    var cache = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    return synchronize(_getAll, cache);
	  }
	
	  function _getAll() {
	    var cache = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    if (cache) {
	      var cachedPreferences = preferencesCache.get('currentPreferences');
	      if (cachedPreferences) {
	        return $q.resolve(cachedPreferences);
	      }
	    }
	    return rnSession.isAuthenticated().then(function (auth) {
	      if (auth) {
	        return rnClient.getConfig().then(function (clientConfig) {
	          var prefs = _.get(clientConfig, 'preferences.entity', undefined);
	          if (prefs === undefined) {
	            return $q.reject("Client config doesn't have preferences");
	          }
	          prefs = preferencesUpdated(prefs, true);
	          return prefs;
	        })['catch'](function () {
	          $log.debug('Unable to find general user preferences (they may have not been set yet).  Returning default preferences.');
	          // Invalidate the cache so that it tries again next time.
	          preferencesCache.removeAll();
	          return angular.merge({}, DEFAULT_PREFERENCES);
	        });
	      }
	
	      var prefs = rnLocalStorage.getObject(LOCAL_STORAGE_KEY);
	      if (!prefs) {
	        prefs = angular.merge({}, DEFAULT_PREFERENCES);
	      }
	      prefs = preferencesUpdated(prefs, true);
	      return prefs;
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name setAll
	   * @methodOf rhino.components.preferences.service:rnPreferences
	   * @description Sets all preferences and emits `rnPreferencesUpdated` on `$rootScope` if successfully updated.
	   *
	   * @param {object} preferences to set
	   * @returns {IPromise<object>} updated preferences
	   */
	  function setAll(preferences) {
	    return synchronize(_setAll, preferences);
	  }
	
	  function _setAll(preferences) {
	    return rnSession.isAuthenticated().then(function (auth) {
	      if (auth) {
	        return rnHttp.put(PORTAL_SERVICE_NAME, PORTAL_PREFERENCES_PATH, preferences).then(function (response) {
	          var updatedPrefs = preferencesUpdated(response.data);
	          return updatedPrefs;
	        });
	      } else {
	        var updatedPrefs = preferencesUpdated(preferences);
	        return updatedPrefs;
	      }
	    });
	  }
	
	  function setSingleObject(appId, name, obj) {
	    return setSingle(appId, name, JSON.stringify(obj));
	  }
	
	  function getSingleObject(appId, name) {
	    return getAll().then(function (prefs) {
	      var pref = _.get(prefs, [appId, name]);
	      if (pref) {
	        try {
	          return $window.JSON.parse(pref);
	        } catch (e) {
	          $log.warn('Failed to parse app "' + appId + '" preference "' + name + '"');
	        }
	      }
	    });
	  }
	
	  function getSingle(appId, name) {
	    return getAll().then(function (prefs) {
	      var pref = _.get(prefs, [appId, name]);
	      return pref;
	    });
	  }
	
	  function getPrefObjectHelper(prefs, appId, name) {
	    var obj = undefined;
	    if (prefs && prefs[appId] && prefs[appId][name]) {
	      obj = prefs[appId][name];
	      if (!(obj instanceof Object)) {
	        obj = JSON.parse(obj);
	      }
	    }
	    return obj;
	  }
	
	  /**
	   * @ngdoc function
	   * @name setSingle
	   * @methodOf rhino.components.preferences.service:rnPreferences
	   * @description Sets a single preference and emits `rnPreferencesUpdated` on `$rootScope` if successfully updated.
	   *
	   * @param {string} appId id of the application containing the preference ('general' for general preferences)
	   * @param {string} name preference name
	   * @param {value} value preference value
	   * @returns {IPromise<object>} complete set of updated preferences
	   */
	  function setSingle(appId, name, value) {
	    return synchronize(_setSingle, appId, name, value);
	  }
	
	  function _setSingle(appId, name, value) {
	    var prefsPatch = _.set({}, [appId, name], value);
	
	    var deferred = $q.defer();
	    rnSession.isAuthenticated().then(function (auth) {
	      if (auth) {
	        rnHttp.patch(PORTAL_SERVICE_NAME, PORTAL_PREFERENCES_PATH, prefsPatch).then(function (response) {
	          var updatedPrefs = preferencesUpdated(response.data);
	          deferred.resolve(updatedPrefs);
	        });
	      } else {
	        var localStoragePrefs = rnLocalStorage.getObject(LOCAL_STORAGE_KEY) || {};
	        angular.merge(localStoragePrefs, prefsPatch);
	        var updatedPrefs = preferencesUpdated(localStoragePrefs);
	        deferred.resolve(updatedPrefs);
	      }
	    });
	    return deferred.promise;
	  }
	
	  function deleteSingle(appId, name) {
	    return synchronize(_deleteSingle, appId, name);
	  }
	
	  function _deleteSingle(appId, name) {
	    return rnSession.isAuthenticated().then(function (auth) {
	      if (auth) {
	        var path = 'preferences/';
	        path += appId.indexOf('.') >= 0 ? '["' + appId + '"]' : appId;
	        path += name.indexOf('.') >= 0 ? '["' + name + '"]' : '.' + name;
	
	        return rnHttp['delete']('portal_service', encodeURI(path), { version: 2, headers: { 'Content-Type': 'application/json' } }).then(function (resp) {
	          return preferencesUpdated(resp.data);
	        });
	      }
	    });
	  }
	
	  function deleteAll() {
	    return synchronize(_deleteAll);
	  }
	
	  function _deleteAll() {
	    return rnSession.isAuthenticated().then(function (auth) {
	      if (auth) {
	        return rnHttp['delete']('portal_service', 'preferences', { version: 2 }).then(function (resp) {
	          return preferencesUpdated(resp.data);
	        });
	      }
	    });
	  }
	
	  function preferencesUpdated(preferences, suppressEvent) {
	    // Update local storage for when unauthenticated
	    rnLocalStorage.setObject(LOCAL_STORAGE_KEY, preferences);
	
	    var prefs = angular.merge({}, DEFAULT_PREFERENCES, preferences);
	    preferencesCache.put('currentPreferences', prefs);
	    if (!suppressEvent) {
	      $rootScope.$emit(EVENT_PREFERENCES_UPDATED, prefs);
	    }
	    return prefs;
	  }
	
	  function getChoices(appId, preferenceName) {
	    var config = {
	      cache: true,
	      params: {
	        appId: appId,
	        name: preferenceName
	      }
	    };
	
	    return rnHttp.get(PORTAL_SERVICE_NAME, 'preferences/choices', config).then(function (response) {
	      return response.data;
	    });
	  }
	}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(515);
	
	var _appNavDirective = __webpack_require__(287);
	
	var gzAppNavDirective = _interopRequireWildcard(_appNavDirective);
	
	var _appNavService = __webpack_require__(288);
	
	var gzAppNavService = _interopRequireWildcard(_appNavService);
	
	exports['default'] = angular.module('gz.appNav', ['ui.router', 'ct.ui.router.extras.future', 'gazelle.components.go']).directive(gzAppNavDirective.name, gzAppNavDirective['default']).factory(gzAppNavService.name, gzAppNavService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(516);
	
	var _bodyWrapDirective = __webpack_require__(291);
	
	var gzBodyWrapDirective = _interopRequireWildcard(_bodyWrapDirective);
	
	exports['default'] = angular.module('gazelle.components.bodyWrap', []).directive(gzBodyWrapDirective.name, gzBodyWrapDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(517);
	
	var _carouselDirective = __webpack_require__(294);
	
	var gzCarouselDirective = _interopRequireWildcard(_carouselDirective);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	exports['default'] = angular.module('gazelle.components.carousel', [_angularTranslate2['default'], _gazelleSrcCoreAnalyticsAnalyticsModule2['default']]).directive(gzCarouselDirective.name, gzCarouselDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(522);
	
	var _errorBarDirective = __webpack_require__(310);
	
	var gzErrorBar = _interopRequireWildcard(_errorBarDirective);
	
	exports['default'] = angular.module('gazelle.components.errorBar', []).directive(gzErrorBar.name, gzErrorBar['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _errorService = __webpack_require__(311);
	
	var gzErrorService = _interopRequireWildcard(_errorService);
	
	exports['default'] = angular.module('gazelle.components.error', ['pascalprecht.translate', 'ngMaterial']).service(gzErrorService.name, gzErrorService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _fieldsService = __webpack_require__(314);
	
	var $gzFields = _interopRequireWildcard(_fieldsService);
	
	exports['default'] = angular.module('gazelle.components.fields', ['pascalprecht.translate', 'angularMoment', 'ngSanitize']).service($gzFields.name, $gzFields['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _quickFilterFilter = __webpack_require__(319);
	
	var gzQuickFilter = _interopRequireWildcard(_quickFilterFilter);
	
	exports['default'] = angular.module('gazelle.components.filterBox.quickFilter', []).filter(gzQuickFilter.name, gzQuickFilter['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(527);
	
	var _formContentDirective = __webpack_require__(324);
	
	var gzFormContent = _interopRequireWildcard(_formContentDirective);
	
	exports['default'] = angular.module('gazelle.components.formContent', []).directive(gzFormContent.name, gzFormContent['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _goService = __webpack_require__(327);
	
	var gzGo = _interopRequireWildcard(_goService);
	
	exports['default'] = angular.module('gazelle.components.go', ['ui.router', 'rhino.core.http', 'rhino.components.application', 'rhino.components.sessionStorage', 'gazelle.components.appBroker', 'gazelle.components.l10n']).service(gzGo.name, gzGo['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _iconDirective = __webpack_require__(336);
	
	var gzIconDirective = _interopRequireWildcard(_iconDirective);
	
	exports['default'] = angular.module('gazelle.components.icon', []).directive(gzIconDirective.name, gzIconDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _outerContainerDirective = __webpack_require__(355);
	
	var gzOuterContainerDirective = _interopRequireWildcard(_outerContainerDirective);
	
	exports['default'] = angular.module('gazelle.components.outerContainer', []).directive(gzOuterContainerDirective.name, gzOuterContainerDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(534);
	
	var _pageHeaderDirective = __webpack_require__(356);
	
	var gzPageHeaderDirective = _interopRequireWildcard(_pageHeaderDirective);
	
	var _gazelleSrcCoreCoreModule = __webpack_require__(30);
	
	var _gazelleSrcCoreCoreModule2 = _interopRequireDefault(_gazelleSrcCoreCoreModule);
	
	exports['default'] = angular.module('gazelle.components.pageHeader', ['ngMaterial', 'gazelle.components.go', _gazelleSrcCoreCoreModule2['default']]).directive(gzPageHeaderDirective.name, gzPageHeaderDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _bkImgDirective = __webpack_require__(361);
	
	var gzBkImg = _interopRequireWildcard(_bkImgDirective);
	
	exports['default'] = angular.module('gazelle.components.printosImages.bkImg', ['rhino.core']).directive(gzBkImg.name, gzBkImg['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _imgSrcDirective = __webpack_require__(362);
	
	var gzImgSrc = _interopRequireWildcard(_imgSrcDirective);
	
	exports['default'] = angular.module('gazelle.components.printosImages.imgSrc', ['rhino.core']).directive(gzImgSrc.name, gzImgSrc['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	'use strict';
	
	EulaController.$inject = ["$mdDialog", "rnHttp", "rnLocale", "requireAccept", "isChanged"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = EulaController;
	var name = 'EulaController';
	exports.name = name;
	var EULA_VERSION_HEADER = 'EULA-Version';
	exports.EULA_VERSION_HEADER = EULA_VERSION_HEADER;
	var EULA_CURRENT_VERSION_HEADER = 'EULA-Current-Version';
	exports.EULA_CURRENT_VERSION_HEADER = EULA_CURRENT_VERSION_HEADER;
	var EULA_FUTURE_VERSION_HEADER = 'EULA-Future-Version';
	exports.EULA_FUTURE_VERSION_HEADER = EULA_FUTURE_VERSION_HEADER;
	var PRIVACY_VERSION_HEADER = 'PRIVACY-Version';
	exports.PRIVACY_VERSION_HEADER = PRIVACY_VERSION_HEADER;
	
	function EulaController($mdDialog, rnHttp, rnLocale, requireAccept, isChanged) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var eulaVersion = undefined;
	
	  var vm = this;
	
	  vm.close = close;
	  vm.accept = accept;
	  vm.eulaText = null;
	  vm.requireAccept = requireAccept;
	  vm.isChanged = isChanged;
	  vm.loading = true;
	
	  activate();
	
	  ///////////////////////
	
	  function activate() {
	    rnLocale.getBestFit().then(function (locale) {
	      getEULA(locale).then(function (response) {
	        vm.eulaText = response.data;
	        eulaVersion = response.headers(EULA_VERSION_HEADER);
	      })['catch'](function (response) {
	        vm.eulaText = response;
	      })['finally'](function () {
	        vm.loading = false;
	      });
	    });
	  }
	
	  function close() {
	    $mdDialog.cancel();
	  }
	
	  function accept() {
	    $mdDialog.hide({
	      eulaVersion: eulaVersion
	    });
	  }
	
	  function getEULA(locale) {
	    var config = {
	      headers: {
	        accept: 'text/html'
	      }
	    };
	    return rnHttp.get('portal_service', '/i18n/eula/' + locale.shortName, config);
	  }
	}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc event
	 * @name $gzViewWidthChanged
	 * @eventOf gazelle.components.view-container.directive:gzViewContainer
	 * @description emitted on `$rootScope` when the view containers width as been impacted
	 *   by the app nav or mini-apps opening or closing.
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzViewContainer;
	var VIEW_WIDTH_CHANGED_EVENT = '$gzViewWidthChanged';
	exports.VIEW_WIDTH_CHANGED_EVENT = VIEW_WIDTH_CHANGED_EVENT;
	var name = 'gzViewContainer';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.view-container.directive:gzViewContainer
	 *
	 * @description
	 * `<gz-view-container>` is a frame component that is responsible for rendering the application view.
	 * It is included as part of `<gz-body-wrap>`.
	 */
	
	function gzViewContainer() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    transclude: true,
	    template: '<ng-transclude></ng-transclude>',
	    link: gzViewContainerLink
	  };
	
	  return directive;
	
	  /////////////////
	  // private functions
	
	  function gzViewContainerLink(scope, element, attrs) {
	    // $log.debug('found a gz-view-container!');
	  }
	}
	
	//gzViewContainer

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(539);
	
	var _viewContainerDirective = __webpack_require__(62);
	
	var gzViewContainerDirective = _interopRequireWildcard(_viewContainerDirective);
	
	exports['default'] = angular.module('gazelle.components.viewContainer', []).directive(gzViewContainerDirective.name, gzViewContainerDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module for linking blue behavior into gazelle.
	 */
	'use strict';
	
	disableMaterialClickHijacking.$inject = ["$mdGestureProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _setBluePageRun = __webpack_require__(395);
	
	var _setBluePageRun2 = _interopRequireDefault(_setBluePageRun);
	
	exports['default'] = angular.module('gazelle.core.blue', ['ngMaterial']).config(disableMaterialClickHijacking).run(_setBluePageRun2['default']).name;
	
	function disableMaterialClickHijacking($mdGestureProvider) {
	  'ngInject';
	
	  $mdGestureProvider.skipClickHijack();
	}
	module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _applicationService = __webpack_require__(417);
	
	var rnApplication = _interopRequireWildcard(_applicationService);
	
	var _applicationViewService = __webpack_require__(416);
	
	var rnApplicationView = _interopRequireWildcard(_applicationViewService);
	
	exports['default'] = angular.module('rhino.components.application', [_rhinoSrcCoreCoreModule2['default'], 'rhino.components.locale']).service(rnApplication.name, rnApplication['default']).service(rnApplicationView.name, rnApplicationView['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';
	
	rnDeviceDetector.$inject = ["rnHttp"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnDeviceDetector;
	var name = 'rnDeviceDetector';
	
	exports.name = name;
	var UI_STATE = {
	  activated: 'activated',
	  added: 'added',
	  addAvailable: 'addAvailable',
	  addUnavailable: 'addUnavailable'
	};
	
	exports.UI_STATE = UI_STATE;
	var AAA_DEVICE_PROVISIONED_STATE = {
	  unknownState: 5001,
	  unmappedModel: 5002,
	  duplicateModel: 5003,
	  loggedIn: 5004,
	  unreleasedModel: 5005,
	  existsInOtherOrg: 5006,
	  autoProvisionableNONE: 5007,
	  autoProvisionableMANUAL: 5008,
	  autoProvisionableAUTO: 5009
	};
	
	exports.AAA_DEVICE_PROVISIONED_STATE = AAA_DEVICE_PROVISIONED_STATE;
	/**
	 * @ngdoc service
	 * @name rhino.components.device.service:rnDeviceAutoProvision
	 *
	 * @description Rhino device auto provision service, providing the state for devices that can be detected by PrintOS.
	 */
	
	function rnDeviceDetector(rnHttp) {
	
	  'ngInject';
	  var thisService = {
	    getDevices: getDevices,
	    getDevicesToAdd: getDevicesToAdd,
	    getDevicesToActivate: getDevicesToActivate,
	    getCanActivateDevices: getCanActivateDevices
	  };
	  return thisService;
	
	  /**
	   * @ngdoc function
	   * @name getDevices
	   * @name rhino.components.device.service:rnDeviceAutoProvision
	   * @description Returns an array of objects with detected device information
	   * @returns {Promise.<Array<Object>>} detected device information
	   */
	  function getDevices() {
	    return rnHttp.get('aaa', 'organizations/devices/provisionedstate').then(function (resp) {
	      return resp.data.map(function (deviceState) {
	        deviceState.uiState = getUiState(deviceState);
	        deviceState.canActivate = getCanActivate(deviceState);
	        return deviceState;
	      });
	    });
	  }
	
	  function getUiState(deviceState) {
	    if (deviceState.state === AAA_DEVICE_PROVISIONED_STATE.loggedIn) {
	      return UI_STATE.activated;
	    }
	
	    if (deviceState.deviceId) {
	      return UI_STATE.added;
	    }
	
	    if (deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableNONE || deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableMANUAL || deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableAUTO || deviceState.state === AAA_DEVICE_PROVISIONED_STATE.duplicateModel) {
	      return UI_STATE.addAvailable;
	    }
	
	    return UI_STATE.addUnavailable;
	  }
	
	  function getCanActivate(deviceState) {
	    return deviceState.state === AAA_DEVICE_PROVISIONED_STATE.loggedIn || deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableMANUAL || deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableAUTO;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getDevicesToAdd
	   * @name rhino.components.device.service:rnDeviceAutoProvision
	   * @description Returns an array of objects that can be added manually be the user
	   *  and can't be activated, which would cause the device to be automatically added
	   * @returns {Promise.<Array<Object>>} array of objects that can be added
	   */
	  function getDevicesToAdd() {
	    return getDevices().then(function (devices) {
	      return devices.filter(function (device) {
	        return device.uiState === UI_STATE.addAvailable && !device.canActivate && device.model;
	      });
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name getDevicesToAdd
	   * @name rhino.components.device.service:rnDeviceAutoProvision
	   * @description Returns an array of objects that can be activated by the user
	   *  and are not activated already
	   * @returns {Promise.<Array<Object>>} array of objects that can be activated and have not been
	   */
	  function getDevicesToActivate() {
	    return getDevices().then(function (devices) {
	      return devices.filter(function (device) {
	        return device.uiState !== UI_STATE.activated && device.canActivate;
	      });
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name getCanActivateDevices
	   * @name rhino.components.device.service:rnDeviceAutoProvision
	   * @description Returns an array of objects that can be activated or are already activated
	   * @returns {Promise.<Array<Object>>} array of devices that can be activated
	   */
	  function getCanActivateDevices() {
	    return getDevices().then(function (devices) {
	      return devices.filter(function (device) {
	        return device.canActivate;
	      });
	    });
	  }
	}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _featureService = __webpack_require__(424);
	
	var rnFeatureService = _interopRequireWildcard(_featureService);
	
	exports['default'] = angular.module('rhino.components.feature', [_rhinoSrcCoreCoreModule2['default']]).service(rnFeatureService.name, rnFeatureService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcComponentsSessionSessionModule = __webpack_require__(10);
	
	var _rhinoSrcComponentsSessionSessionModule2 = _interopRequireDefault(_rhinoSrcComponentsSessionSessionModule);
	
	var _invitationService = __webpack_require__(425);
	
	var rnInvitation = _interopRequireWildcard(_invitationService);
	
	exports['default'] = angular.module('rhino.components.invitation', [_rhinoSrcComponentsSessionSessionModule2['default']]).factory(rnInvitation.name, rnInvitation['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _localStorageService = __webpack_require__(428);
	
	var rnLocalStorage = _interopRequireWildcard(_localStorageService);
	
	exports['default'] = angular.module('rhino.components.localStorage', []).service(rnLocalStorage.name, rnLocalStorage['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _formatService = __webpack_require__(430);
	
	var rnFormat = _interopRequireWildcard(_formatService);
	
	var _localeFormatFilter = __webpack_require__(431);
	
	var rnLocaleFormat = _interopRequireWildcard(_localeFormatFilter);
	
	var _localeOrderByFilter = __webpack_require__(432);
	
	var rnLocaleOrderBy = _interopRequireWildcard(_localeOrderByFilter);
	
	var _abbrFilter = __webpack_require__(429);
	
	var rnAbbr = _interopRequireWildcard(_abbrFilter);
	
	exports['default'] = angular.module('rhino.components.locale.format', []).factory(rnFormat.name, rnFormat['default']).filter(rnLocaleFormat.name, rnLocaleFormat['default']).filter(rnLocaleOrderBy.name, rnLocaleOrderBy['default']).filter(rnAbbr.name, rnAbbr['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _pusherService = __webpack_require__(442);
	
	var rnPusher = _interopRequireWildcard(_pusherService);
	
	exports['default'] = angular.module('rhino.components.pusher', [_rhinoSrcCoreCoreModule2['default']]).factory(rnPusher.name, rnPusher['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _startServiceJs = __webpack_require__(450);
	
	var rnStart = _interopRequireWildcard(_startServiceJs);
	
	var _rhinoSrcComponentsDeviceDeviceModule = __webpack_require__(31);
	
	var _rhinoSrcComponentsDeviceDeviceModule2 = _interopRequireDefault(_rhinoSrcComponentsDeviceDeviceModule);
	
	var _rhinoSrcCoreClientClientModule = __webpack_require__(26);
	
	var _rhinoSrcCoreClientClientModule2 = _interopRequireDefault(_rhinoSrcCoreClientClientModule);
	
	var _rhinoSrcCoreHttpHttpModule = __webpack_require__(11);
	
	var _rhinoSrcCoreHttpHttpModule2 = _interopRequireDefault(_rhinoSrcCoreHttpHttpModule);
	
	var _rhinoSrcComponentsInvitationInvitationModule = __webpack_require__(68);
	
	var _rhinoSrcComponentsInvitationInvitationModule2 = _interopRequireDefault(_rhinoSrcComponentsInvitationInvitationModule);
	
	var _rhinoSrcComponentsPreferencesPreferencesModule = __webpack_require__(45);
	
	var _rhinoSrcComponentsPreferencesPreferencesModule2 = _interopRequireDefault(_rhinoSrcComponentsPreferencesPreferencesModule);
	
	var _rhinoSrcComponentsDeviceDeviceModule3 = _interopRequireDefault(_rhinoSrcComponentsDeviceDeviceModule);
	
	exports['default'] = angular.module('rhino.components.start', [_rhinoSrcComponentsDeviceDeviceModule2['default'], _rhinoSrcCoreClientClientModule2['default'], _rhinoSrcCoreHttpHttpModule2['default'], _rhinoSrcComponentsInvitationInvitationModule2['default'], _rhinoSrcComponentsPreferencesPreferencesModule2['default'], _rhinoSrcComponentsDeviceDeviceModule3['default']]).factory(rnStart.name, rnStart['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	authInterceptor.$inject = ["$httpProvider"];
	runAuth.$inject = ["rnAuthService"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreHttpHttpModule = __webpack_require__(11);
	
	var _rhinoSrcCoreHttpHttpModule2 = _interopRequireDefault(_rhinoSrcCoreHttpHttpModule);
	
	var _rhinoSrcCoreClientClientModule = __webpack_require__(26);
	
	var _rhinoSrcCoreClientClientModule2 = _interopRequireDefault(_rhinoSrcCoreClientClientModule);
	
	var _authEventsConstants = __webpack_require__(457);
	
	var rnAuthEvents = _interopRequireWildcard(_authEventsConstants);
	
	var _authInterceptor = __webpack_require__(458);
	
	var rnAuthInterceptor = _interopRequireWildcard(_authInterceptor);
	
	var _authService = __webpack_require__(459);
	
	var rnAuthService = _interopRequireWildcard(_authService);
	
	var _sessionSingleton = __webpack_require__(460);
	
	var rnSingSession = _interopRequireWildcard(_sessionSingleton);
	
	exports['default'] = angular.module('rhino.core.auth', [_rhinoSrcCoreHttpHttpModule2['default'], _rhinoSrcCoreClientClientModule2['default']]).config(authInterceptor).constant(rnAuthEvents.name, rnAuthEvents['default']).service(rnAuthInterceptor.name, rnAuthInterceptor['default']).service(rnAuthService.name, rnAuthService['default']).service(rnSingSession.name, rnSingSession['default']).run(runAuth).name;
	
	function authInterceptor($httpProvider) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	  $httpProvider.interceptors.push(rnAuthInterceptor.name);
	}
	
	function runAuth(rnAuthService) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // Don't include this while testing because of problems with extra $http calls
	  /* global __TEST__ */
	  if (true) {
	    rnAuthService.validate()['catch'](function () {
	      // no-op - it's ok if we fail validation here. Squelching angular 1.6 unhandled promise rejection.
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var DEBUG_ENABLED_CONST_NAME = 'rnDebugEnabled';
	
	/**
	 * @ngdoc overview
	 * @name rhino.core.debug
	 * @description Provides the angular constant `rnDebugEnabled` for runtime debugging.  It is enabled for developer builds when the webpack `__DEV__` macro is `true`.
	 * It can also be enabled on production builds by input the following on the JavaScript console and reloading the page,
	 * ```javascript
	 * localStorage.rnDebugEnabled = true
	 * ```
	 * The intended use is mainly for `$logProvider.debugEnabled(rnDebugEnabled);` and `$compileProvider.debugInfoEnabled(rnDebugEnabled);`.
	 *
	 * **Note:** `rnDebugEnabled` is not intended as a drop-in replacement for `__DEV__` because `__DEV__` is evaluated at build time and can lead to less generated code during minification when set to `false`.
	 */
	exports['default'] = angular.module('rhino.core.debug', []).constant(DEBUG_ENABLED_CONST_NAME, getRnDebugEnabled()).name;
	
	function getRnDebugEnabled() {
	  // Developers can set this flag on the javascript console with this command,
	  //   localStorage.rnDebugEnabled = true
	  // and then reload the page to have this constant set to true.
	  // It can then be used in $logProvider.debugEnabled(rnDebugEnabled);
	  var localStorage = window.localStorage;
	  var rnDebugEnabled = !!localStorage[DEBUG_ENABLED_CONST_NAME];
	
	  // Debug is also enabled if the dev macro is set
	  return (false) || rnDebugEnabled;
	}
	module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreHttpHttpModule = __webpack_require__(11);
	
	var _rhinoSrcCoreHttpHttpModule2 = _interopRequireDefault(_rhinoSrcCoreHttpHttpModule);
	
	var _recordFactory = __webpack_require__(469);
	
	var rnRecordFactory = _interopRequireWildcard(_recordFactory);
	
	var _recordCollectionFactory = __webpack_require__(470);
	
	var rnRecordCollectionFactory = _interopRequireWildcard(_recordCollectionFactory);
	
	exports['default'] = angular.module('rhino.core.record', [_rhinoSrcCoreHttpHttpModule2['default']]).factory(rnRecordFactory.name, rnRecordFactory['default']).factory(rnRecordCollectionFactory.name, rnRecordCollectionFactory['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict';
	
	HpIdSignInController.$inject = ["$stateParams", "$state", "$gzHpId", "$translate", "$location", "$window", "$gzEULA", "$q", "rnAuthService", "rnInvitation", "$gzAnalytics"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = HpIdSignInController;
	var name = 'HpIdSignInController';
	exports.name = name;
	
	function HpIdSignInController($stateParams, $state, $gzHpId, $translate, $location, $window, $gzEULA, $q, rnAuthService, rnInvitation, $gzAnalytics) {
	  'ngInject';
	
	  var state = undefined;
	  var invitationId = undefined;
	  var eulaVersion = undefined;
	  var bu = undefined;
	
	  var vm = _.assign(this, {
	    loading: true,
	    signin: signin,
	    createAccount: createAccount,
	    goBack: goBack
	  });
	
	  vm.unitTest = {
	    handleError: handleError
	  };
	
	  activate();
	
	  /////////////////
	
	  function activate() {
	    parseParams();
	
	    if (!invitationId) {
	      // TODO: no invitation data to go back to. Report an error in GA.
	      // and display an error to the user.
	      // This could happen if the user reloads this screen.
	      vm.errorKey = 'register.register.Accept_Error_UnknownInvitation';
	    }
	
	    // Sign out requested to ensure a clean state.
	    if ($stateParams.signout) {
	      return signout();
	    }
	
	    isAuthenticated().then(function () {
	      // Signed in with HP ID or PrintOS. We can now go back to accept the invitation.
	      return $state.go(state, {
	        invitationId: invitationId,
	        hpidId: $stateParams.hpidId,
	        bu: bu,
	        data: {
	          postAuthentication: true
	        }
	      });
	    })['catch'](function () {
	      if ($stateParams.statusCode) {
	        var statusCode = $window.parseInt($stateParams.statusCode);
	        var subCode = $window.parseInt($stateParams.subCode);
	        handleError(statusCode, subCode);
	      }
	
	      // (This is not in a `finally` block because we don't want to show
	      //  this page at all when redirecting to accept the invite.)
	      vm.loading = false;
	    });
	  }
	
	  function parseParams() {
	    state = getState();
	    vm.title = getTitle(state);
	    invitationId = getInvitationId();
	    bu = getBu();
	  }
	
	  function getState() {
	    return $stateParams.state ? $stateParams.state : _.get($stateParams, 'data.state', null);
	  }
	
	  function getInvitationId() {
	    return $stateParams.invitationId ? $stateParams.invitationId : _.get($stateParams, 'data.invitationId', null);
	  }
	
	  function getBu() {
	    return $stateParams.bu ? $stateParams.bu : undefined;
	  }
	  /**
	   * Returns a promise that is resolve if the user is authenticated
	   * with HP ID or PrintOS and rejected otherwise.
	   */
	  function isAuthenticated() {
	    if ($stateParams.hpidId) {
	      return $q.resolve();
	    }
	
	    return rnAuthService.validate();
	  }
	
	  function getTitle(state) {
	    var locKey = undefined;
	    switch (state) {
	      case 'acceptAccount':
	        locKey = 'HpAccount';
	        break;
	      case 'acceptUser':
	        locKey = 'AcceptUser';
	        break;
	      default:
	        locKey = 'Accept_Invitation';
	    }
	    return $translate.instant('register.register.' + locKey);
	  }
	
	  function goBack() {
	    return $state.go('signin', { bu: bu });
	  }
	
	  function signin() {
	    $gzAnalytics.eventClick('HP ID existing account');
	    return hpidRedirect('invite');
	  }
	
	  function createAccount() {
	    $gzAnalytics.eventClick('HP ID create account');
	    return rnInvitation.getById(invitationId).then(function (invitation) {
	      vm.invitation = invitation;
	      return hpidRedirect('invite', true);
	    });
	  }
	
	  function signout() {
	    return hpidRedirect('logout');
	  }
	
	  function hpidRedirect(type) {
	    var createAccount = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    vm.submitting = true;
	    var targetUrl = $gzHpId.createTargetUrl($state.current.name, {
	      state: state,
	      invitationId: invitationId,
	      bu: bu
	    });
	
	    var data = createDataObject(createAccount);
	
	    return $gzHpId.redirect(type, targetUrl, data, createAccount)['catch'](function () {
	      vm.submitting = false;
	      vm.errorKey = 'register.register.SignIn_Error_HPID_RedirectFailed';
	    });
	  }
	
	  function createDataObject(createAccount) {
	    var data = {
	      eulaVersion: eulaVersion
	    };
	
	    if (vm.invitation) {
	      if (vm.invitation.email) {
	        data.email = vm.invitation.email;
	      }
	      if (vm.invitation.firstName) {
	        data.firstName = vm.invitation.firstName;
	      }
	      if (vm.invitation.lastName) {
	        data.lastName = vm.invitation.lastName;
	      }
	    }
	
	    return data;
	  }
	
	  // TODO: code cleanup. This was copied from the main sign-in controller.
	  function handleError(statusCode, subCode) {
	    switch (statusCode) {
	      case 401:
	        switch (subCode) {
	          case 1000:
	            // Need to accept EULA
	            $gzEULA.show(true, null, true).then(function (result) {
	              vm.submitting = true;
	              eulaVersion = result.eulaVersion;
	              hpidRedirect('login');
	            })['catch'](function () {
	              vm.errorKey = 'register.register.SignIn_Error_EulaNotAccepted';
	            });
	            break;
	          case 1003:
	            // Account is locked
	            vm.errorKey = 'register.register.SignIn_Error_AccountLocked';
	            break;
	          case 1016:
	            // Need to accept NEW EULA
	            $gzEULA.show(true, null, true, true).then(function (result) {
	              vm.submitting = true;
	              vm.signInData.eulaVersion = result.eulaVersion;
	              hpidRedirect('login');
	            })['catch'](function (result) {
	              vm.submitting = true;
	              $state.go('signin', { signout: true, bu: bu });
	            });
	            break;
	          default:
	            // Unmapped 401 Error
	            vm.errorKey = 'register.register.SignIn_Error_Unknown';
	            break;
	        }
	        break;
	      default:
	        // Unknown Error
	        vm.errorKey = 'register.register.SignIn_Error_Unknown';
	        break;
	    }
	  }
	}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _detectAutoFillDirective = __webpack_require__(495);
	
	var detectAutoFill = _interopRequireWildcard(_detectAutoFillDirective);
	
	exports['default'] = angular.module('register.components.detectautofill', []).directive(detectAutoFill.name, detectAutoFill['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	'use strict';
	
	registerService.$inject = ["$mdMedia"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = registerService;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IMAGE_FAMILY = {
	  general: 'general',
	  ThreeD: 'ThreeD'
	};
	
	exports.IMAGE_FAMILY = IMAGE_FAMILY;
	var name = 'registerService';
	exports.name = name;
	
	function registerService($mdMedia) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var _imagePositions;
	
	  var imageUrlBase = 'https://cdn.printos.com/images/signin';
	  var imageSizes = {
	    large: '1920x1080',
	    medium: '1280x1024'
	  };
	  // List of images to use and how to position them for proper emphasis with smaller widths.
	  var imagePositions = (_imagePositions = {}, _defineProperty(_imagePositions, IMAGE_FAMILY.general, {
	    '1.jpg': 'center',
	    '4.jpg': '30% center',
	    '6.jpg': '35% center',
	    '8.jpg': '10% center',
	    '9.jpg': 'center',
	    '10.jpg': '60% center',
	    '13.jpg': '35% center',
	    '14.jpg': 'center',
	    '15.jpg': 'center',
	    '16.jpg': 'center',
	    '18.jpg': '75% center',
	    '19.jpg': '70% center',
	    '20.jpg': '30% center',
	    '25.jpg': 'center',
	    '27.jpg': '60% center',
	    '29.jpg': '0 center',
	    '31.jpg': 'center',
	    '32.jpg': 'center',
	    '33.jpg': 'center',
	    '34.jpg': 'center',
	    '35.jpg': 'center',
	    '36.jpg': '15% center',
	    '37.jpg': '30% center',
	    '38.jpg': 'center',
	    '39.jpg': 'center',
	    '40.jpg': 'center',
	    '41.jpg': 'center',
	    '42.jpg': 'center',
	    '43.jpg': 'center',
	    '44.jpg': '65% center',
	    '45.jpg': 'center',
	    '46.jpg': 'center',
	    '47.jpg': 'center',
	    '48.jpg': '80% center',
	    '49.jpg': '10% center',
	    '50.jpg': 'center',
	    '51.jpg': '25% center',
	    '52.jpg': 'center',
	    '53.jpg': '30% center',
	    '54.jpg': 'center',
	    '55.jpg': 'center'
	  }), _defineProperty(_imagePositions, IMAGE_FAMILY.ThreeD, {
	    '68.jpg': '15% center'
	  }), _imagePositions);
	
	  var selectedImages = {};
	
	  var service = {
	    getBackgroundImage: getBackgroundImage,
	    getPosition: getPosition,
	    unitTest: {
	      setImageName: function setImageName(family, name) {
	        selectedImages[family] = name;
	      }
	    }
	  };
	
	  activate();
	  return service;
	
	  ////////////////
	  function activate() {
	    for (var family in imagePositions) {
	      selectedImages[family] = _.sample(Object.keys(imagePositions[family]));
	    }
	  }
	
	  function getBackgroundImage() {
	    var imageFamily = arguments.length <= 0 || arguments[0] === undefined ? IMAGE_FAMILY.general : arguments[0];
	
	    var imageName = selectedImages[imageFamily];
	    if (!imageName) {
	      // fall back to general - preferable to a blank screen
	      imageName = selectedImages[IMAGE_FAMILY.general];
	    }
	
	    var resolution = $mdMedia('gt-md') ? imageSizes.large : imageSizes.medium;
	    return imageUrlBase + '/' + resolution + '/' + imageName;
	  }
	
	  function getPosition() {
	    var imageFamily = arguments.length <= 0 || arguments[0] === undefined ? IMAGE_FAMILY.general : arguments[0];
	
	    var imageName = selectedImages[imageFamily];
	    var position = undefined;
	    if (imageName) {
	      position = imagePositions[imageFamily][imageName];
	    } else {
	      // fall back to general - preferable to a blank screen
	      imageName = selectedImages[IMAGE_FAMILY.general];
	      position = imagePositions[IMAGE_FAMILY.general][imageName];
	    }
	
	    return position;
	  }
	}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = global || self, factory(global.Tooltips = {}));
	}(this, (function (exports) { 'use strict';
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function styleInject(css, ref) {
	    if ( ref === void 0 ) ref = {};
	    var insertAt = ref.insertAt;
	
	    if (!css || typeof document === 'undefined') { return; }
	
	    var head = document.head || document.getElementsByTagName('head')[0];
	    var style = document.createElement('style');
	    style.type = 'text/css';
	
	    if (insertAt === 'top') {
	      if (head.firstChild) {
	        head.insertBefore(style, head.firstChild);
	      } else {
	        head.appendChild(style);
	      }
	    } else {
	      head.appendChild(style);
	    }
	
	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	  }
	
	  var css = "[pros-tooltip]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}pros-tooltip-overlay{background-color:#5a5a5a;color:#fff;width:auto;border-radius:4px;padding:4px 8px;margin-top:4px;transform:translateX(-50%);z-index:1000001;font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500;text-align:center;white-space:nowrap;pointer-events:none;user-select:none}pros-tooltip-overlay,pros-tooltip-overlay *,pros-tooltip-overlay :after,pros-tooltip-overlay :before{box-sizing:border-box}";
	  styleInject(css);
	
	  var Tooltips =
	  /*#__PURE__*/
	  function () {
	    function Tooltips() {
	      _classCallCheck(this, Tooltips);
	
	      this._observers = new WeakMap();
	      this._listeners = {
	        mouseenter: new WeakMap(),
	        mouseleave: new WeakMap()
	      };
	    }
	
	    _createClass(Tooltips, [{
	      key: "addObserver",
	      value: function addObserver() {
	        var _this = this;
	
	        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	        if (this._observers.get(target)) {
	          // Could also throw an error
	          return;
	        }
	
	        var observer = new MutationObserver(function (mutations) {
	          mutations.forEach(function (mutation) {
	            if (mutation.type !== 'childList') {
	              return;
	            }
	
	            var addedNodes = mutation.addedNodes;
	
	            for (var i = 0; i < addedNodes.length; i++) {
	              var node = addedNodes[i];
	
	              if (!node.querySelectorAll) {
	                continue;
	              } //Check node itself and then children
	
	
	              if (node.hasAttribute('pros-tooltip')) {
	                _this.bind(node);
	              }
	
	              var elements = node.querySelectorAll('[pros-tooltip]');
	
	              if (elements.length > 0) {
	                for (var j = 0; j < elements.length; j++) {
	                  var element = elements[j];
	
	                  _this.bind(element);
	                }
	              }
	            }
	
	            var removedNodes = mutation.removedNodes;
	
	            for (var _i = 0; _i < removedNodes.length; _i++) {
	              var _node = removedNodes[_i];
	
	              if (!_node.querySelectorAll) {
	                continue;
	              }
	
	              if (_node.hasAttribute('pros-tooltip')) {
	                _this.bind(_node);
	              }
	
	              var _elements = _node.querySelectorAll('[pros-tooltip]');
	
	              if (_elements.length > 0) {
	                for (var _j = 0; _j < _elements.length; _j++) {
	                  var _element = _elements[_j];
	
	                  _this.unbind(_element);
	                }
	              }
	            }
	          });
	        });
	        observer.observe(target, {
	          childList: true,
	          subtree: true,
	          attributes: false,
	          characterData: false
	        });
	
	        this._observers.set(target, observer);
	      }
	    }, {
	      key: "removeObserver",
	      value: function removeObserver() {
	        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	        var observer = this._observers.get(target);
	
	        if (observer) {
	          observer.disconnect();
	
	          this._observers["delete"](target);
	        }
	      }
	    }, {
	      key: "bind",
	      value: function bind(el) {
	        var _this2 = this;
	
	        var listener = function listener() {
	          var attributeValue = el.getAttribute('pros-tooltip');
	
	          if (!attributeValue && isFullContentVisible(el)) {
	            // not specified and text not truncated - don't show tooltip
	            return;
	          }
	
	          var tooltipEl = document.createElement('pros-tooltip-overlay');
	          setContent(tooltipEl, el);
	          setPosition(tooltipEl, el); // Hide, then append to get width, then show once width corrected.
	          // Approach from http://stackoverflow.com/a/2930159/277307
	
	          hideElement(tooltipEl);
	          document.body.appendChild(tooltipEl);
	          ensureEvenWidth(tooltipEl);
	          ensureNotClipped(tooltipEl);
	          showElement(tooltipEl);
	          removeOnMouseLeave.call(_this2, tooltipEl, el);
	        };
	
	        var enterListener = this._listeners.mouseenter.get(el);
	
	        if (!enterListener) {
	          el.addEventListener('mouseenter', listener);
	
	          this._listeners.mouseenter.set(el, listener);
	        }
	      }
	    }, {
	      key: "unbind",
	      value: function unbind(el) {
	        var enterListener = this._listeners.mouseenter.get(el);
	
	        if (enterListener) {
	          el.removeEventListener('mouseenter', enterListener);
	
	          this._listeners.mouseenter["delete"](el);
	        }
	
	        var leaveListener = this._listeners.mouseleave.get(el);
	
	        if (leaveListener) {
	          leaveListener.call(this);
	        }
	      }
	    }]);
	
	    return Tooltips;
	  }(); // Adapted from http://stackoverflow.com/a/10017343/277307
	
	  function isFullContentVisible(el) {
	    return el.offsetWidth >= el.scrollWidth;
	  }
	
	  function setPosition(tooltipEl, el) {
	    tooltipEl.style.position = 'fixed';
	    var elRect = el.getBoundingClientRect();
	    tooltipEl.style.top = elRect.top + elRect.height + 'px'; // Center horizontally under element
	
	    tooltipEl.style.left = elRect.left + elRect.width / 2 + 'px';
	    return tooltipEl;
	  }
	
	  function setContent(tooltipEl, el) {
	    var attrValue = el.getAttribute('pros-tooltip');
	
	    if (attrValue) {
	      // Use value if provided
	      tooltipEl.textContent = attrValue;
	    } else {
	      // Element text by default
	      tooltipEl.textContent = el.textContent;
	    }
	
	    return tooltipEl;
	  }
	
	  function removeOnMouseLeave(tooltipEl, el) {
	    var _this3 = this;
	
	    var leaveHandler = function leaveHandler() {
	      document.body.removeChild(tooltipEl);
	      el.removeEventListener('mouseleave', leaveHandler);
	
	      _this3._listeners.mouseleave["delete"](el);
	    };
	
	    el.addEventListener('mouseleave', leaveHandler);
	
	    this._listeners.mouseleave.set(el, leaveHandler);
	  }
	
	  function hideElement(tooltipEl) {
	    tooltipEl.style.visibility = 'hidden';
	  }
	
	  function showElement(tooltipEl) {
	    tooltipEl.style.removeProperty('visibility');
	  } // Necessary because of chrome font antialiasing with translations on odd widths
	  // will cause blurry text. See http://stackoverflow.com/a/41456864/277307
	
	
	  function ensureEvenWidth(tooltipEl) {
	    var width = Math.round(tooltipEl.getBoundingClientRect().width);
	
	    if (width % 2 !== 0) {
	      width++;
	    }
	
	    tooltipEl.style.width = width + 'px';
	  }
	
	  function ensureNotClipped(tooltipEl) {
	    // Ensure not clipped by window boundary,
	    // since we're transforming left 50% and width could exceed the window.
	    var rect = tooltipEl.getBoundingClientRect();
	    var halfWidth = rect.width / 2;
	
	    if (rect.left < 0) {
	      tooltipEl.style.left = halfWidth + 'px';
	    } else if (rect.right > window.innerWidth) {
	      tooltipEl.style.left = window.innerWidth - halfWidth + 'px';
	    }
	  }
	
	  exports.Tooltips = Tooltips;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = global || self, factory(global.AgnosticViewNav = {}));
	}(this, (function (exports) { 'use strict';
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function noop() {}
	
	  function assign(tar, src) {
	    for (var k in src) {
	      tar[k] = src[k];
	    }
	
	    return tar;
	  }
	
	  function assignTrue(tar, src) {
	    for (var k in src) {
	      tar[k] = 1;
	    }
	
	    return tar;
	  }
	
	  function run(fn) {
	    fn();
	  }
	
	  function append(target, node) {
	    target.appendChild(node);
	  }
	
	  function insert(target, node, anchor) {
	    target.insertBefore(node, anchor);
	  }
	
	  function detachNode(node) {
	    node.parentNode.removeChild(node);
	  }
	
	  function createElement(name) {
	    return document.createElement(name);
	  }
	
	  function createText(data) {
	    return document.createTextNode(data);
	  }
	
	  function createComment() {
	    return document.createComment('');
	  }
	
	  function addListener(node, event, handler, options) {
	    node.addEventListener(event, handler, options);
	  }
	
	  function removeListener(node, event, handler, options) {
	    node.removeEventListener(event, handler, options);
	  }
	
	  function setAttribute(node, attribute, value) {
	    if (value == null) node.removeAttribute(attribute);else node.setAttribute(attribute, value);
	  }
	
	  function setData(text, data) {
	    text.data = '' + data;
	  }
	
	  function toggleClass(element, name, toggle) {
	    element.classList[toggle ? 'add' : 'remove'](name);
	  }
	
	  function linear(t) {
	    return t;
	  }
	
	  function generateRule(_ref, ease, fn) {
	    var a = _ref.a,
	        b = _ref.b,
	        delta = _ref.delta,
	        duration = _ref.duration;
	    var step = 16.666 / duration;
	    var keyframes = '{\n';
	
	    for (var p = 0; p <= 1; p += step) {
	      var t = a + delta * ease(p);
	      keyframes += p * 100 + "%{".concat(fn(t, 1 - t), "}\n");
	    }
	
	    return keyframes + "100% {".concat(fn(b, 1 - b), "}\n}");
	  } // https://github.com/darkskyapp/string-hash/blob/master/index.js
	
	
	  function hash(str) {
	    var hash = 5381;
	    var i = str.length;
	
	    while (i--) {
	      hash = (hash << 5) - hash ^ str.charCodeAt(i);
	    }
	
	    return hash >>> 0;
	  }
	
	  function wrapTransition(component, node, fn, params, intro) {
	    var obj = fn.call(component, node, params);
	    var duration;
	    var ease;
	    var cssText;
	    var initialised = false;
	    return {
	      t: intro ? 0 : 1,
	      running: false,
	      program: null,
	      pending: null,
	      run: function run(b, callback) {
	        var _this = this;
	
	        if (typeof obj === 'function') {
	          transitionManager.wait().then(function () {
	            obj = obj();
	
	            _this._run(b, callback);
	          });
	        } else {
	          this._run(b, callback);
	        }
	      },
	      _run: function _run(b, callback) {
	        duration = obj.duration || 300;
	        ease = obj.easing || linear;
	        var program = {
	          start: window.performance.now() + (obj.delay || 0),
	          b: b,
	          callback: callback || noop
	        };
	
	        if (intro && !initialised) {
	          if (obj.css && obj.delay) {
	            cssText = node.style.cssText;
	            node.style.cssText += obj.css(0, 1);
	          }
	
	          if (obj.tick) obj.tick(0, 1);
	          initialised = true;
	        }
	
	        if (!b) {
	          program.group = outros.current;
	          outros.current.remaining += 1;
	        }
	
	        if (obj.delay) {
	          this.pending = program;
	        } else {
	          this.start(program);
	        }
	
	        if (!this.running) {
	          this.running = true;
	          transitionManager.add(this);
	        }
	      },
	      start: function start(program) {
	        component.fire("".concat(program.b ? 'intro' : 'outro', ".start"), {
	          node: node
	        });
	        program.a = this.t;
	        program.delta = program.b - program.a;
	        program.duration = duration * Math.abs(program.b - program.a);
	        program.end = program.start + program.duration;
	
	        if (obj.css) {
	          if (obj.delay) node.style.cssText = cssText;
	          var rule = generateRule(program, ease, obj.css);
	          transitionManager.addRule(rule, program.name = '__svelte_' + hash(rule));
	          node.style.animation = (node.style.animation || '').split(', ').filter(function (anim) {
	            return anim && (program.delta < 0 || !/__svelte/.test(anim));
	          }).concat("".concat(program.name, " ").concat(program.duration, "ms linear 1 forwards")).join(', ');
	        }
	
	        this.program = program;
	        this.pending = null;
	      },
	      update: function update(now) {
	        var program = this.program;
	        if (!program) return;
	        var p = now - program.start;
	        this.t = program.a + program.delta * ease(p / program.duration);
	        if (obj.tick) obj.tick(this.t, 1 - this.t);
	      },
	      done: function done() {
	        var program = this.program;
	        this.t = program.b;
	        if (obj.tick) obj.tick(this.t, 1 - this.t);
	        component.fire("".concat(program.b ? 'intro' : 'outro', ".end"), {
	          node: node
	        });
	
	        if (!program.b && !program.invalidated) {
	          program.group.callbacks.push(function () {
	            program.callback();
	            if (obj.css) transitionManager.deleteRule(node, program.name);
	          });
	
	          if (--program.group.remaining === 0) {
	            program.group.callbacks.forEach(run);
	          }
	        } else {
	          if (obj.css) transitionManager.deleteRule(node, program.name);
	        }
	
	        this.running = !!this.pending;
	      },
	      abort: function abort(reset) {
	        if (this.program) {
	          if (reset && obj.tick) obj.tick(1, 0);
	          if (obj.css) transitionManager.deleteRule(node, this.program.name);
	          this.program = this.pending = null;
	          this.running = false;
	        }
	      },
	      invalidate: function invalidate() {
	        if (this.program) {
	          this.program.invalidated = true;
	        }
	      }
	    };
	  }
	
	  var outros = {};
	
	  function groupOutros() {
	    outros.current = {
	      remaining: 0,
	      callbacks: []
	    };
	  }
	
	  var transitionManager = {
	    running: false,
	    transitions: [],
	    bound: null,
	    stylesheet: null,
	    activeRules: {},
	    promise: null,
	    add: function add(transition) {
	      this.transitions.push(transition);
	
	      if (!this.running) {
	        this.running = true;
	        requestAnimationFrame(this.bound || (this.bound = this.next.bind(this)));
	      }
	    },
	    addRule: function addRule(rule, name) {
	      if (!this.stylesheet) {
	        var style = createElement('style');
	        document.head.appendChild(style);
	        transitionManager.stylesheet = style.sheet;
	      }
	
	      if (!this.activeRules[name]) {
	        this.activeRules[name] = true;
	        this.stylesheet.insertRule("@keyframes ".concat(name, " ").concat(rule), this.stylesheet.cssRules.length);
	      }
	    },
	    next: function next() {
	      this.running = false;
	      var now = window.performance.now();
	      var i = this.transitions.length;
	
	      while (i--) {
	        var transition = this.transitions[i];
	
	        if (transition.program && now >= transition.program.end) {
	          transition.done();
	        }
	
	        if (transition.pending && now >= transition.pending.start) {
	          transition.start(transition.pending);
	        }
	
	        if (transition.running) {
	          transition.update(now);
	          this.running = true;
	        } else if (!transition.pending) {
	          this.transitions.splice(i, 1);
	        }
	      }
	
	      if (this.running) {
	        requestAnimationFrame(this.bound);
	      } else if (this.stylesheet) {
	        var _i = this.stylesheet.cssRules.length;
	
	        while (_i--) {
	          this.stylesheet.deleteRule(_i);
	        }
	
	        this.activeRules = {};
	      }
	    },
	    deleteRule: function deleteRule(node, name) {
	      node.style.animation = node.style.animation.split(', ').filter(function (anim) {
	        return anim && anim.indexOf(name) === -1;
	      }).join(', ');
	    },
	    wait: function wait() {
	      if (!transitionManager.promise) {
	        transitionManager.promise = Promise.resolve();
	        transitionManager.promise.then(function () {
	          transitionManager.promise = null;
	        });
	      }
	
	      return transitionManager.promise;
	    }
	  };
	
	  function destroyBlock(block, lookup) {
	    block.d(1);
	    lookup[block.key] = null;
	  }
	
	  function updateKeyedEach(old_blocks, component, changed, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, intro_method, next, get_context) {
	    var o = old_blocks.length;
	    var n = list.length;
	    var i = o;
	    var old_indexes = {};
	
	    while (i--) {
	      old_indexes[old_blocks[i].key] = i;
	    }
	
	    var new_blocks = [];
	    var new_lookup = {};
	    var deltas = {};
	    var i = n;
	
	    while (i--) {
	      var child_ctx = get_context(ctx, list, i);
	      var key = get_key(child_ctx);
	      var block = lookup[key];
	
	      if (!block) {
	        block = create_each_block(component, key, child_ctx);
	        block.c();
	      } else if (dynamic) {
	        block.p(changed, child_ctx);
	      }
	
	      new_blocks[i] = new_lookup[key] = block;
	      if (key in old_indexes) deltas[key] = Math.abs(i - old_indexes[key]);
	    }
	
	    var will_move = {};
	    var did_move = {};
	
	    function insert(block) {
	      block[intro_method](node, next);
	      lookup[block.key] = block;
	      next = block.first;
	      n--;
	    }
	
	    while (o && n) {
	      var new_block = new_blocks[n - 1];
	      var old_block = old_blocks[o - 1];
	      var new_key = new_block.key;
	      var old_key = old_block.key;
	
	      if (new_block === old_block) {
	        // do nothing
	        next = new_block.first;
	        o--;
	        n--;
	      } else if (!new_lookup[old_key]) {
	        // remove old block
	        destroy(old_block, lookup);
	        o--;
	      } else if (!lookup[new_key] || will_move[new_key]) {
	        insert(new_block);
	      } else if (did_move[old_key]) {
	        o--;
	      } else if (deltas[new_key] > deltas[old_key]) {
	        did_move[new_key] = true;
	        insert(new_block);
	      } else {
	        will_move[old_key] = true;
	        o--;
	      }
	    }
	
	    while (o--) {
	      var old_block = old_blocks[o];
	      if (!new_lookup[old_block.key]) destroy(old_block, lookup);
	    }
	
	    while (n) {
	      insert(new_blocks[n - 1]);
	    }
	
	    return new_blocks;
	  }
	
	  function blankObject() {
	    return Object.create(null);
	  }
	
	  function destroy(detach) {
	    this.destroy = noop;
	    this.fire('destroy');
	    this.set = noop;
	
	    this._fragment.d(detach !== false);
	
	    this._fragment = null;
	    this._state = {};
	  }
	
	  function _differs(a, b) {
	    return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
	  }
	
	  function fire(eventName, data) {
	    var handlers = eventName in this._handlers && this._handlers[eventName].slice();
	
	    if (!handlers) return;
	
	    for (var i = 0; i < handlers.length; i += 1) {
	      var handler = handlers[i];
	
	      if (!handler.__calling) {
	        try {
	          handler.__calling = true;
	          handler.call(this, data);
	        } finally {
	          handler.__calling = false;
	        }
	      }
	    }
	  }
	
	  function flush(component) {
	    component._lock = true;
	    callAll(component._beforecreate);
	    callAll(component._oncreate);
	    callAll(component._aftercreate);
	    component._lock = false;
	  }
	
	  function get() {
	    return this._state;
	  }
	
	  function init(component, options) {
	    component._handlers = blankObject();
	    component._slots = blankObject();
	    component._bind = options._bind;
	    component._staged = {};
	    component.options = options;
	    component.root = options.root || component;
	    component.store = options.store || component.root.store;
	
	    if (!options.root) {
	      component._beforecreate = [];
	      component._oncreate = [];
	      component._aftercreate = [];
	    }
	  }
	
	  function on(eventName, handler) {
	    var handlers = this._handlers[eventName] || (this._handlers[eventName] = []);
	    handlers.push(handler);
	    return {
	      cancel: function cancel() {
	        var index = handlers.indexOf(handler);
	        if (~index) handlers.splice(index, 1);
	      }
	    };
	  }
	
	  function set(newState) {
	    this._set(assign({}, newState));
	
	    if (this.root._lock) return;
	    flush(this.root);
	  }
	
	  function _set(newState) {
	    var oldState = this._state,
	        changed = {},
	        dirty = false;
	    newState = assign(this._staged, newState);
	    this._staged = {};
	
	    for (var key in newState) {
	      if (this._differs(newState[key], oldState[key])) changed[key] = dirty = true;
	    }
	
	    if (!dirty) return;
	    this._state = assign(assign({}, oldState), newState);
	
	    this._recompute(changed, this._state);
	
	    if (this._bind) this._bind(changed, this._state);
	
	    if (this._fragment) {
	      this.fire("state", {
	        changed: changed,
	        current: this._state,
	        previous: oldState
	      });
	
	      this._fragment.p(changed, this._state);
	
	      this.fire("update", {
	        changed: changed,
	        current: this._state,
	        previous: oldState
	      });
	    }
	  }
	
	  function _stage(newState) {
	    assign(this._staged, newState);
	  }
	
	  function callAll(fns) {
	    while (fns && fns.length) {
	      fns.shift()();
	    }
	  }
	
	  function _mount(target, anchor) {
	    this._fragment[this._fragment.i ? 'i' : 'm'](target, anchor || null);
	  }
	
	  var proto = {
	    destroy: destroy,
	    get: get,
	    fire: fire,
	    on: on,
	    set: set,
	    _recompute: noop,
	    _set: _set,
	    _stage: _stage,
	    _mount: _mount,
	    _differs: _differs
	  };
	
	  function cubicOut(t) {
	    var f = t - 1.0;
	    return f * f * f + 1.0
	  }
	
	  function slide(
	  	node,
	  	ref
	  ) {
	  	var delay = ref.delay; if ( delay === void 0 ) delay = 0;
	  	var duration = ref.duration; if ( duration === void 0 ) duration = 400;
	  	var easing = ref.easing; if ( easing === void 0 ) easing = cubicOut;
	
	  	var style = getComputedStyle(node);
	  	var opacity = +style.opacity;
	  	var height = parseFloat(style.height);
	  	var paddingTop = parseFloat(style.paddingTop);
	  	var paddingBottom = parseFloat(style.paddingBottom);
	  	var marginTop = parseFloat(style.marginTop);
	  	var marginBottom = parseFloat(style.marginBottom);
	  	var borderTopWidth = parseFloat(style.borderTopWidth);
	  	var borderBottomWidth = parseFloat(style.borderBottomWidth);
	
	  	return {
	  		delay: delay,
	  		duration: duration,
	  		easing: easing,
	  		css: function (t) { return "overflow: hidden;" +
	  			"opacity: " + (Math.min(t * 20, 1) * opacity) + ";" +
	  			"height: " + (t * height) + "px;" +
	  			"padding-top: " + (t * paddingTop) + "px;" +
	  			"padding-bottom: " + (t * paddingBottom) + "px;" +
	  			"margin-top: " + (t * marginTop) + "px;" +
	  			"margin-bottom: " + (t * marginBottom) + "px;" +
	  			"border-top-width: " + (t * borderTopWidth) + "px;" +
	  			"border-bottom-width: " + (t * borderBottomWidth) + "px;"; }
	  	};
	  }
	
	  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	  function unwrapExports (x) {
	  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	  }
	
	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }
	
	  /**
	   * lodash (Custom Build) <https://lodash.com/>
	   * Build: `lodash modularize exports="npm" -o ./`
	   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	   * Released under MIT license <https://lodash.com/license>
	   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	   */
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0;
	
	  /** `Object#toString` result references. */
	  var funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      symbolTag = '[object Symbol]';
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /** Used for built-in method references. */
	  var arrayProto = Array.prototype,
	      funcProto = Function.prototype,
	      objectProto = Object.prototype;
	
	  /** Used to detect overreaching core-js shims. */
	  var coreJsData = root['__core-js_shared__'];
	
	  /** Used to detect methods masquerading as native. */
	  var maskSrcKey = (function() {
	    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	    return uid ? ('Symbol(src)_1.' + uid) : '';
	  }());
	
	  /** Used to resolve the decompiled source of functions. */
	  var funcToString = funcProto.toString;
	
	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;
	
	  /**
	   * Used to resolve the
	   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objectToString = objectProto.toString;
	
	  /** Used to detect if a method is native. */
	  var reIsNative = RegExp('^' +
	    funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	  );
	
	  /** Built-in value references. */
	  var Symbol$1 = root.Symbol,
	      splice = arrayProto.splice;
	
	  /* Built-in method references that are verified to be native. */
	  var Map = getNative(root, 'Map'),
	      nativeCreate = getNative(Object, 'create');
	
	  /** Used to convert symbols to primitives and strings. */
	  var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
	      symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	  /**
	   * Creates a hash object.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function Hash(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the hash.
	   *
	   * @private
	   * @name clear
	   * @memberOf Hash
	   */
	  function hashClear() {
	    this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  }
	
	  /**
	   * Removes `key` and its value from the hash.
	   *
	   * @private
	   * @name delete
	   * @memberOf Hash
	   * @param {Object} hash The hash to modify.
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function hashDelete(key) {
	    return this.has(key) && delete this.__data__[key];
	  }
	
	  /**
	   * Gets the hash value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf Hash
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function hashGet(key) {
	    var data = this.__data__;
	    if (nativeCreate) {
	      var result = data[key];
	      return result === HASH_UNDEFINED ? undefined : result;
	    }
	    return hasOwnProperty.call(data, key) ? data[key] : undefined;
	  }
	
	  /**
	   * Checks if a hash value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf Hash
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function hashHas(key) {
	    var data = this.__data__;
	    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	  }
	
	  /**
	   * Sets the hash `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf Hash
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the hash instance.
	   */
	  function hashSet(key, value) {
	    var data = this.__data__;
	    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	    return this;
	  }
	
	  // Add methods to `Hash`.
	  Hash.prototype.clear = hashClear;
	  Hash.prototype['delete'] = hashDelete;
	  Hash.prototype.get = hashGet;
	  Hash.prototype.has = hashHas;
	  Hash.prototype.set = hashSet;
	
	  /**
	   * Creates an list cache object.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function ListCache(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the list cache.
	   *
	   * @private
	   * @name clear
	   * @memberOf ListCache
	   */
	  function listCacheClear() {
	    this.__data__ = [];
	  }
	
	  /**
	   * Removes `key` and its value from the list cache.
	   *
	   * @private
	   * @name delete
	   * @memberOf ListCache
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function listCacheDelete(key) {
	    var data = this.__data__,
	        index = assocIndexOf(data, key);
	
	    if (index < 0) {
	      return false;
	    }
	    var lastIndex = data.length - 1;
	    if (index == lastIndex) {
	      data.pop();
	    } else {
	      splice.call(data, index, 1);
	    }
	    return true;
	  }
	
	  /**
	   * Gets the list cache value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf ListCache
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function listCacheGet(key) {
	    var data = this.__data__,
	        index = assocIndexOf(data, key);
	
	    return index < 0 ? undefined : data[index][1];
	  }
	
	  /**
	   * Checks if a list cache value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf ListCache
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function listCacheHas(key) {
	    return assocIndexOf(this.__data__, key) > -1;
	  }
	
	  /**
	   * Sets the list cache `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf ListCache
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the list cache instance.
	   */
	  function listCacheSet(key, value) {
	    var data = this.__data__,
	        index = assocIndexOf(data, key);
	
	    if (index < 0) {
	      data.push([key, value]);
	    } else {
	      data[index][1] = value;
	    }
	    return this;
	  }
	
	  // Add methods to `ListCache`.
	  ListCache.prototype.clear = listCacheClear;
	  ListCache.prototype['delete'] = listCacheDelete;
	  ListCache.prototype.get = listCacheGet;
	  ListCache.prototype.has = listCacheHas;
	  ListCache.prototype.set = listCacheSet;
	
	  /**
	   * Creates a map cache object to store key-value pairs.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function MapCache(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the map.
	   *
	   * @private
	   * @name clear
	   * @memberOf MapCache
	   */
	  function mapCacheClear() {
	    this.__data__ = {
	      'hash': new Hash,
	      'map': new (Map || ListCache),
	      'string': new Hash
	    };
	  }
	
	  /**
	   * Removes `key` and its value from the map.
	   *
	   * @private
	   * @name delete
	   * @memberOf MapCache
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function mapCacheDelete(key) {
	    return getMapData(this, key)['delete'](key);
	  }
	
	  /**
	   * Gets the map value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf MapCache
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function mapCacheGet(key) {
	    return getMapData(this, key).get(key);
	  }
	
	  /**
	   * Checks if a map value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf MapCache
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function mapCacheHas(key) {
	    return getMapData(this, key).has(key);
	  }
	
	  /**
	   * Sets the map `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf MapCache
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the map cache instance.
	   */
	  function mapCacheSet(key, value) {
	    getMapData(this, key).set(key, value);
	    return this;
	  }
	
	  // Add methods to `MapCache`.
	  MapCache.prototype.clear = mapCacheClear;
	  MapCache.prototype['delete'] = mapCacheDelete;
	  MapCache.prototype.get = mapCacheGet;
	  MapCache.prototype.has = mapCacheHas;
	  MapCache.prototype.set = mapCacheSet;
	
	  /**
	   * Gets the index at which the `key` is found in `array` of key-value pairs.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} key The key to search for.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function assocIndexOf(array, key) {
	    var length = array.length;
	    while (length--) {
	      if (eq(array[length][0], key)) {
	        return length;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.get` without support for default values.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array|string} path The path of the property to get.
	   * @returns {*} Returns the resolved value.
	   */
	  function baseGet(object, path) {
	    path = isKey(path, object) ? [path] : castPath(path);
	
	    var index = 0,
	        length = path.length;
	
	    while (object != null && index < length) {
	      object = object[toKey(path[index++])];
	    }
	    return (index && index == length) ? object : undefined;
	  }
	
	  /**
	   * The base implementation of `_.isNative` without bad shim checks.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a native function,
	   *  else `false`.
	   */
	  function baseIsNative(value) {
	    if (!isObject(value) || isMasked(value)) {
	      return false;
	    }
	    var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	    return pattern.test(toSource(value));
	  }
	
	  /**
	   * The base implementation of `_.toString` which doesn't convert nullish
	   * values to empty strings.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    // Exit early for strings to avoid a performance hit in some environments.
	    if (typeof value == 'string') {
	      return value;
	    }
	    if (isSymbol(value)) {
	      return symbolToString ? symbolToString.call(value) : '';
	    }
	    var result = (value + '');
	    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	  }
	
	  /**
	   * Casts `value` to a path array if it's not one.
	   *
	   * @private
	   * @param {*} value The value to inspect.
	   * @returns {Array} Returns the cast property path array.
	   */
	  function castPath(value) {
	    return isArray(value) ? value : stringToPath(value);
	  }
	
	  /**
	   * Gets the data for `map`.
	   *
	   * @private
	   * @param {Object} map The map to query.
	   * @param {string} key The reference key.
	   * @returns {*} Returns the map data.
	   */
	  function getMapData(map, key) {
	    var data = map.__data__;
	    return isKeyable(key)
	      ? data[typeof key == 'string' ? 'string' : 'hash']
	      : data.map;
	  }
	
	  /**
	   * Gets the native function at `key` of `object`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the method to get.
	   * @returns {*} Returns the function if it's native, else `undefined`.
	   */
	  function getNative(object, key) {
	    var value = getValue(object, key);
	    return baseIsNative(value) ? value : undefined;
	  }
	
	  /**
	   * Checks if `value` is a property name and not a property path.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {Object} [object] The object to query keys on.
	   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	   */
	  function isKey(value, object) {
	    if (isArray(value)) {
	      return false;
	    }
	    var type = typeof value;
	    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	        value == null || isSymbol(value)) {
	      return true;
	    }
	    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	      (object != null && value in Object(object));
	  }
	
	  /**
	   * Checks if `value` is suitable for use as unique object key.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	   */
	  function isKeyable(value) {
	    var type = typeof value;
	    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	      ? (value !== '__proto__')
	      : (value === null);
	  }
	
	  /**
	   * Checks if `func` has its source masked.
	   *
	   * @private
	   * @param {Function} func The function to check.
	   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	   */
	  function isMasked(func) {
	    return !!maskSrcKey && (maskSrcKey in func);
	  }
	
	  /**
	   * Converts `string` to a property path array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the property path array.
	   */
	  var stringToPath = memoize(function(string) {
	    string = toString(string);
	
	    var result = [];
	    if (reLeadingDot.test(string)) {
	      result.push('');
	    }
	    string.replace(rePropName, function(match, number, quote, string) {
	      result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	    });
	    return result;
	  });
	
	  /**
	   * Converts `value` to a string key if it's not a string or symbol.
	   *
	   * @private
	   * @param {*} value The value to inspect.
	   * @returns {string|symbol} Returns the key.
	   */
	  function toKey(value) {
	    if (typeof value == 'string' || isSymbol(value)) {
	      return value;
	    }
	    var result = (value + '');
	    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	  }
	
	  /**
	   * Converts `func` to its source code.
	   *
	   * @private
	   * @param {Function} func The function to process.
	   * @returns {string} Returns the source code.
	   */
	  function toSource(func) {
	    if (func != null) {
	      try {
	        return funcToString.call(func);
	      } catch (e) {}
	      try {
	        return (func + '');
	      } catch (e) {}
	    }
	    return '';
	  }
	
	  /**
	   * Creates a function that memoizes the result of `func`. If `resolver` is
	   * provided, it determines the cache key for storing the result based on the
	   * arguments provided to the memoized function. By default, the first argument
	   * provided to the memoized function is used as the map cache key. The `func`
	   * is invoked with the `this` binding of the memoized function.
	   *
	   * **Note:** The cache is exposed as the `cache` property on the memoized
	   * function. Its creation may be customized by replacing the `_.memoize.Cache`
	   * constructor with one whose instances implement the
	   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	   * method interface of `delete`, `get`, `has`, and `set`.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Function
	   * @param {Function} func The function to have its output memoized.
	   * @param {Function} [resolver] The function to resolve the cache key.
	   * @returns {Function} Returns the new memoized function.
	   * @example
	   *
	   * var object = { 'a': 1, 'b': 2 };
	   * var other = { 'c': 3, 'd': 4 };
	   *
	   * var values = _.memoize(_.values);
	   * values(object);
	   * // => [1, 2]
	   *
	   * values(other);
	   * // => [3, 4]
	   *
	   * object.a = 2;
	   * values(object);
	   * // => [1, 2]
	   *
	   * // Modify the result cache.
	   * values.cache.set(object, ['a', 'b']);
	   * values(object);
	   * // => ['a', 'b']
	   *
	   * // Replace `_.memoize.Cache`.
	   * _.memoize.Cache = WeakMap;
	   */
	  function memoize(func, resolver) {
	    if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	      throw new TypeError(FUNC_ERROR_TEXT);
	    }
	    var memoized = function() {
	      var args = arguments,
	          key = resolver ? resolver.apply(this, args) : args[0],
	          cache = memoized.cache;
	
	      if (cache.has(key)) {
	        return cache.get(key);
	      }
	      var result = func.apply(this, args);
	      memoized.cache = cache.set(key, result);
	      return result;
	    };
	    memoized.cache = new (memoize.Cache || MapCache);
	    return memoized;
	  }
	
	  // Assign cache to `_.memoize`.
	  memoize.Cache = MapCache;
	
	  /**
	   * Performs a
	   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	   * comparison between two values to determine if they are equivalent.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	   * @example
	   *
	   * var object = { 'a': 1 };
	   * var other = { 'a': 1 };
	   *
	   * _.eq(object, object);
	   * // => true
	   *
	   * _.eq(object, other);
	   * // => false
	   *
	   * _.eq('a', 'a');
	   * // => true
	   *
	   * _.eq('a', Object('a'));
	   * // => false
	   *
	   * _.eq(NaN, NaN);
	   * // => true
	   */
	  function eq(value, other) {
	    return value === other || (value !== value && other !== other);
	  }
	
	  /**
	   * Checks if `value` is classified as an `Array` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	   * @example
	   *
	   * _.isArray([1, 2, 3]);
	   * // => true
	   *
	   * _.isArray(document.body.children);
	   * // => false
	   *
	   * _.isArray('abc');
	   * // => false
	   *
	   * _.isArray(_.noop);
	   * // => false
	   */
	  var isArray = Array.isArray;
	
	  /**
	   * Checks if `value` is classified as a `Function` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	   * @example
	   *
	   * _.isFunction(_);
	   * // => true
	   *
	   * _.isFunction(/abc/);
	   * // => false
	   */
	  function isFunction(value) {
	    // The use of `Object#toString` avoids issues with the `typeof` operator
	    // in Safari 8-9 which returns 'object' for typed array and other constructors.
	    var tag = isObject(value) ? objectToString.call(value) : '';
	    return tag == funcTag || tag == genTag;
	  }
	
	  /**
	   * Checks if `value` is the
	   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	   * @example
	   *
	   * _.isObject({});
	   * // => true
	   *
	   * _.isObject([1, 2, 3]);
	   * // => true
	   *
	   * _.isObject(_.noop);
	   * // => true
	   *
	   * _.isObject(null);
	   * // => false
	   */
	  function isObject(value) {
	    var type = typeof value;
	    return !!value && (type == 'object' || type == 'function');
	  }
	
	  /**
	   * Checks if `value` is object-like. A value is object-like if it's not `null`
	   * and has a `typeof` result of "object".
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   * @example
	   *
	   * _.isObjectLike({});
	   * // => true
	   *
	   * _.isObjectLike([1, 2, 3]);
	   * // => true
	   *
	   * _.isObjectLike(_.noop);
	   * // => false
	   *
	   * _.isObjectLike(null);
	   * // => false
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Checks if `value` is classified as a `Symbol` primitive or object.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	   * @example
	   *
	   * _.isSymbol(Symbol.iterator);
	   * // => true
	   *
	   * _.isSymbol('abc');
	   * // => false
	   */
	  function isSymbol(value) {
	    return typeof value == 'symbol' ||
	      (isObjectLike(value) && objectToString.call(value) == symbolTag);
	  }
	
	  /**
	   * Converts `value` to a string. An empty string is returned for `null`
	   * and `undefined` values. The sign of `-0` is preserved.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   * @example
	   *
	   * _.toString(null);
	   * // => ''
	   *
	   * _.toString(-0);
	   * // => '-0'
	   *
	   * _.toString([1, 2, 3]);
	   * // => '1,2,3'
	   */
	  function toString(value) {
	    return value == null ? '' : baseToString(value);
	  }
	
	  /**
	   * Gets the value at `path` of `object`. If the resolved value is
	   * `undefined`, the `defaultValue` is returned in its place.
	   *
	   * @static
	   * @memberOf _
	   * @since 3.7.0
	   * @category Object
	   * @param {Object} object The object to query.
	   * @param {Array|string} path The path of the property to get.
	   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	   * @returns {*} Returns the resolved value.
	   * @example
	   *
	   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	   *
	   * _.get(object, 'a[0].b.c');
	   * // => 3
	   *
	   * _.get(object, ['a', '0', 'b', 'c']);
	   * // => 3
	   *
	   * _.get(object, 'a.b.c', 'default');
	   * // => 'default'
	   */
	  function get$1(object, path, defaultValue) {
	    var result = object == null ? undefined : baseGet(object, path);
	    return result === undefined ? defaultValue : result;
	  }
	
	  var lodash_get = get$1;
	
	  /**
	   * lodash (Custom Build) <https://lodash.com/>
	   * Build: `lodash modularize exports="npm" -o ./`
	   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	   * Released under MIT license <https://lodash.com/license>
	   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	   */
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT$1 = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY$1 = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991;
	
	  /** `Object#toString` result references. */
	  var funcTag$1 = '[object Function]',
	      genTag$1 = '[object GeneratorFunction]',
	      symbolTag$1 = '[object Symbol]';
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp$1 = /^\w*$/,
	      reLeadingDot$1 = /^\./,
	      rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar$1 = /\\(\\)?/g;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	
	  /** Detect free variable `self`. */
	  var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue$1(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject$1(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /** Used for built-in method references. */
	  var arrayProto$1 = Array.prototype,
	      funcProto$1 = Function.prototype,
	      objectProto$1 = Object.prototype;
	
	  /** Used to detect overreaching core-js shims. */
	  var coreJsData$1 = root$1['__core-js_shared__'];
	
	  /** Used to detect methods masquerading as native. */
	  var maskSrcKey$1 = (function() {
	    var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
	    return uid ? ('Symbol(src)_1.' + uid) : '';
	  }());
	
	  /** Used to resolve the decompiled source of functions. */
	  var funcToString$1 = funcProto$1.toString;
	
	  /** Used to check objects for own properties. */
	  var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
	
	  /**
	   * Used to resolve the
	   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  var objectToString$1 = objectProto$1.toString;
	
	  /** Used to detect if a method is native. */
	  var reIsNative$1 = RegExp('^' +
	    funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar$1, '\\$&')
	    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	  );
	
	  /** Built-in value references. */
	  var Symbol$2 = root$1.Symbol,
	      splice$1 = arrayProto$1.splice;
	
	  /* Built-in method references that are verified to be native. */
	  var Map$1 = getNative$1(root$1, 'Map'),
	      nativeCreate$1 = getNative$1(Object, 'create');
	
	  /** Used to convert symbols to primitives and strings. */
	  var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
	      symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;
	
	  /**
	   * Creates a hash object.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function Hash$1(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the hash.
	   *
	   * @private
	   * @name clear
	   * @memberOf Hash
	   */
	  function hashClear$1() {
	    this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
	  }
	
	  /**
	   * Removes `key` and its value from the hash.
	   *
	   * @private
	   * @name delete
	   * @memberOf Hash
	   * @param {Object} hash The hash to modify.
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function hashDelete$1(key) {
	    return this.has(key) && delete this.__data__[key];
	  }
	
	  /**
	   * Gets the hash value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf Hash
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function hashGet$1(key) {
	    var data = this.__data__;
	    if (nativeCreate$1) {
	      var result = data[key];
	      return result === HASH_UNDEFINED$1 ? undefined : result;
	    }
	    return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
	  }
	
	  /**
	   * Checks if a hash value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf Hash
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function hashHas$1(key) {
	    var data = this.__data__;
	    return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
	  }
	
	  /**
	   * Sets the hash `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf Hash
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the hash instance.
	   */
	  function hashSet$1(key, value) {
	    var data = this.__data__;
	    data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED$1 : value;
	    return this;
	  }
	
	  // Add methods to `Hash`.
	  Hash$1.prototype.clear = hashClear$1;
	  Hash$1.prototype['delete'] = hashDelete$1;
	  Hash$1.prototype.get = hashGet$1;
	  Hash$1.prototype.has = hashHas$1;
	  Hash$1.prototype.set = hashSet$1;
	
	  /**
	   * Creates an list cache object.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function ListCache$1(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the list cache.
	   *
	   * @private
	   * @name clear
	   * @memberOf ListCache
	   */
	  function listCacheClear$1() {
	    this.__data__ = [];
	  }
	
	  /**
	   * Removes `key` and its value from the list cache.
	   *
	   * @private
	   * @name delete
	   * @memberOf ListCache
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function listCacheDelete$1(key) {
	    var data = this.__data__,
	        index = assocIndexOf$1(data, key);
	
	    if (index < 0) {
	      return false;
	    }
	    var lastIndex = data.length - 1;
	    if (index == lastIndex) {
	      data.pop();
	    } else {
	      splice$1.call(data, index, 1);
	    }
	    return true;
	  }
	
	  /**
	   * Gets the list cache value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf ListCache
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function listCacheGet$1(key) {
	    var data = this.__data__,
	        index = assocIndexOf$1(data, key);
	
	    return index < 0 ? undefined : data[index][1];
	  }
	
	  /**
	   * Checks if a list cache value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf ListCache
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function listCacheHas$1(key) {
	    return assocIndexOf$1(this.__data__, key) > -1;
	  }
	
	  /**
	   * Sets the list cache `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf ListCache
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the list cache instance.
	   */
	  function listCacheSet$1(key, value) {
	    var data = this.__data__,
	        index = assocIndexOf$1(data, key);
	
	    if (index < 0) {
	      data.push([key, value]);
	    } else {
	      data[index][1] = value;
	    }
	    return this;
	  }
	
	  // Add methods to `ListCache`.
	  ListCache$1.prototype.clear = listCacheClear$1;
	  ListCache$1.prototype['delete'] = listCacheDelete$1;
	  ListCache$1.prototype.get = listCacheGet$1;
	  ListCache$1.prototype.has = listCacheHas$1;
	  ListCache$1.prototype.set = listCacheSet$1;
	
	  /**
	   * Creates a map cache object to store key-value pairs.
	   *
	   * @private
	   * @constructor
	   * @param {Array} [entries] The key-value pairs to cache.
	   */
	  function MapCache$1(entries) {
	    var index = -1,
	        length = entries ? entries.length : 0;
	
	    this.clear();
	    while (++index < length) {
	      var entry = entries[index];
	      this.set(entry[0], entry[1]);
	    }
	  }
	
	  /**
	   * Removes all key-value entries from the map.
	   *
	   * @private
	   * @name clear
	   * @memberOf MapCache
	   */
	  function mapCacheClear$1() {
	    this.__data__ = {
	      'hash': new Hash$1,
	      'map': new (Map$1 || ListCache$1),
	      'string': new Hash$1
	    };
	  }
	
	  /**
	   * Removes `key` and its value from the map.
	   *
	   * @private
	   * @name delete
	   * @memberOf MapCache
	   * @param {string} key The key of the value to remove.
	   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	   */
	  function mapCacheDelete$1(key) {
	    return getMapData$1(this, key)['delete'](key);
	  }
	
	  /**
	   * Gets the map value for `key`.
	   *
	   * @private
	   * @name get
	   * @memberOf MapCache
	   * @param {string} key The key of the value to get.
	   * @returns {*} Returns the entry value.
	   */
	  function mapCacheGet$1(key) {
	    return getMapData$1(this, key).get(key);
	  }
	
	  /**
	   * Checks if a map value for `key` exists.
	   *
	   * @private
	   * @name has
	   * @memberOf MapCache
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function mapCacheHas$1(key) {
	    return getMapData$1(this, key).has(key);
	  }
	
	  /**
	   * Sets the map `key` to `value`.
	   *
	   * @private
	   * @name set
	   * @memberOf MapCache
	   * @param {string} key The key of the value to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns the map cache instance.
	   */
	  function mapCacheSet$1(key, value) {
	    getMapData$1(this, key).set(key, value);
	    return this;
	  }
	
	  // Add methods to `MapCache`.
	  MapCache$1.prototype.clear = mapCacheClear$1;
	  MapCache$1.prototype['delete'] = mapCacheDelete$1;
	  MapCache$1.prototype.get = mapCacheGet$1;
	  MapCache$1.prototype.has = mapCacheHas$1;
	  MapCache$1.prototype.set = mapCacheSet$1;
	
	  /**
	   * Assigns `value` to `key` of `object` if the existing value is not equivalent
	   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	   * for equality comparisons.
	   *
	   * @private
	   * @param {Object} object The object to modify.
	   * @param {string} key The key of the property to assign.
	   * @param {*} value The value to assign.
	   */
	  function assignValue(object, key, value) {
	    var objValue = object[key];
	    if (!(hasOwnProperty$1.call(object, key) && eq$1(objValue, value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = value;
	    }
	  }
	
	  /**
	   * Gets the index at which the `key` is found in `array` of key-value pairs.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} key The key to search for.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function assocIndexOf$1(array, key) {
	    var length = array.length;
	    while (length--) {
	      if (eq$1(array[length][0], key)) {
	        return length;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNative` without bad shim checks.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a native function,
	   *  else `false`.
	   */
	  function baseIsNative$1(value) {
	    if (!isObject$1(value) || isMasked$1(value)) {
	      return false;
	    }
	    var pattern = (isFunction$1(value) || isHostObject$1(value)) ? reIsNative$1 : reIsHostCtor$1;
	    return pattern.test(toSource$1(value));
	  }
	
	  /**
	   * The base implementation of `_.set`.
	   *
	   * @private
	   * @param {Object} object The object to modify.
	   * @param {Array|string} path The path of the property to set.
	   * @param {*} value The value to set.
	   * @param {Function} [customizer] The function to customize path creation.
	   * @returns {Object} Returns `object`.
	   */
	  function baseSet(object, path, value, customizer) {
	    if (!isObject$1(object)) {
	      return object;
	    }
	    path = isKey$1(path, object) ? [path] : castPath$1(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        nested = object;
	
	    while (nested != null && ++index < length) {
	      var key = toKey$1(path[index]),
	          newValue = value;
	
	      if (index != lastIndex) {
	        var objValue = nested[key];
	        newValue = customizer ? customizer(objValue, key, nested) : undefined;
	        if (newValue === undefined) {
	          newValue = isObject$1(objValue)
	            ? objValue
	            : (isIndex(path[index + 1]) ? [] : {});
	        }
	      }
	      assignValue(nested, key, newValue);
	      nested = nested[key];
	    }
	    return object;
	  }
	
	  /**
	   * The base implementation of `_.toString` which doesn't convert nullish
	   * values to empty strings.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString$1(value) {
	    // Exit early for strings to avoid a performance hit in some environments.
	    if (typeof value == 'string') {
	      return value;
	    }
	    if (isSymbol$1(value)) {
	      return symbolToString$1 ? symbolToString$1.call(value) : '';
	    }
	    var result = (value + '');
	    return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
	  }
	
	  /**
	   * Casts `value` to a path array if it's not one.
	   *
	   * @private
	   * @param {*} value The value to inspect.
	   * @returns {Array} Returns the cast property path array.
	   */
	  function castPath$1(value) {
	    return isArray$1(value) ? value : stringToPath$1(value);
	  }
	
	  /**
	   * Gets the data for `map`.
	   *
	   * @private
	   * @param {Object} map The map to query.
	   * @param {string} key The reference key.
	   * @returns {*} Returns the map data.
	   */
	  function getMapData$1(map, key) {
	    var data = map.__data__;
	    return isKeyable$1(key)
	      ? data[typeof key == 'string' ? 'string' : 'hash']
	      : data.map;
	  }
	
	  /**
	   * Gets the native function at `key` of `object`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the method to get.
	   * @returns {*} Returns the function if it's native, else `undefined`.
	   */
	  function getNative$1(object, key) {
	    var value = getValue$1(object, key);
	    return baseIsNative$1(value) ? value : undefined;
	  }
	
	  /**
	   * Checks if `value` is a valid array-like index.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	   */
	  function isIndex(value, length) {
	    length = length == null ? MAX_SAFE_INTEGER : length;
	    return !!length &&
	      (typeof value == 'number' || reIsUint.test(value)) &&
	      (value > -1 && value % 1 == 0 && value < length);
	  }
	
	  /**
	   * Checks if `value` is a property name and not a property path.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {Object} [object] The object to query keys on.
	   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	   */
	  function isKey$1(value, object) {
	    if (isArray$1(value)) {
	      return false;
	    }
	    var type = typeof value;
	    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	        value == null || isSymbol$1(value)) {
	      return true;
	    }
	    return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
	      (object != null && value in Object(object));
	  }
	
	  /**
	   * Checks if `value` is suitable for use as unique object key.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	   */
	  function isKeyable$1(value) {
	    var type = typeof value;
	    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	      ? (value !== '__proto__')
	      : (value === null);
	  }
	
	  /**
	   * Checks if `func` has its source masked.
	   *
	   * @private
	   * @param {Function} func The function to check.
	   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	   */
	  function isMasked$1(func) {
	    return !!maskSrcKey$1 && (maskSrcKey$1 in func);
	  }
	
	  /**
	   * Converts `string` to a property path array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the property path array.
	   */
	  var stringToPath$1 = memoize$1(function(string) {
	    string = toString$1(string);
	
	    var result = [];
	    if (reLeadingDot$1.test(string)) {
	      result.push('');
	    }
	    string.replace(rePropName$1, function(match, number, quote, string) {
	      result.push(quote ? string.replace(reEscapeChar$1, '$1') : (number || match));
	    });
	    return result;
	  });
	
	  /**
	   * Converts `value` to a string key if it's not a string or symbol.
	   *
	   * @private
	   * @param {*} value The value to inspect.
	   * @returns {string|symbol} Returns the key.
	   */
	  function toKey$1(value) {
	    if (typeof value == 'string' || isSymbol$1(value)) {
	      return value;
	    }
	    var result = (value + '');
	    return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
	  }
	
	  /**
	   * Converts `func` to its source code.
	   *
	   * @private
	   * @param {Function} func The function to process.
	   * @returns {string} Returns the source code.
	   */
	  function toSource$1(func) {
	    if (func != null) {
	      try {
	        return funcToString$1.call(func);
	      } catch (e) {}
	      try {
	        return (func + '');
	      } catch (e) {}
	    }
	    return '';
	  }
	
	  /**
	   * Creates a function that memoizes the result of `func`. If `resolver` is
	   * provided, it determines the cache key for storing the result based on the
	   * arguments provided to the memoized function. By default, the first argument
	   * provided to the memoized function is used as the map cache key. The `func`
	   * is invoked with the `this` binding of the memoized function.
	   *
	   * **Note:** The cache is exposed as the `cache` property on the memoized
	   * function. Its creation may be customized by replacing the `_.memoize.Cache`
	   * constructor with one whose instances implement the
	   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	   * method interface of `delete`, `get`, `has`, and `set`.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Function
	   * @param {Function} func The function to have its output memoized.
	   * @param {Function} [resolver] The function to resolve the cache key.
	   * @returns {Function} Returns the new memoized function.
	   * @example
	   *
	   * var object = { 'a': 1, 'b': 2 };
	   * var other = { 'c': 3, 'd': 4 };
	   *
	   * var values = _.memoize(_.values);
	   * values(object);
	   * // => [1, 2]
	   *
	   * values(other);
	   * // => [3, 4]
	   *
	   * object.a = 2;
	   * values(object);
	   * // => [1, 2]
	   *
	   * // Modify the result cache.
	   * values.cache.set(object, ['a', 'b']);
	   * values(object);
	   * // => ['a', 'b']
	   *
	   * // Replace `_.memoize.Cache`.
	   * _.memoize.Cache = WeakMap;
	   */
	  function memoize$1(func, resolver) {
	    if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	      throw new TypeError(FUNC_ERROR_TEXT$1);
	    }
	    var memoized = function() {
	      var args = arguments,
	          key = resolver ? resolver.apply(this, args) : args[0],
	          cache = memoized.cache;
	
	      if (cache.has(key)) {
	        return cache.get(key);
	      }
	      var result = func.apply(this, args);
	      memoized.cache = cache.set(key, result);
	      return result;
	    };
	    memoized.cache = new (memoize$1.Cache || MapCache$1);
	    return memoized;
	  }
	
	  // Assign cache to `_.memoize`.
	  memoize$1.Cache = MapCache$1;
	
	  /**
	   * Performs a
	   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	   * comparison between two values to determine if they are equivalent.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	   * @example
	   *
	   * var object = { 'a': 1 };
	   * var other = { 'a': 1 };
	   *
	   * _.eq(object, object);
	   * // => true
	   *
	   * _.eq(object, other);
	   * // => false
	   *
	   * _.eq('a', 'a');
	   * // => true
	   *
	   * _.eq('a', Object('a'));
	   * // => false
	   *
	   * _.eq(NaN, NaN);
	   * // => true
	   */
	  function eq$1(value, other) {
	    return value === other || (value !== value && other !== other);
	  }
	
	  /**
	   * Checks if `value` is classified as an `Array` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	   * @example
	   *
	   * _.isArray([1, 2, 3]);
	   * // => true
	   *
	   * _.isArray(document.body.children);
	   * // => false
	   *
	   * _.isArray('abc');
	   * // => false
	   *
	   * _.isArray(_.noop);
	   * // => false
	   */
	  var isArray$1 = Array.isArray;
	
	  /**
	   * Checks if `value` is classified as a `Function` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	   * @example
	   *
	   * _.isFunction(_);
	   * // => true
	   *
	   * _.isFunction(/abc/);
	   * // => false
	   */
	  function isFunction$1(value) {
	    // The use of `Object#toString` avoids issues with the `typeof` operator
	    // in Safari 8-9 which returns 'object' for typed array and other constructors.
	    var tag = isObject$1(value) ? objectToString$1.call(value) : '';
	    return tag == funcTag$1 || tag == genTag$1;
	  }
	
	  /**
	   * Checks if `value` is the
	   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	   *
	   * @static
	   * @memberOf _
	   * @since 0.1.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	   * @example
	   *
	   * _.isObject({});
	   * // => true
	   *
	   * _.isObject([1, 2, 3]);
	   * // => true
	   *
	   * _.isObject(_.noop);
	   * // => true
	   *
	   * _.isObject(null);
	   * // => false
	   */
	  function isObject$1(value) {
	    var type = typeof value;
	    return !!value && (type == 'object' || type == 'function');
	  }
	
	  /**
	   * Checks if `value` is object-like. A value is object-like if it's not `null`
	   * and has a `typeof` result of "object".
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   * @example
	   *
	   * _.isObjectLike({});
	   * // => true
	   *
	   * _.isObjectLike([1, 2, 3]);
	   * // => true
	   *
	   * _.isObjectLike(_.noop);
	   * // => false
	   *
	   * _.isObjectLike(null);
	   * // => false
	   */
	  function isObjectLike$1(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Checks if `value` is classified as a `Symbol` primitive or object.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	   * @example
	   *
	   * _.isSymbol(Symbol.iterator);
	   * // => true
	   *
	   * _.isSymbol('abc');
	   * // => false
	   */
	  function isSymbol$1(value) {
	    return typeof value == 'symbol' ||
	      (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
	  }
	
	  /**
	   * Converts `value` to a string. An empty string is returned for `null`
	   * and `undefined` values. The sign of `-0` is preserved.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.0.0
	   * @category Lang
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   * @example
	   *
	   * _.toString(null);
	   * // => ''
	   *
	   * _.toString(-0);
	   * // => '-0'
	   *
	   * _.toString([1, 2, 3]);
	   * // => '1,2,3'
	   */
	  function toString$1(value) {
	    return value == null ? '' : baseToString$1(value);
	  }
	
	  /**
	   * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	   * it's created. Arrays are created for missing index properties while objects
	   * are created for all other missing properties. Use `_.setWith` to customize
	   * `path` creation.
	   *
	   * **Note:** This method mutates `object`.
	   *
	   * @static
	   * @memberOf _
	   * @since 3.7.0
	   * @category Object
	   * @param {Object} object The object to modify.
	   * @param {Array|string} path The path of the property to set.
	   * @param {*} value The value to set.
	   * @returns {Object} Returns `object`.
	   * @example
	   *
	   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	   *
	   * _.set(object, 'a[0].b.c', 4);
	   * console.log(object.a[0].b.c);
	   * // => 4
	   *
	   * _.set(object, ['x', '0', 'y', 'z'], 5);
	   * console.log(object.x[0].y.z);
	   * // => 5
	   */
	  function set$1(object, path, value) {
	    return object == null ? object : baseSet(object, path, value);
	  }
	
	  var lodash_set = set$1;
	
	  /*! *****************************************************************************
	  Copyright (c) Microsoft Corporation. All rights reserved.
	  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	  this file except in compliance with the License. You may obtain a copy of the
	  License at http://www.apache.org/licenses/LICENSE-2.0
	
	  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	  MERCHANTABLITY OR NON-INFRINGEMENT.
	
	  See the Apache Version 2.0 License for specific language governing permissions
	  and limitations under the License.
	  ***************************************************************************** */
	  /* global Reflect, Promise */
	
	  var extendStatics = function(d, b) {
	      extendStatics = Object.setPrototypeOf ||
	          ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	          function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	      return extendStatics(d, b);
	  };
	
	  function __extends(d, b) {
	      extendStatics(d, b);
	      function __() { this.constructor = d; }
	      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	  }
	
	  var __assign = function() {
	      __assign = Object.assign || function __assign(t) {
	          for (var s, i = 1, n = arguments.length; i < n; i++) {
	              s = arguments[i];
	              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	          }
	          return t;
	      };
	      return __assign.apply(this, arguments);
	  };
	
	  function __rest(s, e) {
	      var t = {};
	      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	          t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === "function")
	          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                  t[p[i]] = s[p[i]];
	          }
	      return t;
	  }
	
	  function __decorate(decorators, target, key, desc) {
	      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	      else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	      return c > 3 && r && Object.defineProperty(target, key, r), r;
	  }
	
	  function __param(paramIndex, decorator) {
	      return function (target, key) { decorator(target, key, paramIndex); }
	  }
	
	  function __metadata(metadataKey, metadataValue) {
	      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	  }
	
	  function __awaiter(thisArg, _arguments, P, generator) {
	      return new (P || (P = Promise))(function (resolve, reject) {
	          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	          function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	          step((generator = generator.apply(thisArg, _arguments || [])).next());
	      });
	  }
	
	  function __generator(thisArg, body) {
	      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	      function verb(n) { return function (v) { return step([n, v]); }; }
	      function step(op) {
	          if (f) throw new TypeError("Generator is already executing.");
	          while (_) try {
	              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	              if (y = 0, t) op = [op[0] & 2, t.value];
	              switch (op[0]) {
	                  case 0: case 1: t = op; break;
	                  case 4: _.label++; return { value: op[1], done: false };
	                  case 5: _.label++; y = op[1]; op = [0]; continue;
	                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                  default:
	                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                      if (t[2]) _.ops.pop();
	                      _.trys.pop(); continue;
	              }
	              op = body.call(thisArg, _);
	          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	      }
	  }
	
	  function __exportStar(m, exports) {
	      for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	  }
	
	  function __values(o) {
	      var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	      if (m) return m.call(o);
	      return {
	          next: function () {
	              if (o && i >= o.length) o = void 0;
	              return { value: o && o[i++], done: !o };
	          }
	      };
	  }
	
	  function __read(o, n) {
	      var m = typeof Symbol === "function" && o[Symbol.iterator];
	      if (!m) return o;
	      var i = m.call(o), r, ar = [], e;
	      try {
	          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	      }
	      catch (error) { e = { error: error }; }
	      finally {
	          try {
	              if (r && !r.done && (m = i["return"])) m.call(i);
	          }
	          finally { if (e) throw e.error; }
	      }
	      return ar;
	  }
	
	  function __spread() {
	      for (var ar = [], i = 0; i < arguments.length; i++)
	          ar = ar.concat(__read(arguments[i]));
	      return ar;
	  }
	
	  function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	              r[k] = a[j];
	      return r;
	  }
	  function __await(v) {
	      return this instanceof __await ? (this.v = v, this) : new __await(v);
	  }
	
	  function __asyncGenerator(thisArg, _arguments, generator) {
	      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	      var g = generator.apply(thisArg, _arguments || []), i, q = [];
	      return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	      function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	      function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	      function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	      function fulfill(value) { resume("next", value); }
	      function reject(value) { resume("throw", value); }
	      function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	  }
	
	  function __asyncDelegator(o) {
	      var i, p;
	      return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	      function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	  }
	
	  function __asyncValues(o) {
	      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	      var m = o[Symbol.asyncIterator], i;
	      return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	      function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	      function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	  }
	
	  function __makeTemplateObject(cooked, raw) {
	      if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	      return cooked;
	  }
	  function __importStar(mod) {
	      if (mod && mod.__esModule) return mod;
	      var result = {};
	      if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	      result.default = mod;
	      return result;
	  }
	
	  function __importDefault(mod) {
	      return (mod && mod.__esModule) ? mod : { default: mod };
	  }
	
	  var tslib_es6 = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    __extends: __extends,
	    get __assign () { return __assign; },
	    __rest: __rest,
	    __decorate: __decorate,
	    __param: __param,
	    __metadata: __metadata,
	    __awaiter: __awaiter,
	    __generator: __generator,
	    __exportStar: __exportStar,
	    __values: __values,
	    __read: __read,
	    __spread: __spread,
	    __spreadArrays: __spreadArrays,
	    __await: __await,
	    __asyncGenerator: __asyncGenerator,
	    __asyncDelegator: __asyncDelegator,
	    __asyncValues: __asyncValues,
	    __makeTemplateObject: __makeTemplateObject,
	    __importStar: __importStar,
	    __importDefault: __importDefault
	  });
	
	  var Cache_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });
	  /**
	   * Simple cache implementation
	   */
	  var Cache = /** @class */ (function () {
	      function Cache() {
	          this.data = {};
	          this.pending = {};
	      }
	      Cache.prototype.put = function (key, value) {
	          var previousValue = this.data[key];
	          this.data[key] = value;
	          return previousValue;
	      };
	      Cache.prototype.get = function (key) {
	          return this.data[key];
	      };
	      Cache.prototype.remove = function (key) {
	          var previousValue = this.data[key];
	          delete this.data[key];
	          return previousValue;
	      };
	      Cache.prototype.removeAll = function () {
	          this.data = {};
	      };
	      /**
	       * Gets a value from the cache or invokes the callback to populate the value
	       * with the result of a promise. If invoked multiple times, it will return the promise
	       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	       *
	       * @param key cache key
	       * @param callback returns a Promise to populate the cache with
	       * @returns Promise<*> a promise with the cached value
	       */
	      Cache.prototype.refreshIfAbsent = function (key, callback) {
	          if (this.data.hasOwnProperty(key)) {
	              return Promise.resolve(this.data[key]);
	          }
	          return this.refresh(key, callback);
	      };
	      /**
	       * Invokes the callback to populate the value with the result of a promise.
	       * If invoked multiple times, it will return the promise
	       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
	       *
	       * @param key cache key
	       * @param callback returns a Promise to populate the cache with
	       * @returns Promise<*> a promise with the cached value
	       */
	      Cache.prototype.refresh = function (key, callback) {
	          var _this = this;
	          // Check if the callback is already pending for this key
	          var pending = this.pending[key];
	          if (pending) {
	              return pending;
	          }
	          pending = callback();
	          this.pending[key] = pending;
	          return pending.then(function (value) {
	              delete _this.pending[key];
	              _this.put(key, value);
	              return value;
	          });
	      };
	      return Cache;
	  }());
	  exports.default = Cache;
	
	  });
	
	  unwrapExports(Cache_1);
	
	  var Registry_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });
	
	  var Cache_1$1 = tslib_es6.__importDefault(Cache_1);
	  exports.SERVICE_REGISTRY_PATH = '/api/portal/v1/client/config';
	  var PORTAL_SERVICE_NAME = 'portal_service';
	  var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
	  var DEFAULT_CONFIG = {
	      host: '',
	      cache: new Cache_1$1.default(),
	  };
	  var Registry = /** @class */ (function () {
	      function Registry(config) {
	          if (config === void 0) { config = DEFAULT_CONFIG; }
	          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
	      }
	      // Get the underlying registry cache
	      Registry.prototype.getCache = function () {
	          return this.config.cache;
	      };
	      Registry.prototype.getRegistry = function () {
	          var _this = this;
	          return this.config.cache.refreshIfAbsent('registry', function () {
	              var serviceRegistryUrl = _this.getHost();
	              serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
	              var config = {
	                  method: 'GET',
	                  mode: 'cors',
	                  credentials: 'include',
	                  headers: {
	                      'Content-Type': 'application/json',
	                  },
	              };
	              return fetch(serviceRegistryUrl, config).then(function (resp) {
	                  if (!resp.ok) {
	                      return Promise.reject(resp);
	                  }
	                  return resp.json().then(function (data) {
	                      var dataResponse = tslib_es6.__assign({ data: data }, resp);
	                      var registry = data.registry;
	                      // Optimization - also stuff the client config URL into the cache.
	                      // Sometimes, this URL can be different if it's requested from the same domain.
	                      var portalService = registry.services[PORTAL_SERVICE_NAME];
	                      if (portalService) {
	                          var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH);
	                          _this.config.cache.put(clientConfigUrl, dataResponse);
	                      }
	                      return dataResponse;
	                  });
	              });
	          }).then(function (resp) {
	              return resp.data.registry;
	          });
	      };
	      Registry.prototype.getUrl = function (serviceName, path, version) {
	          var _this = this;
	          if (path === void 0) { path = ''; }
	          return this.getRegistry().then(function (data) {
	              var service = data.services[serviceName];
	              if (service === undefined) {
	                  throw new Error("Unable to find service '" + serviceName + "'");
	              }
	              return service;
	          }).then(function (service) {
	              return _this.createServiceUrl(service, path, version);
	          });
	      };
	      Registry.prototype.getServiceBaseUrl = function (service, version) {
	          var baseUrl = service.base_sv_url;
	          if (!baseUrl) {
	              // unversioned service - simply return regular service url
	              return service.sv_url;
	          }
	          if (version === undefined) {
	              // Use configured version if present
	              // if(apiVersions[serviceName]) {
	              //  version = apiVersions[serviceName];
	              // Fallback to version 1 (keeps backwards comparability and generally safe)
	              version = 1;
	          }
	          return this.joinUrlParts(baseUrl, 'v' + version);
	      };
	      Registry.prototype.getServiceHostUrl = function (service) {
	          // Inspired by https://gist.github.com/jlong/2428561
	          var parser = document.createElement('a');
	          parser.href = service.sv_url;
	          return parser.protocol + "//" + parser.host;
	      };
	      Registry.prototype.createServiceUrl = function (service, path, version) {
	          var base;
	          if (path.charAt(0) === '/') {
	              // Host absolute URL
	              base = this.getServiceHostUrl(service);
	          }
	          else {
	              // Service relative URL
	              base = this.getServiceBaseUrl(service, version);
	          }
	          return this.joinUrlParts(base, path);
	      };
	      /**
	       * Determines the registry host in the following order,
	       * 1. Uses the configured host if set
	       * 2. If a PrintOS subdomain is detected as the current hostname,
	       *    the base domain is returned.
	       *    For example, if location.hostname is 'app.www.printos.com',
	       *    then 'www.printos.com' is returned.
	       * 3. Return an empty string otherwise (resulting in a registry call relative
	       *    to the current host).
	       */
	      Registry.prototype.getHost = function () {
	          if (this.config.host) {
	              // Ensure https
	              if (this.config.host.indexOf('https://') !== 0) {
	                  this.config.host = 'https://' + this.config.host;
	              }
	              return this.config.host;
	          }
	          return '';
	      };
	      Registry.prototype.joinUrlParts = function (a, b) {
	          if (!b) {
	              return a;
	          }
	          if (b.charAt(0) === '/') {
	              // Prevent double slashes by ensuring part b doesn't have a slash
	              b = b.substr(1);
	          }
	          if (a.charAt(a.length - 1) === '/') {
	              return a + b;
	          }
	          return a + '/' + b;
	      };
	      return Registry;
	  }());
	  exports.default = Registry;
	
	  });
	
	  unwrapExports(Registry_1);
	  var Registry_2 = Registry_1.SERVICE_REGISTRY_PATH;
	
	  var Http_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });
	
	  var Registry_1$1 = tslib_es6.__importDefault(Registry_1);
	  var DEFAULT_CONFIG = {
	      registry: new Registry_1$1.default(),
	  };
	  var Http = /** @class */ (function () {
	      function Http(config) {
	          if (config === void 0) { config = DEFAULT_CONFIG; }
	          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
	          // Use registry cache by default to cache the registry efficiently
	          this.config.cache = this.config.cache || this.config.registry.getCache();
	      }
	      Http.prototype.fetchJsonResponse = function (config) {
	          var _this = this;
	          var url = Http.formatUrl(config);
	          var fetchConfig = {
	              method: config.method,
	              mode: 'cors',
	              credentials: config.credentials ? config.credentials : 'include',
	              headers: {},
	          };
	          if (config.data !== undefined && config.data !== null) {
	              if (config.data instanceof FormData) {
	                  fetchConfig.body = config.data;
	                  // fetchConfig.headers['Content-Type'] = 'multipart/form-data';
	              }
	              else {
	                  fetchConfig.body = JSON.stringify(config.data);
	                  fetchConfig.headers['Content-Type'] = 'application/json';
	              }
	          }
	          return fetch(url, fetchConfig).then(function (resp) {
	              if (_this.responseInterceptor) {
	                  return _this.responseInterceptor(resp, config);
	              }
	              return resp;
	          }).then(function (resp) {
	              if (!resp.ok) {
	                  return Promise.reject(Object.assign(resp, { data: null }));
	              }
	              if (resp.status === 204) {
	                  return Promise.resolve(Object.assign(resp, { data: null }));
	              }
	              var contentType = resp.headers.get('Content-Type');
	              if (contentType === 'text/plain' || config.responseType === 'text') {
	                  return resp.text().then(function (data) {
	                      // Extend response to include data
	                      return Object.assign(resp, { data: data });
	                  });
	              }
	              return resp.json().then(function (data) {
	                  // Extend response to include data
	                  return Object.assign(resp, { data: data });
	              });
	          });
	      };
	      Http.formatUrl = function (config) {
	          var url = config.url;
	          if (config.params) {
	              if (url.includes('?')) {
	                  url += '&';
	              }
	              else {
	                  url += '?';
	              }
	              url += Http.getQueryString(config.params);
	          }
	          return url;
	      };
	      // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
	      Http.getQueryString = function (params) {
	          return Object.keys(params).map(function (k) {
	              var param = params[k];
	              if (Array.isArray(param)) {
	                  return param
	                      .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
	                      .join('&');
	              }
	              return encodeURIComponent(k) + "=" + encodeURIComponent(param);
	          }).join('&');
	      };
	      Http.prototype.request = function (config) {
	          var _this = this;
	          if (config === void 0) { config = {}; }
	          if (config.cache === true) {
	              return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
	                  return _this.fetchJsonResponse(config);
	              });
	          }
	          if (config.cache === 'refresh') {
	              return this.config.cache.refresh(Http.formatUrl(config), function () {
	                  return _this.fetchJsonResponse(config);
	              });
	          }
	          return this.fetchJsonResponse(config);
	      };
	      Http.prototype.serviceRequest = function (serviceName, path, config) {
	          var _this = this;
	          if (config === void 0) { config = {}; }
	          return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
	              config.url = url;
	              return _this.request(config);
	          });
	      };
	      //
	      // Shortcut methods
	      //
	      Http.prototype.get = function (serviceName, path, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'GET';
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.post = function (serviceName, path, data, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'POST';
	          config.data = data;
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.put = function (serviceName, path, data, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'PUT';
	          config.data = data;
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.patch = function (serviceName, path, data, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'PATCH';
	          config.data = data;
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.delete = function (serviceName, path, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'DELETE';
	          return this.serviceRequest(serviceName, path, config);
	      };
	      Http.prototype.head = function (serviceName, path, config) {
	          if (config === void 0) { config = {}; }
	          config.method = 'HEAD';
	          return this.serviceRequest(serviceName, path, config);
	      };
	      return Http;
	  }());
	  exports.default = Http;
	
	  });
	
	  unwrapExports(Http_1);
	
	  var Preferences_1 = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });
	
	  var Http_1$1 = tslib_es6.__importDefault(Http_1);
	  var DEFAULT_CONFIG = {
	      http: new Http_1$1.default(),
	  };
	  var Preferences = /** @class */ (function () {
	      function Preferences(config) {
	          if (config === void 0) { config = DEFAULT_CONFIG; }
	          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
	      }
	      Preferences.prototype.get = function (path, cache) {
	          if (path === void 0) { path = null; }
	          if (cache === void 0) { cache = true; }
	          var reqPath = 'preferences';
	          if (path) {
	              reqPath += '/' + path;
	          }
	          return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
	              return resp.data;
	          });
	      };
	      Preferences.prototype.update = function (prefs) {
	          return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
	              return resp.data;
	          });
	      };
	      Preferences.prototype.patch = function (path, prefs) {
	          return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
	              return resp.data;
	          });
	      };
	      Preferences.prototype.delete = function (path) {
	          return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
	              return resp.data;
	          });
	      };
	      Preferences.prototype.deleteAll = function () {
	          return this.config.http.delete('portal_service', 'preferences', { version: 2 });
	      };
	      return Preferences;
	  }());
	  exports.default = Preferences;
	
	  });
	
	  unwrapExports(Preferences_1);
	
	  var dist = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", { value: true });
	
	  var Cache_1$1 = tslib_es6.__importDefault(Cache_1);
	  var Registry_1$1 = tslib_es6.__importDefault(Registry_1);
	  var Http_1$1 = tslib_es6.__importDefault(Http_1);
	  var Preferences_1$1 = tslib_es6.__importDefault(Preferences_1);
	  // TODO: move into Registry and have it listen for blue ready
	  function getRegistryHost() {
	      var host = '';
	      if (window.printos &&
	          window.printos.blue &&
	          window.printos.blue.ui &&
	          window.printos.blue.ui.registry) {
	          host = window.printos.blue.ui.registry.host;
	      }
	      return host;
	  }
	  exports.cache = new Cache_1$1.default();
	  exports.registry = new Registry_1$1.default({
	      cache: exports.cache,
	      host: getRegistryHost(),
	  });
	  exports.http = new Http_1$1.default({
	      cache: exports.cache,
	      registry: exports.registry
	  });
	  exports.preferences = new Preferences_1$1.default({ http: exports.http });
	
	  });
	
	  unwrapExports(dist);
	  var dist_1 = dist.cache;
	  var dist_2 = dist.registry;
	  var dist_3 = dist.http;
	  var dist_4 = dist.preferences;
	
	  /* src/ViewNav.svelte generated by Svelte v2.16.0 */
	
	  function viewName(_ref) {
	    var selectedId = _ref.selectedId,
	        views = _ref.views;
	
	    if (!selectedId) {
	      return '';
	    }
	
	    var selectedView = views.find(function (view) {
	      return view.id === selectedId;
	    });
	
	    if (!selectedView) {
	      for (var i = 0; i < views.length; i++) {
	        if (!views[i].children) {
	          continue;
	        }
	
	        selectedView = views[i].children.find(function (childView) {
	          return childView.id === selectedId;
	        });
	
	        if (selectedView) {
	          break;
	        }
	      }
	    } //this.set({ selectedParentId });
	
	
	    return selectedView ? selectedView.name : '';
	  }
	
	  function data() {
	    return {
	      menuExpanded: false,
	      views: [],
	      keyEventListener: null,
	      selectedId: null,
	      selectedParentId: null,
	      selectedGrandParentId: null,
	      isXS: false,
	      isNavUX: false,
	      responsiveExpanded: false,
	      resizeListener: null,
	      toggleListener: null,
	      expandedPrefs: null,
	      hideNav: false,
	      timeoutId: null,
	      showTooltips: true
	    };
	  }
	  var methods = {
	    handleMouseOver: function handleMouseOver(event) {
	      var _this = this;
	
	      this.set({
	        showTooltips: true
	      });
	
	      var _this$get = this.get(),
	          timeoutId = _this$get.timeoutId,
	          menuExpanded = _this$get.menuExpanded;
	
	      if (menuExpanded) {
	        return;
	      }
	
	      if (timeoutId) {
	        clearTimeout(timeoutId);
	      }
	
	      timeoutId = setTimeout(function () {
	        _this.set({
	          menuExpanded: true,
	          timeoutId: null
	        });
	      }, 2000);
	      this.set({
	        timeoutId: timeoutId
	      });
	    },
	    handleMouseLeave: function handleMouseLeave(event) {
	      var _this$get2 = this.get(),
	          timeoutId = _this$get2.timeoutId;
	
	      if (timeoutId) {
	        clearTimeout(timeoutId);
	      }
	
	      collapseAllSubViews.call(this);
	      this.set({
	        timeoutId: null,
	        menuExpanded: false
	      });
	    },
	    hideTooltips: function hideTooltips() {
	      var _this$get3 = this.get(),
	          timeoutId = _this$get3.timeoutId;
	
	      if (timeoutId) {
	        clearTimeout(timeoutId);
	      }
	
	      this.set({
	        showTooltips: false
	      });
	    },
	    hideAndCollapse: function hideAndCollapse() {
	      var _this$get4 = this.get(),
	          timeoutId = _this$get4.timeoutId;
	
	      if (timeoutId) {
	        clearTimeout(timeoutId);
	      }
	
	      collapseAllSubViews.call(this);
	      this.set({
	        showTooltips: false,
	        menuExpanded: false
	      });
	    },
	    toggleResponsive: function toggleResponsive() {
	      var _this$get5 = this.get(),
	          responsiveExpanded = _this$get5.responsiveExpanded;
	
	      this.set({
	        responsiveExpanded: !responsiveExpanded
	      });
	    },
	    toggleNav: function toggleNav(event) {
	      event.stopPropagation();
	
	      var _this$get6 = this.get(),
	          views = _this$get6.views,
	          menuExpanded = _this$get6.menuExpanded,
	          timeoutId = _this$get6.timeoutId;
	
	      if (timeoutId) {
	        clearTimeout(timeoutId);
	        this.set({
	          timeoutId: null
	        });
	      }
	
	      menuExpanded = !menuExpanded;
	      this.set({
	        views: views,
	        menuExpanded: menuExpanded
	      });
	    },
	    expandNav: function expandNav(event) {
	      var _this$get7 = this.get(),
	          views = _this$get7.views,
	          timeoutId = _this$get7.timeoutId;
	
	      if (timeoutId) {
	        clearTimeout(timeoutId);
	        this.set({
	          timeoutId: null
	        });
	      }
	
	      this.set({
	        views: views,
	        menuExpanded: true
	      });
	    },
	    viewClicked: function viewClicked(event, view) {
	      event.stopPropagation();
	
	      var _this$get8 = this.get(),
	          views = _this$get8.views,
	          menuExpanded = _this$get8.menuExpanded,
	          timeoutId = _this$get8.timeoutId;
	
	      if (timeoutId) {
	        clearTimeout(timeoutId);
	        this.set({
	          timeoutId: null
	        });
	      }
	
	      if (view.childViews && view.childViews.length > 0) {
	        var myView = views.find(function (v) {
	          return view.id === v.id;
	        });
	        myView.isExpanded = !myView.isExpanded;
	        this.set({
	          views: views,
	          menuExpanded: true
	        });
	        event.preventDefault();
	        return;
	      }
	
	      collapseAllSubViews.call(this);
	      this.set({
	        showTooltips: false,
	        menuExpanded: false,
	        responsiveExpanded: false
	      }); // Adapted from vue-router: https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L105-L122
	      // don't redirect with control keys
	
	      if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
	        return;
	      } // don't redirect when preventDefault called
	
	
	      if (event.defaultPrevented) {
	        return;
	      } // don't redirect on right click
	
	
	      if (event.button !== undefined && event.button !== 0) {
	        return;
	      } // don't redirect if `target="_blank"`
	
	
	      if (event.currentTarget && event.currentTarget.getAttribute) {
	        var target = event.currentTarget.getAttribute('target');
	
	        if (/\b_blank\b/i.test(target)) {
	          return;
	        }
	      }
	
	      this.fire('viewClicked', {
	        event: event,
	        view: view
	      });
	    },
	    updateSelection: function updateSelection() {
	      var _this$get9 = this.get(),
	          selectedId = _this$get9.selectedId,
	          selectedParentId = _this$get9.selectedParentId,
	          selectedGrandParentId = _this$get9.selectedGrandParentId,
	          views = _this$get9.views;
	
	      if (!selectedId || views.length === 0) {
	        return;
	      }
	
	      selectedParentId = null;
	      selectedGrandParentId = null;
	      var selectedView = views.find(function (view) {
	        return view.id === selectedId;
	      });
	
	      if (selectedView) {
	        selectedParentId = selectedView.id;
	      } else {
	        for (var i = 0; i < views.length; i++) {
	          if (!views[i].children) {
	            continue;
	          }
	
	          for (var j = 0; j < views[i].children.length; j++) {
	            var childView = views[i].children[j];
	
	            if (childView.id === selectedId) {
	              selectedParentId = views[i].id;
	              break;
	            } else {
	              if (childView.children) {
	                var grandChild = childView.children.find(function (g) {
	                  return g.id === selectedId;
	                });
	
	                if (grandChild) {
	                  selectedParentId = childView.id;
	                  selectedGrandParentId = views[i].id;
	                  break;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      this.set({
	        selectedParentId: selectedParentId,
	        selectedGrandParentId: selectedGrandParentId
	      });
	    }
	  };
	
	  function oncreate() {
	    //Get appId, orgId, preferences
	    //Store preferences in data
	    this.set({
	      preferenceService: dist_4
	    });
	    var toggleListener = this.toggleResponsive.bind(this);
	    window.addEventListener('posb-view-nav-toggle-clicked', toggleListener);
	    this.set({
	      toggleListener: toggleListener
	    });
	  }
	
	  function ondestroy() {
	    var _this$get10 = this.get(),
	        resizeListener = _this$get10.resizeListener;
	
	    window.removeEventListener('resize', resizeListener);
	    window.removeEventListener('posb-viewnav-toggle-clicked', toggleListener);
	  }
	
	  function onstate(_ref2) {
	    var changed = _ref2.changed,
	        current = _ref2.current,
	        previous = _ref2.previous;
	
	    if (changed.selectedId) {
	      this.updateSelection();
	    }
	
	    if (changed.views) {
	      // get preferences
	      var _this$get11 = this.get(),
	          views = _this$get11.views,
	          resizeListener = _this$get11.resizeListener;
	
	      if (views && views.length > 0) {
	        // get expanded preferences let expandedPreferences = get(preferences, 'orgId.appId.viewNav.expanded', []);
	        views.forEach(function (view) {
	          view.childViews = [];
	
	          if (view.children) {
	            view.children.forEach(function (childView) {
	              var showInNav = lodash_get(childView, 'showInNav', true);
	
	              if (showInNav) {
	                view.childViews.push(childView);
	              }
	            });
	          } // If expandedPreferences.contains(view.id) then view.isExpanded = true;
	
	        });
	
	        if (!resizeListener) {
	          resizeListener = handleWindowResize.bind(this);
	          handleWindowResize.call(this);
	          window.addEventListener('resize', resizeListener);
	        }
	
	        this.set({
	          views: views,
	          resizeListener: resizeListener
	        });
	        this.updateSelection();
	      }
	    }
	  }
	
	  function slideRight(node, _ref3) {
	    var _ref3$delay = _ref3.delay,
	        delay = _ref3$delay === void 0 ? 0 : _ref3$delay,
	        _ref3$duration = _ref3.duration,
	        duration = _ref3$duration === void 0 ? 250 : _ref3$duration,
	        _ref3$easing = _ref3.easing;
	    var style = window.getComputedStyle(node);
	    var width = window.parseFloat(style.width);
	    return {
	      delay: delay,
	      duration: duration,
	      css: function css(t) {
	        return "width: ".concat(t * width, "px;");
	      }
	    };
	  }
	  var slideDown = slide;
	
	  function positionDescription(node) {
	    var viewContent = node.closest('.view-content');
	
	    var mouseEnterListener = function mouseEnterListener() {
	      var viewContentRect = viewContent.getBoundingClientRect();
	      node.style.top = "".concat(viewContentRect.top, "px"); // Set display here instead of in CSS to ensure positioning
	
	      node.style.display = 'inherit';
	    };
	
	    var mouseLeaveListener = function mouseLeaveListener() {
	      node.style.display = '';
	    };
	
	    viewContent.addEventListener('mouseenter', mouseEnterListener);
	    viewContent.addEventListener('mouseleave', mouseLeaveListener);
	    return {
	      destroy: function destroy() {
	        viewContent.removeEventListener('mouseenter', mouseEnterListener);
	        viewContent.removeEventListener('mouseleave', mouseLeaveListener);
	      }
	    };
	  }
	
	  function addHref(node, href) {
	    if (href) {
	      node.setAttribute('href', href);
	    }
	  }
	
	  function handleWindowResize() {
	    var isXS = window.innerWidth < 600;
	    lodash_set(window, 'printos.blue.ui.responsiveMenu', isXS);
	    this.set({
	      isXS: isXS
	    });
	  }
	
	  function collapseAllSubViews() {
	    var _this$get12 = this.get(),
	        views = _this$get12.views;
	
	    views.forEach(function (view) {
	      if (view.childViews && view.childViews.length > 0) {
	        view.isExpanded = false;
	      }
	    });
	    this.set({
	      views: views
	    });
	  }
	
	  function add_css() {
	    var style = createElement("style");
	    style.id = 'svelte-123oly2-style';
	    style.textContent = ".pros-view.svelte-123oly2{display:flex;flex-direction:column;box-sizing:border-box;min-width:100%;min-height:100%}@media(max-width: 1199px){.pros-view.svelte-123oly2{padding:0 1%}}.pros-view-nav.svelte-123oly2{position:relative;width:60px;height:100%;font-family:Roboto, \"Helvetica Neue\", sans-serif;font-size:16px;box-sizing:border-box}.pros-view-nav.hideNav.svelte-123oly2{display:none}.pros-view-nav.svelte-123oly2 .view-content-container.svelte-123oly2{overflow:hidden}.pros-view-nav.is-xs.svelte-123oly2{width:0}.pros-view-nav.is-xs.svelte-123oly2 .pros-view-nav-content.svelte-123oly2{width:0;box-shadow:2px 2px 3px 0 rgba(0, 0, 0, 0.25)}.pros-view-nav.is-xs.svelte-123oly2 .pros-view-nav-content.responsive-expanded.svelte-123oly2{width:250px}.pros-view-nav.svelte-123oly2 .pros-view-nav-content.svelte-123oly2{position:absolute;left:0;top:0;bottom:0;transition:width 0.25s ease-out;width:60px;z-index:30;background-color:#FFFFFF;border-right:1px solid #CCCCCC;overflow:auto;scrollbar-color:#CCCCCC transparent;scrollbar-width:thin}.pros-view-nav.svelte-123oly2 .pros-view-nav-content.expanded.svelte-123oly2:not(.is-xs){width:250px;box-shadow:2px 2px 3px 0 rgba(0, 0, 0, 0.25)}.pros-view-nav.svelte-123oly2 .pros-view-nav-content.expanded:not(.is-xs) .child-views .view-content.svelte-123oly2{padding-left:64px}.pros-view-nav.svelte-123oly2 svg{fill:currentColor;width:100%;height:100%;pointer-events:none}.pros-view-nav.svelte-123oly2 .view-name-tooltip.svelte-123oly2{display:none;position:fixed;border:1px solid #F3F3F3;border-radius:3px;max-width:200px;min-width:100px;padding:8px;transform:translate(64px, 0);background-color:#FFFFFF;color:#5A5A5A;box-shadow:2px 2px 3px 0 rgba(0, 0, 0, 0.25);overflow:hidden}.pros-view-nav.svelte-123oly2 .view-description.svelte-123oly2{display:none;position:fixed;border:1px solid #F3F3F3;border-radius:3px;max-width:240px;padding:8px;transform:translate(254px, 0);background-color:#f4f4f4;color:#5A5A5A;box-shadow:2px 2px 3px 0 rgba(0, 0, 0, 0.25);overflow:hidden;word-break:break-word;overflow-wrap:anywhere}.pros-view-nav.svelte-123oly2 .child-views .view-content .view-name-tooltip.svelte-123oly2{transform:translate(56px, 0)}.pros-view-nav.svelte-123oly2 .child-views .view-content .view-description.svelte-123oly2{transform:translate(190px, 0)}.pros-view-nav.svelte-123oly2 .view-content.svelte-123oly2{position:relative;display:flex;justify-content:flex-start;align-items:center;height:50px;cursor:pointer}.pros-view-nav.svelte-123oly2 .view-content.svelte-123oly2:hover{background-color:#EEEEEE}.pros-view-nav.svelte-123oly2 .view-content a.svelte-123oly2{line-height:50px}.pros-view-nav.svelte-123oly2 .view-content.is-nav-ux .view-link .view-icon.svelte-123oly2{height:32px;line-height:32px}.pros-view-nav.svelte-123oly2 .view-content .view-link.svelte-123oly2{cursor:pointer;display:flex;justify-content:flex-start;align-items:center;width:100%;text-decoration:none;color:#666}.pros-view-nav.svelte-123oly2 .view-content .view-link .view-name.svelte-123oly2{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1}.pros-view-nav.svelte-123oly2 .view-content .view-link .view-icon-container.svelte-123oly2{width:60px;height:100%;flex-shrink:0}.pros-view-nav.svelte-123oly2 .view-content .view-link .view-icon.svelte-123oly2{height:24px;width:auto;line-height:24px}.pros-view-nav.svelte-123oly2 .view-content .expand-icon.svelte-123oly2{position:absolute;right:-4px;height:24px;width:24px;color:#666;transition:transform .5s ease,-webkit-transform .5s ease;transform:rotate(180deg)}.pros-view-nav.svelte-123oly2 .view-content .expand-icon.expanded.svelte-123oly2{transform:rotate(0)}.pros-view-nav.svelte-123oly2 .view-content.selected.svelte-123oly2{background-color:rgba(0, 150, 214, 0.1)}.pros-view-nav.svelte-123oly2 .view-content.selected .selected-indicator.svelte-123oly2{display:inherit}.pros-view-nav.svelte-123oly2 .view-content.selected .view-link.svelte-123oly2{color:#0096d6}.pros-view-nav.svelte-123oly2 .view-content .selected-indicator.svelte-123oly2{display:none;position:absolute;left:0;top:0;background-color:#0096d6;width:2px;height:100%}.pros-view-nav.svelte-123oly2 .child-views .view-content.svelte-123oly2{padding-left:8px}.pros-view-nav.svelte-123oly2 ::-webkit-scrollbar{width:2px}";
	    append(document.head, style);
	  }
	
	  function click_handler_1(event) {
	    var _this$_svelte = this._svelte,
	        component = _this$_svelte.component,
	        ctx = _this$_svelte.ctx;
	    component.viewClicked(event, ctx.childView);
	  }
	
	  function mouseenter_handler_3(event) {
	    var component = this._svelte.component;
	    component.hideAndCollapse();
	  }
	
	  function mouseenter_handler_2(event) {
	    var component = this._svelte.component;
	    component.hideTooltips();
	  }
	
	  function get_each_context_1(ctx, list, i) {
	    var child_ctx = Object.create(ctx);
	    child_ctx.childView = list[i];
	    return child_ctx;
	  }
	
	  function click_handler(event) {
	    var _this$_svelte2 = this._svelte,
	        component = _this$_svelte2.component,
	        ctx = _this$_svelte2.ctx;
	    component.viewClicked(event, ctx.view);
	  }
	
	  function mouseenter_handler_1(event) {
	    var component = this._svelte.component;
	    component.hideAndCollapse();
	  }
	
	  function mouseenter_handler(event) {
	    var component = this._svelte.component;
	    component.hideTooltips();
	  }
	
	  function get_each_context(ctx, list, i) {
	    var child_ctx = Object.create(ctx);
	    child_ctx.view = list[i];
	    return child_ctx;
	  }
	
	  function create_main_fragment(component, ctx) {
	    var if_block_anchor;
	    var if_block = ctx.views && ctx.views.length > 0 && create_if_block(component, ctx);
	    return {
	      c: function c() {
	        if (if_block) if_block.c();
	        if_block_anchor = createComment();
	      },
	      m: function m(target, anchor) {
	        if (if_block) if_block.i(target, anchor);
	        insert(target, if_block_anchor, anchor);
	      },
	      p: function p(changed, ctx) {
	        if (ctx.views && ctx.views.length > 0) {
	          if (if_block) {
	            if_block.p(changed, ctx);
	          } else {
	            if_block = create_if_block(component, ctx);
	            if (if_block) if_block.c();
	          }
	
	          if_block.i(if_block_anchor.parentNode, if_block_anchor);
	        } else if (if_block) {
	          groupOutros();
	          if_block.o(function () {
	            if_block.d(1);
	            if_block = null;
	          });
	        }
	      },
	      d: function d(detach) {
	        if (if_block) if_block.d(detach);
	
	        if (detach) {
	          detachNode(if_block_anchor);
	        }
	      }
	    };
	  } // (2:0) {#if views && views.length > 0}
	
	
	  function create_if_block(component, ctx) {
	    var div1,
	        div0,
	        each_blocks_1 = [],
	        each_lookup = blankObject(),
	        div0_transition,
	        current;
	    var each_value = ctx.views;
	
	    var get_key = function get_key(ctx) {
	      return ctx.view.id;
	    };
	
	    for (var i = 0; i < each_value.length; i += 1) {
	      var child_ctx = get_each_context(ctx, each_value, i);
	      var key = get_key(child_ctx);
	      each_blocks_1[i] = each_lookup[key] = create_each_block(component, key, child_ctx);
	    }
	
	    function mousemove_handler(event) {
	      component.handleMouseOver(event);
	    }
	
	    function mouseleave_handler(event) {
	      component.handleMouseLeave(event);
	    }
	
	    function click_handler_2(event) {
	      component.expandNav(event);
	    }
	
	    return {
	      c: function c() {
	        div1 = createElement("div");
	        div0 = createElement("div");
	
	        for (i = 0; i < each_blocks_1.length; i += 1) {
	          each_blocks_1[i].c();
	        }
	
	        addListener(div0, "mousemove", mousemove_handler);
	        addListener(div0, "mouseleave", mouseleave_handler);
	        div0.className = "pros-view-nav-content svelte-123oly2";
	        toggleClass(div0, "expanded", ctx.menuExpanded);
	        toggleClass(div0, "responsive-expanded", ctx.responsiveExpanded);
	        toggleClass(div0, "is-xs", ctx.isXS);
	        addListener(div1, "click", click_handler_2);
	        div1.className = "pros-view-nav svelte-123oly2";
	        toggleClass(div1, "is-xs", ctx.isXS);
	        toggleClass(div1, "hideNav", ctx.hideNav);
	      },
	      m: function m(target, anchor) {
	        insert(target, div1, anchor);
	        append(div1, div0);
	
	        for (i = 0; i < each_blocks_1.length; i += 1) {
	          each_blocks_1[i].m(div0, null);
	        }
	
	        current = true;
	      },
	      p: function p(changed, ctx) {
	        var each_value = ctx.views;
	        each_blocks_1 = updateKeyedEach(each_blocks_1, component, changed, get_key, 1, ctx, each_value, each_lookup, div0, destroyBlock, create_each_block, "m", null, get_each_context);
	
	        if (changed.menuExpanded) {
	          toggleClass(div0, "expanded", ctx.menuExpanded);
	        }
	
	        if (changed.responsiveExpanded) {
	          toggleClass(div0, "responsive-expanded", ctx.responsiveExpanded);
	        }
	
	        if (changed.isXS) {
	          toggleClass(div0, "is-xs", ctx.isXS);
	          toggleClass(div1, "is-xs", ctx.isXS);
	        }
	
	        if (changed.hideNav) {
	          toggleClass(div1, "hideNav", ctx.hideNav);
	        }
	      },
	      i: function i(target, anchor) {
	        if (current) return;
	
	        if (component.root._intro) {
	          if (div0_transition) div0_transition.invalidate();
	
	          component.root._aftercreate.push(function () {
	            if (!div0_transition) div0_transition = wrapTransition(component, div0, slideRight, {}, true);
	            div0_transition.run(1);
	          });
	        }
	
	        this.m(target, anchor);
	      },
	      o: function o(outrocallback) {
	        if (!current) return;
	        if (!div0_transition) div0_transition = wrapTransition(component, div0, slideRight, {}, false);
	        div0_transition.run(0, function () {
	          outrocallback();
	          div0_transition = null;
	        });
	        current = false;
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div1);
	        }
	
	        for (i = 0; i < each_blocks_1.length; i += 1) {
	          each_blocks_1[i].d();
	        }
	
	        removeListener(div0, "mousemove", mousemove_handler);
	        removeListener(div0, "mouseleave", mouseleave_handler);
	
	        if (detach) {
	          if (div0_transition) div0_transition.abort();
	        }
	
	        removeListener(div1, "click", click_handler_2);
	      }
	    };
	  } // (24:10) {:else}
	
	
	  function create_else_block(component, ctx) {
	    var div;
	    return {
	      c: function c() {
	        div = createElement("div");
	        div.className = "no-view-icon svelte-123oly2";
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	      },
	      p: noop,
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	      }
	    };
	  } // (16:10) {#if view.icon}
	
	
	  function create_if_block_8(component, ctx) {
	    var if_block_anchor;
	    var if_block = ctx.view.icon.svg && create_if_block_9(component, ctx);
	    return {
	      c: function c() {
	        if (if_block) if_block.c();
	        if_block_anchor = createComment();
	      },
	      m: function m(target, anchor) {
	        if (if_block) if_block.m(target, anchor);
	        insert(target, if_block_anchor, anchor);
	      },
	      p: function p(changed, ctx) {
	        if (ctx.view.icon.svg) {
	          if (if_block) {
	            if_block.p(changed, ctx);
	          } else {
	            if_block = create_if_block_9(component, ctx);
	            if_block.c();
	            if_block.m(if_block_anchor.parentNode, if_block_anchor);
	          }
	        } else if (if_block) {
	          if_block.d(1);
	          if_block = null;
	        }
	      },
	      d: function d(detach) {
	        if (if_block) if_block.d(detach);
	
	        if (detach) {
	          detachNode(if_block_anchor);
	        }
	      }
	    };
	  } // (17:10) {#if view.icon.svg}
	
	
	  function create_if_block_9(component, ctx) {
	    var div1,
	        div0,
	        raw_value = ctx.view.icon.svg;
	    return {
	      c: function c() {
	        div1 = createElement("div");
	        div0 = createElement("div");
	        div0.className = "view-icon svelte-123oly2";
	        div1.className = "view-icon-container svelte-123oly2";
	      },
	      m: function m(target, anchor) {
	        insert(target, div1, anchor);
	        append(div1, div0);
	        div0.innerHTML = raw_value;
	      },
	      p: function p(changed, ctx) {
	        if (changed.views && raw_value !== (raw_value = ctx.view.icon.svg)) {
	          div0.innerHTML = raw_value;
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div1);
	        }
	      }
	    };
	  } // (29:8) {#if view.childViews.length > 0 && menuExpanded}
	
	
	  function create_if_block_7(component, ctx) {
	    var div;
	    return {
	      c: function c() {
	        div = createElement("div");
	        div.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" class=\"svelte-123oly2\"><path d=\"M7 14l5-5 5 5z\" class=\"svelte-123oly2\"></path><path d=\"M0 0h24v24H0z\" fill=\"none\" class=\"svelte-123oly2\"></path></svg>";
	        div.className = "expand-icon svelte-123oly2";
	        toggleClass(div, "expanded", ctx.view.isExpanded);
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	      },
	      p: function p(changed, ctx) {
	        if (changed.views) {
	          toggleClass(div, "expanded", ctx.view.isExpanded);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	      }
	    };
	  } // (35:8) {#if !menuExpanded && showTooltips && !isXS}
	
	
	  function create_if_block_6(component, ctx) {
	    var div,
	        text_value = ctx.view.name,
	        text,
	        positionDescription_action;
	    return {
	      c: function c() {
	        div = createElement("div");
	        text = createText(text_value);
	        div._svelte = {
	          component: component
	        };
	        addListener(div, "mouseenter", mouseenter_handler);
	        div.className = "view-name-tooltip svelte-123oly2";
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	        append(div, text);
	        positionDescription_action = positionDescription.call(component, div) || {};
	      },
	      p: function p(changed, ctx) {
	        if (changed.views && text_value !== (text_value = ctx.view.name)) {
	          setData(text, text_value);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	
	        removeListener(div, "mouseenter", mouseenter_handler);
	        if (positionDescription_action && typeof positionDescription_action.destroy === 'function') positionDescription_action.destroy.call(component);
	      }
	    };
	  } // (40:8) {#if menuExpanded && view.description && showTooltips && !isXS}
	
	
	  function create_if_block_5(component, ctx) {
	    var div,
	        wbr,
	        text_value = ctx.view.description,
	        text,
	        positionDescription_action;
	    return {
	      c: function c() {
	        div = createElement("div");
	        wbr = createElement("wbr");
	        text = createText(text_value);
	        wbr.className = "svelte-123oly2";
	        div._svelte = {
	          component: component
	        };
	        addListener(div, "mouseenter", mouseenter_handler_1);
	        div.className = "view-description svelte-123oly2";
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	        append(div, wbr);
	        append(div, text);
	        positionDescription_action = positionDescription.call(component, div) || {};
	      },
	      p: function p(changed, ctx) {
	        if (changed.views && text_value !== (text_value = ctx.view.description)) {
	          setData(text, text_value);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	
	        removeListener(div, "mouseenter", mouseenter_handler_1);
	        if (positionDescription_action && typeof positionDescription_action.destroy === 'function') positionDescription_action.destroy.call(component);
	      }
	    };
	  } // (47:6) {#if view.childViews.length > 0 && view.isExpanded}
	
	
	  function create_if_block_1(component, ctx) {
	    var div,
	        each_blocks_1 = [],
	        each_lookup = blankObject(),
	        div_transition,
	        current;
	    var each_value_1 = ctx.view.childViews;
	
	    var get_key = function get_key(ctx) {
	      return ctx.childView.id;
	    };
	
	    for (var i = 0; i < each_value_1.length; i += 1) {
	      var child_ctx = get_each_context_1(ctx, each_value_1, i);
	      var key = get_key(child_ctx);
	      each_blocks_1[i] = each_lookup[key] = create_each_block_1(component, key, child_ctx);
	    }
	
	    return {
	      c: function c() {
	        div = createElement("div");
	
	        for (i = 0; i < each_blocks_1.length; i += 1) {
	          each_blocks_1[i].c();
	        }
	
	        div.className = "child-views svelte-123oly2";
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	
	        for (i = 0; i < each_blocks_1.length; i += 1) {
	          each_blocks_1[i].m(div, null);
	        }
	
	        current = true;
	      },
	      p: function p(changed, ctx) {
	        var each_value_1 = ctx.view.childViews;
	        each_blocks_1 = updateKeyedEach(each_blocks_1, component, changed, get_key, 1, ctx, each_value_1, each_lookup, div, destroyBlock, create_each_block_1, "m", null, get_each_context_1);
	      },
	      i: function i(target, anchor) {
	        if (current) return;
	
	        if (component.root._intro) {
	          if (div_transition) div_transition.invalidate();
	
	          component.root._aftercreate.push(function () {
	            if (!div_transition) div_transition = wrapTransition(component, div, slideDown, {}, true);
	            div_transition.run(1);
	          });
	        }
	
	        this.m(target, anchor);
	      },
	      o: function o(outrocallback) {
	        if (!current) return;
	        if (!div_transition) div_transition = wrapTransition(component, div, slideDown, {}, false);
	        div_transition.run(0, function () {
	          outrocallback();
	          div_transition = null;
	        });
	        current = false;
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	
	        for (i = 0; i < each_blocks_1.length; i += 1) {
	          each_blocks_1[i].d();
	        }
	
	        if (detach) {
	          if (div_transition) div_transition.abort();
	        }
	      }
	    };
	  } // (62:12) {#if childView.description && showTooltips && !isXS}
	
	
	  function create_if_block_4(component, ctx) {
	    var div,
	        wbr,
	        text_value = ctx.childView.description,
	        text,
	        positionDescription_action;
	    return {
	      c: function c() {
	        div = createElement("div");
	        wbr = createElement("wbr");
	        text = createText(text_value);
	        wbr.className = "svelte-123oly2";
	        div._svelte = {
	          component: component
	        };
	        addListener(div, "mouseenter", mouseenter_handler_3);
	        div.className = "view-description svelte-123oly2";
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	        append(div, wbr);
	        append(div, text);
	        positionDescription_action = positionDescription.call(component, div) || {};
	      },
	      p: function p(changed, ctx) {
	        if (changed.views && text_value !== (text_value = ctx.childView.description)) {
	          setData(text, text_value);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	
	        removeListener(div, "mouseenter", mouseenter_handler_3);
	        if (positionDescription_action && typeof positionDescription_action.destroy === 'function') positionDescription_action.destroy.call(component);
	      }
	    };
	  } // (55:10) {#if !menuExpanded && showTooltips && !isXS}
	
	
	  function create_if_block_2(component, ctx) {
	    var if_block_anchor;
	    var if_block = ctx.timeoutId && create_if_block_3(component, ctx);
	    return {
	      c: function c() {
	        if (if_block) if_block.c();
	        if_block_anchor = createComment();
	      },
	      m: function m(target, anchor) {
	        if (if_block) if_block.m(target, anchor);
	        insert(target, if_block_anchor, anchor);
	      },
	      p: function p(changed, ctx) {
	        if (ctx.timeoutId) {
	          if (if_block) {
	            if_block.p(changed, ctx);
	          } else {
	            if_block = create_if_block_3(component, ctx);
	            if_block.c();
	            if_block.m(if_block_anchor.parentNode, if_block_anchor);
	          }
	        } else if (if_block) {
	          if_block.d(1);
	          if_block = null;
	        }
	      },
	      d: function d(detach) {
	        if (if_block) if_block.d(detach);
	
	        if (detach) {
	          detachNode(if_block_anchor);
	        }
	      }
	    };
	  } // (56:12) {#if timeoutId}
	
	
	  function create_if_block_3(component, ctx) {
	    var div,
	        text_value = ctx.childView.name,
	        text,
	        positionDescription_action;
	    return {
	      c: function c() {
	        div = createElement("div");
	        text = createText(text_value);
	        div._svelte = {
	          component: component
	        };
	        addListener(div, "mouseenter", mouseenter_handler_2);
	        div.className = "view-name-tooltip svelte-123oly2";
	      },
	      m: function m(target, anchor) {
	        insert(target, div, anchor);
	        append(div, text);
	        positionDescription_action = positionDescription.call(component, div) || {};
	      },
	      p: function p(changed, ctx) {
	        if (changed.views && text_value !== (text_value = ctx.childView.name)) {
	          setData(text, text_value);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div);
	        }
	
	        removeListener(div, "mouseenter", mouseenter_handler_2);
	        if (positionDescription_action && typeof positionDescription_action.destroy === 'function') positionDescription_action.destroy.call(component);
	      }
	    };
	  } // (49:8) {#each view.childViews as childView (childView.id)}
	
	
	  function create_each_block_1(component, key_1, ctx) {
	    var div2,
	        a,
	        div0,
	        text0_value = ctx.childView.name,
	        text0,
	        addHref_action,
	        text1,
	        div1,
	        text2,
	        div2_id_value;
	
	    function select_block_type_1(ctx) {
	      if (!ctx.menuExpanded && ctx.showTooltips && !ctx.isXS) return create_if_block_2;
	      if (ctx.childView.description && ctx.showTooltips && !ctx.isXS) return create_if_block_4;
	    }
	
	    var current_block_type = select_block_type_1(ctx);
	    var if_block = current_block_type && current_block_type(component, ctx);
	    return {
	      key: key_1,
	      first: null,
	      c: function c() {
	        div2 = createElement("div");
	        a = createElement("a");
	        div0 = createElement("div");
	        text0 = createText(text0_value);
	        text1 = createText("\n          ");
	        div1 = createElement("div");
	        text2 = createText("\n          ");
	        if (if_block) if_block.c();
	        setAttribute(div0, "pros-tooltip", "");
	        div0.className = "view-name svelte-123oly2";
	        a.className = "view-link svelte-123oly2";
	        div1.className = "selected-indicator svelte-123oly2";
	        div2._svelte = {
	          component: component,
	          ctx: ctx
	        };
	        addListener(div2, "click", click_handler_1);
	        div2.id = div2_id_value = "view-" + ctx.childView.id;
	        div2.className = "view-content svelte-123oly2";
	        toggleClass(div2, "selected", ctx.childView.id === ctx.selectedId || ctx.childView.id === ctx.selectedParentId);
	        this.first = div2;
	      },
	      m: function m(target, anchor) {
	        insert(target, div2, anchor);
	        append(div2, a);
	        append(a, div0);
	        append(div0, text0);
	        addHref_action = addHref.call(component, a, ctx.childView.href) || {};
	        append(div2, text1);
	        append(div2, div1);
	        append(div2, text2);
	        if (if_block) if_block.m(div2, null);
	      },
	      p: function p(changed, _ctx) {
	        ctx = _ctx;
	
	        if (changed.views && text0_value !== (text0_value = ctx.childView.name)) {
	          setData(text0, text0_value);
	        }
	
	        if (typeof addHref_action.update === 'function' && changed.views) {
	          addHref_action.update.call(component, ctx.childView.href);
	        }
	
	        if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block) {
	          if_block.p(changed, ctx);
	        } else {
	          if (if_block) if_block.d(1);
	          if_block = current_block_type && current_block_type(component, ctx);
	          if (if_block) if_block.c();
	          if (if_block) if_block.m(div2, null);
	        }
	
	        div2._svelte.ctx = ctx;
	
	        if (changed.views && div2_id_value !== (div2_id_value = "view-" + ctx.childView.id)) {
	          div2.id = div2_id_value;
	        }
	
	        if (changed.views || changed.selectedId || changed.selectedParentId) {
	          toggleClass(div2, "selected", ctx.childView.id === ctx.selectedId || ctx.childView.id === ctx.selectedParentId);
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div2);
	        }
	
	        if (addHref_action && typeof addHref_action.destroy === 'function') addHref_action.destroy.call(component);
	        if (if_block) if_block.d();
	        removeListener(div2, "click", click_handler_1);
	      }
	    };
	  } // (12:4) {#each views as view (view.id)}
	
	
	  function create_each_block(component, key_1, ctx) {
	    var div3,
	        div2,
	        a,
	        text0,
	        div0,
	        text1_value = ctx.view.name,
	        text1,
	        addHref_action,
	        text2,
	        text3,
	        div1,
	        text4,
	        text5,
	        div2_id_value,
	        text6,
	        text7;
	
	    function select_block_type(ctx) {
	      if (ctx.view.icon) return create_if_block_8;
	      return create_else_block;
	    }
	
	    var current_block_type = select_block_type(ctx);
	    var if_block0 = current_block_type(component, ctx);
	    var if_block1 = ctx.view.childViews.length > 0 && ctx.menuExpanded && create_if_block_7(component, ctx);
	    var if_block2 = !ctx.menuExpanded && ctx.showTooltips && !ctx.isXS && create_if_block_6(component, ctx);
	    var if_block3 = ctx.menuExpanded && ctx.view.description && ctx.showTooltips && !ctx.isXS && create_if_block_5(component, ctx);
	    var if_block4 = ctx.view.childViews.length > 0 && ctx.view.isExpanded && create_if_block_1(component, ctx);
	    return {
	      key: key_1,
	      first: null,
	      c: function c() {
	        div3 = createElement("div");
	        div2 = createElement("div");
	        a = createElement("a");
	        if_block0.c();
	        text0 = createText("\n          ");
	        div0 = createElement("div");
	        text1 = createText(text1_value);
	        text2 = createText("\n        ");
	        if (if_block1) if_block1.c();
	        text3 = createText("\n        ");
	        div1 = createElement("div");
	        text4 = createText("\n        ");
	        if (if_block2) if_block2.c();
	        text5 = createText("\n        ");
	        if (if_block3) if_block3.c();
	        text6 = createText("\n\n      ");
	        if (if_block4) if_block4.c();
	        text7 = createText("\n    ");
	        setAttribute(div0, "pros-tooltip", "");
	        div0.className = "view-name svelte-123oly2";
	        a.className = "view-link svelte-123oly2";
	        div1.className = "selected-indicator svelte-123oly2";
	        div2._svelte = {
	          component: component,
	          ctx: ctx
	        };
	        addListener(div2, "click", click_handler);
	        div2.id = div2_id_value = "view-" + ctx.view.id;
	        div2.className = "view-content svelte-123oly2";
	        toggleClass(div2, "selected", ctx.view.id === ctx.selectedId || !ctx.view.isExpanded && (ctx.view.id === ctx.selectedParentId || ctx.view.id === ctx.selectedGrandParentId));
	        toggleClass(div2, "is-nav-ux", ctx.isNavUX);
	        div3.className = "view-content-container svelte-123oly2";
	        this.first = div3;
	      },
	      m: function m(target, anchor) {
	        insert(target, div3, anchor);
	        append(div3, div2);
	        append(div2, a);
	        if_block0.m(a, null);
	        append(a, text0);
	        append(a, div0);
	        append(div0, text1);
	        addHref_action = addHref.call(component, a, ctx.view.href) || {};
	        append(div2, text2);
	        if (if_block1) if_block1.m(div2, null);
	        append(div2, text3);
	        append(div2, div1);
	        append(div2, text4);
	        if (if_block2) if_block2.m(div2, null);
	        append(div2, text5);
	        if (if_block3) if_block3.m(div2, null);
	        append(div3, text6);
	        if (if_block4) if_block4.i(div3, null);
	        append(div3, text7);
	      },
	      p: function p(changed, _ctx) {
	        ctx = _ctx;
	
	        if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
	          if_block0.p(changed, ctx);
	        } else {
	          if_block0.d(1);
	          if_block0 = current_block_type(component, ctx);
	          if_block0.c();
	          if_block0.m(a, text0);
	        }
	
	        if (changed.views && text1_value !== (text1_value = ctx.view.name)) {
	          setData(text1, text1_value);
	        }
	
	        if (typeof addHref_action.update === 'function' && changed.views) {
	          addHref_action.update.call(component, ctx.view.href);
	        }
	
	        if (ctx.view.childViews.length > 0 && ctx.menuExpanded) {
	          if (if_block1) {
	            if_block1.p(changed, ctx);
	          } else {
	            if_block1 = create_if_block_7(component, ctx);
	            if_block1.c();
	            if_block1.m(div2, text3);
	          }
	        } else if (if_block1) {
	          if_block1.d(1);
	          if_block1 = null;
	        }
	
	        if (!ctx.menuExpanded && ctx.showTooltips && !ctx.isXS) {
	          if (if_block2) {
	            if_block2.p(changed, ctx);
	          } else {
	            if_block2 = create_if_block_6(component, ctx);
	            if_block2.c();
	            if_block2.m(div2, text5);
	          }
	        } else if (if_block2) {
	          if_block2.d(1);
	          if_block2 = null;
	        }
	
	        if (ctx.menuExpanded && ctx.view.description && ctx.showTooltips && !ctx.isXS) {
	          if (if_block3) {
	            if_block3.p(changed, ctx);
	          } else {
	            if_block3 = create_if_block_5(component, ctx);
	            if_block3.c();
	            if_block3.m(div2, null);
	          }
	        } else if (if_block3) {
	          if_block3.d(1);
	          if_block3 = null;
	        }
	
	        div2._svelte.ctx = ctx;
	
	        if (changed.views && div2_id_value !== (div2_id_value = "view-" + ctx.view.id)) {
	          div2.id = div2_id_value;
	        }
	
	        if (changed.views || changed.selectedId || changed.selectedParentId || changed.selectedGrandParentId) {
	          toggleClass(div2, "selected", ctx.view.id === ctx.selectedId || !ctx.view.isExpanded && (ctx.view.id === ctx.selectedParentId || ctx.view.id === ctx.selectedGrandParentId));
	        }
	
	        if (changed.isNavUX) {
	          toggleClass(div2, "is-nav-ux", ctx.isNavUX);
	        }
	
	        if (ctx.view.childViews.length > 0 && ctx.view.isExpanded) {
	          if (if_block4) {
	            if_block4.p(changed, ctx);
	          } else {
	            if_block4 = create_if_block_1(component, ctx);
	            if (if_block4) if_block4.c();
	          }
	
	          if_block4.i(div3, text7);
	        } else if (if_block4) {
	          groupOutros();
	          if_block4.o(function () {
	            if_block4.d(1);
	            if_block4 = null;
	          });
	        }
	      },
	      d: function d(detach) {
	        if (detach) {
	          detachNode(div3);
	        }
	
	        if_block0.d();
	        if (addHref_action && typeof addHref_action.destroy === 'function') addHref_action.destroy.call(component);
	        if (if_block1) if_block1.d();
	        if (if_block2) if_block2.d();
	        if (if_block3) if_block3.d();
	        removeListener(div2, "click", click_handler);
	        if (if_block4) if_block4.d();
	      }
	    };
	  }
	
	  function ViewNav(options) {
	    var _this2 = this;
	
	    init(this, options);
	    this._state = assign(data(), options.data);
	
	    this._recompute({
	      selectedId: 1,
	      views: 1
	    }, this._state);
	
	    this._intro = true;
	    this._handlers.state = [onstate];
	    this._handlers.destroy = [ondestroy];
	    if (!document.getElementById("svelte-123oly2-style")) add_css();
	    onstate.call(this, {
	      changed: assignTrue({}, this._state),
	      current: this._state
	    });
	    this._fragment = create_main_fragment(this, this._state);
	
	    this.root._oncreate.push(function () {
	      oncreate.call(_this2);
	
	      _this2.fire("update", {
	        changed: assignTrue({}, _this2._state),
	        current: _this2._state
	      });
	    });
	
	    if (options.target) {
	      this._fragment.c();
	
	      this._mount(options.target, options.anchor);
	
	      flush(this);
	    }
	  }
	
	  assign(ViewNav.prototype, proto);
	  assign(ViewNav.prototype, methods);
	
	  ViewNav.prototype._recompute = function _recompute(changed, state) {
	    if (changed.selectedId || changed.views) {
	      if (this._differs(state.viewName, state.viewName = viewName(state))) changed.viewName = true;
	    }
	  };
	
	  exports.ViewNav = ViewNav;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./bundles/frames.module.js": 279,
		"./bundles/users.module.js": 280,
		"./bundles/widgets.module.js": 281,
		"./components/alert-dialog/alert-dialog.module.js": 283,
		"./components/app-broker/app-broker.module.js": 285,
		"./components/app-nav/app-nav.module.js": 47,
		"./components/auto-tooltip/auto-tooltip.module.js": 290,
		"./components/body-wrap/body-wrap.module.js": 48,
		"./components/browser/browser.module.js": 292,
		"./components/carousel/carousel.module.js": 49,
		"./components/carousel/splash/splash.module.js": 296,
		"./components/carousel/testimonial/testimonial.module.js": 298,
		"./components/color-picker/color-picker.module.js": 300,
		"./components/confirm/confirm-dialog.module.js": 302,
		"./components/dashboard/card/card.module.js": 305,
		"./components/device-status/device-status.module.js": 306,
		"./components/dialog-title-bar/dialog-title-bar.module.js": 309,
		"./components/error-bar/error-bar.module.js": 50,
		"./components/error/error.module.js": 51,
		"./components/fields/field/field.module.js": 313,
		"./components/fields/fields.module.js": 52,
		"./components/filter-bar/filter-bar.module.js": 316,
		"./components/filter-box/filter-box.module.js": 318,
		"./components/filter-box/quick-filter/quick-filter.module.js": 53,
		"./components/filters/filters.module.js": 321,
		"./components/form-content/form-content.module.js": 54,
		"./components/form-footer-bar/form-footer-bar.module.js": 326,
		"./components/go/go.module.js": 55,
		"./components/google-address/google-address.module.js": 329,
		"./components/google-maps/google-maps.module.js": 332,
		"./components/hpid/hpid.module.js": 13,
		"./components/icon/icon.module.js": 56,
		"./components/input-validation/input-validation.module.js": 338,
		"./components/l10n/l10n.module.js": 344,
		"./components/locale-select/locale-select.module.js": 43,
		"./components/month-selector/month-selector.module.js": 350,
		"./components/mouse-wheel/wheel-down/wheel-down.module.js": 352,
		"./components/mouse-wheel/wheel-up/wheel-up.module.js": 354,
		"./components/outer-container/outer-container.module.js": 57,
		"./components/page-header/page-header.module.js": 58,
		"./components/page-not-found/page-not-found.module.js": 358,
		"./components/perf/perf.module.js": 359,
		"./components/printos-images/bk-img/bk-img.module.js": 59,
		"./components/printos-images/img-src/img-src.module.js": 60,
		"./components/printos-images/printos-images.module.js": 363,
		"./components/responsive/responsive.module.js": 365,
		"./components/signin/signin.module.js": 366,
		"./components/spinner/spinner.module.js": 44,
		"./components/time-picker/time-picker.module.js": 371,
		"./components/time-range/time-range.module.js": 373,
		"./components/time/time.module.js": 374,
		"./components/user/eula/eula.module.js": 9,
		"./components/validation/validation.module.js": 384,
		"./components/view-container/view-container.module.js": 63,
		"./components/walkme/walkme.module.js": 386,
		"./components/youtube/youtube.module.js": 390,
		"./core/analytics/analytics.module.js": 6,
		"./core/blue/blue.module.js": 64,
		"./core/core.module.js": 30,
		"./core/system-down/system-down.module.js": 398,
		"./extensions/getting-started/getting-started.module.js": 403,
		"./extensions/grid/columns/columns.module.js": 406,
		"./extensions/grid/grid.module.js": 409,
		"./mini-apps/app-switcher/app-switcher.module.js": 411
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 82;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./aborted.svg": 152,
		"./disconnected.svg": 153,
		"./error.svg": 154,
		"./filter-drop-down.svg": 155,
		"./filter.svg": 156,
		"./grid-columns.svg": 157,
		"./grid-csv.svg": 158,
		"./grid-filter.svg": 159,
		"./grid-options.svg": 160,
		"./grid-reset.svg": 161,
		"./grid-sort.svg": 162,
		"./info.svg": 163,
		"./ok.svg": 164,
		"./printed.svg": 165,
		"./printing.svg": 166,
		"./processing.svg": 167,
		"./save.svg": 168,
		"./shutting-down.svg": 169,
		"./unknown.svg": 170,
		"./warning.svg": 171
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 83;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./3ddata.svg": 172,
		"./3djobs.svg": 173,
		"./3dmaintenance.svg": 174,
		"./3dpaas.svg": 175,
		"./Analytics.svg": 176,
		"./account.svg": 177,
		"./admin.svg": 178,
		"./anacreon.svg": 179,
		"./area51.svg": 180,
		"./autoflow.svg": 181,
		"./blacksea-portal.svg": 182,
		"./box.svg": 183,
		"./color-config.svg": 184,
		"./composer.svg": 185,
		"./da-vinci.svg": 186,
		"./devices.svg": 187,
		"./di.svg": 188,
		"./dscoop.svg": 189,
		"./go3d.svg": 190,
		"./home.svg": 191,
		"./imposer.svg": 192,
		"./indigo-events.svg": 193,
		"./jobs.svg": 194,
		"./jobs_2.svg": 195,
		"./knowledge-zone.svg": 196,
		"./lkc.svg": 197,
		"./locr-maps.svg": 198,
		"./market-admin.svg": 199,
		"./marketplace.svg": 200,
		"./media-locator.svg": 201,
		"./myknowledge.svg": 202,
		"./packzalyzer.svg": 203,
		"./pc-reporter.svg": 204,
		"./ppc.svg": 205,
		"./press-security.svg": 206,
		"./print-beat.svg": 207,
		"./pwicfa.svg": 208,
		"./ready2print.svg": 209,
		"./reseller_portal.svg": 210,
		"./resource-manager.svg": 211,
		"./service-calls.svg": 212,
		"./sim.svg": 213,
		"./site-flow.svg": 214,
		"./softproof.svg": 215,
		"./substrate-manager.svg": 216,
		"./supplies_and_parts.svg": 217,
		"./university.svg": 218,
		"./valid3d.svg": 219,
		"./wallart.svg": 220
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 84;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./components/admin/admin.module.js": 414,
		"./components/application/application.module.js": 65,
		"./components/chat/chat.module.js": 418,
		"./components/device/device.module.js": 31,
		"./components/feature/feature.module.js": 67,
		"./components/invitation/invitation.module.js": 68,
		"./components/language/language.module.js": 426,
		"./components/local-storage/local-storage.module.js": 69,
		"./components/locale/format/format.module.js": 70,
		"./components/locale/locale.module.js": 32,
		"./components/notification/notification.module.js": 435,
		"./components/organization/organization.module.js": 437,
		"./components/preferences/preferences.module.js": 45,
		"./components/profile/profile.module.js": 440,
		"./components/pusher/pusher.module.js": 71,
		"./components/request/request.module.js": 443,
		"./components/search/search.module.js": 445,
		"./components/session-storage/session-storage.module.js": 447,
		"./components/session/session.module.js": 10,
		"./components/start/start.module.js": 72,
		"./components/tutorial/tutorial.module.js": 451,
		"./components/unsubscribe/unsubscribe.module.js": 453,
		"./components/user/user.module.js": 455,
		"./core/auth/auth.module.js": 73,
		"./core/blue/blue.module.js": 33,
		"./core/client/client.module.js": 26,
		"./core/core.module.js": 4,
		"./core/debug/debug.module.js": 74,
		"./core/http/http.module.js": 11,
		"./core/record/record.module.js": 75,
		"./core/registry/registry.module.js": 34
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 85;


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-app-nav{display:flex;flex-direction:column}gz-app-nav md-sidenav{margin-top:16px}gz-app-nav .view-toggle{position:absolute;top:15px;left:10px;z-index:79;color:#5a5a5a}gz-app-nav .nav-items-container{top:64px!important;display:block;padding:0;min-width:160px!important;width:200px!important;max-width:200px!important;background-color:#ddd}@media (max-width:599px){gz-app-nav .nav-items-container{width:160px!important;max-width:160px!important}}gz-app-nav .nav-items-container.collapsed{min-width:56px!important;width:56px!important;max-width:56px!important}gz-app-nav .nav-items-container.collapsed .nav-item-text{overflow:hidden;opacity:0!important}gz-app-nav .nav-items-container .nav-item-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}gz-app-nav .absolute-fill{position:absolute;height:100%;width:100%}gz-app-nav .view-nav-scroll{overflow:auto}gz-app-nav .nav-item{min-width:0}gz-app-nav .nav-item,gz-app-nav .nav-item-common,gz-app-nav .sub-nav-item{display:block;overflow:hidden;background-color:#ddd;color:#5a5a5a;font-size:16px;text-transform:none;white-space:nowrap;text-overflow:ellipsis}gz-app-nav .nav-item-common:not(.last-nav-item),gz-app-nav .nav-item:not(.last-nav-item),gz-app-nav .sub-nav-item:not(.last-nav-item){border-bottom:1px solid #f3f3f3}gz-app-nav .md-button.nav-item,gz-app-nav .md-button.sub-nav-item,gz-app-nav .nav-item-common.md-button{padding:0;border-radius:0;margin:0;text-align:left;white-space:nowrap}gz-app-nav .item-hover.nav-item:not(.item-active),gz-app-nav .item-hover.sub-nav-item:not(.item-active),gz-app-nav .md-button.nav-item:not([disabled]):hover:not(.item-active),gz-app-nav .md-button.sub-nav-item:not([disabled]):hover:not(.item-active),gz-app-nav .nav-item-common.item-hover:not(.item-active),gz-app-nav .nav-item-common.md-button:not([disabled]):hover:not(.item-active){background-color:#ccc;color:#5a5a5a}gz-app-nav .item-hover.item-active.nav-item,gz-app-nav .item-hover.item-active.sub-nav-item,gz-app-nav .md-button.nav-item:not([disabled]):hover.item-active,gz-app-nav .md-button.sub-nav-item:not([disabled]):hover.item-active,gz-app-nav .nav-item-common.item-hover.item-active,gz-app-nav .nav-item-common.md-button:not([disabled]):hover.item-active{background-color:#0096d6;color:#fff}gz-app-nav .nav-item{width:100%;height:100%;padding:0}gz-app-nav .nav-item md-icon{max-height:24px;width:24px;color:inherit;padding:0 16px;text-align:center;box-sizing:content-box}gz-app-nav .nav-items-container.collapsed-add,gz-app-nav .nav-items-container.collapsed-add span,gz-app-nav .nav-items-container.collapsed-remove,gz-app-nav .nav-items-container.collapsed-remove span{-webkit-transition:all .3s ease;transition:all .3s ease;opacity:1}gz-app-nav .nav-items-container.collapsed-add .nav-item,gz-app-nav .nav-items-container.collapsed-add .nav-item-common,gz-app-nav .nav-items-container.collapsed-add .sub-nav-item,gz-app-nav .nav-items-container.collapsed-remove .nav-item,gz-app-nav .nav-items-container.collapsed-remove .nav-item-common,gz-app-nav .nav-items-container.collapsed-remove .sub-nav-item{text-overflow:clip}gz-app-nav .sub-nav-item{height:36px;display:flex}gz-app-nav .sub-nav-item md-icon{padding:0 8px}gz-app-nav .item-active{background-color:#0096d6;color:#fff}gz-app-nav .expand-item{min-height:24px;height:24px;cursor:pointer}gz-app-nav .expand-item md-icon.expand-icon{background-color:transparent;color:#5a5a5a;padding-top:0;padding-bottom:0;line-height:24px}gz-app-nav .nav-item-wrapper{position:relative;height:56px}gz-app-nav .sub-nav{position:absolute;width:200px;z-index:60}@media (max-width:599px){gz-app-nav .sub-nav{left:160px!important;width:160px!important}}gz-app-nav .sub-nav .nav-item-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}gz-app-nav .md-button{line-height:1}gz-app-nav ::-webkit-scrollbar{width:.4em;height:10px}gz-app-nav ::-webkit-scrollbar-track{background-color:transparent}gz-app-nav ::-webkit-scrollbar-thumb{background-color:#ccc;border-radius:10px}", ""]);
	
	// exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".gz-body printos-header{display:none}.gz-body.show printos-header{display:inherit}.gz-body ui-view{position:absolute}.gz-body md-content{background-color:#fff}.gz-body .gz-app-content{overflow:hidden}", ""]);
	
	// exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-carousel,gz-carousel .carousel-container{position:absolute;top:0;bottom:0;left:0;right:0}gz-carousel .visual-asset-container{display:none;height:100%;width:100%;margin-bottom:8px}gz-carousel .visual-asset-container .splash-item{max-height:100%}gz-carousel .visual-asset-container .splash-item .link{cursor:hand}gz-carousel .visual-asset-container .video{min-width:300px}gz-carousel .visual-asset-container .image{max-height:100%;max-width:100%}gz-carousel .visual-asset-container.selected{display:inherit}gz-carousel .pager{height:24px;flex-shrink:0;color:#0096d6}gz-carousel .pager .indicator-container{padding:0 4px}gz-carousel .pager .indicator-container .indicator{margin:0 6px;cursor:pointer;height:8px;width:8px;min-height:8px;min-width:8px;border-radius:100%;border:1px solid #0096d6}gz-carousel .pager .indicator-container .indicator.selected{background-color:#0096d6}gz-carousel .pager .page-selector{cursor:pointer;padding-bottom:2px}", ""]);
	
	// exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-testimonial{position:absolute;top:0;bottom:0;left:0;right:0}.gz-testimonial{height:100%;width:100%;position:relative}.gz-testimonial .company-logo{height:60px;width:auto}.gz-testimonial .headline{font-size:20px;font-weight:700;text-transform:uppercase}.gz-testimonial .quote{font-size:20px;font-style:italic;max-width:500px;text-align:center}.gz-testimonial .quote:after,.gz-testimonial .quote:before{content:'\"'}.gz-testimonial .quote .link{color:#0096d6;cursor:pointer;text-decoration:none}.gz-testimonial .quote .link:hover{text-decoration:underline}.gz-testimonial .picture{border-radius:50%;height:64px;width:64px}.gz-testimonial .name{text-transform:uppercase;font-size:14px}.gz-testimonial .title{font-size:14px;font-style:italic}.gz-testimonial .company{font-size:14px}.gz-testimonial .company .company-link{color:#0096d6;cursor:pointer;text-decoration:none}.gz-testimonial .company .company-link:hover{text-decoration:underline}.gz-testimonial .watermark{position:absolute;bottom:8px;right:8px;color:#ddd}.gz-testimonial .content-container{padding:8px}.gz-testimonial.default .company-logo,.gz-testimonial.default .quote{margin-bottom:32px}.gz-testimonial.default .picture{margin-right:16px}.gz-testimonial.default .name{margin-right:8px}.gz-testimonial.default .name:after{content:\",\"}.gz-testimonial.default .title{margin-right:8px}.gz-testimonial.default .title:after{content:\",\"}.gz-testimonial.personal-1 .image-container{flex-shrink:0}.gz-testimonial.personal-1 .picture{width:150px;height:150px}.gz-testimonial.personal-1 .quote{margin-bottom:16px}.gz-testimonial.personal-1 .company-logo{height:48px;margin-right:16px;background-color:#fff}.gz-testimonial.personal-1 .title{margin-right:8px}.gz-testimonial.personal-1 .title:after{content:\",\"}.gz-testimonial.personal-2 .picture{width:100px;height:100px;margin-bottom:16px}.gz-testimonial.personal-2 .quote{margin-bottom:16px}.gz-testimonial.personal-2 .company-logo{height:48px;margin-right:16px}.gz-testimonial.personal-2 .title{margin-right:8px}.gz-testimonial.personal-2 .title:after{content:\",\"}.gz-testimonial.personal-3 .headline{margin:16px 0}.gz-testimonial.personal-3 .company-logo{height:48px;margin:16px 0}.gz-testimonial.personal-3 .credit-container{width:100%}.gz-testimonial.personal-3 .picture{height:64px;width:64px;margin:0 16px 0 0}.gz-testimonial.personal-3 .quote{font-size:20px;font-weight:400;text-align:center}.gz-testimonial.personal-3 .credit{width:100%}.gz-testimonial.personal-3 .title{margin-right:8px}.gz-testimonial.personal-3 .title:after{content:\",\"}.gz-testimonial.personal-4 .callout{position:absolute;border-radius:50%;border:1px solid #5a5a5a;left:-70px;top:-30px;width:130px;height:130px;background-color:#fff}.gz-testimonial.personal-4 .company-logo{height:48px;margin-right:16px}.gz-testimonial.personal-4 .markup{margin-left:70px;position:relative;padding:16px 8px;padding-left:68px;border:1px solid #ccc;background-color:#fff;box-shadow:2px 2px 2px 0 rgba(0,0,0,.25),-2px 2px 2px -2px rgba(0,0,0,.25)}.gz-testimonial.personal-4 .quote{margin-bottom:16px}.gz-testimonial.personal-4 .picture{width:80%;height:80%}.gz-testimonial.personal-4 .title{margin-right:8px}.gz-testimonial.personal-4 .title:after{content:\",\"}.gz-testimonial.personal-5 .header{width:100%;padding:0 0 16px 32px}.gz-testimonial.personal-5 .header .intro-image{height:48px;width:auto;margin:0}.gz-testimonial.personal-5 .header .header-separator{width:1px;height:48px;flex-shrink:0;background-color:#ccc;margin:0 16px}.gz-testimonial.personal-5 .header .intro .company-main{text-transform:uppercase;font-size:24px;color:#000;margin-bottom:2px}.gz-testimonial.personal-5 .header .intro-headline{color:#0096d6;font-size:20px}.gz-testimonial.personal-5 .image{width:40%;height:auto;margin:0 32px}.gz-testimonial.personal-5 .quote{margin-bottom:16px;text-align:left;font-size:16px;color:#0096d6}.gz-testimonial.personal-5 .company-logo{height:48px;margin-right:16px}.gz-testimonial.personal-5 .title{margin-right:8px}.gz-testimonial.personal-5 .title:after{content:\",\"}@media (max-width:600px){.gz-testimonial.personal-5 .image{display:none}}.gz-testimonial.personal-6 .header{width:100%;padding:16px 0 16px 32px}.gz-testimonial.personal-6 .header .intro-image{height:48px;width:48px}.gz-testimonial.personal-6 .header .header-separator{width:1px;height:48px;flex-shrink:0;background-color:#ccc;margin:0 16px}.gz-testimonial.personal-6 .header .intro .company-main{text-transform:uppercase;font-size:24px;color:#000;margin-bottom:2px}.gz-testimonial.personal-6 .header .intro-headline{color:#0096d6;font-size:20px}.gz-testimonial.personal-6 .image{width:40%;height:auto;margin:0 32px}.gz-testimonial.personal-6 .quote{margin-bottom:16px;text-align:left;font-size:13px;color:#0096d6}.gz-testimonial.personal-6 .company-logo{height:48px;margin-right:16px}.gz-testimonial.personal-6 .title{margin-right:8px}.gz-testimonial.personal-6 .title:after{content:\",\"}@media (max-width:600px){.gz-testimonial.personal-6 .image{display:none}.gz-testimonial.personal-6 .header{padding:16px 8px}.gz-testimonial.personal-6 .header .intro-headline,.gz-testimonial.personal-6 .header .intro .company-main{font-size:13px}}.gz-testimonial.company-1 .company-logo{height:100px;margin:0 32px}.gz-testimonial.company-1 .markup{padding:16px;margin-right:32px}.gz-testimonial.company-1 .quote{margin-bottom:16px}.gz-testimonial.company-1 .picture{width:48px;height:48px;margin-right:16px}.gz-testimonial.company-1 .title{margin-right:8px}.gz-testimonial.company-1 .title:after{content:\",\"}.gz-testimonial.company-2 .company-logo{height:100px;margin-bottom:16px}.gz-testimonial.company-2 .quote{margin-bottom:16px}.gz-testimonial.company-2 .picture{width:48px;height:48px;margin-right:16px}.gz-testimonial.company-2 .title{margin-right:8px}.gz-testimonial.company-2 .title:after{content:\",\"}.gz-testimonial.company-3 .company-logo{height:100px;margin:0 32px}.gz-testimonial.company-3 .markup{padding:16px;border:1px solid #ccc;margin-right:32px;background-color:#fff;box-shadow:2px 2px 2px 0 rgba(0,0,0,.25),-2px 2px 2px -2px rgba(0,0,0,.25)}.gz-testimonial.company-3 .quote{margin-bottom:16px}.gz-testimonial.company-3 .picture{width:48px;height:48px;margin-right:16px}.gz-testimonial.company-3 .title{margin-right:8px}.gz-testimonial.company-3 .title:after{content:\",\"}.gz-testimonial.company-4 .callout{position:absolute;border-radius:50%;border:1px solid #5a5a5a;left:-70px;top:-30px;width:130px;height:130px;background-color:#fff}.gz-testimonial.company-4 .company-logo{height:80%}.gz-testimonial.company-4 .markup{margin-left:70px;position:relative;padding:16px 8px;padding-left:68px;border:1px solid #ccc;background-color:#fff;box-shadow:2px 2px 2px 0 rgba(0,0,0,.25),-2px 2px 2px -2px rgba(0,0,0,.25)}.gz-testimonial.company-4 .quote{margin-bottom:16px}.gz-testimonial.company-4 .picture{width:48px;height:48px;margin-right:16px}.gz-testimonial.company-4 .title{margin-right:8px}.gz-testimonial.company-4 .title:after{content:\",\"}", ""]);
	
	// exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-color-picker .color-picker{position:relative;background-color:#fff}gz-color-picker .color-picker .custom-color{position:absolute;top:100%;left:0;padding:8px;background-color:#fff;width:242px;z-index:25;border-radius:4px;border:1px solid #f3f3f3;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}gz-color-picker .color-picker .custom-color .input-color-container{margin-bottom:8px}gz-color-picker .color-picker .custom-color .input-color-container .random-btn{margin-right:2px;width:32px;height:32px;border-radius:4px;background-color:#509137;border:1px solid rgba(0,0,0,.2)}gz-color-picker .color-picker .custom-color .input-color-container .random-btn .icon{color:#fff;width:50%;display:block}gz-color-picker .color-picker .custom-color .input-color-container .random-btn .icon.dark{color:#000}gz-color-picker .color-picker .custom-color .color-options .option{border:1px solid rgba(0,0,0,.2);margin:1px;border-radius:4px;width:24px;height:24px}gz-color-picker .color-picker .custom-color .btn-close{position:absolute;top:2px;right:2px;width:14px;height:14px;min-width:14px;min-height:14px;font-size:14px;line-height:1;user-select:none}gz-color-picker .color-picker .color-bar{position:relative;overflow:visible;min-width:94px;min-height:24px;width:100%;color:#fff;border-radius:4px;border:1px solid rgba(0,0,0,.2)}gz-color-picker .color-picker .manual-input{margin:0!important}gz-color-picker .color-picker .manual-input input{width:100%!important}gz-color-picker .color-picker .manual-input .md-errors-spacer{display:none}", ""]);
	
	// exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".gz-confirm-dialog-container .gz-readonly .label{font-weight:700}.gz-confirm-dialog-container .gz-readonly .label:after{content:\":\"}", ""]);
	
	// exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-dialog-title-bar{pointer-events:none}gz-dialog-title-bar .md-toolbar-tools{pointer-events:auto}gz-dialog-title-bar .ellipsis{width:90%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-error-bar .error-bar{background-color:#ff5722}gz-error-bar .msg-container{margin:6px 0;-ms-flex:1 1 auto}gz-error-bar md-toolbar{min-height:44px;padding:0 16px}gz-error-bar .error-msg{font-size:16px;margin-right:16px}gz-error-bar .error-details{font-size:14px}", ""]);
	
	// exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-field{color:#5a5a5a}", ""]);
	
	// exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".gz-truncation-bar{background-color:#f0aa3c;color:#5a5a5a;height:40px;padding:0 8px;margin-bottom:4px}.gz-truncation-bar .title{font-weight:700}.gz-truncation-bar .title.try{padding-right:8px}.gz-truncation-bar .truncation-icon{font-size:20px}.gz-truncation-bar .truncation-icon.space-before{padding-left:8px}.gz-truncation-bar .truncation-icon.space-after{padding-right:8px}.gz-truncation-bar .md-button{min-height:32px;line-height:32px;background-color:#5e7d00}.gz-filter-bar-container{border:1px solid #eee;background-color:#fafafa;margin-bottom:8px}.gz-filter-bar-container.filter-mode md-menu-bar{padding:0;margin-right:8px}.gz-filter-bar-container .truncation-icon{font-size:20px}.gz-filter-bar-container .truncation-icon.space-before{padding-left:8px}.gz-filter-bar-container .truncation-icon.space-after{padding-right:8px}.gz-filter-bar-container .quick-filter{margin-right:4px}.gz-filter-bar-container .quick-filter:hover .gz-input-box{border-color:#0096d6}.gz-filter-bar-container .quick-filter .gz-input-box{font-size:14px;height:30px;margin:5px 0;border-radius:0;border-color:#5a5a5a}.gz-filter-bar-container .filter-toolbar{min-height:40px}.gz-filter-bar-container .count-title{font-size:14px;text-align:right;margin:0 16px 0 4px}.gz-filter-bar-container .gz-indicator-container{position:relative;height:28px}.gz-filter-bar-container .gz-filter-bar{padding:0 8px;font-size:16px;font-weight:700;color:#5a5a5a}.gz-filter-bar-container .gz-filter-bar.secondary{border-top:1px solid #eee}.gz-filter-bar-container .gz-filter-bar.emphasis-background{background-color:#fff}.gz-filter-bar-container .gz-filter-bar .title{text-align:right;margin-right:16px;font-size:20px}.gz-filter-bar-container .gz-filter-bar .clickable{cursor:pointer}.gz-filter-bar-container .gz-filter-bar .filters-container{min-width:300px}@media (max-width:599px){.gz-filter-bar-container .gz-filter-bar .filters-container{min-width:150px}}.gz-filter-bar-container .gz-filter-bar .filters-container .chip-container{font-size:12px;margin:0 4px;max-width:150px}.gz-filter-bar-container .gz-filter-bar .filters-container .chip-container:hover .chip{border-color:#0096d6;background-color:#eee}.gz-filter-bar-container .gz-filter-bar .filters-container .chip-container .chip{height:24px;margin:8px 0;border:1px solid #5a5a5a}.gz-filter-bar-container .gz-filter-bar .filters-container .chip-container .chip .display{padding:0 4px}.gz-filter-bar-container .gz-filter-bar .filters-container .chip-container .chip .expand-icon{font-size:16px;margin:0 4px}.gz-filter-bar-container .gz-filter-bar .filters-container .chip-container .chip md-icon.gz-filter-bar-chip-icon{color:#5a5a5a;font-size:16px;min-height:16px;min-width:16px;height:16px;width:16px;line-height:16px;cursor:pointer;margin-right:4px}.gz-filter-bar-container .gz-filter-bar-icon{margin-right:16px;color:#5a5a5a;vertical-align:text-bottom;font-size:20px;min-height:20px;min-width:20px;height:20px;width:20px;line-height:20px;cursor:default}.gz-filter-bar-container .gz-filter-bar-icon:last-child{margin-right:0}.gz-filter-menu-content .gz-filter-icon{font-size:24px}.gz-filter-menu-content .filterSubmenu{font-weight:700;padding-left:8px;color:#5a5a5a;font-size:13px}", ""]);
	
	// exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".gz-filter-box{position:relative;width:100%}.gz-filter-box .gz-input-box{padding:0 24px 0 5px;height:26px;min-height:26px;box-sizing:border-box;font-size:16px;border:1px solid #ccc;border-radius:5px}.gz-filter-box .gz-input-box:focus{outline:none;border-color:#0096d6}.gz-filter-box .gz-input-box::-webkit-input-placeholder{font-style:italic}.gz-filter-box .gz-input-box::-moz-placeholder{font-style:italic}.gz-filter-box .gz-input-box:-ms-input-placeholder{font-style:italic}.gz-filter-box .gz-input-box:-moz-placeholder{font-style:italic}.gz-filter-box .gz-input-box::-ms-clear{display:none}.gz-filter-box .gz-filter-box-icon-container{position:absolute;right:0;top:0;height:100%;width:24px;margin:auto}.gz-filter-box .gz-filter-box-icon-container .gz-filter-box-icon{font-size:16px;line-height:16px;height:16px;width:16px;min-height:16px;min-width:16px;margin:0}.gz-filter-box .gz-filter-box-icon-container.touched{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".mapped-image{padding-right:8px}.mapped-image .status-green{color:#509137}.mapped-image .status-yellow{color:#f0aa3c}.mapped-image .status-red{color:#f04b37}.mapped-image .status-blue{color:#b6dbeb}.edit-filters{color:#5a5a5a;max-height:500px}@media (max-height:499px){.edit-filters{max-height:100%}}.edit-filters md-switch{margin:0;padding:0;overflow:hidden}.edit-filters md-switch.invalid .md-bar{background-color:rgba(240,75,55,.5)}.edit-filters md-switch.invalid .md-thumb{background-color:#f04b37}.edit-filters md-datepicker .md-datepicker-button{padding:0;margin:0;width:24px;height:24px}.edit-filters form{flex-basis:auto}.edit-filters .form-container{min-height:0;padding:16px}.edit-filters .filters-container{min-height:0}.edit-filters .filters-container .column-container{width:200px;border-right:1px solid #f3f3f3;overflow:auto}.edit-filters .filters-container .column-container .column-selector{width:100%;height:50px;padding:0 0 0 8px;cursor:pointer;flex-shrink:0}.edit-filters .filters-container .column-container .column-selector .md-button{margin:0;padding:0}.edit-filters .filters-container .column-container .column-selector.selected{background-color:#bbedff!important;color:#5a5a5a;font-weight:700}.edit-filters .filters-container .column-container .column-selector .server:after{content:\" *\"}.edit-filters .filters-container .column-container .column-selector .invalid{color:#f04b37}.edit-filters .filters-container .column-container .column-selector:hover{background-color:#f3f3f3}.edit-filters .filters-container .filter-container{width:100%;padding:8px;flex-shrink:0}.edit-filters .filters-container .filter-container .filter-title{padding-bottom:16px;font-size:20px;font-weight:700}.edit-filters .filters-container .filter-container .filter-title.disabled{color:#e5e8e8}.edit-filters .filters-container .filter-container .filter{width:100%;flex-shrink:0}.edit-filters .filters-container .filter-container .filter .filter-scroll-container{overflow:auto;min-height:120px}.edit-filters .filters-container .filter-container .filter md-input-container{flex-shrink:0;width:100%;margin:12px 0 4px;padding:0}.edit-filters .filters-container .filter-container .filter md-input-container label{padding:0}.edit-filters .filters-container .filter-container .filter md-select{flex-shrink:0;margin:8px 0 16px}.edit-filters .filters-container .filter-container .filter md-datepicker{flex-shrink:0;width:100%}.edit-filters .filters-container .filter-container .filter .mapped-row{padding:8px}.edit-filters .filters-container .filter-container .filter .mapped-row md-checkbox{margin:0}.edit-filters .filters-container .filter-container .filter .mapped-row:hover{background-color:#f3f3f3}.edit-filters .filters-container .filter-container .filter .table-layout{display:table;height:100%}.edit-filters .filters-container .filter-container .filter .table-layout .row{display:table-row}.edit-filters .filters-container .filter-container .filter .table-layout span{display:table-cell}.edit-filters .filters-container .filter-container .filter .table-layout .label{font-weight:700;white-space:nowrap;vertical-align:middle}.edit-filters .filters-container .filter-container .filter .table-layout .label:after{content:\":\"}", ""]);
	
	// exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-form-content{overflow:auto;position:relative}gz-form-content gz-spinner{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
	
	// exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".alternate{background-color:#e5e8e8}.gz-legend{color:#767676;padding-left:16px}", ""]);
	
	// exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-google-address{height:100%;min-height:300px;width:100%;position:relative}gz-google-address .display-reset{height:100%}gz-google-address .display-map{height:100%;min-height:300px;width:100%;min-width:400px}gz-google-address .display-map gz-google-map{height:100%;width:100%}gz-google-address .unknown-location{border:2px dashed #ccc;margin:4px;width:calc(100% - 8px);color:#ccc}gz-google-address .unknown-location .title{font-size:32px}gz-google-address ng-form{height:100%;min-height:300px;width:100%}gz-google-address ng-form .manual-container{padding-top:8px;width:100%;max-width:1000px}gz-google-address ng-form .manual-container .form-container{min-width:300px}gz-google-address ng-form .manual-container .form-container.spacer{margin-right:16px}@media (max-width:823px){gz-google-address ng-form .manual-container .form-container{height:auto;width:100%}}gz-google-address ng-form .manual-container md-input-container{margin:8px 0;padding:0}gz-google-address ng-form .manual-container md-input-container md-select{margin-bottom:24px}gz-google-address ng-form .manual-container.ng-hide-animate{display:none}gz-google-address ng-form .map-container{width:100%;max-width:1000px;height:100%}gz-google-address ng-form .map-container .form-container{padding-right:16px;min-width:300px;width:400px}gz-google-address ng-form .map-container .form-container md-input-container{width:100%;margin-bottom:0}gz-google-address ng-form .map-container .form-container .location-input-container{width:100%}gz-google-address ng-form .map-container .form-container .action-icon{width:24px;margin-left:8px;cursor:pointer}gz-google-address ng-form .map-container .form-container .best-guess-container{width:100%;font-size:12px}gz-google-address ng-form .map-container .form-container .best-guess-container .label{font-weight:700}gz-google-address ng-form .map-container .form-container .manual-option{width:100%;margin-bottom:8px}gz-google-address ng-form .map-container .form-container .manual-option .manual-msg:after{white-space:pre;content:\"  \"}gz-google-address ng-form .map-container .form-container .manual-option .manual-switch{cursor:pointer;color:#0096d6}gz-google-address ng-form .map-container .form-container .manual-option .manual-switch:hover{text-decoration:underline}gz-google-address ng-form .map-container .form-container md-checkbox{width:100%}gz-google-address ng-form .map-container .form-container .hidden{display:none}gz-google-address ng-form .map-container .map{height:100%;width:100%;min-width:400px;min-height:300px}gz-google-address ng-form .map-container .map gz-google-map{height:300px;width:100%}gz-google-address ng-form .map-container.ng-enter-prepare{display:none}.select-address-dialog gz-google-map{width:100%}", ""]);
	
	// exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-google-map{position:relative}gz-google-map .map{position:absolute;top:0;left:0;right:0;bottom:0}gz-google-map.awaiting-location{visibility:hidden}", ""]);
	
	// exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-input-validation p{color:#f44336}", ""]);
	
	// exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-locale-select md-input-container{box-sizing:border-box;width:100%}gz-locale-select md-input-container md-select-value .secondary{display:none}gz-locale-select md-input-container md-select-value .language-container{align-items:center}.gz-locale-select-menu md-option .md-text{flex:1}md-optgroup .gz-locale-select-menu md-option{padding-right:16px}.gz-locale-select-menu md-option .secondary{color:#ccc;font-style:italic;font-size:14px}.gz-locale-select-menu md-optgroup>label{border-top:1px solid #ccc}", ""]);
	
	// exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-month-selector gz-month-selector-container{margin-bottom:6px}gz-month-selector gz-month-selector-container .md-button{padding:0;margin:0;height:32px;width:32px;min-width:32px;min-height:32px;line-height:32px}gz-month-selector gz-month-selector-container md-select{margin-top:0;margin-bottom:0}gz-month-selector .selected-date-range{min-width:150px}gz-month-selector .date-nav-button{color:#767676}gz-month-selector .change-dates-dialog{font-size:16px}gz-month-selector .change-dates-dialog .pointer{cursor:pointer}gz-month-selector .change-dates-dialog .container{padding:8px}gz-month-selector .change-dates-dialog .container .month-and-year md-select:first-child{padding-right:16px}", ""]);
	
	// exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".task-bar{height:42px;padding:8px 8px 8px 0;font-size:16px;font-weight:700;color:#5a5a5a;border:2px solid #0096d6;border-radius:3px}.task-bar .back-container{cursor:pointer}.task-bar .back-container .back-button{padding:0;margin:0}.task-bar .exit-application{font-weight:400;color:#0096d6;cursor:pointer}.task-bar .exit-application:hover{text-decoration:underline}.pg-header-toolbar{color:#5a5a5a;padding:16px 0}.pg-header-toolbar.with-task-bar{padding-bottom:8px}.pg-header-toolbar.layout-xs-column>.flex{-ms-flex:1 1 auto;-webkit-flex:1 1 auto;flex:1 1 auto}.pg-header-toolbar .delinkify{text-decoration:none}.pg-header-toolbar .brdcrumb{padding-right:16px}.pg-header-toolbar .breadcrumbs-container .breadcrumb-container .breadcrumb{padding-right:6px}.pg-header-toolbar .breadcrumbs-container .breadcrumb-container .breadcrumb.link{cursor:pointer;font-weight:700}.pg-header-toolbar .breadcrumbs-container .breadcrumb-container .breadcrumb.link:hover{color:#0096d6;text-decoration:underline}.pg-header-toolbar .breadcrumbs-container .breadcrumb-container .link-separator{padding-right:6px}.pg-header-toolbar .back-icon{color:#5a5a5a;cursor:pointer}.pg-header-toolbar .fill-width{width:100%}.pg-header-toolbar .transclude-container{min-width:320px}.pg-header-toolbar .toolbar-task-container .submit-button{margin-right:0}.pg-header-toolbar .toolbar-icon{margin:4px 15px 4px 0;color:#5a5a5a;font-size:20px;cursor:pointer}.pg-header-toolbar .toolbar-icon.disabled{margin:4px 15px 4px 0;color:#e5e8e8;vertical-align:text-bottom;cursor:not-allowed}.pg-header-toolbar .md-headline{color:#5a5a5a;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pg-header-toolbar .input.search-filter{border:none;background-color:#f3f3f3;font-size:80%;margin:5px 0}.pg-header-toolbar .search-filter::-webkit-input-placeholder:before{font-family:fontAwesome;content:\" \\F002     \";color:#5a5a5a;font-style:normal}.pg-header-toolbar .search-filter::-moz-placeholder:before{font-family:fontAwesome;content:\" \\F002     \";color:#5a5a5a;font-style:normal}.pg-header-toolbar .search-filter:-ms-input-placeholder:before{font-family:fontAwesome;content:\" \\F002     \";color:#5a5a5a;font-style:normal}.pg-header-toolbar input.search-filter:-moz-placeholder:before{font-family:fontAwesome;content:\" \\F002     \";color:#5a5a5a;font-style:normal}.pg-header-toolbar .search-filter::-webkit-input-placeholder{font-style:italic}.pg-header-toolbar .search-filter::-moz-placeholder{font-style:italic}.pg-header-toolbar .search-filter:-ms-input-placeholder{font-style:italic}.pg-header-toolbar input.search-filter:-moz-placeholder{font-style:italic}", ""]);
	
	// exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".page-not-found-container{margin-top:40px}.page-not-found-container md-icon{color:#0096d6;width:40%;height:40%;margin:0}", ""]);
	
	// exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-time-picker .time-picker{position:relative;min-height:44px}gz-time-picker .time-picker .small-label{position:absolute;top:-6px;font-size:12px;color:rgba(0,0,0,.54)}gz-time-picker .time-picker .small-label.required:after{content:\" *\"}gz-time-picker .time-inputs{margin-bottom:2px;border-bottom:1px solid rgba(0,0,0,.12);padding-bottom:1px}gz-time-picker .time-inputs md-input-container{padding:0}gz-time-picker .time-inputs input{border:none;height:24px}gz-time-picker .time-inputs .separator{margin-bottom:2px}gz-time-picker .time-inputs .separator:after{content:\":\"}gz-time-picker md-input-container{margin:0}gz-time-picker md-input-container .md-errors-spacer{display:none}gz-time-picker md-input-container input{max-width:32px;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-time-range .end-time .label,gz-time-range .start-time .label{color:rgba(0,0,0,.54);font-size:13px}gz-time-range .end-time md-input-container,gz-time-range .start-time md-input-container{margin:0;padding:0}gz-time-range .end-time{padding-left:20px}", ""]);
	
	// exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".eula-container .accept-msg{font-style:italic;font-size:14px;min-width:150px}.eula-container md-content{min-height:50px;flex-basis:auto;background-color:#f3f3f3;overflow-wrap:break-word;word-wrap:break-word}.eula-container md-content .eula-text{margin:0}.eula-container md-content .eula-text ol{counter-reset:section;list-style-type:none;padding-left:20px}.eula-container md-content .eula-text ol li:before{counter-increment:section;content:counters(section,\".\") \". \"}.eula-container md-content .eula-text li,.eula-container md-content .eula-text p{margin:10px 0}.eula-container .terms-button{margin-left:0}.eula-container md-dialog-actions{flex-shrink:0}.eula-container .gz-readonly{background-color:#ff5722;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-view-container ui-view{background:#fff;box-sizing:border-box}", ""]);
	
	// exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "body{overflow:hidden}[data-ng-click],[ng-click],a:focus,input[type=button]:focus,input[type=submit]:focus{outline:none}.translate-cloak{visibility:hidden!important}.gz-padding{padding:8px}", ""]);
	
	// exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".gz-status-ok{color:#509137}.gz-status-warn{color:#f0aa3c}.gz-status-error{color:#f04b37}.gz-status-info{color:#0096d6}.gz-status-neutral{color:#5a5a5a}.gz-status-disabled{color:#ccc}.gz-image-spacer{padding-right:4px}gz-start{position:relative}.gz-start{position:absolute;top:0;bottom:0;left:0;right:0}.gz-start .gz-start-container .steps-container{flex-shrink:0;height:165px}.gz-start .gz-start-container .steps-container .step-scroll-container{height:100%;overflow-x:auto}.gz-start .gz-start-container .steps-container .step-and-connector-container{flex-shrink:0;height:100%}.gz-start .gz-start-container .steps-container .spacer-container{height:100%;padding-bottom:15px}.gz-start .gz-start-container .steps-container .step-container{height:100%;width:64px;cursor:pointer;flex-shrink:0;padding-bottom:15px}.gz-start .gz-start-container .steps-container .step-container.connector,.gz-start .gz-start-container .steps-container .step-container.disabled{cursor:default}.gz-start .gz-start-container .steps-container .step-container.selected{width:72px}.gz-start .gz-start-container .steps-container .hr{width:100%;height:1px;background:#5a5a5a}.gz-start .gz-start-container .steps-container .hr.selected{position:relative}.gz-start .gz-start-container .steps-container .hr.selected .after{position:absolute;border-style:solid;border-width:15px 15px 0;border-color:#fff transparent;display:block;width:0;z-index:1;top:0;left:calc(50% - 15px)}.gz-start .gz-start-container .steps-container .hr.selected .before{position:absolute;border-style:solid;border-width:15px 15px 0;border-color:#000 transparent;display:block;width:0;z-index:1;top:1px;left:calc(50% - 15px)}.gz-start .gz-start-container .steps-container .outer-circle-border{width:72px;height:72px;border:2px solid #0096d6;border-radius:36px;-webkit-border-radius:36px;-moz-border-radius:36px}.gz-start .gz-start-container .steps-container .step{height:72px}.gz-start .gz-start-container .steps-container .circle-border{width:64px;height:64px;border:2px solid #0096d6;border-radius:32px;-webkit-border-radius:32px;-moz-border-radius:32px}.gz-start .gz-start-container .steps-container .circle-border .step-count{font-size:32px;font-weight:700;color:#0096d6}.gz-start .gz-start-container .steps-container .circle-border .step-count.disabled{color:#e5e8e8}.gz-start .gz-start-container .steps-container .circle-border.selected{background-color:#0096d6}.gz-start .gz-start-container .steps-container .circle-border.selected .step-count,.gz-start .gz-start-container .steps-container .circle-border.selected md-icon{color:#fff}.gz-start .gz-start-container .steps-container .step-label{font-size:14px;color:#5a5a5a;height:28px;text-align:center;padding:8px 0;width:64px}.gz-start .gz-start-container .steps-container .step-label.adjust{padding:8px 4px}.gz-start .gz-start-container .steps-container .circle-connector{width:64px;border-top:2px solid #0096d6;border-bottom:2px solid #0096d6}.gz-start .gz-start-container .steps-container md-icon{height:36px;width:36px;font-size:36px;line-height:36px;color:#0096d6;font-weight:700}.gz-start .gz-start-container .steps-container md-icon.success{height:54px;width:54px;margin:0;font-size:54px;line-height:54px;padding-right:4px}.gz-start .gz-start-container .steps-container .disabled{border-color:#e5e8e8;color:#e5e8e8;font-weight:400}.gz-start .gz-start-container .content-container{color:#5a5a5a;flex-shrink:0}.gz-start .gz-start-container .content-container .step-title{text-align:center;font-size:32px;padding-top:16px}.gz-start .gz-start-container .content-container .step-description{padding:8px 0 16px;max-width:600px;text-align:center;font-size:16px}.gz-start .gz-start-container .content-container .step-actions{padding:8px 0;background-color:#fafafa}.gz-start .gz-start-container .content-container .activate-row{width:705px}.gz-start .gz-start-container .content-container .activate-row .activate-item{width:375px}.gz-start .gz-start-container .content-container .content{padding:0 16px}.gz-start .gz-start-container .content-container .content.emphasis{font-weight:700}.gz-start .gz-start-container .content-container .content .grid-row{width:700px}.gz-start .gz-start-container .content-container .content .grid-item,.gz-start .gz-start-container .content-container .content .grid-item .device-count,.gz-start .gz-start-container .content-container .content .grid-item md-select{width:300px}.gz-start .gz-start-container .content-container .content .grid-button{width:250px}.gz-start .gz-start-container .content-container .device-model{font-weight:700}.gz-start .gz-start-container .content-container .device-count{font-weight:700;font-size:20px}.gz-start .gz-start-container .content-container .device-image{height:100px;width:auto}.gz-start .gz-start-container .content-container .main-action{padding-left:32px;padding-right:32px}.gz-start .gz-start-container .content-container md-icon{color:#0096d6}.gz-start .gz-start-container .content-container md-icon.success{height:54px;width:54px;margin:0;font-size:54px;line-height:54px;margin-right:12px}.gz-start .gz-start-container .navigation-container{padding:16px 0}.gz-start .gz-start-container .navigation-container .button-spacer{width:300px}.gz-start .gz-start-container .navigation-container .nav-button{border:1px solid #0096d6}.gz-start .gz-start-container .navigation-container .nav-button:not(:hover){background-color:#fff}.gz-start .gz-start-container .navigation-container .nav-button.prev .button-label{padding-right:12px}.gz-start .gz-start-container .navigation-container .nav-button.next .button-label{padding-left:12px}.gz-start .gz-start-container .nav-button{border:1px solid #0096d6;background-color:#fff}.gz-start .gz-start-container .nav-button.prev .button-label{padding-right:12px}.gz-start .gz-start-container .nav-button.next .button-label{padding-left:12px}.gz-start .gz-start-container .nav-button[disabled]{border-color:#e5e8e8}", ""]);
	
	// exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".edit-columns-dialog{max-height:500px}@media (max-height:499px){.edit-columns-dialog{max-height:100%}}.edit-columns-dialog form{flex-basis:auto}.edit-columns-dialog .form-container{min-height:0;padding:16px}.edit-columns-dialog .columns-header{color:#5a5a5a;flex-shrink:0}.edit-columns-dialog .columns-header .columns-title{font-size:20px;font-weight:700}.edit-columns-dialog .columns-header .md-button{color:#5a5a5a}.edit-columns-dialog .columns-header .md-button.disabled{cursor:default;color:#ccc}.edit-columns-dialog .columns-scroll-container{overflow:auto;padding:8px 0}.edit-columns-dialog .columns-scroll-container .columns-row{flex-shrink:0;cursor:pointer;padding-left:16px;min-height:40px}.edit-columns-dialog .columns-scroll-container .columns-row md-checkbox{margin:0}.edit-columns-dialog .columns-scroll-container .columns-row.selected{background-color:#bbedff!important}.edit-columns-dialog .columns-scroll-container .columns-row .pin-icon{color:#ccc}.edit-columns-dialog .columns-scroll-container .columns-row .pin-icon.pinned{color:#0096d6}.edit-columns-dialog .columns-scroll-container .columns-row:hover{background-color:#f3f3f3}", ""]);
	
	// exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".gz-status-ok{color:#509137}.gz-status-warn{color:#f0aa3c}.gz-status-error{color:#f04b37}.gz-status-info{color:#0096d6}.gz-status-neutral{color:#5a5a5a}.gz-status-disabled{color:#ccc}.gz-image-spacer{padding-right:4px}md-menu-content.md-menu-bar-menu.md-dense .md-menu>.md-button:after{right:8px}md-menu-content{border:2px solid #0096d6}md-menu-content.md-menu-bar-menu.md-dense{padding:0}md-menu-content md-menu-item>.md-button{font-size:14px;font-weight:700;color:#5a5a5a}md-menu-content md-menu-item .md-button:not([disabled]):hover{background-color:#f3f3f3}md-menu-content .gz-menu-icon{height:16px;width:16px;min-height:16px;min-width:16px;font-size:16px;line-height:16px;margin:0 8px 0 0}md-menu-content .gz-menu-icon.right{margin:0}md-menu-content .filter-container{min-width:150px}.gz-indicator-container{position:relative}.gz-indicator-container .gz-indicator{position:absolute;right:0;top:0;height:8px;width:8px;min-height:8px;min-width:8px;border-radius:100%;background-color:#f04b37}.gz-indicator-container .gz-indicator.menu{top:6px;right:14px}gz-grid{position:absolute;top:0;bottom:0;left:0;right:0}gz-grid .gz-clickable{cursor:pointer}gz-grid .gz-grid{position:absolute;top:0;bottom:0;left:0;right:0}gz-grid .gz-grid .gz-grid-header-container,gz-grid .gz-grid .gz-grid-menu-container{height:100%}gz-grid .gz-grid .gz-header-template-container .gz-header-template-cell-label{flex:1;height:100%;text-align:left;overflow:hidden;user-select:none}gz-grid .gz-grid .gz-header-template-container .gz-header-template-cell-label .gz-header-template-text{height:100%}gz-grid .gz-grid .gz-header-template-container .gz-header-template-resize-bar{width:6px;height:100%;cursor:col-resize}gz-grid .gz-grid .ag-root{user-select:text}gz-grid .gz-grid .ag-body{border-left:1px solid #eee;border-right:1px solid #eee;border-bottom:1px solid #eee}gz-grid .gz-grid .ag-header{border-bottom:1px solid #5a5a5a}gz-grid .gz-grid.ag-material .ag-row-selected,gz-grid .gz-grid.ag-material .ag-row-selected:hover{background-color:#bbedff!important}gz-grid .gz-grid.ag-material .ag-row-odd{background-color:#f7f7f7}gz-grid .gz-grid.ag-material .ag-row-hover{background-color:#f3f3f3}gz-grid .gz-grid.ag-material .ag-header-cell{display:flex;flex-direction:row;align-items:center;border-right:1px solid transparent}gz-grid .gz-grid.ag-material .ag-header-cell:hover{border-right:1px solid #ccc}gz-grid .gz-grid.ag-material .ag-header-cell[colId=dummy]{border-right:none}gz-grid .gz-grid.ag-material .ag-header-cell[colId=gzAction]{border-left:none;border-right:none}gz-grid .gz-grid.ag-material .gz-action-btn.disabled{color:#ccc;cursor:default}gz-grid .gz-grid.ag-material .ag-header-cell-sortable{cursor:pointer}gz-grid .gz-grid.ag-material .ag-cell{padding:4px 8px;display:flex;flex-direction:row;align-items:center}gz-grid .gz-grid.ag-material .ag-cell-last-left-pinned.ag-cell-focus{border-right:1px solid #d3d3d3}gz-grid .gz-grid.ag-material .ag-cell-no-focus{border-top:none;border-bottom:none}gz-grid .gz-grid.ag-material .gz-align-center{justify-content:center;text-align:center}gz-grid .gz-grid.ag-material .ag-overlay-wrapper{padding-top:60px;vertical-align:top}gz-grid .gz-grid.ag-material .ag-overlay-wrapper .ag-overlay-loading-center,gz-grid .gz-grid.ag-material .ag-overlay-wrapper .ag-overlay-no-rows-center{color:#5a5a5a;font-size:18px;font-weight:700}gz-grid .gz-grid.ag-material .gz-align-right{justify-content:flex-end;text-align:right}gz-grid .gz-grid.ag-material .gz-center-header{text-align:center;height:100%}gz-grid .gz-grid.ag-material .gz-right-header{text-align:right}gz-grid .gz-grid.ag-material md-menu-bar.gz-action-header{padding:0}gz-grid .gz-grid.ag-material .gz-action-header{width:100%}gz-grid .gz-grid.ag-material .gz-action-header .md-button{min-height:20px}gz-grid .gz-grid.ag-material .gz-action-header .md-button.md-icon-button{margin:0;padding:0;width:20px;height:20px;border-radius:0}gz-grid .gz-grid.ag-material .gz-action-header .md-button.md-icon-button md-icon{min-height:20px;min-width:20px;height:20px;line-height:20px}gz-grid .gz-grid.ag-material .gz-action-header .md-button.md-icon-button .material-icons{font-size:20px}gz-grid .gz-grid.ag-material .gz-header-title{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-height:24px;width:100%;padding-left:4px;padding-right:4px;line-height:30px}gz-grid .gz-grid.ag-material .gz-header:hover .gz-filter{padding-bottom:1px;display:block}gz-grid .gz-grid.ag-material .gz-sort{margin-left:4px;margin-right:2px;line-height:1.4}gz-grid .gz-grid.ag-material .gz-filter{display:none}gz-grid .gz-grid.ag-material .gz-filter.selected{padding-bottom:1px;display:block}gz-grid .gz-grid.ag-material .gz-image-cell{display:flex;flex-direction:row;justify-content:center;width:100%}gz-grid .gz-grid.ag-material .gz-image-cell .gz-image-container img{height:100%;width:auto}gz-grid .gz-grid.ag-material .gz-cell{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%}gz-grid .gz-grid.ag-material .gz-link{color:#0096d6;text-decoration:underline;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}gz-grid .gz-grid.ag-material .gz-link:hover{cursor:pointer}gz-grid .gz-grid.ag-material .gz-grid-expansion-cell{height:100%;width:100%;border:1px solid #0096d6;background-color:#fff;box-sizing:border-box}gz-grid .gz-grid.ag-material .gz-expand-cell{cursor:pointer}gz-grid .gz-grid.ag-material sup{line-height:1.4}gz-grid .gz-grid.ag-material .hideTitle{display:none}gz-grid .gz-grid.ag-material .gz-action{background-color:#0096d6;border:none;color:#fff;padding:2px 30px;text-align:center;text-decoration:none;display:inline-block;font-size:14px;margin:4px 2px;cursor:pointer;min-width:35px;border-radius:3px}gz-grid .gz-grid.ag-material .gz-action:hover{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".sort-dialog{max-height:500px}@media (max-height:499px){.sort-dialog{max-height:100%}}.sort-dialog form{flex-basis:auto}.sort-dialog .form-container{min-height:0;padding:16px}.sort-dialog .sort-header{color:#5a5a5a;border-bottom:1px solid #f3f3f3;margin-bottom:2px}.sort-dialog .sort-header .sort-title{font-size:20px;font-weight:700}.sort-dialog .sort-header .md-button{color:#5a5a5a}.sort-dialog .sort-header .md-button.disabled{cursor:not-allowed;color:#ccc}.sort-dialog .sort-hint{font-size:12px;color:#ccc}.sort-dialog .sort-hint.spacer{padding-right:16px}.sort-dialog .sort-icon{margin:0}.sort-dialog .sort-scroll-container{overflow:auto}.sort-dialog .sort-scroll-container .sort-row{cursor:pointer;padding-left:16px;min-height:40px;color:#5a5a5a}.sort-dialog .sort-scroll-container .sort-row column-title{font-weight:700}.sort-dialog .sort-scroll-container .sort-row.selected{background-color:#bbedff!important}.sort-dialog .sort-scroll-container .sort-row:hover{background-color:#f3f3f3}.sort-dialog .add-row{margin-top:16px;min-height:40px}.sort-dialog .add-row md-select{margin:0}.sort-dialog .add-row .add-button{margin-left:0;margin-right:0}.sort-dialog .add-row .sort-title{font-weight:700;padding-right:16px}.sort-dialog .add-row .sort-title:after{content:\":\"}", ""]);
	
	// exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".gz-clickable{cursor:pointer}.gz-unselectable{user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;cursor:default}.gz-ellipsis{overflow:hidden;text-overflow:ellipsis}.gz-ellipsis,.gz-label{white-space:nowrap}.gz-label:after{content:\":\"}.gz-label.gz-bold{font-weight:700}md-data-table-container table.gz-table{width:100%;max-width:100%;margin-bottom:18px;border-collapse:separate;border-spacing:0;background-color:#fff}md-data-table-container table.gz-table thead:first-child>tr:first-child{background-color:#fff}md-data-table-container table.gz-table thead:first-of-type tr th{vertical-align:bottom;padding:2px 4px 10px!important;line-height:1.42857;text-align:left;font-size:14px!important;color:inherit!important}md-data-table-container table.gz-table thead:first-of-type tr th.center{text-align:center}md-data-table-container table.gz-table thead:first-of-type tr th div{height:auto!important}md-data-table-container table.gz-table thead th{vertical-align:bottom;border-bottom:2px solid #ccc;padding:2px 4px 10px;line-height:1.42857;text-align:left}md-data-table-container table.gz-table thead th.center{text-align:center}md-data-table-container table.gz-table thead[md-table-progress] th{border-bottom:0}md-data-table-container table.gz-table tbody tr td{padding:0 4px!important;line-height:1.5;vertical-align:middle;border-top:none;font-size:14px!important}md-data-table-container table.gz-table tr td:first-child,md-data-table-container table.gz-table tr th:first-child{width:auto!important}md-data-table-container table.gz-table tr:nth-child(2n){background-color:#f7f7f7}md-data-table-container table.gz-table tr:nth-child(odd){background-color:#fff}md-data-table-container table.gz-table tr:hover{background-color:#f3f3f3}md-data-table-container table.gz-table tr.selected{background-color:#bbedff!important}md-data-table-container table.gz-table tr.selectable{cursor:pointer}md-data-table-container table.gz-table tr.selected:hover{background-color:#bbedff!important}md-data-table-container table.gz-table tbody>tr{height:36px}md-data-table-container table.gz-table th.centered div{display:block!important;text-align:center}md-data-table-container table.gz-table tr td.icon{height:36px;text-align:center}md-data-table-container table.gz-table tr td.icon:first-child{text-align:left;padding-left:16px!important}.gz-empty-list-msg{color:#5a5a5a;text-align:center}.gz-view-container{box-sizing:border-box;min-width:100%;min-height:100%;padding:0 16px}@media (max-width:1280px){.gz-view-container{padding:0 1%}}.gz-dialog{max-height:50%}@media (max-width:1280px){.gz-dialog{max-height:66%}}@media (max-width:960px){.gz-dialog{max-height:100%}}.gz-readonly{box-sizing:border-box;background-color:#e5e8e8;padding:4px 8px;width:100%;overflow:hidden;flex-shrink:0}.gz-readonly .gz-table-row-flex{display:flex;box-sizing:border-box;max-width:100%;align-content:center;align-items:center;justify-content:flex-start;font-size:16px}.gz-readonly .gz-table-row-flex .gz-label{font-weight:700;padding-right:4px}.gz-readonly .gz-table-row-flex .gz-label:after{content:\":\"}.gz-readonly .gz-table-row-flex-spacer{height:8px}.gz-readonly .table-layout{display:table}.gz-readonly .table-layout .row{display:table-row}.gz-readonly .table-layout span{display:table-cell}.gz-readonly .table-layout span.label{font-weight:700;padding-right:4px}.gz-readonly .table-layout span.label:after{content:\":\"}.gz-readonly .fixed-table-layout{display:table;table-layout:fixed;width:100%}.gz-readonly .fixed-table-layout .row{display:table-row}.gz-readonly .fixed-table-layout span{display:table-cell}.gz-readonly .fixed-table-layout span.label{font-weight:700;width:80px;padding-right:20px}.gz-readonly .fixed-table-layout span.label:after{content:\":\"}.gz-readonly .fixed-table-layout span.description{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.gz-spinner-container{margin-top:16px}gz-filter-box{width:225px}.gz-toolbar-icon{margin:0 8px 0 0;cursor:pointer;width:24px;min-width:24px;height:24px;min-height:24px;font-size:24px;line-height:24px}.gz-toolbar-icon:last-child{margin:0}.gz-toolbar-icon.disabled{color:#e5e8e8;cursor:not-allowed}.md-tooltip{color:#fff!important;font-size:12px;background-color:#5a5a5a!important;opacity:1}.gz-menu md-menu-content.md-menu-bar-menu.md-dense .md-menu>.md-button:after{right:8px}.gz-menu md-menu-content{border:2px solid #0096d6}.gz-menu md-menu-content.md-menu-bar-menu.md-dense{padding:0}.gz-menu md-menu-content md-menu-item>.md-button{font-size:14px;font-weight:700;color:#5a5a5a}.gz-menu md-menu-content md-menu-item .md-button:not([disabled]):hover{background-color:#f3f3f3}.gz-menu md-menu-content .gz-menu-icon{height:16px;width:16px;min-height:16px;min-width:16px;font-size:16px;line-height:16px;margin:0 8px 0 0}.gz-menu md-menu-content .gz-menu-icon.right{margin:0}.gz-menu md-menu-content .filter-container{min-width:150px}.gz-password-hint{position:relative;-webkit-box-ordinal-group:5;order:4;overflow:hidden;clear:left;padding-top:5px;padding-right:5px;font-size:12px;line-height:14px;color:grey}md-card.gz-card{margin:0}md-card.gz-card md-card-title{flex:0 0 auto;box-sizing:border-box;height:45px;padding:4px 10px 10px;border-bottom:1px solid #767676;border-top-color:transparent;border-top-style:solid;border-top-width:6px}md-card.gz-card md-card-title+md-card-content{padding-top:16px}md-card.gz-card md-card-title-text{width:100%;font-weight:700;font-size:20px;color:#5a5a5a;overflow:hidden}md-card.gz-card md-card-title-text>*{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}md-card.gz-card md-card-content{flex:1 1 auto;overflow-y:auto!important}md-card.gz-card md-card-actions{margin:0}.gz-status-ok{color:#509137}.gz-status-warn{color:#f0aa3c}.gz-status-error{color:#f04b37}.gz-status-info{color:#0096d6}.gz-status-neutral{color:#5a5a5a}.gz-status-disabled{color:#ccc}.gz-image-spacer{padding-right:4px}", ""]);
	
	// exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".accept-account-page .terms-label .callout{color:#0096d6}.accept-account-page .terms-label:hover{color:#0096d6;text-decoration:underline}", ""]);
	
	// exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".hpid-sign-in-page .hpid-details{margin-top:16px}.hpid-sign-in-page .hpid-details i{font-style:normal;color:#e6734b}.hpid-sign-in-page .md-button{margin:16px 0 0}.hpid-sign-in-page .cancel{color:#0096d6;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".accept-user-page .overflow{overflow:hidden;text-overflow:ellipsis}.accept-user-page .terms-label .callout{color:#0096d6}.accept-user-page .terms-label:hover{color:#0096d6;text-decoration:underline}", ""]);
	
	// exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "st-icp .icp{padding:4px 0;font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".background-container{position:absolute;top:0;right:0;bottom:0;left:0;color:#fff}.background-container .background-image{width:100%;overflow:auto;background-image:url(https://cdn.printos.com/images/signin/landing/3d-landing.jpg);background-repeat:no-repeat;background-size:cover;background-position:15%}.background-container .background-image .content-container{padding-left:400px}.background-container .background-image .image-spacer{height:550px}.background-container .background-image .hp-logo{width:80px;height:80px;color:#fff;margin:0 28px 0 0}.background-container .background-image .hp-logo-spacer{width:80px;margin-right:28px}.background-container .background-image .identity-row .product-name{font-size:48px;font-weight:700}.background-container .background-image .description-row .product-description{font-size:20px;max-width:350px}.background-container .background-image .category-row{margin-top:64px}.background-container .background-image .category-row .category{max-width:300px;width:300px;margin:32px 16px}.background-container .background-image .category-row .category .title-container{margin-bottom:16px}.background-container .background-image .category-row .category .category-icon{width:48px;min-width:48px;height:48px;min-height:48px;margin-right:16px;fill:#fff}.background-container .background-image .category-row .category .category-name{font-size:24px}.background-container .background-image .category-row .details-container .category-desc{font-size:16px}@media screen and (max-width:800px){.background-container .background-image .content-container{background:rgba(0,0,0,.4);padding-left:32px}.background-container .background-image .content-container .image-spacer{height:250px}}.parallax-container{overflow:hidden;overflow-y:auto;scroll-behavior:smooth}.parallax-container .test-content{width:100%;height:400px;background-color:blue}.parallax-container .bgimg-1{position:relative;background-image:url(https://cdn.printos.com/images/signin/landing/pos-landing-page-main2.jpg);background-position:50%;background-size:cover;min-height:50vh}.parallax-container .bgimg-1:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;display:block;background-image:linear-gradient(90deg,#fff,#fff 25%,transparent)}.parallax-container .bgimg-1 .caption{position:absolute;bottom:40%;left:15%}.parallax-container .bgimg-1 .caption .welcome-content{-webkit-text-fill-color:#9d388c}@supports (-webkit-background-clip:text) and (not (-webkit-overflow-scrolling:touch)){.parallax-container .bgimg-1 .caption .welcome-content{background:linear-gradient(90deg,#973886,#0096d6);display:inline-block;-webkit-background-clip:text;background-clip:text;width:540px;max-width:100%;-webkit-text-fill-color:transparent}}.parallax-container .bgimg-1 .caption .welcome-content .welcome{font-size:72px}.parallax-container .bgimg-1 .caption .welcome-content .welcome-message{font-size:42px;max-width:100%;width:480px}@media screen and (max-width:1280px){.parallax-container .bgimg-1 .caption .welcome-content{width:300px;background:unset;-webkit-text-fill-color:#9d388c}.parallax-container .bgimg-1 .caption .welcome-content .welcome{font-size:56px}.parallax-container .bgimg-1 .caption .welcome-content .welcome-message{font-size:32px;width:300px}}.parallax-container .bgimg-1 .what-is-printos{position:absolute;right:0;bottom:0;margin:32px;border:2px solid #fff;border-radius:8px;padding:16px 64px;cursor:pointer;background:rgba(0,0,0,.2)}.parallax-container .bgimg-1 .what-is-printos a{text-decoration:unset;color:#fff}.parallax-container .bgimg-1 .what-is-printos .button-label{font-size:36px}.parallax-container .bgimg-1 .what-is-printos:hover{background:rgba(0,0,0,.5)}@media screen and (max-width:960px){.parallax-container .bgimg-1 .what-is-printos{padding:8px 32px;margin:8px;left:0}.parallax-container .bgimg-1 .what-is-printos .button-label{font-size:24px}}.parallax-container .content-container{position:relative;z-index:1;min-height:unset;height:auto;padding:32px;width:100%;flex-shrink:0}.parallax-container .content-container .content{z-index:3;color:#fff;flex-shrink:0}.parallax-container .content-container .content .content-panel{color:#fff;margin:0 32px;min-width:350px;width:100%}@media screen and (max-width:960px){.parallax-container .content-container .content .content-panel{margin:0;width:100%;min-width:100%}}.parallax-container .content-container .content .content-panel .cloud-box{position:relative;height:290px;width:100%}.parallax-container .content-container .content .content-panel .cloud-box .surround-text{position:absolute;top:60px;right:0;bottom:0;left:0;font-size:64px}.parallax-container .content-container .content .content-panel .cloud-box .surround{position:absolute;top:0;right:0;bottom:0;left:0;fill:none;stroke:#fff;height:220px;width:100%}.parallax-container .content-container .content .content-panel .content-label{text-transform:uppercase;text-align:center;font-size:24px;margin-bottom:32px}.parallax-container .content-container .content .content-panel .separator{width:100px;border-bottom:2px solid #fff}.parallax-container .content-container .content .content-panel .content-details{text-align:center;font-size:20px;margin-top:32px;min-height:150px}.parallax-container .content-container.counts{background:linear-gradient(90deg,#973886,#0096d6);box-shadow:0 0 20px #333}.parallax-container .content-container.counts .learn-link{text-decoration:none}.parallax-container .content-container.counts .content-title{color:#fff;font-size:48px;font-weight:300;text-align:center;margin-bottom:32px}.parallax-container .content-container.counts .content-title.button{cursor:pointer;padding:8px 32px;border:1px solid #fff}.parallax-container .content-container.counts .content-title.button:hover{background-color:hsla(0,0%,100%,.2)}.parallax-container .content-container.counts .background-cloud{position:absolute;opacity:.2;fill:#fff}.parallax-container .content-container.counts .background-cloud.cloud1{top:12%;left:3%;width:300px;height:300px}.parallax-container .content-container.counts .background-cloud.cloud2{top:34%;left:52%;width:210px;height:210px}.parallax-container .content-container.counts .background-cloud.cloud3{top:11%;left:72%;width:275px;height:275px}.parallax-container .content-container.pillars{background-color:#f3f3f3;padding:unset}.parallax-container .content-container.pillars .content-title{color:#5a5a5a;font-size:48px;font-weight:300;text-align:center;margin:32px 0}.parallax-container .content-container.pillars .content{width:100%;padding:32px}.parallax-container .content-container.pillars .pillar-box{margin-bottom:32px}.parallax-container .content-container.pillars .pillar-box md-icon.pillar{width:120px;height:120px}.parallax-container .content-container.pillars .pillar-label{text-transform:uppercase;text-align:center;font-size:24px;margin-bottom:32px}.parallax-container .content-container.pillars .pillar-highlight{color:#5a5a5a;text-align:center;font-size:16px;font-weight:700;margin-bottom:8px}.parallax-container .content-container.pillars .pillar-details{color:#5a5a5a;text-align:center;font-size:16px!important;min-height:50px;max-width:300px}.parallax-container .content-container.pillars .content-panel.optimize .pillar-box md-icon.pillar{fill:#973886}.parallax-container .content-container.pillars .content-panel.optimize .pillar-label{color:#973886}.parallax-container .content-container.pillars .content-panel.automate .pillar-box md-icon.pillar{fill:#4b67ae}.parallax-container .content-container.pillars .content-panel.automate .pillar-label{color:#4b67ae}.parallax-container .content-container.pillars .content-panel.grow .pillar-box md-icon.pillar{fill:#0096d6}.parallax-container .content-container.pillars .content-panel.grow .pillar-label{color:#0096d6}.parallax-container .content-container.applications{background-color:#fff;padding:unset}.parallax-container .content-container.applications .content{width:100%;padding:32px}.parallax-container .content-container.applications .content-title{color:#5a5a5a;font-size:48px;font-weight:300;text-align:center;margin:32px 0}.parallax-container .content-container.applications .app-learn{cursor:pointer}.parallax-container .content-container.applications .app-learn .app-play-icon{margin:0 8px 0 0;height:24px;width:24px;min-height:24px;min-width:24px;color:#fff}.parallax-container .content-container.applications .app-learn .app-link{color:#0096d6}.parallax-container .content-container.applications .app-learn:hover .app-link{text-decoration:underline}.parallax-container .content-container.applications .bu-indicator{border-radius:50%;margin-right:8px}.parallax-container .content-container.applications .bu-indicator.indigo{background-color:blue}.parallax-container .content-container.applications .bu-indicator.lf{background-color:green}.parallax-container .content-container.applications .bu-indicator.scitex{background-color:#ff1493}.parallax-container .content-container.applications .bu-indicator.pwi{background-color:orange}.parallax-container .content-container.applications .bu-filters .bu-button{cursor:pointer;border:1px solid #5a5a5a;border-radius:5px;padding:4px 8px;color:#5a5a5a;margin:8px;min-width:200px;height:50px}.parallax-container .content-container.applications .bu-filters .bu-button .bu-indicator{height:20px;width:20px}.parallax-container .content-container.applications .bu-filters .bu-button:hover{background-color:#f3f3f3}.parallax-container .content-container.applications .bu-filters .bu-button.selected{background-color:#ccc}.parallax-container .content-container.applications .app-section-header{margin-top:32px;margin-bottom:16px;max-width:1080px;width:100%}.parallax-container .content-container.applications .app-section-header .app-hr{box-sizing:border-box;border:1px solid}.parallax-container .content-container.applications .app-section-header .app-category-icon{margin-left:16px;margin-right:8px;width:32px;height:32px}.parallax-container .content-container.applications .app-section-header .app-category{margin-right:16px;font-size:24px}.parallax-container .content-container.applications .app-section-header.optimize{color:#973886;border-color:#973886}.parallax-container .content-container.applications .app-section-header.optimize .app-category-icon{color:#973886}.parallax-container .content-container.applications .app-section-header.automate{color:#4b67ae;border-color:#4b67ae}.parallax-container .content-container.applications .app-section-header.automate .app-category-icon{color:#4b67ae}.parallax-container .content-container.applications .app-section-header.grow{color:#0096d6;border-color:#0096d6}.parallax-container .content-container.applications .app-section-header.grow .app-category-icon{color:#0096d6}.parallax-container .content-container.applications .accordion-container{width:100%;padding:0 0 16px}.parallax-container .content-container.applications .accordion-container .bu-indicator{height:24px;width:24px;margin:0 8px}.parallax-container .content-container.applications .accordion{width:100%;max-width:1080px;height:400px;overflow:hidden}.parallax-container .content-container.applications .accordion .ac-table{width:100%;display:table;table-layout:fixed;margin:0;padding:0}.parallax-container .content-container.applications .accordion .ac-table .ac-item{display:table-cell;vertical-align:bottom;position:relative;width:16.666%;height:400px;background-repeat:no-repeat;background-position:50%;transition:all .5s ease;-webkit-box-shadow:-5px 0 40px 1px #000;-mox-box-shadow:-5px 0 40px 1px #000;box-shadow:-5px 0 40px 1px #000}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel{display:flex;overflow:hidden;width:100%}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-collapse{position:absolute;top:0;bottom:0;left:0;right:0;opacity:1}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-collapse .label-container{position:relative;width:100%;height:100%}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-collapse .panel-label{position:absolute;left:8px;bottom:8px;font-color:white;background:hsla(0,0%,100%,.7);padding:5px;font-size:20px;color:#5a5a5a;transform-origin:left bottom;transform:rotate(-90deg) translateY(100%);white-space:nowrap;box-sizing:border-box;max-width:384px}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand{display:flex;height:400px;width:100%;position:relative;z-index:3;padding:15px 20px;box-sizing:border-box;color:#fff;text-decoration:none;font-family:Open Sans,sans-serif;transition:all .2s ease}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand .app-identity{margin-bottom:8px}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand .app-identity .app-icon{min-width:64px;min-height:64px;width:64px;height:64px;margin:0 16px 0 0;color:#fff}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand .app-identity .app-title{font-size:24px}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand .app-identity .app-description{font-size:14px}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand .app-video{position:absolute;top:0;right:0;bottom:0;left:0;background:#000}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand .app-video .video-close-header{width:100%}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand .app-video .video-close-header .video-close{color:#fff;margin:4px 8px;cursor:pointer}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand *{opacity:0;z-index:5;overflow:hidden;-webkit-transform:translateX(-20px);transform:translateX(-20px);-webkit-transition:all .4s ease;transition:all .4s ease}.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item{width:8%}.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover{width:60%}.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover .ac-panel{background:rgba(0,0,0,.7)}.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover .ac-panel *{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover .ac-panel .ac-collapse{display:none}@media screen and (max-width:600px){.parallax-container .content-container.applications .accordion{height:auto}.parallax-container .content-container.applications .accordion .ac-table .ac-item,.parallax-container .content-container.applications .accordion .ac-table .ac-item:hover,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover{-webkit-box-shadow:unset;-mox-box-shadow:unset;box-shadow:unset;position:relative;display:table;table-layout:fixed;width:100%;-webkit-transition:none;transition:none;margin-bottom:8px}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel,.parallax-container .content-container.applications .accordion .ac-table .ac-item:hover .ac-panel,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item .ac-panel,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover .ac-panel{background:rgba(0,0,0,.4)}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel *,.parallax-container .content-container.applications .accordion .ac-table .ac-item:hover .ac-panel *,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item .ac-panel *,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover .ac-panel *{opacity:1!important;-webkit-transform:translateX(0)!important;transform:translateX(0)!important}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-collapse,.parallax-container .content-container.applications .accordion .ac-table .ac-item:hover .ac-panel .ac-collapse,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item .ac-panel .ac-collapse,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover .ac-panel .ac-collapse{display:none}.parallax-container .content-container.applications .accordion .ac-table .ac-item .ac-panel .ac-expand .app-description,.parallax-container .content-container.applications .accordion .ac-table .ac-item:hover .ac-panel .ac-expand .app-description,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item .ac-panel .ac-expand .app-description,.parallax-container .content-container.applications .accordion .ac-table:hover .ac-item:hover .ac-panel .ac-expand .app-description{min-width:unset;font-size:22px}}.footer{max-width:100%;width:940px;font-size:12px;flex-shrink:0;color:#5a5a5a}.footer .copyright-container{margin:8px 0}.footer .link-container{min-width:400px;margin:8px 0}.footer .link-wrapper{padding:4px 0}.footer .link-wrapper a{text-decoration:none}.footer .link{color:#5a5a5a;white-space:nowrap;text-align:center;cursor:pointer}.footer .link.wrap{white-space:normal}.footer .link:hover{color:#0096d6;text-decoration:underline}.footer .separator{border-right:1px solid #ccc;margin:0 16px;height:16px}.footer gz-locale-select{min-width:200px;margin:8px 0}.footer gz-locale-select label{display:none}.footer gz-locale-select md-input-container{margin:0}.scroll-button{position:absolute;right:32px;bottom:32px;background:rgba(0,0,0,.2);height:48px;width:48px;border-radius:50%;cursor:pointer;z-index:3}.scroll-button .arrow-up{border-bottom:16px solid rgba(0,0,0,.5)}.scroll-button .arrow-down,.scroll-button .arrow-up{width:0;height:0;border-left:16px solid transparent;border-right:16px solid transparent}.scroll-button .arrow-down{border-top:16px solid rgba(0,0,0,.5)}", ""]);
	
	// exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".lf-add .device-image{width:100%;margin-bottom:16px}.lf-add .page-information{padding:4px 8px!important;background-color:#f3f3f3;border:1px solid #e6e6e6;margin-bottom:16px}.lf-add .button-container{margin-bottom:12px}.lf-add .button-container .md-button{margin:0}", ""]);
	
	// exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "gz-spinner{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
	
	// exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".select-account .content-container{padding:16px}", ""]);
	
	// exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".sign-in-page gz-spinner{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}.sign-in-page .error-container{margin-bottom:16px;color:#5a5a5a;background:rgba(255,0,0,.1);border:1px solid rgba(255,0,0,.2);padding:8px;border-radius:5px}.sign-in-page .error-container .error-msg{opacity:1;padding-bottom:8px}.sign-in-page .error-container ul{margin-block-start:0;margin-block-end:0;padding-inline-start:20px}.sign-in-page .error-container ul li{margin-top:10px}.sign-in-page .error-container .alt-usernames{padding-bottom:8px}.sign-in-page .error-container .alt-usernames .alt-username{font-weight:700}.sign-in-page .error-container .alt-usernames .alt-sign-in-button{margin:0}.sign-in-page .panel-content .form-container.signin md-input-container{min-height:35px}.sign-in-page .panel-content .form-container.signin md-input-container.sub-linked{margin-bottom:0}.sign-in-page .panel-content .form-container.signin .md-errors-spacer{display:none}.sign-in-page .panel-content .form-container.signin md-checkbox{margin-top:8px}.sign-in-page .login-help .help-icon{margin:0;padding-right:8px;color:#5a5a5a;cursor:pointer;user-select:none}.sign-in-page .login-help .click-here{padding-left:8px;color:#0096d6;cursor:pointer}.sign-in-page .hpid-headline{font-weight:700}.sign-in-page .hpid-headline i{font-style:normal;color:#e6734b}.sign-in-page .hpid-headline i:hover{text-decoration:underline;cursor:pointer}.sign-in-page .hpid-help{padding:8px;border-radius:2px;background-color:rgba(0,150,214,.1)}.sign-in-page .hpid-help i{font-style:normal;color:#e6734b}.sign-in-page .md-button{margin:16px 0 0}.sign-in-page .md-button.last-button{margin-bottom:16px}md-option .md-text{flex:1}md-optgroup md-option{padding-right:16px}md-option .localized-language{color:#ccc;font-style:italic;font-size:14px}md-select-value .localized-language{display:none}md-select-value .language-container{align-items:center}md-optgroup>label{border-top:1px solid #ccc}", ""]);
	
	// exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".sign-up-page .section-title{padding:16px 0;font-weight:700;font-size:16px;color:#0096d6}.sign-up-page .admin-help{background-color:rgba(0,150,214,.3);padding:4px;border-radius:5px;margin-bottom:4px}.sign-up-page .panel-content .form-container.signup md-input-container{min-height:35px;width:100%}.sign-up-page .panel-content .form-container.signup md-input-container.sub-linked{margin-bottom:0}.sign-up-page .panel-content .form-container.signup .md-errors-spacer{display:none}.sign-up-page .help-icon{margin-left:6px;color:#5a5a5a;cursor:pointer;user-select:none}.sign-up-page .help-text{border-radius:5px;padding:8px;background-color:#e5e8e8;margin-bottom:8px}.sign-up-page .help-text .help-title{font-weight:700;margin-bottom:4px}.sign-up-page .help-text .help-section{margin-top:4px}.sign-up-page .captcha-container{height:66px}", ""]);
	
	// exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".support-page{position:relative}.support-page md-input-container .md-errors-spacer{min-height:0}.support-page .login-help{margin-bottom:16px}.support-page .login-help .help-icon{margin:0;padding-right:8px;color:#e6734b;cursor:pointer;user-select:none}.support-page .login-help .click-here{padding-left:8px;color:#0096d6;cursor:pointer}.support-page .help-icon{margin:0;color:#5a5a5a;cursor:pointer;user-select:none}.support-page .hpid-details{margin-bottom:16px;padding:0 8px 8px;border-radius:5px;background-color:rgba(0,150,214,.1)}.support-page .hpid-details .text{padding-bottom:8px}.support-page .hpid-details .text span:first-child{padding-right:4px}.support-page .hpid-details i{font-style:normal;color:#e6734b}.support-page .hpid-details p{margin-block-start:5px;margin-block-end:5px}.support-page .hpid-details ol{margin-block-start:0;margin-block-end:0;padding-inline-start:35px}.support-page .help{padding:8px;border-radius:2px;background-color:#f3f3f3}.support-page .contact-support-text{white-space:pre-wrap;font-family:Roboto,Helvetica Neue,sans-serif}.support-page .md-content{background-color:#f3f3f3}.support-page .message{min-height:30px;line-height:26px;max-height:100px;overflow-y:auto}.support-page .captcha-container{height:66px;margin-bottom:16px}.support-page .help-center-container{position:absolute;top:0;right:400px;bottom:0;left:0;z-index:4;background:rgba(0,0,0,.5)}@media screen and (max-width:1280px){.support-page .help-center-container{display:none}}.support-page .help-center-container .help-center{box-shadow:-7px 0 25px -9px rgba(0,0,0,.91);background-color:#fff;padding:40px;width:70%;max-width:550px}.support-page .help-center-container .help-center.expanded{width:70%;max-width:none;max-height:90%}.support-page .help-center-container .help-center.expanded md-list{max-height:600px;margin-top:24px;overflow:auto}.support-page .help-center-container .help-center .title-bar{width:100%}.support-page .help-center-container .help-center .title-bar .md-title{font-size:22px;font-weight:700;color:#5a5a5a}.support-page .help-center-container .help-center .list{width:100%}.support-page .help-center-container .help-center .search-box{width:200px}.support-page .help-center-container .help-center .expand-container{margin-left:16px}.support-page .help-center-container .help-center md-list{max-height:300px;margin-top:24px;overflow:auto}.support-page .help-center-container .help-center md-list-item{padding:0}.support-page .help-center-container .help-center md-list-item .article{text-transform:none;font-weight:400;font-size:18px;min-width:0;width:100%;text-overflow:ellipsis;padding:8px;color:#5a5a5a}.support-page .help-center-container .help-center .md-button{text-align:left;margin:0}.support-page .help-center-container .help-center .fa-life-ring{font-size:22px;padding:2px;margin-right:5px;color:#5a5a5a}.support-page .help-center-container .help-center .fa-compress,.support-page .help-center-container .help-center .fa-expand{font-size:22px;padding:2px;color:#0096d6;cursor:pointer}.support-page .help-center-container .help-center .see-all{padding-top:10px}.support-page .help-center-container .help-center .see-all a{color:#0096d6;cursor:pointer;text-decoration:none}.confirmation-container .action-container{padding:0 115px}", ""]);
	
	// exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".unsubscribe-container .subscription-data{color:#5a5a5a;background:#ccc;border:1px solid #ccc;padding:8px;border-radius:5px}.unsubscribe-container .subscription-data.success{background:rgba(0,255,0,.1);border:1px solid rgba(0,255,0,.2)}.unsubscribe-container .subscription-data .data{padding-left:8px}.unsubscribe-container .subscription-data .label{font-weight:700}.unsubscribe-container .subscription-data .label:after{content:\":\"}.unsubscribe-container .unsubscribe-desc{margin:16px 4px}", ""]);
	
	// exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)(false);
	// imports
	
	
	// module
	exports.push([module.id, "::-webkit-scrollbar{width:.4em;height:10px}::-webkit-scrollbar-track{background-color:transparent}::-webkit-scrollbar-thumb{background-color:#ccc;border-radius:10px}.fill-width{width:100%}.start-container .header{min-height:60px;background-color:#0096d6;width:100%;padding:0 8%;color:#fff;flex-shrink:0;z-index:3}.start-container .header .logo-container{flex:1;margin:8px 0}.start-container .header .logo-container .hp-logo{fill:#fff;width:36px;height:36px;margin:0 12px 0 0}.start-container .header .logo-container .printos-label{font-size:24px;min-width:200px}@media screen and (max-width:960px){.start-container .header .logo-container{flex:unset}.start-container .header .logo-container .printos-label{min-width:unset}}.start-container .header .button{min-width:200px;min-height:36px;line-height:36px;margin:8px;border-radius:3px;border:1px solid transparent;cursor:pointer}.start-container .header .primary{background-color:#fff;color:#0096d6}.start-container .header .primary:hover{background-color:#f7f7f7}.start-container .header .primary.disabled{color:#e5e8e8;background-color:#f3f3f3}.start-container .header .secondary{background-color:#0096d6;color:#fff;border-color:#fff}.start-container .header .secondary:hover{background-color:#0084bd}.start-container .content-area{width:100%}.start-container landing-content{width:100%;height:100%;position:relative}.content-area gz-error-bar .error-bar{margin-bottom:16px}.content-area gz-error-bar .error-msg{font-size:16px}.content-area .background-general{display:flex;align-items:flex-start;justify-content:center}@media screen and (min-width:1280px) and (max-width:1920px){.content-area gz-filter-box{width:35%}}@media screen and (max-width:1500px){.content-area gz-filter-box{width:25%}.content-area .background-general .help-center .title-bar .md-title{font-size:16px}}.content-area .panel-container{overflow:auto;width:100%;height:100%}@media (min-width:600px){.content-area .panel-container{width:400px}}.content-area .panel-content{min-height:100%;padding:16px;background-color:#fff}.content-area .panel-content md-content{padding:0;background-color:#fff;overflow:hidden}.content-area .panel-content .printos-identity{padding:0}.content-area .panel-content .printos-identity .printos-label{padding-left:16px;font-size:24px;font-weight:700;font-color:#5A5A5A}.content-area .panel-content .printos-identity .hp-logo{color:#0096d6;height:48px;width:48px;margin:0}@media screen and (min-width:600px){.content-area .panel-content .printos-identity{padding:16px 0}}@media screen and (min-width:960px){.content-area .panel-content .printos-identity{padding:32px 0}}.content-area .panel-content .page-title{padding:16px 0;font-weight:700;font-size:20px;color:#0096d6}.content-area .panel-content .page-details{flex-shrink:0;font-weight:700;font-size:16px;line-height:20px;color:#5a5a5a;padding-bottom:16px}.content-area .panel-content .page-information{box-sizing:border-box;padding:4px 0;width:100%;font-size:14px}.content-area .panel-content .page-information .table-layout{display:table}.content-area .panel-content .page-information .table-layout .row{display:table-row}.content-area .panel-content .page-information .table-layout span{display:table-cell;padding-bottom:6px}.content-area .panel-content .page-information .table-layout .label{font-weight:700}.content-area .panel-content .page-information .table-layout .label:after{content:\":\"}.content-area .panel-content .page-information .table-layout .value{padding-left:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.content-area .panel-content .request-container{color:#5a5a5a;background:rgba(0,255,0,.1);border:1px solid rgba(0,255,0,.2);padding:8px;border-radius:5px}.content-area .panel-content .request-container.invalid{background:rgba(255,0,0,.1);border:1px solid rgba(255,0,0,.2)}.content-area .panel-content .request-container .request-title{opacity:1;font-weight:700;padding-bottom:8px}.content-area .panel-content .request-container .request-message{opacity:1;padding-bottom:8px;overflow-wrap:break-word}.content-area .panel-content .form-action-container{padding:16px 0}.content-area .panel-content .form-action-container .md-button{margin:0}.content-area .panel-content .form-action-container .button-spacer{width:16px}.content-area .panel-content .links-container{padding:4px 0;width:100%;min-height:22px}.content-area .panel-content .links-container a{text-decoration:none}.content-area .panel-content .links-container .link{cursor:pointer;color:#0096d6;white-space:nowrap;text-align:center}.content-area .panel-content .links-container .link.left{text-align:left}.content-area .panel-content .links-container .link.right{text-align:right}.content-area .panel-content .links-container .link.sub-link{font-size:12px}.content-area .panel-content .links-container .link.wrap{white-space:normal}.content-area .panel-content .links-container .link:hover{text-decoration:underline;cursor:pointer}.content-area .panel-content .secondary-button{border:1px solid #0096d6}.content-area .panel-content .secondary-button:not(:hover){background-color:#fff}.content-area .panel-content .common-container{padding-top:20px}.content-area .panel-content .common-container .copyright-container{padding:4px 0;font-size:10px}", ""]);
	
	// exports


/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports) {

	module.exports = "<svg id=15f42c32-b52e-4426-81c2-abff64de2959 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Aborted</title><path d=M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM4,12a8,8,0,0,1,8-8,7.92,7.92,0,0,1,5.28,2L6,17.28A7.92,7.92,0,0,1,4,12Zm8,8a7.92,7.92,0,0,1-5.28-2L18,6.72A7.92,7.92,0,0,1,20,12,8,8,0,0,1,12,20Z /></svg>";

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	module.exports = "<svg id=bf21ffb9-165d-4fee-b241-9bbf97717e2b data-name=d91c873a-973e-45e2-bf66-ef0ab13c806a xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Artboard 1</title><path d=M18.73,11.56v-.23a3.21,3.21,0,0,0-3.21-3.2,3.15,3.15,0,0,0-.75.1A5.15,5.15,0,0,0,5,10.38a5.68,5.68,0,0,0,.11,1.09,3.87,3.87,0,0,0,1.8,7.3H17.23a3.76,3.76,0,0,0,1.5-7.21ZM6.88,17.77A2.88,2.88,0,0,1,4,14.89H4a2.85,2.85,0,0,1,1.55-2.53,1,1,0,0,0,.51-1.1A4.34,4.34,0,0,1,6,10.38a4.15,4.15,0,0,1,7.92-1.74,1,1,0,0,0,.91.59h.23a2.25,2.25,0,0,1,.52-.07,2.19,2.19,0,0,1,2.2,2.18v.18a1,1,0,0,0,.59,1,2.76,2.76,0,0,1-1.1,5.3Z /><path d=M14.42,10.83a.51.51,0,0,0-.71,0L12,12.53l-1.7-1.7a.5.5,0,1,0-.71.71l1.7,1.69-1.7,1.7a.5.5,0,0,0,0,.7.49.49,0,0,0,.36.15.47.47,0,0,0,.35-.15L12,13.94l1.69,1.69a.47.47,0,0,0,.35.15.49.49,0,0,0,.36-.15.5.5,0,0,0,0-.7l-1.7-1.7,1.7-1.69A.5.5,0,0,0,14.42,10.83Z /></svg>";

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = "<svg id=551b8ffb-7fa7-4b99-b2e5-3a91599c11dc data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Error</title><path d=M12,21a9,9,0,1,0-9-9A9,9,0,0,0,12,21ZM12,4a8,8,0,1,1-8,8A8,8,0,0,1,12,4Z /><path d=M12,14.79a.76.76,0,0,0,.75-.75V6.22a.75.75,0,1,0-1.5,0V14A.76.76,0,0,0,12,14.79Z /><circle cx=12 cy=17.03 r=0.75 /></svg>";

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24\" xml:space=preserve> <g> <path d=\"M19.15,15.88c-0.13,0-0.26-0.05-0.35-0.15l-4-4l0.71-0.71l3.65,3.65l3.65-3.65l0.71,0.71l-4,4\n\t\tC19.4,15.84,19.28,15.88,19.15,15.88z\"/> </g> <g> <path d=\"M8.5,20H7.32c-0.19,0-0.37-0.11-0.45-0.28c-0.23-0.47-0.41-0.72-0.6-0.96c-0.06-0.08-0.13-0.17-0.19-0.25S6,18.33,6,18.22\n\t\tv-5.11L0.91,5.79C0.81,5.63,0.8,5.43,0.88,5.27C0.97,5.1,1.14,5,1.32,5h12.56c0.14,0,0.26,0.06,0.36,0.15\n\t\tC14.56,5.47,14.58,6,14.3,6.4L9,13.13v6.37C9,19.78,8.78,20,8.5,20z M7.63,19H8v-6.05c0-0.11,0.04-0.22,0.11-0.31L13.35,6H2.28\n\t\tl4.63,6.67C6.97,12.75,7,12.85,7,12.95v5.11c0.02,0.03,0.05,0.06,0.07,0.09C7.23,18.36,7.42,18.61,7.63,19z\"/> </g> </svg> ";

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24\" xml:space=preserve> <g> <path d=\"M12.5,20h-1.18c-0.19,0-0.37-0.11-0.45-0.28c-0.23-0.47-0.41-0.72-0.6-0.96c-0.06-0.08-0.13-0.17-0.19-0.25\n\t\tC10.02,18.43,10,18.33,10,18.22v-5.11L4.91,5.79C4.81,5.63,4.8,5.43,4.88,5.27C4.97,5.1,5.14,5,5.32,5h12.56\n\t\tc0.14,0,0.26,0.06,0.36,0.15C18.56,5.47,18.58,6,18.3,6.4L13,13.13v6.37C13,19.78,12.78,20,12.5,20z M11.63,19H12v-6.05\n\t\tc0-0.11,0.04-0.22,0.11-0.31L17.35,6H6.28l4.63,6.67c0.06,0.08,0.09,0.18,0.09,0.28v5.11c0.02,0.03,0.05,0.06,0.07,0.09\n\t\tC11.23,18.36,11.42,18.61,11.63,19z\"/> </g> </svg> ";

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>edit_view_edit_columns</title><path d=M264.46,956.61H61.55V689.85H376.89l87.77-86.7V63.93A59.55,59.55,0,0,0,405.11,4.38H2V956.61a59.55,59.55,0,0,0,59.55,59.55H253.73ZM61.55,63.93H405.11V331.8H61.55Zm0,327.25H405.11V630.47H61.55Z /><rect x=595.39 y=332.46 width=260.7 height=577.23 transform=\"translate(799.76 1573.42) rotate(-135)\"/><polygon points=\"372.33 790.15 327.2 1019.62 556.67 974.49 372.33 790.15\"/></svg>";

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	module.exports = "<svg width=1792 height=1792 viewBox=\"0 0 1792 1792\" xmlns=http://www.w3.org/2000/svg><path d=\"M1472 989v259q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h255q13 0 22.5 9.5t9.5 22.5q0 27-26 32-77 26-133 60-10 4-16 4h-112q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-214q0-19 18-29 28-13 54-37 16-16 35-8 21 9 21 29zm237-496l-384 384q-18 19-45 19-12 0-25-5-39-17-39-59v-192h-160q-323 0-438 131-119 137-74 473 3 23-20 34-8 2-12 2-16 0-26-13-10-14-21-31t-39.5-68.5-49.5-99.5-38.5-114-17.5-122q0-49 3.5-91t14-90 28-88 47-81.5 68.5-74 94.5-61.5 124.5-48.5 159.5-30.5 196.5-11h160v-192q0-42 39-59 13-5 25-5 26 0 45 19l384 384q19 19 19 45t-19 45z\"/></svg>";

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>edit_view_filter</title><path d=M406.45,535.46v95.41H61.75V390.78h200l-56-56a39,39,0,0,1-3.69-3.57H61.75V62.44h344.7v199H466.2v-199A59.75,59.75,0,0,0,406.45,2.69H2v955.4a59.75,59.75,0,0,0,59.75,59.75H466.2V595.21Zm0,422.63H61.75V690.44h344.7Z /><path d=M988.56,324.91H356.93A29.6,29.6,0,0,0,328,344.06a28.55,28.55,0,0,0,7,34.82L578.73,622.61V862.87a30.64,30.64,0,0,0,9.4,22.28l126.4,126.74a29.25,29.25,0,0,0,22.28,9.4,34.82,34.82,0,0,0,12.19-2.44,29.6,29.6,0,0,0,19.15-29.25v-367l243.74-243.74a28.55,28.55,0,0,0,7-34.82A29.6,29.6,0,0,0,988.56,324.91Z /></svg>";

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>edit_view</title><path d=M402.86,958.76h-.28V765.52H499.5l59.69-59.59H402.58V540.46H683.39v41.48l59.77-59.66V62.92A59.77,59.77,0,0,0,683.39,3.16H2V958.76a59.77,59.77,0,0,0,59.77,59.77H402.86Zm-.28-895.84H683.39V257.24H402.58Zm0,253.91H683.39v164H402.58Zm-60,641.94H61.77V765.52H342.58Zm0-252.84H61.77V540.46H342.58Zm0-225.06H61.77v-164H342.58Zm0-223.63H61.77V62.92H342.58Z /><rect x=682.87 y=474.59 width=207.24 height=458.86 transform=\"translate(844.81 1757.98) rotate(-135)\"/><polygon points=\"505.55 838.42 469.67 1020.84 652.09 984.97 505.55 838.42\"/></svg>";

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>edit_view_reset_to_default</title><path d=M426,977l-16.23-16.16v.91H62.24V691.9H409.76v49.25H470V58.75A60.24,60.24,0,0,0,409.76-1.49H2V961.75A60.24,60.24,0,0,0,62.24,1022H470v-1.16ZM62.24,58.75H409.76v271H62.24Zm0,331H409.76V631.84H62.24Z /><g id=Layer_2 data-name=\"Layer 2\"><path d=M776,322.66H753.52c-135.86,0-246,110.13-246,246V806.21H357.12l220,219.28,220-220h-149V568.65A105.42,105.42,0,0,1,753.52,463.22H776A105.42,105.42,0,0,1,881.43,568.65V847.32H1022V568.65c0-135.86-110.13-246-246-246Z /></g></svg>";

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>edit_view_advanced sort_o2</title><polygon points=\"803.29 803.74 803.29 2 657.7 2 657.7 803.97 512 804.21 730.49 1022 948.98 803.51 803.29 803.74\"/><polygon points=\"220.71 220.26 220.71 1022 366.31 1022 366.31 220.03 512 219.79 293.51 2 75.02 220.49 220.71 220.26\"/></svg>";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = "<svg id=70ca0a72-d1d3-49fd-9b11-c4675d54798c data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Info</title><path d=M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Zm0,17a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z /><path d=M12,9.21a.76.76,0,0,0-.75.75v7.82a.75.75,0,0,0,1.5,0V10A.76.76,0,0,0,12,9.21Z /><circle cx=12 cy=6.97 r=0.75 /></svg>";

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports = "<svg id=39feebe1-14d2-4e34-abe4-11dcf9081a65 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>OK</title><path d=M12,21a9,9,0,1,0-9-9A9,9,0,0,0,12,21ZM12,4a8,8,0,1,1-8,8A8,8,0,0,1,12,4Z /><path d=M10.08,15.4a.52.52,0,0,0,.36.14.5.5,0,0,0,.35-.14l6.09-6.09a.5.5,0,0,0-.71-.71l-5.73,5.74L7.83,11.73a.5.5,0,0,0-.71,0,.5.5,0,0,0,0,.7Z /></svg>";

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	module.exports = "<svg id=51de220b-4778-40f7-aebe-b491ce003211 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Printed</title><path d=M20,4H3V19a1,1,0,0,0,1,1H21V5A1,1,0,0,0,20,4Zm0,1V8.56H4V5ZM4,19V9.56H20V19Z /></svg>";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = "<svg id=cd5b880d-7ba2-4063-96d1-06b944e3dd12 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Printing</title><path d=M20.4,10.28h-.91a8.34,8.34,0,1,0-1.13,6.22.5.5,0,0,0-.84-.54,7.35,7.35,0,1,1,.93-5.69l-.72,0a.6.6,0,0,0-.6.62.8.8,0,0,0,.09.36c.13.25,1.21,2.28,1.29,2.41a.6.6,0,0,0,1,0c0-.05,1.36-2.36,1.41-2.43a.7.7,0,0,0,.08-.33A.58.58,0,0,0,20.4,10.28Z /><path d=M11.08,6a.5.5,0,0,0-.5.5v6.22a.5.5,0,0,0,.5.5H15a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H11.58V6.52A.5.5,0,0,0,11.08,6Z /></svg>";

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	module.exports = "<svg id=427c620e-bc15-4e4d-8c3c-466856966eed data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Processing</title><path d=M12.09,4a8.06,8.06,0,0,1,4.15,1.15l-.81.79a.76.76,0,0,0,0,1.1,1,1,0,0,0,.4.24c.34.11,3.15,1,3.34,1a.76.76,0,0,0,.9-.9S19.19,4,19.16,4A.76.76,0,0,0,19,3.57a.74.74,0,0,0-1.09,0l-.9.87-.1-.1A9.09,9.09,0,0,0,3,12.08a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5A8.09,8.09,0,0,1,12.09,4Z /><path d=M20.5,11.42a.5.5,0,0,0-.5.5A8.08,8.08,0,0,1,7.76,18.85l.81-.79a.76.76,0,0,0,0-1.1,1,1,0,0,0-.4-.24c-.34-.11-3.15-1-3.34-1a.76.76,0,0,0-.9.9c0,.05.89,3.35.92,3.44a.76.76,0,0,0,.21.38.74.74,0,0,0,1.09,0l.9-.87a.94.94,0,0,0,.1.1A9.08,9.08,0,0,0,21,11.92.49.49,0,0,0,20.5,11.42Z /></svg>";

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 24 24\" style=\"enable-background:new 0 0 24 24\" xml:space=preserve> <g> <path d=M19.5,14h-15C4.22,14,4,14.22,4,14.5S4.22,15,4.5,15h15c0.28,0,0.5-0.22,0.5-0.5S19.78,14,19.5,14z /> <path d=M19.5,19h-15C4.22,19,4,19.22,4,19.5S4.22,20,4.5,20h15c0.28,0,0.5-0.22,0.5-0.5S19.78,19,19.5,19z /> <path d=\"M23.15,4.75l-3.9-3.9C18.77,0.37,17.88,0,17.19,0H17H4H1.5C0.67,0,0,0.67,0,1.5v21C0,23.33,0.67,24,1.5,24h21\n\t\tc0.83,0,1.5-0.67,1.5-1.5V6.81C24,6.12,23.63,5.24,23.15,4.75z M16,1v7.5C16,8.78,15.78,9,15.5,9h-10C5.22,9,5,8.78,5,8.5V1H16z\n\t\t M23,22.5c0,0.28-0.22,0.5-0.5,0.5h-21C1.22,23,1,22.78,1,22.5v-21C1,1.22,1.22,1,1.5,1H4v7.5C4,9.33,4.67,10,5.5,10h10\n\t\tc0.83,0,1.5-0.67,1.5-1.5V1h0.19c0.42,0,1.06,0.27,1.35,0.56l3.9,3.9C22.73,5.75,23,6.39,23,6.81V22.5z\"/> </g> </svg> ";

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = "<svg id=026501ec-d3d5-4352-a854-07bff0af76e8 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>ShuttingDown</title><path d=M15.09,4.52a.5.5,0,0,0-.65.29.49.49,0,0,0,.28.65,7.52,7.52,0,1,1-5.44,0,.49.49,0,0,0,.28-.65.5.5,0,0,0-.65-.29,8.53,8.53,0,1,0,6.18,0Z /><path d=M12.5,12.32V3.5a.5.5,0,0,0-1,0v8.82a.5.5,0,0,0,1,0Z /></svg>";

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports = "<svg id=b4ec1432-1947-46a8-9bc1-dfd4ad899bb2 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Unknown</title><path d=M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Zm0,17a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z /><path d=M11.87,15.75a.74.74,0,0,0-.57.22.8.8,0,0,0-.19.53.77.77,0,0,0,.19.52.88.88,0,0,0,1.14,0,.73.73,0,0,0,.19-.52.71.71,0,0,0-.76-.75Z /><path d=M12.06,6.91A3,3,0,0,0,10,7.6a2.34,2.34,0,0,0-.8,1.81H10.5a1.25,1.25,0,0,1,.43-1A1.64,1.64,0,0,1,12.06,8a1.44,1.44,0,0,1,1.11.41,1.61,1.61,0,0,1,.39,1.14A2.11,2.11,0,0,1,13,11l-.91.93a3.32,3.32,0,0,0-.7,1.06,4,4,0,0,0-.19,1.3h1.28A2.3,2.3,0,0,1,13,12.68l.75-.75a3.48,3.48,0,0,0,1.13-2.39,2.58,2.58,0,0,0-.73-1.93A2.83,2.83,0,0,0,12.06,6.91Z /></svg>";

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	module.exports = "<svg id=786b775d-4fe6-484c-b8bc-0c98177d005a data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Warning</title><path d=M11.25,10v4.37a.75.75,0,1,0,1.5,0V10a.75.75,0,0,0-1.5,0Z /><circle cx=12 cy=16.9 r=0.75 /><path d=M12.5,4.74a.53.53,0,0,0-1,0L3.12,19.25c-.28.48-.05.88.5.88H20.38c.55,0,.78-.4.5-.88ZM4.36,19.12,12,5.88l7.64,13.24Z /></svg>";

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Icon_Blue data-name=\"Icon Blue\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 98.79 76.83\"><title>PC_reporter</title><path d=M174.34,152.63V93.36a6.59,6.59,0,0,0-6.59-6.58H75.55V146a6.59,6.59,0,0,0,6.59,6.58h32.93v6.59H103v4.39H146.9v-4.39H134.82v-6.59h39.52ZM82.13,93.36h85.61V146H82.13V93.36Z transform=\"translate(-75.55 -86.78)\"/><polygon points=\"15.2 55.64 15.2 45.59 22.07 45.59 22.07 55.64 15.2 55.64 15.2 55.64\"/><polygon points=\"30.24 55.63 30.24 34.31 37.12 34.31 37.12 55.63 30.24 55.63 30.24 55.63\"/><polygon points=\"45.28 55.63 45.28 38.07 52.16 38.07 52.16 55.63 45.28 55.63 45.28 55.63\"/><polygon points=\"60.33 55.62 60.33 31.01 67.2 31.01 67.2 55.62 60.33 55.62 60.33 55.62\"/><path d=M158.16,96L145.53,97.3a2.41,2.41,0,0,0-.94.26c-0.66.37-.7,1.07,0,1.79l1.41,1.42,0,0-22.17,13.33-15.83-10-20.1,21.33,5.8,3.12L109.37,112l14.37,9.08,26.55-16h0l1.4,1.42A1.89,1.89,0,0,0,154,107a1.66,1.66,0,0,0,.61-0.61l5.18-8.8C160.36,96.6,159.64,95.88,158.16,96Z transform=\"translate(-75.55 -86.78)\"/><polygon points=\"75.9 55.61 75.9 23.47 82.9 23.47 82.9 55.61 75.9 55.61 75.9 55.61\"/></svg>";

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 64 74\"> <path d=\"M49.9 45.7c-7.8 0-14.1 6.3-14.1 14.1s6.3 14.1 14.1 14.1 14.1-6.3 14.1-14.1-6.3-14.1-14.1-14.1zm7.6 11.2l-7.9 7.9c-.6.6-1.7.6-2.3 0l-5.1-5.1c-.6-.6-.6-1.7 0-2.3.6-.6 1.7-.6 2.3 0l4 4 6.8-6.8c.6-.6 1.7-.6 2.3 0 .6.7.6 1.7-.1 2.3z\"/> <path d=\"M24.1 7.3c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8 1.8.8 1.8 1.8 1.8z\" fill=none /> <path d=\"M13.4 11.4v4.6h21.3v-4.6c0-1.6-1.3-2.9-2.9-2.9h-2.5v-3c0-2.9-2.3-5.2-5.2-5.2h-.1c-2.9 0-5.2 2.3-5.2 5.2v2.9h-2.4c-1.7 0-3 1.3-3 3zm10.7-7.7c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8-1.8-.8-1.8-1.8.8-1.8 1.8-1.8zM48.1 8.9c0-2.7-2.1-4.9-4.8-4.9h-12.2c.1.5.2 1 .2 1.5v1h.6c2.7 0 4.9 2.2 4.9 4.9v1.3h5.2v31.8c1.8-1.1 3.9-1.8 6.1-2.1v-33.5zM34.4 53.7h-28.2v-41h5.4v-1.3c0-2.7 2.2-4.9 4.9-4.9h.5v-1c0-.5 0-1 .2-1.5h-12.3c-2.6 0-4.9 2.2-4.9 4.9v46c0 2.7 2.2 4.9 4.9 4.9h28.6v-.5c0-2 .3-3.9.9-5.6z\"/> </svg> ";

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>maintenance-L</title><g id=a0bc8e4f-b787-46a2-bb54-b2f3a90cea5d data-name=\"Layer 2\"><path d=M105.28,29.56V16.16a5.19,5.19,0,0,0-5.2-5.19H83.16V16.5a1.85,1.85,0,1,1-3.69,0V1.85a1.85,1.85,0,1,1,3.69,0V7.27h16.92A8.89,8.89,0,0,1,109,16.16V70.92q-1.69-2.79-3.69-5.81V33.26H9.18v68.61a5.19,5.19,0,0,0,5.2,5.19H61.74a28.06,28.06,0,0,0,2.11,3.7H14.38a8.89,8.89,0,0,1-8.9-8.89V16.16a8.89,8.89,0,0,1,8.9-8.89H27.66V11H14.38a5.19,5.19,0,0,0-5.2,5.19v13.4ZM35,7.27H75.82V11H35V16.5a1.85,1.85,0,0,1-3.7,0V1.85a1.85,1.85,0,0,1,3.7,0Zm79.52,88c0,13.69-11.61,24.76-25.88,24.76S62.77,108.93,62.77,95.24c0-8.45,7.16-22,21.45-40.88a5.55,5.55,0,0,1,8.85,0C107.36,73.28,114.52,86.79,114.52,95.24Zm-48,0c0,11.61,9.91,21.06,22.17,21.06s22.18-9.45,22.18-21.06c0-7.36-6.89-20.36-20.7-38.65a1.84,1.84,0,0,0-2.59-.36,1.54,1.54,0,0,0-.36.36C73.36,74.88,66.47,87.88,66.47,95.24Z /></g></svg>";

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink viewBox=\"0 0 1024 1024\"><title>solution_navigator</title><path d=M428,240H544.09s0,0,0,0h48.75s0,0,0,0H705.4s0,0,0,0h52C692.18,108,556.08,17,398.75,17,178,17-1,196-1,416.74S178,816.47,398.81,816.47c9.8,0,19.19-.35,29.19-1ZM536.43,90.67A352.62,352.62,0,0,1,648.88,166.5C657.7,175.32,666,185,673.76,194H574.27c-20.48-45-45.82-85.66-73.74-116.25A352,352,0,0,1,536.43,90.67ZM428,76.17a144.73,144.73,0,0,1,21.75,16.11c22.16,19.52,44.45,48.34,64.13,83.58,3.32,5.95,6.55,12.14,9.68,18.14H428ZM148.63,166.5A357.73,357.73,0,0,1,300.4,76.74c-28.29,30.71-54,72.26-74.67,117.26h-102C131.52,185,139.81,175.32,148.63,166.5ZM72.8,279.07A410.39,410.39,0,0,1,92.1,240H207.16c-18.24,51-30,106-32.54,157h-129A350.26,350.26,0,0,1,72.8,279.07ZM95.64,599A330.06,330.06,0,0,1,72.8,554.43,352.62,352.62,0,0,1,46,443H174.89C178,495,190,549,208.23,599ZM261.08,742.58a352.6,352.6,0,0,1-112.45-75.83A246.49,246.49,0,0,1,128.72,645h98.43c20,43,44.42,81.71,71.29,110.93A351.88,351.88,0,0,1,261.08,742.58ZM382,762.67c-10-4.25-20.88-11.15-31.81-20.58C328,723,305.78,694.44,286.25,659.82c-2.71-4.8-5.35-9.82-7.94-14.82H382ZM382,599H257.3A509.25,509.25,0,0,1,238,542.21,494.58,494.58,0,0,1,220.55,443H382Zm0-202H220.23c1.8-33,7.81-67.55,17.67-102.76C243,276,249.11,258,256,240H382Zm0-203H276.55c3.13-6,6.42-12.19,9.74-18.14,19.68-35.24,42.1-64.06,64.26-83.58,10.88-9.58,21.45-16.61,31.45-21Z /><path d=M4454.82,2606.15V2969.7H4756V2606.15ZM4093.41,2969.7h301.18V2606.15H4093.41Zm361.41,424.14H4756V3030.3H4454.82Zm-361.41,0h301.18V3030.3H4093.41Zm-361.41,0h301.18V3030.3H3732Zm0-424.14h301.18V2606.15H3732Z /><rect x=614 y=643 width=283 height=46 /><rect x=614 y=735 width=283 height=46 /><rect x=614 y=827 width=283 height=46 /><path d=M838.21,300H487V962.91A51.61,51.61,0,0,0,538.17,1009H1024V489.15ZM842,369.61,960.83,480H842ZM977,963H534V346H803V489.15A38.15,38.15,0,0,0,838.21,521H977Z /></svg>";

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>productivity</title><g id=aa0d0e01-5602-4805-96cf-7255606d8533 data-name=\"Layer 2\"><path d=M56.25,59.18V11.25a52.5,52.5,0,0,0-41,85.33l41-37.41ZM17.73,99.42a52.35,52.35,0,0,0,38.52,16.83v-52L17.73,99.42ZM60,116.12a52.52,52.52,0,0,0,48.75-52.37H60ZM56.25,7.5H60V60h52.5v3.75A56.25,56.25,0,1,1,56.25,7.5Zm15-3.59V48.75h44.84C114.1,25.83,94.17,5.9,71.25,3.91ZM120,52.5H67.5V0C95.29,0,120,24.71,120,52.5Z /><g id=ee963854-478a-465c-9dbe-0e0627a6d7a2 data-name=b><path id=ac480945-5d72-4237-9001-68d59a154d9d data-name=a d=M56.25,59.18V11.25a52.5,52.5,0,0,0-41,85.33l41-37.41ZM17.73,99.42a52.35,52.35,0,0,0,38.52,16.83v-52L17.73,99.42ZM60,116.12a52.52,52.52,0,0,0,48.75-52.37H60ZM56.25,7.5H60V60h52.5v3.75A56.25,56.25,0,1,1,56.25,7.5Zm15-3.59V48.75h44.84C114.1,25.83,94.17,5.9,71.25,3.91ZM120,52.5H67.5V0C95.29,0,120,24.71,120,52.5Z fill-rule=evenodd /></g></g></svg>";

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Account</title><path d=M973.8,679.34H912.42V486.1H547.86V344.66H659.42V115.26a49.8,49.8,0,0,0-49.66-49.51H378.52V296.59c0,27.21,22.69,48.07,49.8,48.07h59.77V486.1H113.56V679.34H2V909c0,27.21,23.43,49.29,50.64,49.29H282.9V727.63a48.15,48.15,0,0,0-48-48.3H173.33V545.87H488.09V679.34H378.52V909a49.8,49.8,0,0,0,49.8,49.29H659.42V727.63c0-27.21-22.45-48.29-49.66-48.29h-61.9V545.87h304.8V679.34H743.09V909a49.39,49.39,0,0,0,49.39,49.29H1022V727.63a47.51,47.51,0,0,0-46.73-48.29Z /></svg>";

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 432 432\"><title>Administration-hp-icon</title><path d=M432,540c-2.15,0-4.29,0-6.42-.1l44.14-121.32h60.75c10.66,0,22.37-8.2,26-18.21l47.89-131.55c7.83-21.54-4.5-39.16-27.42-39.16H492.69L422,424h0L381.86,534.17C286.76,511.56,216,426.06,216,324c0-99.09,66.72-182.58,157.68-208L332.33,229.7h0L263.55,418.62h45.78l58.48-160.53h34.4L343.73,418.62h45.76L444,268.86c7.84-21.54-4.5-39.16-27.39-39.16H378.12L422.3,108.26c3.22-.14,6.45-0.23,9.71-0.23,119.29,0,216,96.71,216,216S551.31,540,432,540ZM562.7,258H528.31L480.14,390.13h34.4Z transform=\"translate(-216.01 -108.03)\"/></svg> ";

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" ?><!doctype html><svg enable-background=\"new 0 0 512 512\" height=512px id=Layer_1 version=1.1 viewBox=\"0 0 512 512\" width=512px xml:space=preserve xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g><path d=\"M189,437c0,4.971,4.029,9,9,9s9-4.029,9-9c0-23.447,23.262-36.737,49-50.186c25.739,13.447,49,26.738,49,50.186   c0,4.971,4.029,9,9,9s9-4.029,9-9c0-29.639-23.104-46.636-47.83-60.334c24.727-13.698,47.83-30.695,47.83-60.334   c0-29.638-23.104-46.635-47.83-60.334c24.726-13.699,47.83-30.696,47.83-60.335c0-29.637-23.104-46.634-47.83-60.331   C299.896,121.634,323,104.638,323,75c0-4.971-4.029-9-9-9s-9,4.029-9,9c0,23.446-23.261,36.736-49,50.184   C230.261,111.736,207,98.446,207,75c0-4.971-4.029-9-9-9s-9,4.029-9,9c0,29.638,23.104,46.634,47.83,60.332   C212.104,149.029,189,166.026,189,195.663c0,29.639,23.104,46.636,47.83,60.335C212.104,269.697,189,286.694,189,316.332   c0,13.25,4.798,25.302,14.26,35.818c1.777,1.976,4.23,2.98,6.693,2.98c2.145,0,4.297-0.762,6.017-2.31   c3.695-3.324,3.996-9.015,0.671-12.71c-6.577-7.311-9.641-14.867-9.641-23.779c0-23.447,23.262-36.737,49-50.186   c25.738,13.448,49,26.738,49,50.186s-23.261,36.737-49,50.186c-6.3-3.293-12.642-6.677-18.427-10.167   c-4.255-2.567-9.787-1.197-12.355,3.059c-2.566,4.256-1.197,9.788,3.059,12.355c2.78,1.677,5.655,3.3,8.556,4.9   C212.105,390.363,189,407.361,189,437z M207,195.663c0-23.446,23.262-36.735,49-50.183c25.738,13.447,49,26.736,49,50.183   c0,23.448-23.261,36.738-49,50.187C230.261,232.401,207,219.111,207,195.663z\"/><path d=M278.333,90.222c4.971,0,9-4.029,9-9s-4.029-9-9-9h-44.666c-4.971,0-9,4.029-9,9s4.029,9,9,9H278.333z /><path d=M233.667,428c-4.971,0-9,4.029-9,9s4.029,9,9,9h44.666c4.971,0,9-4.029,9-9s-4.029-9-9-9H233.667z /><path d=\"M233.667,191.889h44.666c4.971,0,9-4.029,9-9s-4.029-9-9-9h-44.666c-4.971,0-9,4.029-9,9S228.696,191.889,233.667,191.889z   \"/><path d=M278.333,220.889c4.971,0,9-4.029,9-9s-4.029-9-9-9h-44.666c-4.971,0-9,4.029-9,9s4.029,9,9,9H278.333z /><path d=\"M233.667,308.889h44.666c4.971,0,9-4.029,9-9s-4.029-9-9-9h-44.666c-4.971,0-9,4.029-9,9S228.696,308.889,233.667,308.889z   \"/><path d=\"M233.667,337.889h44.666c4.971,0,9-4.029,9-9s-4.029-9-9-9h-44.666c-4.971,0-9,4.029-9,9S228.696,337.889,233.667,337.889z   \"/></g></svg>";

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	module.exports = "<svg width=1792 height=1792 viewBox=\"0 0 1792 1792\" xmlns=http://www.w3.org/2000/svg><path d=\"M1504 448q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zm224-288q0 249-75.5 430.5t-253.5 360.5q-81 80-195 176l-20 379q-2 16-16 26l-384 224q-7 4-16 4-12 0-23-9l-64-64q-13-14-8-32l85-276-281-281-276 85q-3 1-9 1-14 0-23-9l-64-64q-17-19-5-39l224-384q10-14 26-16l379-20q96-114 176-195 188-187 358-258t431-71q14 0 24 9.5t10 22.5z\"/></svg>";

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = "<svg id=fed78da0-d64e-49da-ac5a-913105a72ea3 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Autoflow</title><path d=M795.52,872,574.87,366.83l-.32.2a80.28,80.28,0,0,0,9.1-37.38c0-41.82-31.31-75.72-69.93-75.72s-69.93,33.9-69.93,75.72a79.53,79.53,0,0,0,14.31,45.91L235.78,872.7c-30.6,8.06-53.33,37.95-53.33,73.57,0,41.83,31.31,75.73,69.93,75.73s69.93-33.9,69.93-75.73a80.82,80.82,0,0,0-6.39-31.67c15.36-27.48,75.24-64.42,185.1-64.42H687.74l28.72,69.18a81.36,81.36,0,0,0-4.54,26.91c0,41.83,31.31,75.73,69.93,75.73s69.93-33.9,69.93-75.73C851.78,909.52,827.6,878.88,795.52,872ZM252.38,978.73c-16.55,0-30-14.53-30-32.46s13.42-32.45,30-32.45,30,14.53,30,32.45S268.94,978.73,252.38,978.73ZM513.72,297.2c16.55,0,30,14.53,30,32.45s-13.42,32.46-30,32.46-30-14.53-30-32.46S497.17,297.2,513.72,297.2Zm20.21,455c-83.91,0-134.08,16.93-156.29,37.41l135.72-318L647.44,752.2ZM781.85,978.73c-16.55,0-30-14.53-30-32.46s13.42-32.45,30-32.45,30,14.53,30,32.45S798.4,978.73,781.85,978.73Z /><path d=M681.39,59.91C762.07,120.56,792.63,209.3,792.63,209.3c208.56,71.16,208.56,408.67-19.39,469L729.78,576.52c144.49-9.44,143.09-281.12,0-281.12a37.92,37.92,0,0,0-4.35.49C666.83-30.39,217,87.4,305.39,414.56,214.32,333.25,107.56,490.8,199,567.08c14.91,12.46,31.53,12.51,106.41,15.58L251.62,685.22C107.35,677.65,29.62,506.38,109,379.3,148.69,315.82,211,300.09,211,300.09,239.67,50.38,493.44-81.48,681.39,59.91Z /></svg>";

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	module.exports = "<svg id=adbf924a-e846-4dd5-bce6-ad28c5544903 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>Blacksea_Portal_option1</title><path d=M85.44,92.18a33.22,33.22,0,1,0-2.11,2.13l24.89,24.89a1.5,1.5,0,0,0,2.12,0,1.49,1.49,0,0,0,0-2.12Zm-46-.9a30.2,30.2,0,1,1,42.69,0A30,30,0,0,1,39.47,91.28Z /><path d=M45.94,70.93a1.5,1.5,0,0,0-1.5,1.5v10a1.5,1.5,0,0,0,3,0v-10A1.5,1.5,0,0,0,45.94,70.93Z /><path d=M55.86,55.93a1.5,1.5,0,0,0-1.5,1.5v25a1.5,1.5,0,0,0,3,0v-25A1.5,1.5,0,0,0,55.86,55.93Z /><path d=M65.77,65.93a1.5,1.5,0,0,0-1.5,1.5v15a1.5,1.5,0,0,0,3,0v-15A1.5,1.5,0,0,0,65.77,65.93Z /><path d=M75.69,60.93a1.5,1.5,0,0,0-1.5,1.5v20a1.5,1.5,0,0,0,3,0v-20A1.5,1.5,0,0,0,75.69,60.93Z /><path d=M110,37.34a15.42,15.42,0,0,0-2.59-.86A25.39,25.39,0,0,0,93.21,20.42a25.06,25.06,0,0,0-14.49-1.68A30.69,30.69,0,0,0,62.92,3,30.5,30.5,0,0,0,22.76,18.83a26,26,0,0,0-1,2.77A23.79,23.79,0,0,0,2.08,35.73,23.64,23.64,0,0,0,23.29,68.78h1.23q0-1.5.21-3h-1.4a20.19,20.19,0,0,1-7.78-1.7,20.64,20.64,0,0,1,7.37-39.56,1.49,1.49,0,0,0,1.38-1.09A27,27,0,0,1,25.51,20a27.5,27.5,0,0,1,50.9,1,1.49,1.49,0,0,0,1.74.91,22.7,22.7,0,0,1,5.06-.58A22.07,22.07,0,0,1,92,23.17a22.36,22.36,0,0,1,12.71,15,1.5,1.5,0,0,0,1.2,1.11,13,13,0,0,1,2.85.85,13.31,13.31,0,0,1,8,12.22,13.17,13.17,0,0,1-1.1,5.27,13.57,13.57,0,0,1-10.9,8.2H96.9c.11,1,.18,2,.21,3h7.76l.22,0a16.58,16.58,0,0,0,13.36-10,16.07,16.07,0,0,0,1.35-6.47A16.31,16.31,0,0,0,110,37.34Z /></svg>";

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>box</title><path d=M946.1,548.9v397H77.9V77.9H475.7V2H2V948.7A73.41,73.41,0,0,0,75.3,1022H1022V548.9Z /><path d=M622.8,4V79.7H891.7L605.4,366,659,419.6,944.9,133.7V402.4h75.7V77.1A73.06,73.06,0,0,0,947.5,4Z /></svg>";

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = "<svg id=e5811bd5-6778-4a8f-b80f-a321e2e4db20 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>configuration_center</title><g id=5e386b3b-4c98-44f6-ad58-5fe851bddfb9 data-name=Page-1><g id=a26aed6a-8ed2-402d-a7f7-ece0052233e6 data-name=M-Copy-14><g id=40c39ea5-01cc-4f62-beda-fd64a3c804d4 data-name=Group><g id=86d986bf-4285-4ddc-a20b-881022d2a01f data-name=Configuration-Cente-def><g id=d7221c94-5999-4565-ab50-51b4391151ac data-name=Configuration-Center><path id=3209e4dd-d1e6-4893-9bcb-ebe5ab0d0d6e data-name=Combined-Shape d=M59.65,3A3.78,3.78,0,0,1,63.32.19h8v0A3.78,3.78,0,0,1,75,3l1.72,6.46.88.36,5.88-3.4A3.81,3.81,0,0,1,88.09,7l5.68,5.56a3.73,3.73,0,0,1,.59,4.58L90.9,22.87c.12.27.23.54.34.82l6.62,1.67A3.75,3.75,0,0,1,100.72,29v7.86a3.77,3.77,0,0,1-2.86,3.64l-6.62,1.66c-.11.28-.22.56-.34.83l3.45,5.73a3.72,3.72,0,0,1-.58,4.59l-5.68,5.56a3.85,3.85,0,0,1-4.59.57L77.62,56l-.9.36L75,62.84a3.78,3.78,0,0,1-3.67,2.81h-8a3.78,3.78,0,0,1-3.67-2.81L58,56.39c-.3-.11-.59-.23-.88-.36l-5.89,3.4a3.87,3.87,0,0,1-4.6-.57L40.9,53.3a3.73,3.73,0,0,1-.59-4.58L43.77,43c-.12-.26-.23-.52-.34-.79L36.8,40.49A3.77,3.77,0,0,1,34,36.85V29a3.75,3.75,0,0,1,2.86-3.63l6.62-1.69c.11-.26.22-.53.34-.79l-3.46-5.75a3.73,3.73,0,0,1,.59-4.58L46.58,7A3.84,3.84,0,0,1,49.26,5.9a3.9,3.9,0,0,1,1.91.51l5.9,3.4c.28-.12.57-.24.87-.35ZM71,6.28H63.7L61.65,14l-.91.31a19,19,0,0,0-2.2.89l-.86.41-.83-.47-6.2-3.58-5.12,5,4.13,6.88-.44.87a17.31,17.31,0,0,0-.9,2.15l-.33.9-.93.24-7,1.76v7.06l7.88,2,.33.91a17.83,17.83,0,0,0,.9,2.14l.44.88-.51.84-3.62,6,5.12,5,7-4.05.85.41a19.8,19.8,0,0,0,2.22.9l.92.31.25.94,1.78,6.78H71l2-7.72.91-.31a20.51,20.51,0,0,0,2.24-.9l.86-.42.83.48L84,54.27l5.12-5L85,42.4l.44-.88a19.25,19.25,0,0,0,.92-2.18l.32-.9.94-.24,6.94-1.75V29.39l-7.88-2-.32-.91a18.36,18.36,0,0,0-.92-2.17L85,23.45l.51-.84,3.63-6-5.12-5-7,4.06-.86-.41a19.06,19.06,0,0,0-2.22-.9L73,14l-.25-.93Z /><path id=4cc8d143-c33c-48ea-9589-905bb00db9a6 data-name=Fill-3 d=M67.34,18.29A14.8,14.8,0,0,0,52.4,32.92a14.94,14.94,0,0,0,29.87,0A14.8,14.8,0,0,0,67.34,18.29m0,5.6a9,9,0,1,1-9.22,9,9.13,9.13,0,0,1,9.22-9 /></g><path id=0cc15c6a-d616-4827-a17c-74fe7450a9dd data-name=Fill-5 d=M.08,85.93,0,117.81a2.07,2.07,0,0,0,2.07,2,2,2,0,0,0,.91-.22l12.91-6.18L6.33,83.89Z /><path id=0b912362-4352-4eb9-b61e-93a0f037d1a8 data-name=Fill-7 d=M118.56,75.75A7.7,7.7,0,0,0,107.83,74L85.07,90.26l-31.69,0a2.61,2.61,0,0,1,0-5.21H71a6.88,6.88,0,0,0,7.24-6.65c0-2.86-1-7.66-7.84-7.66L34,70.73c-8.87,0-12.12,3.27-15.89,7l-.46.47a48.93,48.93,0,0,1-6.43,5.12l8.32,25.68a22.32,22.32,0,0,1,11.86-3.38l56,0A8.08,8.08,0,0,0,92,104.23l24.8-17.74a7.7,7.7,0,0,0,1.78-10.74 /></g></g></g></g></svg>";

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = "<svg id=fc238e38-8556-432f-ae1c-4556a92e30b3 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 64 64\"><title>composer_1</title><rect x=30.1 y=42.12 width=22.69 height=1.61 /><rect x=30.1 y=48.22 width=22.69 height=1.61 /><rect x=30.1 y=54.31 width=22.69 height=1.61 /><path d=M38.38,26.76l4.15,6.55,1.34,2.11,1.37-2.09L46.75,31l3.81,5.66H32.26l6.12-9.92m0-2.05a1.18,1.18,0,0,0-1,.6l-7,11.32a1.08,1.08,0,0,0-.1,1.14,1.1,1.1,0,0,0,1,.52H51.57a1,1,0,0,0,.89-1.66l-4.72-7a1.21,1.21,0,0,0-1-.59,1.22,1.22,0,0,0-1,.59l-1.86,2.84-4.53-7.14a1.18,1.18,0,0,0-1-.6Z /><path d=M60.37,64H25.75a3.49,3.49,0,0,1-3.49-3.49V16.93H56.88a3.49,3.49,0,0,1,3.49,3.49ZM23.87,18.54v42a1.88,1.88,0,0,0,1.88,1.88h33v-42a1.88,1.88,0,0,0-1.88-1.88Z /><rect x=10.36 y=39.24 width=10.09 height=1.61 /><rect x=10.36 y=45.33 width=10.1 height=1.61 /><path d=M38.59,7.66h-35V51.78A3.34,3.34,0,0,0,7,55.11H20.41V53.5H7a1.72,1.72,0,0,1-1.72-1.72V9.27H38.59A1.72,1.72,0,0,1,40.3,11v4.07h1.61V11a3.32,3.32,0,0,0-3.32-3.32Z /><path d=M50.76,0H16.14V5.78h1.61V1.61h33a1.88,1.88,0,0,1,1.88,1.88V15.05h1.61V3.49A3.49,3.49,0,0,0,50.76,0Z /><path d=M20.41,27.79H12.52l6.12-9.93,1.74,2.76v-3l-.75-1.19a1.12,1.12,0,0,0-2,0l-7,11.32a1.11,1.11,0,0,0-.11,1.14,1.12,1.12,0,0,0,1,.52h8.83Z /><rect x=10.36 y=33.14 width=10.07 height=1.61 /></svg>";

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 60 60\"><title>MindFire</title><g id=a275720c-41c9-4bb2-88de-7a4b5b6759b4 data-name=\"Layer 2\"><path d=M55.1,13.58a32.81,32.81,0,0,0-2-2.74C57.89,25.4,40.56,39.32,36.51,42.33l2.81,4.31L23.5,45.05,27.12,28l3.46,5.3C49.49,20.91,49.8,10.82,48.83,6.65a30,30,0,0,0-44.43,39C2.35,32.09,17.83,19.68,21.63,16.86l-2.82-4.31,15.83,1.59L31,31.21l-3.47-5.3C10,37.39,8.48,46.9,9.12,51.54a30,30,0,0,0,46-38Z /></g></svg>";

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>devices_1</title><g id=e56d8be8-be04-4b16-b8f5-9bbc13c5d849 data-name=\"Layer 2\"><path d=M117.8,9.7a7.49,7.49,0,0,0-2.06-1.46,8.28,8.28,0,0,0-1.84-.61,8.1,8.1,0,0,0-1.4-.13H0V105a7.48,7.48,0,0,0,4.14,6.7,7.43,7.43,0,0,0,3.36.8H120V15A7.45,7.45,0,0,0,117.8,9.7Zm-39,46.55h37.5v52.5H78.75ZM45,56.25H75v52.5H45ZM116.25,15V52.5H3.75V11.25H112.5A3.76,3.76,0,0,1,116.25,15ZM3.75,105V56.25h37.5v52.5H7.5a3.74,3.74,0,0,1-3-1.56A3.68,3.68,0,0,1,3.75,105Z /><path d=M37.5,22.5H15V41.25H37.5V22.5ZM18.75,26.25h15V37.5h-15Z /></g></svg>";

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = "<svg width=1792 height=1792 viewBox=\"0 0 1792 1792\" xmlns=http://www.w3.org/2000/svg><path d=\"M1024 1408h640v-128h-640v128zm-384-512h1024v-128h-1024v128zm640-512h384v-128h-384v128zm512 832v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-512v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-512v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45z\"/></svg>";

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Dscoop</title><path d=M512,14V346.18c-49.8.14-92.56,41.6-92.56,92.74S462.2,531.45,512,531.65V682.56c-192.05-2-346.13-159.27-344.15-351.32A347.76,347.76,0,0,1,395.54,8.44C170,61.16,2,263.38,2,505c0,281.68,229.1,510,510,510V682.86h.84a92.68,92.68,0,0,0,5.09-185.28q-2.71-.07-5.42,0H512V346.36c2,0,2.27-.12,3.41-.12,192.07,0,347.75,155.76,347.72,347.83a347.78,347.78,0,0,1-215.26,321.48C863.54,956.09,1022,758.56,1022,524,1022,242.33,792.9,14,512,14Z /></svg>";

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 36 36\"> <g> <path d=\"M4,3 L22,3 C23.1045695,3 24,3.8954305 24,5 L24,15 L25,15 L25,5 C25,3.34314575 23.6568542,2 22,2 L3,2 L3,29 C3,30.6568542 4.34314575,32 6,32 L17.6153846,32 L17.6153846,31 L6,31 C4.8954305,31 4,30.1045695 4,29 L4,3 Z M4,3 L22,3 C23.1045695,3 24,3.8954305 24,5 L24,15 L25,15 L25,5 C25,3.34314575 23.6568542,2 22,2 L3,2 L3,29 C3,30.6568542 4.34314575,32 6,32 L17.6153846,32 L17.6153846,31 L6,31 C4.8954305,31 4,30.1045695 4,29 L4,3 Z\"/> <polygon points=\"3 11 3 10 25 10 25 11\"/> <polygon points=\"3 18 3 17 18 17 18 18\"/> <polygon points=\"3 25 3 24 18 24 18 25\"/> <polygon points=\"10 10 11 10 11 32 10 32\"/> <polygon points=\"17 10 18 10 18 18 17 18\"/> <path d=\"M24.5 22C28.162969 22 31 20.4869168 31 19 31 17.5130832 28.162969 16 24.5 16 20.837031 16 18 17.5130832 18 19 18 20.4869168 20.837031 22 24.5 22zM24.5 23C20.3578644 23 17 21.209139 17 19 17 16.790861 20.3578644 15 24.5 15 28.6421356 15 32 16.790861 32 19 32 21.209139 28.6421356 23 24.5 23zM31 23L32 23C32 25.209139 28.6421356 27 24.5 27 20.3578644 27 17 25.209139 17 23L18 23C18 24.4869168 20.837031 26 24.5 26 28.162969 26 31 24.4869168 31 23zM31 23L32 23C32 25.209139 28.6421356 27 24.5 27 20.3578644 27 17 25.209139 17 23L18 23C18 24.4869168 20.837031 26 24.5 26 28.162969 26 31 24.4869168 31 23zM31 27L32 27C32 29.209139 28.6421356 31 24.5 31 20.3578644 31 17 29.209139 17 27L18 27C18 28.4869168 20.837031 30 24.5 30 28.162969 30 31 28.4869168 31 27zM31 27L32 27C32 29.209139 28.6421356 31 24.5 31 20.3578644 31 17 29.209139 17 27L18 27C18 28.4869168 20.837031 30 24.5 30 28.162969 30 31 28.4869168 31 27z\"/> <path d=\"M31,19 L32,19 L32,31 C32,33.209139 28.6421356,35 24.5,35 C20.3578644,35 17,33.209139 17,31 L17,19 L18,19 L18,31 C18,32.4869168 20.837031,34 24.5,34 C28.162969,34 31,32.4869168 31,31 L31,19 Z M31,19 L32,19 L32,31 C32,33.209139 28.6421356,35 24.5,35 C20.3578644,35 17,33.209139 17,31 L17,19 L18,19 L18,31 C18,32.4869168 20.837031,34 24.5,34 C28.162969,34 31,32.4869168 31,31 L31,19 Z\"/> </g> </svg> ";

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Home</title><path d=M1008.14,519.53,555.83,67.12a62.19,62.19,0,0,0-87.66-.06L15.86,519.56c-24.12,24.12-15.94,44,18.17,44H143.45V909.46c0,35.93,29.55,65.52,65.49,65.52H403.43V718H622.57V975h257V563.59H990C1024.08,563.59,1032.26,543.67,1008.14,519.53Z /></svg>";

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Imposer</title><path id=Fill-1 d=M518.09,777.82l23.53,48.44,41.23-20L559.32,757.8ZM629.22,901.66l-22.85-47-41.24,20,13.11,27H273.66l-160.48-321h.06l-31-62.08V505.24l191.45-382.9H578.25l-13.11,27,41.24,20,22.85-47H910.59L731.16,481.19,727.24,489H712.42v45.82h14.8l0,.19,3.92,7.81L910.59,901.66ZM792.65,512.09h-.31l.31-.16L991.07,115.08c17-34,0-61.49-38-61.49H231.17L2,511.92l.08.15H2L202.75,913.58s28.35,56.83,84.41,56.83H1022ZM512.27,660.9l-41.24,20,23.52,48.41,41.25-20ZM465.2,564,424,584l23.53,48.45,41.23-20Zm18-29.21h57.3V489h-57.3Zm34.86-288.63,41.23,20,23.53-48.43-41.23-20Zm17.7,68.47-41.25-20L471,343.06l41.24,20Zm62,220.16h57.28V489H597.83Zm-229.17,0H426V489H368.66Zm-229.17,0h57.29V489H139.49Zm114.59,0h57.29V489H254.08ZM488.72,411.54l-41.23-20L424,440l41.24,20Z /></svg>";

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = "<svg width=1792 height=1792 viewBox=\"0 0 1792 1792\" xmlns=http://www.w3.org/2000/svg><path d=\"M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298zm-640-288v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23z\"/></svg>";

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"> <rect x=271.35 y=600.48 width=319.77 height=42.08 /> <path d=M388,2H48.48V714.46a52.17,52.17,0,0,0,52.16,52.15V54.12h339.5A52.12,52.12,0,0,0,388,2Z /> <path d=M527.13,414.7c-4.61-7-12.11-7-16.74,0l-36.64,55.5L395.22,347.52c-4.52-7.07-11.85-7.07-16.37,0L266.42,520.38c-4.53,7-1.39,12.78,7,12.78H592c8.39,0,11.45-5.67,6.82-12.68Z /> <path d=M411.19,861.62C487.73,965.13,587.14,1022,692.76,1022h1c105.35-.35,204.78-57.21,281.75-160.37C816.43,648.61,569,648.41,411.19,861.62Zm282.17,85.65a85.38,85.38,0,1,1,85.38-85.38A85.38,85.38,0,0,1,693.35,947.27Z /> <path d=M530.92,684.62H271.35V726.7h193A415.65,415.65,0,0,1,530.92,684.62Z /> <path d=M341,861.61l24.82-33.54c3.55-4.8,7.22-9.37,10.87-14H192.19V146.34H475.65V294.28c0,18.14,28.1,45.13,46.21,45.13H669v306.8q11.49-.78,23.09-.81h.77c8,0,16,.3,23.88.84v-352L521.86,98.34H144.2V812.61a49.29,49.29,0,0,0,49.25,49.29h147.8Zm174.81-703,140.58,140.6H515.85Z /> </svg> ";

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>jobs_1</title><g id=e67b5701-b6e6-4b1a-a90f-efc853ef4ebc data-name=\"Layer 2\"><path d=M25.39,54.92a2,2,0,0,1,0-4.07H98.68a2,2,0,0,1,0,4.07Zm0,20.33a2,2,0,0,1,0-4.06H98.68a2,2,0,0,1,0,4.06Zm0,20.34a2,2,0,0,1,0-4.06H78.32a2,2,0,1,1,0,4.06ZM60,31a6.1,6.1,0,1,1,6.11-6.1A6.11,6.11,0,0,1,60,31ZM60,0A22.38,22.38,0,0,1,82.39,22.37h27.43A10.18,10.18,0,0,1,120,32.54V120H10.18A10.17,10.17,0,0,1,0,109.83V22.37H37.61A22.38,22.38,0,0,1,60,0Zm55.93,115.93V32.54a6.11,6.11,0,0,0-6.11-6.1H78.32V22.37a18.32,18.32,0,0,0-36.64,0v4.07H4.07v83.39a6.11,6.11,0,0,0,6.11,6.1Z /><g id=ea1c1383-2f8f-4f7a-a6c3-2d3afd94f8d8 data-name=b><path id=f1428818-04f0-4817-a1b2-e5fd4d6d1920 data-name=a d=M25.39,54.92a2,2,0,0,1,0-4.07H98.68a2,2,0,0,1,0,4.07Zm0,20.33a2,2,0,0,1,0-4.06H98.68a2,2,0,0,1,0,4.06Zm0,20.34a2,2,0,0,1,0-4.06H78.32a2,2,0,1,1,0,4.06ZM60,31a6.1,6.1,0,1,1,6.11-6.1A6.11,6.11,0,0,1,60,31ZM60,0A22.38,22.38,0,0,1,82.39,22.37h27.43A10.18,10.18,0,0,1,120,32.54V120H10.18A10.17,10.17,0,0,1,0,109.83V22.37H37.61A22.38,22.38,0,0,1,60,0Zm55.93,115.93V32.54a6.11,6.11,0,0,0-6.11-6.1H78.32V22.37a18.32,18.32,0,0,0-36.64,0v4.07H4.07v83.39a6.11,6.11,0,0,0,6.11,6.1Z fill-rule=evenodd /></g></g></svg>";

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Knowledge Zone</title><path id=Fill-1 d=M603,790.22H875.3l-66.75-66.75H68.77V189.25H936.83V597.11l63.47,63.5h0l3.28,3.27V189.25a66.78,66.78,0,0,0-66.8-66.76H2v601a66.79,66.79,0,0,0,66.77,66.77H402.65V857H280.23v44.52H725.38V857H603Z /><path d=M987.48,705.13h0L869.25,586.9a179.49,179.49,0,0,0,25.26-91.76c0-99.81-81.19-181-181-181s-181,81.2-181,181,81.21,181,181,181a179.53,179.53,0,0,0,91.25-25L933.51,779.92a34.22,34.22,0,0,0,48.27,0L1022,739.66ZM824,541.66A120.07,120.07,0,0,1,713.51,615c-66.12,0-119.92-53.75-119.92-119.86A119.92,119.92,0,1,1,824,541.66Z /></svg>";

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" standalone=\"no\"?> <!doctype html> <svg version=1.0 xmlns=http://www.w3.org/2000/svg width=1833.000000pt height=842.000000pt viewBox=\"0 0 1833.000000 842.000000\" preserveAspectRatio=\"xMidYMid meet\"> <g transform=\"translate(0.000000,842.000000) scale(0.100000,-0.100000)\" stroke=none> <path d=\"M962 7457 l-962 -962 0 -2908 0 -2907 1918 0 1917 0 943 943 c518\n518 942 945 942 950 0 4 -850 7 -1890 7 l-1890 0 0 2920 c0 1606 -3 2920 -8\n2920 -4 0 -440 -433 -970 -963z\"/> <path d=\"M7478 7453 l-965 -968 -7 -1810 c-3 -995 -6 -2302 -6 -2902 l0 -1093\n970 0 970 0 0 828 c0 455 3 885 7 955 l6 129 961 -959 961 -958 960 3 960 2\n-960 960 c-528 528 -955 960 -950 960 5 0 -426 436 -960 970 l-970 970 1940\n1937 1939 1938 -979 3 -980 2 -957 -957 -958 -958 0 958 c0 526 -4 957 -8 957\n-4 0 -442 -435 -974 -967z\"/> <path d=\"M13480 7445 l-970 -970 0 -1935 0 -1935 968 -968 967 -967 975 0 975\n0 968 968 c532 532 967 970 967 973 0 4 -873 10 -1940 14 l-1940 8 0 1918 0\n1919 1937 0 1938 0 -970 970 -970 970 -967 2 -968 3 -970 -970z\"/> </g> </svg> ";

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 86 120\"><title>locr_maps_icon</title><g id=aef4a52c-b523-4702-8ed2-f05e80e58a27 data-name=\"Layer 2\"><polygon points=\"43.33 81.4 86 107.23 86 98.88 43.32 73.04 0 98.89 0 107.26 43.33 81.4\"/><polygon points=\"43.32 84.9 0 110.75 0 120 43.31 93.93 86 120 86 110.73 43.32 84.9\"/><path d=M27.73,34.16a4.53,4.53,0,0,0-3.83,2.12c-1,1.42-1.55,3.71-1.55,6.94,0,3.42.7,9.22,5.38,9.22,4.89,0,5.51-5.89,5.51-9.46S32.5,34.16,27.73,34.16Z /><path d=M0,0V95.4L43.33,69.54,86,95.37V0ZM16.9,54.17H4.29V51.75H6.75c1,0,1.67-.42,1.67-1.52V24.72a1.67,1.67,0,0,0-.48-1.36,2.69,2.69,0,0,0-1.81-.63H3.88v-2.4l9.08-.4V50.7a.91.91,0,0,0,.25.7,1.78,1.78,0,0,0,1.12.35H16.9ZM33,53.31a10.35,10.35,0,0,1-5.33,1.46,9.41,9.41,0,0,1-7.19-3.2,11.76,11.76,0,0,1-2.93-8.26A11.71,11.71,0,0,1,20.44,35a9.57,9.57,0,0,1,7.29-3.21A9.78,9.78,0,0,1,35.12,35a11.63,11.63,0,0,1,3,8.29C38.1,47.45,36.65,51.13,33,53.31Zm18.87,1.46c-6.42,0-10.28-4.72-10.28-10.92,0-3.77,1-6.73,3.15-8.86a10.18,10.18,0,0,1,7.43-3.16,8,8,0,0,1,5.35,1.8,5.28,5.28,0,0,1,2.14,4.07A3.07,3.07,0,0,1,56.7,41a2.73,2.73,0,0,1-2.77-2.74,3.22,3.22,0,0,1,.87-2.11c.25-.28.28-.41.28-.43,0-.26-.17-.58-.72-1a3.73,3.73,0,0,0-2.17-.55A4.41,4.41,0,0,0,48.34,36a12.6,12.6,0,0,0-2,7.38c0,2.95.59,5.12,1.72,6.57a5.17,5.17,0,0,0,4.28,2.17c3.07,0,4.53-2.48,5.48-5l2.1.62C58.81,52,56.5,54.77,51.82,54.77ZM79.36,39.58a2.58,2.58,0,0,1-2.6-2.85,3.29,3.29,0,0,1,.4-1.56,4.3,4.3,0,0,0,.24-.44l0-.06a3,3,0,0,0-1.88,1,9.37,9.37,0,0,0-2.39,4A21.88,21.88,0,0,0,71.84,46v4.51c0,1.13,1.14,1.2,2,1.2h3v2.42H63.08V51.75h2.46c.63,0,1.77-.18,1.77-1V37.33c0-1.51-.5-2.57-2.16-2.57H63V32.45l8.29-.4v6.59c1.14-3.06,3-6.58,6.77-6.58a3.9,3.9,0,0,1,4.11,4.19C82.12,37.93,81.25,39.58,79.36,39.58Z /></g></svg>";

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>Marketplace Admin app icon</title><path d=M58.89,98.72l-.8-.2h-8V58.69H17.83V98.52H13.32A3.5,3.5,0,0,1,9.82,95V46.61a15.94,15.94,0,0,0,6.3,1.29h0a16.14,16.14,0,0,0,14.63-9.38A16.14,16.14,0,0,0,45.37,47.9h0A16.14,16.14,0,0,0,60,38.52,16.14,16.14,0,0,0,74.62,47.9h0a16.13,16.13,0,0,0,14.62-9.37,16.32,16.32,0,0,0,3.22,4.64,16,16,0,0,0,11.4,4.73h0a16,16,0,0,0,6.31-1.29V61.88l.16.17,2.84,2.89v-20A16.12,16.12,0,0,0,120,31.77a1.48,1.48,0,0,0-.22-.78h0L102.84,3.12A6.52,6.52,0,0,0,97.29,0H19.06L.22,31h0a1.48,1.48,0,0,0-.22.78A16.12,16.12,0,0,0,6.82,44.92V95a6.51,6.51,0,0,0,6.5,6.5H62.53l.31-.51c-.21-.49-.41-1-.59-1.45ZM45.37,44.9a13.15,13.15,0,0,1-13-11.63H58.42A13.16,13.16,0,0,1,45.37,44.9Zm29.25,0a13.15,13.15,0,0,1-13-11.63H87.67A13.16,13.16,0,0,1,74.62,44.9Zm29.25,0h0a13.14,13.14,0,0,1-13-11.63h26.09A13.16,13.16,0,0,1,103.87,44.9ZM20.74,3H97.28a3.59,3.59,0,0,1,3,1.68l15.55,25.59H4.17ZM3.08,33.27H29.17a13.13,13.13,0,0,1-26.09,0ZM20.83,98.52V61.69H47.11V98.52Z /><path d=M89.42,76.79A12.48,12.48,0,0,0,76.8,89.17,12.17,12.17,0,0,0,80.33,98a12.57,12.57,0,0,0,21.54-8.62,12.17,12.17,0,0,0-3.54-8.78A12.57,12.57,0,0,0,89.42,76.79Zm-.14,21.94a9.58,9.58,0,0,1-6.8-2.88A9.11,9.11,0,0,1,79.8,89.2a9.47,9.47,0,0,1,9.41-9.41h.18a9.61,9.61,0,0,1,6.8,2.87,9.23,9.23,0,0,1,2.68,6.66A9.52,9.52,0,0,1,89.28,98.73Z /><path d=M111.7,77.49l3.36-5.63-8-8.2L101.34,67a32.41,32.41,0,0,0-4.61-2l-1.59-6.35H83.53L81.94,65a26.27,26.27,0,0,0-4.61,1.85l-5.68-3.36-8,8.2L67,77.32a32.56,32.56,0,0,0-2,4.57L58.6,83.48V95L65,96.62a27.63,27.63,0,0,0,1.85,4.58l-3.36,5.63,8,8.2,5.68-3.36a31.3,31.3,0,0,0,4.61,2L83.36,120H95l1.59-6.31a27.4,27.4,0,0,0,4.61-1.85l5.66,3.34,8.24-8-3.37-5.65a31,31,0,0,0,2-4.63L119.9,95V83.65l-6.35-1.58A27.63,27.63,0,0,0,111.7,77.49Zm5.2,15.27-5.59,1.76-.24.75a29.58,29.58,0,0,1-2.41,5.59l-.41.75,3,5.08-4.9,4.74-5.13-3-.75.4A23.68,23.68,0,0,1,95,111l-.87.22L92.63,117H85.7l-1.43-5.72-.81-.24a29.84,29.84,0,0,1-5.62-2.4l-.75-.41-5.11,3-4.78-4.87,3-5.11-.41-.75A23.64,23.64,0,0,1,67.62,95l-.22-.87-5.8-1.45V85.82l5.75-1.42.25-.81A28.68,28.68,0,0,1,70,78l.41-.75-3-5.11,4.77-4.87,5.11,3,.75-.41a24.19,24.19,0,0,1,5.54-2.2l.88-.22,1.45-5.77H92.8l1.43,5.71.81.25a29.84,29.84,0,0,1,5.62,2.4l.75.41,5.11-3,4.78,4.87-3,5.1.41.76a23.47,23.47,0,0,1,2.22,5.51l.22.87L116.9,86Z /></svg>";

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	module.exports = "<svg id=982b87f6-f5af-44ba-90ea-aeacd7c499b5 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>market_place_header_icon</title><path d=M23.86,5.26,20.64.84A1.72,1.72,0,0,0,19.17,0H3.9L.14,5.26h0A.72.72,0,0,0,0,5.7,5.47,5.47,0,0,0,1.31,9.3v13A1.73,1.73,0,0,0,3,24H22.48V9.49A5.39,5.39,0,0,0,24,5.7a.7.7,0,0,0-.15-.43ZM4.67,1.5h14.5c.07,0,.14,0,.22.16L21.78,5H2.21ZM19.5,9.3a3.2,3.2,0,0,1-2.94-2.85h5.87A3.18,3.18,0,0,1,19.5,9.3ZM14.93,6.45A3.18,3.18,0,0,1,12,9.3,3.18,3.18,0,0,1,9.07,6.45Zm-13.36,0H7.43A3.18,3.18,0,0,1,4.5,9.3,3.18,3.18,0,0,1,1.57,6.45Zm7.24,16H6.18V15.55H8.81Zm12.17,0H10.31V14.05H4.68v8.44H3a.22.22,0,0,1-.21-.23V10.42a4,4,0,0,0,1.69.38h0A4.4,4.4,0,0,0,8.25,8.51,4.38,4.38,0,0,0,12,10.8h0a4.4,4.4,0,0,0,3.75-2.29A4.38,4.38,0,0,0,19.5,10.8h0A4.11,4.11,0,0,0,21,10.5Z /><path d=M12.2,20.52h7.13V14.05H12.2Zm1.5-5h4.13V19H13.7Z /></svg>";

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Media locator</title><path d=M829.31,2C723.08,2,636.94,88.12,636.94,194.35c0,83.11,117.3,296.19,168.36,385,.67,1.2,1.29,2.26,1.95,3.39a26.17,26.17,0,0,0,42.45.66c1.09-1.93,2.21-3.84,3.4-5.89,52-89.88,168.57-300.63,168.57-383.19C1021.67,88.12,935.55,2,829.31,2Zm0,269.54a67.8,67.8,0,1,1,67.78-67.79A67.8,67.8,0,0,1,829.31,271.54Z /><path d=M393.88,154.42H2.33V894c4.16,29.18,27.82,52.82,57,51.6H231.24V894H55.15V206H354.5v159.7c4.16,19.45,19.93,35.22,39.38,35.22H548.2V504.32l52.82.05V365.72Zm4.64,201.28V232.44L530.59,355.7Z /><path d=M674.53,540.93H275V967.15c-1.39,33.2,12.06,54.85,58.74,54.85H915.05V776.73Zm0,56.06,180,184.48h-180Zm191.81,374.9H325.14V591h310.7V776.73c-1.4,22.14,16.56,40.08,38.69,44.82H866.34Z /></svg>";

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	module.exports = "<svg id=98c18fdc-a951-453c-b578-07a4ba6ff30d data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>knowledge_app</title><path d=M82.12,26.62H37.88v15h-15V71.88a6.51,6.51,0,0,0,6.5,6.5h5.46v-3H29.38a3.51,3.51,0,0,1-3.5-3.5V44.62H94.12V71.88a3.51,3.51,0,0,1-3.5,3.5h-5.5v3h5.5a6.51,6.51,0,0,0,6.5-6.5V41.62h-15Zm-41.24,15v-12H79.12v12Z /><path d=M37.88,86.88a6.51,6.51,0,0,0,6.5,6.5H82.12V64.12H37.88Zm3-19.76H79.12V90.38H44.38a3.51,3.51,0,0,1-3.5-3.5Z /><path d=M60,0A60,60,0,0,0,15.85,100.61L1.09,115.37a2.5,2.5,0,1,0,3.54,3.53l14.75-14.75A60,60,0,1,0,60,0Zm0,117a57,57,0,1,1,57-57A57.06,57.06,0,0,1,60,117Z /></svg>";

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports = "<svg fill=#000000 height=24 viewBox=\"0 0 24 24\" width=24 xmlns=http://www.w3.org/2000/svg> <path d=\"M0 0h24v24H0z\" fill=none /> <path d=\"M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z\"/> </svg>";

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Icon_Blue data-name=\"Icon Blue\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 98.79 76.83\"><title>PC_reporter</title><path d=M174.34,152.63V93.36a6.59,6.59,0,0,0-6.59-6.58H75.55V146a6.59,6.59,0,0,0,6.59,6.58h32.93v6.59H103v4.39H146.9v-4.39H134.82v-6.59h39.52ZM82.13,93.36h85.61V146H82.13V93.36Z transform=\"translate(-75.55 -86.78)\"/><polygon points=\"15.2 55.64 15.2 45.59 22.07 45.59 22.07 55.64 15.2 55.64 15.2 55.64\"/><polygon points=\"30.24 55.63 30.24 34.31 37.12 34.31 37.12 55.63 30.24 55.63 30.24 55.63\"/><polygon points=\"45.28 55.63 45.28 38.07 52.16 38.07 52.16 55.63 45.28 55.63 45.28 55.63\"/><polygon points=\"60.33 55.62 60.33 31.01 67.2 31.01 67.2 55.62 60.33 55.62 60.33 55.62\"/><path d=M158.16,96L145.53,97.3a2.41,2.41,0,0,0-.94.26c-0.66.37-.7,1.07,0,1.79l1.41,1.42,0,0-22.17,13.33-15.83-10-20.1,21.33,5.8,3.12L109.37,112l14.37,9.08,26.55-16h0l1.4,1.42A1.89,1.89,0,0,0,154,107a1.66,1.66,0,0,0,.61-0.61l5.18-8.8C160.36,96.6,159.64,95.88,158.16,96Z transform=\"translate(-75.55 -86.78)\"/><polygon points=\"75.9 55.61 75.9 23.47 82.9 23.47 82.9 55.61 75.9 55.61 75.9 55.61\"/></svg>";

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Predictive_Press_Care</title><polygon points=\"800.39 36.31 776.13 -0.13 752.29 36.31 715.9 60.16 752.67 83.27 776.15 120.4 799.63 84.04 836.42 60.19 800.39 36.31\"/><polygon points=\"731.05 310.67 709.56 278.39 688.44 310.66 656.21 331.79 688.78 352.26 709.57 385.16 730.37 352.95 762.97 331.82 731.05 310.67\"/><path d=M2.65,736.15l-.65,271a17.52,17.52,0,0,0,25.33,15.15L137.1,969.75,55.84,718.89Z /><path d=M1009.79,649.69a65.38,65.38,0,0,0-91.24-15.13L725.11,773l-269.35-.32a22.16,22.16,0,0,1,0-44.32H605.48c38.54,0,61.57-28.72,61.57-56.48,0-24.3-8.65-65.11-66.64-65.11,0,0-272.29.24-309.1.24-75.32,0-103,27.78-135,60l-4,4c-16.33,16.34-36.53,30.9-54.65,43.53L168.4,932.7A190,190,0,0,1,269.29,904c21.54,0,475.53.35,475.53.35a69.67,69.67,0,0,0,39-12.56L994.65,740.93A65.41,65.41,0,0,0,1009.79,649.69Z /><path d=M802.77,569.16l-205.61-206-.2-.2A101.92,101.92,0,0,0,457,245.37l54.08,54.07a37.1,37.1,0,1,1-52.46,52.47l-54.09-54.08a101.93,101.93,0,0,0,117.56,140L727.88,644a53,53,0,1,0,74.89-74.89Zm-21,53.83a23.18,23.18,0,1,1,0-32.78A23.18,23.18,0,0,1,781.72,623Z /><polygon points=\"808.06 283.67 731.84 235.76 807.65 186.07 856.63 111.24 906.43 186.08 981.1 235.56 905.63 284.47 856.59 360.44 808.06 283.67\"/><path d=M761.37,167.15a363.27,363.27,0,0,0-170.76-42.46C389,124.69,225,288.7,225,490.29a365.14,365.14,0,0,0,9.25,81.4,241.38,241.38,0,0,1,41-5.5,325,325,0,0,1-9-75.9c0-179.17,145.24-324.41,324.41-324.41a323.16,323.16,0,0,1,130.72,27.5Z /><path d=M894.75,377.27a325.26,325.26,0,0,1,1.14,222.93,105.66,105.66,0,0,1,48.7-18.31,365.35,365.35,0,0,0-22.87-246.4Z /></svg>";

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = "<svg fill=#000000 height=24 viewBox=\"0 0 24 24\" width=24 xmlns=http://www.w3.org/2000/svg> <path d=\"M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z\"/> <path d=\"M0 0h24v24H0z\" fill=none /> </svg>";

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Print Beat</title><path id=Fill-1 d=M678.76,104.45,647.37,253.1C709.81,295.64,749.93,368,749.93,450.72c0,5.89-.31,12.27-1,20a9.15,9.15,0,0,0,6,9.39c12.94,4.62,32.68,11.76,53,19.09,5-19.89,7.33-42.32,7.32-64.82C815.53,383.88,803,332.54,786,310a10.16,10.16,0,0,1,16.33-12.09c21.45,29.52,33.08,82.65,33.29,136.49,0,24.63-2.65,49.28-8.47,71.72,17.84,6.42,34.67,12.43,46.14,16.44a9.15,9.15,0,0,0,11.8-6.2c7.61-27.57,11.47-66.67,11.47-95.14,0-137.23-81-266.36-217.82-316.78M223.1,421.23a337.41,337.41,0,0,0,12.6,89.42,9.13,9.13,0,0,0,8.77,6.65,10.36,10.36,0,0,0,4-.94c6.71-2.89,16.36-7,23.28-10.1a9.13,9.13,0,0,0,5.22-9.92,241.41,241.41,0,0,1-3.71-42.15C273.3,316.39,384,213,515.93,213a239.64,239.64,0,0,1,45,4.27l46.6-131a396.32,396.32,0,0,0-58.22-4.22c-176.21,0-326.2,138.47-326.2,339.1 /><path id=Fill-3 d=M582.44,459.25a40.33,40.33,0,0,1-22,21.83c-1,.42-2.1.81-3.14,1.14a40.54,40.54,0,0,1-27.57-76.17c1-.42,2.09-.81,3.15-1.14a40.54,40.54,0,0,1,49.6,54.34M662.78,32.11a14,14,0,0,0-18.29,7.55L528.2,366.52c-2.34.51-4.67,1.13-7,1.87-2,.65-4.06,1.37-6.07,2.19a78.86,78.86,0,0,0,53.69,148.16c2-.65,4.06-1.39,6.09-2.21a78.71,78.71,0,0,0,24.63-129.84L671.16,47.64a14,14,0,0,0-8.38-15.53 /><path id=Fill-6 d=M2.66,705,2,976a17.52,17.52,0,0,0,25.33,15.14L137.11,938.6,55.84,687.73Z /><path id=Fill-9 d=M1009.79,618.54a65.38,65.38,0,0,0-91.24-15.13L725.1,741.81l-269.35-.33a22.16,22.16,0,0,1,0-44.32H605.48c38.54,0,61.58-28.72,61.58-56.49,0-24.29-8.65-65.11-66.64-65.11,0,0-272.29.25-309.1.25-75.33,0-103,27.78-135,59.95l-4,4c-16.33,16.34-36.53,30.9-54.66,43.52L168.4,901.55a189.92,189.92,0,0,1,100.89-28.73c21.55,0,475.53.36,475.53.36a69.84,69.84,0,0,0,39-12.56L994.64,709.77a65.4,65.4,0,0,0,15.15-91.24 /></svg>";

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1000 835.15\"> <path d=M20.94-81.89l7.56-8.36-7.56-8.36c-3.54-3.9-87.8-95.68-194.31-95.68s-190.76,91.78-194.3,95.68l-7.56,8.36,7.56,8.36c3.53,3.91,87.79,95.69,194.3,95.69S17.4-78,20.94-81.89Zm-194.31-87.48c77.5,0,144.69,57.26,167.53,79.14-22.8,21.88-89.84,79.11-167.53,79.11-77.48,0-144.66-57.24-167.51-79.13C-318-112.13-250.85-169.37-173.37-169.37Z transform=\"translate(375.23 294.08)\"/> <path d=M-153.26-46.7h-40.38a20.15,20.15,0,0,0,20.22,18.2A20.29,20.29,0,0,0-153.26-46.7Z transform=\"translate(375.23 294.08)\"/> <path d=M-145.42-76.25c10.18-8.39,16-20.12,16-32.19,0-23.28-19.75-43.55-44-43.55s-44,20.27-44,43.55c0,12.07,5.84,23.81,16,32.19a21.23,21.23,0,0,1,7.16,12.94h41.71A21.23,21.23,0,0,1-145.42-76.25Z transform=\"translate(375.23 294.08)\"/> <rect x=189.34 width=24.92 height=69.28 /> <rect x=-316.27 y=-259.11 width=24.91 height=69.28 transform=\"translate(446.77 112.09) rotate(-30)\"/> <rect x=-77.7 y=-236.93 width=69.28 height=24.91 transform=\"translate(548.1 144.57) rotate(-60)\"/> <path class=cls-1 d=M458.73,123a12.46,12.46,0,0,0-12.46,12.46V359.57a12.46,12.46,0,1,0,24.92,0V135.46A12.46,12.46,0,0,0,458.73,123Z transform=\"translate(375.23 294.08)\"/> <path d=M328.32,185.77v173.8a12.46,12.46,0,0,0,24.92,0V185.77a12.46,12.46,0,0,0-24.92,0Z transform=\"translate(375.23 294.08)\"/> <path d=M212.73,251.05V359.57a12.46,12.46,0,0,0,24.92,0V251.05a12.46,12.46,0,0,0-24.92,0Z transform=\"translate(375.23 294.08)\"/> <path d=M90.45,232.36V359.57a12.46,12.46,0,0,0,24.92,0V232.36a12.46,12.46,0,0,0-24.92,0Z transform=\"translate(375.23 294.08)\"/> <path class=cls-1 d=M-22.78,296v63.61A12.46,12.46,0,0,0-10.32,372,12.46,12.46,0,0,0,2.14,359.57V296A12.46,12.46,0,0,0-10.32,283.5,12.46,12.46,0,0,0-22.78,296Z transform=\"translate(375.23 294.08)\"/> <path class=cls-1 d=M139,78.94l-158,151.33a12.46,12.46,0,0,0-.38,17.62,12.42,12.42,0,0,0,9,3.84,12.44,12.44,0,0,0,8.62-3.47l140.83-134.9,90.05,85.32L446.27-1.3V50.54a12.46,12.46,0,1,0,24.92,0V-41.3l-93.32-.27h0a12.45,12.45,0,0,0-12.45,12.42,12.46,12.46,0,0,0,12.42,12.5l48.21.13L229.42,164.58Z transform=\"translate(375.23 294.08)\"/> <path class=cls-1 d=M624.77,437V-62.45a54.05,54.05,0,0,0-54-54H36.7c12.61,12.3,20.8,21.67,23.56,24.92H570.78a29.1,29.1,0,0,1,29.07,29.07V412.11H-131.84A29.11,29.11,0,0,1-160.91,383V37.79c-4.12.25-8.28.4-12.46.4s-8.32-.26-12.46-.53V383a54.06,54.06,0,0,0,54,54H146.73v79.12H32.17v24.92H410.73V516.15H292.61V437ZM267.69,516.15h-96V437h96Z transform=\"translate(375.23 294.08)\"/> </svg> ";

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>report_now_icon</title><g id=e0b23307-afbc-462b-ad61-dea38fbe5c59 data-name=\"Layer 2\"><path d=M105,0H10V115a5,5,0,0,0,5,5h95V5A5,5,0,0,0,105,0Zm0,3a2,2,0,0,1,2,2V109.43H13V3ZM15,117a2,2,0,0,1-2-2v-2.57h94V117Z /><path d=M33.79,84.39a21,21,0,0,0,8.82,2,21.92,21.92,0,0,0,2.68-.17A21,21,0,0,0,56.6,81a1.16,1.16,0,0,0,.38-.86,1.38,1.38,0,0,0-.28-.85L42.44,65h0V44.85a1,1,0,0,0-.38-.8,1.23,1.23,0,0,0-.85-.34A21.53,21.53,0,0,0,31.08,47a21.12,21.12,0,0,0-9.93,18,20.75,20.75,0,0,0,3.61,11.88A21.85,21.85,0,0,0,33.79,84.39ZM26.43,56.11a17.93,17.93,0,0,1,6.25-6.58,18.19,18.19,0,0,1,6.76-2.59V65a3,3,0,0,0,.92,2.16L53.12,79.92a17.55,17.55,0,0,1-8.21,3.3A17.63,17.63,0,0,1,35,81.66a18.61,18.61,0,0,1-7.79-6.46A17.56,17.56,0,0,1,24.15,65,17.78,17.78,0,0,1,26.43,56.11Z /><path d=M69.06,59.72a20.38,20.38,0,0,0-3-9.78,21.79,21.79,0,0,0-7.22-7.23,20.4,20.4,0,0,0-9.79-3,1.25,1.25,0,0,0-.85.33,1,1,0,0,0-.38.81V61H67.91a1,1,0,0,0,.81-.38A1.23,1.23,0,0,0,69.06,59.72ZM50.77,58V42.87a17.12,17.12,0,0,1,6.45,2.4,19,19,0,0,1,6.24,6.24A17.06,17.06,0,0,1,65.86,58Z /><path d=M69.72,65.38a1,1,0,0,0-.81-.38H48.77L63,79.26a1.21,1.21,0,0,0,.86.38,1.19,1.19,0,0,0,.85-.38,22.09,22.09,0,0,0,3.76-6.13,21.21,21.21,0,0,0,1.57-6.89A1.3,1.3,0,0,0,69.72,65.38Zm-4,6.61a19.44,19.44,0,0,1-2,3.7L56,68H66.85A18.63,18.63,0,0,1,65.71,72Z /><path d=M78.34,51.33h19.1a1.5,1.5,0,0,0,0-3H78.34a1.5,1.5,0,0,0,0,3Z /><path d=M78.34,59.58h19.1a1.5,1.5,0,0,0,0-3H78.34a1.5,1.5,0,0,0,0,3Z /><path d=M78.34,67.84h19.1a1.5,1.5,0,0,0,0-3H78.34a1.5,1.5,0,0,0,0,3Z /><path d=M98.85,96H92.5c-.64,0-.91-.39-1.51-2.2s-1.38-4.16-4.23-4.16c-2.07,0-3.51,1.89-4.48,4.19l-2-13.29a1.5,1.5,0,0,0-2.94-.14c0,.12-2.9,11.8-3.77,14.53C73.12,96.36,71.19,96.06,71,96A1.5,1.5,0,0,0,70.39,99c1.64.32,5,.09,6-3.14.41-1.29,1.22-4.39,2-7.41l2,13.33A1.5,1.5,0,0,0,81.91,103h0a1.5,1.5,0,0,0,1.47-1.32c.57-4.58,2.24-9.07,3.36-9.07.53,0,.77.28,1.38,2.11S89.56,99,92.5,99h6.35a1.5,1.5,0,0,0,0-3Z /><path d=M100.51,9.53H21.15v9h79.36Zm-3,6H68.82v-3H97.51Z /><path d=M100.51,23.68H21.15v9h79.36Zm-3,6H83.94v-3H97.51Z /></g></svg>";

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Service Center for Channels</title><path d=M950.11,560.91l-.13-.05a115.77,115.77,0,0,0-34.22-8.79A199.22,199.22,0,0,0,799.56,409.14a197.13,197.13,0,0,0-78.85-16.51,199.46,199.46,0,0,0-56.88,8.3,247,247,0,0,0-461-19.85,236.7,236.7,0,0,0-13.3,40h-1.89A185.38,185.38,0,0,0,113.7,776.56a183.57,183.57,0,0,0,70.87,15.24h2.55l725.66.12,1.24-.12c43.05-4.39,80.33-33.19,98.09-73.68a119.52,119.52,0,0,0-62-157.23Zm18.16,138.18c-10.79,24.94-34.22,42.38-57.69,45H198.93l0-.1H188.38c-.4,0-.74,0-1,0h-.24a135.82,135.82,0,0,1-54.36-11.29,137.54,137.54,0,0,1,73-262.56l23.39,3.13,3.48-23.31a195.6,195.6,0,0,1,14.07-49.82,199.1,199.1,0,0,1,262.2-103.73c61.34,26.7,102.25,80.35,115.41,141.12l6.26,29.08,27-12.36a152.2,152.2,0,0,1,63.09-13.75A148.68,148.68,0,0,1,780.51,453a151.58,151.58,0,0,1,90.81,125l2.23,23.61,23.66-2.07c2-.17,4.14-.28,6.34-.28a69.45,69.45,0,0,1,27.45,5.5,71.73,71.73,0,0,1,37.26,94.31Z /><path d=M647.65,618.55l-171-171a78.81,78.81,0,0,0-108.81-88.38l-6.12,2.68L405.86,406a22.46,22.46,0,1,1-31.76,31.77L330,393.66l-2.68,6.12A78.81,78.81,0,0,0,415.67,508.6l171,171a43.14,43.14,0,0,0,61-61Zm-18.38,42.62a16.89,16.89,0,1,1,0-23.88A16.85,16.85,0,0,1,629.27,661.18Z /></svg>";

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 98.87 75.79\"> <path d=M167.46,116.29a11.25,11.25,0,0,0-3.32-.85,19.35,19.35,0,0,0-11.25-13.86,19,19,0,0,0-7.65-1.59,19.43,19.43,0,0,0-5.52.81,24,24,0,0,0-13.17-14.39A23.94,23.94,0,0,0,95,98.86a22.82,22.82,0,0,0-1.29,3.88H93.56a18,18,0,1,0,0,35.94H112.4V134H93.51a13.1,13.1,0,0,1-5.27-1.1,13.33,13.33,0,0,1,5.32-25.57,32.39,32.39,0,0,1,4,.42,25.4,25.4,0,0,1,1.7-7.09A19.42,19.42,0,0,1,117,89.06a19.21,19.21,0,0,1,7.67,1.6,19.41,19.41,0,0,1,11.19,13.68l0.6,2.82,2.62-1.19c2.79-1.29,8.68-1.86,11.92-.12a17,17,0,0,1,9,14.39,11.27,11.27,0,0,1,5.57.32,6.94,6.94,0,0,1,3.61,9.13,7.21,7.21,0,0,1-5.6,4.37H154v4.64h10a11.91,11.91,0,0,0,9.51-7.15A11.61,11.61,0,0,0,167.46,116.29Z transform=\"translate(-75.56 -84.42)\"/> <path d=M150,132v-8.13h0v-5a3,3,0,0,0-1.23-2.21c-1.87-2.11-8.12-3.66-15.55-3.66h0c-8.91,0-16.13,2.23-16.13,5s7.22,5,16.13,5c5.3,0,10-.78,12.94-2v3.44a40,40,0,0,1-13,1.83c-6.27,0-13.29-1-16.7-3.71v18.75h0v13h0v0.12c0,2.69,5.21,5,12.3,5.65,1.43,0.13,2.93.21,4.49,0.21h0.89l0.85,0h0c8.45-.31,15-2.81,15-5.84V132h0Z transform=\"translate(-75.56 -84.42)\"/> </svg> ";

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Service Center</title><path d=M607.09,674.73v-.06l-427.15-.07c-.39,0-.71,0-1,0h-.23a129.68,129.68,0,0,1-51.9-10.78,131.32,131.32,0,0,1,69.7-250.67l22.33,3,3.32-22.26a186.72,186.72,0,0,1,13.43-47.57,190.09,190.09,0,0,1,250.33-99C544.52,272.75,583.58,324,596.14,382l6,27.77L627.93,398a145.3,145.3,0,0,1,60.24-13.13,142,142,0,0,1,57.09,11.95q4.84,2.1,9.45,4.51,23.78-13,56.16-16.95a190.15,190.15,0,0,0-47.42-29.44,188.22,188.22,0,0,0-75.28-15.76,190.46,190.46,0,0,0-54.31,7.93,235.79,235.79,0,0,0-440.15-18.95A226,226,0,0,0,181,366.3h-1.81a177,177,0,0,0-2.9,353.94H607.09Z /><path d=M840.19,644.63c-71.17,0-99.53-30.65-99.53-105.45,0-75.15,28.36-105.43,99.53-105.43S939.68,464,939.68,539.18C939.68,614,911.31,644.63,840.19,644.63Z /><path d=M963.29,674.73h-305v104.8c0,33.53,25.15,58.62,58.68,58.62h305V733.44C1022,699.91,996.86,674.73,963.29,674.73Z /><path d=M618.41,554.84,455.18,391.62A75.24,75.24,0,0,0,351.3,307.24l-5.85,2.56,42.12,42.12a21.44,21.44,0,1,1-30.32,30.33l-42.13-42.13L312.57,346a75.25,75.25,0,0,0,84.37,103.89L560.17,613.08a41.19,41.19,0,0,0,58.25-58.25Zm-17.55,40.69a16.12,16.12,0,1,1,0-22.8A16.08,16.08,0,0,1,600.87,595.53Z /></svg>";

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	module.exports = "<svg id=f957432c-2363-42d4-9ff9-0792a56b9e52 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 120 120\"><title>supplies_inventory_manager</title><path d=M100.32,58.42h0V21.19H19.7v40.3h0V98.72h80.6ZM72.66,61.49H86.18v9.39H72.66Zm13.52-37.3v9.38H72.66V24.19Zm-16.52,0V36.57H89.18V24.19H97.3V58.42H61.5V24.19ZM33.84,61.49H47.36v9.39H33.84Zm13.52-37.3v9.38H33.84V24.19Zm-16.52,0V36.57H50.36V24.19H58.5V58.42H22.7V24.19ZM22.72,95.72V61.49h8.12V73.88H50.36V61.49h8.16V95.72Zm38.8,0V61.49h8.14V73.88H89.18V61.49h8.14V95.72Z /><path d=M59.67,112.61l-9.86-5.8c-.89-.54-1.63-.12-1.65.93l-.06,4.16H9a3.77,3.77,0,0,1-3.76-3.76V12.2A3.77,3.77,0,0,1,9,8.44H55.51v-3H9A6.76,6.76,0,0,0,2.24,12.2v95.94A6.76,6.76,0,0,0,9,114.9H48.05L48,118.8c0,1.06.71,1.5,1.62,1l10-5.5C60.56,113.78,60.57,113.16,59.67,112.61Z /><path d=M111,5.14H72l.12-3.93c0-1-.69-1.51-1.61-1L60.37,5.55c-.92.5-.94,1.13,0,1.69l9.77,5.94c.89.55,1.64.14,1.67-.91l.12-4.13H111a3.77,3.77,0,0,1,3.76,3.77v95.93A3.76,3.76,0,0,1,111,111.6H64.49v3H111a6.76,6.76,0,0,0,6.76-6.76V11.91A6.77,6.77,0,0,0,111,5.14Z /></svg>";

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Site Flow</title><path id=Shape d=M731.24,689.53H589.57l-6.9,6-2,1.8c-3.5,2.87-7.22,5.73-10.61,8.38l-3.61,2.55-8.7,5.84-3.5,2.23c-4,2.44-8.06,4.78-12.2,7a239.19,239.19,0,0,1-225.18,0h0A239.61,239.61,0,0,1,290,706.73l-.64-.53a240.46,240.46,0,0,1-23.77-19.63l-1.38-1.27q-4.78-4.56-9.23-9.34l-1.7-1.8q-5-5.41-9.66-11.14l-.85-1.17A124.78,124.78,0,0,1,235,651.23l-3-3.4q-3.18-4.67-6.26-9.44l-1.8-2.76c-2.33-3.93-4.56-7.85-6.79-12l-2.12-4.24q-2.23-4.35-4.24-8.81l-2.12-4.78c-1.7-3.93-3.29-7.85-4.78-11.89l-1.49-4.24q-1.7-5.09-3.29-10.61l-1.49-5.41c-.85-3.18-1.59-6.37-2.33-9.55,0-1.59-.74-3.08-1.06-4.67q-1.38-6.79-2.33-13.8a14.06,14.06,0,0,0-.53-4.67q-.64-5.31-1.06-10.61V510.73h0a118.51,118.51,0,0,1,.64-15.28v-3.93a58.58,58.58,0,0,1,1.27-12.1v-3.29q1.06-7.43,2.65-14.64l.53-2.44q1.38-6,3.08-12l1.17-3.93q1.8-6,3.93-11.89l.74-2.12c1.7-4.46,3.5-8.91,5.41-13.26l1.7-3.61q2.23-4.88,4.67-9.66l1.91-3.82c2.23-4.14,4.46-8.17,6.9-12.1l1.17-1.7q3.18-5.09,6.69-10.08l2.76-3.82q3.08-4.14,6.26-8.17l2.55-3.18q4.35-5.2,8.91-10.61l2.87-3,7.22-7.22,3.5-3.4q4.24-3.82,8.6-7.53l2-1.7c3.5-2.87,7.22-5.73,10.61-8.38l3.61-2.55,8.7-5.84,3.5-2.23c4-2.44,8.06-4.78,12.2-7a239.19,239.19,0,0,1,225.18,0h0A240.14,240.14,0,0,1,568.14,317l.85.64a240.67,240.67,0,0,1,23.35,19.21h140.5l47.43-78.31L684.76,163l-78.85,46.69c-5.84-3.4-11.89-6.69-18-9.76L580,196.09l-9.23-4.56-10.61-4.67-5.62-2.12a353.9,353.9,0,0,0-34-11.25l-21.86-89-135.09-.32L341,173.06c-8.17,2.12-16.24,4.56-24.19,7.22h0c-6.15,2.12-12.31,4.35-18.36,6.79L292,189.83q-6.58,2.76-13.05,5.84l-6.47,3.08q-7.43,3.71-14.64,7.75l-3.29,1.8-78.74-47.43h0L80.31,256.36h0L127.11,335a348.91,348.91,0,0,0-36.19,86.17L2,443.13v135H2l88.82,22.71a347.75,347.75,0,0,0,17.83,51.36c2.55,5.84,5.09,11.57,8,17.3s6.15,12,9.44,17.83l-48.92,78,95.51,95.51,78.85-46.69c5.84,3.4,11.89,6.69,18,9.76l7.85,3.82,9.66,4.46,10.61,4.67,5.52,2.12a353.68,353.68,0,0,0,34,11.25l21.86,89,135.09.64,22.6-88.93c8.17-2.12,16.24-4.56,24.19-7.22h0c6.15-2.12,12.31-4.35,18.36-6.79l6.47-2.76q6.58-2.76,13.05-5.84l6.47-3.08q7.43-3.71,14.64-7.75l3.29-1.8,78.31,47.43h0L777,767.64h0Z /><path id=Shape-2 data-name=Shape d=M631,616.74a26.74,26.74,0,0,0,12.95-3.82l148.56-83.09c17.4-9.76,17.4-25.68,0-35.44L643.9,411.29A26.74,26.74,0,0,0,631,407.47c-10.61,0-18.78,9.44-18.78,25.36V591.27c0,16,7.75,25.47,18.78,25.47Z /><path id=Shape-3 data-name=Shape d=M847.44,616.74a26.74,26.74,0,0,0,12.95-3.82l148.56-83.09c17.4-9.76,17.4-25.68,0-35.44L860.38,411.29a26.74,26.74,0,0,0-12.95-3.82c-10.61,0-18.78,9.44-18.78,25.36V591.27c0,16,7.75,25.47,18.78,25.47Z /><path id=Shape-4 data-name=Shape d=M414.37,616.74a26.74,26.74,0,0,0,12.95-3.82l148.56-83.09c17.4-9.76,17.4-25.68,0-35.44L427.32,411.29a26.74,26.74,0,0,0-12.95-3.82c-10.61,0-18.78,9.44-18.78,25.36V591.27c-.11,16,7.75,25.47,18.78,25.47Z /></svg>";

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg width=2048 height=1792 viewBox=\"0 0 2048 1792\" xmlns=http://www.w3.org/2000/svg><path d=\"M2020 11q28 20 28 53v1408q0 20-11 36t-29 23l-640 256q-24 11-48 0l-616-246-616 246q-10 5-24 5-19 0-36-11-28-20-28-53v-1408q0-20 11-36t29-23l640-256q24-11 48 0l616 246 616-246q32-13 60 6zm-1284 135v1270l576 230v-1270zm-608 217v1270l544-217v-1270zm1792 1066v-1270l-544 217v1270z\"/></svg>";

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Substrate manager</title><path id=Shape d=M700.22,719.39c111.22,0,155.58-47.94,155.58-164.78S811.44,389.83,700.22,389.83,544.75,437.05,544.75,554.61s44.36,164.78,155.48,164.78Z /><path id=Shape-2 data-name=Shape d=M893,766.41H416V930a89.44,89.44,0,0,0,92,92H985V858.41a89.65,89.65,0,0,0-92-92Z /><path d=M493.53,2H39V860.66a66.75,66.75,0,0,0,66.14,59.9H353.8v-59.9H100.29V61.9H447.84V247.33a49.07,49.07,0,0,0,45.69,40.89H672.73v61.33h61.33V247.33ZM499,235.68V92.57L652.28,235.68Z /></svg>";

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 99 55.23\"><title>Supplies_and_Parts</title><path class=a d=M107.5,114.55a10.7,10.7,0,1,0,10.69,10.71A10.7,10.7,0,0,0,107.5,114.55Zm54.88-17H75.44v43.18A12.07,12.07,0,0,0,87.5,152.8h86.94V109.62A12.07,12.07,0,0,0,162.39,97.56Zm-35.77,30.72-4,1a15.56,15.56,0,0,1-1.6,3.86l2.11,3.52-4.28,4.26-3.51-2.11a15.5,15.5,0,0,1-3.86,1.59l-1,4h-6l-1-4a15.54,15.54,0,0,1-3.86-1.61l-3.52,2.11-4.27-4.27,2.11-3.51a15.65,15.65,0,0,1-1.59-3.87l-4-1v-6l4-1a15.63,15.63,0,0,1,1.6-3.86l-2.1-3.51,4.27-4.27,3.51,2.11a15.57,15.57,0,0,1,3.86-1.59l1-4h6l1,4a15.81,15.81,0,0,1,3.86,1.6l3.52-2.1,4.27,4.27-2.11,3.51a15.57,15.57,0,0,1,1.6,3.86l4,1v6Zm21.79,16.09a12.37,12.37,0,0,1-10.68-18.57,129.54,129.54,0,0,0,8.68-18.24,2.16,2.16,0,0,1,2-1.45,2.13,2.13,0,0,1,2,1.45,130.58,130.58,0,0,0,8.67,18.24A12.37,12.37,0,0,1,148.4,144.38Zm3.12-21.12c-0.44-.7-0.67-0.77-0.87-0.74s-0.38.18-.62,1a27.68,27.68,0,0,0-1.22,8.15,3.2,3.2,0,1,0,6.3-1A27.7,27.7,0,0,0,151.52,123.26Z transform=\"translate(-75.44 -97.56)\"/></svg>";

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports = "<svg id=b4bff646-0820-4f4a-a70c-2cf44800b430 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 32 32\"><title>Education</title><path d=M23.63,14.18a10.84,10.84,0,0,1,.84,4.22v.25h0l-.09.06-.14.1-.18.12-.15.1-.2.12-.17.1-.22.12-.19.1-.23.12-.21.1-.24.11-.22.1L22,20l-.24.09-.28.1-.25.09-.29.09-.27.08-.31.09-.27.07-.34.08-.28.06-.35.07-.29.05-.37.05-.29,0-.41.05-.28,0-.48,0h-.23l-.73,0-.74,0H15l-.48,0-.27,0L13.87,21l-.29,0-.38-.05-.28-.05-.36-.07-.28-.06L12,20.62l-.27-.07-.32-.09-.26-.08-.3-.09-.25-.09-.28-.1L10,20l-.26-.1-.22-.1L9.3,19.7l-.21-.1-.23-.12-.19-.1-.21-.12-.18-.1L8.09,19l-.16-.1-.17-.12-.14-.1-.09-.06h0c0-.08,0-.16,0-.25a11.08,11.08,0,0,1,.84-4.23L7.66,14a11.65,11.65,0,0,0-.87,4.45c0,.15,0,.3,0,.45V19l.13.11C9,20.78,12.53,21.84,16,21.84s7-1.06,9.06-2.71l.13-.11v-.17c0-.15,0-.3,0-.45A11.79,11.79,0,0,0,24.34,14Z /><path d=M28.53,16.49v-4.7L32,10.71l-15.95-5-16,5,16,5L27.8,12V16.5a1.31,1.31,0,0,0-.95,1.26v8.1L27,26a1.86,1.86,0,0,0,1.18.31A1.84,1.84,0,0,0,29.34,26l.14-.11v-8.1A1.33,1.33,0,0,0,28.53,16.49ZM16,14.92,2.48,10.71,16.05,6.5l13.47,4.21ZM28.75,25.46a1.85,1.85,0,0,1-.58.08,2.23,2.23,0,0,1-.59-.08v-7.7a.59.59,0,1,1,1.17,0Z /></svg>";

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink viewBox=\"0 0 1024 1024\"><title>solution_navigator</title><path d=M428,240H544.09s0,0,0,0h48.75s0,0,0,0H705.4s0,0,0,0h52C692.18,108,556.08,17,398.75,17,178,17-1,196-1,416.74S178,816.47,398.81,816.47c9.8,0,19.19-.35,29.19-1ZM536.43,90.67A352.62,352.62,0,0,1,648.88,166.5C657.7,175.32,666,185,673.76,194H574.27c-20.48-45-45.82-85.66-73.74-116.25A352,352,0,0,1,536.43,90.67ZM428,76.17a144.73,144.73,0,0,1,21.75,16.11c22.16,19.52,44.45,48.34,64.13,83.58,3.32,5.95,6.55,12.14,9.68,18.14H428ZM148.63,166.5A357.73,357.73,0,0,1,300.4,76.74c-28.29,30.71-54,72.26-74.67,117.26h-102C131.52,185,139.81,175.32,148.63,166.5ZM72.8,279.07A410.39,410.39,0,0,1,92.1,240H207.16c-18.24,51-30,106-32.54,157h-129A350.26,350.26,0,0,1,72.8,279.07ZM95.64,599A330.06,330.06,0,0,1,72.8,554.43,352.62,352.62,0,0,1,46,443H174.89C178,495,190,549,208.23,599ZM261.08,742.58a352.6,352.6,0,0,1-112.45-75.83A246.49,246.49,0,0,1,128.72,645h98.43c20,43,44.42,81.71,71.29,110.93A351.88,351.88,0,0,1,261.08,742.58ZM382,762.67c-10-4.25-20.88-11.15-31.81-20.58C328,723,305.78,694.44,286.25,659.82c-2.71-4.8-5.35-9.82-7.94-14.82H382ZM382,599H257.3A509.25,509.25,0,0,1,238,542.21,494.58,494.58,0,0,1,220.55,443H382Zm0-202H220.23c1.8-33,7.81-67.55,17.67-102.76C243,276,249.11,258,256,240H382Zm0-203H276.55c3.13-6,6.42-12.19,9.74-18.14,19.68-35.24,42.1-64.06,64.26-83.58,10.88-9.58,21.45-16.61,31.45-21Z /><path d=M4454.82,2606.15V2969.7H4756V2606.15ZM4093.41,2969.7h301.18V2606.15H4093.41Zm361.41,424.14H4756V3030.3H4454.82Zm-361.41,0h301.18V3030.3H4093.41Zm-361.41,0h301.18V3030.3H3732Zm0-424.14h301.18V2606.15H3732Z /><rect x=614 y=643 width=283 height=46 /><rect x=614 y=735 width=283 height=46 /><rect x=614 y=827 width=283 height=46 /><path d=M838.21,300H487V962.91A51.61,51.61,0,0,0,538.17,1009H1024V489.15ZM842,369.61,960.83,480H842ZM977,963H534V346H803V489.15A38.15,38.15,0,0,0,838.21,521H977Z /></svg> ";

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>Creative</title><path d=M673.41,593.77,594.88,712.62,566,667.54c-33.87,35.13-66,58.3-98.7,62.34l-1.41.17a83.11,83.11,0,0,1-15.7,47.59c-29.85,42.05-90,55.38-123.11,59.57a176.61,176.61,0,0,1-22.41,1.4c-49.29,0-102.46-20.59-133.94-44.17l-20.12,31.41c-9.7,15.11-3,27.42,15,27.42H848.21c18,0,24.53-12.13,14.6-27.14L709.31,593.77C699.38,578.72,683.32,578.72,673.41,593.77ZM946.9,256H910.28L854.6,317.26l-.3.35h92.6a9.22,9.22,0,0,1,9.21,9.21V940.42H72.87a9.22,9.22,0,0,1-9.21-9.21V317.62h577.2c21.26-21.36,41.52-42,60.67-61.66H2V931.21a70.87,70.87,0,0,0,70.87,70.87h944.9V326.83A70.88,70.88,0,0,0,946.9,256ZM295,690.67c7.47-13.17,17.71-31.21,43.91-43.55a88.43,88.43,0,0,1,26.18-7.51l.1-2.93c1.45-44.71,36.82-89,90.51-141.42L426.61,449.8c-9.68-15.15-25.38-15.15-35.09,0L216.2,723.52c8.6,1.51,17.92,2.82,26.52,2.82,8.93,0,13.87-1.42,16.45-2.62C282.39,713,287.69,703.61,295,690.67Z /><path d=M433.82,716.62c-9.31-43.41-52.65-55.31-81.74-41.6-38.72,18.22-21.6,49.62-79.94,76.67-34.14,15.84-91.36-8.33-98.27-2.2-10.76,9.57,71.57,67.1,149.32,57.14C388.32,798.39,444.65,767.42,433.82,716.62Z /><path d=M1010.21,31.27a35.94,35.94,0,0,0-50.8,2.45L739.12,276.29c-58.35,60-123.6,126-192.47,190C489,519.94,407.87,589.75,406.3,638c5.67,11.24,10.3,18.32,23.54,30.37v0c13.23,12.07,20.71,16,32.43,20.67,47.88-5.92,113.2-93.29,161.22-155.67,67.06-87.11,138.35-170.8,200.26-243.32l188.91-208A36,36,0,0,0,1010.21,31.27Z /><path d=M433.82,716.62c-9.31-43.41-52.65-55.31-81.74-41.6-38.72,18.22-21.6,49.62-79.94,76.67-34.14,15.84-91.36-8.33-98.27-2.2-10.76,9.57,71.57,67.1,149.32,57.14C388.32,798.39,444.65,767.42,433.82,716.62Z /></svg>";

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=Alert gz-responsive-dialog><md-toolbar class=\"md-toolbar-tools md-warn\"><h2><i class=\"fa fa-lg fa-warning\"></i><span>&nbsp;{{vm.title}}</span></h2></md-toolbar><md-dialog-content class=md-padding><p>{{vm.content}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between center\"><md-button ng-click=vm.reject() class=\"md-warn md-hue-2\"><i class=\"fa fa-lg fa-caret-left\"></i><span>&nbsp; {{vm.cancel}}</span></md-button><md-button type=submit ng-click=vm.close() class=\"md-primary md-warn md-hue-2\"><span>{{vm.ok}} &nbsp;</span><i class=\"fa fa-lg fa-caret-right\"></i></md-button></md-dialog-actions></md-dialog>";

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports = "<div layout=column layout-fill ng-class=\"{show: vm.showHeader === undefined || vm.showHeader === null || vm.showHeader}\" class=gz-body><printos-header><div style=\"box-sizing:border-box;min-height:64px;border-bottom:2px solid #0096d6;background:#fff\"></div></printos-header><div flex layout=row ng-cloak class=gz-app-content><gz-app-nav items=vm.navItems() is-nav-ux=vm.isNavUx></gz-app-nav><md-content flex><gz-view-container translate-cloak><ui-view layout-fill></ui-view></gz-view-container></md-content></div></div>";

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = "<div layout=column layout-align=\"center center\" ng-mousemove=vm.handleMouseMove() class=carousel-container><div layout-align=\"center center\" ng-repeat=\"asset in vm.visualAssets\" ng-class=\"{selected: vm.index === $index}\" ng-switch=asset.type class=visual-asset-container><gz-you-tube ng-switch-when=video video-id=asset.id player-api=vm.playerAPI player-id=gz-carousel class=\"splash-item video\"></gz-you-tube><div ng-switch-when=image ng-click=vm.imageClick(asset) ng-class=\"{ &quot;link&quot;: !!asset.link }\" class=splash-item><img ng-src={{::asset.src}} class=image></div><gz-splash ng-switch-when=directive type=asset.name></gz-splash><gz-testimonial ng-switch-when=testimonial options=asset.options></gz-testimonial></div><div ng-if=\"vm.visualAssets.length &gt; 1\" layout=row layout-align=\"center center\" class=pager><i ng-click=vm.previous(true) class=\"fa fa-angle-left page-selector\"></i><div layout=row layout-align=\"center center\" class=indicator-container><div ng-repeat=\"asset in vm.visualAssets\" ng-class=\"{selected: vm.index === $index}\" ng-click=vm.specify($index) class=indicator></div></div><i ng-click=vm.next(true) class=\"fa fa-angle-right page-selector\"></i></div></div>";

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"!vm.options.layout || vm.options.layout === &quot;default&quot;\" layout=column layout-align=\"center center\" class=\"gz-testimonial default\"><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div ng-if=vm.options.headline class=headline>{{vm.options.headline}}</div><div translate={{vm.options.quote}} class=quote></div><div layout=row layout-align=\"start center\" class=credit><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=picture><div class=\"name comma\">{{vm.options.name}}</div><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div><div ng-if=vm.options.showVariant class=watermark>Standard</div></div><div ng-if=\"vm.options.layout === &quot;personal-1&quot;\" layout=row layout-align=\"start center\" class=\"gz-testimonial personal-1\"><div class=image-container><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=\"picture large\"></div><div layout=column layout-align=\"center center\" class=markup><div translate={{vm.options.quote}} class=\"quote spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div></div><div ng-if=vm.options.showVariant class=watermark>Personal 1</div></div><div ng-if=\"vm.options.layout === &quot;personal-2&quot;\" layout=column layout-align=\"center center\" class=\"gz-testimonial personal-2\"><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=\"picture large stacked\"><div ng-if=vm.options.headline class=headline>{{vm.options.headline}}</div><div translate={{vm.options.quote}} class=\"quote spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div><div ng-if=vm.options.showVariant class=watermark>Personal 2</div></div><div ng-if=\"vm.options.layout === &quot;personal-3&quot;\" layout=column layout-align=\"center center\" class=\"gz-testimonial personal-3\"><div ng-if=vm.options.headline class=headline>{{vm.options.headline}}</div><div layout=column layout-align=\"start center\" class=quote-container><div translate={{vm.options.quote}} class=quote></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=picture><div layout=column layout-align=\"start start\" flex class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"center center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo></div></div><div ng-if=vm.options.showVariant class=watermark>Personal 3</div></div><div ng-if=\"vm.options.layout === &quot;personal-4&quot;\" layout=row layout-align=\"center center\" class=\"gz-testimonial personal-4\"><div layout=column layout-align=\"center center\" class=markup><div translate={{vm.options.quote}} class=\"quote spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div><div layout=column layout-align=\"center center\" class=callout><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=\"picture large\"></div></div><div ng-if=vm.options.showVariant class=watermark>Personal 4</div></div><div ng-if=\"vm.options.layout === &quot;personal-5&quot;\" layout=column layout-align=\"center center\" class=\"gz-testimonial personal-5\"><div layout=row layout-align=\"start center\" class=header><img ng-if=vm.options.image1 ng-src={{vm.options.image1}} class=intro-image><div ng-if=vm.options.image1 class=header-separator></div><div layout=column layout-align=\"start start\" class=intro><div class=company-main>{{vm.options.companyname}}</div><div ng-if=vm.options.headline class=intro-headline>{{vm.options.headline}}</div></div></div><div layout=row layout-align=\"start center\" class=content-container><img ng-if=vm.options.image2 ng-src={{vm.options.image2}} class=image><div layout=column layout-align=\"center center\" class=markup><div translate={{vm.options.quote}} class=\"quote spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div></div></div><div ng-if=vm.options.showVariant class=watermark>Personal 5</div></div><div ng-if=\"vm.options.layout === &quot;personal-6&quot;\" layout=column layout-align=\"start center\" class=\"gz-testimonial personal-6\"><div layout=row layout-align=\"start center\" class=header><img ng-if=vm.options.image1 ng-src={{vm.options.image1}} class=intro-image><div ng-if=vm.options.image1 class=header-separator></div><div layout=column layout-align=\"start start\" class=intro><div class=company-main>{{vm.options.companyname}}</div><div ng-if=vm.options.headline class=intro-headline>{{vm.options.headline}}</div></div></div><div layout=row layout-align=\"start center\" class=content-container><img ng-if=vm.options.image2 ng-src={{vm.options.image2}} class=image><div layout=column layout-align=\"center center\" class=markup><div translate={{vm.options.quote}} class=\"quote smallFont spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div></div></div><div ng-if=vm.options.showVariant class=watermark>Personal 6</div></div><div ng-if=\"vm.options.layout === &quot;company-1&quot;\" layout=row layout-align=\"start center\" class=\"gz-testimonial company-1\"><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div layout=column layout-align=\"center center\" class=markup><div translate={{vm.options.quote}} class=\"quote spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=\"picture large\"><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div></div><div ng-if=vm.options.showVariant class=watermark>Company 1</div></div><div ng-if=\"vm.options.layout === &quot;company-2&quot;\" layout=column layout-align=\"center center\" class=\"gz-testimonial company-2\"><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div ng-if=vm.options.headline class=headline>{{vm.options.headline}}</div><div translate={{vm.options.quote}} class=\"quote spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=\"picture large stacked\"><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div><div ng-if=vm.options.showVariant class=watermark>Company 2</div></div><div ng-if=\"vm.options.layout === &quot;company-3&quot;\" layout=row layout-align=\"start center\" class=\"gz-testimonial company-3\"><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo><div layout=column layout-align=\"center center\" class=markup><div translate={{vm.options.quote}} class=\"quote spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=\"picture large\"><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div></div><div ng-if=vm.options.showVariant class=watermark>Company 3</div></div><div ng-if=\"vm.options.layout === &quot;company-4&quot;\" layout=row layout-align=\"center center\" class=\"gz-testimonial company-4\"><div layout=column layout-align=\"center center\" class=markup><div translate={{vm.options.quote}} class=\"quote spacer\"></div><div layout=row layout-align=\"start center\" class=credit-container><img ng-if=vm.options.picture ng-src={{vm.options.picture}} class=\"picture large\"><div layout=column class=credit><div class=name>{{vm.options.name}}</div><div layout=row layout-align=\"start center\" class=description><div class=title>{{vm.options.title}}</div><div translate={{vm.options.company}} class=company></div></div></div></div><div layout=column layout-align=\"center center\" class=callout><img ng-if=vm.options.logo ng-src={{vm.options.logo}} class=company-logo></div></div><div ng-if=vm.options.showVariant class=watermark>Company 4</div></div>";

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	module.exports = "<div layout=column layout-align=\"start start\" layout-fill class=color-picker><div layout=row layout-align=\"center center\" ng-click=\"vm.show = !vm.show\" ng-model=vm.color ng-style=\"{ &quot;background-color&quot;: vm.color }\" ng-keyup=vm.closeOnEnterOrEsc($event) class=\"color-bar clickable\"></div><div flex ng-if=vm.show class=custom-color><div layout=row layout-align=\"space-between center\" class=input-color-container><div layout=row layout-align=\"center center\" ng-model=vm.color ng-click=vm.randomize($event) ng-style=\"{ &quot;background-color&quot;: vm.color }\" ng-keydown=vm.preventEnterOrEsc($event) ng-keyup=vm.closeOnEnterOrEsc($event) class=\"random-btn clickable\"><i ng-class=\"{ dark: vm.isDarkContrast(vm.color) }\" class=\"icon fa fa-random\"><md-tooltip>{{'uxf.uxf.Random' | translate}}</md-tooltip></i></div><md-input-container flex class=manual-input><input name=colorcode type=text spellcheck=false ng-model=vm.color ng-keydown=vm.preventEnterOrEsc($event) ng-keyup=vm.closeOnEnterOrEsc($event) ng-init=vm.focusInput()></md-input-container></div><div layout=row layout-wrap class=color-options><div ng-repeat=\"option in vm.colorOptions\" ng-style=\"{ &quot;background-color&quot;: option }\" ng-click=vm.colorChanged(option) class=\"option clickable\"></div></div><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg ng-click=\"vm.show = false\" class=\"btn-close clickable\"><md-tooltip>{{'uxf.uxf.Dialog_Close' | translate}}</md-tooltip></md-icon></div></div>";

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog class=gz-confirm-dialog-container><gz-dialog-title-bar gz-title={{vm.titleKey}} cancel=vm.cancel></gz-dialog-title-bar><div layout=column class=gz-readonly><div ng-if=vm.labelKey layout=row layout-align=\"start center\" class=row><div layout-padding translate={{vm.labelKey}} class=label></div><div flex layout-padding gz-auto-tooltip class=value>{{vm.value}}</div></div><div layout-padding translate={{vm.messageKey}} class=delete-info></div></div><form name=myForm ng-submit=vm.submit() novalidate><gz-error-bar error-key=vm.errorKey></gz-error-bar><gz-form-footer-bar submitting=vm.sending submit-title=uxf.uxf.Dialog_OK show-legend=false show-cancel=vm.showCancel cancel=vm.cancel></gz-form-footer-bar></form></md-dialog>";

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	module.exports = "<md-toolbar><div flex class=md-toolbar-tools><h2 flex class=ellipsis><span translate={{vm.dialogTitle}} gz-auto-tooltip=\"{{vm.dialogTitle | translate}}\"></span></h2><md-button aria-label=\"{{'uxf.uxf.Dialog_Cancel' | translate}}\" ng-click=vm.cancel() class=md-icon-button><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg></md-icon></md-button></div></md-toolbar>";

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	module.exports = "<md-toolbar ng-if=vm.errorKey class=error-bar><div flex layout=row layout-align=\"start center\" class=\"md-warn msg-container\"><div translate={{vm.errorKey}} translate-values={{vm.errorValues}} class=error-msg></div><div translate={{vm.errorDetails}} translate-values={{vm.errorDetailsValues}} class=error-details></div></div></md-toolbar>";

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	module.exports = "";

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"vm.counts.serverFilterCount &gt; vm.counts.limit\" layout=row layout-align=\"start center\" class=gz-truncation-bar><i class=\"truncation-icon space-after fa fa-warning fa-2x\"></i><div translate=uxf.uxf.Grid_TooManyItems translate-values=\"[vm.counts.limit, vm.counts.serverFilterCount, vm.itemsDisplay]\" class=title></div><i class=\"truncation-icon space-before gz-clickable fa fa-question-circle\"><md-tooltip ng-if=vm.truncationTooltipKey>{{vm.truncationTooltipKey | translate}}</md-tooltip><md-tooltip ng-if=!vm.truncationTooltipKey>{{'uxf.uxf.Grid_TryFilteringTooltip' | translate:[vm.counts.limit, vm.counts.limit]}}</md-tooltip></i><span flex></span><div ng-if=\"vm.quickAccessFilters.length &gt; 0\" translate=uxf.uxf.Grid_TryFiltering class=\"title try\"></div><md-button ng-repeat=\"column in vm.quickAccessFilters\" ng-click=\"vm.selectFilterById($event, column.id)\" class=\"md-primary md-raised\">{{column.display}}</md-button></div><div ng-if=\"!vm.filterMode &amp;&amp; vm.displayFilters.length &gt; 0\" layout=column layout-align=\"start stretch\" class=gz-filter-bar-container><div ng-class=\"{&quot;emphasis-background&quot;: vm.emphasisBackground}\" layout=row layout-align=\"space-between center\" layout-wrap class=gz-filter-bar><md-icon md-svg-src=gazelle/grid/images/filter.svg ng-if=vm.showFilter ng-click=vm.selectFilterById() ng-class=\"{clickable: vm.gridOptions}\" class=\"gz-filter-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_Title' | translate}}</md-tooltip></md-icon><div flex layout=row layout-align=\"start center\" layout-wrap class=filters-container><div layout=row layout-align=\"start center\" layout-wrap ng-class=\"{clickable: vm.gridOptions &amp;&amp; filter.id !== &quot;gzQuickFilter&quot;}\" ng-repeat=\"filter in vm.displayFilters\" class=chip-container><div layout=row layout-align=\"start center\" ng-click=\"vm.selectFilter($event, filter)\" class=chip><div class=\"display gz-ellipsis\">{{filter.display}}<md-tooltip>{{filter.tooltip}}</md-tooltip></div><md-icon ng-if=!vm.readonly md-svg-src=https://cdn.printos.com/images/general/material/clear.svg ng-click=vm.removeFilter(filter) class=\"gz-filter-bar-chip-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_Remove' | translate}}</md-tooltip></md-icon></div></div></div><div ng-if=\"vm.displayFilters.length &gt; 0\" layout=row layout-align=\"start center\" class=filter-toolbar><div ng-if=\"!vm.counts &amp;&amp; vm.isAdhoc &amp;&amp; vm.filterCount !== 1\" translate=uxf.uxf.Filter_Total translate-values=\"[vm.filterCount, vm.itemsDisplay]\" class=count-title></div><div ng-if=\"!vm.counts &amp;&amp; vm.isAdhoc &amp;&amp; vm.filterCount === 1\" translate=uxf.uxf.Filter_Total translate-values=\"[vm.filterCount, vm.itemDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; !vm.filtersApplied &amp;&amp; vm.counts.serverFilterCount &lt;= vm.counts.limit &amp;&amp; vm.counts.all !== 1\" translate=uxf.uxf.Filter_Total translate-values=\"[vm.counts.filterCount, vm.itemsDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; !vm.filtersApplied &amp;&amp; vm.counts.serverFilterCount &lt;= vm.counts.limit &amp;&amp; vm.counts.all === 1\" translate=uxf.uxf.Filter_Total translate-values=\"[vm.counts.filterCount, vm.itemDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; vm.filtersApplied &amp;&amp; vm.counts.serverFilterCount &lt;= vm.counts.limit &amp;&amp; vm.counts.all !== 1\" translate=uxf.uxf.Filter_Count translate-values=\"[vm.counts.filterCount, vm.counts.all, vm.itemsDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; vm.filtersApplied &amp;&amp; vm.counts.serverFilterCount &lt;= vm.counts.limit &amp;&amp; vm.counts.all === 1\" translate=uxf.uxf.Filter_Count translate-values=\"[vm.counts.filterCount, vm.counts.all, vm.itemDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; vm.counts.serverFilterCount &gt; vm.counts.limit &amp;&amp; vm.counts.all !== 1\" translate=uxf.uxf.Filter_Count translate-values=\"[vm.counts.filterCount, vm.counts.all, vm.itemsDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; vm.counts.serverFilterCount &gt; vm.counts.limit &amp;&amp; vm.counts.all === 1\" translate=uxf.uxf.Filter_Count translate-values=\"[vm.counts.filterCount, vm.counts.all, vm.itemDisplay]\" class=count-title></div><md-icon md-svg-src=https://cdn.printos.com/images/general/material/save.svg ng-if=!vm.filters.adhocFilter aria-label=\"{{'uxf.uxf.Filter_SaveFilter' | translate}}\" ng-click=vm.saveFilter() class=\"gz-filter-bar-icon clickable\"><md-tooltip>{{'uxf.uxf.Filter_SaveFilter' | translate}}</md-tooltip></md-icon><md-icon ng-if=!vm.readonly md-svg-src=https://cdn.printos.com/images/general/material/clear.svg aria-label=\"{{'uxf.uxf.Filters_RemoveAll' | translate}}\" ng-click=vm.removeAllFilters() class=\"gz-filter-bar-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_RemoveAll' | translate}}</md-tooltip></md-icon></div></div><div ng-if=vm.selectedFilter1 ng-class=\"{&quot;emphasis-background&quot;: vm.emphasisBackground}\" layout=row layout-align=\"space-between center\" class=\"gz-filter-bar secondary\"><div class=\"title sub-title\">{{vm.selectedFilter1.display}}</div><div flex layout=row layout-align=\"start center\" layout-wrap class=filters-container><div layout=row layout-align=\"start center\" layout-wrap ng-class=\"{clickable: vm.gridOptions &amp;&amp; filter.id !== &quot;gzQuickFilter&quot;}\" ng-repeat=\"filter in vm.selectedFilter1.displayFilters\" class=chip-container><div layout=row layout-align=\"start center\" ng-click=\"vm.selectFilter1($event, filter)\" class=chip><div class=\"display gz-ellipsis\">{{filter.display}}<md-tooltip>{{filter.tooltip}}</md-tooltip></div><md-icon ng-if=!vm.readonly md-svg-src=https://cdn.printos.com/images/general/material/clear.svg ng-click=\"vm.removeFilter1(filter, $event)\" class=\"gz-filter-bar-chip-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_Remove' | translate}}</md-tooltip></md-icon></div></div></div></div><div ng-if=\"vm.selectedFilter1 &amp;&amp; vm.selectedFilter2\" ng-class=\"{&quot;emphasis-background&quot;: vm.emphasisBackground}\" layout=row layout-align=\"space-between center\" class=\"gz-filter-bar secondary\"><div class=\"title sub-title\">{{vm.selectedFilter2.display}}</div><div flex layout=row layout-align=\"start center\" layout-wrap class=filters-container><div layout=row layout-align=\"start center\" layout-wrap ng-class=\"{clickable: vm.gridOptions &amp;&amp; filter.id !== &quot;gzQuickFilter&quot;}\" ng-repeat=\"filter in vm.selectedFilter2.displayFilters\" class=chip-container><div layout=row layout-align=\"start center\" ng-click=\"vm.selectFilter($event, filter)\" class=chip><div class=\"display gz-ellipsis\">{{filter.display}}<md-tooltip>{{filter.tooltip}}</md-tooltip></div><md-icon ng-if=!vm.readonly md-svg-src=https://cdn.printos.com/images/general/material/clear.svg ng-click=vm.removeFilter2(filter) class=\"gz-filter-bar-chip-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_Remove' | translate}}</md-tooltip></md-icon></div></div></div></div></div><div ng-if=vm.filterMode layout=column layout-align=\"start stretch\" class=\"gz-filter-bar-container filter-mode\"><div layout=row layout-align=\"start center\" layout-wrap class=\"gz-filter-bar filter-mode\"><div ng-if=vm.showFilter layout=row layout-align=\"start center\" ontouchstart=\"var event=arguments[0];event.stopPropagation()\" ontouchend=\"var event=arguments[0];event.stopPropagation()\" class=gz-grid-menu-container><md-menu-bar class=\"gz-right-header gz-action-header\"><md-menu class=gz-menu><div layout=row layout-align=\"start center\" ng-click=$mdOpenMenu($event) class=gz-indicator-container><md-icon md-svg-src=gazelle/grid/images/filter-drop-down.svg class=\"gz-filter-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_Title' | translate}}</md-tooltip></md-icon><div ng-if=gzGridIndicator.show class=gz-indicator></div></div><md-menu-content width=3 class=gz-filter-menu-content><md-menu-item><md-button ng-click=vm.gzFilterClicked($event)><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-filter.svg class=gz-menu-icon></md-icon><div flex>{{'uxf.uxf.GridMenu_Filters' | translate}}</div></div></md-button></md-menu-item><md-menu-item ng-if=\"vm.namedFilters.length &gt; 0 \"><md-menu><md-button ng-click=$mdOpenMenu()><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-filter.svg class=gz-menu-icon></md-icon><div flex class=filterSubmenu>{{'uxf.uxf.Filter_BuiltInFilters' | translate}}</div></div></md-button><md-menu-content width=2><md-menu-item ng-repeat=\"filter in vm.namedFilters\"><md-button ng-click=\"vm.gzNamedFilterClicked($event, filter)\"><div layout=row layout-align=\"start center\" class=filter-container><div flex>{{filter.display.title}}</div></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item ng-if=\"vm.savedFilters.length &gt; 0\"><md-menu><md-button ng-click=$mdOpenMenu()><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-filter.svg class=gz-menu-icon></md-icon><div flex class=filterSubmenu>{{'uxf.uxf.Filter_MyFilters' | translate}}</div></div></md-button><md-menu-content width=2><md-menu-item ng-repeat=\"filter in vm.savedFilters\"><div ng-click=\"vm.gzSavedFilterClicked($event, filter)\" class=md-button><div layout=row layout-align=\"start center\" class=filter-container><div flex>{{filter.namedFilter.display.title}}</div><md-icon md-svg-src=https://cdn.printos.com/images/general/material/delete_outline.svg ng-click=\"vm.gzRemoveFilterClicked($event, filter)\" class=\"gz-menu-icon right\"></md-icon></div></div></md-menu-item></md-menu-content></md-menu></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><gz-filter-box pairing-id={{vm.pairingId}} filters=vm.filters class=quick-filter></gz-filter-box><i ng-if=\"vm.counts.serverFilterCount &gt; vm.counts.limit\" class=\"truncation-icon space-before space-after fa fa-question-circle\"><md-tooltip>{{'uxf.uxf.quickFilterTruncation' | translate}}</md-tooltip></i><div flex layout=row layout-align=\"start center\" layout-wrap class=filters-container><div layout=row layout-align=\"start center\" layout-wrap ng-class=\"{clickable: vm.gridOptions &amp;&amp; filter.id !== &quot;gzQuickFilter&quot;}\" ng-repeat=\"filter in vm.displayFilters\" class=chip-container><div layout=row layout-align=\"start center\" ng-click=\"vm.selectFilter($event, filter)\" class=chip><div flex class=\"display gz-ellipsis\">{{filter.display}}<md-tooltip>{{filter.tooltip}}</md-tooltip></div><md-icon ng-if=!vm.readonly md-svg-src=https://cdn.printos.com/images/general/material/clear.svg ng-click=vm.removeFilter(filter) class=\"gz-filter-bar-chip-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_Remove' | translate}}</md-tooltip></md-icon></div></div></div><div layout=row layout-align=\"start center\" class=filter-toolbar><div ng-if=\"!vm.counts &amp;&amp; vm.isAdhoc &amp;&amp; vm.filterCount !== 1\" translate=uxf.uxf.Filter_Total translate-values=\"[vm.filterCount, vm.itemsDisplay]\" class=count-title></div><div ng-if=\"!vm.counts &amp;&amp; vm.isAdhoc &amp;&amp; vm.filterCount === 1\" translate=uxf.uxf.Filter_Total translate-values=\"[vm.filterCount, vm.itemDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; !vm.filtersApplied &amp;&amp; vm.counts.serverFilterCount &lt;= vm.counts.limit &amp;&amp; vm.counts.all !== 1\" translate=uxf.uxf.Filter_Total translate-values=\"[vm.counts.filterCount, vm.itemsDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; !vm.filtersApplied &amp;&amp; vm.counts.serverFilterCount &lt;= vm.counts.limit &amp;&amp; vm.counts.all === 1\" translate=uxf.uxf.Filter_Total translate-values=\"[vm.counts.filterCount, vm.itemDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; vm.filtersApplied &amp;&amp; vm.counts.serverFilterCount &lt;= vm.counts.limit &amp;&amp; vm.counts.all !== 1\" translate=uxf.uxf.Filter_Count translate-values=\"[vm.counts.filterCount, vm.counts.all, vm.itemsDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; vm.filtersApplied &amp;&amp; vm.counts.serverFilterCount &lt;= vm.counts.limit &amp;&amp; vm.counts.all === 1\" translate=uxf.uxf.Filter_Count translate-values=\"[vm.counts.filterCount, vm.counts.all, vm.itemDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; vm.counts.serverFilterCount &gt; vm.counts.limit &amp;&amp; vm.counts.all !== 1\" translate=uxf.uxf.Filter_Count translate-values=\"[vm.counts.filterCount, vm.counts.all, vm.itemsDisplay]\" class=count-title></div><div ng-if=\"vm.counts &amp;&amp; vm.counts.serverFilterCount &gt; vm.counts.limit &amp;&amp; vm.counts.all === 1\" translate=uxf.uxf.Filter_Count translate-values=\"[vm.counts.filterCount, vm.counts.all, vm.itemDisplay]\" class=count-title></div><md-icon ng-if=vm.canSave() md-svg-src=gazelle/grid/images/save.svg aria-label=\"{{'uxf.uxf.Filter_SaveFilter' | translate}}\" ng-click=vm.saveFilter() class=\"gz-filter-bar-icon clickable\"><md-tooltip>{{'uxf.uxf.Filter_SaveFilter' | translate}}</md-tooltip></md-icon><md-icon ng-if=vm.filtersApplied aria-label=\"{{'uxf.uxf.Filters_RemoveAll' | translate}}\" md-svg-src=https://cdn.printos.com/images/general/material/clear.svg ng-click=vm.removeAllFilters() class=\"gz-filter-bar-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_RemoveAll' | translate}}</md-tooltip></md-icon></div></div><div ng-if=vm.selectedFilter1 ng-class=\"{&quot;emphasis-background&quot;: vm.emphasisBackground}\" layout=row layout-align=\"space-between center\" class=\"gz-filter-bar secondary\"><div class=\"title sub-title\">{{vm.selectedFilter1.display}}</div><div flex layout=row layout-align=\"start center\" layout-wrap class=filters-container><div layout=row layout-align=\"start center\" layout-wrap ng-class=\"{clickable: vm.gridOptions &amp;&amp; filter.id !== &quot;gzQuickFilter&quot;}\" ng-repeat=\"filter in vm.selectedFilter1.displayFilters\" class=chip-container><div layout=row layout-align=\"start center\" ng-click=\"vm.selectFilter1($event, filter)\" class=chip><div class=\"display gz-ellipsis\">{{filter.display}}<md-tooltip>{{filter.tooltip}}</md-tooltip></div><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg ng-click=\"vm.removeFilter1(filter, $event)\" class=\"gz-filter-bar-chip-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_Remove' | translate}}</md-tooltip></md-icon></div></div></div></div><div ng-if=\"vm.selectedFilter1 &amp;&amp; vm.selectedFilter2\" ng-class=\"{&quot;emphasis-background&quot;: vm.emphasisBackground}\" layout=row layout-align=\"space-between center\" class=\"gz-filter-bar secondary\"><div class=\"title sub-title\">{{vm.selectedFilter2.display}}</div><div flex layout=row layout-align=\"start center\" layout-wrap class=filters-container><div layout=row layout-align=\"start center\" layout-wrap ng-class=\"{clickable: vm.gridOptions &amp;&amp; filter.id !== &quot;gzQuickFilter&quot;}\" ng-repeat=\"filter in vm.selectedFilter2.displayFilters\" class=chip-container><div layout=row layout-align=\"start center\" ng-click=\"vm.selectFilter($event, filter)\" class=chip><div class=\"display gz-ellipsis\">{{filter.display}}<md-tooltip>{{filter.tooltip}}</md-tooltip></div><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg ng-click=vm.removeFilter2(filter) class=\"gz-filter-bar-icon clickable\"><md-tooltip>{{'uxf.uxf.Filters_Remove' | translate}}</md-tooltip></md-icon></div></div></div></div></div>";

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	module.exports = "<div layout=row layout-align=\"start center\" class=gz-filter-box><input flex ng-model=vm.inputText ng-model-options=\"{getterSetter: true}\" ng-keyup=vm.keyupHandler($event) ng-keydown=vm.keydownHandler($event) ng-keypress=vm.keypressHandler($event) placeholder={{vm.placeholder}} ng-click=$event.preventDefault();$event.stopPropagation(); class=gz-input-box><span layout=row layout-align=\"center center\" ng-if=!vm.hasInput ng-click=$event.stopPropagation(); class=gz-filter-box-icon-container><md-icon md-font-set=fa md-font-icon=fa-search class=gz-filter-box-icon></md-icon></span><span layout=row layout-align=\"center center\" ng-if=vm.hasInput ng-click=vm.clearInput($event) class=\"gz-filter-box-icon-container touched\"><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg class=gz-filter-box-icon><md-tooltip><translate>uxf.uxf.General_Clear_Input</translate></md-tooltip></md-icon></span></div>";

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog layout=column class=edit-filters><gz-dialog-title-bar ng-if=!vm.isLoading gz-title=\"{{&quot;uxf.uxf.Filters_Title&quot; | translate }}\"></gz-dialog-title-bar><form flex ng-if=!vm.isLoading name=vm.filtersForm ng-submit=vm.submit($event) novalidate><gz-error-bar error-key=vm.errorKey></gz-error-bar><div flex layout=column submitting=vm.processing class=form-container><div layout=row layout-align=\"start stretch\" class=filters-container><div ng-if=!vm.columnId flex=40 layout=column layout-align=\"start center\" class=column-container><div ng-if=vm.showFilter(column) layout=row layout-align=\"start center\" ng-repeat=\"column in vm.columns\" ng-click=vm.columnClicked(column) ng-class=\"{selected: vm.selectedColumn.id === column.id}\" class=column-selector><div class=switch-container><md-switch ng-model=column.internal.enabled ng-click=\"vm.toggleClicked(column, $event)\" ng-change=vm.toggleEnabled(column) ng-class=\"{invalid: column.internal.enabled &amp;&amp; !vm.filterEnabled(column)}\"></md-switch><md-tooltip ng-if=column.internal.enabled>{{'uxf.uxf.Filter_Disable' | translate}}</md-tooltip><md-tooltip ng-if=!column.internal.enabled>{{'uxf.uxf.Filter_Enable' | translate}}</md-tooltip></div><div flex ng-class=\"{server: column.options.filter.isServerFilter &amp;&amp; vm.showServerIndicator, invalid: column.internal.enabled &amp;&amp; !vm.filterEnabled(column)}\" class=column-title>{{column.header.title}}</div></div></div><div flex ng-if=!vm.selectedColumn layout=row layout-align=\"center center\" class=filter-container><div translate=uxf.uxf.Filters_NoColumnSelected class=filter-title></div></div><div flex ng-if=vm.selectedColumn layout=column ng-switch=vm.selectedColumn.type class=filter-container><div flex ng-switch-when=string layout=column class=filter><div translate=uxf.uxf.Filters_ColumnTitle translate-values=[vm.selectedColumn.header.title] ng-class=\"{disabled: !vm.selectedColumn.internal.enabled}\" class=filter-title></div><md-select id=filter-string-op name=stringOp ng-change=vm.stringOpChanged(vm.stringOp) ng-model=vm.stringOp ng-disabled=!vm.selectedColumn.internal.enabled><md-option ng-value=op ng-repeat=\"op in vm.stringOps\" ng-selected=\"vm.stringOp == op\" translate=\"{{'uxf.uxf.FilterOp_' + op}}\"></md-option></md-select><md-input-container ng-if=\"vm.stringOp !== &quot;isEmpty&quot; &amp;&amp; vm.stringOp !== &quot;isNotEmpty&quot;\"><label for=filter-string-value translate=uxf.uxf.Filter_Value></label><input id=filter-string-value name=stringValue type=text ng-model=vm.stringValue required ng-change=vm.stringValueChanged() md-maxlength=100 md-autofocus ng-disabled=!vm.selectedColumn.internal.enabled></md-input-container></div><div flex ng-switch-when=number layout=column class=filter><div ng-class=\"{disabled: !vm.selectedColumn.internal.enabled}\" class=filter-title>{{vm.selectedColumn.header.title}}</div><md-select id=filter-number-op name=numberOp ng-change=vm.numberOpChanged(vm.numberOp) ng-model=vm.numberOp ng-disabled=!vm.selectedColumn.internal.enabled><md-option ng-value=op ng-repeat=\"op in vm.numberOps\" ng-selected=\"vm.numberOp == op\" translate=\"{{'uxf.uxf.FilterOp_' + op}}\"></md-option></md-select><div flex class=filter-scroll-container><md-input-container ng-if=\"vm.numberOp !== &quot;between&quot; &amp;&amp; vm.numberOp !== &quot;isEmpty&quot; &amp;&amp; vm.numberOp !== &quot;isNotEmpty&quot;\"><label for=filter-number-value translate=uxf.uxf.Filter_Value></label><input id=filter-number-value name=numberValue type=number ng-model=vm.numberValue ng-change=vm.numberValueChanged() md-autofocus required min=0 ng-disabled=!vm.selectedColumn.internal.enabled></md-input-container><md-input-container ng-if=\"vm.numberOp === &quot;between&quot;\"><label for=filter-number-begin translate=uxf.uxf.Filter_Begin></label><input id=filter-number-begin name=numberBegin type=number ng-model=vm.numberBegin ng-change=vm.numberBeginChanged() md-autofocus required min=0 ng-disabled=!vm.selectedColumn.internal.enabled></md-input-container><md-input-container ng-if=\"vm.numberOp === &quot;between&quot;\"><label for=filter-number-end translate=uxf.uxf.Filter_End></label><input id=filter-number-end name=numberEnd type=number ng-model=vm.numberEnd required ng-change=vm.numberEndChanged() min=0 ng-disabled=!vm.selectedColumn.internal.enabled></md-input-container></div></div><div flex ng-switch-when=date layout=column class=filter><div ng-class=\"{disabled: !vm.selectedColumn.internal.enabled}\" class=filter-title>{{vm.selectedColumn.header.title}}</div><md-select id=filter-date-op name=dateOp ng-change=vm.dateOpChanged(vm.dateOp) ng-model=vm.dateOp ng-disabled=!vm.selectedColumn.internal.enabled><md-option ng-value=op ng-repeat=\"op in vm.dateOps\" ng-selected=\"vm.dateOp == op\" translate=\"{{'uxf.uxf.FilterOp_' + op}}\"></md-option></md-select><div flex class=filter-scroll-container><md-datepicker ng-if=vm.showDateValue() ng-model=vm.dateValue md-open-on-focus ng-change=vm.dateChanged() ng-disabled=!vm.selectedColumn.internal.enabled></md-datepicker><div ng-if=vm.showDateRange() class=table-layout><div class=row><span translate=uxf.uxf.Filter_Begin class=label></span><span><md-datepicker ng-model=vm.dateBegin md-open-on-focus ng-change=vm.dateChanged() ng-disabled=!vm.selectedColumn.internal.enabled></md-datepicker></span></div><div class=row><span translate=uxf.uxf.Filter_End class=label></span><span><md-datepicker ng-if=\"vm.dateOp === &quot;between&quot; || vm.dateOp === &quot;thisWeek&quot; || vm.dateOp === &quot;nextWeek&quot; || vm.dateOp === &quot;lastWeek&quot;\" ng-model=vm.dateEnd md-open-on-focus ng-change=vm.dateChanged() ng-disabled=!vm.selectedColumn.internal.enabled></md-datepicker></span></div></div></div></div><div flex ng-switch-when=duration layout=column class=filter><div ng-class=\"{disabled: !vm.selectedColumn.internal.enabled}\" class=filter-title>{{vm.selectedColumn.header.title}}</div><md-select id=filter-duration-op name=durationOp ng-change=vm.durationOpChanged(vm.durationOp) ng-model=vm.durationOp ng-disabled=!vm.selectedColumn.internal.enabled><md-option ng-value=op ng-repeat=\"op in vm.durationOps\" ng-selected=\"vm.durationOp == op\" translate=\"{{'uxf.uxf.FilterOp_' + op}}\"></md-option></md-select><div flex class=filter-scroll-container><md-input-container ng-if=\"vm.durationOp !== &quot;notSet&quot; &amp;&amp; vm.stringOp !== &quot;isEmpty&quot; &amp;&amp; vm.stringOp !== &quot;isNotEmpty&quot;\"><label for=filter-days-value translate=uxf.uxf.Filter_Days></label><input id=filter-days-value name=daysValue type=number ng-model=vm.daysValue ng-change=vm.durationValueChanged() required md-autofocus ng-disabled=!vm.selectedColumn.internal.enabled min=0></md-input-container><md-input-container ng-if=\"vm.durationOp !== &quot;notSet&quot; &amp;&amp; vm.stringOp !== &quot;isEmpty&quot; &amp;&amp; vm.stringOp !== &quot;isNotEmpty&quot;\"><label for=filter-hours-value translate=uxf.uxf.Filter_Hours></label><input id=filter-hours-value name=hoursValue type=number required ng-model=vm.hoursValue ng-change=vm.durationValueChanged() ng-disabled=!vm.selectedColumn.internal.enabled min=0></md-input-container><md-input-container ng-if=\"vm.durationOp !== &quot;notSet&quot; &amp;&amp; vm.stringOp !== &quot;isEmpty&quot; &amp;&amp; vm.stringOp !== &quot;isNotEmpty&quot;\"><label for=filter-minutes-value translate=uxf.uxf.Filter_Minutes></label><input id=filter-minutes-value name=minutesValue type=number required ng-model=vm.minutesValue ng-change=vm.durationValueChanged() ng-disabled=!vm.selectedColumn.internal.enabled min=0></md-input-container><md-input-container ng-if=\"vm.durationOp !== &quot;notSet&quot; &amp;&amp; vm.stringOp !== &quot;isEmpty&quot; &amp;&amp; vm.stringOp !== &quot;isNotEmpty&quot;\"><label for=filter-seconds-value translate=uxf.uxf.Filter_Seconds></label><input id=filter-seconds-value name=secondsValue type=number required ng-model=vm.secondsValue ng-change=vm.durationValueChanged() ng-disabled=!vm.selectedColumn.internal.enabled min=0></md-input-container></div></div><div flex ng-switch-when=mapped layout=column class=filter><div ng-class=\"{disabled: !vm.selectedColumn.internal.enabled}\" class=filter-title>{{vm.selectedColumn.header.title}}</div><md-select id=filter-mapped-value ng-if=\"vm.selectedColumn.field.mapped.display !== &quot;values&quot; &amp;&amp; vm.selectedColumn.field.mapped.display !== &quot;lookup&quot; &amp;&amp; vm.selectedColumn.field.mapped.display !== &quot;status&quot;&amp;&amp; vm.selectedColumn.field.mapped.display !== &quot;locked&quot;\" name=mappedValue ng-change=vm.mappedValueChanged(vm.mappedValue.value) ng-model=vm.mappedValue ng-disabled=!vm.selectedColumn.internal.enabled><md-option ng-value=value ng-repeat=\"value in vm.mappedValues | rnLocaleOrderBy:'display'\" ng-selected=\"vm.mappedValue.value == value.value\"><div layout=row layout-align=\"start center\"><div ng-if=\"value !== undefined\" class=mapped-image><i ng-class=vm.getMappedImage(value.value) class=fa></i></div><div flex class=mapped-title>{{value.display}}</div></div></md-option></md-select><md-select id=filter-mapped-value ng-if=\"vm.selectedColumn.field.mapped.display === &quot;locked&quot;\" name=mappedValue ng-change=vm.mappedValueChanged(vm.mappedValue.value) ng-model=vm.mappedValue ng-disabled=!vm.selectedColumn.internal.enabled><md-option ng-value=value ng-repeat=\"value in vm.mappedValues | rnLocaleOrderBy:'display'\" ng-selected=\"vm.mappedValue.value == value.value\"><div layout=row layout-align=\"start center\"><div ng-if=\"value !== undefined\" class=mapped-image><i ng-class=vm.getMappedImage(value.value) class=fa></i></div><div flex class=mapped-title>{{value.display}}</div></div></md-option></md-select><md-select id=filter-mapped-value ng-if=\"vm.selectedColumn.field.mapped.display === &quot;values&quot; || vm.selectedColumn.field.mapped.display === &quot;lookup&quot; || vm.selectedColumn.field.mapped.display === &quot;status&quot;\" name=mappedOp ng-change=vm.mappedOpChanged(vm.mappedOp) ng-model=vm.mappedOp ng-disabled=!vm.selectedColumn.internal.enabled><md-option ng-value=op ng-repeat=\"op in vm.mappedOps\" ng-selected=\"vm.mappedOp == op\" translate=\"{{'uxf.uxf.FilterOp_' + op}}\"></md-option></md-select><div flex class=filter-scroll-container><div ng-if=\"vm.selectedColumn.field.mapped.display === &quot;values&quot; || vm.selectedColumn.field.mapped.display === &quot;lookup&quot; || vm.selectedColumn.field.mapped.display === &quot;status&quot;\" layout=row layout-align=\"start center\" ng-repeat=\"value in vm.mappedValues | rnLocaleOrderBy:&quot;display&quot;\" ng-switch=vm.selected.field.mapped.display ng-disabled=!vm.selectedColumn.internal.enabled class=mapped-row><div class=mapped-image><i ng-class=vm.getMappedImage(value.value) class=fa></i></div><div flex class=mapped-title>{{::value.display}}</div><md-checkbox ng-model=vm.mappedSelection[value.value] ng-change=vm.toggleMappedValue(value.value) ng-disabled=!vm.selectedColumn.internal.enabled></md-checkbox></div></div></div><div flex ng-switch-default layout=column class=filter><div ng-class=\"{disabled: !vm.selectedColumn.internal.enabled}\" class=filter-title>{{vm.selectedColumn.header.title}}</div></div></div></div></div><gz-form-footer-bar submitting=vm.processing disable-submit=vm.disableSubmit submit-title=uxf.uxf.Dialog_OK legend-key=uxf.uxf.Filter_Legend show-legend=vm.showServerIndicator></gz-form-footer-bar></form></md-dialog>";

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog><gz-dialog-title-bar gz-title=uxf.uxf.Filter_SaveFilter cancel=vm.cancel></gz-dialog-title-bar><form name=vm.editForm ng-submit=vm.save() novalidate><gz-error-bar error-key=vm.errorMessageKey></gz-error-bar><gz-form-content layout=column submitting=vm.sending><md-input-container><label for=name translate=uxf.uxf.Filter_Name></label><input id=filter-name name=name type=text ng-model=vm.filter.name required md-maxlength=100 gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=vm.editForm.name.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container></gz-form-content><gz-form-footer-bar submitting=vm.sending submit-title=uxf.uxf.Dialog_Submit show-cancel=true cancel=vm.cancel disable-submit=vm.disableSubmit></gz-form-footer-bar></form></md-dialog>";

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports = "<md-content ng-if=!vm.noContent class=md-padding><md-backdrop ng-if=vm.submitting class=md-opaque></md-backdrop><ng-transclude layout=column></ng-transclude></md-content><gz-spinner ng-if=vm.submitting class=gz-spinner-container></gz-spinner>";

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	module.exports = "<div layout=row layout-align=\"space-between center\" ng-class=\"{alternate: vm.altBackground}\"><span ng-if=\"vm.showLegend &amp;&amp; !vm.legendKey\" translate=uxf.uxf.FieldRequiredLegend class=gz-legend></span><span ng-if=\"vm.showLegend &amp;&amp; vm.legendKey\" translate={{vm.legendKey}} class=gz-legend></span><span flex ng-if=!vm.showLegend class=gz-legend></span><md-dialog-actions layout=row><md-button ng-if=vm.showCancel type=button ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel class=\"btn-cancel md-primary\"></md-button><md-button type=submit ng-disabled=\"vm.submitting || vm.disableSubmit()\" translate={{vm.submitTitle}} class=\"btn-submit md-primary md-raised\"></md-button></md-dialog-actions></div>";

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"!vm.loading &amp;&amp; !vm.editMode\" class=display-reset><div layout=column layout-align=\"center center\" class=\"display-map google-address\"><gz-google-map ng-if=!vm.unknownLocation ng-init=vm.handleMapReady() flex pairing-id={{vm.pairingId}} await-location=true></gz-google-map><div ng-if=vm.unknownLocation layout=column layout-align=\"center center\" flex class=unknown-location><i class=\"fa fa-question fa-5x\"></i><div translate=uxf.uxf.Address_UnknownLocation class=title></div></div></div></div><div ng-if=\"!vm.loading &amp;&amp; vm.editMode\" class=edit-reset><ng-form name=vm.addressForm layout=column layout-align=\"start center\" class=google-address><div ng-if=!vm.manualMode layout=row layout-align=\"center stretch\" layout-wrap class=map-container><div flex layout=column layout-align=\"start stretch\" class=form-container><md-input-container ng-if=!vm.hideName><label for=name-auto translate=uxf.uxf.MapName></label><input id=name-auto name=nameauto type=text ng-model=vm.name required md-maxlength=100 gz-regex-validator=Validator.AAA.NameUnicode></md-input-container><div layout=row layout-align=\"start center\" class=location-input-container><md-input-container flex><label for=place translate=uxf.uxf.MapPlace></label><input id=place gz-places-auto-complete name=place type=text ng-model=vm.placeText ng-change=vm.handlePlaceTextChanged() place=vm.place required md-maxlength=200 place-types=\"['address']\" on-place-changed=vm.handlePlaceChanged($place) placeholder=\"\"></md-input-container><md-icon md-svg-src=https://cdn.printos.com/images/general/material/location_searching.svg ng-click=vm.useBrowserLocation() class=action-icon><md-tooltip>{{'uxf.uxf.FindMe' | translate}}</md-tooltip></md-icon><md-icon ng-if=vm.showAddressBook md-svg-src=https://cdn.printos.com/images/general/material/chrome_reader_mode.svg ng-click=vm.openAddresses() class=action-icon><md-tooltip>{{'uxf.uxf.AddressBook' | translate}}</md-tooltip></md-icon></div><div ng-if=\"vm.place &amp;&amp; vm.isIncompletePlace()\" layout=row layout-align=\"start center\" class=manual-option><div id=incomplete-place translate=uxf.uxf.LocationDetailsRequired ng-click=vm.toggleView() class=manual-switch></div></div><div ng-if=\"!vm.place &amp;&amp; vm.guess\" layout=column layout-align=\"start stretch\" class=best-guess-container><div translate=uxf.uxf.BestGuess class=label></div><div layout=row layout-align=\"start center\" class=guess-container><div flex gz-auto-tooltip class=guess>{{vm.guess.formatted_address}}</div><md-icon id=best-guess md-svg-src=https://cdn.printos.com/images/general/material/check_circle.svg ng-click=vm.useGuessLocation() class=action-icon><md-tooltip>{{'uxf.uxf.UseAddress' | translate}}</md-tooltip></md-icon></div></div><div flex ng-init=vm.watchSpacer() class=spacer></div><div layout=row layout-align=\"start center\" layout-wrap class=manual-option><div translate=uxf.uxf.UnverifiedAddress class=manual-msg></div><div id=try-this translate=uxf.uxf.SwitchToManual ng-click=vm.toggleView() class=manual-switch></div></div></div><div flex layout=column class=map><gz-google-map ng-hide=vm.unknownLocation ng-init=vm.handleMapReady() pairing-id={{vm.pairingId}} on-map-clicked=vm.handlePlaceChanged($place)></gz-google-map><div ng-if=vm.unknownLocation layout=column layout-align=\"center center\" flex class=unknown-location><i class=\"fa fa-question fa-5x\"></i><div translate=uxf.uxf.Address_UnknownLocation class=title></div></div></div></div><div ng-show=vm.manualMode layout=row layout-align=\"center stretch\" layout-wrap class=manual-container><div flex layout=column class=\"form-container spacer\"><md-input-container ng-if=!vm.hideName><label for=name-manual translate=uxf.uxf.MapName></label><input id=name-manual name=namemanual type=text ng-model=vm.name required md-maxlength=100 gz-regex-validator=Validator.AAA.NameUnicode ng-change=vm.nameChanged(site)></md-input-container><md-input-container><label translate=uxf.uxf.TimeZone></label><md-select id=time-zone ng-model=vm.timezone required><md-option ng-value=timeZone.value ng-repeat=\"timeZone in vm.timezones\" ng-selected=\"vm.timezone === timeZone.value\"><span>{{timeZone.display}}</span></md-option></md-select></md-input-container><md-input-container><label for=in-address1 translate=uxf.uxf.Address></label><input id=in-address1 name=address1 type=text ng-model=vm.address.addressLine1 required md-maxlength=100 gz-regex-validator=Validator.AAA.AddressLine></md-input-container><md-input-container><label for=in-address2 translate=uxf.uxf.Address2></label><input id=in-address2 name=address2 type=text ng-model=vm.address.addressLine2 md-maxlength=100 gz-regex-validator=Validator.AAA.AddressLine></md-input-container></div><div flex layout=column class=form-container><md-input-container><label for=in-city translate=uxf.uxf.Locality></label><input id=in-city required name=city type=text ng-model=vm.address.locality md-maxlength=100 gz-regex-validator=Validator.AAA.DescriptionUnicode></md-input-container><md-input-container><label for=in-state translate=uxf.uxf.Region></label><input id=in-state required name=state type=text ng-model=vm.address.region ng-maxlength=vm.validators.region.maxlength md-maxlength=vm.validators.region.maxlength gz-regex-validator={{vm.validators.region.validator}}></md-input-container><md-input-container><label for=in-postalCode translate=uxf.uxf.PostalCode></label><input id=in-postalcode ng-required=vm.validators.postalCode.required name=postalCode type=text ng-model=vm.address.postalCode ng-maxlength=vm.validators.postalCode.maxlength md-maxlength=vm.validators.postalCode.maxlength gz-regex-validator={{vm.validators.postalCode.validator}}></md-input-container><md-input-container><label translate=uxf.uxf.Country></label><md-select id=country name=country ng-model=vm.address.country required ng-change=vm.countryChanged()><md-option ng-value=country.isoCode ng-repeat=\"country in vm.countries | rnLocaleOrderBy:'localizedName'\">{{country.localizedName}}</md-option></md-select></md-input-container></div></div><div ng-if=\"vm.manualMode &amp;&amp; vm.mapsSupported\" layout=row layout-align=\"center center\" class=container><md-button id=btn-return-to-map type=button ng-click=vm.toggleView() class=\"md-raised map-button\"><span translate=uxf.uxf.ReturnToMap class=main-action></span></md-button></div></ng-form></div>";

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog class=select-address-dialog><gz-dialog-title-bar gz-title=uxf.uxf.Address_Select cancel=vm.cancel></gz-dialog-title-bar><form ng-if=!vm.loading name=selectAddressForm ng-submit=vm.selectAddress() novalidate class=form-content><gz-error-bar error-key=vm.errorKey></gz-error-bar><md-input-container><label for=siteAddress>{{'uxf.uxf.Address' | translate}}</label><md-select id=siteAddress placeholder=\"{{'uxf.uxf.Address_SelectAnAddress' | translate}}\" ng-change=vm.addressChanged() ng-model=vm.address required><md-option ng-value=address ng-selected=\"address.addressId === vm.address.addressId\" ng-repeat=\"address in vm.addresses\">{{address.name || address.addressLine1}}</md-option></md-select></md-input-container><div ng-if=vm.addressDisplay class=address-display>{{vm.addressDisplay}}</div><gz-google-address pairing-id=select-address options=vm.mapOptions></gz-google-address><gz-form-footer-bar submitting=vm.sending submit-title=uxf.uxf.Dialog_OK show-legend=false cancel=vm.cancel></gz-form-footer-bar></form></md-dialog>";

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	module.exports = "<div class=map></div>";

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = "<p>{{vm.msg}}</p>";

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	module.exports = "<md-input-container><label translate=uxf.uxf.Language></label><md-select ng-model=vm.selectedLocale ng-change=vm.setModelValue() md-container-class=gz-locale-select-menu><md-option ng-value=locale ng-repeat=\"locale in vm.localeOptions\" ng-selected=\"vm.selectedLocale.language == locale.language\"><div layout=row layout-align=space-between class=language-container><div class=primary><div ng-if=\"vm.gzNative === &quot;primary&quot;\">{{locale.language}}</div><div ng-if=\"vm.gzNative === &quot;secondary&quot;\" translate=\"{{&quot;uxf.uxf.&quot; + locale.value}}\"></div></div><div class=secondary><div ng-if=\"vm.gzNative === &quot;primary&quot;\" translate=\"{{&quot;uxf.uxf.&quot; + locale.value}}\"></div><div ng-if=\"vm.gzNative === &quot;secondary&quot;\">{{locale.language}}</div></div></div></md-option><md-optgroup ng-if=\"vm.limitedLocaleOptions.length &gt; 0\" label=\"{{&quot;uxf.uxf.PartialTranslation&quot; | translate}}\"><md-option ng-value=locale ng-repeat=\"locale in vm.limitedLocaleOptions\" ng-selected=\"vm.selectedLocale.language === locale.language\"><div layout=row layout-align=space-between class=language-container><div class=primary><div ng-if=\"vm.gzNative === &quot;primary&quot;\">{{locale.language}}</div><div ng-if=\"vm.gzNative === &quot;secondary&quot;\" translate=\"{{&quot;uxf.uxf.&quot; + locale.value}}\"></div></div><div class=secondary><div ng-if=\"vm.gzNative === &quot;primary&quot;\" translate=\"{{&quot;uxf.uxf.&quot; + locale.value}}\"></div><div ng-if=\"vm.gzNative === &quot;secondary&quot;\">{{locale.language}}</div></div></div></md-option></md-optgroup></md-select></md-input-container>";

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog class=\"gz-dialog change-dates-dialog\"><md-toolbar><div class=md-toolbar-tools><h2 translate=uxf.uxf.History_ChangeDateRange></h2><span flex></span><md-button aria-label=\"{{'uxf.uxf.Dialog_Cancel' | translate}}\" ng-click=vm.cancel() class=md-icon-button><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg></md-icon></md-button></div><md-content><div class=container><div layout=row layout-align=\"center center\" class=month-and-year><md-select ng-model=vm.selectedMonth placeholder=\"Select a month\" ng-change=vm.updateOrgOrigination()><md-option ng-repeat=\"month in vm.availableMonths\" ng-selected=\"vm.selectedMonth === month\" ng-value=month> {{month}}</md-option></md-select><md-select ng-model=vm.selectedYear placeholder=\"Select a year\" ng-change=vm.initiateMonths()><md-option ng-repeat=\"year in vm.availableYears\" ng-selected=\"vm.selectedYear === year\" ng-value=year>{{year}}</md-option></md-select></div><div ng-if=vm.isOrgOrigination layout=row layout-align=\"center center\" class=org-origination>{{'uxf.uxf.History_Org_Origination' | translate}}</div><md-dialog-actions layout=row><md-button id=btn-cancel-add-reseller ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel class=md-primary></md-button><md-button id=btn-add-reseller ng-click=vm.submit() translate=uxf.uxf.Dialog_Submit ng-disabled=\"vm.availableMonths.indexOf(vm.selectedMonth) === -1\" class=\"md-primary md-raised\"></md-button></md-dialog-actions></div></md-content></md-toolbar></md-dialog>";

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = "<div layout=row layout-align=\"start center\" class=gz-month-selector-container><md-button ng-click=vm.previousDateRange() ng-disabled=vm.isEarliestDateRange() gz-analytics-event=\"user details previous date range\" gz-analytics-event-click class=prev><md-icon md-font-icon=\"fa fa-2x fa-caret-left\" class=date-nav-button></md-icon><md-tooltip ng-if=vm.isEarliestDateRange()>{{'uxf.uxf.History_Org_Origination' | translate}}</md-tooltip></md-button><div layout=row layout-align=\"center center\" gz-analytics-event=\"user details date range filter\" gz-analytics-event-click ng-click=vm.changeDates($event) class=\"pointer selected-date-range\">{{vm.getCurrentDateRange().toDate() | amDateFormat:'MMMM YYYY'}}<md-tooltip>{{'uxf.uxf.History_ChangeDateRange' | translate}}</md-tooltip></div><md-button ng-click=vm.nextDateRange() gz-analytics-event=\"history next date range\" gz-analytics-event-click class=next><md-icon md-font-icon=\"fa fa-2x fa-caret-right\" class=date-nav-button></md-icon></md-button></div>";

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=!vm.isLoading ng-class=\"{&quot;with-task-bar&quot;: vm.isTask, &quot;view-nav&quot;: vm.viewNav}\" layout=column class=pg-header-toolbar><div ng-if=\"vm.isTask &amp;&amp; !vm.isLoading &amp;&amp; !vm.hideTaskBar\" layout=row layout-align=\"start center\" class=\"task-bar fill-width\"><div layout=row layout-align=\"start center\" ng-click=vm.cancel() class=back-container><md-button aria-label=\"{{&quot;uxf.uxf.From_Task&quot; | translate}}\" class=\"md-icon-button back-button\"><md-tooltip><div translate=uxf.uxf.From_Task translate-values=[vm.taskSource]></div></md-tooltip><md-icon md-svg-src=https://cdn.printos.com/images/general/material/keyboard_arrow_left.svg></md-icon></md-button><div translate=uxf.uxf.From_Task translate-values=[vm.taskSource] class=application-source></div></div><div flex></div><md-button ng-if=\"!vm.isSubmitPage &amp;&amp; !vm.hideBackToTask\" aria-label=\"{{&quot;uxf.uxf.Exit_Task&quot; | translate}}\" ng-click=vm.goToTask() class=md-icon-button><md-tooltip>{{'uxf.uxf.BackToTask' | translate}}</md-tooltip><md-icon md-svg-src=https://cdn.printos.com/images/general/material/arrow_back.svg></md-icon></md-button><md-button ng-if=vm.allowAppNav aria-label={{vm.getShowHideTitle()}} ng-click=vm.toggleAppNav() class=md-icon-button><md-tooltip>{{vm.getShowHideTitle()}}</md-tooltip><md-icon md-svg-src=https://cdn.printos.com/images/general/material/menu.svg></md-icon></md-button><md-button ng-if=\"!vm.hideExitTask &amp;&amp; vm.allowExitToApp\" aria-label={{vm.exitToApplicationTitle}} ng-click=vm.exitTask() class=md-icon-button><md-tooltip>{{vm.exitToApplicationTitle}}</md-tooltip><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg></md-icon></md-button></div><div ng-if=\"!vm.isNavUX &amp;&amp; vm.breadcrumbs &amp;&amp; !vm.isTask\" layout=row layout-align=\"start center\" class=\"breadcrumbs-container fill-width\"><div ng-repeat=\"breadcrumb in vm.breadcrumbs\" layout=row layout-align=\"start center\" class=breadcrumb-container><div ng-if=!$last ng-click=\"vm.gotoState(breadcrumb.state, breadcrumb.stateParams)\" class=\"breadcrumb link\">{{breadcrumb.titleKey | translate}}</div><div ng-if=$last class=breadcrumb>{{breadcrumb.titleKey | translate}}</div><i ng-if=!$last class=\"fa fa-caret-right link-separator\"></i></div></div><div layout=row class=fill-width><div flex layout=row layout-align=\"start center\" class=toolbar-container><div ng-if=\"vm.parentState &amp;&amp; !vm.isTask\" flex ng-click=vm.gotoParent() layout=row layout-align=\"start center\"><i class=\"fa fa-2x fa-caret-left back-icon brdcrumb\"><md-tooltip data-ng-if=vm.parentDescription>{{vm.parentDescription}}</md-tooltip></i><span flex gz-auto-tooltip={{vm.getPageTitle()}} class=md-headline>{{vm.getPageTitle()}}</span></div><span gz-auto-tooltip={{vm.getPageTitle()}} ng-if=\"!(vm.parentState &amp;&amp; !vm.isTask)\" flex class=md-headline>{{vm.getPageTitle()}}</span></div><div layout=row layout-align=\"end center\" class=toolbar-task-container><div hide show-gt-xs ng-if=\"vm.isResponsive &amp;&amp; vm.isSubmitPage &amp;&amp; vm.isTask\" layout=row><md-button id=btn-cancel-task type=button ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel ng-if=!vm.hideCancel class=md-primary></md-button><md-button id=btn-submit-task ng-click=vm.submit() ng-disabled=vm.disableSubmit() class=\"md-primary md-raised submit-button\"><span ng-if=vm.taskSubmitTitle>{{vm.taskSubmitTitle}}</span><span ng-if=!vm.taskSubmitTitle translate=uxf.uxf.Dialog_Submit></span></md-button></div><div ng-if=\"!vm.isResponsive &amp;&amp; vm.isSubmitPage &amp;&amp; vm.isTask\" layout=row><md-button id=btn-cancel-task type=button ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel ng-if=!vm.hideCancel class=md-primary></md-button><md-button id=btn-submit-task ng-click=vm.submit() ng-disabled=vm.disableSubmit() class=\"md-primary md-raised submit-button\"><span ng-if=vm.taskSubmitTitle>{{vm.taskSubmitTitle}}</span><span ng-if=!vm.taskSubmitTitle translate=uxf.uxf.Dialog_Submit></span></md-button></div><ng-transclude ng-if=\"!vm.isResponsive &amp;&amp; !vm.isSubmitPage\" layout=row layout-align=\"start center\"></ng-transclude><ng-transclude hide show-gt-xs ng-if=\"vm.isResponsive &amp;&amp; !vm.isSubmitPage\" layout=row layout-align=\"start center\"></ng-transclude><i ng-if=vm.isCollapse hide-gt-xs show-xs ng-click=\"vm.showMenu = !vm.showMenu\" class=\"toolbar-icon fa fa-bars fa-2x clickable\"><md-tooltip data-ng-if=vm.parentDescription>{{vm.parentDescription}}</md-tooltip></i></div></div><div show-xs hide-gt-xs ng-if=\"vm.isResponsive &amp;&amp; vm.isSubmitPage &amp;&amp; vm.isTask\" layout=row layout-align=\"end center\" class=toolbar-task-container><div layout=row><md-button id=btn-cancel-task type=button ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel ng-if=!vm.hideCancel class=md-primary></md-button><md-button id=btn-submit-task ng-click=vm.submit() ng-disabled=vm.disableSubmit() class=\"md-primary md-raised submit-button\"><span ng-if=vm.taskSubmitTitle>{{vm.taskSubmitTitle}}</span><span ng-if=!vm.taskSubmitTitle translate=uxf.uxf.Dialog_Submit></span></md-button></div></div><ng-transclude show-xs hide-gt-xs ng-if=\"vm.showMenu &amp;&amp; vm.isCollapse &amp;&amp; !vm.isSubmitPage\" layout=column layout-align=\"center end\"></ng-transclude><ng-transclude show-xs hide-gt-xs ng-if=\"vm.isResponsive &amp;&amp; !vm.isCollapse &amp;&amp; !vm.isSubmitPage\" layout=row layout-align=\"start center\"></ng-transclude></div>";

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = "<div layout-fill layout=column layout-align=\"start center\" class=\"gz-view-container page-not-found-container\"><div translate=uxf.uxf.Page_Not_Found class=page-not-found-title></div><md-icon layout=column layout-align=\"center center\" md-svg-src=/images/logos/PrintOS.svg class=production-image></md-icon><div ng-if=vm.reason translate={{vm.reason}} class=page-not-found-reason></div><div ng-if=vm.detail translate={{vm.detail}} class=page-not-found-detail></div></div>";

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"ifLoading === undefined || (ifLoading !== undefined &amp;&amp; ifLoading)\" layout=row layout-align=\"center center\"><md-progress-circular md-mode=indeterminate md-diameter={{::diameter}}></md-progress-circular></div>";

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports = "<div layout=row layout-align=\"start end\" class=time-picker><label ng-if=vm.label translate={{vm.label}} class=small-label></label><div layout=row layout-align=\"start center\" class=time-inputs><md-input-container><input name=hour type=text pattern=[0-9]+ ng-model=vm.hourInput ng-change=vm.hourChanged() ng-blur=vm.formatHour() ng-focus=$event.target.select() ng-keydown=vm.handleHourKey($event)></md-input-container><div class=separator></div><md-input-container><input name=minute type=text pattern=[0-9]+ ng-model=vm.minuteInput ng-change=vm.minuteChanged() ng-blur=vm.formatMinute() ng-focus=$event.target.select() ng-keydown=vm.handleMinuteKey($event)></md-input-container></div><md-input-container><md-select ng-if=vm.is12Hour ng-model=vm.meridiem ng-change=vm.timeChanged()><md-option ng-value=&quot;AM&quot; ng-seleted=\"vm.meridiem === &quot;AM&quot;\" translate=uxf.uxf.AM></md-option><md-option ng-value=&quot;PM&quot; ng-seleted=\"vm.meridiem === &quot;PM&quot;\" translate=uxf.uxf.PM></md-option></md-select></md-input-container></div>";

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = "<div layout=row layout-align=\"start start\" class=time-range-container><div class=start-time><label for=start-time translate=uxf.uxf.StartTime class=label></label><div id=start-time layout=row layout-align=\"start start\" class=input><md-input-container><input id=start-time-input type=datetime-local ng-model=vm.startTime ng-change=vm.timeChanged()></md-input-container></div></div><div class=end-time><label for=end-time translate=uxf.uxf.EndTime class=label></label><div id=end-time layout=row layout-align=\"start start\" class=input><md-input-container><input id=end-time-input type=datetime-local ng-model=vm.endTime ng-change=vm.timeChanged()></md-input-container></div></div></div>";

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog class=\"gz-dialog eula-container\"><md-toolbar class=md-toolbar-tools><h2 flex><span translate=uxf.uxf.EulaTitle></span></h2><md-button aria-label=\"{{'uxf.uxf.Dialog_Cancel' | translate}}\" ng-click=terms.close() class=md-icon-button><md-icon md-svg-src=https://cdn.printos.com/images/general/material/clear.svg></md-icon></md-button></md-toolbar><div ng-if=\"!terms.loading &amp;&amp; terms.isChanged\" class=gz-readonly><div class=table-layout><div class=row><span layout-padding translate=uxf.uxf.EULA_Changed></span></div></div></div><md-content flex class=md-padding><gz-spinner if-loading=terms.loading></gz-spinner><div ng-bind-html=terms.eulaText class=eula-text></div></md-content><md-dialog-actions ng-if=terms.requireAccept layout=row layout-wrap class=md-padding><em translate=uxf.uxf.Agree flex class=accept-msg></em><div><md-button ng-click=terms.close() translate=uxf.uxf.Dialog_Cancel translate-attr-aria-label=uxf.uxf.Dialog_Cancel></md-button><md-button ng-click=terms.accept() translate=uxf.uxf.Dialog_Accept translate-attr-aria-label=uxf.uxf.Dialog_Accept class=\"md-raised md-primary\"></md-button></div></md-dialog-actions><md-dialog-actions ng-if=!terms.requireAccept layout=row class=md-padding><md-button id=btn-eula ng-click=terms.close() translate=uxf.uxf.Dialog_Close translate-attr-aria-label=uxf.uxf.Dialog_Close class=\"md-raised md-primary\"></md-button></md-dialog-actions></md-dialog>";

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports = "<div ng-message=required><translate>uxf.uxf.Required</translate></div><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div>";

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports = "<div class=gz-start><div ng-if=\"vm.loading &amp;&amp; vm.gzIsStarting\" class=gz-start-container><div class=spinner-container><gz-spinner if-loading=vm.loading></gz-spinner></div></div><div ng-if=\"!vm.loading &amp;&amp; vm.gzIsStarting\" layout=column layout-align=\"start stretch\" layout-fill class=gz-start-container><div layout=row layout-align=\"center center\" class=steps-container><div flex layout=column class=spacer-container><div flex></div><div class=hr></div></div><div layout=row layout-align=\"start start\" class=step-scroll-container><div ng-repeat=\"step in vm.mySteps\" layout=row layout-align=\"start stretch\" class=step-and-connector-container><div layout=column ng-click=vm.selectStep($index) ng-class=\"{selected: $index === vm.selectedIndex, disabled: $index &gt; vm.currentStepIndex}\" class=step-container><div flex layout=row layout-align=\"center center\" class=step><div ng-if=\"$index === vm.selectedIndex\" layout=column class=center-container><div layout=row layout-align=\"center center\" ng-class=\"{disabled: $index &gt; vm.currentStepIndex}\" class=outer-circle-border><div layout=row layout-align=\"center center\" ng-class=\"{disabled: $index &gt; vm.currentStepIndex}\" class=\"circle-border selected\"><div ng-if=!step.isComplete class=step-count>{{$index + 1}}</div><md-icon ng-if=step.isComplete md-svg-src=https://cdn.printos.com/images/general/material/check.svg></md-icon></div></div><div ng-if=step.titleKey translate={{step.titleKey}} class=\"step-label adjust\"></div><div ng-if=!step.titleKey class=\"step-label adjust\">{{step.title}}</div></div><div ng-if=\"$index !== vm.selectedIndex\" layout=column class=center-container><div layout=row layout-align=\"center center\" ng-class=\"{disabled: $index &gt; vm.currentStepIndex}\" class=circle-border><div ng-if=\"!step.isComplete || vm.currentStepIndex &lt; $index\" ng-class=\"{disabled: $index &gt; vm.currentStepIndex}\" class=step-count>{{$index + 1}}</div><md-icon ng-if=\"step.isComplete &amp;&amp; vm.currentStepIndex &gt;= $index\" md-svg-src=https://cdn.printos.com/images/general/material/check.svg></md-icon></div><div ng-if=step.titleKey translate={{step.titleKey}} class=step-label></div><div ng-if=!step.titleKey class=step-label>{{step.title}}</div></div></div><div ng-class=\"{selected: $index === vm.selectedIndex}\" class=hr><div class=before></div><div class=after></div></div></div><div ng-if=!$last layout=column class=\"step-container connector\"><div flex layout=row layout-align=\"center center\" class=step><div layout=column class=center-container><div ng-class=\"{disabled: $index &gt;= vm.currentStepIndex}\" class=circle-connector></div><div class=step-label></div></div></div><div class=hr></div></div></div></div><div flex layout=column class=spacer-container><div flex></div><div class=hr></div></div></div><div layout=column class=content-container><div ng-if=!vm.gzStepSettings.currentStep.isComplete layout=column layout-align=\"start center\" class=step-not-complete><div ng-if=vm.gzStepSettings.currentStep.descriptionKey translate={{vm.gzStepSettings.currentStep.descriptionKey}} class=step-title></div><div ng-if=!vm.gzStepSettings.currentStep.descriptionKey class=step-title>{{vm.gzStepSettings.currentStep.description}}</div><div ng-if=vm.gzStepSettings.currentStep.detailsKey translate={{vm.gzStepSettings.currentStep.detailsKey}} class=step-description></div><div ng-if=!vm.gzStepSettings.currentStep.detailsKey class=step-description>{{vm.gzStepSettings.currentStep.details}}</div><div ng-if=vm.gzStepSettings.currentStep.details2Key translate={{vm.gzStepSettings.currentStep.details2Key}} class=\"step-description spacer\"></div><div ng-if=\"vm.gzStepSettings.currentStep.details2 &amp;&amp; !vm.gzStepSettings.currentStep.details2Key\" class=\"step-description spacer\">{{vm.gzStepSettings.currentStep.details2}}</div></div><div ng-if=vm.gzStepSettings.currentStep.isComplete layout=column layout-align=\"start center\" class=step-complete><div layout=row layout-align=\"start center\" class=title-container><md-icon md-svg-src=https://cdn.printos.com/images/general/material/check.svg class=success></md-icon><div ng-if=vm.gzStepSettings.currentStep.completeDescriptionKey translate={{vm.gzStepSettings.currentStep.completeDescriptionKey}} class=step-title></div><div ng-if=!vm.gzStepSettings.currentStep.completeDescriptionKey class=step-title>{{vm.gzStepSettings.currentStep.completeDescription}}</div></div><div ng-if=vm.gzStepSettings.currentStep.completeDetailsKey translate={{vm.gzStepSettings.currentStep.completeDetailsKey}} class=step-description></div><div ng-if=!vm.gzStepSettings.currentStep.completeDetailsKey class=step-description>{{vm.gzStepSettings.currentStep.completeDetails}}</div><div ng-if=vm.gzStepSettings.currentStep.completeDetails2Key translate={{vm.gzStepSettings.currentStep.completeDetails2Key}} class=step-description></div><div ng-if=\"vm.gzStepSettings.currentStep.completeDetails2 &amp;&amp; !vm.gzStepSettings.currentStep.completeDetails2Key\" class=step-description>{{vm.gzStepSettings.currentStep.completeDetails2}}</div></div><div ng-if=\"vm.gzStepSettings.currentStep.id !== &quot;GZ_FINISH_STEP&quot; &amp;&amp; (!vm.gzStepSettings.currentStep.isComplete || vm.gzStepSettings.currentStep.isComplete &amp;&amp; !vm.gzStepSettings.currentStep.hideContentOnComplete)\" layout=column layout-align=\"center center\" class=step-actions><ng-transclude></ng-transclude></div><div ng-if=\"vm.gzStepSettings.currentStep.id === &quot;GZ_FINISH_STEP&quot;\" layout=column layout-align=\"center center\" class=step-actions><md-button id=btn-finish type=button ng-click=vm.reload() class=\"md-primary md-raised wide-button main-action\"><span translate=uxf.uxf.Start_Finish class=main-action></span></md-button></div></div></div></div>";

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog layout=column class=edit-columns-dialog><gz-dialog-title-bar ng-if=!vm.isLoading gz-title=\"{{&quot;uxf.uxf.Columns_Title&quot; | translate }}\"></gz-dialog-title-bar><form flex ng-if=!vm.isLoading name=vm.columnsForm ng-submit=vm.submit($event) novalidate><gz-error-bar error-key=vm.errorKey></gz-error-bar><div flex layout=column submitting=vm.processing class=form-container><div layout=row layout-align=\"start center\" class=columns-header><div flex translate=uxf.uxf.Columns_Title class=columns-title></div><md-button ng-class=\"{disabled: vm.moveUpDisabled()}\" ng-click=vm.moveUp($event) aria-label=\"{{'uxf.uxf.MoveUp' | translate}}\" md-no-ink class=md-icon-button><i class=\"fa fa-arrow-circle-o-up fa-2x\"></i></md-button><md-button ng-class=\"{disabled: vm.moveDownDisabled()}\" ng-click=vm.moveDown($event) aria-label=\"{{'uxf.uxf.MoveDown' | translate}}\" class=md-icon-button><i class=\"fa fa-arrow-circle-o-down fa-2x\"></i></md-button></div><div flex class=columns-scroll-container><div layout=row layout-align=\"start center\" ng-repeat=\"column in vm.displayColumns\" ng-click=vm.columnClicked(column) ng-class=\"{selected: vm.selected.id === column.id}\" class=columns-row><md-checkbox ng-model=column.visible></md-checkbox><div flex class=column-title>{{column.header.title}}</div><md-button ng-if=\"vm.selected.id === column.id || column.pinned\" ng-click=\"vm.togglePin($event, column)\" aria-label=\"{{'uxf.uxf.Pin' | translate}}\" class=md-icon-button><i ng-class=\"{pinned: column.pinned}\" class=\"fa fa-map-pin fa-2x pin-icon\"></i></md-button></div></div></div><gz-form-footer-bar submitting=vm.processing disable-submit=vm.disableSubmit submit-title=uxf.uxf.Dialog_OK show-legend=false></gz-form-footer-bar></form></md-dialog>";

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=node.canFlower ng-click=expandCollapse($event) class=gz-expand-cell><md-icon ng-if=node.expanded md-svg-src=https://cdn.printos.com/images/general/material/keyboard_arrow_down.svg class=gz-expand-cell-image></md-icon><md-icon ng-if=!node.expanded md-svg-src=https://cdn.printos.com/images/general/material/keyboard_arrow_right.svg class=gz-expand-cell-image></md-icon></div>";

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	module.exports = "<i alt=\"{{'uxf.uxf.Grid_View_Action' | translate}}\" ng-if=isRowSelected(rowNode) ng-class=\"{&quot;gz-clickable&quot;: !gotoDisabled(), disabled: gotoDisabled()}\" ng-click=\"drillDownClicked(rowNode, $event)\" class=\"fa fa-caret-right fa-2x gz-action-btn\"><md-tooltip ng-if=drillDownTooltip>{{drillDownTooltip}}</md-tooltip><md-tooltip ng-if=!drillDownTooltip>{{'uxf.uxf.Grid_View_Action' | translate}}</md-tooltip></i>";

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = "<div ontouchstart=\"var event=arguments[0];event.stopPropagation()\" ontouchend=\"var event=arguments[0];event.stopPropagation()\" class=gz-grid-menu-container></div>";

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	module.exports = "<div layout=row class=gz-header-template-container><div id=agHeaderCellLabel class=gz-header-template-cell-label><div id=agText class=gz-header-template-text></div></div><div id=agResizeBar class=gz-header-template-resize-bar></div></div>";

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "<div layout=row layout-align=\"start center\" class=\"gz-grid-header-container gz-header\"><div flex ng-if=!colDef.gzColumn.header.tooltip ng-class=\"{&quot;gz-center-header&quot;: headerJustify === &quot;center&quot;, &quot;gz-right-header&quot;: headerJustify === &quot;right&quot;}\" gz-auto-tooltip class=gz-header-title>{{colDef.headerName}}</div><div ng-if=colDef.gzColumn.header.tooltip flex ng-class=\"{&quot;gz-center-header&quot;: headerJustify === &quot;center&quot;, &quot;gz-right-header&quot;: headerJustify === &quot;right&quot;}\" class=gz-header-title>{{colDef.headerName}}<md-tooltip>{{colDef.gzColumn.header.tooltip}}</md-tooltip></div><i ng-if=\"isFilter(colDef.colId) &amp;&amp; isFiltered(colDef.colId)\" ng-click=\"openFilter($event, colDef.colId)\" class=\"fa fa-filter gz-filter selected\"></i><i ng-if=\"allowFilters &amp;&amp; isFilter(colDef.colId) &amp;&amp; !isFiltered(colDef.colId)\" ng-click=\"openFilter($event, colDef.colId)\" class=\"fa fa-filter gz-filter\"></i><i ng-if=\"getSort(colDef.colId) === &quot;asc&quot;\" class=\"fa fa-long-arrow-down gz-sort\"><md-tooltip><div ng-if=colDef.gzColumn.options.sort.ascendingKey><div translate={{colDef.gzColumn.options.sort.ascendingKey}}></div></div><div ng-if=!colDef.gzColumn.options.sort.ascendingKey ng-switch=colDef.gzColumn.type><div ng-switch-when=string translate=uxf.uxf.AToZ></div><div ng-switch-when=number translate=uxf.uxf.LowToHigh></div><div ng-switch-when=date translate=uxf.uxf.OldToNew></div><div ng-switch-when=duration translate=uxf.uxf.LowToHigh></div><div ng-switch-when=mapped translate=uxf.uxf.LowToHigh></div><div ng-switch-default translate=uxf.uxf.LowToHigh></div></div></md-tooltip></i><i ng-if=\"getSort(colDef.colId) === &quot;desc&quot;\" class=\"fa fa-long-arrow-up gz-sort\"><md-tooltip><div ng-if=colDef.gzColumn.options.sort.descendingKey><div translate={{colDef.gzColumn.options.sort.descendingKey}}></div></div><div ng-if=!colDef.gzColumn.options.sort.descendingKey ng-switch=colDef.gzColumn.type><div ng-switch-when=string translate=uxf.uxf.ZToA></div><div ng-switch-when=number translate=uxf.uxf.HighToLow></div><div ng-switch-when=date translate=uxf.uxf.NewToOld></div><div ng-switch-when=duration translate=uxf.uxf.HighToLow></div><div ng-switch-when=mapped translate=uxf.uxf.HighToLow></div><div ng-switch-default translate=uxf.uxf.HighToLow></div></div></md-tooltip></i><sup>{{getSortIndex(colDef.colId)}}</sup></div>";

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=showMenu layout=row layout-align=\"end center\" ontouchstart=\"var event=arguments[0];event.stopPropagation()\" ontouchend=\"var event=arguments[0];event.stopPropagation()\" class=gz-grid-menu-container><md-menu-bar class=\"gz-right-header gz-action-header\"><md-menu class=gz-menu><md-button ng-click=$mdOpenMenu($event) class=md-icon-button><div class=gz-indicator-container><i class=\"fa fa-bars\"></i><div ng-if=gzGridIndicator.show class=gz-indicator></div></div></md-button><md-menu-content width=3><md-menu-item ng-if=!vm.filterMode><md-button ng-click=gzFilterClicked($event)><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-filter.svg class=gz-menu-icon></md-icon><div flex>{{'uxf.uxf.GridMenu_Filters' | translate}}</div></div></md-button></md-menu-item><md-menu-item ng-if=\"vm.namedFilters.length &gt; 0 &amp;&amp; !vm.filterMode\"><md-menu><md-button ng-click=$mdOpenMenu()><div layout=row layout-align=\"start center\"><div flex>{{'uxf.uxf.Filter_BuiltInFilters' | translate}}</div></div></md-button><md-menu-content width=2><md-menu-item ng-repeat=\"filter in vm.namedFilters\"><md-button ng-click=\"gzNamedFilterClicked($event, filter)\"><div layout=row layout-align=\"start center\" class=filter-container><div flex>{{filter.display.title}}</div></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-item ng-if=\"vm.savedFilters.length &gt; 0 &amp;&amp; !vm.filterMode\"><md-menu><md-button ng-click=$mdOpenMenu()><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-filter.svg class=gz-menu-icon></md-icon><div flex>{{'uxf.uxf.Filter_MyFilters' | translate}}</div></div></md-button><md-menu-content width=2><md-menu-item ng-repeat=\"filter in vm.savedFilters\"><md-button ng-click=\"gzSaveFilterClicked($event, filter)\"><div layout=row layout-align=\"start center\" class=filter-container><div flex>{{filter.namedFilter.display.title}}</div><md-icon md-svg-src=https://cdn.printos.com/images/general/material/delete.svg ng-click=\"gzRemoveFilterClicked($event, filter)\" class=\"gz-menu-icon right\"></md-icon></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider ng-if=\"!vm.filterMode &amp;&amp; (vm.savedFilters.length &gt; 0 || vm.namedFilters.length &gt; 0)\"></md-menu-divider><md-menu-item><md-button ng-click=gzColumnsClicked($event)><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-columns.svg class=gz-menu-icon></md-icon><div flex>{{'uxf.uxf.GridMenu_Columns' | translate}}</div></div></md-button></md-menu-item><md-menu-item><md-button ng-click=gzSortClicked($event)><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-sort.svg class=gz-menu-icon></md-icon><div flex>{{'uxf.uxf.GridMenu_Sort' | translate}}</div></div></md-button></md-menu-item><md-menu-item><md-button ng-click=gzCSVClicked($event)><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-csv.svg class=gz-menu-icon></md-icon><div flex>{{'uxf.uxf.GridMenu_ExportCSV' | translate}}</div></div></md-button></md-menu-item><md-menu-item><md-button ng-click=gzResetSortClicked($event)><div layout=row layout-align=\"start center\"><div class=gz-indicator-container><md-icon md-svg-src=gazelle/grid/images/grid-reset.svg class=gz-menu-icon></md-icon><div ng-if=gzGridIndicator.show class=\"gz-indicator menu\"></div></div><div flex>{{'uxf.uxf.GridMenu_ResetDefaultSort' | translate}}</div></div></md-button></md-menu-item><md-menu-item><md-button ng-click=gzResetClicked($event)><div layout=row layout-align=\"start center\"><md-icon md-svg-src=gazelle/grid/images/grid-reset.svg class=gz-menu-icon></md-icon><div flex>{{'uxf.uxf.GridMenu_ResetDefaults' | translate}}</div></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-tooltip>{{'uxf.uxf.Grid_Options' | translate}}</md-tooltip></div>";

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=!vm.loading ag-grid=vm.agGridOptions class=\"gz-grid ag-material\"></div>";

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog layout=column class=sort-dialog><gz-dialog-title-bar ng-if=!vm.isLoading gz-title=\"{{&quot;uxf.uxf.Sort_Title&quot; | translate }}\"></gz-dialog-title-bar><form flex ng-if=!vm.isLoading name=vm.columnsForm ng-submit=vm.submit($event) novalidate><gz-error-bar error-key=vm.errorKey></gz-error-bar><div flex layout=column submitting=vm.processing class=form-container><div layout=row layout-align=\"start center\" class=sort-header><div flex translate=uxf.uxf.SortBy_Title class=sort-title></div><md-button ng-disabled=vm.moveUpDisabled() ng-class=\"{disabled: vm.moveUpDisabled()}\" ng-click=vm.moveUp($event) aria-label=\"{{'uxf.uxf.MoveUp' | translate}}\" md-no-ink class=md-icon-button><i class=\"fa fa-arrow-circle-o-up fa-2x\"></i></md-button><md-button ng-disabled=vm.moveDownDisabled() ng-class=\"{disabled: vm.moveDownDisabled()}\" ng-click=vm.moveDown($event) aria-label=\"{{'uxf.uxf.MoveDown' | translate}}\" class=md-icon-button><i class=\"fa fa-arrow-circle-o-down fa-2x\"></i></md-button><md-button ng-disabled=!vm.selected ng-class=\"{disabled: !vm.selected}\" ng-click=vm.removeSort($event) aria-label=\"{{'uxf.uxf.RemoveSort' | translate}}\" class=md-icon-button><i class=\"fa fa-trash-o fa-2x\"></i></md-button></div><div flex class=sort-scroll-container><div ng-if=\"vm.sort.length &gt; 0\" layout=row layout-align=\"start center\" ng-repeat=\"sortItem in vm.sort\" ng-click=vm.sortClicked(sortItem) ng-class=\"{selected: vm.selected.column.id === sortItem.column.id}\" class=sort-row><div flex class=column-title>{{sortItem.column.header.title}}</div><div ng-if=\"sortItem.column.options.sort.ascendingKey &amp;&amp; sortItem.sort === &quot;asc&quot;\" class=sort-hint><div translate={{sortItem.column.options.sort.ascendingKey}}></div></div><div ng-if=\"!sortItem.column.options.sort.ascendingKey &amp;&amp; sortItem.sort === &quot;asc&quot;\" ng-switch=sortItem.column.type class=sort-hint><div ng-switch-when=string translate=uxf.uxf.AToZ></div><div ng-switch-when=number translate=uxf.uxf.LowToHigh></div><div ng-switch-when=date translate=uxf.uxf.OldToNew></div><div ng-switch-when=duration translate=uxf.uxf.LowToHigh></div><div ng-switch-when=mapped translate=uxf.uxf.LowToHigh></div><div ng-switch-default translate=uxf.uxf.LowToHigh></div></div><div ng-if=\"sortItem.column.options.sort.descendingKey &amp;&amp; sortItem.sort === &quot;desc&quot;\" class=sort-hint><div translate={{sortItem.column.options.sort.descendingKey}}></div></div><div ng-if=\"!sortItem.column.options.sort.descendingKey &amp;&amp; sortItem.sort === &quot;desc&quot;\" ng-switch=sortItem.column.type class=sort-hint><div ng-switch-when=string translate=uxf.uxf.ZToA></div><div ng-switch-when=number translate=uxf.uxf.HighToLow></div><div ng-switch-when=date translate=uxf.uxf.NewToOld></div><div ng-switch-when=duration translate=uxf.uxf.HighToLow></div><div ng-switch-when=mapped translate=uxf.uxf.HighToLow></div><div ng-switch-default translate=uxf.uxf.HighToLow></div></div><md-button ng-click=\"vm.toggleSortOrder($event, sortItem)\" aria-label=\"{{'uxf.uxf.ToggleSort' | translate}}\" class=md-icon-button><i ng-if=\"sortItem.sort === &quot;asc&quot;\" class=\"fa fa-long-arrow-up fa-2x gz-sort\"></i><i ng-if=\"sortItem.sort === &quot;desc&quot;\" class=\"fa fa-long-arrow-down fa-2x gz-sort\"></i></md-button></div><div ng-if=\"vm.sort.length === 0\" layout=row layout-align=\"start center\" class=sort-row><div translate=uxf.uxf.NoSortItems class=column-title></div></div></div><div ng-if=\"vm.availableColumns.length &gt; 0\" layout=row layout-align=\"start center\" layout-xs=column layout-align-xs=\"start stretch\" class=add-row><div translate=uxf.uxf.AddSort_Title class=sort-title></div><div layout=row layout-align=\"start center\" flex><md-select id=sort-column flex name=sortColumm ng-model=vm.sortColumn><md-option ng-value=column ng-repeat=\"column in vm.availableColumns\" ng-selected=\"vm.sortColumn.id == column.id\">{{column.header.title}}</md-option></md-select><md-button ng-click=vm.toggleSortDirection($event) aria-label=\"{{'uxf.uxf.ToggleSort' | translate}}\" class=\"md-icon-button sort-icon\"><i ng-if=\"vm.sortDirection === &quot;asc&quot;\" class=\"fa fa-long-arrow-up fa-2x gz-sort\"></i><i ng-if=\"vm.sortDirection === &quot;desc&quot;\" class=\"fa fa-long-arrow-down fa-2x gz-sort\"></i></md-button></div><div ng-if=\"sortItem.column.options.sort.ascendingKey &amp;&amp; sortItem.sort === &quot;asc&quot;\" class=\"sort-hint spacer\"><div translate={{sortItem.column.options.sort.ascendingKey}}></div></div><div ng-if=\"!sortItem.column.options.sort.ascendingKey &amp;&amp; vm.sortDirection === &quot;asc&quot;\" ng-switch=vm.sortColumn.type class=\"sort-hint spacer\"><div ng-switch-when=string translate=uxf.uxf.AToZ></div><div ng-switch-when=number translate=uxf.uxf.LowToHigh></div><div ng-switch-when=date translate=uxf.uxf.NewToOld></div><div ng-switch-when=duration translate=uxf.uxf.NewToOld></div><div ng-switch-when=mapped translate=uxf.uxf.LowToHigh></div><div ng-switch-default translate=uxf.uxf.LowToHigh></div></div><div ng-if=\"sortItem.column.options.sort.descendingKey &amp;&amp; sortItem.sort === &quot;asc&quot;\" class=\"sort-hint spacer\"><div translate={{sortItem.column.options.sort.descendingKey}}></div></div><div ng-if=\"!sortItem.column.options.sort.descendingKey &amp;&amp; vm.sortDirection === &quot;desc&quot;\" ng-switch=vm.sortColumn.type class=\"sort-hint spacer\"><div ng-switch-when=string translate=uxf.uxf.ZToA></div><div ng-switch-when=number translate=uxf.uxf.HighToLow></div><div ng-switch-when=date translate=uxf.uxf.OldToNew></div><div ng-switch-when=duration translate=uxf.uxf.OldToNew></div><div ng-switch-when=mapped translate=uxf.uxf.HighToLow></div><div ng-switch-default translate=uxf.uxf.HighToLow></div></div><md-button id=btn-add-device ng-disabled=!vm.sortColumn ng-class=\"{disabled: !vm.sortColumn}\" ng-click=vm.addSort() translate=uxf.uxf.Dialog_Add class=\"md-primary md-raised add-button\"></md-button></div></div><gz-form-footer-bar submitting=vm.processing disable-submit=vm.disableSubmit submit-title=uxf.uxf.Dialog_OK show-legend=false></gz-form-footer-bar></form></md-dialog>";

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area accept-account-page\"><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div ng-if=\"!vm.loading &amp;&amp; !vm.success\" translate=register.register.CreateAccount class=page-title></div><div ng-if=\"!vm.loading &amp;&amp; vm.success\" translate=register.register.Account_Created class=page-title></div><div ng-if=\"!vm.loading &amp;&amp; vm.invitationStatusPending()\" translate=register.register.Almost_There class=almost-there></div><div ng-if=\"!vm.loading &amp;&amp; vm.success\"><div layout=column class=request-container><div translate=register.register.AcceptAccount_SuccessMessage1 translate-values=[vm.accept.organizationName] class=request-message></div><div ng-if=\"vm.invitation.invitationType.indexOf(&quot;SELF&quot;) &gt;= 0 &amp;&amp; vm.invitation.internalId.gbu === &quot;Indigo&quot;\" translate=register.register.AcceptAccount_IndigoMessage class=request-message></div></div><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.go() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><div ng-if=\"!vm.loading &amp;&amp; vm.invalid\"><div class=\"request-container invalid\"><div translate=register.register.Invitation_InvalidInvitation class=request-title></div><div translate={{vm.invalidKey}} class=request-message></div><br><div translate={{vm.invalidActionKey}} class=request-message></div></div><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.cancel() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><form ng-if=\"!vm.loading &amp;&amp; !vm.success &amp;&amp; !vm.invalid\" name=vm.form ng-submit=vm.submit()><gz-form-content submitting=vm.submitting><div layout=column class=\"form-container signin\"><md-input-container><label for=orgName>{{'register.register.Invitation_OrganizationName' | translate}}</label><input id=orgName type=text name=orgName ng-model=vm.accept.organizationName required gz-regex-validator=Validator.AAA.NameUnicode md-maxlength=100><div ng-messages=vm.form.orgName.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-checkbox ng-if=!vm.existingUser ng-model=vm.accept.acceptEula><span translate=register.register.Accept_PrivacyStatement ng-click=vm.openPrivacyStatement($event) class=terms-label></span></md-checkbox><md-checkbox ng-if=!vm.existingUser ng-model=vm.accept.acceptTerms><span translate=register.register.Accept_AcceptTerms ng-click=vm.openTerms($event) class=terms-label></span></md-checkbox></div></gz-form-content><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-cancel flex ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel aria-label=cancel></md-button><div class=button-spacer></div><md-button id=btn-accept flex type=submit ng-disabled=!vm.isValid() translate=register.register.CreateAccount translate-attr-aria-label=register.register.CreateAccount class=\"md-raised md-primary\"></md-button></div></form></div></div></div></div>";

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area hpid-sign-in-page\"><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div class=page-title>{{ vm.title }}</div><div translate=register.register.HpAccountDesc class=page-title-desc></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><div translate=register.register.HaveHpAccount class=hpid-details></div><form name=vm.signinForm ng-submit=vm.signin()><gz-form-content submitting=vm.submitting></gz-form-content><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-signin flex type=submit ng-disabled=\"vm.submitting || vm.errorKey\" translate=register.register.UseHpAccount class=\"md-raised md-primary\"></md-button></div></form><div translate=register.register.DoNotHaveHpAccount class=hpid-details></div><form name=vm.signinForm ng-submit=vm.createAccount()><gz-form-content submitting=vm.submitting></gz-form-content><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-create-account flex type=submit ng-disabled=\"vm.submitting || vm.errorKey\" translate=register.register.CreateHpAccount class=\"md-raised secondary-button\"></md-button></div></form><div layout=row layout-align=\"center center\" ng-click=vm.goBack() translate=uxf.uxf.Dialog_Cancel class=cancel></div></div></div></div></div>";

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area accept-existing-user-page\"><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div ng-if=!vm.loading translate=register.register.AcceptUser class=page-title></div><div ng-if=\"!vm.loading &amp;&amp; !vm.success\" class=page-information><div class=table-layout><div class=row><span translate=register.register.AcceptUser_Account class=label></span><span class=value>{{::vm.invitation.organizationName}}</span></div><div class=row><span translate=register.register.AcceptUser_Name class=label></span><span class=value>{{::vm.invitation.firstName}} {{::vm.invitation.lastName}}</span></div><div class=row><span translate=register.register.AcceptUser_Email class=label></span><span class=value>{{::vm.invitation.email}}</span></div></div></div><div ng-if=\"!vm.loading &amp;&amp; !vm.success &amp;&amp; !vm.invalid\" translate=register.register.AcceptExistingUser_Message translate-values=[vm.invitation.organizationName] class=page-details></div><div ng-if=\"!vm.loading &amp;&amp; vm.success\"><div class=request-container><div translate=register.register.Invitation_Accepted class=request-title></div><div translate=register.register.AcceptExistingUser_SuccessMessage translate-values=[vm.invitation.organizationName] class=request-message></div><div ng-if=!vm.loading class=page-information><div class=table-layout><div class=row><span translate=register.register.AcceptUser_Email class=label></span><span class=value>{{::vm.invitation.email}}</span></div></div></div></div><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.go() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><div ng-if=\"!vm.loading &amp;&amp; vm.invalid\"><div class=\"request-container invalid\"><div translate=register.register.Invitation_InvalidInvitation class=request-title></div><div translate={{vm.invalidKey}} class=request-message></div><br><div translate={{vm.invalidActionKey}} class=request-message></div></div><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.cancel() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><form ng-if=\"!vm.loading &amp;&amp; !vm.success &amp;&amp; !vm.invalid\" name=acceptForm ng-submit=vm.submit()><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-cancel flex ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel aria-label=cancel></md-button><div class=button-spacer></div><md-button id=btn-accept flex type=submit ng-disabled=vm.submitting translate=register.register.Invitation_Accept translate-attr-aria-label=register.register.Invitation_Accept class=\"md-raised md-primary\"></md-button></div></form></div></div></div></div>";

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area accept-user-page\"><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div ng-if=!vm.loading translate=register.register.AcceptUser class=page-title></div><div ng-if=\"!vm.loading &amp;&amp; !vm.success &amp;&amp; !vm.invalid\" translate=register.register.AcceptUser_Message translate-values=[vm.invitation.organizationName] class=page-details></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><div ng-if=\"!vm.loading &amp;&amp; vm.success\"><div layout=column class=request-container><div translate=register.register.Invitation_Accepted class=request-title></div><div translate=register.register.AcceptUser_SuccessMessage1 translate-values=[vm.invitation.organizationName] class=request-message></div><div translate=register.register.AcceptUser_SuccessMessage2 class=request-message></div><div ng-if=!vm.loading class=page-information><div class=table-layout><div class=row><span translate=register.register.AcceptUser_Email class=label></span><span class=value>{{::vm.invitation.email}}</span></div></div></div></div><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.go() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><div ng-if=\"!vm.loading &amp;&amp; vm.invalid\"><div class=\"request-container invalid\"><div translate=register.register.Invitation_InvalidInvitation class=request-title></div><div translate={{vm.invalidKey}} class=request-message></div><br><div translate={{vm.invalidActionKey}} class=request-message></div></div><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.cancel() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><form ng-if=\"!vm.loading &amp;&amp; !vm.success &amp;&amp; !vm.invalid\" name=userForm ng-submit=vm.submit()><gz-form-content submitting=vm.submitting><div layout=column class=\"form-container signin\"><md-checkbox ng-model=vm.userForm.acceptEula><span translate=register.register.Accept_PrivacyStatement ng-click=vm.openPrivacyStatement($event) class=terms-label></span></md-checkbox><md-checkbox ng-model=vm.userForm.acceptTerms><span translate=register.register.Accept_TermsOfService ng-click=vm.openTerms($event) class=terms-label></span></md-checkbox></div></gz-form-content><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-cancel flex ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel aria-label=cancel></md-button><div class=button-spacer></div><md-button id=btn-accept flex type=submit ng-disabled=\"userForm.$invalid || !vm.userForm.acceptEula || !vm.userForm.acceptTerms || vm.submitting\" translate=register.register.Invitation_Accept translate-attr-aria-label=register.register.Invitation_Accept class=\"md-raised md-primary\"></md-button></div></form></div></div></div></div>";

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"vm.showIcp &amp;&amp; vm.icp\" class=icp>{{vm.icp}}</div>";

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"!vm.loading &amp;&amp; vm.bu === &quot;3D&quot;\" layout=column layout-align=\"start center\" class=background-container><div flex class=background-image><div layout=column layout-align=\"start start\" class=content-container><div class=image-spacer></div><div layout=row layout-align=\"start center\" class=identity-row><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div class=product-name>3D Center</div></div><div layout=row layout-align=\"start center\" class=description-row><div class=hp-logo-spacer></div><div translate=register.register.3D_Center_Description class=product-description></div></div><div layout=row layout-align=\"start start\" layout-wrap class=category-row><div layout=column layout-align=\"start start\" class=category><div layout=row layout-align=\"start end\" class=title-container><md-icon md-svg-src=https://cdn.printos.com/images/application/icons/3ddata.svg class=category-icon></md-icon><div translate=register.register.3D_Category_Productivity class=category-name></div></div><div layout=row layout-align=\"start center\" class=details-container><div class=category-icon></div><div translate=register.register.3D_Category_Productivity_Desc class=category-desc></div></div></div><div layout=column layout-align=\"start start\" class=category><div layout=row layout-align=\"start end\" class=title-container><md-icon md-svg-src=https://cdn.printos.com/images/application/icons/3ddevices.svg class=category-icon></md-icon><div translate=register.register.3D_Category_Device class=category-name></div></div><div layout=row layout-align=\"start center\" class=details-container><div class=category-icon></div><div translate=register.register.3D_Category_Device_Desc class=category-desc></div></div></div><div layout=column layout-align=\"start start\" class=category><div layout=row layout-align=\"start end\" class=title-container><md-icon md-svg-src=https://cdn.printos.com/images/application/icons/3djobs.svg class=category-icon></md-icon><div translate=register.register.3D_Category_History class=category-name></div></div><div layout=row layout-align=\"start center\" class=details-container><div class=category-icon></div><div translate=register.register.3D_Category_History_Desc class=category-desc></div></div></div><div layout=column layout-align=\"start start\" class=category><div layout=row layout-align=\"start end\" class=title-container><md-icon md-svg-src=https://cdn.printos.com/images/application/icons/3dmaintenance.svg class=category-icon></md-icon><div translate=register.register.3D_Category_Maintenance class=category-name></div></div><div layout=row layout-align=\"start center\" class=details-container><div class=category-icon></div><div translate=register.register.3D_Category_Maintenance_Desc class=category-desc></div></div></div></div></div></div><div layout=row layout-align=\"center center\" layout-wrap class=footer><div translate=uxf.uxf.Copyright class=copyright-container></div><div flex layout=row layout-align=\"center center\" class=link-container><div layout=row class=link-wrapper><a id=privacy href=http://www.hp.com/go/privacy target=_blank analytics-on=click analytics-event=\"link - Privacy\" analytics-category=signin><div translate=uxf.uxf.Privacy gz-auto-tooltip class=link></div></a></div><div class=separator></div><div id=eula ng-click=vm.openTerms() translate=uxf.uxf.TermsOfUse analytics-on=click analytics-event=\"link - Terms of Service\" analytics-category=signin gz-auto-tooltip class=link></div><div class=separator></div><div ng-if=!vm.helpCenterEnabled layout=row class=link-wrapper><a id=support href={{vm.supportURL}} analytics-on=click analytics-event=\"link - Support\" analytics-category=signin><div translate=uxf.uxf.HelpCenter class=link></div></a></div></div><gz-locale-select ng-model=vm.signInData.locale ng-change=vm.localeChanged()></gz-locale-select></div></div><div id=parallax-container ng-if=\"!vm.loading &amp;&amp; vm.bu !== &quot;3D&quot;\" layout-fill class=parallax-container><div class=bgimg-1><div id=caption-1 class=caption><div layout=column layout-align=\"start start\" class=welcome-content><div translate=register.register.Landing_Welcome class=welcome></div><div translate=register.register.Landing_WelcomeTo class=welcome-message></div></div></div></div><div layout-fill layout=column layout-align=\"start center\" class=\"content-container counts\"><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg class=\"background-cloud cloud1\"></md-icon><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg class=\"background-cloud cloud2\"></md-icon><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg class=\"background-cloud cloud3\"></md-icon><a id=learn-printos href=http://www.hp.com/go/printos target=_blank analytics-on=click analytics-event=\"link - Learn more about PrintOS on HP.com\" analytics-category=signin class=learn-link><div layout=row layout-align=\"center center\" translate=register.register.SignIn_LearnAboutPrintOS class=\"content-title button\"></div></a><div layout=row layout-align=\"start center\" layout-wrap class=content><div flex layout=column layout-align=\"start center\" class=content-panel><div class=cloud-box><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg class=surround></md-icon><div layout=column layout-align=\"center center\" translate=register.register.Landing_HighlightK translate-values=[11] class=surround-text></div></div><div layout=column layout-align=\"start center\" translate=register.register.Landing_Category1 class=content-label></div><div class=separator></div><div layout=column layout-align=\"start center\" translate=register.register.Landing_Details1 class=content-details></div></div><div flex layout=column layout-align=\"start center\" class=content-panel><div class=cloud-box><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg class=surround></md-icon><div layout=column layout-align=\"center center\" translate=register.register.Landing_HighlightK translate-values=[26] class=surround-text></div></div><div layout=row layout-align=\"start center\" translate=register.register.Landing_Category2 class=content-label></div><div class=separator></div><div layout=column layout-align=\"start center\" translate=register.register.Landing_Details2 class=content-details></div></div><div flex layout=column layout-align=\"start center\" class=content-panel><div class=cloud-box><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg class=surround></md-icon><div layout=column layout-align=\"center center\" translate=register.register.Landing_HighlightK translate-values=[20] class=surround-text></div></div><div layout=row layout-align=\"start center\" translate=register.register.Landing_Category3 class=content-label></div><div class=separator></div><div layout=column layout-align=\"start center\" translate=register.register.Landing_Details3 class=content-details></div></div></div></div><div layout-fill layout=column layout-align=\"start center\" class=\"content-container pillars\"><div layout=row layout-align=\"center center\" translate=register.register.SignIn_WhatDoesPrintOSDo class=content-title></div><div layout=row layout-align=\"start center\" layout-wrap class=content><div flex layout=column layout-align=\"start center\" class=\"content-panel optimize\"><div class=pillar-box><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/Optimize.svg class=pillar></md-icon></div><div layout=column layout-align=\"start center\" translate=register.register.Pillar_Optimize class=pillar-label></div><div layout=column layout-align=\"start center\" translate=register.register.Pillar_Optimize_Highlight class=pillar-highlight></div><div layout=column layout-align=\"start center\" translate=register.register.Pillar_Optimize_Details class=pillar-details></div></div><div flex layout=column layout-align=\"start center\" class=\"content-panel automate\"><div class=pillar-box><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/Automate.svg class=pillar></md-icon></div><div layout=row layout-align=\"start center\" translate=register.register.Pillar_Automate class=pillar-label></div><div layout=row layout-align=\"start center\" translate=register.register.Pillar_Automate_Highlight class=pillar-highlight></div><div layout=column layout-align=\"start center\" translate=register.register.Pillar_Automate_Details class=pillar-details></div></div><div flex layout=column layout-align=\"start center\" class=\"content-panel grow\"><div class=pillar-box><md-icon md-svg-src=https://cdn.printos.com/images/signin/landing/Grow.svg class=pillar></md-icon></div><div layout=row layout-align=\"start center\" translate=register.register.Pillar_Grow class=pillar-label></div><div layout=row layout-align=\"start center\" translate=register.register.Pillar_Grow_Highlight class=pillar-highlight></div><div layout=column layout-align=\"start center\" translate=register.register.Pillar_Grow_Details class=pillar-details></div></div></div></div><div ng-if=vm.isAppUX layout-fill layout=column layout-align=\"start center\" class=\"content-container applications\"><div layout=row layout-align=\"center center\" translate=register.register.Landing_Applications class=content-title></div><div layout=row layout-align=\"center center\" layout-wrap class=bu-filters><div layout=row layout-align=\"center center\" ng-click=vm.selectBU() ng-class=\"{selected: !vm.bu}\" class=bu-button><div translate=register.register.BU_All class=bu></div></div><div layout=row layout-align=\"start center\" ng-click=vm.selectBU(&quot;Indigo&quot;) ng-class=\"{selected: vm.bu === &quot;Indigo&quot;}\" class=bu-button><div class=\"bu-indicator indigo\"></div><div translate=register.register.BU_Indigo class=bu></div></div><div layout=row layout-align=\"start center\" ng-click=vm.selectBU(&quot;LF&quot;) ng-class=\"{selected: vm.bu === &quot;LF&quot;}\" class=bu-button><div class=\"bu-indicator lf\"></div><div translate=register.register.BU_LF class=bu></div></div><div layout=row layout-align=\"start center\" ng-click=vm.selectBU(&quot;Scitex&quot;) ng-class=\"{selected: vm.bu === &quot;Scitex&quot;}\" class=bu-button><div class=\"bu-indicator scitex\"></div><div translate=register.register.BU_Scitex class=bu></div></div><div layout=row layout-align=\"start center\" ng-click=vm.selectBU(&quot;PWI&quot;) ng-class=\"{selected: vm.bu === &quot;PWI&quot;}\" class=bu-button><div class=\"bu-indicator pwi\"></div><div translate=register.register.BU_PWI class=bu></div></div></div></div><div ng-if=\"vm.isAppUX &amp;&amp; category.filteredAppCount &gt; 0\" ng-repeat=\"category in vm.categories\" layout-fill layout=column layout-align=\"start center\" class=\"content-container applications\"><div layout=row layout-align=\"start center\" class=\"app-section-header optimize\"><div flex class=app-hr></div><md-icon md-svg-src={{category.icon}} class=app-category-icon></md-icon><div translate={{category.displayKey}} class=app-category></div><div flex class=app-hr></div></div><div layout=column layout-align=\"start center\" class=\"accordion-container optimize\"><div class=accordion><div class=ac-table><div ng-repeat=\"app in category.apps\" ng-hide=!app.show ng-style=\"{ &quot;background-image&quot;: app.bgImage }\" ng-mouseleave=vm.closeApp(app) class=ac-item><div class=ac-panel><div class=ac-collapse><div class=label-container><div class=panel-label>{{ app.name }}</div></div></div><div layout=column class=ac-expand><div layout=row layout-align=\"start center\" class=app-identity><md-icon md-svg-src={{app.icon}} class=app-icon></md-icon><div layout=column layout-align=\"start start\"><div flex class=app-title>{{ app.name }}</div><div class=app-description>{{ app.desc }}</div></div></div><div flex ng-if=!app.content class=app-content></div><div flex ng-if=app.content class=app-content><gz-carousel id=landing-page options=app.content></gz-carousel></div><div layout=row class=app-footer><div ng-if=app.learn flex ng-click=vm.linkClicked(app) layout=row layout-align=\"start center\" class=app-learn><div translate=register.register.LearnMore class=app-link></div></div><div ng-if=!app.learnLink flex class=app-link-spacer></div><div ng-repeat=\"bu in app.businessUnits\" class=app-bu-container><div ng-if=\"bu === &quot;Indigo&quot;\" class=\"bu-indicator indigo\"><md-tooltip>{{ 'register.register.BU_Indigo' | translate }}</md-tooltip></div><div ng-if=\"bu === &quot;LF&quot;\" class=\"bu-indicator lf\"><md-tooltip>{{ 'register.register.BU_LF' | translate }}</md-tooltip></div><div ng-if=\"bu === &quot;Scitex&quot;\" class=\"bu-indicator scitex\"><md-tooltip>{{ 'register.register.BU_Scitex' | translate }}</md-tooltip></div><div ng-if=\"bu === &quot;PWI&quot;\" class=\"bu-indicator pwi\"><md-tooltip>{{ 'register.register.BU_PWI' | translate }}</md-tooltip></div></div></div></div></div></div></div></div></div></div><div layout=column layout-align=\"start center\" class=footer-container><div layout=row layout-align=\"center center\" layout-wrap class=footer><div translate=uxf.uxf.Copyright class=copyright-container></div><div flex layout=row layout-align=\"center center\" class=link-container><div layout=row class=link-wrapper><a id=privacy href=http://www.hp.com/go/privacy target=_blank analytics-on=click analytics-event=\"link - Privacy\" analytics-category=signin><div translate=uxf.uxf.Privacy gz-auto-tooltip class=link></div></a></div><div class=separator></div><div id=eula ng-click=vm.openTerms() translate=uxf.uxf.TermsOfUse analytics-on=click analytics-event=\"link - Terms of Service\" analytics-category=signin gz-auto-tooltip class=link></div><div class=separator></div><div ng-if=!vm.helpCenterEnabled layout=row class=link-wrapper><a id=support href={{vm.supportURL}} analytics-on=click analytics-event=\"link - Support\" analytics-category=signin><div translate=uxf.uxf.HelpCenter class=link></div></a></div></div><gz-locale-select ng-model=vm.signInData.locale ng-change=vm.localeChanged()></gz-locale-select><st-icp></st-icp></div></div></div><div ng-if=\"vm.bu !== &quot;3D&quot; &amp;&amp; vm.showScrollButton\" layout=column layout-align=\"center center\" ng-click=vm.scroll($event) class=scroll-button><div ng-if=vm.atTop class=arrow-down><md-tooltip>{{\"register.register.ScrollToBottom\" | translate}}</md-tooltip></div><div ng-if=!vm.atTop class=arrow-up><md-tooltip>{{\"register.register.ScrollToTop\" | translate}}</md-tooltip></div></div>";

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area lf-add\"><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div ng-if=!vm.loading translate=register.register.AddPrinter class=page-title></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><div ng-if=\"!vm.loading &amp;&amp; !vm.printerVerified\"><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.cancel() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><div ng-if=\"!vm.loading &amp;&amp; !vm.errorKey\"><img ng-src={{vm.device.internal.display.scaledImagePath}} class=device-image><div class=page-information><div class=table-layout><div class=row><span translate=register.register.Family class=label></span><span class=value>{{vm.device.internal.loc.type}}</span></div><div class=row><span translate=register.register.Model class=label></span><span class=value>{{vm.device.internal.loc.model}}</span></div><div class=row><span translate=register.register.SerialNumber class=label></span><span class=value>{{vm.device.serialNumber}}</span></div></div></div><div ng-if=\"!vm.loading &amp;&amp; !vm.success\" translate=register.register.AddPrinterDetails class=page-details></div><div layout=row layout-align=\"space-between center\" class=button-container><md-button id=btn-sign-in flex ng-click=vm.goSignIn() ng-disabled=!vm.printerVerified translate=register.register.SignIn translate-attr-aria-label=register.register.SignIn class=\"md-raised md-primary\"></md-button></div><div layout=row layout-align=\"space-between center\" class=button-container><md-button id=btn-sign-up flex ng-click=vm.goSignUp() ng-disabled=!vm.printerVerified translate=register.register.SignUp translate-attr-aria-label=register.register.SignUp class=\"secondary-button fill-width\"></md-button></div></div></div></div></div></div>";

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area password-expired-page\"><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div ng-if=!vm.loading translate=register.register.AddPrinter class=page-title></div><div ng-if=\"!vm.loading &amp;&amp; !vm.success\" translate=register.register.AddCodeDetails class=page-details></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><form ng-if=!vm.loading name=keyForm ng-submit=vm.submit()><gz-form-content submitting=vm.submitting><div layout=column class=\"form-container signin\"><md-input-container><label for=code translate=register.register.SecurityCode></label><input id=code type=text name=code ng-model=vm.code maxlength=20 required gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=keyForm.code.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container></div></gz-form-content><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-cancel flex ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel aria-label=cancel></md-button><div class=button-spacer></div><md-button id=btn-submit flex type=submit ng-disabled=\"keyForm.$invalid || vm.submitting\" translate=uxf.uxf.Dialog_Submit translate-attr-aria-label=uxf.uxf.Dialog_Submit gz-auto-tooltip class=\"md-raised md-primary\"></md-button></div></form></div></div></div></div>";

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = "<gz-spinner></gz-spinner>";

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog gz-responsive-dialog class=select-account><gz-dialog-title-bar gz-title=\"{{&quot;register.register.SelectAccount&quot; | translate}}\" cancel=vm.cancel></gz-dialog-title-bar><form name=selectForm ng-submit=vm.submit() novalidate layout=column><gz-error-bar error-key=vm.errorKey></gz-error-bar><div layout=column class=content-container><md-input-container><label for=account translate=register.register.Account></label><md-select id=account name=account placeholder=\"{{'register.register.Account' | translate}}\" ng-model=vm.selectedContext><md-option ng-value=context ng-repeat=\"context in vm.contexts\" ng-selected=\"vm.selectedContext.id === context.id\">{{context.name}}</md-option></md-select></md-input-container></div><gz-form-footer-bar submitting=vm.sending submit-title=register.register.SelectAccount show-legend=false cancel=vm.cancel></gz-form-footer-bar></form></md-dialog>";

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=\"start-container sign-in-page\"><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" class=\"start-container sign-in-page\"><div layout=column layout-align=\"start center\" layout-gt-sm=row layout-align-gt-sm=\"start center\" layout-wrap class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div><div ng-if=\"!vm.errorKey &amp;&amp; !vm.altUsernames\" layout=column layout-align=\"start center\" layout-gt-sm=row layout-align-gt-sm=\"start center\" layout-wrap class=button-bar><form name=vm.signinForm ng-submit=vm.signin()><button id=btn-signin type=submit ng-class=\"{ 'disabled' : vm.submitting }\" translate=register.register.SignIn autofocus ng-blur=vm.focusSignIn() class=\"button primary\"></button></form><button id=btn-oee-checkin type=button ng-if=vm.isTrustedStation ng-class=\"{ 'disabled' : vm.submitting }\" ng-click=vm.oeeCheckIn() href=/oee translate=register.register.SignInOEE class=\"button secondary secondary-button\"></button><button type=button ng-class=\"{ 'disabled' : vm.submitting }\" ng-click=vm.signUp() translate=register.register.SignUp class=\"button secondary\"></button></div></div><div flex layout=row layout-align=\"start start\" class=content-area><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div ng-if=\"vm.errorKey || vm.altUsernames\" class=panel-container><div layout=column class=panel-content><div translate=register.register.SignIn class=page-title></div><div ng-if=vm.messageKey translate={{vm.messageKey}} translate-values={{vm.messageParams}} class=page-details></div><div ng-if=vm.isUnsupportedBrowser translate=register.register.BrowserWarning class=\"request-container invalid\"></div><div ng-if=vm.errorKey class=error-container><div translate={{vm.errorKey}} translate-values={{vm.errorValues}} class=error-msg></div></div><div ng-if=vm.altUsernames class=error-container><div ng-if=\"vm.errorValues.length === 0\" translate=register.register.SignIn_Error_SignInWithAlternativeHPID_OneHP class=error-msg></div><div ng-if=\"vm.errorValues.length &gt; 0\" translate=register.register.SignIn_Error_SignInWithAlternativeHPID translate-values={{vm.errorValues}} class=error-msg></div><div layout=row layout-align=\"start start\" ng-repeat=\"altUsername in vm.altUsernames\" class=alt-usernames><div flex gz-auto-tooltip class=alt-username>{{altUsername}}</div><md-button type=button ng-disabled=vm.submitting ng-click=vm.signinAltUsername(altUsername) translate=register.register.SignIn aria-label=register.register.SignIn class=\"md-raised md-primary alt-sign-in-button\"></md-button></div></div><div layout=row layout-align=\"start center\" class=hpid-headline><span translate=register.register.SignIn_HPID_Headline ng-click=vm.hpidHelpClicked()></span></div><div ng-if=vm.hpidHelp class=hpid-help><div translate=register.register.SignIn_HPID_Description class=text></div></div><form name=vm.signinForm ng-submit=vm.signin()><gz-form-content submitting=vm.submitting></gz-form-content><div layout=column class=\"form-container signin\"><md-button id=btn-signin ng-class=\"{'md-primary md-raised' : !vm.altUsernames, 'secondary-button' : vm.altUsernames}\" type=submit ng-disabled=vm.submitting translate=register.register.SignIn autofocus></md-button><md-button id=btn-oee-checkin ng-if=vm.isTrustedStation type=button ng-disabled=vm.submitting ng-click=vm.oeeCheckIn() href=/oee translate=register.register.SignInOEE class=secondary-button></md-button><md-button id=btn-signup type=button ng-disabled=vm.submitting ng-click=vm.signUp() translate=register.register.SignUp class=\"secondary-button last-button\"></md-button></div></form></div></div></div></div>";

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area sign-up-page\"><landing-content bu=vm.bgBU flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div translate=register.register.SignUp class=page-title></div><div layout=row ng-if=\"!vm.success &amp;&amp; !vm.noCaptcha\" translate=register.register.SignUp_Message1 class=page-details></div><div layout=row ng-if=\"!vm.success &amp;&amp; !vm.noCaptcha\" translate=register.register.SignUp_Message2 class=admin-help></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><div ng-if=vm.success><div class=request-container><div ng-if=vm.canSelfInvite><div translate=register.register.SignUp_Invitation_Sent class=request-title></div><div translate=register.register.SignUp_Invitation_Sent_Message class=request-message></div></div><div ng-if=!vm.canSelfInvite><div translate=register.register.SignUp_Request_Sent class=request-title></div><div translate=register.register.SignUp_Request_Sent_Message class=request-message></div></div></div><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.cancel() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><div ng-if=vm.noCaptcha layout=row layout-align=\"space-between center\" class=\"form-action-container fill-width\"><md-button id=btn-cancel flex ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel aria-label=cancel></md-button><div class=button-spacer></div><md-button id=btn-email-support flex type=button ng-disabled=vm.submitting translate=register.register.Support_Email_Support href=mailto:printos.cc@hp.com analytics-on=click analytics-event=\"email support - No Captcha\" analytics-category=signin class=\"md-raised md-primary\"></md-button></div><form ng-if=\"!vm.success &amp;&amp; !vm.noCaptcha\" name=vm.signupForm ng-submit=vm.executeRecaptcha()><gz-form-content submitting=vm.submitting><div layout=column class=\"form-container signup\"><div ng-if=\"!vm.inputDevice &amp;&amp; vm.bu !== &quot;3D&quot;\" class=section-container><div translate=register.register.SignUp_My_Device class=section-title></div><md-input-container><label for=type translate=devices.devices.Device_Type></label><md-select id=sel-device-type name=type ng-change=vm.typeChanged(vm.device.type) ng-model=vm.device.type ng-disabled=vm.activationDetails required><md-option ng-value=deviceType.name ng-repeat=\"deviceType in vm.deviceTypesAndModels\" ng-selected=\"vm.device.type == deviceType.name\" translate={{deviceType.nameKey}}></md-option></md-select></md-input-container></div><div ng-if=\"!vm.inputDevice &amp;&amp; vm.device.type\" class=section-container><div ng-if=vm.showPrinterInfo><md-input-container><label for=model translate=devices.devices.Device_Model></label><md-select id=sel-device-model name=model ng-model=vm.device.model required ng-change=vm.modelChanged() ng-disabled=\"vm.deviceModels.length == 0 || vm.activationDetails\"><md-option ng-value=deviceModel.modelName ng-repeat=\"deviceModel in vm.deviceModels | rnLocaleOrderBy:&quot;localizedName&quot;\" ng-selected=\"vm.device.model == deviceModel.modelName\" translate={{deviceModel.modelNameKey}}></md-option></md-select></md-input-container><md-input-container><label for=serialNumber translate=devices.devices.Device_Serial_Number_Caption></label><input id=in-serial-number name=serialNumber type=text ng-model=vm.device.serialNumber required md-maxlength=100 gz-regex-validator=Validator.AAA.SerialNumber ng-disabled=vm.activationDetails><div ng-messages=vm.signupForm.serialNumber.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container ng-if=vm.showScitexId flex><label for=scitexId ng-show=vm.showScitexId translate=register.register.SignUp_Device_ScitexId></label><input id=in-scitex-id name=scitexId type=text ng-model=vm.device.scitexId md-maxlength=32 ng-show=vm.showScitexId required gz-regex-validator=Validator.AAA.SerialNumber><md-icon md-svg-src=https://cdn.printos.com/images/general/material/help.svg ng-click=vm.scitexIdHelpClicked() class=help-icon></md-icon></md-input-container><div ng-if=vm.showScitexIdHelp class=help-text><div translate=register.register.Device_ScitexId_Intro class=help-title></div><div translate=register.register.Device_ScitexId_Step1 class=help-item></div><div translate=register.register.Device_ScitexId_Step2 class=help-item></div><div translate=register.register.Device_ScitexId_Signup class=help-section></div></div></div><div ng-if=vm.showPressInfo><md-input-container><label for=model translate=devices.devices.Device_Models></label><md-select id=sel-device-model name=model ng-model=vm.models multiple=multiple required><md-option ng-value=deviceModel.modelName ng-repeat=\"deviceModel in vm.deviceModels | rnLocaleOrderBy:&quot;localizedName&quot;\">{{deviceModel.modelNameKey | translate}}</md-option></md-select></md-input-container><md-input-container><label for=serialNumber translate=register.register.SignUp_Press_Serial_Number></label><input id=in-serial-number name=serialNumber type=text ng-model=vm.device.serialNumber required md-maxlength=100 gz-regex-validator=Validator.AAA.DescriptionUnicode><div ng-messages=vm.signupForm.serialNumber.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container></div></div><div class=section-container><div translate=register.register.SignUp_My_Information class=section-title></div><md-input-container><label for=email translate=register.register.Support_Email></label><input id=email type=text name=email autocomplete=new-password ng-model=vm.request.email maxlength=100 required gz-regex-validator=Validator.Email><div ng-messages=signupForm.email.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Email</translate></div></div></md-input-container><md-input-container><label for=firstName translate=register.register.Support_FirstName></label><input id=firstName type=text name=firstName autocomplete=new-password ng-model=vm.request.firstName maxlength=100 required gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=signupForm.firstName.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label for=lastName translate=register.register.Support_LastName></label><input id=lastName type=text name=lastName autocomplete=new-password ng-model=vm.request.lastName maxlength=100 required gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=signupForm.lastName.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><div ng-if=vm.showAllInfo><md-input-container><label for=title translate=register.register.SignUp_Title></label><md-select id=title name=title ng-model=vm.userTitle required><md-option ng-value=title.key ng-repeat=\"title in vm.titles\">{{title.value}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.userTitle==&quot;Other&quot;\"><label for=otherTitle translate=register.register.SignUp_Other_Title></label><input id=title type=text name=otherTitle autocomplete=new-password ng-model=vm.otherTitle md-maxlength=100 required gz-regex-validator=Validator.AAA.DescriptionUnicode><div ng-messages=vm.signupForm.otherTitle.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label for=company translate=register.register.SignUp_Company></label><input id=company type=text name=company autocomplete=new-password ng-model=vm.company maxlength=100 required gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=signupForm.company.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label translate=register.register.SignUp_Country></label><md-select id=country name=country ng-model=vm.address.country required ng-change=vm.countryChanged()><md-option ng-value=country.isoCode ng-repeat=\"country in vm.countries | orderBy:&quot;+localizedName&quot;\">{{country.localizedName}}</md-option></md-select></md-input-container><md-input-container><label for=state translate=uxf.uxf.Region></label><input id=in-state required name=state type=text ng-model=vm.address.region md-maxlength=vm.validators.region.maxlength gz-regex-validator={{vm.validators.region.validator}}><div ng-messages=signupForm.state.$error><div ng-message=required><translate>uxf.uxf.Validation_Required</translate></div><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label for=city translate=uxf.uxf.Locality></label><input id=in-city required name=city type=text ng-model=vm.address.locality maxlength=100 gz-regex-validator=Validator.AAA.DescriptionUnicode><div ng-messages=vm.signupForm.city.$error><div ng-message=required><translate>uxf.uxf.Validation_Required</translate></div><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label for=postalCode translate=uxf.uxf.PostalCode></label><input id=in-postalcode required name=postalCode type=text ng-model=vm.address.postalCode maxlength=vm.validators.postalCode.maxlength gz-regex-validator={{vm.validators.postalCode.validator}}><div ng-messages=vm.signupForm.postalCode.$error><div ng-message=required><translate>uxf.uxf.Validation_Required</translate></div><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container class=max-width><label for=phone translate=register.register.SignUp_Phone_Number></label><input id=phone required type=text name=phone ng-model=vm.primaryPhone maxlength=100 gz-regex-validator=Validator.AAA.Phone><div ng-messages=vm.signupForm.phone.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container></div><div ng-if=vm.captchaSiteID layout=row layout-align=\"center center\" class=captcha-container><div id=recaptchaSignUp data-sitekey={{vm.captchaSiteID}} ng-init=vm.renderRecaptcha() data-size=invisible data-badge=inline required class=g-recaptcha></div><div ng-if=vm.recaptchaInvalid ng-messages=contactsupport.recaptchaBox.$error>{{vm.recaptchaBoxMessage}}</div></div></div></div></gz-form-content><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-cancel flex ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel aria-label=cancel></md-button><div class=button-spacer></div><md-button id=btn-submit flex type=submit ng-disabled=vm.disableSubmit() translate=uxf.uxf.Dialog_Submit translate-attr-aria-label=uxf.uxf.Dialog_Submit gz-auto-tooltip class=\"md-raised md-primary\"></md-button></div></form></div></div></div></div>";

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area support-page\"><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div ng-if=\"!vm.loading &amp;&amp; !vm.success\" translate=register.register.Support class=page-title></div><div ng-if=\"!vm.loading &amp;&amp; !vm.success\" layout=row layout-align=\"start center\" class=login-help><md-icon md-svg-src=https://cdn.printos.com/images/general/material/help.svg ng-click=vm.signInHelpClicked() class=help-icon></md-icon><span translate=register.register.SignIn_HPID_Trouble_Signing_In></span><span translate=register.register.SignIn_Click_Here ng-click=vm.signInHelpClicked() class=click-here></span></div><div ng-if=\"!vm.loading &amp;&amp; !vm.success &amp;&amp; vm.signInHelp\" layout=column class=hpid-details><div translate=register.register.SignIn_HPID_Having_Trouble_Help class=text></div><form name=vm.signinForm ng-submit=vm.signin()><gz-form-content submitting=vm.submitting></gz-form-content><div layout=column class=\"form-container signin\"><md-button id=btn-signin type=submit ng-disabled=vm.submitting translate=register.register.SignIn aria-label=register.register.SignIn class=\"md-raised md-primary\"></md-button></div></form></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><div ng-if=\"!vm.loading &amp;&amp; vm.isUnsupportedBrowser\" translate=register.register.BrowserWarning class=\"request-container invalid\"></div><div ng-if=\"!vm.loading &amp;&amp; vm.success\" layout=column><div class=request-container><div translate=register.register.SignIn_RequestSent class=request-title></div><div translate=register.register.Support_SentMessage class=request-message></div></div><div layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-got-it flex ng-click=vm.cancel() translate=register.register.SignIn_GotIt translate-attr-aria-label=register.register.SignIn_GotIt class=\"md-raised md-primary\"></md-button></div></div><div ng-if=vm.noCaptcha layout=row layout-align=\"space-between center\" class=\"form-action-container fill-width\"><md-button id=btn-cancel flex ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel aria-label=cancel></md-button><div class=button-spacer></div><md-button id=btn-email-support flex type=button ng-disabled=vm.submitting translate=register.register.Support_Email_Support href=mailto:printos.cc@hp.com analytics-on=click analytics-event=\"email support - No Captcha\" analytics-category=signin class=\"md-raised md-primary fill-width\"></md-button></div><form ng-if=\"!vm.loading &amp;&amp; !vm.success &amp;&amp; !vm.noCaptcha\" name=supportForm ng-submit=vm.executeRecaptcha()><gz-form-content submitting=vm.submitting><div layout=column class=\"form-container signin\"><md-input-container><label for=email translate=register.register.Support_Email></label><input id=email type=text name=email autocomplete=new-password ng-model=vm.request.email md-maxlength=100 required gz-regex-validator=Validator.Email><div ng-messages=supportForm.email.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Email</translate></div></div></md-input-container><md-input-container><label for=firstName translate=register.register.Support_FirstName></label><input id=firstName type=text name=firstName autocomplete=new-password ng-model=vm.request.firstName md-maxlength=200 required gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=supportForm.firstName.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label for=lastName translate=register.register.Support_LastName></label><input id=lastName type=text name=lastName autocomplete=new-password ng-model=vm.request.lastName md-maxlength=200 required gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=supportForm.lastName.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label translate=register.register.SignUp_Country></label><md-select id=country name=country ng-model=vm.request.country required ng-change=vm.countryChanged()><md-option ng-value=country.isoCode ng-repeat=\"country in vm.countries | orderBy:&quot;+localizedName&quot;\">{{country.localizedName}}</md-option></md-select><md-icon md-svg-src=https://cdn.printos.com/images/general/material/help.svg ng-click=vm.countryHelpClicked() class=help-icon></md-icon></md-input-container><div ng-if=vm.countryHelp class=help><div translate=register.register.Support_Country_Help class=text></div></div><md-input-container><label for=accountName translate=register.register.Support_AccountName></label><input id=accountName type=text name=accountName autocomplete=new-password md-maxlength=200 ng-model=vm.request.accountName gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=supportForm.accountName.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label for=subject translate=register.register.Support_Subject></label><input id=subject type=text name=subject autocomplete=new-password ng-model=vm.request.subject md-maxlength=100 required gz-regex-validator=Validator.AAA.NameUnicode><div ng-messages=supportForm.subject.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><md-input-container><label for=message translate=register.register.Support_Body></label><textarea id=message name=message ng-model=vm.request.message property-name=message required text-area-auto-size md-autogrow reference-to=message add-more-height=20 md-maxlength=30000 class=message></textarea><div ng-messages=supportForm.message.$error><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div></div></md-input-container><div ng-if=vm.request.captchaId layout=row layout-align=\"center center\" class=captcha-container><div id=recaptchaSupport data-sitekey={{vm.request.captchaId}} ng-init=vm.renderRecaptcha() data-size=invisible data-badge=inline required class=g-recaptcha></div></div><div translate=register.register.Support_Message class=\"help text\"></div></div></gz-form-content><div ng-if=!vm.loading layout=row layout-align=\"space-between center\" class=form-action-container><md-button id=btn-cancel flex ng-click=vm.cancel() translate=uxf.uxf.Dialog_Cancel aria-label=cancel></md-button><div class=button-spacer></div><md-button id=btn-submit flex type=submit ng-disabled=\"supportForm.$invalid || vm.submitting\" translate=register.register.SignIn_SendRequest translate-attr-aria-label=register.register.SignIn_SendRequest class=\"md-raised md-primary\"></md-button></div></form></div></div><div ng-if=vm.helpCenterEnabled layout=column layout-align=\"center center\" class=help-center-container><div ng-class=\"{'expanded' : vm.expanded}\" layout=column layout-align=\"start center\" class=help-center><div layout=row layout-align=\"start start\" class=title-bar><div flex layout=row layout-align=\"start center\" layout-wrap class=wrap-container><div flex layout=row layout-align=\"start center\"><i aria-hidden=true class=\"fa fa-life-ring\"></i><span translate=uxf.uxf.SupportArticles class=md-title></span></div><gz-filter-box search-text=vm.inputText changed-callback=vm.searchInsideTutorials placeholder=\"{{ &quot;uxf.uxf.Search&quot; | translate}}\" class=search-box></gz-filter-box></div><div class=expand-container><i aria-hidden=true ng-if=\"!vm.expanded &amp;&amp; vm.hasArticles()\" ng-click=vm.seeAllArticles() ng-href=\"#/support?fromState=signin&amp;expanded=true\" class=\"fa fa-expand\"></i><i aria-hidden=true ng-if=\"vm.expanded &amp;&amp; vm.hasArticles()\" ng-click=vm.seeSlicedArticles() ng-href=\"#/support?fromState=signin&amp;expanded=false\" class=\"fa fa-compress\"></i></div></div><md-list flex class=list><md-list-item ng-repeat=\"article in vm.articles\"><md-button ng-href=\"{{ article.content }}\" target=_blank gz-auto-tooltip ng-click=vm.clickOnArticle(article.analyticsTitle) class=article>{{ article.title }}</md-button><md-divider ng-if=!$last></md-divider></md-list-item></md-list><div ng-if=!vm.hasArticles() translate=uxf.uxf.List_NoItems class=gz-empty-list-msg></div><div ng-if=vm.hasArticles() class=see-all><a translate=uxf.uxf.SeeAllArticles ng-click=vm.seeAllArticles() ng-href=\"#/support?fromState=signin&amp;expanded=true\" ng-if=!vm.expanded></a></div></div></div></div></div>";

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=vm.loading layout-fill layout=column layout-align=\"center center\" class=start-container><gz-spinner ng-if=vm.loading></gz-spinner></div><div ng-if=!vm.loading layout-fill layout=column layout-align=\"start center\" layout-wrap class=start-container><div layout=row layout-align=\"start center\" class=header><div layout=row layout-align=\"start center\" class=logo-container><md-icon md-svg-src=register/images/hp.svg class=hp-logo></md-icon><div flex translate=uxf.uxf.Site_title class=printos-label></div></div></div><div flex layout=row layout-align=\"start start\" class=\"content-area unsubscribe-container\"><landing-content bu=vm.bu flex locale=vm.locale></landing-content><div class=panel-container><div layout=column class=panel-content><div ng-if=!vm.unsubscribed translate=register.register.Unsubscribe class=page-title></div><div ng-if=vm.unsubscribed translate=register.register.UnsubscribeSucces class=page-title></div><gz-error-bar error-key=vm.errorKey></gz-error-bar><form ng-if=!vm.unsubscribed name=vm.signinForm ng-submit=vm.unsubscribe()><gz-form-content submitting=vm.submitting><div layout=column layout-padding class=subscription-data><div layout=row><div translate=register.register.Category class=label></div><div class=data>{{vm.subscription.categoryDisplay}}</div></div></div><div translate=register.register.ConfirmDesc class=unsubscribe-desc></div></gz-form-content><div layout=row layout-align=\"space-between center\" class=\"form-action-container fill-width\"><md-button id=btn-signin type=submit ng-disabled=\"vm.submitting || !(vm.subscription.userId &amp;&amp; vm.subscription.category)\" translate=register.register.Confirm aria-label=register.register.Confirm class=\"md-raised md-primary fill-width\"></md-button></div></form><form ng-if=vm.unsubscribed name=vm.signinForm ng-submit=vm.goToSignIn($event)><gz-form-content submitting=vm.submitting><div ng-if=vm.unsubscribed layout=column layout-padding class=\"subscription-data success\"><div layout=row><div translate=register.register.UnsubscribeSuccess class=data></div></div></div></gz-form-content><div layout=row layout-align=\"space-between center\" class=\"form-action-container fill-width\"><md-button id=btn-signin type=submit ng-disabled=vm.submitting translate=register.register.GotIt aria-label=register.register.GotIt class=\"md-raised md-primary fill-width\"></md-button></div></form><div layout=row layout-align=\"space-between center\" class=\"form-action-container fill-width\"><md-button id=btn-signin type=button ng-click=vm.goToEmailSettings($event) ng-disabled=vm.submitting translate=register.register.SubscriptionSettings aria-label=register.register.SubscriptionSettings class=\"md-raised fill-width\"></md-button></div></div></div></div></div>";

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 432 432\"><title>Administration-hp-icon</title><path d=M432,540c-2.15,0-4.29,0-6.42-.1l44.14-121.32h60.75c10.66,0,22.37-8.2,26-18.21l47.89-131.55c7.83-21.54-4.5-39.16-27.42-39.16H492.69L422,424h0L381.86,534.17C286.76,511.56,216,426.06,216,324c0-99.09,66.72-182.58,157.68-208L332.33,229.7h0L263.55,418.62h45.78l58.48-160.53h34.4L343.73,418.62h45.76L444,268.86c7.84-21.54-4.5-39.16-27.39-39.16H378.12L422.3,108.26c3.22-.14,6.45-0.23,9.71-0.23,119.29,0,216,96.71,216,216S551.31,540,432,540ZM562.7,258H528.31L480.14,390.13h34.4Z transform=\"translate(-216.01 -108.03)\"/></svg> ";

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100\" xml:space=preserve> <style type=text/css></style> <g> <path class=st0 d=\"M68,69.1l0-5.4l-3.6-0.9c-0.3-1.2-0.8-2.4-1.4-3.5l1.9-3.2l-3.8-3.9l-3.2,1.9c-1.1-0.6-2.2-1.1-3.5-1.5\n\t\tl-0.9-3.6L48,49l-0.9,3.6c-1.2,0.3-2.4,0.8-3.5,1.4l-3.2-1.9L36.6,56l1.9,3.2c-0.6,1.1-1.1,2.2-1.5,3.5l-3.6,0.9l0,5.5l3.6,0.9\n\t\tc0.3,1.2,0.8,2.4,1.4,3.5l-1.9,3.2l3.8,3.9l3.2-1.9c1.1,0.6,2.2,1.1,3.5,1.5l0.9,3.6l5.5,0l0.9-3.6c1.2-0.3,2.4-0.8,3.5-1.4\n\t\tl3.2,1.9l3.9-3.8l-1.9-3.2c0.6-1.1,1.1-2.2,1.5-3.5L68,69.1z M50.7,76c-5.3,0-9.7-4.4-9.6-9.7c0-5.3,4.4-9.7,9.7-9.6\n\t\tc5.3,0,9.7,4.4,9.6,9.7C60.4,71.7,56,76,50.7,76z\"/> <path id=XMLID_3_ class=st0 d=\"M70.1,56c3.4,6.6,3.4,14.8-0.8,21.5c-4,6.5-11,10.4-18.7,10.4c-4,0-8-1.1-11.4-3.2\n\t\tC28.9,78.4,25.7,64.9,32,54.6c4-6.5,11-10.4,18.7-10.4c2.8,0,5.6,0.6,8.2,1.6l-0.3,0.6l-0.9,1.5c-0.8,1.2-0.3,2.3,1.1,2.3l11.4,0.4\n\t\tc1.3,0.1,1.9-0.9,1.2-2l-5.6-9.9c-0.7-1.2-1.8-1.1-2.6,0.1l-1,1.7l-0.3,0.5c-3.6-1.6-7.4-2.4-11.2-2.4c-9.3,0-18.3,4.7-23.5,13.1\n\t\tc-8,13-3.9,29.9,9,37.9c4.5,2.8,9.5,4.1,14.4,4.1c9.3,0,18.3-4.7,23.5-13.1c4.7-7.6,5.2-16.6,2.2-24.3L70.1,56z\"/> <path id=XMLID_2_ class=st0 d=\"M92.3,38.4L92.3,38.4L92.3,38.4c-1.1-0.5-2.2-0.7-3.3-0.9c-1.2-5.9-5.2-11.2-11.2-13.8\n\t\tc-2.5-1.1-5.1-1.6-7.6-1.6c-1.9,0-3.7,0.3-5.5,0.8C62.6,16.7,58,11.4,51.5,8.5c-3.1-1.3-6.3-2-9.5-2C32.8,6.6,24,12,20.1,21\n\t\tc-0.6,1.3-1,2.6-1.3,3.9c-0.1,0-0.1,0-0.2,0c-6.9,0-13.5,4-16.5,10.8c-1,2.3-1.5,4.7-1.5,7.1c0,6.9,4,13.5,10.8,16.5\n\t\tc2.2,1,4.6,1.4,6.9,1.5l0,0h0.2c0.3-1.6,0.7-3.1,1.1-4.6h-1c0,0-0.1,0-0.1,0h0c-1.8,0-3.5-0.3-5.3-1.1c-5-2.2-8-7.1-8-12.2\n\t\tc0-1.8,0.4-3.6,1.1-5.3c2.2-5,7.1-8,12.2-8c0.6,0,1.2,0,1.8,0.1l2.3,0.3l0.3-2.3c0.2-1.7,0.7-3.3,1.4-4.8\n\t\tc3.1-7.3,10.2-11.6,17.7-11.6c2.6,0,5.1,0.5,7.7,1.6c5.9,2.6,9.9,7.8,11.2,13.6l0.6,2.8L64,28c1.9-0.9,4-1.3,6.1-1.3\n\t\tc1.9,0,3.9,0.4,5.8,1.2c5.1,2.2,8.3,6.9,8.8,12.1l0.2,2.3l2.3-0.2c0.2,0,0.4,0,0.6,0c0.9,0,1.8,0.2,2.7,0.5\n\t\tc2.6,1.1,4.2,3.7,4.2,6.4c0,0.9-0.2,1.8-0.6,2.8c-1,2.4-3.3,4.1-5.6,4.4l-7,0c0.5,1.5,0.9,3.1,1.2,4.6h6l0.1,0\n\t\tc4.2-0.4,7.8-3.2,9.5-7.1c0.6-1.5,1-3.1,1-4.6C99.3,44.5,96.7,40.3,92.3,38.4z\"/> </g> </svg> ";

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// Create a single module that includes all modules in this library by
	// creating a new require context (see http://webpack.github.io/docs/context.html)
	// for finding all module files and then requiring them as dependencies
	// to the all-encompassing module.
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var requiresModule = __webpack_require__(82);
	
	var moduleNames = [];
	
	var moduleFiles = requiresModule.keys();
	_.remove(moduleFiles, function (key) {
	  return _.startsWith(key, './extensions');
	});
	
	moduleFiles.forEach(function (moduleFile) {
	  moduleNames.push(requiresModule(moduleFile));
	});
	
	exports['default'] = angular.module('gazelle', moduleNames).name;
	module.exports = exports['default'];

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _gazelleSrcComponentsOuterContainerOuterContainerModule = __webpack_require__(57);
	
	var _gazelleSrcComponentsOuterContainerOuterContainerModule2 = _interopRequireDefault(_gazelleSrcComponentsOuterContainerOuterContainerModule);
	
	var _gazelleSrcComponentsAppNavAppNavModule = __webpack_require__(47);
	
	var _gazelleSrcComponentsAppNavAppNavModule2 = _interopRequireDefault(_gazelleSrcComponentsAppNavAppNavModule);
	
	var _gazelleSrcComponentsViewContainerViewContainerModule = __webpack_require__(63);
	
	var _gazelleSrcComponentsViewContainerViewContainerModule2 = _interopRequireDefault(_gazelleSrcComponentsViewContainerViewContainerModule);
	
	var _gazelleSrcComponentsBodyWrapBodyWrapModule = __webpack_require__(48);
	
	var _gazelleSrcComponentsBodyWrapBodyWrapModule2 = _interopRequireDefault(_gazelleSrcComponentsBodyWrapBodyWrapModule);
	
	exports['default'] = angular.module('gazelle.bundles.frames', [_gazelleSrcComponentsOuterContainerOuterContainerModule2['default'], _gazelleSrcComponentsAppNavAppNavModule2['default'], _gazelleSrcComponentsViewContainerViewContainerModule2['default'], _gazelleSrcComponentsBodyWrapBodyWrapModule2['default']]).name;
	module.exports = exports['default'];

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = angular.module('gazelle.bundles.users', [
	  // gzUserPanel,
	]).name;
	module.exports = exports['default'];

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _gazelleSrcComponentsIconIconModule = __webpack_require__(56);
	
	var _gazelleSrcComponentsIconIconModule2 = _interopRequireDefault(_gazelleSrcComponentsIconIconModule);
	
	var _gazelleSrcComponentsSpinnerSpinnerModule = __webpack_require__(44);
	
	var _gazelleSrcComponentsSpinnerSpinnerModule2 = _interopRequireDefault(_gazelleSrcComponentsSpinnerSpinnerModule);
	
	var _gazelleSrcComponentsPageHeaderPageHeaderModule = __webpack_require__(58);
	
	var _gazelleSrcComponentsPageHeaderPageHeaderModule2 = _interopRequireDefault(_gazelleSrcComponentsPageHeaderPageHeaderModule);
	
	exports['default'] = angular.module('gazelle.bundles.widgets', [_gazelleSrcComponentsIconIconModule2['default'], _gazelleSrcComponentsSpinnerSpinnerModule2['default'], _gazelleSrcComponentsPageHeaderPageHeaderModule2['default']]).name;
	module.exports = exports['default'];

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	'use strict';
	
	AlertDialogController.$inject = ["$mdDialog"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AlertDialogController;
	var name = 'AlertDialogController';
	
	exports.name = name;
	
	function AlertDialogController($mdDialog) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var vm = this;
	  vm.close = close;
	  vm.reject = cancel;
	
	  return;
	
	  function close() {
	    $mdDialog.hide();
	  }
	
	  function cancel() {
	    $mdDialog.cancel();
	  }
	}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _alertDialogService = __webpack_require__(284);
	
	var gzAlertDialog = _interopRequireWildcard(_alertDialogService);
	
	var _alertDialogController = __webpack_require__(282);
	
	var gzAlerController = _interopRequireWildcard(_alertDialogController);
	
	exports['default'] = angular.module('gz.alertDialog', ['ngMaterial']).service(gzAlertDialog.name, gzAlertDialog['default']).controller(gzAlerController.name, gzAlerController['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	$gzAlertDialog.$inject = ["$mdDialog"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzAlertDialog;
	var name = '$gzAlertDialog';
	
	exports.name = name;
	
	function $gzAlertDialog($mdDialog) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var service = {
	    show: show
	  };
	
	  return service;
	
	  /////////////////
	
	  function show(options) {
	    return $mdDialog.show({
	      template: __webpack_require__(221),
	      escapeToClose: false,
	      controller: 'AlertDialogController',
	      bindToController: true,
	      controllerAs: 'vm',
	      locals: options
	    });
	  }
	}
	
	//$gzAlertDialog

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _appBrokerService = __webpack_require__(286);
	
	var gzAppBroker = _interopRequireWildcard(_appBrokerService);
	
	exports['default'] = angular.module('gazelle.components.appBroker', ['ngMaterial']).service(gzAppBroker.name, gzAppBroker['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	$gzAppBroker.$inject = ["$log", "$mdSidenav", "$rootScope"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzAppBroker;
	
	var _gazelleSrcComponentsViewContainerViewContainerDirective = __webpack_require__(62);
	
	var name = '$gzAppBroker';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name gazelle.components.appBroker.service:$gzAppBroker
	 *
	 * @description
	 * The $gzAppBroker service keeps track of which applications are loaded in the client browser and provides an interface for other registered applications
	 * to request that a specific application be shown, hidden, or get access to its public interface.
	 *
	 * The $gzAppBroker is primarily used by applications to request a mini-app show/hide itself or otherwise send messages to said mini-app.
	 *
	 * Applications should register themselves during their (AngularJS)run phase using $gzAppBroker.register('my-app-id', appInterface).
	 *
	 * An application that needs to send message to another application should use $gzAppBroker.interface('other-app-id') to retrieve the other applications
	 * public interface.
	 *
	 * To cause an application to shown or hidden use the $gzAppBroker.show('other-app-id', [onShowParam]) and $gzAppBroker.hide('other-app-id').
	 *
	 * Before showing (opening) an app, if the app has a registered load function, the app's load function will be called.
	 *
	 * After showing (opening) an app, if the app has a registered onShow function, the app's onShow function will be called with the optional onShowParam.
	 *
	 * @usage
	 * ```js
	 * // In 'my-apps' module.run method:
	 * $gzAppBroker.register('my-app-id', {load: loadFunction, onShow: onShowFunction});
	 * ```
	 */
	
	function $gzAppBroker($log, $mdSidenav, $rootScope) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var vm = this;
	  vm.apps = {};
	
	  var service = {
	    register: register,
	    load: load,
	    hasBeenLoaded: hasBeenLoaded,
	    show: show,
	    hide: hide,
	    toggle: toggle,
	    isShown: isShown,
	    appInterface: appInterface
	  };
	
	  return service;
	
	  //
	  // Public functions
	  //
	
	  /**
	   * @ngdoc function
	   * @name register
	   * @methodOf gazelle.components.appBroker.service:$gzAppBroker
	   * @description Registers an app
	   * @param {string} appId - The ID of the app
	   * @param {Object} appInterface - A JSON object that contains the app's public interfaces (i.e. "{load: myLoadFunction}")
	   */
	  function register(appId, appInterface) {
	    $log.debug('gzAppBroker register called for appId = ' + appId);
	    vm.apps[appId] = {};
	    vm.apps[appId].appId = appId;
	    vm.apps[appId].hasBeenLoaded = false;
	    vm.apps[appId].appInterfaces = appInterface;
	  } //register
	
	  /**
	   * @ngdoc function
	   * @name load
	   * @methodOf gazelle.components.appBroker.service:$gzAppBroker
	   * @description Loads an app. Results in the app's "load" function to be called (if one exists).
	   * @param {string} appId - The ID of the app
	   */
	  function load(appId) {
	    $log.debug('gzAppBroker load called for appId = ' + appId);
	    if (appId in vm.apps && vm.apps[appId].appInterfaces && vm.apps[appId].appInterfaces.load) {
	      vm.apps[appId].appInterfaces.load();
	
	      // TODO: Should we require the app's load function to return a promise and also return the promise here?
	
	      vm.apps[appId].hasBeenLoaded = true;
	    } else if (appId in vm.apps) {
	      vm.apps[appId].hasBeenLoaded = false;
	    }
	  } //load
	
	  /**
	   * @ngdoc function
	   * @name hasBeenLoaded
	   * @methodOf gazelle.components.appBroker.service:$gzAppBroker
	   * @description Determine if an app has been loaded yet
	   * @param {string} appId - The ID of the app
	   * @returns {boolean} a flag indicating if the app has been loaded
	   */
	  function hasBeenLoaded(appId) {
	    return appId in vm.apps && vm.apps[appId].hasBeenLoaded;
	  } //hasBeenLoaded
	
	  /**
	   * @ngdoc function
	   * @name show
	   * @methodOf gazelle.components.appBroker.service:$gzAppBroker
	   * @description Causes an app to be shown (opened)
	   * @param {string} appId - The ID of the app
	   * @param {Object} [onShowParam] - An optional param that will be passed to the onShow function, if registered
	   */
	  function show(appId, onShowParam) {
	    var openAppId = _getOpenApp();
	    if (openAppId) {
	      return hide(openAppId).then(function () {
	        return _openApp(appId, onShowParam);
	      });
	    } else {
	      return _openApp(appId, onShowParam);
	    }
	  } //show
	
	  /**
	   * @ngdoc function
	   * @name hide
	   * @methodOf gazelle.components.appBroker.service:$gzAppBroker
	   * @description Causes an app to be hidden (closed)
	   * @param {string} appId - The ID of the app
	   */
	  function hide(appId) {
	    //$log.debug('gzAppBroker hide called for appId = ' + appId);
	    var wasLockedOpen = $mdSidenav(appId).isLockedOpen();
	
	    return $mdSidenav(appId).close().then(function () {
	      //$log.debug('gzAppBroker hide finished = ' + appId);
	      if (wasLockedOpen) {
	        $rootScope.$emit(_gazelleSrcComponentsViewContainerViewContainerDirective.VIEW_WIDTH_CHANGED_EVENT, {
	          source: name,
	          expanded: false
	        });
	      }
	    });
	  } //hide
	
	  /**
	   * @ngdoc function
	   * @name toggle
	   * @methodOf gazelle.components.appBroker.service:$gzAppBroker
	   * @description Causes an app to be toggled. Open if currently closed; close if currently open.
	   * @param {string} appId - The ID of the app
	   * @param {Object} [onShowParam] - An optional param that will be passed to the onShow function, if registered
	   */
	  function toggle(appId, onShowParam) {
	    //$log.debug('gzAppBroker toggle called for appId = ' + appId);
	    if ($mdSidenav(appId).isOpen()) {
	      return hide(appId);
	    } else {
	      return show(appId, onShowParam);
	    }
	  } //toggle
	
	  /**
	   * @ngdoc function
	   * @name isShown
	   * @methodOf gazelle.components.appBroker.service:$gzAppBroker
	   * @description Determine if an app is currently being shown
	   * @param {string} appId - The ID of the app
	   * @returns {boolean} a flag indicating if the app is currently being shown
	   */
	  function isShown(appId) {
	    //$log.debug('gzAppBroker isShown ', appId, $mdSidenav(appId).isOpen(), transitionState);
	    return vm.apps[appId] && $mdSidenav(appId).isOpen();
	  } //isShown
	
	  /**
	   * @ngdoc function
	   * @name appInterface
	   * @methodOf gazelle.components.appBroker.service:$gzAppBroker
	   * @description Retrieve the public interfaces for the app
	   * @param {string} appId - The ID of the app
	   * @returns {Object} the public interfaces for the app
	   */
	  function appInterface(appId) {
	    //$log.debug('gzAppBroker appInterface called for appId = ' + appId);
	    if (appId in vm.apps) {
	      return vm.apps[appId].appInterfaces;
	    }
	  } //appInterface
	
	  //
	  // Private functions
	  //
	  function _openApp(appId, onShowParam) {
	    if (!hasBeenLoaded(appId)) {
	      load(appId);
	    }
	
	    return $mdSidenav(appId).open().then(function () {
	      if ($mdSidenav(appId).isLockedOpen()) {
	        $rootScope.$emit(_gazelleSrcComponentsViewContainerViewContainerDirective.VIEW_WIDTH_CHANGED_EVENT, {
	          source: name,
	          expanded: true
	        });
	      }
	      _callOnShowIfRegistered(appId, onShowParam);
	    });
	  }
	
	  function _getOpenApp() {
	    var appId = null;
	    _.forEach(vm.apps, function (app) {
	      if ($mdSidenav(app.appId).isOpen()) {
	        appId = app.appId;
	      }
	    });
	    return appId;
	  }
	
	  function _callOnShowIfRegistered(appId, onShowParam) {
	    if (appId in vm.apps && vm.apps[appId].appInterfaces && vm.apps[appId].appInterfaces.onShow) {
	      vm.apps[appId].appInterfaces.onShow(onShowParam);
	    }
	  }
	}
	
	//$gzAppBroker

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	gzAppNav.$inject = ["$log", "$q", "$rootScope", "$state", "$futureState", "$gzGo", "$injector"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzAppNav;
	
	var _printosAgnosticViewNav = __webpack_require__(80);
	
	/**
	 * @ngdoc directive
	 * @name gazelle.components.appNav.directive:gzAppNav
	 *
	 * @param {*} items Pass in either a callback method that will return an array of menu items, or pass in an array of menu items directly.
	 *
	 * @description
	 * `<gz-app-nav>` is a frame component that is responsible for rendering the application navigation menu items (currently) on the left side of the page.
	 * It accepts one parameter (items) that can be a callback to a function in the application that returns the menu item structure or the menu array itself.
	 * The difference between the two is that when passing in the array the application would already have to have created the menu items and have everything
	 * resolved before invoking gz-app-nav.  When passing in the callback, Gazelle will make the call to the function to retrieve the menu items. The callback
	 * should return a promise.  When the promise is resolved the result will be displayed.This can result in a later binding of the navigation menu creation.
	 *
	 * The structure of the JSON menu items array is as follows:
	 * ```
	 * [
	 *  {
	 *   id: '',
	 *   loc: {
	 *     name: 'Home'
	 *   },
	 *   icon: {
	 *     type: 'fa',
	 *     name: 'home'
	 *   },
	 *   state: 'home'
	 *   },
	 *   {
	 *     id: '',
	 *     loc: {
	 *       name: 'Item2'
	 *     },
	 *     icon: {
	 *       type: 'fa',
	 *       name: 'newspaper-o'
	 *     },
	 *     state: 'item2',
	 *     views: [{
	 *         id: '',
	 *         loc: {
	 *           name: 'Sub-nav item-1'
	 *         },
	 *         icon: {
	 *           type: 'fa',
	 *           name: 'nav1'
	 *         },
	 *         state: "subnav-1"
	 *     }]
	 *   }
	 *  }
	 * ]
	 * ```
	 *
	 * id: is a unique id for the menu item within the entire array
	 * loc: Localized strings - items here must be localized before sending to the directive (the directive will not localize these values).
	 *   name: The localized name of the menu item for display to the user either as label text, hover, or some other affordance.
	 * icon: The icon definition
	 *   type: The type of icon, 'fa' = FontAwesome, 'md' = Material Design, 'svg' = SVG image.
	 *   name: The name of the icon in the icon set (fa, md).
	 *    For SVGs this is the URL to retrieve the image, which can be previously stored in the $templateCache.
	 *    See `src/mini-apps/app-switcher/cache-icons.run.js` for an example.
	 * state: The ui-router state to transition to when this menu item is selected.
	 *  States can also be ui-router future states as long as they define a `lazyLoad` function which returns a promise that resolves
	 *  if the state exists and is rejected if the state does not exist.
	 * views: A nested version of this structure to support sub-menu items.
	
	 * @example
	 * Jade
	 * ```jade
	 * gz-app-nav(items='function()')
	 * -or-
	 * gz-app-nav(items='object')
	 * ```
	 *
	 * HTML
	 * ```html
	 * <gz-app-nav items='function()'></gz-app-nav>
	 * -or-
	 * <gz-app-nav items='object'></gz-app-nav>
	 * ```
	 */
	var name = 'gzAppNav';
	exports.name = name;
	
	function gzAppNav($log, $q, $rootScope, $state, $futureState, $gzGo, $injector) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzAppNavController.$inject = ["$scope", "$translate", "$templateCache", "$state", "rnApplication", "rnClient"];
	  var viewNav = undefined;
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      items: '&',
	      isNavUx: '='
	    },
	    link: gzAppNavLink,
	    controller: gzAppNavController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	
	  function gzAppNavLink(scope, element, attrs) {
	    viewNav = new _printosAgnosticViewNav.ViewNav({
	      target: element[0]
	    });
	  }
	
	  //* @ngInject
	  function gzAppNavController($scope, $translate, $templateCache, $state, rnApplication, rnClient) {
	    var navMenuItems = [];
	
	    var vm = this;
	
	    activate();
	    return;
	
	    function activate() {
	      var promises = [];
	      promises.push(loadMenuItems());
	      promises.push($translate.onReady());
	
	      return $q.all(promises).then(function () {
	        viewNav.set({ selectedId: $state.current.name });
	        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	          viewNav.set({ selectedId: toState.name });
	        });
	
	        var views = navMenuItems.map(function (item) {
	          var view = mapViewNavItem(item);
	          if (item.children) {
	            view.children = item.children.map(mapViewNavItem);
	          }
	
	          return view;
	        });
	
	        var config = {
	          views: views,
	          isNavUX: vm.isNavUx
	        };
	
	        var appId = rnApplication.getCurrentAppId();
	        if (appId) {
	          config.pairingId = appId;
	        }
	        viewNav.set(config);
	        $scope.$watch($gzGo.showAppNav, function (showViewNav) {
	          viewNav.set({ hideNav: !showViewNav });
	        });
	      });
	    }
	
	    function mapViewNavItem(item) {
	      var view = {
	        id: item.id
	      };
	
	      if (item.showInNav !== undefined) {
	        view.showInNav = item.showInNav;
	      }
	
	      view.name = item.name;
	      if (!view.name && _.get(item, 'loc.name')) {
	        view.name = $translate.instant(item.loc.name);
	      }
	
	      if ($state.get(item.id)) {
	        var href = $state.href(item.id, {}, { inherit: false });
	        if (href) {
	          view.href = href;
	        }
	      } else {
	        var futureStates = $futureState.get();
	        if (futureStates) {
	          var futureState = futureStates[item.id];
	          if (futureState) {
	            view.href = '#' + futureState.url;
	          }
	        }
	      }
	
	      view.description = item.description;
	      if (item.descriptionKey) {
	        view.description = $translate.instant(item.descriptionKey);
	      }
	
	      // TODO: figure out fa and md types
	      if (_.get(item, 'icon.type') === 'svg') {
	        view.icon = {
	          svg: $templateCache.get(item.icon.name)
	        };
	      }
	
	      // Check for additional children that do not show in nav from route definition
	      var itemStateConfig = $state.get(item.id);
	      if (itemStateConfig && itemStateConfig.childStates) {
	        if (!view.children) {
	          view.children = [];
	        }
	        itemStateConfig.childStates.forEach(function (childState) {
	          var found = view.children.find(function (c) {
	            return c.id === childState;
	          });
	
	          if (!found) {
	            view.children.push({ id: childState, showInNav: false });
	          }
	        });
	      }
	
	      return view;
	    }
	
	    function ensureLazyLoadedStates() {
	      var futureStates = $futureState.get();
	      var promises = [];
	      for (var futureStateName in futureStates) {
	        if (!futureStates.hasOwnProperty(futureStateName)) {
	          continue;
	        }
	
	        var futureState = futureStates[futureStateName];
	        var promise = checkFutureState(futureState);
	        if (promise) {
	          promises.push(promise);
	        }
	      }
	      return $q.all(promises);
	    }
	
	    function loadMenuItems() {
	      // $log.debug('In gzAppNavController loadMenuItems');
	      // Ensure vm.items is defined (at least as a function returning undefined
	      vm.items = vm.items || function () {
	        return undefined;
	      };
	
	      return $q.when(vm.items()).then(function (items) {
	        navMenuItems = items || [];
	
	        // Ensure backwards compatibility
	        ensureChildren(navMenuItems);
	        ensureId(navMenuItems);
	        ensureId(navMenuItems.children);
	      }).then(ensureLazyLoadedStates).then(filterOutInvalidFutureStates)['catch'](function (error) {
	        return $log.error('Unable to retrieve application views', error);
	      });
	    }
	
	    function ensureId(items) {
	      if (items) {
	        items.forEach(function (item) {
	          // Map state to id for legacy view items
	          item.id = item.state ? item.state : item.id;
	          delete item.state;
	        });
	      }
	    }
	
	    function ensureChildren(items) {
	      items.forEach(function (item) {
	        if (item.views) {
	          // Map views to children for legacy view items
	          item.children = item.views;
	          delete item.views;
	        }
	      });
	    }
	
	    function checkFutureState(futureState) {
	      if (futureState.lazyLoad) {
	        return $injector.invoke(futureState.lazyLoad, futureState, { futureState: futureState })['catch'](function () {
	          // no-op - want to ensure all promises resolve here
	        });
	      }
	    }
	
	    function filterOutInvalidFutureStates() {
	      navMenuItems.forEach(function (item) {
	        if (item.children) {
	          item.children = item.children.filter(isValidFutureState);
	        }
	      });
	
	      navMenuItems = navMenuItems.filter(function (item) {
	        if (item.children && item.children.length > 0) {
	          return true;
	        }
	
	        return isValidFutureState(item);
	      });
	    }
	
	    function isValidFutureState(item) {
	      var futureStates = $futureState.get();
	      var state = $state.get(item.id);
	      if (!state) {
	        var futureState = futureStates[item.id];
	        if (!futureState || futureState && !futureState.include) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }
	}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	"use strict";
	
	$gzAppNav.$inject = ["$log", "$rootScope"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = $gzAppNav;
	var name = '$gzAppNav';
	
	exports.name = name;
	var EMPHASIS_BACKGROUND = "#EEEEEE";
	exports.EMPHASIS_BACKGROUND = EMPHASIS_BACKGROUND;
	var DEFAULT_BACKGROUND = "#FFFFFF";
	
	exports.DEFAULT_BACKGROUND = DEFAULT_BACKGROUND;
	/**
	 * @ngdoc service
	 * @name gazelle.components.appNav.service:$gzAppNav
	 *
	 * @description
	 * The $gzAppNav service allows the application to specify the background color to use below the app nav menu.
	 *
	 *
	 * @usage
	 * ```js
	 * // In 'my-apps' controller.activate method:
	 * $gzAppNav.setEmphasisBackground('hp-emphasis-background'});
	 * ```
	 */
	
	function $gzAppNav($log, $rootScope) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var bgColor = DEFAULT_BACKGROUND;
	  var transColor = DEFAULT_BACKGROUND;
	
	  var service = {
	    setEmphasisBackground: setEmphasisBackground,
	    setBackgroundColor: setBackgroundColor,
	    bgColor: getBackgroundColor
	  };
	
	  activate();
	  return service;
	
	  function activate() {
	    $rootScope.$on('$stateChangeStart', function () {
	      transColor = DEFAULT_BACKGROUND;
	    });
	    $rootScope.$on('$stateChangeSuccess', function () {
	      bgColor = transColor;
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name setEmphasisBackground
	   * @methodOf gazelle.components.appNav.service:$gzAppNav
	   * @description Sets the background color for the nav bar during ui-router transition to `$hp-emphasis-background` (`#EEEEEE`)
	   */
	  function setEmphasisBackground() {
	    $log.debug('gzAppNav setEmphasisBackground called');
	    transColor = EMPHASIS_BACKGROUND;
	  }
	
	  /**
	   * @ngdoc function
	   * @name setBackgroundColor
	   * @methodOf gazelle.components.appNav.service:$gzAppNav
	   * @description Sets the background color for the nav bar during ui-router transition
	   * @param {string} color - hex color definition used in background-color style attribute (e.g. "#EEEEEE")
	   */
	  function setBackgroundColor(color) {
	    transColor = color;
	  }
	
	  function getBackgroundColor() {
	    return bgColor;
	  }
	}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	
	gzAutoTooltip.$inject = ["$compile", "$sanitize"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzAutoTooltip;
	var name = 'gzAutoTooltip';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.printosImages.gzAutoTooltip.directive:gzAutoTooltip
	 *
	 * @param {string=} gzAutoTooltip tooltip to display if contents are clipped.  Optional.  If not specified shows element's text contents.
	 *
	 * @description
	 * `gz-auto-tooltip` is an attribute directive for specifying a tooltip to show when contents are clipped.
	 * Otherwise, tooltip is not shown.  Uses md-tooltip to manage the tooltip.
	 *
	 * @usage
	 * ```html
	 * <div gz-auto-tooltip>My text</div>
	 * <div gz-auto-tooltip='My tooltip'>My text</div>
	 * ```
	 * Produces (if content is clipped)
	 * ```html
	 * <div gz-auto-tooltip>
	 *     <md-tooltip>My text</md-tooltip>
	 *     My text
	 * </div>
	 * ```
	 */
	
	function gzAutoTooltip($compile, $sanitize) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'A',
	    link: gzAutoTooltipLink
	  };
	
	  return directive;
	
	  //////////////////////
	
	  function gzAutoTooltipLink(scope, element, attrs) {
	    // Automatically add the gazelle class to clip with ellipsis
	    if (!element[0].classList.contains('gz-ellipsis')) {
	      element[0].classList.add('gz-ellipsis');
	    }
	
	    element.on("mouseenter", function (event, tooltipTrigger) {
	      if (tooltipTrigger) {
	        return;
	      }
	
	      if (element[0].offsetWidth < element[0].scrollWidth) {
	        (function () {
	          var tooltip = attrs.gzAutoTooltip;
	          if (!tooltip) {
	            tooltip = element.text();
	          }
	
	          if (tooltip) {
	            tooltip = tooltip.replace(/{{/g, '');
	            tooltip = tooltip.replace(/}}/g, '');
	            tooltip = $sanitize(tooltip);
	          }
	
	          var keyEl = angular.element("<md-tooltip md-autohide='true'>" + tooltip + "</md-tooltip>");
	          element.append(keyEl);
	          $compile(keyEl)(scope);
	
	          var leaveHandler = function leaveHandler() {
	            keyEl.remove();
	            element.off('mouseleave', leaveHandler);
	          };
	
	          element.on("mouseleave", leaveHandler);
	
	          element.triggerHandler(event, true);
	        })();
	      }
	    });
	  }
	}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _autoTooltipDirective = __webpack_require__(289);
	
	var autoTooltip = _interopRequireWildcard(_autoTooltipDirective);
	
	exports['default'] = angular.module('gazelle.components.autoTooltip', ['ngSanitize']).directive(autoTooltip.name, autoTooltip['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	gzBodyWrap.$inject = ["$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzBodyWrap;
	var name = 'gzBodyWrap';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.bodyWrap.directive:gzBodyWrap
	 *
	 * @param {string=} title If present, sets the application title in the left portion of the mini-bar.
	 * @param {object=} nav-items If present, defines the set of application navigational items in the app-nav.
	 *
	 * @description
	 * `<gz-body-wrap>` is a frame component convenience directive that simply wraps the application body and invokes the other frame directives in the
	 * proper order and hierarchy.
	 * There can only be one gz-body-wrap on a page and it should be immediately follow the body tag.
	 *
	 * @usage
	 * ```html
	 * <gz-body-wrap title="App Title" nav-items="nav_items_properties"></gz-body-wrap>
	 * ```
	 */
	
	function gzBodyWrap($log) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      title: '@',
	      appTitle: '@',
	      navItems: '&',
	      showHeader: '=',
	      isNavUx: '='
	    },
	    template: __webpack_require__(222),
	    link: gzBodyWrapLink,
	    controller: gzBodyWrapController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	
	  return directive;
	
	  // /////////////////
	  // // private functions
	
	  function gzBodyWrapLink(scope, element, attrs) {
	    if (attrs.appTitle === undefined) {
	      // $log.warn('appTitle is undefined. Set the app title using the app-title attribute.');
	      attrs.appTitle = attrs.title;
	      element.removeAttr('title');
	    }
	    if (attrs.title !== undefined) {
	      // $log.warn('Using title to set the app title has been deprecated. Please use app-title.');
	    }
	
	    proxyBlueAttrs(element, attrs);
	  }
	
	  function proxyBlueAttrs(element, attrs) {
	    var printosHeader = element.find('printos-header');
	
	    if ('allowAnonymous' in attrs) {
	      printosHeader.attr('allow-anonymous', '');
	    }
	
	    if (attrs.appId) {
	      printosHeader.attr('app-id', attrs.appId);
	    }
	  }
	
	  //* @ngInject
	  function gzBodyWrapController() {}
	}
	
	//gzBodyWrap

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _browserService = __webpack_require__(293);
	
	var $gzBrowser = _interopRequireWildcard(_browserService);
	
	exports['default'] = angular.module('gazelle.components.browser', []).service($gzBrowser.name, $gzBrowser['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzBrowser.$inject = ["$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzBrowser;
	var name = '$gzBrowser';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name gazelle.components.browser.service:$gzBrowser
	 *
	 * @description Gazelle browser service for checking browser properties and capabilities.
	 * This is sadly necessary because some libraries and features simply act different or don't
	 * work on particular platforms.
	 * This module may also be extended with a show/hide attribute directive to simplify expressions like
	 * `ng-if='!$gzBrowser.isMobile()'`.
	 *
	 * @example
	 * ```js
	 *   $gzBrowser.isMobile();
	 * ```
	 */
	
	function $gzBrowser($window) {
	  'ngInject';
	
	  var USER_AGENT_MOBILE_REGEX = /android|iemobile|ipad|iphone|ipod|phone|windows phone/i;
	
	  var service = {
	    isMobile: isMobile,
	    isDesktop: isDesktop
	  };
	  return service;
	
	  //////////////
	
	  /**
	   * @ngdoc function
	   * @name isMobile
	   * @methodOf gazelle.components.browser.service:$gzBrowser
	   * @description Checks if the browser is on a mobile device (phone or tablet)
	   * @returns {boolean} true if the browser platform is a mobile device (phone or tablet), false otherwise
	   */
	  function isMobile() {
	    var mobile = USER_AGENT_MOBILE_REGEX.test($window.navigator.userAgent);
	    return mobile;
	  }
	
	  /**
	   * @ngdoc function
	   * @name isDesktop
	   * @methodOf gazelle.components.browser.service:$gzBrowser
	   * @description Checks if the browser is on a desktop platform (that is, not a mobile platform)
	   * @returns {boolean} true if the browser is on a desktop platform (that is, not a mobile platform), false otherwise
	   */
	  function isDesktop() {
	    return !isMobile();
	  }
	}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzCarousel;
	var name = 'gzCarousel';
	exports.name = name;
	
	function gzCarousel()
	// Directive angular dependencies
	{
	  'ngInject';
	
	  carouselController.$inject = ["$window", "$translate", "$scope", "$timeout", "$gzAnalytics"];
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      options: '=',
	      id: '=',
	      language: '='
	    },
	    template: __webpack_require__(223),
	    link: carouselLink,
	    controller: carouselController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function carouselLink(scope, element, attrs) {}
	
	  /** @ngInject */
	  function carouselController(
	  // Controller angular dependencies
	  $window, $translate, $scope, $timeout, $gzAnalytics) {
	    // Constants
	    var DEFAULT_DELAY = 7 * 1000;
	    var SELECT_DELAY = 20 * 1000;
	
	    // Variables
	    var pageAdvanceTimer = undefined;
	    var debounceResetTimer = _.debounce(function () {
	      resetTimer(vm.timer);
	    }, 200, { maxWait: 1000, trailing: true });
	    var hasVideo = false;
	    var isVideoPlaying = false;
	
	    // View Model
	    var vm = this;
	    //   VM properties
	    vm.index = 0;
	    vm.visualAssets = [];
	    vm.playerAPI = {};
	    vm.imageClick = imageClick;
	
	    //   VM methods
	    vm.next = next;
	    vm.previous = previous;
	    vm.specify = specify;
	    vm.handleMouseMove = handleMouseMove;
	
	    vm.$onInit = onInit;
	    return;
	
	    ///////////////
	    // Init
	    function onInit() {
	      vm.visualAssets = [];
	      vm.options.forEach(function (option) {
	        switch (option.type) {
	          case 'video':
	            vm.visualAssets.push({
	              type: 'video',
	              id: option.videoIds[vm.language] ? option.videoIds[vm.language] : option.videoIds.en
	            });
	            hasVideo = true;
	            break;
	          case 'image':
	            vm.visualAssets.push({
	              type: 'image',
	              src: option.path.startsWith('https') ? option.path : 'https://cdn.printos.com/images/market/products/summary/' + $window.encodeURIComponent(option.path),
	              link: option.link
	            });
	            break;
	          case 'directive':
	            vm.visualAssets.push({
	              type: 'directive',
	              name: option.name
	            });
	            break;
	          case 'testimonial':
	            var myOptions = option.options;
	            var opts = {};
	            if (myOptions.logo) {
	              opts.logo = myOptions.logo.startsWith('https') ? myOptions.logo : 'https://cdn.printos.com/images/market/products/summary/' + $window.encodeURIComponent(myOptions.logo);
	            }
	            if (myOptions.headline || myOptions.headlineKey) {
	              opts.headline = myOptions.headlineKey ? $translate.instant(myOptions.headlineKey) : myOptions.headline;
	            }
	            opts.quote = myOptions.quoteKey ? $translate.instant(myOptions.quoteKey) : myOptions.quote;
	            if (myOptions.picture) {
	              opts.picture = myOptions.picture.startsWith('https') ? myOptions.picture : 'https://cdn.printos.com/images/market/products/summary/' + $window.encodeURIComponent(myOptions.picture);
	            }
	            opts.name = myOptions.name;
	            opts.title = myOptions.title;
	            opts.company = myOptions.company;
	            opts.companyname = myOptions.companyname;
	            opts.image1 = myOptions.image1;
	            opts.image2 = myOptions.image2;
	            opts.layout = myOptions.layout;
	            opts.showVariant = myOptions.showVariant;
	            vm.visualAssets.push({
	              type: 'testimonial',
	              options: opts
	            });
	            break;
	        }
	      });
	
	      if (vm.visualAssets.length > 1) {
	        startTimer();
	        $scope.$on('$destroy', function () {
	          cancelTimer();
	        });
	
	        if (hasVideo) {
	          $window.addEventListener('gz-youtube-play', handleVideoPlay);
	          $window.addEventListener('gz-youtube-stop', handleVideoStop);
	          $window.addEventListener('gz-youtube-pause', handleVideoStop);
	        }
	      }
	    }
	
	    ///////////////
	    // VM methods
	    function previous() {
	      var userClick = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	      vm.index--;
	      if (vm.index < 0) {
	        vm.index = vm.visualAssets.length - 1;
	      }
	
	      if (userClick) {
	        $gzAnalytics.event(vm.id + ' Carousel Navigation', { type: 'previous' });
	        $window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', { detail: { playerId: 'gz-carousel' } }));
	        resetTimer(SELECT_DELAY);
	      } else {
	        resetTimer();
	      }
	    }
	
	    function next() {
	      var userClick = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	      vm.index++;
	      if (vm.index > vm.visualAssets.length - 1) {
	        vm.index = 0;
	      }
	
	      if (userClick) {
	        $gzAnalytics.event(vm.id + ' Carousel Navigation', { type: 'next' });
	        $window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', { detail: { playerId: 'gz-carousel' } }));
	        resetTimer(SELECT_DELAY);
	      } else {
	        resetTimer();
	      }
	    }
	
	    function specify(index) {
	      vm.index = index;
	      $gzAnalytics.event(vm.id + ' Carousel Navigation', { type: 'index' });
	      $window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', { detail: { playerId: 'gz-carousel' } }));
	      resetTimer(SELECT_DELAY);
	    }
	
	    function handleMouseMove() {
	      if (!isVideoPlaying) {
	        debounceResetTimer();
	      } else {
	        cancelTimer();
	      }
	    }
	
	    function handleVideoPlay(event) {
	      $gzAnalytics.event(vm.id + ' Carousel Play Video', { videoId: event.detail.videoId });
	      isVideoPlaying = true;
	      cancelTimer();
	    }
	
	    function handleVideoStop(event) {
	      if (isVideoPlaying) {
	        isVideoPlaying = false;
	        startTimer();
	      }
	    }
	
	    ///////////////
	    // Helpers
	    function startTimer() {
	      var delay = arguments.length <= 0 || arguments[0] === undefined ? DEFAULT_DELAY : arguments[0];
	
	      vm.timer = delay;
	      if (!pageAdvanceTimer) {
	        pageAdvanceTimer = $timeout(next, delay);
	      }
	    }
	
	    function cancelTimer() {
	      if (pageAdvanceTimer) {
	        $timeout.cancel(pageAdvanceTimer);
	        pageAdvanceTimer = null;
	      }
	    }
	
	    function resetTimer() {
	      var delay = arguments.length <= 0 || arguments[0] === undefined ? DEFAULT_DELAY : arguments[0];
	
	      cancelTimer();
	      startTimer(delay);
	    }
	
	    function imageClick(asset) {
	      if (asset.link) {
	        window.open(asset.link, '_blank');
	      }
	    }
	  }
	}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	'use strict';
	
	gzSplash.$inject = ["$compile"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzSplash;
	var name = 'gzSplash';
	
	exports.name = name;
	/**
	 * @param {string=} type. Type name for splash template to load
	
	 * @description
	 * `<gz-splash>` is a widget that displays a product specific splash. (ex. an OEE equation)
	 *
	 * @usage
	 * ```html
	 * <gz-splash
	 *   type='oee'
	 * >
	 *
	 * ```
	 */
	
	function gzSplash(
	// Directive angular dependencies
	$compile) {
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      type: '='
	    },
	    // template: require('./splash.jade'),
	    link: splashLink,
	    controller: splashController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function splashLink(scope, element, attrs) {
	    var splashElement = $compile('<' + scope.vm.type + ' layout-fill layout=\'column\' layout-align=\'start start\'></' + scope.vm.type + '>')(scope);
	    element.append(splashElement[0]);
	  }
	
	  /** @ngInject */
	  function splashController()
	  // Controller angular dependencies
	  {
	    // Constants
	
	    // Variables
	
	    // View Model
	    var vm = this;
	    //   VM properties
	    //   VM methods
	
	    vm.$onInit = onInit;
	    return;
	
	    ///////////////
	    // Init
	    function onInit() {}
	
	    ///////////////
	    // VM methods
	
	    ///////////////
	    // Helpers
	  }
	}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _splashDirective = __webpack_require__(295);
	
	var gzSplashDirective = _interopRequireWildcard(_splashDirective);
	
	exports['default'] = angular.module('gazelle.components.splash', []).directive(gzSplashDirective.name, gzSplashDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzTestimonial;
	var name = 'gzTestimonial';
	exports.name = name;
	
	function gzTestimonial()
	// Directive angular dependencies
	{
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      options: '='
	    },
	    template: __webpack_require__(224),
	    link: testimonialLink,
	    controller: testimonialController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function testimonialLink(scope, element, attrs) {}
	
	  /** @ngInject */
	  function testimonialController()
	  // Controller angular dependencies
	  {
	    // Constants
	
	    // Variables
	
	    // View Model
	    var vm = this;
	    vm.$onInit = onInit;
	
	    return;
	
	    function onInit() {}
	  }
	}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(518);
	
	var _testimonialDirective = __webpack_require__(297);
	
	var gzTestimonialDirective = _interopRequireWildcard(_testimonialDirective);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	exports['default'] = angular.module('gazelle.components.testimonial', [_angularTranslate2['default']]).directive(gzTestimonialDirective.name, gzTestimonialDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzColorPicker;
	var name = 'gzColorPicker';
	exports.name = name;
	
	function gzColorPicker()
	// Directive angular dependencies
	{
	  'ngInject';
	
	  colorPickerController.$inject = ["$window"];
	  var directive = {
	    restrict: 'EA',
	    require: '^ngModel',
	    scope: {
	      gzNative: '@?',
	      color: '=',
	      options: '='
	    },
	    template: __webpack_require__(225),
	    link: colorPickerLink,
	    controller: colorPickerController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function colorPickerLink(scope, element, attrs, ngModelCtrl) {
	    scope.vm.setModelValue = function () {
	      ngModelCtrl.$setViewValue(scope.vm.color);
	    };
	
	    scope.vm.focusInput = function () {
	      scope.$applyAsync(function () {
	        var input = element[0].querySelector('.manual-input input');
	        if (input) {
	          input.focus();
	          input.select();
	        }
	      });
	    };
	  }
	
	  /** @ngInject */
	  function colorPickerController($window) {
	    // Constants
	    var DEFAULT_COLOR = '#0e8a16';
	
	    // Variables
	    // View Model
	    var vm = this;
	    vm.colorOptions = ['#b60205', '#d93f0b', '#fbca04', '#0e8a16', '#006b75', '#1d76db', '#0052cc', '#5319e7', '#e99695', '#f9d0c4', '#fef2c0', '#c2e0c6', '#bfdadc', '#c5def5', '#bfd4f2', '#d4c5f9'];
	
	    vm.colorChanged = colorChanged;
	    vm.randomize = randomize;
	    vm.isDarkContrast = isDarkContrast;
	    vm.closeOnEnterOrEsc = closeOnEnterOrEsc;
	    vm.preventEnterOrEsc = preventEnterOrEsc;
	
	    vm.$onInit = onInit;
	    return;
	
	    ///////////////////////////////////////////////////////////
	    // Activate
	    function onInit() {
	      if (!vm.color) {
	        vm.color = DEFAULT_COLOR;
	      }
	    }
	
	    function randomize() {
	      // Adapted from http://disq.us/p/di2t9p
	      vm.color = '#' + ('000000' + $window.Math.floor($window.Math.random() * 0xFFFFFF).toString(16)).slice(-6);
	      if (_.get(vm.cycleOptions, 'api')) {
	        vm.options.api.changeColor(vm.color);
	      }
	    }
	
	    function colorChanged(color) {
	      vm.color = color;
	      if (_.get(vm.cycleOptions, 'api')) {
	        vm.options.api.changeColor(vm.color);
	      }
	      vm.show = false;
	    }
	
	    // Adapted from https://24ways.org/2010/calculating-color-contrast/
	    function isDarkContrast(hexcolor) {
	      if (!hexcolor) {
	        return true;
	      }
	
	      var r = $window.parseInt(hexcolor.substr(1, 2), 16);
	      var g = $window.parseInt(hexcolor.substr(3, 2), 16);
	      var b = $window.parseInt(hexcolor.substr(5, 2), 16);
	      var yiq = (r * 299 + g * 587 + b * 114) / 1000;
	      return yiq >= 128;
	    }
	
	    function closeOnEnterOrEsc($event) {
	      $event.stopPropagation();
	      $event.preventDefault();
	      if ($event.key === 'Enter' || $event.key === 'Escape') {
	        colorChanged(vm.color);
	      }
	    }
	
	    // Necessary to capture on keydown to prevent actions like submit from occuring
	    function preventEnterOrEsc($event) {
	      if ($event.key === 'Enter' || $event.key === 'Escape') {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  }
	}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(519);
	
	var _colorPickerDirective = __webpack_require__(299);
	
	var gzColorPickerDirective = _interopRequireWildcard(_colorPickerDirective);
	
	exports['default'] = angular.module('gazelle.components.colorPicker', ['ngMaterial', 'pascalprecht.translate', 'ngSanitize']).directive(gzColorPickerDirective.name, gzColorPickerDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	
	gzConfirmDialogController.$inject = ["$mdDialog"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzConfirmDialogController;
	var name = 'gzConfirmDialogController';
	exports.name = name;
	
	function gzConfirmDialogController(
	// Controller angular dependencies
	$mdDialog) {
	  'ngInject';
	  // Constants
	
	  // Variables
	
	  // View Model
	  var vm = this;
	  //   VM properties
	  //   VM methods
	  vm.submit = submit;
	
	  onInit();
	  return;
	
	  ///////////////
	  // Init
	  function onInit() {}
	
	  ///////////////
	  // VM methods
	  function submit() {
	    $mdDialog.hide(true);
	  }
	
	  ///////////////
	  // Helpers
	}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(520);
	
	var _confirmDialogController = __webpack_require__(301);
	
	var ConfirmDialogController = _interopRequireWildcard(_confirmDialogController);
	
	var _confirmDialogService = __webpack_require__(303);
	
	var $gzConfirmDialog = _interopRequireWildcard(_confirmDialogService);
	
	exports['default'] = angular.module('gazelle.components.confirmDialog', ['ngMaterial']).controller(ConfirmDialogController.name, ConfirmDialogController['default']).factory($gzConfirmDialog.name, $gzConfirmDialog['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	$gzConfirmDialog.$inject = ["$mdDialog"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzConfirmDialog;
	var name = '$gzConfirmDialog';
	exports.name = name;
	
	function $gzConfirmDialog($mdDialog) {
	  'ngInject';
	
	  // Constants
	
	  // Variables
	
	  // Service
	  var service = {
	    confirm: confirm
	  };
	
	  return service;
	
	  ///////////////
	  // Service
	  function confirm(locals) {
	    return $mdDialog.show({
	      parent: angular.element(document.body),
	      targetEvent: null,
	      clickOutsideToClose: false,
	      escapeToClose: true,
	      template: __webpack_require__(226),
	      controller: 'gzConfirmDialogController',
	      bindToController: true,
	      controllerAs: 'vm',
	      locals: locals
	    });
	  }
	
	  ///////////////
	  // Helpers
	}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	'use strict';
	
	gzCard.$inject = ["$compile"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzCard;
	var name = 'gzCard';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.dashboard.card.directive:gzCard
	 *
	 * @param {string=} gzCardType. Type name for card template to load
	 * @param {string=} gzCardSettings. Settings to pass to the card controller
	 *
	 * @description
	 * `<gz-card>` is a widget that displays application specific data.
	 *
	 * @usage
	 * ```html
	 * <gz-card
	 *   gz-card-type="account.account"
	 *   gz-card-settings="controller.settings"
	 * >
	 *
	 * ```
	 */
	
	function gzCard($compile) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzCardController.$inject = ["$scope"];
	  var directive = {
	    restrict: 'E',
	    scope: {
	      gzCardType: '=',
	      gzCard: '=?'
	    },
	    //template: require('./card.jade'),
	    link: gzCardLink,
	    controller: gzCardController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	  function gzCardLink(scope, element, attrs) {
	    var cardElement = $compile('<' + scope.vm.gzCardType + ' layout-fill layout=\'column\' gz-card=\'vm.gzCard\'"></' + scope.vm.gzCardType + '>')(scope);
	    element.append(cardElement[0]);
	  }
	
	  /** @ngInject */
	  function gzCardController($scope) {
	    // Constants
	
	    // Variables
	
	    // Controller
	    var vm = this;
	
	    activate();
	
	    //////////////////
	    function activate() {}
	  }
	}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _cardDirectiveJs = __webpack_require__(304);
	
	var cardDirective = _interopRequireWildcard(_cardDirectiveJs);
	
	exports['default'] = angular.module('gazelle.components.dashboard.card', []).directive(cardDirective.name, cardDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _deviceStatusService = __webpack_require__(307);
	
	var gzDeviceStatus = _interopRequireWildcard(_deviceStatusService);
	
	exports['default'] = angular.module('gazelle.components.deviceStatus', ['gazelle.components.l10n']).service(gzDeviceStatus.name, gzDeviceStatus['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzDeviceStatus.$inject = ["$log", "$filter"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzDeviceStatus;
	var STATUS_IMAGE_BASE = 'https://cdn.printos.com/images/status/';
	exports.STATUS_IMAGE_BASE = STATUS_IMAGE_BASE;
	var STATE = Object.freeze({
	  UNKNOWN: {
	    rank: Infinity,
	    color: '#E5E8E8', // Matches the $hp-disabled-gray
	    staleColor: '#E5E8E8', // Matches the $hp-disabled-gray
	    colorSilent: 'transparent',
	    status: 'unknown',
	    'class': 'gz-status-neutral'
	  },
	  ERROR: {
	    rank: 0,
	    color: '#F04B37', // Matches the $hp-status-red
	    staleColor: '#E5E8E8', // Matches the $hp-disabled-gray
	    status: 'error',
	    'class': 'gz-status-error'
	  },
	  WARN: {
	    rank: 1,
	    color: '#F0AA3C', // Matches the $hp-status-yellow
	    staleColor: '#E5E8E8', // Matches the $hp-disabled-gray
	    status: 'warning',
	    'class': 'gz-status-warn'
	  },
	  OFF: {
	    rank: 2,
	    color: '#F0AA3C', // Matches the $hp-status-yellow
	    staleColor: '#E5E8E8', // Matches the $hp-disabled-gray
	    //colorSilent: "transparent",  // Use this color if you don't want to call attention to this state
	    status: 'off',
	    'class': 'gz-status-neutral'
	  },
	  OK: {
	    rank: 3,
	    color: '#509137', // Matches the $hp-status-green
	    staleColor: '#E5E8E8', // Matches the $hp-disabled-gray
	    colorSilent: "transparent", // Use this color if you don't want to call attention to this state
	    status: 'ok',
	    'class': 'gz-status-ok'
	  }
	});
	
	exports.STATE = STATE;
	var name = '$gzDeviceStatus';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name gazelle.components.card.service:$gzDeviceStatus
	 *
	 * @description
	 * The $gzDeviceStatus service provides a mechanism to get individual and combined device status information.
	 */
	
	function $gzDeviceStatus($log, $filter) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var service = {
	    getDeviceStatus: getDeviceStatus,
	    getInkState: getInkState,
	    getOverallState: getOverallState,
	    getOverallStateOfMultipleDevices: getOverallStateOfMultipleDevices
	  };
	  return service;
	
	  //
	  // Public functions
	  //
	
	  /**
	   * @ngdoc function
	   * @name getDeviceStatus
	   * @methodOf gazelle.components.card.service:$gzDeviceStatus
	   * @description Get the status information for a device
	   * @param {Object} element - A device object
	   * @param {Object} [options] - Optional. Options.
	   * @returns {Object} A status object, i.e.: {text: "someString", image: "imagePath", state: {rank: 0, color: #F04B37}}
	  */
	  function getDeviceStatus(device, options) {
	    var deviceSpecificStatusKey = null;
	    if (device && device.data && device.data.miscInfo && device.data.miscInfo.deviceSpecificStatusKey) {
	      deviceSpecificStatusKey = device.data.miscInfo.deviceSpecificStatusKey;
	    }
	
	    var status = {
	      text: deviceSpecificStatusKey ? $filter('L10N')(deviceSpecificStatusKey) : $filter('L10N')('devices.devices.Status_Unknown'),
	      image: STATUS_IMAGE_BASE + 'unknown.svg',
	      state: STATE.UNKNOWN
	    };
	
	    try {
	      switch (_.get(device, 'data.deviceStatus')) {
	        case 'DS_PRINTING':
	          status = {
	            text: deviceSpecificStatusKey ? $filter('L10N')(deviceSpecificStatusKey) : device.type === "IndigoDFE" || device.type === "ProductionCenter" ? $filter('L10N')('devices.devices.DFE_Status_Printing') : device.type === "IndigoPress" ? $filter('L10N')('devices.devices.Indigo_Press_Status_printing') : $filter('L10N')('devices.devices.Status_Printing'),
	            image: STATUS_IMAGE_BASE + 'printing.svg',
	            state: STATE.OK
	          };
	          break;
	        case 'DS_RIPPING':
	          status = {
	            text: deviceSpecificStatusKey ? $filter('L10N')(deviceSpecificStatusKey) : device.type === "IndigoDFE" || device.type === "ProductionCenter" ? $filter('L10N')('devices.devices.DFE_Status_Ripping') : device.type === "IndigoPress" ? $filter('L10N')('devices.devices.Indigo_Press_Status_printing') : $filter('L10N')('devices.devices.Status_Processing'),
	            image: STATUS_IMAGE_BASE + 'processing.svg',
	            state: STATE.OK
	          };
	          break;
	        case 'DS_ON':
	          status = {
	            text: deviceSpecificStatusKey ? $filter('L10N')(deviceSpecificStatusKey) : device.type === "IndigoDFE" || device.type === "ProductionCenter" ? $filter('L10N')('devices.devices.DFE_Status_Ready') : device.type === "IndigoPress" ? $filter('L10N')('devices.devices.Indigo_Press_Status_readytoprint') : $filter('L10N')('devices.devices.Status_PoweredOnIdle'),
	            image: STATUS_IMAGE_BASE + 'ok.svg',
	            state: STATE.OK
	          };
	          break;
	        case 'DS_STANDBY':
	          status = {
	            text: deviceSpecificStatusKey ? $filter('L10N')(deviceSpecificStatusKey) : device.type === "IndigoDFE" || device.type === "ProductionCenter" ? $filter('L10N')('devices.devices.DFE_Status_Paused') : device.type === "IndigoPress" ? $filter('L10N')('devices.devices.Indigo_Press_Status_up') : $filter('L10N')('devices.devices.Status_Standby'),
	            image: STATUS_IMAGE_BASE + 'ok.svg',
	            state: STATE.OK
	          };
	          break;
	        case 'DS_OFF':
	          status = {
	            text: deviceSpecificStatusKey ? $filter('L10N')(deviceSpecificStatusKey) : device.type === "IndigoDFE" || device.type === "ProductionCenter" ? $filter('L10N')('devices.devices.DFE_Status_Offline') : device.type === "IndigoPress" ? $filter('L10N')('devices.devices.Indigo_Press_Status_down') : $filter('L10N')('devices.devices.Status_PoweredOff'),
	            image: STATUS_IMAGE_BASE + 'unknown.svg',
	            state: STATE.OFF
	          };
	          break;
	        case 'DS_WARNING':
	          status = {
	            text: deviceSpecificStatusKey ? $filter('L10N')(deviceSpecificStatusKey) : device.type === "IndigoDFE" || device.type === "ProductionCenter" ? $filter('L10N')('devices.devices.DFE_Status_Warning') : device.type === "IndigoPress" ? $filter('L10N')('devices.devices.Indigo_Press_Status_warning') : $filter('L10N')('devices.devices.Status_Warning'),
	            image: STATUS_IMAGE_BASE + 'warning.svg',
	            state: STATE.WARN
	          };
	          break;
	        case 'DS_ERROR':
	          status = {
	            text: deviceSpecificStatusKey ? $filter('L10N')(deviceSpecificStatusKey) : device.type === "IndigoDFE" || device.type === "ProductionCenter" ? $filter('L10N')('devices.devices.DFE_Status_Problem') : device.type === "IndigoPress" ? $filter('L10N')('devices.devices.Indigo_Press_Status_error') : $filter('L10N')('devices.devices.Status_Error'),
	            image: STATUS_IMAGE_BASE + 'error.svg',
	            state: STATE.ERROR
	          };
	          break;
	        default:
	          break;
	      }
	
	      status.isStale = false;
	      // Determine if the status is stale since some devices want to display the Disconnected status if the status is stale
	      // Currently, "some devices" are: Indigo Press, 3D, Production Center
	      if (device.type === "IndigoPress" || device.type === "ThreeDPrinter" || device.type === "ThreeDController" || device.type === "ProductionCenter") {
	        var msBeforeStale = 10 * 60 * 1000;
	        if (options && options.msBeforeStale) {
	          msBeforeStale = options.msBeforeStale;
	        }
	        if (device && device.data && device.data.lastUpdate && msBeforeStale > 0) {
	          var msSinceUpdate = Date.now() - new Date(device.data.lastUpdate).getTime();
	          if (msSinceUpdate > msBeforeStale) {
	            status.isStale = true;
	            status.text = $filter('L10N')('devices.devices.Status_Disconnected');
	            status.image = STATUS_IMAGE_BASE + 'unknown.svg';
	            status.state = STATE.UNKNOWN;
	          }
	        }
	      }
	    } catch (e) {}
	
	    return status;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getInkState
	   * @methodOf gazelle.components.card.service:$gzDeviceStatus
	   * @description Get the combined ink state information for a device
	   * @param {Object} element - A device object
	   * @param {Object} inkThresholds - Ink level thresholds, i.e: {error: 10, warn: 30}
	   * @returns {Object} A STATE object, i.e.: {rank: 0, color: #F04B37}
	   */
	  function getInkState(device, inkThresholds) {
	    var state = STATE.UNKNOWN;
	    if (inkThresholds !== undefined && inkThresholds.error !== undefined && inkThresholds.warn !== undefined) {
	      try {
	        var inkLevels = device.inkLevels;
	        if (!inkLevels || inkLevels.length < 1) {
	          state = STATE.UNKNOWN;
	        } else {
	          var minInk = _.min(inkLevels, 'value');
	          var minInkValue = parseInt(minInk.value);
	          if (minInk.value >= inkThresholds.warn) {
	            state = STATE.OK;
	          } else if (minInk.value >= inkThresholds.error) {
	            state = STATE.WARN;
	          } else if (minInk.value >= 0) {
	            state = STATE.ERROR;
	          }
	        }
	      } catch (e) {
	        state = STATE.UNKNOWN;
	      }
	    }
	
	    return state;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getOverallState
	   * @methodOf gazelle.components.card.service:$gzDeviceStatus
	   * @description Get the overall state of the device, taking into account device status and ink state
	   * @param {Object} element - A device object
	   * @param {Object} [thresholds] - Optional. Thresholds, i.e: {ink: {error: 10, warn: 30}}. If 'ink' threshold
	   * is present then the specific type of levels will be taken into consideration when determining the overall state.
	   * If, for example, you don't want ink to be included in the status determination then don't include any ink element.
	   * @returns {Object} A STATE object, i.e.: {rank: 0, color: #F04B37}
	   */
	  function getOverallState(device, thresholds) {
	    var state = STATE.UNKNOWN;
	    try {
	      var states = [];
	      states.push(getDeviceStatus(device, {}).state);
	      if (thresholds !== undefined) {
	        // Check to see if we are supposed to include ink status
	        if (thresholds.ink !== undefined && thresholds.ink.error !== undefined && thresholds.ink.warn !== undefined) {
	          states.push(getInkState(device, thresholds.ink));
	        }
	      }
	      state = _.min(states, 'rank');
	    } catch (e) {
	      state = STATE.UNKNOWN;
	    }
	    return state;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getOverallStateOfMultipleDevices
	   * @methodOf gazelle.components.card.service:$gzDeviceStatus
	   * @description Get the overall state of the device, taking into account device status and ink state
	   * @param {Array} element - An array of device objects
	   * @param {Object} [thresholds] - Optional. Thresholds, i.e: {ink: {error: 10, warn: 30}}. If 'ink' threshold
	   * is present then the specific type of levels will be taken into consideration when determining the overall state.
	   * If, for example, you don't want ink to be included in the status determination then don't include any ink element.
	   * @returns {Object} A STATE object, i.e.: {rank: 0, color: #F04B37}
	   */
	  function getOverallStateOfMultipleDevices(devices, thresholds) {
	    var state = STATE.UNKNOWN;
	    try {
	      var states = [];
	      for (var i = 0; i < devices.length; i++) {
	        states.push(getDeviceStatus(devices[i], {}).state);
	        if (thresholds !== undefined) {
	          // Check to see if we are supposed to include ink status
	          if (thresholds.ink !== undefined && thresholds.ink.error !== undefined && thresholds.ink.warn !== undefined) {
	            states.push(getInkState(devices[i], thresholds.ink));
	          }
	        }
	      }
	      state = _.min(states, 'rank');
	    } catch (e) {
	      state = STATE.UNKNOWN;
	    }
	    return state;
	  }
	}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzDialogTitleBar;
	var name = 'gzDialogTitleBar';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.dialogTitleBar.directive:gzDialogTitleBar
	 *
	 * @param {string} title (DEPRECATED) The text to display along the title bar. This will be left-aligned.
	 * @param {string} gz-title  The text to display along the title bar. This will be left-aligned.
	 * @param {function} cancel (optional) A function to perform a custom cancellation process. If this is provided the developer
	 *                          becomes responsible for closing the dialog. If this is not provided the dialog will be closed
	 *                          by gzDialogTitleBar.
	 * @param {string} gz-analytics-category (optional) The category to use for analytics reporting
	 * @param {string} gz-analytics-event (optional) The event to use for analytics reporting
	 * @param {string} gz-analytics-label (optional) The label to use for analytics reporting
	 * @param {string} gz-analytics-action (optional) The action to use for analytics reporting
	 *
	 * @description Provides a consistent look for dialog title bars with built-in L10N property string conversion and a default cancel
	 *              action. Passing in a property file key will enable gzDialogTitleBar to conduct the L10N conversion. By
	 *              default gzDialogTitleBar will take care of closing the dialog when the close icon is linked, however, you
	 *              can specifiy a custom function to execute as well. If this route is take then the developer bears responsibility
	 *              for closing the dialog.
	 *
	 * @usage
	 * ````html
	 *
	 * // With custom cancellation
	 * <gz-dialog-title-bar title="account.account.somePropertyKey" cancel="vm.doCancel"></gz-dialog-title-bar>
	 *
	 * // With default cancellation
	 * <gz-dialog-title-bar title="account.account.somePropertyKey"></gz-dialog-title-bar>
	 *
	 * ````
	 */
	
	function gzDialogTitleBar() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzDialogTitleBarController.$inject = ["$mdDialog", "$gzAnalytics"];
	  var directive = {
	    restrict: 'E',
	    scope: {
	      title: '@',
	      gzTitle: '@',
	      cancel: '=?'
	    },
	    template: __webpack_require__(227),
	    controllerAs: 'vm',
	    bindToController: true,
	    link: gzDialogTitleBarLink,
	    controller: gzDialogTitleBarController
	  };
	
	  return directive;
	
	  /////////////////////
	
	  function gzDialogTitleBarLink(scope, elem, attrs) {
	    // Add category
	    if (attrs.hasOwnProperty('gzAnalyticsCategory')) {
	      scope.vm.setCategory(attrs.gzAnalyticsCategory);
	    }
	
	    // Add event
	    if (attrs.hasOwnProperty('gzAnalyticsEvent')) {
	      scope.vm.setEvent(attrs.gzAnalyticsEvent);
	    }
	
	    // Add label
	    if (attrs.hasOwnProperty('gzAnalyticsLabel')) {
	      scope.vm.setLabel(attrs.gzAnalyticsLabel);
	    }
	
	    // Add value
	    if (attrs.hasOwnProperty('gzAnalyticsValue')) {
	      scope.vm.setValue(attrs.gzAnalyticsValue);
	    }
	  }
	
	  /** @ngInject */
	  function gzDialogTitleBarController($mdDialog, $gzAnalytics) {
	
	    var vm = this;
	    var event = 'GZ EVENT';
	    var eventObj = {
	      category: 'GZ EVENT CATEGORY'
	    };
	
	    vm.activate = activate;
	    vm.defaultCancel = defaultCancel;
	    vm.setCategory = setCategory;
	    vm.setEvent = setEvent;
	    vm.setLabel = setLabel;
	    vm.setValue = setValue;
	
	    activate();
	
	    ////////////////////
	
	    function activate() {
	
	      // If a title is not provided assign the warning title
	      if (vm.gzTitle) {
	        vm.dialogTitle = vm.gzTitle;
	      } else if (vm.title) {
	        vm.dialogTitle = vm.title;
	      } else {
	        vm.dialogTitle = 'uxf.uxf.No_Title';
	      }
	
	      // If a custom cancel function is not provided assign the default cancel function
	      if (vm.cancel === undefined) {
	        vm.cancel = defaultCancel;
	      }
	    }
	
	    function setEvent(anEvent) {
	      event = anEvent;
	    }
	
	    function setCategory(category) {
	      eventObj.category = category;
	    }
	
	    function setLabel(label) {
	      eventObj.label = label;
	    }
	
	    function setValue(value) {
	      eventObj.value = value;
	    }
	
	    function defaultCancel() {
	      $mdDialog.cancel();
	
	      // An event has been reported
	      if (event !== 'GZ EVENT') {
	        $gzAnalytics.eventCancel(event, eventObj);
	      }
	    }
	  }
	}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(521);
	
	var _dialogTitleBarDirective = __webpack_require__(308);
	
	var gzDialogTitleBar = _interopRequireWildcard(_dialogTitleBarDirective);
	
	var _gazelleSrcCoreCoreModule = __webpack_require__(30);
	
	var _gazelleSrcCoreCoreModule2 = _interopRequireDefault(_gazelleSrcCoreCoreModule);
	
	exports['default'] = angular.module('gazelle.components.dialogTitleBar', ['pascalprecht.translate', 'ngMaterial', _gazelleSrcCoreCoreModule2['default']]).directive(gzDialogTitleBar.name, gzDialogTitleBar['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzErrorBar;
	var name = 'gzErrorBar';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.errorBar.directive:gzErrorBar
	 *
	 * @param {string} error-key localization key of error message to display
	 * @param {Array=} error-values localization param values for the error message
	 * @param {string=} error-details localization key of error details to display
	 * @param {Array=} error-details-values localization param values for the error details
	 *
	 * @description
	 * `<gz-error-bar>` is a simple subheader for displaying error messages above a title bar, following 26A common error handling.
	 * The error will be hidden until the message is displayed.
	 * It translates the error message with the provided localization key and optional values
	 *
	 * @usage
	 * ```html
	 * <gz-error-bar error-key='vm.errorMsgKey' error-details='vm.errorDetailsKey'</gz-error-bar>
	 * ```
	 */
	
	function gzErrorBar() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      errorKey: '=',
	      errorValues: '=?',
	      errorDetails: '=?',
	      errorDetailsValues: '=?'
	    },
	    template: __webpack_require__(228),
	    controllerAs: 'vm',
	    bindToController: true,
	    controller: gzErrorBarController
	  };
	
	  return directive;
	
	  /////////////////
	
	  function gzErrorBarController() {}
	}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzError.$inject = ["$log", "$mdDialog", "$mdToast", "$filter"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzError;
	var name = '$gzError';
	exports.name = name;
	
	function $gzError($log, $mdDialog, $mdToast, $filter) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var service = {
	    alert: doAlert,
	    alertByLocalizationKey: alertByLocalizationKey,
	    alertBySmsException: alertBySmsException,
	    alertMessage: alertMessage
	  };
	
	  return service;
	
	  /////////////////
	
	  function doAlert(app, catalog, service, errorCode, subCode) {
	    var toast = arguments.length <= 5 || arguments[5] === undefined ? false : arguments[5];
	
	    var message = $filter('translate')(app + '.' + catalog + '.' + service + '_' + errorCode + '_' + subCode);
	    return showErrorDialog(message);
	  }
	
	  function alertByLocalizationKey(localizationKey) {
	    var toast = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    var message = $filter('translate')(localizationKey);
	    return showErrorDialog(message);
	  }
	
	  function alertBySmsException(exception) {
	    var toast = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    $log.info('exception: ' + JSON.stringify(exception));
	    var message;
	    if (exception === undefined || exception.smsError === undefined || exception.smsError.message === undefined) {
	      message = $filter('translate')('uxf.uxf.GenericError');
	    } else {
	      message = exception.smsError.message;
	    }
	
	    return showErrorDialog(message);
	  }
	
	  function alertMessage(message) {
	    var toast = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    $log.warn('$gzError#alertMessage does not localize - use "alert" or "alertByLocalizationKey"');
	    return showErrorDialog(message);
	  }
	
	  function showErrorDialog(message) {
	    var ok = $filter('translate')('uxf.uxf.OK');
	    var errorTitle = $filter('translate')('uxf.uxf.Error_Title');
	
	    if (message.indexOf("L10N") > -1) {
	      message = $filter('translate')('uxf.uxf.GenericError');
	    }
	
	    return $mdDialog.show($mdDialog.alert().parent(angular.element(document.body))
	    // .title(errorTitle)
	    .textContent(message).ariaLabel(errorTitle).ok(ok));
	  }
	
	  function showErrorToast(message) {
	    if (message.indexOf("L10N") > -1) {
	      message = $filter('translate')('uxf.uxf.GenericError');
	    }
	    return $mdToast.showSimple(message);
	  }
	}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	gzField.$inject = ["$compile", "$gzFields", "$sanitize"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzField;
	var name = 'gzField';
	exports.name = name;
	
	function gzField(
	// Directive angular dependencies
	$compile, $gzFields, $sanitize) {
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      id: '@',
	      options: '=',
	      record: '=',
	      value: '=?'
	    },
	    template: __webpack_require__(229),
	    link: fieldLink,
	    controller: fieldController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function fieldLink(scope, element, attrs) {
	    var renderValue = undefined;
	    var rawValue = undefined;
	    var column = _.find(scope.vm.options.columns, { id: scope.vm.id });
	
	    if (scope.vm.value) {
	      rawValue = scope.vm.value;
	    } else {
	      var path = _.get(column, 'field.path');
	      if (path) {
	        rawValue = _.get(scope.vm.record, path);
	      }
	    }
	
	    var classes = [];
	    var classRenderer = _.get(column, 'field.callbacks.classRenderer');
	    if (classRenderer) {
	      classes = classRenderer(rawValue, scope.vm.record, column);
	    }
	
	    var value = $gzFields.getValue(rawValue, scope.vm.record, column);
	    _.set(scope, 'gzColumn.' + column.id, column);
	    _.set(scope, 'gzValue.' + column.id, rawValue);
	    if (value !== null) {
	      renderValue = '<div class="gz-field ';
	      _.forEach(classes, function (myClass) {
	        renderValue += myClass + ' ';
	      });
	
	      if (column.type === 'string') {
	        value = $sanitize(value);
	      }
	
	      renderValue += '" gz-auto-tooltip>' + value + '</div>';
	    }
	
	    var myElement = $compile(renderValue)(scope);
	    element.append(myElement[0]);
	  }
	
	  /** @ngInject */
	  function fieldController()
	  // Controller angular dependencies
	  {
	    // Constants
	
	    // Variables
	
	    // View Model
	    var vm = this;
	    vm.$onInit = onInit;
	
	    return;
	
	    function onInit() {}
	  }
	}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(523);
	
	var _fieldDirective = __webpack_require__(312);
	
	var gzFieldDirective = _interopRequireWildcard(_fieldDirective);
	
	var _fieldsModule = __webpack_require__(52);
	
	var _fieldsModule2 = _interopRequireDefault(_fieldsModule);
	
	exports['default'] = angular.module('gazelle.components.field', [_fieldsModule2['default']]).directive(gzFieldDirective.name, gzFieldDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzFields.$inject = ["$translate", "$sanitize", "moment"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzFields;
	var name = '$gzFields';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name gazelle.components.fields.service:$gzFields
	 *
	 * @description
	 * The $gzFields service provides helpers to use with field definitions provided to a grid so rendering could occur elsewhere
	 *
	 */
	
	function $gzFields($translate, $sanitize, moment) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var unitTest = {};
	
	  var service = {
	    resolveString: resolveString,
	    getValue: getValue,
	    getExportValue: getExportValue,
	    getDateStringValue: getDateStringValue,
	    getMappedStringValue: getMappedStringValue,
	    unitTest: unitTest
	  };
	
	  activate();
	  return service;
	
	  function activate() {}
	
	  //
	  // Public functions
	  //
	  function resolveString(src, target) {
	    var value = arguments.length <= 2 || arguments[2] === undefined ? undefined : arguments[2];
	
	    if (target && target !== '') {
	      // If target already has a value we will use that
	      var passedIn = _.get(src, target);
	      if (passedIn) {
	        return passedIn;
	      }
	    } else {
	      target = '';
	    }
	
	    // 2. Localization Key (example target='title', lookup 'titleKey')
	    var key = _.get(src, target + 'Key');
	    if (key) {
	      return $translate.instant(key, '!' + key + '!');
	    }
	
	    // 3. Localization Pattern (E.G. target='title', lookup 'titleKeyBase')
	    var keyBase = _.get(src, target + 'KeyBase');
	    if (keyBase) {
	      return $translate.instant(keyBase + value, '!' + 'keyBase' + value + '!');
	    }
	
	    // 4. Fall back to placeholder (id or value)
	    return value;
	  }
	
	  function getValue(rawValue, data, column, params) {
	    var myValue = rawValue;
	    var valueRenderer = _.get(column, 'field.callbacks.valueRenderer');
	    if (valueRenderer) {
	      var customValue = valueRenderer(rawValue, data, column, params);
	      if (column.type === 'custom') {
	        return customValue === undefined ? null : customValue;
	      } else {
	        myValue = customValue;
	      }
	    }
	
	    switch (column.type) {
	      case 'string':
	        myValue = getStringValue(myValue, column);
	        if (myValue) {
	          myValue = '' + myValue;
	          myValue = myValue.replace(/{{/g, '');
	          myValue = myValue.replace(/}}/g, '');
	        }
	        break;
	      case 'number':
	        myValue = getNumberValue(myValue, column);
	        break;
	      case 'date':
	        myValue = getDateValue(myValue, column);
	        break;
	      case 'mapped':
	        myValue = getMappedValue(myValue, column);
	        break;
	      case 'duration':
	        myValue = getDurationValue(myValue, column);
	        break;
	      case 'image':
	        myValue = getImageValue(myValue, column);
	        break;
	    }
	
	    return myValue;
	  }
	
	  function getExportValue(rawValue, data, column) {
	    var myValue = rawValue;
	    var exportRenderer = _.get(column, 'field.callbacks.exportRenderer');
	    if (exportRenderer) {
	      var value = exportRenderer(rawValue, data, column);
	      return value === undefined ? null : value;
	    }
	
	    var valueRenderer = _.get(column, 'field.callbacks.valueRenderer');
	    if (valueRenderer) {
	      var customValue = valueRenderer(rawValue, data, column);
	      if (column.type === 'custom') {
	        return customValue === undefined ? null : customValue;
	      } else {
	        myValue = customValue;
	      }
	    }
	
	    switch (column.type) {
	      case 'string':
	        return getStringValue(myValue, column);
	      case 'number':
	        return getNumberValue(myValue, column);
	      case 'date':
	        var myDateColumn = _.cloneDeep(column);
	        if (_.get(myDateColumn, 'field.date.display') === 'elapse') {
	          _.set(myDateColumn, 'field.date.display', 'medium');
	        }
	        return getDateValue(myValue, myDateColumn);
	      case 'mapped':
	        var myMappedColumn = _.cloneDeep(column);
	        _.set(myMappedColumn, 'field.mapped.showImage', false);
	        _.set(myMappedColumn, 'field.mapped.showText', true);
	        _.set(myMappedColumn, 'field.mapped.sparseValues', []);
	        return getMappedValue(myValue, myMappedColumn, true);
	      case 'duration':
	        return getDurationValue(myValue, column);
	      case 'image':
	        return myValue;
	    }
	  }
	
	  //
	  // Private functions
	  //
	  function getStringValue(rawValue, column) {
	    var value = null;
	    if (!isEmpty(rawValue)) {
	      var test = '' + rawValue;
	      var display = _.get(column, 'field.string.display', undefined);
	      switch (display) {
	        case 'upper':
	          value = test.toLocaleUpperCase();
	          break;
	        case 'lower':
	          value = test.toLocaleLowerCase();
	          break;
	        case 'lookup':
	          value = $translate.instant(test, test);
	          break;
	        default:
	          value = test;
	      }
	    }
	
	    return value;
	  }
	
	  function getNumberValue(rawValue, column) {
	    if (typeof rawValue === 'string') {
	      rawValue = parseFloat(rawValue);
	    }
	
	    var value = null;
	    if (!isEmpty(rawValue)) {
	      var display = _.get(column, 'field.number.display', undefined);
	      switch (display) {
	        case 'decimal':
	          var decimalPlaces = _.get(column, 'field.number.decimalPlaces', 2);
	          value = Number(Math.round(rawValue + 'e' + decimalPlaces) + 'e-' + decimalPlaces);
	          //value = value.toFixed(decimalPlaces);
	          break;
	        default:
	          value = rawValue;
	      }
	    }
	
	    return value;
	  }
	
	  function getDateValue(rawValue, column) {
	    var value = null;
	    if (!isEmpty(rawValue)) {
	      var display = _.get(column, 'field.date.display', 'medium');
	      var showTime = _.get(column, 'field.date.showTime', true);
	      var showDate = _.get(column, 'field.date.showDate', true);
	      if (display === 'elapse') {
	        value = '<div am-time-ago="gzValue.' + column.id + '"><md-tooltip>{{::gzValue.' + column.id + ' | amDateFormat: \'LLL\'}}</md-tooltip></div>';
	      } else if (display === 'elapseOnly') {
	        value = moment(rawValue).fromNow();
	      } else {
	        if (showDate || showTime) {
	          var format = undefined;
	          switch (display) {
	            case 'medium':
	              format = 'LLL';
	              if (showDate && !showTime) {
	                format = 'LL';
	              } else if (!showDate && showTime) {
	                format = 'LT';
	              }
	              value = moment(rawValue).format(format);
	              break;
	            case 'full':
	              format = 'LLLL';
	              if (showDate && !showTime) {
	                format = 'LL';
	              } else if (!showDate && showTime) {
	                format = 'LTS';
	              }
	              value = moment(rawValue).format(format);
	              break;
	            case 'short':
	              format = 'L LT';
	              if (showDate && !showTime) {
	                format = 'L';
	              } else if (!showDate && showTime) {
	                format = 'LT';
	              }
	              value = moment(rawValue).format(format);
	              break;
	            case 'format':
	              format = _.get(column, 'field.date.format', 'LLL');
	              value = moment(rawValue).format(format);
	              break;
	            default:
	              value = moment(rawValue).format('LLL');
	              break;
	          }
	        }
	      }
	    }
	
	    return value;
	  }
	
	  function getDateStringValue(rawValue, column) {
	    var columnCopy = column ? _.cloneDeep(column) : {};
	    _.set(columnCopy, 'field.date.display', 'elapseOnly');
	
	    return getDateValue(rawValue, columnCopy);
	  }
	
	  function getMappedStringValue(rawValue, column) {
	    var columnCopy = column ? _.cloneDeep(column) : {};
	    _.set(columnCopy, 'field.mapped.showImage', false);
	    _.set(columnCopy, 'field.mapped.showText', true);
	
	    return getMappedValue(rawValue, columnCopy);
	  }
	
	  function getMappedValue(rawValue, column) {
	    var isExport = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	    var value = null;
	    var sparseValues = _.get(column, 'field.mapped.sparseValues', []);
	    if (!isEmpty(rawValue) && !isSparseValue(rawValue, sparseValues)) {
	      var display = _.get(column, 'field.mapped.display', 'raw');
	      var showText = _.get(column, 'field.mapped.showText', false);
	      var showBoth = _.get(column, 'field.mapped.showBoth', false);
	      var iconSize = _.get(column, 'field.mapped.defaultSize', 16);
	
	      switch (display) {
	        case 'active':
	        case 'on':
	        case 'true':
	        case 'yes':
	        case 'locked':
	          var test = ensureBoolean(rawValue);
	          if (showText) {
	            if (!isExport) {
	              value = '<div gz-auto-tooltip>';
	              value += getMappedString(display, test);
	              value += '</div>';
	            } else {
	              value = getMappedString(display, test);
	            }
	          } else if (showBoth) {
	            value = '<div layout="row" layout-align="start center">';
	            value += getMappedImage(display, test, true, iconSize);
	            value += '<div gz-auto-tooltip>';
	            value += getMappedString(display, test);
	            value += '</div>';
	            value += '</div>';
	          } else {
	            value = getMappedImage(display, test, false, iconSize);
	          }
	          break;
	        case 'status':
	          value = '';
	          var addStyle = ' style="font-size:' + iconSize + 'px;"';
	
	          switch (rawValue.toUpperCase()) {
	            case 'OK':
	              if (showText) {
	                if (!isExport) {
	                  value = '<div gz-auto-tooltip>';
	                  value += $translate.instant('uxf.uxf.Grid_Ok');
	                  value += '</div>';
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_Ok');
	                }
	              } else if (showBoth) {
	                value = '<div layout="row" layout-align="start center">';
	                value += '<md-icon md-svg-src="gazelle/grid/images/ok.svg" class="gz-status-ok gz-image-spacer" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Ok') + '</md-tooltip></i>';
	                value += '<div gz-auto-tooltip>';
	                value += $translate.instant('uxf.uxf.Grid_Ok');
	                value += '</div>';
	                value += '</div>';
	              } else {
	                value = '<md-icon md-svg-src="gazelle/grid/images/ok.svg" class="gz-status-ok" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Ok') + '</md-tooltip></i>';
	              }
	              break;
	            case 'WARN':
	              if (showText) {
	                if (!isExport) {
	                  value = '<div gz-auto-tooltip>';
	                  value += $translate.instant('uxf.uxf.Grid_Warn');
	                  value += '</div>';
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_Warn');
	                }
	              } else if (showBoth) {
	                value = '<div layout="row" layout-align="start center">';
	                value += '<md-icon md-svg-src="gazelle/grid/images/warning.svg" class="gz-status-warn gz-image-spacer" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Warn') + '</md-tooltip></md-icon>';
	                value += '<div gz-auto-tooltip>';
	                value += $translate.instant('uxf.uxf.Grid_Warn');
	                value += '</div>';
	                value += '</div>';
	              } else {
	                value = '<md-icon md-svg-src="gazelle/grid/images/warning.svg"  class="gz-status-warn" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Warn') + '</md-tooltip></md-icon>';
	              }
	              break;
	            case 'ERROR':
	              if (showText) {
	                if (!isExport) {
	                  value = '<div gz-auto-tooltip>';
	                  value += $translate.instant('uxf.uxf.Grid_Error');
	                  value += '</div>';
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_Error');
	                }
	              } else if (showBoth) {
	                value = '<div layout="row" layout-align="start center">';
	                value += '<md-icon md-svg-src="gazelle/grid/images/error.svg"  class="gz-status-error gz-image-spacer" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Error') + '</md-tooltip></i>';
	                value += '<div gz-auto-tooltip>';
	                value += $translate.instant('uxf.uxf.Grid_Error');
	                value += '</div>';
	                value += '</div>';
	              } else {
	                value = '<md-icon md-svg-src="gazelle/grid/images/error.svg" class="gz-status-error" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Error') + '</md-tooltip></i>';
	              }
	              break;
	            case 'INFO':
	              if (showText) {
	                if (!isExport) {
	                  value = '<div gz-auto-tooltip>';
	                  value += $translate.instant('uxf.uxf.Grid_Info');
	                  value += '</div>';
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_Info');
	                }
	              } else if (showBoth) {
	                value = '<div layout="row" layout-align="start center">';
	                value += '<md-icon md-svg-src="gazelle/grid/images/info.svg" class="gz-status-info gz-image-spacer" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Info') + '</md-tooltip></i>';
	                value += '<div gz-auto-tooltip>';
	                value += $translate.instant('uxf.uxf.Grid_Info');
	                value += '</div>';
	                value += '</div>';
	              } else {
	                value = '<md-icon md-svg-src="gazelle/grid/images/info.svg" class="gz-status-info" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Info') + '</md-tooltip></i>';
	              }
	              break;
	            case 'UNKNOWN':
	              if (showText) {
	                if (!isExport) {
	                  value = '<div gz-auto-tooltip>';
	                  value += $translate.instant('uxf.uxf.Grid_Unknown');
	                  value += '</div>';
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_Unknown');
	                }
	              } else if (showBoth) {
	                value = '<div layout="row" layout-align="start center">';
	                value += '<md-icon md-svg-src="gazelle/grid/images/unknown.svg" class="gz-status-info gz-image-spacer" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Unknown') + '</md-tooltip></i>';
	                value += '<div>';
	                value += $translate.instant('uxf.uxf.Grid_Unknown');
	                value += '</div>';
	                value += '</div>';
	              } else {
	                value = '<md-icon md-svg-src="gazelle/grid/images/unknown.svg" class="gz-status-info" ' + addStyle + '><md-tooltip>' + $translate.instant('uxf.uxf.Grid_Unknown') + '</md-tooltip></i>';
	              }
	              break;
	          }
	          break;
	        case 'lookup':
	          value = '';
	          var lookup = _.get(column, 'field.mapped.lookup');
	          if (lookup) {
	            var imageBase = _.get(lookup, 'imageBase');
	            var imageType = _.get(lookup, 'imageType');
	            var imageColor = _.get(lookup, 'imageColor');
	            var imageWidth = _.get(lookup, 'imageWidth');
	            var imageHeight = _.get(lookup, 'imageHeight');
	            var classes = _.get(lookup, 'classes', []);
	            if (isExport) {
	              classes = [];
	            }
	            var imageClasses = _.get(lookup, 'imageClasses', []);
	            var text = resolveString(lookup, 'title', rawValue);
	            var tooltip = resolveString(lookup, 'tooltip', text);
	
	            if (showText) {
	              if (classes.length > 0) {
	                value = getClassesDiv(classes, isExport) + text + '</div>';
	              } else {
	                if (!isExport) {
	                  value = '<div gz-auto-tooltip>';
	                }
	                value += text;
	                if (!isExport) {
	                  value += '</div>';
	                }
	              }
	            } else if (showBoth) {
	              var image = $translate.instant(imageBase + rawValue);
	              value = '<div layout="row" layout-align="start center">';
	              value += composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, imageClasses, true, tooltip);
	              value += '<div flex gz-auto-tooltip>' + text + '</div>';
	              value += '</div>';
	            } else {
	              var image = $translate.instant(imageBase + rawValue);
	              value = composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, imageClasses, false, tooltip);
	            }
	          }
	          break;
	        case 'values':
	          value = '';
	          var values = _.get(column, 'field.mapped.values', undefined);
	          if (values) {
	            var info = _.find(values, { value: rawValue });
	            if (info) {
	              var image = _.get(info, 'image', undefined);
	              var imageType = _.get(info, 'imageType', undefined);
	              var imageColor = _.get(info, 'imageColor', undefined);
	              var imageWidth = _.get(info, 'imageWidth', undefined);
	              var imageHeight = _.get(info, 'imageHeight', undefined);
	              var classes = _.get(info, 'classes', []);
	              if (isExport) {
	                classes = [];
	              }
	              var imageClasses = _.get(info, 'imageClasses', []);
	              var text = resolveString(info, 'title', rawValue);
	              var tooltip = resolveString(info, 'tooltip', text);
	              if (showText) {
	                if (classes.length > 0) {
	                  value = getClassesDiv(classes, isExport);
	                  value += text;
	                  value += '</div>';
	                } else {
	                  if (isExport) {
	                    value += text;
	                  } else {
	                    value = '<div gz-auto-tooltip>';
	                    value += text;
	                    value += '</div>';
	                  }
	                }
	              } else if (showBoth) {
	                value = '<div layout="row" layout-align="start center">';
	                value += composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, imageClasses, true, tooltip);
	                if (classes.length > 0) {
	                  value += getClassesDiv(classes) + text + '</div>';
	                } else {
	                  value += '<div flex gz-auto-tooltip>' + text + '</div>';
	                }
	                value += '</div>';
	              } else {
	                value = composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, imageClasses, false, tooltip);
	              }
	            } else {
	              value = rawValue;
	            }
	          }
	          break;
	        default:
	          value = rawValue;
	          break;
	      }
	    }
	
	    return value;
	  }
	
	  function getDurationValue(rawValue, column) {
	    var value = null;
	    if (!isEmpty(rawValue)) {
	      var display = _.get(column, 'field.duration.display', 'verbose');
	      var dropZero = _.get(column, 'field.duration.dropZero', false);
	      var precision = _.get(column, 'field.duration.precision', 'ms');
	      var significantValues = _.get(column, 'field.duration.maxUnits', 2);
	      if (significantValues > 4) {
	        significantValues = 4;
	      }
	
	      var s_ms_adjustment = 1;
	      if (precision === 's') {
	        s_ms_adjustment = 1000;
	      }
	
	      var x = rawValue * s_ms_adjustment;
	      x = Math.floor(x / 1000);
	      var seconds = x % 60;
	      x = Math.floor(x / 60);
	      var minutes = x % 60;
	      x = Math.floor(x / 60);
	      var hours = x % 24;
	      x = Math.floor(x / 24);
	      var days = x;
	
	      var significant = false;
	      var itemsPlaced = 0;
	      var values = [];
	      var parts = [];
	
	      if (days > 0) {
	        significant = true;
	        itemsPlaced++;
	        if (itemsPlaced === significantValues) {
	          // Round up if last place
	          if (hours > 11) {
	            days++;
	          }
	        }
	        if (days === 1) {
	          parts.push('d');
	        } else {
	          parts.push('ds');
	        }
	        values.push(days);
	      }
	
	      if (hours > 0 || significant) {
	        significant = true;
	        itemsPlaced++;
	        if (itemsPlaced === significantValues) {
	          // Round up if last place
	          if (minutes > 29) {
	            hours++;
	          }
	        }
	
	        if (itemsPlaced <= significantValues) {
	          if (hours === 1) {
	            parts.push('h');
	            values.push(hours);
	          } else if (hours === 0 && !dropZero || hours > 1) {
	            parts.push('hs');
	            values.push(hours);
	          }
	        }
	      }
	
	      if (minutes > 0 || significant) {
	        significant = true;
	        itemsPlaced++;
	        if (itemsPlaced === significantValues) {
	          // Round up if last place
	          if (seconds > 29) {
	            minutes++;
	          }
	        }
	
	        if (itemsPlaced <= significantValues) {
	          if (minutes === 1) {
	            parts.push('m');
	            values.push(minutes);
	          } else if (minutes === 0 && !dropZero || minutes > 1) {
	            parts.push('ms');
	            values.push(minutes);
	          }
	        }
	      }
	
	      if (seconds > 0 || significant) {
	        significant = true;
	        itemsPlaced++;
	        if (itemsPlaced <= significantValues) {
	          if (seconds === 1) {
	            parts.push('s');
	            values.push(seconds);
	          } else if (seconds === 0 && !dropZero || seconds > 1) {
	            parts.push('ss');
	            values.push(seconds);
	          }
	        }
	      }
	
	      if (!significant && rawValue === 0) {
	        parts.push('ss');
	        values.push(rawValue);
	        significant = true;
	      }
	
	      if (significant) {
	        var key = 'uxf.uxf.Grid_Duration';
	        _.forEach(parts, function (part) {
	          key += '_' + part;
	        });
	
	        if (display === 'medium') {
	          key += '_Medium';
	        } else if (display === 'short') {
	          key += '_Short';
	        }
	
	        value = $translate.instant(key, values);
	      }
	    }
	
	    return value;
	  }
	
	  function getImageValue(rawValue, column) {
	    var value = null;
	    if (!isEmpty(rawValue)) {
	      var options = _.get(column, 'field.image');
	      var type = _.get(options, 'type');
	      var color = _.get(options, 'color');
	      var width = _.get(options, 'width');
	      var height = _.get(options, 'height');
	      var imageClasses = _.get(options, 'imageClasses');
	      var tooltip = resolveString(options, 'tooltip');
	
	      value = composeImageHTML(rawValue, type, color, width, height, imageClasses, false, tooltip);
	    }
	
	    return value;
	  }
	
	  function getCustomValue(rawValue, data, column) {
	    var value = null;
	    if (!isEmpty(rawValue)) {}
	
	    return value;
	  }
	
	  function isEmpty(value) {
	    return value === undefined || value === null || value === '';
	  }
	
	  function isSparseValue(value, sparseValues) {
	    var sparse = false;
	    if (sparseValues.length > 0 && _.indexOf(sparseValues, value) > -1) {
	      sparse = true;
	    }
	
	    return sparse;
	  }
	
	  function getClassesDiv(classes) {
	    var isExport = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    var div = undefined;
	    if (isExport) {
	      div = '<div ';
	    } else {
	      div = '<div gz-auto-tooltip ';
	    }
	
	    if (classes && classes.length > 0) {
	      div += ' class="';
	      for (var i = 0; i < classes.length; i++) {
	        div += classes[i];
	        if (i + 1 < classes.length) {
	          div += ' ';
	        }
	      }
	    }
	
	    div += '">';
	
	    return div;
	  }
	
	  function ensureBoolean(value) {
	    if (typeof value === 'string') {
	      value = value.toLowerCase();
	    }
	
	    return value === 'true' || value === true ? true : false;
	  }
	
	  function getMappedImage(type, value) {
	    var withText = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	    var iconSize = arguments.length <= 3 || arguments[3] === undefined ? 16 : arguments[3];
	
	    var image = undefined;
	    var addClass = withText ? ' gz-image-spacer' : '';
	    var addStyle = ' style="font-size:' + iconSize + 'px;"';
	
	    switch (type) {
	      case 'active':
	      case 'on':
	      case 'true':
	      case 'yes':
	        image = value ? '<md-icon md-svg-src="gazelle/grid/images/ok.svg" class="gz-status-ok' + addClass + '" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) + '</md-tooltip></md-icon>' : '<md-icon  md-svg-src="gazelle/grid/images/aborted.svg" class="gz-status-error' + addClass + '" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) + '</md-tooltip></md-icon>';
	        break;
	      case 'locked':
	        image = value ? '<i class="fa fa-lock gz-status-error' + addClass + '" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) + '</md-tooltip></i>' : '<i class="fa fa-unlock gz-status-ok' + addClass + '" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) + '</md-tooltip></i>';
	        break;
	      default:
	        image = value ? '<md-icon md-svg-src="gazelle/grid/images/ok.svg" class="gz-status-ok' + addClass + '" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) + '</md-tooltip></md-icon>' : '<md-icon md-svg-src="gazelle/grid/images/aborted.svg" class="gz-status-error' + addClass + '" ' + addStyle + '><md-tooltip>' + getMappedString(type, value) + '</md-tooltip></md-icon>';
	        break;
	    }
	
	    return image;
	  }
	
	  function getMappedString(type, value) {
	    var text = undefined;
	    switch (type) {
	      case 'active':
	        text = value ? $translate.instant('uxf.uxf.Grid_Active') : $translate.instant('uxf.uxf.Grid_Inactive');
	        break;
	      case 'on':
	        text = value ? $translate.instant('uxf.uxf.Grid_On') : $translate.instant('uxf.uxf.Grid_Off');
	        break;
	      case 'true':
	        text = value ? $translate.instant('uxf.uxf.Grid_True') : $translate.instant('uxf.uxf.Grid_False');
	        break;
	      case 'yes':
	        text = value ? $translate.instant('uxf.uxf.Grid_Yes') : $translate.instant('uxf.uxf.Grid_No');
	        break;
	      case 'locked':
	        text = value ? $translate.instant('uxf.uxf.Grid_Locked') : $translate.instant('uxf.uxf.Grid_Unlocked');
	        break;
	      default:
	        text = value ? $translate.instant('uxf.uxf.Grid_Yes') : $translate.instant('uxf.uxf.Grid_No');
	        break;
	    }
	
	    return text;
	  }
	
	  function composeImageHTML(image, imageType, imageColor, imageWidth, imageHeight, classes) {
	    var withText = arguments.length <= 6 || arguments[6] === undefined ? false : arguments[6];
	    var tooltip = arguments.length <= 7 || arguments[7] === undefined ? undefined : arguments[7];
	
	    var addClass = withText ? 'gz-image-spacer ' : 'gz-image-cell';
	    if (classes) {
	      _.forEach(classes, function (myClass) {
	        addClass += myClass + ' ';
	      });
	    }
	
	    var html = '<div class="' + addClass + '">';
	    var style = undefined;
	    if (imageWidth || imageHeight || imageColor) {
	      style = '';
	      style += ' style="';
	
	      if (imageWidth) {
	        style += 'width:' + imageWidth + 'px;';
	        style += 'min-width:' + imageWidth + 'px;';
	      } else {
	        style += 'width: auto;';
	      }
	
	      if (imageHeight) {
	        style += 'height:' + imageHeight + 'px;';
	        style += 'min-height:' + imageHeight + 'px;';
	      } else {
	        style += 'height: auto;';
	      }
	
	      if (imageColor) {
	        style += 'color:' + imageColor + ';';
	      }
	
	      if (imageType === 'fa' || imageType === 'md' || imageType === 'svg') {
	        var fontSize = imageHeight;
	        if (!imageHeight) {
	          fontSize = 16;
	        }
	        style += 'font-size:' + fontSize + 'px;';
	        style += 'line-height:' + fontSize + 'px;';
	      }
	      style += '"';
	    }
	
	    if (tooltip) {
	      html += '<md-tooltip>' + tooltip + '</md-tooltip>';
	    }
	
	    html += '<div class="gz-image-container"';
	
	    if (imageType === 'md' || imageType === 'svg') {
	      if (imageHeight) {
	        html += ' style="height:' + imageHeight + 'px;"';
	      }
	    } else {
	      if (style) {
	        html += ' ' + style;
	      }
	    }
	
	    html += '>';
	
	    if (imageType) {
	      switch (imageType) {
	        case 'fa':
	          html += '<i class="fa fa-' + image + '"></i>';
	          break;
	        case 'md':
	          html += '<md-icon';
	          if (style) {
	            html += ' ' + style;
	          }
	          html += ' md-font-set="material-icons">' + image + '</md-icon>';
	          break;
	        case 'gz':
	          html += '<img gz-img-src="' + image + '">';
	          break;
	        case 'ng':
	          html += '<img ng-src="' + image + '">';
	          break;
	        case 'svg':
	          html += '<md-icon class="gz-app-icon"';
	          if (style) {
	            html += ' ' + style;
	          }
	          html += ' md-svg-src="' + image + '"></md-icon>';
	          break;
	        default:
	          html += '<img src="' + image + '">';
	          break;
	      }
	    }
	    html += '</div></div>';
	
	    return html;
	  }
	}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc directive
	 * @name gazelle.components.filterBar.directive:gzFilterBar
	 *
	 * @param {filters} Array of filter objects
	 * @param {filterCount=} object that contains the current filtered count
	 * @param {removeCallback=} callback that is called when the user removes an individual filter.
	 * @param {removeAllCallback=} callback that is called when the user removes ALL filters.
	 *
	 * @description
	 * `<gz-filter-bar>` provides a standard display of applied filters.
	 *
	 * The filter bar allows the consumer to specify a list of applied filters.  It will display the filters and allow the user to remove
	 * individual filters or all of the filters
	 *
	 * @example
	 * ````html
	 * <gz-filter-bar
	 *  filters='vm.filters'
	 *  filter-count='vm.filterCount'
	 *  remove-callback='vm.removeFilter'
	 *  remove-all-callback='vm.removeAllFilters'>
	 * </gz-filter-bar>
	 * ````
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzFilterBar;
	var name = 'gzFilterBar';
	exports.name = name;
	
	function gzFilterBar() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzFilterBarController.$inject = ["$translate", "$scope", "$rootScope", "moment", "$gzFilters", "$gzFields", "$gzAnalytics", "rnHttp", "$log", "$mdToast", "$filter"];
	  var directive = {
	    restrict: 'E',
	    scope: {
	      gridOptions: '=',
	      filterCount: '=?',
	      filters: '=?',
	      counts: '=?',
	      pairingId: '@',
	      emphasisBackground: '=?',
	      filterMode: '=?'
	    },
	    template: __webpack_require__(230),
	    link: gzFilterBarLink,
	    controllerAs: 'vm',
	    bindToController: true,
	    controller: gzFilterBarController
	  };
	
	  return directive;
	
	  /////////////////
	
	  function gzFilterBarLink(scope, element, attrs) {
	    scope.vm.readonly = 'readonly' in attrs;
	  }
	
	  // @ngInject
	  function gzFilterBarController($translate, $scope, $rootScope, moment, $gzFilters, $gzFields, $gzAnalytics, rnHttp, $log, $mdToast, $filter) {
	    var vm = this;
	
	    var QUICK_FILTER = 'GZ_QUICK_FILTER';
	    var USER_FILTER = 'GZ_USER_FILTER';
	    var ADHOC_FILTER = 'GZ_ADHOC_FILTER';
	    var NAMED_FILTER = 'GZ_NAMED_FILTER';
	    var MATCH_ANY = 'GZ_MATCH_ANY';
	    var EXCLUDE = 'GZ_EXCLUDE';
	    var PORTAL_SERVICE_NAME = 'portal_service';
	    var FILTERS_PATH = 'filters';
	
	    var filters = undefined;
	    var userFilterListener = undefined;
	    var namedFilterListener = undefined;
	    var adhocFilterListener = undefined;
	    var quickFilterListener = undefined;
	    var filterCountListener = undefined;
	    var savedFilterAddedListener = undefined;
	
	    vm.displayFilters = [];
	    vm.quickAccessFilters = [];
	    vm.savedFilters = [];
	    vm.namedFilters = [];
	    vm.filtersApplied = false;
	
	    vm.selectFilter = selectFilter;
	    vm.selectFilter1 = selectFilter1;
	    vm.selectFilterById = selectFilterById;
	    vm.toggleFilter = toggleFilter;
	    vm.toggleFilter1 = toggleFilter1;
	    vm.removeFilter = removeFilter;
	    vm.removeFilter1 = removeFilter1;
	    vm.removeFilter2 = removeFilter2;
	    vm.removeAllFilters = removeAllFilters;
	    vm.isExpandable = isExpandable;
	    vm.isExpanded = isExpanded;
	    vm.isExpanded1 = isExpanded1;
	    vm.canSave = canSave;
	    vm.saveFilter = saveFilter;
	    vm.gzSavedFilterClicked = gzSavedFilterClicked;
	    vm.gzNamedFilterClicked = gzNamedFilterClicked;
	    vm.gzRemoveFilterClicked = gzRemoveFilterClicked;
	    vm.gzRemoveBuiltInFilterClicked = gzRemoveBuiltInFilterClicked;
	    vm.gzFilterClicked = gzFilterClicked;
	
	    vm.unitTest = {
	      setFilters: function setFilters(f) {
	        filters = f;
	      },
	      getFilters: function getFilters() {
	        return filters;
	      },
	      handleUserFilterChanged: handleUserFilterChanged,
	      handleNamedFilterChanged: handleNamedFilterChanged,
	      handleAdhocFilterChanged: handleAdhocFilterChanged,
	      handleQuickFilterChanged: handleQuickFilterChanged,
	      handleFilterCountChanged: handleFilterCountChanged
	    };
	
	    vm.$onInit = onInit;
	    return;
	
	    //////////////////
	    function onInit() {
	      var allowFilters = _.get(vm.gridOptions, 'grid.options.allowFilters', true);
	      vm.showFilter = allowFilters && hasColumnFilter();
	      vm.truncationTooltipKey = _.get(vm.gridOptions, 'grid.options.filter.truncationTooltipKey');
	
	      vm.itemsDisplay = $translate.instant(_.get(vm.gridOptions, 'grid.options.itemPluralKey', 'uxf.uxf.FilterItems'));
	      vm.itemDisplay = $translate.instant(_.get(vm.gridOptions, 'grid.options.itemSingularKey', 'uxf.uxf.FilterItem'));
	
	      if (vm.filterMode === undefined) {
	        vm.filterMode = false;
	      }
	      if (vm.filters) {
	        filters = _.cloneDeep(vm.filters);
	        if (filters.namedFilters) {
	          vm.namedFilters = _.sortBy(filters.namedFilters, function (filter) {
	            return filter.display.title;
	          });
	        }
	        $gzFilters.mergeFilters(filters);
	      } else {
	        filters = $gzFilters.createFiltersObject(vm.filters);
	      }
	
	      userFilterListener = $rootScope.$on('gzUserFilterChangedEvent', handleUserFilterChanged);
	      namedFilterListener = $rootScope.$on('gzNamedFilterChangedEvent', handleNamedFilterChanged);
	      adhocFilterListener = $rootScope.$on('gzAdhocFilterChangedEvent', handleAdhocFilterChanged);
	      quickFilterListener = $rootScope.$on('gzQuickFilterChangedEvent', handleQuickFilterChanged);
	      filterCountListener = $rootScope.$on('gzFilterCountUpdated', handleFilterCountChanged);
	      savedFilterAddedListener = $rootScope.$on('gzSavedFilterAddedEvent', handleSavedFilterAdded);
	
	      $scope.$on('$destroy', function () {
	        userFilterListener();
	        namedFilterListener();
	        adhocFilterListener();
	        quickFilterListener();
	        filterCountListener();
	        savedFilterAddedListener();
	      });
	
	      $translate.onReady().then(function () {
	        loadSavedFilters();
	        updateFilters();
	        updateQuickAccessFilters();
	      });
	    }
	
	    function hasColumnFilter() {
	      if (!_.get(vm, 'gridOptions.columns')) {
	        return false;
	      }
	
	      var hasFilters = false;
	      _.forEach(vm.gridOptions.columns, function (column) {
	        var allowFilter = _.get(column, 'options.allowFilter', true);
	        if (allowFilter) {
	          hasFilters = true;
	          return false;
	        }
	      });
	
	      return hasFilters;
	    }
	
	    function updateFilters() {
	      vm.displayFilters = [];
	
	      if (filters) {
	        vm.filtersApplied = filters.quickFilter || _.get(filters, 'mergedFilter.and', []).length > 0;
	
	        var adhocFilters = _.get(filters, 'adhocFilter.and', []);
	        var adhocDisplayFilters = getDisplayFilters(adhocFilters, false, true);
	        _.forEach(adhocDisplayFilters, function (displayFilter) {
	          displayFilter.type = ADHOC_FILTER;
	          vm.displayFilters.push(displayFilter);
	          vm.isAdhoc = true;
	        });
	
	        var namedFilter = _.get(filters, 'namedFilter.display');
	        if (namedFilter) {
	          var title = namedFilter.title;
	          if (namedFilter.titleKey) {
	            title = $translate.instant(namedFilter.titleKey);
	          }
	
	          var namedDisplayFilter = {
	            id: filters.namedFilter.id,
	            internalId: NAMED_FILTER,
	            type: NAMED_FILTER,
	            display: $translate.instant('uxf.uxf.FilterBuiltIn', [title]),
	            tooltip: $translate.instant('uxf.uxf.FilterBuiltInTooltip', [title])
	          };
	
	          var namedFilters = _.get(filters, 'namedFilter.and');
	          if (namedFilters) {
	            namedDisplayFilter.displayFilters = getDisplayFilters(namedFilters);
	          }
	
	          vm.displayFilters.push(namedDisplayFilter);
	        }
	
	        var userFilters = _.get(filters, 'userFilter.and', []);
	        var userDisplayFilters = getDisplayFilters(userFilters);
	        _.forEach(userDisplayFilters, function (displayFilter) {
	          vm.displayFilters.push(displayFilter);
	        });
	      } else {
	        vm.filtersApplied = false;
	      }
	    }
	
	    function getDisplayFilters(items) {
	      var isSubFilter = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	      var isAdhoc = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	      var displayFilters = [];
	      _.forEach(items, function (item) {
	        var or = _.get(item, 'or');
	        var and = _.get(item, 'and');
	        if (!or && !and && isAdhoc) {
	          displayFilters.push(item);
	        } else if (or) {
	
	          var columnId = or[0].columnId;
	          var columnTitle = getColumnTitle(columnId);
	          var matchAnyFilter = {
	            id: columnId,
	            type: MATCH_ANY,
	            display: $translate.instant('uxf.uxf.FilterMatchAny', [columnTitle]),
	            tooltip: $translate.instant('uxf.uxf.FilterMatchAnyTooltip', [columnTitle, or.length])
	          };
	
	          matchAnyFilter.displayFilters = getDisplayFilters(or, true);
	
	          displayFilters.push(matchAnyFilter);
	        } else if (and) {
	          var columnId = and[0].columnId;
	          var columnTitle = getColumnTitle(columnId);
	          var excludeFilter = {
	            id: columnId,
	            type: EXCLUDE,
	            display: $translate.instant('uxf.uxf.FilterExclude', [columnTitle]),
	            tooltip: $translate.instant('uxf.uxf.FilterExcludeTooltip', [columnTitle, and.length])
	          };
	
	          excludeFilter.displayFilters = getDisplayFilters(and, true);
	
	          displayFilters.push(excludeFilter);
	        } else {
	          item.type = USER_FILTER;
	          setupDisplayStrings(item, isSubFilter);
	          displayFilters.push(item);
	        }
	      });
	
	      return displayFilters;
	    }
	
	    function updateQuickAccessFilters() {
	      if (vm.gridOptions) {
	        _.forEach(vm.gridOptions.columns, function (column) {
	          var isQuickAccess = _.get(column, 'options.filter.isQuickAccess', false);
	          if (isQuickAccess) {
	            var index = _.get(column, 'options.filter.quickAccessIndex', 0);
	            var filter = {
	              id: column.id,
	              display: $gzFields.resolveString(column.header, 'title', column.id),
	              index: column.options.filter.quickAccessIndex
	            };
	
	            vm.quickAccessFilters.push(filter);
	          }
	        });
	
	        vm.quickAccessFilters = _.sortBy(vm.quickAccessFilters, 'index');
	      }
	    }
	
	    function getColumnTitle(columnId) {
	      var column = _.find(vm.gridOptions.columns, { id: columnId });
	      var title = _.get(column, 'header.title');
	      if (title === undefined) {
	        title = $gzFields.resolveString(column.header, 'title', column.id);
	        _.set(column, 'header.title', title);
	      }
	
	      return title;
	    }
	
	    function setupDisplayStrings(filter, isSubFilter) {
	      if (vm.gridOptions) {
	        var column = _.find(vm.gridOptions.columns, { id: filter.columnId });
	        var columnTitle = getColumnTitle(filter.columnId);
	        var value = filter.value;
	        var begin = filter.begin;
	        var end = filter.end;
	        switch (column.type) {
	          case 'date':
	            value = moment(value).format('LL');
	            begin = moment(begin).format('LL');
	            end = moment(end).format('LL');
	            break;
	          case 'duration':
	            var myColumn = _.cloneDeep(column);
	            delete myColumn.field.callbacks;
	            _.set(myColumn, 'field.duration.display', 'short');
	            _.set(myColumn, 'field.duration.dropZero', true);
	            _.set(myColumn, 'field.duration.maxUnits', 4);
	            value = $gzFields.getValue(value, null, myColumn);
	            break;
	          case 'mapped':
	            switch (column.field.mapped.display) {
	              case 'active':
	                if (value) {
	                  value = $translate.instant('uxf.uxf.Grid_Active');
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_Inactive');
	                }
	                break;
	              case 'on':
	                if (value) {
	                  value = $translate.instant('uxf.uxf.Grid_On');
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_Off');
	                }
	                break;
	              case 'yes':
	                if (value) {
	                  value = $translate.instant('uxf.uxf.Grid_Yes');
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_No');
	                }
	                break;
	              case 'locked':
	                if (value) {
	                  value = $translate.instant('uxf.uxf.Grid_Locked');
	                } else {
	                  value = $translate.instant('uxf.uxf.Grid_Unlocked');
	                }
	                break;
	              case 'status':
	                switch (value.toUpperCase()) {
	                  case 'OK':
	                    value = $translate.instant('uxf.uxf.Grid_Ok');
	                    break;
	                  case 'WARN':
	                    value = $translate.instant('uxf.uxf.Grid_Warn');
	                    break;
	                  case 'ERROR':
	                    value = $translate.instant('uxf.uxf.Grid_Error');
	                    break;
	                  case 'INFO':
	                    value = $translate.instant('uxf.uxf.Grid_Info');
	                    break;
	                  default:
	                    value = $translate.instant('uxf.uxf.Grid_Unknown');
	                    break;
	                }
	                break;
	              case 'lookup':
	                var lookup = _.get(column, 'field.mapped.lookup', { title: '' });
	                value = $gzFields.resolveString(column.field.mapped.lookup, 'title', value);
	                break;
	              case 'values':
	                var found = _.find(column.field.mapped.values, { value: value });
	                if (found) {
	                  value = $gzFields.resolveString(found, 'title', value);
	                } else {
	                  value = '';
	                }
	                break;
	            }
	            break;
	        }
	
	        switch (filter.op) {
	          case 'equals':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterEquals', [columnTitle, value]));
	            break;
	          case 'notEqual':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterNotEquals', [columnTitle, value]));
	            break;
	          case 'isEmpty':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterEmpty', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterEmpty', [columnTitle]));
	            break;
	          case 'isNotEmpty':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterNotEmpty', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterNotEmpty', [columnTitle]));
	            break;
	          case 'contains':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterContains', [columnTitle, value]));
	            break;
	          case 'startsWith':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterStartsWith', [columnTitle, value]));
	            break;
	          case 'endsWith':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterEndsWith', [columnTitle, value]));
	            break;
	          case 'greaterThan':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterGreaterThan', [columnTitle, value]));
	            break;
	          case 'greaterThanOrEqual':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterGreaterThanOrEquals', [columnTitle, value]));
	            break;
	          case 'lessThan':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterLessThan', [columnTitle, value]));
	            break;
	          case 'lessThanOrEqual':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShort', [columnTitle, value]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterLessThanOrEquals', [columnTitle, value]));
	            break;
	          case 'between':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterShortBetween', [columnTitle, begin, end]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterBetween', [columnTitle, begin, end]));
	            break;
	          case 'thisWeek':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterThisWeek', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterThisWeek', [columnTitle]));
	            break;
	          case 'nextWeek':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterNextWeek', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterNextWeek', [columnTitle]));
	            break;
	          case 'lastWeek':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterLastWeek', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterLastWeek', [columnTitle]));
	            break;
	          case 'today':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterToday', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterToday', [columnTitle]));
	            break;
	          case 'tomorrow':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterTomorrow', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterTomorrow', [columnTitle]));
	            break;
	          case 'yesterday':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterYesterday', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterYesterday', [columnTitle]));
	            break;
	          case 'future':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterFuture', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterFuture', [columnTitle]));
	            break;
	          case 'past':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterPast', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterPast', [columnTitle]));
	            break;
	          case 'lastSevenDays':
	            _.set(filter, 'display', $translate.instant('uxf.uxf.FilterLastSevenDays', [columnTitle]));
	            _.set(filter, 'tooltip', $translate.instant('uxf.uxf.FilterLastSevenDays', [columnTitle]));
	            break;
	        }
	      }
	    }
	
	    function handleUserFilterChanged(event, data) {
	      if (data.pairingId === vm.pairingId) {
	        filters.userFilter = _.cloneDeep(data.userFilter);
	        $gzFilters.mergeFilters(filters);
	
	        if (!data.suppressFilterBarRefresh) {
	          vm.selectedFilter1 = undefined;
	          vm.selectedFilter2 = undefined;
	        }
	        updateFilters();
	      }
	    }
	
	    function handleNamedFilterChanged(event, data) {
	      if (data.pairingId === vm.pairingId) {
	        filters.namedFilter = _.cloneDeep(data.namedFilter);
	        if (data.namedFilter) {
	          filters.userFilter = { and: [] };
	        }
	        $gzFilters.mergeFilters(filters);
	        if (vm.selectedFilter1 && vm.selectedFilter1.type === NAMED_FILTER) {
	          vm.selectedFilter1 = undefined;
	          vm.selectedFilter2 = undefined;
	        }
	        updateFilters();
	      }
	    }
	
	    function handleAdhocFilterChanged(event, data) {
	      if (data.pairingId === vm.pairingId) {
	        filters.adhocFilter = _.cloneDeep(data.adhocFilter);
	        $gzFilters.mergeFilters(filters);
	        updateFilters();
	      }
	    }
	
	    function handleQuickFilterChanged(event, data) {
	      if (data.pairingId === vm.pairingId) {
	        filters.quickFilter = _.cloneDeep(data.quickFilter);
	        updateFilters();
	      }
	    }
	
	    function handleFilterCountChanged(event, data) {
	      if (data.pairingId === vm.pairingId) {
	        vm.counts = _.cloneDeep(data.counts);
	      }
	    }
	
	    function handleSavedFilterAdded(event, data) {
	      if (data.pairingId === vm.pairingId) {
	        //Adding the newly added user filter to saved filter so that it should reflect in grid my filter menu
	        vm.savedFilters.push(data);
	        vm.savedFilters = _.sortBy(vm.savedFilters, function (filter) {
	          return filter.namedFilter.display;
	        });
	
	        loadSavedFilters();
	      }
	    }
	
	    function toggleFilter(event, filter) {
	      event.stopPropagation();
	      if (vm.selectedFilter1 && vm.selectedFilter1.type === filter.type) {
	        vm.selectedFilter1 = undefined;
	      } else {
	        vm.selectedFilter1 = filter;
	      }
	      vm.selectedFilter2 = undefined;
	    }
	
	    function toggleFilter1(event, filter) {
	      event.stopPropagation();
	      if (vm.selectedFilter2 && vm.selectedFilter2.type === filter.type) {
	        vm.selectedFilter2 = undefined;
	      } else {
	        vm.selectedFilter2 = filter;
	      }
	    }
	
	    function isExpandable(filter) {
	      return filter.type === NAMED_FILTER || filter.type === MATCH_ANY || filter.type === EXCLUDE;
	    }
	
	    function isExpanded(filter) {
	      return vm.selectedFilter1 !== undefined && vm.selectedFilter1.type === filter.type;
	    }
	
	    function isExpanded1(filter) {
	      return vm.selectedFilter2 !== undefined && vm.selectedFilter2.type === filter.type;
	    }
	
	    function selectFilter(event, filter) {
	      if (filter.type === ADHOC_FILTER) {
	        return;
	      }
	
	      if (filter.type === USER_FILTER) {
	        selectFilterById(filter.columnId);
	      } else {
	        toggleFilter(event, filter);
	      }
	    }
	
	    function selectFilter1(event, filter) {
	      if (filter.type === USER_FILTER) {
	        selectFilterById(filter.columnId);
	      } else {
	        toggleFilter1(event, filter);
	      }
	    }
	
	    function selectFilterById(id) {
	
	      if (vm.gridOptions) {
	        $gzFilters.openFilterDialog(vm.pairingId, vm.gridOptions.columns, filters, id);
	      }
	    }
	
	    function blowUpNamedFilter() {
	      var namedId = filters.namedFilter.id;
	      filters.userFilter = filters.mergedFilter;
	      delete filters.namedFilter;
	
	      // Tell listeners that named filter was removed so they can clear state
	      $rootScope.$emit('gzNamedFilterChangedEvent', {
	        pairingId: vm.pairingId,
	        suppressFilterBarRefresh: true
	      });
	
	      // Tell listeners that the user filters have changed (merged with what remains of named filter)
	      $rootScope.$emit('gzUserFilterChangedEvent', {
	        pairingId: vm.pairingId,
	        userFilter: _.cloneDeep(filters.mergedFilter)
	      });
	    }
	
	    function removeFilter1(displayFilter, $event) {
	      $event.stopPropagation();
	      if (vm.selectedFilter1.type === NAMED_FILTER) {
	        var and = _.get(filters, 'mergedFilter.and', []);
	        switch (displayFilter.type) {
	          case USER_FILTER:
	            removeFilterFromFilters(and, displayFilter.internalId);
	            adjustForSingleAndOrFilters(and);
	            break;
	          case MATCH_ANY:
	            _.remove(and, function (item) {
	              return item.or && item.or[0].columnId === displayFilter.id;
	            });
	            break;
	          case EXCLUDE:
	            _.remove(and, function (item) {
	              return item.and && item.and[0].columnId === displayFilter.id;
	            });
	            break;
	        }
	
	        blowUpNamedFilter();
	
	        vm.selectedFilter1 = undefined;
	        if (displayFilter === vm.selectedFilter2) {
	          vm.selectedFilter2 = undefined;
	        }
	
	        $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Clear filter', { label: 'Filter: ' + displayFilter.tooltip });
	      } else {
	        removeFilter(displayFilter);
	        vm.selectedFilter1 = _.find(vm.displayFilters, { id: vm.selectedFilter1.id });
	        if (vm.selectedFilter1.displayFilters.length < 2) {
	          vm.selectedFilter1 = undefined;
	        }
	      }
	      updateFilters();
	    }
	
	    function removeFilter2(displayFilter) {
	      //This has to be a Multi Match Any or Multi Exclude that is being removed from a named filter
	      var and = _.get(filters, 'mergedFilter.and', []);
	      removeFilterFromFilters(and, displayFilter.internalId);
	      adjustForSingleAndOrFilters(and);
	
	      blowUpNamedFilter();
	
	      vm.selectedFilter1 = undefined;
	      vm.selectedFilter2 = undefined;
	
	      updateFilters();
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Clear filter', { label: 'Filter: ' + displayFilter.tooltip });
	    }
	
	    function removeFilter(displayFilter) {
	      if (displayFilter.columnId) {
	        $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Clear user filter', { label: 'ColId: ' + displayFilter.columnId });
	      }
	
	      switch (displayFilter.type) {
	        case QUICK_FILTER:
	          delete filters.quick;
	          delete filters.quick;
	          $rootScope.$emit('gzQuickFilterChangedEvent', {
	            pairingId: vm.pairingId
	          });
	          $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Clear quick filter', { label: 'Filter: ' + displayFilter.display });
	          break;
	        case ADHOC_FILTER:
	          var and = _.get(filters, 'adhocFilter.and', []);
	          removeFilterFromFilters(and, displayFilter.internalId);
	          $rootScope.$emit('gzAdhocFilterChangedEvent', {
	            pairingId: vm.pairingId,
	            adhocFilter: _.cloneDeep(filters.adhocFilter),
	            suppressFilterBarRefresh: true
	          });
	          $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Clear adhoc filter', { label: 'FilterId: ' + displayFilter.id + ', Filter: ' + displayFilter.display });
	          break;
	        case USER_FILTER:
	          and = _.get(filters, 'userFilter.and', []);
	          removeFilterFromFilters(and, displayFilter.internalId);
	          adjustForSingleAndOrFilters(and);
	          $rootScope.$emit('gzUserFilterChangedEvent', {
	            pairingId: vm.pairingId,
	            userFilter: _.cloneDeep(filters.userFilter),
	            suppressFilterBarRefresh: true
	          });
	          $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Clear user filter', { label: 'FilterId: ' + displayFilter.id + ', Filter: ' + displayFilter.display });
	          break;
	        case MATCH_ANY:
	          and = _.get(filters, 'userFilter.and', []);
	          _.remove(and, function (item) {
	            return item.or && item.or[0].columnId === displayFilter.id;
	          });
	          $rootScope.$emit('gzUserFilterChangedEvent', {
	            pairingId: vm.pairingId,
	            userFilter: _.cloneDeep(filters.userFilter),
	            suppressFilterBarRefresh: true
	          });
	          vm.selectedFilter1 = undefined;
	          break;
	        case EXCLUDE:
	          and = _.get(filters, 'userFilter.and', []);
	          _.remove(and, function (item) {
	            return item.and && item.and[0].columnId === displayFilter.id;
	          });
	          $rootScope.$emit('gzUserFilterChangedEvent', {
	            pairingId: vm.pairingId,
	            userFilter: _.cloneDeep(filters.userFilter),
	            suppressFilterBarRefresh: true
	          });
	          break;
	        case NAMED_FILTER:
	          delete filters.namedFilter;
	          $rootScope.$emit('gzNamedFilterChangedEvent', {
	            pairingId: vm.pairingId,
	            suppressFilterBarRefresh: true
	          });
	          $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Clear named filter', { label: 'Filter: ' + displayFilter.tooltip });
	          break;
	      }
	
	      if (displayFilter === vm.selectedFilter1) {
	        vm.selectedFilter1 = undefined;
	      }
	
	      $rootScope.$emit('gzFilterRemovedEvent', {
	        pairingId: vm.pairingId,
	        filterId: displayFilter.id
	      });
	
	      updateFilters();
	    }
	
	    function removeFilterFromFilters(filters, id) {
	      _.remove(filters, { internalId: id });
	      _.forEach(filters, function (item) {
	        if (item.or) {
	          removeFilterFromFilters(item.or, id);
	        } else if (item.and) {
	          removeFilterFromFilters(item.and, id);
	        }
	      });
	    }
	
	    function adjustForSingleAndOrFilters(filters) {
	      _.forEach(filters, function (item) {
	        if (item.or && item.or.length === 1) {
	          filters.push(item.or[0]);
	        }
	        if (item.and && item.and.length === 1) {
	          filters.push(item.and[0]);
	        }
	      });
	
	      _.remove(filters, function (item) {
	        return item.or && item.or.length < 2 || item.and && item.and.length < 2;
	      });
	    }
	
	    function removeAllFilters() {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Clear all filters');
	      var test = _.get(filters, 'userFilter.and', []);
	      if (test.length > 0) {
	        $rootScope.$emit('gzUserFilterChangedEvent', {
	          pairingId: vm.pairingId
	        });
	      }
	
	      if (filters.quickFilter) {
	        $rootScope.$emit('gzQuickFilterChangedEvent', {
	          pairingId: vm.pairingId
	        });
	      }
	
	      if (filters.namedFilter) {
	        $rootScope.$emit('gzNamedFilterChangedEvent', {
	          pairingId: vm.pairingId
	        });
	      }
	
	      $rootScope.$emit('gzFilterRemoveAllEvent', {
	        pairingId: vm.pairingId
	      });
	
	      filters = {};
	      updateFilters();
	    }
	
	    function canSave() {
	      return _.get(filters, 'mergedFilter.and', []).length > 0;
	    }
	
	    function saveFilter() {
	      $gzAnalytics.eventOpen('Grid (' + vm.pairingId + ') - Save filter Dialog');
	      $gzFilters.openSaveFilterDialog(vm.pairingId, filters).then(function (savedFilter) {
	        var data = {
	          pairingId: vm.pairingId
	        };
	
	        if (savedFilter.namedFilter) {
	          data.namedFilter = savedFilter.namedFilter;
	        }
	
	        //Preventing quick filter save for filterMode=true view
	        if (!vm.filterMode) {
	          if (savedFilter.quickFilter) {
	            data.quickFilter = savedFilter.quickFilter;
	          }
	        }
	
	        $rootScope.$emit('gzSavedFilterAddedEvent', data);
	
	        if (filters.namedFilter) {
	          $rootScope.$emit('gzFilterRemovedEvent', {
	            pairingId: vm.pairingId
	          });
	        }
	
	        $rootScope.$emit('gzNamedFilterChangedEvent', {
	          pairingId: vm.pairingId,
	          namedFilter: savedFilter.namedFilter
	        });
	
	        loadSavedFilters();
	      });
	    }
	
	    //Grid's server Filters
	    function loadSavedFilters() {
	      return rnHttp.get(PORTAL_SERVICE_NAME, FILTERS_PATH).then(function (response) {
	        if (response) {
	          var myFilters = _.filter(response.data.filters, { pairingId: vm.pairingId });
	          //Fix up display
	          _.forEach(myFilters, function (filter) {
	            var display = {
	              title: filter.name
	            };
	            _.set(filter, 'namedFilter.display', display);
	          });
	          vm.savedFilters = _.sortBy(myFilters, function (filter) {
	            return filter.namedFilter.display;
	          });
	        }
	      })['catch'](function (error) {
	        return $log.error('Unable to retrieve saved filter', error);
	      });
	    }
	
	    function gzSavedFilterClicked($event, filter) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Saved Filter Clicked', { label: 'Filter: ' + filter.id });
	      $rootScope.$emit('gzNamedFilterChangedEvent', {
	        pairingId: vm.pairingId,
	        namedFilter: filter.namedFilter
	      });
	
	      if (filter.quickFilter) {
	        $rootScope.$emit('gzQuickFilterChangedEvent', {
	          pairingId: vm.pairingId,
	          quickFilter: filter.quickFilter,
	          force: true
	        });
	      }
	    }
	
	    function gzNamedFilterClicked($event, filter) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Named Filter Clicked', { label: 'Filter: ' + filter.id });
	      $rootScope.$emit('gzNamedFilterChangedEvent', {
	        pairingId: vm.pairingId,
	        namedFilter: filter
	      });
	    }
	
	    function gzRemoveFilterClicked($event, filter) {
	      $event.stopPropagation();
	      $event.preventDefault();
	      if (filter && filter.id) {
	        rnHttp['delete'](PORTAL_SERVICE_NAME, FILTERS_PATH + '/' + filter.id).then(function () {
	          _.remove(vm.savedFilters, { id: filter.id });
	
	          var message = filter.name + ' ' + $filter('translate')('uxf.uxf.Filter_Removed');
	          $mdToast.showSimple(message);
	          $gzAnalytics.eventDelete('Grid (' + vm.pairingId + ') - Filter ' + filter.name);
	        });
	      }
	    }
	
	    function gzRemoveBuiltInFilterClicked($event, filter) {
	      if (filter && filter.id) {
	        $rootScope.$emit('gzFilterRemovedEvent', {
	          pairingId: vm.pairingId,
	          filterId: filter.id
	        });
	
	        $rootScope.$emit('gzNamedFilterChangedEvent', {
	          pairingId: vm.pairingId,
	          userFilter: filters.namedFilter
	        });
	      }
	    }
	
	    function gzFilterClicked($event) {
	      var colId = arguments.length <= 1 || arguments[1] === undefined ? undefined : arguments[1];
	
	      $gzFilters.openFilterDialog(vm.pairingId, vm.gridOptions.columns, filters, colId);
	    }
	  }
	}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _filterBarDirective = __webpack_require__(315);
	
	var gzFilterBar = _interopRequireWildcard(_filterBarDirective);
	
	__webpack_require__(524);
	
	var _coreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _coreAnalyticsAnalyticsModule2 = _interopRequireDefault(_coreAnalyticsAnalyticsModule);
	
	exports['default'] = angular.module('gazelle.components.filterBar', ['pascalprecht.translate', 'angularMoment', 'ngMaterial', 'gazelle.components.filters', _coreAnalyticsAnalyticsModule2['default']]).directive(gzFilterBar.name, gzFilterBar['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Callback for submitting a search request, debounced by the filter box to reduce service calls.
	 * @callback searchRequest
	 * @param {string} simple query string to search for
	 */
	/**
	 * Typical PrintOS list count structure containing information about the total and limit query amounts
	 * @typedef {object} listCounts
	 * @property {number} total indicates the collection total
	 * @property {number} limit indicates the max number of returned items in the collection
	 * @property {number} offset indicates the index offset for the returned queried items
	 */
	/**
	 * @ngdoc directive
	 * @name gazelle.components.filterBox.directive:gzFilterBox
	 *
	 * @param {string} searchText scope property for storing the search text
	 * @param {searchRequest=} searchRequest callback for submitting a search request, debounced by the filter box to reduce service calls.
	 * @param {Promise<listCounts>|listCounts=} listCounts promise that resolves to an object (or is just the object)
	 *   containing list counts to determine if the complete data set is on the client. This object must contain the properties
	 *   `total` for the total number of items in the collection and `limit` for the max amount that was queried.
	 * @param {placeholder} override placeholder text (expects localized string)
	 *
	 * @description
	 * `<gz-filter-box>` provides a styled text input element for filtering data. It includes a magnifying glass icon on the
	 * far right of the input element when no text has been entered. Once text is entered the magnifying glass is replaced
	 * with a X icon to provide a clickable means to clear the input.
	 *
	 * The filter box also allows for a hybrid behavior where data may be filtered in the client with an angular `filter`
	 * or with a server query. If the `listCounts` promise is provided that resolves to the typical PrintOS list metadata,
	 * then the filter box can determine if the entire data set is available to the client. If so, the filter box will set
	 * the `searchText` reference. If the entire data set is not on the client, the filter box will invoke the `searchRequest`
	 * callback (if provided) in a debounced manner when user input is received.
	 *
	 * @example
	 * ````html
	 * <gz-filter-box
	 *  search-text='vm.userFilterText'
	 *  search-request='vm.queryFromServer'
	 *  list-counts='vm.initialQueryPromise'
	 *  placeholder='New placeholder text'>
	 * </gz-filter-box>
	 * ````
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzFilterBox;
	var name = 'gzFilterBox';
	exports.name = name;
	var SEARCH_REQUEST_DEBOUNCE_MILLIS = 1000;exports.SEARCH_REQUEST_DEBOUNCE_MILLIS = SEARCH_REQUEST_DEBOUNCE_MILLIS;
	// exported for testing
	
	function gzFilterBox() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzFilterBoxController.$inject = ["$log", "$q", "$translate", "$scope", "$rootScope", "$gzAnalytics"];
	  var directive = {
	    restrict: 'E',
	    scope: {
	      searchText: '=?',
	      searchRequest: '=?',
	      listCounts: '=?',
	      placeholder: '@',
	      changedCallback: '=?',
	      enterCallback: '=?',
	      filters: '=?',
	      pairingId: '@'
	    },
	    template: __webpack_require__(231),
	    controllerAs: 'vm',
	    bindToController: true,
	    controller: gzFilterBoxController
	  };
	
	  return directive;
	
	  /////////////////
	
	  // @ngInject
	  function gzFilterBoxController($log, $q, $translate, $scope, $rootScope, $gzAnalytics) {
	    var FILTER_TYPE = 'gzQuickFilter';
	    var vm = this;
	
	    vm.hasInput = false;
	
	    vm.keyupHandler = keyupHandler;
	    vm.keydownHandler = keydownHandler;
	    vm.keypressHandler = keypressHandler;
	    vm.clearInput = clearInput;
	    vm.inputText = inputText;
	
	    var hasAllData = true;
	    var _inputText = '';
	    var debouncedSearchRequest = undefined;
	    var filterRemoveListener = undefined;
	    var filterRemoveAllListener = undefined;
	    var quickFilterChangedListener = undefined;
	
	    activate();
	    return;
	
	    //////////////////
	    function activate() {
	      if (vm.filters) {
	        var quickFilter = _.get(vm.filters, 'quickFilter');
	        vm.filters = {};
	        if (quickFilter !== undefined) {
	          vm.filters.quickFilter = quickFilter;
	          vm.searchText = quickFilter.value;
	        }
	      } else {
	        vm.filters = {};
	      }
	
	      filterRemoveListener = $rootScope.$on('gzFilterRemovedEvent', function (event, data) {
	        if (data.filterId === FILTER_TYPE && vm.pairingId === data.pairingId) {
	          clearInput();
	        }
	      });
	
	      filterRemoveAllListener = $rootScope.$on('gzFilterRemoveAllEvent', function (event, data) {
	        if (vm.pairingId === data.pairingId) {
	          clearInput();
	        }
	      });
	
	      quickFilterChangedListener = $rootScope.$on('gzQuickFilterChangedEvent', function (event, data) {
	        if (vm.pairingId === data.pairingId && data.force) {
	          inputText(data.quickFilter.value);
	          vm.hasInput = true;
	        }
	      });
	
	      $scope.$on('$destroy', function () {
	        filterRemoveListener();
	        filterRemoveAllListener();
	        quickFilterChangedListener();
	      });
	
	      if (!vm.placeholder) {
	        $translate('uxf.uxf.QuickFilter_Placeholder').then(function (text) {
	          vm.placeholder = text;
	        });
	      }
	
	      if (vm.searchText !== undefined && vm.searchText !== null && vm.searchText !== '') {
	        inputText(vm.searchText);
	        vm.hasInput = true;
	      }
	
	      $scope.$watch('vm.searchText', function (newValue, oldValue) {
	        if (!newValue) {
	          newValue = '';
	        }
	
	        if (_inputText !== newValue) {
	          inputText(newValue);
	        }
	
	        vm.hasInput = _inputText.length > 0;
	      });
	
	      setHasAllData();
	      if (vm.searchRequest !== undefined) {
	        debouncedSearchRequest = _.debounce(vm.searchRequest, SEARCH_REQUEST_DEBOUNCE_MILLIS);
	      }
	    }
	
	    function setHasAllData() {
	      if (vm.listCounts === undefined) {
	        return;
	      }
	
	      $q.when(vm.listCounts).then(function (counts) {
	        if (counts.total === undefined) {
	          $log.warn('gzFilterBox expects listCounts with a total', counts);
	        }
	        if (counts.limit === undefined) {
	          $log.warn('gzFilterBox expects listCounts with a limit', counts);
	        }
	
	        hasAllData = counts.total <= counts.limit;
	      });
	    }
	
	    function keydownHandler($event) {
	      $event.stopPropagation();
	    }
	
	    function keyupHandler($event) {
	      $event.stopPropagation();
	      if ($event.keyCode === 13 && vm.enterCallback) {
	        vm.enterCallback($event);
	      }
	
	      if ($event.keyCode === 27) {
	        clearInput();
	      } else {
	        vm.hasInput = _inputText.length > 0;
	      }
	    }
	
	    function keypressHandler($event) {
	      $event.stopPropagation();
	    }
	
	    function clearInput($event) {
	      if ($event) {
	        $event.stopPropagation();
	      }
	
	      _inputText = '';
	      vm.hasInput = false;
	      handleInputChanged(_inputText, true);
	    }
	
	    // Use a combo getterSetter method for intercepting when the input changes.
	    function inputText(updatedText) {
	      if (arguments.length > 0) {
	        _inputText = updatedText;
	        handleInputChanged(updatedText);
	      }
	      return _inputText;
	    }
	
	    function handleInputChanged(updatedText) {
	      var immediate = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      if (hasAllData) {
	        vm.searchText = updatedText;
	      } else if (debouncedSearchRequest) {
	        vm.searchText = '';
	
	        if (immediate) {
	          // Cancel any pending debounced calls and immediately invoke an update
	          debouncedSearchRequest.cancel();
	          vm.searchRequest(updatedText);
	        } else {
	          debouncedSearchRequest(updatedText);
	        }
	      }
	
	      handleChangeCallback(updatedText);
	    }
	
	    function handleChangeCallback(searchText) {
	      if (searchText === '') {
	        if (vm.filters) {
	          delete vm.filters.quickFilter;
	        }
	      } else {
	        var quick = {
	          id: 'gzQuickFilter',
	          value: searchText
	        };
	        _.set(vm.filters, 'quickFilter', quick);
	      }
	
	      $rootScope.$emit('gzQuickFilterChangedEvent', {
	        pairingId: vm.pairingId,
	        quickFilter: vm.filters.quickFilter
	      });
	
	      if (searchText && searchText !== '') {
	        $gzAnalytics.event('Quick Filter (' + vm.pairingId + ')', { value: searchText });
	      }
	
	      if (vm.changedCallback) {
	        vm.changedCallback(searchText);
	      }
	    }
	  }
	}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(525);
	
	var _quickFilterQuickFilterModule = __webpack_require__(53);
	
	var _quickFilterQuickFilterModule2 = _interopRequireDefault(_quickFilterQuickFilterModule);
	
	var _filterBoxDirective = __webpack_require__(317);
	
	var gzFilterBox = _interopRequireWildcard(_filterBoxDirective);
	
	var _coreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _coreAnalyticsAnalyticsModule2 = _interopRequireDefault(_coreAnalyticsAnalyticsModule);
	
	exports['default'] = angular.module('gazelle.components.filterBox', ['pascalprecht.translate', _quickFilterQuickFilterModule2['default'],
	// Required for angular 1.6 $compile change handled in rhino core.config.js.
	// Consider moving somewhere else
	'rhino.core', _coreAnalyticsAnalyticsModule2['default']]).directive(gzFilterBox.name, gzFilterBox['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzQuickFilterFactory;
	var name = 'gzQuickFilter';
	
	exports.name = name;
	/**
	 * @ngdoc filter
	 * @name gazelle.components.filterBox.quickFilter.filter:gzQuickFilter
	 * @function
	 *
	 * @description
	 * Filters an array of objects with particular fields using a case insenstive match.
	 * The simple angular filter "filter" will check all fields,
	 * which leads to goofy matches like "ff" matching a user's ID and showing the user in a list.
	 * (Tied into filter-box module because the two will usually be used together.)
	 *
	 * @param {string} searchText text to search for
	 * @param {string[]} propertyNames array of property names to match (can use '.' notation for nested properties such as 'address.country')
	 *
	 * @returns {Object[]} containing specified properties that match the search text
	 *
	 * @example
	 * HTML
	 * ```html
	 * <tr ng-repeat="user in users.userList.users | gzQuickFilter:vm.searchText:['displayName', 'firstName', 'lastName']"></tr>
	 * ```
	 */
	
	function gzQuickFilterFactory() {
	  return qzQuickFilter;
	
	  function qzQuickFilter(inputObjects, searchText, propertyNames) {
	    if (!searchText) {
	      return inputObjects;
	    }
	    if (!_.isArray(inputObjects)) {
	      return inputObjects;
	    }
	    if (!_.isArray(propertyNames)) {
	      return inputObjects;
	    }
	
	    // case-insensitive search
	    searchText = searchText.toLowerCase();
	
	    return _.filter(inputObjects, function (input) {
	      return _.some(propertyNames, function (property) {
	        var propertyValue = _.get(input, property);
	        if (!_.isString(propertyValue)) {
	          return false;
	        }
	        return _.includes(propertyValue.toLowerCase(), searchText);
	      });
	    });
	  }
	}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	'use strict';
	
	gzFilterDialogController.$inject = ["columns", "filters", "pairingId", "columnId", "showServerIndicator", "$translate", "$mdDialog", "$rootScope", "moment", "$gzFilters", "$gzFields", "$gzAnalytics", "$timeout"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzFilterDialogController;
	var name = 'gzFilterDialogController';
	exports.name = name;
	
	function gzFilterDialogController(columns, filters, pairingId, columnId, showServerIndicator, $translate, $mdDialog, $rootScope, moment, $gzFilters, $gzFields, $gzAnalytics, $timeout) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var vm = this;
	  vm.columns = columns;
	  vm.filtersForm = null;
	
	  //
	  var stringOps = ['equals', 'notEqual', 'isEmpty', 'isNotEmpty', 'contains', 'startsWith', 'endsWith'];
	
	  var numberOps = ['equals', 'notEqual', 'isEmpty', 'isNotEmpty', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual', 'between'];
	
	  var dateOps = ['equals', 'isEmpty', 'isNotEmpty', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual', 'between', 'today', 'tomorrow', 'yesterday', 'thisWeek', 'nextWeek', 'lastWeek', 'future', 'past', 'lastSevenDays'];
	
	  var validDateValueOps = ['equals', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'];
	
	  var validDateRangeOps = ['between'];
	
	  var durationOps = ['greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'];
	
	  var mappedOps = ['matchAny', 'exclude'];
	
	  var myFilters = undefined;
	  vm.columnClicked = columnClicked;
	  vm.showFilter = showFilter;
	  vm.filterEnabled = filterEnabled;
	  vm.clearFilter = clearFilter;
	  vm.stringOpChanged = stringOpChanged;
	  vm.stringValueChanged = stringValueChanged;
	  vm.numberOpChanged = numberOpChanged;
	  vm.numberValueChanged = numberValueChanged;
	  vm.numberBeginChanged = numberBeginChanged;
	  vm.numberEndChanged = numberEndChanged;
	  vm.dateOpChanged = dateOpChanged;
	  vm.dateChanged = dateChanged;
	  vm.durationOpChanged = durationOpChanged;
	  vm.durationValueChanged = durationValueChanged;
	  vm.getMappedImage = getMappedImage;
	  vm.mappedOpChanged = mappedOpChanged;
	  vm.mappedValueChanged = mappedValueChanged;
	  vm.toggleMappedValue = toggleMappedValue;
	  vm.showDateValue = showDateValue;
	  vm.showDateRange = showDateRange;
	  vm.submit = submit;
	  vm.disableSubmit = disableSubmit;
	  vm.toggleEnabled = toggleEnabled;
	  vm.toggleClicked = toggleClicked;
	
	  vm.unitTest = {
	    getFilters: function getFilters() {
	      return myFilters;
	    },
	    setFilters: function setFilters(f) {
	      myFilters = f;
	    },
	    namedFilterModified: namedFilterModified,
	    removeFilter: removeFilter,
	    initColumnSelection: initColumnSelection,
	    getMappedDisplay: getMappedDisplay
	  };
	
	  activate();
	
	  //////////////////
	
	  function activate() {
	    vm.showLegend = parseLegend();
	    vm.showServerIndicator = vm.showLegend ? showServerIndicator : false;
	
	    initColumnTitles();
	    myFilters = _.cloneDeep(filters);
	    $gzFilters.mergeFilters(myFilters);
	
	    _.forEach(vm.columns, function (column) {
	      _.set(column, 'internal.enabled', filterEnabled(column));
	    });
	
	    var selectedColumn = undefined;
	    // Select a reasonable default column to select
	    if (columnId) {
	      // If a column is passed in then we use that
	      selectedColumn = _.find(vm.columns, { id: columnId });
	      vm.columnId = selectedColumn.id;
	      columnClicked(selectedColumn);
	      if (vm.selectedColumn && !vm.selectedColumn.internal.enabled) {
	        vm.selectedColumn.internal.enabled = true;
	        toggleEnabled(vm.selectedColumn);
	      }
	    }
	
	    if (!selectedColumn) {
	      // Look for first enabled column
	      _.forEach(vm.columns, function (column) {
	        if (column.internal.enabled) {
	          selectedColumn = column;
	          columnClicked(selectedColumn);
	          return false;
	        }
	      });
	
	      if (!selectedColumn) {
	        // Look for first valid column that supports filters
	        _.forEach(vm.columns, function (column) {
	          if (_.get(column, 'options.allowFilter', true)) {
	            selectedColumn = column;
	            columnClicked(selectedColumn);
	            return false;
	          }
	        });
	      }
	    }
	  }
	
	  function initColumnTitles() {
	    _.forEach(vm.columns, function (column) {
	      if (!column.header.title) {
	        var title = $gzFields.resolveString(column.header, 'title', column.id);
	        _.set(column, 'header.title', title);
	      }
	    });
	  }
	
	  function submit($event) {
	    myFilters.userFilter = _.cloneDeep(myFilters.mergedFilter);
	    filters.userFilter = myFilters.userFilter;
	    var namedFilter = _.get(myFilters, 'namedFilter.and');
	    if (namedFilter) {
	      if (namedFilterModified()) {
	        delete filters.namedFilter;
	        $rootScope.$emit('gzNamedFilterChangedEvent', {
	          pairingId: pairingId
	        });
	
	        $rootScope.$emit('gzFilterRemovedEvent', {
	          pairingId: pairingId,
	          filterId: myFilters.namedFilter.id
	        });
	      } else {
	        _.forEach(namedFilter, function (item) {
	          var colId = item.columnId;
	          if (item.and) {
	            colId = item.and[0].columnId;
	          } else if (item.or) {
	            colId = item.or[0].columnId;
	          }
	          _.remove(myFilters.userFilter.and, function (item) {
	            return item.columnId === colId || item.or && item.or[0].columnId === colId || item.and && item.and[0].columnId === colId;
	          });
	        });
	      }
	    }
	
	    var filterData = myFilters.userFilter.and.map(function (filter) {
	      return filter.columnId + ' ' + filter.op + ' ' + filter.value;
	    });
	
	    $gzAnalytics.event('Grid (' + pairingId + ') - Column filtered', { label: 'filter : ' + JSON.stringify(filterData) });
	    $rootScope.$emit('gzUserFilterChangedEvent', {
	      pairingId: pairingId,
	      userFilter: myFilters.userFilter
	    });
	
	    $mdDialog.hide(myFilters);
	  }
	
	  function namedFilterModified() {
	    var modified = false;
	    var namedFilter = _.get(myFilters, 'namedFilter.and');
	    var mergedFilter = _.get(myFilters, 'mergedFilter.and');
	    if (!namedFilter) {
	      return false;
	    }
	
	    _.forEach(namedFilter, function (item) {
	      if (modified) {
	        return false;
	      }
	      if (item.and) {
	        (function () {
	          var columnId = item.and[0].columnId;
	          var found = _.find(mergedFilter, function (item) {
	            return item.and && item.and[0].columnId === columnId;
	          });
	          if (found) {
	            if (item.and.length !== found.and.length) {
	              modified = true;
	            } else {
	              for (var i = 0; i < item.and.length; i++) {
	                var filter = item.and[i];
	                var test = _.find(found.and, { value: filter.value });
	                if (!test) {
	                  modified = true;
	                  break;
	                } else {
	                  if (filter.op !== test.op) {
	                    modified = true;
	                    break;
	                  }
	                }
	              }
	            }
	          } else {
	            modified = true;
	          }
	        })();
	      } else if (item.or) {
	        (function () {
	          var columnId = item.or[0].columnId;
	          var found = _.find(mergedFilter, function (item) {
	            return item.or && item.or[0].columnId === columnId;
	          });
	          if (found) {
	            if (item.or.length !== found.or.length) {
	              modified = true;
	            } else {
	              for (var i = 0; i < item.or.length; i++) {
	                var filter = item.or[i];
	                var test = _.find(found.or, { value: filter.value });
	                if (!test) {
	                  modified = true;
	                  break;
	                } else {
	                  if (filter.op !== test.op) {
	                    modified = true;
	                    break;
	                  }
	                }
	              }
	            }
	          } else {
	            modified = true;
	          }
	        })();
	      } else {
	        var found = _.find(mergedFilter, { columnId: item.columnId });
	        if (found) {
	          if (found.op !== item.op || found.value !== item.value) {
	            modified = true;
	          }
	        } else {
	          modified = true;
	        }
	      }
	    });
	
	    return modified;
	  }
	
	  function showDateValue() {
	    return validDateValueOps.indexOf(vm.dateOp) >= 0;
	  }
	
	  function showDateRange() {
	    return validDateRangeOps.indexOf(vm.dateOp) >= 0;
	  }
	
	  function columnClicked(column) {
	    if (!vm.selectedColumn || vm.selectedColumn.id !== column.id) {
	      vm.selectedColumn = column;
	      initColumnSelection(column);
	      $timeout(function () {
	        if (column.internal.enabled) {
	          if (vm.filtersForm) {
	            vm.filtersForm.$setSubmitted();
	          }
	        } else {
	          if (vm.filtersForm) {
	            vm.filtersForm.$setPristine();
	            vm.filtersForm.$setUntouched();
	          }
	        }
	      });
	    }
	  }
	
	  function showFilter(column) {
	    var showFilter = _.get(column, 'options.allowFilter', true);
	    return showFilter && column.type !== 'custom';
	  }
	
	  function parseLegend() {
	    var hasServerSideFilters = false;
	    _.forEach(vm.columns, function (column) {
	      var serverSideFilter = _.get(column, 'options.filter.isServerFilter', false);
	      if (serverSideFilter) {
	        hasServerSideFilters = true;
	        return false;
	      }
	    });
	
	    return vm.selectedColumn !== undefined && hasServerSideFilters;
	  }
	
	  function filterEnabled(column) {
	    var found = _.find(myFilters.mergedFilter.and, function (item) {
	      return item.columnId === column.id || item.or && item.or[0].columnId === column.id || item.and && item.and[0].columnId === column.id;
	    });
	
	    if (found) {
	      return true;
	    }
	
	    return false;
	  }
	
	  function clearFilter($event, column) {
	    $event.stopPropagation();
	    var and = _.get(myFilters, 'mergedFilter.and', []);
	    removeColumnFilter(column.id);
	    if (vm.selectedColumn && vm.selectedColumn.id === column.id) {
	      initColumnSelection(column);
	    }
	  }
	
	  function removeColumnFilter(colId) {
	    var and = _.get(myFilters, 'mergedFilter.and', []);
	    _.remove(and, function (item) {
	      return item.columnId === colId || item.or && item.or[0].columnId === colId || item.and && item.and[0].columnId === colId;
	    });
	  }
	
	  function removeFilter(internalId) {
	    var and = _.get(myFilters, 'mergedFilter.and', []);
	    _.remove(and, { internalId: internalId });
	    _.forEach(and, function (item) {
	      if (item.and) {
	        _.remove(item.and, { internalId: internalId });
	      } else if (item.or) {
	        _.remove(item.or, { internalId: internalId });
	      }
	    });
	
	    adjustForSingleOrFilters(and);
	  }
	
	  function adjustForSingleOrFilters(filters) {
	    _.forEach(filters, function (item) {
	      if (item.or && item.or.length === 1) {
	        filters.push(item.or[0]);
	      }
	
	      if (item.and && item.and.length === 1) {
	        filters.push(item.and[0]);
	      }
	    });
	
	    _.remove(filters, function (item) {
	      return item.or && item.or.length < 2 || item.and && item.and.length < 2;
	    });
	  }
	
	  function initColumnSelection(column) {
	    if (!column) {
	      return;
	    }
	
	    switch (column.type) {
	      case 'string':
	        setupStringFilter(column);
	        break;
	      case 'number':
	        setupNumberFilter(column);
	        break;
	      case 'date':
	        setupDateFilter(column);
	        break;
	      case 'mapped':
	        setupMappedFilter(column);
	        break;
	      case 'duration':
	        setupDurationFilter(column);
	        break;
	      default:
	        break;
	    }
	
	    if (vm.filtersForm) {
	      vm.filtersForm.$setPristine();
	      vm.filtersForm.$setUntouched();
	    }
	  }
	
	  function setupStringFilter(column) {
	    var conditions = _.get(column, 'options.filter.supportedOps');
	    if (!conditions) {
	      conditions = stringOps;
	    }
	    vm.stringOps = conditions;
	
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: column.id });
	    if (found) {
	      vm.stringOp = found.op;
	      vm.stringValue = found.value;
	    } else {
	      var defaultOp = _.get(column, 'options.filter.defaultOp', 'contains');
	      vm.stringOp = defaultOp;
	      vm.stringValue = undefined;
	    }
	
	    var element = document.getElementById('filter-string-value');
	    if (element) {
	      element.focus();
	    }
	  }
	
	  function isNamedFilter(colId) {
	    var named = false;
	    if (myFilters.namedFilter && myFilters.namedFilter.namedColIds && myFilters.namedFilter.namedColIds.indexOf(colId) > -1) {
	      named = true;
	    }
	
	    return named;
	  }
	
	  function stringOpChanged(op) {
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: vm.selectedColumn.id });
	    if (found) {
	      found.op = op;
	      if (op !== 'isEmpty' && op !== 'isNotEmpty' && isEmptyString(vm.stringValue)) {
	        removeColumnFilter(vm.selectedColumn.id);
	      }
	    } else {
	      if (op === 'isEmpty' || op === 'isNotEmpty') {
	        vm.stringValue = undefined;
	        addStringFilter();
	      }
	    }
	  }
	
	  function stringValueChanged() {
	    if (isEmptyString(vm.stringValue)) {
	      removeColumnFilter(vm.selectedColumn.id);
	    } else {
	      addStringFilter();
	    }
	  }
	
	  function isEmptyString(value) {
	    return value === undefined || value === null || value === '';
	  }
	
	  function emptyNumber(value) {
	    return value === undefined || value === null || value === '';
	  }
	
	  function addStringFilter() {
	    var column = vm.selectedColumn;
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: column.id });
	    if (!found) {
	      var filter = {
	        columnId: column.id,
	        op: vm.stringOp,
	        value: vm.stringValue
	      };
	
	      $gzFilters.setInternalId(myFilters, filter);
	      and.push(filter);
	    } else {
	      found.value = vm.stringValue;
	    }
	  }
	
	  function setupNumberFilter(column) {
	    var conditions = _.get(column, 'options.filter.supportedOps');
	    if (!conditions) {
	      conditions = numberOps;
	    }
	    vm.numberOps = conditions;
	
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: column.id });
	    if (found) {
	      vm.numberOp = found.op;
	      vm.numberBegin = found.begin;
	      vm.numberEnd = found.end;
	      vm.numberValue = found.value;
	    } else {
	      var defaultOp = _.get(column, 'options.filter.defaultOp', 'equals');
	      vm.numberOp = defaultOp;
	      vm.numberValue = undefined;
	      vm.numberBegin = undefined;
	      vm.numberEnd = undefined;
	    }
	  }
	
	  function numberOpChanged(op) {
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: vm.selectedColumn.id });
	    if (found) {
	      found.op = op;
	      if (op !== 'isEmpty' && op !== 'isNotEmpty') {
	        if (emptyNumber(vm.numberValue)) {
	          removeColumnFilter(vm.selectedColumn.id);
	        }
	      }
	    } else {
	      if (op === 'isEmpty' || op === 'isNotEmpty') {
	        addNumberFilter();
	      }
	    }
	  }
	
	  function numberValueChanged() {
	    if (emptyNumber(vm.numberValue)) {
	      removeColumnFilter(vm.selectedColumn.id);
	    } else {
	      addNumberFilter();
	    }
	  }
	
	  function numberBeginChanged() {
	    if (vm.numberBegin === '' || vm.numberEnd === '') {
	      removeColumnFilter(vm.selectedColumn.id);
	    } else {
	      addNumberFilter();
	    }
	  }
	
	  function numberEndChanged() {
	    if (vm.numberBegin === '' || vm.numberEnd === '') {
	      removeColumnFilter(vm.selectedColumn.id);
	    } else {
	      addNumberFilter();
	    }
	  }
	
	  function addNumberFilter() {
	    var column = vm.selectedColumn;
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: column.id });
	    if (!found) {
	      var filter = {
	        columnId: column.id,
	        op: vm.numberOp,
	        value: vm.numberValue,
	        begin: vm.numberBegin,
	        end: vm.numberEnd
	      };
	
	      $gzFilters.setInternalId(myFilters, filter);
	      and.push(filter);
	    } else {
	      found.value = vm.numberValue;
	      found.begin = vm.numberBegin;
	      found.end = vm.numberEnd;
	    }
	  }
	
	  function setupDateFilter(column) {
	    var conditions = _.get(column, 'options.filter.supportedOps');
	    if (!conditions) {
	      conditions = dateOps;
	    }
	    vm.dateOps = conditions;
	
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: column.id });
	    if (found) {
	      vm.dateOp = found.op ? found.op : 'equals';
	      vm.dateValue = found.value ? new Date(found.value) : new Date();
	      vm.dateBegin = found.begin ? new Date(found.begin) : new Date();
	      vm.dateEnd = found.end ? new Date(found.end) : new Date();
	    } else {
	      vm.dateValue = new Date();
	      vm.dateBegin = new Date();
	      vm.dateEnd = new Date();
	      vm.dateOp = 'equals';
	    }
	  }
	
	  function dateOpChanged(op) {
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: vm.selectedColumn.id });
	    if (found) {
	      found.op = op;
	    } else {
	      var filter = {
	        columnId: vm.selectedColumn.id,
	        op: vm.dateOp,
	        value: moment(vm.dateValue).utc().toISOString(),
	        begin: moment(vm.dateBegin).utc().toISOString(),
	        end: moment(vm.dateEnd).utc().toISOString()
	      };
	      $gzFilters.setInternalId(myFilters, filter);
	      and.push(filter);
	    }
	  }
	
	  function dateChanged() {
	    updateDateFilter();
	  }
	
	  function updateDateFilter() {
	    var column = vm.selectedColumn;
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: column.id });
	    if (found) {
	      found.value = moment(vm.dateValue).utc().toISOString();
	      found.begin = moment(vm.dateBegin).utc().toISOString();
	      found.end = moment(vm.dateEnd).utc().toISOString();
	    }
	  }
	
	  function getMappedImage(value) {
	    var column = vm.selectedColumn;
	    switch (column.field.mapped.display) {
	      case 'active':
	      case 'on':
	      case 'true':
	      case 'yes':
	        return value ? 'fa-check-circle status-green' : 'fa-times-circle status-red';
	      case 'locked':
	        return value ? 'fa-lock status-red' : 'fa-unlock status-green';
	      case 'status':
	        switch (value.toUpperCase()) {
	          case 'OK':
	            return 'fa-check-circle status-green';
	          case 'WARN':
	            return 'fa-exclamation-circle status-yellow';
	          case 'ERROR':
	            return 'fa-times-circle status-red';
	          case 'INFO':
	            return 'fa-info-circle status-blue';
	          case 'UNKNOWN':
	            return 'fa-question-circle';
	        }
	        break;
	      case 'lookup':
	        var lookup = _.get(column, 'field.mapped.lookup');
	        if (lookup.imageType === 'fa') {
	          return 'fa-' + $translate.instant(lookup.imageBase + value);
	        }
	        break;
	      case 'values':
	        var values = _.get(column, 'field.mapped.values');
	        if (values) {
	          var found = _.find(values, { value: value });
	          if (found) {
	            if (found.imageType === 'fa') {
	              return 'fa-' + found.image;
	            }
	          }
	        }
	        break;
	    }
	  }
	
	  function getMappedDisplay(value) {
	    var column = vm.selectedColumn;
	    switch (column.field.mapped.display) {
	      case 'active':
	        return value ? $translate.instant('uxf.uxf.Grid_Active') : $translate.instant('uxf.uxf.Grid_Inactive');
	      case 'on':
	        return value ? $translate.instant('uxf.uxf.Grid_On') : $translate.instant('uxf.uxf.Grid_Off');
	      case 'true':
	        return value ? $translate.instant('uxf.uxf.Grid_True') : $translate.instant('uxf.uxf.Grid_False');
	      case 'yes':
	        return value ? $translate.instant('uxf.uxf.Grid_Yes') : $translate.instant('uxf.uxf.Grid_No');
	      case 'locked':
	        return value ? $translate.instant('uxf.uxf.Grid_Locked') : $translate.instant('uxf.uxf.Grid_Unlocked');
	      case 'status':
	        switch (value.toUpperCase()) {
	          case 'OK':
	            return $translate.instant('uxf.uxf.Grid_Ok');
	          case 'WARN':
	            return $translate.instant('uxf.uxf.Grid_Warn');
	          case 'ERROR':
	            return $translate.instant('uxf.uxf.Grid_Error');
	          case 'INFO':
	            return $translate.instant('uxf.uxf.Grid_Info');
	          case 'UNKNOWN':
	            return $translate.instant('uxf.uxf.Grid_Unknown');
	        }
	        break;
	      case 'lookup':
	        var lookup = _.get(column, 'field.mapped.lookup');
	        if (lookup) {
	          return $gzFields.resolveString(lookup, 'title', value);
	        }
	        break;
	      case 'values':
	        var values = _.get(column, 'field.mapped.values');
	        var found = _.find(values, { value: value });
	        if (found) {
	          return $gzFields.resolveString(found, 'title', value);
	        }
	        break;
	    }
	  }
	
	  function setupMappedFilter(column) {
	    vm.mappedValues = undefined;
	    vm.mappedValue = undefined;
	
	    var values = undefined;
	    switch (column.field.mapped.display) {
	      case 'active':
	        values = [true, false];
	        break;
	      case 'on':
	        values = [true, false];
	        break;
	      case 'true':
	        values = [true, false];
	        break;
	      case 'yes':
	        values = [true, false];
	        break;
	      case 'locked':
	        values = [true, false];
	        break;
	      case 'status':
	        vm.mappedOps = mappedOps;
	        vm.mappedOp = 'matchAny';
	        values = ['OK', 'INFO', 'WARN', 'ERROR', 'UNKNOWN'];
	        break;
	      case 'lookup':
	        vm.mappedOps = mappedOps;
	        break;
	      case 'values':
	        vm.mappedOps = mappedOps;
	        vm.mappedOp = 'matchAny';
	        values = [];
	        _.forEach(column.field.mapped.values, function (value) {
	          values.push(value.value);
	        });
	        break;
	    }
	
	    if (values) {
	      vm.mappedValues = _.map(values, function (value) {
	        return {
	          value: value,
	          display: getMappedDisplay(value)
	        };
	      });
	    }
	
	    vm.mappedSelection = {};
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: column.id });
	    if (found) {
	      //Single value set
	      vm.mappedValue = {
	        value: found.value,
	        display: getMappedDisplay(found.value)
	      };
	      _.set(vm.mappedSelection, found.value, true);
	      if (found.op === 'notEqual') {
	        vm.mappedOp = 'exclude';
	      }
	    } else {
	      found = _.find(and, function (item) {
	        return item.or && item.or[0].columnId === column.id || item.and && item.and[0].columnId === column.id;
	      });
	
	      if (found) {
	        if (found.and) {
	          vm.mappedOp = 'exclude';
	          _.forEach(found.and, function (filter) {
	            _.set(vm.mappedSelection, filter.value, true);
	          });
	        } else if (found.or) {
	          vm.mappedOp = 'matchAny';
	          _.forEach(found.or, function (filter) {
	            _.set(vm.mappedSelection, filter.value, true);
	          });
	        }
	      } else {
	        if (vm.mappedValues.length > 0 && column.field.mapped.display !== 'values' && column.field.mapped.display !== 'lookup' && column.field.mapped.display !== 'status') {
	          vm.mappedValue = vm.mappedValues[0];
	          _.set(vm.mappedSelection, true, true);
	        }
	      }
	    }
	  }
	
	  function durationOpChanged(op) {
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: vm.selectedColumn.id });
	    if (found) {
	      found.op = op;
	    } else {
	      var filter = {
	        columnId: vm.selectedColumn.id,
	        op: vm.durationOp,
	        value: getDurationValue(vm.daysValue, vm.hoursValue, vm.minutesValue, vm.secondsValue)
	      };
	
	      $gzFilters.setInternalId(myFilters, filter);
	      and.push(filter);
	    }
	  }
	
	  function setupDurationFilter(column) {
	    var conditions = _.get(column, 'options.filter.supportedOps');
	    if (!conditions) {
	      conditions = durationOps;
	    }
	    vm.durationOps = conditions;
	
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var filter = _.find(and, { columnId: column.id });
	    if (filter) {
	      vm.durationOp = filter.op;
	      var precision = _.get(column, 'field.duration.precision', 'ms');
	      var s_ms_adjustment = 1;
	      if (precision === 's') {
	        s_ms_adjustment = 1000;
	      }
	
	      var x = Math.floor(filter.value * s_ms_adjustment / 1000);
	
	      vm.secondsValue = x % 60;
	      x = Math.floor(x / 60);
	      vm.minutesValue = x % 60;
	      x = Math.floor(x / 60);
	      vm.hoursValue = x % 24;
	      x = Math.floor(x / 24);
	      vm.daysValue = x;
	    } else {
	      vm.durationOp = 'greaterThan';
	      vm.daysValue = 0;
	      vm.hoursValue = 0;
	      vm.minutesValue = 0;
	      vm.secondsValue = 0;
	    }
	  }
	
	  function durationValueChanged() {
	    var column = vm.selectedColumn;
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: column.id });
	    if (found) {
	      var precision = _.get(column, 'field.duration.precision', 'ms');
	      found.value = getDurationValue(precision);
	    }
	  }
	
	  function getDurationValue(precision) {
	    var s_ms_adjustment = 1000;
	    if (precision === 's') {
	      s_ms_adjustment = 1;
	    }
	
	    var d = 0;
	    var h = 0;
	    var m = 0;
	    var s = 0;
	
	    if (vm.daysValue !== undefined && vm.daysValue !== null && vm.daysValue !== '' && vm.daysValue > 0) {
	      d = vm.daysValue;
	    }
	
	    if (vm.hoursValue !== undefined && vm.hoursValue !== null && vm.hoursValue !== '' && vm.hoursValue > 0) {
	      h = vm.hoursValue;
	    }
	
	    if (vm.minutesValue !== undefined && vm.minutesValue !== null && vm.minutesValue !== '' && vm.minutesValue > 0) {
	      m = vm.minutesValue;
	    }
	
	    if (vm.secondsValue !== undefined && vm.secondsValue !== null && vm.secondsValue !== '' && vm.secondsValue > 0) {
	      s = vm.secondsValue;
	    }
	
	    return d * 24 * 60 * 60 * s_ms_adjustment + h * 60 * 60 * s_ms_adjustment + m * 60 * s_ms_adjustment + s * s_ms_adjustment;
	  }
	
	  function mappedOpChanged(op) {
	    var and = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(and, { columnId: vm.selectedColumn.id });
	    if (found) {
	      // Single Value version exists
	      if (op === 'matchAny') {
	        found.op = 'equals';
	      } else {
	        found.op = 'notEqual';
	      }
	    } else {
	      found = _.find(and, function (item) {
	        return item.or && item.or[0].columnId === vm.selectedColumn.id;
	      });
	
	      if (found) {
	        (function () {
	          // Multi 'Match Any' version exists
	          // Add 'Exclude' (and) version
	          var exclude = { and: [] };
	          _.forEach(found.or, function (orItem) {
	            orItem.op = 'notEqual';
	            exclude.and.push(orItem);
	          });
	
	          and.push(exclude);
	
	          // Remove 'Match Any' (or) version
	          _.remove(and, function (item) {
	            return item.or && item.or[0].columnId === vm.selectedColumn.id;
	          });
	        })();
	      } else {
	        found = _.find(and, function (item) {
	          return item.and && item.and[0].columnId === vm.selectedColumn.id;
	        });
	
	        if (found) {
	          (function () {
	            // Multi 'Exclude' version exists
	            // Add 'Match Any' (or) version
	            var matchAny = { or: [] };
	            _.forEach(found.and, function (andItem) {
	              andItem.op = 'equals';
	              matchAny.or.push(andItem);
	            });
	
	            and.push(matchAny);
	
	            // Remove 'Exclude' (and) version
	            _.remove(and, function (item) {
	              return item.and && item.and[0].columnId === vm.selectedColumn.id;
	            });
	          })();
	        }
	      }
	    }
	  }
	
	  function mappedValueChanged(value) {
	    var and = _.get(myFilters, 'mergedFilter.and');
	    if (value === undefined) {
	      _.remove(and, { columnId: vm.selectedColumn.id });
	    } else {
	      var found = _.find(and, { columnId: vm.selectedColumn.id });
	      if (found) {
	        found.value = value;
	      } else {
	        var filter = {
	          columnId: vm.selectedColumn.id,
	          op: 'equals',
	          value: value
	        };
	
	        $gzFilters.setInternalId(myFilters, filter);
	        and.push(filter);
	      }
	    }
	  }
	
	  function toggleMappedValue(value) {
	    var mergedFilter = _.get(myFilters, 'mergedFilter.and');
	    var found = _.find(mergedFilter, { columnId: vm.selectedColumn.id });
	    if (found) {
	      // Single Value version exists
	      if (value === found.value) {
	        // Removing Existing Value (toggled off)
	        removeColumnFilter(vm.selectedColumn.id);
	      } else {
	        var filter = {
	          columnId: vm.selectedColumn.id,
	          value: value
	        };
	
	        // Adding new value to Single Value (Converting to Multi)
	        if (vm.mappedOp === 'matchAny') {
	          var or = { or: [] };
	          found.op = 'equals';
	          or.or.push(found);
	
	          filter.op = 'equals';
	          $gzFilters.setInternalId(myFilters, filter);
	          or.or.push(filter);
	          mergedFilter.push(or);
	        } else {
	          var and = { and: [] };
	          found.op = 'notEqual';
	          and.and.push(found);
	
	          filter.op = 'notEqual';
	          $gzFilters.setInternalId(myFilters, filter);
	          and.and.push(filter);
	          mergedFilter.push(and);
	        }
	
	        _.remove(mergedFilter, { columnId: vm.selectedColumn.id });
	      }
	    } else {
	      found = _.find(mergedFilter, function (item) {
	        return item.or && item.or[0].columnId === vm.selectedColumn.id;
	      });
	
	      if (found) {
	        // Multi 'Match Any' (or) version exists
	        var current = _.find(found.or, { value: value });
	        if (current) {
	          removeFilter(current.internalId);
	        } else {
	          // Adding Value to filter
	          var filter = {
	            columnId: vm.selectedColumn.id,
	            op: 'equals',
	            value: value
	          };
	
	          $gzFilters.setInternalId(myFilters, filter);
	          found.or.push(filter);
	        }
	      } else {
	        found = _.find(mergedFilter, function (item) {
	          return item.and && item.and[0].columnId === vm.selectedColumn.id;
	        });
	
	        if (found) {
	          // Multi 'Exclude' (and) version exists
	          var current = _.find(found.and, { value: value });
	          if (current) {
	            removeFilter(current.internalId);
	          } else {
	            // Adding Value to filter
	            var filter = {
	              columnId: vm.selectedColumn.id,
	              op: 'notEqual',
	              value: value
	            };
	
	            $gzFilters.setInternalId(myFilters, filter);
	            found.and.push(filter);
	          }
	        } else {
	          // Adding Single Value
	          var filter = {
	            columnId: vm.selectedColumn.id,
	            value: value
	          };
	
	          if (vm.mappedOp === 'matchAny') {
	            filter.op = 'equals';
	          } else {
	            filter.op = 'notEqual';
	          }
	
	          $gzFilters.setInternalId(myFilters, filter);
	          mergedFilter.push(filter);
	        }
	      }
	    }
	  }
	
	  function disableSubmit() {
	    if (vm.filtersForm.$invalid) {
	      return true;
	    }
	
	    var enabledColumn = _.find(vm.columns, function (column) {
	      return column.internal.enabled === true;
	    });
	
	    if (!enabledColumn) {
	      return true;
	    }
	
	    var disable = false;
	    _.forEach(vm.columns, function (column) {
	      if (column.internal.enabled && !filterEnabled(column)) {
	        disable = true;
	        return false;
	      }
	    });
	
	    return disable;
	  }
	
	  function toggleClicked(column, $event) {
	    $event.stopPropagation();
	    if ($event && column.id !== _.get(vm, 'selectedColumn.id')) {
	      columnClicked(column);
	    }
	  }
	
	  function toggleEnabled(column) {
	    if (column.internal.enabled) {
	      switch (column.type) {
	        case 'string':
	          stringOpChanged(vm.stringOp);
	          break;
	        case 'number':
	          numberOpChanged(vm.numberOp);
	          break;
	        case 'date':
	          dateOpChanged(vm.dateOp);
	          break;
	        case 'mapped':
	          if (_.get(vm, 'mappedValue.value')) {
	            mappedValueChanged(vm.mappedValue.value);
	          }
	          break;
	        case 'duration':
	          durationOpChanged(vm.durationOp);
	          break;
	        default:
	          break;
	      }
	
	      if (vm.filtersForm) {
	        vm.filtersForm.$setSubmitted();
	      }
	    } else {
	      if (vm.filtersForm) {
	        vm.filtersForm.$setPristine();
	        vm.filtersForm.$setUntouched();
	      }
	      removeColumnFilter(column.id);
	    }
	  }
	}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _filtersService = __webpack_require__(322);
	
	var $gzFilters = _interopRequireWildcard(_filtersService);
	
	var _filterDialogFilterDialogController = __webpack_require__(320);
	
	var editFilters = _interopRequireWildcard(_filterDialogFilterDialogController);
	
	var _saveDialogSaveDialogController = __webpack_require__(323);
	
	var saveFilter = _interopRequireWildcard(_saveDialogSaveDialogController);
	
	var _coreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _coreAnalyticsAnalyticsModule2 = _interopRequireDefault(_coreAnalyticsAnalyticsModule);
	
	exports['default'] = angular.module('gazelle.components.filters', ['ngMaterial', 'angularMoment', 'pascalprecht.translate', 'gazelle.components.fields', 'rhino.core', _coreAnalyticsAnalyticsModule2['default']]).service($gzFilters.name, $gzFilters['default']).controller(editFilters.name, editFilters['default']).controller(saveFilter.name, saveFilter['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	$gzFilters.$inject = ["$mdDialog", "$translate", "$gzFields", "moment"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzFilters;
	var name = '$gzFilters';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name gazelle.components.filters.service:$gzFilters
	 *
	 * @description
	 * The $gzFilters service provides helpers to use with filter definitions
	 *
	 */
	
	function $gzFilters($mdDialog, $translate, $gzFields, moment) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var unitTest = {};
	
	  var service = {
	    openFilterDialog: openFilterDialog,
	    openSaveFilterDialog: openSaveFilterDialog,
	    createFiltersObject: createFiltersObject,
	    mergeFilters: mergeFilters,
	    setInternalId: setInternalId,
	    evaluateOr: evaluateOr,
	    evaluateAnd: evaluateAnd,
	    evaluateExpression: evaluateExpression,
	    getServerFilters: getServerFilters,
	    unitTest: unitTest
	  };
	
	  activate();
	  return service;
	
	  function activate() {}
	
	  //
	  // Public functions
	  //
	  function openFilterDialog(pairingId, columns, filters) {
	    var columnId = arguments.length <= 3 || arguments[3] === undefined ? undefined : arguments[3];
	    var showServerIndicator = arguments.length <= 4 || arguments[4] === undefined ? true : arguments[4];
	
	    return $mdDialog.show({
	      template: __webpack_require__(232),
	      controller: 'gzFilterDialogController',
	      controllerAs: 'vm',
	      multiple: true,
	      locals: {
	        pairingId: pairingId,
	        columns: columns,
	        filters: filters,
	        columnId: columnId,
	        showServerIndicator: showServerIndicator
	      }
	    });
	  }
	
	  function openSaveFilterDialog(pairingId, filters) {
	    return $mdDialog.show({
	      template: __webpack_require__(233),
	      controller: 'gzSaveDialogController',
	      controllerAs: 'vm',
	      locals: {
	        pairingId: pairingId,
	        filters: filters
	      }
	    }).then(function (savedFilter) {
	      return savedFilter;
	    });
	  }
	
	  function createFiltersObject() {
	    var filters = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var myFilters = undefined;
	    if (filters && (filters.userFilter || filters.quickFilter)) {
	      var userFilter = _.get(filters, 'userFilter');
	      var quickFilter = _.get(filters, 'quickFilter');
	      var namedFilter = _.get(filters, 'namedFilter');
	      var mergedFilter = _.get(filters, 'mergedFilter');
	      myFilters = {};
	      if (userFilter !== undefined) {
	        myFilters.userFilter = userFilter;
	      }
	      if (quickFilter !== undefined) {
	        myFilters.quickFilter = quickFilter;
	      }
	      if (namedFilter !== undefined) {
	        myFilters.namedFilter = namedFilter;
	      }
	      if (mergedFilter !== undefined) {
	        myFilters.mergedFilter = mergedFilter;
	      }
	    } else {
	      myFilters = {};
	      myFilters.userFilter = { and: [] };
	      myFilters.mergedFilter = { and: [] };
	    }
	
	    return myFilters;
	  }
	
	  function setInternalId(filters, expression) {
	    var nextIndex = _.get(filters, 'internalId', 0);
	    expression.internalId = nextIndex++;
	    filters.internalId = nextIndex;
	  }
	
	  function mergeFilters(filters) {
	    var userFilter = _.get(filters, 'userFilter.and', []);
	    var namedFilter = _.get(filters, 'namedFilter.and', []);
	    var adhocFilter = _.get(filters, 'adhocFilter.and', []);
	    var mergedFilter = [];
	    var userColIds = [];
	    var nextFilterIndex = _.get(filters, 'nextIndex');
	    if (!nextFilterIndex) {
	      nextFilterIndex = 0;
	    }
	
	    var currentId = undefined;
	    _.forEach(userFilter, function (filter) {
	      if (filter.and) {
	        currentId = filter.and[0].columnId;
	        _.forEach(filter.and, function (andFilter) {
	          _.set(andFilter, 'internalId', nextFilterIndex++);
	        });
	      } else if (filter.or) {
	        currentId = filter.or[0].columnId;
	        _.forEach(filter.or, function (orFilter) {
	          _.set(orFilter, 'internalId', nextFilterIndex++);
	        });
	      } else {
	        currentId = filter.columnId;
	        filter.internalId = nextFilterIndex++;
	      }
	      userColIds.push(currentId);
	      mergedFilter.push(_.cloneDeep(filter));
	    });
	
	    _.forEach(adhocFilter, function (filter) {
	      _.set(filter, 'internalId', nextFilterIndex++);
	    });
	
	    _.forEach(namedFilter, function (filter) {
	      if (filter.and) {
	        currentId = filter.and[0].columnId;
	        _.forEach(filter.and, function (andFilter) {
	          _.set(andFilter, 'internalId', nextFilterIndex++);
	        });
	      } else if (filter.or) {
	        currentId = filter.or[0].columnId;
	        _.forEach(filter.or, function (orFilter) {
	          _.set(orFilter, 'internalId', nextFilterIndex++);
	        });
	      } else {
	        filter.internalId = nextFilterIndex++;
	        currentId = filter.columnId;
	      }
	
	      if (userColIds.indexOf(currentId) === -1) {
	        mergedFilter.push(_.cloneDeep(filter));
	      }
	    });
	
	    if (filters) {
	      filters.nextIndex = nextFilterIndex;
	    }
	
	    _.set(filters, 'mergedFilter.and', mergedFilter);
	    return mergedFilter;
	  }
	
	  ///////////////Filter Functions////////////////////////
	  ///////////////////////////////////////////////////////
	  function evaluateOr(or, node, columns) {
	    var pass = false;
	    _.forEach(or, function (item) {
	      var test = false;
	      if (item.or) {
	        test = evaluateOr(item.or, node, columns);
	      } else if (item.and) {
	        test = evaluateAnd(item.and, node, columns);
	      } else {
	        test = evaluateExpression(item, node, columns);
	      }
	
	      if (test) {
	        pass = true;
	        return false;
	      }
	    });
	
	    return pass;
	  }
	
	  function evaluateAnd(and, node, columns) {
	    var pass = true;
	    _.forEach(and, function (item) {
	      var test = true;
	      if (item.or) {
	        test = evaluateOr(item.or, node, columns);
	      } else if (item.and) {
	        test = evaluateAnd(item.and, node, columns);
	      } else {
	        test = evaluateExpression(item, node, columns);
	      }
	
	      if (!test) {
	        pass = false;
	        return false;
	      }
	    });
	
	    return pass;
	  }
	
	  function evaluateExpression(filter, node, columns) {
	    var pass = false;
	    var column = _.find(columns, { id: filter.columnId });
	    if (column) {
	      var _isServerFilter = _.get(column, 'options.filter.isServerFilter', false);
	      if (_isServerFilter) {
	        //Assume the server has already filtered things out
	        return true;
	      }
	
	      switch (column.type) {
	        case 'string':
	          pass = evaluateStringFilter(filter, node, column);
	          break;
	        case 'number':
	          pass = evaluateNumberFilter(filter, node, column);
	          break;
	        case 'date':
	          pass = evaluateDateFilter(filter, node, column);
	          break;
	        case 'mapped':
	          pass = evaluateMappedFilter(filter, node, column);
	          break;
	        case 'duration':
	          pass = evaluateDurationFilter(filter, node, column);
	          break;
	        default:
	          // Ignore?
	          break;
	      }
	    }
	    return pass;
	  }
	
	  function evaluateStringFilter(filter, node, column) {
	    var rawValue = _.get(node.data, column.field.path);
	    if (rawValue) {
	      rawValue = '' + rawValue;
	    }
	    var value = _.get(node.data, 'internal.display.' + column.id);
	    if (!value) {
	      value = $gzFields.getValue(rawValue, node.data, column);
	      if (value) {
	        value = '' + value;
	      }
	      _.set(node.data, 'internal.display.' + column.id, value);
	    } else {
	      value = '' + value;
	    }
	
	    var filterValue = filter.value;
	    if (filter.op !== 'equals' && filter.op !== 'notEqual' && filter.op !== 'isEmpty' && filter.op !== 'isNotEmpty') {
	      if (value) {
	        value = value.toLocaleLowerCase();
	      }
	      if (filterValue) {
	        filterValue = filterValue.toLocaleLowerCase();
	      }
	    }
	    switch (filter.op) {
	      case 'equals':
	        return value === filterValue;
	      case 'notEqual':
	        return value !== filterValue;
	      case 'isEmpty':
	        return value === undefined || value === null || value === '';
	      case 'isNotEmpty':
	        return value !== undefined && value !== null && value !== '';
	      case 'contains':
	        if (!value) {
	          return false;
	        }
	        return value.indexOf(filterValue) >= 0;
	      case 'startsWith':
	        if (!value) {
	          return false;
	        }
	        return value.startsWith(filterValue);
	      case 'endsWith':
	        if (!value) {
	          return false;
	        }
	        return value.endsWith(filterValue);
	    }
	  }
	
	  function evaluateNumberFilter(filter, node, column) {
	    var rawValue = _.get(node.data, column.field.path);
	    var value = _.get(node.data, 'internal.display.' + column.id);
	    if (!value) {
	      value = $gzFields.getValue(rawValue, node.data, column);
	      _.set(node.data, 'internal.display.' + column.id, value);
	    }
	
	    if (value) {
	      value = parseInt(value);
	    }
	
	    switch (filter.op) {
	      case 'equals':
	        return value === filter.value;
	      case 'notEqual':
	        return value !== filter.value;
	      case 'isEmpty':
	        return value === undefined || value === null || value === '';
	      case 'isNotEmpty':
	        return value !== undefined && value !== null && value !== '';
	      case 'greaterThan':
	        return value > filter.value;
	      case 'greaterThanOrEqual':
	        return value >= filter.value;
	      case 'lessThan':
	        return value < filter.value;
	      case 'lessThanOrEqual':
	        return value <= filter.value;
	      case 'between':
	        var begin = filter.begin;
	        var end = filter.end;
	        if (begin > end) {
	          begin = filter.end;
	          end = filter.begin;
	        }
	        return value >= begin && value <= end;
	    }
	  }
	
	  function evaluateDateFilter(filter, node, column) {
	    var rawValue = _.get(node.data, column.field.path);
	    var value = _.get(node.data, 'internal.display.' + column.id);
	    if (!value) {
	      value = $gzFields.getValue(rawValue, node.data, column);
	      _.set(node.data, 'internal.display.' + column.id, value);
	    }
	
	    switch (filter.op) {
	      case 'equals':
	        return moment(rawValue).isSame(moment(filter.value), 'day');
	      case 'notEqual':
	        return !moment(rawValue).isSame(moment(filter.value), 'day');
	      case 'isEmpty':
	        return rawValue === undefined || rawValue === null || rawValue === '';
	      case 'isNotEmpty':
	        return rawValue !== undefined && rawValue !== null && rawValue !== '';
	      case 'greaterThan':
	        return moment(rawValue).isAfter(moment(filter.value), 'day');
	      case 'greaterThanOrEqual':
	        return moment(rawValue).isSameOrAfter(moment(filter.value), 'day');
	      case 'lessThan':
	        return moment(rawValue).isBefore(moment(filter.value), 'day');
	      case 'lessThanOrEqual':
	        return moment(rawValue).isSameOrBefore(moment(filter.value), 'day');
	      case 'between':
	        var begin = filter.begin;
	        var end = filter.end;
	        if (filter.begin > filter.end) {
	          begin = filter.end;
	          end = filter.begin;
	        }
	        return moment(rawValue).isSameOrAfter(moment(begin), 'day') && moment(rawValue).isSameOrBefore(moment(end), 'day');
	      case 'today':
	        return moment(rawValue).isSame(moment(), 'day');
	      case 'tomorrow':
	        return moment(rawValue).isSame(moment().add(1, 'd'), 'day');
	      case 'yesterday':
	        return moment(rawValue).isSame(moment().subtract(1, 'd'), 'day');
	      case 'thisWeek':
	        var test = moment(rawValue);
	        begin = moment().startOf('week');
	        end = moment().endOf('week');
	        return test.isSameOrAfter(begin, 'day') && test.isSameOrBefore(end, 'day');
	      case 'nextWeek':
	        test = moment(rawValue);
	        begin = moment().startOf('week');
	        end = moment().endOf('week');
	        var beginNextWeek = begin.add(1, 'w');
	        var endNextWeek = end.add(1, 'w');
	        return test.isSameOrAfter(beginNextWeek, 'day') && test.isSameOrBefore(endNextWeek, 'day');
	      case 'lastWeek':
	        test = moment(rawValue);
	        begin = moment().startOf('week');
	        end = moment().endOf('week');
	        var beginLastWeek = begin.subtract(1, 'w');
	        var endLastWeek = end.subtract(1, 'w');
	        return test.isSameOrAfter(beginLastWeek, 'day') && test.isSameOrBefore(endLastWeek, 'day');
	      case 'future':
	        return moment(rawValue).isAfter(moment(), 'day');
	      case 'past':
	        return moment(rawValue).isBefore(moment(), 'day');
	      case 'lastSevenDays':
	        var today = moment();
	        var sevenDayBefore = moment().subtract(7, 'day');
	        return moment(rawValue).isSameOrAfter(moment(sevenDayBefore), 'day') && moment(rawValue).isSameOrBefore(moment(today), 'day');
	    }
	  }
	
	  function evaluateMappedFilter(filter, node, column) {
	    var value = _.get(node.data, column.field.path, 0);
	    //TODO: Use comparator if necessary
	    switch (filter.op) {
	      case 'equals':
	        return value === filter.value;
	      case 'notEqual':
	        return value !== filter.value;
	      case 'greaterThan':
	        return value > filter.value;
	      case 'greaterThanOrEqual':
	        return value >= filter.value;
	      case 'lessThan':
	        return value < filter.value;
	      case 'lessThanOrEqual':
	        return value <= filter.value;
	    }
	  }
	
	  function evaluateDurationFilter(filter, node, column) {
	    var rawValue = _.get(node.data, column.field.path);
	    var valueRenderer = _.get(column, 'field.callbacks.valueRenderer');
	    if (valueRenderer) {
	      rawValue = valueRenderer(rawValue, node.data, column);
	    }
	    var value = _.get(node.data, 'internal.display.' + column.id);
	    if (!value) {
	      value = $gzFields.getValue(rawValue, node.data, column);
	      _.set(node.data, 'internal.display.' + column.id, value);
	    }
	
	    // let rounded =  rawValue - (rawValue % 1000);
	    switch (filter.op) {
	      case 'equals':
	        return rawValue === filter.value;
	      case 'notEqual':
	        return rawValue !== filter.value;
	      case 'isEmpty':
	        return rawValue === undefined || rawValue === null || rawValue === '';
	      case 'isNotEmpty':
	        return rawValue !== undefined && rawValue !== null && rawValue !== '';
	      case 'greaterThan':
	        return rawValue > filter.value;
	      case 'greaterThanOrEqual':
	        return rawValue >= filter.value;
	      case 'lessThan':
	        return rawValue < filter.value;
	      case 'lessThanOrEqual':
	        return rawValue <= filter.value;
	      case 'between':
	        return true;
	    }
	
	    return true;
	  }
	
	  ///////////////Server Filter Functions/////////////////
	  ///////////////////////////////////////////////////////
	  function getServerFilters(filters, gridOptions) {
	    var sFilters = { and: [] };
	    var serverAND = _.get(gridOptions, 'grid.options.filter.serverFilterAND', false);
	    var serverOR = _.get(gridOptions, 'grid.options.filter.serverFilterOR', false);
	    var serverRecurse = _.get(gridOptions, 'grid.options.filter.serverFilterRecurse', false);
	    var mergedFilter = _.get(filters, 'mergedFilter.and', []);
	    markServerFilters(mergedFilter, serverAND, serverOR, serverRecurse, gridOptions.columns);
	    if (serverAND) {
	      _.forEach(filters.mergedFilter.and, function (item) {
	        if (item.isServerFilter) {
	          sFilters.and.push(item);
	        }
	      });
	    } else {
	      // In this case, return back the first valid server filter
	      for (var i = 0; i < filters.mergedFilter.and.length; i++) {
	        var item = filters.mergedFilter.and[i];
	        if (item.isServerFilter && !item.or && !item.and) {
	          sFilters.and.push(item);
	          break;
	        }
	      }
	    }
	
	    return sFilters;
	  }
	
	  function markServerFilters(items, AND, OR, RECURSE, columns) {
	    _.forEach(items, function (item) {
	      if (RECURSE) {
	        if (item.or) {
	          if (OR) {
	            markServerFilters(item.or, AND, OR, RECURSE, columns);
	            item.isServerFilter = isServerRecurseFilter(item.or);
	          } else {
	            //Server doesn't support the OR concept so we can ignore
	            item.isServerFilter = false;
	          }
	        } else if (item.and) {
	          if (AND) {
	            markServerFilters(item.and, AND, OR, RECURSE, columns);
	            item.isServerFilter = isServerRecurseFilter(item.and);
	          } else {
	            //Server doesn't support the AND concept so we can ignore
	            item.isServerFilter = false;
	          }
	        } else {
	          item.isServerFilter = isServerFilter(item, columns);
	        }
	      } else {
	        if (item.or || item.and) {
	          // No Recursion concept so we can ignore
	          item.isServerFilter = false;
	        } else {
	          item.isServerFilter = isServerFilter(item, columns);
	        }
	      }
	    });
	  }
	
	  function isServerRecurseFilter(item) {
	    // For now, we'll pass filters back to server only if everything in array isServerFilter
	    var isServer = true;
	    for (var i = 0; i < item.length; i++) {
	      if (!item[i].isServerFilter) {
	        isServer = false;
	      }
	    }
	
	    return isServer;
	  }
	
	  function isServerFilter(item, columns) {
	    var found = _.find(columns, { id: item.columnId });
	    if (found) {
	      var SERVER = _.get(found, 'options.filter.isServerFilter', false);
	      var supportsOp = true;
	      var OPS = _.get(found, 'options.filter.serverOps');
	      if (OPS) {
	        supportsOp = OPS.indexOf(item.op) >= 0;
	      }
	
	      return SERVER && supportsOp;
	    }
	  }
	
	  //
	  // Private functions
	  //
	}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	'use strict';
	
	gzSaveDialogController.$inject = ["rnHttp", "$mdDialog", "$mdToast", "$filter", "filters", "pairingId", "$gzAnalytics"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzSaveDialogController;
	var name = 'gzSaveDialogController';
	exports.name = name;
	
	function gzSaveDialogController(rnHttp, $mdDialog, $mdToast, $filter, filters, pairingId, $gzAnalytics) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var PORTAL_SERVICE_NAME = 'portal_service';
	  var FILTERS_PATH = 'filters';
	
	  /* jshint validthis: true */
	  var vm = this;
	
	  vm.sending = false;
	  vm.filter = filters;
	  vm.editForm = null;
	  vm.save = save;
	  vm.cancel = cancel;
	  vm.disableSubmit = disableSubmit;
	
	  activate();
	
	  ////////////////
	
	  function activate() {}
	
	  function save() {
	    vm.sending = true;
	    vm.errorMessageKey = null;
	    var filterToSave = {
	      name: vm.filter.name,
	      shared: false,
	      pairingId: pairingId
	    };
	
	    _.set(filterToSave, 'namedFilter', _.cloneDeep(vm.filter.mergedFilter));
	    if (vm.filter.quickFilter) {
	      _.set(filterToSave, 'quickFilter', _.cloneDeep(vm.filter.quickFilter));
	    }
	
	    return rnHttp.post(PORTAL_SERVICE_NAME, FILTERS_PATH, filterToSave).then(function (serverFilter) {
	      if (serverFilter && serverFilter.data) {
	        var display = {
	          title: serverFilter.data.name
	        };
	        _.set(serverFilter.data, 'namedFilter.display', display);
	        if (serverFilter.data.userFilter) {
	          delete serverFilter.data.userFilter;
	        }
	
	        $mdDialog.hide(serverFilter.data);
	        var message = $filter('translate')('uxf.uxf.Filter_Saved');
	        $mdToast.showSimple(message);
	        var filterData = [];
	        if (vm.filter.mergedFilter) {
	          filterData = vm.filter.mergedFilter.and.map(function (filter) {
	            return filter.columnId + ' ' + filter.op + ' ' + filter.value;
	          });
	        }
	
	        if (vm.filter.quickFilter) {
	          filterData += ',' + vm.filter.quickFilter.display;
	        }
	
	        //Clear the input after saving filter
	        vm.filter.name = '';
	
	        $gzAnalytics.eventSave('Grid (' + pairingId + ') Filters', { label: 'filter name : ' + vm.filter.name + ', filters : ' + JSON.stringify(filterData) });
	        return serverFilter.data;
	      }
	    })['finally'](function () {
	      vm.sending = false;
	    });
	  }
	
	  function cancel() {
	    //Clear the input
	    vm.filter.name = '';
	    $gzAnalytics.eventClick('Grid (' + pairingId + ') Filters');
	    $mdDialog.cancel();
	  }
	
	  function disableSubmit() {
	    return vm.editForm.$invalid || vm.sending || vm.filter && vm.filter.name && vm.filter.name.trim() === '';
	  }
	}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzFormContent;
	var name = 'gzFormContent';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.formContent.directive:gzFormContent
	 *
	 * @param {boolean} submitting flag to indicate the form is currently being submitted.
	 *    When true, the form content will be backdropped behind a spinner, visible but unable to edit.
	 * @param {boolean} no-content (optional) flag to indicate the form is empty and shouldn't display empty content.
	 *
	 * @description
	 * `<gz-form-content>` wraps form content to allow for a consistent approach following the
	 * [Behaviors-Errors-Validation mockups](https://hp.sharepoint.com/teams/GSBCTO/Shared%20Documents/Programs/Genesis/User%20Experience/Shared/Behaviors-Errors-Validation.pdf).
	 * In particular, when a form is being submitted (as indicated by the `submitting` parameter),
	 * the form is backdropped behind a spinner and is visible but not editable.
	 *
	 * @example
	 * ```html
	   <form name="vm.form" ng-submit="vm.submit()">
	     <!-- Will display any submission errors at the top -->
	     <gz-error-bar error-key="vm.errorMessageKey"></gz-error-bar>
	
	     <!-- Scrolling form content with spinner during submission -->
	     <gz-form-content>
	       <md-input-container>
	         <label for="userName" translate="UserName"></label>
	         <input id="userName" name="userName" ng-model="vm.user.name" required>
	       </md-input-container>
	     </gz-form-content>
	
	     <!-- Form action buttons -->
	     <div class="md-actions" layout="row">
	       <md-button class="md-primary" type="button" ng-click="vm.cancel()" translate="Cancel"></md-button>
	       <md-button class="md-primary md-raised" type="submit" translate="Submit"></md-button>
	     </div>
	   </form>
	 * ```
	 **/
	
	function gzFormContent() {
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      submitting: '=',
	      noContent: '=?'
	    },
	    template: __webpack_require__(234),
	    transclude: true,
	    controllerAs: 'vm',
	    bindToController: true,
	    controller: gzFormContentController
	  };
	
	  return directive;
	
	  /////////////////
	
	  function gzFormContentController() {}
	}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzFormFooterBar;
	var name = 'gzFormFooterBar';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.formFooterBar.directive: gzFormFooterBar
	 *
	 * @param {string} submit-title (optional) Property string to provide as a custom label for the submit button. By default,
	 *                              a localized version of 'SUBMIT' is provided.
	 * @param {boolean} show-cancel (optional) Flag to indicate if the cancel button should be shown. Defaults to true.
	 * @param {boolean} submitting (required) Flag to indicate the form is currently being submitted.
	 * @param {function} disable-submit (optional) Custom function for evaluating the conditions for when the submit button is
	 *                                  disabled. By default, a function is provided which will disable the submit button
	 *                                  while the form is invalid or while the form is in a submitting state.
	 * @param {function} cancel (optional) A function to perform a custom cancellation process. If this is provided the developer
	 *                          becomes responsible for closing the dialog. If this is not provided the dialog will be closed
	 *                          by gzFormTitleBar.
	 * @param {function} show-legend (optional) Flag to indicate if the required legend should be shown.  Defaults to true.
	 * @param {function} alt-background (optional) Flag to indicate alternate background color should be shown.
	 *
	 * @description Provides a consistent look for form footers with built-in L10 property string conversion and a default
	 *              submit button title, cancel button function, and submit button function. The only required attribute is
	 *              the <i>submitting</i> attribute which lets the directive know when the form is in a submitting state.
	 *
	 *              Left-aligned in the footer is a legend indicating that a star identifies a required field. Right-aligned
	 *              in the footer are the cancel and submit buttons, in that order.
	 *
	 * @usage
	 * ````html
	 *
	 * // With default submit title, submit function, and cancel function
	 * <gz-form-footer-bar submitting="vm.sending"></gz-form-footer-bar>
	 *
	 * // With custom submit title
	 * <gz-form-footer-bar submitting="vm.sending"
	 *                     submit-title="account.account.Some_Property_Key"></gz-form-footer-bar>
	 *
	 * // With custom disable submit function
	 * <gz-form-footer-bar submitting="vm.sending"
	 *                     disable-submit="vm.myDisableSubmitFunction"></gz-form-footer-bar>
	 *
	 * // With custom cancel function
	 * <gz-form-footer-bar submitting="vm.sending"
	 *                     cancel="vm.myCancelFunction"></gz-form-footer-bar>
	 * ````
	 */
	
	function gzFormFooterBar() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzFormFooterBarController.$inject = ["$mdDialog", "$parse"];
	  var directive = {
	    require: '^?form', /// this is not really optional, however, Jasmine can't find it and throws an error
	    restrict: 'E',
	    scope: {
	      submitTitle: '@',
	      submitting: '=',
	      showCancel: '=?',
	      disableSubmit: '=?',
	      cancel: '=?',
	      showLegend: '=?',
	      altBackground: '=?',
	      legendKey: '@'
	    },
	    template: __webpack_require__(235),
	    controllerAs: 'vm',
	    bindToController: true,
	    link: gzFormFooterBarLink,
	    controller: gzFormFooterBarController
	  };
	
	  return directive;
	
	  ////////////////////
	
	  function gzFormFooterBarLink(scope, iElem, iAttrs, form) {
	
	    scope.$watch(function () {
	      return form ? form.$invalid : true;
	    }, function (newVal) {
	      if (newVal !== undefined) {
	        scope.vm.setInvalidForm(newVal);
	      }
	    });
	  }
	
	  /** @ngInject **/
	  function gzFormFooterBarController($mdDialog, $parse) {
	
	    var vm = this;
	
	    vm.invalidForm = true;
	
	    vm.activate = activate;
	    vm.defaultCancel = defaultCancel;
	    vm.defaultDisableSubmit = defaultDisableSubmit;
	    vm.setInvalidForm = setInvalidForm;
	
	    activate();
	
	    ////////////////////
	
	    function activate() {
	      if (vm.showLegend === undefined) {
	        vm.showLegend = true;
	      }
	
	      // Don't show the cancel button if it isn't wanted
	      if (vm.showCancel === undefined) {
	        vm.showCancel = true;
	      }
	
	      // If a custom submit label is not provided use the default label
	      if (vm.submitTitle === undefined) {
	        vm.submitTitle = 'uxf.uxf.Dialog_Submit';
	      }
	
	      // If a custom disable submit function is not provided use the default  disable submit function
	      if (vm.disableSubmit === undefined) {
	        vm.disableSubmit = defaultDisableSubmit;
	      }
	
	      // If a custom cancel function is not provided assign the default cancel function
	      if (vm.cancel === undefined) {
	        vm.cancel = defaultCancel;
	      }
	    }
	
	    function defaultCancel() {
	      $mdDialog.cancel();
	    }
	
	    function defaultDisableSubmit() {
	      return vm.submitting || vm.invalidForm;
	    }
	
	    function setInvalidForm(valid) {
	      vm.invalidForm = valid;
	    }
	  }
	}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(528);
	
	var _formFooterBarDirectiveJs = __webpack_require__(325);
	
	var gzFormFooterBar = _interopRequireWildcard(_formFooterBarDirectiveJs);
	
	exports['default'] = angular.module('gazelle.components.formFooterBar', ['pascalprecht.translate', 'ngMaterial',
	// Required for angular 1.6 $compile change handled in rhino core.config.js.
	// Consider moving somewhere else
	'rhino.core']).directive(gzFormFooterBar.name, gzFormFooterBar['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzGo.$inject = ["$q", "$log", "rnHttp", "rnApplication", "$window", "$state", "$gzAppBroker", "gzL10nInterpolationService", "$rootScope", "rnPreferences"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzGo;
	var name = '$gzGo';
	
	exports.name = name;
	var taskState = {
	  NEW: 'new',
	  ACTIVE: 'active'
	};
	
	exports.taskState = taskState;
	var taskStatus = {
	  DONE: 'done',
	  CANCELLED: 'cancelled'
	};
	
	exports.taskStatus = taskStatus;
	/**
	 * @ngdoc service
	 * @name gazelle.components.go.service:$gzGo
	 *
	 * @description
	 * The $gzGo service provides a mechanism to navigate to a context, interacting with the portal's "go" API.
	 *
	 * **Cross-Application Tasks:**
	 * Cross-Application Tasks are intended to feel like an extension of the calling app (similar to a modal dialog)
	 *
	 * Calling Application - Application that launches cross-application task
	 * - Must support a goContext for the page to return to
	 * - Calls $gzGo.startTask to start the cross-application task
	 * -- Provides return goContext for the page to return to (which can be different than the actual page that launches)
	 * -- Provides a Javascript object payload containing any data to be conveyed to cross-application task as a parameter to $gzGo.startTask
	 * - Can use $gzGo.getReturnData to process any data returned from Task Application
	 *
	 * Task Application - Application that owns the cross-application task
	 * - Must support a goContext for the page to return to
	 * - Configures gz-page-header directive to support task
	 * -- (REQUIRED) Set 'support-task="true"' to enable the page header to switch between Task Mode and Normal Mode
	 * -- Set 'support-full-app="true"' to enable the user to show/hide the full app navigation
	 * -- Set 'task-title="{{app.cat.key | translate}}"' or 'task-title="{{app.cat.key | translate:[parameters]}}"' to override the page title when in task mode
	 * -- (REQUIRED) Set 'task-submit="controller.submit"' to specify a function reference in your controller that returns a promise that returns the payload to pass to the Calling Application
	 * -- Set 'task-submit-title="{{app.cat.key | translate}}"' to override the 'Submit' button name
	 * -- Set 'task-cancel="controller.cancel"' to specify a function reference in your controller that returns a promise
	 * -- Set 'task-disable-submit="controller.disableSubmit"' to specify a function reference in your controller that returns a boolean to control the disabled state of the submit button
	 * - Modifies controller on page to support task
	 * -- Add appropriate methods to controller to support gz-page-header configuration
	 * -- Can use $gzGo.getTaskData to process any data passed into the task from Calling Application
	 * -- Page controller/content may need to be modified to support Task Mode and Normal Mode
	 *
	 */
	
	function $gzGo($q, $log, rnHttp, rnApplication, $window, $state, $gzAppBroker, gzL10nInterpolationService, $rootScope, rnPreferences) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var TASK_CATEGORY = 'pos.gz.task';
	  var TASK_IN_KEY = 'pos.gz.taskIn';
	  var TASK_OUT_KEY = 'pos.gz.taskOut';
	
	  var taskData = undefined;
	  var returnData = undefined;
	  var isFullApp = false;
	  var activatePromise = undefined;
	  var lastPreferences = undefined;
	
	  var unitTest = {
	    setTaskData: setTaskData,
	    setReturnData: setReturnData,
	    setIsFullApp: setIsFullApp
	  };
	
	  var service = {
	    toContext: toContext,
	    taskIsActive: taskIsActive,
	    getTaskId: getTaskId,
	    startTask: startTask,
	    completeTask: completeTask,
	    cancelTask: cancelTask,
	    exitTask: exitTask,
	    goToTaskHome: goToTaskHome,
	    showAppNav: showAppNav,
	    setAppNav: setAppNav,
	    toggleAppNav: toggleAppNav,
	    getTaskData: getTaskData,
	    getReturnData: getTaskReturnData,
	    clearReturnData: clearTaskReturnData,
	    unitTest: unitTest
	  };
	
	  activate();
	  return service;
	
	  function activate() {
	    if (activatePromise) {
	      return activatePromise.promise;
	    }
	
	    activatePromise = $q.defer();
	    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	      rnPreferences.getAll().then(function (prefs) {
	        if (prefs[TASK_CATEGORY] && prefs[TASK_CATEGORY][TASK_IN_KEY]) {
	          taskData = rnPreferences.getPrefObjectHelper(prefs, TASK_CATEGORY, TASK_IN_KEY);
	          if (taskData) {
	            if (taskData.taskState === taskState.NEW) {
	              isFullApp = false;
	              // This is the task destination
	              taskData.taskId = toState.name;
	              taskData.toParams = toParams;
	              taskData.taskState = taskState.ACTIVE;
	              taskData.toAppId = rnApplication.getCurrentAppId();
	              taskData.toStateName = toState.name;
	              taskData.requestPayload = taskData.payload;
	              rnPreferences.setSingleObject(TASK_CATEGORY, TASK_IN_KEY, taskData)['catch'](function (error) {
	                //catch this error so we don't stop routing
	                //if this happens we will still go to destination page, we just won't initiate task
	                console.log('$gzGo: Could not initiate task', error);
	              });
	            } else {
	              if (rnApplication.getCurrentAppId() !== taskData.toAppId || rnApplication.getCurrentAppId() === taskData.toAppId && taskData.toStateName !== toState.name && !isFullApp) {
	                rnPreferences.deleteSingle(TASK_CATEGORY, TASK_IN_KEY)['catch'](function (error) {
	                  //catch this error so we don't stop routing
	                  //This could have some odd side effects depending on the situation
	                  console.log('$gzGo: Could not clean up task', error);
	                });
	                taskData = undefined;
	              }
	            }
	          }
	        }
	
	        var test = rnPreferences.getPrefObjectHelper(prefs, TASK_CATEGORY, TASK_OUT_KEY);
	        if (test) {
	          setReturnData(test);
	        }
	
	        activatePromise.resolve();
	      })['catch'](function (error) {
	        //catch this error so we don't stop routing
	        //If this happens we won't do anything with the task (initiate or clean up)
	        console.log('$gzGo: Could not read task data', error);
	      });
	    });
	
	    return activatePromise.promise;
	  }
	
	  //
	  // Public functions
	  //
	
	  function showAppNav() {
	    return !taskData || taskData && isFullApp;
	  }
	
	  /**
	   * @ngdoc function
	   * @name taskIsActive
	   * @methodOf gazelle.components.go.service:$gzGo
	   * @description Check and see if task is active for current page
	   * @returns {Promise.<boolean>} promise to a flag indicating if task is active for current page
	   */
	  function taskIsActive() {
	    var deferred = $q.defer();
	    activate().then(function () {
	      var active = taskData !== undefined && taskData !== null && taskData.taskState === taskState.ACTIVE;
	      deferred.resolve(active);
	    });
	    return deferred.promise;
	  }
	
	  function setAppNav(show) {
	    isFullApp = show;
	  }
	
	  function toggleAppNav() {
	    isFullApp = !isFullApp;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getTaskId
	   * @methodOf gazelle.components.go.service:$gzGo
	   * @description Returns taskId used for the current task (matches incoming route)
	   * @returns {object} A javascript object
	   */
	  function getTaskId() {
	    return taskData.taskId;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getTaskData
	   * @methodOf gazelle.components.go.service:$gzGo
	   * @description Returns taskData for the Active or Paused task
	   * @returns {object} A javascript object
	   * @example
	   * ```
	   * {
	   *   context: "device-add",
	   *   target: "null",
	   *   returnContext: "home",
	   *   returnTarget: "null",
	   *   taskState: "active",
	   *   appId: "home",
	   *   toAppId: "account",
	   *   toStateName: "device-add"
	   *   payload: {
	   *     somekey: "somevalue"
	   *   }
	   * }
	   * ```
	   */
	  function getTaskData() {
	    return taskData;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getTaskData
	   * @methodOf gazelle.components.go.service:$gzGo
	   * @description Returns taskData for the Active or Paused task
	   * @returns {object} A javascript object
	   * @example
	   * ```
	   * {
	   *   context: context,
	   *   target: target,
	   *   taskState: "new",
	   *   status: "done",
	   *   payload: payload
	   *   payload: {
	   *     somekey: "somevalue"
	   *   }
	   * }
	   * ```
	   */
	  function getTaskReturnData() {
	    return returnData;
	  }
	
	  function clearTaskReturnData() {
	    rnPreferences.deleteSingle(TASK_CATEGORY, TASK_OUT_KEY);
	    returnData = undefined;
	  }
	
	  /**
	   * @ngdoc function
	   * @name startTask
	   * @methodOf gazelle.components.go.service:$gzGo
	   * @description Go to a context as a task. If the context is in the current app, the location will be switched
	   * without reloading the app.
	   * @param {string} goContext - The context to switch to for the task
	   * @param {string} [target] - The optional target (null if not necessary)
	   * @param {string} returnContext - The context to return to when the task is complete
	   * @param {string} returnTarget - The optional target on return (null if not necessary)
	   * @param {object} payload - Javascript object containing any data to be conveyed to the task application
	   */
	  function startTask(goContext, goTarget, returnContext, returnTarget, payload) {
	    var data = {
	      context: goContext,
	      target: goTarget,
	      returnContext: returnContext,
	      returnTarget: returnTarget,
	      payload: payload,
	      taskState: taskState.NEW,
	      appId: rnApplication.getCurrentAppId()
	    };
	
	    var promises = [];
	    promises.push(rnPreferences.deleteSingle(TASK_CATEGORY, TASK_OUT_KEY));
	    promises.push(rnPreferences.setSingleObject(TASK_CATEGORY, TASK_IN_KEY, data));
	    $q.all(promises)['finally'](function () {
	      toContext(goContext, goTarget);
	    });
	  }
	
	  function completeTask(payload) {
	    if (taskData) {
	      var context = taskData.returnContext;
	      var target = taskData.returnTarget;
	      if (!payload) {
	        payload = {};
	      }
	
	      var data = {
	        context: context,
	        target: target,
	        taskState: taskState.NEW,
	        status: taskStatus.DONE,
	        payload: payload,
	        requestPayload: taskData.requestPayload
	      };
	
	      var promises = [];
	      promises.push(rnPreferences.deleteSingle(TASK_CATEGORY, TASK_IN_KEY));
	      promises.push(rnPreferences.setSingleObject(TASK_CATEGORY, TASK_OUT_KEY, data));
	      $q.all(promises)['finally'](function () {
	        toContext(taskData.returnContext, taskData.returnTarget);
	      });
	    }
	  }
	
	  function cancelTask(payload) {
	    if (taskData) {
	      var context = taskData.returnContext;
	      var target = taskData.returnTarget;
	      if (!payload) {
	        payload = {};
	      }
	
	      var data = {
	        context: context,
	        target: target,
	        taskState: taskState.NEW,
	        status: taskStatus.CANCELLED,
	        payload: payload,
	        requestPayload: taskData.requestPayload
	      };
	
	      var promises = [];
	      promises.push(rnPreferences.deleteSingle(TASK_CATEGORY, TASK_IN_KEY));
	      promises.push(rnPreferences.setSingleObject(TASK_CATEGORY, TASK_OUT_KEY, data));
	      $q.all(promises)['finally'](function () {
	        toContext(taskData.returnContext, taskData.returnTarget);
	      });
	    }
	  }
	
	  function exitTask() {
	    isFullApp = true;
	    rnPreferences.deleteSingle(TASK_CATEGORY, TASK_IN_KEY);
	    taskData = undefined;
	  }
	
	  function goToTaskHome() {
	    $state.go(taskData.taskId, taskData.toParams);
	  }
	
	  /**
	   * @ngdoc function
	   * @name toContext
	   * @methodOf gazelle.components.go.service:$gzGo
	   * @description Go to a context. If the context is in the current app, the location will be switched
	   * without reloading the app.
	   * @param {string} context - The context
	   * @param {string} [target] - The optional target
	   */
	  function toContext(context, target) {
	    $log.debug('gzGo toContext for context: ' + context + ' target: ' + target);
	
	    return rnHttp.get('portal_service', '/go/contexts', { cache: true }).then(function (response) {
	      // Look for a matching context
	      var goContext = _.find(response.data, { name: context });
	      if (goContext) {
	        // Change to the new location
	        if (goContext.ui && goContext.ui.show) {
	          // Just show the (mini) app
	          //$log.debug("show mini app via app-broker: " + goContext.ui.show);
	          $gzAppBroker.show(goContext.ui.show, target);
	        } else if (rnApplication.getCurrentAppId() === goContext.appId) {
	          // If same app, see if we can change the state within that app
	          if (goContext.ui && goContext.ui.state) {
	            if (goContext.ui.stateParam) {
	              var stateParam = {};
	              stateParam[goContext.ui.stateParam] = target;
	              $state.go(goContext.ui.state, stateParam);
	            } else {
	              $state.go(goContext.ui.state);
	            }
	          } else {
	            $log.debug("state change not implemented for context: " + context + ". Load it instead.");
	            loadApp(goContext, target);
	          }
	        } else {
	          // If different app, load the new app
	          loadApp(goContext, target);
	        }
	      } else {
	        $log.debug("gzGo context not found for " + context);
	      }
	    })['catch'](function () {
	      $log.debug("gzGo go/contexts API error");
	    });
	  }
	
	  //
	  // Private functions
	  //
	  function loadApp(goContext, target) {
	    var path = gzL10nInterpolationService.interpolate(goContext.path, [target]);
	    var href = goContext.appUrl + path;
	    $log.debug("loadApp load href: " + href);
	    $window.location.href = href;
	  }
	
	  function setTaskData(td) {
	    taskData = td;
	  }
	
	  function setReturnData(rd) {
	    returnData = rd;
	  }
	
	  function setIsFullApp(isFull) {
	    isFullApp = isFull;
	  }
	}
	
	//$gzGo

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	gzGoogleAddress.$inject = ["$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzGoogleAddress;
	var name = 'gzGoogleAddress';
	exports.name = name;
	
	function gzGoogleAddress($window) {
	  'ngInject';
	
	  googleAddressController.$inject = ["rnHttp", "rnLocale", "$gzGoogleMaps", "$gzTime", "$window", "$rootScope", "$timeout", "$q", "$mdDialog"];
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      pairingId: '@?',
	      options: '=',
	      onMapClicked: '&?'
	    },
	    template: __webpack_require__(236),
	    link: googleAddressLink,
	    controller: googleAddressController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function googleAddressLink(scope, element) {
	    // Add this method to the scope to be invoked with ng-init
	    // when the spacer element is added to the DOM. This ensures the elements are present.
	    scope.vm.watchSpacer = function () {
	      var el = element[0];
	      if (el.parentElement) {
	        // If we have a parent element, let's use that for sizing
	        el = el.parentElement;
	      }
	
	      var map = el.querySelector('.map');
	      var formContainer = el.querySelector('.form-container');
	      var spacer = el.querySelector('.spacer');
	
	      toggleSpacer();
	      $window.addEventListener('resize', toggleSpacer);
	      scope.$on('$destroy', function () {
	        $window.removeEventListener('resize', toggleSpacer);
	      });
	
	      function toggleSpacer() {
	        if (scope.vm.manualMode) {
	          return;
	        }
	
	        // Hilarious: parseInt() by definition will stop parsing on first non-number character.
	        // So "300px" is parsed to 300. Incredible.
	        var mapMinWidth = $window.parseInt($window.getComputedStyle(map).getPropertyValue('min-width'), 10);
	        var formContainerMinWidth = $window.parseInt($window.getComputedStyle(formContainer).getPropertyValue('min-width'), 10);
	        if (el.clientWidth < mapMinWidth + formContainerMinWidth) {
	          // Wrapping so remove spacer
	          spacer.classList.add("hidden");
	        } else {
	          spacer.classList.remove("hidden");
	        }
	      }
	    };
	  }
	
	  /** @ngInject */
	  function googleAddressController(rnHttp, rnLocale, $gzGoogleMaps, $gzTime, $window, $rootScope, $timeout, $q, $mdDialog) {
	    // Constants
	    var US_VALIDATORS = {
	      region: {
	        maxlength: 2,
	        validator: 'Validator.AAA.USState'
	      },
	      postalCode: {
	        required: true,
	        maxlength: 10,
	        validator: 'Validator.AAA.USPostalCode'
	      }
	    };
	    var CANADA_VALIDATORS = {
	      region: {
	        maxlength: 2,
	        validator: 'Validator.AAA.CAProvidences'
	      },
	      postalCode: {
	        required: true,
	        maxlength: 7,
	        validator: 'Validator.AAA.CAPostalCode'
	      }
	    };
	    var DEFAULT_VALIDATORS = {
	      region: {
	        maxlength: 100,
	        validator: 'Validator.AAA.DescriptionUnicode'
	      },
	      postalCode: {
	        required: false,
	        maxlength: 35,
	        validator: 'Validator.AAA.PostalCode'
	      }
	    };
	    var US_COUNTRY_CODE = 'US';
	    var CANADA_COUNTRY_CODE = 'CA';
	
	    // Variables
	    var updateGuessDebounceTimer = undefined;
	
	    var defaultTimeZone = undefined;
	    var isInitialized = false; // Ready for place handlers (map ready, address initialized)
	    var markers = []; // Store markers currently on the map for clean up
	    var addresses = []; // Address book addresses
	
	    // View Model
	    var vm = this;
	    vm.loading = true; // Cleared once we get dependent data
	    vm.manualMode = false; // Applies to Edit Mode, whether or not to display the form (true) or map (false)
	    vm.editMode = true; // Whether or not to show address edit controls (true) or display map only (false)
	    vm.validators = DEFAULT_VALIDATORS; // Current set of validation depending on selected country
	
	    vm.handleMapReady = handleMapReady; // Google map control is initialized with map object
	    vm.useBrowserLocation = useBrowserLocation; // Use browser location services to set location
	    vm.useGuessLocation = useGuessLocation; // Use our best guess location
	    vm.handlePlaceChanged = handlePlaceChanged; // Location field place changed
	    vm.handlePlaceTextChanged = handlePlaceTextChanged; // Location field place text changed
	    vm.toggleView = toggleView; // Switch between map and form mode (editMode ONLY)
	    vm.openAddresses = openAddresses; // Open select Address Book dialog
	    vm.countryChanged = countryChanged; // Set validation based on country
	    vm.isIncompletePlace = isIncompletePlace;
	
	    // API
	    // setAddress -
	    // getAddress -
	
	    vm.$onInit = onInit;
	    return;
	
	    function onInit() {
	      vm.mapsSupported = $gzGoogleMaps.mapsSupported;
	      if (!vm.mapsSupported) {
	        vm.manualMode = true;
	      }
	
	      parseOptions();
	      setupAPI();
	
	      if (vm.editMode) {
	        var promises = [];
	        promises.push(getTimeZones());
	        promises.push(getCountries());
	        promises.push(getAddresses());
	        return $q.all(promises)['finally'](function () {
	          vm.loading = false;
	        });
	      } else {
	        vm.loading = false;
	        return $q.resolve();
	      }
	    }
	
	    ///////////////////////////////////////////////////////////
	    // Activate
	    function parseOptions() {
	      vm.hideName = _.get(vm.options, 'hideNameField', false);
	      vm.name = _.get(vm.options, 'name');
	      vm.address = _.get(vm.options, 'address');
	      vm.timezone = _.get(vm.options, 'timezone', defaultTimeZone);
	      vm.editMode = !_.get(vm.options, 'displayMode', false);
	    }
	
	    function setupAPI() {
	      _.set(vm.options, 'api.isValid', isValid);
	      _.set(vm.options, 'api.getAddress', getAddress);
	      _.set(vm.options, 'api.setAddress', setAddress);
	    }
	
	    function getTimeZones() {
	      return $gzTime.getTimeZones().then(function (timezones) {
	        vm.timezones = timezones;
	        return $gzTime.getPreferredTimeZone().then(function (tz) {
	          if (!vm.timezone) {
	            vm.timezone = tz;
	          }
	        });
	      })['catch'](function (error) {});
	    }
	
	    function getCountries() {
	      return rnLocale.getBestFit().then(function (locale) {
	        var portalCountriesOpts = {
	          cache: true,
	          params: {
	            locale: locale.value
	          }
	        };
	
	        return rnHttp.get('portal_service', 'preferences/countries', portalCountriesOpts).then(function (response) {
	          vm.countries = response.data;
	        });
	      });
	    }
	
	    function getAddresses() {
	      return rnHttp.get('aaa', 'organizations/addresses/').then(function (resp) {
	        addresses = _.get(resp, 'data.addresses', []);
	        if (addresses.length > 0) {
	          vm.showAddressBook = true;
	        }
	      });
	    }
	
	    ///////////////////////////////////////////////////////////
	    // Handlers
	    function handleMapReady() {
	      vm.loadingMap = true;
	      return $gzGoogleMaps.onMap(vm.pairingId).then(function (map) {
	        vm.map = map;
	
	        return initializeMap().then(function () {
	          return updateMarkers().then(function () {
	            var onMapLoaded = _.get(vm.options, 'onMapLoaded');
	            if (onMapLoaded) {
	              onMapLoaded(vm.place);
	            }
	          });
	        })['finally'](function () {
	          isInitialized = true;
	        });
	      })['finally'](function () {
	        vm.loadingMap = false;
	      });
	    }
	
	    function handlePlaceChanged(place) {
	      if (!isInitialized) {
	        // Ignore place changed until we've set the initial address
	        return;
	      }
	
	      vm.place = place;
	      if (place) {
	        vm.placeText = place.formatted_address;
	      }
	      updateAddressForm();
	      updateMarkers();
	    }
	
	    function handlePlaceTextChanged() {
	      // Clean up previous timer
	      delete vm.place;
	      if (updateGuessDebounceTimer) {
	        $timeout.cancel(updateGuessDebounceTimer);
	      }
	
	      if (vm.placeText) {
	        updateGuessDebounceTimer = $timeout(updateGuess, 1000);
	      }
	    }
	    ///////////////////////////////////////////////////////////
	    // View Model
	    function useBrowserLocation() {
	      if (!('geolocation' in $window.navigator)) {
	        return $q.reject();
	      }
	
	      $window.navigator.geolocation.getCurrentPosition(function (position) {
	        var defaultLocation = {
	          lat: position.coords.latitude,
	          lng: position.coords.longitude
	        };
	        var geocoder = new $window.google.maps.Geocoder();
	        geocoder.geocode({ 'latLng': defaultLocation }, function (results, status) {
	          if (status === $window.google.maps.GeocoderStatus.OK && results[0]) {
	            $rootScope.$applyAsync(function () {
	              // Set the place directly here and let the places auto complete
	              // directive call placeChanged() with additional info.
	              vm.place = results[0];
	              if (vm.place) {
	                vm.placeText = vm.place.formatted_address;
	              }
	            });
	          }
	        });
	      }, function (error) {
	        console.error('Failed to get location');
	      }, { timeout: 5000 });
	    }
	
	    function useGuessLocation() {
	      vm.place = vm.guess;
	      vm.placeText = vm.place.formatted_address;
	    }
	
	    function toggleView() {
	      vm.manualMode = !vm.manualMode;
	      if (vm.manualMode) {
	        delete vm.place;
	        countryChanged();
	      } else {
	        vm.options.address = vm.address;
	      }
	    }
	
	    function openAddresses() {
	      $mdDialog.show({
	        template: __webpack_require__(237),
	        controller: 'SelectAddressController',
	        bindToController: true,
	        controllerAs: 'vm',
	        locals: {
	          addresses: addresses
	        }
	      }).then(function (data) {
	        if (data) {
	          vm.timezone = data.timezone;
	          setAddress(data.address);
	        }
	      });
	    }
	
	    function isIncompletePlace() {
	      return vm.addressForm.place.$dirty && !vm.addressForm.$pending && !isAddressValid();
	    }
	
	    ///////////////////////////////////////////////////////////
	    // API
	    function isValid() {
	      if (!vm.addressForm) {
	        return false;
	      }
	
	      if (!vm.addressForm.$valid) {
	        return false;
	      }
	
	      if (!vm.hideName) {
	        if (!vm.name || vm.name.trim() === '') {
	          return false;
	        }
	      }
	
	      if (!isAddressValid()) {
	        return false;
	      }
	
	      return true;
	    }
	
	    function isAddressValid() {
	      if (!vm.address.addressLine1 || vm.address.addressLine1.trim() === '') {
	        return false;
	      }
	
	      if (!vm.address.locality || vm.address.locality.trim() === '') {
	        return false;
	      }
	
	      if (!vm.address.region || vm.address.region.trim() === '') {
	        return false;
	      }
	
	      if (vm.validators.postalCode.required && (!vm.address.postalCode || vm.address.postalCode.trim() === '')) {
	        return false;
	      }
	
	      if (!vm.timezone) {
	        return false;
	      }
	
	      if (!vm.address.country) {
	        return false;
	      }
	
	      return true;
	    }
	
	    function getAddress() {
	      var address = {
	        address: vm.address,
	        timezone: vm.timezone
	      };
	      if (!vm.hideName) {
	        address.name = vm.name.trim();
	      }
	      return address;
	    }
	
	    function setAddress(address) {
	      delete vm.place;
	      delete vm.placeText;
	      vm.options.address = address;
	      return updatePlace(address);
	    }
	
	    ///////////////////////////////////////////////////////////
	    // Helpers
	    function initializeMap() {
	      var address = _.get(vm, 'options.address');
	      return updatePlace(address);
	    }
	
	    function updatePlace(address) {
	      resetMap();
	      if (!address) {
	        delete vm.place;
	        delete vm.placeText;
	        delete vm.guess;
	        return updateMarkers();
	      }
	
	      return $gzGoogleMaps.getPlaceFromAddress(address).then(function (place) {
	        vm.place = place;
	        if (vm.editMode) {
	          vm.placeText = place ? place.formatted_address : $gzGoogleMaps.getFormattedAddress(address);
	          resetForm();
	          if (place) {
	            updateAddressForm();
	          }
	        }
	        return updateMarkers().then(function () {
	          return vm.place;
	        });
	      });
	    }
	
	    function updateMarkers() {
	      clearMarkers();
	      if (vm.address) {
	        return updatePlaceMarker();
	      } else {
	        return updateAddressMarkers();
	      }
	    }
	
	    function updatePlaceMarker() {
	      vm.unknownLocation = false;
	      if (!vm.place) {
	        vm.unknownLocation = true;
	        return $q.resolve();
	      }
	
	      var geometry = _.get(vm.place, 'geometry.location');
	      if (!geometry) {
	        vm.unknownLocation = true;
	        return $q.resolve();
	      }
	
	      var location = _.get(vm, 'place.geometry.location');
	      var position = undefined;
	      if (_.isFunction(location.lat)) {
	        position = { lat: location.lat(), lng: location.lng() };
	      } else {
	        position = location;
	      }
	
	      if (!position) {
	        vm.unknownLocation = true;
	        return $q.resolve();
	      }
	
	      markers.push(new $window.google.maps.Marker({
	        position: position,
	        map: vm.map
	      }));
	
	      vm.map.setZoom(17);
	      vm.map.panTo(position);
	
	      return $q.resolve();
	    }
	
	    function updateAddressMarkers() {
	      var addresses = _.get(vm.options, 'addresses', []);
	      if (addresses.length === 0) {
	        var address = _.get(vm.options, 'address');
	        if (address) {
	          addresses.push({ address: address });
	        }
	      }
	
	      if (addresses.length === 0) {
	        return $q.resolve();
	      }
	
	      var promises = [];
	      _.forEach(addresses, function (address) {
	        if (address.address.addressLine1) {
	          promises.push($gzGoogleMaps.getPlaceFromAddress(address.address).then(function (place) {
	            if (!place) {
	              return;
	            }
	
	            var location = _.get(place, 'geometry.location');
	            if (!location) {
	              return;
	            }
	
	            markers.push(new $window.google.maps.Marker({
	              position: location,
	              map: vm.map,
	              title: address.name
	            }));
	
	            if (addresses.length === 1) {
	              if (vm.map.getZoom() < 14) {
	                vm.map.setZoom(14);
	                vm.map.panTo(location);
	              }
	            }
	          }));
	        }
	      });
	
	      return $q.all(promises);
	    }
	
	    function updateGuess() {
	      if (vm.place || !vm.placeText) {
	        // If we already have a place or we do NOT have text to look up
	        delete vm.guess;
	        return;
	      }
	
	      $gzGoogleMaps.getPlaceFromLocation(vm.placeText).then(function (place) {
	        if (place) {
	          // TODO: Also make sure this is a valid PrintOS Address for us
	          vm.guess = place;
	        } else {
	          delete vm.guess;
	        }
	      });
	    }
	
	    function updateAddressForm() {
	      vm.address = $gzGoogleMaps.getAddressFromPlace(vm.place);
	      vm.timezone = _.get(vm.place, 'gzTimeZone.value');
	      if (_.get(vm, 'addressForm.place')) {
	        vm.addressForm.place.$setDirty();
	      }
	      countryChanged();
	    }
	
	    function countryChanged() {
	      if (!_.get(vm, 'address.country')) {
	        return;
	      }
	
	      var country = getCountry(vm.address.country);
	
	      if (country) {
	        switch (country.isoCode) {
	          case US_COUNTRY_CODE:
	            vm.validators = US_VALIDATORS;
	            break;
	          case CANADA_COUNTRY_CODE:
	            vm.validators = CANADA_VALIDATORS;
	            break;
	          default:
	            vm.validators = DEFAULT_VALIDATORS;
	            break;
	        }
	
	        // Semi-hack to trigger validation on region and postal code gz-regex-validator has
	        // had a chance to pick up the new value (after appropriate digest cycle)
	        $rootScope.$applyAsync(resetForm);
	      }
	    }
	
	    function clearMarkers() {
	      markers.forEach(function (marker) {
	        marker.setMap(null);
	      });
	      markers.splice(0, markers.length);
	    }
	
	    function getCountry(isoCode) {
	      return _.find(vm.countries, { isoCode: isoCode });
	    }
	
	    function resetMap() {
	      if (vm.map) {
	        vm.map.panTo({ lat: 0, lng: 0 });
	        // vm.location = undefined;
	        vm.map.setZoom(1);
	      }
	    }
	
	    function resetForm() {
	      var form = vm.addressForm;
	      if (form) {
	        if (form.state) {
	          form.state.$setDirty();
	          form.state.$setTouched();
	          form.state.$validate();
	        }
	
	        if (form.postalCode) {
	          form.postalCode.$setDirty();
	          form.postalCode.$setTouched();
	          form.postalCode.$validate();
	        }
	        form.$setSubmitted();
	      }
	    }
	
	    ///////////////////////////////////////////////////////////
	    // View Model
	    function isPrintOSAddress(address) {
	      vm.reasons = [];
	      var isValid = true;
	      if (_.get(address, 'addressLine1', '').trim() === '') {
	        vm.reasons.push('uxf.uxf.invalidAddress');
	        isValid = false;
	      }
	
	      if (_.get(address, 'locality', '').trim() === '') {
	        vm.reasons.push('uxf.uxf.invalidLocality');
	        isValid = false;
	      }
	
	      if (_.get(address, 'region', '').trim() === '') {
	        vm.reasons.push('uxf.uxf.invalidRegion');
	        isValid = false;
	      }
	
	      if (vm.validators.postalCode.required && _.get(address, 'postalCode', '').trim() === '') {
	        vm.reasons.push('uxf.uxf.invalidPostalCode');
	        isValid = false;
	      }
	
	      return isValid;
	    }
	
	    ///////////////////////////////////////////////////////////
	    // Helpers
	  }
	}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(529);
	
	var _googleAddressDirective = __webpack_require__(328);
	
	var gzGoogleAddressDirective = _interopRequireWildcard(_googleAddressDirective);
	
	var _selectAddressDialogController = __webpack_require__(330);
	
	var gzSelectAddress = _interopRequireWildcard(_selectAddressDialogController);
	
	var _gazelleSrcCoreCoreModule = __webpack_require__(30);
	
	var _gazelleSrcCoreCoreModule2 = _interopRequireDefault(_gazelleSrcCoreCoreModule);
	
	exports['default'] = angular.module('gazelle.components.googleAddress', ['rhino.core.http', 'rhino.components.locale', 'gazelle.components.googleMaps', 'gazelle.components.time', 'pascalprecht.translate', 'ngMaterial', _gazelleSrcCoreCoreModule2['default']]).directive(gzGoogleAddressDirective.name, gzGoogleAddressDirective['default']).controller(gzSelectAddress.name, gzSelectAddress['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	'use strict';
	
	SelectAddressController.$inject = ["$mdDialog", "$gzAnalytics", "$gzGoogleMaps", "addresses"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SelectAddressController;
	var name = 'SelectAddressController';
	exports.name = name;
	
	function SelectAddressController($mdDialog, $gzAnalytics, $gzGoogleMaps, addresses) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var vm = this;
	  vm.loading = true;
	
	  vm.mapOptions = {
	    hideNameField: true,
	    displayMode: true,
	    onMapLoaded: handleMapLoaded
	  };
	
	  vm.selectAddress = selectAddress;
	  vm.addressChanged = addressChanged;
	  vm.cancel = cancel;
	
	  activate();
	
	  ////////////////////////
	  function activate() {
	    if (vm.addresses && vm.addresses.length > 0) {
	      vm.address = vm.addresses[0];
	      vm.mapOptions.address = vm.address;
	    }
	    vm.loading = false;
	  }
	
	  function selectAddress() {
	    var address = {
	      address: vm.address,
	      timezone: vm.timeZone
	    };
	    $mdDialog.hide(address);
	  }
	
	  function addressChanged() {
	    if (vm.mapOptions.api) {
	      vm.mapOptions.api.setAddress(vm.address).then(function (place) {
	        vm.addressDisplay = place ? place.formatted_address : $gzGoogleMaps.getFormattedAddress(vm.address);
	      });
	    }
	  }
	
	  function handleMapLoaded(place) {
	    vm.addressDisplay = place ? place.formatted_address : $gzGoogleMaps.getFormattedAddress(vm.address);
	  }
	
	  function cancel() {
	    $mdDialog.cancel();
	    $gzAnalytics.eventCancel('Select address', {});
	  }
	}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	gzGoogleMap.$inject = ["$gzGoogleMaps", "$state", "$window", "$rootScope"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzGoogleMap;
	var name = 'gzGoogleMap';
	exports.name = name;
	
	function gzGoogleMap($gzGoogleMaps, $state, $window, $rootScope) {
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      pairingId: '@?',
	      options: '=?',
	      onMapClicked: '&?',
	      awaitLocation: '=?'
	    },
	    template: __webpack_require__(238),
	    controllerAs: 'vm',
	    bindToController: true,
	    link: gzGoogleMapLink,
	    controller: gzGoogleMapController
	  };
	  return directive;
	
	  function gzGoogleMapLink(scope, element) {
	    scope.$on('$destroy', function () {
	      // Ensure map instance removed
	      $gzGoogleMaps.mapRemoved(scope.vm.pairingId);
	    });
	
	    // if (scope.vm.awaitLocation) {
	    //   element[0].classList.add('awaiting-location');
	    // }
	
	    return $gzGoogleMaps.onReady().then(function () {
	      var map = new $window.google.maps.Map(element.children()[0], {
	        // TODO: pass options through attributes
	        center: { lat: 0, lng: 0 },
	        zoom: 1,
	        zoomControl: true,
	        mapTypeControl: true,
	        scaleControl: true,
	        streetViewControl: true,
	        rotateControl: true,
	        fullscreenControl: true
	      });
	
	      // if (scope.vm.awaitLocation) {
	      //   map.addListener('center_changed', () => {
	      //     element[0].classList.remove('awaiting-location');
	      //   });
	      // }
	
	      var geocoder = new $window.google.maps.Geocoder();
	
	      $gzGoogleMaps.mapAdded(scope.vm.pairingId, map);
	
	      if (scope.vm.onMapClicked) {
	        var clickHandler = _.debounce(function (event) {
	          if (map.getZoom() < 16) {
	            return;
	          }
	
	          geocoder.geocode({ 'latLng': event.latLng }, function (results, status) {
	            if (status === $window.google.maps.GeocoderStatus.OK && results[0]) {
	              $rootScope.$applyAsync(function () {
	                scope.vm.onMapClicked({ $place: results[0] });
	              });
	            }
	          });
	        }, 400);
	        $window.google.maps.event.addListener(map, 'click', clickHandler);
	        $window.google.maps.event.addListener(map, 'dblclick', clickHandler.cancel);
	      }
	
	      return map;
	    });
	  }
	
	  // @ngInject
	  function gzGoogleMapController() {}
	}

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(530);
	
	var _googleMapsService = __webpack_require__(333);
	
	var $gzGoogleMaps = _interopRequireWildcard(_googleMapsService);
	
	var _googleMapDirective = __webpack_require__(331);
	
	var gzGoogleMap = _interopRequireWildcard(_googleMapDirective);
	
	var _placesAutoCompleteDirective = __webpack_require__(334);
	
	var gzPlacesAutoComplete = _interopRequireWildcard(_placesAutoCompleteDirective);
	
	exports['default'] = angular.module('gazelle.components.googleMaps', ['ui.router', 'rhino.core', 'rhino.components.locale']).factory($gzGoogleMaps.name, $gzGoogleMaps['default']).directive(gzGoogleMap.name, gzGoogleMap['default']).directive(gzPlacesAutoComplete.name, gzPlacesAutoComplete['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzGoogleMaps.$inject = ["rnRegistry", "rnHttp", "rnLocale", "$q", "$state", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = $gzGoogleMaps;
	var MAPS_READY_GLOBAL_CALLBACK = 'printos.gazelle.$gzGoogleMaps.mapsReady';
	
	exports.MAPS_READY_GLOBAL_CALLBACK = MAPS_READY_GLOBAL_CALLBACK;
	var name = '$gzGoogleMaps';
	exports.name = name;
	
	function $gzGoogleMaps(rnRegistry, rnHttp, rnLocale, $q, $state, $window) {
	  'ngInject';
	
	  var maps = {};
	  var mapsDeferred = {};
	  var readyDeferred = undefined;
	  var isMaps = false;
	
	  var service = {
	    mapsSupported: mapsSupported,
	    onReady: onReady,
	    onMap: onMap,
	    getMap: getMap,
	    mapAdded: mapAdded,
	    mapRemoved: mapRemoved,
	    getPlaceFromAddress: getPlaceFromAddress,
	    getPlaceFromLocation: getPlaceFromLocation,
	    getAddressFromPlace: getAddressFromPlace,
	    getTimeZoneFromAddress: getTimeZoneFromAddress,
	    getFormattedAddress: getFormattedAddress,
	    getMapsKey: getMapsKey
	  };
	  return service;
	
	  function onReady() {
	    if (!readyDeferred) {
	      return install();
	    }
	    return readyDeferred.promise;
	  }
	
	  function getMapsKey() {
	    return rnRegistry.getKey('mapsKey');
	  }
	
	  function install() {
	    return getMapsKey().then(function (apiKey) {
	      isMaps = true;
	      return addGoogleMapsScript(apiKey);
	    });
	  }
	
	  function mapsSupported() {
	    return isMaps;
	  }
	
	  function addGoogleMapsScript(apiKey) {
	    if (readyDeferred) {
	      return readyDeferred.promise;
	    }
	
	    readyDeferred = $q.defer();
	    var mapsReady = function mapsReady() {
	      readyDeferred.resolve();
	    };
	    _.set($window, MAPS_READY_GLOBAL_CALLBACK, mapsReady);
	
	    var script = $window.document.createElement('script');
	    script.type = 'text/javascript';
	    script.async = true;
	    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places&callback=' + MAPS_READY_GLOBAL_CALLBACK;
	    var firstScript = $window.document.getElementsByTagName('script')[0];
	    firstScript.parentNode.insertBefore(script, firstScript);
	
	    return readyDeferred.promise;
	  }
	
	  function onMap(pairingId) {
	    if (!pairingId) {
	      pairingId = $state.current.name;
	    }
	    var map = getMap(pairingId);
	    if (map) {
	      return $q.resolve(map);
	    }
	
	    var deferred = mapsDeferred[pairingId];
	    if (!deferred) {
	      deferred = $q.defer();
	      mapsDeferred[pairingId] = deferred;
	    }
	    return deferred.promise;
	  }
	
	  function getMap(pairingId) {
	    if (!pairingId) {
	      pairingId = $state.current.name;
	    }
	    return maps[pairingId];
	  }
	
	  function mapAdded(pairingId, map) {
	    if (!pairingId) {
	      pairingId = $state.current.name;
	    }
	    maps[pairingId] = map;
	
	    var deferred = mapsDeferred[pairingId];
	    if (deferred) {
	      deferred.resolve(map);
	      mapsDeferred[pairingId] = undefined;
	    }
	  }
	
	  function mapRemoved(pairingId) {
	    if (!pairingId) {
	      pairingId = $state.current.name;
	    }
	    maps[pairingId] = undefined;
	  }
	
	  function getPlaceFromAddress(address) {
	    var location = '';
	    if (address.addressLine1) {
	      location += address.addressLine1 + ' ';
	    }
	    if (address.addressLine2) {
	      location += address.addressLine2 + ' ';
	    }
	    if (address.locality) {
	      location += address.locality + ' ';
	    }
	    if (address.region) {
	      location += address.region + ' ';
	    }
	    if (address.postalCode) {
	      location += address.postalCode + ' ';
	    }
	    if (address.country) {
	      location += address.country;
	    }
	
	    return getPlaceFromLocation(location);
	  }
	
	  function getPlaceFromLocation(location) {
	    return getPlacePredictionFromLocation(location).then(function (place) {
	      if (place) {
	        return place;
	      }
	      // Fallback to geocoding API. Sadly some results from places API are asymmetric for some reason.
	      return getGeocodeFromLocation(location);
	    });
	  }
	
	  function getPlacePredictionFromLocation(location) {
	    return onReady().then(function () {
	      var deferred = $q.defer();
	
	      var autoCompleteService = new $window.google.maps.places.AutocompleteService();
	      autoCompleteService.getPlacePredictions({
	        input: location,
	        types: ['address']
	      }, function (predictions, status) {
	        if (status !== $window.google.maps.places.PlacesServiceStatus.OK || predictions.length === 0) {
	          return deferred.resolve();
	        }
	
	        var placesService = new $window.google.maps.places.PlacesService(document.createElement('div'));
	        placesService.getDetails({ placeId: predictions[0].place_id }, function (place, placesStatus) {
	          if (placesStatus !== $window.google.maps.places.PlacesServiceStatus.OK) {
	            return deferred.resolve();
	          }
	
	          return deferred.resolve(place);
	        });
	      });
	
	      return deferred.promise;
	    });
	  }
	
	  function getGeocodeFromLocation(location) {
	    return $q.all([getMapsKey(), getGoogleLanguageCode()]).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var mapsKey = _ref2[0];
	      var language = _ref2[1];
	
	      var config = {
	        headers: {
	          'If-Modified-Since': undefined,
	          'Cache-Control': undefined
	        },
	        method: 'GET',
	        url: 'https://maps.googleapis.com/maps/api/geocode/json',
	        withCredentials: false,
	        params: {
	          key: mapsKey,
	          address: location,
	          language: language
	        }
	      };
	
	      return rnHttp.simpleRequest(config).then(function (resp) {
	        if (resp.data.status === 'OK' && resp.data.results[0]) {
	          return resp.data.results[0];
	        }
	
	        // If we don't get any results, return undefined
	        $q.resolve(undefined);
	      })['catch'](function (error) {
	        // If something blows up, return undefined
	        $q.resolve();
	      });
	    });
	  }
	
	  function getGoogleLanguageCode() {
	    return rnLocale.getBestFit().then(function (locale) {
	      if (locale.shortName === 'zh') {
	        return 'zh-CN';
	      }
	      return locale.shortName;
	    });
	  }
	
	  function getAddressFromPlace(place) {
	    var components = _.get(place, 'address_components');
	    var address = {};
	    if (!components) {
	      return address;
	    }
	
	    // Address Line 1
	    var address1 = '';
	    var street_number = getAddressPart(components, 'street_number');
	    if (street_number) {
	      address1 += street_number.long_name;
	    }
	
	    var route = getAddressPart(components, 'route');
	    if (route) {
	      if (address1 !== '') {
	        address1 += ' ';
	      }
	      address1 += route.long_name;
	    }
	    if (address1 !== '') {
	      address.addressLine1 = address1;
	    }
	
	    // Address Line 2
	    var address2 = '';
	    var floor = getAddressPart(components, 'floor');
	    if (floor) {
	      address2 += floor.long_name;
	    }
	
	    var room = getAddressPart(components, 'room');
	    if (room) {
	      if (address2 !== '') {
	        address2 += ' ';
	      }
	      address2 += room.long_name;
	    }
	
	    var box = getAddressPart(components, 'post_box');
	    if (box) {
	      if (address2 !== '') {
	        address2 += ' ';
	      }
	      address2 += box.long_name;
	    }
	
	    var subpremise = getAddressPart(components, 'subpremise');
	    if (subpremise) {
	      if (address2 !== '') {
	        address2 += ' ';
	      }
	      address2 += subpremise.long_name;
	    }
	
	    if (address2 !== '') {
	      address.addressLine2 = address2;
	    }
	
	    // City/Locality
	    var locality = getAddressPart(components, 'locality');
	    if (locality) {
	      address.locality = locality.long_name;
	    } else {
	      locality = getAddressPart(components, 'administrative_area_level_2');
	      if (locality) {
	        address.locality = locality.long_name;
	      }
	    }
	
	    // State/Region
	    var region = getAddressPart(components, 'administrative_area_level_1');
	    if (region) {
	      address.region = region.short_name;
	    }
	
	    // Postal Code
	    var postalCode = '';
	    var code = getAddressPart(components, 'postal_code');
	    if (code) {
	      postalCode += code.long_name;
	    }
	
	    var codeSuffix = getAddressPart(components, 'postal_code_suffix');
	    if (codeSuffix) {
	      if (postalCode !== '') {
	        postalCode += '-';
	      }
	      postalCode += codeSuffix.long_name;
	    }
	
	    if (postalCode !== '') {
	      address.postalCode = postalCode;
	    }
	
	    // Country
	    var country = getAddressPart(components, 'country');
	    if (country) {
	      address.country = country.short_name;
	    }
	
	    return address;
	  }
	
	  function getTimeZoneFromAddress(address) {
	    return getMapsKey().then(function (mapsKey) {
	      return getPlaceFromAddress(address).then(function (place) {
	        var config = {
	          headers: {
	            'If-Modified-Since': undefined,
	            'Cache-Control': undefined
	          },
	          method: 'GET',
	          url: 'https://maps.googleapis.com/maps/api/timezone/json',
	          withCredentials: false,
	          params: {
	            key: mapsKey,
	            timestamp: new Date().getTime() / 1000
	          }
	        };
	
	        var location = _.get(place, 'geometry.location');
	        if (location) {
	          if (_.isFunction(location.lat)) {
	            _.set(config, 'params.location', location.lat() + ',' + location.lng());
	          } else {
	            _.set(config, 'params.location', location.lat + ',' + location.lng);
	          }
	
	          return rnHttp.simpleRequest(config).then(function (resp) {
	            return resp.data;
	          })['catch'](function (error) {
	            return $q.resolve();
	          });
	        } else {
	          return $q.resolve();
	        }
	      });
	    });
	  }
	
	  function getFormattedAddress(address) {
	    var location = '';
	
	    if (address) {
	      if (address.addressLine1) {
	        location += address.addressLine1 + ' ';
	      }
	      if (address.addressLine2) {
	        location += address.addressLine2 + ' ';
	      }
	      if (address.locality) {
	        location += address.locality + ' ';
	      }
	      if (address.region) {
	        location += address.region + ' ';
	      }
	      if (address.postalCode) {
	        location += address.postalCode + ' ';
	      }
	      if (address.country) {
	        location += address.country;
	      }
	    }
	
	    return location;
	  }
	
	  //////////////////////////
	  /// Helpers
	  //////////////////////////
	  function getAddressPart(addressComponents, part) {
	    return _.find(addressComponents, function (o) {
	      return o.types.indexOf(part) !== -1;
	    });
	  }
	}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	'use strict';
	
	gzPlacesAutoComplete.$inject = ["$gzGoogleMaps", "$window", "$rootScope", "rnHttp", "$q", "$gzTime"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = gzPlacesAutoComplete;
	var name = 'gzPlacesAutoComplete';
	exports.name = name;
	
	function gzPlacesAutoComplete($gzGoogleMaps, $window, $rootScope, rnHttp, $q, $gzTime) {
	  'ngInject';
	
	  var directive = {
	    restrict: 'A',
	    scope: {
	      onPlaceChanged: '&?',
	      pairingId: '@?',
	      place: '=?',
	      placeTypes: '=?'
	    },
	    controllerAs: 'vm',
	    bindToController: true,
	    link: gzPlacesAutoCompleteLink,
	    controller: gzPlacesAutoCompleteController
	  };
	  return directive;
	
	  function gzPlacesAutoCompleteLink(scope, element) {
	    return $q.all([$gzGoogleMaps.getMapsKey(), $gzGoogleMaps.onReady()]).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 1);
	
	      var mapsKey = _ref2[0];
	
	      var lastPlace = undefined;
	      var autocomplete = new $window.google.maps.places.Autocomplete(element[0], {
	        // TODO: allow for options
	        // TODO: pair with map for bounds and watch for map changes?
	      });
	
	      scope.$watch('vm.placeTypes', function (placeTypes) {
	        autocomplete.setTypes(placeTypes);
	      });
	
	      scope.$watch('vm.place', function (place) {
	        autocomplete.set('place', place);
	      });
	
	      if (scope.vm.onPlaceChanged) {
	        autocomplete.addListener('place_changed', function () {
	          var place = autocomplete.getPlace();
	          if (place === lastPlace) {
	            return;
	          }
	
	          lastPlace = place;
	          var config = {
	            headers: {
	              'If-Modified-Since': undefined,
	              'Cache-Control': undefined
	            },
	            method: 'GET',
	            url: 'https://maps.googleapis.com/maps/api/timezone/json',
	            withCredentials: false,
	            params: {
	              key: mapsKey,
	              timestamp: new Date().getTime() / 1000
	            }
	          };
	
	          var location = _.get(place, 'geometry.location');
	          if (location) {
	            if (_.isFunction(location.lat)) {
	              _.set(config, 'params.location', location.lat() + ',' + location.lng());
	            } else {
	              _.set(config, 'params.location', location.lat + ',' + location.lng);
	            }
	
	            rnHttp.simpleRequest(config).then(function (resp) {
	              place.gzTimeZone = $gzTime.getById(resp.data.timeZoneId);
	            })['catch'](function () {
	              $q.resolve(true);
	            })['finally'](function () {
	              $rootScope.$applyAsync(function () {
	                scope.vm.onPlaceChanged({ $place: place });
	              });
	            });
	          } else {
	            $rootScope.$applyAsync(function () {
	              scope.vm.onPlaceChanged({ $place: place });
	            });
	          }
	        });
	      }
	      return autocomplete;
	    });
	  }
	
	  // @ngInject
	  function gzPlacesAutoCompleteController() {}
	}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzHpId.$inject = ["rnHttp", "rnLocale", "$window", "$state"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = $gzHpId;
	var name = '$gzHpId';
	
	exports.name = name;
	
	function $gzHpId(rnHttp, rnLocale, $window, $state) {
	  'ngInject';
	
	  // Dynamic parameters are those not explicitly set in the router URL.
	  // Instead these are defined in the params object, usually embedded in a "data" object param.
	  var DYNAMIC_PARAMS = ['locale', 'target'];
	  // Default parameters to set for the target URL.
	  // Currently, these are parameters we want to ensure are cleared
	  // since AAA will set these on a failure.
	  var DEFAULT_TARGET_PARAMS = {
	    statusCode: null,
	    subCode: null,
	    username: null,
	    altUsername: null
	  };
	
	  var service = {
	    getLink: getLink,
	    redirect: redirect,
	    createTargetUrl: createTargetUrl
	  };
	  return service;
	
	  function getAllLinks(linkType, redirectUrl) {
	    var data = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    return rnLocale.getBestFit().then(function (locale) {
	      var body = _.assign({
	        linkType: linkType,
	        fragmentParams: true
	      }, data);
	
	      // Allow for a locale override
	      if (data.locale) {
	        locale = data.locale;
	      }
	
	      body.locale = getHpIdLocale(locale);
	      if (redirectUrl) {
	        // Ensure PrintOS locale is returned to be set correctly in preferences.
	        body.redirectUrl = ensureDynamicParams(redirectUrl, { locale: locale.value });
	      }
	
	      return rnHttp.post('aaa', 'hpid/link', body).then(function (resp) {
	        return resp.data;
	      });
	    });
	  }
	
	  function getLink() {
	    var linkType = arguments.length <= 0 || arguments[0] === undefined ? 'login' : arguments[0];
	    var redirectUrl = arguments.length <= 1 || arguments[1] === undefined ? $window.location.href : arguments[1];
	    var data = arguments.length <= 2 || arguments[2] === undefined ? undefined : arguments[2];
	
	    return getAllLinks(linkType, redirectUrl, data).then(function (data) {
	      return data.loginLink;
	    });
	  }
	
	  function getCreateLink() {
	    var linkType = arguments.length <= 0 || arguments[0] === undefined ? 'login' : arguments[0];
	    var redirectUrl = arguments.length <= 1 || arguments[1] === undefined ? $window.location.href : arguments[1];
	    var data = arguments.length <= 2 || arguments[2] === undefined ? undefined : arguments[2];
	
	    return getAllLinks(linkType, redirectUrl, data).then(function (data) {
	      return data.createLink;
	    });
	  }
	
	  function redirect(type, redirectUrl, data) {
	    var createAccount = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	    // Required to ensure Firefox BFCache (back-forward cache) doesn't cache the page in a spinning state.
	    // Without this, sign in followed by clicking back results in a stuck sign-in page with a spinner.
	    // See https://coderwall.com/p/3t6ila/disable-the-back-forward-cache-of-firefox-and-safari
	    $window.addEventListener('unload', function () {});
	
	    if (!redirectUrl) {
	      redirectUrl = createTargetUrl();
	    }
	
	    if (createAccount) {
	      return getCreateLink(type, redirectUrl, data, createAccount).then(function (link) {
	        $window.location.href = link;
	      });
	    } else {
	      return getLink(type, redirectUrl, data).then(function (link) {
	        $window.location.href = link;
	      });
	    }
	  }
	
	  function createTargetUrl() {
	    var uiState = arguments.length <= 0 || arguments[0] === undefined ? $state.current.name : arguments[0];
	    var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    params = Object.assign({}, DEFAULT_TARGET_PARAMS, params);
	    var uiRouterParams = _.omit(params, DYNAMIC_PARAMS);
	    var targetUrl = $window.location.origin + $window.location.pathname + $state.href(uiState, uiRouterParams);
	    targetUrl = ensureDynamicParams(targetUrl, params);
	    return targetUrl;
	  }
	
	  function ensureDynamicParams() {
	    var url = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	    var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // split out URL components
	
	    var _url$split = url.split('#');
	
	    var _url$split2 = _slicedToArray(_url$split, 2);
	
	    var baseUrl = _url$split2[0];
	    var fragment = _url$split2[1];
	
	    if (fragment === undefined) {
	      fragment = '';
	    }
	
	    var _fragment$split = fragment.split('?');
	
	    var _fragment$split2 = _slicedToArray(_fragment$split, 2);
	
	    var route = _fragment$split2[0];
	    var routeParams = _fragment$split2[1];
	
	    if (routeParams === undefined) {
	      routeParams = '';
	    }
	
	    _.forEach(DYNAMIC_PARAMS, function (dynamicParam) {
	      var dynamicParamValue = params[dynamicParam];
	      if (dynamicParamValue) {
	        if (dynamicParam === 'target') {
	          dynamicParamValue = $window.encodeURIComponent(dynamicParamValue);
	        }
	
	        // append params
	        if (routeParams) {
	          routeParams += '&';
	        }
	        routeParams += dynamicParam + '=' + dynamicParamValue;
	      }
	    });
	
	    // reconstitute url
	    return baseUrl + '#' + route + (routeParams ? '?' : '') + routeParams;
	  }
	
	  function getHpIdLocale(printOsLocale) {
	    var hpIdLocale = printOsLocale.value;
	    if (printOsLocale.value === 'zh-HANS') {
	      hpIdLocale = 'zh-CN';
	    } else if (printOsLocale.value === 'ko-KO') {
	      hpIdLocale = 'ko-KR';
	    }
	    return hpIdLocale;
	  }
	}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	'use strict';
	
	gzIcon.$inject = ["$log", "$compile"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzIcon;
	var name = 'gzIcon';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.icon.directive:gzIcon
	 *
	 * @param {string=} icon Specifies the icon set and the icon in that set to use.
	 *
	 * @description
	 * `<gz-icon>` is a widget that will display an md-icon.  Based on the icon set 'fa', 'md', 'hp', 'png' it will load the appropriate
	 *  icon set and use the name to render the icon.
	 *
	 * @usage
	 * ```html
	 * <gz-icon icon='set:name'></gz-icon>
	 * ```
	 */
	
	function gzIcon($log, $compile) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      icon: '@'
	    },
	    link: gzIconLink
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	
	  function gzIconLink(scope, element, attrs) {
	    // $log.debug('gzIconLink' + attrs.icon);
	    var type = '';
	    var split = attrs.icon.split(':');
	    var iconName = split[1];
	    //shudder - yucky case:
	    switch (split[0]) {
	      case 'md':
	        type = 'md-font-set="material-icons"';
	        break;
	      case 'fa':
	        type = 'md-font-set="fa"';
	        break;
	      case 'hp':
	        type = 'md-font-set=""';
	        break;
	      default:
	        $log.warn('unknown icon set specified: ' + split[0]);
	    }
	    var html = '<md-icon ' + type + '>' + iconName + '</md-icon>';
	    var e = $compile(html)(scope);
	    element.replaceWith(e);
	  }
	}
	
	//gzIcon

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzInputValidation;
	var name = 'gzInputValidation';
	
	exports.name = name;
	
	function gzInputValidation() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'E',
	    scope: {
	      msg: '@'
	    },
	    controller: gzInputValidationController,
	    controllerAs: 'vm',
	    link: gzInputValidationLinkFunction,
	    bindToController: true,
	    template: __webpack_require__(239)
	  };
	
	  return directive;
	
	  function gzInputValidationController() {
	    var vm = this;
	  }
	
	  function gzInputValidationLinkFunction(scope, element) {
	    scope.$on('$destroy', destroyHandler);
	
	    function destroyHandler() {}
	  }
	}
	
	//gzInputValidation

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(531);
	
	var _inputValidationDirective = __webpack_require__(337);
	
	var gzInputValidationDirective = _interopRequireWildcard(_inputValidationDirective);
	
	exports['default'] = angular.module('gazelle.components.input-validation', []).directive(gzInputValidationDirective.name, gzInputValidationDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	configSetMomentLocale.$inject = ["moment", "rnLocaleCookieProvider", "rnLocalPreferences"];
	runSetMomentLocale.$inject = ["$translate", "$rootScope", "amMoment", "moment"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.configSetMomentLocale = configSetMomentLocale;
	exports.runSetMomentLocale = runSetMomentLocale;
	var MOMENT_CUSTOMIZATIONS = {
	  calendar: {
	    lastDay: '[Yesterday at] LT',
	    sameDay: '[Today at] LT',
	    nextDay: '[Tomorrow at] LT',
	    lastWeek: 'dddd [at] LT',
	    nextWeek: 'dddd [at] LT',
	    sameElse: 'LLL'
	  }
	};
	
	/**
	 * Sets the moment locale during a config block by looking at local preferences if available.
	 */
	
	function configSetMomentLocale(moment, rnLocaleCookieProvider, rnLocalPreferences) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // Look first to locale cookie for user's preferred language
	  var preferredLocale = rnLocaleCookieProvider.getLocale();
	  if (!preferredLocale) {
	    // Fallback to local preferences
	    preferredLocale = _.get(rnLocalPreferences(), 'general.locale');
	  }
	
	  if (preferredLocale) {
	    preferredLocale = getSupportedLocale(preferredLocale);
	    // Can't call angular-moment here, so call moment directly
	    var momentLocaleName = moment.locale(preferredLocale);
	    moment.updateLocale(momentLocaleName, MOMENT_CUSTOMIZATIONS);
	  }
	}
	
	/**
	 * Sets the angular moment locale when the locale is changed
	 * by listening for angular-translate events.
	 */
	
	function runSetMomentLocale($translate, $rootScope, amMoment, moment) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  $rootScope.$on('$translateChangeSuccess', function () {
	    var locale = $translate.use();
	    locale = getSupportedLocale(locale);
	    // Call angular-moment for proper eventing
	    var momentLocaleName = amMoment.changeLocale(locale);
	    moment.updateLocale(momentLocaleName, MOMENT_CUSTOMIZATIONS);
	  });
	}
	
	function getSupportedLocale(locale) {
	  // moment.js doesn't currently support 'zh-HANS', need to specify the more specific variant of 'zh-cn'.
	  if (locale === 'zh-HANS') {
	    locale = 'zh-cn';
	  }
	
	  return locale;
	}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	'use strict';
	
	configSetMomentTimeZone.$inject = ["moment", "rnLocaleCookieProvider", "angularMomentConfig", "$injector"];
	runSetMomentTimeZone.$inject = ["$rootScope", "rnPreferences", "amMoment", "angularMomentConfig", "$injector"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.configSetMomentTimeZone = configSetMomentTimeZone;
	exports.runSetMomentTimeZone = runSetMomentTimeZone;
	
	function configSetMomentTimeZone(moment, rnLocaleCookieProvider, angularMomentConfig, $injector) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // Allow for configuring a bypass for setting the time zone.
	  // This is not recommended but was requested.
	  // Before configuring the app module, configure like this,
	  // angular.module('gazelle.components.l10n').constant('$gzL10nConfig', { userTimeZone: false });
	  if ($injector.has('$gzL10nConfig')) {
	    var $gzL10nConfig = $injector.get('$gzL10nConfig');
	    if ($gzL10nConfig.userTimeZone === false) {
	      return;
	    }
	  }
	
	  // Look to local preferences for user's preferred time zone
	  var preferredTz = getTimeZone(rnLocaleCookieProvider.getTimeZone());
	
	  // Can't call amMoment here, so call moment directly.
	  // Will still call amMoment above because of eventing.
	  // Leveraged from https://github.com/urish/angular-moment/blob/master/angular-moment.js#L382
	  angularMomentConfig.timezone = preferredTz;
	  if (moment.tz && moment.tz.setDefault) {
	    moment.tz.setDefault(preferredTz);
	  }
	}
	
	/**
	 * Sets the angular moment time zone when the timezone is changed
	 * by listening for rhino preference changes.
	 */
	
	function runSetMomentTimeZone($rootScope, rnPreferences, amMoment, angularMomentConfig, $injector) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // Allow for configuring a bypass for setting the time zone.
	  // This is not recommended but was requested.
	  // Before configuring the app module, configure like this,
	  // angular.module('gazelle.components.l10n').constant('$gzL10nConfig', { userTimeZone: false });
	  if ($injector.has('$gzL10nConfig')) {
	    var $gzL10nConfig = $injector.get('$gzL10nConfig');
	    if ($gzL10nConfig.userTimeZone === false) {
	      return;
	    }
	  }
	
	  rnPreferences.getAll().then(function (prefs) {
	    return changeTimeZone(prefs);
	  });
	
	  $rootScope.$on('rnPreferencesUpdated', function (events, prefs) {
	    return changeTimeZone(prefs);
	  });
	
	  /**
	   * Change angular moment time zone based on rhino preferences.
	   * @param prefs rhino preferences
	   * @param prefs.general general preferences
	   * @param prefs.general.timeZone time zone preference
	   */
	  function changeTimeZone(prefs) {
	    var timeZonePref = _.get(prefs, 'general.timeZone');
	    var preferredTz = getTimeZone(timeZonePref);
	    if (angularMomentConfig.timezone !== preferredTz) {
	      amMoment.changeTimezone(preferredTz);
	    }
	  }
	}
	
	function getTimeZone(timeZonePref) {
	  if (timeZonePref) {
	    var tzParts = timeZonePref.split(/\s+/);
	    // support old time zone preference format with UTC offset in front.
	    if (tzParts.length > 1) {
	      return tzParts[1];
	    }
	    return tzParts[0];
	  }
	  return null;
	}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	'use strict';
	
	gzL10nLoader.$inject = ["$log", "$q", "$translate", "rnHttp", "rnRegistry"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzL10nLoader;
	var name = 'gzL10nLoader';
	
	exports.name = name;
	
	function gzL10nLoader($log, $q, $translate, rnHttp, rnRegistry) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  return loadAllCatalogs;
	
	  /////////////////
	
	  /**
	   * Loads all specified catalogs
	   * @example
	   * loadAllCatalogs({
	   * catalogServices: {
	   *    'admin.common': 'portal_service'
	   *  },
	   * });
	   * @param options.catalogServices mapping of catalogs to Genesis services
	   *  where these catalogs can be retrieved.  Catalog URLs will be resolved using the rhino registry.
	   * @returns {Promise.<Object>} a promise to an object with localized strings.
	   */
	  function loadAllCatalogs(options) {
	    var catalogPromises = [];
	
	    // Reduce locales like 'en-UK' to language codes understood by Genesis services.
	    var lang = options.key.split('-')[0];
	
	    if (!options.catalogServices) {
	      options.catalogServices = {};
	    }
	
	    ensureDefaultCatalogs(options.catalogServices);
	
	    _.forIn(options.catalogServices, function (service, catId) {
	      catalogPromises.push(loadCatalogFromService(service, catId, lang));
	    });
	
	    return resolveCatalogPromises(options.key, catalogPromises);
	  }
	
	  function resolveCatalogPromises(langKey, promises) {
	    // Inspired by the source for $q.all() but to not stop at first rejection.
	    // https://github.com/angular/angular.js/blob/6838c979451c109d959a15035177ccee715ccf19/src/ng/q.js#L538
	    var deferred = $q.defer();
	    var allCatalogs = {};
	
	    var remainingPromises = promises.length;
	    _.forEach(promises, function resolved(promise) {
	      promise.then(function (catalog) {
	        // Append to all catalogs object
	        _.assign(allCatalogs, catalog);
	      })['finally'](function promiseFinally() {
	        // See if there are any promises left.
	        // If not, resolve if we have any catalog data or reject otherwise.
	        remainingPromises--;
	        if (remainingPromises <= 0) {
	          if (!_.isEmpty(allCatalogs)) {
	            deferred.resolve(allCatalogs);
	          } else {
	            deferred.reject(langKey);
	          }
	        }
	      });
	    });
	
	    return deferred.promise;
	  }
	
	  function ensureDefaultCatalogs(catalogServices) {
	    if (!catalogServices['uxf.uxf']) {
	      catalogServices['uxf.uxf'] = 'portal_service';
	    }
	  }
	
	  function loadCatalogFromService(service, catId, lang) {
	    var catalogId = getCatalogId(catId);
	
	    return rnRegistry.getRegistry().then(function (registry) {
	      var printosVersion = registry.keys.printosVersion;
	      var opts = {
	        cache: true
	      };
	      if (printosVersion) {
	        // Cache catalogs by PrintOS deployment version
	        opts.params = {
	          v: printosVersion
	        };
	        opts.headers = {
	          // Overwrite default parameters
	          'If-Modified-Since': undefined,
	          'Cache-Control': undefined
	        };
	      }
	      return rnHttp.get(service, 'i18n/' + catalogId + '/' + lang, opts);
	    }).then(function (response) {
	      var messages = response.data.messages;
	      var catalog = {};
	      _.forEach(messages, function (message) {
	        catalog[catId + '.' + message.msgId] = message.msgText;
	      });
	      return catalog;
	    })['catch'](function (res) {
	      $log.warn('Failed to get localization catalog \'' + catId + '\' from ' + service);
	      $q.reject(res);
	    });
	  }
	
	  function getCatalogId(catId) {
	    var catRefArray = catId.split('.');
	    var catalogId = catRefArray[0];
	    if (catRefArray.length > 1) {
	      // Support old 'appId.catalogId' form
	      catalogId = catRefArray[1];
	    }
	
	    return catalogId;
	  }
	}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	gzL10nInterpolationService.$inject = ["moment"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzL10nInterpolationService;
	var name = 'gzL10nInterpolationService';
	
	exports.name = name;
	/**
	 * An angular-translate interpolation service for supporting a simplified Java MessageFormat
	 * syntax.  By Default, angular-translate interpolates parameters like angular with syntax {{token}}.
	 * Java syntax uses placeholders like {0}, {1}, etc.
	 *
	 * Angular-translate by default expects an object for interpolation parameters.  This service instead
	 * expects an array of parameters, similar to Java syntax.
	 *
	 * @example
	 *  <div translate="pb.app.THOUSANDS_OF_IMPRESSIONS" translate-values="[{{vm.currentImpressionCount()}}]"></div>
	 *  <div translate="app.catalog.MULTIPLE_VALUES_REQUIRED" translate-values="['a','b','c','d']"></div>
	 *
	 * Dates are supported and localized using moment.js.  Date FormatStyle is not currently supported and defaults to
	 * the localized moment.js format 'LL'.
	 *
	 * This currently does not support any MessageFormat FormatTypes besides 'date' and any FormatStyle parameters.
	 *
	 * @see https://github.com/angular-translate/angular-translate/issues/924
	 * @see http://docs.oracle.com/javase/7/docs/api/java/text/MessageFormat.html
	 * @returns {{setLocale: setLocale, getInterpolationIdentifier: getInterpolationIdentifier, interpolate: interpolate}}
	 */
	
	function gzL10nInterpolationService(moment) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var messageArgIndexGroup = '(\\d+)';
	  var messageFormatTypeOptionalGroup = '(?:,(\\w+))?';
	  var messageFormatRegExp = new RegExp('\\{' + messageArgIndexGroup + messageFormatTypeOptionalGroup + '\\}', 'g');
	
	  var service = {
	    setLocale: setLocale,
	    getInterpolationIdentifier: getInterpolationIdentifier,
	    interpolate: interpolate
	  };
	
	  return service;
	
	  /////////////////
	
	  function setLocale(locale) {}
	
	  function getInterpolationIdentifier() {
	    return 'java';
	  }
	
	  function interpolate(str, interpolateParams) {
	    if (!interpolateParams || _.isEmpty(interpolateParams)) {
	      return str;
	    }
	
	    // Looks like angular-translate requires an object with parameters or an array.
	    // This convenience doesn't currently work.
	    // Wrap a single object into an array for ease of using a single element
	    //if(!Array.isArray(interpolateParams)) {
	    //  interpolateParams = [interpolateParams];
	    //}
	
	    // Adapted from http://stackoverflow.com/a/1353411/277307
	    return str.replace(messageFormatRegExp, function (match, argumentIndex, formatType) {
	      var paramValue = interpolateParams[argumentIndex];
	
	      switch (formatType) {
	        case 'date':
	          return formatDate(paramValue);
	        case 'time':
	          return formatTime(paramValue);
	        default:
	          return paramValue;
	      }
	    });
	  }
	
	  function formatDate(paramValue) {
	    return moment(paramValue).format('LL');
	  }
	
	  function formatTime(paramValue) {
	    return moment(paramValue).format('LT');
	  }
	}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';
	
	gzL10nMissingTranslation.$inject = ["$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzL10nMissingTranslation;
	var name = 'gzL10nMissingTranslation';
	
	exports.name = name;
	
	function gzL10nMissingTranslation($log) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var missedIds = {};
	
	  return missingTranslation;
	
	  /////////////////
	
	  function missingTranslation(translationId) {
	    if (!missedIds[translationId]) {
	      missedIds[translationId] = true;
	      $log.warn("Missing translation: " + translationId);
	    }
	  }
	}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc overview
	 * @name gazelle.components.l10n
	 * @description Provides for configuring localization using angular-translate for strings
	 *  and angular-moment with moment.js for dates and times.  Moment.js is configured for the
	 *  user's preferred locale and time zone so that application developers may simply use these
	 *  tools without worrying about determining the user's preferences.
	 */
	'use strict';
	
	configureTranslationProvider.$inject = ["$translateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _amLocaleRun = __webpack_require__(339);
	
	var setMomentLocale = _interopRequireWildcard(_amLocaleRun);
	
	var _amTimezoneRun = __webpack_require__(340);
	
	var setMomentTimeZone = _interopRequireWildcard(_amTimezoneRun);
	
	var _l10nRun = __webpack_require__(345);
	
	var setLanguage = _interopRequireWildcard(_l10nRun);
	
	var _l10nFactory = __webpack_require__(341);
	
	var gzL10nLoader = _interopRequireWildcard(_l10nFactory);
	
	var _l10nMissingFactory = __webpack_require__(343);
	
	var gzL10nMissingTranslation = _interopRequireWildcard(_l10nMissingFactory);
	
	var _l10nInterpolationService = __webpack_require__(342);
	
	var gzL10nInterpolationService = _interopRequireWildcard(_l10nInterpolationService);
	
	var _mdDateformatConfig = __webpack_require__(346);
	
	var _mdDateformatConfig2 = _interopRequireDefault(_mdDateformatConfig);
	
	var _module = angular.module('gazelle.components.l10n', ['rhino.core', 'rhino.components.locale', 'rhino.components.preferences', 'pascalprecht.translate', 'angularMoment', 'ngMaterial']).config(configureTranslationProvider).config(setLanguage.configSetPreferredLanguage).config(setMomentLocale.configSetMomentLocale).config(setMomentTimeZone.configSetMomentTimeZone).config(_mdDateformatConfig2['default']).factory(gzL10nInterpolationService.name, gzL10nInterpolationService['default']).factory(gzL10nMissingTranslation.name, gzL10nMissingTranslation['default']).factory(gzL10nLoader.name, gzL10nLoader['default'])
	// proxy L10N filter to angular-translate filter for legacy code
	.filter('L10N', ["translateFilter", function (translateFilter) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  return translateFilter;
	}]);
	
	function configureTranslationProvider($translateProvider) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  $translateProvider.useInterpolation(gzL10nInterpolationService.name);
	  if (false) {
	    $translateProvider.useMissingTranslationHandler(gzL10nMissingTranslation.name);
	  }
	
	  // Initialize to US English and then update after we receive preferences.
	  $translateProvider.preferredLanguage('en-US');
	}
	
	// Don't include this while testing because of problems with extra $http calls
	/* global __TEST__ */
	if (true) {
	  _module.run(setMomentLocale.runSetMomentLocale).run(setMomentTimeZone.runSetMomentTimeZone).run(setLanguage.runSetLanguage);
	}
	
	exports['default'] = _module.name;
	module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	'use strict';
	
	configSetPreferredLanguage.$inject = ["$translateProvider", "rnLocaleCookieProvider", "rnLocalPreferences"];
	runSetLanguage.$inject = ["$translate", "rnLocale"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.configSetPreferredLanguage = configSetPreferredLanguage;
	exports.runSetLanguage = runSetLanguage;
	
	function configSetPreferredLanguage($translateProvider, rnLocaleCookieProvider, rnLocalPreferences) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // Look first to locale cookie for user's preferred language
	  var preferredLocale = rnLocaleCookieProvider.getLocale();
	  if (!preferredLocale) {
	    // Fallback to local preferences with a default of US English
	    preferredLocale = _.get(rnLocalPreferences(), 'general.locale', 'en-US');
	  }
	
	  $translateProvider.preferredLanguage(preferredLocale);
	}
	
	function runSetLanguage($translate, rnLocale) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  rnLocale.getBestFit().then(function (bestFitLocale) {
	    $translate.use(bestFitLocale.value);
	  });
	}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	/**
	 * Use moment to format and validate dates with angular material
	 */
	'use strict';
	
	configMaterialDates.$inject = ["$mdDateLocaleProvider", "moment"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = configMaterialDates;
	
	function configMaterialDates($mdDateLocaleProvider, moment) {
	  'ngInject';
	
	  $mdDateLocaleProvider.formatDate = function (date) {
	    return moment(date).format('l');
	  };
	
	  $mdDateLocaleProvider.parseDate = function (dateString) {
	    var m = moment(dateString, 'l', true);
	    return m.isValid() ? m.toDate() : new Date(NaN);
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzLocaleSelect;
	var name = 'gzLocaleSelect';
	exports.name = name;
	
	function gzLocaleSelect()
	// Directive angular dependencies
	{
	  'ngInject';
	
	  localeSelectController.$inject = ["rnLocale", "$translate", "$q"];
	  var directive = {
	    restrict: 'EA',
	    require: '^ngModel',
	    scope: {
	      gzExcludes: '=?',
	      gzNative: '@?'
	    },
	    template: __webpack_require__(240),
	    link: localeSelectLink,
	    controller: localeSelectController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function localeSelectLink(scope, element, attrs, ngModelCtrl) {
	    attrs.$observe('required', function (required) {
	      if (required) {
	        element.find('md-select')[0].setAttribute('required', '');
	      } else {
	        element.find('md-select')[0].removeAttribute('required');
	      }
	      // For some reason, this isn't automatically going to the label also.
	      element.find('label').toggleClass('md-required', required);
	    });
	
	    // Adapted from https://stackoverflow.com/a/34001183/277307
	    scope.vm.setModelValue = function () {
	      ngModelCtrl.$setViewValue(scope.vm.selectedLocale);
	    };
	  }
	
	  /** @ngInject */
	  function localeSelectController(rnLocale, $translate, $q) {
	    // Constants
	
	    // Variables
	
	    // View Model
	    var vm = this;
	    vm.selectedLocale = undefined;
	    vm.localeOptions = [];
	    vm.limitedLocaleOptions = [];
	
	    vm.$onInit = onInit;
	
	    return;
	
	    function onInit() {
	      if (!vm.gzNative) {
	        vm.gzNative = 'primary';
	      }
	
	      return $q.all([setInitialLocale(), setLocales()]);
	    }
	
	    function setInitialLocale() {
	      return rnLocale.getBestFit().then(function (locale) {
	        vm.selectedLocale = locale;
	        vm.setModelValue();
	      });
	    }
	
	    function setLocales() {
	      return $translate.onReady().then(function () {
	        return rnLocale.localeOptions();
	      }).then(function (locales) {
	        vm.localeOptions = _.filter(locales, { limited: false });
	        vm.limitedLocaleOptions = _.filter(locales, { limited: true });
	        if (vm.gzExcludes) {
	          vm.localeOptions = _.filter(vm.localeOptions, function (locale) {
	            return !isExcluded(locale);
	          });
	          vm.limitedLocaleOptions = _.filter(vm.limitedLocaleOptions, function (locale) {
	            return !isExcluded(locale);
	          });
	        }
	
	        vm.localeOptions = _.sortBy(vm.localeOptions, function (locale) {
	          return $translate.instant('uxf.uxf.' + locale.value);
	        });
	        vm.limitedLocaleOptions = _.sortBy(vm.limitedLocaleOptions, function (locale) {
	          return $translate.instant('uxf.uxf.' + locale.value);
	        });
	      });
	    }
	
	    function isExcluded(locale) {
	      return _.includes(vm.gzExcludes, locale.value) || _.includes(vm.gzExcludes, getShortName(locale));
	    }
	
	    function getShortName(locale) {
	      return locale.value.split('-')[0];
	    }
	  }
	}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	GzMonthSelectorChangeDatesController.$inject = ["$mdDialog", "$translate", "moment", "created"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = GzMonthSelectorChangeDatesController;
	var name = 'gzMonthSelectorChangeDatesController';
	exports.name = name;
	
	function GzMonthSelectorChangeDatesController($mdDialog, $translate, moment, created) {
	
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var MONTHS = moment.months();
	
	  var vm = this;
	
	  vm.isOrgOrigination = false;
	  vm.created = created;
	
	  vm.cancel = cancel;
	  vm.submit = submit;
	  vm.initiateMonths = initiateMonths;
	  vm.updateOrgOrigination = updateOrgOrigination;
	
	  vm.test = {
	    initiateYears: initiateYears,
	    initiateMonths: initiateMonths
	  };
	
	  activate();
	
	  //////////////
	
	  function activate() {
	    initiateYears();
	    initiateMonths();
	  }
	
	  function cancel() {
	    $mdDialog.cancel();
	  }
	
	  function submit() {
	    var monthIndex = _.findIndex(MONTHS, function (m) {
	      return m === vm.selectedMonth;
	    });
	    $mdDialog.hide(moment([vm.selectedYear, monthIndex]));
	  }
	
	  function initiateMonths() {
	    var today = moment();
	
	    // moment.month() uses 0-indexed months so we'll use this convention too
	    var startMonth = vm.selectedYear === vm.created.year() ? vm.created.month() : 0;
	    // We don't want to go beyond the current month of the current year
	    var endMonth = vm.selectedYear === today.year() ? today.month() : 11;
	
	    vm.availableMonths = [];
	    for (var i = startMonth; i <= endMonth; i++) {
	      vm.availableMonths.push(MONTHS[i]);
	    }
	
	    if (vm.selectedMonth === undefined) {
	      // Initialize to today's month if it's the current year, otherwise, initialize to the first month in the
	      // selected year.
	      if (vm.selectedYear === today.year()) {
	        vm.selectedMonth = vm.availableMonths[today.month()];
	      } else {
	        vm.selectedMonth = vm.availableMonths[0];
	      }
	    }
	
	    updateOrgOrigination();
	  }
	
	  function initiateYears() {
	    var today = moment();
	
	    // Initialize to today's year
	    vm.selectedYear = today.year();
	
	    vm.availableYears = [];
	    for (var i = vm.created.year(); i <= vm.selectedYear; i++) {
	      vm.availableYears.push(i);
	    }
	  }
	
	  function updateOrgOrigination() {
	    vm.isOrgOrigination = vm.selectedYear === vm.created.year() && vm.selectedMonth === vm.created.format('MMMM');
	  }
	}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzMonthSelector;
	var name = 'gzMonthSelector';
	exports.name = name;
	
	function gzMonthSelector()
	// Directive angular dependencies
	{
	  'ngInject';
	
	  monthSelectorController.$inject = ["moment", "rnOrganization", "$mdDialog"];
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      dateChanged: '=',
	      initialDate: '='
	    },
	    template: __webpack_require__(242),
	    link: monthSelectorLink,
	    controller: monthSelectorController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function monthSelectorLink(scope, element, attrs) {}
	
	  /** @ngInject */
	  function monthSelectorController(
	  // Controller angular dependencies
	  moment, rnOrganization, $mdDialog) {
	    // Constants
	
	    // Variables
	
	    // View Model
	    var vm = this;
	
	    //   VM properties
	    vm.dateRanges = [];
	    vm.isLoading = true;
	    vm.currentRangeIndex = 0;
	
	    //   VM methods
	    vm.getCurrentDateRange = getCurrentDateRange;
	    vm.isEarliestDateRange = isEarliestDateRange;
	    vm.changeDates = changeDates;
	    vm.previousDateRange = previousDateRange;
	    vm.nextDateRange = nextDateRange;
	
	    vm.$onInit = onInit;
	    return;
	
	    ///////////////
	    // Init
	    function onInit() {
	      rnOrganization.getOrganization().then(function (org) {
	        var fullCreatedDate = moment(org.data.createdTime);
	        // We want only month and year so we can more easily compare
	        vm.created = moment([fullCreatedDate.year(), fullCreatedDate.month()]);
	
	        initDateRanges(vm.initialDate);
	      })['finally'](function () {
	        vm.isLoading = false;
	      });
	    }
	
	    ///////////////
	    // VM methods
	
	    function getCurrentDateRange() {
	      if (!_.isEmpty(vm.dateRanges)) {
	        var date = vm.dateRanges[vm.currentRangeIndex][0];
	        return date;
	      }
	    }
	
	    function isEarliestDateRange() {
	      var cur = getCurrentDateRange();
	      if (cur) {
	        return cur.year() === vm.created.year() && cur.month() === vm.created.month();
	      }
	    }
	
	    function changeDates($event) {
	      $event.stopPropagation();
	
	      return $mdDialog.show({
	        parent: angular.element(document.body),
	        targetEvent: $event,
	        clickOutsideToClose: false,
	        escapeToClose: true,
	        template: __webpack_require__(241),
	        controller: 'gzMonthSelectorChangeDatesController',
	        bindToController: true,
	        controllerAs: 'vm',
	        locals: {
	          created: vm.created,
	          dateRanges: vm.dateRanges
	        }
	      }).then(function (newDate) {
	        var lastDate = vm.dateRanges[vm.dateRanges.length - 1][0];
	
	        while (newDate.isBefore(lastDate)) {
	          var lastRangeBegin = vm.dateRanges[vm.dateRanges.length - 1][0];
	          addDateRanges(lastRangeBegin.clone().subtract(1, 'month'));
	          lastDate = vm.dateRanges[vm.dateRanges.length - 1][0];
	        }
	
	        for (var i = 0; i < vm.dateRanges.length; i++) {
	          if (vm.dateRanges[i][0].year() === newDate.year() && vm.dateRanges[i][0].month() === newDate.month()) {
	            vm.currentRangeIndex = i;
	            break;
	          }
	        }
	
	        notifyParent();
	      });
	    }
	
	    function previousDateRange() {
	      if (getCurrentDateRange().isBefore(vm.created)) {
	        return;
	      }
	
	      if (vm.currentRangeIndex >= vm.dateRanges.length - 1) {
	        var lastRangeBegin = vm.dateRanges[vm.dateRanges.length - 1][0];
	        addDateRanges(lastRangeBegin.clone().subtract(1, 'month'));
	      }
	      vm.currentRangeIndex++;
	
	      notifyParent();
	    }
	
	    function nextDateRange() {
	      if (vm.currentRangeIndex === 0) {
	        var lastRangeBegin = vm.dateRanges[0][0];
	        addDateRanges(lastRangeBegin.clone().add(1, 'month'), false);
	      }
	
	      if (vm.currentRangeIndex > 0) {
	        vm.currentRangeIndex--;
	      }
	
	      notifyParent();
	    }
	
	    function notifyParent() {
	      vm.dateChanged(vm.getCurrentDateRange());
	    }
	
	    ///////////////
	    // Helpers
	
	    function initDateRanges(initialDate) {
	      var endOfToday = moment(initialDate).endOf('day');
	      addDateRanges(endOfToday);
	    }
	
	    function addDateRanges(rangeBegin) {
	      var goBackwards = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      for (var i = 0; i < 12; i++) {
	
	        if (rangeBegin < vm.created) {
	          return;
	        }
	
	        var nextRangeEnd = rangeBegin.clone().endOf('month');
	        var nextRangeBegin = moment([rangeBegin.year(), rangeBegin.month()]);
	
	        if (goBackwards) {
	          vm.dateRanges.push([nextRangeBegin, nextRangeEnd]);
	          rangeBegin = nextRangeBegin.clone().subtract(1, 'month');
	        } else {
	          vm.dateRanges.splice(0, 0, [nextRangeBegin, nextRangeEnd]);
	          rangeBegin = nextRangeBegin.clone().add(1, 'month');
	          vm.currentRangeIndex++;
	        }
	      }
	    }
	  }
	}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(533);
	
	var _coreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _coreAnalyticsAnalyticsModule2 = _interopRequireDefault(_coreAnalyticsAnalyticsModule);
	
	var _monthSelectorDirective = __webpack_require__(349);
	
	var gzMonthSelectorDirective = _interopRequireWildcard(_monthSelectorDirective);
	
	var _change_datesController = __webpack_require__(348);
	
	var changeDates = _interopRequireWildcard(_change_datesController);
	
	exports['default'] = angular.module('gazelle.components.monthSelector', ['angularMoment', _coreAnalyticsAnalyticsModule2['default']]).directive(gzMonthSelectorDirective.name, gzMonthSelectorDirective['default']).controller(changeDates.name, changeDates['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	gzMouseWheelDown.$inject = ["$compile", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzMouseWheelDown;
	var name = 'gzMouseWheelDown';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.mouse.wheelDown.directive:gzMouseWheelDown
	 *
	 * @description
	 * `<gz-mouse-wheel-down>` captures wheel down events.
	 *
	 * @usage
	 * ```html
	 * <div gz-mouse-wheel-down='vm.wheelDown()'>
	 *
	 * ```
	 */
	
	function gzMouseWheelDown($compile, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    link: gzMouseDownLink
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	  function gzMouseDownLink(scope, element, attrs) {
	    element.bind('DOMMouseScroll mousewheel onmousewheel', function (ev) {
	      var prevent = false;
	      if (attrs.gzMouseWheelPrevent) {
	        prevent = scope.$eval(attrs.gzMouseWheelPrevent);
	      }
	
	      if (!prevent) {
	        var _event = $window.event || ev;
	        var delta = Math.max(-1, Math.min(1, _event.wheelDelta || -_event.detail));
	        if (delta < 0) {
	          scope.$apply(function () {
	            scope.$eval(attrs.gzMouseWheelDown);
	          });
	        }
	
	        if (_event.preventDefault) {
	          _event.preventDefault();
	        }
	
	        // for IE
	        _event.returnValue = false;
	      }
	    });
	  }
	}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _wheelDownDirective = __webpack_require__(351);
	
	var wheelDownDirective = _interopRequireWildcard(_wheelDownDirective);
	
	exports['default'] = angular.module('gazelle.components.mouse.wheelDown', []).directive(wheelDownDirective.name, wheelDownDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	'use strict';
	
	gzMouseWheelUp.$inject = ["$compile", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzMouseWheelUp;
	var name = 'gzMouseWheelUp';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.mouse.wheelUp.directive:gzMouseWheelUp
	 *
	 * @description
	 * `<gz-mouse-wheel-up>` captures wheel down events.
	 *
	 * @usage
	 * ```html
	 * <div gz-mouse-wheel-up='vm.wheelUp()'>
	 *
	 * ```
	 */
	
	function gzMouseWheelUp($compile, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    link: gzMouseUpLink
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	  function gzMouseUpLink(scope, element, attrs) {
	    element.bind('DOMMouseScroll mousewheel onmousewheel', function (ev) {
	      var prevent = false;
	      if (attrs.gzMouseWheelPrevent) {
	        prevent = scope.$eval(attrs.gzMouseWheelPrevent);
	      }
	
	      if (!prevent) {
	        var _event = $window.event || ev;
	        var delta = Math.max(-1, Math.min(1, _event.wheelDelta || -_event.detail));
	        if (delta > 0) {
	          scope.$apply(function () {
	            scope.$eval(attrs.gzMouseWheelUp);
	          });
	        }
	
	        if (_event.preventDefault) {
	          _event.preventDefault();
	        }
	
	        // for IE
	        _event.returnValue = false;
	      }
	    });
	  }
	}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _wheelUpDirective = __webpack_require__(353);
	
	var wheelUpDirective = _interopRequireWildcard(_wheelUpDirective);
	
	exports['default'] = angular.module('gazelle.components.mouse.wheelUp', []).directive(wheelUpDirective.name, wheelUpDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	'use strict';
	
	gzOuterContainer.$inject = ["$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzOuterContainer;
	var name = 'gzOuterContainer';
	exports.name = name;
	
	function gzOuterContainer($log) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    template: '<ng-transclude></ng-transclude>',
	    link: gzOuterContainerLink
	  };
	
	  return directive;
	
	  /////////////////
	  // private functions
	
	  function gzOuterContainerLink(scope, element, attrs) {
	    // $log.debug('found a gz-outer-container!');
	  }
	}
	
	//gzOuterContainer

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	gzPageHeader.$inject = ["$log", "$state"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzPageHeader;
	var name = 'gzPageHeader';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.pageHeader.directive:gzPageHeader
	 *
	 * @param {string=} title. Specify the Page title
	 *
	 * @description
	 * `<gz-page-header>` is a widget that places a page header for the current page. A page-header is a title bar that contains
	 * bread-crumb navigation, a page title, and optional tool-bar content.
	 *
	 * @usage
	 * ```html
	 * <gz-page-header
	 *   page-title="{{'pageTitle' | translate}}"
	 *   parent-state="{{ui-router state to go back to}}"
	 *   parent-description="{{'backArrowTooltip' | translate}}"
	 *   breadcrumbs="array of breadcrumb descriptions"
	 *   support-task="true to allow header to switch between Task Mode and Normal Mode"
	 *   is-full-app="true to show the app navigation by default"
	 *   submit-states="(OPTIONAL) array of state names to allow submit.  Will assume entry point state if not provided"
	 *   hide-back-to-task="(OPTIONAL) true to suppress the 'Back to Task' button on the task bar"
	 *   hide-exit-task="(OPTIONAL) true to suppress the 'Exit Task' button on the task bar"
	 *   responsive-mode="'collapse' or 'row', default is none.  'collapse' will collapse into a sub-menu where 'row' will move menu to new row under responsive"
	 *   task-title="{{'taskTitleToUseInTaskMode' | translate}}"
	 *   task-submit="controller.submit function that returns promise which returns payload (REQUIRED if support-task='true') "
	 *   task-submit-title="{{'submitButtonTitleOverride' | translate}}"
	 *   task-cancel="controller.cancel function that returns promise"
	 *   task-exit="controller.exit function that returns promise for clean up of any application task data"
	 *   task-disable-submit="controller.disableSubmit function that returns boolean"
	 * >
	 *  <span layout='row'>
	 *    <i class='toolbar-icon fa fa-plus fa-2x' ...></i>
	 *    <i class='toolbar-icon fa fa-edit fa-2x' ...></i>
	 *  </span>
	 *
	 * ```
	 */
	
	function gzPageHeader($log, $state) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzPageHeaderController.$inject = ["$scope", "$mdMedia", "$gzGo", "$translate", "rnClient", "rnApplication", "$state"];
	  var directive = {
	    restrict: 'EA',
	    transclude: true,
	    scope: {
	      pageTitle: '@',
	      parentState: '@',
	      parentStateParams: '=?',
	      parentDescription: '@',
	      breadcrumbs: '=?',
	      supportTask: '@',
	      submitStates: '=?',
	      isFullApp: '=?',
	      hideBackToTask: '=?',
	      hideExitTask: '=?',
	      hideCancel: '=?',
	      responsiveMode: '@',
	      taskTitle: '@',
	      taskSubmit: '=?',
	      taskSubmitTitle: '@',
	      taskCancel: '=?',
	      taskExit: '=?',
	      taskDisableSubmit: '=?'
	    },
	    template: __webpack_require__(243),
	    link: gzPageHeaderLink,
	    controller: gzPageHeaderController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	  function gzPageHeaderLink(scope, element, attrs) {
	    element.attr({
	      'role': 'header'
	    });
	    if (attrs.pageTitle === undefined) {
	      $log.warn('pageTitle is undefined. Set the page title using the page-title attribute.');
	      attrs.pageTitle = attrs.title;
	      element.removeAttr('title');
	    }
	    if (attrs.title !== undefined) {
	      $log.warn('Using title to set the page title has been deprecated. Please use page-title.');
	    }
	  }
	
	  /** @ngInject */
	  function gzPageHeaderController($scope, $mdMedia, $gzGo, $translate, rnClient, rnApplication, $state) {
	    var vm = this;
	
	    var showFullAppTitle = undefined;
	    var hideFullAppTitle = undefined;
	
	    vm.$mdMedia = $mdMedia;
	    vm.$gzGo = $gzGo;
	    vm.getPageTitle = getPageTitle;
	    vm.cancel = cancel;
	    vm.submit = submit;
	    vm.taskSource = null;
	    vm.toggleAppNav = toggleAppNav;
	    vm.getShowHideTitle = getShowHideTitle;
	    vm.appNavShown = appNavShown;
	    vm.exitTask = exitTask;
	    vm.isLoading = true;
	    vm.showToolbar = false;
	    vm.isResponsive = false;
	    vm.isCollapse = false;
	    vm.isTask = false;
	    vm.goToTask = goToTask;
	    vm.gotoParent = gotoParent;
	    vm.gotoState = gotoState;
	
	    // Code here to manage/manipulate/respond to the breadcrumb links
	
	    activate();
	
	    //////////////////
	
	    function activate() {
	      if (vm.responsiveMode) {
	        if (vm.responsiveMode === "collapse") {
	          vm.isResponsive = true;
	          vm.isCollapse = true;
	        } else if (vm.responsiveMode === "row") {
	          vm.isResponsive = true;
	          vm.isCollapse = false;
	        }
	      }
	
	      if (vm.isFullApp) {
	        $gzGo.setAppNav(true);
	      }
	
	      var promises = [];
	      promises.push(initTask());
	      promises.push(initFeatures());
	      return Promise.all(promises);
	    }
	
	    function initTask() {
	      return $gzGo.taskIsActive().then(function (isActive) {
	        vm.taskData = $gzGo.getTaskData();
	        vm.hideTaskBar = _.get(vm.taskData, 'payload.hideTaskBar', false);
	        vm.allowExitToApp = _.get(vm.taskData, 'payload.allowExitToApp', true);
	        vm.allowAppNav = _.get(vm.taskData, 'payload.allowAppNav', true);
	        vm.returnLabel = _.get(vm.taskData, 'payload.returnLabel');
	        if (vm.taskDisableSubmit) {
	          vm.disableSubmit = vm.taskDisableSubmit;
	        } else {
	          vm.disableSubmit = defaultDisableSubmit;
	        }
	
	        if (isActive) {
	          vm.isTask = true;
	          if (vm.submitStates) {
	            vm.isSubmitPage = vm.submitStates.indexOf($state.current.name) > -1;
	          } else {
	            vm.isSubmitPage = $gzGo.getTaskId() === $state.current.name;
	          }
	
	          return rnApplication.getAppLocName(vm.taskData.appId).then(function (name) {
	            vm.taskSource = vm.returnLabel ? vm.returnLabel : name;
	            return rnApplication.getAppLocName(rnApplication.getCurrentAppId()).then(function (name) {
	              showFullAppTitle = $translate.instant('uxf.uxf.Show_FullApp', [name]);
	              hideFullAppTitle = $translate.instant('uxf.uxf.Hide_FullApp', [name]);
	              vm.exitToApplicationTitle = $translate.instant('uxf.uxf.Exit_Task', [name]);
	            })['finally'](function () {
	              vm.isLoading = false;
	            });
	          });
	        } else {
	          vm.isLoading = false;
	        }
	      });
	    }
	
	    function initFeatures() {
	      return rnClient.getConfig().then(function (resp) {
	        vm.isNavUX = resp.features.includes('ux-navigation');
	      });
	    }
	
	    function getPageTitle() {
	      if (vm.taskTitle) {
	        return vm.taskTitle();
	      }
	
	      return vm.pageTitle;
	    }
	
	    function gotoParent() {
	      $state.go(vm.parentState, vm.parentStateParams);
	    }
	
	    function gotoState(state, stateParams) {
	      $state.go(state, stateParams);
	    }
	
	    function getShowHideTitle() {
	      if ($gzGo.showAppNav()) {
	        return hideFullAppTitle;
	      } else {
	        return showFullAppTitle;
	      }
	    }
	
	    function appNavShown() {
	      return $gzGo.showAppNav;
	    }
	
	    function cancel() {
	      if (vm.taskCancel) {
	        vm.taskCancel().then(function () {
	          $gzGo.cancelTask();
	        });
	      } else {
	        $gzGo.cancelTask();
	      }
	    }
	
	    function submit() {
	      if (vm.taskSubmit) {
	        vm.taskSubmit().then(function (payload) {
	          $gzGo.completeTask(payload);
	        });
	      } else {
	        $gzGo.completeTask({});
	      }
	    }
	
	    function toggleAppNav() {
	      $gzGo.toggleAppNav();
	    }
	
	    function goToTask() {
	      $gzGo.goToTaskHome();
	    }
	
	    function exitTask() {
	      if (vm.taskExit) {
	        vm.taskExit().then(function () {
	          $gzGo.exitTask();
	          vm.isTask = false;
	          vm.isSubmitPage = false;
	        });
	      } else {
	        $gzGo.exitTask();
	        vm.isTask = false;
	        vm.isSubmitPage = false;
	      }
	    }
	
	    function defaultDisableSubmit() {
	      return false;
	    }
	  }
	}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	'use strict';
	
	PageNotFoundController.$inject = ["$window", "$stateParams"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = PageNotFoundController;
	var name = 'PageNotFoundController';
	exports.name = name;
	
	function PageNotFoundController($window, $stateParams) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var vm = this;
	
	  activate();
	
	  ///////////
	
	  function activate() {
	    if ($stateParams.reason) {
	      vm.reason = $stateParams.reason;
	    }
	    if ($stateParams.detail) {
	      vm.detail = $stateParams.detail;
	    }
	  }
	}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(535);
	
	var _pageNotFoundController = __webpack_require__(357);
	
	var pageNotFoundController = _interopRequireWildcard(_pageNotFoundController);
	
	var pageNotFoundState = {
	  name: 'not-found',
	  url: '/not-found?reason&detail',
	  template: __webpack_require__(244),
	  controller: 'PageNotFoundController',
	  controllerAs: 'vm'
	};
	
	exports['default'] = angular.module('gazelle.components.pageNotFound', ['ui.router']).controller(pageNotFoundController.name, pageNotFoundController['default']).constant('gzPageNotFoundState', pageNotFoundState).name;
	module.exports = exports['default'];

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _perfService = __webpack_require__(360);
	
	var $gzPerf = _interopRequireWildcard(_perfService);
	
	exports['default'] = angular.module('gazelle.components.perf', ['ui.router']).factory($gzPerf.name, $gzPerf['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	$gzPerf.$inject = ["$rootScope", "$window", "$timeout", "$state"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzPerf;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _gazelleSrcCoreAnalyticsGaCustomDefs = __webpack_require__(25);
	
	var END_LABEL = 'end';
	
	exports.END_LABEL = END_LABEL;
	var name = '$gzPerf';
	exports.name = name;
	
	function $gzPerf($rootScope, $window, $timeout, $state) {
	  'ngInject';
	
	  // Initialize to current state since we'll likely
	  // miss $stateChangeStart on initial load.
	  var loadingState = $state.current;
	  var navigationStartOffset = 0;
	
	  var service = {
	    viewLoadingStart: viewLoadingStart,
	    viewLoadingProgress: viewLoadingProgress,
	    viewLoadingEnd: viewLoadingEnd
	  };
	
	  activate();
	
	  return service;
	
	  ////////////////////
	
	  function activate() {
	    registerStateListener();
	  }
	
	  function registerStateListener() {
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
	      if (!hasUserTimingsApi()) {
	        // Not supported on this browser
	        return;
	      }
	
	      loadingState = toState;
	      if (_.isEmpty(fromState)) {
	        navigationStartOffset = 0;
	      } else {
	        navigationStartOffset = $window.performance.now();
	      }
	    });
	  }
	
	  function viewLoadingStart() {
	    if (!hasUserTimingsApi()) {
	      // Not supported on this browser
	      return;
	    }
	
	    $window.performance.mark(loadingState.name + '-start');
	  }
	
	  function viewLoadingProgress(sublabel) {
	    sendViewLoadingEvent(sublabel);
	  }
	
	  function viewLoadingEnd() {
	    // Execute inside of a timeout to get closer to the actual rendering time since
	    // this will be queued after DOM updates.
	    // See https://stackoverflow.com/a/22541080/277307
	    $timeout(function () {
	      sendViewLoadingEvent(END_LABEL);
	    }, 0, false);
	  }
	
	  function sendViewLoadingEvent(sublabel) {
	    var _hit;
	
	    if (!hasUserTimingsApi()) {
	      // Not supported on this browser
	      return;
	    }
	
	    var label = loadingState.name;
	    var startLabel = label + '-start';
	    var endLabel = label + '-' + sublabel;
	    var measureLabel = endLabel + '-measure';
	    $window.performance.mark(endLabel);
	
	    var startMark = getPerformanceEntry(startLabel, 'mark');
	    if (!startMark) {
	      return;
	    }
	
	    var endMark = getPerformanceEntry(endLabel, 'mark');
	    if (!endMark) {
	      return;
	    }
	
	    $window.performance.measure(measureLabel, startLabel, endLabel);
	    var measure = getPerformanceEntry(measureLabel, 'measure');
	    if (!measure) {
	      return;
	    }
	
	    var cachedResources = countCachedResources();
	
	    var eventLabel = label;
	    if (sublabel !== END_LABEL) {
	      // only report the sublabel for loading progress events
	      eventLabel = label + ' - ' + sublabel;
	    }
	
	    var hit = (_hit = {
	      hitType: 'event',
	      nonInteraction: true,
	      eventCategory: 'performance',
	      eventAction: 'view loading',
	      eventLabel: eventLabel,
	      eventValue: $window.Math.round(measure.duration)
	    }, _defineProperty(_hit, _gazelleSrcCoreAnalyticsGaCustomDefs.metrics.startDuration, $window.Math.round(startMark.startTime - navigationStartOffset)), _defineProperty(_hit, _gazelleSrcCoreAnalyticsGaCustomDefs.metrics.endDuration, $window.Math.round(endMark.startTime - navigationStartOffset)), _defineProperty(_hit, _gazelleSrcCoreAnalyticsGaCustomDefs.metrics.cachedResources, cachedResources), _hit);
	    $window.ga('send', hit);
	
	    if (sublabel === END_LABEL) {
	      $window.performance.clearMarks(startLabel);
	    }
	    $window.performance.clearMarks(endLabel);
	    $window.performance.clearMeasures(measureLabel);
	  }
	
	  function countCachedResources() {
	    var resourceTimings = $window.performance.getEntriesByType('resource');
	    return resourceTimings.reduce(function (accumulator, resourceTiming) {
	      // Must check for requestStart because CORS Timing-Allow-Origin header is not on external resources.
	      if (resourceTiming.requestStart && !resourceTiming.transferSize) {
	        accumulator++;
	      }
	      return accumulator;
	    }, 0);
	  }
	
	  function hasUserTimingsApi() {
	    return _.get($window, 'performance.mark');
	  }
	
	  function getPerformanceEntry(name, type) {
	    var entries = $window.performance.getEntriesByName(name, type);
	    if (entries.length !== 1) {
	      $window.ga('send', {
	        hitType: 'exception',
	        exDescription: '$gzPerf: unexpected number of performance entries for ' + name + '. Expected 1, found ' + entries.length,
	        exFatal: false
	      });
	      return undefined;
	    }
	    return entries[0];
	  }
	}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	gzBkImg.$inject = ["rnRegistry"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzBkImg;
	var name = 'gzBkImg';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.printosImages.bkImg.directive:gzBkImg
	 *
	 * @param {string=} gzBkImg path to a background image in common printos-images
	 *
	 * @description
	 * `gz-bk-img` is an attribute directive for specifying a background image in CSS
	 * with an absolute URL to a common PrintOS images location.
	 *
	 * @usage
	 * ```html
	 * <div gz-bk-img='logos/hp.png'></div>
	 * ```
	 * Produces
	 * ```html
	 * <div gz-bk-img='logos/hp.png' style="background-image: url("https://www.printos.com/images/logos/hp.png");"></div>
	 * ```
	 */
	
	function gzBkImg(rnRegistry) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'A',
	    link: gzBkImgLink
	  };
	
	  return directive;
	
	  //////////////////////
	
	  function gzBkImgLink(scope, element, attrs) {
	    attrs.$observe(name, function (imgPath) {
	      rnRegistry.getImageUrl(imgPath).then(function (imgUrl) {
	        element.css({
	          'background-image': 'url("' + imgUrl + '")'
	        });
	      });
	    });
	  }
	}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	'use strict';
	
	gzImgSrc.$inject = ["rnRegistry"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzImgSrc;
	var name = 'gzImgSrc';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.printosImages.imgSrc.directive:gzImgSrc
	 *
	 * @param {string=} gzImgSrc path to an image in common printos-images
	 *
	 * @description
	 * `gz-img-src` is an attribute directive for specifying an image src attribute
	 * with an absolute URL to a common PrintOS images location.
	 *
	 * @usage
	 * ```html
	 * <img gz-img-src='logos/hp.png'></img>
	 * ```
	 * Produces
	 * ```html
	 * <img gz-img-src='logos/hp.png' src="https://www.printos.com/images/logos/hp.png"></img>
	 * ```
	 */
	
	function gzImgSrc(rnRegistry) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'A',
	    link: gzImgSrcLink
	  };
	
	  return directive;
	
	  //////////////////////
	
	  function gzImgSrcLink(scope, element, attrs) {
	    attrs.$observe(name, function (imgPath) {
	      rnRegistry.getImageUrl(imgPath).then(function (imgUrl) {
	        element.attr('src', imgUrl);
	      });
	    });
	  }
	}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _bkImgBkImgModule = __webpack_require__(59);
	
	var _bkImgBkImgModule2 = _interopRequireDefault(_bkImgBkImgModule);
	
	var _imgSrcImgSrcModule = __webpack_require__(60);
	
	var _imgSrcImgSrcModule2 = _interopRequireDefault(_imgSrcImgSrcModule);
	
	exports['default'] = angular.module('gazelle.components.printosImages', [_bkImgBkImgModule2['default'], _imgSrcImgSrcModule2['default']]).name;
	module.exports = exports['default'];

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzResponsiveDialog;
	var name = 'gzResponsiveDialog';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.responsive.directive:gzResponsiveDialog
	 *
	 * @description
	 * `gz-responsive-dialog` is an attribute directive for a preset of flex classes
	 * providing a width pattern.
	 *
	 * @usage
	 * ```html
	 * <md-dialog gz-responsive-dialog></md-dialog>
	 * ```
	 */
	
	function gzResponsiveDialog() {
	  'ngInject';
	
	  var directive = {
	    restrict: 'A',
	    link: gzResponsiveLink
	  };
	  return directive;
	
	  //////////////////////
	
	  function gzResponsiveLink(scope, element) {
	    // Tried to add material flex directives but struggled
	    // (see http://stackoverflow.com/questions/19224028/add-directives-from-directive-in-angularjs).
	    // Using material flex classes instead since the attributes are just class wrappers.
	    element.addClass('flex-xs-100');
	    element.addClass('flex-sm-65');
	    element.addClass('flex-md-50');
	    element.addClass('flex-35');
	  }
	}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _responsiveDirective = __webpack_require__(364);
	
	var gzResponsive = _interopRequireWildcard(_responsiveDirective);
	
	exports['default'] = angular.module('gazelle.components.responsive', ['ngMaterial']).directive(gzResponsive.name, gzResponsive['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _signinService = __webpack_require__(368);
	
	var gzSigninService = _interopRequireWildcard(_signinService);
	
	var _signinRun = __webpack_require__(367);
	
	var _signinRun2 = _interopRequireDefault(_signinRun);
	
	exports['default'] = angular.module('gazelle.components.signin', ['rhino.components.application', 'angulartics']).run(_signinRun2['default']).service(gzSigninService.name, gzSigninService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	'use strict';
	
	listenForRhinoAuthEvents.$inject = ["$log", "rnAUTH_EVENTS", "$gzSignin", "$analytics", "$rootScope"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = listenForRhinoAuthEvents;
	
	function listenForRhinoAuthEvents($log, rnAUTH_EVENTS, $gzSignin, $analytics, $rootScope) {
	  'ngInject';
	
	  $rootScope.$on(rnAUTH_EVENTS.signinSuccess, listenMsg);
	  $rootScope.$on(rnAUTH_EVENTS.signinFailure, listenMsg);
	  $rootScope.$on(rnAUTH_EVENTS.signinCanceled, listenMsg);
	  $rootScope.$on(rnAUTH_EVENTS.signoutSuccess, listenMsg);
	  $rootScope.$on(rnAUTH_EVENTS.sessionTimeout, signin);
	  $rootScope.$on(rnAUTH_EVENTS.authenticated, updateAnalyticsUser);
	  $rootScope.$on(rnAUTH_EVENTS.notAuthenticated, signin);
	  // $rootScope.$on(rnAUTH_EVENTS.notAuthorized, listenMsg);
	
	  function listenMsg(event, args) {
	    $log.debug('gz-signin listener event: ' + event.name + '  -> ', args);
	  }
	
	  function signin(event, opts) {
	    listenMsg(event, opts);
	
	    if (!opts) {
	      opts = {};
	    }
	
	    if (opts.reloadOnSignin === undefined) {
	      opts.reloadOnSignin = true;
	    }
	
	    if (opts.blackoutOnSignin === undefined) {
	      opts.blackoutOnSignin = true;
	    }
	
	    $gzSignin.signin(true);
	  }
	
	  function updateAnalyticsUser(event, args) {
	    listenMsg(event, args);
	    $analytics.setUsername(args.entity.id);
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzSignin.$inject = ["rnApplication", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzSignin;
	var name = '$gzSignin';
	exports.name = name;
	
	function $gzSignin(rnApplication, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var processingSignIn = false;
	  var processingSignOut = false;
	
	  var vm = this;
	  var service = {
	    signin: signin,
	    signout: signout
	  };
	
	  return service;
	
	  ///////////////////
	  // Public methods
	  //////////////////
	
	  function signin() {
	    var autoForward = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    if (!processingSignIn) {
	      processingSignIn = true;
	      rnApplication.getApplication('register').then(function (registerApp) {
	        var signInURL = registerApp._links.self;
	        if (autoForward) {
	          signInURL += '/#/signin?target=' + $window.encodeURIComponent($window.location.href);
	        }
	        $window.location.href = signInURL;
	      })['finally'](function () {
	        processingSignIn = false;
	      });
	    }
	  }
	
	  function signout() {
	    if (!processingSignOut) {
	      rnApplication.getApplication('register').then(function (registerApp) {
	        var signInURL = registerApp._links.self;
	        signInURL += '/#/signin?signout';
	        $window.location.href = signInURL;
	      })['finally'](function () {
	        processingSignIn = false;
	      });
	    }
	  }
	}
	
	//$gzSignin

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	gzSpinner.$inject = ["$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzSpinner;
	var name = 'gzSpinner';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.spinner.directive:gzSpinner
	 *
	 * @param {boolean=} if-loading specifies the model property to watch to determine when to show the spinner.
	 * @param {number=} md-diameter specifies the diameter of the circular progress.  Default: 48
	 *
	 * @description
	 * `<gz-spinner>` is a widget that will display a spinner until promises are resolved and data is ready. If the value passed to if-loading is true then
	 * the spinner is visable. If it is false then the spinner is hidden.  If nothing is passed to if-loading then gz-spinner will attempt to use the 26A convetional
	 * property (isLoading) for a loading situation.  Controllers should define the isLoading property to indicate if it is still waiting in a promise.
	 * Either way, the value is watched and will cause the spinner to appear (true) or the spinner to be hidden (false).
	 *
	 * @usage
	 * ```html
	 * <div>
	 *   <gz-spinner if-loading='vm.isLoading'></gz-spinner>
	 *   <span> Content shows here when it is resolved</span>
	 * </div>
	 * ```
	 */
	
	function gzSpinner($log) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      ifLoading: '=',
	      diameter: '@mdDiameter'
	    },
	    template: __webpack_require__(245),
	    link: gzSpinnerLink
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	
	  function gzSpinnerLink(scope, element, attrs) {
	    // If the developer didn't pass in an if-loading='something' attribute then look for
	    // the "standard" loading flag on the parent.
	    if (scope.ifLoading === undefined && _.get(scope, '$parent.vm.isLoading', undefined) !== undefined) {
	      (function () {
	        var unregister = scope.$parent.$watch('vm.isLoading', function (newVal, oldVal) {
	          scope.ifLoading = newVal;
	          if (!newVal) {
	            unregister();
	          }
	          // $log.debug('scope.isLoading changed to ' + newVal);
	        });
	      })();
	    }
	
	    if (scope.diameter !== undefined) {
	      // MD default
	      scope.diameter = 50;
	    }
	  }
	}
	
	//gzSpinner

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzTimePicker;
	var name = 'gzTimePicker';
	exports.name = name;
	
	function gzTimePicker()
	// Directive angular dependencies
	{
	  'ngInject';
	
	  timePickerController.$inject = ["moment", "$window"];
	  var directive = {
	    restrict: 'EA',
	    require: '^ngModel',
	    scope: {
	      label: '@?'
	    },
	    template: __webpack_require__(246),
	    link: timePickerLink,
	    controller: timePickerController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function timePickerLink(scope, element, attrs, ngModelCtrl) {
	    attrs.$observe('required', function (required) {
	      element.find('label').toggleClass('required', required);
	    });
	
	    // Adapted from https://stackoverflow.com/a/34001183/277307
	    scope.vm.setModelValue = function (value) {
	      ngModelCtrl.$setViewValue(value);
	    };
	
	    ngModelCtrl.$render = function () {
	      if (scope.vm.parseModel) {
	        scope.vm.parseModel(ngModelCtrl.$modelValue);
	      }
	    };
	  }
	
	  /** @ngInject */
	  function timePickerController(moment, $window) {
	    // Constants
	
	    // Variables
	
	    // View Model
	    //   VM properties
	    var vm = this;
	    vm.is12Hour = false;
	    vm.hourInput = '00';
	    vm.minuteInput = '00';
	    vm.meridiem = 'AM';
	    //   VM methods
	    vm.hourChanged = hourChanged;
	    vm.minuteChanged = minuteChanged;
	    vm.timeChanged = timeChanged;
	    vm.formatHour = formatHour;
	    vm.formatMinute = formatMinute;
	    vm.selectInput = selectInput;
	    vm.handleHourKey = handleHourKey;
	    vm.handleMinuteKey = handleMinuteKey;
	    vm.parseModel = parseModel;
	
	    vm.$onInit = onInit;
	
	    return;
	
	    ///////////////
	    // Init
	    function onInit() {
	      vm.is12Hour = moment.localeData().longDateFormat('LT').toUpperCase().includes('A');
	
	      if (vm.is12Hour) {
	        vm.hourInput = '12';
	      }
	    }
	
	    ///////////////
	    // VM methods
	    function hourChanged() {
	      var fixedInput = validateInput(vm.hourInput, 0, vm.is12Hour ? 12 : 23);
	      if (fixedInput !== undefined) {
	        vm.hourInput = fixedInput;
	        return;
	      }
	
	      timeChanged();
	    }
	
	    function minuteChanged() {
	      var fixedInput = validateInput(vm.minuteInput, 0, 59);
	      if (fixedInput !== undefined) {
	        vm.minuteInput = fixedInput;
	        return;
	      }
	
	      timeChanged();
	    }
	
	    function timeChanged() {
	      var hour = $window.Number.parseInt(vm.hourInput);
	      var minute = $window.Number.parseInt(vm.minuteInput);
	
	      if (vm.is12Hour) {
	        if (hour === 12) {
	          if (vm.meridiem === 'AM') {
	            // 12:00 AM is 0:00 in 24-hour time
	            hour = 0;
	          }
	        } else {
	          if (vm.meridiem === 'PM') {
	            // Anything not 12:00 PM is +12 hours
	            hour += 12;
	          }
	        }
	      }
	
	      var formattedHour = hour.toString().padStart(2, '0');
	      var formattedMinute = minute.toString().padStart(2, '0');
	      vm.setModelValue(formattedHour + ':' + formattedMinute);
	    }
	
	    function formatHour() {
	      if (!vm.hourInput) {
	        vm.hourInput = vm.is12Hour ? '12' : '00';
	      }
	      if (!vm.is12Hour) {
	        vm.hourInput = vm.hourInput.padStart(2, '0');
	      }
	    }
	
	    function formatMinute() {
	      if (!vm.minuteInput) {
	        vm.minuteInput = '00';
	      }
	      vm.minuteInput = vm.minuteInput.padStart(2, '0');
	    }
	
	    function selectInput($event) {
	      $event.target.select();
	    }
	
	    function handleHourKey($event) {
	      if (!isSupportedKey($event)) {
	        return;
	      }
	      if (!vm.hourInput) {
	        return;
	      }
	
	      var hour = $window.Number.parseInt(vm.hourInput);
	      if ($event.key === 'ArrowUp') {
	        if (vm.is12Hour) {
	          if (hour < 12) {
	            hour++;
	          } else {
	            // wrap around
	            hour = 1;
	          }
	        } else {
	          if (hour < 23) {
	            hour++;
	          } else {
	            hour = 0;
	          }
	        }
	      } else if ($event.key === 'ArrowDown') {
	        if (vm.is12Hour) {
	          if (hour > 1) {
	            hour--;
	          } else {
	            // wrap around
	            hour = 12;
	          }
	        } else {
	          if (hour > 0) {
	            hour--;
	          } else {
	            hour = 23;
	          }
	        }
	      }
	
	      vm.hourInput = hour.toString();
	      formatHour();
	      timeChanged();
	    }
	
	    function handleMinuteKey($event) {
	      if (!isSupportedKey($event)) {
	        return;
	      }
	      if (!vm.minuteInput) {
	        return;
	      }
	
	      var minute = $window.Number.parseInt(vm.minuteInput);
	
	      if ($event.key === 'ArrowUp') {
	        if (minute < 59) {
	          minute++;
	        } else {
	          // wrap around
	          minute = 0;
	        }
	      } else if ($event.key === 'ArrowDown') {
	        if (minute > 0) {
	          minute--;
	        } else {
	          // wrap around
	          minute = 59;
	        }
	      }
	
	      vm.minuteInput = minute.toString();
	      formatMinute();
	      timeChanged();
	    }
	
	    function isSupportedKey($event) {
	      return $event.key === 'ArrowUp' || $event.key === 'ArrowDown';
	    }
	
	    // Allow for two-way binding with incoming changes to the time
	    function parseModel(model) {
	      if (!model) {
	        return;
	      }
	
	      var parsed = moment(model, 'H:mm');
	      if (!parsed.isValid()) {
	        return;
	      }
	
	      vm.minuteInput = parsed.minute().toString();
	      if (!vm.is12Hour) {
	        vm.hourInput = parsed.minute().toString();
	      } else {
	        var hour = parsed.hour();
	
	        vm.meridiem = hour >= 12 ? 'PM' : 'AM';
	        if (hour > 12) {
	          hour -= 12;
	        } else if (hour === 0) {
	          hour = 12;
	        }
	        vm.hourInput = hour.toString();
	      }
	
	      formatHour();
	      formatMinute();
	    }
	
	    ///////////////
	    // Helpers
	    function validateInput(input, min, max) {
	      if (!input) {
	        return '';
	      }
	
	      if (input.length > 2) {
	        return input.substring(0, 2);
	      }
	
	      var parsedInput = $window.Number.parseInt(input);
	      if ($window.Number.isNaN(parsedInput)) {
	        return '';
	      }
	
	      if (parsedInput < min) {
	        return min.toString();
	      }
	
	      if (parsedInput > max) {
	        return input.substring(0, 1);
	      }
	    }
	  }
	}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(536);
	
	var _timePickerDirective = __webpack_require__(370);
	
	var gzTimePickerDirective = _interopRequireWildcard(_timePickerDirective);
	
	exports['default'] = angular.module('gazelle.components.timePicker', ['angularMoment']).directive(gzTimePickerDirective.name, gzTimePickerDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzTimeRange;
	var name = 'gzTimeRange';
	exports.name = name;
	
	function gzTimeRange()
	// Directive angular dependencies
	{
	  'ngInject';
	
	  timeRangeController.$inject = ["moment"];
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      init: '=',
	      onChange: '='
	    },
	    template: __webpack_require__(247),
	    link: timeRangeLink,
	    controller: timeRangeController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function timeRangeLink(scope, element, attrs) {}
	
	  /** @ngInject */
	  function timeRangeController(
	  // Controller angular dependencies
	  moment) {
	    // Constants
	    var DEFAULT_RETURN_FORMAT = 'YYYY-MM-DD HH:mm:ss';
	
	    // Variables
	
	    // View Model
	    var vm = this;
	    vm.startTime = null;
	    vm.endTime = null;
	
	    //   VM properties
	    //   VM methods
	
	    vm.$onInit = onInit;
	    vm.timeChanged = timeChanged;
	    return;
	
	    ///////////////
	    // Init
	    function onInit() {
	      if (vm.init) {}
	    }
	
	    ///////////////
	    // VM methods
	
	    function notifyParent(range) {
	      if (vm.onChange) {
	        vm.onChange(range);
	      }
	    }
	
	    function timeChanged() {
	
	      if (!vm.startTime || !vm.endTime) {
	        notifyParent(null);
	        return;
	      }
	
	      var start = moment(vm.startTime);
	      var end = moment(vm.endTime);
	
	      var invalid = end.isBefore(start);
	
	      if (invalid) {
	        notifyParent(null);
	        return;
	      } else {
	        var formatString = vm.timeFormat ? vm.timeFormat : DEFAULT_RETURN_FORMAT;
	        var timeRange = {
	          start: start.format(formatString),
	          end: end.format(formatString)
	        };
	
	        notifyParent(timeRange);
	      }
	    }
	  }
	}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(537);
	
	var _timeRangeDirective = __webpack_require__(372);
	
	var gzTimeRangeDirective = _interopRequireWildcard(_timeRangeDirective);
	
	exports['default'] = angular.module('gazelle.components.timeRange', ['angularMoment', 'rhino.components.organization']).directive(gzTimeRangeDirective.name, gzTimeRangeDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _timeService = __webpack_require__(375);
	
	var gzTime = _interopRequireWildcard(_timeService);
	
	exports['default'] = angular.module('gazelle.components.time', ['angularMoment', 'rhino.core', 'rhino.components.preferences']).service(gzTime.name, gzTime['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	$gzTime.$inject = ["$log", "rnHttp", "rnPreferences", "moment", "$q"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzTime;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tzExclusions = __webpack_require__(376);
	
	var _tzExclusions2 = _interopRequireDefault(_tzExclusions);
	
	/**
	 * @ngdoc service
	 * @name gazelle.components.time.service:$gzTime
	 *
	 * @description
	 * The $gzTime service provides a service to deal with moment/time related functionality.
	 */
	var name = '$gzTime';
	exports.name = name;
	
	function $gzTime($log, rnHttp, rnPreferences, moment, $q) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var PORTAL_SERVICE_NAME = 'portal_service';
	  var service = {
	    getTimeZones: getTimeZones,
	    getTimeZonesSync: getTimeZonesSync,
	    getTimeZoneDisplay: getTimeZoneDisplay,
	    getPreferredTimeZone: getPreferredTimeZone,
	    getByOffset: getByOffset,
	    getById: getById
	  };
	
	  return service;
	
	  /**
	   * Gets time zones wrapped in a promise for legacy reasons (this call used to request a list of zones from a service)
	   */
	  function getTimeZones() {
	    return $q.resolve(getTimeZonesSync());
	  }
	
	  /**
	   * Gets time zones synchronously sorted by UTC offset and then name
	   */
	  function getTimeZonesSync() {
	    var zones = moment.tz.names().filter(function (timeZoneId) {
	      return !_tzExclusions2['default'].includes(timeZoneId);
	    }).map(function (timeZoneId) {
	      return getById(timeZoneId);
	    });
	    return sort(zones);
	  }
	
	  function getTimeZoneDisplay(timezone) {
	    return moment.tz(timezone.value).format('(UTCZ)') + ' ' + timezone.value.replace(/_/g, ' ');
	  }
	
	  function sort(timezones) {
	    var sortingFns = [];
	    sortingFns.push(function (timezone) {
	      return moment.tz(timezone.value).utcOffset();
	    });
	
	    sortingFns.push(function (timezone) {
	      return timezone.value.toLowerCase();
	    });
	
	    return _.sortByAll(timezones, sortingFns);
	  }
	
	  function getPreferredTimeZone() {
	    return rnPreferences.getAll().then(function (prefs) {
	      var timeZone = _.get(prefs, 'general.timeZone', moment.tz.guess());
	      return timeZone;
	    });
	  }
	
	  function getByOffset(offset) {
	    return getTimeZones().then(function (zones) {
	      return _.filter(zones, function (zone) {
	        return moment.tz(zone.value).utcOffset() === offset;
	      });
	    });
	  }
	
	  function getById(timeZoneId) {
	    var tz = {
	      value: timeZoneId.trim()
	    };
	
	    tz.display = getTimeZoneDisplay(tz);
	    return tz;
	  }
	}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = ["America/Knox_IN", "Australia/ACT", "Australia/LHI", "Australia/North", "Australia/NSW", "Australia/Queensla", "Australia/South", "Australia/Tasmania", "Australia/Victoria", "Australia/West", "Brazil/Acre", "Brazil/DeNoronha", "Brazil/East", "Brazil/West", "Canada/Atlantic", "Canada/Central", "Canada/Eastern", "Canada/Mountain", "Canada/Newfoundlan", "Canada/Pacific", "Canada/Saskatchewa", "Canada/Yukon", "CET", "Chile/Continental", "Chile/EasterIsland", "CST6CDT", "Cuba", "EET", "Egypt", "Eire", "EST", "EST5EDT", "Etc/GMT", "Etc/GMT+0", "Etc/GMT-0", "Etc/GMT0", "Etc/GMT+1", "Etc/GMT+10", "Etc/GMT+11", "Etc/GMT+12", "Etc/GMT+2", "Etc/GMT+3", "Etc/GMT+4", "Etc/GMT+5", "Etc/GMT+6", "Etc/GMT+7", "Etc/GMT+8", "Etc/GMT+9", "Etc/GMT-1", "Etc/GMT-10", "Etc/GMT-11", "Etc/GMT-12", "Etc/GMT-13", "Etc/GMT-14", "Etc/GMT-2", "Etc/GMT-3", "Etc/GMT-4", "Etc/GMT-5", "Etc/GMT-6", "Etc/GMT-7", "Etc/GMT-8", "Etc/GMT-9", "Etc/UTC", "Etc/Greenwich", "Etc/UCT", "Etc/Universal", "Etc/Zulu", "GB", "GB-Eire", "GMT", "GMT+0", "GMT0", "GMT-0", "Greenwich", "Hongkong", "HST", "Iceland", "Iran", "Israel", "Jamaica", "Japan", "Kwajalein", "Libya", "MET", "Mexico/BajaNorte", "Mexico/BajaSur", "Mexico/General", "MST", "MST7MDT", "Navajo", "NZ", "NZ-CHAT", "Poland", "Portugal", "PRC", "PST8PDT", "ROC", "ROK", "Singapore", "Turkey", "UCT", "Universal", "US/Alaska", "US/Aleutian", "US/Arizona", "US/Central", "US/Eastern", "US/East-Indiana", "US/Hawaii", "US/Indiana-Starke", "US/Michigan", "US/Mountain", "US/Pacific", "US/Pacific-New", "US/Samoa", "WET", "W-SU", "Zulu"];
	module.exports = exports["default"];

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	$gzEULA.$inject = ["$log", "$mdDialog", "rnHttp"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzEULA;
	
	var _eulaController = __webpack_require__(61);
	
	var name = '$gzEULA';
	exports.name = name;
	
	function $gzEULA($log, $mdDialog, rnHttp) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var service = {
	    show: show,
	    getCurrentVersion: getCurrentVersion,
	    getPrivacyVersion: getPrivacyVersion
	  };
	  return service;
	
	  /////////////////
	
	  function show() {
	    var requireAccept = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	    var $event = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	    var inSignin = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	    var isChanged = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	    // $log.debug('$gzEULA#show: Open EULA');
	    return openEulaDialog(requireAccept, $event, isChanged).then(function (result) {
	      if (inSignin) {
	        // go back to the signin state machine
	        return result;
	      }
	    });
	  }
	
	  function openEulaDialog(requireAccept, $event, isChanged) {
	    return $mdDialog.show({
	      targetEvent: $event,
	      template: __webpack_require__(248),
	      controller: 'EulaController',
	      bindToController: true,
	      controllerAs: 'terms',
	      locals: {
	        requireAccept: requireAccept,
	        isChanged: isChanged
	      }
	    })['catch'](function (error) {
	      // User cancelled dialog
	    });
	  }
	
	  function getCurrentVersion() {
	    return rnHttp.head('portal_service', '/i18n/eula/en', { cache: true }).then(function (resp) {
	      return resp.headers(_eulaController.EULA_VERSION_HEADER);
	    });
	  }
	
	  function getPrivacyVersion() {
	    return rnHttp.head('portal_service', '/i18n/eula/en', { cache: true }).then(function (resp) {
	      return resp.headers(_eulaController.PRIVACY_VERSION_HEADER);
	    });
	  }
	}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	'use strict';
	
	match.$inject = ["$parse", "$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = match;
	var name = 'match';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.validation.directive:match
	 *
	 * @param {string=} the expression to match against
	 *
	 * @description
	 * `match` is an attribute directive used to check string equality between an input field and a specified view model value.
	 * For the purposes of setting ngMessage values the following ngModel.NgModelController validity states will be triggered:
	 *
	 *  `match` if the control model value is not equal to the match expression
	 *
	 * @usage
	 * ```html
	 * <input name="confirmPassword" type="password" match="vm.password"></input>
	 * ```
	 */
	
	function match($parse, $log) {
	
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  return {
	    require: 'ngModel',
	    restrict: 'A',
	    link: function link(scope, elem, attrs, ctrl) {
	
	      //This part does the matching
	      scope.$watch(function () {
	        return ctrl.$modelValue;
	      }, watchListener);
	
	      scope.$watch(attrs.match, watchListener);
	
	      function watchListener() {
	        if ($parse(attrs.match)(scope) === ctrl.$modelValue) {
	          setMatch(true);
	        } else {
	          setMatch(false);
	        }
	      }
	
	      function setMatch(match) {
	        ctrl.$setValidity('match', match);
	      }
	    }
	  };
	}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Adds default validation messages to the template cache to be used with gz-messages-include.
	 * Unfortunately, ng-messages-include doesn't appear to work with angular-material's md-auto-hide,
	 * which hides validation messages until after the user is allowed a chance to fill out the form (will need to file a defect).
	 * Therefore, it is currently recommended to inline the messages and not use ng-messages-include.
	 */
	'use strict';
	
	addMessagesToInclude.$inject = ["$templateCache"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addMessagesToInclude;
	var NG_MESSAGES_INCLUDE_NAME = 'gz-validation';
	exports.NG_MESSAGES_INCLUDE_NAME = NG_MESSAGES_INCLUDE_NAME;
	
	function addMessagesToInclude($templateCache) {
	  'ngInject';
	
	  var messagesMarkup = __webpack_require__(249);
	  $templateCache.put(NG_MESSAGES_INCLUDE_NAME, messagesMarkup);
	}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc directive
	 * @name gazelle.components.validation.directive:gzRegexValidator
	 *
	 * @param {string=} regex property name to retrieve regex to validate against
	 *
	 * @description
	 * `<gz-regex-validator>` is an async form validator, providing for validating a model
	 * against a regex property.
	 *
	 * @example
	 * Jade
	 * ```jade
	   md-input-container
	     label(for="name" translate='account.account.Device_Device_Name')
	     input#in-name(
	     name="name"
	     type="text"
	     ng-model="vm.device.name"
	     required
	     md-maxlength="100"
	     gz-regex-validator="Validator.AAA.NameUnicode"
	   )
	   div(ng-messages="vm.form.name.$error")
	     div(ng-message='required'): translate uxf.uxf.Required
	     div(ng-message='gzRegexValidator'): translate uxf.uxf.Validation_Invalid
	 * ```
	 */
	'use strict';
	
	gzRegexValidator.$inject = ["$q", "$gzRegexValidator"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzRegexValidator;
	var name = 'gzRegexValidator';
	exports.name = name;
	
	function gzRegexValidator($q, $gzRegexValidator) {
	  'ngInject';
	
	  var directive = {
	    require: 'ngModel',
	    restrict: 'A',
	    link: gzRegexValidatorLink
	  };
	  return directive;
	
	  function gzRegexValidatorLink(scope, element, attrs, ctrl) {
	    ctrl.$asyncValidators.gzRegexValidator = function (modelValue, viewValue) {
	      if (ctrl.$isEmpty(modelValue)) {
	        // consider empty model valid
	        return $q.resolve();
	      }
	
	      return $gzRegexValidator.validate(attrs.gzRegexValidator, modelValue);
	    };
	  }
	}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	/**
	 * @ngdoc service
	 * @name gazelle.components.validation.service:$gzRegexValidator
	 *
	 * @description
	 * `$gzRegexValidator` allows for validating values against model regex validators.
	 */
	'use strict';
	
	$gzRegexValidator.$inject = ["rnHttp", "$q", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzRegexValidator;
	var name = '$gzRegexValidator';
	exports.name = name;
	
	function $gzRegexValidator(rnHttp, $q, $window) {
	  'ngInject';
	
	  var service = {
	    validate: validate
	  };
	  return service;
	
	  ////////////////////
	
	  /**
	   * @ngdoc function
	   * @name validate
	   * @name gazelle.components.validation.service:$gzRegexValidator
	   * @description validates a value against a regex validator
	   * @param {string} regexValidatorProperty name of the regex validator property to retrieve the regex to validate with
	   * @param {string} value to validate
	   */
	  function validate(regexValidatorProperty, value) {
	    return getValidator(regexValidatorProperty).then(function (validator) {
	      var regex = new $window.XRegExp(validator.validation, validator.validationFlags);
	      if (!regex.test(value)) {
	        return $q.reject('Validator "' + validator.validationId + '" rejected value "' + value + '"');
	      }
	      return true;
	    });
	  }
	
	  function getValidator(validatorProperty) {
	    return rnHttp.get('portal_service', 'validation', { cache: true }).then(function (response) {
	      var allValidators = response.data;
	      var validator = _.find(allValidators, 'validationId', validatorProperty);
	      if (validator === undefined) {
	        return $q.reject('Unable to find validator ' + validator);
	      }
	      return validator;
	    });
	  }
	}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	'use strict';
	
	gzUniqueValidator.$inject = ["$q"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzUniqueValidator;
	var name = 'gzUniqueValidator';
	exports.name = name;
	
	function gzUniqueValidator($q) {
	  'ngInject';
	
	  var directive = {
	    require: 'ngModel',
	    restrict: 'A',
	    scope: {
	      gzUniqueValidator: '=',
	      gzUniqueValidatorProperty: '@',
	      gzUniqueValidatorMatchCase: '@?'
	    },
	    link: gzUniqueValidatorLink
	  };
	
	  return directive;
	
	  /////////////////
	
	  function gzUniqueValidatorLink(scope, element, attrs, ctrl) {
	    ctrl.$asyncValidators.gzUniqueValidator = function (modelValue, viewValue) {
	
	      // If nothing has been entered it's unique
	      if (ctrl.$isEmpty(modelValue)) {
	        return $q.resolve();
	      }
	
	      var collection = scope.gzUniqueValidator;
	      var property = scope.gzUniqueValidatorProperty;
	      var matchCase = true;
	
	      // If there is no collection or property
	      if (!collection || !property) {
	        return $q.resolve();
	      }
	
	      if (scope.gzUniqueValidatorMatchCase) {
	        matchCase = scope.gzUniqueValidatorMatchCase.toLocaleLowerCase() === 'false' ? false : true;
	      }
	
	      if (_.find(collection, function (item) {
	        if (matchCase) {
	          return item[property] === modelValue;
	        } else {
	          return item[property].toLocaleLowerCase() === modelValue.toLowerCase();
	        }
	      })) {
	        return $q.reject();
	      } else {
	        return $q.resolve();
	      }
	    };
	  }
	}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	
	validateInput.$inject = ["Validation", "$compile", "$log", "$timeout", "$parse"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = validateInput;
	var name = 'validateInput';
	
	exports.name = name;
	
	function validateInput(Validation, $compile, $log, $timeout, $parse) {
	
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  return {
	    require: 'ngModel',
	    restrict: 'A',
	    scope: true,
	    priority: 102,
	    link: function link(scope, element, attrs, ctrl) {
	      scope.$watch(function () {
	        return ctrl.$modelValue;
	      }, function () {
	
	        var required = isRequired();
	
	        if (!ctrl.$pristine || angular.isDefined(ctrl.$modelValue)) {
	
	          var doValidation = true;
	          var deleteNext = false;
	          var value = ctrl.$modelValue;
	          var propertyName = scope.$eval(attrs.propertyName);
	          if (propertyName === undefined) {
	            // fallback to the property value as a string
	            propertyName = attrs.propertyName;
	          }
	          var validationLength = {};
	          var customValidation = attrs.customValidation;
	
	          if (attrs.ngMaxLength !== undefined) {
	            validationLength = attrs.ngMaxLength;
	          } else if (attrs.maxLength !== undefined) {
	            validationLength = attrs.maxLength;
	          }
	
	          if (attrs.validateIfDirty !== undefined && ctrl.$pristine) {
	            doValidation = false;
	          }
	
	          if (attrs.doValidation !== undefined) {
	            doValidation = attrs.doValidation;
	          }
	
	          var disabled = attrs.disabled;
	          if (disabled !== undefined && disabled !== null && disabled === true) {
	            doValidation = false;
	          }
	
	          if (doValidation) {
	            var promise = Validation.validate(required, propertyName, value, validationLength, customValidation);
	            promise.then(function (validationResult) {
	              setValidity('required1', validationResult.required);
	              setValidity('valid', validationResult.valid);
	              setValidity('length', validationResult.length);
	              setValidity('max', validationResult.max);
	              setValidity('validInput', true);
	            }, function () {
	              resetValidity();
	            });
	          } else {
	            resetValidity();
	          }
	        } else {
	          resetValidity();
	          if (required) {
	            ctrl.$setValidity('validInput', false);
	          } else {
	            ctrl.$setValidity('validInput', true);
	          }
	        }
	      });
	
	      scope.$watch(attrs.ngRequired, function () {
	        var required = false;
	        if (attrs.ngRequired) {
	          required = $parse(attrs.ngRequired)(scope);
	          if (required && ctrl.$pristine && !angular.isDefined(ctrl.$modelValue)) {
	            ctrl.$setValidity('validInput', false);
	          } else if (ctrl.$pristine && !angular.isDefined(ctrl.$modelValue)) {
	            ctrl.$setValidity('validInput', true);
	          }
	        }
	      }, true);
	
	      appendValidationMessages();
	
	      /**
	       * Returns the form element associated with a specific element by traversing up the DOM from the element's position
	       * and returns the first form element it comes across.
	       * @param element The element from which to begin the traversal
	       * @returns {*}
	       */
	      function getForm(element) {
	        try {
	          var parent = element.parent();
	          while (parent[0].tagName.toLowerCase() !== 'form') {
	            parent = parent.parent();
	          }
	          return parent;
	        } catch (exception) {
	          return null;
	        }
	      }
	
	      function setValidity(name, value) {
	        if (value === false) {
	          ctrl.$setValidity(name, false);
	        } else {
	          ctrl.$setValidity(name, true);
	        }
	      }
	
	      function resetValidity() {
	        ctrl.$setValidity('length', true);
	        ctrl.$setValidity('max', true);
	        ctrl.$setValidity('valid', true);
	        ctrl.$setValidity('required1', true);
	        ctrl.$setValidity('validInput', true);
	      }
	
	      /**
	       * Determines whether the form element has required input. Looks for the angular ngRequired input attribute first.
	       * If that is not found it looks for the HTML5 required atttribute. If that's not found either, it returns false.
	       */
	      function isRequired() {
	        var required = false;
	
	        try {
	          // Angular version
	          if (attrs.ngRequired !== undefined) {
	            if (typeof attrs.ngRequired === 'boolean') {
	              required = attrs.ngRequired;
	            } else if (typeof attrs.ngRequired === 'string') {
	              var requiredStr = attrs.ngRequired;
	              if (requiredStr.toLowerCase() === 'true' || requiredStr.toLowerCase() === 'false') {
	                required = Boolean(requiredStr.toLowerCase());
	              } else {
	                required = $parse(requiredStr)(scope);
	              }
	            }
	          }
	          // HTML5 version
	          else if (attrs.required !== undefined) {
	              required = attrs.required;
	            }
	        } catch (Exception) {
	          $log.error('Unable to parse required attribute');
	        }
	
	        return required;
	      }
	
	      /**
	       * Creates and appends the ng-messages div to the current form, if found. Else, does nothing.
	       */
	      function appendValidationMessages() {
	        var formElement = getForm(element);
	        var messagesFor = formElement.attr("name") + '.' + attrs.name + '.$error';
	
	        var parent = element.parent();
	        var ngMessagesElement = parent[0].querySelector('[ng-messages],ng-messages');
	        if (ngMessagesElement) {
	          ngMessagesElement = angular.element(ngMessagesElement);
	        } else {
	          ngMessagesElement = angular.element("<div ng-messages='" + messagesFor + "'>");
	          parent.append(ngMessagesElement);
	        }
	        var messagesToAppend = angular.element("<div ng-message='required1'><translate>uxf.uxf.Validation_Required</translate></div>" + "<div ng-message='valid'><translate>uxf.uxf.Validation_Invalid</translate></div>" + "<div ng-message='length'><translate>uxf.uxf.Validation_Length</translate></div>" + "<div ng-message='max'><translate>uxf.uxf.Validation_Max</translate></div>");
	
	        ngMessagesElement.append(messagesToAppend);
	        $compile(ngMessagesElement)(scope);
	      }
	    }
	  };
	}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _matchDirective = __webpack_require__(378);
	
	var matchDirective = _interopRequireWildcard(_matchDirective);
	
	var _validateInputDirective = __webpack_require__(383);
	
	var validateInputDirective = _interopRequireWildcard(_validateInputDirective);
	
	var _validationService = __webpack_require__(385);
	
	var validationService = _interopRequireWildcard(_validationService);
	
	var _regexValidatorService = __webpack_require__(381);
	
	var $gzRegexValidator = _interopRequireWildcard(_regexValidatorService);
	
	var _regexValidatorDirective = __webpack_require__(380);
	
	var gzRegexValidator = _interopRequireWildcard(_regexValidatorDirective);
	
	var _uniqueValidatorDirective = __webpack_require__(382);
	
	var gzUniqueValidator = _interopRequireWildcard(_uniqueValidatorDirective);
	
	var _messagesRun = __webpack_require__(379);
	
	var _messagesRun2 = _interopRequireDefault(_messagesRun);
	
	exports['default'] = angular.module('gazelle.components.validation', ['rhino.core', 'ngMessages']).directive(matchDirective.name, matchDirective['default']).directive(validateInputDirective.name, validateInputDirective['default']).directive(gzRegexValidator.name, gzRegexValidator['default']).directive(gzUniqueValidator.name, gzUniqueValidator['default']).service(validationService.name, validationService['default']).factory($gzRegexValidator.name, $gzRegexValidator['default']).run(_messagesRun2['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict';
	
	Validation.$inject = ["$q", "$filter", "rnHttp", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Validation;
	var name = 'Validation';
	
	exports.name = name;
	
	function Validation($q, $filter, rnHttp, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  this.validate = function (required, property, value, validationLength, customValidation) {
	    var deferred = $q.defer();
	    var ref = this;
	
	    if (this.isEmpty()) {
	      var promise = this.getValidations();
	      promise.then(function (data) {
	        angular.forEach(data, function (validation, key) {
	          ref.setProperty(validation.validationId, validation);
	        });
	        var result = ref.validateValue(required, property, value, validationLength, customValidation);
	        deferred.resolve(result);
	      }, function (reason) {});
	    } else {
	      var result = this.validateValue(required, property, value, validationLength, customValidation);
	      deferred.resolve(result);
	    }
	    return deferred.promise;
	  };
	
	  this.validateValue = function (required, property, value, validationLength, customValidation) {
	    var validationResult = {};
	    validationResult.required = this.validateRequired(required, value);
	
	    if (property !== undefined || validationLength !== undefined) {
	      validationResult.length = this.validateLength(property, value, validationLength);
	    }
	
	    if (property !== undefined || customValidation !== undefined) {
	      validationResult.valid = this.validateRegex(property, value, customValidation);
	    }
	
	    if (property !== undefined && customValidation === 'integer') {
	      validationResult.max = this.validateMax(property, value);
	    }
	
	    return validationResult;
	  };
	
	  this.validateRegex = function (property, value, customValidation) {
	    var valid = true;
	
	    if (customValidation && customValidation === 'date') {
	      return this.validateDate(value);
	    } else if (customValidation && customValidation === 'currentDate') {
	      return this.validateCurrentDate(value);
	    } else {
	
	      if (value && value.length > 0) {
	        var regex = '';
	        if (customValidation) {
	          regex = new $window.XRegExp(this.customValidations[customValidation]);
	        } else {
	          var validator = this.getProperty(property);
	          regex = new $window.XRegExp(validator.validation, validator.validationFlags);
	        }
	        valid = value && regex.test(value);
	      }
	      return valid;
	    }
	  };
	
	  this.validateDate = function (value) {
	    var valid = true;
	    if (value !== null) {
	      value = $filter('date')(value, 'MM/dd/yyyy');
	      var regex = new $window.XRegExp(this.customValidations.date);
	      valid = value && regex.test(value);
	    }
	
	    return valid;
	  };
	
	  this.validateCurrentDate = function (value) {
	    var valid = true;
	    if (this.validateDate(value)) {
	      if (value) {
	        value = $filter('date')(value, 'MM/dd/yyyy');
	        var q = new Date();
	        var month = q.getMonth();
	        var day = q.getDate();
	        var year = q.getFullYear();
	        var today = new Date(year, month, day);
	        var valueDate = new Date(value);
	        if (valueDate < today) {
	          valid = false;
	        }
	      }
	    } else {
	      valid = false;
	    }
	
	    return valid;
	  };
	
	  this.validateRequired = function (required, value) {
	    var valid = true;
	    if ((value === undefined || value === null || value.length < 1) && required) {
	      valid = false;
	    }
	    return valid;
	  };
	
	  this.validateLength = function (property, value, validationLength) {
	    var valid = true;
	    var length = 0;
	    if (validationLength !== undefined) {
	      length = validationLength;
	    } else {
	      length = this.lengths[property];
	    }
	    if (length === undefined) {
	      length = 100;
	    }
	    if (value && value.length > length) {
	      valid = false;
	    }
	    return valid;
	  };
	
	  /****
	   * To be consistent with the Rhino design and architecture this rnHttp call should live in a Rhino service. However, these validations
	   * are temporary and will soon be removed and replaced with different code. This is why we are not looking to move this
	   * into Rhino. - DJL
	   */
	  this.getValidations = function () {
	    var deferred = $q.defer();
	    rnHttp.get('portal_service', 'validation', { cache: true }).success(function (data) {
	      deferred.resolve(data);
	      //$log.debug('Successful Context request: ' + JSON.stringify(data));
	    }).error(function (reason) {
	      deferred.reject(reason);
	      //$log.debug('Failed Context request');
	    });
	    return deferred.promise;
	  };
	
	  this.getProperty = function (key) {
	
	    return this.props[key];
	  };
	
	  this.setProperty = function (key, value) {
	    this.props[key] = value;
	  };
	
	  this.isEmpty = function () {
	    return Object.getOwnPropertyNames(this.props).length === 0;
	  };
	
	  this.validateMax = function (property, value) {
	    var valid = true;
	    var maxValue = 0;
	    maxValue = this.maxValues[property];
	    if (maxValue !== undefined) {
	      if (value && parseInt(value) > maxValue) {
	        valid = false;
	      }
	    }
	    return valid;
	  };
	
	  this.props = {};
	  this.lengths = {
	    "Validator.AAA.SubDomain": "100",
	    "Validator.SmsPortal.Name": "100",
	    "Validator.Email": "100",
	    "Validator.SmsInteg.SafeString": "256",
	    "Validator.AAA.AddressLine": "100",
	    "Validator.AAA.Alphabetic": "1024",
	    "Validator.AAA.Numeric": "100",
	    "Validator.AAA.PostalCode": "100",
	    "Validator.AAA.Notempty": "200",
	    "Validator.AAA.SerialNumber": "100"
	  };
	
	  this.maxValues = {
	    "OrderCopies": "100000"
	  };
	
	  this.customValidations = {
	    "integer": "^\\d+$",
	    "date": "(0[1-9]|1[012])[- \\/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\\d\\d"
	
	  };
	}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	initGlobalsForWalkme.$inject = ["$window", "rnAUTH_EVENTS", "$rootScope"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _walkmeRun = __webpack_require__(387);
	
	var _walkmeRun2 = _interopRequireDefault(_walkmeRun);
	
	var _walkmeService = __webpack_require__(388);
	
	var gzWalkMe = _interopRequireWildcard(_walkmeService);
	
	var _module = angular.module('gazelle.components.walkme', ['rhino.components.tutorial', 'rhino.components.user', 'rhino.core']).service(gzWalkMe.name, gzWalkMe['default']).run(initGlobalsForWalkme);
	
	function initGlobalsForWalkme($window, rnAUTH_EVENTS, $rootScope) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  $rootScope.$on(rnAUTH_EVENTS.authenticated, function (event, data) {
	    _.set($window, 'printos.walkme.userId', data.entity.id);
	    _.set($window, 'printos.walkme.userCreatedTime', data.entity.createdTime);
	  });
	}
	
	// Don't include this while testing because of problems with extra $http calls
	/* global __TEST__ */
	if (true) {
	  _module.run(_walkmeRun2['default']);
	}
	
	exports['default'] = _module.name;
	module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	runWalkme.$inject = ["$window", "rnClient", "rnUser"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = runWalkme;
	
	function runWalkme($window, rnClient, rnUser) {
	  'ngInject';
	
	  return rnClient.getConfig(function (clientConfig) {
	    // Only set walkme user information for user entities
	    if (_.get(clientConfig, 'entity.type') !== 'User') {
	      return;
	    }
	
	    return rnUser.getSelectedUserRoles().then(function (data) {
	      var hpUser = data.userRoles.some(function (userRole) {
	        return _.get(userRole, 'systemRole.organizationType') === 'HP';
	      });
	
	      _.set($window, 'printos.walkme.hpUser', hpUser);
	    });
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	'use strict';
	
	$gzWalkMe.$inject = ["$window", "$log", "$q", "rnTutorial"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzWalkMe;
	var name = '$gzWalkMe';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name gazelle.components.walkme.service:$gzWalkMe
	 *
	 * @description
	 * The $gzWalkMe service provides a way of interacting with the WalkMe snippet and API.
	 */
	
	function $gzWalkMe($window, $log, $q, rnTutorial) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var US_LANG = 'en-US';
	  var WALK_ME_API_NAME = 'WalkMeAPI';
	  var WALK_ME_STARTED_LOADING_MSG = WALK_ME_API_NAME + ': started loading.';
	  var WALK_ME_READY_MSG = WALK_ME_API_NAME + ': ready!';
	  var WALK_ME_STARTING_MSG = function WALK_ME_STARTING_MSG(id) {
	    return 'Starting walkme id: ' + id;
	  };
	
	  activate();
	
	  return {
	    setupHeader: setupHeader,
	    changeLanguage: changeLanguage,
	    startWalkthru: startWalkthru,
	    startWalkMeByTitle: startWalkMeByTitle
	  };
	
	  /**
	   * This function injects the WalkMe snippet on the head of the html, except if the WalkMeAPI loaded already or
	   * is loading.
	   * - If the WalkMeAPI loaded already, it will be resolved in the promise right away.
	   * - If the WalkMeAPI is loading, this function will keep polling until the WalkMeAPI finishes loading or it will fail
	   * in case of taking longer than a predefined timeout.
	   * - If the WalkMeAPI was loaded by other component or if the WalkMeAPI is loading (and this was started outside of
	   * this function), this function will not be able to identify this and it will inject the snippet again.
	   * @returns {Promise}
	   */
	  function setupHeader() {
	    var deferred = $q.defer();
	    // Check if someone already load the WalkMeAPI to the global scope
	    if (isLoaded()) {
	      deferred.resolve($window.WalkMeAPI);
	      return deferred.promise;
	    }
	
	    $log.log(WALK_ME_STARTED_LOADING_MSG);
	
	    var otherWalkmeCallback = undefined;
	    if (typeof $window.walkme_ready === 'function') {
	      otherWalkmeCallback = $window.walkme_ready;
	    }
	
	    $window.walkme_ready = function () {
	      $log.log(WALK_ME_READY_MSG);
	      deferred.resolve($window.WalkMeAPI);
	
	      if (otherWalkmeCallback) {
	        otherWalkmeCallback();
	      }
	    };
	
	    return deferred.promise;
	  }
	
	  function changeLanguage(locale) {
	    if (isLoaded() && !!locale) {
	      var localeValue = !locale.value || locale.value.startsWith('en') ? '' : locale.value;
	      $window.WalkMeAPI.changeLanguage(localeValue);
	    }
	  }
	
	  function startWalkthru(walkMeId) {
	    if (isLoaded()) {
	      safeStartWalkthru($window.WalkMeAPI, walkMeId);
	    } else {
	      setupHeader().then(function (WalkMeAPI) {
	        return safeStartWalkthru(WalkMeAPI, walkMeId);
	      });
	    }
	  }
	
	  function activate() {
	    setupHeader();
	  }
	
	  function isLoaded() {
	    return !!$window.WalkMeAPI;
	  }
	
	  function safeStartWalkthru(WalkMeAPI, walkMeId) {
	    $log.debug(WALK_ME_STARTING_MSG(walkMeId));
	    var walkmeStarted = WalkMeAPI.startWalkthruById(parseInt(walkMeId));
	    return walkmeStarted ? walkmeStarted : WalkMeAPI.startFlowById(walkMeId);
	  }
	
	  function startWalkMeByTitle(title) {
	    return rnTutorial.getByTitle(title, 'walkthruweb').then(function (walkMe) {
	      if (walkMe) {
	        startWalkthru(walkMe.content.trim());
	      } else {
	        $q.reject();
	      }
	    });
	  }
	}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	gzYouTube.$inject = ["$window", "$q", "$parse"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzYouTube;
	var name = 'gzYouTube';
	
	exports.name = name;
	/**
	 * @ngdoc directive
	 * @name gazelle.components.youTube.directive:gzYoutube
	 *
	 * @description
	 * `<gz-you-tube>` creates iframe YouTube player
	 *
	 * @usage
	 * ```html
	 * <gz-you-tube video-id='someId'></gz-you-tube>
	 *
	 * ```
	 */
	
	function gzYouTube($window, $q, $parse) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'E',
	    scope: {
	      videoId: '@',
	      playerId: '@',
	      width: '@',
	      height: '@',
	      playerApi: '=?',
	      autoplay: '@',
	      showinfo: '@',
	      controls: '@'
	    },
	    link: gzYouTubeLink
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	  function gzYouTubeLink(scope, element) {
	    var tag = document.createElement('script');
	    tag.src = 'https://www.youtube.com/iframe_api';
	    var firstScriptTag = document.getElementsByTagName('script')[0];
	    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	
	    $window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
	    var player = undefined;
	
	    if (!$window.gzYTDefer) {
	      $window.gzYTDefer = $q.defer();
	    }
	
	    var videoId = $parse(scope.videoId)(scope.$parent);
	    if (!videoId) {
	      videoId = scope.videoId;
	    }
	    var autoplay = $parse(scope.autoplay)(scope.$parent);
	    if (autoplay === undefined) {
	      autoplay = 0;
	    }
	    var showinfo = $parse(scope.showinfo)(scope.$parent);
	    if (showinfo === undefined) {
	      showinfo = 1;
	    }
	    var controls = $parse(scope.controls)(scope.$parent);
	    if (controls === undefined) {
	      controls = 1;
	    }
	
	    $window.gzYTDefer.promise.then(function () {
	      player = new YT.Player(element[0], { // jshint ignore:line
	        playerVars: {
	          host: 'https://www.youtube.com',
	          autoplay: autoplay,
	          html5: 1,
	          theme: 'light',
	          modesbranding: 0,
	          color: 'white',
	          iv_load_policy: 3,
	          showinfo: showinfo,
	          controls: controls,
	          rel: 0
	        },
	        videoId: videoId,
	        events: {
	          // 'onReady': onPlayerReady,
	          'onStateChange': onPlayerStateChange
	        }
	      });
	
	      scope.playerApi = {
	        play: APIPlay,
	        stop: APIStop,
	        pause: APIPause
	      };
	
	      $window.addEventListener('gz-youtube-command-stop', function () {
	        APIStop();
	      });
	    });
	
	    function onYouTubeIframeAPIReady() {
	      $window.gzYTDefer.resolve();
	    }
	
	    function APIPlay() {
	      $window.gzYTDefer.promise.then(function () {
	        if (player && player.playVideo) {
	          player.playVideo();
	        }
	      });
	    }
	
	    function APIStop() {
	      $window.gzYTDefer.promise.then(function () {
	        if (player && player.seekTo && player.stopVideo) {
	          player.seekTo(0);
	          player.stopVideo();
	        }
	      });
	    }
	
	    function APIPause() {
	      $window.gzYTDefer.promise.then(function () {
	        if (player && player.pauseVideo) {
	          player.pauseVideo();
	        }
	      });
	    }
	
	    function onPlayerReady(event) {
	      var e = event;
	    }
	
	    function onPlayerStateChange(event) {
	      var videoId = $parse(scope.videoId)(scope.$parent);
	      switch (event.data) {
	        case 1:
	          $window.dispatchEvent(new window.CustomEvent('gz-youtube-play', { detail: { playerId: scope.playerId, videoId: videoId } }));
	          break;
	        case 2:
	          $window.dispatchEvent(new window.CustomEvent('gz-youtube-pause', { detail: { playerId: scope.playerId, videoId: videoId } }));
	          break;
	        case 0:
	          if (player.seekTo && player.stopVideo) {
	            scope.reset = true;
	            player.seekTo(0);
	            player.stopVideo();
	          }
	          $window.dispatchEvent(new window.CustomEvent('gz-youtube-stop', { detail: { playerId: scope.playerId, videoId: videoId } }));
	          break;
	        case -1:
	          if (scope.reset) {
	            delete scope.reset;
	            $window.dispatchEvent(new window.CustomEvent('gz-youtube-stop', { detail: { playerId: scope.playerId, videoId: videoId } }));
	          }
	          break;
	      }
	    }
	  }
	}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _youtubeDirective = __webpack_require__(389);
	
	var youTubeDirective = _interopRequireWildcard(_youtubeDirective);
	
	exports['default'] = angular.module('gazelle.components.youTube', []).directive(youTubeDirective.name, youTubeDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzAnalyticsEvent;
	var name = 'gzAnalyticsEvent';
	
	exports.name = name;
	
	function gzAnalyticsEvent() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzAnalyticsEventController.$inject = ["$gzAnalytics"];
	  var directive = {
	    restrict: 'A',
	    // Use a low priority to ensure our event listeners are registered first.
	    // This works because pre-link functions are executed in priority order but post-link functions are
	    // executed in reverse order. So, lowest priority has post-link registered first.
	    // This ensures the page name is accurate in the case where ng-click and gz-analytics-event
	    // is on the same element, or example.
	    priority: -1000,
	    scope: {},
	    controllerAs: 'vm',
	    bindToController: true,
	    link: gzAnalyticsEventLink,
	    controller: gzAnalyticsEventController
	  };
	
	  return directive;
	
	  /////////////////
	
	  function gzAnalyticsEventLink(scope, elem, attrs) {
	
	    // Add event
	    scope.vm.setEvent(attrs.gzAnalyticsEvent);
	
	    // Add category
	    if (attrs.hasOwnProperty('gzAnalyticsCategory')) {
	      scope.vm.setCategory(attrs.gzAnalyticsCategory);
	    }
	
	    // Add label
	    if (attrs.hasOwnProperty('gzAnalyticsLabel')) {
	      scope.vm.setLabel(attrs.gzAnalyticsLabel);
	    }
	
	    // Add value
	    if (attrs.hasOwnProperty('gzAnalyticsValue')) {
	      scope.vm.setValue(attrs.gzAnalyticsValue);
	    }
	
	    // Add event actions
	    if (attrs.hasOwnProperty('gzAnalyticsEventClick')) {
	      scope.vm.setUserAction('click');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventSave')) {
	      scope.vm.setUserAction('save');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventCancel')) {
	      scope.vm.setUserAction('cancel');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventSelect')) {
	      scope.vm.setUserAction('select');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventSend')) {
	      scope.vm.setUserAction('send');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventDelete')) {
	      scope.vm.setUserAction('delete');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventToggle')) {
	      scope.vm.setUserAction('toggle');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventOpen')) {
	      scope.vm.setUserAction('open');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventClose')) {
	      scope.vm.setUserAction('close');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventAdd')) {
	      scope.vm.setUserAction('add');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventEdit')) {
	      scope.vm.setUserAction('edit');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventConfirm')) {
	      scope.vm.setUserAction('confirm');
	    } else if (attrs.hasOwnProperty('gzAnalyticsEventCreate')) {
	      scope.vm.setUserAction('create');
	    }
	
	    // Set the event handler
	    switch (attrs.gzAnalyticsOn) {
	      case 'click':
	      case 'blur':
	      case 'hover':
	        // capture the event to ensure we report before possibly changing views (ensure correct 'page')
	        elem[0].addEventListener(attrs.gzAnalyticsOn, function () {
	          scope.$apply(scope.vm.reportAnalytics);
	        }, true);
	        break;
	      default:
	        // capture the event to ensure we report before possibly changing views (ensure correct 'page')
	        elem[0].addEventListener('click', function () {
	          scope.$apply(scope.vm.reportAnalytics);
	        }, true);
	        break;
	    }
	  }
	
	  // @ngInject
	  function gzAnalyticsEventController($gzAnalytics) {
	
	    var vm = this;
	    var event = null;
	    var eventAction = null;
	    var eventObj = {};
	
	    vm.setEvent = setEvent;
	    vm.setCategory = setCategory;
	    vm.setLabel = setLabel;
	    vm.setValue = setValue;
	    vm.reportAnalytics = reportAnalytics;
	    vm.setUserAction = setUserAction;
	
	    //////////////////////
	
	    function setEvent(anEvent) {
	      event = anEvent;
	    }
	
	    function setCategory(category) {
	      eventObj.category = category;
	    }
	
	    function setLabel(label) {
	      eventObj.label = label;
	    }
	
	    function setValue(value) {
	      eventObj.value = value;
	    }
	
	    function setUserAction(action) {
	      eventAction = action;
	    }
	
	    function reportAnalytics() {
	      switch (eventAction) {
	        case 'click':
	          $gzAnalytics.eventClick(event, eventObj);
	          break;
	        case 'save':
	          $gzAnalytics.eventSave(event, eventObj);
	          break;
	        case 'cancel':
	          $gzAnalytics.eventCancel(event, eventObj);
	          break;
	        case 'select':
	          $gzAnalytics.eventSelect(event, eventObj);
	          break;
	        case 'send':
	          $gzAnalytics.eventSend(event, eventObj);
	          break;
	        case 'delete':
	          $gzAnalytics.eventDelete(event, eventObj);
	          break;
	        case 'toggle':
	          $gzAnalytics.eventDelete(event, eventObj);
	          break;
	        case 'open':
	          $gzAnalytics.eventOpen(event, eventObj);
	          break;
	        case 'close':
	          $gzAnalytics.eventClose(event, eventObj);
	          break;
	        case 'add':
	          $gzAnalytics.eventAdd(event, eventObj);
	          break;
	        case 'edit':
	          $gzAnalytics.eventEdit(event, eventObj);
	          break;
	        case 'confirm':
	          $gzAnalytics.eventConfirm(event, eventObj);
	          break;
	        case 'create':
	          $gzAnalytics.eventCreate(event, eventObj);
	          break;
	        default:
	          $gzAnalytics.event(event, eventObj);
	          break;
	      }
	    }
	  }
	}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	$gzAnalytics.$inject = ["$analytics", "$window", "rnApplication", "$state", "$stateParams"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = $gzAnalytics;
	
	var _gaCustomDefs = __webpack_require__(25);
	
	var name = '$gzAnalytics';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name gazelle.core.analytics.service:$gzAnalytics
	 *
	 * @description
	 * The $gzAnalytics service provides a consistent way to report analytic events.
	 */
	
	function $gzAnalytics($analytics, $window, rnApplication, $state, $stateParams) {
	  'ngInject';
	
	  var GZ_EVENT = 'GZ EVENT';
	
	  var pathParamsRegex = /({(\w+)}|:(\w+))/g;
	  var paramsRegex = /(\w+)/g;
	
	  var service = {
	    intercomTrackEvent: intercomTrackEvent,
	    event: eventTrack,
	    eventClick: eventActionClick,
	    eventSave: eventActionSave,
	    eventCancel: eventActionCancel,
	    eventToggle: eventActionToggle,
	    eventOpen: eventActionOpen,
	    eventClose: eventActionClose,
	    eventAdd: eventActionAdd,
	    eventEdit: eventActionEdit,
	    eventConfirm: eventActionConfirm,
	    eventCreate: eventActionCreate,
	    eventDelete: eventActionDelete,
	    eventSelect: eventActionSelect,
	    eventSend: eventActionSend,
	    exception: exceptionTrack,
	    setUserName: setUserName,
	    getPage: getPage,
	    setAppBuContext: setAppBuContext
	  };
	
	  return service;
	
	  // Public functions
	  function getPage() {
	    if (!$state.current.analyticsParams) {
	      return rnApplication.getCurrentAppId() + $state.current.url;
	    }
	    return rnApplication.getCurrentAppId() + getAnalyticsParamsPage();
	  }
	
	  function getAnalyticsParamsPage() {
	    var analyticsParams = $state.current.analyticsParams;
	
	    var _$state$current$url$split = $state.current.url.split('?');
	
	    var _$state$current$url$split2 = _slicedToArray(_$state$current$url$split, 2);
	
	    var path = _$state$current$url$split2[0];
	    var queryParams = _$state$current$url$split2[1];
	
	    var analyticsUrl = path;
	    if (path) {
	      analyticsUrl = path.replace(pathParamsRegex, function (match, pathParam, braceParamName, colonParamName) {
	        var paramName = braceParamName || colonParamName;
	        if (!analyticsParams.includes(paramName) || !$stateParams.hasOwnProperty(paramName)) {
	          return pathParam;
	        }
	        return $stateParams[paramName];
	      });
	    }
	
	    if (queryParams) {
	      var newQueryParams = queryParams.replace(paramsRegex, function (match, paramName) {
	        if (!analyticsParams.includes(paramName) || !$stateParams.hasOwnProperty(paramName)) {
	          return paramName;
	        }
	        return paramName + '=' + $stateParams[paramName];
	      });
	
	      analyticsUrl += '?' + newQueryParams;
	    }
	
	    return analyticsUrl;
	  }
	
	  function eventTrack(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    if (event === null || event === undefined || event.length === 0) {
	      event = GZ_EVENT;
	    }
	    // Page set in page-analytics.run
	    //eventObj.page = getPage();
	    if (!eventObj.hasOwnProperty('category')) {
	      eventObj.category = rnApplication.getCurrentAppId();
	    }
	    $analytics.eventTrack(event, eventObj);
	  }
	
	  function eventActionCancel(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - canceled', eventObj);
	  }
	
	  function eventActionClick(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - clicked', eventObj);
	  }
	
	  function eventActionToggle(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - toggled', eventObj);
	  }
	
	  function eventActionOpen(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - opened', eventObj);
	  }
	
	  function eventActionClose(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - closed', eventObj);
	  }
	
	  function eventActionAdd(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - added', eventObj);
	  }
	
	  function eventActionEdit(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - edited', eventObj);
	  }
	
	  function eventActionSave(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - saved', eventObj);
	  }
	
	  function eventActionConfirm(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - confirmed', eventObj);
	  }
	
	  function eventActionCreate(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - created', eventObj);
	  }
	
	  function eventActionDelete(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - deleted', eventObj);
	  }
	
	  function eventActionSelect(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - selected', eventObj);
	  }
	
	  function eventActionSend(event) {
	    var eventObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    eventTrack(event + ' - sent', eventObj);
	  }
	
	  function exceptionTrack(exDescription) {
	    var exFatal = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    $window.ga('send', {
	      hitType: 'exception',
	      exDescription: exDescription,
	      exFatal: exFatal
	    });
	  }
	
	  function setAppBuContext(appBuContext) {
	    $window.ga('set', _gaCustomDefs.dimensions.appBuContext, appBuContext);
	  }
	
	  function setUserName(userId) {
	    $analytics.setUsername(userId);
	  }
	
	  function intercomTrackEvent(event, metadata) {
	    if ($window.Intercom) {
	      $window.Intercom('trackEvent', event, metadata);
	    } else {
	      exceptionTrack('Failed to send Intercom event: ' + event);
	    }
	  }
	}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	// HP - modified GA tracking snippet to only ensure temporary ga function
	// to prevent any possible timing window where blue hasn't initialized this yet.
	// Google analytics tracking snippet: https://developers.google.com/analytics/devguides/collection/analyticsjs/tracking-snippet-reference
	/* jshint ignore:start */
	'use strict';
	
	(function (i, s, o, g, r, a, m) {
	  i['GoogleAnalyticsObject'] = r; // Acts as a pointer to support renaming.
	
	  // Creates an initial ga() function.
	  // The queued commands will be executed once analytics.js loads.
	  if (!i[r]) {
	    i[r] = function gaGazelleTemp() {
	      (i[r].q = i[r].q || []).push(arguments);
	    };
	
	    // Sets the time (as an integer) this tag was executed.
	    // Used for timing hits.
	    i[r].l = 1 * new Date();
	  }
	
	  // HP - Don't load the script since it will be loaded in blue
	  /*
	   if (!i.__karma__) {
	   // Insert the script tag asynchronously.
	   // Inserts above current tag to prevent blocking in addition to using the
	   // async attribute.
	   a = s.createElement(o);
	   m = s.getElementsByTagName(o)[0];
	   a.async = 1;
	   a.src = g;
	   m.parentNode.insertBefore(a, m);
	   }
	   */
	
	  // HP - originally,
	  // })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
	})(window, document, undefined, undefined, 'ga');
	/**
	 * Creates a temporary global ga object and loads analytics.js.
	 * Parameters o, a, and m are all used internally. They could have been
	 * declared using 'var', instead they are declared as parameters to save
	 * 4 bytes ('var ').
	 *
	 * @param {Window}        i The global context object.
	 * @param {HTMLDocument}  s The DOM document object.
	 * @param {string}        o Must be 'script'.
	 * @param {string}        g Protocol relative URL of the analytics.js script.
	 * @param {string}        r Global name of analytics object. Defaults to 'ga'.
	 * @param {HTMLElement}   a Async script tag.
	 * @param {HTMLElement}   m First script tag in document.
	 */

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	
	runPageAnalytics.$inject = ["$rootScope", "$analytics", "$gzAnalytics", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = runPageAnalytics;
	
	function runPageAnalytics($rootScope, $analytics, $gzAnalytics, $window) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeSuccess', function () {
	    var pageName = $gzAnalytics.getPage();
	    var index = pageName.indexOf('?');
	    if (index !== -1) {
	      pageName = pageName.substring(0, index);
	    }
	    // set to the current GA session as well so event hits have correct page
	    $window.ga('set', 'page', pageName);
	    $analytics.pageTrack(pageName);
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict';
	
	runSetBluePage.$inject = ["$rootScope", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = runSetBluePage;
	
	function runSetBluePage($rootScope, $window) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	    _.set($window, 'printos.blue.ui.page.id', toState.name);
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	'use strict';
	
	gazelleConfig.$inject = ["$mdThemingProvider", "$mdAriaProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gazelleConfig;
	
	function gazelleConfig($mdThemingProvider, $mdAriaProvider) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // if (__DEV__) { console.log('Gazelle Config: Starting...'); }
	
	  // Do Gazelle config work here....
	
	  /* Consider defining full palettes instead of extending material ones
	  $mdThemingProvider.definePalette('sms-grey', {
	    '50': 'eceff1',    // C1
	    '100': 'd2dadf',   // C2
	    '200': 'c8d2d7',   // C3
	    '300': 'bdcacf',   // C4 prime hue1 background hue1
	    '400': 'adbcc3',   // C6
	    '500': '8a9fa9',   // C10  primary default $hp-blue-appnav for app-nav
	    '600': '9cadb6',   // C8
	    '700': '93a7b0',   // C9
	    '800': '8a9fa9',   // C10 prime hue2 background hue2
	    '900': '253137',   // C0 background hue3
	    'A100': '778f9b',  // C16 prime hue3 (accent hue1) default background color - change this to white
	    'A200': '5c717b',  // C15 accent default color
	    'A400': '445963',  // C18 accent hue2
	    'A700': '324349',  // C14 accent hue3
	    'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
	                                        // on this palette should be dark or light
	    'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
	     '200', '300', '400', 'A100'],
	    'contrastLightColors': undefined    // could also specify this if default was 'dark'
	  });
	  */
	
	  $mdThemingProvider.definePalette('printos-blue', $mdThemingProvider.extendPalette('blue', {
	    '500': '#0096d6' }));
	
	  // HP Blue
	  $mdThemingProvider.definePalette('printos-purple', $mdThemingProvider.extendPalette('purple', {
	    '500': '#822980' }));
	
	  // HP Purple
	  $mdThemingProvider.theme('default').primaryPalette('printos-blue')
	  // Use HP Purple for the default accent color.
	  // Accent palettes use A200, A100, A400 and A700 by default.
	  .accentPalette('printos-blue', {
	    'default': '500'
	  }).warnPalette('deep-orange');
	
	  // Disabling aria warnings until this is a higher program priority.
	  // Also mutes spurious warnings generated from using with angular-translate.
	  // See https://github.com/angular/material/issues/3441
	  $mdAriaProvider.disableWarnings();
	}
	
	module.exports = exports['default'];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	runGazelleRun.$inject = ["$log", "$rootScope", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = runGazelleRun;
	
	function runGazelleRun($log, $rootScope, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // $log.debug('The Gazelle has started running...');
	
	  // Do Gazelle run work here...
	  //rnL10n.setAppServiceBase('uxf', 'portal_service');
	
	  var gazelleVersion = 'unknown';
	  /* global __GAZELLE_VERSION__ */
	  if (true) {
	    gazelleVersion = ("1.13.0");
	  }
	  $log.info('Gazelle version: ' + gazelleVersion);
	
	  logUiRouterEvents();
	
	  // $log.debug('The Gazelle finished running and is tired now.');
	
	  ////////////////
	
	  function logUiRouterEvents() {
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	      $log.debug(event.name + ' fromState: \'' + fromState.name + '\' => toState: \'' + toState.name + '\'');
	    });
	    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	      $log.debug(event.name + ' fromState: \'' + fromState.name + '\' => toState: \'' + toState.name + '\'');
	    });
	    $rootScope.$on('$stateNotFound', function (event, toState, toParams, fromState, fromParams) {
	      $log.warn(event.name + ' fromState: \'' + fromState.name + '\' => toState: \'' + toState.name + '\'');
	    });
	    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
	      $log.error(event.name + ' fromState: \'' + fromState.name + '\' => toState: \'' + toState.name + '\'', error);
	    });
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	gzSystemDownConfig.$inject = ["$httpProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _systemDownProvider = __webpack_require__(399);
	
	var gzSystemDown = _interopRequireWildcard(_systemDownProvider);
	
	exports['default'] = angular.module('gazelle.core.systemDown', ['pascalprecht.translate']).provider(gzSystemDown.name, gzSystemDown['default']).config(gzSystemDownConfig).name;
	
	function gzSystemDownConfig($httpProvider) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  $httpProvider.interceptors.push(gzSystemDown.name);
	}
	module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzSystemDownProvider;
	var name = '$gzSystemDown';
	
	exports.name = name;
	/**
	 * @ngdoc object
	 * @name gazelle.core.systemDown.provider:$gzSystemDownProvider
	 * @description Allows for configuring the system down `$http` interceptor,
	 *   for handling 5xx server responses.
	 */
	
	function $gzSystemDownProvider() {
	  // By default, the alert dialog is only used in production.
	  $gzSystemDown.$inject = ["$log", "$q", "$injector", "$rootScope", "$translate"];
	  var alertDialogEnabled = !(false);
	  // By default, alert toast is only used in development.
	  var alertToastEnabled = (false);
	
	  /**
	   * @ngdoc property
	   * @type {string[]}
	   * @name essentialServices
	   * @propertyOf gazelle.core.systemDown.provider:$gzSystemDownProvider
	   * @description Contains service names that are considered essential.
	   *   Any service unavailable (503) errors received in an non-developer build
	   *   will cause an alert popup to be displayed.
	   *   **Note:** AAA and portal are considered essential services for all apps.
	   * @example
	   * ```javascript
	     function configEssentialServices($gzSystemDownProvider) {
	       'ngInject';
	       $gzSystemDownProvider.essentialServices.push('PrintbeatService');
	     }
	   * ```
	   */
	  var essentialServices = this.essentialServices = ['aaa', 'portal_service'];
	  this.useAlertDialog = useAlertDialog;
	  this.useAlertToast = useAlertToast;
	  this.$get = $gzSystemDown;
	
	  return;
	
	  /**
	   * @ngdoc function
	   * @name useAlertDialog
	   * @methodOf gazelle.core.systemDown.provider:$gzSystemDownProvider
	   * @param {boolean} enableDialog true to enable the dialog, false to disable it
	   * @description Allows for configuring if the alert dialog will be used for 503 errors.
	   *   By default, this is false for development builds and true for production builds
	   *   (using the webpack `__DEV__` flag).
	   */
	  function useAlertDialog(enableDialog) {
	    alertDialogEnabled = enableDialog;
	  }
	
	  /**
	   * @ngdoc function
	   * @name useAlertToast
	   * @methodOf gazelle.core.systemDown.provider:$gzSystemDownProvider
	   * @param {boolean} enableToast true to enable developer toasts, false to disable them
	   * @description Allows for configuring if alert toasts will be used for 5xx errors.
	   *   By default, this is true for development builds and false for production builds
	   *   (using the webpack `__DEV__` flag).
	   */
	  function useAlertToast(enableToast) {
	    alertToastEnabled = enableToast;
	  }
	
	  function $gzSystemDown($log, $q, $injector, $rootScope, $translate) {
	    'ngInject';
	
	    // $log.debug('gzSystemDown loaded.');
	    var processing5xx = false;
	
	    var service = {
	      responseError: responseError
	    };
	
	    return service;
	
	    /////////////////
	
	    function responseError(response) {
	      // Whoops! We got a 5xx from the server
	      // Only do this when not in development mode.
	      if (response.status >= 502 && response.status <= 504 && alertDialogEnabled) {
	        // $log.debug('gzSystemDown responseError interceptor running');
	
	        isEssentialService(response).then(function () {
	          // We got a bad gateway[502], service unavailable[503] or a gateway timeout[504] (apache is up, but tomcats are not)
	          if (!processing5xx) {
	            (function () {
	              $rootScope.inErrorState = response;
	              processing5xx = true;
	              $log.debug('response = ', response);
	              $log.debug('Oh no!!! We got a ' + response.status + '.');
	              $log.debug('Response = ' + response.statusText + ' for ' + response.config.url);
	              var rnApplication = $injector.get('rnApplication');
	              show5xxError(response).then(function () {
	                rnApplication.rebootApp();
	              })['catch'](function () {
	                rnApplication.rebootApp(true);
	              })['finally'](function () {
	                processing5xx = false;
	              });
	            })();
	          }
	        })['catch'](function () {
	          // swallow - don't care about non-essential services
	        });
	      }
	      // Only do this in development mode.
	      if (response.status >= 500 && response.status <= 599 && alertToastEnabled) {
	        $rootScope.inErrorState = response;
	        var $mdToast = $injector.get('$mdToast');
	        $mdToast.show($mdToast.simple({
	          content: response.statusText + ' (' + response.status + ')'
	        }));
	      }
	      return $q.reject(response);
	    }
	
	    /**
	     * @param url to match against an essential service
	     * @returns {Promise.<TResult>} resolved if the URL is from an essentials service, rejected otherwise
	       */
	    function isEssentialService(response) {
	      // Check for an explicit service name. Important to determine if the portal service is offline.
	      var explicitServiceName = _.get(response, 'config.rhino.serviceName');
	      if (explicitServiceName) {
	        if (_.includes(essentialServices, explicitServiceName)) {
	          return $q.resolve();
	        }
	        return $q.reject();
	      }
	
	      var rnRegistry = $injector.get('rnRegistry');
	      return rnRegistry.getServiceName(response.config.url).then(function (serviceName) {
	        if (_.includes(essentialServices, serviceName)) {
	          return $q.resolve();
	        }
	        return $q.reject();
	      });
	    }
	
	    function show5xxError(response) {
	      var $gzAlertDialog = $injector.get('$gzAlertDialog');
	      var content = translateDefault('uxf.uxf.SystemDown_content', 'There was a problem accessing the requested page.');
	      return $gzAlertDialog.show({
	        title: response.statusText + ' (' + response.status + ')',
	        content: content,
	        cancel: translateDefault('uxf.uxf.SystemDown_GoHome', 'PrintOS Home'),
	        ok: translateDefault('uxf.uxf.SystemDown_TryAgain', 'Try Again')
	      });
	    }
	
	    /**
	     * Attempts to translate a string, falling back to a default (like the `translate-default` directive).
	     * TODO: Consider moving this to gazelle l10n as an angular-translate decorator like angular-promise extras.
	     * See: https://github.com/ohjames/angular-promise-extras/blob/master/angular-promise-extras.js
	     * See: http://www.bennadel.com/blog/2870-using-module-decorator-in-angularjs-1-4.htm
	     *
	     * @param locKey {string} localization key
	     * @param defaultString {string} fallback (English) translation
	     * @returns {string} translation or defaultString if translation not found
	     */
	    function translateDefault(locKey, defaultString) {
	      var translation = $translate.instant(locKey);
	      if (translation === locKey) {
	        // Missing translation (perhaps because service down).  Return default string.
	        return defaultString;
	      }
	      return translation;
	    }
	  }
	}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = configPrintOSTooltips;
	
	var _printosAgnosticTooltips = __webpack_require__(79);
	
	// Configure for PrintOS tooltips as required by framework-agnostic components including view nav
	
	function configPrintOSTooltips() {
	  'ngInject';
	
	  var tooltips = new _printosAgnosticTooltips.Tooltips();
	  tooltips.addObserver();
	}
	
	module.exports = exports['default'];

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	'use strict';
	
	configTrustedResources.$inject = ["$sceDelegateProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = configTrustedResources;
	
	function configTrustedResources($sceDelegateProvider) {
	  'ngInject';
	  var whiteList = $sceDelegateProvider.resourceUrlWhitelist() || [];
	
	  $sceDelegateProvider.resourceUrlWhitelist(whiteList.concat([
	  // Trust PrintOS CDN images
	  'https://cdn.printos.com/**']));
	}
	
	module.exports = exports['default'];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc directive
	 * @name gazelle.components.gettingStarted.directive:gzStart
	 *
	 * @description
	 *
	 * @example
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzStart;
	var name = 'gzStart';
	exports.name = name;
	
	function gzStart() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzStartController.$inject = ["$translate", "$q", "$window", "rnClient", "rnPreferences", "$gzAnalytics"];
	  var directive = {
	    restrict: 'E',
	    transclude: true,
	    scope: {
	      gzStepSettings: '=',
	      gzIsStarting: '=?',
	      gzPairingId: '@'
	    },
	    template: __webpack_require__(250),
	    controllerAs: 'vm',
	    bindToController: true,
	    controller: gzStartController
	  };
	
	  return directive;
	
	  /////////////////
	
	  // @ngInject
	  function gzStartController($translate, $q, $window, rnClient, rnPreferences, $gzAnalytics) {
	
	    var api = {
	      test: test,
	      resetAll: resetAll,
	      evaluateSteps: evaluateSteps
	    };
	    var clientConfig = undefined;
	    var preferences = undefined;
	    var currentPath = undefined;
	
	    var vm = this;
	    vm.loading = true;
	    vm.mySteps = [];
	
	    vm.back = back;
	    vm.next = next;
	    vm.selectStep = selectStep;
	    vm.reload = reload;
	
	    vm.unitTest = {
	      determineInclude: determineInclude,
	      determineComplete: determineComplete,
	      setPreferences: function setPreferences(p) {
	        preferences = p;
	      },
	      setCurrentPath: function setCurrentPath(c) {
	        currentPath = c;
	      }
	    };
	
	    vm.$onInit = onInit;
	
	    ////////////////
	    function onInit() {
	      var promises = [];
	      promises.push($translate.onReady());
	      promises.push(getClientConfig());
	      promises.push(determineInclude());
	      $q.all(promises).then(function () {
	        configureAPI();
	        // Quick short circuit if we've already determined all steps are complete
	        if (stepsComplete()) {
	          vm.gzIsStarting = false;
	          return;
	        }
	
	        return initSteps()['finally'](function () {
	          // After evaluation we may determine that all the steps are complete
	          vm.gzIsStarting = !stepsComplete();
	          vm.loading = false;
	        });
	      })['finally'](function () {
	        var onLoadCallback = _.get(vm.gzStepSettings, 'callbacks.onLoad');
	        if (onLoadCallback) {
	          onLoadCallback();
	        }
	
	        vm.loading = false;
	      });
	    }
	
	    function configureAPI() {
	      _.set(vm.gzStepSettings, 'state.isLoaded', true);
	      _.set(vm.gzStepSettings, 'api', api);
	    }
	
	    function getClientConfig() {
	      return rnClient.getConfig('gazelle', 'gettingStarted').then(function (config) {
	        clientConfig = config;
	        return rnPreferences.getSingleObject('gazelle', 'gettingStarted').then(function (prefs) {
	          preferences = prefs ? prefs : {};
	          currentPath = vm.gzPairingId + '.' + config.context.id;
	          var currentPreference = _.get(preferences, currentPath);
	          if (!currentPreference) {
	            var newPrefs = {
	              isComplete: false,
	              skippedSteps: []
	            };
	            _.set(preferences, currentPath, newPrefs);
	            rnPreferences.setSingleObject('gazelle', 'gettingStarted', preferences);
	          }
	        });
	      });
	    }
	
	    function initSteps() {
	      return determineComplete().then(function () {
	        _.forEach(vm.gzStepSettings.steps, function (step) {
	          if (step.isIncluded) {
	            vm.mySteps.push(step);
	          }
	        });
	
	        var found = _.find(vm.mySteps, '{id: "GZ_FINISH_STEP"}');
	        if (!found) {
	          vm.mySteps.push({
	            id: 'GZ_FINISH_STEP',
	            // titleKey: '',
	            titleKey: 'uxf.uxf.Finish_Title',
	            completeDescriptionKey: 'uxf.uxf.Finish_Description',
	            completeDetailsKey: 'uxf.uxf.Finish_Details',
	            isOptional: false,
	            isIncluded: true,
	            isComplete: false
	          });
	        }
	
	        vm.selectedIndex = 0;
	        _.forEach(vm.mySteps, function (step) {
	          if (step.isComplete) {
	            vm.selectedIndex++;
	          } else {
	            return false;
	          }
	        });
	
	        vm.currentStepIndex = vm.selectedIndex;
	        vm.gzStepSettings.currentStep = vm.mySteps[vm.selectedIndex];
	        if (vm.gzStepSettings.currentStep.id === 'GZ_FINISH_STEP') {
	          //Once they advance to finish we'll automatically check it for them
	          vm.gzStepSettings.currentStep.isComplete = true;
	          finishSteps();
	        }
	      });
	    }
	
	    function stepsComplete() {
	      return _.get(preferences, currentPath + '.isComplete', false);
	    }
	
	    function isStepSkipped(step) {
	      var skippedSteps = _.get(preferences, currentPath + '.skippedSteps', []);
	      return skippedSteps.indexOf(step.id) >= 0;
	    }
	
	    function skipStep(step) {
	      var skippedSteps = _.get(preferences, currentPath + '.skippedSteps');
	      if (skippedSteps.indexOf(step.id) < 0) {
	        skippedSteps.push(step.id);
	      }
	
	      rnPreferences.setSingleObject('gazelle', 'gettingStarted', preferences);
	    }
	
	    function finishSteps() {
	      _.set(preferences, currentPath + '.isComplete', true);
	      rnPreferences.setSingleObject('gazelle', 'gettingStarted', preferences);
	    }
	
	    function determineInclude() {
	      var promises = [];
	      _.forEach(vm.gzStepSettings.steps, function (step) {
	        var stepSpecificCallback = _.get(step, 'callbacks.isStepIncluded');
	        if (stepSpecificCallback) {
	          promises.push(stepSpecificCallback(step).then(function (isIncluded) {
	            step.isIncluded = isIncluded;
	          }));
	        } else {
	          var generalCallback = _.get(vm.gzStepSettings, 'callbacks.isStepIncluded');
	          if (generalCallback) {
	            promises.push(generalCallback(step).then(function (isIncluded) {
	              step.isIncluded = isIncluded;
	            }));
	          } else {
	            step.isIncluded = false;
	          }
	        }
	      });
	
	      return $q.all(promises);
	    }
	
	    function determineComplete() {
	      var promises = [];
	      _.forEach(vm.gzStepSettings.steps, function (step) {
	        if (step.isIncluded) {
	          if (step.isOptional) {
	            if (isStepSkipped(step)) {
	              step.isComplete = true;
	              return;
	            }
	          }
	
	          var stepSpecificCallback = _.get(step, 'callbacks.isStepComplete');
	          if (stepSpecificCallback) {
	            promises.push(stepSpecificCallback(step).then(function (isComplete) {
	              step.isComplete = isComplete;
	            }));
	          } else {
	            var generalCallback = _.get(vm.gzStepSettings, 'callbacks.isStepComplete');
	            if (generalCallback) {
	              promises.push(generalCallback(step).then(function (isComplete) {
	                step.isComplete = isComplete;
	              }));
	            } else {
	              step.isComplete = false;
	            }
	          }
	        }
	      });
	
	      return $q.all(promises);
	    }
	
	    function selectStep(index) {
	      var clicked = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      if (index <= vm.currentStepIndex) {
	        vm.selectedIndex = index;
	        vm.gzStepSettings.currentStep = vm.mySteps[index];
	      }
	      var message = 'Getting Started - ' + vm.gzPairingId;
	      if (clicked) {
	        message = 'Click: ' + message;
	      }
	      $gzAnalytics.event(message, { label: 'step: ' + vm.mySteps[index].id });
	    }
	
	    function back() {
	      if (vm.selectedIndex > 0) {
	        vm.selectedIndex--;
	        vm.gzStepSettings.currentStep = vm.mySteps[vm.selectedIndex];
	      }
	      $gzAnalytics.eventClick('back button on start directive');
	    }
	
	    function next() {
	      if (vm.gzStepSettings.currentStep.isOptional) {
	        if (!vm.gzStepSettings.currentStep.isComplete) {
	          vm.gzStepSettings.currentStep.isComplete = true;
	          skipStep(vm.gzStepSettings.currentStep);
	        }
	      }
	
	      vm.selectedIndex++;
	      vm.gzStepSettings.currentStep = vm.mySteps[vm.selectedIndex];
	      if (vm.selectedIndex > vm.currentStepIndex) {
	        vm.currentStepIndex++;
	      }
	
	      if (vm.gzStepSettings.currentStep.id === 'GZ_FINISH_STEP') {
	        //Once they advance to finish we'll automatically check it for them
	        vm.gzStepSettings.currentStep.isComplete = true;
	        finishSteps();
	      }
	
	      $gzAnalytics.eventClick('next button on start directive');
	    }
	
	    function reload() {
	      $window.location.reload();
	    }
	
	    function test() {
	      alert('This message comes calling a test method in the getting started API');
	    }
	
	    function resetAll() {
	      if (_.get(preferences, currentPath)) {
	        delete preferences[vm.gzPairingId][clientConfig.context.id];
	      }
	
	      return rnPreferences.setSingleObject('gazelle', 'gettingStarted', preferences);
	    }
	
	    function evaluateSteps(step) {
	      return initSteps();
	    }
	  }
	}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(541);
	
	var _gettingStartedDirective = __webpack_require__(402);
	
	var gzStart = _interopRequireWildcard(_gettingStartedDirective);
	
	var _coreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _coreAnalyticsAnalyticsModule2 = _interopRequireDefault(_coreAnalyticsAnalyticsModule);
	
	exports['default'] = angular.module('gazelle.components.start', ['pascalprecht.translate', 'rhino.components.preferences', 'rhino.core', _coreAnalyticsAnalyticsModule2['default']]).directive(gzStart.name, gzStart['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Add app icons to the template cache so they may be referenced from apps.json
	 */
	'use strict';
	
	cacheAccountIcons.$inject = ["$templateCache"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = cacheAccountIcons;
	var GRID_IMAGES_CACHE_PREFIX = 'gazelle/grid/images/';
	exports.GRID_IMAGES_CACHE_PREFIX = GRID_IMAGES_CACHE_PREFIX;
	
	function cacheAccountIcons($templateCache) {
	  'ngInject';
	
	  // (Use the html loader to pull the SVG content directly into the template cache.)
	  var requireImages = __webpack_require__(83);
	
	  _.forEach(requireImages.keys(), function (img) {
	    // strip off leading ./
	    var imgFileName = img.substr(2);
	    $templateCache.put(GRID_IMAGES_CACHE_PREFIX + imgFileName, requireImages(img));
	  });
	}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	'use strict';
	
	gzColumnsDialogController.$inject = ["columns", "pairingId", "$translate", "$mdDialog", "rnPreferences", "$gzAnalytics"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzColumnsDialogController;
	var name = 'gzColumnsDialogController';
	exports.name = name;
	
	function gzColumnsDialogController(columns, pairingId, $translate, $mdDialog, rnPreferences, $gzAnalytics) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var vm = this;
	
	  var gridPreferences = undefined;
	  vm.moveUpDisabled = moveUpDisabled;
	  vm.moveDownDisabled = moveDownDisabled;
	  vm.columnClicked = columnClicked;
	  vm.moveUp = moveUp;
	  vm.moveDown = moveDown;
	  vm.togglePin = togglePin;
	  vm.submit = submit;
	
	  activate();
	
	  //////////////////
	
	  function activate() {
	    return rnPreferences.getAll().then(function (prefs) {
	      vm.displayColumns = [];
	      if (prefs.gzGrid) {
	        (function () {
	          gridPreferences = rnPreferences.getPrefObjectHelper(prefs, 'gzGrid', pairingId);
	          var columnPrefs = gridPreferences.columnPrefs;
	          var columnOrder = gridPreferences.columnOrder;
	          if (columnOrder) {
	            _.forEach(columns, function (column) {
	              var allowShow = _.get(column, 'options.allowShow', true);
	              if (allowShow) {
	                var index = columnOrder.indexOf(column.id);
	                if (index < 0) {
	                  index = 1000;
	                }
	                _.set(column, 'sortIndex', index);
	
	                if (columnPrefs) {
	                  column.visible = columnPrefs[column.id].show;
	                  column.pinned = columnPrefs[column.id].pinned === 'left';
	                }
	                vm.displayColumns.push(column);
	              }
	            });
	
	            vm.displayColumns = _.sortBy(vm.displayColumns, 'sortIndex');
	          }
	        })();
	      }
	    });
	  }
	
	  function submit() {
	
	    vm.processing = true;
	    var columnOrder = [];
	    var columnPrefs = {};
	    var columnVisible = [];
	    var columnPinned = [];
	    if (gridPreferences && gridPreferences.columnPrefs) {
	      columnPrefs = gridPreferences.columnPrefs;
	    }
	    _.forEach(vm.displayColumns, function (column) {
	      columnOrder.push(column.id);
	      if (gridPreferences && gridPreferences.columnPrefs) {
	        var found = gridPreferences.columnPrefs[column.id];
	        found.show = column.visible;
	        if (found.show) {
	          columnVisible.push(column.id);
	        }
	
	        if (column.pinned) {
	          found.pinned = 'left';
	          columnPinned.push(column.id);
	        } else {
	          delete found.pinned;
	        }
	      } else {
	        var pref = {
	          show: column.visible
	        };
	        if (pref.show) {
	          columnVisible.push(column.id);
	        }
	        if (column.pinned) {
	          pref.pinned = 'left';
	          columnPinned.push(column.id);
	        }
	      }
	    });
	    var prefs = {
	      columnOrder: columnOrder,
	      columnPrefs: columnPrefs
	    };
	
	    rnPreferences.setSingleObject('gzGrid', pairingId, prefs).then(function () {
	      vm.processing = false;
	      $gzAnalytics.eventSave('Grid (' + pairingId + ') - Columns', { label: 'Order: ' + JSON.stringify(columnOrder) + ', Visible: ' + JSON.stringify(columnVisible) + ', Pinned: ' + JSON.stringify(columnPinned) });
	      $mdDialog.hide(prefs);
	    })['finally'](function () {
	      vm.processing = false;
	    });
	  }
	
	  function columnClicked(column) {
	    if (vm.selected && vm.selected.id === column.id) {
	      delete vm.selected;
	    } else {
	      vm.selected = column;
	    }
	  }
	
	  function moveUpDisabled() {
	    if (!vm.selected) {
	      return true;
	    }
	
	    return vm.displayColumns.indexOf(vm.selected) === 0;
	  }
	
	  function moveDownDisabled() {
	    if (!vm.selected) {
	      return true;
	    }
	
	    return vm.displayColumns.indexOf(vm.selected) === vm.displayColumns.length - 1;
	  }
	
	  function moveUp(event) {
	    event.stopPropagation();
	    var index = vm.displayColumns.indexOf(vm.selected);
	    if (index > 0) {
	      _.remove(vm.displayColumns, { id: vm.selected.id });
	      vm.displayColumns.splice(index - 1, 0, vm.selected);
	    }
	  }
	
	  function moveDown(event) {
	    event.stopPropagation();
	    var index = vm.displayColumns.indexOf(vm.selected);
	    if (index < vm.displayColumns.length - 1) {
	      _.remove(vm.displayColumns, { id: vm.selected.id });
	      vm.displayColumns.splice(index + 1, 0, vm.selected);
	    }
	  }
	
	  function togglePin(event, column) {
	    if (column.pinned) {
	      $gzAnalytics.eventClick('Grid (' + pairingId + ') - Column unpinned', { label: 'ColId: ' + column.id + ', Pinned: ' + column.pinned });
	    } else {
	      $gzAnalytics.eventClick('Grid (' + pairingId + ') - Column pinned', { label: 'ColId: ' + column.id + ', Pinned: ' + column.pinned });
	    }
	    event.stopPropagation();
	    column.pinned = !column.pinned;
	  }
	}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _columnsService = __webpack_require__(407);
	
	var gzColumns = _interopRequireWildcard(_columnsService);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	exports['default'] = angular.module('gazelle.extensions.grid.columns', [_gazelleSrcCoreAnalyticsAnalyticsModule2['default']]).service(gzColumns.name, gzColumns['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $gzColumns;
	var name = '$gzColumns';
	
	exports.name = name;
	
	function $gzColumns() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var unitTest = {};
	
	  var service = {
	    unitTest: unitTest
	  };
	
	  activate();
	  return service;
	
	  function activate() {}
	
	  //
	  // Public functions
	  //
	
	  //
	  // Private functions
	  //
	}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @ngdoc directive
	 * @name gazelle.components.grid.directive:gzGrid
	 *
	 * @description
	 *
	 * @example
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzGrid;
	var name = 'gzGrid';
	exports.name = name;
	
	function gzGrid() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  gzGridController.$inject = ["$translate", "$q", "$timeout", "$window", "$scope", "$rootScope", "$mdDialog", "rnPreferences", "$gzFilters", "$gzFields", "rnHttp", "$mdToast", "$filter", "$log", "$gzAnalytics", "$sanitize"];
	  var directive = {
	    restrict: 'E',
	    scope: {
	      gridOptions: '=',
	      filters: '=?',
	      pairingId: '@',
	      filterMode: '=?'
	    },
	    template: __webpack_require__(258),
	    controllerAs: 'vm',
	    bindToController: true,
	    controller: gzGridController
	  };
	
	  return directive;
	
	  /////////////////
	
	  // @ngInject
	  function gzGridController($translate, $q, $timeout, $window, $scope, $rootScope, $mdDialog, rnPreferences, $gzFilters, $gzFields, rnHttp, $mdToast, $filter, $log, $gzAnalytics, $sanitize) {
	    var vm = this;
	    vm.agGridOptions = {
	      columnDefs: [],
	      onGridReady: agGridReady,
	      onModelUpdated: agModelUpdated,
	      onColumnVisible: agColumnVisible,
	      onColumnPinned: agColumnPinned,
	      onColumnMoved: agColumnMoved,
	      onDragStopped: agDragStopped,
	      onCellClicked: agCellClicked,
	      onAfterSortChanged: agAfterSortChanged,
	      onColumnResized: agColumnResized,
	      onAfterFilterChanged: agAfterFilterChanged,
	      headerCellTemplate: __webpack_require__(255),
	      angularCompileHeaders: true,
	      angularCompileRows: true,
	      headerHeight: 30,
	      isExternalFilterPresent: isExternalFilterPresent,
	      doesExternalFilterPass: doesExternalFilterPass,
	      // Only use mouse events on mobile devices and prevent the filter popup.
	      // See https://github.com/ag-grid/ag-grid/issues/1205
	      suppressTouch: true
	    };
	
	    var PORTAL_SERVICE_NAME = 'portal_service';
	    var FILTERS_PATH = 'filters';
	
	    var data = undefined;
	    var lastSortModel = [];
	    var allowReorder = true;
	    var autoColumns = [];
	    var identityColumns = [];
	    var lastSelection = [];
	    var lastColumnIndex = 0;
	    var serverFilterAND = true; // Does the server support AND statements
	    var serverFilterOR = false; // Does the server support OR statements
	    var serverFilterRecurse = false; // Does the server support arbitrarily nested logic
	    var gridPreferences = undefined;
	    var columnPrefs = undefined;
	    var columnOrder = undefined;
	    var columnSort = undefined;
	    var selectionDebounceTimer = undefined;
	    var deselectDebounceTimer = undefined;
	    var hasServerFilters = false;
	    var filters = undefined;
	    var defaultSort = [];
	    var savePreferencesDebounce = _.debounce(savePreferences, 200, { maxWait: 2000, trailing: true });
	    var getDataDebounce = _.debounce(getData, 200, { maxWait: 2000, trailing: true });
	    var adjustColumnWidthsDebounce = _.debounce(adjustColumnWidths, 100, { maxWait: 300, trailing: true });
	    var userFilterChangeListener = undefined;
	    var namedFilterChangeListener = undefined;
	    var quickFilterChangeListener = undefined;
	    var savedFilterAddedListener = undefined;
	    var lastWidth = undefined;
	    var lastColumnState = [];
	    var gridIndicator = { show: false };
	    var drillDownTooltip = undefined;
	    var expandableRows = false;
	    var allowExpandMultiple = false;
	
	    var columnDefs = [];
	    var counts = {
	      all: undefined,
	      serverFilterCount: undefined,
	      limit: undefined,
	      filterCount: undefined
	    };
	
	    vm.loading = true;
	    vm.savedFilters = [];
	    vm.namedFilters = [];
	    vm.isCustomFiltersAvailable = false;
	
	    vm.unitTest = {
	      getFilters: function getFilters() {
	        return filters;
	      },
	      setFilters: function setFilters(f) {
	        filters = f;
	      },
	      setLastSelection: function setLastSelection(s) {
	        lastSelection = s;
	      },
	      setLastSortModel: function setLastSortModel(l) {
	        lastSortModel = l;
	      },
	      agGridReady: agGridReady,
	      handleUserFilterChanged: handleUserFilterChanged,
	      handleNamedFilterChanged: handleNamedFilterChanged,
	      handleQuickFilterChanged: handleQuickFilterChanged,
	      handleSavedFilterAdded: handleSavedFilterAdded,
	      gzCellRenderer: gzCellRenderer,
	      handleQuickFilterText: handleQuickFilterText,
	      handleCellRenderer: handleCellRenderer,
	      selectionChanged: selectionChanged,
	      isServerSortAffected: isServerSortAffected
	    };
	
	    vm.$onInit = onInit;
	
	    ////////////////
	    function onInit() {
	      setupGridAPI();
	      if (vm.filters) {
	        filters = _.cloneDeep(vm.filters);
	        if (filters.namedFilters) {
	          vm.namedFilters = filters.namedFilters;
	        }
	        $gzFilters.mergeFilters(filters);
	      } else {
	        filters = $gzFilters.createFiltersObject(vm.filters);
	      }
	
	      var promises = [];
	      promises.push($translate.onReady());
	      promises.push(loadPreferences());
	      return $q.all(promises).then(function () {
	        setupAGGrid();
	        var localeText = {
	          noRowsToShow: $translate.instant('uxf.uxf.List_NoItems'),
	          loadingOoo: $translate.instant('uxf.uxf.List_Loading')
	        };
	        vm.agGridOptions.localeText = localeText;
	        vm.loading = false;
	      });
	    }
	
	    ///////////////AG-Grid Initialization////////////////////
	    ///////////////////////////////////////////////////////
	    function agGridReady() {
	      var promises = [];
	      promises.push($translate.onReady());
	      promises.push(loadSavedFilters());
	      promises.push(loadPreferences());
	
	      $q.all(promises).then(function () {
	        initColumnDefs();
	        resetColumns();
	        getData(true).then(function () {
	          updateQuickFilter();
	          $window.addEventListener('resize', handleWindowResized);
	          userFilterChangeListener = $rootScope.$on('gzUserFilterChangedEvent', handleUserFilterChanged);
	          namedFilterChangeListener = $rootScope.$on('gzNamedFilterChangedEvent', handleNamedFilterChanged);
	          quickFilterChangeListener = $rootScope.$on('gzQuickFilterChangedEvent', handleQuickFilterChanged);
	          savedFilterAddedListener = $rootScope.$on('gzSavedFilterAddedEvent', handleSavedFilterAdded);
	
	          $scope.$on('$destroy', function () {
	            $window.removeEventListener('resize', handleWindowResized);
	            userFilterChangeListener();
	            namedFilterChangeListener();
	            quickFilterChangeListener();
	            savedFilterAddedListener();
	          });
	
	          updateColumnWidths();
	        });
	      });
	    }
	
	    function initAndResetColumns() {
	      initColumnDefs();
	      resetColumns();
	      updateColumnWidths();
	    }
	
	    function updateColumnWidths() {
	      $rootScope.$applyAsync(function () {
	        autoSizeColumns();
	        adjustColumnWidthsDebounce();
	      });
	    }
	
	    function resetColumns() {
	      vm.agGridOptions.api.setColumnDefs(columnDefs);
	      // This needs to happen after columnDefs
	      // Check preferences first, then set default sort
	      defaultSort = _.get(vm.gridOptions, 'grid.options.defaultSort', []);
	      if (columnSort) {
	        vm.agGridOptions.api.setSortModel(columnSort);
	      } else {
	        if (defaultSort.length > 0) {
	          vm.agGridOptions.api.setSortModel(defaultSort);
	        }
	      }
	    }
	
	    function agModelUpdated() {
	      autoSizeColumns();
	    }
	
	    function setupGridAPI() {
	      vm.gridOptions.api = {
	        getData: apiGetData,
	        selectRow: apiSelectRow,
	        getAGOptions: apiGetAGOptions,
	        addOrUpdateRows: apiAddOrUpdateRows,
	        removeRows: apiRemoveRows
	      };
	    }
	
	    function initColumnDefs() {
	      columnDefs = [];
	      identityColumns = [];
	      autoColumns.splice(0, autoColumns.length);
	
	      if (columnOrder) {
	        _.forEach(vm.gridOptions.columns, function (column) {
	          var index = columnOrder.indexOf(column.id);
	          if (index < 0) {
	            index = 1000;
	          }
	          _.set(column, 'sortIndex', index);
	
	          if (_.get(column, 'options.isIdentity', false)) {
	            identityColumns.push(column);
	          }
	        });
	
	        vm.gridOptions.sortedColumns = _.sortBy(vm.gridOptions.columns, 'sortIndex');
	      } else {
	        vm.gridOptions.sortedColumns = vm.gridOptions.columns;
	      }
	
	      expandableRows = _.get(vm.gridOptions, 'grid.options.expandableRows', false);
	      var showExpandIndicator = _.get(vm.gridOptions, 'grid.options.showExpandIndicator', true);
	      allowExpandMultiple = _.get(vm.gridOptions, 'grid.options.allowExpandMultiple', false);
	      if (expandableRows && showExpandIndicator) {
	        columnDefs.push({
	          colId: 'gzExpand',
	          headerName: '',
	          suppressSorting: true,
	          suppressMenu: true,
	          suppressFilter: true,
	          suppressResize: true,
	          suppressMovable: true,
	          suppressNavigable: true,
	          minWidth: 40,
	          pinned: 'left',
	          width: 40,
	          cellRenderer: function cellRenderer(params) {
	            params.$scope.node = params.node;
	            params.$scope.expandCollapse = function (event) {
	              event.stopPropagation();
	              params.node.expanded = !params.node.expanded;
	              if (!allowExpandMultiple) {
	                vm.agGridOptions.api.forEachNode(function (node) {
	                  if (node !== params.node) {
	                    node.expanded = false;
	                  }
	                });
	              }
	              vm.agGridOptions.api.onGroupExpandedOrCollapsed(event.rowIndex);
	            };
	            return __webpack_require__(252);
	          }
	        });
	      }
	
	      _.forEach(vm.gridOptions.sortedColumns, function (column) {
	        var columnDef = { colId: column.id };
	        setupColumnHeader(column, columnDef);
	        setupColumnDefaults(column, columnDef);
	        setupColumnOptions(column, columnDef);
	        setupCommonCellOptions(column, columnDef);
	        setupCellOptions(column, columnDef);
	        _.set(columnDef, 'headerCellRenderer', agHeaderCellRenderer);
	        _.set(columnDef, 'angularCompileHeaders', true);
	        var cellRenderer = _.get(column, 'field.callbacks.cellRenderer');
	        if (cellRenderer) {
	          _.set(columnDef, 'cellRenderer', handleCellRenderer);
	        } else {
	          _.set(columnDef, 'cellRenderer', gzCellRenderer);
	        }
	
	        columnDefs.push(columnDef);
	      });
	
	      if (columnDefs.length > 0) {
	        lastColumnIndex = columnDefs.length - 1;
	      }
	
	      // Add dummy column to extend rows to full width of grid
	      columnDefs.push({
	        colId: 'gzDummy',
	        headerName: '',
	        headerCellRenderer: gzDummyHeaderRenderer,
	        suppressSorting: true,
	        suppressMenu: true,
	        suppressFilter: true,
	        suppressResize: true,
	        suppressMovable: true,
	        suppressNavigable: true,
	        minWidth: 0
	      });
	      var gzAction = {
	        colId: 'gzAction',
	        headerName: '',
	        headerCellRenderer: gzActionHeaderRenderer,
	        minWidth: 32,
	        maxWidth: 32,
	        width: 32,
	        pinned: 'right',
	        suppressSorting: true,
	        suppressMenu: true,
	        suppressFilter: true,
	        suppressResize: true,
	        suppressMovable: true,
	        suppressNavigable: true
	      };
	      var allowSelect = _.get(vm.gridOptions, 'grid.options.allowSelect', true);
	      var allowMulti = _.get(vm.gridOptions, 'grid.options.allowMultiSelect', false);
	      var goto = _.get(vm.gridOptions, 'grid.callbacks.gotoClicked');
	      if (allowSelect && !allowMulti && goto !== undefined) {
	        drillDownTooltip = $gzFields.resolveString(vm.gridOptions, 'grid.options.drillDownTooltip', undefined);
	        gzAction.cellRenderer = gzActionCellRenderer;
	      }
	      if (_.get(vm.gridOptions, 'grid.options.showActionMenu', true) || _.get(vm.gridOptions, 'grid.callbacks.gotoClicked')) {
	        columnDefs.push(gzAction);
	        autoColumns.push('gzAction');
	      }
	    }
	
	    function autoSizeColumns() {
	      if (vm.agGridOptions.columnApi) {
	        vm.agGridOptions.columnApi.autoSizeColumns(autoColumns);
	      }
	    }
	
	    function setupAGGrid() {
	      _.set(vm.agGridOptions, 'localeText.noRowsToShow', $translate.instant('uxf.uxf.List_NoItems'));
	      var allowFilters = _.get(vm.gridOptions, 'grid.options.allowFilters', true);
	      _.set(vm.agGridOptions, 'enableFilter', allowFilters);
	      // Row Height - default 48px
	      var rowHeight = _.get(vm.gridOptions, 'grid.options.rowHeight', 48);
	      _.set(vm.agGridOptions, 'rowHeight', rowHeight);
	
	      // Row Selection - default 'single'
	      var allowSelect = _.get(vm.gridOptions, 'grid.options.allowSelect', true);
	      if (allowSelect) {
	        var allowMultiSelect = _.get(vm.gridOptions, 'grid.options.allowMultiSelect', false);
	        if (!allowMultiSelect) {
	          _.set(vm.agGridOptions, 'rowSelection', 'single');
	          _.set(vm.agGridOptions, 'onRowClicked', agRowClicked);
	        } else {
	          _.set(vm.agGridOptions, 'rowSelection', 'multiple');
	          _.set(vm.agGridOptions, 'onRowClicked', agRowClicked);
	        }
	        _.set(vm.agGridOptions, 'rowDeselection', true);
	        _.set(vm.agGridOptions, 'onRowSelected', agRowSelected);
	        _.set(vm.agGridOptions, 'onRowDoubleClicked', agRowDoubleClicked);
	      }
	
	      // Sorting - default true
	      var allowSort = _.get(vm.gridOptions, 'grid.options.allowSort', true);
	      if (allowSort) {
	        _.set(vm.agGridOptions, 'enableSorting', true);
	      }
	
	      // Resizing Columns - default true
	      var allowResize = _.get(vm.gridOptions, 'grid.options.allowResize', true);
	      if (allowResize) {
	        _.set(vm.agGridOptions, 'enableColResize', true);
	      }
	
	      // Reordering Columns - default true (handled at column level)
	      var temp = _.get(vm.gridOptions, 'grid.options.allowReorder', true);
	      if (temp) {
	        allowReorder = false;
	      }
	
	      var allowDragToHide = _.get(vm.gridOptions, 'grid.options.allowDragToHide', true);
	      if (!allowDragToHide) {
	        vm.agGridOptions.suppressDragLeaveHidesColumns = true;
	      }
	
	      // Server supports AND filters - default true
	      var serverAND = _.get(vm.gridOptions, 'grid.options.serverFilterAND', true);
	      if (serverAND) {
	        serverFilterAND = false;
	      }
	
	      // Server supports OR filters - default false
	      var serverOR = _.get(vm.gridOptions, 'grid.options.serverFilterOR', false);
	      if (serverOR) {
	        serverFilterOR = true;
	      }
	
	      // Server supports Recursive filters - default false
	      var serverRecurse = _.get(vm.gridOptions, 'grid.options.serverFilterRecurse', false);
	      if (serverRecurse) {
	        serverFilterRecurse = true;
	      }
	
	      initColumnDefs();
	
	      var identityColumnId = _.get(vm.gridOptions, 'grid.options.identityColumnId');
	      if (identityColumnId) {
	        var identityColumn = _.find(vm.gridOptions.columns, { id: identityColumnId });
	        if (identityColumn) {
	          (function () {
	            var fieldPath = _.get(identityColumn, 'field.path', identityColumnId);
	            _.set(vm.agGridOptions, 'getRowNodeId', function (data) {
	              return _.get(data, fieldPath);
	            });
	          })();
	        }
	      }
	      if (expandableRows) {
	        (function () {
	          _.set(vm.agGridOptions, 'isFullWidthCell', function (rowNode) {
	            return rowNode.flower;
	          });
	
	          _.set(vm.agGridOptions, 'doesDataFlower', function (rowNode) {
	            var isExpandableCallback = _.get(vm.gridOptions, 'grid.callbacks.isRowExpandable');
	            if (isExpandableCallback) {
	              return isExpandableCallback(rowNode);
	            }
	
	            return true;
	          });
	
	          _.set(vm.agGridOptions, 'fullWidthCellRenderer', FullWidthCellRenderer);
	
	          var expandHeight = _.get(vm.gridOptions, 'grid.options.expandRowHeight', 50);
	          _.set(vm.agGridOptions, 'getRowHeight', function (params) {
	            var isDetailRow = params.node.flower;
	            return isDetailRow ? rowHeight + expandHeight : rowHeight;
	          });
	        })();
	      }
	    }
	
	    function FullWidthCellRenderer() {}
	
	    FullWidthCellRenderer.prototype.init = function (params) {
	      var eTemp = document.createElement('div');
	      eTemp.innerHTML = this.getTemplate(params);
	      this.eGui = eTemp.firstElementChild;
	
	      this.consumeMouseWheelOnCenterText();
	    };
	
	    FullWidthCellRenderer.prototype.getTemplate = function (params) {
	      // the flower row shares the same data as the parent row
	      var data = params.node.data;
	
	      var template = '<div class="gz-grid-expansion-cell"> ERROR - grid.callbacks.getExpandedContent not defined </div>';
	      var getContent = _.get(vm.gridOptions, 'grid.callbacks.getExpandedContent');
	      if (getContent) {
	        template = '<div class="gz-grid-expansion-cell">';
	        template += getContent(params);
	        template += '</div>';
	      }
	
	      return template;
	    };
	
	    FullWidthCellRenderer.prototype.getGui = function () {
	      return this.eGui;
	    };
	
	    // if we don't do this, then the mouse wheel will be picked up by the main
	    // grid and scroll the main grid and not this component. this ensures that
	    // the wheel move is only picked up by the text field
	    FullWidthCellRenderer.prototype.consumeMouseWheelOnCenterText = function () {
	      var mouseWheelListener = function mouseWheelListener(event) {
	        event.stopPropagation();
	      };
	
	      // event is 'mousewheel' for IE9, Chrome, Safari, Opera
	      this.eGui.addEventListener('mousewheel', mouseWheelListener);
	      this.eGui.addEventListener('click', mouseWheelListener);
	      // event is 'DOMMouseScroll' Firefox
	      this.eGui.addEventListener('DOMMouseScroll', mouseWheelListener);
	    };
	
	    function setupColumnHeader(column, columnDef) {
	      var title = $gzFields.resolveString(column.header, 'title', column.id);
	      _.set(column, 'header.title', title);
	      var showTitle = _.get(column, 'options.showTitle', true);
	      if (column.header.tooltip || column.header.tooltipKey || column.header.tooltipKeyBase) {
	        _.set(column, 'header.tooltip', $gzFields.resolveString(column.header, 'tooltip', column.id));
	      } else if (!showTitle) {
	        _.set(column, 'header.tooltip', title);
	      }
	
	      _.set(columnDef, 'headerName', column.header.title);
	      var fieldPath = _.get(column, 'field.path', null);
	      _.set(columnDef, 'field', fieldPath);
	      _.set(columnDef, 'suppressSizeToFit', true);
	    }
	
	    function setupColumnDefaults(column, columnDef) {
	      var columnPreferences = _.get(columnPrefs, column.id);
	      var showColumn = _.get(column, 'defaults.show', true);
	      var columnWidth = _.get(column, 'defaults.width', 150);
	      var pinColumn = _.get(column, 'defaults.pinned');
	      var widthFromPreference = false;
	      if (columnPreferences) {
	        var showPreference = _.get(columnPreferences, 'show');
	        if (showPreference !== undefined) {
	          showColumn = showPreference;
	        }
	
	        var widthPreference = _.get(columnPreferences, 'width');
	        if (widthPreference !== undefined) {
	          columnWidth = widthPreference;
	          widthFromPreference = true;
	        }
	
	        var pinnedPreference = _.get(columnPreferences, 'pinned');
	        if (pinnedPreference !== undefined) {
	          pinColumn = pinnedPreference;
	        }
	      }
	
	      if (!showColumn) {
	        _.set(columnDef, 'hide', true);
	      }
	
	      if (pinColumn) {
	        _.set(columnDef, 'pinned', pinColumn);
	      }
	
	      // Column minWidth - default none
	      var minWidth = _.get(column, 'defaults.minWidth', undefined);
	      if (minWidth) {
	        _.set(columnDef, 'minWidth', minWidth);
	      }
	
	      // Column maxWidth - default none
	      var maxWidth = _.get(column, 'defaults.maxWidth', undefined);
	      if (maxWidth) {
	        _.set(columnDef, 'maxWidth', maxWidth);
	      }
	
	      // AutoSize - default false
	      if (widthFromPreference) {
	        _.set(columnDef, 'width', columnWidth);
	      } else {
	        var autoSize = _.get(column, 'defaults.autoSize', false);
	        if (autoSize) {
	          autoColumns.push(column.id);
	        } else {
	          _.set(columnDef, 'width', columnWidth);
	        }
	      }
	    }
	
	    function setupColumnOptions(column, columnDef) {
	      // Show Title - default true
	      var showTitle = _.get(column, 'options.showTitle', true);
	      if (!showTitle) {
	        _.set(columnDef, 'headerName', '');
	      }
	
	      // Show Tooltip - default true
	      var showTooltip = _.get(column, 'options.showTooltip', true);
	      if (!showTooltip) {
	        delete columnDef.headerTooltip;
	      }
	
	      // Allow Sort - default true
	      var allowSort = _.get(column, 'options.allowSort', true);
	      if (!allowSort) {
	        _.set(columnDef, 'suppressSorting', true);
	      }
	
	      // Allow Reorder - default true
	      var testReorder = _.get(column, 'options.allowReorder', true);
	      if (!allowReorder || !testReorder) {
	        _.set(columnDef, 'suppressMoveable', true);
	      }
	
	      // Allow Resize - default true
	      var allowResize = _.get(column, 'options.allowResize', true);
	      if (!allowResize) {
	        _.set(columnDef, 'suppressResize', true);
	      }
	
	      // Custom Sort Comparator
	      var customSort = _.get(column, 'field.callbacks.sortComparator');
	      if (customSort) {
	        _.set(columnDef, 'comparator', handleSortComparator.bind(null, column));
	      }
	
	      // Allow quick filter
	      var hideColumn = _.get(columnDef, 'hide', false);
	      var allowQuickFilter = _.get(column, 'options.allowQuickFilter', true);
	      if (allowQuickFilter) {
	        _.set(columnDef, 'getQuickFilterText', handleQuickFilterText);
	      } else {
	        _.set(columnDef, 'getQuickFilterText', function () {
	          return null;
	        });
	      }
	    }
	
	    function setupCommonCellOptions(column, columnDef) {
	      var cellClasses = [];
	      var justify = _.get(column, 'options.justify');
	      if (justify) {
	        // Use justification if the column specifies
	        switch (justify) {
	          case 'center':
	            cellClasses.push('gz-align-center');
	            break;
	          case 'right':
	            cellClasses.push('gz-align-right');
	            break;
	        }
	      } else {
	        // If column doesn't override, process default special cases
	        var columnType = _.get(column, 'type');
	        switch (columnType) {
	          case 'number':
	            cellClasses.push('gz-align-right');
	            break;
	          case 'image':
	            cellClasses.push('gz-align-center');
	            break;
	          case 'mapped':
	            var showText = _.get(column, 'field.mapped.showText', false);
	            if (!showText) {
	              cellClasses.push('gz-align-center');
	            }
	            break;
	        }
	      }
	
	      // Store this off in the column to use in the class handler
	      _.set(column, 'internal.cellClasses', cellClasses);
	      _.set(columnDef, 'gzColumn', column);
	      _.set(columnDef, 'cellClass', handleCellClass);
	    }
	
	    function setupCellOptions(column, columnDef) {
	      switch (column.type) {
	        case "mapped":
	          setupMappedCell(column, columnDef);
	          break;
	        case "duration":
	          setupDurationCell(column, columnDef);
	          break;
	      }
	    }
	
	    function setupMappedCell(column, columnDef) {
	      var mappedDisplay = _.get(column, 'field.mapped.display');
	      if (mappedDisplay === 'status') {
	        _.set(columnDef, 'comparator', defaultStatusComparator);
	      }
	    }
	
	    function setupDurationCell(column, columnDef) {
	      var customSort = _.get(column, 'field.callbacks.sortComparator');
	      if (!customSort) {
	        _.set(columnDef, 'comparator', defaultDurationComparator.bind(null, column));
	      }
	    }
	
	    function getData() {
	      var force = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	      var shouldGetData = true;
	      var getData = _.get(vm.gridOptions, 'grid.callbacks.getData', undefined);
	      var path = _.get(vm.gridOptions, 'grid.path', undefined);
	      if (getData) {
	        var _ret3 = (function () {
	          var serverFilters = $gzFilters.getServerFilters(filters, vm.gridOptions);
	          if (serverFilters.and.length > 0) {
	            hasServerFilters = true;
	          } else {
	            // For now we are optimizing this call out if we didn't have any server filters
	            // applied already.  You could argue that we should make sure we have a current
	            // data set any time a filter changes
	            if (!force && !hasServerFilters) {
	              shouldGetData = false;
	            }
	            hasServerFilters = false;
	          }
	
	          if (shouldGetData) {
	            var _ret4 = (function () {
	              vm.agGridOptions.api.showLoadingOverlay();
	              var serverSortModel = getServerSort();
	              return {
	                v: {
	                  v: getData(serverFilters, serverSortModel).then(function (resp) {
	                    if (resp) {
	                      counts = {
	                        all: undefined,
	                        serverFilterCount: undefined,
	                        limit: undefined,
	                        filterCount: undefined
	                      };
	
	                      if (path) {
	                        data = _.get(resp, path, []);
	                      } else {
	                        // If no path provided then we assume we were handed the array
	                        data = resp;
	                      }
	
	                      // Use vm.counts to initialize if available
	                      if (vm.counts) {
	                        counts.limit = vm.counts.limit;
	                        counts.serverFiltercount = vm.counts.total;
	                        counts.all = vm.counts.unfilteredTotal;
	                      }
	
	                      // Override counts if they came back with the response
	                      if (resp.limit !== undefined && resp.limit !== null) {
	                        counts.limit = resp.limit;
	                      }
	
	                      if (resp.total !== undefined && resp.total !== null) {
	                        counts.serverFilterCount = resp.total;
	                      }
	
	                      if (resp.unfilteredTotal !== undefined && resp.unfilteredTotal !== null) {
	                        counts.all = resp.unfilteredTotal;
	                      }
	
	                      if (counts.all === undefined) {
	                        counts.all = data.length;
	                      }
	
	                      if (counts.serverFilterCount === undefined) {
	                        counts.serverFilterCount = data.length;
	                      }
	
	                      if (counts.limit === undefined) {
	                        counts.limit = data.length;
	                      }
	
	                      var getMoreData = _.get(vm.gridOptions, 'grid.callbacks.getMoreData');
	                      var getMoreAutoMode = _.get(vm.gridOptions, 'grid.options.getMoreAutoMode', false);
	                      if (counts.serverFilterCount > counts.limit) {
	                        if (getMoreData && getMoreAutoMode) {
	                          // Determine how many pages to get
	                          var pages = Math.ceil(counts.serverFilterCount / counts.limit);
	                          var promises = [];
	                          for (var p = 2; p <= pages; p++) {
	                            promises.push(_getMoreData(getMoreData, serverFilters, serverSortModel, p));
	                          }
	
	                          $q.all(promises).then(function () {
	                            updateGridData();
	                          });
	                        } else {
	                          $gzAnalytics.event('Grid (' + vm.pairingId + ') - Truncated', { label: 'Limit: ' + counts.limit + ', Count: ' + counts.serverFilterCount });
	                          updateGridData();
	                        }
	                      } else {
	                        updateGridData();
	                      }
	                    }
	                  })
	                }
	              };
	            })();
	
	            if (typeof _ret4 === 'object') return _ret4.v;
	          } else {
	            updateFilters();
	          }
	        })();
	
	        if (typeof _ret3 === 'object') return _ret3.v;
	      }
	
	      return $q.resolve();
	    }
	
	    function _getMoreData(getMoreData, serverFilters, sort, page) {
	      var path = _.get(vm.gridOptions, 'grid.path', undefined);
	      var identityColumnId = _.get(vm.gridOptions, 'grid.options.identityColumnId');
	      var identityColumn = undefined;
	      var identityDataPath = undefined;
	      if (identityColumnId) {
	        identityColumn = _.find(vm.gridOptions.columns, { id: identityColumnId });
	        if (identityColumn) {
	          identityDataPath = _.get(identityColumn, 'field.path');
	        }
	      }
	      return getMoreData(serverFilters, sort, page).then(function (resp) {
	        var myData = [];
	        if (path) {
	          myData = _.get(resp, path, []);
	        } else {
	          myData = resp;
	        }
	
	        if (identityDataPath) {
	          (function () {
	            var addedRows = 0;
	            _.forEach(myData, function (row) {
	              var testA = _.get(row, identityDataPath, undefined);
	              if (testA) {
	                var found = _.find(data, function (r) {
	                  var testB = _.get(r, identityDataPath);
	                  if (testB && testA === testB) {
	                    return true;
	                  }
	                });
	
	                if (!found) {
	                  data.push(row);
	                  addedRows++;
	                }
	              }
	            });
	
	            counts.limit += addedRows;
	          })();
	        } else {
	          // If we don't have identity we'll concatenate the results
	          data = data.concat(myData);
	          counts.limit += myData.length;
	        }
	      });
	    }
	
	    function updateGridData() {
	      vm.agGridOptions.api.setRowData(data);
	      updateFilters();
	      $rootScope.$applyAsync(function () {
	        handleAfterGetData();
	      });
	    }
	
	    function handleAfterGetData() {
	      var afterGetDataCallback = _.get(vm.gridOptions, 'grid.callbacks.afterGetData');
	      if (afterGetDataCallback) {
	        afterGetDataCallback();
	      }
	    }
	
	    function getServerSort() {
	      var serverSort = [];
	      var sortModel = _.cloneDeep(vm.agGridOptions.api.getSortModel());
	      _.forEach(sortModel, function (item) {
	        var column = _.find(vm.gridOptions.columns, { id: item.colId });
	        var isServerSort = _.get(column, 'options.sort.isServerSort', false);
	        if (isServerSort) {
	          serverSort.push(item);
	        }
	      });
	
	      return serverSort;
	    }
	
	    ///////////////GZ-Grid API////////////////////////
	    ///////////////////////////////////////////////////////
	    function apiGetData() {
	      getData(true);
	    }
	
	    function apiFindRow(matchCriteria) {
	      var foundNode = undefined;
	      vm.agGridOptions.api.forEachNode(function (node) {
	        for (var propertyName in matchCriteria) {
	          var rowValue = _.get(node.data, propertyName);
	          var matchValue = _.get(matchCriteria, propertyName);
	          if (rowValue !== matchValue) {
	            return;
	          }
	        }
	        foundNode = node;
	      });
	
	      return foundNode;
	    }
	
	    function apiSelectRow(matchCriteria) {
	      var scrollIntoView = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	      var selected = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	      var clearSelection = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];
	
	      var node = apiFindRow(matchCriteria);
	      if (node) {
	        node.setSelected(selected, clearSelection);
	        if (scrollIntoView) {
	          vm.agGridOptions.api.ensureIndexVisible(node.rowIndex);
	        }
	      }
	    }
	
	    function apiGetAGOptions() {
	      return vm.agGridOptions;
	    }
	
	    function apiAddOrUpdateRows(rows) {
	      var identityColumnId = _.get(vm.gridOptions, 'grid.options.identityColumnId');
	      if (!rows || !identityColumnId) {
	        return false;
	      }
	
	      var idColumn = _.find(vm.gridOptions.columns, { id: identityColumnId });
	      if (!idColumn) {
	        return false;
	      }
	
	      var fieldPath = _.get(idColumn, 'field.path', idColumn.id);
	      if (!fieldPath) {
	        return false;
	      }
	
	      var ids = [];
	      var mappedRows = {};
	      rows.forEach(function (row) {
	        var id = _.get(row, fieldPath);
	        if (id) {
	          mappedRows[id] = row;
	          ids.push(id);
	        }
	      });
	
	      vm.agGridOptions.api.forEachNode(function (node) {
	        var test = _.get(node.data, fieldPath);
	        if (ids.includes(test)) {
	          delete node.data.internal.display;
	          node.setData(mappedRows[test]);
	          delete mappedRows[test];
	        }
	      });
	
	      var addNodes = Object.values(mappedRows);
	      if (addNodes.length > 0) {
	        vm.agGridOptions.api.addItems(addNodes);
	      }
	
	      vm.agGridOptions.api.onFilterChanged();
	      vm.agGridOptions.api.onSortChanged();
	    }
	
	    function apiRemoveRows(rowIds) {
	      var rowNodes = vm.agGridOptions.api.getModel().rowsToDisplay;
	      var removeNodes = [];
	      rowIds.forEach(function (id) {
	        var found = rowNodes.find(function (rn) {
	          return rn.id === id;
	        });
	
	        if (found) {
	          removeNodes.push(found);
	        }
	      });
	
	      if (removeNodes.length > 0) {
	        vm.agGridOptions.api.removeItems(removeNodes);
	        agAfterFilterChanged(null);
	      }
	    }
	    ///////////////GZ-Grid Handlers////////////////////////
	    ///////////////////////////////////////////////////////
	    function handleWindowResized(event) {
	      adjustColumnWidthsDebounce();
	    }
	
	    function handleUserFilterChanged(event, data) {
	      if (vm.agGridOptions.api !== null && data.pairingId === vm.pairingId) {
	        filters.userFilter = _.cloneDeep(data.userFilter);
	        mergeAndEventFilters(filters);
	        getDataDebounce();
	      }
	    }
	
	    function handleNamedFilterChanged(event, data) {
	      if (vm.agGridOptions.api !== null && data.pairingId === vm.pairingId) {
	        filters.namedFilter = _.cloneDeep(data.namedFilter);
	        if (data.namedFilter) {
	          filters.userFilter = { and: [] };
	        }
	        mergeAndEventFilters(filters);
	        getDataDebounce();
	      }
	    }
	
	    function handleQuickFilterChanged(event, data) {
	      if (data.pairingId === vm.pairingId) {
	        filters.quickFilter = _.cloneDeep(data.quickFilter);
	        mergeAndEventFilters(filters);
	        updateQuickFilter();
	      }
	    }
	
	    function handleSavedFilterAdded(event, data) {
	      if (vm.agGridOptions.api !== null && data.pairingId === vm.pairingId) {
	        //Adding the newly added user filter to saved filter so that it should reflect in grid my filter menu
	        vm.savedFilters.push(data);
	        loadSavedFilters();
	      }
	    }
	
	    function mergeAndEventFilters(filters) {
	      $gzFilters.mergeFilters(filters);
	      $rootScope.$emit('gzFiltersChangedEvent', {
	        pairingId: vm.pairingId,
	        filters: {
	          userFilter: filters.userFilter,
	          namedFilter: filters.namedFilter,
	          quickFilter: filters.quickFilter
	        }
	      });
	    }
	
	    ///////////////GZ-Cell Renderer///////////////////////
	    ///////////////////////////////////////////////////////
	    function gzCellRenderer(params) {
	      var renderValue = null;
	      var column = _.get(params, 'colDef.gzColumn', undefined);
	      var value = $gzFields.getValue(params.value, params.data, column, params);
	      var classes = [];
	
	      //Store the rendered value in the row for access later
	      _.set(params, '$scope.gzColumn.' + column.id, column);
	      _.set(params, '$scope.gzValue.' + column.id, params.value);
	      _.set(params, 'data.internal.display.' + params.colDef.colId, value);
	
	      var isLinkCallback = _.get(column, 'field.callbacks.isLink', undefined);
	      var isActionCallback = _.get(column, 'field.callbacks.isAction', undefined);
	      if (value !== null && value !== '' && isLinkCallback && isLinkCallback(params.value, params.data, column)) {
	        classes.push('gz-link');
	      } else if (value !== null && value !== '' && isActionCallback && isActionCallback(params.value, params.data, column)) {
	        classes.push('gz-action');
	      } else if (value !== null) {
	        classes.push('gz-cell');
	      }
	
	      if (value !== null) {
	        value = "" + value;
	        renderValue = '<div class="';
	        _.forEach(classes, function (myClass) {
	          renderValue += myClass + ' ';
	        });
	
	        if (column.type === 'string') {
	          value = $sanitize(value);
	        }
	
	        if ((column.type === 'string' || column.type === 'number' || column.type === 'date' || column.type === 'duration') && value.indexOf('tooltip') === -1) {
	          renderValue += '" gz-auto-tooltip>' + value;
	        } else {
	          renderValue += '">'; //close div
	          renderValue += value;
	        }
	
	        renderValue += '</div>';
	      }
	
	      return renderValue;
	    }
	
	    ///////////////AG-Grid Handlers////////////////////////
	    ///////////////////////////////////////////////////////
	    function isExternalFilterPresent() {
	      var mergedFilter = _.get(filters, 'mergedFilter.and', []);
	      return mergedFilter.length > 0;
	    }
	
	    function doesExternalFilterPass(node) {
	      var and = _.get(filters, 'mergedFilter.and', []);
	      return $gzFilters.evaluateAnd(and, node, vm.gridOptions.columns);
	    }
	
	    function agCellClicked(params) {
	      var column = _.get(params, 'colDef.gzColumn');
	      if (column) {
	        //Link click
	        var isLinkCallback = _.get(column, 'field.callbacks.isLink');
	        if (isLinkCallback && isLinkCallback(params.value, params.data, column)) {
	          var gotoLink = _.get(column, 'field.callbacks.gotoLink');
	          if (gotoLink) {
	            params.event.preventDefault();
	            params.event.stopPropagation();
	            gotoLink(params.value, params.data, column);
	          }
	        }
	
	        //Button click
	        var isButtonCallback = _.get(column, 'field.callbacks.isAction');
	        if (isButtonCallback && isButtonCallback(params.value, params.data, column)) {
	          var gotoAction = _.get(column, 'field.callbacks.gotoAction');
	          if (gotoAction) {
	            gotoAction(params.value, params.data, column);
	          }
	        }
	      }
	    }
	
	    function agHeaderCellRenderer(params) {
	      params.$scope.getSort = getSort;
	      params.$scope.getSortIndex = getSortIndex;
	      params.$scope.allowFilters = _.get(vm.gridOptions, 'grid.options.allowFilters', true);
	      params.$scope.isFiltered = isFiltered;
	      params.$scope.isFilter = isFilter;
	      params.$scope.openFilter = openFilter;
	      params.$scope.headerJustify = _.get(params.colDef.gzColumn, 'options.justify', 'left');
	
	      return __webpack_require__(256);
	    }
	
	    function gzDummyHeaderRenderer() {
	      return __webpack_require__(254);
	    }
	
	    function gzActionHeaderRenderer(params) {
	      params.$scope.showMenu = _.get(vm.gridOptions, 'grid.options.showActionMenu', true);
	      params.$scope.gzFilterClicked = gzFilterClicked;
	      params.$scope.gzSortClicked = gzSortClicked;
	      params.$scope.gzColumnsClicked = gzColumnsClicked;
	      params.$scope.gzCSVClicked = gzCSVClicked;
	      params.$scope.gzResetSortClicked = gzResetSortClicked;
	      params.$scope.gzGridIndicator = gridIndicator;
	      params.$scope.gzResetClicked = gzResetClicked;
	      params.$scope.gzSaveFilterClicked = gzSaveFilterClicked;
	      params.$scope.gzNamedFilterClicked = gzNamedFilterClicked;
	      params.$scope.gzRemoveFilterClicked = gzRemoveFilterClicked;
	      params.$scope.gzRemoveBuiltInFilterClicked = gzRemoveBuiltInFilterClicked;
	      params.$scope.gzShowSort = gzShowSort;
	      return __webpack_require__(257);
	    }
	
	    function gzActionCellRenderer(params) {
	      params.$scope.isRowSelected = isRowSelected;
	      params.$scope.drillDownClicked = drillDownClicked;
	      params.$scope.drillDownTooltip = drillDownTooltip;
	
	      var gotoDisabled = _.get(vm.gridOptions, 'grid.callbacks.gotoDisabled');
	      if (gotoDisabled) {
	        params.$scope.gotoDisabled = gotoDisabled;
	      }
	
	      return __webpack_require__(253);
	    }
	
	    function handleQuickFilterText(params) {
	      if (_.get(params, 'colDef.hide', false)) {
	        return null;
	      }
	
	      var column = _.get(params, 'colDef.gzColumn', undefined);
	      var quickFilter = _.get(column, 'field.callbacks.quickFilterText');
	      if (quickFilter) {
	        return quickFilter(params.value, params.data, column, params);
	      } else {
	        switch (column.type) {
	          case 'date':
	            return $gzFields.getDateStringValue(params.value, column);
	          case 'mapped':
	            return $gzFields.getMappedStringValue(params.value, column);
	          case 'image':
	            return null;
	          default:
	            var str = _.get(params, 'data.internal.display.' + params.colDef.colId, null);
	            if (str === null) {
	              str = $gzFields.getValue(params.value, params.data, column, params);
	              _.set(params, 'data.internal.display.' + params.colDef.colId, str);
	            }
	            return '' + str;
	        }
	      }
	    }
	
	    function handleCellClass(params) {
	      var column = _.get(params, 'colDef.gzColumn');
	      var myClasses = _.get(column, 'internal.cellClasses', []);
	      var classRenderer = _.get(vm.gridOptions, 'grid.callbacks.cellClassRenderer');
	      var customClasses = undefined;
	      if (classRenderer) {
	        customClasses = classRenderer(params);
	      }
	
	      if (customClasses && customClasses.length > 0) {
	        customClasses.forEach(function (cc) {
	          if (!myClasses.includes(cc)) {
	            myClasses.push(cc);
	          }
	        });
	      }
	
	      return myClasses.length > 0 ? myClasses : null;
	    }
	
	    function handleCellRenderer(params) {
	      var column = _.get(params, 'colDef.gzColumn');
	      var cellRenderer = _.get(column, 'field.callbacks.cellRenderer');
	      var value = _.get(params, 'value', null);
	      if (cellRenderer) {
	        return cellRenderer(value, params.data, column, params);
	      }
	    }
	
	    function handleSortComparator(column, valueA, valueB, dataA, dataB, isInverted) {
	      var customSort = _.get(column, 'field.callbacks.sortComparator');
	      if (customSort) {
	        return customSort(valueA, valueB, dataA.data, dataB.data, isInverted, column);
	      }
	    }
	
	    function defaultStatusComparator(valueA, valueB) {
	      var compare = getStatusOrdinal(valueA) - getStatusOrdinal(valueB);
	      return compare;
	    }
	
	    function defaultDurationComparator(column, valueA, valueB, dataA, dataB, isInverted) {
	      var valueRenderer = _.get(column, 'field.callbacks.valueRenderer');
	      if (valueRenderer) {
	        valueA = valueRenderer(null, dataA.data, column);
	        valueB = valueRenderer(null, dataB.data, column);
	      }
	
	      return valueA - valueB;
	    }
	
	    function agRowClicked(event) {
	      var isMultiselect = _.get(vm.gridOptions, 'grid.options.allowMultiSelect');
	      if (isMultiselect) {
	        if (!event.event.ctrlKey && !event.event.shiftKey) {
	          if (event.node.isSelected()) {
	            //deselectAll
	            vm.agGridOptions.api.deselectAll();
	            // deselectDebounceTimer = $timeout(deselectRow, 100, true, event);
	          } else {
	              //deselectAll
	              vm.agGridOptions.api.deselectAll();
	              //Select node
	              event.node.setSelected(true);
	            }
	        }
	      } else {
	        if (event.node.isSelected()) {
	          deselectDebounceTimer = $timeout(deselectRow, 100, true, event);
	        }
	      }
	
	      var expandOnSelect = _.get(vm.gridOptions, 'grid.options.expandOnSelect', true);
	      if (expandableRows && expandOnSelect) {
	        event.node.expanded = !event.node.expanded;
	        if (!allowExpandMultiple) {
	          vm.agGridOptions.api.forEachNode(function (node) {
	            if (node !== event.node) {
	              node.expanded = false;
	            }
	          });
	        }
	        vm.agGridOptions.api.onGroupExpandedOrCollapsed(event.rowIndex);
	      }
	
	      // if (isMultiselect && ev
	    }
	
	    function agRowDoubleClicked(event) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Row double clicked');
	      if (deselectDebounceTimer) {
	        $timeout.cancel(deselectDebounceTimer);
	      }
	      if (selectionDebounceTimer) {
	        $timeout.cancel(selectionDebounceTimer);
	      }
	
	      var rowDoubleClicked = _.get(vm.gridOptions, 'grid.callbacks.rowDoubleClicked');
	      if (rowDoubleClicked) {
	        rowDoubleClicked(event.data);
	      }
	    }
	
	    function agAfterSortChanged(event) {
	      var shouldGetData = false;
	      if (counts && counts.serverFilterCount > counts.limit) {
	        shouldGetData = isServerSortAffected();
	      }
	
	      lastSortModel = vm.agGridOptions.api.getSortModel();
	      gridIndicator.show = false;
	      if (lastSortModel.length === 0) {
	        (function () {
	          var defaultSortColumnHidden = false;
	          var columnState = vm.agGridOptions.columnApi.getColumnState();
	          _.forEach(defaultSort, function (sort) {
	            var found = _.find(columnState, { colId: sort.colId });
	            if (found && found.hide === true) {
	              defaultSortColumnHidden = true;
	              return false;
	            }
	          });
	
	          if (defaultSortColumnHidden) {
	            gridIndicator.show = true;
	          }
	        })();
	      }
	      savePreferencesDebounce();
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Column sorted', { label: 'Sort: ' + JSON.stringify(lastSortModel) });
	
	      if (shouldGetData) {
	        getData(true);
	      }
	    }
	
	    function isServerSortAffected() {
	      var newSortModel = vm.agGridOptions.api.getSortModel();
	
	      var index = 0;
	      while (true) {
	        if (index >= newSortModel.length) {
	          if (index >= lastSortModel.length) {
	            return false;
	          }
	
	          while (index < lastSortModel.length) {
	            var sortItem = lastSortModel[index];
	            if (isColumnServerSort(sortItem.colId)) {
	              return true;
	            }
	            ++index;
	          }
	
	          return false;
	        }
	
	        if (index >= lastSortModel.length) {
	          while (index < newSortModel.length) {
	            var sortItem = newSortModel[index];
	            if (isColumnServerSort(sortItem.colId)) {
	              return true;
	            }
	            ++index;
	          }
	
	          return false;
	        }
	
	        var lastSortItem = lastSortModel[index];
	        var newSortItem = newSortModel[index];
	        if (newSortItem.colId !== lastSortItem.colId || newSortItem.sort !== lastSortItem.sort) {
	          if (isColumnServerSort(lastSortItem.colId)) {
	            return true;
	          }
	          if (isColumnServerSort(newSortItem.colId)) {
	            return true;
	          }
	        }
	        ++index;
	      }
	
	      return false;
	    }
	
	    function getColumn(colId) {
	      return _.find(vm.gridOptions.columns, { id: colId });
	    }
	
	    function isColumnServerSort(colId) {
	      var column = getColumn(colId);
	      if (column) {
	        return _.get(column, 'options.sort.isServerSort', false);
	      }
	      return false;
	    }
	
	    function agColumnResized(event) {
	      if (event && !event.finished) {
	        return;
	      }
	
	      if (event.column && event.column.colId !== 'gzDummy' && event.column.colId !== 'gzAction' && event.column.colId !== 'gzExpand') {
	        autoColumns.splice(autoColumns.indexOf(event.column.colId), 1);
	        $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Column resized', { label: 'ColId: ' + event.column.colId + ', type: manual' });
	      }
	
	      adjustColumnWidthsDebounce();
	    }
	
	    function agAfterFilterChanged(event) {
	      $timeout(function () {
	        if (!_.get(vm, 'agGridOptions.api')) {
	          return;
	        }
	
	        counts.filterCount = vm.agGridOptions.api.getModel().rowsToDisplay.length;
	        $rootScope.$emit('gzFilterCountUpdated', {
	          pairingId: vm.pairingId,
	          counts: counts
	        });
	      }, 200);
	    }
	
	    function agColumnVisible(event) {
	      savePreferencesDebounce();
	      adjustColumnWidthsDebounce();
	    }
	
	    function agColumnPinned(event) {
	      savePreferencesDebounce();
	      adjustColumnWidthsDebounce();
	    }
	
	    function agColumnMoved(event) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Column moved', { label: 'ColId: ' + event.column.colId + ', moved to order: ' + event.toIndex });
	      event.toIndex = 0;
	      adjustColumnWidthsDebounce();
	    }
	
	    function agDragStopped(event) {
	      var columnStates = vm.agGridOptions.columnApi.getColumnState();
	      if (expandableRows && columnStates[0] !== 'gzExpand' || columnStates[columnStates.length - 1].colId !== 'gzAction' || columnStates[columnStates.length - 2].colId !== 'gzDummy') {
	        (function () {
	          var dummyColumnState = _.find(columnStates, { colId: 'gzDummy' });
	          var actionColumnState = _.find(columnStates, { colId: 'gzAction' });
	          var expandColumnState = _.find(columnStates, { colId: 'gzExpand' });
	          var reOrdered = [];
	          if (expandColumnState) {
	            reOrdered.push(expandColumnState);
	          }
	          _.forEach(columnStates, function (columnState) {
	            if (columnState.colId !== 'gzDummy' && columnState.colId !== 'gzAction' && columnState.colId !== 'gzExpand') {
	              reOrdered.push(columnState);
	            }
	          });
	
	          if (dummyColumnState) {
	            reOrdered.push(dummyColumnState);
	          }
	          if (actionColumnState) {
	            reOrdered.push(actionColumnState);
	          }
	          vm.agGridOptions.columnApi.setColumnState(reOrdered);
	        })();
	      }
	
	      var columns = vm.agGridOptions.columnApi.getAllColumns();
	      _.forEach(columns, function (column) {
	        if (column.colId !== 'gzAction' && column.pinned === 'right') {
	          vm.agGridOptions.columnApi.setColumnPinned(column.colId, null);
	        }
	      });
	      adjustColumnWidthsDebounce();
	    }
	
	    function agRowSelected(event) {
	      if (selectionDebounceTimer) {
	        $timeout.cancel(selectionDebounceTimer);
	      }
	      selectionDebounceTimer = $timeout(selectionChanged, 100);
	    }
	
	    function selectionChanged() {
	      if (!vm.agGridOptions.api) {
	        return;
	      }
	
	      selectionDebounceTimer = undefined;
	      var selectionChanged = _.get(vm.gridOptions, 'grid.callbacks.selectionChanged');
	      if (selectionChanged) {
	        (function () {
	          var allNodes = vm.agGridOptions.api.getModel().rowsToDisplay;
	          var selectedNodes = allNodes.filter(function (node) {
	            return node.selected;
	          });
	          var currentSelection = selectedNodes.map(function (node) {
	            return node.data;
	          });
	
	          var addedRows = [];
	          var removedRows = [];
	          if (identityColumns.length > 0) {
	            _.forEach(lastSelection, function (row) {
	              if (!containsRow(currentSelection, row)) {
	                removedRows.push(row);
	              }
	            });
	
	            _.forEach(currentSelection, function (row) {
	              if (!containsRow(lastSelection, row)) {
	                addedRows.push(row);
	              }
	            });
	          }
	
	          selectionChanged(currentSelection, addedRows, removedRows);
	          lastSelection = currentSelection;
	        })();
	      }
	    }
	
	    function containsRow(rows, test) {
	      // If we don't have anything to match on we'll assume no match
	      if (identityColumns.length === 0) {
	        return false;
	      }
	
	      var rowContainsTest = false;
	      _.forEach(rows, function (row) {
	        var matchAllColumns = true;
	        _.forEach(identityColumns, function (column) {
	          var path = _.get(column, 'field.path');
	          if (_.get(row, path) !== _.get(test, path)) {
	            matchAllColumns = false;
	            return false;
	          }
	        });
	
	        if (matchAllColumns) {
	          rowContainsTest = true;
	          return false;
	        }
	      });
	
	      return rowContainsTest;
	    }
	    ///////////////AG-Header Controller////////////////////
	    ///////////////////////////////////////////////////////
	    function getSort(colId) {
	      var sort = vm.agGridOptions.api.getSortModel();
	      if (sort.length === 0) {
	        return;
	      }
	
	      var found = _.find(sort, { colId: colId });
	      if (!found) {
	        return;
	      }
	      return found.sort;
	    }
	
	    function getSortIndex(colId) {
	      var sort = vm.agGridOptions.api.getSortModel();
	      if (sort.length === 0 || sort.length === 1) {
	        return;
	      }
	
	      var index = _.findIndex(sort, { colId: colId });
	      if (index < 0) {
	        return;
	      }
	
	      return ++index;
	    }
	
	    function isFilter(colId) {
	      var column = getColumn(colId);
	      var isFilter = _.get(column, 'options.allowFilter', true);
	      return isFilter;
	    }
	
	    function isFiltered(colId) {
	      var and = _.get(filters, 'mergedFilter.and');
	      var found = _.find(and, function (item) {
	        return item.columnId === colId || item.or && item.or[0].columnId === colId || item.and && item.and[0].columnId === colId;
	      });
	
	      return found !== undefined;
	    }
	
	    function openFilter(event, colId) {
	      event.stopPropagation();
	      gzFilterClicked(event, colId);
	    }
	
	    ///////////////GZ-Action Controller////////////////////
	    ///////////////////////////////////////////////////////
	    function gzShowSort() {
	      if (!vm.gridOptions.allowSort) {
	        return false;
	      }
	
	      return true;
	    }
	
	    function gzFilterClicked($event) {
	      var colId = arguments.length <= 1 || arguments[1] === undefined ? undefined : arguments[1];
	
	      $gzFilters.openFilterDialog(vm.pairingId, vm.gridOptions.columns, filters, colId);
	    }
	
	    function gzSortClicked($event) {
	      $mdDialog.show({
	        targetEvent: $event,
	        template: __webpack_require__(259),
	        controller: 'gzSortDialogController',
	        bindToController: true,
	        controllerAs: 'vm',
	        locals: {
	          sortModel: vm.agGridOptions.api.getSortModel(),
	          columns: vm.gridOptions.columns,
	          pairingId: vm.pairingId
	        }
	      }).then(function (sortModel) {
	        var columnIds = _.pluck(sortModel, 'colId');
	        $gzAnalytics.eventSave('Grid (' + vm.pairingId + ') - Sort', { label: 'ColIds: ' + JSON.stringify(columnIds) + ', Sort: ' + JSON.stringify(sortModel) });
	        vm.agGridOptions.api.setSortModel(sortModel);
	        agAfterSortChanged();
	      });
	    }
	
	    function gzColumnsClicked($event) {
	      $mdDialog.show({
	        targetEvent: $event,
	        template: __webpack_require__(251),
	        controller: 'gzColumnsDialogController',
	        controllerAs: 'vm',
	        locals: {
	          columns: vm.gridOptions.columns,
	          pairingId: vm.pairingId
	        }
	      }).then(function (prefs) {
	        columnPrefs = _.get(prefs, 'columnPrefs');
	        columnOrder = _.get(prefs, 'columnOrder');
	        initAndResetColumns();
	        vm.agGridOptions.api.setSortModel(lastSortModel);
	        savePreferencesDebounce();
	      });
	    }
	
	    function gzResetSortClicked($event) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Reset sort');
	      vm.agGridOptions.api.setSortModel(defaultSort);
	      savePreferencesDebounce();
	    }
	
	    function gzCSVClicked($event) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Export CSV');
	
	      var params = {
	        processCellCallback: agCSVExportCellRenderer,
	        processHeaderCallback: agCSVExportHeaderRenderer
	      };
	
	      //Excluding image column while exporting
	      var displayedColumns = vm.agGridOptions.columnApi.getAllDisplayedColumns();
	      var hideColumns = [];
	      displayedColumns.forEach(function (col) {
	        var allowExport = _.get(col, 'colDef.gzColumn.options.allowExport', true);
	        if ((!allowExport || !col.colDef.gzColumn || col.colDef.gzColumn.type === 'image') && col.visible) {
	          hideColumns.push(col.colDef.colId);
	          vm.agGridOptions.columnApi.setColumnVisible(col.colDef.colId, false);
	        }
	      });
	
	      vm.agGridOptions.api.exportDataAsCsv(params);
	
	      hideColumns.forEach(function (colId) {
	        vm.agGridOptions.columnApi.setColumnVisible(colId, true);
	      });
	    }
	
	    function agCSVExportCellRenderer(params) {
	      var gzColumn = _.get(params, 'column.colDef.gzColumn');
	      if (!gzColumn) {
	        return '';
	      }
	      var exportValue = $gzFields.getExportValue(params.value, params.node.data, params.column.colDef.gzColumn);
	      if (exportValue && exportValue.length > 0) {
	        var badLeadingChars = ['=', '+', '-', '@'];
	        var index = 0;
	        while (badLeadingChars.includes(exportValue[index++])) {}
	
	        if (index > 0) {
	          exportValue = exportValue.substring(index - 1);
	        }
	      }
	
	      return exportValue;
	    }
	
	    function agCSVExportHeaderRenderer(params) {
	      var gzColumn = _.get(params, 'column.colDef.gzColumn');
	      if (!gzColumn) {
	        return '';
	      }
	      return $gzFields.resolveString(params.column.colDef.gzColumn.header, 'title', params.column.colId);
	    }
	
	    function gzResetClicked($event) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Reset Defaults');
	      rnPreferences.deleteSingle('gzGrid', vm.pairingId).then(function () {
	        columnPrefs = undefined;
	        columnOrder = undefined;
	        loadPreferences().then(function () {
	          initAndResetColumns();
	          vm.agGridOptions.api.setSortModel(defaultSort);
	          savePreferencesDebounce();
	        });
	      });
	    }
	
	    ///////////////AG-Cell Functions///////////////////////
	    ///////////////////////////////////////////////////////
	    function isRowSelected(rowNode) {
	      return rowNode.isSelected();
	    }
	
	    function drillDownClicked(rowNode, $event) {
	      if ($event) {
	        $event.stopPropagation();
	      }
	
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Goto');
	      var goto = _.get(vm.gridOptions, 'grid.callbacks.gotoClicked');
	      if (goto) {
	        goto(rowNode.data);
	      }
	    }
	
	    ///////////////GZ-Grid Preferences/////////////////////
	    ///////////////////////////////////////////////////////
	    function savePreferences() {
	      if (!vm.agGridOptions.columnApi) {
	        return;
	      }
	
	      var columnState = vm.agGridOptions.columnApi.getColumnState();
	      var co = [];
	      var cp = {};
	      var cs = lastSortModel;
	      _.forEach(columnState, function (state) {
	        if (state.colId !== 'gzDummy' && state.colId !== 'gzAction' && state.colId !== 'gzExpand') {
	          co.push(state.colId);
	          var pref = {
	            show: !state.hide,
	            pinned: state.pinned
	          };
	          if (autoColumns.indexOf(state.colId) === -1) {
	            pref.width = state.width;
	          }
	          _.set(cp, state.colId, pref);
	        }
	      });
	      var gp = {
	        columnOrder: co,
	        columnPrefs: cp,
	        columnSort: cs
	      };
	      rnPreferences.setSingleObject('gzGrid', vm.pairingId, gp);
	    }
	
	    function loadPreferences() {
	      return rnPreferences.getAll().then(function (prefs) {
	        if (prefs.gzGrid) {
	          gridPreferences = rnPreferences.getPrefObjectHelper(prefs, 'gzGrid', vm.pairingId);
	          columnPrefs = _.get(gridPreferences, 'columnPrefs');
	          columnOrder = _.get(gridPreferences, 'columnOrder');
	          columnSort = _.get(gridPreferences, 'columnSort');
	        }
	      });
	    }
	
	    ///////////////Helper Functions////////////////////////
	    ///////////////////////////////////////////////////////
	    function columnWidthsAreDifferent(columnState, lastColumnState) {
	      var isSame = true;
	      if (columnState.length !== lastColumnState.length) {
	        return false;
	      }
	
	      for (var i = 0; i < columnState.length; i++) {
	        var testA = columnState[i];
	        var testB = lastColumnState[i];
	        if (testA.colId !== testB.colId || testA.hide !== testB.hide || testA.width !== testB.width) {
	          isSame = false;
	          break;
	        }
	      }
	
	      return !isSame;
	    }
	
	    function adjustColumnWidths() {
	      var force = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	      // Manually adjust dummy column and hide if horizontally scrolling to prevent
	      // an issue with ag-grid with a gap appears next to the pinned gzAction column.
	      var viewport = document.querySelector('[pairing-id="' + vm.pairingId + '"] .ag-body-viewport');
	      if (!viewport) {
	        return;
	      }
	
	      var width = viewport.getBoundingClientRect().width;
	      var scrollWidth = viewport.offsetWidth - viewport.clientWidth;
	      width -= scrollWidth;
	
	      var columnState = vm.agGridOptions.columnApi.getColumnState();
	      if (force || width !== lastWidth || columnWidthsAreDifferent(columnState, lastColumnState)) {
	        // Manually adjust dummy column and hide if horizontally scrolling to prevent
	        // an issue with ag-grid with a gap appears next to the pinned gzAction column.
	
	        // store off new viewport width before we start manipulating it
	        lastWidth = width;
	
	        columnState.forEach(function (column) {
	          if (column.colId === 'gzDummy' || column.colId === 'gzAction' || column.colId === 'gzExpand' || column.hide || column.pinned) {
	            return;
	          }
	          width -= column.width;
	        });
	
	        // Store off new columnState before we potentially trigger new calls to adjustColumnWidths
	        lastColumnState = columnState;
	
	        var dummyCol = _.find(columnState, { colId: 'gzDummy' });
	        if (width > 0) {
	          vm.agGridOptions.columnApi.setColumnWidth('gzDummy', width);
	          vm.agGridOptions.columnApi.setColumnVisible('gzDummy', true);
	        } else {
	          vm.agGridOptions.columnApi.setColumnVisible('gzDummy', false);
	        }
	      }
	
	      savePreferencesDebounce();
	    }
	
	    function updateFilters() {
	      if (vm.agGridOptions.api) {
	        vm.agGridOptions.api.onFilterChanged();
	      }
	    }
	
	    function updateQuickFilter() {
	      //Sometimes api goes away if we rebuild column definitions
	      if (!vm.agGridOptions.api) {
	        $timeout(updateQuickFilter, 100);
	        return;
	      }
	      var quickValue = _.get(filters, 'quickFilter.value');
	      if (quickValue !== undefined) {
	        vm.agGridOptions.api.setQuickFilter(quickValue);
	      } else {
	        vm.agGridOptions.api.setQuickFilter('');
	      }
	    }
	
	    function deselectRow(event) {
	      event.node.setSelected(false);
	    }
	
	    function getStatusOrdinal(status) {
	      if (status) {
	        switch (status.toLowerCase()) {
	          case 'info':
	            return 1;
	          case 'warn':
	            return 2;
	          case 'error':
	            return 3;
	          case 'unknown':
	            return 4;
	        }
	      }
	      return 0;
	    }
	
	    //Grid's server Filters
	    function loadSavedFilters() {
	      return rnHttp.get(PORTAL_SERVICE_NAME, FILTERS_PATH).then(function (response) {
	        if (response) {
	          var myFilters = _.filter(response.data.filters, { pairingId: vm.pairingId });
	          //Fix up display
	          _.forEach(myFilters, function (filter) {
	            var display = {
	              title: filter.name
	            };
	            _.set(filter, 'namedFilter.display', display);
	          });
	          vm.savedFilters = myFilters;
	        }
	      })['catch'](function (error) {
	        return $log.error('Unable to retrieve saved filter', error);
	      });
	    }
	
	    function gzSaveFilterClicked($event, filter) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Saved Filter', { label: 'Filter: ' + filter.id });
	      $rootScope.$emit('gzNamedFilterChangedEvent', {
	        pairingId: vm.pairingId,
	        namedFilter: filter.namedFilter
	      });
	
	      if (filter.quickFilter) {
	        $rootScope.$emit('gzQuickFilterChangedEvent', {
	          pairingId: vm.pairingId,
	          quickFilter: filter.quickFilter,
	          force: true
	        });
	      }
	    }
	
	    function gzNamedFilterClicked($event, filter) {
	      $gzAnalytics.eventClick('Grid (' + vm.pairingId + ') - Named Filter', { label: 'Filter: ' + filter.id });
	      $rootScope.$emit('gzNamedFilterChangedEvent', {
	        pairingId: vm.pairingId,
	        namedFilter: filter
	      });
	    }
	
	    function gzRemoveFilterClicked($event, filter) {
	      $event.stopPropagation();
	      if (filter && filter.id) {
	        rnHttp['delete'](PORTAL_SERVICE_NAME, FILTERS_PATH + '/' + filter.id).then(function () {
	          _.remove(vm.savedFilters, { id: filter.id });
	
	          var message = filter.name + ' ' + $filter('translate')('uxf.uxf.Filter_Removed');
	          $mdToast.showSimple(message);
	          $gzAnalytics.eventDelete('Grid (' + vm.pairingId + ') - Filter', { label: 'Filter: ' + filter.name });
	        });
	      }
	    }
	
	    function gzRemoveBuiltInFilterClicked($event, filter) {
	      if (filter && filter.id) {
	        $rootScope.$emit('gzFilterRemovedEvent', {
	          pairingId: vm.pairingId,
	          filterId: filter.id
	        });
	
	        $rootScope.$emit('gzNamedFilterChangedEvent', {
	          pairingId: vm.pairingId,
	          userFilter: filters.namedFilter
	        });
	      }
	    }
	  }
	}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(543);
	
	var _gridDirective = __webpack_require__(408);
	
	var gzGrid = _interopRequireWildcard(_gridDirective);
	
	var _cacheImagesRunJs = __webpack_require__(404);
	
	var _cacheImagesRunJs2 = _interopRequireDefault(_cacheImagesRunJs);
	
	var _columnsColumnsDialogController = __webpack_require__(405);
	
	var editColumns = _interopRequireWildcard(_columnsColumnsDialogController);
	
	var _sortSortDialogController = __webpack_require__(410);
	
	var editSort = _interopRequireWildcard(_sortSortDialogController);
	
	__webpack_require__(526);
	
	__webpack_require__(542);
	
	__webpack_require__(544);
	
	var _coreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _coreAnalyticsAnalyticsModule2 = _interopRequireDefault(_coreAnalyticsAnalyticsModule);
	
	exports['default'] = angular.module('gazelle.components.grid', ['agGrid', 'angularMoment', 'pascalprecht.translate', 'gazelle.components.filters', 'gazelle.components.fields', 'rhino.components.preferences', 'rhino.core', _coreAnalyticsAnalyticsModule2['default']]).run(_cacheImagesRunJs2['default']).directive(gzGrid.name, gzGrid['default']).controller(editColumns.name, editColumns['default']).controller(editSort.name, editSort['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	'use strict';
	
	gzSortDialogController.$inject = ["sortModel", "columns", "$mdDialog", "$gzAnalytics", "pairingId"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gzSortDialogController;
	var name = 'gzSortDialogController';
	exports.name = name;
	
	function gzSortDialogController(sortModel, columns, $mdDialog, $gzAnalytics, pairingId) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var vm = this;
	  vm.columns = columns;
	
	  vm.availableColumns = [];
	  vm.sortDirection = "desc";
	  vm.moveUpDisabled = moveUpDisabled;
	  vm.moveDownDisabled = moveDownDisabled;
	  vm.sortClicked = sortClicked;
	  vm.moveUp = moveUp;
	  vm.moveDown = moveDown;
	  vm.toggleSortOrder = toggleSortOrder;
	  vm.toggleSortDirection = toggleSortDirection;
	  vm.addSort = addSort;
	  vm.removeSort = removeSort;
	  vm.submit = submit;
	  vm.sort = [];
	
	  activate();
	
	  //////////////////
	
	  function activate() {
	    _.forEach(columns, function (column) {
	      var allowSort = _.get(column, 'options.allowSort', true);
	      if (allowSort) {
	        vm.availableColumns.push(column);
	      }
	    });
	
	    _.forEach(sortModel, function (sortItem) {
	      var column = _.find(columns, { id: sortItem.colId });
	      _.remove(vm.availableColumns, { id: sortItem.colId });
	
	      var found = _.find(columns, { type: 'image' });
	      if (found) {
	        _.remove(vm.availableColumns, { id: found.id });
	      }
	
	      var item = {
	        id: column.id,
	        column: column,
	        sort: sortItem.sort
	      };
	
	      vm.sort.push(item);
	    });
	
	    if (vm.availableColumns.length > 0) {
	      vm.availableColumns = _.sortBy(vm.availableColumns, function (column) {
	        return column.header.title;
	      });
	      vm.sortColumn = vm.availableColumns[0];
	    }
	  }
	
	  function submit() {
	    var sortModel = [];
	    _.forEach(vm.sort, function (sortItem) {
	      var sort = {
	        colId: sortItem.id,
	        sort: sortItem.sort
	      };
	      sortModel.push(sort);
	    });
	
	    var columnIds = _.pluck(sortModel, 'colId');
	    $gzAnalytics.eventSave('Grid (' + pairingId + ') - Sorted column', { label: 'Sort: ' + JSON.stringify(sortModel) });
	    $mdDialog.hide(sortModel);
	  }
	
	  function sortClicked(sortItem) {
	    if (vm.selected && vm.selected.id === sortItem.id) {
	      delete vm.selected;
	    } else {
	      vm.selected = sortItem;
	    }
	  }
	
	  function moveUpDisabled() {
	    if (!vm.selected) {
	      return true;
	    }
	
	    return vm.sort.indexOf(vm.selected) === 0;
	  }
	
	  function moveDownDisabled() {
	    if (!vm.selected) {
	      return true;
	    }
	
	    return vm.sort.indexOf(vm.selected) === vm.sort.length - 1;
	  }
	
	  function moveUp(event) {
	    event.stopPropagation();
	    var index = vm.sort.indexOf(vm.selected);
	    if (index > 0) {
	      _.remove(vm.sort, vm.selected);
	      vm.sort.splice(index - 1, 0, vm.selected);
	    }
	  }
	
	  function moveDown(event) {
	    event.stopPropagation();
	    var index = vm.sort.indexOf(vm.selected);
	    if (index < vm.sort.length - 1) {
	      _.remove(vm.sort, vm.selected);
	      vm.sort.splice(index + 1, 0, vm.selected);
	    }
	  }
	
	  function toggleSortOrder(event, sortItem) {
	    event.stopPropagation();
	    if (sortItem.sort === "asc") {
	      sortItem.sort = "desc";
	    } else {
	      sortItem.sort = "asc";
	    }
	  }
	
	  function toggleSortDirection() {
	    if (vm.sortDirection === "asc") {
	      vm.sortDirection = "desc";
	    } else {
	      vm.sortDirection = "asc";
	    }
	  }
	
	  function addSort() {
	    var sortItem = {
	      id: vm.sortColumn.id,
	      column: vm.sortColumn,
	      sort: vm.sortDirection
	    };
	
	    vm.sort.push(sortItem);
	    vm.selected = sortItem;
	    _.remove(vm.availableColumns, { id: sortItem.id });
	
	    if (vm.availableColumns.length > 0) {
	      vm.sortColumn = vm.availableColumns[0];
	    }
	  }
	
	  function removeSort(event) {
	    var index = vm.sort.indexOf(vm.selected);
	    _.remove(vm.sort, { id: vm.selected.id });
	
	    var found = _.find(columns, { id: vm.selected.id });
	    if (found) {
	      vm.availableColumns.push(found);
	      vm.availableColumns = _.sortBy(vm.availableColumns, function (column) {
	        return column.header.title;
	      });
	    }
	
	    if (vm.sort.length === 0) {
	      vm.selected = undefined;
	    } else if (index > vm.sort.length - 1) {
	      vm.selected = vm.sort[vm.sort.length - 1];
	    } else {
	      vm.selected = vm.sort[index];
	    }
	  }
	}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _cacheIconsRunJs = __webpack_require__(412);
	
	var _cacheIconsRunJs2 = _interopRequireDefault(_cacheIconsRunJs);
	
	exports['default'] = angular.module('appAppSwitcher', []).run(_cacheIconsRunJs2['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Add app icons to the template cache so they may be referenced from apps.json
	 */
	'use strict';
	
	cacheAppIcons.$inject = ["$templateCache"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = cacheAppIcons;
	var APP_ICONS_CACHE_PREFIX = 'app-switcher/icons/';
	exports.APP_ICONS_CACHE_PREFIX = APP_ICONS_CACHE_PREFIX;
	
	function cacheAppIcons($templateCache) {
	  'ngInject';
	
	  // (Use the html loader to pull the SVG content directly into the template cache.)
	  var requireIcon = __webpack_require__(84);
	
	  _.forEach(requireIcon.keys(), function (icon) {
	    // Store icons in cache at app-switcher/icons/Box.svg
	    // strip off leading ./
	    var iconFileName = icon.substr(2);
	    $templateCache.put(APP_ICONS_CACHE_PREFIX + iconFileName, requireIcon(icon));
	  });
	}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	// Create a single module that includes all modules in this library by
	// creating a new require context (see http://webpack.github.io/docs/context.html)
	// for finding all module files and then requiring them as dependencies
	// to the all-encompassing module.
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var requiresModule = __webpack_require__(85);
	
	var moduleNames = [];
	requiresModule.keys().forEach(function (moduleFile) {
	  moduleNames.push(requiresModule(moduleFile));
	});
	
	exports['default'] = angular.module('rhino', moduleNames).name;
	module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcComponentsSessionSessionModule = __webpack_require__(10);
	
	var _rhinoSrcComponentsSessionSessionModule2 = _interopRequireDefault(_rhinoSrcComponentsSessionSessionModule);
	
	var _adminService = __webpack_require__(415);
	
	var rnAdmin = _interopRequireWildcard(_adminService);
	
	exports['default'] = angular.module('rhino.components.admin', [_rhinoSrcComponentsSessionSessionModule2['default']]).factory(rnAdmin.name, rnAdmin['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	'use strict';
	
	rnAdmin.$inject = ["$http", "$q", "$log", "rnHttp"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnAdmin;
	var name = 'rnAdmin';
	exports.name = name;
	
	function rnAdmin($http, $q, $log, rnHttp) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var AAA_SERVICE_NAME = 'aaa';
	  var ORG_PATH = 'admin/organizations/';
	  var USER_PATH = 'admin/users/';
	  var DEVICE_PATH = 'admin/devices/';
	
	  var service = {
	    getOrgs: getOrgs,
	    getUsers: getUsers,
	    getDevices: getDevices,
	    putLocked: putLocked
	  };
	
	  return service;
	
	  //////////////////////
	
	  function getOrgs(offset, limit) {
	    var config = { 'offset': offset, 'limit': limit };
	
	    return doAaaGet(ORG_PATH, config);
	  }
	
	  function getUsers(offset, limit) {
	    var config = { 'offset': offset, 'limit': limit };
	
	    return doAaaGet(USER_PATH, config);
	  }
	
	  function getDevices(offset, limit) {
	    var config = { 'offset': offset, 'limit': limit };
	
	    return doAaaGet(DEVICE_PATH, config);
	  }
	
	  function putLocked(href, locked) {
	
	    return doAaaPut(href, locked);
	  }
	
	  function doAaaGet(path, params) {
	    var config = {
	      params: params
	    };
	
	    return rnHttp.get(AAA_SERVICE_NAME, path, config);
	  }
	
	  function doAaaPut(path, content) {
	
	    // DJL - Some HAL implementation for REST responses has already begun on the server. However, the
	    // link vals are returning absolute URLs. This is necessary until we formally outline (and implement)
	    // our approach to JSON/HAL on both the client and server.
	    // TODO remove when we no longer have to deal with absolute and relative URLs
	    var start = path.indexOf('admin');
	    var end = path.length;
	    var modifiedPath = path.substring(start, end);
	    var deferred = $q.defer();
	
	    return rnHttp.put(AAA_SERVICE_NAME, modifiedPath, content);
	  }
	}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	'use strict';
	
	rnApplicationView.$inject = ["$log", "rnHttp", "rnApplication", "$q"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnApplicationView;
	var name = 'rnApplicationView';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.application.service:rnApplicationView
	 * @description
	 * Simple service for retrieving application views.  This service is useful in an application's
	 * main controller to determine which views the user can see in the nav menu.
	 */
	
	function rnApplicationView($log, rnHttp, rnApplication, $q) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var APPLICATIONS_SEGMENT = 'apps';
	  var PORTAL_SERVICE = 'portal_service';
	
	  var service = {
	    getAppViews: getAppViews,
	    hasView: hasView
	  };
	
	  return service;
	
	  ////////////////
	
	  /**
	   * @ngdoc function
	   * @name getAppViews
	   * @methodOf rhino.components.application.service:rnApplicationView
	   * @description Retrieve views for a specified application.
	   * @param {string} [appId=Current App Id] the application to find views for or the current application if not specified
	   * @param {boolean} [reload] true to force a reload of the data from the server
	   * @returns {Promise} an array of views or an error response
	   */
	  function getAppViews(appId, reload) {
	    if (!appId) {
	      appId = rnApplication.getCurrentAppId();
	      if (!appId) {
	        return $q.reject('Unable to get the current app id');
	      }
	    }
	
	    return rnHttp.get(PORTAL_SERVICE, APPLICATIONS_SEGMENT + '/' + appId + '/views', { cache: !reload }).then(function (response) {
	      return response.data.views;
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name hasView
	   * @methodOf rhino.components.application.service:rnApplicationView
	   * @description Determines whether or not a view is present in the list of an application's views.
	   * @param {string} [toState] the state to search for
	   * @param {string} [appId=Current App Id] the application to find views for or the current application if not specified
	   * @param {boolean} [reload] true to force a reload of the data from the server
	   * @returns {boolean} true if present, else false
	   */
	  function hasView(toState, appId, reload) {
	    return getAppViews(appId, reload).then(function (views) {
	      var view = _.find(views, function (v) {
	        if (v.views) {
	          // We can have, potentially, one level of nested views
	          var nestedView = _.find(v.views, function (nView) {
	            return nView.state === toState;
	          });
	          return nestedView ? true : false;
	        } else {
	          return v.state === toState;
	        }
	      });
	      return view ? true : false;
	    });
	  }
	}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	rnApplication.$inject = ["$log", "$q", "$window", "rnRegistry", "rnHttp", "$rootElement", "rnClient"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnApplication;
	var name = 'rnApplication';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.application.service:rnApplication
	 * @description Service for managing applications
	 */
	
	function rnApplication($log, $q, $window, rnRegistry, rnHttp, $rootElement, rnClient) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var service = {
	    getAllApps: getAllApps,
	    getFullApps: getFullApps,
	    getApplication: getApplication,
	    getMiniApps: getMiniApps,
	    getExternalApps: getExternalApps,
	    getCurrentAppId: getCurrentAppId,
	    setCurrentAppId: setCurrentAppId,
	    rebootApp: rebootApp,
	    getAppLocName: getAppLocName
	  };
	
	  var nbh = true; // never been here
	  var currentAppId = null;
	
	  return service;
	
	  ////////////////
	
	  /**
	   * @ngdoc function
	   * @name getApplications
	   * @methodOf rhino.components.application.service:rnApplication
	   * @description Get all apps of all types
	   * @param {boolean} [reload] - If false or undefined, use cache
	   */
	  function getApplications() {
	    var reload = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    return rnClient.getConfig(!reload).then(function (clientConfig) {
	      var apps = clientConfig.apps;
	      if (nbh) {
	        nbh = !nbh;
	        $log.debug('rnApplications.getApplications: ', apps);
	      }
	      return apps; // TODO we should just return data.apps here.....but we need to first find out if other PrintOS apps
	      // are expecting just data
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name getApplication
	   * @methodOf rhino.components.application.service:rnApplication
	   * @description Get all apps of all types
	   * @param {String} [appId] - appId for application to return
	   */
	  function getApplication(appId) {
	    return getApplications(false).then(function (apps) {
	      var found = _.find(apps.entity, { appId: appId });
	      return found;
	    });
	  }
	
	  function getAllApps(reload) {
	    return getApplications(reload).then(function (apps) {
	      return apps.entity;
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name getFullApps
	   * @methodOf rhino.components.application.service:rnApplication
	   * @description Get apps of type 'full'
	   * @param {boolean} [reload] - If false or undefined, use cache
	   */
	  function getFullApps(reload) {
	    return getApplications(reload).then(function (apps) {
	      return _.select(apps.entity, { type: 'full' });
	    });
	  } //getFullApps
	
	  /**
	   * @ngdoc function
	   * @name getMiniApps
	   * @methodOf rhino.components.application.service:rnApplication
	   * @description Get apps of type 'mini'
	   * @param {boolean} [reload] - If false or undefined, use cache
	   */
	  function getMiniApps(reload) {
	    return getApplications(reload).then(function (apps) {
	      return _.select(apps.entity, { type: 'mini' });
	    });
	  } //getMiniApps
	
	  /**
	   * @ngdoc function
	   * @name getExternalApps
	   * @methodOf rhino.components.application.service:rnApplication
	   * @description Get apps of type 'external'
	   * @param {boolean} [reload] - If false or undefined, use cache
	   */
	  function getExternalApps(reload) {
	    return getApplications(reload).then(function (apps) {
	      return _.select(apps.entity, { type: 'external' });
	    });
	  } //getExternalApps
	
	  /**
	   * @ngdoc function
	   * @name rebootApp
	   * @methodOf rhino.components.application.service:rnApplication
	   * @description Reboot the entire front-end.. This is a hard reload of the client side application
	   * @param {boolean} [goHome=false] Force the browser to load '/' on the primary server if true, else just reload the existing route
	   */
	  function rebootApp() {
	    var goHome = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    $log.debug('Rebooting Application!!');
	    if (goHome === true) {
	      rnRegistry.getUrl('sms_portal', 'home').then(function (url) {
	        $window.location.href = url;
	      });
	    } else {
	      $window.location.reload();
	    }
	  }
	
	  /**
	   * @ngdoc function
	   * @name getCurrentAppId
	   * @methodOf rhino.components.application.service:rnApplication
	   * @description Returns the current application id by inspecting the `ng-app` attribute.
	   * @returns {String|undefined} current application id or undefined if it couldn't be determined
	   */
	  function getCurrentAppId() {
	    if (currentAppId) {
	      return currentAppId;
	    }
	
	    var appId = $rootElement.attr('ng-app') || $rootElement.attr('data-ng-app');
	    if (!appId) {
	      $log.info("Can't find current app id");
	    }
	    return appId;
	  }
	
	  function setCurrentAppId(appId) {
	    currentAppId = appId;
	  }
	
	  function getAppLocName(appId) {
	    return getApplications(false).then(function (apps) {
	      var found = _.find(apps.entity, { appId: appId });
	      if (found) {
	        return found.loc.name;
	      } else {
	        return $q.reject("App not found (" + appId + ")");
	      }
	    });
	  }
	}
	
	//rnApplication

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _chatService = __webpack_require__(419);
	
	var rnChatService = _interopRequireWildcard(_chatService);
	
	exports['default'] = angular.module('rhino.components.chat', [_rhinoSrcCoreCoreModule2['default']]).service(rnChatService.name, rnChatService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	'use strict';
	
	rnChatService.$inject = ["$q", "$log", "$filter", "rnRegistry", "rnHttp", "rnRecordFactory"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnChatService;
	var name = 'rnChatService';
	exports.name = name;
	
	function rnChatService($q, $log, $filter, rnRegistry, rnHttp, rnRecordFactory) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	  var chatServiceName = 'chat_service';
	  var chatServiceRoot = 'room';
	  var dateFormat = 'yyyy-MM-dd HH:mm:ssZ';
	  var portalService = 'sms_portal';
	
	  var service = {
	    getChatrooms: getChatrooms,
	    getChatroom: getChatroom,
	    getOrgUsers: getOrgUsers,
	    startChat: startChat,
	    sendMessage: sendMessage,
	    getMessage: getMessage,
	    unsubscribe: unsubscribe,
	    getMessages: getMessages,
	    getChatroomByEntity: getChatroomByEntity,
	    addRemoveCurrentUser: addRemoveCurrentUser,
	    loadMoreChats: loadMoreChats,
	    createRoomRecord: createRoomRecord,
	    chatHalRequest: chatHalRequest
	  };
	
	  return service;
	
	  ////////////////
	
	  function getOrgUsers(link, params) {
	    var config = {};
	    config.params = params;
	
	    return chatHalRequest(link, null, config).then(function (resp) {
	      return $q.resolve(resp.data);
	    });
	  }
	
	  function getChatrooms() {
	    var config = {};
	    var today = new Date();
	    today.setHours(0, 0, 0, 0);
	    config.params = { timestamp: today.toISOString().replace(/T/, ' ').replace(/\..+/, '') };
	    var proxyServicePromise = rnRegistry.getUrl(chatServiceName);
	
	    return proxyServicePromise.then(function (url) {
	      var link = {};
	      link.href = url;
	      link.op = 'GET';
	      return rnHttp.halRequest(link, null, config).then(function (resp) {
	        var chatData = resp.data;
	        var categories = _.map(chatData.categories, createCategoryRecord);
	        chatData.categories = categories;
	        return $q.resolve(chatData);
	      });
	    });
	  }
	
	  function startChat(chatroom, link) {
	    var config = {};
	
	    return chatHalRequest(link, chatroom, config).then(function (resp) {
	      var chatroom = createRoomRecord(resp.data);
	      return $q.resolve(chatroom);
	    });
	  }
	
	  function sendMessage(message, link) {
	    var config = {};
	
	    return chatHalRequest(link, message, config).then(function (resp) {
	      return $q.resolve(resp.data);
	    });
	  }
	
	  function unsubscribe(link) {
	    var config = {};
	    return chatHalRequest(link, null, config);
	  }
	
	  function getMessage(url, updateMsgRead) {
	    var link = {};
	    link.op = 'GET';
	    link.href = url;
	    var config = {};
	    if (updateMsgRead) {
	      config.params = { updateMsgRead: true };
	    }
	
	    return chatHalRequest(link, null, config).then(function (resp) {
	      return $q.resolve(resp.data);
	    });
	  }
	
	  function getMessages(link) {
	    var config = {};
	
	    return chatHalRequest(link, null, config).then(function (resp) {
	      return $q.resolve(resp.data);
	    });
	  }
	
	  function getChatroom(url) {
	    var link = {};
	    link.op = 'GET';
	    link.href = url;
	    var config = {};
	
	    return chatHalRequest(link, null, config).then(function (resp) {
	      var chatroom = createRoomRecord(resp.data);
	      return $q.resolve(chatroom);
	    });
	  }
	
	  function getChatroomByEntity(entityId) {
	    var link = {};
	    link.op = 'GET';
	    var config = {};
	    var proxyServicePromise = rnRegistry.getUrl(chatServiceName);
	
	    return proxyServicePromise.then(function (url) {
	      link.href = url + chatServiceRoot + "/entity/" + entityId;
	      return rnHttp.halRequest(link, null, config).then(function (resp) {
	        var chatroom = createRoomRecord(resp.data);
	        return $q.resolve(chatroom);
	      });
	    });
	  }
	
	  function createCategoryRecord(data) {
	    var category = rnRecordFactory.create(data);
	    var roomRecords = _.map(category.rooms, createRoomRecord);
	    category.rooms = roomRecords;
	
	    return category;
	  }
	
	  function createRoomRecord(data) {
	    var room = rnRecordFactory.create(data);
	    room.internal.idName = 'chatId';
	
	    return room;
	  }
	
	  function addRemoveCurrentUser(link) {
	    var config = {};
	    return chatHalRequest(link, null, config).then(function (resp) {
	      var chatroom = createRoomRecord(resp.data);
	      return $q.resolve(chatroom);
	    });
	  }
	
	  function loadMoreChats(link) {
	    var config = {};
	    return chatHalRequest(link).then(function (resp) {
	      var category = resp.data;
	      var categoryRecord = createCategoryRecord(category);
	      return $q.resolve(categoryRecord);
	    });
	  }
	
	  function chatHalRequest(link, data, config) {
	    var newLink = angular.copy(link);
	    return appendServer(newLink.href).then(function (href) {
	      newLink.href = href;
	
	      return rnHttp.halRequest(newLink, data, config);
	    });
	  }
	
	  function appendServer(path) {
	    return rnRegistry.getUrl(portalService, path);
	  }
	}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	rnDcs.$inject = ["$q", "$log", "$filter", "rnHttp"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnDcs;
	var name = 'rnDcs';
	exports.name = name;
	
	function rnDcs($q, $log, $filter, rnHttp) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var DCS_SERVICE_NAME = 'dcs_service';
	  var DEVICES_PATH = 'devices/';
	  var DELIVERY_CAPABILITIES_PATH = 'deliverycapabilities/';
	
	  var service = {
	    getAll: getAll,
	    getById: getById,
	    createDevice: createDevice,
	    updateDevice: updateDevice,
	    deleteDevice: deleteDevice,
	    getDeliveryCapabilities: getDeliveryCapabilities
	  };
	
	  return service;
	
	  //////////////
	
	  function getAll(offset, limit) {
	    var params = { offset: offset, limit: limit };
	    var config = { params: params, version: 2 };
	
	    return rnHttp.get(DCS_SERVICE_NAME, DEVICES_PATH, config).then(rnHttp.resolveWithData)['catch'](rnHttp.rejectWithSmsError);
	  }
	
	  function getById(id) {
	    return rnHttp.get(DCS_SERVICE_NAME, DEVICES_PATH + id, { version: 2 }).then(rnHttp.resolveWithData)['catch'](rnHttp.rejectWithSmsError);
	  }
	
	  function createDevice(device) {
	    return rnHttp.post(DCS_SERVICE_NAME, DEVICES_PATH, device, { version: 2 }).then(rnHttp.resolveWithData)['catch'](rnHttp.rejectWithSmsError);
	  }
	
	  function updateDevice(deviceObject) {
	    var link = _.get(deviceObject, 'device._links.update', null);
	
	    if (!link) {
	      return $q.reject('No update link included');
	    }
	
	    return rnHttp.halRequest(link, deviceObject).then(rnHttp.resolveWithData)['catch'](rnHttp.rejectWithSmsError);
	  }
	
	  function deleteDevice(id, password) {
	    return rnHttp.deleteWithBody(DCS_SERVICE_NAME, DEVICES_PATH + id, password, { version: 2 })['catch'](rnHttp.rejectWithSmsError);
	  }
	
	  function getDeliveryCapabilities() {
	    return rnHttp.get(DCS_SERVICE_NAME, DELIVERY_CAPABILITIES_PATH, { version: 2 }).then(rnHttp.resolveWithData)['catch'](rnHttp.rejectWithSmsError);
	  }
	}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	'use strict';
	
	rnDevice.$inject = ["$q", "$log", "$filter", "rnHttp", "rnSession", "rnPusher", "rnRecordFactory", "rnRecordCollectionFactory", "systemStatisticsService", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnDevice;
	var name = 'rnDevice';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.device.service:rnDevice
	 *
	 * @description Rhino Device service, provides methods to interact with devices.
	 */
	
	function rnDevice($q, $log, $filter, rnHttp, rnSession, rnPusher, rnRecordFactory, rnRecordCollectionFactory, systemStatisticsService, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var AAA_SERVICE_NAME = 'aaa';
	  var SYS_STATS_SERVICE_NAME = 'system_statistics';
	  var ORG_DEVICES_PATH = 'organizations/devices/';
	  var ORG_DEVICES_WITH_CONTEXT_PATH = 'organizations/devices/v2';
	  var DEVICE_MODEL_PATH = 'devices/modeltypes/';
	  var ORG_DEVICE_MODEL_PATH = 'organizations/devices/modeltypes/';
	
	  var serialNumberRequiredTypeList = ['LatexPrinter', 'DesignjetPrinter', 'TextilePrinter', 'PageWideXLPrinter', 'IndigoPress', 'IHPSPress', 'ScitexPress', 'FinishingDevice'];
	
	  var service = {
	    setupPusher: setupPusher,
	    getDeviceModels: getDeviceModels,
	    getOrganizationDeviceModels: getOrganizationDeviceModels,
	    addDevice: addDevice,
	    updateDevice: updateDevice,
	    getById: getById,
	    getAll: getAll,
	    getAllWithContext: getAllWithContext,
	    addDisplayInfo: addDisplayInfo,
	    getImagePath: getImagePath,
	    getScaledImagePath: getScaledImagePath,
	
	    // Is anybody calling this directly? or is it just exposed here to enable tests? It is called by the .getAll function
	    find: find,
	
	    // We would like to obsolete these
	    newDevice: newDevice,
	    getDevicesForTable: getDevicesForTable,
	    getDevicesForWidgets: getDevicesForWidgets,
	    getDeviceStats: getDeviceStats
	  };
	
	  return service;
	
	  ////////////////
	
	  /**
	   * @ngdoc function
	   * @name setupPusher
	   * @methodOf rhino.components.device.service:rnDevice
	   * @param {string} channelName of the channel to bind to
	   * @description Binds a callback function to a channel event.
	   * @param {function} callback for pusher to call
	   * @param {object} scope - so that the callback is unbound on scope destruction
	   */
	  function setupPusher(callback, scope) {
	    if (callback && scope) {
	      rnSession.userContext().then(function (context) {
	        if (context !== undefined && context !== null) {
	          rnPusher.bind('private-' + context.id + '-DeviceStatistics', 'NewDeviceStatistic', callback, scope)['catch'](function (error) {
	            $log.warn('Unable to setup pusher: ', error);
	          });
	        } else {
	          $log.warn('Unable to get user context to setup pusher');
	        }
	      })['catch'](function (error) {
	        $log.warn('Unable to get user context to setup pusher: ', error);
	      });
	    } else {
	      $log.warn('callback and scope are required. Pusher not setup');
	    }
	  }
	
	  // Get all device models
	  function getDeviceModels() {
	    return doGet(AAA_SERVICE_NAME, DEVICE_MODEL_PATH).then(function (data) {
	      data = changeDeviceTypeHashtoList(data);
	      return data;
	    });
	  }
	
	  // Get all device models that are avaialable for this organization
	  // For example, some unreleased device models may not be available to this organization and will not be included
	  function getOrganizationDeviceModels() {
	    return doGet(AAA_SERVICE_NAME, ORG_DEVICE_MODEL_PATH).then(function (data) {
	      data = changeDeviceTypeHashtoList(data);
	      return data;
	    });
	  }
	
	  // The upstream caller of this function is expected to have already injected it into the device passed in.
	  function addDevice(device, url) {
	    return doAaaPost(url, device);
	  }
	
	  // The caller is expected to strip _links and internal nodes before passing in.
	  function updateDevice(device, url) {
	    return doAaaPut(url, device);
	  }
	
	  function getById(id) {
	    return doGet(AAA_SERVICE_NAME, 'organizations/devices/' + id).then(function (data) {
	      var device = createRecord(data);
	      device = addDisplayInfo(device);
	      return device;
	    })['catch'](function (err) {
	      return $q.reject(err);
	    });
	  }
	
	  function getAll(offset, limit) {
	    return getAllWithContext({ offset: offset, limit: limit });
	  }
	
	  function getAllWithContext(params) {
	    var config = { params: params };
	
	    return doGet(AAA_SERVICE_NAME, ORG_DEVICES_WITH_CONTEXT_PATH, config).then(function (data) {
	      var combinedDeviceRecords = [];
	
	      // Iterate through each context and create Rhino records for the devices, and also copy the devices
	      // into a single combined devices array
	      _.forEach(data.devicesWithContext, function (deviceCollection) {
	        var deviceRecords = undefined;
	        var deviceRecordsCollection = undefined;
	
	        deviceRecords = _.map(deviceCollection.devices, createRecord);
	
	        // Add to a single "devices" array which is all of the devices from each context combined together
	        combinedDeviceRecords = combinedDeviceRecords.concat(deviceRecords);
	
	        deviceCollection.devices = deviceRecords;
	        deviceRecordsCollection = rnRecordCollectionFactory.create(deviceCollection);
	
	        deviceRecordsCollection = addDisplayInfoToList(deviceRecordsCollection);
	
	        deviceCollection.devices = deviceRecordsCollection.devices;
	      });
	
	      var combinedDeviceRecordsCollection = { devices: combinedDeviceRecords };
	      data.devices = addDisplayInfoToList(combinedDeviceRecordsCollection).devices;
	
	      var deviceWithContextRecords = _.map(data.devicesWithContext, createRecord);
	      data.devicesWithContext = deviceWithContextRecords;
	
	      var dataCollection = rnRecordCollectionFactory.create(data);
	
	      return dataCollection;
	    })['catch'](function (err) {
	      return $q.reject(err);
	    });
	  }
	
	  function isPrintBeatRealTimeDevice(device) {
	    switch (device.type) {
	      case 'LatexPrinter':
	      case 'TextilePrinter':
	      case 'DesignjetPrinter':
	      case 'PageWideXLPrinter':
	      case 'ScitexPress':
	        return true;
	      case 'IHPSPress':
	        return false;
	      case 'IndigoPress':
	        switch (device.model) {
	          case 'HP Indigo 10000 Digital Press':
	          case 'HP Indigo 12000 Digital Press':
	          case 'HP Indigo 13000 Digital Press':
	          case 'HP Indigo 20000 Digital Press':
	          case 'HP Indigo 30000 Digital Press':
	          case 'HP Indigo 50000 Digital Press':
	          case 'HP Indigo s2000 Digital Press':
	          case 'HP Indigo ws2000 Digital Press':
	          case 'HP Indigo w3200 Digital Press':
	          case 'HP Indigo w3250 Digital Press':
	          case 'hp indigo press 5500':
	          case 'HP Indigo 5600 Digital Press':
	          case 'HP Indigo 5900 Digital Press':
	          case 'HP Indigo WS6000 Digital Press':
	          case 'HP Indigo WS6000p Digital Press':
	          case 'HP Indigo WS6600 Digital Press':
	          case 'HP Indigo WS6600p Digital Press':
	          case 'HP Indigo WS6800 Digital Press':
	          case 'HP Indigo WS6800p Digital Press':
	          case 'HP Indigo WS6900 Digital Press':
	          case 'HP Indigo 6900 Digital Press':
	          case 'HP Indigo 7000 Digital Press':
	          case 'HP Indigo 7500 Digital Press':
	          case 'HP Indigo 7600 Digital Press':
	          case 'HP Indigo 7800 Digital Press':
	          case 'HP Indigo 7900 Digital Press':
	          case 'HP Indigo 7eco Digital Press':
	          case 'HP Indigo Series5 Digital Press':
	          case 'HP Indigo 8000 Digital Press':
	          case 'HP Indigo 5r Digital Press':
	          case 'HP Indigo 6r Digital Press':
	          case 'HP Indigo 7r Digital Press':
	          case 'HP Indigo 10r Digital Press':
	          case 'HP Indigo 10000HD Digital Press':
	          case 'HP Indigo 12000HD Digital Press':
	            // case 'HP Indigo Ayala':
	            // case 'HP Indigo Ayala HD':
	            return true;
	          default:
	            return false;
	        }
	    }
	  }
	
	  function find(params) {
	    var config = {
	      params: params
	    };
	
	    return doGet(AAA_SERVICE_NAME, ORG_DEVICES_PATH, config).then(function (deviceCollection) {
	      var deviceRecords = undefined;
	      var deviceRecordsCollection = undefined;
	
	      deviceRecords = _.map(deviceCollection.devices, createRecord);
	      deviceCollection.devices = deviceRecords;
	      deviceRecordsCollection = rnRecordCollectionFactory.create(deviceCollection);
	
	      deviceRecordsCollection = addDisplayInfoToList(deviceRecordsCollection);
	
	      return deviceRecordsCollection;
	    })['catch'](function (err) {
	      $q.reject(err);
	    });
	  }
	
	  // We would like to obsolete this call (it isn't used in skyline).
	  function getDeviceStats(deviceId) {
	    var path = 'devices/' + deviceId + '/latest';
	
	    return doGet(SYS_STATS_SERVICE_NAME, path);
	  }
	
	  /**
	   * Get a bunch of device items from the given url
	   * We would like to obsolete this call (it isn't used in skyline).
	   * @returns {*}  An array of devices.
	   */
	  function getDevicesForWidgets(offset, limit) {
	    var devices;
	
	    return getDevicesForTable(offset, limit).then(function (data) {
	      devices = _.filter(data.devices, function (entry) {
	        return entry.type !== 'PSPAgent';
	      });
	      angular.forEach(devices, function (device, key) {
	        device.id = device.type; // Why are we setting the id to the type?
	        systemStatisticsService.getDeviceStats(device.id, device);
	      });
	      return devices;
	    });
	  }
	
	  // This used to take the standard data from the server, then replace the type and model fields with their
	  // localized values. But now it is no different than calling getAll.
	  // We would like to obsolete this call (it isn't used in skyline).
	  function getDevicesForTable(offset, limit) {
	    return getAll(offset, limit);
	  }
	
	  // Used to get a new, empty device object from the server.  Not currently implemented by AAA so not used ATM.
	  // We would like to obsolete this call (it isn't used in skyline).
	  function newDevice(url) {
	
	    return doGet(AAA_SERVICE_NAME, url);
	  }
	
	  //
	  // private functions
	  //
	
	  function addDisplayInfoToList(deviceList) {
	    var devicesWithDisplayInfo = {};
	    angular.copy(deviceList, devicesWithDisplayInfo);
	    _.forEach(devicesWithDisplayInfo.devices, function (device) {
	      addDisplayInfo(device);
	    });
	
	    return devicesWithDisplayInfo;
	  }
	
	  function addDisplayInfo(device) {
	    if (device && device.internal) {
	      device.internal.isPBRTSupported = isPrintBeatRealTimeDevice(device);
	      // Display info such as loc keys and image paths
	      var catalogPrefix = 'devices.devices.';
	      device.internal.display = {};
	      var display = device.internal.display;
	
	      device.internal.loc = {};
	      var loc = device.internal.loc;
	
	      if (device.type) {
	        display.typeKey = sanitizeKey(catalogPrefix + device.type);
	        loc.type = $filter('L10N')('devices.devices.' + sanitizeKey(device.type));
	      }
	
	      if (device.model) {
	        display.modelKey = sanitizeKey(catalogPrefix + device.model);
	        display.imagePath = getImagePath(device.model);
	        display.scaledImagePath = getScaledImagePath(device.model);
	        loc.model = $filter('L10N')('devices.devices.' + sanitizeKey(device.model));
	      }
	
	      // Take the standard data from the server and localize them here.
	      // This allows the visible strings to show up as search/filter results when
	      // using an Angular filter.
	      loc.active = device.active ? $filter('L10N')('devices.devices.Device_Active') : $filter('L10N')('devices.devices.Device_Not_Active');
	
	      if (device.parentId !== undefined) {
	        loc.jobSubmission = $filter('L10N')('devices.devices.Device_Use_Parent');
	      } else if (device.jobDestination !== undefined) {
	        loc.jobSubmission = $filter('L10N')('devices.devices.Device_Direct');
	      } else {
	        loc.jobSubmission = $filter('L10N')('devices.devices.Device_Not_Configured');
	      }
	    }
	
	    return device;
	  }
	
	  function getImagePath(model) {
	    var fileKey = sanitizeKey(model);
	    return 'https://cdn.printos.com/images/devices/general/' + $window.encodeURIComponent(fileKey) + '.png';
	  }
	
	  function getScaledImagePath(model) {
	    var fileKey = sanitizeKey(model);
	    return 'https://cdn.printos.com/images/devices/scaled/' + $window.encodeURIComponent(fileKey) + '.png';
	  }
	
	  function createRecord(data) {
	    var device = rnRecordFactory.create(data);
	    // JVM - hack - set id attribute for a consistent model.
	    // This should be changed at the server.
	    device.internal.idName = 'deviceId';
	    return device;
	  }
	
	  // Some of the elements (i.e. model) in the AAA database have spaces in them, which are not suitable as localization
	  // keys. Change the key appropriately.
	  function sanitizeKey(key) {
	    key = key.replace(/ /g, '_');
	    return key;
	  }
	
	  // Massage the data a bit to provide more hints to the UI on when to show or require fields.
	  // This routine takes the data from the server and applies some business logic to it, adding a
	  // couple fields that are useful to the UI.
	  function changeDeviceTypeHashtoList(typeModels) {
	    var catalogPrefix = 'devices.devices.';
	    var deviceTypeList = [];
	    angular.forEach(typeModels, function (models, key) {
	      var deviceType = {};
	      deviceType.name = key;
	      deviceType.nameKey = catalogPrefix + sanitizeKey(key);
	      deviceType.selfProvisionable = isSelfProvisionable(models);
	      deviceType.serialNumRequired = isSerialNumRequired(key);
	      angular.forEach(models, function (model, modelKey) {
	        model.modelNameKey = catalogPrefix + sanitizeKey(model.modelName);
	      });
	      deviceType.models = models;
	      deviceTypeList.push(deviceType);
	    });
	    return deviceTypeList;
	  }
	
	  // If all models of a device type are self-provisionable, indicate that the
	  // entire device type is self-provisionable so we can hide it from the add dialog.
	  // The end user should not be able to manually add a self-provisionable device, and AAA will block it.
	  function isSelfProvisionable(models) {
	    return !_.any(models, 'selfProvisionable', false);
	  }
	
	  function isSerialNumRequired(name) {
	    return _.includes(serialNumberRequiredTypeList, name);
	  }
	
	  function doGet(service, path) {
	    var config = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    path = cleanPath(path);
	
	    return rnHttp.get(service, path, config).then(function (data) {
	      return data.data;
	    })['catch'](function (reason) {
	      return $q.reject(reason);
	    });
	  }
	
	  function doAaaPost(path, content) {
	    path = cleanPath(path);
	    return rnHttp.post(AAA_SERVICE_NAME, path, content);
	  }
	
	  function doAaaPut(path, content) {
	    path = cleanPath(path);
	    return rnHttp.put(AAA_SERVICE_NAME, path, content);
	  }
	
	  function doAaaDeleteWithContent(path, content) {
	    path = cleanPath(path);
	    return rnHttp.deleteWithBody(AAA_SERVICE_NAME, path, content);
	  }
	
	  // DJL - Some HAL implementation for REST responses has already begun on the server. However, SOME of the
	  // link vals are returning absolute URLs. This is necessary until we formally outline (and implement)
	  // our approach to JSON/HAL on both the client and server.
	  // TODO remove when we no longer have to deal with both absolute and relative URLs
	  function cleanPath(path) {
	    // Support v1, v2...versions optimistically through v9 by removing version out of replace and adjusting +2
	    if (path.indexOf('/api/aaa/v') >= 0) {
	      var start = path.indexOf('organizations');
	      var end = path.length + 2;
	      return path.substring(start, end);
	    } else {
	      return path;
	    }
	  }
	}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	'use strict';
	
	rnInstructionsService.$inject = ["$injector", "$q"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnInstructionsService;
	var name = 'rnInstructionsService';
	exports.name = name;
	
	function rnInstructionsService($injector, $q) {
	  'ngInject';
	
	  addLatexInternalId.$inject = ["rnOrganization", "step"];
	  var URL = 'url';
	  var SVG_ICON = 'svg';
	
	  var MODEL_TYPES = {
	    LatexPrinter: {
	      'M0E30A': 'LatexLV',
	      '1QE01A': 'LatexLV',
	      '1QE01B': 'LatexLV',
	      '1QE01C': 'LatexLV',
	      '1QE01D': 'LatexLV',
	      'B4H69A': 'LatexLV',
	      'V7L46A': 'LatexLV',
	      'V7L46B': 'LatexLV',
	      'V7L46C': 'LatexLV',
	      'V7L46D': 'LatexLV',
	      'E2X76A': 'LatexLV',
	      'V7L47A': 'LatexLV',
	      'V7L47B': 'LatexLV',
	      'V7L47C': 'LatexLV',
	      'V7L47D': 'LatexLV',
	      'B4H70A': 'LatexLV',
	      'V8L39A': 'LatexLV',
	      'V8L39B': 'LatexLV',
	      'V8L39C': 'LatexLV',
	      'V8L39D': 'LatexLV',
	      'L4R41A': 'LatexLV',
	      'V8N83A': 'LatexLV',
	      'V8N83B': 'LatexLV',
	      'V8N83C': 'LatexLV',
	      'V8N83D': 'LatexLV',
	      'M0E29A': 'LatexLV',
	      'M0E29B': 'LatexLV',
	      'M0E29C': 'LatexLV',
	      'M0E29D': 'LatexLV',
	      'N2G70A': 'LatexLV',
	      'N2G70B': 'LatexLV',
	      'N2G70C': 'LatexLV',
	      'N2G70D': 'LatexLV',
	      'K4T88A': 'LatexMV',
	      'CZ056A': 'LatexMV',
	      'L2E27A': 'LatexMV',
	      '1HA06A': 'LatexMV',
	      'K4G10A': 'LatexMV',
	      '1HA07A': 'LatexMV',
	      '3DB03A': 'LatexMV',
	      'K0Q45A': 'LatexR',
	      'K0Q46A': 'LatexR',
	      'K0Q47A': 'LatexR',
	      'K0Q48A': 'LatexR',
	      'Y0U22A': 'DesignJet',
	      'Y0U23A': 'DesignJet',
	      'Y0U21A': 'DesignJet',
	      '3XD61A': 'DesignJet'
	    },
	    TextilePrinter: {
	      '2ET72A': 'Textile',
	      '2ET73A': 'Textile',
	      '2ET73B': 'Textile',
	      '4DC17A': 'TextileMV'
	    },
	    DesignjetPrinter: {
	      'T8W15A': 'DesignJet',
	      'T8W15B': 'DesignJet',
	      'T8W16A': 'DesignJet',
	      'T8W18A': 'DesignJet',
	      'T8W18B': 'DesignJet',
	      'W3Z71A': 'DesignJet',
	      'W3Z72A': 'DesignJet',
	      'W3Z71B': 'DesignJet',
	      'X9D24A': 'DesignJet',
	      'X9D24B': 'DesignJet',
	      'T8W15D': 'DesignJet',
	      'T8W16D': 'DesignJet',
	      'W3Z71D': 'DesignJet',
	      '2RM82A': 'DesignJet',
	      '2QU25A': 'DesignJet'
	    },
	    PageWideXLPrinter: {
	      'CZ309A': 'LatexR',
	      'CZ313A': 'LatexR',
	      '4VW19A': 'DesignJet',
	      '4VW20A': 'DesignJet',
	      '4VW21A': 'DesignJet'
	    }
	  };
	
	  var INSTRUCTIONS = {
	
	    // DesignJet
	    DesignJet: {
	      qr: {
	        steps: [{ key: 'devices.devices.DI_DesignJet_QR_Step1' }, { key: 'devices.devices.DI_DesignJet_QR_Step2' }, { key: 'devices.devices.DI_DesignJet_QR_Step3' }, { key: 'devices.devices.DI_DesignJet_QR_Step4' }, { key: 'devices.devices.DI_DesignJet_QR_Step5' }, { key: 'devices.devices.DI_DesignJet_QR_Step6' }, { key: 'devices.devices.DI_DesignJet_QR_Step7' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }]
	      },
	      sc: {
	        steps: [{ key: 'devices.devices.DI_DesignJet_SC_Step1' }, { key: 'devices.devices.DI_DesignJet_SC_Step2' }, { key: 'devices.devices.DI_DesignJet_SC_Step3' }, { key: 'devices.devices.DI_DesignJet_SC_Step4' }, { key: 'devices.devices.DI_DesignJet_SC_Step5' }, { key: 'devices.devices.DI_DesignJet_SC_Step6' }, { key: 'devices.devices.DI_DesignJet_SC_Step7' }, { key: 'devices.devices.DI_DesignJet_SC_Step8' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }]
	      }
	    },
	
	    // Latex 110, 115, 310, 315, 330, 335, 360, 365, 370, 375, 560, 570, 1500, 3000, 3100, 3200, 3500, 3600, 3800
	    LatexLV: {
	      qr: {
	        steps: [{ key: 'devices.devices.DI_LatexLV_QR_Step1' }, { key: 'devices.devices.DI_LatexLV_QR_Step2' }, { key: 'devices.devices.DI_LatexLV_QR_Step3' }, { key: 'devices.devices.DI_LatexLV_QR_Step4' }, { key: 'devices.devices.DI_LatexLV_QR_Step5' }, { key: 'devices.devices.DI_LatexLV_QR_Step6' }, { key: 'devices.devices.DI_LatexLV_QR_Step7' }],
	        notes: ['devices.devices.DI_DataAccuracyNote'],
	        postActivation: {
	          notes: [{
	            key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }, {
	            key: 'devices.devices.DI_DataAccuracyNote',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }]
	        }
	      },
	      sc: {
	        steps: [{ key: 'devices.devices.DI_LatexLV_SC_Step1' }, { key: 'devices.devices.DI_LatexLV_SC_Step2' }, { key: 'devices.devices.DI_LatexLV_SC_Step3' }, { key: 'devices.devices.DI_LatexLV_SC_Step4' }, { key: 'devices.devices.DI_LatexLV_SC_Step5' }, { key: 'devices.devices.DI_LatexLV_SC_Step6' }],
	        notes: ['devices.devices.DI_DataAccuracyNote'],
	        postActivation: {
	          notes: [{
	            key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }, {
	            key: 'devices.devices.DI_DataAccuracyNote',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }]
	        }
	      },
	      sn: {
	        postActivation: {
	          titles: ['devices.devices.DI_LatexLV_SN_PA_Title1', 'devices.devices.DI_LatexLV_SN_PA_Title2'],
	          steps: [{ key: 'devices.devices.DI_LatexLV_SN_PA_Step1' }, { key: 'devices.devices.DI_LatexLV_SN_PA_Step2' }, { key: 'devices.devices.DI_LatexLV_SN_PA_Step3' }, { key: 'devices.devices.DI_LatexLV_SN_PA_Step4' }, { key: 'devices.devices.DI_LatexLV_SN_PA_Step5' }, { key: 'devices.devices.DI_LatexLV_SN_PA_Step6',
	            subSteps: [{ key: 'devices.devices.DI_LatexLV_SN_PA_Step6a' }, {
	              key: 'devices.devices.DI_LatexLV_SN_PA_Step6b',
	              resolve: { addLatexInternalId: addLatexInternalId }
	            }]
	          }, { key: 'devices.devices.DI_LatexLV_SN_PA_Step7' }, { key: 'devices.devices.DI_LatexLV_SN_PA_Step8' }],
	          notes: [{
	            key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }, {
	            key: 'devices.devices.DI_DataAccuracyNote',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }]
	        }
	      }
	    },
	    LatexMV: {
	      qr: {
	        steps: [{ key: 'devices.devices.DI_LatexMV_QR_Step1' }, { key: 'devices.devices.DI_LatexMV_QR_Step2' }, { key: 'devices.devices.DI_LatexMV_QR_Step3' }, { key: 'devices.devices.DI_LatexMV_QR_Step4' }, { key: 'devices.devices.DI_LatexMV_QR_Step5' }, { key: 'devices.devices.DI_LatexMV_QR_Step6' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }]
	      },
	      sc: {
	        steps: [{ key: 'devices.devices.DI_LatexMV_SC_Step1' }, { key: 'devices.devices.DI_LatexMV_SC_Step2' }, { key: 'devices.devices.DI_LatexMV_SC_Step3' }, { key: 'devices.devices.DI_LatexMV_SC_Step4' }, {
	          key: 'devices.devices.DI_LatexMV_SC_Step5',
	          subSteps: [{
	            key: 'devices.devices.DI_LatexMV_SC_Step5a',
	            type: URL
	          }]
	        }, { key: 'devices.devices.DI_LatexMV_SC_Step6' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }]
	      },
	      sn: {
	        postActivation: {
	          titles: ['devices.devices.DI_LatexMV_SN_PA_Title1', 'devices.devices.DI_LatexMV_SN_PA_Title2'],
	          steps: [{ key: 'devices.devices.DI_LatexMV_SN_PA_Step1' }, { key: 'devices.devices.DI_LatexMV_SN_PA_Step2' }, { key: 'devices.devices.DI_LatexMV_SN_PA_Step3' }, { key: 'devices.devices.DI_LatexMV_SN_PA_Step4' }, { key: 'devices.devices.DI_LatexMV_SN_PA_Step5' }, {
	            key: 'devices.devices.DI_LatexMV_SN_PA_Step6',
	            subSteps: [{ key: 'devices.devices.DI_LatexMV_SN_PA_Step6a' }, {
	              key: 'devices.devices.DI_LatexMV_SN_PA_Step6b',
	              resolve: { addLatexInternalId: addLatexInternalId }
	            }]
	          }, { key: 'devices.devices.DI_LatexMV_SN_PA_Step7' }, { key: 'devices.devices.DI_LatexMV_SN_PA_Step8' }],
	          notes: [{ key: 'devices.devices.DI_LatexMV_SN_PA_Note1' }, { key: 'devices.devices.DI_DataAccuracyNote' }]
	        }
	      }
	    },
	    LatexR: {
	      qr: {
	        steps: [{ key: 'devices.devices.DI_LatexR_QR_Step1' }, {
	          key: 'devices.devices.DI_LatexR_QR_Step2',
	          icon: {
	            type: SVG_ICON,
	            path: 'https://cdn.printos.com/images/general/material/settings.svg'
	          }
	        }, { key: 'devices.devices.DI_LatexR_QR_Step3' }, { key: 'devices.devices.DI_LatexR_QR_Step4' }, { key: 'devices.devices.DI_LatexR_QR_Step5' }, { key: 'devices.devices.DI_LatexR_QR_Step6' }, { key: 'devices.devices.DI_LatexR_QR_Step7' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }]
	      },
	      sc: {
	        steps: [{
	          key: 'devices.devices.DI_LatexR_SC_Step1'
	
	        }, {
	          key: 'devices.devices.DI_LatexR_SC_Step2',
	          icon: {
	            type: SVG_ICON,
	            path: 'https://cdn.printos.com/images/general/material/settings.svg'
	          }
	        }, { key: 'devices.devices.DI_LatexR_SC_Step3' }, { key: 'devices.devices.DI_LatexR_SC_Step4' }, { key: 'devices.devices.DI_LatexR_SC_Step5' }, { key: 'devices.devices.DI_LatexR_SC_Step6' }, { key: 'devices.devices.DI_LatexR_SC_Step7' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }]
	      }
	    },
	    Textile: {
	      qr: {
	        steps: [{ key: 'devices.devices.DI_Textile_QR_Step1' }, { key: 'devices.devices.DI_Textile_QR_Step2' }, { key: 'devices.devices.DI_Textile_QR_Step3' }, { key: 'devices.devices.DI_Textile_QR_Step4' }, { key: 'devices.devices.DI_Textile_QR_Step5' }, { key: 'devices.devices.DI_Textile_QR_Step6' }, { key: 'devices.devices.DI_Textile_QR_Step7' }, { key: 'devices.devices.DI_Textile_QR_Step8' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }],
	        postActivation: {
	          notes: [{
	            key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }, {
	            key: 'devices.devices.DI_DataAccuracyNote',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }]
	        }
	      },
	      sc: {
	        steps: [{ key: 'devices.devices.DI_Textile_SC_Step1' }, {
	          key: 'devices.devices.DI_Textile_SC_Step2',
	          icon: {
	            type: SVG_ICON,
	            path: 'https://cdn.printos.com/images/general/material/settings.svg'
	          }
	        }, { key: 'devices.devices.DI_Textile_SC_Step3' }, { key: 'devices.devices.DI_Textile_SC_Step4' }, { key: 'devices.devices.DI_Textile_SC_Step5' }, { key: 'devices.devices.DI_Textile_SC_Step6' }, { key: 'devices.devices.DI_Textile_SC_Step7' }, { key: 'devices.devices.DI_Textile_SC_Step8' }, { key: 'devices.devices.DI_Textile_SC_Step9' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }],
	        postActivation: {
	          notes: [{
	            key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }, {
	            key: 'devices.devices.DI_DataAccuracyNote',
	            icon: {
	              type: SVG_ICON,
	              path: 'https://cdn.printos.com/images/general/light_bulb_color.svg'
	            }
	          }]
	        }
	      }
	    },
	    TextileMV: {
	      qr: {
	        steps: [{ key: 'devices.devices.DI_LatexMV_QR_Step1' }, { key: 'devices.devices.DI_LatexMV_QR_Step2' }, { key: 'devices.devices.DI_LatexMV_QR_Step3' }, { key: 'devices.devices.DI_LatexMV_QR_Step4' }, { key: 'devices.devices.DI_LatexMV_QR_Step5' }, { key: 'devices.devices.DI_LatexMV_QR_Step6' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }]
	      },
	      sc: {
	        steps: [{ key: 'devices.devices.DI_LatexMV_SC_Step1' }, { key: 'devices.devices.DI_LatexMV_SC_Step2' }, { key: 'devices.devices.DI_LatexMV_SC_Step3' }, { key: 'devices.devices.DI_LatexMV_SC_Step4' }, {
	          key: 'devices.devices.DI_LatexMV_SC_Step5',
	          subSteps: [{
	            key: 'devices.devices.DI_LatexMV_SC_Step5a',
	            type: URL
	          }]
	        }, { key: 'devices.devices.DI_LatexMV_SC_Step6' }],
	        notes: [{ key: 'devices.devices.DI_DataAccuracyNote' }]
	      }
	    }
	  };
	
	  var service = {
	    getInstructions: getInstructions,
	    hasPostActivationInstructions: hasPostActivationInstructions,
	    getPostInstructions: getPostInstructions,
	    getInstallMethods: getInstallMethods
	  };
	  return service;
	
	  function getInstallMethods(type, model) {
	    var methods = {
	      qr: false,
	      sc: false,
	      sn: true
	    };
	
	    if (!_.get(MODEL_TYPES, type + '.' + model)) {
	      return methods;
	    }
	
	    var instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
	    if (instructions) {
	      methods = {
	        qr: instructions.qr !== undefined,
	        sc: instructions.sc !== undefined,
	        sn: instructions.sn !== undefined
	      };
	    }
	
	    return methods;
	  }
	
	  function hasPostActivationInstructions(type, model, method) {
	    if (!_.get(MODEL_TYPES, type + '.' + model)) {
	      return false;
	    }
	
	    var instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
	    if (!instructions) {
	      return false;
	    }
	
	    if (!instructions[method]) {
	      return false;
	    }
	
	    if (!instructions[method].postActivation) {
	      return false;
	    }
	
	    return true;
	  }
	
	  function getInstructions(type, model) {
	    if (!(type && model)) {
	      return undefined;
	    }
	
	    var instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
	    var promises = [];
	    Object.keys(instructions).forEach(function (method) {
	      if (instructions[method].steps) {
	        promises = promises.concat(doResolve(instructions[method].steps));
	      }
	
	      var postActivationSteps = _.get(instructions[method], 'postActivation.steps');
	      if (postActivationSteps) {
	        promises = promises.concat(doResolve(postActivationSteps));
	      }
	    });
	
	    return $q.all(promises).then(function () {
	      return instructions;
	    });
	  }
	
	  function getPostInstructions(type, model, method) {
	    if (!(type && model && method)) {
	      return undefined;
	    }
	
	    return getInstructions(type, model).then(function (instructions) {
	      if (instructions && instructions[method] && instructions[method].postActivation) {
	        return instructions[method].postActivation;
	      } else {
	        return undefined;
	      }
	    });
	  }
	
	  function doResolve(steps) {
	    var promises = [];
	    steps.forEach(function (step) {
	      if (step.resolve) {
	        Object.keys(step.resolve).forEach(function (r) {
	          var promise = $injector.invoke(step.resolve[r], null, { step: step });
	          promises.push(promise);
	        });
	      }
	
	      if (step.subSteps) {
	        promises = promises.concat(doResolve(step.subSteps, $injector));
	      }
	    });
	
	    return promises;
	  }
	
	  // Helpers (will be invoked with $injector)
	  function addLatexInternalId(rnOrganization, step) {
	    'ngInject';
	
	    return rnOrganization.getOrganization(false).then(function (resp) {
	      var org = resp.data;
	      if (!org.internalIds) {
	        org.internalIds = [];
	      }
	
	      var latexInternalId = org.internalIds.find(function (id) {
	        return id.gbu === 'Latex';
	      });
	      if (latexInternalId) {
	        step.values = [latexInternalId.gbuInternalId];
	      }
	    });
	  }
	}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	'use strict';
	
	systemStatisticsService.$inject = ["rnHttp", "$q", "$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = systemStatisticsService;
	var name = 'systemStatisticsService';
	exports.name = name;
	
	function systemStatisticsService(rnHttp, $q, $log) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var SYSTEM_STATISTICS_SERVICE_NAME = 'system_statistics';
	
	  var service = {
	    getAllDeviceStats: getAllDeviceStats,
	    getDeviceStats: getDeviceStats,
	    processExtendedInformation: processExtendedInformation
	  };
	
	  return service;
	
	  ////////////////
	
	  // The caller should pass in the existing device data, and we will overlay it with the
	  // latest stats using extend and return a promise to the updated data.
	  function getAllDeviceStats(deviceData) {
	    var deviceIds = _.pluck(deviceData, 'deviceId');
	    var deviceIdChunks = [];
	    while (deviceIds.length > 0) {
	      deviceIdChunks.push(deviceIds.splice(0, 75));
	    }
	
	    var promises = [];
	    deviceIdChunks.forEach(function (deviceIdChunk) {
	      var config = {
	        version: 2,
	        params: {
	          device: deviceIdChunk
	        }
	      };
	
	      var promise = rnHttp.get(SYSTEM_STATISTICS_SERVICE_NAME, 'devices/latest', config).then(function (response) {
	        var data = response.data;
	        data.deviceStatistics.forEach(function (value) {
	          var device = _.find(deviceData, { deviceId: value.deviceId });
	          if (device) {
	            processExtendedInformation(device.type, value);
	            angular.extend(device, value);
	          }
	        });
	
	        return deviceData;
	      })['catch'](function (response) {
	        return $q.reject(_.get(response, 'data.smsError', response));
	      });
	      promises.push(promise);
	    });
	
	    return $q.all(promises).then(function (deviceDataArrays) {
	      return _.flatten(deviceDataArrays);
	    })['catch'](function (err) {
	      return $q.reject(err);
	    });
	  }
	
	  function getDeviceStats(deviceId, deviceData) {
	    var deferred = $q.defer();
	    rnHttp.get(SYSTEM_STATISTICS_SERVICE_NAME, 'devices/' + deviceId + '/latest', { version: 2 }).then(function (response) {
	      var data = response.data;
	      var device = _.find(deviceData, { deviceId: data.deviceId });
	      if (device) {
	        processExtendedInformation(device.type, data);
	        angular.extend(device, data);
	      }
	
	      deferred.resolve(deviceData);
	    })['catch'](function (response) {
	      deferred.reject(_.get(response, 'data.smsError', response));
	    });
	
	    return deferred.promise;
	  }
	
	  /**
	   * If there is any extended information in the stats record, process it into a form that's easier to deal with
	   * in the markup.
	   */
	  function processExtendedInformation(deviceType, device) {
	    if (device) {
	      if (!device.data) {
	        device.data = {};
	      }
	      var deviceData = device.data;
	
	      deviceData.exists = {
	        primaryInks: false,
	        intermediateInks: false,
	        loadedSubstrates: false,
	        printingJobs: false,
	        queuedJobs: false,
	        jobHistory: false,
	        maintenance: false,
	        notifications: false,
	        jobFiltersBrief: false,
	        jobFiltersVerbose: false,
	        lastUpdate: false,
	        colorControl: false
	      };
	
	      deviceData.inks = null;
	      deviceData.substrates = null;
	      deviceData.jobs = null;
	      deviceData.maintenance = null;
	      deviceData.notifications = null;
	      deviceData.jobFilters = null;
	      deviceData.miscInfo = {};
	      deviceData.colorControl = null;
	
	      if (deviceData) {
	        try {
	          // Fixup the deviceData to make sure it is in the correct buckets (generalData, inkData, substrateData, jobData), even if it was posted with a v1 API
	          fixupDeviceData(deviceType, deviceData);
	
	          // Set lastUpdate to the timestamp of when the record was updated or created. It may be overwritten later from extended information
	          if (device.updatedTime) {
	            deviceData.exists.lastUpdate = true;
	            deviceData.lastUpdate = device.updatedTime;
	          } else if (device.createdTime) {
	            deviceData.exists.lastUpdate = true;
	            deviceData.lastUpdate = device.createdTime;
	          }
	
	          // Perform device specific parsing of the incoming data into a common format that the UI will understand regardless of what device it is
	          switch (deviceType) {
	            case "DesignjetPrinter":
	            case "LatexPrinter":
	            case "TextilePrinter":
	            case "PageWideXLPrinter":
	              processLFData(deviceData);
	              break;
	            case "ThreeDPrinter":
	            case "ThreeDController":
	              process3DData(deviceData);
	              break;
	            case "ProductionCenter":
	              processProductionCenterData(deviceData);
	              break;
	            case "RIP":
	              processColorControlData(deviceData);
	              break;
	            default:
	              break;
	          }
	        } catch (e) {
	          $log.debug("Error parsing extended info: " + e);
	        }
	      }
	    }
	  }
	
	  function fixupDeviceData(deviceType, deviceData) {
	    // Account for devices that posted their data with the v1 API where everything was in extendedInformation (and then renamed to generalData).
	    // Make them look as if they posted with v2 where there are different buckets (generalData, inkData, substrateData, jobData)
	    switch (deviceType) {
	      case "DesignjetPrinter":
	      case "LatexPrinter":
	      case "TextilePrinter":
	      case "PageWideXLPrinter":
	        if (deviceData.generalData && deviceData.generalData.printer_data && deviceData.generalData.printer_data.data) {
	          var data = deviceData.generalData.printer_data.data;
	          // Ink
	          if (data.ink_info) {
	            if (!deviceData.inkData) {
	              deviceData.inkData = {};
	            }
	            deviceData.inkData.ink_info = data.ink_info;
	            delete data.ink_info;
	          }
	          if (data.intermediate_tanks) {
	            if (!deviceData.inkData) {
	              deviceData.inkData = {};
	            }
	            deviceData.inkData.intermediate_tanks = data.intermediate_tanks;
	            delete data.intermediate_tanks;
	          }
	
	          // Substrate
	          if (data.substrates) {
	            if (!deviceData.substrateData) {
	              deviceData.substrateData = {};
	            }
	            deviceData.substrateData.substrates = data.substrates;
	            delete data.substrates;
	          }
	
	          // Job
	          if (data.job) {
	            if (!deviceData.jobData) {
	              deviceData.jobData = {};
	            }
	            deviceData.jobData.job = data.job;
	            delete data.job;
	          }
	        }
	        break;
	      case "ProductionCenter":
	        // Move the PC job filters out of generalData and into jobData
	        if (deviceData.generalData && deviceData.generalData.job) {
	          if (!deviceData.jobData) {
	            deviceData.jobData = {};
	            deviceData.jobData.job = deviceData.generalData.job;
	            delete deviceData.generalData.job;
	          }
	        }
	        break;
	      case "RIP":
	        // Everything can remain in generalData
	        break;
	      default:
	        break;
	    }
	  }
	
	  function processLFData(deviceData) {
	    try {
	      if (deviceData.inkData) {
	        var data = deviceData.inkData;
	
	        // Inks
	        if (data.ink_info && data.ink_info.length > 0) {
	          if (!deviceData.inks) {
	            deviceData.inks = {};
	          }
	          deviceData.inks.primaryInkLevels = [];
	          // Look for known ink values and put them in the preferred order.
	          var labels = ["M", "LM", "LC", "C", "OP", "Y", "CR", "CG", "CB", "G", "K", "MK", "PK", "W", "OC", "E"];
	          for (var i = 0; i < labels.length; i++) {
	            for (var y = 0; y < data.ink_info.length; y++) {
	              var consumable = data.ink_info[y].consumable_label_code;
	              if (consumable && consumable === labels[i]) {
	                var percentFull = 0;
	                var currentLevel = parseFloat(data.ink_info[y].Level);
	                var maxCapacity = parseFloat(data.ink_info[y].max_capacity);
	                if (currentLevel > 0 && maxCapacity > 0) {
	                  if (currentLevel > maxCapacity) {
	                    currentLevel = 0;
	                    data.ink_info[y].status_id = 'error';
	                  } else {
	                    percentFull = Math.round(currentLevel / maxCapacity * 100);
	                  }
	                }
	                var level = {
	                  id: "ink_" + i,
	                  label: labels[i],
	                  productName: data.ink_info[y].product_name,
	                  productNumber: data.ink_info[y].product_number,
	                  level: currentLevel,
	                  statusId: data.ink_info[y].status_id,
	                  value: percentFull.toString(),
	                  height: percentFull.toString() + "%",
	                  pad: 100 - percentFull + "%",
	                  statusKey: "devices.devices.Latex_Cartridge_State_" + data.ink_info[y].status_id,
	                  measuredQuantityState: data.ink_info[y].measured_quantity_state,
	                  expirationDate: data.ink_info[y].expiration_date
	                };
	                deviceData.inks.primaryInkLevels.push(level);
	                break;
	              }
	            }
	          }
	          deviceData.exists.primaryInks = true;
	        }
	
	        // Intermediate inks
	        if (data.intermediate_tanks && data.intermediate_tanks.length > 0) {
	          if (!deviceData.inks) {
	            deviceData.inks = {};
	          }
	          deviceData.inks.intermediateInkLevels = [];
	          // Look for known ink values and put them in the preferred order.
	          var labels = ["M", "LM", "LC", "C", "OP", "Y", "K", "W"];
	          for (var i = 0; i < labels.length; i++) {
	            for (var y = 0; y < data.intermediate_tanks.length; y++) {
	              var consumable = data.intermediate_tanks[y].consumable_label_code;
	              if (consumable && consumable === labels[i]) {
	                var percentFull = 0;
	                if (data.intermediate_tanks[y].Level > 0 && data.intermediate_tanks[y].max_capacity > 0) {
	                  percentFull = Math.round(data.intermediate_tanks[y].Level / data.intermediate_tanks[y].max_capacity * 100);
	                }
	                var level = {
	                  id: "ink_" + i,
	                  label: labels[i],
	                  productName: data.intermediate_tanks[y].product_name,
	                  productNumber: data.intermediate_tanks[y].product_number,
	                  level: data.intermediate_tanks[y].Level,
	                  statusId: data.intermediate_tanks[y].status_id,
	                  value: percentFull.toString(),
	                  height: percentFull.toString() + "%",
	                  pad: 100 - percentFull + "%",
	                  statusKey: "devices.devices.Latex_Cartridge_State_" + data.ink_info[y].status_id,
	                  measuredQuantityState: data.intermediate_tanks[y].measured_quantity_state,
	                  expirationDate: data.intermediate_tanks[y].expiration_date
	                };
	                deviceData.inks.intermediateInkLevels.push(level);
	                break;
	              }
	            }
	          }
	          deviceData.exists.intermediateInks = true;
	        }
	      }
	
	      if (deviceData.substrateData) {
	        var data = deviceData.substrateData;
	
	        // Substrate
	        if (data.substrates && data.substrates.length > 0) {
	          if (!deviceData.substrates) {
	            deviceData.substrates = {};
	          }
	          deviceData.substrates.loadedSubstrates = [];
	          for (var i = 0; i < data.substrates.length; i++) {
	            var widthmm = data.substrates[i].media_width * 1000; // Convert to mm
	            var mediaWidth = Math.round(widthmm * 100) / 100; // Rounded, 2 decimal places
	
	            // media_counter will eventually be deprecated and replaced with remaining_length or substrate_counter. Only one should exist
	            var remainingLength = null;
	            var substrateCounter = null;
	            var mediaCounter = null;
	            if (data.substrates[i].remaining_length && data.substrates[i].remaining_length !== "Unknown") {
	              remainingLength = data.substrates[i].remaining_length; // Leave in meters
	              remainingLength = Math.round(remainingLength * 100) / 100; // Rounded, 2 decimal places
	            } else if (data.substrates[i].substrate_counter && data.substrates[i].substrate_counter !== "Unknown") {
	                substrateCounter = data.substrates[i].substrate_counter; // Leave in meters
	                substrateCounter = Math.round(substrateCounter * 100) / 100; // Rounded, 2 decimal places
	              } else if (data.substrates[i].media_counter && data.substrates[i].media_counter.value !== undefined && data.substrates[i].media_counter.value !== "Unknown") {
	                  mediaCounter = data.substrates[i].media_counter.value; // Leave in meters
	                  mediaCounter = Math.round(mediaCounter * 100) / 100; // Rounded, 2 decimal places
	                }
	
	            var substrate = {
	              mediaName: data.substrates[i].media_name,
	              mediaFormat: data.substrates[i].media_format,
	              mediaWidth: mediaWidth,
	              trayState: data.substrates[i].tray_state,
	              measuredQuantity: data.substrates[i].measured_quantity,
	              mediaCounter: mediaCounter,
	              remainingLength: remainingLength,
	              substrateCounter: substrateCounter
	            };
	            if (substrate.mediaName != null) {
	              deviceData.substrates.loadedSubstrates.push(substrate);
	            }
	          }
	          if (deviceData.substrates.loadedSubstrates.length > 0) {
	            deviceData.exists.loadedSubstrates = true; // Only indicate that it exists if we have a name for it. We have seen that if media is "out" all of the fields will be null
	          }
	        }
	      }
	
	      if (deviceData.jobData) {
	        var data = deviceData.jobData;
	
	        // Printing Jobs
	        if (data.job && data.job.printing_jobs) {
	          if (!deviceData.jobs) {
	            deviceData.jobs = {};
	          }
	          deviceData.jobs.printingJobs = [];
	          data.job.printing_jobs.forEach(function (item) {
	            var jobState = "unknown";
	            if (item.job_state) {
	              // The job_state will be translated
	              jobState = item.job_state.toLowerCase().replace(/[^A-Z0-9]/ig, "");
	            }
	            item.jobStateKey = "devices.devices.Latex_Job_Status_" + jobState;
	            deviceData.jobs.printingJobs.push(item);
	            deviceData.exists.printingJobs = true;
	          });
	        }
	
	        // Queued Jobs
	        if (data.job && data.job.future) {
	          if (!deviceData.jobs) {
	            deviceData.jobs = {};
	          }
	          deviceData.jobs.queuedJobs = [];
	          data.job.future.forEach(function (item) {
	            var jobState = "unknown";
	            if (item.job_state) {
	              // The job_state will be translated
	              jobState = item.job_state.toLowerCase().replace(/[^A-Z0-9]/ig, "");
	            }
	            item.jobStateKey = "devices.devices.Latex_Job_Status_" + jobState;
	            deviceData.jobs.queuedJobs.push(item);
	            deviceData.exists.queuedJobs = true;
	          });
	        }
	
	        // Job History
	        if (data.job && data.job.history) {
	          if (!deviceData.jobs) {
	            deviceData.jobs = {};
	          }
	          deviceData.jobs.jobHistory = [];
	          data.job.history.forEach(function (item) {
	            var jobState = "unknown";
	            if (item.end_state) {
	              // The end_state will be translated
	              jobState = item.end_state.toLowerCase().replace(/[^A-Z0-9]/ig, "");
	            }
	            item.jobStateKey = "devices.devices.Latex_Job_Status_" + jobState;
	            deviceData.jobs.jobHistory.push(item);
	            deviceData.exists.jobHistory = true;
	          });
	        }
	      }
	
	      if (deviceData.generalData && deviceData.generalData.printer_data && deviceData.generalData.printer_data.data) {
	        var data = deviceData.generalData.printer_data.data;
	
	        // Maintenance
	        if (data.monocassette_info) {
	          deviceData.maintenance = {
	            productNumber: data.monocassette_info.product_number,
	            maxCapacity: data.monocassette_info.max_capacity,
	            level: data.monocassette_info.level,
	            consumableState: data.monocassette_info.consumable_state
	          };
	          deviceData.exists.maintenance = true;
	        }
	
	        // Notifications
	        if (data.notifications !== undefined) {
	          data.notifications.list.forEach(function (item) {
	            if (item.severity) {
	              item.severityKey = "devices.devices.Device_Notifications_" + item.severity.toLowerCase();
	            }
	          });
	          deviceData.notifications = {
	            list: data.notifications.list
	          };
	          deviceData.exists.notifications = true;
	
	          // Device Specific Detailed Status
	          if (data.notifications.front_panel_message) {
	            // This will be shown 'as is' without localization on the details page
	            deviceData.miscInfo.deviceSpecificDetailedStatusMsg = data.notifications.front_panel_message;
	            deviceData.exists.deviceSpecificDetailedStatusMsg = true;
	          }
	        }
	
	        // Device Specific Status Key
	        if (data.printer_info && data.printer_info.status) {
	          // This will be used to lookup the basic device status instead of the generic status string
	          deviceData.miscInfo.deviceSpecificStatusKey = "devices.devices.Latex_Status_" + data.printer_info.status.toLowerCase();
	          deviceData.exists.deviceSpecificStatusKey = true;
	        }
	
	        // Device specific product name (model string)
	        if (data.printer_info && data.printer_info.printer_model !== undefined) {
	          deviceData.miscInfo.deviceSpecificProductName = data.printer_info.printer_model;
	          deviceData.exists.deviceSpecificProductName = true;
	        }
	
	        // Firmware Version
	        if (data.printer_info && data.printer_info.printer_firmware_version !== undefined) {
	          deviceData.miscInfo.firmwareVersion = data.printer_info.printer_firmware_version;
	          deviceData.exists.firmwareVersion = true;
	        }
	
	        // Last Update
	        if (data.printer_info && data.printer_info.last_update_at) {
	          // Set to the value received from the device
	          deviceData.lastUpdate = data.printer_info.last_update_at;
	          deviceData.exists.lastUpdate = true;
	        }
	      }
	    } catch (e) {
	      $log.debug("Error processing large format info: " + e);
	    }
	  }
	
	  function process3DData(deviceData) {
	    try {
	      if (deviceData.generalData && deviceData.generalData.printer_data && deviceData.generalData.printer_data.data) {
	        var data = deviceData.generalData.printer_data.data;
	
	        // Notifications
	        if (data.notifications !== undefined) {
	          data.notifications.list.forEach(function (item) {
	            if (item.severity) {
	              item.severityKey = "devices.devices.Device_Notifications_" + item.severity.toLowerCase();
	            }
	          });
	          deviceData.notifications = {
	            list: data.notifications.list
	          };
	          deviceData.exists.notifications = true;
	        }
	
	        // Firmware Version
	        if (data.printer_info && data.printer_info.printer_firmware_version !== undefined) {
	          deviceData.miscInfo.firmwareVersion = data.printer_info.printer_firmware_version;
	          deviceData.exists.firmwareVersion = true;
	        }
	      }
	    } catch (e) {
	      $log.debug("Error processing 3D info: " + e);
	    }
	  }
	
	  function processProductionCenterData(deviceData) {
	    try {
	      if (deviceData.jobData) {
	        if (deviceData.jobData.job && deviceData.jobData.job.filters) {
	          if (!deviceData.jobFilters) {
	            deviceData.jobFilters = {};
	          }
	          // Job Filters
	          // The way the filters should be displayed is that the title should be displayed 'as is' if it’s non-null, else use the id as the loc key.
	          // The id comes to us like "ACTIVE_JOBS" so we need to prepend the devices.devices.PC_Filter_ to it so we can look it up in our catalog.
	          if (deviceData.jobData.job.filters.brief) {
	            deviceData.jobFilters.jobFiltersBrief = [];
	            deviceData.jobData.job.filters.brief.forEach(function (item) {
	              var filter = {
	                id: item.id ? item.id : null,
	                titleKey: item.id ? "devices.devices.PC_Filter_" + item.id : null,
	                title: item.title ? item.title : null,
	                count: item.count
	              };
	              deviceData.jobFilters.jobFiltersBrief.push(filter);
	              deviceData.exists.jobFiltersBrief = true;
	            });
	          }
	
	          if (deviceData.jobData.job.filters.verbose) {
	            deviceData.jobFilters.jobFiltersVerbose = [];
	            deviceData.jobData.job.filters.verbose.forEach(function (item) {
	              var filter = {
	                id: item.id ? item.id : null,
	                titleKey: item.id ? "devices.devices.PC_Filter_" + item.id : null,
	                title: item.title ? item.title : null,
	                count: item.count
	              };
	              deviceData.jobFilters.jobFiltersVerbose.push(filter);
	              deviceData.exists.jobFiltersVerbose = true;
	            });
	          }
	        }
	      }
	    } catch (e) {
	      $log.debug("Error processing production center info: " + e);
	    }
	  }
	
	  function processColorControlData(deviceData) {
	    try {
	      deviceData.colorControl = {};
	      if (deviceData.colorControl.lastScan) {
	        deviceData.generalData.lastScan = deviceData.generalData.lastScan;
	      }
	      if (deviceData.generalData.press) {
	        deviceData.colorControl.press = deviceData.generalData.press;
	      }
	      if (deviceData.generalData.target) {
	        deviceData.colorControl.target = deviceData.generalData.target;
	      }
	      if (deviceData.generalData.substrates) {
	        deviceData.colorControl.substrates = deviceData.generalData.substrates;
	      }
	      if (deviceData.generalData.jobName) {
	        deviceData.colorControl.jobName = deviceData.generalData.jobName;
	      }
	      if (deviceData.generalData.result) {
	        deviceData.colorControl.result = deviceData.generalData.result;
	      }
	      if (deviceData.generalData.color) {
	        switch (deviceData.generalData.color) {
	          case 'G':
	            deviceData.colorControl.color = '#509137'; // Matches the $hp-status-green
	            break;
	          case 'Y':
	            deviceData.colorControl.color = '#F0AA3C'; // Matches the $hp-status-yellow
	            break;
	          case 'R':
	            deviceData.colorControl.color = '#F04B37'; // Matches the $hp-status-red
	            break;
	          default:
	            deviceData.colorControl.color = '#509137'; // Matches the $hp-status-green
	            break;
	        }
	      }
	      if (deviceData.generalData.fileType) {
	        deviceData.colorControl.fileType = deviceData.generalData.fileType;
	      }
	      if (deviceData.generalData.custom1) {
	        deviceData.colorControl.custom1 = deviceData.generalData.custom1;
	      }
	      if (deviceData.generalData.custom2) {
	        deviceData.colorControl.custom2 = deviceData.generalData.custom2;
	      }
	      if (deviceData.generalData.custom3) {
	        deviceData.colorControl.custom3 = deviceData.generalData.custom3;
	      }
	    } catch (e) {
	      $log.debug("Error processing color control info: " + e);
	    }
	  }
	}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';
	
	rnFeature.$inject = ["rnClient"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnFeature;
	var name = 'rnFeature';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.feature.service:rnFeature
	 *
	 * @description Rhino Feature service, provides methods to get feature settings
	 */
	
	function rnFeature(rnClient) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var service = {
	    getOrganizationFeatures: getOrganizationFeatures,
	    getFeatures: getFeatures
	  };
	
	  return service;
	
	  ////////////////
	
	  /**
	   * @ngdoc function
	   * @name getOrganizationFeatures
	   * @methodOf rhino.components.feature.service:rnFeature
	   * @description Gets the features that are enabled for the organization as an array of objects (for backwards compatibility)
	   * @returns {Promise.<Array<Object>>} enabled features as an array of feature objects with a "name" property
	   */
	  function getOrganizationFeatures() {
	    return getFeatures().then(function (features) {
	      return features.map(function (name) {
	        return { name: name };
	      });
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name getFeatures
	   * @methodOf rhino.components.feature.service:rnFeature
	   * @description Provides the enabled features in an array
	   * @returns {Promise.<Array<String>>} enabled feature names as an array of strings
	   */
	  function getFeatures() {
	    return rnClient.getConfig().then(function (clientConfig) {
	      return clientConfig.features;
	    });
	  }
	}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	'use strict';
	
	rnInvitation.$inject = ["$q", "$log", "rnHttp", "rnRecordFactory", "rnRecordCollectionFactory"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnInvitation;
	var name = 'rnInvitation';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.invitation.service:rnInvitation
	 * @description Service for managing invitations
	 */
	
	function rnInvitation($q, $log, rnHttp, rnRecordFactory, rnRecordCollectionFactory) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var EMAIL_SERVICE_NAME = 'email_service';
	  var INVITATIONS_PATH = 'invitations/';
	
	  var service = {
	    getById: getById,
	    getAll: getAll,
	    find: find,
	    sendInvitation: sendInvitation,
	    acceptInvitation: acceptInvitation,
	    acceptEmailInvitation: acceptEmailInvitation,
	    getNewInvitation: getNewInvitation,
	    getUserOrganizations: getUserOrganizations,
	    acceptInvitationWithExistingUser: acceptInvitationWithExistingUser,
	    resendInvitation: resendInvitation,
	    revokeInvitation: revokeInvitation
	  };
	
	  return service;
	
	  ////////////////
	
	  function generate() {
	    // TODO DJL - This method requests the model structure from the server. We need server-side implementation to support this
	  }
	
	  function getById(id) {
	    var deferred = $q.defer();
	    rnHttp.get(EMAIL_SERVICE_NAME, 'invitations/' + id).success(function (data) {
	      var invitation = rnRecordFactory.create(data);
	      deferred.resolve(invitation);
	    }).error(function (reason) {
	      deferred.reject(reason);
	    });
	    return deferred.promise;
	  }
	
	  function getAll(offset, limit, type) {
	    return find({ offset: offset, limit: limit, type: type });
	  }
	
	  function find(params) {
	    var deferred = $q.defer();
	    var config = {};
	    config.params = params;
	
	    rnHttp.get(EMAIL_SERVICE_NAME, INVITATIONS_PATH, config).success(function (invitationCollection) {
	      var invitationRecords;
	      var invitationRecordsCollection;
	
	      invitationRecords = _.map(invitationCollection.invitations, rnRecordFactory.create);
	      invitationCollection.invitations = invitationRecords;
	      invitationRecordsCollection = rnRecordCollectionFactory.create(invitationCollection);
	
	      deferred.resolve(invitationRecordsCollection);
	    }).error(function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc function
	   * @name sendInvitation
	   * @methodOf rhino.components.invitation.service:rnInvitation
	   * @description Sends an invitation to a specified url
	   */
	  function sendInvitation(invitation, url) {
	
	    return doEmailServicePost(url, invitation);
	  }
	
	  /**
	   * @ngdoc function
	   * @name acceptInvitation
	   * @methodOf rhino.components.invitation.service:rnInvitation
	   * @description Accept an invitation
	   */
	  function acceptInvitation(acceptance, url) {
	    var modifiedPath = correctHalLink(url);
	    var config = {
	      rhino: {
	        allow401: true
	      }
	    };
	
	    return rnHttp.post(EMAIL_SERVICE_NAME, modifiedPath, acceptance, config).then(function (response) {
	      return response.data;
	    })['catch'](function (response) {
	      return $q.reject(response.data);
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name acceptEmailInvitation
	   * @methodOf rhino.components.invitation.service:rnInvitation
	   * @description Accept an email change invitation
	   */
	  function acceptEmailInvitation(url) {
	    return acceptInvitation({}, url);
	  }
	
	  /**
	   * @ngdoc function
	   * @name acceptInvitationWithExistingUser
	   * @methodOf rhino.components.invitation.service:rnInvitation
	   * @description Accept an invitation with an existing user, either for a new or existing org.
	   * @param {string} url HAL link url
	   * @param {string} op HTTP method (from HAL op)
	   * @param {object|undefined} org new org to accept invitation with or undefined if an existing org
	   * @returns {Promise} a promise
	   */
	  function acceptInvitationWithExistingUser(url, op, org) {
	    var modifiedPath = correctHalLink(url);
	    var deferred = $q.defer();
	    var config = {
	      method: op,
	      data: org
	    };
	
	    rnHttp.request(EMAIL_SERVICE_NAME, modifiedPath, config).success(function (data) {
	      deferred.resolve(data);
	      $log.debug('Successful ' + modifiedPath + ' request: ', data);
	    }).error(function (reason) {
	      deferred.reject(reason);
	      $log.debug('Failed ' + modifiedPath + ' request: ', reason);
	    });
	
	    return deferred.promise;
	  }
	
	  function getNewInvitation(url) {
	
	    return doEmailServiceGet(url);
	  }
	
	  function getUserOrganizations(url, type) {
	    var link = {
	      href: url,
	      op: 'GET'
	    };
	
	    var params = {};
	    if (type) {
	      params.type = type;
	    }
	    return rnHttp.halRequest(link, null, { params: params }).then(function (resp) {
	      return resp.data;
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name resendInvitation
	   * @methodOf rhino.components.invitation.service:rnInvitation
	   * @description Resends an invitation using the provided resend link.
	   * If the invitation doesn't have a resend link, this method returns a rejected promise.
	   *
	   * @param {object} invitation to resend
	   * @returns {IPromise<invitation|string|response} a promise with the resent invitation, or a string or response on error
	   */
	  function resendInvitation(invitation) {
	    var resendLink = _.get(invitation, '_links.resend');
	    if (!resendLink) {
	      var err = 'Cannot resend invitation missing resend link';
	      $log.warn(err, resendLink);
	      return $q.reject(err);
	    }
	
	    // Remove UI internals not supported by the server.
	    delete invitation.internal;
	
	    var path = correctHalLink(resendLink.href);
	    return rnHttp.request(EMAIL_SERVICE_NAME, path, {
	      method: resendLink.op,
	      data: invitation
	    }).then(function (response) {
	      return response.data;
	    });
	  }
	
	  function revokeInvitation(invitation) {
	    var revokeLink = _.get(invitation, '_links.revoke');
	    if (!revokeLink) {
	      var err = 'Cannot resend invitation missing revoke link';
	      $log.warn(err, revokeLink);
	      return $q.reject(err);
	    }
	
	    var path = correctHalLink(revokeLink.href);
	    return rnHttp.request(EMAIL_SERVICE_NAME, path, {
	      method: revokeLink.op
	    }).then(function (response) {
	      return response.data;
	    });
	  }
	
	  function doEmailServiceGet(path, config) {
	    var modifiedPath = correctHalLink(path);
	    var deferred = $q.defer();
	
	    rnHttp.get(EMAIL_SERVICE_NAME, modifiedPath, config).success(function (data) {
	      deferred.resolve(data);
	      $log.debug('Successful ' + modifiedPath + ' request: ', data);
	    }).error(function (reason) {
	      deferred.reject(reason);
	      $log.debug('Failed ' + modifiedPath + ' request: ' + reason);
	    });
	
	    return deferred.promise;
	  }
	
	  function doEmailServicePost(path, content) {
	    var modifiedPath = correctHalLink(path);
	    var deferred = $q.defer();
	
	    rnHttp.post(EMAIL_SERVICE_NAME, modifiedPath, content).success(function (data) {
	      deferred.resolve(data);
	      $log.debug('Successful ' + modifiedPath + ' request: ', data);
	    }).error(function (reason) {
	      deferred.reject(reason);
	      $log.debug('Failed ' + modifiedPath + ' request: ' + reason);
	    });
	
	    return deferred.promise;
	  }
	
	  function correctHalLink(path) {
	    // DJL - Some HAL implementation for REST responses has already begun on the server. However, the
	    // link vals are returning absolute URLs. This is necessary until we formally outline (and implement)
	    // our approach to JSON/HAL on both the client and server.
	    var start = path.indexOf('invitations');
	    var end = path.length;
	    return path.substring(start, end);
	  }
	}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _languageServiceJs = __webpack_require__(427);
	
	var rnLanguage = _interopRequireWildcard(_languageServiceJs);
	
	exports['default'] = angular.module('rhino.components.language', ['ngCookies']).service(rnLanguage.name, rnLanguage['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	'use strict';
	
	rnLanguage.$inject = ["$http", "$log", "$q", "$window", "$cookies"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnLanguage;
	var name = 'rnLanguage';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.language.service:rnLanguage
	 * @description This service provides the client application with the ability to query the server for the list of available
	 * language packs for a given user (browser) side language.
	 * @deprecated Use rnLocale instead (focusing on locales instead of languages)
	 */
	
	function rnLanguage($http, $log, $q, $window, $cookies) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var defaultLanguage = { value: "en", name: "English" };
	  var languageListServiceUrlResource = '/api/portal/v1/i18n/listlanguages/';
	  var self = this;
	
	  var service = {
	    getServiceLanguages: getServiceLanguages,
	    getBestFitLanguageForUser: getBestFitLanguageForUser,
	    setLanguageCookie: setLanguageCookie,
	    getBrowserLanguage: getBrowserLanguage,
	    defaultLanguage: defaultLanguage,
	    getLanguageServiceUrl: getLanguageServiceUrl,
	    getCurrentLanguage: getCurrentLanguage
	  };
	
	  return service;
	
	  /////////////////////
	  // Private functions
	  ////////////////////
	
	  /**
	   * @ngdoc function
	   * @name getLanguageServiceUrl
	   * @methodOf rhino.components.language.service:rnLanguage
	   * @description Generate the correct service URL for the given applicationName and browserLanguage
	   * @param {string} applicationName - the name of the desired application
	   * @param {string} browserLanguage - the language of the browser
	   * @returns {string} the correctly formatted service url
	   */
	  function getLanguageServiceUrl(applicationName, browserLanguage) {
	    return languageListServiceUrlResource + applicationName + '/' + browserLanguage;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getServiceLanguages
	   * @methodOf rhino.components.language.service:rnLanguage
	   * @description Query the server for the list of available languages for the given applicationName.  Note that different
	   * applications may have different languages available
	   * @param {string} applicationName - the name of the application that you want to get the list of available languages for
	   * @returns {*} a promise which, when resolved will be an array of language name objects
	   */
	  function getServiceLanguages(applicationName) {
	    var deferred = $q.defer();
	    var url = getLanguageServiceUrl(applicationName, getBrowserLanguage());
	    $http.get(url).then(function (resp) {
	      deferred.resolve({
	        success: true,
	        result: resp.data
	      });
	    })['catch'](function () {
	      //availableLanguages = [defaultLanguage];
	      deferred.reject({
	        success: false,
	        result: "Failed to get Service languages"
	      });
	    });
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getBrowserLanguage
	   * @methodOf rhino.components.language.service:rnLanguage
	   * @description Get the w3c language code from the browser.  This represents the language that the borwser is currently configured
	   * to use
	   * @returns {string|*} the language code
	   */
	  function getBrowserLanguage() {
	    var lang = $window.navigator.language || $window.navigator.browserLanguage || $window.navigator.userLanguage;
	    if (lang === undefined) {
	      lang = $window.navigator.languages ? $window.navigator.languages[0] : null;
	    }
	    return lang;
	  }
	
	  /**
	   * @ngdoc function
	   * @name setLanguageCookie
	   * @methodOf rhino.components.language.service:rnLanguage
	   * @description Set a cookie for the given user indicating their selected langauge
	   * @param {object} signinData - the user session info that is required to generate a cookie
	   * @param {string} userSelectedLanguage - the name of the user selected language
	   */
	  function setLanguageCookie(signinData, userSelectedLanguage) {
	    //if(selectedLanguage.value != vm.signinData.language.value) {
	    //The user has changed their desired language on the login form, so write a cookie containing the desired language
	    // MD is adding a $$mdSelectId to the language object - pick out only the elements we want in the cookie.
	    $cookies.putObject('userSelectedLanguage', _.pick(signinData.language, 'value', 'name'), { path: '/' });
	    $log.debug("Saved user selected language in cookie: " + $cookies.getObject(userSelectedLanguage));
	    //}
	  }
	
	  /**
	   * @ngdoc function
	   * @name getBestFitLanguageForUser
	   * @methodOf rhino.components.language.service:rnLanguage
	   * @description Given the list of available languages and the current language mode of the browser, try to select the best fit
	   * language for the user.  Language fit will attempt to start out as specific as possible and will become more
	   * generic until a suitable match is found
	   * @param {array[]} availableLanguages an array of the available languages as provided by the server for the application
	   * @returns {value: string, name: string} the best fit language
	   */
	  function getBestFitLanguageForUser(availableLanguages) {
	    var lang = defaultLanguage;
	    //first, see if the user has previously selected a language
	    if ($cookies.get('userSelectedLanguage') !== undefined) {
	      $log.debug('Attempt to parse $cookies.userSelectedLanguage');
	      lang = $cookies.getObject('userSelectedLanguage');
	      $log.debug('Result is: ', lang);
	    }
	    //second, try to get the browsers language
	    else {
	        lang = getBrowserLanguage();
	        //now try to match a language object from the service...
	        //try an exact match first..
	        var match = false;
	        for (var i = 0; i < availableLanguages.length; i++) {
	          if (lang === availableLanguages[i].value) {
	            lang = availableLanguages[i];
	            match = true;
	            break;
	          }
	        }
	        //failing an exact match, try a highest level language match... (i.e. the first part... en-us would match en)
	        if (match === false) {
	          for (i = 0; i < availableLanguages.length; i++) {
	            if (lang.indexOf(availableLanguages[i].value) === 0) {
	              lang = availableLanguages[i];
	              match = true;
	              break;
	            }
	          }
	        }
	        //worst case, we could not match anything
	        if (match === false) {
	          lang = defaultLanguage;
	        }
	      }
	    return lang;
	  }
	
	  function getCurrentLanguage() {
	    //first, see if the user has previously selected a language
	    if ($cookies.get('userSelectedLanguage') !== undefined) {
	      return $cookies.getObject('userSelectedLanguage');
	    }
	  }
	}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var name = 'rnLocalStorage';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.local-storage.service:rnLocalStorage
	 * @description
	 * Provides a simple facade over localStorage, allowing it to be easily
	 * injected and testable.  Also simplifies storing and retrieving objects
	 * instead of just strings.
	 *
	 * @example
	 * ```js
	 * rnLocalStorage.getString('marco'); // returns null
	 * rnLocalStorage.setString('marco', 'polo');
	 * rnLocalStorage.getString('marco'); // returns 'polo'
	 *
	 * rnLocalStorage.clear();
	 * rnLocalStorage.getString('marco'); // returns null again
	 *
	 * rnLocalStorage.getObject('preferences'); // returns null
	 * rnLocalStorage.setObject('preferences', {lang: 'en'});
	 * rnLocalStorage.getObject('preferences'); // returns {lang: 'en'}
	 *
	 * rnLocalStorage.setString('notAnObject', 'notAnObject');
	 * rnLocalStorage.getObject('notAnObject'); // throws JSON parse error
	 * ```
	 */
	
	exports['default'] = ["$window", function ($window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var localStorage = $window.localStorage;
	
	  var service = {
	    getString: getString,
	    setString: setString,
	    getObject: getObject,
	    setObject: setObject,
	    removeItem: removeItem,
	    clear: clear
	  };
	  return service;
	
	  ////////////////
	
	  /**
	   * @ngdoc function
	   * @name getString
	   * @methodOf rhino.components.local-storage.service:rnLocalStorage
	   * @param {string} key to get
	   * @returns {string} value `null` if not found
	   */
	  function getString(key) {
	    return localStorage.getItem(key);
	  }
	
	  /**
	   * @ngdoc function
	   * @name setString
	   * @methodOf rhino.components.local-storage.service:rnLocalStorage
	   * @param {string} key to set
	   * @param {string} str value to set
	   */
	  function setString(key, str) {
	    localStorage.setItem(key, str);
	  }
	
	  /**
	   * @ngdoc function
	   * @name getObject
	   * @methodOf rhino.components.local-storage.service:rnLocalStorage
	   * @param {string} key to get
	   * @returns {object} value `null` if not found
	   */
	  function getObject(key) {
	    var item = getString(key);
	    if (item === null) {
	      return null;
	    }
	    return JSON.parse(item);
	  }
	
	  /**
	   * @ngdoc function
	   * @name setObject
	   * @methodOf rhino.components.local-storage.service:rnLocalStorage
	   * @param {string} key to set
	   * @param {object} value to set
	   */
	  function setObject(key, obj) {
	    setString(key, JSON.stringify(obj));
	  }
	
	  /**
	   * @ngdoc function
	   * @name removeItem
	   * @methodOf rhino.components.local-storage.service:rnLocalStorage
	   */
	  function removeItem(key) {
	    localStorage.removeItem(key);
	  }
	
	  /**
	   * @ngdoc function
	   * @name clear
	   * @methodOf rhino.components.local-storage.service:rnLocalStorage
	   */
	  function clear() {
	    localStorage.clear();
	  }
	}];

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	rnAbbr.$inject = ["rnFormat"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnAbbr;
	var name = 'rnAbbr';
	
	exports.name = name;
	
	function rnAbbr(rnFormat) {
	  'ngInject';
	
	  return rnFormat.abbr;
	}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';
	
	rnFormat.$inject = ["rnLocaleCookie", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnFormat;
	var name = 'rnFormat';
	
	exports.name = name;
	var ROUNDING = {
	  floor: 'floor',
	  ceil: 'ceil',
	  round: 'round'
	};
	
	exports.ROUNDING = ROUNDING;
	/**
	 * @ngdoc service
	 * @name rhino.components.locale.format.service:rnFormat
	 * @description Provides for formatting strings according to the user's preferred locale
	 */
	
	function rnFormat(rnLocaleCookie, $window) {
	  'ngInject';
	
	  var SI_SUFFIX = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
	  var localeCompareOptions = { numeric: true };
	  var locale = rnLocaleCookie.getLocale();
	  var service = {
	    toLocaleString: toLocaleString,
	    localeOrderBy: localeOrderBy,
	    abbr: abbr
	  };
	  return service;
	
	  ///////////////
	
	  /**
	   * @ngdoc function
	   * @name toLocaleString
	   * @methodOf rhino.components.locale.format.service:rnFormat
	   * @description Formats a number according to the current locale preference
	   *
	   * @returns {string} number formatted in the preferred locale
	   */
	  function toLocaleString(num, fractionSize) {
	    if (num === undefined) {
	      return '';
	    }
	    if (fractionSize < 0) {
	      fractionSize = 0;
	    }
	
	    return (+num).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: fractionSize });
	  }
	
	  /**
	   * @ngdoc function
	   * @name localeOrderBy
	   * @methodOf rhino.components.locale.format.service:rnFormat
	   * @description Uses `String.localeCompare` to order strings so that accented characters
	   * are sorted correctly. Adapted from http://www.janholinka.net/Blog/Article/8
	   *
	   * @returns {string[]} the sorted array
	   */
	  function localeOrderBy(array, sortPredicate, reverseOrder) {
	    if (!Array.isArray(array)) {
	      return array;
	    }
	    if (!sortPredicate) {
	      return array;
	    }
	
	    var arrayCopy = _.clone(array);
	
	    arrayCopy.sort(function (a, b) {
	      var valueA = a[sortPredicate];
	      var valueB = b[sortPredicate];
	
	      if (_.isString(valueA)) {
	        return !reverseOrder ? valueA.localeCompare(valueB, undefined, localeCompareOptions) : valueB.localeCompare(valueA, undefined, localeCompareOptions);
	      }
	
	      if (_.isNumber(valueA) || _.isBoolean(valueA)) {
	        return !reverseOrder ? valueA - valueB : valueB - valueA;
	      }
	
	      return 0;
	    });
	
	    return arrayCopy;
	  }
	
	  function abbr(num) {
	    var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    if ($window.Number.isNaN($window.Number.parseFloat(num))) {
	      return num;
	    }
	
	    var options = Object.assign({
	      fractionSize: 2
	    }, opts);
	
	    var result = num;
	    var thousandsPower = 0;
	    while (result > 1000) {
	      result = result / 1000;
	      thousandsPower++;
	    }
	
	    var suffix = SI_SUFFIX[thousandsPower];
	    if (!suffix) {
	      suffix = '';
	      result = num;
	    }
	
	    return (+result).toLocaleString(locale, opts) + suffix;
	  }
	}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	'use strict';
	
	rnLocaleFormat.$inject = ["rnFormat"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnLocaleFormat;
	var name = 'rnLocaleFormat';
	
	exports.name = name;
	
	function rnLocaleFormat(rnFormat) {
	  'ngInject';
	
	  return rnFormat.toLocaleString;
	}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	'use strict';
	
	rnLocaleOrderBy.$inject = ["rnFormat"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnLocaleOrderBy;
	var name = 'rnLocaleOrderBy';
	
	exports.name = name;
	
	function rnLocaleOrderBy(rnFormat) {
	  'ngInject';
	
	  return rnFormat.localeOrderBy;
	}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnLocaleCookieProvider;
	
	var _preferencesPreferencesService = __webpack_require__(46);
	
	var LOCALE_COOKIE_NAME = 'pos.rn.locale';
	
	exports.LOCALE_COOKIE_NAME = LOCALE_COOKIE_NAME;
	var name = 'rnLocaleCookie';
	exports.name = name;
	
	function rnLocaleCookieProvider() {
	  'ngInject';
	
	  rnLocaleCookie.$inject = ["$cookies", "$rootScope"];
	  this.getLocale = getLocale;
	  this.getTimeZone = getTimeZone;
	  this.$get = rnLocaleCookie;
	
	  activateProvider();
	  return;
	
	  function activateProvider() {
	    checkLocaleQueryParam();
	  }
	
	  function getCookiesService() {
	    return angular.injector(['ngCookies']).get('$cookies');
	  }
	
	  function getWindowService() {
	    return angular.injector(['ng']).get('$window');
	  }
	
	  function setLocale(locale) {
	    var cookie = getLocaleCookie() || {};
	    cookie.locale = locale;
	    var $cookies = getCookiesService();
	    $cookies.putObject(LOCALE_COOKIE_NAME, cookie, getCookieOptions());
	  }
	
	  function getLocaleCookie() {
	    var $cookies = getCookiesService();
	    return $cookies.getObject(LOCALE_COOKIE_NAME);
	  }
	
	  function getLocale() {
	    return _.get(getLocaleCookie(), 'locale');
	  }
	
	  function getTimeZone() {
	    return _.get(getLocaleCookie(), 'tz');
	  }
	
	  function checkLocaleQueryParam() {
	    var locale = undefined;
	    var hashSplit = window.location.href.split('#');
	    if (hashSplit.length > 1) {
	      // First see if there is a locale param on the root url
	      locale = getLocaleFromString(hashSplit[0]);
	      if (!locale) {
	        locale = getLocaleFromString(hashSplit[1], true);
	      }
	    } else {
	      locale = getLocaleFromString(hashSplit[0]);
	    }
	
	    if (locale) {
	      var localeParts = locale.split('-');
	      if (localeParts.length === 2) {
	        localeParts[0] = localeParts[0].toLowerCase();
	        localeParts[1] = localeParts[1].toUpperCase();
	        locale = localeParts[0] + '-' + localeParts[1];
	      }
	
	      setLocale(locale);
	    }
	  }
	
	  function getLocaleFromString(searchString) {
	    var rebuildURL = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    var locale = undefined;
	    var queryParamsBuildUp = '';
	
	    var paramCount = 0;
	    var qSplit = searchString.split('?');
	    if (qSplit.length > 1) {
	      var querySegment = qSplit[1];
	      var params = querySegment.split('&');
	      paramCount = params.length;
	      for (var i = 0; i < params.length; i++) {
	        var param = params[i].split('=');
	        var key = param[0];
	        var value = param[1];
	        if (key === 'locale') {
	          locale = value;
	        } else {
	          if (i === 0) {
	            queryParamsBuildUp += params[i];
	          } else {
	            queryParamsBuildUp += '&' + params[i];
	          }
	        }
	      }
	    }
	
	    if (locale && rebuildURL) {
	      var hashSplit = window.location.href.split('#');
	      var _qSplit = hashSplit[1].split('?');
	      if (paramCount === 1) {
	        window.location.href = hashSplit[0] + '#' + _qSplit[0];
	      } else {
	        window.location.href = hashSplit[0] + '#' + _qSplit[0] + '?' + queryParamsBuildUp;
	      }
	    }
	
	    return locale;
	  }
	
	  function getCookieOptions() {
	    var cookieOptions = {
	      path: '/'
	    };
	    var host = getWindowService().location.hostname;
	    if (host.indexOf('.') >= 0) {
	      // Browsers won't accept domains that aren't qualified (such as localhost)
	      // See http://stackoverflow.com/questions/1134290/cookies-on-localhost-with-explicit-domain
	      cookieOptions.domain = host;
	    }
	    return cookieOptions;
	  }
	
	  /** @ngInject */
	  function rnLocaleCookie($cookies, $rootScope) {
	    var service = {
	      // publish provider methods on service as well
	      getLocale: getLocale,
	      getTimeZone: getTimeZone
	    };
	    activate();
	    return service;
	
	    function activate() {
	      $rootScope.$on(_preferencesPreferencesService.EVENT_PREFERENCES_UPDATED, function (event, prefs) {
	        setLocaleCookie(prefs);
	      });
	    }
	
	    function setLocaleCookie(preferences) {
	      var prefsCookie = {};
	      var locale = _.get(preferences, 'general.locale');
	      if (locale) {
	        prefsCookie.locale = locale;
	      }
	      var timeZone = _.get(preferences, 'general.timeZone');
	      if (timeZone) {
	        prefsCookie.tz = timeZone;
	      }
	
	      if (!_.isEmpty(prefsCookie)) {
	        $cookies.putObject(LOCALE_COOKIE_NAME, prefsCookie, getCookieOptions());
	      } else {
	        $cookies.remove(LOCALE_COOKIE_NAME);
	      }
	    }
	  }
	}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	'use strict';
	
	rnLocale.$inject = ["$log", "$q", "$window", "$location", "rnPreferences", "rnLocaleCookie", "rnClient"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnLocale;
	var RUSSIAN_FEATURE_NAME = 'russian-locale';
	
	exports.RUSSIAN_FEATURE_NAME = RUSSIAN_FEATURE_NAME;
	var name = 'rnLocale';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.locale.service:rnLocale
	 * @description This service provides the client application with the ability to query the server for the list of available
	 * locales for a given user (browser) side language.
	 */
	
	function rnLocale($log, $q, $window, $location, rnPreferences, rnLocaleCookie, rnClient) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	  var defaultLocale = {
	    id: '1',
	    value: 'en-US',
	    shortName: 'en',
	    language: 'English (US)',
	    appId: 'general'
	  };
	
	  var PRINTOS_DOC_LOCALES = {
	    'en-EN': 'EN',
	    'de-DE': 'DE',
	    'en-GB': 'EN',
	    'en-US': 'EN',
	    'es-ES': 'ES',
	    'fr-FR': 'FR',
	    'it-IT': 'IT',
	    'ja-JP': 'JP',
	    'ko-KO': 'KO',
	    'pt-PT': 'PT',
	    'ru-RU': 'RU',
	    'zh-HANS': 'ZHCN'
	  };
	
	  /**
	   * This is the externally facing API of the service
	   */
	  var service = {
	    allLocaleOptions: allLocaleOptions,
	    localeOptions: localeOptions,
	    browserLocale: browserLocale,
	    setLocalePreference: setLocalePreference,
	    getLocalePreference: getLocalePreference,
	    findBestLocale: findBestLocale,
	    getBestFit: getBestFit,
	    getBestFitForBrowser: getBestFitForBrowser,
	    getUrlWithCurrentLocale: getUrlWithCurrentLocale,
	    defaultLocale: defaultLocale,
	    getBcp47Locale: getBcp47Locale
	  };
	  return service;
	
	  /////////////////////
	  // Private functions
	  ////////////////////
	
	  /**
	   * @ngdoc function
	   * @name allLocaleOptions
	   * @methodOf rhino.components.locale.service:rnLocale
	   * @description Returns a full list of unfiltered locale options. Typically, `localeOptions()`
	   * is the correct method to call because it filters out locales based on features.
	   * However, in some cases, the full list of locales is necessary (for instance, when accepting
	   * an invitation).
	   *
	   * @returns {*} a promise which, when resolved will be an array of locale objects
	   */
	  function allLocaleOptions() {
	    return rnClient.getConfig().then(function (clientConfig) {
	      return _.get(clientConfig, 'preferences.options.locales');
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name localeOptions
	   * @methodOf rhino.components.locale.service:rnLocale
	   * @description Query the server for the list of available locales, falling back to
	   * the default locale on error and filtering out any locales the user/org doesn't have access to.
	   *
	   * @returns {*} a promise which, when resolved will be an array of locale objects
	   */
	  function localeOptions() {
	    return rnClient.getConfig().then(function (clientConfig) {
	      var locales = _.get(clientConfig, 'preferences.options.locales');
	      var features = clientConfig.features || [];
	      var cookieLocale = rnLocaleCookie.getLocale();
	      locales = _.filter(locales, function (locale) {
	        if (!locale.features) {
	          return true;
	        }
	        // Include a locale if it's in the cookie. This allows for showing a locale at sign-in
	        // that the user previously had access to.
	        if (locale.value === cookieLocale) {
	          return true;
	        }
	        return _.intersection(locale.features, features).length > 0;
	      });
	      return locales;
	    })['catch'](function () {
	      return [defaultLocale];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name browserLocale
	   * @methodOf rhino.components.locale.service:rnLocale
	   * @description Get the w3c language code from the browser.  This represents the language that the borwser is currently configured
	   * to use
	   * @returns {string|*} the language code
	   */
	  function browserLocale() {
	    var lang = $window.navigator.language || $window.navigator.browserLanguage || $window.navigator.userLanguage;
	    if (lang === undefined) {
	      lang = $window.navigator.languages ? $window.navigator.languages[0] : null;
	    }
	    return lang;
	  }
	
	  /**
	   * @ngdoc function
	   * @name findBestLocale
	   * @methodOf rhino.components.locale.service:rnLocale
	   * @description Given the list of available locales and a language code, try to select the best fit
	   * locale.  Language fit will attempt to start out as specific as possible and will become more
	   * generic until a suitable match is found
	   * @param {object|Array} availableLocales an array of the available locales as provided by the server for the application
	   * @param {String} lang code
	   * @returns {value: string, name: string} the best fit language
	   */
	  function findBestLocale() {
	    var availableLocales = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	    var lang = arguments.length <= 1 || arguments[1] === undefined ? undefined : arguments[1];
	
	    //now try to match a language object from the service...
	    //try an exact match first..
	    $log.debug('Match browser locale. available:', availableLocales);
	
	    if (lang) {
	      var _ret = (function () {
	        var exactLocale = availableLocales.find(function (locale) {
	          return locale.value === lang;
	        });
	        if (exactLocale) {
	          return {
	            v: exactLocale
	          };
	        }
	
	        //failing an exact match, try a highest level language match... (i.e. the first part... en-us would match en)
	        var langShortName = getShortName(lang).toLowerCase();
	        var langLocale = availableLocales.find(function (locale) {
	          return getShortName(locale.value).toLowerCase() === langShortName;
	        });
	        if (langLocale) {
	          return {
	            v: langLocale
	          };
	        }
	      })();
	
	      if (typeof _ret === 'object') return _ret.v;
	    }
	
	    // Default China domain to Chinese (Simplified)
	    if ($location.host().endsWith('.cn')) {
	      var chinese = availableLocales.find(function (locale) {
	        return locale.value === 'zh-HANS';
	      });
	      if (chinese) {
	        return chinese;
	      }
	    }
	
	    //worst case, we could not match anything
	    return defaultLocale;
	  }
	
	  /**
	   * @ngdoc function
	   * @name getBestFit
	   * @methodOf rhino.components.locale.service:rnLocale
	   * @description  Returns the best fit locale for the user using the following heuristic,
	   *   1. Use the user's locale preference, if available.
	   *   2. If a browser cookie is set indicating the locale (in case the user isn't signed in), it will be used.
	   *   3. Get a list of available locales from the server.
	   *      Attempt to find the best fit locale based on the browser.
	   *   4. Fallback to the default locale.
	   *
	   * @returns {IPromise<string>|Promise.<string>} promise of the locale value with a shortName for convenience
	   */
	  function getBestFit() {
	    return getLocalePreference().then(function (locale) {
	      if (locale) {
	        return withShortName(locale);
	      }
	
	      return getBestFitForBrowser();
	    });
	  }
	
	  function getLocalePreference() {
	    return allLocaleOptions().then(function (locales) {
	      var locale = undefined;
	      var cookieLocale = rnLocaleCookie.getLocale();
	      if (cookieLocale) {
	        locale = _.find(locales, 'value', cookieLocale);
	        return locale;
	      }
	
	      return rnPreferences.getAll().then(function (prefs) {
	        var prefLocale = _.get(prefs, 'general.locale');
	        if (prefLocale) {
	          locale = _.find(locales, 'value', prefLocale);
	          return locale;
	        }
	      });
	    });
	  }
	
	  function setLocalePreference(locale) {
	    var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    return getLocalePreference().then(function (prefLocale) {
	      if (force || !prefLocale || !_.get(prefLocale, 'features') || locale.value === _.get(prefLocale, 'value')) {
	        // Only set the preference if the current preference isn't associated with a feature.
	        // This keeps sign-in from overwriting a preference that was only available after sign-in.
	        return rnPreferences.setSingle('general', 'locale', locale.value);
	      }
	      return rnPreferences.getAll();
	    });
	  }
	
	  function withShortName(locale) {
	    locale.shortName = getShortName(locale.value);
	    return locale;
	  }
	
	  function getShortName(value) {
	    return value.split('-')[0];
	  }
	
	  function getUrlWithCurrentLocale(base, extension) {
	    var currentLocale = rnLocaleCookie.getLocale() || 'en-US';
	    return base + PRINTOS_DOC_LOCALES[currentLocale] + extension;
	  }
	
	  function getBestFitForBrowser() {
	    return localeOptions().then(function (localeOptions) {
	      var bestLocale = findBestLocale(localeOptions, browserLocale());
	      return withShortName(bestLocale);
	    });
	  }
	
	  // BCP47 is a standard locale with lang-REGION
	  function getBcp47Locale() {
	    return getBestFit().then(function (locale) {
	      var value = locale.value;
	      if (value === 'zh-HANS') {
	        value = 'zh-CN';
	      }
	      return value;
	    });
	  }
	}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _notificationService = __webpack_require__(436);
	
	var rnNotificationService = _interopRequireWildcard(_notificationService);
	
	exports['default'] = angular.module('rhino.components.notification', [_rhinoSrcCoreCoreModule2['default']]).service(rnNotificationService.name, rnNotificationService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	'use strict';
	
	rnNotificationService.$inject = ["$q", "$log", "$filter", "rnRegistry", "rnHttp", "rnRecordFactory"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnNotificationService;
	var name = 'rnNotificationService';
	exports.name = name;
	
	function rnNotificationService($q, $log, $filter, rnRegistry, rnHttp, rnRecordFactory) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	  var NOTIFICATION_SERVICE = 'notification_service';
	  var PORTAL_SERVICE = 'sms_portal';
	
	  var service = {
	    getNotifications: getNotifications,
	    getSubscription: getSubscription,
	    getSubscriptions: getSubscriptions,
	    getApplications: getApplications,
	    acknowledgeNotification: acknowledgeNotification,
	    getEventDescriptionsByApplication: getEventDescriptionsByApplication,
	    removeSubscription: removeSubscription,
	    addSubscription: addSubscription,
	    createNotificationRecord: createNotificationRecord,
	    acknowledgeAllNotifications: acknowledgeAllNotifications,
	    loadMoreNotifications: loadMoreNotifications,
	    updateFilter: updateFilter,
	    notificationHalRequest: notificationHalRequest
	  };
	
	  return service;
	
	  ////////////////
	
	  function getNotifications() {
	    var offset = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	    var limit = arguments.length <= 1 || arguments[1] === undefined ? 50 : arguments[1];
	
	    var config = {
	      params: {
	        offset: offset,
	        limit: limit
	      }
	    };
	    return rnHttp.get(NOTIFICATION_SERVICE, '', config).then(function (_ref) {
	      var notificationData = _ref.data;
	
	      var notificationEventRecords = _.map(notificationData.notificationEvents, createNotificationEventRecord);
	      notificationData.notificationEvents = notificationEventRecords;
	      return notificationData;
	    });
	  }
	
	  function getSubscriptions(link) {
	    var deferred = $q.defer();
	    var config = {};
	    notificationHalRequest(link).then(function (resp) {
	      var subscriptionCollection = resp.data;
	      var subscriptionRecords = _.map(subscriptionCollection.userSubscriptionList, createSubscriptionRecord);
	      subscriptionCollection.userSubscriptionList = subscriptionRecords;
	      deferred.resolve(subscriptionCollection);
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function getSubscription(link) {
	    var deferred = $q.defer();
	    var config = {};
	    notificationHalRequest(link).then(function (resp) {
	      deferred.resolve(createSubscriptionRecord(resp.data));
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function loadMoreNotifications(link) {
	    var deferred = $q.defer();
	    var config = {};
	    notificationHalRequest(link).then(function (resp) {
	      var notificationEvent = resp.data;
	      var notificationEventRecord = createNotificationEventRecord(notificationEvent);
	      deferred.resolve(notificationEventRecord);
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function createRecord(data) {
	    var record = rnRecordFactory.create(data);
	    record.setRelativeService(PORTAL_SERVICE);
	    return record;
	  }
	
	  function createNotificationEventRecord(data) {
	    var event = createRecord(data);
	    var notificationRecords = _.map(event.notificationEventList, createNotificationRecord);
	    event.notificationEventList = notificationRecords;
	    return event;
	  }
	
	  function createNotificationRecord(data) {
	    var notification = createRecord(data);
	    //notification.internal.idName = 'eventId';
	    return notification;
	  }
	
	  function createSubscriptionRecord(data) {
	    var subscription = createRecord(data);
	    subscription.internal.idName = 'userSubscriptionId';
	    var deliveryRecords = _.map(subscription.deliveryMethods, createDeliveryMethodRecord);
	    subscription.deliveryMethods = deliveryRecords;
	    return subscription;
	  }
	
	  function createDeliveryMethodRecord(data) {
	    var deliveryMethod = createRecord(data);
	    deliveryMethod.internal.idName = 'name';
	    return deliveryMethod;
	  }
	
	  function getApplications(link) {
	    var deferred = $q.defer();
	    var config = {};
	    notificationHalRequest(link).then(function (resp) {
	      var applications = resp.data;
	      deferred.resolve(applications);
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function getEventDescriptionsByApplication(link) {
	    var deferred = $q.defer();
	    var config = {};
	    notificationHalRequest(link).then(function (resp) {
	      var descriptionCollection = resp.data;
	      var descriptionRecords = _.map(descriptionCollection.eventDescriptionList, createEventDescriptionRecord);
	      descriptionCollection.eventDescriptionList = descriptionRecords;
	      deferred.resolve(descriptionCollection);
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function createEventDescriptionRecord(data) {
	    var description = rnRecordFactory.create(data);
	    description.internal.idName = 'eventDescriptionName';
	
	    return description;
	  }
	
	  function acknowledgeNotification(link) {
	    var deferred = $q.defer();
	    var config = {};
	    notificationHalRequest(link).then(function (response) {
	      deferred.resolve(createNotificationRecord(response.data));
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function acknowledgeAllNotifications(link) {
	    var deferred = $q.defer();
	    notificationHalRequest(link).then(function (response) {
	      deferred.resolve();
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function addSubscription(link) {
	    var deferred = $q.defer();
	    notificationHalRequest(link).then(function (resp) {
	      var subscription = createSubscriptionRecord(resp.data);
	      deferred.resolve(subscription);
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function removeSubscription(link) {
	    var deferred = $q.defer();
	    notificationHalRequest(link).then(function () {
	      deferred.resolve();
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function updateFilter(link, data) {
	    var deferred = $q.defer();
	    notificationHalRequest(link, data).then(function (response) {
	      deferred.resolve(createSubscriptionRecord(response.data));
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function notificationHalRequest(link, data, config) {
	    var deferred = $q.defer();
	    var newLink = angular.copy(link);
	    appendServer(newLink.href).then(function (href) {
	      newLink.href = href;
	      rnHttp.halRequest(newLink, data, config).then(function (resp) {
	        deferred.resolve(resp);
	      })['catch'](function (err) {
	        deferred.reject(err);
	      });
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function appendServer(path) {
	    return rnRegistry.getUrl(PORTAL_SERVICE, path);
	  }
	}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _organizationServiceJs = __webpack_require__(438);
	
	var rnOrganization = _interopRequireWildcard(_organizationServiceJs);
	
	exports['default'] = angular.module('rhino.components.organization', [_rhinoSrcCoreCoreModule2['default']]).factory(rnOrganization.name, rnOrganization['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	'use strict';
	
	rnOrganization.$inject = ["$q", "$log", "$filter", "rnHttp", "rnRecordFactory"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnOrganization;
	var name = 'rnOrganization';
	exports.name = name;
	
	function rnOrganization($q, $log, $filter, rnHttp, rnRecordFactory) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var AAA_SERVICE_NAME = 'aaa';
	  var ORG_ORGANIZATIONS_PATH = 'organizations';
	  var ORG_APPLICATIONS_PATH = 'organizations/applications/';
	  var ORG_PACKAGES_PATH = 'organizations/packages/';
	  var ORG_PACKAGEAPPLOG_PATH = 'organizations/packageapplog/';
	  var ORG_USERS_PATH = 'organizations/users/';
	  var ORG_SUMMARY_PATH = 'organizations/summary';
	  var ORG_GRANTED_SHARES_PATH = 'organizations/grantedshares/';
	
	  var service = {
	    getPackage: getPackage,
	    getApplications: getApplications,
	    getPackageapplog: getPackageapplog,
	    getOrganization: getOrganization,
	    setOrganization: setOrganization,
	    setActive: setActive,
	    getSummary: getSummary,
	    getGrantedOrgs: getGrantedOrgs,
	    testObject: {
	      cleanPath: cleanPath
	    }
	  };
	
	  return service;
	
	  ////////////////
	
	  function getPackage() {
	
	    return doGet(AAA_SERVICE_NAME, ORG_PACKAGES_PATH).then(function (packageData) {
	      var packageRecord = createRecord(packageData);
	      return $q.resolve(packageRecord);
	    });
	  }
	
	  function getApplications() {
	
	    return doGet(AAA_SERVICE_NAME, ORG_APPLICATIONS_PATH).then(function (appsCollection) {
	      var appsRecords = _.map(appsCollection.applications, createRecord);
	      appsCollection.applications = appsRecords;
	      return appsCollection.data;
	    });
	  }
	
	  function getPackageapplog() {
	    return doGet(AAA_SERVICE_NAME, ORG_PACKAGEAPPLOG_PATH).then(function (logsCollection) {
	      var logRecords = _.map(logsCollection.logs, createRecord);
	      logsCollection.logs = logRecords;
	      return $q.resolve(logsCollection);
	    });
	  }
	
	  function createRecord(data) {
	    var record = rnRecordFactory.create(data);
	    return record;
	  }
	
	  function setActive(userId, active) {
	    var path = ORG_USERS_PATH + userId + '/active/';
	
	    return doAaaPut(path, active);
	  }
	
	  function doAaaPut(path, content) {
	    return rnHttp.put(AAA_SERVICE_NAME, path, content);
	  }
	
	  function getOrganization() {
	    var cache = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    // Should be safe to cache in memory
	    return rnHttp.get(AAA_SERVICE_NAME, ORG_ORGANIZATIONS_PATH, { cache: cache });
	  }
	
	  function setOrganization(org) {
	    return doAaaPut(ORG_ORGANIZATIONS_PATH, org);
	  }
	
	  function getSummary() {
	    return rnHttp.get(AAA_SERVICE_NAME, ORG_SUMMARY_PATH);
	  }
	
	  function getGrantedOrgs() {
	    return rnHttp.get(AAA_SERVICE_NAME, ORG_GRANTED_SHARES_PATH);
	  }
	
	  function doGet(service, path, config) {
	    // Annoying but necessary as we are working with both absolute and relative URLs for AAA services. This doesn't
	    // occur with other services in this service but if it does we will need to split this into service specific functions
	    // so we can test for all cases.
	    if (path.indexOf('/api/aaa/v1/') >= 0) {
	      path = cleanPath(path);
	    }
	
	    return rnHttp.get(service, path, config);
	  }
	
	  function cleanPath(dirty) {
	    var start = dirty.indexOf('organizations');
	    var end = dirty.length;
	    var clean = dirty.substring(start, end);
	
	    return clean;
	  }
	}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnLocalPreferences;
	
	var _preferencesService = __webpack_require__(46);
	
	var name = 'rnLocalPreferences';
	
	exports.name = name;
	
	function rnLocalPreferences() {
	  var localPreferences = window.localStorage.getItem(_preferencesService.LOCAL_STORAGE_KEY);
	  if (localPreferences) {
	    try {
	      var parsed = JSON.parse(localPreferences);
	      return parsed;
	    } catch (e) {
	      console.warn('Unable to parse preferences from local storage', localPreferences, e);
	    }
	  }
	  return null;
	}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _rhinoSrcComponentsSessionSessionModule = __webpack_require__(10);
	
	var _rhinoSrcComponentsSessionSessionModule2 = _interopRequireDefault(_rhinoSrcComponentsSessionSessionModule);
	
	var _profileServiceJs = __webpack_require__(441);
	
	var rnProfile = _interopRequireWildcard(_profileServiceJs);
	
	exports['default'] = angular.module('rhino.components.profile', [_rhinoSrcCoreCoreModule2['default'], _rhinoSrcComponentsSessionSessionModule2['default']]).factory(rnProfile.name, rnProfile['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	rnProfile.$inject = ["$q", "$log", "rnHttp", "rnSession"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnProfile;
	var name = 'rnProfile';
	exports.name = name;
	
	function rnProfile($q, $log, rnHttp, rnSession) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var AAA_SERVICE_NAME = 'aaa';
	  var PROFILE_PATH = 'users/';
	  var PROFILE_CONTEXT_PATH = 'users/context/';
	  var PROFILE_ROLE_PATH = 'users/roles/';
	
	  var service = {
	    getProfile: getProfile,
	    saveProfile: saveProfile,
	    getProfileAccounts: getProfileAccounts,
	    removeProfileAccount: removeProfileAccount,
	    getProfileRoles: getProfileRoles,
	    removeProfileRole: removeProfileRole
	  };
	
	  return service;
	
	  ////////////////
	
	  function getProfile() {
	    return doAaaGet(PROFILE_PATH);
	  }
	
	  function saveProfile(profileData) {
	    return doAaaPut(PROFILE_PATH, profileData);
	  }
	
	  function getProfileAccounts() {
	    return doAaaGet(PROFILE_CONTEXT_PATH);
	  }
	
	  function removeProfileAccount(id) {
	    var path = PROFILE_CONTEXT_PATH + id;
	    // DJL - Why are we passing this ID as data when it's already part of the URL?
	    return doAaaDeleteWithContent(path, id);
	  }
	
	  function getProfileRoles() {
	    return doAaaGet(PROFILE_ROLE_PATH);
	  }
	
	  function removeProfileRole(id) {
	    var path = PROFILE_ROLE_PATH + id;
	    return doAaaDelete(path);
	  }
	
	  function doAaaGet(path) {
	    var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    return rnSession.isAuthenticated().then(function (auth) {
	      if (auth) {
	        return rnHttp.get(AAA_SERVICE_NAME, path, config).then(function (resp) {
	          $log.debug('Successful ' + path + ' request: ', resp.data);
	          return $q.resolve(resp.data);
	        })['catch'](function (resp) {
	          $log.debug('Failed ' + path + ' request: ' + resp);
	          return $q.reject(resp);
	        });
	      } else {
	        return $q.reject({ status: 401, statusText: 'Unauthenticated' });
	      }
	    });
	  }
	
	  function doAaaPut(path, content) {
	    return rnHttp.put(AAA_SERVICE_NAME, path, content);
	  }
	
	  function doAaaDeleteWithContent(path, content) {
	    return rnHttp['delete'](AAA_SERVICE_NAME, path, content);
	  }
	
	  function doAaaDelete(path) {
	    return rnHttp['delete'](AAA_SERVICE_NAME, path);
	  }
	}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	rnPusher.$inject = ["$q", "$rootScope", "$log", "rnBlue"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnPusher;
	var name = 'rnPusher';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.pusher.service:rnPusher
	 *
	 * @description Rhino Pusher service, providing a simplified facade for working with Pusher.
	 * This service uses a single Pusher client configured with the Rhino Registry
	 * for easily adding and removing event listeners.  This services automatically
	 * subscribes to and unsubscribes from channels as required.  Having a central
	 * client also reduces the number of Pusher authorizations.
	 *
	 * @example
	 * ```js
	 * rnPusher.bind('devices', 'deviceUpdated', device => {});
	 * ```
	 */
	
	function rnPusher($q, $rootScope, $log, rnBlue) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var service = {
	    bind: bind,
	    unbind: unbind
	  };
	  return service;
	
	  ////////////////////
	
	  function getBluePusherApi() {
	    return rnBlue.getBlueApi().then(function (blueApi) {
	      return blueApi.pusher;
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name bind
	   * @methodOf rhino.components.pusher.service:rnPusher
	   * @description Binds a callback function to a channel event.
	   * @param {string} channelName of the channel to bind to
	   * @param {string} eventName of the event to bind to
	   * @param {function} callback for pusher to call
	   * @param {object} [scope] if provided, rnPusher will ensure the callback is unbound on scope destruction
	   * @returns {Promise.<T>|IPromise<TResult>} a promise
	   */
	  function bind(channelName, eventName, callback, scope) {
	    if (!channelName) {
	      $log.warn('Attempt to bind without a channel name', channelName, eventName, callback, scope);
	      return $q.reject('Unable to bind without a channel name');
	    }
	    if (!eventName) {
	      $log.warn('Attempt to bind without an event name', channelName, eventName, callback, scope);
	      return $q.reject('Unable to bind without an event name');
	    }
	    if (!callback) {
	      $log.warn('Attempt to bind without a callback ', channelName, eventName, callback, scope);
	      return $q.reject('Unable to bind without a callback');
	    }
	
	    return getBluePusherApi().then(function (bluePusherApi) {
	      var decoratedCallback = function pusherCallback(payload) {
	        callback(payload);
	        // Pusher events are outside of the angular digest loop.
	        // Ensure a digest loop here so that any changes made in the callback take effect.
	        $rootScope.$digest();
	      };
	
	      bluePusherApi.bind(channelName, eventName, decoratedCallback);
	      // Gross - save a reference back to the decorated callback.
	      // It is this callback that is needed in unbind (see pusher-angular.unbind).
	      callback.decorator = decoratedCallback;
	
	      if (scope) {
	        scope.$on('$destroy', function () {
	          unbind(channelName, eventName, callback);
	        });
	      }
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name unbind
	   * @methodOf rhino.components.pusher.service:rnPusher
	   * @description Unbinds a callback function from a channel event.
	   * @param {string} channelName of the channel to unbind from
	   * @param {string} eventName of the event to unbind from
	   * @param {function} callback to unbind
	   * @returns {Promise.<T>|IPromise<TResult>} a promise
	   */
	  function unbind(channelName, eventName, callback) {
	    if (!channelName) {
	      $log.warn('Attempt to unbind without a channel name', channelName, eventName, callback);
	      return $q.reject('Unable to unbind without a channel name');
	    }
	    if (!eventName) {
	      $log.warn('Attempt to unbind without an event name', channelName, eventName, callback);
	      return $q.reject('Unable to unbind without an event name');
	    }
	    if (!callback) {
	      $log.warn('Attempt to unbind without a callback ', channelName, eventName, callback);
	      return $q.reject('Unable to unbind without a callback');
	    }
	
	    return getBluePusherApi().then(function (bluePusherApi) {
	      var decoratedCallback = callback.decorator;
	      bluePusherApi.unbind(channelName, eventName, decoratedCallback);
	    });
	  }
	}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _requestService = __webpack_require__(444);
	
	var rnRequestService = _interopRequireWildcard(_requestService);
	
	exports['default'] = angular.module('rhino.components.request', [_rhinoSrcCoreCoreModule2['default']]).service(rnRequestService.name, rnRequestService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	rnRequest.$inject = ["$q", "$log", "rnHttp"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnRequest;
	var name = 'rnRequest';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.request.service:rnRequest
	 *
	 * @description Rhino Request service, provides methods to make requests to the support service
	 */
	
	function rnRequest($q, $log, rnHttp) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var SUPPORT_APP_SERVICE = 'supportapp_service';
	  var REQUESTS_TYPES_PATH = 'requests/types';
	  var REQUESTS_PATH = 'requests';
	
	  var service = {
	    getRequestTypes: getRequestTypes,
	    createRequest: createRequest
	  };
	
	  return service;
	
	  ////////////////
	
	  /**
	   * @ngdoc function
	   * @name getRequestTypes
	   * @methodOf rhino.components.request.service:rnRequest
	   * @description Gets the valid request types for this user
	   */
	  function getRequestTypes() {
	    var deferred = $q.defer();
	
	    rnHttp.get(SUPPORT_APP_SERVICE, REQUESTS_TYPES_PATH).then(function (response) {
	      deferred.resolve(response.data); // We only care about the data
	    })['catch'](function (error) {
	      deferred.reject(error.data); // We only care about the data
	    });
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc function
	   * @name createRequest
	   * @methodOf rhino.components.request.service:rnRequest
	   * @description Creates a request
	   * @param {object} params - a json object payload
	   */
	  function createRequest(params) {
	    var deferred = $q.defer();
	
	    rnHttp.post(SUPPORT_APP_SERVICE, REQUESTS_PATH, params).then(function (response) {
	      deferred.resolve(response.data); // We only care about the data
	    })['catch'](function (error) {
	      deferred.reject(error.data); // We only care about the data
	    });
	    return deferred.promise;
	  }
	}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _searchServiceJs = __webpack_require__(446);
	
	var rnSearch = _interopRequireWildcard(_searchServiceJs);
	
	exports['default'] = angular.module('rhino.components.search', [_rhinoSrcCoreCoreModule2['default']]).service(rnSearch.name, rnSearch['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	rnSearch.$inject = ["$log", "$q", "rnHttp"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnSearch;
	var name = 'rnSearch';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.search.service:rnSearch
	 * @description This service provides the client application with the ability to query the CSIS Genesis search server.
	 */
	
	function rnSearch($log, $q, rnHttp) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var self = this;
	
	  /**
	   * This is the externally facing API of the service
	   */
	  var service = {
	    search: search
	  };
	
	  return service;
	
	  /////////////////////
	  // Private functions
	  ////////////////////
	
	  function search(params) {
	
	    var url = constructUrl(params);
	    var query = constructQuery(params);
	
	    return doPost(url, query);
	  }
	
	  function constructUrl() {
	    var url = '/apps/search/';
	    return url;
	  }
	
	  /**
	   * Constructs an Elastic Search query based upon the search terms
	   * @param params
	   * @returns {{query: {match: {_all: *}}}}
	   */
	  function constructQuery(params) {
	
	    var searchTerm = params.searchFor;
	    var q = {};
	    getQuery(q, searchTerm);
	
	    return q;
	  }
	
	  function attachSearchTerm(q, searchTerm) {
	    q.searchFor = searchTerm;
	  }
	
	  function detachSearchTerm(q) {
	    delete q.searchFor;
	  }
	
	  function getQuery(q, searchTerm) {
	    attachSearchTerm(q, searchTerm);
	    q.query = {};
	    getQueryType(q);
	    detachSearchTerm(q);
	  }
	
	  function getQueryType(q) {
	    var isPhraseSearch = q.searchFor.indexOf('"') === 0 && q.searchFor.lastIndexOf('"') === q.searchFor.length - 1;
	    var queryType = isPhraseSearch ? "match_phrase" : "match";
	    q.query[queryType] = { "_all": q.searchFor };
	  }
	
	  function doPost(path, content) {
	    var service = 'portal_service';
	    return rnHttp.post(service, path, content);
	  }
	}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _sessionStorageService = __webpack_require__(448);
	
	var rnSessionStorage = _interopRequireWildcard(_sessionStorageService);
	
	exports['default'] = angular.module('rhino.components.sessionStorage', []).service(rnSessionStorage.name, rnSessionStorage['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var name = 'rnSessionStorage';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.local-storage.service:rnSessionStorage
	 * @description
	 * Provides a simple facade over sessionStorage, allowing it to be easily
	 * injected and testable.  Also simplifies storing and retrieving objects
	 * instead of just strings.
	 *
	 * @example
	 * ```js
	 * rnSessionStorage.getString('marco'); // returns null
	 * rnSessionStorage.setString('marco', 'polo');
	 * rnSessionStorage.getString('marco'); // returns 'polo'
	 *
	 * rnSessionStorage.clear();
	 * rnSessionStorage.getString('marco'); // returns null again
	 *
	 * rnSessionStorage.getObject('preferences'); // returns null
	 * rnSessionStorage.setObject('preferences', {lang: 'en'});
	 * rnSessionStorage.getObject('preferences'); // returns {lang: 'en'}
	 *
	 * rnSessionStorage.setString('notAnObject', 'notAnObject');
	 * rnSessionStorage.getObject('notAnObject'); // throws JSON parse error
	 * ```
	 */
	
	exports['default'] = ["$window", function ($window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var sessionStorage = $window.sessionStorage;
	
	  var service = {
	    getString: getString,
	    setString: setString,
	    getObject: getObject,
	    setObject: setObject,
	    removeItem: removeItem,
	    clear: clear
	  };
	  return service;
	
	  ////////////////
	
	  /**
	   * @ngdoc function
	   * @name getString
	   * @methodOf rhino.components.local-storage.service:rnSessionStorage
	   * @param {string} key to get
	   * @returns {string} value `null` if not found
	   */
	  function getString(key) {
	    return sessionStorage.getItem(key);
	  }
	
	  /**
	   * @ngdoc function
	   * @name setString
	   * @methodOf rhino.components.local-storage.service:rnSessionStorage
	   * @param {string} key to set
	   * @param {string} str value to set
	   */
	  function setString(key, str) {
	    sessionStorage.setItem(key, str);
	  }
	
	  /**
	   * @ngdoc function
	   * @name getObject
	   * @methodOf rhino.components.local-storage.service:rnSessionStorage
	   * @param {string} key to get
	   * @returns {object} value `null` if not found
	   */
	  function getObject(key) {
	    var item = getString(key);
	    if (item === null) {
	      return null;
	    }
	    return JSON.parse(item);
	  }
	
	  /**
	   * @ngdoc function
	   * @name setObject
	   * @methodOf rhino.components.local-storage.service:rnSessionStorage
	   * @param {string} key to set
	   * @param {object} value to set
	   */
	  function setObject(key, obj) {
	    setString(key, JSON.stringify(obj));
	  }
	
	  /**
	   * @ngdoc function
	   * @name removeItem
	   * @methodOf rhino.components.local-storage.service:rnSessionStorage
	   */
	  function removeItem(key) {
	    sessionStorage.removeItem(key);
	  }
	
	  /**
	   * @ngdoc function
	   * @name clear
	   * @methodOf rhino.components.local-storage.service:rnSessionStorage
	   */
	  function clear() {
	    sessionStorage.clear();
	  }
	}];

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	'use strict';
	
	rnSession.$inject = ["$log", "$http", "rnHttp", "$q", "$window", "rnRegistry", "rnSingSession", "rnAuthService", "rnApplication"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnSession;
	var name = 'rnSession';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.components.session.service:rnSession
	 * @description
	 * Provides the client application with security / authentication related session-based functions that enable the
	 * client application to authenticate to the genesis eco-system.
	 */
	
	function rnSession($log, $http, rnHttp, $q, $window, rnRegistry, rnSingSession, rnAuthService, rnApplication) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var self = this;
	  var AAA_SERVICE_NAME = 'aaa';
	  var USER_VALIDATION_PATH = 'users/validate';
	  var USER_SIGNIN_PATH = 'users/login';
	  var USER_SIGNOUT_PATH = 'users/logout';
	  var USER_CONTEXTS_PATH = 'users/context';
	  var USER_SWITCH_CONTEXT_PATH = 'users/context';
	
	  var cachedEnityInfo = null;
	
	  var service = {
	    // New Session API (currently code is in rnSingSession) [Session Singleton]
	    // this API is being duplicated here so that we don't have to refactor code twice.
	    // No client code should reference rnSingSession.  We forward the API from here to rnSingSession
	    // and when this old API is gone and everything uses rnAuthService rnSingSession will become rnSession.
	    id: rnSingSession.id,
	    user: rnSingSession.user,
	    context: rnSingSession.context,
	    // Uncomment the next line as part of step 5 (below)
	    // isAuthenticated: rnSingSession.isAuthenticated,
	    _create: rnSingSession._create,
	    _destroy: rnSingSession._destroy,
	
	    // Special case: old rnSession isAuthenticated returns a promise - the new one (in rnSingSession) will return boolean.
	    // To accommodate this we will return a promise from here for now.
	    // To migrate: (currently on step 1)
	    //  1. Make rnSession return a wrapped boolean from rnSingSession as a promise.
	    //  2. Refactor client code to use rnAuthService if a promise is need for isAuthenticated
	    //  3. Change above isAuthenticated interface to return a boolean (not a promise)
	    //  4. Refactor client code that can be simplified by using a boolean to use rnSession.isAuthenticated === true
	    //  5. Delete isAuthenticated entry below and uncomment the one above
	    //
	    // Delete the next line as part of step 5 (above)
	    isAuthenticated: isAuthenticated,
	    isAuthenticatedNow: rnSingSession.isAuthenticated,
	
	    // Old rnSession API - these will be forwarded to new AuthService APIs as needed.
	    // Eventually all of these should be removed in favor of using rnAuthService
	    // To migrate: (currently on step 1)
	    //  1. Forward API to rnAuthService, add $log.warn statements that the client should use the new API
	    //  2. APIs that cannot be forwarded need to have $log.warn (or $error) statements that explain new usage
	    //  3. Refactor client code to use rnAuthService
	    //  4. Remove old APIs from here once client code is refactored (PSI8.3 at the latest)
	    //
	
	    //need to be forwarded
	    isUserValidationUrl: isUserValidationUrl,
	    isUserSigninUrl: isUserSigninUrl,
	
	    userInfo: getUserInfo,
	    updateUserInfo: updateUserInfo,
	
	    userContext: getUserContext,
	    availableContexts: getAvailableContexts,
	    switchContext: switchContext,
	    clearCache: clearCache,
	
	    signin: signin,
	    signout: signout,
	
	    // Probably not part of a session - these should not be here.  Need to host the reloadApp API in the app broker.
	    // Forward the API from here if it makes sense.  reloadUXF needs to be removed.
	    reloadApp: reloadApp,
	    reloadUXF: reloadUXF,
	
	    // Definitely not part of a session - these need to be moved to another component ASAP.
	    systemVersions: getSystemVersions,
	    systemVideos: getSystemVideos
	
	  };
	
	  return service;
	
	  /////////////////////
	  // Private functions
	  ////////////////////
	
	  /**
	   * @ngdoc function
	   * @name isUserValidationUrl
	   * @methodOf rhino.components.session.service:rnSession
	   * @description Checks if a URL is the user validation URL.
	   * (Needed by the session expiration interceptor and to centralize this URL here).
	   * @param {string} url to check
	   * @returns {boolean} `true` if the URL is the user validation URL
	   */
	  function isUserValidationUrl(url) {
	    // Cheating here so I don't have to turn this method into async.
	    return url.indexOf(USER_VALIDATION_PATH) > -1;
	  }
	
	  /**
	   * @ngdoc function
	   * @name isUserSigninUrl
	   * @methodOf rhino.components.session.service:rnSession
	   * @description Checks if a URL is the user signin URL.
	   * (Needed by the session expiration interceptor and to centralize this URL here).
	   * @param {string} url to check
	   * @returns {boolean} `true` if the URL is the user sign-in URL
	   */
	  function isUserSigninUrl(url) {
	    // Cheating here so I don't have to turn this method into async.
	    return url.indexOf(USER_SIGNIN_PATH) > -1;
	  }
	
	  /**
	   * @ngdoc function
	   * @name clearCache
	   * @methodOf rhino.components.session.service:rnSession
	   *
	   * @description
	   * Clear the cached entity information and set the flag so that $http won't use it's cache next time the call is made.
	   *
	   * @return {rnSession} service.  Returns the service so this method is chainable  i.e. rnSession.clearCache().isAuthenticated()
	   */
	  function clearCache() {
	    $log.warn('$name}#clearCache is deprecated with no replacement');
	    // cachedEnityInfo = null;
	    // cacheResponse = false;
	    return service;
	  }
	
	  function isAuthenticated() {
	    if (rnSingSession.isAuthenticated() !== undefined) {
	      return $q.when(rnSingSession.isAuthenticated());
	    } else {
	      var _ret = (function () {
	        var q = $q.defer();
	        rnAuthService.validate()['catch'](function () {
	          // no-op - it's ok if we fail validation here. Squelching angular 1.6 unhandled promise rejection.
	        })['finally'](function () {
	          q.resolve(rnSingSession.isAuthenticated());
	        });
	        return {
	          v: q.promise
	        };
	      })();
	
	      if (typeof _ret === 'object') return _ret.v;
	    }
	  }
	
	  /**
	   * @ngdoc function
	   * @name getUserInfo
	   * @methodOf rhino.components.session.service:rnSession
	   *
	   * @description Return cached user info. If there is no cache then call getEntityInfo to refresh from AAA
	   * and return the user info portion.
	   * @returns {*} cached user info
	   */
	  function getUserInfo() {
	    if (rnSingSession.isAuthenticated() !== undefined) {
	      return $q.when(rnSingSession.user);
	    } else {
	      var _ret2 = (function () {
	        var q = $q.defer();
	        rnAuthService.validate()['finally'](function () {
	          q.resolve(rnSingSession.user);
	        });
	        return {
	          v: q.promise
	        };
	      })();
	
	      if (typeof _ret2 === 'object') return _ret2.v;
	    }
	  }
	
	  /**
	   * @ngdoc function
	   * @name getUserContext
	   * @methodOf rhino.components.session.service:rnSession
	   *
	   * @description Return cached context organization ID. If there is no cache then call
	   * getEntityInfo to refresh from AAA and return the context organization ID.
	   * @returns {*} the cached user context org ID
	   */
	  function getUserContext() {
	    if (rnSingSession.isAuthenticated() !== undefined) {
	      return $q.when(rnSingSession.context);
	    } else {
	      var _ret3 = (function () {
	        var q = $q.defer();
	        rnAuthService.validate()['finally'](function () {
	          q.resolve(rnSingSession.context);
	        });
	        return {
	          v: q.promise
	        };
	      })();
	
	      if (typeof _ret3 === 'object') return _ret3.v;
	    }
	  }
	
	  /**
	   * @ngdoc function
	   * @name getAvailableContexs
	   * @methodOf rhino.components.session.service:rnSession
	   *
	   * @description Get the various contexts that are available for this authenticated session.
	   * @returns {Promise<ContextContainer>} a promise of available contexts
	   */
	  function getAvailableContexts() {
	    var deferred = $q.defer();
	    this.isAuthenticated().then(function (auth) {
	      if (auth) {
	        var config = {
	          params: {
	            limit: 10000
	          }
	        };
	
	        rnHttp.get(AAA_SERVICE_NAME, USER_CONTEXTS_PATH, config).then(function (resp) {
	          deferred.resolve(resp.data);
	        });
	      } else {
	        deferred.reject({ status: 401, statusText: 'Unauthenticated' });
	      }
	    });
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc function
	   * @name switchContext
	   * @methodOf rhino.components.session.service:rnSession
	   *
	   * @description Change the user session context to the given context
	   * @param {object} context - the new context to switch into...
	   * @returns {Promise} with the server response
	   */
	  function switchContext(context) {
	    var deferred = $q.defer();
	
	    if (!context) {
	      deferred.reject({ status: 400, statusText: 'Invalid Context' });
	    } else {
	      rnHttp.put(AAA_SERVICE_NAME, USER_SWITCH_CONTEXT_PATH, context).then(function (resp) {
	        // Use ga() global directly because we need to start a new analytics session.
	        $window.ga('send', 'event', {
	          sessionControl: 'start',
	          eventCategory: 'account',
	          eventAction: 'org context switch',
	          eventLabel: rnSingSession.context.id + '|' + context.id
	        });
	
	        deferred.resolve(resp.data);
	      })['catch'](function (resp) {
	        deferred.reject(resp);
	      });
	    }
	    return deferred.promise;
	  }
	
	  /**
	   * @ngdoc function
	   * @name signin
	   * @methodOf rhino.components.session.service:rnSession
	   *
	   * @description Sign-in the user into the genesis eco-system
	   * @param {object} signin_data to sign in with
	   * @returns {Promise} containing the sign in result
	   */
	  function signin(signin_data) {
	    $log.warn(name + '#signin is deprecated - use rnAuthService#signin instead');
	    return rnAuthService.signin(signin_data);
	  }
	
	  /**
	   * @ngdoc function
	   * @name signout
	   * @methodOf rhino.components.session.service:rnSession
	   *
	   * @description Sign-out the currently signed in user from the genesis eco-system
	   * @returns {Promise} server response
	   */
	  function signout() {
	    $log.warn(name + '#signout is deprecated - use rnAuthService#signout instead');
	    return rnAuthService.signout();
	  }
	
	  /**
	   * @ngdoc reload
	   * @name clearCache
	   * @methodOf rhino.components.session.service:rnSession
	   *
	   * @description Reload the entire page... This is a hard reload of the client side application
	   * see rnApplication - this API should probably not be here - it should be on the rnApplication
	   * leaving them both for now because we use this a lot on rnSession.
	   *
	   * @param {boolean} goHome - Force the browser to load '/' if true, else just reload the existing route
	   */
	  function reloadApp(goHome) {
	    $log.warn(name + '#reloadApp() is deprecated - please call rnApplication.rebootApp() instead');
	    rnApplication.rebootApp(goHome);
	  }
	
	  //TODO: The rest of this file contains APIs that are not part of the user session - they need to be moved somewhere else
	
	  // Not part of a session - these should not be here....
	  var SYSTEM_VIDEO = 'https://s3.amazonaws.com/genesis_prod_public/assets/videos/training/videolist.json?callback=JSON_CALLBACK';
	  var systemVersionInfo;
	  var systemVideoList;
	
	  /**
	   * Reload the entire page... This is a hard reload of the client side application
	   * @param goHome - Force the browser to load '/' if true, else just reload the existing route
	   */
	  function reloadUXF(goHome) {
	    $log.warn(name + '#reloadUXF() is deprecated - please call rnApplication.rebootApp() instead');
	    rnApplication.rebootApp(goHome);
	  }
	
	  function getSystemInfo() {
	    var SMS_PORTAL = 'sms_portal';
	    var SYSTEM_VERSIONING = 'versions/versions.json';
	
	    var deferredInfo = $q.defer();
	    rnHttp.get(SMS_PORTAL, SYSTEM_VERSIONING).then(function (resp) {
	      $log.debug("success in getSystemInfo");
	      systemVersionInfo = resp.data;
	      deferredInfo.resolve(systemVersionInfo);
	    })['catch'](function (resp) {
	      $log.warn("Failed to get system versioning info");
	      systemVersionInfo = null;
	      deferredInfo.reject(null);
	    });
	    return deferredInfo.promise;
	  }
	
	  /**
	  * Return system versioning info.
	  * @returns {*}
	  */
	  function getSystemVersions() {
	    var deferred = $q.defer();
	    $log.debug("in getSystemVersions");
	    getSystemInfo().then(function (data) {
	      $log.debug("getSystemVersions success");
	      deferred.resolve(_.sortBy(data, 'name'));
	    })['catch'](function () {
	      $log.warn("getSystemVersions failed");
	      deferred.resolve(null);
	    });
	    return deferred.promise;
	  }
	
	  /**
	   * Return system video info for home page How Do I widget.
	   * @returns {*}
	   */
	  function getSystemVideos() {
	    var deferred = $q.defer();
	    $log.debug("in getSystemVideos");
	    getSystemVideoList().then(function (data) {
	      $log.debug("getSystemVideo success");
	      deferred.resolve(data);
	    }, function () {
	      $log.warn("getSystemVideo failed");
	      deferred.resolve(null);
	    });
	    return deferred.promise;
	  }
	
	  function getSystemVideoList() {
	    var deferredInfo = $q.defer();
	    //For CORS issue
	
	    $http.jsonp(SYSTEM_VIDEO).success(function (data) {
	      $log.debug("success in getSystemVideoList");
	      systemVideoList = data;
	      deferredInfo.resolve(systemVideoList);
	    }).error(function (data, status) {
	      $log.warn("Failed to get system video info " + status);
	      $log.warn("System video list: ", data);
	      systemVideoList = null;
	      deferredInfo.reject(null);
	    })['finally'](function () {
	      $log.debug("getSystemVideoList in finally");
	    });
	    return deferredInfo.promise;
	  }
	
	  function updateUserInfo(userInfo) {
	    rnSingSession.user = userInfo;
	  }
	}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	rnStart.$inject = ["rnClient", "rnHttp", "rnSession", "$q", "$log", "rnInvitation", "rnPreferences", "rnDeviceDetector", "rnDcs"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = rnStart;
	
	var _rhinoSrcComponentsDeviceDetectorService = __webpack_require__(66);
	
	var STEP_NAME = {
	  signIn: 'signIn',
	  profile: 'profile',
	  location: 'location',
	  addDevice: 'addDevice',
	  activateDevice: 'activateDevice',
	  finish: 'finish'
	};
	
	exports.STEP_NAME = STEP_NAME;
	// Exported for testing
	var ORG_TYPE = {
	  PSP: 'PSP',
	  Channel: 'Channel',
	  HP: 'HP',
	  Generic: 'Generic'
	};
	
	exports.ORG_TYPE = ORG_TYPE;
	var BUSINESS_UNIT = {
	  LF: 'LargeFormat',
	  ThreeD: 'ThreeD',
	  Indigo: 'Indigo',
	  Scitex: 'Scitex',
	  IHPS: 'PWI',
	  NONE: 'None'
	};
	
	exports.BUSINESS_UNIT = BUSINESS_UNIT;
	var INTERNAL_ID_GBU = {
	  Indigo: 'Indigo',
	  Latex: 'Latex',
	  ThreeD: 'ThreeD',
	  Designjet: 'Designjet',
	  IHPS: 'IHPS',
	  Scitex: 'Scitex'
	};
	
	exports.INTERNAL_ID_GBU = INTERNAL_ID_GBU;
	var DEFAULT_STARTUP_APP = {
	  Channel: {
	    LargeFormat: 'reseller-portal'
	  },
	  DEFAULT: 'home'
	};
	
	exports.DEFAULT_STARTUP_APP = DEFAULT_STARTUP_APP;
	var SHOW_WELCOME_PAGE = {
	  PSP: {
	    LF: false,
	    ThreeD: false
	  },
	  Channel: {
	    LF: false,
	    ThreeD: false
	  },
	  DEFAULT: true
	};
	
	exports.SHOW_WELCOME_PAGE = SHOW_WELCOME_PAGE;
	var name = 'rnStart';
	exports.name = name;
	
	function rnStart(rnClient, rnHttp, rnSession, $q, $log, rnInvitation, rnPreferences, rnDeviceDetector, rnDcs) {
	  'ngInject';
	
	  var START_VERSION = 4;
	  var STEP_DEFINITIONS = [{
	    type: STEP_NAME.signIn,
	    businessUnits: [BUSINESS_UNIT.Indigo, BUSINESS_UNIT.Scitex, BUSINESS_UNIT.IHPS, BUSINESS_UNIT.LF, BUSINESS_UNIT.ThreeD, BUSINESS_UNIT.NONE],
	    orgTypes: [ORG_TYPE.PSP, ORG_TYPE.Channel],
	    isPermitted: function isPermitted() {
	      return $q.resolve(true);
	    },
	    isComplete: function isComplete() {
	      return $q.resolve(true);
	    }
	  }, {
	    type: STEP_NAME.profile,
	    businessUnits: [BUSINESS_UNIT.Indigo, BUSINESS_UNIT.Scitex, BUSINESS_UNIT.IHPS, BUSINESS_UNIT.LF, BUSINESS_UNIT.ThreeD, BUSINESS_UNIT.NONE],
	    orgTypes: [ORG_TYPE.PSP, ORG_TYPE.Channel, ORG_TYPE.HP],
	    isPermitted: function isPermitted() {
	      return $q.resolve(true);
	    },
	    isComplete: function isComplete() {
	      return getClientConfig().then(function (clientConfig) {
	        //IF we are HP in another account where we are not a member then treat step as complete
	        if (_.get(clientConfig, 'managingContext.type') === 'HP') {
	          return true;
	        }
	
	        var hasJobFunctions = _.get(clientConfig, 'entity.persona.myTypes', []).length > 0;
	
	        return hasJobFunctions;
	      });
	    }
	  }, {
	    type: STEP_NAME.location,
	    businessUnits: [BUSINESS_UNIT.Indigo, BUSINESS_UNIT.Scitex, BUSINESS_UNIT.IHPS, BUSINESS_UNIT.LF, BUSINESS_UNIT.ThreeD, BUSINESS_UNIT.NONE],
	    orgTypes: [ORG_TYPE.PSP, ORG_TYPE.Channel],
	    isPermitted: function isPermitted() {
	      return rnHttp.get('aaa', 'organizations/sites', { params: { offset: 0, limit: 1000 }, cache: true }).then(function (resp) {
	        return _.get(resp, 'data._links.add') !== undefined;
	      });
	    },
	    isComplete: function isComplete() {
	      // incomplete if no sites or 1 site without an address
	      return rnHttp.get('aaa', 'organizations/sites', { params: { offset: 0, limit: 1000 }, cache: true }).then(function (resp) {
	        var sites = resp.data.sites;
	        if (sites.length === 0) {
	          return false;
	        } else if (sites.length === 1) {
	          if (!_.get(sites[0], 'primaryAddress.addressLine1')) {
	            return false;
	          }
	        }
	
	        return true;
	      });
	    }
	  }, {
	    type: STEP_NAME.addDevice,
	    businessUnits: [BUSINESS_UNIT.LF, BUSINESS_UNIT.Indigo, BUSINESS_UNIT.Scitex, BUSINESS_UNIT.IHPS, BUSINESS_UNIT.ThreeD, BUSINESS_UNIT.NONE],
	    orgTypes: [ORG_TYPE.PSP],
	    isPermitted: function isPermitted() {
	      var promises = [];
	      promises.push(isBusinessUnit(BUSINESS_UNIT.ThreeD));
	      promises.push(queryDevices());
	      promises.push(canAddDevice());
	      return $q.all(promises).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 3);
	
	        var isThreeD = _ref2[0];
	        var devicesContainer = _ref2[1];
	        var canAddDevice = _ref2[2];
	
	        var hasDevices = devicesContainer.total > 0;
	        if (isThreeD) {
	          return hasDevices && canAddDevice;
	        }
	
	        return canAddDevice;
	      });
	    },
	    isComplete: function isComplete() {
	      var promises = [];
	      promises.push(queryDevices());
	      promises.push(queryPayloads());
	      promises.push(rnHttp.get('aaa', 'organizations/sites', { params: { offset: 0, limit: 1000 }, cache: true }));
	      promises.push(rnPreferences.getSingleObject('pos.gz.task', 'pos.gz.taskOut'));
	      return $q.all(promises).then(function (_ref3) {
	        var _ref32 = _slicedToArray(_ref3, 4);
	
	        var devicesContainer = _ref32[0];
	        var payloads = _ref32[1];
	        var sitesResp = _ref32[2];
	        var taskData = _ref32[3];
	
	        var hasSites = sitesResp.data.sites.length > 0;
	        var hasDevices = devicesContainer.total > 0;
	        var hasPayloads = payloads.length > 0;
	        var hasUnAddedPayloadDevices = false;
	        if (hasPayloads) {
	          var payloadDevices = _.get(payloads[0], 'ext_payload.onboard.devices', []);
	          _.forEach(payloadDevices, function (payloadDevice) {
	            var foundSN = devicesContainer.devices.find(function (d) {
	              return d.serialNumber === payloadDevice.serialNumber || d.serialNumber === _.get(taskData, 'payload.sn');
	            });
	            if (foundSN === undefined) {
	              hasUnAddedPayloadDevices = true;
	              return false;
	            }
	          });
	        }
	        var hasUnassigned = false;
	        _.forEach(devicesContainer.devices, function (device) {
	          if (hasSites && !_.get(device, 'site')) {
	            hasUnassigned = true;
	            return false;
	          }
	        });
	        return hasDevices && !hasUnAddedPayloadDevices && !hasUnassigned;
	      });
	    }
	  }, {
	    type: STEP_NAME.activateDevice,
	    businessUnits: [BUSINESS_UNIT.LF, BUSINESS_UNIT.Indigo],
	    orgTypes: [ORG_TYPE.PSP],
	    isPermitted: canAddDevice,
	    isComplete: function isComplete() {
	      // Complete if there is at least one activated device
	      // or there are no devices that can be activated
	      var promises = [];
	      promises.push(getLatexDevicesToActivate());
	      promises.push(getIndigoDevicesToActivate());
	      return $q.all(promises).then(function (_ref4) {
	        var _ref42 = _slicedToArray(_ref4, 2);
	
	        var latexDevices = _ref42[0];
	        var indigoDevices = _ref42[1];
	
	        return hasActivatedDevice(latexDevices, indigoDevices) || !hasUnactivatedDevice(latexDevices, indigoDevices);
	      });
	    }
	  }];
	
	  var deviceType = undefined;
	  var ccPromise = undefined;
	  var cc = undefined;
	
	  var service = {
	    getStartInfo: getStartInfo,
	    getOrgInfo: getOrgInfo,
	    getDeviceType: getDeviceType,
	    getBusinessUnits: getBusinessUnits,
	    getRecommendedStartupApp: getDefaultStartupApp,
	    skipStep: skipStep,
	    finishSteps: finishSteps,
	    getSkipWelcome: getSkipWelcome,
	    setSkipWelcome: setSkipWelcome,
	    unitTest: {
	      getStepDefinitions: function getStepDefinitions() {
	        return STEP_DEFINITIONS;
	      }
	    }
	  };
	
	  return service;
	
	  ////////////////////
	  function getClientConfig() {
	    if (cc) {
	      return Promise.resolve(cc);
	    }
	
	    if (!ccPromise) {
	      ccPromise = rnClient.getConfig(false).then(function (resp) {
	        cc = resp;
	        return cc;
	      });
	    }
	
	    return ccPromise;
	  }
	
	  function queryDevices() {
	    // No need to call the device service for this one since we just need a subset of device data.
	    var config = {
	      params: {
	        limit: 1000
	      },
	      cache: true
	    };
	    return rnHttp.get('aaa', 'organizations/devices', config).then(function (resp) {
	      return resp.data;
	    });
	  }
	
	  function queryPayloads() {
	    var config = {
	      cache: true
	    };
	    return rnHttp.get('email_service', 'invitations/payload', config).then(function (resp) {
	      return resp.data;
	    })['catch'](function () {
	      // Treat 401's and other issues as no payloads - this is not critical data
	      return [];
	    });
	  }
	
	  function queryOrg() {
	    return rnHttp.get('aaa', 'organizations', { cache: true }).then(function (resp) {
	      return resp.data;
	    });
	  }
	
	  function getOrgInfo() {
	    return $q.all({
	      businessUnits: getBusinessUnits(),
	      orgType: getOrgType()
	    });
	  }
	
	  function getDeviceType() {
	    return deviceType;
	  }
	
	  function canAddDevice() {
	    return rnDcs.getAll(0, 0).then(function (devicesContainer) {
	      return _.has(devicesContainer, '_links.create');
	    })['catch'](function () {
	      return false;
	    });
	  }
	
	  function hasActivatedDevice(latexDevices, indigoDevices) {
	    //1. Check for an activated Latex
	    if (latexDevices.activationStatusesWithContext.length > 0) {
	      var found = latexDevices.activationStatusesWithContext[0].activationStatuses;
	      var hasActivatedLatex = found.some(function (activationStatus) {
	        return activationStatus.status === 'active';
	      });
	
	      if (hasActivatedLatex) {
	        return true;
	      }
	    }
	
	    //2. Check for an activated Indigo
	    indigoDevices = indigoDevices || [];
	    var hasActivatedIndigo = indigoDevices.some(function (device) {
	      return device.uiState === _rhinoSrcComponentsDeviceDetectorService.UI_STATE.activated;
	    });
	
	    return hasActivatedIndigo;
	  }
	
	  function hasUnactivatedDevice(latexDevices, indigoDevices) {
	    //1. Check whether latex devices are available to activate
	    if (latexDevices.activationStatusesWithContext.length > 0) {
	      var found = latexDevices.activationStatusesWithContext[0].activationStatuses;
	      var hasUnactivatedLatex = found.some(function (activationStatus) {
	        return activationStatus.status !== 'active';
	      });
	
	      if (hasUnactivatedLatex) {
	        return true;
	      }
	    }
	
	    //2. Check whether Indigo devices are available to activate
	    if (indigoDevices && indigoDevices.length > 0) {
	      return true;
	    }
	
	    return false;
	  }
	
	  function getLatexDevicesToActivate() {
	    var config = {
	      cache: true,
	      params: {
	        limit: 1000
	      }
	    };
	    return rnHttp.get('aaa', 'organizations/devices/activationstatus', config).then(function (_ref5) {
	      var activationContainer = _ref5.data;
	
	      return activationContainer;
	    })['catch'](function (error) {
	      // Putting this in because on some stacks this appears to fail for some reason
	      return { activationStatusesWithContext: [] };
	    });
	  }
	
	  function getIndigoDevicesToActivate() {
	    return rnDeviceDetector.getCanActivateDevices().then(function (deviceList) {
	      return deviceList;
	    })['catch'](function () {
	      return [];
	    });
	  }
	
	  function getBusinessUnits() {
	    var businessUnits = [];
	    return queryOrg().then(function (org) {
	      if (org.internalIds) {
	        if (org.internalIds.length === 0) {
	          businessUnits.push(BUSINESS_UNIT.NONE);
	        }
	
	        org.internalIds.forEach(function (internalId) {
	          switch (internalId.gbu) {
	            case INTERNAL_ID_GBU.Latex:
	              if (businessUnits.indexOf(BUSINESS_UNIT.LF) === -1) {
	                businessUnits.push(BUSINESS_UNIT.LF);
	              }
	              break;
	            case INTERNAL_ID_GBU.ThreeD:
	              if (businessUnits.indexOf(BUSINESS_UNIT.ThreeD) === -1) {
	                businessUnits.push(BUSINESS_UNIT.ThreeD);
	              }
	              break;
	            case INTERNAL_ID_GBU.Indigo:
	              if (businessUnits.indexOf(BUSINESS_UNIT.Indigo) === -1) {
	                businessUnits.push(BUSINESS_UNIT.Indigo);
	              }
	              break;
	            case INTERNAL_ID_GBU.Designjet:
	              if (businessUnits.indexOf(BUSINESS_UNIT.LF) === -1) {
	                businessUnits.push(BUSINESS_UNIT.LF);
	              }
	              break;
	            case INTERNAL_ID_GBU.Scitex:
	              if (businessUnits.indexOf(BUSINESS_UNIT.Scitex) === -1) {
	                businessUnits.push(BUSINESS_UNIT.Scitex);
	              }
	              break;
	            case INTERNAL_ID_GBU.IHPS:
	              if (businessUnits.indexOf(BUSINESS_UNIT.IHPS) === -1) {
	                businessUnits.push(BUSINESS_UNIT.IHPS);
	              }
	              break;
	          }
	        });
	      } else {
	        businessUnits.push(BUSINESS_UNIT.NONE);
	      }
	
	      return businessUnits;
	    });
	  }
	
	  function getOrgType() {
	    return getClientConfig().then(function (clientConfig) {
	      return clientConfig.context.type;
	    });
	  }
	
	  function getStartInfo() {
	    var force = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    return getClientConfig().then(function (clientConfig) {
	      return getShortCircuit(clientConfig, force).then(function (shortCircuit) {
	        var promises = [];
	        promises.push(getApplicableSteps(shortCircuit));
	        promises.push(getDefaultStartupApp(clientConfig));
	        promises.push(getShowWelcomePage(clientConfig));
	        return $q.all(promises).then(function (_ref6) {
	          var _ref62 = _slicedToArray(_ref6, 3);
	
	          var steps = _ref62[0];
	          var defaultAppId = _ref62[1];
	          var showWelcome = _ref62[2];
	
	          var startInfo = {
	            showWelcome: showWelcome,
	            defaultAppId: defaultAppId
	          };
	
	          if (shortCircuit) {
	            shortCircuitSteps(steps);
	            startInfo.hasIncompleteSteps = false;
	            startInfo.steps = steps;
	            return startInfo;
	          } else {
	            return initializeSteps(steps).then(function (steps) {
	              startInfo.hasIncompleteSteps = _.some(steps, { complete: false });
	              startInfo.steps = steps;
	
	              return startInfo;
	            });
	          }
	        })['catch'](function (error) {
	          $log.error('Error (getStartInfo)', error);
	        });
	      });
	    });
	  }
	
	  function getShortCircuit(clientConfig) {
	    var force = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    if (force) {
	      return $q.resolve(false);
	    }
	
	    var orgId = clientConfig.context.id;
	    return rnPreferences.getSingleObject('home', 'start.' + orgId).then(function (startPrefs) {
	      var version = _.get(startPrefs, 'completeSteps.finish', 0);
	      if (version === true || version === false) {
	        return false;
	      }
	
	      return version === START_VERSION;
	    });
	  }
	
	  function shortCircuitSteps(steps) {
	    _.forEach(steps, function (step) {
	      var stepDef = _.find(STEP_DEFINITIONS, { type: step.type });
	      step.complete = true;
	      step.optional = _.get(stepDef, 'optional', false);
	    });
	
	    steps.push({
	      type: STEP_NAME.finish,
	      complete: true
	    });
	  }
	
	  function initializeSteps(steps) {
	    var promises = [];
	    steps.forEach(function (step) {
	      var stepDef = _.find(STEP_DEFINITIONS, { type: step.type });
	      promises.push(stepDef.isComplete().then(function (complete) {
	        step.complete = complete;
	        step.optional = _.get(stepDef, 'optional', false);
	        return step;
	      }));
	    });
	
	    return $q.all(promises).then(function (steps) {
	      if (_.some(steps, { complete: false })) {
	        // If there are any remaining steps, add a finish step as well.
	        steps.push({
	          type: STEP_NAME.finish,
	          complete: false
	        });
	        cleanupSteps(steps);
	      } else {
	        // Otherwise, we need to return all steps as complete
	        steps.push({
	          type: STEP_NAME.finish,
	          complete: true
	        });
	        finishSteps();
	      }
	      return steps;
	    });
	  }
	
	  function getApplicableSteps(shortCircuit) {
	    if (shortCircuit) {
	      return [];
	    }
	
	    return getOrgApplicableStepsDefs().then(function (stepDefs) {
	      var promises = [];
	      stepDefs.forEach(function (stepDef) {
	        promises.push(stepDef.isPermitted().then(function (permitted) {
	          return {
	            type: stepDef.type,
	            permitted: permitted
	          };
	        }));
	      });
	
	      return $q.all(promises).then(function (sparseSteps) {
	        return _.filter(sparseSteps, { permitted: true });
	      });
	    })['catch'](function (error) {
	      console.error('Error (getApplicableSteps) - ' + error);
	    });
	  }
	
	  function isBusinessUnit(businessUnit) {
	    return getOrgInfo().then(function (orgInfo) {
	      return orgInfo.businessUnits.indexOf(businessUnit) > -1;
	    });
	  }
	
	  function getOrgApplicableStepsDefs() {
	    return getOrgInfo().then(function (orgInfo) {
	      var filteredStepDefs = _.filter(STEP_DEFINITIONS, function (stepDef) {
	        if (stepDef.hasOwnProperty('orgTypes') && !_.includes(stepDef.orgTypes, orgInfo.orgType)) {
	          return false;
	        }
	
	        if (stepDef.hasOwnProperty('businessUnits') && _.isEmpty(_.intersection(stepDef.businessUnits, orgInfo.businessUnits))) {
	          return false;
	        }
	
	        return true;
	      });
	
	      return filteredStepDefs;
	    });
	  }
	
	  function getDefaultStartupApp(clientConfig) {
	    return rnPreferences.getSingleObject('app-switcher', '' + clientConfig.context.type).then(function (myPref) {
	      // If we already have a default preference for this account we should go there
	      if (myPref && myPref.defaultAppId) {
	        return myPref.defaultAppId;
	      }
	
	      return getDefaultAppId(clientConfig);
	    })['catch'](function (error) {
	      console.error('Error (getDefaultStartupApp) - ' + error);
	    });
	  }
	
	  function getRedirectAppId() {
	    return queryPayloads().then(function (invitations) {
	      var redirectAppId = undefined;
	      _.forEach(invitations, function (invitation) {
	        redirectAppId = _.get(invitations[0], 'ext_payload.onboard.redirectAppId');
	        if (redirectAppId) {
	          return false;
	        }
	      });
	
	      return redirectAppId;
	    })['catch'](function () {});
	  }
	
	  function getDefaultAppId(clientConfig) {
	    var promises = [];
	    promises.push(getRedirectAppId());
	    promises.push(getBusinessUnits());
	    return $q.all(promises).then(function (_ref7) {
	      var _ref72 = _slicedToArray(_ref7, 2);
	
	      var redirectAppId = _ref72[0];
	      var businessUnits = _ref72[1];
	
	      var defaultAppId = undefined;
	      if (redirectAppId) {
	        defaultAppId = redirectAppId;
	      } else if (businessUnits.length === 1) {
	        var bu = businessUnits[0];
	        defaultAppId = _.get(DEFAULT_STARTUP_APP, [clientConfig.context.type, bu], DEFAULT_STARTUP_APP.DEFAULT);
	      } else {
	        defaultAppId = DEFAULT_STARTUP_APP.DEFAULT;
	      }
	
	      return rnPreferences.setSingle('app-switcher', 'defaultAppId.' + clientConfig.context.id, defaultAppId).then(function () {
	        return defaultAppId;
	      });
	    });
	  }
	
	  function getShowWelcomePage(clientConfig) {
	    var promises = [];
	    promises.push(getBusinessUnits());
	    promises.push(getSkipWelcome());
	    return $q.all(promises).then(function (_ref8) {
	      var _ref82 = _slicedToArray(_ref8, 2);
	
	      var businessUnits = _ref82[0];
	      var skipWelcome = _ref82[1];
	
	      if (clientConfig.context.type === ORG_TYPE.Generic) {
	        return false;
	      }
	
	      var showWelcome = SHOW_WELCOME_PAGE.DEFAULT;
	      if (businessUnits.length === 1) {
	        var bu = businessUnits[0];
	        showWelcome = _.get(SHOW_WELCOME_PAGE, clientConfig.context.type + '.' + bu, SHOW_WELCOME_PAGE.DEFAULT);
	      }
	
	      if (showWelcome) {
	        showWelcome = !skipWelcome;
	      }
	
	      return showWelcome;
	    })['catch'](function (error) {
	      console.error('Error (getShowWelcomePage) - ' + error);
	    });
	  }
	
	  function getSkipWelcome() {
	    return getClientConfig().then(function (clientConfig) {
	      var orgId = clientConfig.context.id;
	      var promises = [];
	      promises.push(rnPreferences.getSingleObject('home', 'start'));
	      promises.push(rnPreferences.getSingleObject('home', 'start.' + orgId));
	      return $q.all(promises).then(function (_ref9) {
	        var _ref92 = _slicedToArray(_ref9, 2);
	
	        var globalPref = _ref92[0];
	        var orgPref = _ref92[1];
	
	        var skip = _.get(globalPref, 'skipWelcome');
	        if (!skip) {
	          skip = _.get(orgPref, 'skipWelcome', false);
	        }
	        return skip;
	      });
	    });
	  }
	
	  function setSkipWelcome(skip) {
	    return getClientConfig().then(function (clientConfig) {
	      var orgId = clientConfig.context.id;
	      return rnPreferences.getSingleObject('home', 'start').then(function (p) {
	        if (!p) {
	          p = {};
	        }
	        p.skipWelcome = skip;
	        return rnPreferences.setSingleObject('home', 'start', p);
	      });
	    });
	  }
	
	  function skipStep(step) {
	    if (!step.optional) {
	      return $q.resolve(false);
	    }
	
	    return getClientConfig().then(function (clientConfig) {
	      var orgId = clientConfig.context.id;
	      return rnPreferences.getSingleObject('home', 'start.' + orgId).then(function (p) {
	        if (!p) {
	          p = {};
	        }
	
	        _.set(p, 'completeSteps.' + step.type, START_VERSION);
	        step.complete = true;
	
	        return rnPreferences.setSingleObject('home', 'start.' + orgId, p);
	      });
	    });
	  }
	
	  function finishSteps() {
	    return getClientConfig().then(function (clientConfig) {
	      var orgId = clientConfig.context.id;
	      return rnPreferences.getSingleObject('home', 'start.' + orgId).then(function (p) {
	        if (!p) {
	          p = {};
	        }
	
	        _.set(p, 'completeSteps.' + STEP_NAME.finish, START_VERSION);
	        return rnPreferences.setSingleObject('home', 'start.' + orgId, p);
	      });
	    });
	  }
	
	  function cleanupSteps(steps) {
	    var markAsIncomplete = false;
	    for (var i = 0; i < steps.length; i++) {
	      if (!markAsIncomplete) {
	        if (!steps[i].complete) {
	          markAsIncomplete = true;
	        }
	      } else {
	        steps[i].complete = false;
	      }
	    }
	  }
	}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _rhinoSrcComponentsLocaleLocaleModule = __webpack_require__(32);
	
	var _rhinoSrcComponentsLocaleLocaleModule2 = _interopRequireDefault(_rhinoSrcComponentsLocaleLocaleModule);
	
	var _tutorialService = __webpack_require__(452);
	
	var rnTutorial = _interopRequireWildcard(_tutorialService);
	
	exports['default'] = angular.module('rhino.components.tutorial', [_rhinoSrcCoreCoreModule2['default'], _rhinoSrcComponentsLocaleLocaleModule2['default']]).factory(rnTutorial.name, rnTutorial['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	rnTutorial.$inject = ["rnHttp", "rnLocale"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnTutorial;
	var name = 'rnTutorial';
	exports.name = name;
	
	function rnTutorial(rnHttp, rnLocale) {
	  'ngInject';
	
	  var SUPPORT_SERVICE = 'supportapp_service';
	
	  var service = {
	    getAll: getAll,
	    getByTitle: getByTitle
	  };
	  return service;
	
	  /////////////////
	
	  function getAll() {
	    var queryParams = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    return rnLocale.getBestFit().then(function (locale) {
	      if (!queryParams.hasOwnProperty('active')) {
	        queryParams.active = true;
	      }
	      if (!queryParams.hasOwnProperty('locale')) {
	        queryParams.locale = locale.value;
	      }
	
	      var config = {
	        params: queryParams,
	        cache: true,
	        rhino: {
	          allow401: true
	        }
	      };
	      return rnHttp.get(SUPPORT_SERVICE, 'tutorials', config).then(function (resp) {
	        return resp.data;
	      });
	    });
	  }
	
	  function getByTitle(title, type) {
	    return getAll().then(function (tutorials) {
	      return _.find(tutorials.list, function (tutorial) {
	        if (type !== undefined && type !== tutorial.type) {
	          return false;
	        }
	
	        var analyticsTitle = tutorial.analyticsTitle;
	        if (analyticsTitle) {
	          analyticsTitle = analyticsTitle.trim();
	        }
	        return analyticsTitle === title;
	      });
	    });
	  }
	}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _unsubscribeService = __webpack_require__(454);
	
	var rnUnsubscribe = _interopRequireWildcard(_unsubscribeService);
	
	exports['default'] = angular.module('rhino.components.unsubscribe', [_rhinoSrcCoreCoreModule2['default']]).service(rnUnsubscribe.name, rnUnsubscribe['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	'use strict';
	
	rnUnsubscribe.$inject = ["$log", "$q", "rnHttp", "rnRegistry"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnUnsubscribe;
	var name = 'rnUnsubscribe';
	
	exports.name = name;
	
	function rnUnsubscribe($log, $q, rnHttp, rnRegistry) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var EMAIL_SERVICE = 'email_service';
	
	  /**
	   * This is the externally facing API of the service
	   */
	  var service = {
	    unsubscribe: unsubscribe
	  };
	
	  return service;
	
	  /////////////////////
	  // Private functions
	  ////////////////////
	
	  function unsubscribe(listId) {
	    var link = {};
	    link.op = 'DELETE';
	    link.href = 'distribution-lists/' + listId + '/users';
	
	    return unsubscribeHalRequest(link);
	  }
	
	  function unsubscribeHalRequest(link, data, config) {
	    var newLink = angular.copy(link);
	    return appendServer(newLink.href).then(function (href) {
	      newLink.href = href;
	      return rnHttp.halRequest(newLink, data, config);
	    });
	  }
	
	  function appendServer(path) {
	    return rnRegistry.getUrl(EMAIL_SERVICE, path);
	  }
	}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcComponentsSessionSessionModuleJs = __webpack_require__(10);
	
	var _rhinoSrcComponentsSessionSessionModuleJs2 = _interopRequireDefault(_rhinoSrcComponentsSessionSessionModuleJs);
	
	var _userServiceJs = __webpack_require__(456);
	
	var rnUser = _interopRequireWildcard(_userServiceJs);
	
	exports['default'] = angular.module('rhino.components.user', [_rhinoSrcComponentsSessionSessionModuleJs2['default']]).factory(rnUser.name, rnUser['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	'use strict';
	
	rnUser.$inject = ["$q", "$log", "rnHttp", "rnRecordFactory", "rnRecordCollectionFactory", "rnSession"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnUser;
	var name = 'rnUser';
	exports.name = name;
	
	function rnUser($q, $log, rnHttp, rnRecordFactory, rnRecordCollectionFactory, rnSession) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var AAA_SERVICE_NAME = 'aaa';
	  var ORG_USER_PATH = 'organizations/users/';
	  var USER_CONTEXT_PATH = 'users/context/';
	  var USER_ROLE_PATH = 'users/roles/';
	  var USER_PATH = 'users/';
	
	  var service = {
	    getUserContext: getUserContext,
	    getUserRoles: getUserRoles,
	    getUserSystemRoles: getUserSystemRoles,
	    getHmacSystemRoles: getHmacSystemRoles,
	    getDeviceSystemRoles: getDeviceSystemRoles,
	    getSelectedUserOrgRoles: getSelectedUserOrgRoles,
	    getSelectedUserRoles: getSelectedUserRoles,
	    saveUserRoles: saveUserRoles,
	    removeUserRoles: removeUserRoles,
	    removeUserAccount: removeUserAccount,
	    deleteUser: deleteUser,
	    updateUserProfile: updateUserProfile,
	    getById: getById,
	    getAll: getAll,
	    validateUserToken: validateUserToken
	  };
	
	  return service;
	
	  ////////////////
	
	  function getById(id) {
	    return doAaaGet(ORG_USER_PATH + id).then(function (data) {
	      var device = createRecord(data);
	      return $q.resolve(device);
	    });
	  }
	
	  function getAll(offset, limit) {
	    return find({ offset: offset, limit: limit });
	  }
	
	  function find(params) {
	    var config = {};
	    config.params = params;
	
	    return doAaaGet(ORG_USER_PATH, config).then(function (userCollection) {
	      var userRecords = undefined;
	      var userRecordsCollection = undefined;
	
	      userRecords = _.map(userCollection.users, createRecord);
	      userCollection.users = userRecords;
	      userRecordsCollection = rnRecordCollectionFactory.create(userCollection);
	
	      return $q.resolve(userRecordsCollection);
	    });
	  }
	
	  function createRecord(data) {
	    var user = rnRecordFactory.create(data);
	
	    // JVM - hack - set id attribute for a consistent model.
	    // This should be changed at the server.
	    user.internal.idName = 'userId';
	    return user;
	  }
	
	  function generate() {
	    // TODO DJL - This method requests the model structure from the server. We need server-side implementation to support this
	  }
	
	  function getUserContext() {
	
	    return doAaaGet(USER_CONTEXT_PATH);
	  }
	
	  function getSelectedUserOrgRoles(id) {
	    // DJL - until we have the JSON/HAL design implemented on the server we will
	    // have to perform this type of surgery
	    var path = ORG_USER_PATH + id + '/roles';
	
	    return doAaaGet(path);
	  }
	
	  function getSelectedUserRoles() {
	
	    return doAaaGet(USER_ROLE_PATH, { params: { limit: 1000 } });
	  }
	
	  // Continue to call version 1 for backwards compatibility. Clients ideally should call getXSystemRoles instead.
	  function getUserRoles(id) {
	    var path = 'systemroles?' + id + 'Role=true';
	
	    return doAaaGet(path, { version: 1 });
	  }
	
	  function getUserSystemRoles(organizationType) {
	    var path = 'systemroles?' + 'entityType=User' + '&organizationType=' + organizationType;
	    if (organizationType === "HP") {
	      // Tell the service to perform a check to see if the HP Operation role should be included in the list of roles returned
	      path += '&hpOperationCheck=true';
	    }
	
	    return doAaaGet(path);
	  }
	
	  function getHmacSystemRoles(organizationType) {
	    var path = 'systemroles?' + 'entityType=HMAC' + '&organizationType=' + organizationType;
	
	    return doAaaGet(path, { cache: true });
	  }
	
	  function getDeviceSystemRoles(organizationType) {
	    var path = 'systemroles?' + 'entityType=Device' + '&organizationType=' + organizationType;
	
	    return doAaaGet(path);
	  }
	
	  function saveUserRoles(userID, roles) {
	    var path = ORG_USER_PATH + userID + '/roles';
	
	    return doAaaPost(path, roles);
	  }
	
	  /**
	   * This function is a little tricky because of the AAA schema.  When we get called, we have the ID of the
	   * system role (e.g. "Owner") and we have to go get all of the roles assigned to this user and check each one
	   * for that ID.  Once we find it, the actual role ID we want to delete is userRoleId in that structure.
	   */
	  function removeUserRoles(userId, systemRoleId) {
	    // The roleId passed in is the systemRoleId.  Get the roles for the user, then find the one that matches.
	    return getSelectedUserOrgRoles(userId).then(function (userRoles) {
	      angular.forEach(userRoles.userRoles, function (userRole, key) {
	        if (userRole.systemRole.id === systemRoleId) {
	          return doAaaDelete(ORG_USER_PATH + userId + '/roles/' + userRole.userRoleId);
	        }
	      });
	    });
	  }
	
	  function removeUserAccount(accountId) {
	
	    return doAaaDelete(USER_CONTEXT_PATH + accountId);
	  }
	
	  function deleteUser(userId) {
	    return rnHttp['delete'](AAA_SERVICE_NAME, ORG_USER_PATH + userId);
	  }
	
	  function updateUserProfile(userInfo) {
	    return doAaaPut(USER_PATH, userInfo).then(function () {
	      return rnSession.updateUserInfo(userInfo);
	    });
	  }
	
	  function validateUserToken() {
	    var path = USER_PATH + 'validate';
	    return doAaaGet(path, {});
	  }
	
	  function doAaaGet(path) {
	    var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    return rnSession.isAuthenticated().then(function (auth) {
	      if (auth) {
	        return rnHttp.get(AAA_SERVICE_NAME, path, config).then(function (resp) {
	          $log.debug('Successful ' + path + ' request: ', resp.data);
	          return $q.resolve(resp.data);
	        });
	      } else {
	        return $q.reject({ status: 401, statusText: 'Unauthenticated' });
	      }
	    });
	  }
	
	  function doAaaPost(path, content) {
	    return rnHttp.post(AAA_SERVICE_NAME, path, content);
	  }
	
	  function doAaaDelete(path) {
	    return rnHttp['delete'](AAA_SERVICE_NAME, path);
	  }
	
	  function doAaaDeleteWithContent(path, content) {
	    return rnHttp.deleteWithBody(AAA_SERVICE_NAME, path, content);
	  }
	
	  function doAaaPut(path, content) {
	    return rnHttp.put(AAA_SERVICE_NAME, path, content);
	  }
	}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var name = 'rnAUTH_EVENTS';
	
	exports.name = name;
	exports['default'] = {
	  signinSuccess: 'auth-signin-success',
	  signinFailure: 'auth-signin-failed',
	  signinCanceled: 'auth-signin-canceled',
	  signoutSuccess: 'auth-signout-success',
	  contextSuccess: 'auth-context-success',
	  contextFailure: 'auth-context-failure',
	  sessionTimeout: 'auth-session-timeout',
	  authenticated: 'auth-authenticated',
	  notAuthenticated: 'auth-not-authenticated'
	  // notAuthorized:    'auth-not-authorized'
	};

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	'use strict';
	
	rnAuthInterceptor.$inject = ["$log", "$q", "$injector", "$rootScope", "rnAUTH_EVENTS"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnAuthInterceptor;
	var name = 'rnAuthInterceptor';
	exports.name = name;
	
	function rnAuthInterceptor($log, $q, $injector, $rootScope, rnAUTH_EVENTS) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // misbehaving APIs or APIs that we don't want to attempt to revalidate to user session
	  var BLACKLIST = ['/api/aaa/v1/users/validate', // returns 401 instead of 404 as it should
	  '/api/aaa/v1/users/login', // returns 401 instead of 404 as it should
	  '/api/aaa/v1/users/logout', '/api/supportapp-service/v1/askexpert/questioncharacteristics/retrieveAll', // TODO: Help app should not be making authenticated calls with anonymous user
	  '/api/PrintbeatService/PerformanceTracking/WeeklyReport/many', // TODO: this was blocking reseller login
	  '/api/notification-service/v1/'];
	
	  // APIs that we do want to pop up a sign-in dialog if it returns a 401.
	  // system notifications currently return 401 for an unauthenticated user but shouldn't
	  var WHITELIST = [];
	
	  var service = {
	    responseError: responseError
	  };
	
	  return service;
	
	  /////////////////
	
	  function responseError(response) {
	    // This interceptor only cares about security status errors - 401 (unauthenticated)
	    if (response.status === 401) {
	      // If it is in the white list then we really do want to pop a sign-in dialog now.
	      if (checkAPI(WHITELIST, response)) {
	        $log.debug('401 returned from Whitelisted API - broadcast a notAuthenticated event now');
	        $rootScope.$broadcast(rnAUTH_EVENTS.notAuthenticated, response);
	      }
	      // If it's not in the blacklist or accepted through config then revalidate the session with AAA
	      else if (!allowBypass(response)) {
	          $log.debug('Validating user with AAA - got a 401 from ' + response.config.url);
	          //rnAuthService.validate();
	          var rnAuthService = $injector.get('rnAuthService');
	          rnAuthService.authenticate(true, true, false);
	        }
	    }
	    return $q.reject(response);
	  }
	
	  /**
	   * @returns { match<Boolean>} [Indicates this APIs was found in the list]
	   */
	  function checkAPI(list, response) {
	    return _.includes(list, getPathFromURL(response.config.url));
	  }
	
	  /**
	   * @returns {boolean} true if request can bypass authentication, false otherwise
	   */
	  function allowBypass(response) {
	    if (checkAPI(BLACKLIST, response)) {
	      return true;
	    }
	
	    return _.get(response.config, 'rhino.allow401', false);
	  }
	
	  /**
	   * getPathFromURL - return the path portion from a full URL
	   */
	  function getPathFromURL(url) {
	    // Use the browsers native URL creation/parsing to get the path - significantly faster then writing our own js code
	    var parser = document.createElement('a');
	    parser.href = url;
	    var path = parser.pathname;
	    if (path.charAt(0) !== '/') {
	      // Ensure path starts with a leading slash (in IE11 it does not).
	      path = '/' + path;
	    }
	    return path;
	  }
	}
	
	//rnAuthInterceptor

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	rnAuthService.$inject = ["$log", "$q", "$rootScope", "rnHttp", "rnSingSession", "rnAUTH_EVENTS", "rnClient"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnAuthService;
	var name = 'rnAuthService';
	
	exports.name = name;
	
	function rnAuthService($log, $q, $rootScope, rnHttp, rnSingSession, rnAUTH_EVENTS, rnClient) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var self = this;
	  var AAA_SERVICE_NAME = 'aaa';
	  var USER_SIGNIN_PATH = 'users/login';
	  var USER_SIGNOUT_PATH = 'users/logout';
	  var DEVICE_SIGNOUT_PATH = 'devices/logout';
	  // const USER_CONTEXTS_PATH       = 'users/context?limit=1000';
	  // const USER_SWITCH_CONTEXT_PATH = 'users/context';
	
	  var CACHE_BUST_TIME = 1000 * 10; // in milliseconds
	  var FAR_IN_THE_FUTURE = 3600000 * 24; // One day => 3,600,000 miliseconds in an hour
	
	  // Set the time to check with AAA to some time in the past so our first validate call will always trigger a real HTTP request
	  var timeToCheckWithAAA = new Date(0);
	  // First time through, use the cached version from blue
	  var cacheClientConfig = true;
	
	  // signin and validate set/return validateDeferred so that when validate uses the cache we just return a valid promise.
	  var validateDeferred = undefined;
	  var validateRequestInProgress = false;
	
	  var authnticatedNotificationSent = false;
	
	  var service = {
	    signin: signin,
	    signout: signout,
	    validate: validate,
	    authenticate: authenticate,
	    isAuthenticated: rnSingSession.isAuthenticated,
	    isClientAuthenticated: isClientAuthenticated
	  };
	
	  return service;
	
	  function signin(credentials) {
	    validateDeferred = $q.defer();
	    var config = {
	      rhino: {
	        allow401: true
	      }
	    };
	    rnHttp.post(AAA_SERVICE_NAME, USER_SIGNIN_PATH, credentials, config).then(function (resp) {
	      $log.debug(name + '#signin (POST) response:', resp);
	      // alias 'user' to 'entity' to conform with client config API
	      resp.data.entity = resp.data.user;
	      resp.data.entity.id = resp.data.entity.userId;
	      setCurrentUser(resp.data);
	      $rootScope.$broadcast(rnAUTH_EVENTS.signinSuccess);
	      validateDeferred.resolve(resp);
	    })['catch'](function (resp) {
	      $log.debug('Signin failed:', resp.status);
	      ensureNoUser();
	      $rootScope.$broadcast(rnAUTH_EVENTS.signinFailure);
	      validateDeferred.reject(resp);
	    });
	    return validateDeferred.promise;
	  }
	
	  function validate() {
	    // If we already have an http request in progress then don't do anything - just return the existing promise.
	    if (!validateRequestInProgress) {
	      // throttle the (real) http requests by using the cache for a few seconds - this helps during the initial startup/load of an app
	      var refreshCache = Date.now() > timeToCheckWithAAA;
	      if (refreshCache) {
	        validateRequestInProgress = true;
	        validateDeferred = $q.defer();
	        rnClient.getConfig(cacheClientConfig).then(function (clientConfig) {
	          cacheClientConfig = false;
	
	          var hasSignInLink = _.get(clientConfig, '_links.signIn') !== undefined;
	          if (hasSignInLink) {
	            $log.debug(name + '#validate user is not authenticated');
	            ensureNoUser();
	            return validateDeferred.reject(clientConfig);
	          }
	
	          $log.debug(name + '#validate (GET) response:', clientConfig);
	          setCurrentUser(clientConfig);
	          return validateDeferred.resolve(clientConfig);
	        })['catch'](function (resp) {
	          $log.debug(name + '#validate failed to get client config', resp);
	          ensureNoUser();
	          return validateDeferred.reject(resp);
	        })['finally'](function () {
	          validateRequestInProgress = false;
	        });
	      } else {
	        $log.debug(name + '#validate: Using cache - next validation with AAA will be after: ', new Date(timeToCheckWithAAA).toString());
	      }
	    }
	    return validateDeferred.promise;
	  } //validate
	
	  function signout() {
	    return rnClient.getConfig(false).then(function (clientConfig) {
	      // Extend supporting sign out for users and users
	      var path = undefined;
	      var entityType = _.get(clientConfig, 'entity.type', 'User');
	      switch (entityType) {
	        case 'User':
	          path = USER_SIGNOUT_PATH;
	          break;
	        case 'Device':
	          path = DEVICE_SIGNOUT_PATH;
	          break;
	      }
	
	      var config = {
	        rhino: {
	          allow401: true
	        }
	      };
	      return rnHttp['delete'](AAA_SERVICE_NAME, path, config).then(function (resp) {
	        $log.debug(name + '#signout (DELETE) response:', resp);
	        return resp;
	      })['catch'](function (resp) {
	        $log.warn(name + '#signout: Failed to signout of server', resp);
	        // This code was not correctly returning a rejected promise
	        // and has been updated merely to return the response instead of undefined.
	        // This maintains the extisting API behavior.
	        return resp;
	      })['finally'](function () {
	        ensureNoUser();
	        $rootScope.$broadcast(rnAUTH_EVENTS.signoutSuccess);
	      });
	    });
	  }
	
	  function authenticate() {
	    var require_authentication = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	    var reloadOnSignin = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	    var blackoutOnSignin = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	    $log.debug(name + '#authenticate called');
	    var route = $q.defer();
	
	    // if (!require_authentication || rnSingSession.isAuthenticated()) {
	    if (!require_authentication) {
	      $log.debug(name + '#authenticate - anonymous route or user already authenticated, resolve route');
	      return route.resolve();
	    } else {
	      // first check with server
	      validate().then(function (user) {
	        $log.debug(name + '#authenticate - user really was signed in - we had to wait for server response');
	        return route.resolve();
	      })['catch'](function () {
	        $log.debug(name + '#authenticate - user is anonymous, request a sign-in');
	        $rootScope.$broadcast(rnAUTH_EVENTS.notAuthenticated, {
	          resolver: 'require authentication',
	          reloadOnSignin: reloadOnSignin,
	          blackoutOnSignin: blackoutOnSignin
	        });
	
	        $rootScope.$on(rnAUTH_EVENTS.signinSuccess, function (event, args) {
	          $log.debug(name + '#authenticate: sign-in success:', event, args);
	          return route.resolve();
	        });
	        $rootScope.$on(rnAUTH_EVENTS.signinCanceled, function (event, args) {
	          $log.debug(name + '#authenticate: sign-in failure:', event, args);
	          return route.reject();
	        });
	      });
	      $log.debug('returning promise for route - need to wait for sign-in');
	      return route.promise;
	    }
	  }
	
	  /**
	   * Lightweight check to see if the user is connected with the cached client config.
	   */
	  function isClientAuthenticated() {
	    return rnClient.getConfig().then(function (clientConfig) {
	      var hasSignInLink = _.get(clientConfig, '_links.signIn') !== undefined;
	      if (hasSignInLink) {
	        $rootScope.$broadcast(rnAUTH_EVENTS.notAuthenticated, {
	          resolver: 'require authentication'
	        });
	
	        // Ok, let me explain. We need to return an unresolvable promise to mimic what
	        // was going on authenticate(). We want blue to redirect to sign-in and for ui-router
	        // to wait for that redirect. If we reject here, we end up with a timing window where
	        // the user could get redirected back to a Not Found page.
	        return $q.defer().promise;
	      }
	
	      return $q.resolve(clientConfig);
	    });
	  }
	
	  /**
	   * Private methods
	   */
	  function setCurrentUser(clientConfig) {
	    $log.debug(name + '#setCurrentUser - ', clientConfig);
	    rnSingSession._create(clientConfig.entity.id, clientConfig.entity, clientConfig.context);
	    timeToCheckWithAAA = Date.now() + CACHE_BUST_TIME;
	    if (!authnticatedNotificationSent) {
	      $rootScope.$broadcast(rnAUTH_EVENTS.authenticated, clientConfig);
	      authnticatedNotificationSent = true;
	    }
	  }
	
	  function ensureNoUser() {
	    $log.debug(name + '#ensureNoUser');
	    rnSingSession._destroy();
	    authnticatedNotificationSent = false;
	    // If they are signed out, there is no point in checking with AAA - the won't magically be signed-in.
	    // We do check when they are signed-in becuase they can expire or be forced off the sytem.
	    timeToCheckWithAAA = Date.now() + FAR_IN_THE_FUTURE;
	  }
	}
	
	//rnAuthService

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	'use strict';
	
	rnSingSession.$inject = ["$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnSingSession;
	var name = 'rnSingSession';
	
	exports.name = name;
	
	function rnSingSession($log) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	  var self = this;
	
	  self.authenticated = undefined;
	
	  var service = {
	    id: undefined,
	    user: {},
	    context: {},
	    isAuthenticated: isAuthenticated,
	    _create: _create,
	    _destroy: _destroy
	  };
	
	  return service;
	
	  function isAuthenticated() {
	    return self.authenticated;
	  }
	
	  function _create(sessionId, user, context) {
	    $log.debug('rnSingSession#create');
	    service.id = sessionId;
	    service.user = angular.copy(user);
	    service.context = angular.copy(context);
	    self.authenticated = true;
	  }
	
	  function _destroy() {
	    $log.debug('rnSingSession#destroy');
	    service.id = null;
	    service.user = {};
	    service.context = {};
	    self.authenticated = false;
	  }
	}
	
	//rnSingSession

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	'use strict';
	
	rnBlue.$inject = ["$q", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnBlue;
	var POSB_READY_EVENT = 'posb-ready';
	
	exports.POSB_READY_EVENT = POSB_READY_EVENT;
	var name = 'rnBlue';
	exports.name = name;
	
	function rnBlue($q, $window) {
	  'ngInject';
	
	  var blueApiDeferred = $q.defer();
	
	  var service = {
	    getBlueApi: getBlueApi,
	    getRegistryHost: getRegistryHost
	  };
	
	  activate();
	  return service;
	
	  //////////////
	
	  function activate() {
	    var blueApi = _.get($window, 'printos.blue.ui', {});
	    if (blueApi.readyState === 'complete') {
	      blueApiDeferred.resolve(blueApi);
	    } else {
	      // Intentionally use window instead of $window here since this is in activation,
	      // which is causing any tests that mock up window to fail.
	      window.addEventListener(POSB_READY_EVENT, function () {
	        blueApiDeferred.resolve(_.get($window, 'printos.blue.ui'));
	      });
	    }
	  }
	
	  function getBlueApi() {
	    return blueApiDeferred.promise;
	  }
	
	  /**
	   * @returns {String} the PrintOS registry host, if configured for blue
	   */
	  function getRegistryHost() {
	    return _.get($window, 'printos.blue.ui.registry.host');
	  }
	}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnClientProvider;
	var CLIENT_CONFIG_PATH = '/api/portal/v1/client/config';
	
	exports.CLIENT_CONFIG_PATH = CLIENT_CONFIG_PATH;
	var name = 'rnClient';
	
	exports.name = name;
	
	function rnClientProvider() {
	  rnClient.$inject = ["$q", "$http", "$window", "rnBlue"];
	  var useBlue = true;
	
	  _.assign(this, {
	    useBlueApi: useBlueApi,
	    $get: rnClient
	  });
	  return;
	
	  function useBlueApi() {
	    var doUseBlue = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    useBlue = doUseBlue;
	  }
	
	  function rnClient($q, $http, $window, rnBlue) {
	    'ngInject';
	
	    var service = {
	      getConfig: getConfig
	    };
	    return service;
	
	    function getConfig() {
	      var cache = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      if (useBlue) {
	        return rnBlue.getBlueApi().then(function (api) {
	          return $q.when(api.getClientConfig(cache));
	        });
	      }
	
	      return $http.get(getHost() + CLIENT_CONFIG_PATH, {
	        cache: cache,
	        rhino: {
	          serviceName: 'portal_service'
	        }
	      }).then(function (resp) {
	        return resp.data;
	      });
	    }
	
	    function getHost() {
	      // Allow for overriding registry host
	      if ($window.RN_SERVICE_REGISTRY) {
	        return $window.RN_SERVICE_REGISTRY;
	      }
	
	      // Fallback to blue registry host
	      var blueRegistryHost = rnBlue.getRegistryHost();
	      if (blueRegistryHost) {
	        return blueRegistryHost;
	      }
	
	      // No registry host configured
	      return '';
	    }
	  }
	}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	rhinoConfig.$inject = ["$compileProvider", "$logProvider", "$httpProvider", "$cookiesProvider", "rnDebugEnabled", "$locationProvider", "$qProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rhinoConfig;
	
	function rhinoConfig($compileProvider, $logProvider, $httpProvider, $cookiesProvider, rnDebugEnabled, $locationProvider, $qProvider) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // if (__DEV__) { console.log('Rhino Config: Starting...'); }
	
	  ///////////////////////////
	  // Configure Compile Settings
	  ///////////////////////////
	
	  // Optimize angular gernated markup - don't include css hints that protractor and batarang need while in production
	  $compileProvider.debugInfoEnabled(rnDebugEnabled);
	
	  // Required for angular 1.6 changes
	  // See https://docs.angularjs.org/guide/migration#migrate1.5to1.6-ng-services-$compile
	  $compileProvider.preAssignBindingsEnabled(true);
	
	  // Necessary because angular 1.6 has '!' as the default hash prefix.
	  // See https://github.com/angular/angular.js/issues/15496
	  $locationProvider.hashPrefix('');
	
	  ///////////////////////////
	  // Configure cookie Settings
	  ///////////////////////////
	
	  // Configure $cookiesProvider so that we can use cookies across all subdomains, make them only usable only if secure
	  $cookiesProvider.defaults = {
	    path: '/',
	    secure: true
	  };
	
	  // Angular 1.6 - log errors for unhandled promises when in dev mode
	  $qProvider.errorOnUnhandledRejections((false));
	
	  // if (__DEV__) { console.log('Rhino Config: Finished.'); }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	runRhinoRun.$inject = ["$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = runRhinoRun;
	
	function runRhinoRun($log) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var rhinoVersion = 'unknown';
	  /* global __RHINO_VERSION__ */
	  if (true) {
	    rhinoVersion = ("1.9.1");
	  }
	  $log.info(" __   __         ___  __   __  \n" + "|__) |__) | |\\ |  |  /  \\ /__` \n" + "|    |  \\ | | \\|  |  \\__/ .__/ \n");
	
	  $log.info('Rhino version: ' + rhinoVersion);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	'use strict';
	
	httpConfig.$inject = ["$httpProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = httpConfig;
	
	function httpConfig($httpProvider) {
	  'ngInject';
	
	  ///////////////////////////
	  // Configure HTTP Settings
	  ///////////////////////////
	
	  // set the default header content-type to application/json for DELETE - we sometimes send JSON data on delete
	  if (!$httpProvider.defaults.headers['delete']) {
	    $httpProvider.defaults.headers['delete'] = {};
	  }
	  $httpProvider.defaults.headers['delete']['Content-Type'] = 'application/json';
	
	  // Turn caching off by default.  We wanted to have this on so multiple requests
	  // to the same url at the same time result in only on request.
	  // However, this led to caching GETs which caused update issues with our REST APIs.
	  $httpProvider.defaults.cache = false;
	  // Improve performance during bootstrap when there are many http requests at once.
	  $httpProvider.useApplyAsync(true);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	/**
	 * Wraps a promise as an angular HTTP promise with `success` and `error` methods
	 * that extract the HTTP response data.
	 *
	 * Adapted from angular source: https://github.com/angular/angular.js/blob/master/rhino/src/ng/http.js#L957
	 * To proxy known http promise methods.
	 *
	 * (Extracted to its own file to aide in creating mock responses in testing.)
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = wrapHttpPromise;
	
	function wrapHttpPromise(promise) {
	  promise.success = function (fn) {
	    promise.then(function (response) {
	      fn(response.data, response.status, response.headers, response.config);
	    });
	    return promise;
	  };
	
	  promise.error = function (fn) {
	    promise.then(null, function (response) {
	      if (_.has(response, 'config')) {
	        fn(response.data, response.status, response.headers, response.config);
	      } else {
	        // May be an error from rnRegistry, not a response object.
	        fn(response, null, null, response.config);
	      }
	    });
	    return promise;
	  };
	
	  return promise;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	rnHttp.$inject = ["rnRegistry", "$http", "$log", "$q"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnHttp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _httpPromiseJs = __webpack_require__(466);
	
	var _httpPromiseJs2 = _interopRequireDefault(_httpPromiseJs);
	
	var name = 'rnHttp';
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.core.http.service:rnHttp
	 * @description Proxy for $http calls that reference services from `rnRegistry`.
	 * This service will resolve the registry data in a central service, keeping rhino
	 * code from having to wrap an extra promise.
	 *
	 * This service returns promises wrapped with the now deprecated `success` and `error` methods.
	 * It is recommended to use the standard promise `then` and `catch` methods instead, which
	 * return a response object.
	 *
	 * @example
	 * Get preferences from the portal service,
	 * ```js
	 * rnHttp.get('portal_service', 'preferences')
	 *  .then(response => {})
	 *  .catch(response => {});
	 * ```
	 */
	
	function rnHttp(rnRegistry, $http, $log, $q) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var service = {
	    simpleRequest: simpleRequest,
	    request: request,
	    halRequest: halRequest,
	    get: createShortcut('GET'),
	    post: createShortcutWithContent('POST'),
	    put: createShortcutWithContent('PUT'),
	    patch: createShortcutWithContent('PATCH'),
	    'delete': createShortcut('DELETE'),
	    // PrintOS has some deletes with content.
	    // However, $http doesn't have data on their API.
	    // Creating a separate method to keep a faithful proxy.
	    deleteWithBody: createShortcutWithContent('DELETE'),
	    head: createShortcut('HEAD'),
	    resolveWithData: resolveWithData,
	    rejectWithSmsError: rejectWithSmsError
	  };
	
	  return service;
	
	  ////////////////
	
	  /**
	   * @ngdoc function
	   * @name simpleRequest
	   * @methodOf rhino.core.http.service:rnHttp
	   * @description Proxy for base $http function.
	   * @param {IRequestConfig} config $http config object
	   * @returns {IHttpPromise<T>} proxy for angular $http request promise
	   *  with **deprecated** `success` and `error` convenience functions.
	   * @see https://docs.angularjs.org/api/ng/service/$http
	   */
	  function simpleRequest() {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    return (0, _httpPromiseJs2['default'])($http(config));
	  }
	
	  /**
	   * @ngdoc function
	   * @methodOf rhino.core.http.service:rnHttp
	   * @description Proxy for base $http function.
	   * @param {string} serviceName name of the service to make a request against
	   * @param {string} path service relative request path
	   * @param {IRequestConfig} config $http config object
	   * @returns {IHttpPromise<T>} proxy for angular $http request promise
	   *  with **deprecated** `success` and `error` convenience functions.
	   * @see https://docs.angularjs.org/api/ng/service/$http
	   */
	  function request(serviceName, path) {
	    var config = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    var promise = rnRegistry.getUrl(serviceName, path, true, config.version).then(function (url) {
	      config.url = url;
	      //$log.debug('Rhino requesting url ' + url);
	      return $http(config);
	    });
	
	    return (0, _httpPromiseJs2['default'])(promise);
	  } //request
	
	  /**
	   * @ngdoc function
	   * @methodOf rhino.core.http.service:rnHttp
	   * @description Proxy for an $http request based on a Genesis HAL link.
	   * @param {object} link Genesis HAL link
	   * @param {string} link.op HTTP method
	   * @param {string} link.href HTTP URL
	   * @param {*} data content to send in the request.  May be null.
	   * @param {IRequestConfig} config additional $http config
	   * @param {string} relativeToService service the path should be relative.  Should be null for absolute URLs.
	   * @returns {IHttpPromise<T>} request promise
	   */
	  function halRequest(link, data, config, relativeToService) {
	    if (!config) {
	      config = {};
	    }
	    if (!config.headers) {
	      config.headers = {};
	    }
	    // If there is no Content-Type specified and we are not told to allow undefined Content-Type, then provide a default. There are some
	    // cases where the caller needs to explicitly pass an undefined Content-Type. For example, to tell the browser to add the
	    // multipart/form-data type for you and automatically add the boundaries. If you set the Content-Type yourself to multipart/form-data
	    // then the boundaries will not be filled in and your request will fail.
	    if (!config.headers['Content-Type'] && !(config.hasOwnProperty('rhino') && config.rhino.allowUndefinedContentType)) {
	      config.headers['Content-Type'] = 'application/json';
	    }
	
	    if (link.op) {
	      config.method = link.op;
	    } else {
	      $log.warn('halRequest: HAL link missing "op" property for HTTP method. Modify the server API for consistency.');
	    }
	    if (link.href) {
	      config.url = link.href;
	    } else {
	      $log.warn('halRequest: HAL link missing "href" property. Modify the server API for consistency.');
	    }
	
	    if (data) {
	      config.data = data;
	    }
	
	    if (!relativeToService) {
	      return (0, _httpPromiseJs2['default'])($http(config));
	    } else {
	      return request(relativeToService, link.href, config);
	    }
	  } //halRequest
	
	  /**
	   * Creates a shortcut function for a request, mirroring $http shortcut methods.
	   *
	   * @param httpMethod method name to create a shortcut for
	   * @returns {Function}
	   */
	  function createShortcut(httpMethod) {
	    return function (serviceName, path, config) {
	      if (!config) {
	        config = {};
	      }
	      config.method = httpMethod;
	
	      return request(serviceName, path, config);
	    };
	  } //createShortcut
	
	  /**
	   * Creates a shortcut function for a request with a body, mirroring $http shortcut methods.
	   *
	   * @param httpMethod method name to create a shortcut for
	   * @returns {Function}
	   */
	  function createShortcutWithContent(httpMethod) {
	    return function (serviceName, path, data, config) {
	      if (!config) {
	        config = {};
	      }
	      config.data = data;
	      config.method = httpMethod;
	      // Our DELETE with data requires application/json content type
	      if (!config.headers) {
	        config.headers = {};
	      }
	      // If there is no Content-Type specified and we are not told to allow undefined Content-Type, then provide a default. There are some
	      // cases where the caller needs to explicitly pass an undefined Content-Type. For example, to tell the browser to add the
	      // multipart/form-data type for you and automatically add the boundaries. If you set the Content-Type yourself to multipart/form-data
	      // then the boundaries will not be filled in and your request will fail.
	      if (!config.headers['Content-Type'] && !(config.hasOwnProperty('rhino') && config.rhino.allowUndefinedContentType)) {
	        config.headers['Content-Type'] = 'application/json';
	      }
	
	      return request(serviceName, path, config);
	    };
	  } //createShortcut
	
	  /**
	   * @ngdoc function
	   * @name resolveWithData
	   * @methodOf rhino.core.http.service:rnHttp
	   * @description Simple function to use as a default handler to resolve a promise with response data.
	   * @param {object} response http response
	   * @returns {Promise<object>} a resolved promise with the response data
	   *   or returns a rejected promise if response data is missing
	   * @example
	   * ```javascript
	   *  rnHttp.get('some_service', 'some/path')
	   *    .then(rnHttp.resolveWithData)
	   *    .catch(rnHttp.rejectWithSmsError);
	   * ```
	   */
	  function resolveWithData(response) {
	    var data = _.get(response, 'data');
	    if (data === undefined) {
	      var errResponse = {
	        data: {
	          smsError: {
	            message: 'resolveWithData() expected response data'
	          }
	        }
	      };
	      return $q.reject(errResponse);
	    }
	
	    return $q.resolve(data);
	  }
	
	  /**
	   * @ngdoc function
	   * @name rejectWithSmsError
	   * @methodOf rhino.core.http.service:rnHttp
	   * @description Simple function to use as a default error handler to reject a promise with the typical PrintOS SmsError.
	   * @param {object} response http response
	   * @returns {Promise<object>} a rejected promise with the SmsError
	   *   or the response itself if the response does not have 'data.smsError'.
	   * @example
	   * ```javascript
	   *  rnHttp.get('some_service', 'some/path')
	   *    .then(rnHttp.resolveWithData)
	   *    .catch(rnHttp.rejectWithSmsError);
	   * ```
	   */
	  function rejectWithSmsError(response) {
	    return $q.reject(_.get(response, 'data.smsError', response));
	  }
	}
	
	//rnHttp

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	installInterceptorConfig.$inject = ["$httpProvider"];
	rnWithCredentialsInterceptor.$inject = ["$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.installInterceptorConfig = installInterceptorConfig;
	exports['default'] = rnWithCredentialsInterceptor;
	var name = 'rnWithCredentialsInterceptor';
	
	exports.name = name;
	
	function installInterceptorConfig($httpProvider) {
	  'ngInject';
	
	  // Don't include this while testing because of problems with extra $http calls
	  /* global __TEST__ */
	  if (true) {
	    $httpProvider.interceptors.push(name);
	  }
	}
	
	function rnWithCredentialsInterceptor($window) {
	  'ngInject';
	
	  var mainDomain = undefined;
	
	  var interceptor = {
	    request: request
	  };
	
	  activate();
	  return interceptor;
	
	  /////////////////
	
	  function activate() {
	    var hostnameParts = $window.location.hostname.split('.');
	    if (hostnameParts.length >= 3) {
	      // If we're on a subdomain, extract the main domain
	      mainDomain = hostnameParts.slice(-3).join('.');
	    }
	  }
	
	  function request(config) {
	    if (mainDomain) {
	      // If requested url is a string (it can be a TrustedObject)
	      // and contains the main domain, ensure withCredentials is set for the auth token cookie
	      // to be sent with CORS requests. We used to set this with every request, but that
	      // caused issues with other domains (cdn.printos.com in particular).
	      if (_.isString(config.url) && _.includes(config.url, mainDomain)) {
	        config.withCredentials = true;
	      }
	    }
	    return config;
	  }
	}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	'use strict';
	
	rnRecordFactory.$inject = ["rnHttp"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = rnRecordFactory;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var name = 'rnRecordFactory';
	
	exports.name = name;
	/**
	 * @ngdoc service
	 * @name rhino.core.record.service:rnRecordFactory
	 * @description Creates a common implementation of the Active Record pattern by Matrin Fowler
	 * using Genesis JSON+HAL (Hypertext Application Language) links.
	 * Data for objects are merge directly from server responses into a new record by using the `create` method.
	 *
	 * Any data and objects used internally by the UI and not meant to be sent back to the server
	 * is stored on the `internal` child object.
	 *
	 * A number of `canXXXX` functions exist to check if an operation is allowed.
	 * These functions check if HAL links exist for the requested operation.
	 * If an operation is not allowed, trying to invoke that operation will throw an error.
	 *    Side discussion: should it return a failed promise instead?
	 *    No, it should fail spectacularly if the caller didn't check the corresponding `can` function.
	 *    Yes, since these functions already return promises.  But, then we have to create a record with the `$q` dependency as well.
	 *
	 * Each operation function (`save`, `create`, `delete`, `update`) returns a promise
	 * that is resolved after the server responds to the request.
	 * The `save` operation is a shortcut to `create` if the record is new or `update` if the record already exists.
	 * The record is determined to exist if it has an `id` attribute (or the attribute specified in `internal.idName`).
	 */
	
	function rnRecordFactory(rnHttp) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // (Class definition must come before factory is returned because class definitions are not hoisted.)
	
	  var RhinoRecord = (function () {
	    function RhinoRecord(data) {
	      _classCallCheck(this, RhinoRecord);
	
	      // Store internals on a separate object.
	      // Could also create an "addInternalProperty" method that
	      // uses Object.defineProperty to create an non-enumerable property on the object
	      this.internal = {};
	      this.internal.idName = 'id';
	
	      // Bind server returned data to do this object
	      angular.extend(this, data);
	    }
	
	    // RhinoRecord
	
	    /**
	     * Creates a new, independent record.
	     * @returns {Object}
	     */
	
	    _createClass(RhinoRecord, [{
	      key: 'clone',
	      value: function clone() {
	        return angular.copy(this);
	      }
	    }, {
	      key: 'throwInvalidOp',
	      value: function throwInvalidOp(op) {
	        throw {
	          error: 'Invalid operation "' + op + '" for record',
	          record: this
	        };
	      }
	
	      /**
	       * @ngdoc function
	       * @name getData
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @description Get just the data portion of this record (typically before sending to the server)
	       * @returns {object} just the data portion of this record without any internal data or objects
	       */
	    }, {
	      key: 'getData',
	      value: function getData() {
	        // remove class variables
	        return _.omit(this, ['internal']);
	      }
	
	      /**
	       * @ngdoc function
	       * @name save
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @description The `save` operation is a shortcut to `create` if the record is new or `update` if the record already exists.
	       * @returns {IHttpPromise<T>} a server request promise
	       * @throws unless `canSave`
	       */
	    }, {
	      key: 'save',
	      value: function save() {
	        if (!this.canSave()) {
	          this.throwInvalidOp('save');
	        }
	
	        if (this.isNew()) {
	          return this.create();
	        }
	        return this.update();
	      }
	
	      /**
	       * @ngdoc function
	       * @name create
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @description Requests the server creates the record.
	       * @returns {IHttpPromise<T>} a server request promise
	       * @throws unless `canUpdate`
	       */
	    }, {
	      key: 'create',
	      value: function create() {
	        if (!this.canCreate()) {
	          this.throwInvalidOp('create');
	        }
	        var link = this.getLink('create');
	
	        if (!link.op) {
	          console.warn('HAL link missing HTTP method property "op".  Assuming op "POST" for method create. Record: ');
	          console.dir(this);
	          link = _.cloneDeep(link);
	          link.op = 'POST';
	        }
	
	        return this.makeHalRequest(link, this.getData());
	      }
	
	      /**
	       * @ngdoc function
	       * @name destroy
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @description Requests the server deletes the record.
	       * @returns {IHttpPromise<T>} a server request promise
	       * @throws unless `canDestroy`
	       */
	    }, {
	      key: 'destroy',
	      value: function destroy() {
	        if (!this.canDestroy()) {
	          this.throwInvalidOp('destroy');
	        }
	
	        var link = this.getLink('delete');
	        if (!link.op) {
	          console.warn('HAL link missing HTTP method property "op".  Assuming op "DELETE" for method destroy. Record: ');
	          console.dir(this);
	          link = _.cloneDeep(link);
	          link.op = 'DELETE';
	        }
	
	        return this.makeHalRequest(link);
	      }
	
	      /**
	       * @ngdoc function
	       * @name update
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @description Requests the server updates the record.
	       * @returns {IHttpPromise<T>} a server request promise
	       * @throws unless `canUpdate`
	       */
	    }, {
	      key: 'update',
	      value: function update() {
	        if (!this.canUpdate()) {
	          this.throwInvalidOp('update');
	        }
	
	        var link = undefined;
	        if (this.hasLink('update')) {
	          link = this.getLink('update');
	        } else if (this.hasLink('edit')) {
	          console.warn('HAL link is named "edit" for an update operation. Change API to be "update" instead. Record: ');
	          console.dir(this);
	          link = this.getLink('edit');
	        }
	
	        if (!link.op) {
	          console.warn('HAL link missing HTTP method property "op".  Assuming op "PUT" for method update. Record: ');
	          console.dir(this);
	          link = _.cloneDeep(link);
	          link.op = 'PUT';
	        }
	
	        return this.makeHalRequest(link, this.getData());
	      }
	
	      /**
	       * Reloads the record from the server.  This instance will be updated once the promise is resolved,
	       * and the instance will be returned in the resolved promise.
	       *
	       * @returns {IPromise<HalActiveRecord>} a promise of the updated record.
	       * @throws unless `canReload`
	       */
	    }, {
	      key: 'reload',
	      value: function reload() {}
	      // TODO: Implement
	
	      /**
	       * @returns {boolean} `true` if the data has been modified since it was requested, `false` otherwise
	       */
	
	    }, {
	      key: 'isDirty',
	      value: function isDirty() {
	        // TODO: Implement
	        // How do we implement this?  Some ideas,
	        //   1. We could try something like an agular $watch or Object.watch that would inform us of changes when they're made.
	        //      Using $watch() too much has performance implications.
	        //   2. If we're not worried about memory, we could create an initial copy and store it in internals.  Seems heavy but should work.
	        //   3. Somehow use ES5 getters ('get') and setters ('set') or ES6 computed properties with a setter?
	      }
	    }, {
	      key: 'validate',
	      value: function validate() {
	        // TODO: Implement
	      }
	    }, {
	      key: 'isValid',
	      value: function isValid() {}
	      // TODO: Implement
	
	      /**
	       * @ngdoc function
	       * @name getLink
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @param {string} linkName name of the link to find
	       * @returns {Object} a link object, supporting the HAL conventional link property name '_links' as well as 'links'
	       */
	
	    }, {
	      key: 'getLink',
	      value: function getLink(linkName) {
	        var links = undefined;
	        if (_.has(this, '_links')) {
	          links = this._links;
	        } else if (_.has(this, 'links')) {
	          console.warn('Record has unconventional property "links".  APIs should provide "_links" instead. Record: ');
	          console.dir(this);
	          links = this.links;
	        }
	
	        if (links) {
	          return links[linkName];
	        }
	        return undefined;
	      }
	
	      /**
	       * @ngdoc function
	       * @name hasLink
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @param {string} linkName name of the link to check for
	       * @returns {boolean} `true` if the record has a specified link
	       */
	    }, {
	      key: 'hasLink',
	      value: function hasLink(linkName) {
	        return this.getLink(linkName) !== undefined;
	      }
	
	      /**
	       * @ngdoc function
	       * @name canSave
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @returns {boolean} `true` if the record can be saved
	       */
	    }, {
	      key: 'canSave',
	      value: function canSave() {
	        if (this.isNew()) {
	          return this.canCreate();
	        }
	        return this.canUpdate();
	      }
	
	      /**
	       * @ngdoc function
	       * @name canCreate
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @returns {boolean} `true` if the record can be created
	       */
	    }, {
	      key: 'canCreate',
	      value: function canCreate() {
	        return this.hasLink('create');
	      }
	
	      /**
	       * @ngdoc function
	       * @name canDestroy
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @returns {boolean} `true` if the record can be destroyed
	       */
	    }, {
	      key: 'canDestroy',
	      value: function canDestroy() {
	        return this.hasLink('delete');
	      }
	
	      /**
	       * @ngdoc function
	       * @name canUpdate
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @returns {boolean} `true` if the record can be updated
	       */
	    }, {
	      key: 'canUpdate',
	      value: function canUpdate() {
	        return this.hasLink('update') || this.hasLink('edit');
	      }
	
	      /**
	       * @ngdoc function
	       * @name canReload
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @returns {boolean} `true` if the record can be reloaded
	       */
	    }, {
	      key: 'canReload',
	      value: function canReload() {
	        return this.hasLink('self');
	      }
	
	      /**
	       * @returns {boolean} returns `true` if the record has an `id` attribute (or the attribute specified in `internal.idName`), false `otherwise`.
	       */
	    }, {
	      key: 'isNew',
	      value: function isNew() {
	        return !_.has(this, this.internal.idName);
	      }
	
	      /**
	       * @ngdoc function
	       * @name setRelativeService
	       * @methodOf rhino.core.record.service:rnRecordFactory
	       * @description Sets the relative service for HAL links to be used against.  Necessary because HAL links are currently root-relative instead of absolute.
	       *
	       * @param {string} serviceName name of the serivce to make HAL requests relative to.
	       */
	    }, {
	      key: 'setRelativeService',
	      value: function setRelativeService(serviceName) {
	        this.internal.relativeService = serviceName;
	      }
	    }, {
	      key: 'makeHalRequest',
	      value: function makeHalRequest(link, data) {
	        return rnHttp.halRequest(link, data, null, this.internal.relativeService);
	      }
	    }]);
	
	    return RhinoRecord;
	  })();
	
	  var factory = {
	    create: createRecord
	  };
	  return factory;
	
	  /////////////////
	
	  /**
	   * @ngdoc function
	   * @name create
	   * @methodOf rhino.core.record.service:rnRecordFactory
	   * @description Creates an active record with data bound to it.
	   *
	   * @param {object} data a data object returned from the server
	   * @returns {RhinoRecord} a new record
	   */
	  function createRecord(data) {
	    return new RhinoRecord(data);
	  }
	}
	
	// rnRecordFactory

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnRecordCollectionFactory;
	var name = 'rnRecordCollectionFactory';
	
	exports.name = name;
	
	function rnRecordCollectionFactory() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var factory = {
	    create: createCollection
	  };
	  return factory;
	
	  /////////////////
	
	  function createCollection(data) {
	    var collection = {
	      canCreate: canCreate,
	      canNew: canNew,
	      getLink: getLink
	    };
	
	    activate();
	
	    return collection;
	
	    /////////////////
	
	    function activate() {
	      // Bind server returned data to do this object
	      _.extend(collection, data);
	    }
	
	    function canCreate() {
	      return hasLink('create') || hasLink('add');
	    }
	
	    function canNew() {
	      return hasLink('new');
	    }
	
	    function hasLink(linkName) {
	      return getLink(linkName) !== undefined;
	    }
	
	    function getLink(linkName) {
	      var links = undefined;
	      if (_.has(data, '_links')) {
	        links = data._links;
	      } else if (_.has(data, 'links')) {
	        console.warn('Collection has unconventional property "links".  APIs should provide "_links" instead. Collection: ');
	        console.dir(data);
	        links = data.links;
	      }
	
	      if (links) {
	        return links[linkName];
	      }
	      return undefined;
	    }
	  }
	}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	// exported for testing
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = rnRegistryProvider;
	var name = 'rnRegistry';
	exports.name = name;
	
	function rnRegistryProvider() {
	
	  rnRegistry.$inject = ["$log", "$http", "$q", "$window", "rnBlue", "rnClient"];
	  var apiVersions = {
	    aaa: 4,
	    system_statistics: 2
	  };
	
	  this.setApiVersions = setApiVersions;
	  this.$get = rnRegistry;
	
	  return;
	
	  function setApiVersions() {
	    var versions = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    apiVersions = versions;
	  }
	
	  /**
	   * @ngdoc service
	   * @name rhino.core.registry.service:rnRegistry
	   * @description
	   * `rnRegistry` is a service that retrieves and caches service registry information from Genesis servers.
	   */
	  function rnRegistry($log, $http, $q, $window, rnBlue, rnClient) {
	    //noinspection BadExpressionStatementJS
	    'ngInject';
	
	    var service = {
	      getKey: getKey,
	      getUrl: getUrl,
	      getImageUrl: getImageUrl,
	      getServiceName: getServiceName,
	      getPath: getPath,
	      getRegistry: getRegistry,
	      pusherAuthEndpoint: pusherAuthEndpoint
	    };
	
	    var coreModule = 'rhino.core';
	    var servicesName = 'rnServices';
	    var keysName = 'rnKeys';
	
	    var cached_registry;
	    var nbh = true; // never been here
	
	    return service;
	
	    ////////////////
	
	    /**
	     * @ngdoc function
	     * @name getKey
	     * @methodOf rhino.core.registry.service:rnRegistry
	     * @param {string} keyName Name of the service registry key to retrieve
	     *
	     * @description
	     * Return a specific keys value from the registry as a promise.
	     */
	    function getKey(keyName) {
	      return getRegistry().then(function (data) {
	        if (data.keys[keyName] === undefined) {
	          $log.warn('No services key for ' + keyName);
	          return $q.reject('No services key for ' + keyName);
	        }
	        return data.keys[keyName];
	      });
	    } //getKey
	
	    /**
	     * @ngdoc function
	     * @name getPath
	     * @methodOf rhino.core.registry.service:rnRegistry
	     * @param {string} serviceName Name of the service to retrieve the absolute path for.
	     * @param {string} path Relative path to be appended to service path.
	     *
	     * @description
	     * Return a URL absolute path without the authority (protocol, server, or port) based on
	     * the service and the relative path requested as a promise.
	     *
	     *```js
	     * rnRegistry.getPath('AAA', 'users')
	     *   .then(function(path) {
	    *     // promise resolves to a path here.
	    *     // For example: "/api/aaa/v1/users"
	    *   });
	     *```
	     */
	    function getPath(serviceName) {
	      var path = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	      $log.info('rnRegistry#getPath(' + serviceName + ', ' + path + ') called. Consider calling getUrl instead.');
	      return getRegistry().then(function (data) {
	        if (data.services[serviceName] === undefined) {
	          $log.warn('No service registry entry for service:' + serviceName);
	          return $q.reject('No service registry entry for service:' + serviceName);
	        }
	        var base = data.services[serviceName].proxy;
	        if (path.length > 0 && base.charAt(base.length - 1) !== '/' && path.charAt(0) !== '/') {
	          return base + '/' + path;
	        } else {
	          return base + path;
	        }
	      });
	    } //getPath
	
	    /**
	     * @ngdoc function
	     * @name getUrl
	     * @methodOf rhino.core.registry.service:rnRegistry
	     * @param {string} serviceName Name of the service to retrieve the absolute path for.
	     * @param {string} [path=''] Relative path to be appended to service path.
	     * @param {boolean} [appendTrailingSlash=true] true to ensure the service base and path are joined with a slash
	     * @param {number|undefined} [version] API version number to formulate URL with
	     *
	     * @description
	     * Return a full URL with any authority information (protocol, server, port) based on
	     * the service and the relative path requested as a promise.
	     *
	     *```js
	     * rnRegistry.getUrl('portal_service', 'apps')
	     *   .then(function(url) {
	    *     // promise resolves to a url here.
	    *     // For example: "https://daily.gsbprint.net/api/portal/v1/apps"
	    *   });
	     *```
	     */
	    function getUrl(serviceName) {
	      var path = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	      var appendTrailingSlash = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	      var version = arguments.length <= 3 || arguments[3] === undefined ? undefined : arguments[3];
	
	      return getRegistry().then(function (data) {
	        if (data.services[serviceName] === undefined) {
	          $log.warn('No service registry entry for ' + serviceName);
	          return $q.reject('No service registry entry for ' + serviceName);
	        }
	
	        var base = getServiceBaseUrl(data.services[serviceName], serviceName, version);
	        if (appendTrailingSlash) {
	          return joinUrlParts(base, path);
	        } else {
	          return base + path;
	        }
	      });
	    } //getUrl
	
	    /**
	     * Gets the base URL of a service, formed with a version if provided.
	     *
	     * @param {object} service service registry data for service
	     * @param {string} serviceName name of the service to form the URL for
	     * @param {number} [version] API version to form URL with
	     */
	    function getServiceBaseUrl(service, serviceName, version) {
	      var baseUrl = service.base_sv_url;
	      if (!baseUrl) {
	        if (version !== undefined) {
	          $log.warn('API version specified but not supported for service ' + serviceName);
	        }
	        // unversioned service - simply return regular service url
	        return service.sv_url;
	      }
	
	      if (version === undefined) {
	        // Use configured version if present
	        if (apiVersions[serviceName]) {
	          version = apiVersions[serviceName];
	        } else {
	          // Fallback to version 1 (keeps backwards comparability and generally safe)
	          version = 1;
	        }
	      }
	      return joinUrlParts(baseUrl, 'v' + version);
	    }
	
	    function joinUrlParts(a, b) {
	      if (b.charAt(0) === '/') {
	        // Prevent double slashes by ensuring part b doesn't have a slash
	        b = b.substr(1);
	      }
	
	      if (a.charAt(a.length - 1) === '/') {
	        return a + b;
	      }
	      return a + '/' + b;
	    }
	
	    /**
	     * @ngdoc function
	     * @name getServiceName
	     * @methodOf rhino.core.registry.service:rnRegistry
	     * @param {string} url requested URL to determine service name from
	     * @returns {Promise<string|undefined>} the service name or undefined if not found
	     *
	     * @description
	     * Determines the service name from a URL (the inverse of getUrl()).
	     *
	     *```js
	     * rnRegistry.getServiceName('https://daily.gsbprint.net/api/aaa/organizations/devices')
	     *   .then(serviceName => {
	     *     expect(serviceName).toBe('aaa');
	     *   });
	     *```
	     */
	    function getServiceName(url) {
	      return getRegistry().then(function (data) {
	        return _.findKey(data.services, function (service) {
	          var serviceUrl = service.base_sv_url;
	          if (!serviceUrl) {
	            serviceUrl = service.sv_url;
	          }
	          if (!serviceUrl) {
	            return false;
	          }
	          return _.includes(url, serviceUrl);
	        });
	      });
	    }
	
	    /**
	     * @ngdoc function
	     * @name getImageUrl
	     * @methodOf rhino.core.registry.service:rnRegistry
	     * @param {string} [path=''] relative path of the image.
	     * @param {string} [appendTrailingSlash=true] true to ensure the service base and path are joined with a slash
	     *
	     * @description
	     * Returns a full URL to a PrintOS common image.
	     *
	     *```js
	     * rnRegistry.getImageUrl('devices/Indigo_1000.png')
	     *   .then(function(imgUrl) {
	    *     // promise resolves to a url here.
	    *     // For example: "https://daily.gsbprint.net/images/devices/Indigo_1000.png"
	    *   });
	     *```
	     */
	    function getImageUrl() {
	      var path = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	      var appendTrailingSlash = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      return getUrl('printos_images', path, appendTrailingSlash);
	    }
	
	    function getRegistry() {
	      var rDeferred = $q.defer();
	      // set the content type and cached values in the case this is called during angular deferred bootstrap
	      rnClient.getConfig().then(function (clientConfig) {
	        if (nbh) {
	          nbh = !nbh;
	          $log.debug('rnRegistry.getRegistry: ', clientConfig);
	        }
	        var registry = clientConfig.registry;
	
	        // Would like to import module name but not create circular dependency
	        var rhinoCore = angular.module(coreModule);
	        rhinoCore.constant(servicesName, registry.services);
	        rhinoCore.constant(keysName, registry.keys);
	        cached_registry = registry;
	        rDeferred.resolve(registry);
	      }, function (response) {
	        rDeferred.reject(response.statusText);
	        $log.error('rnRegistry.getRegistry error: ' + JSON.stringify(response) + '  status: ' + response.status + '  config: ' + JSON.stringify(response.config));
	      });
	      return rDeferred.promise;
	    } //getRegistry
	
	    function pusherAuthEndpoint() {
	      if (cached_registry) {
	        return cached_registry.services.aaa.base_sv_url + 'v3/client-eventing/authorize-subscription-request';
	      } else {
	        $log.error('called pusherAuthEndpoint when registry wasn\'t cached!');
	      }
	    }
	  } //rnRegistry
	}
	
	//rnRegistryProvider

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Add register icons to the template cache so they may be referenced
	 */
	'use strict';
	
	cacheAccountIcons.$inject = ["$templateCache"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = cacheAccountIcons;
	var REGISTER_IMAGES_CACHE_PREFIX = 'register/images/';
	exports.REGISTER_IMAGES_CACHE_PREFIX = REGISTER_IMAGES_CACHE_PREFIX;
	
	function cacheAccountIcons($templateCache) {
	  'ngInject';
	
	  // (Use the html loader to pull the SVG content directly into the template cache.)
	  var requireImages = __webpack_require__(574);
	
	  _.forEach(requireImages.keys(), function (img) {
	    // Store icons in cache at app-switcher/icons/Box.svg
	    // strip off leading ./
	    var imgFileName = img.substr(2);
	    $templateCache.put(REGISTER_IMAGES_CACHE_PREFIX + imgFileName, requireImages(img));
	  });
	}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	AcceptAccountController.$inject = ["$gzEULA", "rnInvitation", "rnAuthService", "rnSession", "rnLocale", "rnPreferences", "$analytics", "$state", "$stateParams", "$q", "$translate", "$location", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AcceptAccountController;
	var name = 'AcceptAccountController';
	
	exports.name = name;
	
	function AcceptAccountController($gzEULA, rnInvitation, rnAuthService, rnSession, rnLocale, rnPreferences, $analytics, $state, $stateParams, $q, $translate, $location, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var EVENT_NAME = 'accept invitation';
	  var EVENT_CATEGORY = 'account';
	
	  var analyticsEvent = undefined;
	  var myParams = {};
	  var locales = undefined;
	  var user = undefined;
	  var invitationId = undefined;
	
	  var vm = this;
	  vm.loading = true;
	  vm.submitting = false;
	  vm.accept = {};
	  vm.form = {};
	
	  // controller functions
	  vm.submit = submit;
	  vm.cancel = cancel;
	  vm.go = go;
	  vm.getName = getName;
	  vm.invitationStatusPending = invitationStatusPending;
	  vm.isValid = isValid;
	  vm.existingUser = false;
	  vm.openTerms = openTerms;
	  vm.openPrivacyStatement = openPrivacyStatement;
	
	  vm.unitTest = {
	    getMyParams: function getMyParams() {
	      return myParams;
	    },
	    handleAcceptError: handleAcceptError
	  };
	
	  activate();
	
	  ////////////////////////
	  function activate() {
	    parseParams();
	
	    vm.accept.hpidId = $stateParams.hpidId;
	
	    var promises = [];
	    promises.push(getInvitation(invitationId));
	    promises.push(getLocales());
	    promises.push(getCurrentEulaVersion());
	    promises.push(getCurrentPrivacyVersion());
	    return $q.all(promises).then(function () {
	      var locale = _.find(locales, { value: vm.invitation.languageCode });
	      if (locale) {
	        rnLocale.setLocalePreference(locale);
	        $translate.use(locale.value);
	      }
	
	      if (vm.invitation.status !== 'Pending') {
	        vm.invalid = true;
	        vm.invalidKey = 'register.register.Invitation_Error_' + vm.invitation.status;
	        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
	        return;
	      }
	
	      var postAuthentication = _.get(myParams, 'data.postAuthentication');
	      if (rnAuthService.isAuthenticated() && postAuthentication) {
	        vm.existingUser = true;
	      } else {
	        if (!vm.accept.hpidId) {
	          // Userneeds to authenticate with HP ID first (creating an account if necessary)
	          _.set(myParams, 'invitationId', invitationId);
	          _.set(myParams, 'state', 'acceptAccount');
	          _.set(myParams, 'signout', true);
	          $state.go('acceptHpIdSignIn', myParams);
	        }
	      }
	    })['catch'](function (error) {
	      // No op
	    })['finally'](function () {
	      vm.loading = false;
	    });
	  }
	
	  function parseParams() {
	    var urlParams = $location.search();
	
	    myParams.data = $stateParams.data;
	
	    if ($stateParams.bu) {
	      myParams.bu = $stateParams.bu;
	      vm.bu = $stateParams.bu;
	    }
	
	    invitationId = $stateParams.invitationId;
	    if (!invitationId || invitationId === '') {
	      invitationId = _.get(myParams, 'data.invitationId', undefined);
	    }
	
	    if (!invitationId) {
	      $state.go('signin', { signout: true });
	    }
	  }
	
	  function getInvitation(invitationId) {
	    return rnInvitation.getById(invitationId).then(function (invitation) {
	      vm.invitation = invitation;
	      if (invitation.status !== 'Pending') {
	        vm.invalid = true;
	        vm.invalidKey = 'register.register.Invitation_Error_' + invitation.status;
	        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
	      }
	    })['catch'](function (error) {
	      vm.invalid = true;
	      vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
	
	      var statusCode = _.get(error, 'smsError.statusCode');
	      var subCode = _.get(error, 'smsError.subCode');
	
	      switch (statusCode) {
	        case 404:
	          vm.invalidKey = 'register.register.Invitation_Error_Retrieve_NotFound';
	          break;
	        case 409:
	          switch (subCode) {
	            case 1100:
	              vm.invalidKey = 'register.register.Invitation_Error_Multiple_Account_Association';
	              break;
	            default:
	              vm.invalidKey = 'register.register.Invitation_Error_Multiple_Account_Association';
	              break;
	          }
	          break;
	        default:
	          vm.invalidKey = 'register.register.Invitation_Error_Retrieve';
	          break;
	      }
	
	      return $q.reject();
	    });
	  }
	
	  function getLocales() {
	    return rnLocale.allLocaleOptions().then(function (options) {
	      locales = options;
	    });
	  }
	
	  function getCurrentEulaVersion() {
	    return $gzEULA.getCurrentVersion().then(function (version) {
	      vm.accept.eulaVersion = version;
	    });
	  }
	
	  function getCurrentPrivacyVersion() {
	    return $gzEULA.getPrivacyVersion().then(function (version) {
	      vm.accept.privacyVersion = version;
	    });
	  }
	
	  function submit() {
	    if (!isValid()) {
	      return;
	    }
	
	    if (vm.existingUser) {
	      return acceptExisting();
	    } else {
	      return acceptNew();
	    }
	  }
	
	  function acceptExisting() {
	    var org = {
	      name: vm.accept.organizationName,
	      type: vm.invitation.organizationType,
	      securityPassword: vm.accept.securityPassword
	    };
	
	    return rnInvitation.acceptInvitationWithExistingUser('invitations/' + vm.invitation.id + '/org', 'POST', org).then(function (data) {
	      var orgId = data.organization.organizationId;
	      return rnSession.switchContext({ id: orgId })['finally'](function () {
	        $analytics.eventTrack(EVENT_NAME, analyticsEvent);
	        go();
	      });
	    })['catch'](function (error) {
	      handleAcceptError(error);
	    })['finally'](function () {
	      vm.submitting = false;
	    });
	  }
	
	  function acceptNew() {
	    var url = vm.invitation._links.accept.href;
	    vm.submitting = true;
	    delete vm.errorKey;
	
	    if (vm.accept.organizationName) {
	      vm.accept.organizationName = vm.accept.organizationName.trim();
	    }
	
	    return rnInvitation.acceptInvitation(vm.accept, url).then(function (data) {
	      user = data.user;
	      $analytics.setUsername(user.userId);
	      $analytics.eventTrack(EVENT_NAME, analyticsEvent);
	      go();
	    })['catch'](function (error) {
	      handleAcceptError(error);
	    })['finally'](function () {
	      vm.submitting = false;
	    });
	  }
	
	  function isValid() {
	    if (vm.form.$invalid) {
	      return false;
	    }
	    if (!vm.accept) {
	      return false;
	    }
	    if (!vm.existingUser) {
	      if (!vm.accept.acceptEula) {
	        return false;
	      }
	      if (!vm.accept.acceptTerms) {
	        return false;
	      }
	    }
	    if (vm.submitting) {
	      return false;
	    }
	    if (!vm.accept.organizationName) {
	      return false;
	    }
	    if (vm.accept.organizationName.trim() === '') {
	      return false;
	    }
	
	    return true;
	  }
	
	  function handleAcceptError(error) {
	    var statusCode = _.get(error, 'smsError.statusCode', -1);
	    var subCode = _.get(error, 'smsError.subCode', null);
	
	    switch (statusCode) {
	      case 401:
	        if (subCode === 1019) {
	          // Serial number is invalid
	          vm.errorKey = 'register.register.Invitation_ErrorCode_Device_SN_Error';
	        } else if (subCode === 1022) {
	          // The serial number has an invalid format, which we will assume is because it needs to be uppercase
	          vm.errorKey = 'devices.devices.Device_Serial_Number_Incorrect_Case';
	        } else if (subCode === 1020) {
	          // Issue validating the serial number (the service is probably down)
	          vm.errorKey = 'register.register.Invitation_ErrorCode_Device_Validation_Internal_Error';
	        } else {
	          vm.errorKey = 'register.register.Error_Accepting_Invitation';
	        }
	        break;
	      case 403:
	        if (error.smsError.message === 'HPID migration in progress, this action is forbidden') {
	          vm.errorKey = 'register.register.Invitation_Error_HPID_Migration';
	        } else {
	          vm.errorKey = 'register.register.Error_Accepting_Invitation';
	        }
	        break;
	      case 404:
	        // Invitation not found
	        vm.errorKey = 'register.register.Invitation_ErrorCode_NotFound';
	        break;
	      case 409:
	        if (subCode === 1002) {
	          // A device with this serial number already exists for this model
	          vm.errorKey = 'register.register.Invitation_ErrorCode_Device_SN_Exists';
	        } else if (subCode === 1030) {
	          vm.errorKey = 'register.register.EUID_Conflict';
	        } else {
	          // Username, email, or GBU Internal ID may already be in use
	          vm.errorKey = 'register.register.Name_Conflict';
	        }
	        break;
	      case 498:
	        vm.errorKey = 'register.register.Invitation_ErrorCode_Expired';
	        break;
	      default:
	        vm.errorKey = 'register.register.Error_Accepting_Invitation';
	    }
	
	    // $analytics.exceptionTrack() in the future
	    $window.ga('send', 'exception', {
	      exDescription: EVENT_NAME + " failed: " + _.get(error, 'smsError.message', 'unknown')
	    });
	  }
	
	  function cancel() {
	    $state.go('signin', { signout: true });
	  }
	
	  function go() {
	    _.set(myParams, 'data.organizationName', vm.invitation.organizationName);
	    myParams.forward = true;
	    $state.go('signin', myParams);
	  }
	
	  function getName() {
	    var name = '';
	    if (_.get(user, 'firstName')) {
	      name += user.firstName + ' ';
	    }
	    if (_.get(user, 'lastName')) {
	      name += user.lastName;
	    }
	    return name.trim();
	  }
	
	  function invitationStatusPending() {
	    if (vm.success) {
	      return false;
	    }
	    return _.get(vm.invitation, 'status', '') === 'Pending';
	  }
	
	  function openTerms($event) {
	    if ($event) {
	      $event.stopPropagation();
	    }
	    $gzEULA.show();
	  }
	
	  function openPrivacyStatement($event) {
	    if ($event) {
	      $event.stopPropagation();
	    }
	    $window.open('http://www.hp.com/go/privacy', 'hp-privacy');
	  }
	}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	// import modules this module depends on
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	// import rnDevice from 'rhino/src/components/device/device.module';
	// import rnSession from 'rhino/src/components/session/session.module';
	// import rnHttp from 'rhino/src/core/http/http.module';
	// import rnPreferences from 'rhino/src/components/preferences/preferences.module';
	
	var _acceptAccountController = __webpack_require__(473);
	
	var acceptAccount = _interopRequireWildcard(_acceptAccountController);
	
	var _gazelleSrcComponentsUserEulaEulaModule = __webpack_require__(9);
	
	var _gazelleSrcComponentsUserEulaEulaModule2 = _interopRequireDefault(_gazelleSrcComponentsUserEulaEulaModule);
	
	var _gazelleSrcComponentsHpidHpidModule = __webpack_require__(13);
	
	var _gazelleSrcComponentsHpidHpidModule2 = _interopRequireDefault(_gazelleSrcComponentsHpidHpidModule);
	
	// import this modules components
	
	__webpack_require__(546);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.acceptaccount', [_gazelleSrcComponentsUserEulaEulaModule2['default'], _angularUiRouter2['default'], _angularMaterial2['default'], _angularTranslate2['default'], _gazelleSrcComponentsHpidHpidModule2['default'], 'rhino.components.locale', 'rhino.components.invitation', 'rhino.components.session', 'rhino.components.preferences', 'rhino.components.locale', 'rhino.core', 'angulartics']).controller(acceptAccount.name, acceptAccount['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	// import modules this module depends on
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	var _gazelleSrcComponentsHpidHpidModule = __webpack_require__(13);
	
	var _gazelleSrcComponentsHpidHpidModule2 = _interopRequireDefault(_gazelleSrcComponentsHpidHpidModule);
	
	var _gazelleSrcComponentsUserEulaEulaModule = __webpack_require__(9);
	
	var _gazelleSrcComponentsUserEulaEulaModule2 = _interopRequireDefault(_gazelleSrcComponentsUserEulaEulaModule);
	
	// import this modules components
	
	__webpack_require__(547);
	
	var _hpidSignInController = __webpack_require__(76);
	
	var hpIdSignInController = _interopRequireWildcard(_hpidSignInController);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.accept.hpIdSignIn', ['rhino.components.invitation', 'rhino.components.locale', _angularUiRouter2['default'], _gazelleSrcComponentsHpidHpidModule2['default'], _gazelleSrcCoreAnalyticsAnalyticsModule2['default'], _gazelleSrcComponentsUserEulaEulaModule2['default'], _angularTranslate2['default']]).controller(hpIdSignInController.name, hpIdSignInController['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	'use strict';
	
	AcceptExistingUserController.$inject = ["rnInvitation", "rnAuthService", "rnSession", "$analytics", "$state", "$window", "$stateParams"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AcceptExistingUserController;
	var name = 'AcceptExistingUserController';
	
	exports.name = name;
	
	function AcceptExistingUserController(rnInvitation, rnAuthService, rnSession, $analytics, $state, $window, $stateParams) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var EVENT_NAME = 'accept invitation';
	  var EVENT_CATEGORY = 'account';
	
	  var analyticsEvent = undefined;
	  var contexts = undefined;
	  var myParams = {};
	  var invitationId = undefined;
	
	  var vm = this;
	  vm.loading = true;
	  vm.submitting = false;
	
	  // controller functions
	  vm.submit = submit;
	  vm.cancel = cancel;
	  vm.go = go;
	
	  vm.unitTest = {
	    getMyParams: function getMyParams() {
	      return myParams;
	    },
	    handleAcceptError: handleAcceptError
	  };
	
	  activate();
	
	  ////////////////////////
	  function activate() {
	    parseParams();
	    getInvitation(invitationId)['finally'](function () {
	      vm.loading = false;
	    });
	  }
	
	  function parseParams() {
	    myParams.data = $stateParams.data;
	    if ($stateParams.bu) {
	      myParams.bu = $stateParams.bu;
	      vm.bu = $stateParams.bu;
	    }
	
	    invitationId = $stateParams.invitationId;
	    if (!invitationId || invitationId === '') {
	      // fall back to what is stored in state data
	      invitationId = _.get(myParams, 'data.invitationId', undefined);
	    }
	
	    if (!invitationId) {
	      // If we don't have an invitation id we can abort and drop state
	      $state.go('signin', { signout: true });
	    }
	  }
	
	  function getInvitation(invitationId) {
	    return rnInvitation.getById(invitationId).then(function (invitation) {
	      vm.invitation = invitation;
	
	      analyticsEvent = {
	        category: 'account',
	        label: vm.invitation.invitationType + " - " + vm.invitation.organizationType,
	        value: vm.invitation.roleId
	      };
	
	      if (invitation.status !== 'Pending') {
	        vm.invalid = true;
	        vm.invalidKey = 'register.register.Invitation_Error_' + invitation.status;
	        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
	      }
	    })['catch'](function (error) {
	      vm.invalid = true;
	      vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
	      if (error === 404) {
	        vm.invalidKey = 'register.register.Invitation_Error_Retrieve_NotFound';
	      } else {
	        vm.invalidKey = 'register.register.Invitation_Error_Retrieve';
	      }
	    });
	  }
	
	  function submit() {
	    var url = vm.invitation._links.accept.href;
	    vm.submitting = true;
	    delete vm.errorKey;
	
	    rnInvitation.acceptInvitationWithExistingUser(vm.invitation._links.accept.href, vm.invitation._links.accept.op).then(function (data) {
	      getContexts()['finally'](function () {
	        $analytics.eventTrack(EVENT_NAME, analyticsEvent);
	        vm.success = true;
	      });
	    })['catch'](function (error) {
	      handleAcceptError(error);
	    })['finally'](function () {
	      vm.submitting = false;
	    });
	  }
	
	  function getContexts() {
	    return rnSession.availableContexts().then(function (data) {
	      contexts = data.contexts;
	    });
	  }
	
	  function handleAcceptError(error) {
	    var statusCode = _.get(error, 'smsError.statusCode', -1);
	
	    switch (statusCode) {
	      case 404:
	        vm.errorKey = 'register.register.Invitation_ErrorCode_NotFound';
	        break;
	      case 409:
	        if (myParams.data.username) {
	          vm.errorKey = 'register.register.User_Name_Conflict';
	        } else {
	          vm.errorKey = 'register.register.Invitation_ErrorCode_User_Already_Member';
	        }
	        break;
	      case 498:
	        vm.errorKey = 'register.register.Invitation_ErrorCode_Expired';
	        break;
	      default:
	        vm.errorKey = 'register.register.Error_Accepting_Invitation';
	    }
	
	    // $analytics.exceptionTrack() in the future
	    ga('send', 'exception', {
	      exDescription: EVENT_NAME + " failed: " + _.get(error, 'smsError.message', 'unknown')
	    });
	  }
	
	  function cancel() {
	    $state.go('signin', { signout: true });
	  }
	
	  function go() {
	    var found = _.find(contexts, { name: vm.invitation.organizationName });
	
	    var params = {
	      forward: true,
	      data: {
	        orgId: vm.invitation.senderOrganizationId
	      }
	    };
	
	    if (found) {
	      rnSession.switchContext(found).then(function () {
	        $state.go('signin', params);
	      });
	    } else {
	      $state.go('signin', params);
	    }
	  }
	}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	// import modules this module depends on
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _acceptExistingUserController = __webpack_require__(476);
	
	var acceptExistingUser = _interopRequireWildcard(_acceptExistingUserController);
	
	// import this modules components
	
	__webpack_require__(548);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.acceptexistinguser', [_angularUiRouter2['default'], _angularMaterial2['default'], _angularTranslate2['default'], 'rhino.components.locale', 'rhino.components.invitation', 'rhino.components.session', 'rhino.core', 'angulartics']).controller(acceptExistingUser.name, acceptExistingUser['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	AcceptUserController.$inject = ["$gzEULA", "rnInvitation", "rnAuthService", "rnSession", "rnPreferences", "rnLocale", "$analytics", "$state", "$stateParams", "$q", "$window", "$translate"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = AcceptUserController;
	var name = 'AcceptUserController';
	
	exports.name = name;
	
	function AcceptUserController($gzEULA, rnInvitation, rnAuthService, rnSession, rnPreferences, rnLocale, $analytics, $state, $stateParams, $q, $window, $translate) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var EVENT_NAME = 'accept invitation';
	
	  var analyticsEvent = undefined;
	  var myParams = {};
	  var locales = undefined;
	  var invitationId = undefined;
	
	  var vm = this;
	  vm.loading = true;
	  vm.submitting = false;
	  vm.accept = {};
	
	  // controller functions
	  vm.submit = submit;
	  vm.cancel = cancel;
	  vm.go = go;
	  vm.openTerms = openTerms;
	  vm.openPrivacyStatement = openPrivacyStatement;
	
	  vm.unitTest = {
	    getMyParams: function getMyParams() {
	      return myParams;
	    },
	    handleAcceptError: handleAcceptError
	  };
	
	  activate();
	
	  ////////////////////////
	  function activate() {
	    parseParams();
	    var promises = [];
	    promises.push(getInvitation(invitationId));
	    promises.push(getLocales());
	    promises.push(getCurrentEulaVersion());
	    promises.push(getCurrentPrivacyVersion());
	    $q.all(promises).then(function () {
	      var locale = _.find(locales, { value: vm.invitation.languageCode });
	      if (locale) {
	        rnLocale.setLocalePreference(locale);
	        $translate.use(locale.value);
	      }
	
	      if (vm.invitation.status !== 'Pending') {
	        vm.invalid = true;
	        vm.invalidKey = 'register.register.Invitation_Error_' + vm.invitation.status;
	        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
	        vm.loading = false;
	        return;
	      }
	
	      var postAuthentication = _.get(myParams, 'data.postAuthentication');
	      if (rnAuthService.isAuthenticated() && postAuthentication) {
	        $state.go('acceptExistingUser', { invitationId: invitationId });
	      } else {
	        if (!vm.accept.hpidId) {
	          // User needs to authenticate with HP ID first (creating an account if necessary)
	          _.set(myParams, 'invitationId', invitationId);
	          _.set(myParams, 'state', 'acceptUser');
	          _.set(myParams, 'signout', true);
	          $state.go('acceptHpIdSignIn', myParams);
	        }
	
	        vm.loading = false;
	      }
	    })['catch'](function () {
	      vm.loading = false;
	    });
	  }
	
	  function parseParams() {
	    myParams.data = $stateParams.data;
	    if ($stateParams.bu) {
	      myParams.bu = $stateParams.bu;
	      vm.bu = $stateParams.bu;
	    }
	
	    invitationId = $stateParams.invitationId;
	    if (!invitationId || invitationId === '') {
	      // fall back to what is stored in state data
	      invitationId = _.get(myParams, 'data.invitationId', undefined);
	    }
	
	    vm.accept.hpidId = $stateParams.hpidId;
	  }
	
	  function getInvitation(invitationId) {
	    return rnInvitation.getById(invitationId).then(function (invitation) {
	      vm.invitation = invitation;
	    })['catch'](function (error) {
	      vm.invalid = true;
	      vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
	      if (error === 404) {
	        vm.invalidKey = 'register.register.Invitation_Error_Retrieve_NotFound';
	      } else {
	        vm.invalidKey = 'register.register.Invitation_Error_Retrieve';
	      }
	      vm.loading = false;
	      return $q.reject();
	    });
	  }
	
	  function getLocales() {
	    return rnLocale.allLocaleOptions().then(function (options) {
	      locales = options;
	    });
	  }
	  function getCurrentEulaVersion() {
	    return $gzEULA.getCurrentVersion().then(function (version) {
	      vm.accept.eulaVersion = version;
	    });
	  }
	
	  function getCurrentPrivacyVersion() {
	    return $gzEULA.getPrivacyVersion().then(function (version) {
	      vm.accept.privacyVersion = version;
	    });
	  }
	
	  function submit() {
	    var url = vm.invitation._links.accept.href;
	    vm.submitting = true;
	    delete vm.errorKey;
	
	    return rnInvitation.acceptInvitation(vm.accept, url).then(function (data) {
	      vm.success = true;
	      $analytics.setUsername(data.user.userId);
	      $analytics.eventTrack(EVENT_NAME, analyticsEvent);
	    })['catch'](function (error) {
	      handleAcceptError(error);
	    })['finally'](function () {
	      vm.submitting = false;
	    });
	  }
	
	  function handleAcceptError(error) {
	    var statusCode = _.get(error, 'smsError.statusCode', -1);
	
	    switch (statusCode) {
	      case 404:
	        vm.errorKey = 'register.register.Invitation_ErrorCode_NotFound';
	        break;
	      case 409:
	        if (vm.accept.loginName) {
	          vm.errorKey = 'register.register.User_Name_Conflict';
	          vm.errorValues = [vm.accept.loginName];
	        } else {
	          vm.errorKey = 'register.register.Invitation_ErrorCode_User_Already_Member';
	        }
	        break;
	      case 498:
	        vm.errorKey = 'register.register.Invitation_ErrorCode_Expired';
	        break;
	      default:
	        vm.errorKey = 'register.register.Error_Accepting_Invitation';
	    }
	
	    // $analytics.exceptionTrack() in the future
	    ga('send', 'exception', {
	      exDescription: EVENT_NAME + " failed: " + _.get(error, 'smsError.message', 'unknown')
	    });
	  }
	
	  function cancel() {
	    // If we cancel from here we can drop state (myParams)
	    $state.go('signin', { signout: true });
	  }
	
	  function go() {
	    _.set(myParams, 'data.organizationName', vm.invitation.organizationName);
	    myParams.forward = true;
	    $state.go('signin', myParams);
	  }
	
	  function openTerms($event) {
	    if ($event) {
	      $event.stopPropagation();
	    }
	    $gzEULA.show();
	  }
	
	  function openPrivacyStatement($event) {
	    if ($event) {
	      $event.stopPropagation();
	    }
	    $window.open('http://www.hp.com/go/privacy', 'hp-privacy');
	  }
	}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	// import modules this module depends on
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	// import rnDevice from 'rhino/src/components/device/device.module';
	// import rnSession from 'rhino/src/components/session/session.module';
	// import rnHttp from 'rhino/src/core/http/http.module';
	// import rnPreferences from 'rhino/src/components/preferences/preferences.module';
	
	var _acceptUserController = __webpack_require__(478);
	
	var acceptUser = _interopRequireWildcard(_acceptUserController);
	
	var _gazelleSrcComponentsUserEulaEulaModule = __webpack_require__(9);
	
	var _gazelleSrcComponentsUserEulaEulaModule2 = _interopRequireDefault(_gazelleSrcComponentsUserEulaEulaModule);
	
	var _gazelleSrcComponentsHpidHpidModule = __webpack_require__(13);
	
	var _gazelleSrcComponentsHpidHpidModule2 = _interopRequireDefault(_gazelleSrcComponentsHpidHpidModule);
	
	// import this modules components
	
	__webpack_require__(549);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.acceptuser', [_gazelleSrcComponentsUserEulaEulaModule2['default'], _angularUiRouter2['default'], _angularMaterial2['default'], _angularTranslate2['default'], _gazelleSrcComponentsHpidHpidModule2['default'], 'rhino.components.locale', 'rhino.components.preferences', 'rhino.components.invitation', 'rhino.components.session', 'rhino.core', 'angulartics']).controller(acceptUser.name, acceptUser['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _analyticsRun = __webpack_require__(481);
	
	var _analyticsRun2 = _interopRequireDefault(_analyticsRun);
	
	exports['default'] = angular.module('start.core.analytics', ['angulartics.google.analytics', 'rhino.components.application']).run(_analyticsRun2['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	initAnalyticsRun.$inject = ["$q", "$log", "$window", "$document", "rnClient", "rnLocale", "rnApplication"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = initAnalyticsRun;
	
	var _gazelleSrcCoreAnalyticsGaCustomDefs = __webpack_require__(25);
	
	function initAnalyticsRun($q, $log, $window, $document, rnClient, rnLocale, rnApplication) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  // Deliberately using raw window reference to prevent mocking $window from bypassing this check in testing.
	  if (window.__karma__) {
	    $log.info('Detected karma tests running.  Not configuring analytics.');
	    return;
	  }
	
	  addGaTempGlobal();
	
	  $q.all([rnClient.getConfig(), rnLocale.getBcp47Locale()]).then(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2);
	
	    var clientConfig = _ref2[0];
	    var locale = _ref2[1];
	
	    if (!hasGaConsent(clientConfig)) {
	      return;
	    }
	    var analyticsKey = _.get(clientConfig, 'registry.keys.analyticsKey');
	    if (!analyticsKey) {
	      return;
	    }
	
	    gaRunFirst(function () {
	      $window.ga('create', analyticsKey, 'auto');
	      setFields(clientConfig, locale);
	    });
	
	    addGaScript();
	  });
	
	  // Adapted from google analytics tracking snippet: https://developers.google.com/analytics/devguides/collection/analyticsjs/tracking-snippet-reference
	  // Split out adding the temporary GA global from adding the GA script
	  // so that we can create the global, add the script, initialize the GA tracker,
	  // and then apply the temp queue. GA expects the tracker to be created as the first command,
	  // but that's not possible in our env because we dynamically load the GA tracker.
	  function addGaTempGlobal() {
	    var name = arguments.length <= 0 || arguments[0] === undefined ? 'ga' : arguments[0];
	
	    // Direct GA towards a temporary global for bootstrapping
	    $window.GoogleAnalyticsObject = name;
	
	    // Creates an initial ga() function.
	    // The queued commands will be executed once analytics.js loads.
	    if (!$window[name]) {
	      $window[name] = function startBlueTemp() {
	        ($window[name].q = $window[name].q || []).push(arguments);
	      };
	
	      // Sets the time (as an integer) this tag was executed.
	      // Used for timing hits.
	      $window[name].l = 1 * new Date();
	    }
	  }
	
	  function gaRunFirst(callback) {
	    if (!$window.ga.q) {
	      return callback();
	    }
	
	    var gaTempQueue = $window.ga.q;
	    $window.ga.q = [];
	
	    callback();
	
	    $window.ga.q.push.apply($window.ga.q, gaTempQueue);
	  }
	
	  function hasGaConsent(clientConfig) {
	    return _.get(clientConfig, 'consent.performance', false);
	  }
	
	  // Adapted from google analytics tracking snippet: https://developers.google.com/analytics/devguides/collection/analyticsjs/tracking-snippet-reference
	  function addGaScript() {
	    // Insert the script tag asynchronously.
	    // Inserts above current tag to prevent blocking in addition to using the
	    // async attribute.
	    var document = $document[0];
	    var gaScript = document.createElement('script');
	    var currentScript = document.getElementsByTagName('script')[0];
	    gaScript.async = true;
	    gaScript.src = '//www.google-analytics.com/analytics.js';
	    currentScript.parentNode.insertBefore(gaScript, currentScript);
	  }
	
	  function setFields(clientConfig, locale) {
	    // Use beacon transport to minimize any impact on navigation and performance
	    set('transport', 'beacon');
	
	    var entityId = _.get(clientConfig, 'entity.id');
	    if (entityId) {
	      set('userId', entityId);
	      set(_gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.uid, entityId);
	    }
	
	    var managingContextId = _.get(clientConfig, 'managingContext.id');
	    if (managingContextId) {
	      set(_gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.orgId, managingContextId);
	    }
	
	    var contextId = _.get(clientConfig, 'context.id');
	    if (contextId) {
	      if (managingContextId) {
	        set(_gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.visitingOrgId, contextId);
	      } else {
	        set(_gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.orgId, contextId);
	      }
	    }
	
	    // entity type will be set by data import in the future
	    var entityType = _.get(clientConfig, 'entity.type');
	    if (entityType) {
	      set(_gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.entityType, entityType);
	    }
	
	    var currentAppId = rnApplication.getCurrentAppId();
	    if (currentAppId) {
	      set('title', currentAppId);
	      set('appName', currentAppId);
	      set('appID', currentAppId);
	    }
	
	    var experimentId = _.get(clientConfig, 'experiment.id');
	    if (experimentId) {
	      set('expId', experimentId);
	    }
	
	    var variantId = _.get(clientConfig, 'experiment.variant');
	    if (variantId !== undefined) {
	      set('expVar', variantId);
	    }
	
	    set('language', locale);
	  }
	
	  function set(name, value) {
	    $window.ga('set', name, value);
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _rhinoSrcComponentsLocaleLocaleModule = __webpack_require__(32);
	
	var _rhinoSrcComponentsLocaleLocaleModule2 = _interopRequireDefault(_rhinoSrcComponentsLocaleLocaleModule);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	var _consentRun = __webpack_require__(483);
	
	var _consentRun2 = _interopRequireDefault(_consentRun);
	
	exports['default'] = angular.module('start.core.consent', [_rhinoSrcCoreCoreModule2['default'], _rhinoSrcComponentsLocaleLocaleModule2['default'], _gazelleSrcCoreAnalyticsAnalyticsModule2['default']]).run(_consentRun2['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	runCookieConsentScript.$inject = ["$document", "$window", "$q", "rnClient", "rnLocale", "$gzAnalytics"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = runCookieConsentScript;
	
	function runCookieConsentScript($document, $window, $q, rnClient, rnLocale, $gzAnalytics) {
	  'ngInject';
	
	  return $q.all([rnLocale.getBcp47Locale(), rnClient.getConfig()]).then(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2);
	
	    var locale = _ref2[0];
	    var clientConfig = _ref2[1];
	
	    // unwrap document from jqlite wrapper
	    var document = $document[0];
	
	    // Set the document lang for OneTrust to reference
	    document.documentElement.lang = locale;
	
	    var consentScript = _.get(clientConfig, 'consent.script');
	    if (consentScript && _.get(clientConfig, 'consent.show')) {
	      $gzAnalytics.eventOpen('cookie consent');
	
	      var scriptElement = document.createElement('script');
	      scriptElement.src = consentScript;
	      scriptElement.async = true;
	      scriptElement.defer = true;
	      scriptElement.dataset.documentLanguage = 'true';
	
	      checkForOptanonReady();
	      document.head.append(scriptElement);
	    }
	  });
	
	  function checkForOptanonReady() {
	    if (!$window.Optanon || !optanonCSSLoaded()) {
	      $window.setTimeout(checkForOptanonReady, 500);
	      return;
	    }
	
	    handleOptanonReady();
	  }
	
	  function optanonCSSLoaded() {
	    var ss = $document[0].styleSheets;
	    for (var i = 0; i < ss.length; i++) {
	      if (ss[i].href && ss[i].href.startsWith('https://optanon.blob.core.windows.net/skins/')) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function handleOptanonReady() {
	    $window.Optanon.LoadBanner();
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = stIcp;
	var name = 'stIcp';
	exports.name = name;
	
	function stIcp()
	// Directive angular dependencies
	{
	  'ngInject';
	
	  icpController.$inject = ["rnClient", "$location"];
	  var directive = {
	    restrict: 'EA',
	    scope: {},
	    template: __webpack_require__(264),
	    link: icpLink,
	    controller: icpController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	  return directive;
	
	  //////////////////////
	
	  function icpLink(scope, element, attrs) {}
	
	  /** @ngInject */
	  function icpController(rnClient, $location) {
	    // Constants
	
	    // Variables
	
	    // View Model
	    var vm = this;
	    //   VM properties
	    vm.showIcp = $location.host().endsWith('.cn');
	    vm.icp = null;
	    //   VM methods
	
	    vm.$onInit = onInit;
	    return;
	
	    ///////////////
	    // Init
	    function onInit() {
	      rnClient.getConfig().then(function (clientConfig) {
	        vm.icp = _.get(clientConfig, 'registry.keys.icp');
	      });
	    }
	
	    ///////////////
	    // VM methods
	
	    ///////////////
	    // Helpers
	  }
	}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(550);
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _icpDirective = __webpack_require__(484);
	
	var stIcpDirective = _interopRequireWildcard(_icpDirective);
	
	exports['default'] = angular.module('start.components.icp', [_rhinoSrcCoreCoreModule2['default']]).directive(stIcpDirective.name, stIcpDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var BU = {
	  Indigo: 'Indigo',
	  LF: 'LF',
	  Scitex: 'Scitex',
	  PWI: 'PWI'
	};
	
	exports.BU = BU;
	var PILLAR = {
	  Optimize: 'Optimize',
	  Automate: 'Automate',
	  Grow: 'Grow'
	};
	exports.PILLAR = PILLAR;
	// id: landing page identifier for application - drives Name and Description
	// appId: application id associated with this item - drives Icon
	// name: display name for application
	// desc: description for the application
	// icon: cdn reference to icon associated with the application
	// bgImage: cdn reference to image to associate with the application
	// pillar: Which pillar is the application associated with?
	// businessUnits: Which business units is this application associated with?
	var appDefinitions = [{
	  id: 'print-beat',
	  appId: 'printbeat',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&1")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&1")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.Indigo, BU.LF, BU.PWI, BU.Scitex],
	  content: [{
	    type: 'video',
	    videoIds: {
	      en: '86BHQ1vGzyM'
	    }
	  }]
	}, {
	  id: 'media-locator',
	  appId: 'ml',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&2")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&2")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI]
	}, {
	  id: 'knowledge-zone',
	  appId: 'information-center',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&3")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&3")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.Indigo, BU.PWI, BU.Scitex]
	}, {
	  id: 'print-beat-mobile',
	  appId: 'print-beat-mobile',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&4")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&4")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.Indigo]
	}, {
	  id: 'service-center',
	  appId: 'pwi-sc',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&5")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&5")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI]
	}, {
	  id: 'service-center-channels',
	  appId: 'reseller-portal',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&6")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&6")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.LF]
	}, {
	  id: 'substrate-manager',
	  appId: 'csm',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&7")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&7")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.Indigo]
	}, {
	  id: 'configuration-center',
	  appId: 'color-config',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&8")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&8")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.LF]
	}, {
	  id: 'jobs-api',
	  appId: 'jobs',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&9")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&9")',
	  pillar: PILLAR.Optimize,
	  businessUnits: [BU.Indigo]
	}, {
	  id: 'site-flow',
	  appId: 'production',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&10")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&10")',
	  pillar: PILLAR.Automate,
	  businessUnits: [BU.Indigo, BU.Scitex, BU.PWI]
	}, {
	  id: 'box',
	  appId: 'box',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&11")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&11")',
	  pillar: PILLAR.Automate,
	  businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI]
	}, {
	  id: 'composer',
	  appId: 'composer',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&12")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&12")',
	  pillar: PILLAR.Automate,
	  businessUnits: [BU.Indigo, BU.Scitex, BU.PWI],
	  content: [{
	    type: 'testimonial',
	    options: {
	      layout: 'personal-1',
	      logo: 'https://cdn.printos.com/images/market/products/summary/composer/company-wihabo.jpg',
	      quote: 'PrintOS Composer has been greatly effective in delivering our award winning <a class=\"link\" href=\"https://www.wihabo.nl/vers-van-de-pers/tony-s-limited-editions-are-really-one-of-a-kind\" target=\"_blank\">Tony\'s Chocolonely</a> VDP project quickly and accurately.',
	      picture: 'https://cdn.printos.com/images/market/products/summary/composer/wihabo-testimonial1.jpg',
	      name: 'Mike Rovers',
	      title: 'Studio Manager',
	      company: '<a class=\"company-link\" href=\"https://www.wihabo.nl/\" target=\"_blank\">Wihabo</a>'
	    }
	  }, {
	    type: 'testimonial',
	    options: {
	      layout: 'personal-1',
	      logo: 'https://cdn.printos.com/images/market/products/summary/composer/company-feburman.png',
	      quote: 'Creating the <a class=\"link\" href=\"http://www.hellorichard.co.uk/?portfolio=fes-watch-u-x-g-f-smith" target=\"_blank\">Sony FES Watch U</a> campaign, required a robust Variable PDF creation tool.  PrintOS Composer provided us with exactly what we needed.',
	      picture: 'https://cdn.printos.com/images/market/products/summary/composer/feburman-testimonial1.jpg',
	      name: 'Roger White',
	      title: 'Creative & Technical Lead',
	      company: '<a class=\"company-link\" href=\"https://www.feburman.co.uk/\" target=\"_blank\">F.E. Burman</a>'
	    }
	  }, {
	    type: 'video',
	    videoIds: {
	      en: 'WUvQ3KIqDd4'
	    }
	  }]
	}, // learn: {
	//   link: 'https://hp.com',
	// }
	{
	  id: 'imposer',
	  appId: 'imposer',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&13")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&13")',
	  pillar: PILLAR.Automate,
	  businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI]
	}, {
	  id: 'resource-manager',
	  appId: 'resourcemanager',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&14")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&14")',
	  pillar: PILLAR.Automate,
	  businessUnits: [BU.Indigo]
	}, {
	  id: 'applications-center',
	  appId: 'wallart',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&15")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&15")',
	  pillar: PILLAR.Automate,
	  businessUnits: [BU.LF]
	}, {
	  id: 'marketplace-licenses',
	  appId: 'marketplace',
	  bgImage: 'url("https://picsum.photos/1920/1080?random&16")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&16")',
	  pillar: PILLAR.Grow,
	  businessUnits: [BU.Indigo]
	}, {
	  id: 'marketplace-ideas',
	  appId: 'marketplace',
	  bgImage: 'url("https://picsum.photos/id/631/1920/1080")',
	  // bgImage: 'url("https://picsum.photos/g/1920/1080?random&17")',
	  pillar: PILLAR.Grow,
	  businessUnits: [BU.Indigo]
	}];
	exports.appDefinitions = appDefinitions;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = landingContent;
	
	var _appDefinitions = __webpack_require__(486);
	
	var name = 'landingContent';
	exports.name = name;
	
	function landingContent() {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  landingContentController.$inject = ["rnClient", "rnLocale", "rnLocalStorage", "$gzEULA", "$gzAnalytics", "$translate", "$rootScope", "$window", "$timeout"];
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      bu: '=',
	      locale: '='
	    },
	    template: __webpack_require__(265),
	    link: landingContentLink,
	    controller: landingContentController,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	
	  function landingContentLink(scope, element, attrs) {}
	
	  /** @ngInject */
	  function landingContentController(rnClient, rnLocale, rnLocalStorage, $gzEULA, $gzAnalytics, $translate, $rootScope, $window, $timeout) {
	    // Constants
	    var HOST_WHITE_LIST = ['printos-dev.test', 'daily.gsbprint.net'];
	    // Variables
	    var currentLocale = undefined;
	    var isIconUX = false;
	
	    // View Model
	    var vm = this;
	    vm.loading = true;
	    vm.signInData = {};
	    vm.categories = [{
	      id: 'optimize',
	      icon: 'https://cdn.printos.com/images/signin/landing/Optimize.svg',
	      displayKey: 'register.register.Pillar_Optimize_Section',
	      apps: [],
	      filteredAppCount: 0
	    }, {
	      id: 'automate',
	      icon: 'https://cdn.printos.com/images/signin/landing/Automate.svg',
	      displayKey: 'register.register.Pillar_Automate_Section',
	      apps: [],
	      filteredAppCount: 0
	    }, {
	      id: 'grow',
	      icon: 'https://cdn.printos.com/images/signin/landing/Grow.svg',
	      displayKey: 'register.register.Pillar_Grow_Section',
	      apps: [],
	      filteredAppCount: 0
	    }];
	
	    vm.localeChanged = localeChanged;
	    vm.openTerms = openTerms;
	    vm.scroll = scroll;
	    vm.selectBU = selectBU;
	    vm.linkClicked = linkClicked;
	    vm.closeApp = closeApp;
	
	    activate();
	    return;
	
	    ///////////////////////////////////////////////////////////
	    // Activate
	    function activate() {
	      return rnClient.getConfig().then(function (cc) {
	        // isIconUX = cc.features.includes('ux-app-icons');
	        vm.supportURL = '#/support?fromState=signin&expanded=false';
	        if (vm.bu) {
	          vm.supportURL += '&bu=' + vm.bu;
	        }
	
	        if (HOST_WHITE_LIST.includes($window.location.host)) {
	          vm.isAppUX = true;
	        }
	
	        initApplications();
	        filterApplications();
	
	        $timeout(function () {
	          var myContainer = $window.document.getElementById('parallax-container');
	          if (myContainer) {
	            vm.showScrollButton = myContainer.scrollHeight > myContainer.clientHeight;
	            vm.atTop = myContainer.scrollTop === 0;
	            updateWelcomePositioning();
	            myContainer.addEventListener('scroll', function (event) {
	              $rootScope.$applyAsync(updateWelcomePositioning);
	            });
	          }
	        }, 2000);
	
	        $window.addEventListener('resize', function (event) {
	          var myContainer = $window.document.getElementById('parallax-container');
	          if (myContainer) {
	            $rootScope.$applyAsync(function () {
	              vm.showScrollButton = myContainer.scrollHeight > myContainer.clientHeight;
	              vm.atTop = myContainer.scrollTop === 0;
	              updateWelcomePositioning();
	            });
	          }
	        });
	      })['finally'](function () {
	        vm.loading = false;
	      });
	    }
	
	    function initApplications() {
	      _appDefinitions.appDefinitions.forEach(function (def) {
	        def.name = $translate.instant('register.register.' + def.id + '_Name');
	        def.desc = $translate.instant('register.register.' + def.id + '_Desc');
	        var iconDir = isIconUX ? 'icons2' : 'icons';
	        def.icon = 'https://cdn.printos.com/images/application/' + iconDir + '/' + def.appId + '.svg';
	        def.show = true;
	      });
	
	      vm.categories[0].apps = _appDefinitions.appDefinitions.filter(function (def) {
	        return def.pillar === _appDefinitions.PILLAR.Optimize;
	      });
	
	      vm.categories[1].apps = _appDefinitions.appDefinitions.filter(function (def) {
	        return def.pillar === _appDefinitions.PILLAR.Automate;
	      });
	
	      vm.categories[2].apps = _appDefinitions.appDefinitions.filter(function (def) {
	        return def.pillar === _appDefinitions.PILLAR.Grow;
	      });
	    }
	
	    function updateWelcomePositioning() {
	      var myContainer = $window.document.getElementById('parallax-container');
	      var test = $window.document.getElementById('caption-1');
	      var tRect = test.getBoundingClientRect();
	      var pRect = test.parentElement.getBoundingClientRect();
	      var heightOnScreen = pRect.height - myContainer.scrollTop;
	      var bottomWhiteSpace = (heightOnScreen - tRect.height) * 0.6;
	      test.style.bottom = bottomWhiteSpace < 64 ? '64px' : bottomWhiteSpace + 'px';
	      vm.atTop = myContainer.scrollTop === 0;
	    }
	
	    ///////////////////////////////////////////////////////////
	    // View Model
	    function localeChanged() {
	      currentLocale = vm.signInData.locale;
	      vm.locale = currentLocale;
	      $translate.use(currentLocale.value);
	      rnLocale.setLocalePreference(currentLocale);
	
	      // Temporarily commenting this out until we figure out a path forward with the following issue. This
	      // particular event ('locale dropdown - selected') is the #1 reported event in the 'register' category
	      // due to the fact that this function is called by Material Design during each page refresh, sign-in,
	      // and sign-out. It does not reflect actual usage by the user. However, we would like to know how often
	      // this is used.
	      //
	      //$gzAnalytics.eventSelect('locale dropdown', {label: currentLocale.value});
	    }
	
	    function openTerms() {
	      $gzEULA.show();
	    }
	
	    function scroll(event) {
	      event.preventDefault();
	      var myContainer = $window.document.getElementById('parallax-container');
	      if (vm.atTop) {
	        $gzAnalytics.event('Click: scroll Down button', { category: 'landing-page' });
	        myContainer.scrollTo({ top: myContainer.scrollHeight, behavior: 'smooth' });
	      } else {
	        $gzAnalytics.event('Click: scroll Up button', { category: 'landing-page' });
	        myContainer.scrollTo({ top: 0, behavior: 'smooth' });
	      }
	    }
	
	    function selectBU(bu) {
	      vm.bu = bu;
	      filterApplications();
	    }
	
	    function closeApp(app) {
	      $window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', { detail: { playerId: 'gz-carousel' } }));
	    }
	
	    function linkClicked(app) {
	      if (app.learn.link) {
	        $window.open(app.learn.link, '_blank');
	      }
	    }
	
	    ///////////////////////////////////////////////////////////
	    // Helpers
	    function filterApplications() {
	      vm.categories[0].filteredAppCount = 0;
	      vm.categories[1].filteredAppCount = 0;
	      vm.categories[2].filteredAppCount = 0;
	      vm.categories[0].apps.forEach(function (def) {
	        def.show = vm.bu ? def.businessUnits.includes(vm.bu) : true;
	        if (def.show) {
	          vm.categories[0].filteredAppCount++;
	        }
	      });
	      vm.categories[1].apps.forEach(function (def) {
	        def.show = vm.bu ? def.businessUnits.includes(vm.bu) : true;
	        if (def.show) {
	          vm.categories[1].filteredAppCount++;
	        }
	      });
	      vm.categories[2].apps.forEach(function (def) {
	        def.show = vm.bu ? def.businessUnits.includes(vm.bu) : true;
	        if (def.show) {
	          vm.categories[2].filteredAppCount++;
	        }
	      });
	    }
	  }
	}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	__webpack_require__(551);
	
	var _landingContentDirective = __webpack_require__(487);
	
	var landingContentDirective = _interopRequireWildcard(_landingContentDirective);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _gazelleSrcComponentsLocaleSelectLocaleSelectModule = __webpack_require__(43);
	
	var _gazelleSrcComponentsLocaleSelectLocaleSelectModule2 = _interopRequireDefault(_gazelleSrcComponentsLocaleSelectLocaleSelectModule);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	var _gazelleSrcComponentsUserEulaEulaModule = __webpack_require__(9);
	
	var _gazelleSrcComponentsUserEulaEulaModule2 = _interopRequireDefault(_gazelleSrcComponentsUserEulaEulaModule);
	
	var _gazelleSrcComponentsCarouselCarouselModule = __webpack_require__(49);
	
	var _gazelleSrcComponentsCarouselCarouselModule2 = _interopRequireDefault(_gazelleSrcComponentsCarouselCarouselModule);
	
	exports['default'] = angular.module('start.component.landing.content', ['ngMaterial', _angularTranslate2['default'], _gazelleSrcCoreAnalyticsAnalyticsModule2['default'], _gazelleSrcComponentsLocaleSelectLocaleSelectModule2['default'], _gazelleSrcComponentsUserEulaEulaModule2['default'], _gazelleSrcComponentsCarouselCarouselModule2['default']]).directive(landingContentDirective.name, landingContentDirective['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	'use strict';
	
	addLFDeviceController.$inject = ["rnHttp", "rnDevice", "$state", "$stateParams", "$window"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addLFDeviceController;
	var name = 'addLFDeviceController';
	
	exports.name = name;
	
	function addLFDeviceController(rnHttp, rnDevice, $state, $stateParams, $window) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var myParams = {};
	
	  var vm = this;
	  vm.loading = true;
	  vm.submitting = false;
	
	  // controller functions
	  vm.cancel = cancel;
	  vm.goSignIn = goSignIn;
	  vm.goSignUp = goSignUp;
	  vm.printerVerified = false;
	
	  activate();
	
	  ////////////////////////
	  function activate() {
	    myParams.data = $stateParams.data;
	    vm.code = $stateParams.lfCode;
	    if (!vm.code && _.get(myParams, 'data.lfCode')) {
	      vm.code = myParams.data.lfCode;
	    }
	
	    if ($stateParams.bu) {
	      myParams.bu = $stateParams.bu;
	      vm.bu = $stateParams.bu;
	    }
	
	    _.set(myParams, 'data.lfCode', vm.code);
	
	    var config = {
	      headers: {
	        'If-Modified-Since': undefined,
	        'Cache-Control': undefined
	      },
	      params: {
	        sc: vm.code
	      }
	    };
	
	    return rnHttp.get('lf_cc', 'ValidatePrinterSC', config).then(function (resp) {
	      if (resp.data.status === 'invalid') {
	        vm.errorKey = 'register.register.InvalidCode';
	        return;
	      }
	
	      vm.device = {
	        type: resp.data.type,
	        model: resp.data.pn,
	        serialNumber: resp.data.sn,
	        securityCode: vm.code,
	        internal: {}
	      };
	      rnDevice.addDisplayInfo(vm.device);
	
	      vm.printerVerified = true;
	    })['catch'](function (error) {
	      vm.errorKey = 'register.register.InvalidCode';
	    })['finally'](function () {
	      vm.loading = false;
	    });
	
	    // DEVELOPER TESTING
	    // vm.device = {
	    //   type: 'LatexPrinter',
	    //   model: 'CZ056A',
	    //   serialNumber: 'AL687470771',
	    //   internal: {}
	    // };
	    // rnDevice.addDisplayInfo(vm.device);
	    // vm.printerVerified = true;
	    // vm.loading = false;
	    // END DEVELOPER TESTING
	  }
	
	  function goSignIn() {
	    if (!vm.printerVerified) {
	      return;
	    }
	
	    _.set(myParams, 'chooseAccount', true);
	    // _.set(myParams, 'signout', true);
	    _.set(myParams, 'forward', true);
	    if (vm.code) {
	      _.set(myParams, 'lfCode', vm.code);
	      _.set(myParams, 'data.target.url', $window.location.origin + '/account/#/devices/add/lf/' + vm.code);
	      // _.set(myParams, 'data.target.messageKey', 'register.register.AddPrinterSignIn');
	    }
	    $state.go('signin', myParams);
	  }
	
	  function goSignUp() {
	    if (!vm.printerVerified) {
	      return;
	    }
	
	    if (vm.code) {
	      _.set(myParams, 'lfCode', vm.code);
	      _.set(myParams, 'data.device', vm.device);
	    }
	    $state.go('signup', myParams);
	  }
	
	  function cancel() {
	    $state.go('lf-code', myParams);
	  }
	}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	// import modules this module depends on
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _rhinoSrcCoreHttpHttpModule = __webpack_require__(11);
	
	var _rhinoSrcCoreHttpHttpModule2 = _interopRequireDefault(_rhinoSrcCoreHttpHttpModule);
	
	var _rhinoSrcComponentsDeviceDeviceModule = __webpack_require__(31);
	
	var _rhinoSrcComponentsDeviceDeviceModule2 = _interopRequireDefault(_rhinoSrcComponentsDeviceDeviceModule);
	
	var _lfAddController = __webpack_require__(489);
	
	var lfAdd = _interopRequireWildcard(_lfAddController);
	
	// import this modules components
	
	__webpack_require__(552);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.lfadd', [_angularUiRouter2['default'], _angularMaterial2['default'], _angularTranslate2['default'], 'rhino.core', _rhinoSrcCoreHttpHttpModule2['default'], _rhinoSrcComponentsDeviceDeviceModule2['default'], 'angulartics']).controller(lfAdd.name, lfAdd['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	'use strict';
	
	addLFCodeController.$inject = ["rnHttp", "$state", "$stateParams"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addLFCodeController;
	var name = 'addLFCodeController';
	
	exports.name = name;
	
	function addLFCodeController(rnHttp, $state, $stateParams) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var myParams = {};
	
	  var vm = this;
	  vm.loading = true;
	  vm.submitting = false;
	
	  // controller functions
	  vm.submit = submit;
	  vm.cancel = cancel;
	
	  activate();
	
	  ////////////////////////
	  function activate() {
	    if ($stateParams.bu) {
	      myParams.bu = $stateParams.bu;
	      vm.bu = $stateParams.bu;
	    }
	
	    myParams.data = $stateParams.data;
	    vm.loading = false;
	  }
	
	  function submit() {
	    vm.submitting = true;
	    delete vm.errorKey;
	
	    var config = {
	      headers: {
	        'If-Modified-Since': undefined,
	        'Cache-Control': undefined
	      },
	      params: {
	        sc: vm.code
	      }
	    };
	    return rnHttp.get('lf_cc', 'ValidatePrinterSC', config).then(function (resp) {
	      if (resp.data.status === 'invalid') {
	        vm.errorKey = 'register.register.InvalidCode';
	        return;
	      }
	
	      _.set(myParams, 'lfCode', vm.code);
	      $state.go('lf-add', myParams);
	    })['catch'](function (error) {
	      vm.errorKey = 'register.register.InvalidCode';
	    })['finally'](function () {
	      vm.submitting = false;
	    });
	  }
	
	  function cancel() {
	    $state.go('signin', myParams);
	  }
	}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	// import modules this module depends on
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _rhinoSrcCoreHttpHttpModule = __webpack_require__(11);
	
	var _rhinoSrcCoreHttpHttpModule2 = _interopRequireDefault(_rhinoSrcCoreHttpHttpModule);
	
	var _lfCodeController = __webpack_require__(491);
	
	var lfCode = _interopRequireWildcard(_lfCodeController);
	
	// import this modules components
	
	__webpack_require__(553);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.lfCode', [_angularUiRouter2['default'], _angularMaterial2['default'], _angularTranslate2['default'], 'rhino.core', _rhinoSrcCoreHttpHttpModule2['default'], 'angulartics']).controller(lfCode.name, lfCode['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RedirectController.$inject = ["$state", "$stateParams", "$location", "$window", "rnClient", "$analytics"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = RedirectController;
	
	var _gazelleSrcCoreAnalyticsGaCustomDefs = __webpack_require__(25);
	
	var name = 'RedirectController';
	
	exports.name = name;
	/**
	 * Provides for redirecting into PrintOS with analytics configured
	 * and for the locale cooke to be set by rhino.
	 */
	
	function RedirectController($state, $stateParams, $location, $window, rnClient, $analytics) {
	  'ngInject';
	
	  var myParams = {};
	
	  activate();
	
	  ////////////////////////
	
	  function activate() {
	    parseParams();
	    configureEntityAnalytics();
	    goToTargetUrl();
	  }
	
	  function parseParams() {
	    var urlParams = $location.search();
	
	    myParams.data = $stateParams.data;
	    if (urlParams.target) {
	      _.set(myParams, 'data.target.url', $window.decodeURIComponent(urlParams.target));
	    }
	  }
	
	  function goToTargetUrl() {
	    var target = _.get(myParams, 'data.target.url');
	    if (!target) {
	      // Redirect to sign-in without a valid target
	      return $state.go('signin');
	    }
	
	    $window.location.href = target;
	  }
	
	  function configureEntityAnalytics() {
	    return rnClient.getConfig().then(function (clientConfig) {
	      if (!clientConfig) {
	        return;
	      }
	
	      var entity = clientConfig.entity;
	      if (!entity) {
	        return;
	      }
	
	      $analytics.setUsername(entity.id);
	
	      // Set custom dimension1 for entity id (UID)
	      $window.ga('set', _gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.uid, entity.id);
	
	      // Set custom dimension2 for organization id (ORGID)
	      $window.ga('set', _gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.orgId, clientConfig.context.id);
	
	      // Set custom dimension3 for hpinternal (Use string, not Boolean "true" or "false")
	      // Currently not available through client config (recommend import data outside of UI)
	      //$window.ga('set', dimensions.hpInternal, hpInternal);
	
	      // Set custom dimension4 for user role names
	      // Currently not available through client config (recommend import data outside of UI)
	      //if (rolesString) {
	      //  $window.ga('set', dimensions.roles, rolesString);
	      //}
	
	      // Set custom dimension5 for organization type
	      // Currently not available through client config (recommend import data outside of UI)
	      //$window.ga('set', dimensions.orgType, orgType);
	
	      // Set custom dimension6 for selfProvisioned (Use string, not Boolean "true" or "false")
	      //$window.ga('set', dimensions.selfProvisioned, selfProvisioned);
	
	      // Set custom dimension7 for the entity type (ENTITY TYPE)
	      $window.ga('set', _gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.entityType, entity.type);
	
	      var target = _.get(myParams, 'data.target.url');
	      $analytics.eventTrack('redirect', { category: 'account', label: target });
	    });
	  }
	}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angulartics = __webpack_require__(41);
	
	var _angulartics2 = _interopRequireDefault(_angulartics);
	
	var _gazelleSrcComponentsSpinnerSpinnerModule = __webpack_require__(44);
	
	var _gazelleSrcComponentsSpinnerSpinnerModule2 = _interopRequireDefault(_gazelleSrcComponentsSpinnerSpinnerModule);
	
	var _rhinoSrcCoreCoreModule = __webpack_require__(4);
	
	var _rhinoSrcCoreCoreModule2 = _interopRequireDefault(_rhinoSrcCoreCoreModule);
	
	var _redirectController = __webpack_require__(493);
	
	var redirect = _interopRequireWildcard(_redirectController);
	
	__webpack_require__(554);
	
	exports['default'] = angular.module('register.components.redirect', [_angularUiRouter2['default'], _angulartics2['default'], _gazelleSrcComponentsSpinnerSpinnerModule2['default'], _rhinoSrcCoreCoreModule2['default']]).controller(redirect.name, redirect['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	detectAutoFill.$inject = ["$timeout"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = detectAutoFill;
	var name = 'detectAutoFill';
	
	exports.name = name;
	
	function detectAutoFill($timeout) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    require: 'ngModel',
	    restrict: 'EA',
	    link: detectAutoFillLink
	  };
	
	  return directive;
	
	  //////////////////////
	  function detectAutoFillLink(scope, element, attrs, ctrl) {
	    var focusId = attrs.focusCtrl;
	    var start = element.val();
	    $timeout(function () {
	      var current = element.val();
	      if (ctrl.$pristine && start !== current) {
	        ctrl.$setViewValue(current);
	        var focusCtrl = document.getElementById(focusId);
	        if (focusCtrl) {
	          focusCtrl.focus();
	        }
	      }
	    }, 500);
	  }
	}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	'use strict';
	
	SelectAccountController.$inject = ["$mdDialog", "$gzAnalytics", "contexts", "targetContext"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SelectAccountController;
	var name = 'SelectAccountController';
	exports.name = name;
	
	function SelectAccountController($mdDialog, $gzAnalytics, contexts, targetContext) {
	
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  /* jshint validthis: true */
	  var vm = this;
	  vm.sending = false;
	  vm.errorKey = null;
	
	  vm.submit = submit;
	  vm.cancel = cancel;
	
	  activate();
	
	  ////////////////
	
	  function activate() {
	    vm.contexts = _.sortBy(contexts, function (context) {
	      return context.name.toLocaleLowerCase();
	    });
	
	    if (_.get(targetContext, 'id')) {
	      vm.selectedContext = targetContext;
	    }
	  }
	
	  function submit() {
	    $mdDialog.hide(vm.selectedContext);
	    $gzAnalytics.event('select account', { context: vm.selectedContext.name });
	  }
	
	  function cancel($event) {
	    $mdDialog.cancel();
	    $gzAnalytics.eventCancel('select account - cancelled');
	  }
	}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(555);
	
	var _gazelleSrcComponentsErrorErrorModule = __webpack_require__(51);
	
	var _gazelleSrcComponentsErrorErrorModule2 = _interopRequireDefault(_gazelleSrcComponentsErrorErrorModule);
	
	var _gazelleSrcComponentsErrorBarErrorBarModule = __webpack_require__(50);
	
	var _gazelleSrcComponentsErrorBarErrorBarModule2 = _interopRequireDefault(_gazelleSrcComponentsErrorBarErrorBarModule);
	
	var _gazelleSrcComponentsFormContentFormContentModule = __webpack_require__(54);
	
	var _gazelleSrcComponentsFormContentFormContentModule2 = _interopRequireDefault(_gazelleSrcComponentsFormContentFormContentModule);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	var _selectAccountController = __webpack_require__(496);
	
	var selectAccount = _interopRequireWildcard(_selectAccountController);
	
	exports['default'] = angular.module('account.devices.delete', [_angularMaterial2['default'], _angularUiRouter2['default'], _gazelleSrcComponentsErrorErrorModule2['default'], _gazelleSrcComponentsErrorBarErrorBarModule2['default'], _gazelleSrcComponentsFormContentFormContentModule2['default'], _angularTranslate2['default'], _gazelleSrcCoreAnalyticsAnalyticsModule2['default'], 'angulartics']).controller(selectAccount.name, selectAccount['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	SignInController.$inject = ["$gzEULA", "rnAuthService", "rnSession", "rnLocalStorage", "$translate", "$state", "$stateParams", "$window", "$location", "$q", "$gzAnalytics", "rnHttp", "rnUser", "rnPreferences", "rnApplication", "rnFeature", "rnClient", "$gzHpId", "rnStart", "moment", "rnRegistry", "$mdDialog", "$stStations", "$timeout"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = SignInController;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _validUrl = __webpack_require__(563);
	
	var _validUrl2 = _interopRequireDefault(_validUrl);
	
	var _gazelleSrcCoreAnalyticsGaCustomDefs = __webpack_require__(25);
	
	var name = 'SignInController';
	
	exports.name = name;
	
	function SignInController($gzEULA, rnAuthService, rnSession, rnLocalStorage, $translate, $state, $stateParams, $window, $location, $q, $gzAnalytics, rnHttp, rnUser, rnPreferences, rnApplication, rnFeature, rnClient, $gzHpId, rnStart, moment, rnRegistry, $mdDialog, $stStations, $timeout) {
	  //noinspection BadExpressisionStatementJS
	  'ngInject';
	
	  var signOutRequested = false;
	  var promptForAccount = false;
	  var autoForward = false;
	  var myParams = {};
	
	  // Welcome Page
	  var WELCOME_URL = '/home/#/welcome';
	  var GETTING_STARTED_URL = '/home/#/start';
	  var firstTimeUser = false;
	  var applications = [];
	  var isInvite = false;
	
	  var vm = this;
	  vm.loading = true;
	  vm.submitting = false;
	  vm.hpidHelp = false;
	  vm.isTrustedStation = false;
	  vm.helpCenterEnabled = false;
	
	  // controller functions
	  vm.signin = signin;
	  vm.signinAltUsername = signinAltUsername;
	  vm.openSupportRequest = openSupportRequest;
	  vm.hpidHelpClicked = hpidHelpClicked;
	  vm.signUp = signUp;
	  vm.oeeCheckIn = oeeCheckIn;
	  vm.focusSignIn = focusSignIn;
	
	  vm.unitTest = {
	    parseParams: parseParams,
	    launchPrintOS: launchPrintOS,
	    ensureContext: ensureContext,
	    handleError: handleError,
	    signInAnalytics: signInAnalytics,
	    getSignOutRequested: function getSignOutRequested() {
	      return signOutRequested;
	    },
	    getMyParams: function getMyParams() {
	      return myParams;
	    },
	    setApplications: function setApplications(apps) {
	      return applications = apps;
	    },
	    setStartInfo: function setStartInfo(value) {
	      return startInfo = value;
	    }
	  };
	
	  activate();
	
	  ////////////////////////
	  function activate() {
	    detectUnsupportedBrowsers();
	    getHelpCenterEnabledRegistryKey();
	    parseParams();
	    $timeout(function () {
	      focusSignIn();
	    }, 400);
	    // If signOut requested
	    if (signOutRequested) {
	      signout();
	    } else {
	      initialize();
	    }
	  }
	
	  function focusSignIn() {
	    var myContainer = $window.document.getElementById('btn-signin');
	    if (myContainer) {
	      myContainer.focus();
	    }
	  }
	
	  function detectUnsupportedBrowsers() {
	    vm.isUnsupportedBrowser = $window.navigator.userAgent.indexOf("MSIE") !== -1 || $window.navigator.userAgent.indexOf("rv:11") !== -1;
	  }
	
	  function detectTrustedStationSecret() {
	    return $stStations.hasKey().then(function (isTrustedStation) {
	      vm.isTrustedStation = isTrustedStation;
	    });
	  }
	
	  function parseParams() {
	    var urlParams = $location.search();
	    if ($stateParams.signout || urlParams.signout) {
	      signOutRequested = true;
	    }
	
	    if ($stateParams.forward) {
	      autoForward = true;
	    }
	
	    if ($stateParams.chooseAccount || urlParams.chooseAccount) {
	      promptForAccount = true;
	    }
	
	    if ($stateParams.bu) {
	      myParams.bu = $stateParams.bu;
	      vm.bu = $stateParams.bu;
	    }
	
	    myParams.data = $stateParams.data;
	    if (urlParams.target) {
	      _.set(myParams, 'data.target.url', $window.decodeURIComponent(urlParams.target));
	    }
	
	    if (urlParams.statusCode && urlParams.statusCode !== 200) {
	      _.set(myParams, 'data.error.statusCode', urlParams.statusCode);
	      _.set(myParams, 'data.error.subCode', urlParams.subCode);
	    }
	
	    isInvite = _.get(myParams, 'data.invitationId', false) ? true : false;
	    vm.messageKey = _.get(myParams, 'data.target.messageKey', urlParams.messageKey);
	    vm.messageParams = _.get(myParams, 'data.target.messageParams', urlParams.messageParams);
	  }
	
	  function initialize() {
	    rnUser.validateUserToken().then(function (data) {
	      if (_.get(myParams, 'data.error.statusCode')) {
	        // let statusCode = parseInt(_.get(myParams, 'data.error.statusCode'));
	        // let subCode = parseInt(_.get(myParams, 'data.error.subCode'));
	        //
	        // handleError(statusCode, subCode);
	        delete myParams.data.error;
	      } else {
	        return initLaunch({ data: data, reportLogin: false });
	      }
	    })['catch'](function () {
	      // User not signed in
	      var promises = [];
	      promises.push(detectTrustedStationSecret());
	      $q.all(promises).then(function () {})['catch'](function () {
	        // don't care
	      })['finally'](function () {
	        if (!autoForward) {
	          vm.loading = false;
	        }
	
	        var loadingFinished = $window.performance.now();
	        $window.ga('send', {
	          hitType: 'timing',
	          timingCategory: 'register',
	          timingVar: 'sign-in',
	          timingValue: loadingFinished
	        });
	
	        if (_.get(myParams, 'data.error.statusCode')) {
	          var statusCode = parseInt(_.get(myParams, 'data.error.statusCode'));
	          var subCode = parseInt(_.get(myParams, 'data.error.subCode'));
	
	          handleError(statusCode, subCode);
	        } else if (autoForward) {
	          signin();
	        }
	      });
	    });
	  }
	
	  function handleError(statusCode, subCode) {
	    $gzAnalytics.event('Sign In - error', { label: statusCode + ' - ' + subCode });
	
	    switch (statusCode) {
	      case 401:
	        switch (subCode) {
	          case 1000:
	            // Need to accept EULA
	            firstTimeUser = true;
	            $gzEULA.show(true, null, true).then(function (result) {
	              vm.submitting = true;
	              _.set(vm, 'signInData.eulaVersion', result.eulaVersion);
	              signin();
	            })['catch'](function () {
	              vm.errorKey = 'register.register.SignIn_Error_EulaNotAccepted';
	            });
	            break;
	          case 1003:
	            // Account is locked
	            displayErrorAndForceLogin('register.register.SignIn_Error_AccountLocked');
	            break;
	          case 1016:
	            // Need to accept NEW EULA
	            $gzEULA.show(true, null, true, true).then(function (result) {
	              vm.submitting = true;
	              _.set(vm, 'signInData.eulaVersion', result.eulaVersion);
	              signin();
	            })['catch'](function (result) {
	              vm.submitting = true;
	              _.set(myParams, 'signout', true);
	              $state.go('signin', myParams);
	            });
	            break;
	          case 1026:
	            // Not enabled in HP ID
	            displayErrorAndForceLogin('register.register.SignIn_Error_NotEnabledInHPID');
	            break;
	          case 1027:
	            // Unsupported identity provider
	            displayErrorAndForceLogin('register.register.SignIn_Error_UnsuportedIdentityProvider');
	            break;
	          case 1032:
	            // Did not accept EULA
	            displayErrorAndForceLogin('register.register.SignIn_Error_EulaNotAccepted');
	            break;
	          case 1040:
	            // Expired or missing session key id
	            displayErrorAndForceLogin('register.register.SignIn_Error_ExpiredOrMissingSessionKeyId');
	            break;
	          default:
	            // Unmapped 401 Error
	            vm.errorKey = 'register.register.SignIn_Error_Unknown';
	            break;
	        }
	        break;
	      case 404:
	        switch (subCode) {
	          case 1023:
	            // HPID Link Expired
	            displayErrorAndForceLogin('register.register.SignIn_Error_HPID_Link_Expired');
	            signin();
	            break;
	          case 1024:
	            // User is not in PrintOS
	            vm.errorValues = [$stateParams.username];
	            vm.altUsernames = _.get($stateParams, 'altUsername');
	
	            if (vm.altUsernames) {
	              if (!Array.isArray(vm.altUsernames)) {
	                vm.altUsernames = [vm.altUsernames];
	              }
	
	              $gzAnalytics.eventClick('Sign In - Showing alternate usernames', { label: vm.altUsernames.length });
	              vm.forceLogin = true;
	            } else {
	              displayErrorAndForceLogin('register.register.SignIn_Error_SignInWithDifferentHPID');
	            }
	            break;
	          default:
	            // Unmapped 404 Error
	            vm.errorKey = 'register.register.SignIn_Error_Unknown';
	            break;
	        }
	        break;
	      case 500:
	        switch (subCode) {
	          case 1025:
	            displayErrorAndForceLogin('register.register.SignIn_Error_Unknown');
	            break;
	          case 1026:
	            displayErrorAndForceLogin('register.register.SignIn_Error_NoAvailableContexts');
	            break;
	          default:
	            // Unmapped 500 Error
	            displayErrorAndForceLogin('register.register.SignIn_Error_Unknown');
	            break;
	        }
	        break;
	      default:
	        // Unknown Error
	        vm.errorKey = 'register.register.SignIn_Error_Unknown';
	        break;
	    }
	  }
	
	  function displayErrorAndForceLogin(errMsg) {
	    vm.forceLogin = true;
	    vm.errorKey = errMsg;
	  }
	
	  function signinAltUsername(altUsername) {
	    $stateParams.username = altUsername;
	    signin();
	    $gzAnalytics.eventClick('Sign In - Alternate username clicked');
	  }
	
	  function signin() {
	    var type = arguments.length <= 0 || arguments[0] === undefined ? 'login' : arguments[0];
	
	    vm.submitting = true;
	    delete vm.errorKey;
	
	    //send analytics event when user clicks on sign in button if trusted station has been detected
	    if (vm.isTrustedStation) {
	      $gzAnalytics.eventClick('Trusted station configuration detected - Sign in clicked');
	    }
	
	    $gzAnalytics.eventClick('Sign In - Sign in clicked');
	
	    var returnUrl = $gzHpId.createTargetUrl($state.current.name, {
	      messageKey: vm.messageKey,
	      messageParams: vm.messageParams,
	      target: _.get(myParams, 'data.target.url')
	    });
	
	    var params = {
	      // (if eulaVersion is null it won't be sent)
	      eulaVersion: _.get(vm, 'signInData.eulaVersion'),
	      locale: vm.locale,
	      username: $stateParams.username,
	      userId: $stateParams.userId,
	      orgId: $stateParams.orgId
	    };
	
	    if (vm.forceLogin) {
	      params.forceLogin = true;
	      vm.forceLogin = false;
	    }
	
	    return $gzHpId.redirect(type, returnUrl, params)['catch'](function () {
	      vm.submitting = false;
	      vm.errorKey = 'register.register.SignIn_Error_HPID_RedirectFailed';
	    });
	  }
	
	  function oeeCheckIn() {
	    if (vm.submitting) {
	      return;
	    }
	    $gzAnalytics.eventClick('OEE Sign In clicked');
	    $window.location.href = '/oee';
	  }
	
	  function initLaunch(analyticsData) {
	    // Must ensure a valid context before continuing (not something you can do in parallel)
	    if (isInvite) {
	      launchPrintOS();
	    } else {
	      return ensureContext().then(function () {
	        var promises = [];
	        if (analyticsData) {
	          promises.push(signInAnalytics(analyticsData));
	        }
	
	        promises.push(getStartInfo());
	        promises.push(getApplications());
	        $q.all(promises).then(function () {
	          launchPrintOS();
	        })['catch'](function () {
	          vm.errorKey = 'register.register.SignIn_Error_UnknownLaunch';
	          vm.loading = false;
	        });
	      });
	    }
	  }
	
	  var startInfo = undefined;
	  function getStartInfo() {
	    return rnStart.getStartInfo().then(function (resp) {
	      startInfo = resp;
	    });
	  }
	
	  function getApplications() {
	    return rnApplication.getFullApps(true).then(function (apps) {
	      applications = apps;
	    });
	  }
	
	  function getOrg() {
	    return rnHttp.get('aaa', 'organizations', { cache: true }).then(function (resp) {
	      return resp.data;
	    });
	  }
	
	  function signInAnalytics(signInResponse) {
	    var promises = [];
	    var org = undefined;
	    var rolesResponse = undefined;
	    var clientConfig = undefined;
	    promises.push(getOrg().then(function (orgData) {
	      org = orgData;
	    }));
	
	    promises.push(rnUser.getSelectedUserRoles().then(function (resp) {
	      rolesResponse = resp;
	    }));
	
	    promises.push(rnClient.getConfig(false).then(function (config) {
	      clientConfig = config;
	    }));
	
	    return $q.all(promises)['finally'](function () {
	      var userId = signInResponse.data.user.userId;
	
	      var orgId = signInResponse.data.context.id;
	      if (clientConfig.managingContext) {
	        orgId = clientConfig.managingContext.id;
	      }
	
	      var userRoleNames = [];
	      _.forEach(rolesResponse.userRoles, function (role) {
	        var contextId = _.get(role, 'context.id', undefined);
	        var systemRole = _.get(role, 'systemRole.name', undefined);
	        if (contextId && contextId === orgId && systemRole) {
	          userRoleNames.push(systemRole);
	        }
	      });
	
	      var rolesString = userRoleNames.join('|');
	
	      // Set custom dimension1 for user id (UID)
	      $window.ga('set', _gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.uid, userId);
	
	      // Set custom dimension2 for organization id (ORGID)
	      var analyticsUserId = userId;
	      if (orgId) {
	        $window.ga('set', _gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.orgId, orgId);
	        analyticsUserId = orgId + '|' + userId;
	      }
	
	      $gzAnalytics.setUserName(userId);
	
	      // Set custom dimension4 for user role names
	      if (rolesString) {
	        $window.ga('set', _gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.roles, rolesString);
	      }
	
	      if (!clientConfig.managingContext) {
	        var selfProvisioned = _.get(org, 'anonymous', undefined) ? "true" : "false";
	        // Set custom dimension6 for selfProvisioned (Use string, not Boolean "true" or "false")
	        $window.ga('set', _gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.selfProvisioned, selfProvisioned);
	      }
	
	      // Set custom dimension7 for the entity type (ENTITY TYPE), always user through sign in
	      $window.ga('set', _gazelleSrcCoreAnalyticsGaCustomDefs.dimensions.entityType, 'User');
	
	      $gzAnalytics.event(signInResponse.reportLogin ? 'login' : 'launch', { category: 'start', label: analyticsUserId });
	    });
	  }
	
	  function signUp() {
	    $state.go('signup', myParams);
	    $gzAnalytics.eventClick('Sign In - Sign Up clicked');
	  }
	
	  function openSupportRequest() {
	    _.set(myParams, 'fromState', 'signin');
	    $state.go('support', myParams);
	  }
	
	  function ensureContext() {
	    var promises = [];
	    promises.push(rnClient.getConfig());
	    promises.push(rnSession.availableContexts());
	    promises.push(rnSession.userContext());
	    return $q.all(promises).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 3);
	
	      var clientConfig = _ref2[0];
	      var contextData = _ref2[1];
	      var userContext = _ref2[2];
	
	      var contexts = contextData.contexts;
	
	      var urlRequestedContext = undefined;
	      if (clientConfig.entity.id === $stateParams.userId && $stateParams.orgId) {
	        urlRequestedContext = contexts.find(function (c) {
	          return c.id === $stateParams.orgId;
	        });
	      }
	
	      if (contexts.length === 0) {
	        displayErrorAndForceLogin('register.register.SignIn_Error_NoAvailableContexts');
	        vm.submitting = false;
	        vm.loading = false;
	        return $q.reject(vm.errorKey);
	      } else if (contexts.length === 1) {
	        // If we have one context then we can set the user context to that and go
	        if (_.get(userContext, 'id') === contexts[0].id) {
	          return;
	        }
	
	        return rnSession.switchContext(contexts[0]);
	      } else if (_.get(userContext, 'id') && !promptForAccount && !urlRequestedContext) {
	        // If multiple accounts (Existing session)
	        // we can just use the user context if we are not supposed to prompt
	        return;
	      }
	
	      var targetContext = userContext;
	      // If we are an HP Inc. account we need to target that as a priority
	      var hpContext = _.find(contexts, { name: 'HP Inc.' });
	      if (hpContext) {
	        targetContext = hpContext;
	      }
	
	      if (urlRequestedContext) {
	        targetContext = urlRequestedContext;
	      }
	
	      if (promptForAccount || !_.get(targetContext, 'id')) {
	        // Prompt the user to choose context
	        return $mdDialog.show({
	          clickOutsideToClose: false,
	          escapeToClose: true,
	          template: __webpack_require__(269),
	          controller: 'SelectAccountController',
	          bindToController: true,
	          controllerAs: 'vm',
	          locals: {
	            contexts: contexts,
	            targetContext: targetContext
	          }
	        }).then(function (selectedContext) {
	          if (selectedContext.id !== _.get(userContext, 'id')) {
	            return rnSession.switchContext(selectedContext);
	          }
	        })['catch'](function () {
	          // Account selection was cancelled...just return
	          vm.forceLogin = true;
	          vm.submitting = false;
	          vm.loading = false;
	          return $q.reject();
	        });
	      }
	
	      return rnSession.switchContext(targetContext);
	    });
	  }
	
	  function launchPrintOS() {
	    var targetState = _.get(myParams, 'data.target.state', undefined);
	    if (targetState) {
	      delete myParams.signout;
	      $state.go(targetState, myParams);
	      return;
	    }
	
	    goToTargetUrl();
	  }
	
	  function goToTargetUrl() {
	    var target = _.get(myParams, 'data.target.url');
	    if (!_validUrl2['default'].isWebUri(target)) {
	      if (startInfo.hasIncompleteSteps) {
	        target = GETTING_STARTED_URL;
	      } else if (startInfo.showWelcome) {
	        target = WELCOME_URL;
	      } else {
	        var defaultApp = _.find(applications, { appId: startInfo.defaultAppId });
	        if (!defaultApp) {
	          // TODO: consider setting preference to home since default app not found
	          defaultApp = _.find(applications, { appId: 'home' });
	        }
	
	        target = defaultApp._links.self;
	      }
	    }
	
	    $window.location.href = target;
	  }
	
	  function signout() {
	    if (true) {
	      $gzAnalytics.event('logout', { category: 'register' });
	    }
	
	    vm.submitting = true;
	    var params = {
	      messageKey: vm.messageKey,
	      messageParams: vm.messageParams,
	      statusCode: null,
	      subCode: null
	    };
	
	    // Remember target if we are forcing a signout
	    var targetURL = _.get(myParams, 'data.target.url');
	    if (targetURL) {
	      params.target = targetURL;
	    }
	
	    var returnUrl = $gzHpId.createTargetUrl($state.current.name, params);
	    return $gzHpId.redirect('logout', returnUrl, {})['catch'](function () {
	      vm.submitting = false;
	      vm.errorKey = 'register.register.SignIn_Error_HPID_RedirectFailed';
	    });
	  }
	
	  function hpidHelpClicked() {
	    vm.hpidHelp = !vm.hpidHelp;
	    if (vm.hpidHelp) {
	      $gzAnalytics.eventClick('HPID - Help opened');
	    } else {
	      $gzAnalytics.eventClick('HPID - Help closed');
	    }
	  }
	
	  function getHelpCenterEnabledRegistryKey() {
	    rnRegistry.getRegistry().then(function (registry) {
	      vm.helpCenterEnabled = registry.keys.helpCenterEnabled;
	    });
	  }
	}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(556);
	
	// import modules this module depends on
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _gazelleSrcComponentsUserEulaEulaModule = __webpack_require__(9);
	
	var _gazelleSrcComponentsUserEulaEulaModule2 = _interopRequireDefault(_gazelleSrcComponentsUserEulaEulaModule);
	
	var _rhinoSrcComponentsSessionSessionModule = __webpack_require__(10);
	
	var _rhinoSrcComponentsSessionSessionModule2 = _interopRequireDefault(_rhinoSrcComponentsSessionSessionModule);
	
	var _rhinoSrcComponentsFeatureFeatureModule = __webpack_require__(67);
	
	var _rhinoSrcComponentsFeatureFeatureModule2 = _interopRequireDefault(_rhinoSrcComponentsFeatureFeatureModule);
	
	var _angularMoment = __webpack_require__(38);
	
	var _angularMoment2 = _interopRequireDefault(_angularMoment);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	var _gazelleSrcComponentsHpidHpidModule = __webpack_require__(13);
	
	var _gazelleSrcComponentsHpidHpidModule2 = _interopRequireDefault(_gazelleSrcComponentsHpidHpidModule);
	
	var _detectAutoFillModule = __webpack_require__(77);
	
	var _detectAutoFillModule2 = _interopRequireDefault(_detectAutoFillModule);
	
	var _rhinoSrcCoreRegistryRegistryModule = __webpack_require__(34);
	
	var _rhinoSrcCoreRegistryRegistryModule2 = _interopRequireDefault(_rhinoSrcCoreRegistryRegistryModule);
	
	var _rhinoSrcComponentsStartStartModule = __webpack_require__(72);
	
	var _rhinoSrcComponentsStartStartModule2 = _interopRequireDefault(_rhinoSrcComponentsStartStartModule);
	
	var _gazelleSrcComponentsLocaleSelectLocaleSelectModule = __webpack_require__(43);
	
	var _gazelleSrcComponentsLocaleSelectLocaleSelectModule2 = _interopRequireDefault(_gazelleSrcComponentsLocaleSelectLocaleSelectModule);
	
	// import this modules components
	
	var _stationsService = __webpack_require__(500);
	
	var $stStations = _interopRequireWildcard(_stationsService);
	
	var _signInController = __webpack_require__(498);
	
	var signIn = _interopRequireWildcard(_signInController);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.signin', [_gazelleSrcComponentsUserEulaEulaModule2['default'], _angularUiRouter2['default'], _angularMaterial2['default'], _angularMoment2['default'], _angularTranslate2['default'], _rhinoSrcComponentsSessionSessionModule2['default'], _rhinoSrcComponentsFeatureFeatureModule2['default'], _rhinoSrcComponentsStartStartModule2['default'], _rhinoSrcCoreRegistryRegistryModule2['default'], _gazelleSrcCoreAnalyticsAnalyticsModule2['default'], _gazelleSrcComponentsHpidHpidModule2['default'], _gazelleSrcComponentsLocaleSelectLocaleSelectModule2['default'], 'rhino.components.locale', 'rhino.components.user', 'rhino.core', 'angulartics', _detectAutoFillModule2['default']]).controller(signIn.name, signIn['default']).factory($stStations.name, $stStations['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = $stStations;
	
	var _idbKeyval = __webpack_require__(509);
	
	var name = '$stStations';
	exports.name = name;
	
	function $stStations() {
	  'ngInject';
	
	  // Constants
	  var idbStore = new _idbKeyval.Store('printos', 'hmacs');
	
	  // Variables
	
	  // Service
	  var service = {
	    hasKey: hasKey
	  };
	  return service;
	
	  //////////////
	  // Service
	
	  function hasKey() {
	    return (0, _idbKeyval.get)('trustedStation', idbStore).then(function (hmac) {
	      return hmac !== undefined;
	    });
	  }
	}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	'use strict';
	
	SignUpController.$inject = ["$location", "$q", "rnDevice", "rnHttp", "rnLocale", "rnInstructionsService", "$state", "$stateParams", "$timeout", "$translate", "$gzAnalytics", "$window", "rnRegistry"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SignUpController;
	var name = 'SignUpController';
	
	exports.name = name;
	
	function SignUpController($location, $q, rnDevice, rnHttp, rnLocale, rnInstructionsService, $state, $stateParams, $timeout, $translate, $gzAnalytics, $window, rnRegistry) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var US_VALIDATORS = {
	    region: {
	      maxlength: 2,
	      validator: 'Validator.AAA.USState'
	    },
	    postalCode: {
	      maxlength: 10,
	      validator: 'Validator.AAA.USPostalCode'
	    }
	  };
	
	  var CANADA_VALIDATORS = {
	    region: {
	      maxlength: 2,
	      validator: 'Validator.AAA.CAProvidences'
	    },
	    postalCode: {
	      maxlength: 7,
	      validator: 'Validator.AAA.CAPostalCode'
	    }
	  };
	
	  var DEFAULT_VALIDATORS = {
	    region: {
	      maxlength: 100,
	      validator: 'Validator.AAA.DescriptionUnicode'
	    },
	    postalCode: {
	      maxlength: 35,
	      validator: 'Validator.AAA.PostalCode'
	    }
	  };
	
	  var EMAIL_SERVICE = 'email_service';
	  var EMAIL_SELF_INVITE_PATH = 'invitations/self';
	  var SUPPORT_SERVICE = 'supportapp_service';
	  var CAPTCHA_PATH = 'captcha/key';
	  var PORTAL_SERVICE = 'portal_service';
	  var US_COUNTRY_CODE = 'US';
	  var CANADA_COUNTRY_CODE = 'CA';
	
	  var locale = {};
	  var myParams = {};
	  var captchaId = undefined;
	  var incoming3D = false;
	
	  var vm = this;
	
	  vm.loading = true;
	  vm.submitting = false;
	  vm.validators = DEFAULT_VALIDATORS;
	  vm.signupForm = null;
	  vm.deviceTypesAndModels = null;
	  vm.device = {};
	  vm.internalId = null;
	  vm.deviceModels = [];
	  vm.titles = [];
	  vm.address = null;
	  vm.showScitexId = false;
	  vm.showScitexIdHelp = false;
	  vm.helpCenterEnabled = false;
	
	  // controller functions
	  vm.getDeviceTypesAndModels = getDeviceTypesAndModels;
	  vm.typeChanged = typeChanged;
	  vm.modelChanged = modelChanged;
	  vm.countryChanged = countryChanged;
	  vm.getCountry = getCountry;
	  vm.getCountries = getCountries;
	  vm.disableSubmit = disableSubmit;
	  vm.submit = submit;
	  vm.cancel = cancel;
	  vm.renderRecaptcha = renderRecaptcha;
	  vm.executeRecaptcha = executeRecaptcha;
	  vm.scitexIdHelpClicked = scitexIdHelpClicked;
	
	  vm.$onInit = onInit;
	
	  ////////////////////////
	  function onInit() {
	    myParams.data = $stateParams.data;
	    vm.inputDevice = _.get($stateParams, 'data.device');
	    if (vm.inputDevice) {
	      _.set(vm.device, 'type', vm.inputDevice.type);
	      _.set(vm.device, 'model', vm.inputDevice.model);
	      _.set(vm.device, 'serialNumber', vm.inputDevice.serialNumber);
	      if (vm.inputDevice.securityCode) {
	        vm.activationDetails = {
	          securityCode: vm.inputDevice.securityCode
	        };
	      }
	    }
	    getHelpCenterEnabledRegistryKey();
	
	    var promises = [];
	    promises.push(getDeviceTypes());
	    promises.push(getCountries());
	    promises.push(getSiteKey());
	    promises.push(getLocale());
	
	    return $q.all(promises).then(function (data) {
	      initDeviceTypesAndModels(data[0]);
	      vm.countries = data[1];
	      parseParams();
	    })['finally'](function () {
	      countryChanged();
	      initTitles();
	      if (!$window.grecaptcha) {
	        vm.errorKey = 'register.register.SignUp_Error_NoCaptcha';
	        vm.noCaptcha = true;
	        $gzAnalytics.event('Sign Up - no captcha');
	      }
	      vm.loading = false;
	    });
	  }
	
	  function getLocale() {
	    return rnLocale.getBestFit().then(function (l) {
	      locale = l;
	    });
	  }
	
	  function getSiteKey() {
	    return rnHttp.get(SUPPORT_SERVICE, CAPTCHA_PATH, { version: 1 }).then(function (resp) {
	      vm.captchaSiteID = resp.data.key;
	    });
	  }
	
	  function renderRecaptcha() {
	    if ($window.grecaptcha) {
	      captchaId = $window.grecaptcha.render('recaptchaSignUp', {
	        sitekey: vm.captchaSiteID,
	        callback: submit,
	        // Recaptcha errors are also handled in submit method
	        'error-callback': submit,
	        'expired-callback': submit
	      });
	    }
	  }
	
	  function executeRecaptcha() {
	    if ($window.grecaptcha) {
	      $window.grecaptcha.execute(captchaId);
	      $gzAnalytics.eventClick('Sign up - Captcha executed');
	    }
	  }
	
	  function getDeviceTypes() {
	    return rnDevice.getDeviceModels().then(function (deviceModelList) {
	      vm.deviceTypesAndModels = deviceModelList;
	    });
	  }
	
	  function initDeviceTypesAndModels(deviceModelList) {
	    // Remove all unreleased models
	    _.forEach(vm.deviceTypesAndModels, function (deviceModels) {
	      _.remove(deviceModels.models, function (model) {
	        return model.released === false;
	      });
	    });
	
	    // Remove model type if no models left for it
	    _.remove(vm.deviceTypesAndModels, function (modelType) {
	      return modelType.models.length === 0;
	    });
	
	    // Sort based on localized values
	    var temp = [];
	    var name = '';
	    for (var i = 0; i < vm.deviceTypesAndModels.length; i++) {
	      name = $translate.instant('devices.devices.' + vm.deviceTypesAndModels[i].name);
	      temp.push({ originalObject: vm.deviceTypesAndModels[i], localizedName: name });
	    }
	    vm.deviceTypesAndModels = _.pluck(_.sortBy(temp, 'localizedName'), 'originalObject');
	
	    var uiTypesAndModels = [];
	    _.forEach(vm.deviceTypesAndModels, function (deviceType) {
	      // TODO: Audit code - is it better to filter on deviceGroup?
	      if (deviceType.name === 'IndigoPress' || deviceType.name === 'ScitexPress' || deviceType.name === 'IHPSPress' || deviceType.name === 'LatexPrinter' || deviceType.name === 'DesignjetPrinter' || deviceType.name === 'PageWideXLPrinter' || deviceType.name === 'ThreeDPrinter' || deviceType.name === 'TextilePrinter') {
	        uiTypesAndModels.push(deviceType);
	      }
	    });
	    vm.deviceTypesAndModels = uiTypesAndModels;
	  }
	
	  function getDeviceTypesAndModels() {
	    return vm.deviceTypesAndModels;
	  }
	
	  function typeChanged(deviceType) {
	    vm.canSelfInvite = false;
	    vm.showPrinterInfo = false;
	    vm.showPressInfo = false;
	    vm.showAllInfo = false;
	    vm.showScitexId = false;
	    vm.showScitexIdHelp = false;
	    vm.device.model = undefined;
	    vm.bgBU = undefined;
	
	    // TODO: Audit code - doesn't AAA create the internal IDs? Or is this just for the support request?
	    // Create an appropriate internalId for the GBU
	    vm.internalId = {
	      internalIdType: 'PSPId'
	    };
	
	    switch (deviceType) {
	      case 'IndigoPress':
	        vm.showPressInfo = true;
	        vm.showAllInfo = true;
	        vm.internalId.gbu = 'Indigo';
	        break;
	      case 'ScitexPress':
	        vm.showPrinterInfo = true;
	        vm.showAllInfo = true;
	        vm.showScitexId = true;
	        vm.internalId.gbu = 'Scitex';
	        delete vm.device.scitexId;
	        break;
	      case 'IHPSPress':
	        vm.showPressInfo = true;
	        vm.showAllInfo = true;
	        vm.internalId.gbu = 'IHPS';
	        break;
	      case 'LatexPrinter':
	      case 'TextilePrinter':
	      case 'PageWideXLPrinter':
	        vm.showPrinterInfo = true;
	        vm.internalId.gbu = 'Latex';
	        break;
	      case 'DesignjetPrinter':
	        vm.showPrinterInfo = true;
	        vm.internalId.gbu = 'Designjet';
	        break;
	      case 'ThreeDPrinter':
	        vm.showAllInfo = false;
	        vm.internalId.gbu = 'ThreeD';
	        vm.bgBU = '3D';
	        myParams.bu = '3D';
	        break;
	      default:
	        vm.internalId = null;
	        break;
	    }
	
	    vm.deviceModels = _.result(_.find(vm.deviceTypesAndModels, { 'name': deviceType }), 'models');
	    if (vm.deviceModels) {
	      vm.deviceModels.forEach(function (model) {
	        model.localizedName = $translate.instant(model.modelNameKey);
	      });
	
	      if (deviceType === 'ThreeDPrinter') {
	        // Remove the old (duplicate) 3D models that used the friendly name as the model in the DB
	        _.remove(vm.deviceModels, function (model) {
	          return model.modelName.startsWith('HP Jet Fusion 3D');
	        });
	
	        // Remove the old model A devices that are internal only and will not be released to customers
	        _.remove(vm.deviceModels, function (model) {
	          return model.modelName === "M0P44A" || model.modelName === "M0P49A";
	        });
	      }
	
	      // Sort models based on localized names
	      var temp = [];
	      var _name = '';
	      for (var i = 0; i < vm.deviceModels.length; i++) {
	        _name = $translate.instant(vm.deviceModels[i].modelNameKey);
	        temp.push({ originalObject: vm.deviceModels[i], localizedName: _name });
	      }
	      vm.deviceModels = _.pluck(_.sortBy(temp, 'localizedName'), 'originalObject');
	    }
	  }
	
	  function modelChanged() {
	    if (vm.device.serialNumber) {
	      delete vm.device.serialNumber;
	    }
	
	    if (vm.device.scitexId) {
	      delete vm.device.scitexId;
	    }
	  }
	
	  function initTitles() {
	    var titles = [];
	    titles.push({ key: 'Business Owner', value: $translate.instant('register.register.SignUp_Business_Owner') });
	    titles.push({ key: 'Production Manager', value: $translate.instant('register.register.SignUp_Production_Manager') });
	    titles.push({ key: 'IT Manager', value: $translate.instant('register.register.SignUp_IT_Manager') });
	    titles.push({ key: 'Press Operator', value: $translate.instant('register.register.SignUp_Press_Operator') });
	    titles.push({ key: 'Other', value: $translate.instant('register.register.SignUp_Other_Title') });
	    vm.titles = titles;
	  }
	
	  function getCountry(isoCode) {
	    return _.find(vm.countries, { isoCode: isoCode });
	  }
	
	  function getCountries() {
	    var portalCountriesOpts = {
	      cache: true,
	      params: {
	        locale: locale.value
	      }
	    };
	
	    return rnHttp.get(PORTAL_SERVICE, 'preferences/countries', portalCountriesOpts).then(function (response) {
	      return response.data;
	    });
	  }
	
	  function countryChanged() {
	    var country = getCountry(vm.country);
	    if (country) {
	      switch (country.isoCode) {
	        case US_COUNTRY_CODE:
	          vm.validators = US_VALIDATORS;
	          break;
	        case CANADA_COUNTRY_CODE:
	          vm.validators = CANADA_VALIDATORS;
	          break;
	        default:
	          vm.validators = DEFAULT_VALIDATORS;
	          break;
	      }
	
	      // Semi-hack to trigger validation on region and postal code gz-regex-validator has
	      // had a chance to pick up the new value (after appropriate digest cycle)
	      $timeout(resetForm, 100);
	    }
	  }
	
	  function resetForm() {
	    if (vm.signupForm.state && vm.signupForm.state.$viewValue !== undefined && vm.signupForm.state.$viewValue.length > 0) {
	      vm.signupForm.state.$setDirty();
	      vm.signupForm.state.$setTouched();
	      vm.signupForm.state.$validate();
	    }
	
	    if (vm.signupForm.postalCode && vm.signupForm.postalCode.$viewValue !== undefined && vm.signupForm.postalCode.$viewValue.length > 0) {
	      vm.signupForm.postalCode.$setDirty();
	      vm.signupForm.postalCode.$setTouched();
	      vm.signupForm.postalCode.$validate();
	    }
	  }
	
	  function formatRequest() {
	    if (vm.internalId) {
	      _.set(vm, 'request.internalId', vm.internalId);
	    }
	
	    if (vm.models) {
	      vm.device.model = vm.models.join(', ').substring(0, 99);
	    }
	
	    if (vm.device && vm.device.model) {
	      // Only send the deviceIdentifier if the user has provided info for the device
	      _.set(vm, 'request.deviceIdentifier', vm.device);
	
	      // Add device to invitation payload so Getting Started can use information
	      // Only do this if we don't have a security code (sc scenario automatically adds the device)
	      if (!_.get(vm, 'inputDevice.securityCode') && rnInstructionsService.getInstallMethods(vm.device.type, vm.device.model).sn) {
	        var payload = {
	          onboard: {
	            devices: [{
	              name: vm.device.serialNumber,
	              type: vm.device.type,
	              partNumber: vm.device.model,
	              serialNumber: vm.device.serialNumber
	            }]
	          }
	        };
	        _.set(vm, 'request.ext_payload', payload);
	      }
	    }
	
	    if (vm.activationDetails) {
	      _.set(vm, 'request.deviceActivationDetails', vm.activationDetails);
	    }
	
	    if (vm.userTitle) {
	      _.set(vm, 'request.title', vm.userTitle);
	      if (vm.otherTitle) {
	        _.set(vm, 'request.title', vm.otherTitle);
	      }
	    }
	
	    if (vm.company) {
	      _.set(vm, 'request.company', vm.company);
	    }
	
	    if (vm.address) {
	      _.set(vm, 'request.address', vm.address);
	      _.set(vm, 'request.primaryPhone', vm.primaryPhone);
	    }
	
	    if ($window.grecaptcha) {
	      _.set(vm, 'request.userInput', $window.grecaptcha.getResponse(captchaId));
	    }
	  }
	
	  function disableSubmit() {
	    if (vm.submitting) {
	      return true;
	    }
	
	    if (vm.signupForm.$invalid) {
	      return true;
	    }
	
	    if (!vm.device.type) {
	      return true;
	    }
	
	    if (vm.showPressInfo && vm.device.serialNumber && vm.device.serialNumber.trim() === '') {
	      return true;
	    }
	
	    return false;
	  }
	
	  function submit() {
	    if (vm.submitting) {
	      return;
	    }
	
	    vm.submitting = true;
	    delete vm.errorKey;
	    formatRequest();
	
	    if (!vm.request.userInput || vm.request.userInput && vm.request.userInput === '') {
	      vm.errorKey = 'register.register.SignUp_Error_Captcha';
	      vm.submitting = false;
	      $gzAnalytics.event('Sign Up - captcha error');
	      return;
	    }
	
	    vm.request.languageCode = locale.value;
	
	    var config = {
	      version: 1,
	      rhino: {
	        allow401: true
	      }
	    };
	
	    return rnHttp.post(EMAIL_SERVICE, EMAIL_SELF_INVITE_PATH, vm.request, config).then(function (response) {
	      var invitation = response.data;
	
	      if (invitation.id) {
	        var params = {
	          invitationId: invitation.id,
	          data: {
	            email: vm.request.email,
	            firstName: vm.request.firstName,
	            lastName: vm.request.lastName
	          },
	          signout: true
	        };
	
	        if (vm.bu) {
	          params.bu = vm.bu;
	        }
	
	        if (vm.bgBU) {
	          params.bu = vm.bgBU;
	        }
	
	        $gzAnalytics.event('Sign Up - success with invitation id');
	        return $state.go('acceptAccount', params);
	      } else {
	        vm.showAllInputs = false;
	        vm.success = true;
	        $gzAnalytics.event('Sign Up - success no invitation id');
	      }
	    })['catch'](function (error) {
	      if ($window.grecaptcha) {
	        $window.grecaptcha.reset(captchaId);
	      }
	
	      var statusCode = _.get(error, 'data.smsError.statusCode', -1);
	      var subCode = _.get(error, 'data.smsError.subCode', null);
	      $gzAnalytics.event('Sign Up - error', { label: statusCode + ' - ' + subCode });
	
	      if (statusCode === 401) {
	        if (subCode === 1019) {
	          // Serial number is invalid
	          vm.errorKey = 'register.register.SignUp_Device_SN_Error';
	        } else if (subCode === 1022) {
	          // The serial number has an invalid format, which we will assume is because it needs to be uppercase
	          vm.errorKey = 'devices.devices.Device_Serial_Number_Incorrect_Case';
	        } else if (subCode === 1020) {
	          // Issue validating the serial number (the service is probably down)
	          vm.errorKey = 'register.register.SignUp_Device_Validation_Internal_Error';
	        } else {
	          vm.errorKey = 'register.register.SignUp_Error';
	        }
	      } else if (statusCode === 409) {
	        if (subCode === 1002) {
	          // Device exists in another org
	          vm.errorKey = 'register.register.SignUp_Device_Conflict';
	        } else {
	          vm.errorKey = 'register.register.Email_Conflict';
	        }
	      } else {
	        vm.errorKey = 'register.register.SignUp_Error';
	      }
	    })['finally'](function () {
	      vm.submitting = false;
	    });
	  }
	
	  function cancel() {
	    myParams.signout = true;
	    if (!incoming3D && myParams.bu) {
	      delete myParams.bu;
	    }
	
	    $state.go('signin', myParams);
	    $gzAnalytics.eventCancel('Sign Up - Cancel clicked');
	  }
	
	  function parseParams() {
	    var queryParams = $location.search();
	    if ($stateParams.bu) {
	      incoming3D = true;
	      myParams.bu = $stateParams.bu;
	      vm.bu = $stateParams.bu;
	
	      switch (vm.bu) {
	        case '3D':
	          vm.deviceTypesAndModels = vm.deviceTypesAndModels.filter(function (dt) {
	            return dt.name === 'ThreeDPrinter';
	          });
	          vm.device.type = 'ThreeDPrinter';
	          typeChanged(vm.device.type);
	          break;
	      }
	    }
	  }
	
	  function scitexIdHelpClicked() {
	    vm.showScitexIdHelp = !vm.showScitexIdHelp;
	  }
	
	  function getHelpCenterEnabledRegistryKey() {
	    rnRegistry.getRegistry().then(function (registry) {
	      vm.helpCenterEnabled = registry.keys.helpCenterEnabled;
	    });
	  }
	}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	// import modules this module depends on
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _rhinoSrcComponentsDeviceDeviceModule = __webpack_require__(31);
	
	var _rhinoSrcComponentsDeviceDeviceModule2 = _interopRequireDefault(_rhinoSrcComponentsDeviceDeviceModule);
	
	var _rhinoSrcComponentsLocaleLocaleModule = __webpack_require__(32);
	
	var _rhinoSrcComponentsLocaleLocaleModule2 = _interopRequireDefault(_rhinoSrcComponentsLocaleLocaleModule);
	
	var _signUpController = __webpack_require__(501);
	
	var signUp = _interopRequireWildcard(_signUpController);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	var _gazelleSrcComponentsUserEulaEulaModule = __webpack_require__(9);
	
	var _gazelleSrcComponentsUserEulaEulaModule2 = _interopRequireDefault(_gazelleSrcComponentsUserEulaEulaModule);
	
	// import this modules components
	
	__webpack_require__(557);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.signup', [_gazelleSrcComponentsUserEulaEulaModule2['default'], _angularUiRouter2['default'], _rhinoSrcComponentsDeviceDeviceModule2['default'], _rhinoSrcComponentsLocaleLocaleModule2['default'], _angularMaterial2['default'], _angularTranslate2['default'], 'rhino.components.locale', 'rhino.core', 'angulartics', _gazelleSrcCoreAnalyticsAnalyticsModule2['default']]).controller(signUp.name, signUp['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	startBackground.$inject = ["$log", "$compile", "registerService", "$mdMedia", "$location"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = startBackground;
	
	var _registerService = __webpack_require__(78);
	
	var name = 'startBackground';
	exports.name = name;
	
	function startBackground($log, $compile, registerService, $mdMedia, $location) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var directive = {
	    restrict: 'EA',
	    scope: {
	      bu: '@',
	      icon: '@'
	    },
	    link: startBackgroundLink
	  };
	
	  return directive;
	
	  //////////////////////
	  // Private functions
	
	  function startBackgroundLink(scope, element, attrs, controllers) {
	    var previousWatchResult = { size: -1, is3d: false };
	    scope.$watch(function () {
	      var bu = attrs.bu;
	      if (!bu) {
	        bu = $location.search().bu;
	      }
	
	      var is3d = bu === '3D';
	
	      var size = undefined;
	      if ($mdMedia('xs')) {
	        size = 0;
	      } else if ($mdMedia('gt-md')) {
	        size = 2;
	      } else {
	        size = 1;
	      }
	
	      return {
	        is3d: is3d,
	        size: size
	      };
	    }, function (watchResult) {
	      if (watchResult.size > previousWatchResult.size || watchResult.is3d !== previousWatchResult.is3d || element.css('background-image') === '') {
	        previousWatchResult = watchResult;
	        if (watchResult.is3d) {
	          // Add a marker class for automated testing
	          element.removeClass('background-general');
	          element.addClass('background-3d');
	
	          element.css({
	            'background-image': 'url(' + registerService.getBackgroundImage(_registerService.IMAGE_FAMILY.ThreeD) + ')',
	            'background-repeat': 'no-repeat',
	            'background-size': 'cover',
	            'background-position': registerService.getPosition(_registerService.IMAGE_FAMILY.ThreeD)
	          });
	        } else {
	          // Add a marker class for automated testing
	          element.removeClass('background-3d');
	          element.addClass('background-general');
	
	          element.css({
	            'background-image': 'url(' + registerService.getBackgroundImage(_registerService.IMAGE_FAMILY.general) + ')',
	            'background-repeat': 'no-repeat',
	            'background-size': 'cover',
	            'background-position': registerService.getPosition(_registerService.IMAGE_FAMILY.general)
	          });
	        }
	      }
	      // Need to do object equality when returning an object from $watch.
	      // See https://stackoverflow.com/a/19455564/277307
	    }, true);
	  }
	}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _startBackgroundDirective = __webpack_require__(503);
	
	var startBackgroundDirective = _interopRequireWildcard(_startBackgroundDirective);
	
	var _registerService = __webpack_require__(78);
	
	var registerService = _interopRequireWildcard(_registerService);
	
	exports['default'] = angular.module('register.components.background', ['ngMaterial']).directive(startBackgroundDirective.name, startBackgroundDirective['default']).service(registerService.name, registerService['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	'use strict';
	
	SupportRequestController.$inject = ["$state", "$stateParams", "Upload", "$window", "rnHttp", "$analytics", "$q", "rnLocale", "$location", "$gzAnalytics", "$gzHpId", "rnRegistry"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = SupportRequestController;
	var name = 'SupportRequestController';
	
	exports.name = name;
	
	function SupportRequestController($state, $stateParams, Upload, $window, rnHttp, $analytics, $q, rnLocale, $location, $gzAnalytics, $gzHpId, rnRegistry) {
	  //noinspection BadExpressionStatementJS
	  'ngInject';
	
	  var US_VALIDATORS = {
	    region: {
	      maxlength: 2,
	      validator: 'Validator.AAA.USState'
	    },
	    postalCode: {
	      maxlength: 10,
	      validator: 'Validator.AAA.USPostalCode'
	    }
	  };
	
	  var CANADA_VALIDATORS = {
	    region: {
	      maxlength: 2,
	      validator: 'Validator.AAA.CAProvidences'
	    },
	    postalCode: {
	      maxlength: 7,
	      validator: 'Validator.AAA.CAPostalCode'
	    }
	  };
	
	  var DEFAULT_VALIDATORS = {
	    region: {
	      maxlength: 100,
	      validator: 'Validator.AAA.DescriptionUnicode'
	    },
	    postalCode: {
	      maxlength: 35,
	      validator: 'Validator.AAA.PostalCode'
	    }
	  };
	
	  var SUPPORT_SERVICE = 'supportapp_service';
	  var PORTAL_SERVICE = 'portal_service';
	  var CAPTCHA_PATH = 'captcha/key';
	  var US_COUNTRY_CODE = 'US';
	  var CANADA_COUNTRY_CODE = 'CA';
	  var ANONYMOUS_CASES_URL = '/api/supportapp-service/v1/cases/anonymous';
	
	  // See https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-query-string-query.html#_reserved_characters
	  var RESERVED_CHARS = ['\\+', '-', '=', '&', '\\||', '<', '>', '!', '\\(', '\\)', '{', '}', '\\[', '\\]', '\\^', '"', '~', '\\*', '\\?', ':', '\\\\', '/'];
	
	  var locale = {};
	  var myParams = {};
	  var captchaId = undefined;
	  var directNavigation = false;
	  var anonymousTutorials = {};
	  var slicedAnonymousTutorials = {};
	
	  var vm = this;
	  vm.errorKey = null;
	  vm.loading = true;
	  vm.submitting = false;
	  vm.signInHelp = false;
	  vm.countryHelp = false;
	  vm.recaptchaResponse = '';
	  vm.helpCenterEnabled = false;
	  vm.articles = [];
	  vm.expanded = false;
	
	  // controller functions
	  vm.getCountry = getCountry;
	  vm.getCountries = getCountries;
	  vm.countryChanged = countryChanged;
	  vm.submit = submit;
	  vm.cancel = cancel;
	  vm.signInHelpClicked = signInHelpClicked;
	  vm.countryHelpClicked = countryHelpClicked;
	  vm.prepareFormInfoToSend = prepareFormInfoToSend;
	  vm.renderRecaptcha = renderRecaptcha;
	  vm.executeRecaptcha = executeRecaptcha;
	  vm.signin = signin;
	  vm.$onInit = onInit;
	  vm.searchInsideTutorials = searchInsideTutorials;
	  vm.seeAllArticles = seeAllArticles;
	  vm.seeSlicedArticles = seeSlicedArticles;
	  vm.hasArticles = hasArticles;
	  vm.clickOnArticle = clickOnArticle;
	
	  vm.unitTest = {
	    sanitizeText: sanitizeText,
	    getHelpCenterEnabledRegistryKey: getHelpCenterEnabledRegistryKey,
	    getAnonymousTutorials: getAnonymousTutorials,
	    sortArticles: sortArticles,
	    sortByTitle: sortByTitle,
	    setAnonymousTutorials: function setAnonymousTutorials(value) {
	      return anonymousTutorials = value;
	    },
	    setSlicedAnonymousTutorials: function setSlicedAnonymousTutorials(value) {
	      return slicedAnonymousTutorials = value;
	    }
	  };
	
	  ////////////////////////
	  function onInit() {
	    detectUnsupportedBrowsers();
	    getHelpCenterEnabledRegistryKey();
	
	    var promises = [];
	    promises.push();
	    promises.push(getCountries());
	    promises.push(getSiteKey());
	    promises.push(getLocale().then(function () {
	      return getAnonymousTutorials();
	    }));
	
	    return $q.all(promises).then(function (data) {
	      vm.countries = data[0];
	      parseParams();
	    })['finally'](function () {
	      countryChanged();
	      if (!$window.grecaptcha) {
	        // Just display the email support button instead of reusing the signup error message (which is signup specific).
	        //vm.errorKey = 'register.register.SignUp_Error_NoCaptcha';
	        vm.noCaptcha = true;
	      }
	      vm.loading = false;
	    });
	  }
	
	  function detectUnsupportedBrowsers() {
	    vm.isUnsupportedBrowser = $window.navigator.userAgent.indexOf("MSIE") !== -1 || $window.navigator.userAgent.indexOf("rv:11") !== -1;
	  }
	
	  function parseParams() {
	    var urlParams = $location.search();
	
	    myParams.data = $stateParams.data;
	    if ($stateParams.bu) {
	      myParams.bu = $stateParams.bu;
	      vm.bu = $stateParams.bu;
	    }
	
	    if (urlParams.target) {
	      myParams.data = {};
	      _.set(myParams, 'data.target.url', $window.decodeURIComponent(urlParams.target));
	      directNavigation = true;
	    }
	  }
	
	  function getLocale() {
	    return rnLocale.getBestFit().then(function (l) {
	      locale = l;
	    });
	  }
	
	  /**
	   * @summary Get the google captcha site key from support app service.
	   * @return sets the vm.request.captchaId
	   */
	  function getSiteKey() {
	    return rnHttp.get(SUPPORT_SERVICE, CAPTCHA_PATH, { version: 1 }).then(function (resp) {
	      _.set(vm, 'request.captchaId', resp.data.key);
	    });
	  }
	
	  function getCountry(isoCode) {
	    return _.find(vm.countries, { isoCode: isoCode });
	  }
	
	  function getCountries() {
	    var portalCountriesOpts = {
	      cache: true,
	      params: {
	        locale: locale.value
	      }
	    };
	
	    return rnHttp.get(PORTAL_SERVICE, 'preferences/countries', portalCountriesOpts).then(function (response) {
	      return response.data;
	    });
	  }
	
	  function countryChanged() {
	    var country = getCountry(vm.country);
	    if (country) {
	      switch (country.isoCode) {
	        case US_COUNTRY_CODE:
	          vm.validators = US_VALIDATORS;
	          break;
	        case CANADA_COUNTRY_CODE:
	          vm.validators = CANADA_VALIDATORS;
	          break;
	        default:
	          vm.validators = DEFAULT_VALIDATORS;
	          break;
	      }
	    }
	  }
	
	  function renderRecaptcha() {
	    if ($window.grecaptcha) {
	      captchaId = $window.grecaptcha.render('recaptchaSupport', {
	        sitekey: vm.request.captchaId,
	        callback: submit,
	        // Recaptcha errors are also handled in submit method
	        'error-callback': submit,
	        'expired-callback': submit
	      });
	    }
	  }
	
	  function executeRecaptcha() {
	    if ($window.grecaptcha) {
	      $window.grecaptcha.execute(captchaId);
	    }
	  }
	
	  /**
	   * @summary Post the support form information (as jsonBlob) to support app service
	   * @return response about support email sent successfully or not
	   */
	  function submit() {
	    vm.submitting = true;
	    delete vm.errorKey;
	
	    if ($window.grecaptcha) {
	      _.set(vm, 'request.captchaBytes', $window.grecaptcha.getResponse(captchaId));
	    }
	
	    if (!vm.request.captchaBytes || vm.request.captchaBytes && vm.request.captchaBytes === '') {
	      vm.errorKey = 'register.register.SignUp_Error_Captcha';
	      vm.submitting = false;
	      return;
	    }
	
	    //Prepare support form input
	    var data = {
	      'case': Upload.jsonBlob(prepareFormInfoToSend())
	    };
	
	    Upload.upload({
	      url: ANONYMOUS_CASES_URL,
	      data: data
	    }).then(function (response) {
	      vm.success = true;
	      $analytics.eventTrack('support request sent', { category: 'account' });
	    })['catch'](function (error) {
	      if ($window.grecaptcha) {
	        $window.grecaptcha.reset(captchaId);
	      }
	      vm.errorKey = 'uxf.uxf.ContactHPSupport_error';
	    })['finally'](function () {
	      vm.submitting = false;
	    });
	  }
	
	  /**
	   * @summary Prepare support form input in JSON format.
	   * @return json
	   */
	  function prepareFormInfoToSend() {
	    var sendParams = {
	      caseSource: "WEB",
	      subject: vm.request.subject,
	      type: "ANONYMOUS_QUESTION",
	      userEntries: [{
	        userEntryType: "EMAIL",
	        value: vm.request.email
	      }, {
	        userEntryType: "FIRST_NAME",
	        value: vm.request.firstName
	      }, {
	        userEntryType: "LAST_NAME",
	        value: vm.request.lastName
	      }, {
	        userEntryType: "COUNTRY",
	        value: vm.request.country
	      }, {
	        userEntryType: "ACCOUNT_NAME",
	        value: vm.request.accountName
	      }, {
	        userEntryType: "DESCRIPTION",
	        value: vm.request.message
	      }, {
	        userEntryType: "RECAPTCHA_RESPONSE",
	        value: vm.request.captchaBytes
	      }]
	    };
	    return sendParams;
	  }
	
	  function cancel() {
	    if (directNavigation) {
	      var target = _.get(myParams, 'data.target.url');
	      $window.location.href = target;
	    } else {
	      $state.go($stateParams.fromState, myParams);
	    }
	  }
	
	  function signInHelpClicked() {
	    vm.signInHelp = !vm.signInHelp;
	    if (vm.signInHelp) {
	      $gzAnalytics.eventClick('Support - Help opened');
	    } else {
	      $gzAnalytics.eventClick('Support - Help closed');
	    }
	  }
	
	  function countryHelpClicked() {
	    vm.countryHelp = !vm.countryHelp;
	  }
	
	  function signin() {
	    var type = arguments.length <= 0 || arguments[0] === undefined ? 'login' : arguments[0];
	
	    vm.submitting = true;
	    delete vm.errorKey;
	
	    $gzAnalytics.eventClick('Sign In From Support - Sign in clicked');
	
	    var returnUrl = $gzHpId.createTargetUrl('signin', {
	      messageKey: vm.messageKey,
	      messageParams: vm.messageParams,
	      target: _.get(myParams, 'data.target.url')
	    });
	
	    var params = {
	      locale: locale,
	      username: $stateParams.username,
	      userId: $stateParams.userId,
	      orgId: $stateParams.orgId,
	      forceLogin: true
	    };
	
	    return $gzHpId.redirect(type, returnUrl, params)['catch'](function () {
	      vm.submitting = false;
	      vm.errorKey = 'register.register.SignIn_Error_HPID_RedirectFailed';
	    });
	  }
	
	  function getAnonymousTutorials() {
	    var urlParams = $location.search();
	    vm.expanded = urlParams.expanded === "true";
	
	    var config = {
	      params: {
	        visibleForAnonymous: true,
	        locale: locale.value
	      }
	    };
	
	    return rnHttp.get(SUPPORT_SERVICE, 'tutorials', config).then(function (resp) {
	      // We should not have anonymous walkme tutorials
	      anonymousTutorials = sortArticles(resp.data && resp.data.list && resp.data.list.filter(function (tutorial) {
	        return !tutorial.type.includes('walk');
	      }), sortByTitle);
	      slicedAnonymousTutorials = anonymousTutorials.slice(0, 5);
	      vm.articles = vm.expanded ? anonymousTutorials : slicedAnonymousTutorials;
	    });
	  }
	
	  function searchInsideTutorials(text) {
	    if (text.length === 0) {
	      vm.articles = vm.expanded ? anonymousTutorials : slicedAnonymousTutorials;
	      return;
	    }
	
	    var config = {
	      params: {
	        hasText: sanitizeText(text),
	        locale: locale.value
	      }
	    };
	
	    return rnHttp.get(SUPPORT_SERVICE, 'searchdocs/tutorials', config).then(function (resp) {
	      if (vm.inputText === text) {
	        (function () {
	          var analyticsTitles = resp.data.list.map(function (tutorial) {
	            return tutorial.analyticsTitle;
	          });
	          vm.articles = anonymousTutorials.filter(function (tutorial) {
	            return analyticsTitles.includes(tutorial.analyticsTitle);
	          });
	        })();
	      }
	    });
	  }
	
	  function removeSpecialChars(text) {
	    var sanitizedText = text;
	    RESERVED_CHARS.forEach(function (reservedChar) {
	      sanitizedText = sanitizedText.replace(new RegExp(reservedChar, 'g'), '');
	    });
	
	    return sanitizedText;
	  }
	
	  // based on printos-blue-ui/test/unit/specs/services/search-docs.js
	  function sanitizeText(uncheckedText) {
	    var text = uncheckedText ? uncheckedText.trim() : '';
	    return text.length === 0 ? text : removeSpecialChars(text).trim();
	  }
	
	  function getHelpCenterEnabledRegistryKey() {
	    rnRegistry.getRegistry().then(function (registry) {
	      vm.helpCenterEnabled = registry.keys.helpCenterEnabled;
	    });
	  }
	
	  function seeAllArticles() {
	    $gzAnalytics.eventClick('Support - See all articles');
	    vm.articles = anonymousTutorials;
	    vm.inputText = '';
	    vm.expanded = true;
	    $location.search('expanded', 'true');
	  }
	
	  function seeSlicedArticles() {
	    vm.articles = slicedAnonymousTutorials;
	    vm.inputText = '';
	    vm.expanded = false;
	    $location.search('expanded', 'false');
	  }
	
	  function clickOnArticle(analyticsTitle) {
	    $gzAnalytics.eventClick('Support - Click on article', { label: '' + analyticsTitle });
	  }
	
	  function hasArticles() {
	    return vm.articles.length > 0;
	  }
	
	  function sortArticles(anonymousTutorials, sortByTitle) {
	    return anonymousTutorials.filter(function (article) {
	      return article.faq === true;
	    }).sort(function (a, b) {
	      return sortByTitle(a, b);
	    }).concat(anonymousTutorials.filter(function (article) {
	      return article.faq === false;
	    }).sort(function (a, b) {
	      return sortByTitle(a, b);
	    }));
	  }
	
	  function sortByTitle(a, b) {
	    return a.title.trim().toLocaleLowerCase().localeCompare(b.title.trim().toLocaleLowerCase());
	  }
	}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularMaterial = __webpack_require__(8);
	
	var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _supportController = __webpack_require__(505);
	
	var supportRequest = _interopRequireWildcard(_supportController);
	
	var _gazelleSrcComponentsUserEulaEulaModule = __webpack_require__(9);
	
	var _gazelleSrcComponentsUserEulaEulaModule2 = _interopRequireDefault(_gazelleSrcComponentsUserEulaEulaModule);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule = __webpack_require__(6);
	
	var _gazelleSrcCoreAnalyticsAnalyticsModule2 = _interopRequireDefault(_gazelleSrcCoreAnalyticsAnalyticsModule);
	
	var _gazelleSrcComponentsHpidHpidModule = __webpack_require__(13);
	
	var _gazelleSrcComponentsHpidHpidModule2 = _interopRequireDefault(_gazelleSrcComponentsHpidHpidModule);
	
	// import this modules components
	
	__webpack_require__(558);
	
	// define the module in one place and export the module name
	exports['default'] = angular.module('register.components.support', [_gazelleSrcComponentsUserEulaEulaModule2['default'], _gazelleSrcComponentsHpidHpidModule2['default'], _angularUiRouter2['default'], _angularMaterial2['default'], _angularTranslate2['default'], _gazelleSrcCoreAnalyticsAnalyticsModule2['default'], 'rhino.components.locale', 'rhino.core', 'angulartics', 'ngFileUpload']).controller(supportRequest.name, supportRequest['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	'use strict';
	
	UnsubscribeController.$inject = ["$state", "$stateParams", "rnHttp", "$translate", "$gzGo"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = UnsubscribeController;
	var name = 'UnsubscribeController';
	exports.name = name;
	
	function UnsubscribeController(
	// Controller angular dependencies
	$state, $stateParams, rnHttp, $translate, $gzGo) {
	  'ngInject';
	  // Constants
	
	  // Variables
	
	  // View Model
	  var vm = this;
	  vm.loading = true;
	  vm.unsubscribe = unsubscribe;
	  vm.goToSignIn = goToSignIn;
	  vm.goToEmailSettings = goToEmailSettings;
	  vm.$onInit = onInit;
	
	  return;
	
	  function onInit() {
	    parseParams();
	    vm.loading = false;
	  }
	
	  function parseParams() {
	    vm.subscription = {};
	
	    //vm.subscription.email = _.get($stateParams, 'email');
	    vm.subscription.userId = _.get($stateParams, 'userId');
	    vm.subscription.category = _.get($stateParams, 'category');
	
	    if (!vm.subscription.category) {
	      vm.subscription.categoryDisplay = $translate.instant('register.register.NotDefined');
	    } else {
	      vm.subscription.categoryDisplay = $translate.instant('register.register.' + vm.subscription.category);
	    }
	  }
	
	  function unsubscribe() {
	    vm.submitting = true;
	
	    return rnHttp.post('email_service', 'unsubscriber/unsubscribe/' + vm.subscription.category, vm.subscription.userId).then(function (response) {
	      vm.unsubscribed = true;
	    })['catch'](function (error) {
	      vm.errorKey = 'register.register.UnsubscribeError';
	    })['finally'](function () {
	      vm.submitting = false;
	    });
	  }
	
	  function goToSignIn($event) {
	    $event.stopPropagation();
	    vm.submitting = true;
	    $state.go('signin');
	  }
	
	  function goToEmailSettings($event) {
	    $event.stopPropagation();
	    $gzGo.toContext('email-subscriptions');
	  }
	}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularTranslate = __webpack_require__(5);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	// import modules this module depends on
	
	var _gazelleSrcComponentsGoGoModule = __webpack_require__(55);
	
	var _gazelleSrcComponentsGoGoModule2 = _interopRequireDefault(_gazelleSrcComponentsGoGoModule);
	
	// import this modules components
	
	__webpack_require__(559);
	
	var _unsubscribeController = __webpack_require__(507);
	
	var UnsubscribeController = _interopRequireWildcard(_unsubscribeController);
	
	exports['default'] = angular.module('start.components.unsubscribe', ['rhino.core', 'angulartics', _angularUiRouter2['default'], _angularTranslate2['default'], _gazelleSrcComponentsGoGoModule2['default']]).controller(UnsubscribeController.name, UnsubscribeController['default']).name;
	module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var Store = (function () {
	    function Store() {
	        var dbName = arguments.length <= 0 || arguments[0] === undefined ? 'keyval-store' : arguments[0];
	        var storeName = arguments.length <= 1 || arguments[1] === undefined ? 'keyval' : arguments[1];
	
	        _classCallCheck(this, Store);
	
	        this.storeName = storeName;
	        this._dbp = new Promise(function (resolve, reject) {
	            var openreq = indexedDB.open(dbName, 1);
	            openreq.onerror = function () {
	                return reject(openreq.error);
	            };
	            openreq.onsuccess = function () {
	                return resolve(openreq.result);
	            };
	            // First time setup: create an empty object store
	            openreq.onupgradeneeded = function () {
	                openreq.result.createObjectStore(storeName);
	            };
	        });
	    }
	
	    _createClass(Store, [{
	        key: '_withIDBStore',
	        value: function _withIDBStore(type, callback) {
	            var _this = this;
	
	            return this._dbp.then(function (db) {
	                return new Promise(function (resolve, reject) {
	                    var transaction = db.transaction(_this.storeName, type);
	                    transaction.oncomplete = function () {
	                        return resolve();
	                    };
	                    transaction.onabort = transaction.onerror = function () {
	                        return reject(transaction.error);
	                    };
	                    callback(transaction.objectStore(_this.storeName));
	                });
	            });
	        }
	    }]);
	
	    return Store;
	})();
	
	var store = undefined;
	function getDefaultStore() {
	    if (!store) store = new Store();
	    return store;
	}
	function get(key) {
	    var store = arguments.length <= 1 || arguments[1] === undefined ? getDefaultStore() : arguments[1];
	
	    var req = undefined;
	    return store._withIDBStore('readonly', function (store) {
	        req = store.get(key);
	    }).then(function () {
	        return req.result;
	    });
	}
	function set(key, value) {
	    var store = arguments.length <= 2 || arguments[2] === undefined ? getDefaultStore() : arguments[2];
	
	    return store._withIDBStore('readwrite', function (store) {
	        store.put(value, key);
	    });
	}
	function del(key) {
	    var store = arguments.length <= 1 || arguments[1] === undefined ? getDefaultStore() : arguments[1];
	
	    return store._withIDBStore('readwrite', function (store) {
	        store['delete'](key);
	    });
	}
	function clear() {
	    var store = arguments.length <= 0 || arguments[0] === undefined ? getDefaultStore() : arguments[0];
	
	    return store._withIDBStore('readwrite', function (store) {
	        store.clear();
	    });
	}
	function keys() {
	    var store = arguments.length <= 0 || arguments[0] === undefined ? getDefaultStore() : arguments[0];
	
	    var keys = [];
	    return store._withIDBStore('readonly', function (store) {
	        // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
	        // And openKeyCursor isn't supported by Safari.
	        (store.openKeyCursor || store.openCursor).call(store).onsuccess = function () {
	            if (!this.result) return;
	            keys.push(this.result.key);
	            this.result['continue']();
	        };
	    }).then(function () {
	        return keys;
	    });
	}
	
	exports.Store = Store;
	exports.get = get;
	exports.set = set;
	exports.del = del;
	exports.clear = clear;
	exports.keys = keys;

/***/ }),
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(98);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./app-nav.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./app-nav.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(99);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./body-wrap.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./body-wrap.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(100);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./carousel.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./carousel.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./testimonial.scss", function() {
				var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./testimonial.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(102);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./color-picker.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./color-picker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(103);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./confirm-dialog.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./confirm-dialog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(104);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./dialog-title-bar.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./dialog-title-bar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(105);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./error-bar.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./error-bar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(106);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./field.scss", function() {
				var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./field.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(107);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./filter-bar.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./filter-bar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(108);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./filter-box.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./filter-box.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(109);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./filter-dialog.scss", function() {
				var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./filter-dialog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(110);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./form-content.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./form-content.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(111);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./form-footer-bar.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./form-footer-bar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(112);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./google-address.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./google-address.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(113);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./google-maps.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./google-maps.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(114);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./input-validation.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./input-validation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(115);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./locale-select.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./locale-select.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(116);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./month-selector.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./month-selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(117);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./page-header.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./page-header.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(118);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./page-not-found.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./page-not-found.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(119);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./time-picker.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./time-picker.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(120);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./time-range.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./time-range.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(121);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./eula.scss", function() {
				var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./eula.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(122);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./view-container.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./view-container.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(123);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../sass-loader/index.js!./core.scss", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../sass-loader/index.js!./core.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(124);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./getting-started.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./getting-started.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(125);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./columns-dialog.scss", function() {
				var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./columns-dialog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(126);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./grid.scss", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/index.js!./grid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(127);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./sort-dialog.scss", function() {
				var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/index.js!./sort-dialog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(128);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!../../../../sass-loader/index.js!./hpprintos.scss", function() {
				var newContent = require("!!../../../../css-loader/index.js!../../../../sass-loader/index.js!./hpprintos.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(129);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./accept-account.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./accept-account.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(130);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./hpid-sign-in.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./hpid-sign-in.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(131);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./accept-existing-user.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./accept-existing-user.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(132);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./accept-user.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./accept-user.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(133);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./icp.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./icp.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(134);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./landing-page.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./landing-page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(135);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./lf-add.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./lf-add.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(136);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./lf-code.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./lf-code.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(137);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./redirect.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./redirect.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(138);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./select-account.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./select-account.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(139);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./sign-in.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./sign-in.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(140);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./sign-up.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./sign-up.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(141);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./support.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./support.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(142);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./unsubscribe.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./unsubscribe.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(143);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./start.scss", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./start.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function(module) {
	    'use strict';
	
	    module.exports.is_uri = is_iri;
	    module.exports.is_http_uri = is_http_iri;
	    module.exports.is_https_uri = is_https_iri;
	    module.exports.is_web_uri = is_web_iri;
	    // Create aliases
	    module.exports.isUri = is_iri;
	    module.exports.isHttpUri = is_http_iri;
	    module.exports.isHttpsUri = is_https_iri;
	    module.exports.isWebUri = is_web_iri;
	
	
	    // private function
	    // internal URI spitter method - direct from RFC 3986
	    var splitUri = function(uri) {
	        var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
	        return splitted;
	    };
	
	    function is_iri(value) {
	        if (!value) {
	            return;
	        }
	
	        // check for illegal characters
	        if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return;
	
	        // check for hex escapes that aren't complete
	        if (/%[^0-9a-f]/i.test(value)) return;
	        if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return;
	
	        var splitted = [];
	        var scheme = '';
	        var authority = '';
	        var path = '';
	        var query = '';
	        var fragment = '';
	        var out = '';
	
	        // from RFC 3986
	        splitted = splitUri(value);
	        scheme = splitted[1]; 
	        authority = splitted[2];
	        path = splitted[3];
	        query = splitted[4];
	        fragment = splitted[5];
	
	        // scheme and path are required, though the path can be empty
	        if (!(scheme && scheme.length && path.length >= 0)) return;
	
	        // if authority is present, the path must be empty or begin with a /
	        if (authority && authority.length) {
	            if (!(path.length === 0 || /^\//.test(path))) return;
	        } else {
	            // if authority is not present, the path must not start with //
	            if (/^\/\//.test(path)) return;
	        }
	
	        // scheme must begin with a letter, then consist of letters, digits, +, ., or -
	        if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase()))  return;
	
	        // re-assemble the URL per section 5.3 in RFC 3986
	        out += scheme + ':';
	        if (authority && authority.length) {
	            out += '//' + authority;
	        }
	
	        out += path;
	
	        if (query && query.length) {
	            out += '?' + query;
	        }
	
	        if (fragment && fragment.length) {
	            out += '#' + fragment;
	        }
	
	        return out;
	    }
	
	    function is_http_iri(value, allowHttps) {
	        if (!is_iri(value)) {
	            return;
	        }
	
	        var splitted = [];
	        var scheme = '';
	        var authority = '';
	        var path = '';
	        var port = '';
	        var query = '';
	        var fragment = '';
	        var out = '';
	
	        // from RFC 3986
	        splitted = splitUri(value);
	        scheme = splitted[1]; 
	        authority = splitted[2];
	        path = splitted[3];
	        query = splitted[4];
	        fragment = splitted[5];
	
	        if (!scheme)  return;
	
	        if(allowHttps) {
	            if (scheme.toLowerCase() != 'https') return;
	        } else {
	            if (scheme.toLowerCase() != 'http') return;
	        }
	
	        // fully-qualified URIs must have an authority section that is
	        // a valid host
	        if (!authority) {
	            return;
	        }
	
	        // enable port component
	        if (/:(\d+)$/.test(authority)) {
	            port = authority.match(/:(\d+)$/)[0];
	            authority = authority.replace(/:\d+$/, '');
	        }
	
	        out += scheme + ':';
	        out += '//' + authority;
	        
	        if (port) {
	            out += port;
	        }
	        
	        out += path;
	        
	        if(query && query.length){
	            out += '?' + query;
	        }
	
	        if(fragment && fragment.length){
	            out += '#' + fragment;
	        }
	        
	        return out;
	    }
	
	    function is_https_iri(value) {
	        return is_http_iri(value, true);
	    }
	
	    function is_web_iri(value) {
	        return (is_http_iri(value) || is_https_iri(value));
	    }
	
	})(module);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)(module)))

/***/ }),
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./accept/account/accept-account.module.js": 474,
		"./accept/hpid-sign-in/hpid-sign-in.module.js": 475,
		"./accept/user/accept-existing-user.module.js": 477,
		"./accept/user/accept-user.module.js": 479,
		"./analytics/analytics.module.js": 480,
		"./consent/consent.module.js": 482,
		"./icp/icp.module.js": 485,
		"./landing-content/landing-content.module.js": 488,
		"./lf-add/lf-add.module.js": 490,
		"./lf-code/lf-code.module.js": 492,
		"./redirect/redirect.module.js": 494,
		"./sign-in/detectAutoFill.module.js": 77,
		"./sign-in/select-account/select-account.module.js": 497,
		"./sign-in/sign-in.module.js": 499,
		"./sign-up/sign-up.module.js": 502,
		"./start-background/start-background.module.js": 504,
		"./support/support.module.js": 506,
		"./unsubscribe/unsubscribe.module.js": 508
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 573;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./hp.svg": 274,
		"./print-os.svg": 275
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 574;


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// start.js